
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("289ZW", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $Wgg6o = parcelRequire("Wgg6o");

var $hPtJY = parcelRequire("hPtJY");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $Wgg6o.isBrowserBundle)() && Object.prototype.toString.call(typeof $hPtJY !== "undefined" ? $hPtJY : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("Wgg6o", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $0af207894032bdf2$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $0af207894032bdf2$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0af207894032bdf2$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("bDB9l", function(module, exports) {
$parcel$export(module.exports, "endpointMiddlewareOptions", () => (parcelRequire("jxKDL")).endpointMiddlewareOptions);
$parcel$export(module.exports, "getEndpointPlugin", () => (parcelRequire("jxKDL")).getEndpointPlugin);
$parcel$export(module.exports, "resolveEndpointConfig", () => (parcelRequire("3JRa2")).resolveEndpointConfig);
parcelRequire("akQPY");
parcelRequire("2Pavd");
parcelRequire("jxKDL");
parcelRequire("3JRa2");
parcelRequire("4xyKW");

});
parcelRegister("akQPY", function(module, exports) {
parcelRequire("k84Ba");
parcelRequire("e7Axv");

});
parcelRegister("k84Ba", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromInstructions", () => $ea781f297cdd2a45$export$deed4544608f82ff);
parcelRequire("01YT2");
var $55RTS = parcelRequire("55RTS");

var $9Agsa = parcelRequire("9Agsa");

var $gLB8b = parcelRequire("gLB8b");

var $e7Axv = parcelRequire("e7Axv");
const $ea781f297cdd2a45$export$deed4544608f82ff = async (commandInput, instructionsSupplier, clientConfig, context)=>{
    if (!clientConfig.endpoint) {
        const endpointFromConfig = await (0, $gLB8b.getEndpointFromConfig)(clientConfig.serviceId || "");
        if (endpointFromConfig) clientConfig.endpoint = ()=>Promise.resolve((0, $e7Axv.toEndpointV1)(endpointFromConfig));
    }
    const endpointParams = await $ea781f297cdd2a45$export$a4c001b14047c450(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") throw new Error("config.endpointProvider is not set.");
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const $ea781f297cdd2a45$export$a4c001b14047c450 = async (commandInput, instructionsSupplier, clientConfig)=>{
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions))switch(instruction.type){
        case "staticContextParams":
            endpointParams[name] = instruction.value;
            break;
        case "contextParams":
            endpointParams[name] = commandInput[instruction.name];
            break;
        case "clientContextParams":
        case "builtInParams":
            endpointParams[name] = await (0, $9Agsa.createConfigValueProvider)(instruction.name, name, clientConfig)();
            break;
        default:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
    if (Object.keys(instructions).length === 0) Object.assign(endpointParams, clientConfig);
    if (String(clientConfig.serviceId).toLowerCase() === "s3") await (0, $55RTS.resolveParamsForS3)(endpointParams);
    return endpointParams;
};

});
parcelRegister("01YT2", function(module, exports) {
$parcel$export(module.exports, "resolveParamsForS3", () => (parcelRequire("55RTS")).resolveParamsForS3);
parcelRequire("55RTS");

});
parcelRegister("55RTS", function(module, exports) {

$parcel$export(module.exports, "resolveParamsForS3", () => $3b573adc0d37fb20$export$972ee8f9276654f0);
const $3b573adc0d37fb20$export$972ee8f9276654f0 = async (endpointParams)=>{
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    if ($3b573adc0d37fb20$export$fe7fec9fee338b98(bucket)) {
        if (endpointParams.ForcePathStyle === true) throw new Error("Path-style addressing cannot be used with ARN buckets");
    } else if (!$3b573adc0d37fb20$export$360a1e07839d0d27(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) endpointParams.ForcePathStyle = true;
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const $3b573adc0d37fb20$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const $3b573adc0d37fb20$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const $3b573adc0d37fb20$var$DOTS_PATTERN = /\.\./;
const $3b573adc0d37fb20$export$b0b24e5455be29b0 = /\./;
const $3b573adc0d37fb20$export$43f53815580748f = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const $3b573adc0d37fb20$export$360a1e07839d0d27 = (bucketName)=>$3b573adc0d37fb20$var$DOMAIN_PATTERN.test(bucketName) && !$3b573adc0d37fb20$var$IP_ADDRESS_PATTERN.test(bucketName) && !$3b573adc0d37fb20$var$DOTS_PATTERN.test(bucketName);
const $3b573adc0d37fb20$export$fe7fec9fee338b98 = (bucketName)=>{
    const [arn, partition, service, , , bucket] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = Boolean(isArn && partition && service && bucket);
    if (isArn && !isValidArn) throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    return isValidArn;
};

});


parcelRegister("9Agsa", function(module, exports) {

$parcel$export(module.exports, "createConfigValueProvider", () => $6fa43d1e922a902d$export$47243fd4b8e52f1e);
const $6fa43d1e922a902d$export$47243fd4b8e52f1e = (configKey, canonicalEndpointParamKey, config)=>{
    const configProvider = async ()=>{
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") return configValue();
        return configValue;
    };
    if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.credentialScope ?? credentials?.CredentialScope;
        return configValue;
    };
    if (configKey === "accountId" || canonicalEndpointParamKey === "AccountId") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.accountId ?? credentials?.AccountId;
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") return async ()=>{
        const endpoint = await configProvider();
        if (endpoint && typeof endpoint === "object") {
            if ("url" in endpoint) return endpoint.url.href;
            if ("hostname" in endpoint) {
                const { protocol: protocol, hostname: hostname, port: port, path: path } = endpoint;
                return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
            }
        }
        return endpoint;
    };
    return configProvider;
};

});

parcelRegister("gLB8b", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromConfig", () => $c34dd68d79edd019$export$8a5041d6190772fe);
const $c34dd68d79edd019$export$8a5041d6190772fe = async (serviceId)=>undefined;

});

parcelRegister("e7Axv", function(module, exports) {

$parcel$export(module.exports, "toEndpointV1", () => $a47e1014d07c2c5c$export$32d52e935fceeb99);

var $fIJBr = parcelRequire("fIJBr");
const $a47e1014d07c2c5c$export$32d52e935fceeb99 = (endpoint)=>{
    if (typeof endpoint === "object") {
        if ("url" in endpoint) return (0, $fIJBr.parseUrl)(endpoint.url);
        return endpoint;
    }
    return (0, $fIJBr.parseUrl)(endpoint);
};

});
parcelRegister("fIJBr", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $b71e56dcf280298d$export$7a5253c0f62e0150);

var $9PwL1 = parcelRequire("9PwL1");
const $b71e56dcf280298d$export$7a5253c0f62e0150 = (url)=>{
    if (typeof url === "string") return $b71e56dcf280298d$export$7a5253c0f62e0150(new URL(url));
    const { hostname: hostname, pathname: pathname, port: port, protocol: protocol, search: search } = url;
    let query;
    if (search) query = (0, $9PwL1.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

});
parcelRegister("9PwL1", function(module, exports) {

$parcel$export(module.exports, "parseQueryString", () => $7282496b0a30759e$export$66256f83798e5415);
function $7282496b0a30759e$export$66256f83798e5415(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) for (const pair of querystring.split("&")){
        let [key, value = null] = pair.split("=");
        key = decodeURIComponent(key);
        if (value) value = decodeURIComponent(value);
        if (!(key in query)) query[key] = value;
        else if (Array.isArray(query[key])) query[key].push(value);
        else query[key] = [
            query[key],
            value
        ];
    }
    return query;
}

});





parcelRegister("2Pavd", function(module, exports) {

$parcel$export(module.exports, "endpointMiddleware", () => $20e87dbf25d113aa$export$aa1c2d132a457833);
parcelRequire("et0OQ");
var $b8rNH = parcelRequire("b8rNH");

var $k84Ba = parcelRequire("k84Ba");
const $20e87dbf25d113aa$export$aa1c2d132a457833 = ({ config: config, instructions: instructions })=>{
    return (next, context)=>async (args)=>{
            const endpoint = await (0, $k84Ba.getEndpointFromInstructions)(args.input, {
                getEndpointParameterInstructions () {
                    return instructions;
                }
            }, {
                ...config
            }, context);
            context.endpointV2 = endpoint;
            context.authSchemes = endpoint.properties?.authSchemes;
            const authScheme = context.authSchemes?.[0];
            if (authScheme) {
                context["signing_region"] = authScheme.signingRegion;
                context["signing_service"] = authScheme.signingName;
                const smithyContext = (0, $b8rNH.getSmithyContext)(context);
                const httpAuthOption = smithyContext?.selectedHttpAuthScheme?.httpAuthOption;
                if (httpAuthOption) httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
                    signing_region: authScheme.signingRegion,
                    signingRegion: authScheme.signingRegion,
                    signing_service: authScheme.signingName,
                    signingName: authScheme.signingName,
                    signingRegionSet: authScheme.signingRegionSet
                }, authScheme.properties);
            }
            return next({
                ...args
            });
        };
};

});
parcelRegister("et0OQ", function(module, exports) {
$parcel$export(module.exports, "getSmithyContext", () => (parcelRequire("b8rNH")).getSmithyContext);
$parcel$export(module.exports, "normalizeProvider", () => (parcelRequire("25kVm")).normalizeProvider);
parcelRequire("b8rNH");
parcelRequire("25kVm");

});
parcelRegister("b8rNH", function(module, exports) {

$parcel$export(module.exports, "getSmithyContext", () => $81b601b1f130ca67$export$1d3c197393275463);
parcelRequire("95Hh5");
var $35FCJ = parcelRequire("35FCJ");
const $81b601b1f130ca67$export$1d3c197393275463 = (context)=>context[0, $35FCJ.SMITHY_CONTEXT_KEY] || (context[0, $35FCJ.SMITHY_CONTEXT_KEY] = {});

});
parcelRegister("95Hh5", function(module, exports) {
$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => (parcelRequire("g5NVg")).HttpApiKeyAuthLocation);
$parcel$export(module.exports, "EndpointURLScheme", () => (parcelRequire("6G7Uo")).EndpointURLScheme);
$parcel$export(module.exports, "AlgorithmId", () => (parcelRequire("02fee")).AlgorithmId);
$parcel$export(module.exports, "FieldPosition", () => (parcelRequire("2d9D8")).FieldPosition);
$parcel$export(module.exports, "SMITHY_CONTEXT_KEY", () => (parcelRequire("35FCJ")).SMITHY_CONTEXT_KEY);
parcelRequire("4pfTA");
parcelRequire("cZS4T");
parcelRequire("b0jx1");
parcelRequire("9PUS5");
parcelRequire("aZnJc");
parcelRequire("4aK90");
parcelRequire("j7Uxf");
parcelRequire("5VWE7");
parcelRequire("5iMgo");
parcelRequire("6G7Uo");
parcelRequire("43OuW");
parcelRequire("8KJ4j");
parcelRequire("dIB8s");
parcelRequire("2d9D8");
parcelRequire("7aisf");
parcelRequire("7pebm");
parcelRequire("akPyN");
parcelRequire("35FCJ");
parcelRequire("44xqx");
parcelRequire("lCEkv");
parcelRequire("29NQD");
parcelRequire("5OTuC");
parcelRequire("69wwd");
parcelRequire("c8XVf");
parcelRequire("fLwdo");
parcelRequire("7U8MM");
parcelRequire("d9jwn");
parcelRequire("4q9RD");
parcelRequire("3ZQN0");
parcelRequire("8LCYE");
parcelRequire("lAhab");
parcelRequire("aS17m");
parcelRequire("991zS");
parcelRequire("eZkkM");
parcelRequire("9Y3Qd");
parcelRequire("5xHAa");

});
parcelRegister("4pfTA", function(module, exports) {

});

parcelRegister("cZS4T", function(module, exports) {
$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => (parcelRequire("g5NVg")).HttpApiKeyAuthLocation);
parcelRequire("iiZmx");
parcelRequire("g5NVg");
parcelRequire("hnVOW");
parcelRequire("gDzGU");
parcelRequire("9zard");
parcelRequire("h0S1q");

});
parcelRegister("iiZmx", function(module, exports) {
var $d53981c3614577d2$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($d53981c3614577d2$export$e24756d4ad084ce1 || ($d53981c3614577d2$export$e24756d4ad084ce1 = {}));

});

parcelRegister("g5NVg", function(module, exports) {

$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => $bb73d68ec848b3ea$export$8c5ca875010cb2a6);
var $bb73d68ec848b3ea$export$8c5ca875010cb2a6;
(function(HttpApiKeyAuthLocation) {
    HttpApiKeyAuthLocation["HEADER"] = "header";
    HttpApiKeyAuthLocation["QUERY"] = "query";
})($bb73d68ec848b3ea$export$8c5ca875010cb2a6 || ($bb73d68ec848b3ea$export$8c5ca875010cb2a6 = {}));

});

parcelRegister("hnVOW", function(module, exports) {

});

parcelRegister("gDzGU", function(module, exports) {

});

parcelRegister("9zard", function(module, exports) {

});

parcelRegister("h0S1q", function(module, exports) {

});


parcelRegister("b0jx1", function(module, exports) {

});

parcelRegister("9PUS5", function(module, exports) {

});

parcelRegister("aZnJc", function(module, exports) {

});

parcelRegister("4aK90", function(module, exports) {

});

parcelRegister("j7Uxf", function(module, exports) {
parcelRequire("iD6iB");
parcelRequire("l4rab");
parcelRequire("7l0GA");

});
parcelRegister("iD6iB", function(module, exports) {

});

parcelRegister("l4rab", function(module, exports) {

});

parcelRegister("7l0GA", function(module, exports) {

});


parcelRegister("5VWE7", function(module, exports) {

});

parcelRegister("5iMgo", function(module, exports) {

});

parcelRegister("6G7Uo", function(module, exports) {

$parcel$export(module.exports, "EndpointURLScheme", () => $4dccccca93fbe3a1$export$b141d049add1dcb5);
var $4dccccca93fbe3a1$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($4dccccca93fbe3a1$export$b141d049add1dcb5 || ($4dccccca93fbe3a1$export$b141d049add1dcb5 = {}));

});

parcelRegister("43OuW", function(module, exports) {
parcelRequire("g6ppK");
parcelRequire("jPdpB");
parcelRequire("6NrQh");
parcelRequire("8ydlr");
parcelRequire("82JKB");

});
parcelRegister("g6ppK", function(module, exports) {

});

parcelRegister("jPdpB", function(module, exports) {

});

parcelRegister("6NrQh", function(module, exports) {

});

parcelRegister("8ydlr", function(module, exports) {

});

parcelRegister("82JKB", function(module, exports) {

});


parcelRegister("8KJ4j", function(module, exports) {

});

parcelRegister("dIB8s", function(module, exports) {

$parcel$export(module.exports, "AlgorithmId", () => (parcelRequire("02fee")).AlgorithmId);
parcelRequire("aYmDt");
parcelRequire("jhaTi");

var $02fee = parcelRequire("02fee");

});
parcelRegister("aYmDt", function(module, exports) {

var $02fee = parcelRequire("02fee");
const $7fd110f2bfbe7296$export$7081660fd0cd662b = (runtimeConfig)=>{
    return {
        ...(0, $02fee.getChecksumConfiguration)(runtimeConfig)
    };
};
const $7fd110f2bfbe7296$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $02fee.resolveChecksumRuntimeConfig)(config)
    };
};

});
parcelRegister("02fee", function(module, exports) {

$parcel$export(module.exports, "AlgorithmId", () => $006c00194dd9cd93$export$fe562bf21391d1f0);
$parcel$export(module.exports, "getChecksumConfiguration", () => $006c00194dd9cd93$export$129b301e72591856);
$parcel$export(module.exports, "resolveChecksumRuntimeConfig", () => $006c00194dd9cd93$export$589dfc268e61d391);
var $006c00194dd9cd93$export$fe562bf21391d1f0;
(function(AlgorithmId) {
    AlgorithmId["MD5"] = "md5";
    AlgorithmId["CRC32"] = "crc32";
    AlgorithmId["CRC32C"] = "crc32c";
    AlgorithmId["SHA1"] = "sha1";
    AlgorithmId["SHA256"] = "sha256";
})($006c00194dd9cd93$export$fe562bf21391d1f0 || ($006c00194dd9cd93$export$fe562bf21391d1f0 = {}));
const $006c00194dd9cd93$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    if (runtimeConfig.sha256 !== undefined) checksumAlgorithms.push({
        algorithmId: ()=>$006c00194dd9cd93$export$fe562bf21391d1f0.SHA256,
        checksumConstructor: ()=>runtimeConfig.sha256
    });
    if (runtimeConfig.md5 != undefined) checksumAlgorithms.push({
        algorithmId: ()=>$006c00194dd9cd93$export$fe562bf21391d1f0.MD5,
        checksumConstructor: ()=>runtimeConfig.md5
    });
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $006c00194dd9cd93$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};

});


parcelRegister("jhaTi", function(module, exports) {

});


parcelRegister("2d9D8", function(module, exports) {

$parcel$export(module.exports, "FieldPosition", () => $19c444025ae5faab$export$54765d03252bd9ed);
var $19c444025ae5faab$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($19c444025ae5faab$export$54765d03252bd9ed || ($19c444025ae5faab$export$54765d03252bd9ed = {}));

});

parcelRegister("7aisf", function(module, exports) {

});

parcelRegister("7pebm", function(module, exports) {
parcelRequire("5jZWr");
parcelRequire("7H7nt");
parcelRequire("bDQb3");
parcelRequire("a3Tk6");

});
parcelRegister("5jZWr", function(module, exports) {

});

parcelRegister("7H7nt", function(module, exports) {

});

parcelRegister("bDQb3", function(module, exports) {

});

parcelRegister("a3Tk6", function(module, exports) {

});


parcelRegister("akPyN", function(module, exports) {

});

parcelRegister("35FCJ", function(module, exports) {

$parcel$export(module.exports, "SMITHY_CONTEXT_KEY", () => $2402204dec407064$export$94e7bb1b8aa610cb);
const $2402204dec407064$export$94e7bb1b8aa610cb = "__smithy_context";

});

parcelRegister("44xqx", function(module, exports) {

});

parcelRegister("lCEkv", function(module, exports) {
var $fbdc6e3a5b71c341$export$bd84655cbf2c28d9;
(function(IniSectionType) {
    IniSectionType["PROFILE"] = "profile";
    IniSectionType["SSO_SESSION"] = "sso-session";
    IniSectionType["SERVICES"] = "services";
})($fbdc6e3a5b71c341$export$bd84655cbf2c28d9 || ($fbdc6e3a5b71c341$export$bd84655cbf2c28d9 = {}));

});

parcelRegister("29NQD", function(module, exports) {

});

parcelRegister("5OTuC", function(module, exports) {

});

parcelRegister("69wwd", function(module, exports) {

});

parcelRegister("c8XVf", function(module, exports) {

});

parcelRegister("fLwdo", function(module, exports) {

});

parcelRegister("7U8MM", function(module, exports) {

});

parcelRegister("d9jwn", function(module, exports) {

});

parcelRegister("4q9RD", function(module, exports) {

});

parcelRegister("3ZQN0", function(module, exports) {

});

parcelRegister("8LCYE", function(module, exports) {
var $6620f292f63e1498$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($6620f292f63e1498$export$6431f3fda9a48da2 || ($6620f292f63e1498$export$6431f3fda9a48da2 = {}));

});

parcelRegister("lAhab", function(module, exports) {

});

parcelRegister("aS17m", function(module, exports) {

});

parcelRegister("991zS", function(module, exports) {

});

parcelRegister("eZkkM", function(module, exports) {

});

parcelRegister("9Y3Qd", function(module, exports) {

});

parcelRegister("5xHAa", function(module, exports) {

});



parcelRegister("25kVm", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $184c4781feb1f814$export$b1276c07738d6325);
const $184c4781feb1f814$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

});



parcelRegister("jxKDL", function(module, exports) {

$parcel$export(module.exports, "endpointMiddlewareOptions", () => $e3a5472d351bf15f$export$1e040b8d263b920b);
$parcel$export(module.exports, "getEndpointPlugin", () => $e3a5472d351bf15f$export$946c80457b765eab);
parcelRequire("4VvaK");
var $aAT5t = parcelRequire("aAT5t");

var $2Pavd = parcelRequire("2Pavd");
const $e3a5472d351bf15f$export$1e040b8d263b920b = {
    step: "serialize",
    tags: [
        "ENDPOINT_PARAMETERS",
        "ENDPOINT_V2",
        "ENDPOINT"
    ],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $aAT5t.serializerMiddlewareOption).name
};
const $e3a5472d351bf15f$export$946c80457b765eab = (config, instructions)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $2Pavd.endpointMiddleware)({
                config: config,
                instructions: instructions
            }), $e3a5472d351bf15f$export$1e040b8d263b920b);
        }
    });

});
parcelRegister("4VvaK", function(module, exports) {
$parcel$export(module.exports, "getSerdePlugin", () => (parcelRequire("aAT5t")).getSerdePlugin);
$parcel$export(module.exports, "serializerMiddlewareOption", () => (parcelRequire("aAT5t")).serializerMiddlewareOption);
parcelRequire("5sQ0k");
parcelRequire("aAT5t");
parcelRequire("3UxpU");

});
parcelRegister("5sQ0k", function(module, exports) {

$parcel$export(module.exports, "deserializerMiddleware", () => $3fa7e84457157be9$export$d10196e291075f95);
const $3fa7e84457157be9$export$d10196e291075f95 = (options, deserializer)=>(next)=>async (args)=>{
            const { response: response } = await next(args);
            try {
                const parsed = await deserializer(response, options);
                return {
                    response: response,
                    output: parsed
                };
            } catch (error) {
                Object.defineProperty(error, "$response", {
                    value: response
                });
                if (!("$metadata" in error)) {
                    const hint = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
                    error.message += "\n  " + hint;
                    if (typeof error.$responseBodyText !== "undefined") {
                        if (error.$response) error.$response.body = error.$responseBodyText;
                    }
                }
                throw error;
            }
        };

});

parcelRegister("aAT5t", function(module, exports) {

$parcel$export(module.exports, "serializerMiddlewareOption", () => $7b67ff6108e5be33$export$1bd449976e9c484d);
$parcel$export(module.exports, "getSerdePlugin", () => $7b67ff6108e5be33$export$53fdc69654553fd4);

var $5sQ0k = parcelRequire("5sQ0k");

var $3UxpU = parcelRequire("3UxpU");
const $7b67ff6108e5be33$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
const $7b67ff6108e5be33$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $7b67ff6108e5be33$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack)=>{
            commandStack.add((0, $5sQ0k.deserializerMiddleware)(config, deserializer), $7b67ff6108e5be33$export$f5d82b333b4f39c9);
            commandStack.add((0, $3UxpU.serializerMiddleware)(config, serializer), $7b67ff6108e5be33$export$1bd449976e9c484d);
        }
    };
}

});
parcelRegister("3UxpU", function(module, exports) {

$parcel$export(module.exports, "serializerMiddleware", () => $2d9085fb3f09b86b$export$125a23d36094c5de);
const $2d9085fb3f09b86b$export$125a23d36094c5de = (options, serializer)=>(next, context)=>async (args)=>{
            const endpoint = context.endpointV2?.url && options.urlParser ? async ()=>options.urlParser(context.endpointV2.url) : options.endpoint;
            if (!endpoint) throw new Error("No valid endpoint provider available.");
            const request = await serializer(args.input, {
                ...options,
                endpoint: endpoint
            });
            return next({
                ...args,
                request: request
            });
        };

});




parcelRegister("3JRa2", function(module, exports) {

$parcel$export(module.exports, "resolveEndpointConfig", () => $2b8ecfb31dd9a46b$export$8c5b66831e3f26ff);
parcelRequire("et0OQ");
var $25kVm = parcelRequire("25kVm");

var $e7Axv = parcelRequire("e7Axv");
const $2b8ecfb31dd9a46b$export$8c5b66831e3f26ff = (input)=>{
    const tls = input.tls ?? true;
    const { endpoint: endpoint } = input;
    const customEndpointProvider = endpoint != null ? async ()=>(0, $e7Axv.toEndpointV1)(await (0, $25kVm.normalizeProvider)(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    return {
        ...input,
        endpoint: customEndpointProvider,
        tls: tls,
        isCustomEndpoint: isCustomEndpoint,
        useDualstackEndpoint: (0, $25kVm.normalizeProvider)(input.useDualstackEndpoint ?? false),
        useFipsEndpoint: (0, $25kVm.normalizeProvider)(input.useFipsEndpoint ?? false)
    };
};

});

parcelRegister("4xyKW", function(module, exports) {

});


parcelRegister("eKvzZ", function(module, exports) {
$parcel$export(module.exports, "NoOpLogger", () => (parcelRequire("avv1m")).NoOpLogger);
$parcel$export(module.exports, "Client", () => (parcelRequire("2AKIE")).Client);
$parcel$export(module.exports, "collectBody", () => (parcelRequire("hEciL")).collectBody);
$parcel$export(module.exports, "Command", () => (parcelRequire("dm5an")).Command);
$parcel$export(module.exports, "SENSITIVE_STRING", () => (parcelRequire("bLYmx")).SENSITIVE_STRING);
$parcel$export(module.exports, "parseEpochTimestamp", () => (parcelRequire("iik7Y")).parseEpochTimestamp);
$parcel$export(module.exports, "parseRfc3339DateTime", () => (parcelRequire("iik7Y")).parseRfc3339DateTime);
$parcel$export(module.exports, "parseRfc3339DateTimeWithOffset", () => (parcelRequire("iik7Y")).parseRfc3339DateTimeWithOffset);
$parcel$export(module.exports, "withBaseException", () => (parcelRequire("alLJe")).withBaseException);
$parcel$export(module.exports, "loadConfigsForDefaultMode", () => (parcelRequire("aczlM")).loadConfigsForDefaultMode);
$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => (parcelRequire("6vLVm")).getDefaultExtensionConfiguration);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => (parcelRequire("6vLVm")).resolveDefaultRuntimeConfig);
$parcel$export(module.exports, "decorateServiceException", () => (parcelRequire("l1h1U")).decorateServiceException);
$parcel$export(module.exports, "ServiceException", () => (parcelRequire("l1h1U")).ServiceException);
$parcel$export(module.exports, "extendedEncodeURIComponent", () => (parcelRequire("2w5pr")).extendedEncodeURIComponent);
$parcel$export(module.exports, "getValueFromTextNode", () => (parcelRequire("buZaR")).getValueFromTextNode);
$parcel$export(module.exports, "take", () => (parcelRequire("gZe9T")).take);
$parcel$export(module.exports, "expectBoolean", () => (parcelRequire("kHa9s")).expectBoolean);
$parcel$export(module.exports, "expectInt32", () => (parcelRequire("kHa9s")).expectInt32);
$parcel$export(module.exports, "expectNonNull", () => (parcelRequire("kHa9s")).expectNonNull);
$parcel$export(module.exports, "expectNumber", () => (parcelRequire("kHa9s")).expectNumber);
$parcel$export(module.exports, "expectString", () => (parcelRequire("kHa9s")).expectString);
$parcel$export(module.exports, "strictParseInt32", () => (parcelRequire("kHa9s")).strictParseInt32);
$parcel$export(module.exports, "resolvedPath", () => (parcelRequire("9GK4j")).resolvedPath);
$parcel$export(module.exports, "_json", () => (parcelRequire("kfE6I"))._json);
parcelRequire("avv1m");
parcelRequire("2AKIE");
parcelRequire("hEciL");
parcelRequire("dm5an");
parcelRequire("bLYmx");
parcelRequire("fBtuk");
parcelRequire("iik7Y");
parcelRequire("alLJe");
parcelRequire("aczlM");
parcelRequire("avLqn");
parcelRequire("i0Ktq");
parcelRequire("l1h1U");
parcelRequire("2w5pr");
parcelRequire("aQZR7");
parcelRequire("buZaR");
parcelRequire("cI8D9");
parcelRequire("gZe9T");
parcelRequire("kHa9s");
parcelRequire("9GK4j");
parcelRequire("6eupr");
parcelRequire("kfE6I");
parcelRequire("lTTQL");

});
parcelRegister("avv1m", function(module, exports) {

$parcel$export(module.exports, "NoOpLogger", () => $7a64dcbd6d1e06f1$export$4147bde06f294c2e);
class $7a64dcbd6d1e06f1$export$4147bde06f294c2e {
    trace() {}
    debug() {}
    info() {}
    warn() {}
    error() {}
}

});

parcelRegister("2AKIE", function(module, exports) {

$parcel$export(module.exports, "Client", () => $1e332f05d1ae8c15$export$1f2bb630327ac4b6);
parcelRequire("29Tcr");
var $5KbfD = parcelRequire("5KbfD");
class $1e332f05d1ae8c15$export$1f2bb630327ac4b6 {
    constructor(config){
        this.middlewareStack = (0, $5KbfD.constructStack)();
        this.config = config;
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then((result)=>callback(null, result.output), (err)=>callback(err)).catch(()=>{});
        else return handler(command).then((result)=>result.output);
    }
    destroy() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    }
}

});
parcelRegister("29Tcr", function(module, exports) {
$parcel$export(module.exports, "constructStack", () => (parcelRequire("5KbfD")).constructStack);
parcelRequire("5KbfD");

});
parcelRegister("5KbfD", function(module, exports) {

$parcel$export(module.exports, "constructStack", () => $42e9f9e04e987c3d$export$73604a93307363d8);
const $42e9f9e04e987c3d$var$getAllAliases = (name, aliases)=>{
    const _aliases = [];
    if (name) _aliases.push(name);
    if (aliases) for (const alias of aliases)_aliases.push(alias);
    return _aliases;
};
const $42e9f9e04e987c3d$var$getMiddlewareNameWithAliases = (name, aliases)=>{
    return `${name || "anonymous"}${aliases && aliases.length > 0 ? ` (a.k.a. ${aliases.join(",")})` : ""}`;
};
const $42e9f9e04e987c3d$export$73604a93307363d8 = ()=>{
    let absoluteEntries = [];
    let relativeEntries = [];
    let identifyOnResolve = false;
    const entriesNameSet = new Set();
    const sort = (entries)=>entries.sort((a, b)=>$42e9f9e04e987c3d$var$stepWeights[b.step] - $42e9f9e04e987c3d$var$stepWeights[a.step] || $42e9f9e04e987c3d$var$priorityWeights[b.priority || "normal"] - $42e9f9e04e987c3d$var$priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            const aliases = $42e9f9e04e987c3d$var$getAllAliases(entry.name, entry.aliases);
            if (aliases.includes(toRemove)) {
                isRemoved = true;
                for (const alias of aliases)entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.middleware === toRemove) {
                isRemoved = true;
                for (const alias of $42e9f9e04e987c3d$var$getAllAliases(entry.name, entry.aliases))entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack)=>{
        absoluteEntries.forEach((entry)=>{
            toStack.add(entry.middleware, {
                ...entry
            });
        });
        relativeEntries.forEach((entry)=>{
            toStack.addRelativeTo(entry.middleware, {
                ...entry
            });
        });
        toStack.identifyOnResolve?.(stack.identifyOnResolve());
        return toStack;
    };
    const expandRelativeMiddlewareList = (from)=>{
        const expandedMiddlewareList = [];
        from.before.forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false)=>{
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $42e9f9e04e987c3d$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $42e9f9e04e987c3d$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry)=>{
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error(`${entry.toMiddleware} is not found when adding ` + `${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(entry.name, entry.aliases)} ` + `middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList)=>{
            wholeList.push(...expandedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {})=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware: middleware,
                ...options
            };
            const aliases = $42e9f9e04e987c3d$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = absoluteEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = absoluteEntries[toOverrideIndex];
                        if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) throw new Error(`"${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware with ` + `${toOverride.priority} priority in ${toOverride.step} step cannot ` + `be overridden by "${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware with ` + `${entry.priority} priority in ${entry.step} step.`);
                        absoluteEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options)=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                middleware: middleware,
                ...options
            };
            const aliases = $42e9f9e04e987c3d$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = relativeEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = relativeEntries[toOverrideIndex];
                        if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error(`"${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware ` + `${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` + `by "${$42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware ${entry.relation} ` + `"${entry.toMiddleware}" middleware.`);
                        relativeEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            relativeEntries.push(entry);
        },
        clone: ()=>cloneTo($42e9f9e04e987c3d$export$73604a93307363d8()),
        use: (plugin)=>{
            plugin.applyToStack(stack);
        },
        remove: (toRemove)=>{
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: (toRemove)=>{
            let isRemoved = false;
            const filterCb = (entry)=>{
                const { tags: tags, name: name, aliases: _aliases } = entry;
                if (tags && tags.includes(toRemove)) {
                    const aliases = $42e9f9e04e987c3d$var$getAllAliases(name, _aliases);
                    for (const alias of aliases)entriesNameSet.delete(alias);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from)=>{
            const cloned = cloneTo($42e9f9e04e987c3d$export$73604a93307363d8());
            cloned.use(from);
            cloned.identifyOnResolve(identifyOnResolve || cloned.identifyOnResolve() || (from.identifyOnResolve?.() ?? false));
            return cloned;
        },
        applyToStack: cloneTo,
        identify: ()=>{
            return getMiddlewareList(true).map((mw)=>{
                const step = mw.step ?? mw.relation + " " + mw.toMiddleware;
                return $42e9f9e04e987c3d$var$getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
            });
        },
        identifyOnResolve (toggle) {
            if (typeof toggle === "boolean") identifyOnResolve = toggle;
            return identifyOnResolve;
        },
        resolve: (handler, context)=>{
            for (const middleware of getMiddlewareList().map((entry)=>entry.middleware).reverse())handler = middleware(handler, context);
            if (identifyOnResolve) console.log(stack.identify());
            return handler;
        }
    };
    return stack;
};
const $42e9f9e04e987c3d$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
const $42e9f9e04e987c3d$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

});



parcelRegister("hEciL", function(module, exports) {

$parcel$export(module.exports, "collectBody", () => $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca);
parcelRequire("7nghV");
var $e8SAo = parcelRequire("e8SAo");
const $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca = async (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return (0, $e8SAo.Uint8ArrayBlobAdapter).mutate(streamBody);
    if (!streamBody) return (0, $e8SAo.Uint8ArrayBlobAdapter).mutate(new Uint8Array());
    const fromContext = context.streamCollector(streamBody);
    return (0, $e8SAo.Uint8ArrayBlobAdapter).mutate(await fromContext);
};

});
parcelRegister("7nghV", function(module, exports) {
$parcel$export(module.exports, "Uint8ArrayBlobAdapter", () => (parcelRequire("e8SAo")).Uint8ArrayBlobAdapter);
$parcel$export(module.exports, "sdkStreamMixin", () => (parcelRequire("6r6wj")).sdkStreamMixin);
parcelRequire("e8SAo");
parcelRequire("grjNH");
parcelRequire("6r6wj");
parcelRequire("cEyDX");
parcelRequire("deLvY");
parcelRequire("bC6qI");

});
parcelRegister("e8SAo", function(module, exports) {

$parcel$export(module.exports, "Uint8ArrayBlobAdapter", () => $a4bc27afde7d71d9$export$1465fbad93f83f0a);

var $adY7T = parcelRequire("adY7T");
class $a4bc27afde7d71d9$export$1465fbad93f83f0a extends Uint8Array {
    static fromString(source, encoding = "utf-8") {
        switch(typeof source){
            case "string":
                return (0, $adY7T.transformFromString)(source, encoding);
            default:
                throw new Error(`Unsupported conversion from ${typeof source} to Uint8ArrayBlobAdapter.`);
        }
    }
    static mutate(source) {
        Object.setPrototypeOf(source, $a4bc27afde7d71d9$export$1465fbad93f83f0a.prototype);
        return source;
    }
    transformToString(encoding = "utf-8") {
        return (0, $adY7T.transformToString)(this, encoding);
    }
}

});
parcelRegister("adY7T", function(module, exports) {

$parcel$export(module.exports, "transformToString", () => $7719c21ad0ffc017$export$e9aa0d127315abe);
$parcel$export(module.exports, "transformFromString", () => $7719c21ad0ffc017$export$ed8c0e91f57de3aa);
parcelRequire("sAmZU");
var $3kZdG = parcelRequire("3kZdG");
var $fSi4d = parcelRequire("fSi4d");
parcelRequire("geIv0");
var $1uolR = parcelRequire("1uolR");
var $3cIry = parcelRequire("3cIry");

var $e8SAo = parcelRequire("e8SAo");
function $7719c21ad0ffc017$export$e9aa0d127315abe(payload, encoding = "utf-8") {
    if (encoding === "base64") return (0, $fSi4d.toBase64)(payload);
    return (0, $3cIry.toUtf8)(payload);
}
function $7719c21ad0ffc017$export$ed8c0e91f57de3aa(str, encoding) {
    if (encoding === "base64") return (0, $e8SAo.Uint8ArrayBlobAdapter).mutate((0, $3kZdG.fromBase64)(str));
    return (0, $e8SAo.Uint8ArrayBlobAdapter).mutate((0, $1uolR.fromUtf8)(str));
}

});
parcelRegister("sAmZU", function(module, exports) {
$parcel$export(module.exports, "fromBase64", () => (parcelRequire("3kZdG")).fromBase64);
$parcel$export(module.exports, "toBase64", () => (parcelRequire("fSi4d")).toBase64);
parcelRequire("3kZdG");
parcelRequire("fSi4d");

});
parcelRegister("3kZdG", function(module, exports) {

$parcel$export(module.exports, "fromBase64", () => $26e2ba55729a8e75$export$c537b38001c583b7);

var $dU9VN = parcelRequire("dU9VN");
const $26e2ba55729a8e75$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $dU9VN.alphabetByEncoding))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $dU9VN.alphabetByEncoding)[input[j]] << (limit - j) * (0, $dU9VN.bitsPerLetter);
            bitLength += (0, $dU9VN.bitsPerLetter);
        } else bits >>= (0, $dU9VN.bitsPerLetter);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $dU9VN.bitsPerByte);
        const byteLength = Math.floor(bitLength / (0, $dU9VN.bitsPerByte));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $dU9VN.bitsPerByte);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};

});
parcelRegister("dU9VN", function(module, exports) {

$parcel$export(module.exports, "alphabetByEncoding", () => $a1f83572e1efebc8$export$7753813254d72972);
$parcel$export(module.exports, "alphabetByValue", () => $a1f83572e1efebc8$export$8f4022378ddff4c7);
$parcel$export(module.exports, "bitsPerLetter", () => $a1f83572e1efebc8$export$1c5cfd5e95b84581);
$parcel$export(module.exports, "bitsPerByte", () => $a1f83572e1efebc8$export$79b97ac4c24c9385);
$parcel$export(module.exports, "maxLetterValue", () => $a1f83572e1efebc8$export$43e943b030ae3d73);
const $a1f83572e1efebc8$export$7753813254d72972 = {};
const $a1f83572e1efebc8$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $a1f83572e1efebc8$export$7753813254d72972[char] = i;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $a1f83572e1efebc8$export$7753813254d72972[char] = index;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $a1f83572e1efebc8$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $a1f83572e1efebc8$export$7753813254d72972[char] = index;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[index] = char;
}
$a1f83572e1efebc8$export$7753813254d72972["+"] = 62;
$a1f83572e1efebc8$export$8f4022378ddff4c7[62] = "+";
$a1f83572e1efebc8$export$7753813254d72972["/"] = 63;
$a1f83572e1efebc8$export$8f4022378ddff4c7[63] = "/";
const $a1f83572e1efebc8$export$1c5cfd5e95b84581 = 6;
const $a1f83572e1efebc8$export$79b97ac4c24c9385 = 8;
const $a1f83572e1efebc8$export$43e943b030ae3d73 = 63;

});


parcelRegister("fSi4d", function(module, exports) {

$parcel$export(module.exports, "toBase64", () => $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462);
parcelRequire("geIv0");
var $1uolR = parcelRequire("1uolR");

var $dU9VN = parcelRequire("dU9VN");
function $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462(_input) {
    let input;
    if (typeof _input === "string") input = (0, $1uolR.fromUtf8)(_input);
    else input = _input;
    const isArrayLike = typeof input === "object" && typeof input.length === "number";
    const isUint8Array = typeof input === "object" && typeof input.byteOffset === "number" && typeof input.byteLength === "number";
    if (!isArrayLike && !isUint8Array) throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $dU9VN.bitsPerByte);
            bitLength += (0, $dU9VN.bitsPerByte);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $dU9VN.bitsPerLetter));
        bits <<= bitClusterCount * (0, $dU9VN.bitsPerLetter) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $dU9VN.bitsPerLetter);
            str += (0, $dU9VN.alphabetByValue)[(bits & (0, $dU9VN.maxLetterValue) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

});
parcelRegister("geIv0", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("1uolR")).fromUtf8);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("jGtn4")).toUint8Array);
$parcel$export(module.exports, "toUtf8", () => (parcelRequire("3cIry")).toUtf8);
parcelRequire("1uolR");
parcelRequire("jGtn4");
parcelRequire("3cIry");

});
parcelRegister("1uolR", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc);
const $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("jGtn4", function(module, exports) {

$parcel$export(module.exports, "toUint8Array", () => $e548b91235db5cfc$export$73470fd2221e6aef);

var $1uolR = parcelRequire("1uolR");
const $e548b91235db5cfc$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $1uolR.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("3cIry", function(module, exports) {

$parcel$export(module.exports, "toUtf8", () => $2554f7a5fe934436$export$b4b216764bb846eb);
const $2554f7a5fe934436$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

});






parcelRegister("grjNH", function(module, exports) {
const $bf7e86ef23159abe$export$cc0c9507624e70d1 = (readableStream, options)=>{
    const { base64Encoder: base64Encoder, bodyLengthChecker: bodyLengthChecker, checksumAlgorithmFn: checksumAlgorithmFn, checksumLocationName: checksumLocationName, streamHasher: streamHasher } = options;
    const checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
    const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
    const reader = readableStream.getReader();
    return new ReadableStream({
        async pull (controller) {
            const { value: value, done: done } = await reader.read();
            if (done) {
                controller.enqueue(`0\r\n`);
                if (checksumRequired) {
                    const checksum = base64Encoder(await digest);
                    controller.enqueue(`${checksumLocationName}:${checksum}\r\n`);
                    controller.enqueue(`\r\n`);
                }
                controller.close();
            } else controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r\n${value}\r\n`);
        }
    });
};

});

parcelRegister("6r6wj", function(module, exports) {

$parcel$export(module.exports, "sdkStreamMixin", () => $4afa527ae68dfced$export$5f9760b56bbf9f65);
parcelRequire("3SFJh");
var $KtzJ8 = parcelRequire("KtzJ8");
parcelRequire("sAmZU");
var $fSi4d = parcelRequire("fSi4d");

var $lUOK3 = parcelRequire("lUOK3");
parcelRequire("geIv0");
var $3cIry = parcelRequire("3cIry");

var $bC6qI = parcelRequire("bC6qI");
const $4afa527ae68dfced$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const $4afa527ae68dfced$export$5f9760b56bbf9f65 = (stream)=>{
    if (!$4afa527ae68dfced$var$isBlobInstance(stream) && !(0, $bC6qI.isReadableStream)(stream)) {
        const name = stream?.__proto__?.constructor?.name || stream;
        throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name}`);
    }
    let transformed = false;
    const transformToByteArray = async ()=>{
        if (transformed) throw new Error($4afa527ae68dfced$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
        transformed = true;
        return await (0, $KtzJ8.streamCollector)(stream);
    };
    const blobToWebStream = (blob)=>{
        if (typeof blob.stream !== "function") throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
        return blob.stream();
    };
    return Object.assign(stream, {
        transformToByteArray: transformToByteArray,
        transformToString: async (encoding)=>{
            const buf = await transformToByteArray();
            if (encoding === "base64") return (0, $fSi4d.toBase64)(buf);
            else if (encoding === "hex") return (0, $lUOK3.toHex)(buf);
            else if (encoding === undefined || encoding === "utf8" || encoding === "utf-8") return (0, $3cIry.toUtf8)(buf);
            else if (typeof TextDecoder === "function") return new TextDecoder(encoding).decode(buf);
            else throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
        },
        transformToWebStream: ()=>{
            if (transformed) throw new Error($4afa527ae68dfced$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            transformed = true;
            if ($4afa527ae68dfced$var$isBlobInstance(stream)) return blobToWebStream(stream);
            else if ((0, $bC6qI.isReadableStream)(stream)) return stream;
            else throw new Error(`Cannot transform payload to web stream, got ${stream}`);
        }
    });
};
const $4afa527ae68dfced$var$isBlobInstance = (stream)=>typeof Blob === "function" && stream instanceof Blob;

});
parcelRegister("3SFJh", function(module, exports) {
$parcel$export(module.exports, "FetchHttpHandler", () => (parcelRequire("dshpv")).FetchHttpHandler);
$parcel$export(module.exports, "streamCollector", () => (parcelRequire("KtzJ8")).streamCollector);
parcelRequire("dshpv");
parcelRequire("KtzJ8");

});
parcelRegister("dshpv", function(module, exports) {

$parcel$export(module.exports, "FetchHttpHandler", () => $9cbb653eb839bbf4$export$83588b87edbfa7e0);
parcelRequire("lJ13n");
var $3OhLM = parcelRequire("3OhLM");

var $fg0iI = parcelRequire("fg0iI");

var $7ssSX = parcelRequire("7ssSX");
const $9cbb653eb839bbf4$export$3d6343d6ab3191df = {
    supported: undefined
};
class $9cbb653eb839bbf4$export$83588b87edbfa7e0 {
    static create(instanceOrOptions) {
        if (typeof instanceOrOptions?.handle === "function") return instanceOrOptions;
        return new $9cbb653eb839bbf4$export$83588b87edbfa7e0(instanceOrOptions);
    }
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
        if ($9cbb653eb839bbf4$export$3d6343d6ab3191df.supported === undefined) $9cbb653eb839bbf4$export$3d6343d6ab3191df.supported = Boolean(typeof Request !== "undefined" && "keepalive" in new Request("https://[::1]"));
    }
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        const keepAlive = this.config.keepAlive === true;
        const credentials = this.config.credentials;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $fg0iI.buildQueryString)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method,
            credentials: credentials
        };
        if (body) requestOptions.duplex = "half";
        if (typeof AbortController !== "undefined") requestOptions.signal = abortSignal;
        if ($9cbb653eb839bbf4$export$3d6343d6ab3191df.supported) requestOptions.keepalive = keepAlive;
        let removeSignalEventListener = ()=>{};
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $3OhLM.HttpResponse)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $3OhLM.HttpResponse)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $7ssSX.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            const onAbort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
            if (typeof abortSignal.addEventListener === "function") {
                const signal = abortSignal;
                signal.addEventListener("abort", onAbort, {
                    once: true
                });
                removeSignalEventListener = ()=>signal.removeEventListener("abort", onAbort);
            } else abortSignal.onabort = onAbort;
        }));
        return Promise.race(raceOfPromises).finally(removeSignalEventListener);
    }
    updateHttpClientConfig(key, value) {
        this.config = undefined;
        this.configProvider = this.configProvider.then((config)=>{
            config[key] = value;
            return config;
        });
    }
    httpHandlerConfigs() {
        return this.config ?? {};
    }
}

});
parcelRegister("lJ13n", function(module, exports) {
$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => (parcelRequire("2ycgn")).getHttpHandlerExtensionConfiguration);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => (parcelRequire("2ycgn")).resolveHttpHandlerRuntimeConfig);
$parcel$export(module.exports, "HttpRequest", () => (parcelRequire("acFZn")).HttpRequest);
$parcel$export(module.exports, "HttpResponse", () => (parcelRequire("3OhLM")).HttpResponse);
parcelRequire("35ycI");
parcelRequire("hhtDk");
parcelRequire("elp5t");
parcelRequire("kGcET");
parcelRequire("acFZn");
parcelRequire("3OhLM");
parcelRequire("iw4Qy");
parcelRequire("6WPcE");

});
parcelRegister("35ycI", function(module, exports) {
$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => (parcelRequire("2ycgn")).getHttpHandlerExtensionConfiguration);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => (parcelRequire("2ycgn")).resolveHttpHandlerRuntimeConfig);
parcelRequire("2ycgn");

});
parcelRegister("2ycgn", function(module, exports) {

$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => $1db844f570103080$export$663b205817703038);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => $1db844f570103080$export$d94fe0350385c1a8);
const $1db844f570103080$export$663b205817703038 = (runtimeConfig)=>{
    let httpHandler = runtimeConfig.httpHandler;
    return {
        setHttpHandler (handler) {
            httpHandler = handler;
        },
        httpHandler () {
            return httpHandler;
        },
        updateHttpClientConfig (key, value) {
            httpHandler.updateHttpClientConfig(key, value);
        },
        httpHandlerConfigs () {
            return httpHandler.httpHandlerConfigs();
        }
    };
};
const $1db844f570103080$export$d94fe0350385c1a8 = (httpHandlerExtensionConfiguration)=>{
    return {
        httpHandler: httpHandlerExtensionConfiguration.httpHandler()
    };
};

});


parcelRegister("hhtDk", function(module, exports) {
parcelRequire("95Hh5");
var $2d9D8 = parcelRequire("2d9D8");
class $c94b02bf893e75d8$export$a455218a85c89869 {
    constructor({ name: name, kind: kind = (0, $2d9D8.FieldPosition).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}

});

parcelRegister("elp5t", function(module, exports) {
class $a7167cafc9d081ea$export$833b3e5a19fb8939 {
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}

});

parcelRegister("kGcET", function(module, exports) {

});

parcelRegister("acFZn", function(module, exports) {

$parcel$export(module.exports, "HttpRequest", () => $76db987a884ad8a2$export$7587955500404ec3);
class $76db987a884ad8a2$export$7587955500404ec3 {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static clone(request) {
        const cloned = new $76db987a884ad8a2$export$7587955500404ec3({
            ...request,
            headers: {
                ...request.headers
            }
        });
        if (cloned.query) cloned.query = $76db987a884ad8a2$var$cloneQuery(cloned.query);
        return cloned;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        return $76db987a884ad8a2$export$7587955500404ec3.clone(this);
    }
}
function $76db987a884ad8a2$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}

});

parcelRegister("3OhLM", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", () => $2c63d34427c28f98$export$1d94dfe0d9d1f1e7);
class $2c63d34427c28f98$export$1d94dfe0d9d1f1e7 {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}

});

parcelRegister("iw4Qy", function(module, exports) {
function $d7aef99e0ec8cee0$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

});

parcelRegister("6WPcE", function(module, exports) {

});


parcelRegister("fg0iI", function(module, exports) {

$parcel$export(module.exports, "buildQueryString", () => $b1b8956416c9f9fe$export$6b17a39e52c8ee53);
parcelRequire("5N8Rb");
var $5THLa = parcelRequire("5THLa");
function $b1b8956416c9f9fe$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $5THLa.escapeUri)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $5THLa.escapeUri)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $5THLa.escapeUri)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}

});
parcelRegister("5N8Rb", function(module, exports) {
$parcel$export(module.exports, "escapeUri", () => (parcelRequire("5THLa")).escapeUri);
parcelRequire("5THLa");
parcelRequire("lOuMg");

});
parcelRegister("5THLa", function(module, exports) {

$parcel$export(module.exports, "escapeUri", () => $44b4089172bbcee0$export$c3b4775ad75a73db);
const $44b4089172bbcee0$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $44b4089172bbcee0$var$hexEncode);
const $44b4089172bbcee0$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

});

parcelRegister("lOuMg", function(module, exports) {

var $5THLa = parcelRequire("5THLa");
const $fe16244244f29c08$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $5THLa.escapeUri)).join("/");

});



parcelRegister("7ssSX", function(module, exports) {

$parcel$export(module.exports, "requestTimeout", () => $56e18dfdfb3dcfa8$export$363ac302bdbd807b);
function $56e18dfdfb3dcfa8$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});


parcelRegister("KtzJ8", function(module, exports) {

$parcel$export(module.exports, "streamCollector", () => $08bb3d04fbb6f025$export$17bf97b72e307d52);
parcelRequire("sAmZU");
var $3kZdG = parcelRequire("3kZdG");
const $08bb3d04fbb6f025$export$17bf97b72e307d52 = (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob) return $08bb3d04fbb6f025$var$collectBlob(stream);
    return $08bb3d04fbb6f025$var$collectStream(stream);
};
async function $08bb3d04fbb6f025$var$collectBlob(blob) {
    const base64 = await $08bb3d04fbb6f025$var$readToBase64(blob);
    const arrayBuffer = (0, $3kZdG.fromBase64)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $08bb3d04fbb6f025$var$collectStream(stream) {
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    let length = 0;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            length += value.length;
        }
        isDone = done;
    }
    const collected = new Uint8Array(length);
    let offset = 0;
    for (const chunk of chunks){
        collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}
function $08bb3d04fbb6f025$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}

});


parcelRegister("lUOK3", function(module, exports) {

$parcel$export(module.exports, "fromHex", () => $ff463032e6a14a0a$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $ff463032e6a14a0a$export$7ea66e3774a60b67);
const $ff463032e6a14a0a$var$SHORT_TO_HEX = {};
const $ff463032e6a14a0a$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $ff463032e6a14a0a$var$SHORT_TO_HEX[i] = encodedByte;
    $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte] = i;
}
function $ff463032e6a14a0a$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $ff463032e6a14a0a$var$HEX_TO_SHORT) out[i / 2] = $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $ff463032e6a14a0a$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $ff463032e6a14a0a$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});

parcelRegister("bC6qI", function(module, exports) {

$parcel$export(module.exports, "isReadableStream", () => $87483b24f60de4fe$export$ac613ff475b69d05);
const $87483b24f60de4fe$export$ac613ff475b69d05 = (stream)=>typeof ReadableStream === "function" && (stream?.constructor?.name === ReadableStream.name || stream instanceof ReadableStream);

});


parcelRegister("cEyDX", function(module, exports) {
async function $936417f5af687998$export$e0d279bcdde969f4(stream) {
    if (typeof stream.stream === "function") stream = stream.stream();
    const readableStream = stream;
    return readableStream.tee();
}

});

parcelRegister("deLvY", function(module, exports) {
async function $9a3170947303079f$export$c5bd1fa662e233aa(stream, bytes) {
    let byteLengthCounter = 0;
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            byteLengthCounter += value?.byteLength ?? 0;
        }
        if (byteLengthCounter >= bytes) break;
        isDone = done;
    }
    reader.releaseLock();
    const collected = new Uint8Array(Math.min(bytes, byteLengthCounter));
    let offset = 0;
    for (const chunk of chunks){
        if (chunk.byteLength > collected.byteLength - offset) {
            collected.set(chunk.subarray(0, collected.byteLength - offset), offset);
            break;
        } else collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}

});



parcelRegister("dm5an", function(module, exports) {

$parcel$export(module.exports, "Command", () => $9b91565ddaedd0f1$export$cc7e12c76513e857);
parcelRequire("29Tcr");
var $5KbfD = parcelRequire("5KbfD");
parcelRequire("95Hh5");
var $35FCJ = parcelRequire("35FCJ");
class $9b91565ddaedd0f1$export$cc7e12c76513e857 {
    constructor(){
        this.middlewareStack = (0, $5KbfD.constructStack)();
    }
    static classBuilder() {
        return new $9b91565ddaedd0f1$var$ClassBuilder();
    }
    resolveMiddlewareWithContext(clientStack, configuration, options, { middlewareFn: middlewareFn, clientName: clientName, commandName: commandName, inputFilterSensitiveLog: inputFilterSensitiveLog, outputFilterSensitiveLog: outputFilterSensitiveLog, smithyContext: smithyContext, additionalContext: additionalContext, CommandCtor: CommandCtor }) {
        for (const mw of middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options))this.middlewareStack.use(mw);
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: inputFilterSensitiveLog,
            outputFilterSensitiveLog: outputFilterSensitiveLog,
            [(0, $35FCJ.SMITHY_CONTEXT_KEY)]: {
                commandInstance: this,
                ...smithyContext
            },
            ...additionalContext
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
}
class $9b91565ddaedd0f1$var$ClassBuilder {
    constructor(){
        this._init = ()=>{};
        this._ep = {};
        this._middlewareFn = ()=>[];
        this._commandName = "";
        this._clientName = "";
        this._additionalContext = {};
        this._smithyContext = {};
        this._inputFilterSensitiveLog = (_)=>_;
        this._outputFilterSensitiveLog = (_)=>_;
        this._serializer = null;
        this._deserializer = null;
    }
    init(cb) {
        this._init = cb;
    }
    ep(endpointParameterInstructions) {
        this._ep = endpointParameterInstructions;
        return this;
    }
    m(middlewareSupplier) {
        this._middlewareFn = middlewareSupplier;
        return this;
    }
    s(service, operation, smithyContext = {}) {
        this._smithyContext = {
            service: service,
            operation: operation,
            ...smithyContext
        };
        return this;
    }
    c(additionalContext = {}) {
        this._additionalContext = additionalContext;
        return this;
    }
    n(clientName, commandName) {
        this._clientName = clientName;
        this._commandName = commandName;
        return this;
    }
    f(inputFilter = (_)=>_, outputFilter = (_)=>_) {
        this._inputFilterSensitiveLog = inputFilter;
        this._outputFilterSensitiveLog = outputFilter;
        return this;
    }
    ser(serializer) {
        this._serializer = serializer;
        return this;
    }
    de(deserializer) {
        this._deserializer = deserializer;
        return this;
    }
    build() {
        const closure = this;
        let CommandRef;
        return CommandRef = class extends $9b91565ddaedd0f1$export$cc7e12c76513e857 {
            static getEndpointParameterInstructions() {
                return closure._ep;
            }
            constructor(...[input]){
                super();
                this.serialize = closure._serializer;
                this.deserialize = closure._deserializer;
                this.input = input ?? {};
                closure._init(this);
            }
            resolveMiddleware(stack, configuration, options) {
                return this.resolveMiddlewareWithContext(stack, configuration, options, {
                    CommandCtor: CommandRef,
                    middlewareFn: closure._middlewareFn,
                    clientName: closure._clientName,
                    commandName: closure._commandName,
                    inputFilterSensitiveLog: closure._inputFilterSensitiveLog,
                    outputFilterSensitiveLog: closure._outputFilterSensitiveLog,
                    smithyContext: closure._smithyContext,
                    additionalContext: closure._additionalContext
                });
            }
        };
    }
}

});

parcelRegister("bLYmx", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_STRING", () => $8922e83afabc5012$export$17127055dc9ac067);
const $8922e83afabc5012$export$17127055dc9ac067 = "***SensitiveInformation***";

});

parcelRegister("fBtuk", function(module, exports) {
const $b5c12f6f44721cae$export$d13079724e1f0e8b = (commands, Client)=>{
    for (const command of Object.keys(commands)){
        const CommandCtor = commands[command];
        const methodImpl = async function(args, optionsOrCb, cb) {
            const command = new CommandCtor(args);
            if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
            else if (typeof cb === "function") {
                if (typeof optionsOrCb !== "object") throw new Error(`Expected http options but got ${typeof optionsOrCb}`);
                this.send(command, optionsOrCb || {}, cb);
            } else return this.send(command, optionsOrCb);
        };
        const methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
        Client.prototype[methodName] = methodImpl;
    }
};

});

parcelRegister("iik7Y", function(module, exports) {

$parcel$export(module.exports, "parseRfc3339DateTime", () => $d519855744bca7a8$export$202e14f4d6038b6c);
$parcel$export(module.exports, "parseRfc3339DateTimeWithOffset", () => $d519855744bca7a8$export$3cb821e2875b4b7d);
$parcel$export(module.exports, "parseEpochTimestamp", () => $d519855744bca7a8$export$685da212e4e79e10);

var $kHa9s = parcelRequire("kHa9s");
const $d519855744bca7a8$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $d519855744bca7a8$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $d519855744bca7a8$export$5b50865171ed23a9(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${$d519855744bca7a8$var$DAYS[dayOfWeek]}, ${dayOfMonthString} ${$d519855744bca7a8$var$MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const $d519855744bca7a8$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
const $d519855744bca7a8$export$202e14f4d6038b6c = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $d519855744bca7a8$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = (0, $kHa9s.strictParseShort)($d519855744bca7a8$var$stripLeadingZeroes(yearStr));
    const month = $d519855744bca7a8$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31);
    return $d519855744bca7a8$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
const $d519855744bca7a8$var$RFC3339_WITH_OFFSET = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/);
const $d519855744bca7a8$export$3cb821e2875b4b7d = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $d519855744bca7a8$var$RFC3339_WITH_OFFSET.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, offsetStr] = match;
    const year = (0, $kHa9s.strictParseShort)($d519855744bca7a8$var$stripLeadingZeroes(yearStr));
    const month = $d519855744bca7a8$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31);
    const date = $d519855744bca7a8$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
    if (offsetStr.toUpperCase() != "Z") date.setTime(date.getTime() - $d519855744bca7a8$var$parseOffsetToMilliseconds(offsetStr));
    return date;
};
const $d519855744bca7a8$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $d519855744bca7a8$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $d519855744bca7a8$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
const $d519855744bca7a8$export$cf3a566289648a1e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    let match = $d519855744bca7a8$var$IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $d519855744bca7a8$var$buildDate((0, $kHa9s.strictParseShort)($d519855744bca7a8$var$stripLeadingZeroes(yearStr)), $d519855744bca7a8$var$parseMonthByShortName(monthStr), $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $d519855744bca7a8$var$RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $d519855744bca7a8$var$adjustRfc850Year($d519855744bca7a8$var$buildDate($d519855744bca7a8$var$parseTwoDigitYear(yearStr), $d519855744bca7a8$var$parseMonthByShortName(monthStr), $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $d519855744bca7a8$var$ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return $d519855744bca7a8$var$buildDate((0, $kHa9s.strictParseShort)($d519855744bca7a8$var$stripLeadingZeroes(yearStr)), $d519855744bca7a8$var$parseMonthByShortName(monthStr), $d519855744bca7a8$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const $d519855744bca7a8$export$685da212e4e79e10 = (value)=>{
    if (value === null || value === undefined) return undefined;
    let valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $kHa9s.strictParseDouble)(value);
    else if (typeof value === "object" && value.tag === 1) valueAsDouble = value.value;
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
const $d519855744bca7a8$var$buildDate = (year, month, day, time)=>{
    const adjustedMonth = month - 1;
    $d519855744bca7a8$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $d519855744bca7a8$var$parseDateValue(time.hours, "hour", 0, 23), $d519855744bca7a8$var$parseDateValue(time.minutes, "minute", 0, 59), $d519855744bca7a8$var$parseDateValue(time.seconds, "seconds", 0, 60), $d519855744bca7a8$var$parseMilliseconds(time.fractionalMilliseconds)));
};
const $d519855744bca7a8$var$parseTwoDigitYear = (value)=>{
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $kHa9s.strictParseShort)($d519855744bca7a8$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
const $d519855744bca7a8$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
const $d519855744bca7a8$var$adjustRfc850Year = (input)=>{
    if (input.getTime() - new Date().getTime() > $d519855744bca7a8$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
const $d519855744bca7a8$var$parseMonthByShortName = (value)=>{
    const monthIdx = $d519855744bca7a8$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError(`Invalid month: ${value}`);
    return monthIdx + 1;
};
const $d519855744bca7a8$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $d519855744bca7a8$var$validateDayOfMonth = (year, month, day)=>{
    let maxDays = $d519855744bca7a8$var$DAYS_IN_MONTH[month];
    if (month === 1 && $d519855744bca7a8$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError(`Invalid day for ${$d519855744bca7a8$var$MONTHS[month]} in ${year}: ${day}`);
};
const $d519855744bca7a8$var$isLeapYear = (year)=>{
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const $d519855744bca7a8$var$parseDateValue = (value, type, lower, upper)=>{
    const dateVal = (0, $kHa9s.strictParseByte)($d519855744bca7a8$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    return dateVal;
};
const $d519855744bca7a8$var$parseMilliseconds = (value)=>{
    if (value === null || value === undefined) return 0;
    return (0, $kHa9s.strictParseFloat32)("0." + value) * 1000;
};
const $d519855744bca7a8$var$parseOffsetToMilliseconds = (value)=>{
    const directionStr = value[0];
    let direction = 1;
    if (directionStr == "+") direction = 1;
    else if (directionStr == "-") direction = -1;
    else throw new TypeError(`Offset direction, ${directionStr}, must be "+" or "-"`);
    const hour = Number(value.substring(1, 3));
    const minute = Number(value.substring(4, 6));
    return direction * (hour * 60 + minute) * 60000;
};
const $d519855744bca7a8$var$stripLeadingZeroes = (value)=>{
    let idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

});
parcelRegister("kHa9s", function(module, exports) {

$parcel$export(module.exports, "expectBoolean", () => $f10fb2b359b91940$export$259b2ebfc29bf466);
$parcel$export(module.exports, "expectNumber", () => $f10fb2b359b91940$export$f3945e48fdb5f9a);
$parcel$export(module.exports, "expectInt32", () => $f10fb2b359b91940$export$99c64e845cdac9c1);
$parcel$export(module.exports, "expectNonNull", () => $f10fb2b359b91940$export$8413a63dbe548a49);
$parcel$export(module.exports, "expectString", () => $f10fb2b359b91940$export$7ed80f53fe336639);
$parcel$export(module.exports, "strictParseDouble", () => $f10fb2b359b91940$export$89e17ed633a86621);
$parcel$export(module.exports, "strictParseFloat32", () => $f10fb2b359b91940$export$b15cbcea8b4c492f);
$parcel$export(module.exports, "strictParseInt32", () => $f10fb2b359b91940$export$c3c2f00b115709e6);
$parcel$export(module.exports, "strictParseShort", () => $f10fb2b359b91940$export$813d4a13f25c6b38);
$parcel$export(module.exports, "strictParseByte", () => $f10fb2b359b91940$export$f18d20ea3b6b353);
const $f10fb2b359b91940$export$3fb54149990fb5b5 = (value)=>{
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const $f10fb2b359b91940$export$259b2ebfc29bf466 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$export$f3945e48fdb5f9a = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected number but observed string: ${value}`));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$var$MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const $f10fb2b359b91940$export$44880ec4d8d4909d = (value)=>{
    const expected = $f10fb2b359b91940$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $f10fb2b359b91940$var$MAX_FLOAT) throw new TypeError(`Expected 32-bit float, got ${value}`);
    }
    return expected;
};
const $f10fb2b359b91940$export$a883517a83c9c18 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$export$dbec7593c34ded08 = $f10fb2b359b91940$export$a883517a83c9c18;
const $f10fb2b359b91940$export$99c64e845cdac9c1 = (value)=>$f10fb2b359b91940$var$expectSizedInt(value, 32);
const $f10fb2b359b91940$export$d4f903340b146129 = (value)=>$f10fb2b359b91940$var$expectSizedInt(value, 16);
const $f10fb2b359b91940$export$3e4c4435b3b19562 = (value)=>$f10fb2b359b91940$var$expectSizedInt(value, 8);
const $f10fb2b359b91940$var$expectSizedInt = (value, size)=>{
    const expected = $f10fb2b359b91940$export$a883517a83c9c18(value);
    if (expected !== undefined && $f10fb2b359b91940$var$castInt(expected, size) !== expected) throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    return expected;
};
const $f10fb2b359b91940$var$castInt = (value, size)=>{
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const $f10fb2b359b91940$export$8413a63dbe548a49 = (value, location)=>{
    if (value === null || value === undefined) {
        if (location) throw new TypeError(`Expected a non-null value for ${location}`);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const $f10fb2b359b91940$export$cf825aadce530e7e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const $f10fb2b359b91940$export$7ed80f53fe336639 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$export$9ef77073e45b6301 = (value)=>{
    if (value === null || value === undefined) return undefined;
    const asObject = $f10fb2b359b91940$export$cf825aadce530e7e(value);
    const setKeys = Object.entries(asObject).filter(([, v])=>v != null).map(([k])=>k);
    if (setKeys.length === 0) throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    if (setKeys.length > 1) throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    return asObject;
};
const $f10fb2b359b91940$export$89e17ed633a86621 = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$export$f3945e48fdb5f9a($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$f3945e48fdb5f9a(value);
};
const $f10fb2b359b91940$export$884f8e3b42a6cfbf = $f10fb2b359b91940$export$89e17ed633a86621;
const $f10fb2b359b91940$export$b15cbcea8b4c492f = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$export$44880ec4d8d4909d($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$44880ec4d8d4909d(value);
};
const $f10fb2b359b91940$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const $f10fb2b359b91940$var$parseNumber = (value)=>{
    const matches = value.match($f10fb2b359b91940$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError(`Expected real number, got implicit NaN`);
    return parseFloat(value);
};
const $f10fb2b359b91940$export$11335e83c8af2784 = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$var$parseFloatString(value);
    return $f10fb2b359b91940$export$f3945e48fdb5f9a(value);
};
const $f10fb2b359b91940$export$b6a7906d2e4b31df = $f10fb2b359b91940$export$11335e83c8af2784;
const $f10fb2b359b91940$export$50b04c19f942a079 = $f10fb2b359b91940$export$11335e83c8af2784;
const $f10fb2b359b91940$export$f14938f3036dd492 = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$var$parseFloatString(value);
    return $f10fb2b359b91940$export$44880ec4d8d4909d(value);
};
const $f10fb2b359b91940$var$parseFloatString = (value)=>{
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const $f10fb2b359b91940$export$f90617f39a736d36 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$a883517a83c9c18($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$a883517a83c9c18(value);
};
const $f10fb2b359b91940$export$39b7be5d28a09fe1 = $f10fb2b359b91940$export$f90617f39a736d36;
const $f10fb2b359b91940$export$c3c2f00b115709e6 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$99c64e845cdac9c1($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$99c64e845cdac9c1(value);
};
const $f10fb2b359b91940$export$813d4a13f25c6b38 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$d4f903340b146129($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$d4f903340b146129(value);
};
const $f10fb2b359b91940$export$f18d20ea3b6b353 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$3e4c4435b3b19562($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$3e4c4435b3b19562(value);
};
const $f10fb2b359b91940$var$stackTraceWarning = (message)=>{
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter((s)=>!s.includes("stackTraceWarning")).join("\n");
};
const $f10fb2b359b91940$export$af88d00dbe7f521 = {
    warn: console.warn
};

});


parcelRegister("alLJe", function(module, exports) {

$parcel$export(module.exports, "withBaseException", () => $7890e3748e9b15a4$export$62ac8acba1748a85);

var $l1h1U = parcelRequire("l1h1U");
const $7890e3748e9b15a4$export$3df0f68aaf858737 = ({ output: output, parsedBody: parsedBody, exceptionCtor: exceptionCtor, errorCode: errorCode })=>{
    const $metadata = $7890e3748e9b15a4$var$deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody?.code || parsedBody?.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, $l1h1U.decorateServiceException)(response, parsedBody);
};
const $7890e3748e9b15a4$export$62ac8acba1748a85 = (ExceptionCtor)=>{
    return ({ output: output, parsedBody: parsedBody, errorCode: errorCode })=>{
        $7890e3748e9b15a4$export$3df0f68aaf858737({
            output: output,
            parsedBody: parsedBody,
            exceptionCtor: ExceptionCtor,
            errorCode: errorCode
        });
    };
};
const $7890e3748e9b15a4$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });

});
parcelRegister("l1h1U", function(module, exports) {

$parcel$export(module.exports, "ServiceException", () => $f4d6e6bcf25435f5$export$29647f3b4097d3c0);
$parcel$export(module.exports, "decorateServiceException", () => $f4d6e6bcf25435f5$export$db01f0c43e877a50);
class $f4d6e6bcf25435f5$export$29647f3b4097d3c0 extends Error {
    constructor(options){
        super(options.message);
        Object.setPrototypeOf(this, $f4d6e6bcf25435f5$export$29647f3b4097d3c0.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
}
const $f4d6e6bcf25435f5$export$db01f0c43e877a50 = (exception, additions = {})=>{
    Object.entries(additions).filter(([, v])=>v !== undefined).forEach(([k, v])=>{
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

});


parcelRegister("aczlM", function(module, exports) {

$parcel$export(module.exports, "loadConfigsForDefaultMode", () => $76d6722ee679f099$export$b6e2b46631b45a92);
const $76d6722ee679f099$export$b6e2b46631b45a92 = (mode)=>{
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

});

parcelRegister("avLqn", function(module, exports) {
let $7a71961dd24090a7$var$warningEmitted = false;
const $7a71961dd24090a7$export$96550b8fa3e6f65a = (version)=>{
    if (version && !$7a71961dd24090a7$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 16) $7a71961dd24090a7$var$warningEmitted = true;
};

});

parcelRegister("i0Ktq", function(module, exports) {
$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => (parcelRequire("6vLVm")).getDefaultExtensionConfiguration);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => (parcelRequire("6vLVm")).resolveDefaultRuntimeConfig);
parcelRequire("6vLVm");

});
parcelRegister("6vLVm", function(module, exports) {

$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => $4bdad01735bad74c$export$2d53aaae46f156f5);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => $4bdad01735bad74c$export$abfa28b95316e0ae);

var $17POX = parcelRequire("17POX");

var $6qVxl = parcelRequire("6qVxl");
const $4bdad01735bad74c$export$2d53aaae46f156f5 = (runtimeConfig)=>{
    return {
        ...(0, $17POX.getChecksumConfiguration)(runtimeConfig),
        ...(0, $6qVxl.getRetryConfiguration)(runtimeConfig)
    };
};
const $4bdad01735bad74c$export$7081660fd0cd662b = $4bdad01735bad74c$export$2d53aaae46f156f5;
const $4bdad01735bad74c$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $17POX.resolveChecksumRuntimeConfig)(config),
        ...(0, $6qVxl.resolveRetryRuntimeConfig)(config)
    };
};

});
parcelRegister("17POX", function(module, exports) {

$parcel$export(module.exports, "getChecksumConfiguration", () => $0d1ea476e89901b4$export$129b301e72591856);
$parcel$export(module.exports, "resolveChecksumRuntimeConfig", () => $0d1ea476e89901b4$export$589dfc268e61d391);
parcelRequire("95Hh5");
var $02fee = parcelRequire("02fee");
const $0d1ea476e89901b4$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    for(const id in 0, $02fee.AlgorithmId){
        const algorithmId = (0, $02fee.AlgorithmId)[id];
        if (runtimeConfig[algorithmId] === undefined) continue;
        checksumAlgorithms.push({
            algorithmId: ()=>algorithmId,
            checksumConstructor: ()=>runtimeConfig[algorithmId]
        });
    }
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $0d1ea476e89901b4$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};

});

parcelRegister("6qVxl", function(module, exports) {

$parcel$export(module.exports, "getRetryConfiguration", () => $4af1cd6a0c091beb$export$d36c8ee6d99d60f7);
$parcel$export(module.exports, "resolveRetryRuntimeConfig", () => $4af1cd6a0c091beb$export$67f4c4448e6afddf);
const $4af1cd6a0c091beb$export$d36c8ee6d99d60f7 = (runtimeConfig)=>{
    let _retryStrategy = runtimeConfig.retryStrategy;
    return {
        setRetryStrategy (retryStrategy) {
            _retryStrategy = retryStrategy;
        },
        retryStrategy () {
            return _retryStrategy;
        }
    };
};
const $4af1cd6a0c091beb$export$67f4c4448e6afddf = (retryStrategyConfiguration)=>{
    const runtimeConfig = {};
    runtimeConfig.retryStrategy = retryStrategyConfiguration.retryStrategy();
    return runtimeConfig;
};

});



parcelRegister("2w5pr", function(module, exports) {

$parcel$export(module.exports, "extendedEncodeURIComponent", () => $1d52c41f10162b1d$export$7640f3c16fe7f54b);
function $1d52c41f10162b1d$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

});

parcelRegister("aQZR7", function(module, exports) {
const $7e6ebdfaa9b33533$export$52272e038712c64e = (mayBeArray)=>Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];

});

parcelRegister("buZaR", function(module, exports) {

$parcel$export(module.exports, "getValueFromTextNode", () => $85f1f2fc8f60827c$export$113d90026b452881);
const $85f1f2fc8f60827c$export$113d90026b452881 = (obj)=>{
    const textNodeName = "#text";
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $85f1f2fc8f60827c$export$113d90026b452881(obj[key]);
    }
    return obj;
};

});

parcelRegister("cI8D9", function(module, exports) {
const $941049e874f424ad$export$40e2db4f1ce24b10 = function() {
    const Class = Object.getPrototypeOf(this).constructor;
    const Constructor = Function.bind.apply(String, [
        null,
        ...arguments
    ]);
    const instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$941049e874f424ad$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $941049e874f424ad$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($941049e874f424ad$export$40e2db4f1ce24b10, String);
class $941049e874f424ad$export$494ed5148690ecaf extends $941049e874f424ad$export$40e2db4f1ce24b10 {
    deserializeJSON() {
        return JSON.parse(super.toString());
    }
    toJSON() {
        return super.toString();
    }
    static fromObject(object) {
        if (object instanceof $941049e874f424ad$export$494ed5148690ecaf) return object;
        else if (object instanceof String || typeof object === "string") return new $941049e874f424ad$export$494ed5148690ecaf(object);
        return new $941049e874f424ad$export$494ed5148690ecaf(JSON.stringify(object));
    }
}

});

parcelRegister("gZe9T", function(module, exports) {

$parcel$export(module.exports, "take", () => $c5dd53748caa092b$export$b7df5d561049483a);
function $c5dd53748caa092b$export$871de8747c9eaa88(arg0, arg1, arg2) {
    let target;
    let filter;
    let instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return $c5dd53748caa092b$var$mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    for (const key of Object.keys(instructions)){
        if (!Array.isArray(instructions[key])) {
            target[key] = instructions[key];
            continue;
        }
        $c5dd53748caa092b$var$applyInstruction(target, null, instructions, key);
    }
    return target;
}
const $c5dd53748caa092b$export$a2c0df515c751f13 = (target)=>{
    const output = {};
    for (const [k, v] of Object.entries(target || {}))output[k] = [
        ,
        v
    ];
    return output;
};
const $c5dd53748caa092b$export$b7df5d561049483a = (source, instructions)=>{
    const out = {};
    for(const key in instructions)$c5dd53748caa092b$var$applyInstruction(out, source, instructions, key);
    return out;
};
const $c5dd53748caa092b$var$mapWithFilter = (target, filter, instructions)=>{
    return $c5dd53748caa092b$export$871de8747c9eaa88(target, Object.entries(instructions).reduce((_instructions, [key, value])=>{
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};
const $c5dd53748caa092b$var$applyInstruction = (target, source, instructions, targetKey)=>{
    if (source !== null) {
        let instruction = instructions[targetKey];
        if (typeof instruction === "function") instruction = [
            ,
            instruction
        ];
        const [filter = $c5dd53748caa092b$var$nonNullish, valueFn = $c5dd53748caa092b$var$pass, sourceKey = targetKey] = instruction;
        if (typeof filter === "function" && filter(source[sourceKey]) || typeof filter !== "function" && !!filter) target[targetKey] = valueFn(source[sourceKey]);
        return;
    }
    let [filter, value] = instructions[targetKey];
    if (typeof value === "function") {
        let _value;
        const defaultFilterPassed = filter === undefined && (_value = value()) != null;
        const customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed) target[targetKey] = _value;
        else if (customFilterPassed) target[targetKey] = value();
    } else {
        const defaultFilterPassed = filter === undefined && value != null;
        const customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed || customFilterPassed) target[targetKey] = value;
    }
};
const $c5dd53748caa092b$var$nonNullish = (_)=>_ != null;
const $c5dd53748caa092b$var$pass = (_)=>_;

});

parcelRegister("9GK4j", function(module, exports) {

$parcel$export(module.exports, "resolvedPath", () => $70dbc58951792150$export$405ac9a9ce1cbd80);

var $2w5pr = parcelRequire("2w5pr");
const $70dbc58951792150$export$405ac9a9ce1cbd80 = (resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel)=>{
    if (input != null && input[memberName] !== undefined) {
        const labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment)=>(0, $2w5pr.extendedEncodeURIComponent)(segment)).join("/") : (0, $2w5pr.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};

});

parcelRegister("6eupr", function(module, exports) {
const $489ba385804e8644$export$4a2bea4ecaa09ba7 = (value)=>{
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};
const $489ba385804e8644$export$93f3a0dd288ea1c8 = (date)=>date.toISOString().replace(".000Z", "Z");

});

parcelRegister("kfE6I", function(module, exports) {

$parcel$export(module.exports, "_json", () => $ebe451dc94a22d0f$export$e0ede334cf6ab53c);
const $ebe451dc94a22d0f$export$e0ede334cf6ab53c = (obj)=>{
    if (obj == null) return {};
    if (Array.isArray(obj)) return obj.filter((_)=>_ != null).map($ebe451dc94a22d0f$export$e0ede334cf6ab53c);
    if (typeof obj === "object") {
        const target = {};
        for (const key of Object.keys(obj)){
            if (obj[key] == null) continue;
            target[key] = $ebe451dc94a22d0f$export$e0ede334cf6ab53c(obj[key]);
        }
        return target;
    }
    return obj;
};

});

parcelRegister("lTTQL", function(module, exports) {
function $ff1a0eaa8d696784$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    const segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    const compoundSegments = [];
    let currentSegment = "";
    for(let i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

});


parcelRegister("gugHf", function(module, exports) {

$parcel$export(module.exports, "parseJsonBody", () => $c00c6648b526529c$export$759bcb35b0d1bf81);
$parcel$export(module.exports, "parseJsonErrorBody", () => $c00c6648b526529c$export$cb111c4739f3951f);
$parcel$export(module.exports, "loadRestJsonErrorCode", () => $c00c6648b526529c$export$6e21dac881a79e70);

var $lFiCX = parcelRequire("lFiCX");
const $c00c6648b526529c$export$759bcb35b0d1bf81 = (streamBody, context)=>(0, $lFiCX.collectBodyString)(streamBody, context).then((encoded)=>{
        if (encoded.length) try {
            return JSON.parse(encoded);
        } catch (e) {
            if (e?.name === "SyntaxError") Object.defineProperty(e, "$responseBodyText", {
                value: encoded
            });
            throw e;
        }
        return {};
    });
const $c00c6648b526529c$export$cb111c4739f3951f = async (errorBody, context)=>{
    const value = await $c00c6648b526529c$export$759bcb35b0d1bf81(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const $c00c6648b526529c$export$6e21dac881a79e70 = (output, data)=>{
    const findKey = (object, key)=>Object.keys(object).find((k)=>k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue)=>{
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

});
parcelRegister("lFiCX", function(module, exports) {

$parcel$export(module.exports, "collectBodyString", () => $fc5be054d0d3ae76$export$3cc1021c6dfb9c3e);
parcelRequire("eKvzZ");
var $hEciL = parcelRequire("hEciL");
const $fc5be054d0d3ae76$export$3cc1021c6dfb9c3e = (streamBody, context)=>(0, $hEciL.collectBody)(streamBody, context).then((body)=>context.utf8Encoder(body));

});


parcelRegister("bKjgg", function(module, exports) {

$parcel$export(module.exports, "resolveHostHeaderConfig", () => $88d2ee7e36f5c90f$export$c1625bf0b32b4481);
$parcel$export(module.exports, "getHostHeaderPlugin", () => $88d2ee7e36f5c90f$export$23d3b647211be53a);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
function $88d2ee7e36f5c90f$export$c1625bf0b32b4481(input) {
    return input;
}
const $88d2ee7e36f5c90f$export$858685d7aeef192d = (options)=>(next)=>async (args)=>{
            if (!(0, $acFZn.HttpRequest).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { handlerProtocol: handlerProtocol = "" } = options.requestHandler.metadata || {};
            if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                delete request.headers["host"];
                request.headers[":authority"] = request.hostname + (request.port ? ":" + request.port : "");
            } else if (!request.headers["host"]) {
                let host = request.hostname;
                if (request.port != null) host += `:${request.port}`;
                request.headers["host"] = host;
            }
            return next(args);
        };
const $88d2ee7e36f5c90f$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
const $88d2ee7e36f5c90f$export$23d3b647211be53a = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($88d2ee7e36f5c90f$export$858685d7aeef192d(options), $88d2ee7e36f5c90f$export$696d244ba96181e8);
        }
    });

});

parcelRegister("ktQJf", function(module, exports) {
$parcel$export(module.exports, "getLoggerPlugin", () => (parcelRequire("bVaTS")).getLoggerPlugin);
parcelRequire("bVaTS");

});
parcelRegister("bVaTS", function(module, exports) {

$parcel$export(module.exports, "getLoggerPlugin", () => $8add791fe0d5d356$export$f6ef65d7766fc255);
const $8add791fe0d5d356$export$fe0e777ee4f58cde = ()=>(next, context)=>async (args)=>{
            try {
                const response = await next(args);
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog: overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context.outputFilterSensitiveLog;
                const { $metadata: $metadata, ...outputWithoutMetadata } = response.output;
                logger?.info?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                    metadata: $metadata
                });
                return response;
            } catch (error) {
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                logger?.error?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    error: error,
                    metadata: error.$metadata
                });
                throw error;
            }
        };
const $8add791fe0d5d356$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
const $8add791fe0d5d356$export$f6ef65d7766fc255 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($8add791fe0d5d356$export$fe0e777ee4f58cde(), $8add791fe0d5d356$export$877c148ab4ad0722);
        }
    });

});


parcelRegister("8j4Ts", function(module, exports) {

$parcel$export(module.exports, "getRecursionDetectionPlugin", () => $60c3e4d6205418db$export$11d0b9345788bd5);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");

var $hPtJY = parcelRequire("hPtJY");
const $60c3e4d6205418db$var$TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const $60c3e4d6205418db$var$ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const $60c3e4d6205418db$var$ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const $60c3e4d6205418db$export$d12885408d4c0634 = (options)=>(next)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $acFZn.HttpRequest).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty($60c3e4d6205418db$var$TRACE_ID_HEADER_NAME)) return next(args);
            const functionName = $hPtJY.env[$60c3e4d6205418db$var$ENV_LAMBDA_FUNCTION_NAME];
            const traceId = $hPtJY.env[$60c3e4d6205418db$var$ENV_TRACE_ID];
            const nonEmptyString = (str)=>typeof str === "string" && str.length > 0;
            if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[$60c3e4d6205418db$var$TRACE_ID_HEADER_NAME] = traceId;
            return next({
                ...args,
                request: request
            });
        };
const $60c3e4d6205418db$export$1f1705db3faed8f3 = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
const $60c3e4d6205418db$export$11d0b9345788bd5 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($60c3e4d6205418db$export$d12885408d4c0634(options), $60c3e4d6205418db$export$1f1705db3faed8f3);
        }
    });

});

parcelRegister("gEO0Y", function(module, exports) {
$parcel$export(module.exports, "resolveUserAgentConfig", () => (parcelRequire("a4d7T")).resolveUserAgentConfig);
$parcel$export(module.exports, "getUserAgentPlugin", () => (parcelRequire("azZ8T")).getUserAgentPlugin);
parcelRequire("a4d7T");
parcelRequire("azZ8T");

});
parcelRegister("a4d7T", function(module, exports) {

$parcel$export(module.exports, "resolveUserAgentConfig", () => $754475b8730b53d4$export$ec9a2d5663958cb);
function $754475b8730b53d4$export$ec9a2d5663958cb(input) {
    return {
        ...input,
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    };
}

});

parcelRegister("azZ8T", function(module, exports) {

$parcel$export(module.exports, "getUserAgentPlugin", () => $7b3c99e5173f4767$export$5393c0d2d7f4f5f0);
parcelRequire("fCO99");
var $iV6h0 = parcelRequire("iV6h0");
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");

var $E1iFG = parcelRequire("E1iFG");
const $7b3c99e5173f4767$export$62c460923941c0b0 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $acFZn.HttpRequest).isInstance(request)) return next(args);
            const { headers: headers } = request;
            const userAgent = context?.userAgent?.map($7b3c99e5173f4767$var$escapeUserAgent) || [];
            const defaultUserAgent = (await options.defaultUserAgentProvider()).map($7b3c99e5173f4767$var$escapeUserAgent);
            const customUserAgent = options?.customUserAgent?.map($7b3c99e5173f4767$var$escapeUserAgent) || [];
            const prefix = (0, $iV6h0.getUserAgentPrefix)();
            const sdkUserAgentValue = (prefix ? [
                prefix
            ] : []).concat([
                ...defaultUserAgent,
                ...userAgent,
                ...customUserAgent
            ]).join((0, $E1iFG.SPACE));
            const normalUAValue = [
                ...defaultUserAgent.filter((section)=>section.startsWith("aws-sdk-")),
                ...customUserAgent
            ].join((0, $E1iFG.SPACE));
            if (options.runtime !== "browser") {
                if (normalUAValue) headers[0, $E1iFG.X_AMZ_USER_AGENT] = headers[0, $E1iFG.X_AMZ_USER_AGENT] ? `${headers[0, $E1iFG.USER_AGENT]} ${normalUAValue}` : normalUAValue;
                headers[0, $E1iFG.USER_AGENT] = sdkUserAgentValue;
            } else headers[0, $E1iFG.X_AMZ_USER_AGENT] = sdkUserAgentValue;
            return next({
                ...args,
                request: request
            });
        };
const $7b3c99e5173f4767$var$escapeUserAgent = (userAgentPair)=>{
    const name = userAgentPair[0].split((0, $E1iFG.UA_NAME_SEPARATOR)).map((part)=>part.replace((0, $E1iFG.UA_NAME_ESCAPE_REGEX), (0, $E1iFG.UA_ESCAPE_CHAR))).join((0, $E1iFG.UA_NAME_SEPARATOR));
    const version = userAgentPair[1]?.replace((0, $E1iFG.UA_VALUE_ESCAPE_REGEX), (0, $E1iFG.UA_ESCAPE_CHAR));
    const prefixSeparatorIndex = name.indexOf((0, $E1iFG.UA_NAME_SEPARATOR));
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter((item)=>item && item.length > 0).reduce((acc, item, index)=>{
        switch(index){
            case 0:
                return item;
            case 1:
                return `${acc}/${item}`;
            default:
                return `${acc}#${item}`;
        }
    }, "");
};
const $7b3c99e5173f4767$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
const $7b3c99e5173f4767$export$5393c0d2d7f4f5f0 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($7b3c99e5173f4767$export$62c460923941c0b0(config), $7b3c99e5173f4767$export$29eb04da6afef73f);
        }
    });

});
parcelRegister("fCO99", function(module, exports) {
$parcel$export(module.exports, "awsEndpointFunctions", () => (parcelRequire("bNrU9")).awsEndpointFunctions);
$parcel$export(module.exports, "getUserAgentPrefix", () => (parcelRequire("iV6h0")).getUserAgentPrefix);
parcelRequire("bNrU9");
parcelRequire("iV6h0");
parcelRequire("5wMR6");
parcelRequire("7DQCE");
parcelRequire("jGBri");

});
parcelRegister("bNrU9", function(module, exports) {

$parcel$export(module.exports, "awsEndpointFunctions", () => $8969ea93d35fa137$export$1bfd97ffc6d0eef8);
parcelRequire("8nNaZ");
var $eVY0r = parcelRequire("eVY0r");

var $4beS5 = parcelRequire("4beS5");

var $bUkx2 = parcelRequire("bUkx2");

var $iV6h0 = parcelRequire("iV6h0");
const $8969ea93d35fa137$export$1bfd97ffc6d0eef8 = {
    isVirtualHostableS3Bucket: (0, $4beS5.isVirtualHostableS3Bucket),
    parseArn: (0, $bUkx2.parseArn),
    partition: (0, $iV6h0.partition)
};
(0, $eVY0r.customEndpointFunctions).aws = $8969ea93d35fa137$export$1bfd97ffc6d0eef8;

});
parcelRegister("8nNaZ", function(module, exports) {
$parcel$export(module.exports, "isIpAddress", () => (parcelRequire("V3yru")).isIpAddress);
$parcel$export(module.exports, "isValidHostLabel", () => (parcelRequire("flMx7")).isValidHostLabel);
$parcel$export(module.exports, "customEndpointFunctions", () => (parcelRequire("eVY0r")).customEndpointFunctions);
$parcel$export(module.exports, "resolveEndpoint", () => (parcelRequire("bZE5G")).resolveEndpoint);
parcelRequire("V3yru");
parcelRequire("flMx7");
parcelRequire("eVY0r");
parcelRequire("bZE5G");
parcelRequire("heLC6");

});
parcelRegister("V3yru", function(module, exports) {

$parcel$export(module.exports, "isIpAddress", () => $0ab814d713c16233$export$2c835f0fe38d2e0e);
const $0ab814d713c16233$var$IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const $0ab814d713c16233$export$2c835f0fe38d2e0e = (value)=>$0ab814d713c16233$var$IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");

});

parcelRegister("flMx7", function(module, exports) {

$parcel$export(module.exports, "isValidHostLabel", () => $b2ce76df48082420$export$8a024457acd8bb49);
const $b2ce76df48082420$var$VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const $b2ce76df48082420$export$8a024457acd8bb49 = (value, allowSubDomains = false)=>{
    if (!allowSubDomains) return $b2ce76df48082420$var$VALID_HOST_LABEL_REGEX.test(value);
    const labels = value.split(".");
    for (const label of labels){
        if (!$b2ce76df48082420$export$8a024457acd8bb49(label)) return false;
    }
    return true;
};

});

parcelRegister("eVY0r", function(module, exports) {

$parcel$export(module.exports, "customEndpointFunctions", () => $adf4ef82c5406460$export$2614fba0847da171);
const $adf4ef82c5406460$export$2614fba0847da171 = {};

});

parcelRegister("bZE5G", function(module, exports) {

$parcel$export(module.exports, "resolveEndpoint", () => $8bb47d62c326fec1$export$48b88e4e5ecac119);
parcelRequire("ZWGPZ");
var $kbNEq = parcelRequire("kbNEq");
var $8kQCN = parcelRequire("8kQCN");
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");
parcelRequire("joZCx");
var $i1FT2 = parcelRequire("i1FT2");
const $8bb47d62c326fec1$export$48b88e4e5ecac119 = (ruleSetObject, options)=>{
    const { endpointParams: endpointParams, logger: logger } = options;
    const { parameters: parameters, rules: rules } = ruleSetObject;
    options.logger?.debug?.(`${(0, $kbNEq.debugId)} Initial EndpointParams: ${(0, $8kQCN.toDebugString)(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters).filter(([, v])=>v.default != null).map(([k, v])=>[
            k,
            v.default
        ]);
    if (paramsWithDefault.length > 0) for (const [paramKey, paramDefaultValue] of paramsWithDefault)endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    const requiredParams = Object.entries(parameters).filter(([, v])=>v.required).map(([k])=>k);
    for (const requiredParam of requiredParams){
        if (endpointParams[requiredParam] == null) throw new (0, $jRYqF.EndpointError)(`Missing required parameter: '${requiredParam}'`);
    }
    const endpoint = (0, $i1FT2.evaluateRules)(rules, {
        endpointParams: endpointParams,
        logger: logger,
        referenceRecord: {}
    });
    if (options.endpointParams?.Endpoint) try {
        const givenEndpoint = new URL(options.endpointParams.Endpoint);
        const { protocol: protocol, port: port } = givenEndpoint;
        endpoint.url.protocol = protocol;
        endpoint.url.port = port;
    } catch (e) {}
    options.logger?.debug?.(`${(0, $kbNEq.debugId)} Resolved endpoint: ${(0, $8kQCN.toDebugString)(endpoint)}`);
    return endpoint;
};

});
parcelRegister("ZWGPZ", function(module, exports) {
$parcel$export(module.exports, "debugId", () => (parcelRequire("kbNEq")).debugId);
$parcel$export(module.exports, "toDebugString", () => (parcelRequire("8kQCN")).toDebugString);
parcelRequire("kbNEq");
parcelRequire("8kQCN");

});
parcelRegister("kbNEq", function(module, exports) {

$parcel$export(module.exports, "debugId", () => $eb2b595e4df3c8a1$export$2a09d6727e5ecede);
const $eb2b595e4df3c8a1$export$2a09d6727e5ecede = "endpoints";

});

parcelRegister("8kQCN", function(module, exports) {

$parcel$export(module.exports, "toDebugString", () => $611903286022a030$export$7b48b8905f46d631);
function $611903286022a030$export$7b48b8905f46d631(input) {
    if (typeof input !== "object" || input == null) return input;
    if ("ref" in input) return `$${$611903286022a030$export$7b48b8905f46d631(input.ref)}`;
    if ("fn" in input) return `${input.fn}(${(input.argv || []).map($611903286022a030$export$7b48b8905f46d631).join(", ")})`;
    return JSON.stringify(input, null, 2);
}

});


parcelRegister("heLC6", function(module, exports) {
$parcel$export(module.exports, "EndpointError", () => (parcelRequire("jRYqF")).EndpointError);
parcelRequire("jRYqF");
parcelRequire("2wqAr");
parcelRequire("6vpny");
parcelRequire("xI6wD");
parcelRequire("aZmvy");
parcelRequire("aDHh9");
parcelRequire("hpU6u");

});
parcelRegister("jRYqF", function(module, exports) {

$parcel$export(module.exports, "EndpointError", () => $e771d78b9f8bcdf4$export$603f31e9980bccaf);
class $e771d78b9f8bcdf4$export$603f31e9980bccaf extends Error {
    constructor(message){
        super(message);
        this.name = "EndpointError";
    }
}

});

parcelRegister("2wqAr", function(module, exports) {

});

parcelRegister("6vpny", function(module, exports) {

});

parcelRegister("xI6wD", function(module, exports) {

});

parcelRegister("aZmvy", function(module, exports) {

});

parcelRegister("aDHh9", function(module, exports) {

});

parcelRegister("hpU6u", function(module, exports) {

});


parcelRegister("joZCx", function(module, exports) {
$parcel$export(module.exports, "evaluateRules", () => (parcelRequire("i1FT2")).evaluateRules);
parcelRequire("eVY0r");
parcelRequire("i1FT2");

});
parcelRegister("i1FT2", function(module, exports) {

$parcel$export(module.exports, "evaluateRules", () => $d1f8cfcf2cabbbad$export$cd6fa289eb934f12);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $b1oHX = parcelRequire("b1oHX");

var $d9wJW = parcelRequire("d9wJW");

var $5C08r = parcelRequire("5C08r");
const $d1f8cfcf2cabbbad$export$cd6fa289eb934f12 = (rules, options)=>{
    for (const rule of rules){
        if (rule.type === "endpoint") {
            const endpointOrUndefined = (0, $b1oHX.evaluateEndpointRule)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else if (rule.type === "error") (0, $d9wJW.evaluateErrorRule)(rule, options);
        else if (rule.type === "tree") {
            const endpointOrUndefined = (0, $5C08r.evaluateTreeRule)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else throw new (0, $jRYqF.EndpointError)(`Unknown endpoint rule: ${rule}`);
    }
    throw new (0, $jRYqF.EndpointError)(`Rules evaluation failed`);
};

});
parcelRegister("b1oHX", function(module, exports) {

$parcel$export(module.exports, "evaluateEndpointRule", () => $8062f42c3ec4b2c2$export$791799461674b1cb);
parcelRequire("ZWGPZ");
var $kbNEq = parcelRequire("kbNEq");
var $8kQCN = parcelRequire("8kQCN");

var $eXi9G = parcelRequire("eXi9G");

var $fN4jF = parcelRequire("fN4jF");

var $eybiV = parcelRequire("eybiV");

var $51bkk = parcelRequire("51bkk");
const $8062f42c3ec4b2c2$export$791799461674b1cb = (endpointRule, options)=>{
    const { conditions: conditions, endpoint: endpoint } = endpointRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $eXi9G.evaluateConditions)(conditions, options);
    if (!result) return;
    const endpointRuleOptions = {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    };
    const { url: url, properties: properties, headers: headers } = endpoint;
    options.logger?.debug?.(`${(0, $kbNEq.debugId)} Resolving endpoint from template: ${(0, $8kQCN.toDebugString)(endpoint)}`);
    return {
        ...headers != undefined && {
            headers: (0, $fN4jF.getEndpointHeaders)(headers, endpointRuleOptions)
        },
        ...properties != undefined && {
            properties: (0, $eybiV.getEndpointProperties)(properties, endpointRuleOptions)
        },
        url: (0, $51bkk.getEndpointUrl)(url, endpointRuleOptions)
    };
};

});
parcelRegister("eXi9G", function(module, exports) {

$parcel$export(module.exports, "evaluateConditions", () => $ae34a899addd37cd$export$bad219652748f1f3);
parcelRequire("ZWGPZ");
var $kbNEq = parcelRequire("kbNEq");
var $8kQCN = parcelRequire("8kQCN");

var $8LWCH = parcelRequire("8LWCH");
const $ae34a899addd37cd$export$bad219652748f1f3 = (conditions = [], options)=>{
    const conditionsReferenceRecord = {};
    for (const condition of conditions){
        const { result: result, toAssign: toAssign } = (0, $8LWCH.evaluateCondition)(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord
            }
        });
        if (!result) return {
            result: result
        };
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.(`${(0, $kbNEq.debugId)} assign: ${toAssign.name} := ${(0, $8kQCN.toDebugString)(toAssign.value)}`);
        }
    }
    return {
        result: true,
        referenceRecord: conditionsReferenceRecord
    };
};

});
parcelRegister("8LWCH", function(module, exports) {

$parcel$export(module.exports, "evaluateCondition", () => $66302fe08c994187$export$6695392473e235ae);
parcelRequire("ZWGPZ");
var $kbNEq = parcelRequire("kbNEq");
var $8kQCN = parcelRequire("8kQCN");
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $gOTlu = parcelRequire("gOTlu");
const $66302fe08c994187$export$6695392473e235ae = ({ assign: assign, ...fnArgs }, options)=>{
    if (assign && assign in options.referenceRecord) throw new (0, $jRYqF.EndpointError)(`'${assign}' is already defined in Reference Record.`);
    const value = (0, $gOTlu.callFunction)(fnArgs, options);
    options.logger?.debug?.(`${(0, $kbNEq.debugId)} evaluateCondition: ${(0, $8kQCN.toDebugString)(fnArgs)} = ${(0, $8kQCN.toDebugString)(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...assign != null && {
            toAssign: {
                name: assign,
                value: value
            }
        }
    };
};

});
parcelRegister("gOTlu", function(module, exports) {

$parcel$export(module.exports, "callFunction", () => $c3ec3f539e00230f$export$d883fbf232f0d35a);

var $eVY0r = parcelRequire("eVY0r");

var $bOmah = parcelRequire("bOmah");

var $cgCJQ = parcelRequire("cgCJQ");
const $c3ec3f539e00230f$export$d883fbf232f0d35a = ({ fn: fn, argv: argv }, options)=>{
    const evaluatedArgs = argv.map((arg)=>[
            "boolean",
            "number"
        ].includes(typeof arg) ? arg : (0, $cgCJQ.evaluateExpression)(arg, "arg", options));
    const fnSegments = fn.split(".");
    if (fnSegments[0] in (0, $eVY0r.customEndpointFunctions) && fnSegments[1] != null) return (0, $eVY0r.customEndpointFunctions)[fnSegments[0]][fnSegments[1]](...evaluatedArgs);
    return (0, $bOmah.endpointFunctions)[fn](...evaluatedArgs);
};

});
parcelRegister("bOmah", function(module, exports) {

$parcel$export(module.exports, "endpointFunctions", () => $89958eb0dabade94$export$fffca6040ff170c9);
parcelRequire("999Rf");
var $1OWzU = parcelRequire("1OWzU");
var $l00lU = parcelRequire("l00lU");
var $1BIha = parcelRequire("1BIha");
var $flMx7 = parcelRequire("flMx7");
var $2qOH8 = parcelRequire("2qOH8");
var $bNKao = parcelRequire("bNKao");
var $guv6Y = parcelRequire("guv6Y");
var $9pkYt = parcelRequire("9pkYt");
var $jOEtm = parcelRequire("jOEtm");
const $89958eb0dabade94$export$fffca6040ff170c9 = {
    booleanEquals: $1OWzU.booleanEquals,
    getAttr: $l00lU.getAttr,
    isSet: $1BIha.isSet,
    isValidHostLabel: $flMx7.isValidHostLabel,
    not: $2qOH8.not,
    parseURL: $bNKao.parseURL,
    stringEquals: $guv6Y.stringEquals,
    substring: $9pkYt.substring,
    uriEncode: $jOEtm.uriEncode
};

});
parcelRegister("999Rf", function(module, exports) {
$parcel$export(module.exports, "booleanEquals", () => (parcelRequire("1OWzU")).booleanEquals);
$parcel$export(module.exports, "getAttr", () => (parcelRequire("l00lU")).getAttr);
$parcel$export(module.exports, "isSet", () => (parcelRequire("1BIha")).isSet);
$parcel$export(module.exports, "isValidHostLabel", () => (parcelRequire("flMx7")).isValidHostLabel);
$parcel$export(module.exports, "not", () => (parcelRequire("2qOH8")).not);
$parcel$export(module.exports, "parseURL", () => (parcelRequire("bNKao")).parseURL);
$parcel$export(module.exports, "stringEquals", () => (parcelRequire("guv6Y")).stringEquals);
$parcel$export(module.exports, "substring", () => (parcelRequire("9pkYt")).substring);
$parcel$export(module.exports, "uriEncode", () => (parcelRequire("jOEtm")).uriEncode);
parcelRequire("1OWzU");
parcelRequire("l00lU");
parcelRequire("1BIha");
parcelRequire("flMx7");
parcelRequire("2qOH8");
parcelRequire("bNKao");
parcelRequire("guv6Y");
parcelRequire("9pkYt");
parcelRequire("jOEtm");

});
parcelRegister("1OWzU", function(module, exports) {

$parcel$export(module.exports, "booleanEquals", () => $1537e660032a5fe5$export$6608cbdc537206b3);
const $1537e660032a5fe5$export$6608cbdc537206b3 = (value1, value2)=>value1 === value2;

});

parcelRegister("l00lU", function(module, exports) {

$parcel$export(module.exports, "getAttr", () => $f499df0769e38c4f$export$6a93fe6b2b4c71a0);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $l5sZi = parcelRequire("l5sZi");
const $f499df0769e38c4f$export$6a93fe6b2b4c71a0 = (value, path)=>(0, $l5sZi.getAttrPathList)(path).reduce((acc, index)=>{
        if (typeof acc !== "object") throw new (0, $jRYqF.EndpointError)(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
        else if (Array.isArray(acc)) return acc[parseInt(index)];
        return acc[index];
    }, value);

});
parcelRegister("l5sZi", function(module, exports) {

$parcel$export(module.exports, "getAttrPathList", () => $f5a08cebe8df4a90$export$e8fa1ee343c456a5);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");
const $f5a08cebe8df4a90$export$e8fa1ee343c456a5 = (path)=>{
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts){
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) throw new (0, $jRYqF.EndpointError)(`Path: '${path}' does not end with ']'`);
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) throw new (0, $jRYqF.EndpointError)(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            if (squareBracketIndex !== 0) pathList.push(part.slice(0, squareBracketIndex));
            pathList.push(arrayIndex);
        } else pathList.push(part);
    }
    return pathList;
};

});


parcelRegister("1BIha", function(module, exports) {

$parcel$export(module.exports, "isSet", () => $12bb976b8957e370$export$6750766a7c7ec627);
const $12bb976b8957e370$export$6750766a7c7ec627 = (value)=>value != null;

});

parcelRegister("2qOH8", function(module, exports) {

$parcel$export(module.exports, "not", () => $1c55556a98b8435a$export$6003a5f097c73977);
const $1c55556a98b8435a$export$6003a5f097c73977 = (value)=>!value;

});

parcelRegister("bNKao", function(module, exports) {

$parcel$export(module.exports, "parseURL", () => $8978150b3a37296c$export$4b3d9a5bae55976);
parcelRequire("95Hh5");
var $6G7Uo = parcelRequire("6G7Uo");

var $V3yru = parcelRequire("V3yru");
const $8978150b3a37296c$var$DEFAULT_PORTS = {
    [(0, $6G7Uo.EndpointURLScheme).HTTP]: 80,
    [(0, $6G7Uo.EndpointURLScheme).HTTPS]: 443
};
const $8978150b3a37296c$export$4b3d9a5bae55976 = (value)=>{
    const whatwgURL = (()=>{
        try {
            if (value instanceof URL) return value;
            if (typeof value === "object" && "hostname" in value) {
                const { hostname: hostname, port: port, protocol: protocol = "", path: path = "", query: query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query).map(([k, v])=>`${k}=${v}`).join("&");
                return url;
            }
            return new URL(value);
        } catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host: host, hostname: hostname, pathname: pathname, protocol: protocol, search: search } = whatwgURL;
    if (search) return null;
    const scheme = protocol.slice(0, -1);
    if (!Object.values((0, $6G7Uo.EndpointURLScheme)).includes(scheme)) return null;
    const isIp = (0, $V3yru.isIpAddress)(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${$8978150b3a37296c$var$DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${$8978150b3a37296c$var$DEFAULT_PORTS[scheme]}`);
    const authority = `${host}${inputContainsDefaultPort ? `:${$8978150b3a37296c$var$DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme: scheme,
        authority: authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp: isIp
    };
};

});

parcelRegister("guv6Y", function(module, exports) {

$parcel$export(module.exports, "stringEquals", () => $c01794caafd04fb6$export$f8f73f238947765e);
const $c01794caafd04fb6$export$f8f73f238947765e = (value1, value2)=>value1 === value2;

});

parcelRegister("9pkYt", function(module, exports) {

$parcel$export(module.exports, "substring", () => $6d96b7f498206e88$export$662d3818631fba36);
const $6d96b7f498206e88$export$662d3818631fba36 = (input, start, stop, reverse)=>{
    if (start >= stop || input.length < stop) return null;
    if (!reverse) return input.substring(start, stop);
    return input.substring(input.length - stop, input.length - start);
};

});

parcelRegister("jOEtm", function(module, exports) {

$parcel$export(module.exports, "uriEncode", () => $e6d214d81e42bf7a$export$1ea6cdab375898b5);
const $e6d214d81e42bf7a$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value).replace(/[!*'()]/g, (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`);

});



parcelRegister("cgCJQ", function(module, exports) {

$parcel$export(module.exports, "evaluateExpression", () => $8ee5075073d02e6d$export$3191fa0ae67b450c);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $gOTlu = parcelRequire("gOTlu");

var $li0Hy = parcelRequire("li0Hy");

var $1lYnk = parcelRequire("1lYnk");
const $8ee5075073d02e6d$export$3191fa0ae67b450c = (obj, keyName, options)=>{
    if (typeof obj === "string") return (0, $li0Hy.evaluateTemplate)(obj, options);
    else if (obj["fn"]) return (0, $gOTlu.callFunction)(obj, options);
    else if (obj["ref"]) return (0, $1lYnk.getReferenceValue)(obj, options);
    throw new (0, $jRYqF.EndpointError)(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};

});
parcelRegister("li0Hy", function(module, exports) {

$parcel$export(module.exports, "evaluateTemplate", () => $f7fbd2b803898893$export$c77ca0e5a2c5469c);
parcelRequire("999Rf");
var $l00lU = parcelRequire("l00lU");
const $f7fbd2b803898893$export$c77ca0e5a2c5469c = (template, options)=>{
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    let currentIndex = 0;
    while(currentIndex < template.length){
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push((0, $l00lU.getAttr)(templateContext[refName], attrName));
        } else evaluatedTemplateArr.push(templateContext[parameterName]);
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};

});

parcelRegister("1lYnk", function(module, exports) {

$parcel$export(module.exports, "getReferenceValue", () => $0fc695e612fbfd9e$export$812bd59fe014e418);
const $0fc695e612fbfd9e$export$812bd59fe014e418 = ({ ref: ref }, options)=>{
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    return referenceRecord[ref];
};

});





parcelRegister("fN4jF", function(module, exports) {

$parcel$export(module.exports, "getEndpointHeaders", () => $b7eec7b8f859e46b$export$479dec716600cbb);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $cgCJQ = parcelRequire("cgCJQ");
const $b7eec7b8f859e46b$export$479dec716600cbb = (headers, options)=>Object.entries(headers).reduce((acc, [headerKey, headerVal])=>({
            ...acc,
            [headerKey]: headerVal.map((headerValEntry)=>{
                const processedExpr = (0, $cgCJQ.evaluateExpression)(headerValEntry, "Header value entry", options);
                if (typeof processedExpr !== "string") throw new (0, $jRYqF.EndpointError)(`Header '${headerKey}' value '${processedExpr}' is not a string`);
                return processedExpr;
            })
        }), {});

});

parcelRegister("eybiV", function(module, exports) {

$parcel$export(module.exports, "getEndpointProperties", () => $a97d0273fb2dbe87$export$f7b44341c2929056);

var $V4rwJ = parcelRequire("V4rwJ");
const $a97d0273fb2dbe87$export$f7b44341c2929056 = (properties, options)=>Object.entries(properties).reduce((acc, [propertyKey, propertyVal])=>({
            ...acc,
            [propertyKey]: (0, $V4rwJ.getEndpointProperty)(propertyVal, options)
        }), {});

});
parcelRegister("V4rwJ", function(module, exports) {

$parcel$export(module.exports, "getEndpointProperty", () => $0ab8c54509c0c0f0$export$39bc8a0c7360c2f4);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $li0Hy = parcelRequire("li0Hy");

var $eybiV = parcelRequire("eybiV");
const $0ab8c54509c0c0f0$export$39bc8a0c7360c2f4 = (property, options)=>{
    if (Array.isArray(property)) return property.map((propertyEntry)=>$0ab8c54509c0c0f0$export$39bc8a0c7360c2f4(propertyEntry, options));
    switch(typeof property){
        case "string":
            return (0, $li0Hy.evaluateTemplate)(property, options);
        case "object":
            if (property === null) throw new (0, $jRYqF.EndpointError)(`Unexpected endpoint property: ${property}`);
            return (0, $eybiV.getEndpointProperties)(property, options);
        case "boolean":
            return property;
        default:
            throw new (0, $jRYqF.EndpointError)(`Unexpected endpoint property type: ${typeof property}`);
    }
};

});


parcelRegister("51bkk", function(module, exports) {

$parcel$export(module.exports, "getEndpointUrl", () => $3a75d50c2fc387b9$export$c54f5a49b5be9709);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $cgCJQ = parcelRequire("cgCJQ");
const $3a75d50c2fc387b9$export$c54f5a49b5be9709 = (endpointUrl, options)=>{
    const expression = (0, $cgCJQ.evaluateExpression)(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") try {
        return new URL(expression);
    } catch (error) {
        console.error(`Failed to construct URL with ${expression}`, error);
        throw error;
    }
    throw new (0, $jRYqF.EndpointError)(`Endpoint URL must be a string, got ${typeof expression}`);
};

});


parcelRegister("d9wJW", function(module, exports) {

$parcel$export(module.exports, "evaluateErrorRule", () => $99358314d10d6e91$export$a36dfbc7e1fb8626);
parcelRequire("heLC6");
var $jRYqF = parcelRequire("jRYqF");

var $eXi9G = parcelRequire("eXi9G");

var $cgCJQ = parcelRequire("cgCJQ");
const $99358314d10d6e91$export$a36dfbc7e1fb8626 = (errorRule, options)=>{
    const { conditions: conditions, error: error } = errorRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $eXi9G.evaluateConditions)(conditions, options);
    if (!result) return;
    throw new (0, $jRYqF.EndpointError)((0, $cgCJQ.evaluateExpression)(error, "Error", {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    }));
};

});

parcelRegister("5C08r", function(module, exports) {

$parcel$export(module.exports, "evaluateTreeRule", () => $41609b382c728b2b$export$2e518b103c26ca79);

var $eXi9G = parcelRequire("eXi9G");

var $i1FT2 = parcelRequire("i1FT2");
const $41609b382c728b2b$export$2e518b103c26ca79 = (treeRule, options)=>{
    const { conditions: conditions, rules: rules } = treeRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $eXi9G.evaluateConditions)(conditions, options);
    if (!result) return;
    return (0, $i1FT2.evaluateRules)(rules, {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    });
};

});





parcelRegister("4beS5", function(module, exports) {

$parcel$export(module.exports, "isVirtualHostableS3Bucket", () => $30b3b9a5722908f3$export$6b6a3f4e857868ec);
parcelRequire("8nNaZ");
var $flMx7 = parcelRequire("flMx7");
parcelRequire("5wMR6");
var $V3yru = parcelRequire("V3yru");
const $30b3b9a5722908f3$export$6b6a3f4e857868ec = (value, allowSubDomains = false)=>{
    if (allowSubDomains) {
        for (const label of value.split(".")){
            if (!$30b3b9a5722908f3$export$6b6a3f4e857868ec(label)) return false;
        }
        return true;
    }
    if (!(0, $flMx7.isValidHostLabel)(value)) return false;
    if (value.length < 3 || value.length > 63) return false;
    if (value !== value.toLowerCase()) return false;
    if ((0, $V3yru.isIpAddress)(value)) return false;
    return true;
};

});
parcelRegister("5wMR6", function(module, exports) {

$parcel$export(module.exports, "isIpAddress", () => (parcelRequire("V3yru")).isIpAddress);
parcelRequire("8nNaZ");
var $V3yru = parcelRequire("V3yru");

});


parcelRegister("bUkx2", function(module, exports) {

$parcel$export(module.exports, "parseArn", () => $8ab4d9d9e20a654f$export$ec6a98ce8737fc2c);
const $8ab4d9d9e20a654f$var$ARN_DELIMITER = ":";
const $8ab4d9d9e20a654f$var$RESOURCE_DELIMITER = "/";
const $8ab4d9d9e20a654f$export$ec6a98ce8737fc2c = (value)=>{
    const segments = value.split($8ab4d9d9e20a654f$var$ARN_DELIMITER);
    if (segments.length < 6) return null;
    const [arn, partition, service, region, accountId, ...resourcePath] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourcePath.join($8ab4d9d9e20a654f$var$ARN_DELIMITER) === "") return null;
    const resourceId = resourcePath.map((resource)=>resource.split($8ab4d9d9e20a654f$var$RESOURCE_DELIMITER)).flat();
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resourceId: resourceId
    };
};

});

parcelRegister("iV6h0", function(module, exports) {

$parcel$export(module.exports, "partition", () => $dc626a9d0b895939$export$b29f828819edca8d);
$parcel$export(module.exports, "getUserAgentPrefix", () => $dc626a9d0b895939$export$c249da7071246380);

var $azm8T = parcelRequire("azm8T");
let $dc626a9d0b895939$var$selectedPartitionsInfo = (0, (/*@__PURE__*/$parcel$interopDefault($azm8T)));
let $dc626a9d0b895939$var$selectedUserAgentPrefix = "";
const $dc626a9d0b895939$export$b29f828819edca8d = (value)=>{
    const { partitions: partitions } = $dc626a9d0b895939$var$selectedPartitionsInfo;
    for (const partition of partitions){
        const { regions: regions, outputs: outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)){
            if (region === value) return {
                ...outputs,
                ...regionData
            };
        }
    }
    for (const partition of partitions){
        const { regionRegex: regionRegex, outputs: outputs } = partition;
        if (new RegExp(regionRegex).test(value)) return {
            ...outputs
        };
    }
    const DEFAULT_PARTITION = partitions.find((partition)=>partition.id === "aws");
    if (!DEFAULT_PARTITION) throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
    return {
        ...DEFAULT_PARTITION.outputs
    };
};
const $dc626a9d0b895939$export$5b2daaf969a6da2e = (partitionsInfo, userAgentPrefix = "")=>{
    $dc626a9d0b895939$var$selectedPartitionsInfo = partitionsInfo;
    $dc626a9d0b895939$var$selectedUserAgentPrefix = userAgentPrefix;
};
const $dc626a9d0b895939$export$1003c50da40cdce = ()=>{
    $dc626a9d0b895939$export$5b2daaf969a6da2e((0, (/*@__PURE__*/$parcel$interopDefault($azm8T))), "");
};
const $dc626a9d0b895939$export$c249da7071246380 = ()=>$dc626a9d0b895939$var$selectedUserAgentPrefix;

});
parcelRegister("azm8T", function(module, exports) {
module.exports = JSON.parse('{"partitions":[{"id":"aws","outputs":{"dnsSuffix":"amazonaws.com","dualStackDnsSuffix":"api.aws","implicitGlobalRegion":"us-east-1","name":"aws","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^(us|eu|ap|sa|ca|me|af|il|mx)\\\\-\\\\w+\\\\-\\\\d+$","regions":{"af-south-1":{"description":"Africa (Cape Town)"},"ap-east-1":{"description":"Asia Pacific (Hong Kong)"},"ap-northeast-1":{"description":"Asia Pacific (Tokyo)"},"ap-northeast-2":{"description":"Asia Pacific (Seoul)"},"ap-northeast-3":{"description":"Asia Pacific (Osaka)"},"ap-south-1":{"description":"Asia Pacific (Mumbai)"},"ap-south-2":{"description":"Asia Pacific (Hyderabad)"},"ap-southeast-1":{"description":"Asia Pacific (Singapore)"},"ap-southeast-2":{"description":"Asia Pacific (Sydney)"},"ap-southeast-3":{"description":"Asia Pacific (Jakarta)"},"ap-southeast-4":{"description":"Asia Pacific (Melbourne)"},"ap-southeast-5":{"description":"Asia Pacific (Malaysia)"},"aws-global":{"description":"AWS Standard global region"},"ca-central-1":{"description":"Canada (Central)"},"ca-west-1":{"description":"Canada West (Calgary)"},"eu-central-1":{"description":"Europe (Frankfurt)"},"eu-central-2":{"description":"Europe (Zurich)"},"eu-north-1":{"description":"Europe (Stockholm)"},"eu-south-1":{"description":"Europe (Milan)"},"eu-south-2":{"description":"Europe (Spain)"},"eu-west-1":{"description":"Europe (Ireland)"},"eu-west-2":{"description":"Europe (London)"},"eu-west-3":{"description":"Europe (Paris)"},"il-central-1":{"description":"Israel (Tel Aviv)"},"me-central-1":{"description":"Middle East (UAE)"},"me-south-1":{"description":"Middle East (Bahrain)"},"sa-east-1":{"description":"South America (Sao Paulo)"},"us-east-1":{"description":"US East (N. Virginia)"},"us-east-2":{"description":"US East (Ohio)"},"us-west-1":{"description":"US West (N. California)"},"us-west-2":{"description":"US West (Oregon)"}}},{"id":"aws-cn","outputs":{"dnsSuffix":"amazonaws.com.cn","dualStackDnsSuffix":"api.amazonwebservices.com.cn","implicitGlobalRegion":"cn-northwest-1","name":"aws-cn","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^cn\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-cn-global":{"description":"AWS China global region"},"cn-north-1":{"description":"China (Beijing)"},"cn-northwest-1":{"description":"China (Ningxia)"}}},{"id":"aws-us-gov","outputs":{"dnsSuffix":"amazonaws.com","dualStackDnsSuffix":"api.aws","implicitGlobalRegion":"us-gov-west-1","name":"aws-us-gov","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-us-gov-global":{"description":"AWS GovCloud (US) global region"},"us-gov-east-1":{"description":"AWS GovCloud (US-East)"},"us-gov-west-1":{"description":"AWS GovCloud (US-West)"}}},{"id":"aws-iso","outputs":{"dnsSuffix":"c2s.ic.gov","dualStackDnsSuffix":"c2s.ic.gov","implicitGlobalRegion":"us-iso-east-1","name":"aws-iso","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-iso-global":{"description":"AWS ISO (US) global region"},"us-iso-east-1":{"description":"US ISO East"},"us-iso-west-1":{"description":"US ISO WEST"}}},{"id":"aws-iso-b","outputs":{"dnsSuffix":"sc2s.sgov.gov","dualStackDnsSuffix":"sc2s.sgov.gov","implicitGlobalRegion":"us-isob-east-1","name":"aws-iso-b","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-iso-b-global":{"description":"AWS ISOB (US) global region"},"us-isob-east-1":{"description":"US ISOB East (Ohio)"}}},{"id":"aws-iso-e","outputs":{"dnsSuffix":"cloud.adc-e.uk","dualStackDnsSuffix":"cloud.adc-e.uk","implicitGlobalRegion":"eu-isoe-west-1","name":"aws-iso-e","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^eu\\\\-isoe\\\\-\\\\w+\\\\-\\\\d+$","regions":{"eu-isoe-west-1":{"description":"EU ISOE West"}}},{"id":"aws-iso-f","outputs":{"dnsSuffix":"csp.hci.ic.gov","dualStackDnsSuffix":"csp.hci.ic.gov","implicitGlobalRegion":"us-isof-south-1","name":"aws-iso-f","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-isof\\\\-\\\\w+\\\\-\\\\d+$","regions":{}}],"version":"1.1"}');

});



parcelRegister("7DQCE", function(module, exports) {
parcelRequire("8nNaZ");
var $bZE5G = parcelRequire("bZE5G");

});

parcelRegister("jGBri", function(module, exports) {
parcelRequire("16y03");
parcelRequire("a7HB9");
parcelRequire("7pABj");
parcelRequire("7cdUU");
parcelRequire("ce4zF");
parcelRequire("21yT3");

});
parcelRegister("16y03", function(module, exports) {
parcelRequire("8nNaZ");
var $jRYqF = parcelRequire("jRYqF");

});

parcelRegister("a7HB9", function(module, exports) {

});

parcelRegister("7pABj", function(module, exports) {

});

parcelRegister("7cdUU", function(module, exports) {

});

parcelRegister("ce4zF", function(module, exports) {

});

parcelRegister("21yT3", function(module, exports) {

});



parcelRegister("E1iFG", function(module, exports) {

$parcel$export(module.exports, "USER_AGENT", () => $0784beb967af4490$export$97a08a1bb7ee0545);
$parcel$export(module.exports, "X_AMZ_USER_AGENT", () => $0784beb967af4490$export$e010e3d6246262a3);
$parcel$export(module.exports, "SPACE", () => $0784beb967af4490$export$27b7b95a5fde2b31);
$parcel$export(module.exports, "UA_NAME_SEPARATOR", () => $0784beb967af4490$export$43290ff793d1777d);
$parcel$export(module.exports, "UA_NAME_ESCAPE_REGEX", () => $0784beb967af4490$export$2d1b87b5b2a59af3);
$parcel$export(module.exports, "UA_VALUE_ESCAPE_REGEX", () => $0784beb967af4490$export$84cb6e726944481);
$parcel$export(module.exports, "UA_ESCAPE_CHAR", () => $0784beb967af4490$export$f810014d932f8c3e);
const $0784beb967af4490$export$97a08a1bb7ee0545 = "user-agent";
const $0784beb967af4490$export$e010e3d6246262a3 = "x-amz-user-agent";
const $0784beb967af4490$export$27b7b95a5fde2b31 = " ";
const $0784beb967af4490$export$43290ff793d1777d = "/";
const $0784beb967af4490$export$2d1b87b5b2a59af3 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const $0784beb967af4490$export$84cb6e726944481 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
const $0784beb967af4490$export$f810014d932f8c3e = "-";

});



parcelRegister("9hNGK", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => (parcelRequire("ipi8J")).DEFAULT_USE_DUALSTACK_ENDPOINT);
$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => (parcelRequire("ha5o2")).DEFAULT_USE_FIPS_ENDPOINT);
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("32WEY")).resolveRegionConfig);
parcelRequire("6L32A");
parcelRequire("dyY3H");
parcelRequire("27RLo");

});
parcelRegister("6L32A", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => (parcelRequire("ipi8J")).DEFAULT_USE_DUALSTACK_ENDPOINT);
$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => (parcelRequire("ha5o2")).DEFAULT_USE_FIPS_ENDPOINT);
parcelRequire("ipi8J");
parcelRequire("ha5o2");
parcelRequire("fT7mF");
parcelRequire("hSNUq");

});
parcelRegister("ipi8J", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => $d668a1f94de4394e$export$beb01fae7626c427);
parcelRequire("aApLZ");
var $OOnC1 = parcelRequire("OOnC1");
var $lE3xp = parcelRequire("lE3xp");
const $d668a1f94de4394e$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
const $d668a1f94de4394e$export$71f82540e79c63bf = "use_dualstack_endpoint";
const $d668a1f94de4394e$export$beb01fae7626c427 = false;
const $d668a1f94de4394e$export$522137fc0ae615ab = {
    environmentVariableSelector: (env)=>(0, $OOnC1.booleanSelector)(env, $d668a1f94de4394e$export$eacd91361c129033, (0, $lE3xp.SelectorType).ENV),
    configFileSelector: (profile)=>(0, $OOnC1.booleanSelector)(profile, $d668a1f94de4394e$export$71f82540e79c63bf, (0, $lE3xp.SelectorType).CONFIG),
    default: false
};

});
parcelRegister("aApLZ", function(module, exports) {
$parcel$export(module.exports, "booleanSelector", () => (parcelRequire("OOnC1")).booleanSelector);
$parcel$export(module.exports, "SelectorType", () => (parcelRequire("lE3xp")).SelectorType);
parcelRequire("OOnC1");
parcelRequire("jWgI2");
parcelRequire("lE3xp");

});
parcelRegister("OOnC1", function(module, exports) {

$parcel$export(module.exports, "booleanSelector", () => $098bc0039cdbe194$export$f8c4049184e0ac3f);
const $098bc0039cdbe194$export$f8c4049184e0ac3f = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};

});

parcelRegister("jWgI2", function(module, exports) {
const $e840653ae7d8968b$export$964ee8ab6fdb2cf2 = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    const numberValue = parseInt(obj[key], 10);
    if (Number.isNaN(numberValue)) throw new TypeError(`Cannot load ${type} '${key}'. Expected number, got '${obj[key]}'.`);
    return numberValue;
};

});

parcelRegister("lE3xp", function(module, exports) {

$parcel$export(module.exports, "SelectorType", () => $fc2013f5bd279bce$export$4e8b093ec8dcab0d);
var $fc2013f5bd279bce$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($fc2013f5bd279bce$export$4e8b093ec8dcab0d || ($fc2013f5bd279bce$export$4e8b093ec8dcab0d = {}));

});



parcelRegister("ha5o2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => $c7e78c882a40b6b4$export$5555deeca435a10b);
parcelRequire("aApLZ");
var $OOnC1 = parcelRequire("OOnC1");
var $lE3xp = parcelRequire("lE3xp");
const $c7e78c882a40b6b4$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
const $c7e78c882a40b6b4$export$30cf725f60d4be3e = "use_fips_endpoint";
const $c7e78c882a40b6b4$export$5555deeca435a10b = false;
const $c7e78c882a40b6b4$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: (env)=>(0, $OOnC1.booleanSelector)(env, $c7e78c882a40b6b4$export$b7eebc18f98c6d7f, (0, $lE3xp.SelectorType).ENV),
    configFileSelector: (profile)=>(0, $OOnC1.booleanSelector)(profile, $c7e78c882a40b6b4$export$30cf725f60d4be3e, (0, $lE3xp.SelectorType).CONFIG),
    default: false
};

});

parcelRegister("fT7mF", function(module, exports) {
parcelRequire("et0OQ");
var $25kVm = parcelRequire("25kVm");
const $b911b4816d034755$export$6cd750975e36686c = (input)=>{
    const { endpoint: endpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: (0, $25kVm.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $25kVm.normalizeProvider)(input.useDualstackEndpoint ?? false)
    };
};

});

parcelRegister("hSNUq", function(module, exports) {
parcelRequire("et0OQ");
var $25kVm = parcelRequire("25kVm");

var $9YCCo = parcelRequire("9YCCo");
const $d04e31b74ae931c5$export$24f352b1bd1e2f8b = (input)=>{
    const useDualstackEndpoint = (0, $25kVm.normalizeProvider)(input.useDualstackEndpoint ?? false);
    const { endpoint: endpoint, useFipsEndpoint: useFipsEndpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: endpoint ? (0, $25kVm.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : ()=>(0, $9YCCo.getEndpointFromRegion)({
                ...input,
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }),
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
};

});
parcelRegister("9YCCo", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromRegion", () => $7437ac690d075132$export$c69bd155af41e6f1);
const $7437ac690d075132$export$c69bd155af41e6f1 = async (input)=>{
    const { tls: tls = true } = input;
    const region = await input.region();
    const dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
    const useDualstackEndpoint = await input.useDualstackEndpoint();
    const useFipsEndpoint = await input.useFipsEndpoint();
    const { hostname: hostname } = await input.regionInfoProvider(region, {
        useDualstackEndpoint: useDualstackEndpoint,
        useFipsEndpoint: useFipsEndpoint
    }) ?? {};
    if (!hostname) throw new Error("Cannot resolve hostname from client config");
    return input.urlParser(`${tls ? "https:" : "http:"}//${hostname}`);
};

});



parcelRegister("dyY3H", function(module, exports) {
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("32WEY")).resolveRegionConfig);
parcelRequire("8hWMV");
parcelRequire("32WEY");

});
parcelRegister("8hWMV", function(module, exports) {
const $608d8357e6f35ef9$export$26513716e2900bad = "AWS_REGION";
const $608d8357e6f35ef9$export$8afb1c306a7d01b = "region";
const $608d8357e6f35ef9$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$608d8357e6f35ef9$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$608d8357e6f35ef9$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $608d8357e6f35ef9$export$9a37503ca194454d = {
    preferredFile: "credentials"
};

});

parcelRegister("32WEY", function(module, exports) {

$parcel$export(module.exports, "resolveRegionConfig", () => $237f0f9cb76337ce$export$7696ef37558bd0ec);

var $95I27 = parcelRequire("95I27");

var $8EIAK = parcelRequire("8EIAK");
const $237f0f9cb76337ce$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $95I27.getRealRegion)(region);
            const providedRegion = await region();
            return (0, $95I27.getRealRegion)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $8EIAK.isFipsRegion)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};

});
parcelRegister("95I27", function(module, exports) {

$parcel$export(module.exports, "getRealRegion", () => $69e6bcc7a5eed993$export$ecbdf004a8547a7f);

var $8EIAK = parcelRequire("8EIAK");
const $69e6bcc7a5eed993$export$ecbdf004a8547a7f = (region)=>(0, $8EIAK.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;

});
parcelRegister("8EIAK", function(module, exports) {

$parcel$export(module.exports, "isFipsRegion", () => $64d4a625133a3952$export$cc893cb7e6a508dd);
const $64d4a625133a3952$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

});




parcelRegister("27RLo", function(module, exports) {
parcelRequire("b4gPy");
parcelRequire("1P0PC");
parcelRequire("5gcWI");

});
parcelRegister("b4gPy", function(module, exports) {

});

parcelRegister("1P0PC", function(module, exports) {

});

parcelRegister("5gcWI", function(module, exports) {

var $av90x = parcelRequire("av90x");

var $gghBJ = parcelRequire("gghBJ");

var $bOued = parcelRequire("bOued");

var $9IcCI = parcelRequire("9IcCI");
const $3d487d31922eb060$export$2b789d827caebed0 = (region, { useFipsEndpoint: useFipsEndpoint = false, useDualstackEndpoint: useDualstackEndpoint = false, signingService: signingService, regionHash: regionHash, partitionHash: partitionHash })=>{
    const partition = (0, $bOued.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    const resolvedRegion = region in regionHash ? region : partitionHash[partition]?.endpoint ?? region;
    const hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    const regionHostname = (0, $av90x.getHostnameFromVariants)(regionHash[resolvedRegion]?.variants, hostnameOptions);
    const partitionHostname = (0, $av90x.getHostnameFromVariants)(partitionHash[partition]?.variants, hostnameOptions);
    const hostname = (0, $gghBJ.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error(`Endpoint resolution failed for: ${{
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }}`);
    const signingRegion = (0, $9IcCI.getResolvedSigningRegion)(hostname, {
        signingRegion: regionHash[resolvedRegion]?.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return {
        partition: partition,
        signingService: signingService,
        hostname: hostname,
        ...signingRegion && {
            signingRegion: signingRegion
        },
        ...regionHash[resolvedRegion]?.signingService && {
            signingService: regionHash[resolvedRegion].signingService
        }
    };
};

});
parcelRegister("av90x", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromVariants", () => $7a53c960b810204a$export$75494cb913bf7ef6);
const $7a53c960b810204a$export$75494cb913bf7ef6 = (variants = [], { useFipsEndpoint: useFipsEndpoint, useDualstackEndpoint: useDualstackEndpoint })=>variants.find(({ tags: tags })=>useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack"))?.hostname;

});

parcelRegister("gghBJ", function(module, exports) {

$parcel$export(module.exports, "getResolvedHostname", () => $bd6bcc7ca8940bfc$export$d062b2a57a5d579b);
const $bd6bcc7ca8940bfc$export$d062b2a57a5d579b = (resolvedRegion, { regionHostname: regionHostname, partitionHostname: partitionHostname })=>regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;

});

parcelRegister("bOued", function(module, exports) {

$parcel$export(module.exports, "getResolvedPartition", () => $899bcfe9a695cf02$export$2ba1c8e181ae49f8);
const $899bcfe9a695cf02$export$2ba1c8e181ae49f8 = (region, { partitionHash: partitionHash })=>Object.keys(partitionHash || {}).find((key)=>partitionHash[key].regions.includes(region)) ?? "aws";

});

parcelRegister("9IcCI", function(module, exports) {

$parcel$export(module.exports, "getResolvedSigningRegion", () => $712203e3bf9fb371$export$be75b39beeb48b5c);
const $712203e3bf9fb371$export$be75b39beeb48b5c = (hostname, { signingRegion: signingRegion, regionRegex: regionRegex, useFipsEndpoint: useFipsEndpoint })=>{
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        const regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        const regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

});




parcelRegister("2xHTL", function(module, exports) {
$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => (parcelRequire("j8ita")).getHttpAuthSchemeEndpointRuleSetPlugin);
$parcel$export(module.exports, "getHttpSigningPlugin", () => (parcelRequire("kY2T6")).getHttpSigningPlugin);
$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => (parcelRequire("7C8Sk")).DefaultIdentityProviderConfig);
$parcel$export(module.exports, "doesIdentityRequireRefresh", () => (parcelRequire("hKyAA")).doesIdentityRequireRefresh);
$parcel$export(module.exports, "isIdentityExpired", () => (parcelRequire("hKyAA")).isIdentityExpired);
$parcel$export(module.exports, "memoizeIdentityProvider", () => (parcelRequire("hKyAA")).memoizeIdentityProvider);
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("pdHpr")).NoAuthSigner);
$parcel$export(module.exports, "normalizeProvider", () => (parcelRequire("k1l7u")).normalizeProvider);
parcelRequire("dAKZ2");
parcelRequire("kouLK");
parcelRequire("hH5ic");
parcelRequire("g0WBB");
parcelRequire("k1l7u");
parcelRequire("iBKR4");

var $ajjxx = parcelRequire("ajjxx");

});
parcelRegister("dAKZ2", function(module, exports) {
$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => (parcelRequire("j8ita")).getHttpAuthSchemeEndpointRuleSetPlugin);
parcelRequire("puQE4");
parcelRequire("j8ita");
parcelRequire("85Cj3");

});
parcelRegister("puQE4", function(module, exports) {

$parcel$export(module.exports, "httpAuthSchemeMiddleware", () => $04ca43b517367a6c$export$681dcf755d3830d0);
parcelRequire("95Hh5");
parcelRequire("et0OQ");
var $b8rNH = parcelRequire("b8rNH");
function $04ca43b517367a6c$var$convertHttpAuthSchemesToMap(httpAuthSchemes) {
    const map = new Map();
    for (const scheme of httpAuthSchemes)map.set(scheme.schemeId, scheme);
    return map;
}
const $04ca43b517367a6c$export$681dcf755d3830d0 = (config, mwOptions)=>(next, context)=>async (args)=>{
            const options = config.httpAuthSchemeProvider(await mwOptions.httpAuthSchemeParametersProvider(config, context, args.input));
            const authSchemes = $04ca43b517367a6c$var$convertHttpAuthSchemesToMap(config.httpAuthSchemes);
            const smithyContext = (0, $b8rNH.getSmithyContext)(context);
            const failureReasons = [];
            for (const option of options){
                const scheme = authSchemes.get(option.schemeId);
                if (!scheme) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` was not enabled for this service.`);
                    continue;
                }
                const identityProvider = scheme.identityProvider(await mwOptions.identityProviderConfigProvider(config));
                if (!identityProvider) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` did not have an IdentityProvider configured.`);
                    continue;
                }
                const { identityProperties: identityProperties = {}, signingProperties: signingProperties = {} } = option.propertiesExtractor?.(config, context) || {};
                option.identityProperties = Object.assign(option.identityProperties || {}, identityProperties);
                option.signingProperties = Object.assign(option.signingProperties || {}, signingProperties);
                smithyContext.selectedHttpAuthScheme = {
                    httpAuthOption: option,
                    identity: await identityProvider(option.identityProperties),
                    signer: scheme.signer
                };
                break;
            }
            if (!smithyContext.selectedHttpAuthScheme) throw new Error(failureReasons.join("\n"));
            return next(args);
        };

});

parcelRegister("j8ita", function(module, exports) {

$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => $dedd174d36635ec9$export$6ababc1a6356ca41);
parcelRequire("bDB9l");
var $jxKDL = parcelRequire("jxKDL");

var $puQE4 = parcelRequire("puQE4");
const $dedd174d36635ec9$export$8c136d4eb4815c3e = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $jxKDL.endpointMiddlewareOptions).name
};
const $dedd174d36635ec9$export$6ababc1a6356ca41 = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $puQE4.httpAuthSchemeMiddleware)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $dedd174d36635ec9$export$8c136d4eb4815c3e);
        }
    });

});

parcelRegister("85Cj3", function(module, exports) {
parcelRequire("4VvaK");
var $aAT5t = parcelRequire("aAT5t");

var $puQE4 = parcelRequire("puQE4");
const $5e3c812e98e1d09b$export$11cd3870e3f87892 = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $aAT5t.serializerMiddlewareOption).name
};
const $5e3c812e98e1d09b$export$ac2af07429c3a20e = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $puQE4.httpAuthSchemeMiddleware)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $5e3c812e98e1d09b$export$11cd3870e3f87892);
        }
    });

});


parcelRegister("kouLK", function(module, exports) {
$parcel$export(module.exports, "getHttpSigningPlugin", () => (parcelRequire("kY2T6")).getHttpSigningPlugin);
parcelRequire("9jKA9");
parcelRequire("kY2T6");

});
parcelRegister("9jKA9", function(module, exports) {

$parcel$export(module.exports, "httpSigningMiddleware", () => $6c8a05a79cd5d584$export$fe39ed571a606f80);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
parcelRequire("95Hh5");
parcelRequire("et0OQ");
var $b8rNH = parcelRequire("b8rNH");
const $6c8a05a79cd5d584$var$defaultErrorHandler = (signingProperties)=>(error)=>{
        throw error;
    };
const $6c8a05a79cd5d584$var$defaultSuccessHandler = (httpResponse, signingProperties)=>{};
const $6c8a05a79cd5d584$export$fe39ed571a606f80 = (config)=>(next, context)=>async (args)=>{
            if (!(0, $acFZn.HttpRequest).isInstance(args.request)) return next(args);
            const smithyContext = (0, $b8rNH.getSmithyContext)(context);
            const scheme = smithyContext.selectedHttpAuthScheme;
            if (!scheme) throw new Error(`No HttpAuthScheme was selected: unable to sign request`);
            const { httpAuthOption: { signingProperties: signingProperties = {} }, identity: identity, signer: signer } = scheme;
            const output = await next({
                ...args,
                request: await signer.sign(args.request, identity, signingProperties)
            }).catch((signer.errorHandler || $6c8a05a79cd5d584$var$defaultErrorHandler)(signingProperties));
            (signer.successHandler || $6c8a05a79cd5d584$var$defaultSuccessHandler)(output.response, signingProperties);
            return output;
        };

});

parcelRegister("kY2T6", function(module, exports) {

$parcel$export(module.exports, "getHttpSigningPlugin", () => $f43ba6ab0f28e1d5$export$ed476aa7e410a);
parcelRequire("kl6vu");
var $ghlrH = parcelRequire("ghlrH");

var $9jKA9 = parcelRequire("9jKA9");
const $f43ba6ab0f28e1d5$export$dce1f72b9e752c12 = {
    step: "finalizeRequest",
    tags: [
        "HTTP_SIGNING"
    ],
    name: "httpSigningMiddleware",
    aliases: [
        "apiKeyMiddleware",
        "tokenMiddleware",
        "awsAuthMiddleware"
    ],
    override: true,
    relation: "after",
    toMiddleware: (0, $ghlrH.retryMiddlewareOptions).name
};
const $f43ba6ab0f28e1d5$export$ed476aa7e410a = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $9jKA9.httpSigningMiddleware)(config), $f43ba6ab0f28e1d5$export$dce1f72b9e752c12);
        }
    });

});
parcelRegister("kl6vu", function(module, exports) {
$parcel$export(module.exports, "resolveRetryConfig", () => (parcelRequire("1HvUN")).resolveRetryConfig);
$parcel$export(module.exports, "getRetryPlugin", () => (parcelRequire("ghlrH")).getRetryPlugin);
$parcel$export(module.exports, "retryMiddlewareOptions", () => (parcelRequire("ghlrH")).retryMiddlewareOptions);
parcelRequire("4R6O2");
parcelRequire("epVH2");
parcelRequire("1HvUN");
parcelRequire("g6he3");
parcelRequire("ftXa6");
parcelRequire("l98Vq");
parcelRequire("ghlrH");

});
parcelRegister("4R6O2", function(module, exports) {
parcelRequire("eVim3");
var $aoD3X = parcelRequire("aoD3X");
var $79mxn = parcelRequire("79mxn");

var $epVH2 = parcelRequire("epVH2");
class $389164393771d0af$export$b6f3faf7501de8bc extends (0, $epVH2.StandardRetryStrategy) {
    constructor(maxAttemptsProvider, options){
        const { rateLimiter: rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new (0, $aoD3X.DefaultRateLimiter)();
        this.mode = (0, $79mxn.RETRY_MODES).ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async ()=>{
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response)=>{
                this.rateLimiter.updateClientSendingRate(response);
            }
        });
    }
}

});
parcelRegister("eVim3", function(module, exports) {
$parcel$export(module.exports, "AdaptiveRetryStrategy", () => (parcelRequire("bcbXK")).AdaptiveRetryStrategy);
$parcel$export(module.exports, "DefaultRateLimiter", () => (parcelRequire("aoD3X")).DefaultRateLimiter);
$parcel$export(module.exports, "StandardRetryStrategy", () => (parcelRequire("b8FrF")).StandardRetryStrategy);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => (parcelRequire("79mxn")).DEFAULT_MAX_ATTEMPTS);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => (parcelRequire("79mxn")).DEFAULT_RETRY_MODE);
$parcel$export(module.exports, "RETRY_MODES", () => (parcelRequire("79mxn")).RETRY_MODES);
$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => (parcelRequire("h9sBI")).DEFAULT_RETRY_DELAY_BASE);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => (parcelRequire("h9sBI")).INITIAL_RETRY_TOKENS);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => (parcelRequire("h9sBI")).INVOCATION_ID_HEADER);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => (parcelRequire("h9sBI")).MAXIMUM_RETRY_DELAY);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => (parcelRequire("h9sBI")).NO_RETRY_INCREMENT);
$parcel$export(module.exports, "REQUEST_HEADER", () => (parcelRequire("h9sBI")).REQUEST_HEADER);
$parcel$export(module.exports, "RETRY_COST", () => (parcelRequire("h9sBI")).RETRY_COST);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => (parcelRequire("h9sBI")).THROTTLING_RETRY_DELAY_BASE);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => (parcelRequire("h9sBI")).TIMEOUT_RETRY_COST);
parcelRequire("bcbXK");
parcelRequire("fpe8H");
parcelRequire("aoD3X");
parcelRequire("b8FrF");
parcelRequire("79mxn");
parcelRequire("h9sBI");
parcelRequire("e37gS");

});
parcelRegister("bcbXK", function(module, exports) {

$parcel$export(module.exports, "AdaptiveRetryStrategy", () => $826a184038c7af0f$export$b6f3faf7501de8bc);

var $79mxn = parcelRequire("79mxn");

var $aoD3X = parcelRequire("aoD3X");

var $b8FrF = parcelRequire("b8FrF");
class $826a184038c7af0f$export$b6f3faf7501de8bc {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $79mxn.RETRY_MODES).ADAPTIVE;
        const { rateLimiter: rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new (0, $aoD3X.DefaultRateLimiter)();
        this.standardRetryStrategy = new (0, $b8FrF.StandardRetryStrategy)(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}

});
parcelRegister("79mxn", function(module, exports) {

$parcel$export(module.exports, "RETRY_MODES", () => $534adb1defad154b$export$6842199fccd474d3);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => $534adb1defad154b$export$2c7e51f38ba5a406);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => $534adb1defad154b$export$41315747b7c5d042);
var $534adb1defad154b$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($534adb1defad154b$export$6842199fccd474d3 || ($534adb1defad154b$export$6842199fccd474d3 = {}));
const $534adb1defad154b$export$2c7e51f38ba5a406 = 3;
const $534adb1defad154b$export$41315747b7c5d042 = $534adb1defad154b$export$6842199fccd474d3.STANDARD;

});

parcelRegister("aoD3X", function(module, exports) {

$parcel$export(module.exports, "DefaultRateLimiter", () => $791a7254310959c4$export$4d4bb1390e4746c4);

var $1fbdJ = parcelRequire("1fbdJ");
class $791a7254310959c4$export$4d4bb1390e4746c4 {
    constructor(options){
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) return;
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = (amount - this.currentCapacity) / this.fillRate * 1000;
            await new Promise((resolve)=>setTimeout(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if ((0, $1fbdJ.isThrottlingError)(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}

});
parcelRegister("1fbdJ", function(module, exports) {

$parcel$export(module.exports, "isRetryableByTrait", () => $0e7fe54b0cea3a74$export$46428803f4bd8a0c);
$parcel$export(module.exports, "isClockSkewError", () => $0e7fe54b0cea3a74$export$7b87435661177a94);
$parcel$export(module.exports, "isThrottlingError", () => $0e7fe54b0cea3a74$export$cbecb89f6256ccc8);
$parcel$export(module.exports, "isTransientError", () => $0e7fe54b0cea3a74$export$31778435da988512);
$parcel$export(module.exports, "isServerError", () => $0e7fe54b0cea3a74$export$a7cbe72d7c4012af);

var $cmAZ4 = parcelRequire("cmAZ4");
const $0e7fe54b0cea3a74$export$46428803f4bd8a0c = (error)=>error.$retryable !== undefined;
const $0e7fe54b0cea3a74$export$7b87435661177a94 = (error)=>(0, $cmAZ4.CLOCK_SKEW_ERROR_CODES).includes(error.name);
const $0e7fe54b0cea3a74$export$ca8501ea0db9a003 = (error)=>error.$metadata?.clockSkewCorrected;
const $0e7fe54b0cea3a74$export$cbecb89f6256ccc8 = (error)=>error.$metadata?.httpStatusCode === 429 || (0, $cmAZ4.THROTTLING_ERROR_CODES).includes(error.name) || error.$retryable?.throttling == true;
const $0e7fe54b0cea3a74$export$31778435da988512 = (error)=>$0e7fe54b0cea3a74$export$ca8501ea0db9a003(error) || (0, $cmAZ4.TRANSIENT_ERROR_CODES).includes(error.name) || (0, $cmAZ4.NODEJS_TIMEOUT_ERROR_CODES).includes(error?.code || "") || (0, $cmAZ4.TRANSIENT_ERROR_STATUS_CODES).includes(error.$metadata?.httpStatusCode || 0);
const $0e7fe54b0cea3a74$export$a7cbe72d7c4012af = (error)=>{
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !$0e7fe54b0cea3a74$export$31778435da988512(error)) return true;
        return false;
    }
    return false;
};

});
parcelRegister("cmAZ4", function(module, exports) {

$parcel$export(module.exports, "CLOCK_SKEW_ERROR_CODES", () => $90043a5f28ccd58b$export$9fde012b8b2a10ca);
$parcel$export(module.exports, "THROTTLING_ERROR_CODES", () => $90043a5f28ccd58b$export$89cd1b0ccfcb99d);
$parcel$export(module.exports, "TRANSIENT_ERROR_CODES", () => $90043a5f28ccd58b$export$18bd3bfe89ded398);
$parcel$export(module.exports, "TRANSIENT_ERROR_STATUS_CODES", () => $90043a5f28ccd58b$export$38bf589d26009e4f);
$parcel$export(module.exports, "NODEJS_TIMEOUT_ERROR_CODES", () => $90043a5f28ccd58b$export$e4f761fe9d74ce41);
const $90043a5f28ccd58b$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
const $90043a5f28ccd58b$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
const $90043a5f28ccd58b$export$18bd3bfe89ded398 = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $90043a5f28ccd58b$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];
const $90043a5f28ccd58b$export$e4f761fe9d74ce41 = [
    "ECONNRESET",
    "ECONNREFUSED",
    "EPIPE",
    "ETIMEDOUT"
];

});



parcelRegister("b8FrF", function(module, exports) {

$parcel$export(module.exports, "StandardRetryStrategy", () => $81c097369ad908e6$export$64af437cce00eae8);

var $79mxn = parcelRequire("79mxn");

var $h9sBI = parcelRequire("h9sBI");

var $fgZnV = parcelRequire("fgZnV");

var $fCAB2 = parcelRequire("fCAB2");
class $81c097369ad908e6$export$64af437cce00eae8 {
    constructor(maxAttempts){
        this.maxAttempts = maxAttempts;
        this.mode = (0, $79mxn.RETRY_MODES).STANDARD;
        this.capacity = (0, $h9sBI.INITIAL_RETRY_TOKENS);
        this.retryBackoffStrategy = (0, $fgZnV.getDefaultRetryBackoffStrategy)();
        this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return (0, $fCAB2.createDefaultRetryToken)({
            retryDelay: (0, $h9sBI.DEFAULT_RETRY_DELAY_BASE),
            retryCount: 0
        });
    }
    async refreshRetryTokenForRetry(token, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(token, errorInfo, maxAttempts)) {
            const errorType = errorInfo.errorType;
            this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? (0, $h9sBI.THROTTLING_RETRY_DELAY_BASE) : (0, $h9sBI.DEFAULT_RETRY_DELAY_BASE));
            const delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
            const retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
            const capacityCost = this.getCapacityCost(errorType);
            this.capacity -= capacityCost;
            return (0, $fCAB2.createDefaultRetryToken)({
                retryDelay: retryDelay,
                retryCount: token.getRetryCount() + 1,
                retryCost: capacityCost
            });
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.capacity = Math.max((0, $h9sBI.INITIAL_RETRY_TOKENS), this.capacity + (token.getRetryCost() ?? (0, $h9sBI.NO_RETRY_INCREMENT)));
    }
    getCapacity() {
        return this.capacity;
    }
    async getMaxAttempts() {
        try {
            return await this.maxAttemptsProvider();
        } catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${(0, $79mxn.DEFAULT_MAX_ATTEMPTS)}`);
            return 0, $79mxn.DEFAULT_MAX_ATTEMPTS;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount() + 1;
        return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
    getCapacityCost(errorType) {
        return errorType === "TRANSIENT" ? (0, $h9sBI.TIMEOUT_RETRY_COST) : (0, $h9sBI.RETRY_COST);
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}

});
parcelRegister("h9sBI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => $c7c977bd0e69865b$export$7067ba90effbd789);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => $c7c977bd0e69865b$export$2412c80d04e902c6);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => $c7c977bd0e69865b$export$4af31f8250b48e23);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => $c7c977bd0e69865b$export$f8c3d11675a1153);
$parcel$export(module.exports, "RETRY_COST", () => $c7c977bd0e69865b$export$797febae1136bc84);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => $c7c977bd0e69865b$export$b643545eaf9af837);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => $c7c977bd0e69865b$export$a25da3406dc148e4);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => $c7c977bd0e69865b$export$197fd517bf66ccb2);
$parcel$export(module.exports, "REQUEST_HEADER", () => $c7c977bd0e69865b$export$d4f764f0ec4f52f);
const $c7c977bd0e69865b$export$7067ba90effbd789 = 100;
const $c7c977bd0e69865b$export$2412c80d04e902c6 = 20000;
const $c7c977bd0e69865b$export$4af31f8250b48e23 = 500;
const $c7c977bd0e69865b$export$f8c3d11675a1153 = 500;
const $c7c977bd0e69865b$export$797febae1136bc84 = 5;
const $c7c977bd0e69865b$export$b643545eaf9af837 = 10;
const $c7c977bd0e69865b$export$a25da3406dc148e4 = 1;
const $c7c977bd0e69865b$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
const $c7c977bd0e69865b$export$d4f764f0ec4f52f = "amz-sdk-request";

});

parcelRegister("fgZnV", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryBackoffStrategy", () => $b1e7f763a905ab4a$export$fc672061560e1611);

var $h9sBI = parcelRequire("h9sBI");
const $b1e7f763a905ab4a$export$fc672061560e1611 = ()=>{
    let delayBase = (0, $h9sBI.DEFAULT_RETRY_DELAY_BASE);
    const computeNextBackoffDelay = (attempts)=>{
        return Math.floor(Math.min((0, $h9sBI.MAXIMUM_RETRY_DELAY), Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay)=>{
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay: computeNextBackoffDelay,
        setDelayBase: setDelayBase
    };
};

});

parcelRegister("fCAB2", function(module, exports) {

$parcel$export(module.exports, "createDefaultRetryToken", () => $b5f6cae3968bdcb0$export$330ec27afca1b9b);

var $h9sBI = parcelRequire("h9sBI");
const $b5f6cae3968bdcb0$export$330ec27afca1b9b = ({ retryDelay: retryDelay, retryCount: retryCount, retryCost: retryCost })=>{
    const getRetryCount = ()=>retryCount;
    const getRetryDelay = ()=>Math.min((0, $h9sBI.MAXIMUM_RETRY_DELAY), retryDelay);
    const getRetryCost = ()=>retryCost;
    return {
        getRetryCount: getRetryCount,
        getRetryDelay: getRetryDelay,
        getRetryCost: getRetryCost
    };
};

});



parcelRegister("fpe8H", function(module, exports) {

var $h9sBI = parcelRequire("h9sBI");

var $b8FrF = parcelRequire("b8FrF");
class $b3742896607db1e0$export$4d488d77e5dad28e extends (0, $b8FrF.StandardRetryStrategy) {
    constructor(maxAttempts, computeNextBackoffDelay = (0, $h9sBI.DEFAULT_RETRY_DELAY_BASE)){
        super(typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts);
        if (typeof computeNextBackoffDelay === "number") this.computeNextBackoffDelay = ()=>computeNextBackoffDelay;
        else this.computeNextBackoffDelay = computeNextBackoffDelay;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const token = await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        token.getRetryDelay = ()=>this.computeNextBackoffDelay(token.getRetryCount());
        return token;
    }
}

});

parcelRegister("e37gS", function(module, exports) {

});


parcelRegister("epVH2", function(module, exports) {

$parcel$export(module.exports, "StandardRetryStrategy", () => $a7f027275fe09b81$export$64af437cce00eae8);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
var $3OhLM = parcelRequire("3OhLM");

var $1fbdJ = parcelRequire("1fbdJ");
parcelRequire("eVim3");
var $79mxn = parcelRequire("79mxn");
var $h9sBI = parcelRequire("h9sBI");

var $5sKyw = parcelRequire("5sKyw");

var $kA7lK = parcelRequire("kA7lK");

var $g6he3 = parcelRequire("g6he3");

var $l98Vq = parcelRequire("l98Vq");

var $4tRhD = parcelRequire("4tRhD");
class $a7f027275fe09b81$export$64af437cce00eae8 {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $79mxn.RETRY_MODES).STANDARD;
        this.retryDecider = options?.retryDecider ?? (0, $l98Vq.defaultRetryDecider);
        this.delayDecider = options?.delayDecider ?? (0, $g6he3.defaultDelayDecider);
        this.retryQuota = options?.retryQuota ?? (0, $kA7lK.getDefaultRetryQuota)((0, $h9sBI.INITIAL_RETRY_TOKENS));
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        } catch (error) {
            maxAttempts = (0, $79mxn.DEFAULT_MAX_ATTEMPTS);
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request: request } = args;
        if ((0, $acFZn.HttpRequest).isInstance(request)) request.headers[0, $h9sBI.INVOCATION_ID_HEADER] = (0, $5sKyw.default)();
        while(true)try {
            if ((0, $acFZn.HttpRequest).isInstance(request)) request.headers[0, $h9sBI.REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
            if (options?.beforeRequest) await options.beforeRequest();
            const { response: response, output: output } = await next(args);
            if (options?.afterRequest) options.afterRequest(response);
            this.retryQuota.releaseRetryTokens(retryTokenAmount);
            output.$metadata.attempts = attempts + 1;
            output.$metadata.totalRetryDelay = totalDelay;
            return {
                response: response,
                output: output
            };
        } catch (e) {
            const err = (0, $4tRhD.asSdkError)(e);
            attempts++;
            if (this.shouldRetry(err, attempts, maxAttempts)) {
                retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                const delayFromDecider = this.delayDecider((0, $1fbdJ.isThrottlingError)(err) ? (0, $h9sBI.THROTTLING_RETRY_DELAY_BASE) : (0, $h9sBI.DEFAULT_RETRY_DELAY_BASE), attempts);
                const delayFromResponse = $a7f027275fe09b81$var$getDelayFromRetryAfterHeader(err.$response);
                const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                totalDelay += delay;
                await new Promise((resolve)=>setTimeout(resolve, delay));
                continue;
            }
            if (!err.$metadata) err.$metadata = {};
            err.$metadata.attempts = attempts;
            err.$metadata.totalRetryDelay = totalDelay;
            throw err;
        }
    }
}
const $a7f027275fe09b81$var$getDelayFromRetryAfterHeader = (response)=>{
    if (!(0, $3OhLM.HttpResponse).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("kA7lK", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryQuota", () => $efbcdeeef1878a5a$export$2ebe7988802fc284);
parcelRequire("eVim3");
var $h9sBI = parcelRequire("h9sBI");
const $efbcdeeef1878a5a$export$2ebe7988802fc284 = (initialRetryTokens, options)=>{
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? (0, $h9sBI.NO_RETRY_INCREMENT);
    const retryCost = options?.retryCost ?? (0, $h9sBI.RETRY_COST);
    const timeoutRetryCost = options?.timeoutRetryCost ?? (0, $h9sBI.TIMEOUT_RETRY_COST);
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error)=>error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    const hasRetryTokens = (error)=>getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error)=>{
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount)=>{
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

});

parcelRegister("g6he3", function(module, exports) {

$parcel$export(module.exports, "defaultDelayDecider", () => $bb8a918551d0eac6$export$1cddd42598a3b1f6);
parcelRequire("eVim3");
var $h9sBI = parcelRequire("h9sBI");
const $bb8a918551d0eac6$export$1cddd42598a3b1f6 = (delayBase, attempts)=>Math.floor(Math.min((0, $h9sBI.MAXIMUM_RETRY_DELAY), Math.random() * 2 ** attempts * delayBase));

});

parcelRegister("l98Vq", function(module, exports) {

$parcel$export(module.exports, "defaultRetryDecider", () => $f6515c9b19754f41$export$3839fd261f89ec2);

var $1fbdJ = parcelRequire("1fbdJ");
const $f6515c9b19754f41$export$3839fd261f89ec2 = (error)=>{
    if (!error) return false;
    return (0, $1fbdJ.isRetryableByTrait)(error) || (0, $1fbdJ.isClockSkewError)(error) || (0, $1fbdJ.isThrottlingError)(error) || (0, $1fbdJ.isTransientError)(error);
};

});

parcelRegister("4tRhD", function(module, exports) {

$parcel$export(module.exports, "asSdkError", () => $343333d06ff290bf$export$c780f8210b6eca50);
const $343333d06ff290bf$export$c780f8210b6eca50 = (error)=>{
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};

});



parcelRegister("1HvUN", function(module, exports) {

$parcel$export(module.exports, "resolveRetryConfig", () => $13d2904175ea6339$export$ca7f6138f2c98476);
parcelRequire("et0OQ");
var $25kVm = parcelRequire("25kVm");
parcelRequire("eVim3");
var $bcbXK = parcelRequire("bcbXK");
var $79mxn = parcelRequire("79mxn");
var $b8FrF = parcelRequire("b8FrF");
const $13d2904175ea6339$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
const $13d2904175ea6339$export$9ae8a04532f798bc = "max_attempts";
const $13d2904175ea6339$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: (env)=>{
        const value = env[$13d2904175ea6339$export$a19952f9e421517c];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Environment variable ${$13d2904175ea6339$export$a19952f9e421517c} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    configFileSelector: (profile)=>{
        const value = profile[$13d2904175ea6339$export$9ae8a04532f798bc];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Shared config file entry ${$13d2904175ea6339$export$9ae8a04532f798bc} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    default: (0, $79mxn.DEFAULT_MAX_ATTEMPTS)
};
const $13d2904175ea6339$export$ca7f6138f2c98476 = (input)=>{
    const { retryStrategy: retryStrategy } = input;
    const maxAttempts = (0, $25kVm.normalizeProvider)(input.maxAttempts ?? (0, $79mxn.DEFAULT_MAX_ATTEMPTS));
    return {
        ...input,
        maxAttempts: maxAttempts,
        retryStrategy: async ()=>{
            if (retryStrategy) return retryStrategy;
            const retryMode = await (0, $25kVm.normalizeProvider)(input.retryMode)();
            if (retryMode === (0, $79mxn.RETRY_MODES).ADAPTIVE) return new (0, $bcbXK.AdaptiveRetryStrategy)(maxAttempts);
            return new (0, $b8FrF.StandardRetryStrategy)(maxAttempts);
        }
    };
};
const $13d2904175ea6339$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
const $13d2904175ea6339$export$c5c0171a17765aea = "retry_mode";
const $13d2904175ea6339$export$972bf2bb01959ff5 = {
    environmentVariableSelector: (env)=>env[$13d2904175ea6339$export$4728af91ff39ef3b],
    configFileSelector: (profile)=>profile[$13d2904175ea6339$export$c5c0171a17765aea],
    default: (0, $79mxn.DEFAULT_RETRY_MODE)
};

});

parcelRegister("ftXa6", function(module, exports) {
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
parcelRequire("eVim3");
var $h9sBI = parcelRequire("h9sBI");
const $b45774cbe4af775c$export$536b11ee0b9c4a95 = ()=>(next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $acFZn.HttpRequest).isInstance(request)) {
                delete request.headers[0, $h9sBI.INVOCATION_ID_HEADER];
                delete request.headers[0, $h9sBI.REQUEST_HEADER];
            }
            return next(args);
        };
const $b45774cbe4af775c$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
const $b45774cbe4af775c$export$fa165e6edc16c2a2 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($b45774cbe4af775c$export$536b11ee0b9c4a95(), $b45774cbe4af775c$export$3ec587d8f35e7a2c);
        }
    });

});

parcelRegister("ghlrH", function(module, exports) {

$parcel$export(module.exports, "retryMiddlewareOptions", () => $bd9ede8b9dd2c907$export$44d3d03587957ce9);
$parcel$export(module.exports, "getRetryPlugin", () => $bd9ede8b9dd2c907$export$c73199e2b1df9340);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
var $3OhLM = parcelRequire("3OhLM");

var $1fbdJ = parcelRequire("1fbdJ");
parcelRequire("eKvzZ");
var $avv1m = parcelRequire("avv1m");
parcelRequire("eVim3");
var $h9sBI = parcelRequire("h9sBI");

var $5sKyw = parcelRequire("5sKyw");

var $2QnQL = parcelRequire("2QnQL");

var $4tRhD = parcelRequire("4tRhD");
const $bd9ede8b9dd2c907$export$a3922aa5f87bae85 = (options)=>(next, context)=>async (args)=>{
            let retryStrategy = await options.retryStrategy();
            const maxAttempts = await options.maxAttempts();
            if ($bd9ede8b9dd2c907$var$isRetryStrategyV2(retryStrategy)) {
                retryStrategy;
                let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
                let lastError = new Error();
                let attempts = 0;
                let totalRetryDelay = 0;
                const { request: request } = args;
                const isRequest = (0, $acFZn.HttpRequest).isInstance(request);
                if (isRequest) request.headers[0, $h9sBI.INVOCATION_ID_HEADER] = (0, $5sKyw.default)();
                while(true)try {
                    if (isRequest) request.headers[0, $h9sBI.REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                    const { response: response, output: output } = await next(args);
                    retryStrategy.recordSuccess(retryToken);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalRetryDelay;
                    return {
                        response: response,
                        output: output
                    };
                } catch (e) {
                    const retryErrorInfo = $bd9ede8b9dd2c907$var$getRetryErrorInfo(e);
                    lastError = (0, $4tRhD.asSdkError)(e);
                    if (isRequest && (0, $2QnQL.isStreamingPayload)(request)) {
                        (context.logger instanceof (0, $avv1m.NoOpLogger) ? console : context.logger)?.warn("An error was encountered in a non-retryable streaming request.");
                        throw lastError;
                    }
                    try {
                        retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                    } catch (refreshError) {
                        if (!lastError.$metadata) lastError.$metadata = {};
                        lastError.$metadata.attempts = attempts + 1;
                        lastError.$metadata.totalRetryDelay = totalRetryDelay;
                        throw lastError;
                    }
                    attempts = retryToken.getRetryCount();
                    const delay = retryToken.getRetryDelay();
                    totalRetryDelay += delay;
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else {
                retryStrategy;
                if (retryStrategy?.mode) context.userAgent = [
                    ...context.userAgent || [],
                    [
                        "cfg/retry-mode",
                        retryStrategy.mode
                    ]
                ];
                return retryStrategy.retry(next, args);
            }
        };
const $bd9ede8b9dd2c907$var$isRetryStrategyV2 = (retryStrategy)=>typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const $bd9ede8b9dd2c907$var$getRetryErrorInfo = (error)=>{
    const errorInfo = {
        error: error,
        errorType: $bd9ede8b9dd2c907$var$getRetryErrorType(error)
    };
    const retryAfterHint = $bd9ede8b9dd2c907$export$8f45b27d98dcedff(error.$response);
    if (retryAfterHint) errorInfo.retryAfterHint = retryAfterHint;
    return errorInfo;
};
const $bd9ede8b9dd2c907$var$getRetryErrorType = (error)=>{
    if ((0, $1fbdJ.isThrottlingError)(error)) return "THROTTLING";
    if ((0, $1fbdJ.isTransientError)(error)) return "TRANSIENT";
    if ((0, $1fbdJ.isServerError)(error)) return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const $bd9ede8b9dd2c907$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
const $bd9ede8b9dd2c907$export$c73199e2b1df9340 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($bd9ede8b9dd2c907$export$a3922aa5f87bae85(options), $bd9ede8b9dd2c907$export$44d3d03587957ce9);
        }
    });
const $bd9ede8b9dd2c907$export$8f45b27d98dcedff = (response)=>{
    if (!(0, $3OhLM.HttpResponse).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};

});
parcelRegister("2QnQL", function(module, exports) {

$parcel$export(module.exports, "isStreamingPayload", () => $2122f03ca92a44c5$export$e29b4465f2a53696);
const $2122f03ca92a44c5$export$e29b4465f2a53696 = (request)=>request?.body instanceof ReadableStream;

});





parcelRegister("hH5ic", function(module, exports) {
$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => (parcelRequire("7C8Sk")).DefaultIdentityProviderConfig);
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("pdHpr")).NoAuthSigner);
$parcel$export(module.exports, "doesIdentityRequireRefresh", () => (parcelRequire("hKyAA")).doesIdentityRequireRefresh);
$parcel$export(module.exports, "isIdentityExpired", () => (parcelRequire("hKyAA")).isIdentityExpired);
$parcel$export(module.exports, "memoizeIdentityProvider", () => (parcelRequire("hKyAA")).memoizeIdentityProvider);
parcelRequire("7C8Sk");
parcelRequire("Gt3oj");
parcelRequire("hKyAA");

});
parcelRegister("7C8Sk", function(module, exports) {

$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => $58b2f76f3f73da07$export$67f43b78065c5551);
class $58b2f76f3f73da07$export$67f43b78065c5551 {
    constructor(config){
        this.authSchemes = new Map();
        for (const [key, value] of Object.entries(config))if (value !== undefined) this.authSchemes.set(key, value);
    }
    getIdentityProvider(schemeId) {
        return this.authSchemes.get(schemeId);
    }
}

});

parcelRegister("Gt3oj", function(module, exports) {
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("pdHpr")).NoAuthSigner);
parcelRequire("8rVr5");
parcelRequire("fTHxg");
parcelRequire("pdHpr");

});
parcelRegister("8rVr5", function(module, exports) {
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
parcelRequire("95Hh5");
var $g5NVg = parcelRequire("g5NVg");
class $626d65e42d28a35c$export$823b895391979983 {
    async sign(httpRequest, identity, signingProperties) {
        if (!signingProperties) throw new Error("request could not be signed with `apiKey` since the `name` and `in` signer properties are missing");
        if (!signingProperties.name) throw new Error("request could not be signed with `apiKey` since the `name` signer property is missing");
        if (!signingProperties.in) throw new Error("request could not be signed with `apiKey` since the `in` signer property is missing");
        if (!identity.apiKey) throw new Error("request could not be signed with `apiKey` since the `apiKey` is not defined");
        const clonedRequest = (0, $acFZn.HttpRequest).clone(httpRequest);
        if (signingProperties.in === (0, $g5NVg.HttpApiKeyAuthLocation).QUERY) clonedRequest.query[signingProperties.name] = identity.apiKey;
        else if (signingProperties.in === (0, $g5NVg.HttpApiKeyAuthLocation).HEADER) clonedRequest.headers[signingProperties.name] = signingProperties.scheme ? `${signingProperties.scheme} ${identity.apiKey}` : identity.apiKey;
        else throw new Error("request can only be signed with `apiKey` locations `query` or `header`, but found: `" + signingProperties.in + "`");
        return clonedRequest;
    }
}

});

parcelRegister("fTHxg", function(module, exports) {
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
class $b92dc34d941cc386$export$f646f7f27c38a496 {
    async sign(httpRequest, identity, signingProperties) {
        const clonedRequest = (0, $acFZn.HttpRequest).clone(httpRequest);
        if (!identity.token) throw new Error("request could not be signed with `token` since the `token` is not defined");
        clonedRequest.headers["Authorization"] = `Bearer ${identity.token}`;
        return clonedRequest;
    }
}

});

parcelRegister("pdHpr", function(module, exports) {

$parcel$export(module.exports, "NoAuthSigner", () => $04bcf647a2718850$export$19622a6daa7bca6e);
class $04bcf647a2718850$export$19622a6daa7bca6e {
    async sign(httpRequest, identity, signingProperties) {
        return httpRequest;
    }
}

});


parcelRegister("hKyAA", function(module, exports) {

$parcel$export(module.exports, "doesIdentityRequireRefresh", () => $cec1903e82a55a6a$export$5fef7ca5b4791fa9);
$parcel$export(module.exports, "isIdentityExpired", () => $cec1903e82a55a6a$export$42a11a4dafc8f476);
$parcel$export(module.exports, "memoizeIdentityProvider", () => $cec1903e82a55a6a$export$b258763a05c20e85);
const $cec1903e82a55a6a$export$4c74afac7567edb5 = (expirationMs)=>(identity)=>$cec1903e82a55a6a$export$5fef7ca5b4791fa9(identity) && identity.expiration.getTime() - Date.now() < expirationMs;
const $cec1903e82a55a6a$export$1d503351280d1918 = 300000;
const $cec1903e82a55a6a$export$42a11a4dafc8f476 = $cec1903e82a55a6a$export$4c74afac7567edb5($cec1903e82a55a6a$export$1d503351280d1918);
const $cec1903e82a55a6a$export$5fef7ca5b4791fa9 = (identity)=>identity.expiration !== undefined;
const $cec1903e82a55a6a$export$b258763a05c20e85 = (provider, isExpired, requiresRefresh)=>{
    if (provider === undefined) return undefined;
    const normalizedProvider = typeof provider !== "function" ? async ()=>Promise.resolve(provider) : provider;
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async (options)=>{
        if (!pending) pending = normalizedProvider(options);
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        if (isConstant) return resolved;
        if (!requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider(options);
            return resolved;
        }
        return resolved;
    };
};

});


parcelRegister("g0WBB", function(module, exports) {
parcelRequire("95Hh5");
var $35FCJ = parcelRequire("35FCJ");
const $ba8a1b474d4951ab$export$1d3c197393275463 = (context)=>context[0, $35FCJ.SMITHY_CONTEXT_KEY] || (context[0, $35FCJ.SMITHY_CONTEXT_KEY] = {});

});

parcelRegister("k1l7u", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $e93448931b62a38c$export$b1276c07738d6325);
const $e93448931b62a38c$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

});

parcelRegister("iBKR4", function(module, exports) {
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
parcelRequire("eKvzZ");
var $9GK4j = parcelRequire("9GK4j");
function $d8c0071a361ed8f6$export$9f1f89e694d26cd0(input, context) {
    return new $d8c0071a361ed8f6$export$e63ecf257fa6a994(input, context);
}
class $d8c0071a361ed8f6$export$e63ecf257fa6a994 {
    constructor(input, context){
        this.input = input;
        this.context = context;
        this.query = {};
        this.method = "";
        this.headers = {};
        this.path = "";
        this.body = null;
        this.hostname = "";
        this.resolvePathStack = [];
    }
    async build() {
        const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await this.context.endpoint();
        this.path = basePath;
        for (const resolvePath of this.resolvePathStack)resolvePath(this.path);
        return new (0, $acFZn.HttpRequest)({
            protocol: protocol,
            hostname: this.hostname || hostname,
            port: port,
            method: this.method,
            path: this.path,
            query: this.query,
            body: this.body,
            headers: this.headers
        });
    }
    hn(hostname) {
        this.hostname = hostname;
        return this;
    }
    bp(uriLabel) {
        this.resolvePathStack.push((basePath)=>{
            this.path = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + uriLabel;
        });
        return this;
    }
    p(memberName, labelValueProvider, uriLabel, isGreedyLabel) {
        this.resolvePathStack.push((path)=>{
            this.path = (0, $9GK4j.resolvedPath)(path, this.input, memberName, labelValueProvider, uriLabel, isGreedyLabel);
        });
        return this;
    }
    h(headers) {
        this.headers = headers;
        return this;
    }
    q(query) {
        this.query = query;
        return this;
    }
    b(body) {
        this.body = body;
        return this;
    }
    m(method) {
        this.method = method;
        return this;
    }
}

});

parcelRegister("ajjxx", function(module, exports) {
const $781ad5f3dff16bec$var$makePagedClientRequest = async (CommandCtor, client, input, ...args)=>{
    return await client.send(new CommandCtor(input), ...args);
};
function $781ad5f3dff16bec$export$531a5724c6bf0340(ClientCtor, CommandCtor, inputTokenName, outputTokenName, pageSizeTokenName) {
    return async function* paginateOperation(config, input, ...additionalArguments) {
        let token = config.startingToken || undefined;
        let hasNext = true;
        let page;
        while(hasNext){
            input[inputTokenName] = token;
            if (pageSizeTokenName) input[pageSizeTokenName] = input[pageSizeTokenName] ?? config.pageSize;
            if (config.client instanceof ClientCtor) page = await $781ad5f3dff16bec$var$makePagedClientRequest(CommandCtor, config.client, input, ...additionalArguments);
            else throw new Error(`Invalid client, expected instance of ${ClientCtor.name}`);
            yield page;
            const prevToken = token;
            token = $781ad5f3dff16bec$var$get(page, outputTokenName);
            hasNext = !!(token && (!config.stopOnSameToken || token !== prevToken));
        }
        return undefined;
    };
}
const $781ad5f3dff16bec$var$get = (fromObject, path)=>{
    let cursor = fromObject;
    const pathComponents = path.split(".");
    for (const step of pathComponents){
        if (!cursor || typeof cursor !== "object") return undefined;
        cursor = cursor[step];
    }
    return cursor;
};

});


parcelRegister("kjxgR", function(module, exports) {

$parcel$export(module.exports, "getContentLengthPlugin", () => $ec9f63e670cded24$export$7e6ddf9365a30fe9);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
const $ec9f63e670cded24$var$CONTENT_LENGTH_HEADER = "content-length";
function $ec9f63e670cded24$export$940b29eb2788b975(bodyLengthChecker) {
    return (next)=>async (args)=>{
            const request = args.request;
            if ((0, $acFZn.HttpRequest).isInstance(request)) {
                const { body: body, headers: headers } = request;
                if (body && Object.keys(headers).map((str)=>str.toLowerCase()).indexOf($ec9f63e670cded24$var$CONTENT_LENGTH_HEADER) === -1) try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [$ec9f63e670cded24$var$CONTENT_LENGTH_HEADER]: String(length)
                    };
                } catch (error) {}
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $ec9f63e670cded24$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
const $ec9f63e670cded24$export$7e6ddf9365a30fe9 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($ec9f63e670cded24$export$940b29eb2788b975(options.bodyLengthChecker), $ec9f63e670cded24$export$1f7816f8f350b2f5);
        }
    });

});

parcelRegister("iJsrS", function(module, exports) {

$parcel$export(module.exports, "resolveAwsSdkSigV4Config", () => $da327f45df4eb8a5$export$e18f3f8a841a90ec);
parcelRequire("2xHTL");
var $hKyAA = parcelRequire("hKyAA");
var $k1l7u = parcelRequire("k1l7u");
parcelRequire("2ludW");
var $4of3b = parcelRequire("4of3b");
const $da327f45df4eb8a5$export$e18f3f8a841a90ec = (config)=>{
    let normalizedCreds;
    if (config.credentials) normalizedCreds = (0, $hKyAA.memoizeIdentityProvider)(config.credentials, (0, $hKyAA.isIdentityExpired), (0, $hKyAA.doesIdentityRequireRefresh));
    if (!normalizedCreds) {
        if (config.credentialDefaultProvider) normalizedCreds = (0, $k1l7u.normalizeProvider)(config.credentialDefaultProvider(Object.assign({}, config, {
            parentClientConfig: config
        })));
        else normalizedCreds = async ()=>{
            throw new Error("`credentials` is missing");
        };
    }
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = config.systemClockOffset || 0, sha256: sha256 } = config;
    let signer;
    if (config.signer) signer = (0, $k1l7u.normalizeProvider)(config.signer);
    else if (config.regionInfoProvider) signer = ()=>(0, $k1l7u.normalizeProvider)(config.region)().then(async (region)=>[
                await config.regionInfoProvider(region, {
                    useFipsEndpoint: await config.useFipsEndpoint(),
                    useDualstackEndpoint: await config.useDualstackEndpoint()
                }) || {},
                region
            ]).then(([regionInfo, region])=>{
            const { signingRegion: signingRegion, signingService: signingService } = regionInfo;
            config.signingRegion = config.signingRegion || signingRegion || region;
            config.signingName = config.signingName || signingService || config.serviceId;
            const params = {
                ...config,
                credentials: normalizedCreds,
                region: config.signingRegion,
                service: config.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            };
            const SignerCtor = config.signerConstructor || (0, $4of3b.SignatureV4);
            return new SignerCtor(params);
        });
    else signer = async (authScheme)=>{
        authScheme = Object.assign({}, {
            name: "sigv4",
            signingName: config.signingName || config.defaultSigningName,
            signingRegion: await (0, $k1l7u.normalizeProvider)(config.region)(),
            properties: {}
        }, authScheme);
        const signingRegion = authScheme.signingRegion;
        const signingService = authScheme.signingName;
        config.signingRegion = config.signingRegion || signingRegion;
        config.signingName = config.signingName || signingService || config.serviceId;
        const params = {
            ...config,
            credentials: normalizedCreds,
            region: config.signingRegion,
            service: config.signingName,
            sha256: sha256,
            uriEscapePath: signingEscapePath
        };
        const SignerCtor = config.signerConstructor || (0, $4of3b.SignatureV4);
        return new SignerCtor(params);
    };
    return {
        ...config,
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    };
};
const $da327f45df4eb8a5$export$d85a20fa3e1218b1 = $da327f45df4eb8a5$export$e18f3f8a841a90ec;

});
parcelRegister("2ludW", function(module, exports) {
$parcel$export(module.exports, "SignatureV4", () => (parcelRequire("4of3b")).SignatureV4);
parcelRequire("4of3b");

var $4J7rv = parcelRequire("4J7rv");

var $9nGoz = parcelRequire("9nGoz");

var $vptMW = parcelRequire("vptMW");

var $8doNd = parcelRequire("8doNd");

var $9JIS1 = parcelRequire("9JIS1");
parcelRequire("3KbSh");

});
parcelRegister("4of3b", function(module, exports) {

$parcel$export(module.exports, "SignatureV4", () => $332513fcfabd50ca$export$20baf4d3f65eb30c);

var $lUOK3 = parcelRequire("lUOK3");
parcelRequire("et0OQ");
var $25kVm = parcelRequire("25kVm");
parcelRequire("5N8Rb");
var $5THLa = parcelRequire("5THLa");
parcelRequire("geIv0");
var $jGtn4 = parcelRequire("jGtn4");

var $dR6N0 = parcelRequire("dR6N0");

var $3KbSh = parcelRequire("3KbSh");

var $4J7rv = parcelRequire("4J7rv");

var $9nGoz = parcelRequire("9nGoz");

var $vptMW = parcelRequire("vptMW");

var $6rpMp = parcelRequire("6rpMp");

var $2wqrW = parcelRequire("2wqrW");

var $8doNd = parcelRequire("8doNd");

var $9JIS1 = parcelRequire("9JIS1");

var $99xKO = parcelRequire("99xKO");
class $332513fcfabd50ca$export$20baf4d3f65eb30c {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.headerFormatter = new (0, $6rpMp.HeaderFormatter)();
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $25kVm.normalizeProvider)(region);
        this.credentialProvider = (0, $25kVm.normalizeProvider)(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        if (expiresIn > (0, $dR6N0.MAX_PRESIGNED_TTL)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $3KbSh.createScope)(shortDate, region, signingService ?? this.service);
        const request = (0, $8doNd.moveHeadersToQuery)((0, $9JIS1.prepareRequest)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $dR6N0.TOKEN_QUERY_PARAM] = credentials.sessionToken;
        request.query[0, $dR6N0.ALGORITHM_QUERY_PARAM] = (0, $dR6N0.ALGORITHM_IDENTIFIER);
        request.query[0, $dR6N0.CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $dR6N0.AMZ_DATE_QUERY_PARAM] = longDate;
        request.query[0, $dR6N0.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
        const canonicalHeaders = (0, $4J7rv.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        request.query[0, $dR6N0.SIGNED_HEADERS_QUERY_PARAM] = $332513fcfabd50ca$var$getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $dR6N0.SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $vptMW.getPayloadHash)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        const scope = (0, $3KbSh.createScope)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, $vptMW.getPayloadHash)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $lUOK3.toHex)(await hash.digest());
        const stringToSign = [
            (0, $dR6N0.EVENT_ALGORITHM_IDENTIFIER),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerFormatter.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $jGtn4.toUint8Array)(stringToSign));
        return (0, $lUOK3.toHex)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, $9JIS1.prepareRequest)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        const scope = (0, $3KbSh.createScope)(shortDate, region, signingService ?? this.service);
        request.headers[0, $dR6N0.AMZ_DATE_HEADER] = longDate;
        if (credentials.sessionToken) request.headers[0, $dR6N0.TOKEN_HEADER] = credentials.sessionToken;
        const payloadHash = await (0, $vptMW.getPayloadHash)(request, this.sha256);
        if (!(0, $2wqrW.hasHeader)((0, $dR6N0.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, $dR6N0.SHA256_HEADER] = payloadHash;
        const canonicalHeaders = (0, $4J7rv.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $dR6N0.AUTH_HEADER] = `${0, $dR6N0.ALGORITHM_IDENTIFIER} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${$332513fcfabd50ca$var$getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $9nGoz.getCanonicalQuery)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, $jGtn4.toUint8Array)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, $dR6N0.ALGORITHM_IDENTIFIER}
${longDate}
${credentialScope}
${(0, $lUOK3.toHex)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = (0, $5THLa.escapeUri)(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $jGtn4.toUint8Array)(stringToSign));
        return (0, $lUOK3.toHex)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $3KbSh.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
}
const $332513fcfabd50ca$var$formatDate = (now)=>{
    const longDate = (0, $99xKO.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const $332513fcfabd50ca$var$getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");

});
parcelRegister("dR6N0", function(module, exports) {

$parcel$export(module.exports, "ALGORITHM_QUERY_PARAM", () => $a1657dd5dbbba947$export$186cd8495ba0377d);
$parcel$export(module.exports, "CREDENTIAL_QUERY_PARAM", () => $a1657dd5dbbba947$export$5c8e6dd7758f59d6);
$parcel$export(module.exports, "AMZ_DATE_QUERY_PARAM", () => $a1657dd5dbbba947$export$6e114beec37430d7);
$parcel$export(module.exports, "SIGNED_HEADERS_QUERY_PARAM", () => $a1657dd5dbbba947$export$2dcbb254f883c238);
$parcel$export(module.exports, "EXPIRES_QUERY_PARAM", () => $a1657dd5dbbba947$export$a0afe6f3bbfaf76e);
$parcel$export(module.exports, "SIGNATURE_QUERY_PARAM", () => $a1657dd5dbbba947$export$41ae838dc1e0f082);
$parcel$export(module.exports, "TOKEN_QUERY_PARAM", () => $a1657dd5dbbba947$export$8e1383b7eea7bee);
$parcel$export(module.exports, "AUTH_HEADER", () => $a1657dd5dbbba947$export$9924a64a4b8b0d58);
$parcel$export(module.exports, "AMZ_DATE_HEADER", () => $a1657dd5dbbba947$export$acf4b8bdf24aab34);
$parcel$export(module.exports, "GENERATED_HEADERS", () => $a1657dd5dbbba947$export$20d6a73fd0b10982);
$parcel$export(module.exports, "SIGNATURE_HEADER", () => $a1657dd5dbbba947$export$29961f34c719157e);
$parcel$export(module.exports, "SHA256_HEADER", () => $a1657dd5dbbba947$export$eaef12179141669a);
$parcel$export(module.exports, "TOKEN_HEADER", () => $a1657dd5dbbba947$export$fdc81b663012a8d2);
$parcel$export(module.exports, "ALWAYS_UNSIGNABLE_HEADERS", () => $a1657dd5dbbba947$export$8ffdcd58c4092560);
$parcel$export(module.exports, "PROXY_HEADER_PATTERN", () => $a1657dd5dbbba947$export$8085db98abbe0597);
$parcel$export(module.exports, "SEC_HEADER_PATTERN", () => $a1657dd5dbbba947$export$758380400526c39);
$parcel$export(module.exports, "ALGORITHM_IDENTIFIER", () => $a1657dd5dbbba947$export$863a63fba5b2ddf5);
$parcel$export(module.exports, "EVENT_ALGORITHM_IDENTIFIER", () => $a1657dd5dbbba947$export$9a1f6cf06ac56167);
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $a1657dd5dbbba947$export$91f7321b40d9fd07);
$parcel$export(module.exports, "MAX_CACHE_SIZE", () => $a1657dd5dbbba947$export$bf665777b4a1722f);
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", () => $a1657dd5dbbba947$export$c4bf0942098f6bb);
$parcel$export(module.exports, "MAX_PRESIGNED_TTL", () => $a1657dd5dbbba947$export$274df788bdcca184);
const $a1657dd5dbbba947$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $a1657dd5dbbba947$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $a1657dd5dbbba947$export$6e114beec37430d7 = "X-Amz-Date";
const $a1657dd5dbbba947$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $a1657dd5dbbba947$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $a1657dd5dbbba947$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $a1657dd5dbbba947$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $a1657dd5dbbba947$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $a1657dd5dbbba947$export$9924a64a4b8b0d58 = "authorization";
const $a1657dd5dbbba947$export$acf4b8bdf24aab34 = $a1657dd5dbbba947$export$6e114beec37430d7.toLowerCase();
const $a1657dd5dbbba947$export$c65c8c9f514da472 = "date";
const $a1657dd5dbbba947$export$20d6a73fd0b10982 = [
    $a1657dd5dbbba947$export$9924a64a4b8b0d58,
    $a1657dd5dbbba947$export$acf4b8bdf24aab34,
    $a1657dd5dbbba947$export$c65c8c9f514da472
];
const $a1657dd5dbbba947$export$29961f34c719157e = $a1657dd5dbbba947$export$41ae838dc1e0f082.toLowerCase();
const $a1657dd5dbbba947$export$eaef12179141669a = "x-amz-content-sha256";
const $a1657dd5dbbba947$export$fdc81b663012a8d2 = $a1657dd5dbbba947$export$8e1383b7eea7bee.toLowerCase();
const $a1657dd5dbbba947$export$96307741595055fc = "host";
const $a1657dd5dbbba947$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $a1657dd5dbbba947$export$8085db98abbe0597 = /^proxy-/;
const $a1657dd5dbbba947$export$758380400526c39 = /^sec-/;
const $a1657dd5dbbba947$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $a1657dd5dbbba947$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $a1657dd5dbbba947$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $a1657dd5dbbba947$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $a1657dd5dbbba947$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $a1657dd5dbbba947$export$bf665777b4a1722f = 50;
const $a1657dd5dbbba947$export$c4bf0942098f6bb = "aws4_request";
const $a1657dd5dbbba947$export$274df788bdcca184 = 604800;

});

parcelRegister("3KbSh", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $2b9ee0fe71097206$export$41a9651decfe2bde);
$parcel$export(module.exports, "getSigningKey", () => $2b9ee0fe71097206$export$8b95a069d16dd783);

var $lUOK3 = parcelRequire("lUOK3");
parcelRequire("geIv0");
var $jGtn4 = parcelRequire("jGtn4");

var $dR6N0 = parcelRequire("dR6N0");
const $2b9ee0fe71097206$var$signingKeyCache = {};
const $2b9ee0fe71097206$var$cacheQueue = [];
const $2b9ee0fe71097206$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $dR6N0.KEY_TYPE_IDENTIFIER}`;
const $2b9ee0fe71097206$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $2b9ee0fe71097206$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $lUOK3.toHex)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $2b9ee0fe71097206$var$signingKeyCache) return $2b9ee0fe71097206$var$signingKeyCache[cacheKey];
    $2b9ee0fe71097206$var$cacheQueue.push(cacheKey);
    while($2b9ee0fe71097206$var$cacheQueue.length > (0, $dR6N0.MAX_CACHE_SIZE))delete $2b9ee0fe71097206$var$signingKeyCache[$2b9ee0fe71097206$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $dR6N0.KEY_TYPE_IDENTIFIER)
    ])key = await $2b9ee0fe71097206$var$hmac(sha256Constructor, key, signable);
    return $2b9ee0fe71097206$var$signingKeyCache[cacheKey] = key;
};
const $2b9ee0fe71097206$export$a31b95746ea0a30a = ()=>{
    $2b9ee0fe71097206$var$cacheQueue.length = 0;
    Object.keys($2b9ee0fe71097206$var$signingKeyCache).forEach((cacheKey)=>{
        delete $2b9ee0fe71097206$var$signingKeyCache[cacheKey];
    });
};
const $2b9ee0fe71097206$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $jGtn4.toUint8Array)(data));
    return hash.digest();
};

});

parcelRegister("4J7rv", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", () => $3711235d8e5015ee$export$859d7f1bb55e2914);

var $dR6N0 = parcelRequire("dR6N0");
const $3711235d8e5015ee$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $dR6N0.ALWAYS_UNSIGNABLE_HEADERS) || unsignableHeaders?.has(canonicalHeaderName) || (0, $dR6N0.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, $dR6N0.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};

});

parcelRegister("9nGoz", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQuery", () => $6d4725dbc7ca19cd$export$8fea7e63ecd1ddbb);
parcelRequire("5N8Rb");
var $5THLa = parcelRequire("5THLa");

var $dR6N0 = parcelRequire("dR6N0");
const $6d4725dbc7ca19cd$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query).sort()){
        if (key.toLowerCase() === (0, $dR6N0.SIGNATURE_HEADER)) continue;
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") serialized[key] = `${(0, $5THLa.escapeUri)(key)}=${(0, $5THLa.escapeUri)(value)}`;
        else if (Array.isArray(value)) serialized[key] = value.slice(0).reduce((encoded, value)=>encoded.concat([
                `${(0, $5THLa.escapeUri)(key)}=${(0, $5THLa.escapeUri)(value)}`
            ]), []).sort().join("&");
    }
    return keys.map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};

});

parcelRegister("vptMW", function(module, exports) {

$parcel$export(module.exports, "getPayloadHash", () => $05e6a90e0ea94a56$export$a46a74202b0efd71);

var $eObbq = parcelRequire("eObbq");

var $lUOK3 = parcelRequire("lUOK3");
parcelRequire("geIv0");
var $jGtn4 = parcelRequire("jGtn4");

var $dR6N0 = parcelRequire("dR6N0");
const $05e6a90e0ea94a56$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $dR6N0.SHA256_HEADER)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $eObbq.isArrayBuffer)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $jGtn4.toUint8Array)(body));
        return (0, $lUOK3.toHex)(await hashCtor.digest());
    }
    return 0, $dR6N0.UNSIGNED_PAYLOAD;
};

});
parcelRegister("eObbq", function(module, exports) {

$parcel$export(module.exports, "isArrayBuffer", () => $ac7e68f76bf33be3$export$9dd3754ae86f0017);
const $ac7e68f76bf33be3$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

});


parcelRegister("6rpMp", function(module, exports) {

$parcel$export(module.exports, "HeaderFormatter", () => $4b0943057fec6a85$export$2695849af3fba360);

var $lUOK3 = parcelRequire("lUOK3");
parcelRequire("geIv0");
var $1uolR = parcelRequire("1uolR");
class $4b0943057fec6a85$export$2695849af3fba360 {
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = (0, $1uolR.fromUtf8)(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = (0, $1uolR.fromUtf8)(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set($4b0943057fec6a85$export$8a5e19712a0a5deb.fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$4b0943057fec6a85$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $lUOK3.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
}
var $4b0943057fec6a85$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($4b0943057fec6a85$var$HEADER_VALUE_TYPE || ($4b0943057fec6a85$var$HEADER_VALUE_TYPE = {}));
const $4b0943057fec6a85$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
class $4b0943057fec6a85$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $4b0943057fec6a85$var$negate(bytes);
        return new $4b0943057fec6a85$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $4b0943057fec6a85$var$negate(bytes);
        return parseInt((0, $lUOK3.toHex)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $4b0943057fec6a85$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

});

parcelRegister("2wqrW", function(module, exports) {

$parcel$export(module.exports, "hasHeader", () => $1d6316486d1b2b5d$export$17944590be865217);
const $1d6316486d1b2b5d$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $1d6316486d1b2b5d$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $1d6316486d1b2b5d$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};

});

parcelRegister("8doNd", function(module, exports) {

$parcel$export(module.exports, "moveHeadersToQuery", () => $5fb2c4f9ab02391c$export$bfc08a76d4bd60f6);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
const $5fb2c4f9ab02391c$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = (0, $acFZn.HttpRequest).clone(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers: headers,
        query: query
    };
};

});

parcelRegister("9JIS1", function(module, exports) {

$parcel$export(module.exports, "prepareRequest", () => $716b1f50de7e844c$export$a7cfe9131aa06be4);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");

var $dR6N0 = parcelRequire("dR6N0");
const $716b1f50de7e844c$export$a7cfe9131aa06be4 = (request)=>{
    request = (0, $acFZn.HttpRequest).clone(request);
    for (const headerName of Object.keys(request.headers))if ((0, $dR6N0.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};

});

parcelRegister("99xKO", function(module, exports) {

$parcel$export(module.exports, "iso8601", () => $6a9f233137451648$export$b65d57190c224ef2);
const $6a9f233137451648$export$b65d57190c224ef2 = (time)=>$6a9f233137451648$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $6a9f233137451648$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

});




parcelRegister("df1qn", function(module, exports) {
$parcel$export(module.exports, "Sha256", () => (parcelRequire("8u8KM")).Sha256);
parcelRequire("8u8KM");

var $iqup0 = parcelRequire("iqup0");

});
parcelRegister("8u8KM", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $019820aecc286d80$export$3b58ea8124ac5e28);

var $iqup0 = parcelRequire("iqup0");
parcelRequire("78v1Z");
var $4xNDb = parcelRequire("4xNDb");
parcelRequire("gLT3G");
var $7zAbY = parcelRequire("7zAbY");

var $b3AtY = parcelRequire("b3AtY");
parcelRequire("6dvWF");
var $3cPkP = parcelRequire("3cPkP");
var $019820aecc286d80$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $7zAbY.supportsWebCrypto)((0, $b3AtY.locateWindow)())) this.hash = new (0, $iqup0.Sha256)(secret);
        else this.hash = new (0, $4xNDb.Sha256)(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $3cPkP.convertToBuffer)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();

});
parcelRegister("iqup0", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $d6a23cfbd2ef7d82$export$3b58ea8124ac5e28);
parcelRequire("6dvWF");
var $3cPkP = parcelRequire("3cPkP");
var $ZB00P = parcelRequire("ZB00P");

var $9XUHG = parcelRequire("9XUHG");

var $b3AtY = parcelRequire("b3AtY");
var $d6a23cfbd2ef7d82$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $ZB00P.isEmptyData)(data)) return;
        var update = (0, $3cPkP.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $b3AtY.locateWindow)().crypto.subtle.sign((0, $9XUHG.SHA_256_HMAC_ALGO), key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $ZB00P.isEmptyData)(this.toHash)) return Promise.resolve((0, $9XUHG.EMPTY_DATA_SHA_256));
        return Promise.resolve().then(function() {
            return (0, $b3AtY.locateWindow)().crypto.subtle.digest((0, $9XUHG.SHA_256_HASH), _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $b3AtY.locateWindow)().crypto.subtle.importKey("raw", (0, $3cPkP.convertToBuffer)(_this.secret), (0, $9XUHG.SHA_256_HMAC_ALGO), false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();

});
parcelRegister("6dvWF", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => (parcelRequire("3cPkP")).convertToBuffer);
$parcel$export(module.exports, "isEmptyData", () => (parcelRequire("ZB00P")).isEmptyData);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $3cPkP = parcelRequire("3cPkP");

var $ZB00P = parcelRequire("ZB00P");

var $aecxA = parcelRequire("aecxA");

var $kjfFh = parcelRequire("kjfFh");

});
parcelRegister("3cPkP", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => $255a5028cde3f3bc$export$4f21f20c2f1a9063);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
parcelRequire("kcCoK");
var $1FWfu = parcelRequire("1FWfu");

var $6ZWSX = parcelRequire("6ZWSX");
var $255a5028cde3f3bc$require$Buffer = $6ZWSX.Buffer;
// Quick polyfill
var $255a5028cde3f3bc$var$fromUtf8 = typeof $255a5028cde3f3bc$require$Buffer !== "undefined" && $255a5028cde3f3bc$require$Buffer.from ? function(input) {
    return $255a5028cde3f3bc$require$Buffer.from(input, "utf8");
} : (0, $1FWfu.fromUtf8);
function $255a5028cde3f3bc$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $255a5028cde3f3bc$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("kcCoK", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("1FWfu")).fromUtf8);
parcelRequire("1FWfu");
parcelRequire("jnBOW");
parcelRequire("2xmra");

});
parcelRegister("1FWfu", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $1386cdccd15f2250$export$c7c5cef950a4d2fc);
const $1386cdccd15f2250$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("jnBOW", function(module, exports) {

var $1FWfu = parcelRequire("1FWfu");
const $e1bd80b49552314d$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $1FWfu.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("2xmra", function(module, exports) {
const $1d901166ee365ecc$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

});


parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("ZB00P", function(module, exports) {

$parcel$export(module.exports, "isEmptyData", () => $0b9265e3f06832e9$export$ea55f474a468804e);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $0b9265e3f06832e9$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}

});

parcelRegister("aecxA", function(module, exports) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7724f0827d728d87$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}

});

parcelRegister("kjfFh", function(module, exports) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $ec91bbb6f0039d68$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}

});


parcelRegister("9XUHG", function(module, exports) {

$parcel$export(module.exports, "SHA_256_HASH", () => $74159bdf00ac3318$export$2113793cf72f4599);
$parcel$export(module.exports, "SHA_256_HMAC_ALGO", () => $74159bdf00ac3318$export$1f80374c274e65a6);
$parcel$export(module.exports, "EMPTY_DATA_SHA_256", () => $74159bdf00ac3318$export$b6c4a2c4743c9cae);
var $74159bdf00ac3318$export$2113793cf72f4599 = {
    name: "SHA-256"
};
var $74159bdf00ac3318$export$1f80374c274e65a6 = {
    name: "HMAC",
    hash: $74159bdf00ac3318$export$2113793cf72f4599
};
var $74159bdf00ac3318$export$b6c4a2c4743c9cae = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("b3AtY", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $80cc462e9f5bf099$export$2a77db4d0e0dd1ff);
const $80cc462e9f5bf099$var$fallbackWindow = {};
function $80cc462e9f5bf099$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $80cc462e9f5bf099$var$fallbackWindow;
}

});


parcelRegister("78v1Z", function(module, exports) {
$parcel$export(module.exports, "Sha256", () => (parcelRequire("4xNDb")).Sha256);
parcelRequire("4xNDb");

});
parcelRegister("4xNDb", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $34f0be31e76b3852$export$3b58ea8124ac5e28);

var $7WQrb = parcelRequire("7WQrb");

var $4saKg = parcelRequire("4saKg");

var $bGlNU = parcelRequire("bGlNU");
parcelRequire("6dvWF");
var $3cPkP = parcelRequire("3cPkP");
var $ZB00P = parcelRequire("ZB00P");
var $34f0be31e76b3852$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $bGlNU.RawSha256)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ZB00P.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $3cPkP.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $bGlNU.RawSha256)();
        if (this.secret) {
            this.outer = new (0, $bGlNU.RawSha256)();
            var inner = $34f0be31e76b3852$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $4saKg.BLOCK_SIZE));
            outer.set(inner);
            for(var i = 0; i < (0, $4saKg.BLOCK_SIZE); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $34f0be31e76b3852$var$bufferFromSecret(secret) {
    var input = (0, $3cPkP.convertToBuffer)(secret);
    if (input.byteLength > (0, $4saKg.BLOCK_SIZE)) {
        var bufferHash = new (0, $bGlNU.RawSha256)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $4saKg.BLOCK_SIZE));
    buffer.set(input);
    return buffer;
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRegister("4saKg", function(module, exports) {

$parcel$export(module.exports, "BLOCK_SIZE", () => $33e21cb3f745e23a$export$b2e3d6d444266a5c);
$parcel$export(module.exports, "DIGEST_LENGTH", () => $33e21cb3f745e23a$export$d7bd469488748c5f);
$parcel$export(module.exports, "KEY", () => $33e21cb3f745e23a$export$7167c830cefcb6b5);
$parcel$export(module.exports, "INIT", () => $33e21cb3f745e23a$export$d788bc089976c004);
$parcel$export(module.exports, "MAX_HASHABLE_LENGTH", () => $33e21cb3f745e23a$export$856b3d11dc447b50);
/**
 * @internal
 */ var $33e21cb3f745e23a$export$b2e3d6d444266a5c = 64;
var $33e21cb3f745e23a$export$d7bd469488748c5f = 32;
var $33e21cb3f745e23a$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $33e21cb3f745e23a$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $33e21cb3f745e23a$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;

});

parcelRegister("bGlNU", function(module, exports) {

$parcel$export(module.exports, "RawSha256", () => $881487c8a44da5fa$export$aab6bc1ad3c77a42);

var $4saKg = parcelRequire("4saKg");
/**
 * @internal
 */ var $881487c8a44da5fa$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $4saKg.INIT));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $4saKg.MAX_HASHABLE_LENGTH)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $4saKg.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $4saKg.BLOCK_SIZE) >= (0, $4saKg.BLOCK_SIZE) - 8) {
                for(var i = this.bufferLength; i < (0, $4saKg.BLOCK_SIZE); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $4saKg.BLOCK_SIZE) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $4saKg.BLOCK_SIZE) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $4saKg.BLOCK_SIZE) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $4saKg.DIGEST_LENGTH));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $4saKg.BLOCK_SIZE); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $4saKg.KEY)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();

});



parcelRegister("gLT3G", function(module, exports) {
$parcel$export(module.exports, "supportsWebCrypto", () => (parcelRequire("7zAbY")).supportsWebCrypto);
parcelRequire("7zAbY");

});
parcelRegister("7zAbY", function(module, exports) {

$parcel$export(module.exports, "supportsWebCrypto", () => $5837e0442dfecebd$export$519d4361bb708a57);

var $7WQrb = parcelRequire("7WQrb");
var $5837e0442dfecebd$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $5837e0442dfecebd$export$519d4361bb708a57(window) {
    if ($5837e0442dfecebd$export$c4783ac5e58b0ef6(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $5837e0442dfecebd$export$17b9b1d09487d874(subtle);
    }
    return false;
}
function $5837e0442dfecebd$export$c4783ac5e58b0ef6(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
function $5837e0442dfecebd$export$17b9b1d09487d874(subtle) {
    return subtle && $5837e0442dfecebd$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
function $5837e0442dfecebd$export$d94d4c5ec4742a(subtle) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$5837e0442dfecebd$export$17b9b1d09487d874(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}

});




parcelRegister("4H0oe", function(module, exports) {

$parcel$export(module.exports, "defaultUserAgent", () => $36ab7aff4f97a5b5$export$69d579f32876892f);

var $kyrHl = parcelRequire("kyrHl");
const $36ab7aff4f97a5b5$export$69d579f32876892f = ({ serviceId: serviceId, clientVersion: clientVersion })=>async ()=>{
        const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($kyrHl))).parse(window.navigator.userAgent) : undefined;
        const sections = [
            [
                "aws-sdk-js",
                clientVersion
            ],
            [
                "ua",
                "2.0"
            ],
            [
                `os/${parsedUA?.os?.name || "other"}`,
                parsedUA?.os?.version
            ],
            [
                "lang/js"
            ],
            [
                "md/browser",
                `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`
            ]
        ];
        if (serviceId) sections.push([
            `api/${serviceId}`,
            clientVersion
        ]);
        return sections;
    };

});
parcelRegister("kyrHl", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});


parcelRegister("iJJRH", function(module, exports) {
$parcel$export(module.exports, "invalidProvider", () => (parcelRequire("kCtuP")).invalidProvider);
parcelRequire("06Gcz");
parcelRequire("kCtuP");

});
parcelRegister("06Gcz", function(module, exports) {
const $00052ea55f86919c$export$8b6362171c4dfa64 = (message)=>()=>{
        throw new Error(message);
    };

});

parcelRegister("kCtuP", function(module, exports) {

$parcel$export(module.exports, "invalidProvider", () => $f02e3c97a2fee0d8$export$d59dd53963f8f3d5);
const $f02e3c97a2fee0d8$export$d59dd53963f8f3d5 = (message)=>()=>Promise.reject(message);

});


parcelRegister("8Z0V4", function(module, exports) {
$parcel$export(module.exports, "calculateBodyLength", () => (parcelRequire("f9NMI")).calculateBodyLength);
parcelRequire("f9NMI");

});
parcelRegister("f9NMI", function(module, exports) {

$parcel$export(module.exports, "calculateBodyLength", () => $b08e507d63327dfa$export$967f3527bf233bc0);
const $b08e507d63327dfa$var$TEXT_ENCODER = typeof TextEncoder == "function" ? new TextEncoder() : null;
const $b08e507d63327dfa$export$967f3527bf233bc0 = (body)=>{
    if (typeof body === "string") {
        if ($b08e507d63327dfa$var$TEXT_ENCODER) return $b08e507d63327dfa$var$TEXT_ENCODER.encode(body).byteLength;
        let len = body.length;
        for(let i = len - 1; i >= 0; i--){
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error(`Body Length computation failed for ${body}`);
};

});


parcelRegister("oudWl", function(module, exports) {

$parcel$export(module.exports, "AwsSdkSigV4Signer", () => $0499afd4aee63cb6$export$8d10c019aa195a2b);
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");

var $hB4eN = parcelRequire("hB4eN");
var $2PnYH = parcelRequire("2PnYH");
var $g4sA1 = parcelRequire("g4sA1");
const $0499afd4aee63cb6$var$throwSigningPropertyError = (name, property)=>{
    if (!property) throw new Error(`Property \`${name}\` is not resolved for AWS SDK SigV4Auth`);
    return property;
};
const $0499afd4aee63cb6$export$bca4a894ff7cfe11 = async (signingProperties)=>{
    const context = $0499afd4aee63cb6$var$throwSigningPropertyError("context", signingProperties.context);
    const config = $0499afd4aee63cb6$var$throwSigningPropertyError("config", signingProperties.config);
    const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
    const signerFunction = $0499afd4aee63cb6$var$throwSigningPropertyError("signer", config.signer);
    const signer = await signerFunction(authScheme);
    const signingRegion = signingProperties?.signingRegion;
    const signingRegionSet = signingProperties?.signingRegionSet;
    const signingName = signingProperties?.signingName;
    return {
        config: config,
        signer: signer,
        signingRegion: signingRegion,
        signingRegionSet: signingRegionSet,
        signingName: signingName
    };
};
class $0499afd4aee63cb6$export$8d10c019aa195a2b {
    async sign(httpRequest, identity, signingProperties) {
        if (!(0, $acFZn.HttpRequest).isInstance(httpRequest)) throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
        const validatedProps = await $0499afd4aee63cb6$export$bca4a894ff7cfe11(signingProperties);
        const { config: config, signer: signer } = validatedProps;
        let { signingRegion: signingRegion, signingName: signingName } = validatedProps;
        const handlerExecutionContext = signingProperties.context;
        if (handlerExecutionContext?.authSchemes?.length ?? false) {
            const [first, second] = handlerExecutionContext.authSchemes;
            if (first?.name === "sigv4a" && second?.name === "sigv4") {
                signingRegion = second?.signingRegion ?? signingRegion;
                signingName = second?.signingName ?? signingName;
            }
        }
        const signedRequest = await signer.sign(httpRequest, {
            signingDate: (0, $2PnYH.getSkewCorrectedDate)(config.systemClockOffset),
            signingRegion: signingRegion,
            signingService: signingName
        });
        return signedRequest;
    }
    errorHandler(signingProperties) {
        return (error)=>{
            const serverTime = error.ServerTime ?? (0, $hB4eN.getDateHeader)(error.$response);
            if (serverTime) {
                const config = $0499afd4aee63cb6$var$throwSigningPropertyError("config", signingProperties.config);
                const initialSystemClockOffset = config.systemClockOffset;
                config.systemClockOffset = (0, $g4sA1.getUpdatedSystemClockOffset)(serverTime, config.systemClockOffset);
                const clockSkewCorrected = config.systemClockOffset !== initialSystemClockOffset;
                if (clockSkewCorrected && error.$metadata) error.$metadata.clockSkewCorrected = true;
            }
            throw error;
        };
    }
    successHandler(httpResponse, signingProperties) {
        const dateHeader = (0, $hB4eN.getDateHeader)(httpResponse);
        if (dateHeader) {
            const config = $0499afd4aee63cb6$var$throwSigningPropertyError("config", signingProperties.config);
            config.systemClockOffset = (0, $g4sA1.getUpdatedSystemClockOffset)(dateHeader, config.systemClockOffset);
        }
    }
}
const $0499afd4aee63cb6$export$9e647fbacb03e1b7 = $0499afd4aee63cb6$export$8d10c019aa195a2b;

});
parcelRegister("hB4eN", function(module, exports) {

$parcel$export(module.exports, "getDateHeader", () => $ccf92ddfab059a72$export$6a001c300b5a041e);
parcelRequire("lJ13n");
var $3OhLM = parcelRequire("3OhLM");
const $ccf92ddfab059a72$export$6a001c300b5a041e = (response)=>(0, $3OhLM.HttpResponse).isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;

});

parcelRegister("2PnYH", function(module, exports) {

$parcel$export(module.exports, "getSkewCorrectedDate", () => $20f2f1be28f498cd$export$86d5c90340985ada);
const $20f2f1be28f498cd$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);

});

parcelRegister("g4sA1", function(module, exports) {

$parcel$export(module.exports, "getUpdatedSystemClockOffset", () => $bb3330749e6081fd$export$1ed4d48b860b1348);

var $7bShw = parcelRequire("7bShw");
const $bb3330749e6081fd$export$1ed4d48b860b1348 = (clockTime, currentSystemClockOffset)=>{
    const clockTimeInMs = Date.parse(clockTime);
    if ((0, $7bShw.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

});
parcelRegister("7bShw", function(module, exports) {

$parcel$export(module.exports, "isClockSkewed", () => $53c3aab0cbd4deff$export$c162a01d4a03ea6f);

var $2PnYH = parcelRequire("2PnYH");
const $53c3aab0cbd4deff$export$c162a01d4a03ea6f = (clockTime, systemClockOffset)=>Math.abs((0, $2PnYH.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;

});



parcelRegister("jbXkG", function(module, exports) {
$parcel$export(module.exports, "resolveDefaultsModeConfig", () => (parcelRequire("gvFyj")).resolveDefaultsModeConfig);
parcelRequire("gvFyj");

});
parcelRegister("gvFyj", function(module, exports) {

$parcel$export(module.exports, "resolveDefaultsModeConfig", () => $c04fc604b66e97d3$export$b146d618450007ac);
parcelRequire("bLD0r");
var $6LSA9 = parcelRequire("6LSA9");

var $kyrHl = parcelRequire("kyrHl");

var $jcPDE = parcelRequire("jcPDE");
const $c04fc604b66e97d3$export$b146d618450007ac = ({ defaultsMode: defaultsMode } = {})=>(0, $6LSA9.memoize)(async ()=>{
        const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
        switch(mode?.toLowerCase()){
            case "auto":
                return Promise.resolve($c04fc604b66e97d3$var$isMobileBrowser() ? "mobile" : "standard");
            case "mobile":
            case "in-region":
            case "cross-region":
            case "standard":
            case "legacy":
                return Promise.resolve(mode?.toLocaleLowerCase());
            case undefined:
                return Promise.resolve("legacy");
            default:
                throw new Error(`Invalid parameter for "defaultsMode", expect ${(0, $jcPDE.DEFAULTS_MODE_OPTIONS).join(", ")}, got ${mode}`);
        }
    });
const $c04fc604b66e97d3$var$isMobileBrowser = ()=>{
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($kyrHl))).parse(window.navigator.userAgent) : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};

});
parcelRegister("bLD0r", function(module, exports) {
$parcel$export(module.exports, "CredentialsProviderError", () => (parcelRequire("2ZVkn")).CredentialsProviderError);
$parcel$export(module.exports, "memoize", () => (parcelRequire("6LSA9")).memoize);
parcelRequire("2ZVkn");
parcelRequire("8PKHp");
parcelRequire("5CYge");
parcelRequire("iTPQJ");
parcelRequire("37xJs");
parcelRequire("6LSA9");

});
parcelRegister("2ZVkn", function(module, exports) {

$parcel$export(module.exports, "CredentialsProviderError", () => $22edbf5d928b139b$export$921076535eff0df5);

var $8PKHp = parcelRequire("8PKHp");
class $22edbf5d928b139b$export$921076535eff0df5 extends (0, $8PKHp.ProviderError) {
    constructor(message, options = true){
        super(message, options);
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, $22edbf5d928b139b$export$921076535eff0df5.prototype);
    }
}

});
parcelRegister("8PKHp", function(module, exports) {

$parcel$export(module.exports, "ProviderError", () => $66e74fa52ad76d5e$export$478ec1fdae99aa79);
class $66e74fa52ad76d5e$export$478ec1fdae99aa79 extends Error {
    constructor(message, options = true){
        let logger;
        let tryNextLink = true;
        if (typeof options === "boolean") {
            logger = undefined;
            tryNextLink = options;
        } else if (options != null && typeof options === "object") {
            logger = options.logger;
            tryNextLink = options.tryNextLink ?? true;
        }
        super(message);
        this.name = "ProviderError";
        this.tryNextLink = tryNextLink;
        Object.setPrototypeOf(this, $66e74fa52ad76d5e$export$478ec1fdae99aa79.prototype);
        logger?.debug?.(`@smithy/property-provider ${tryNextLink ? "->" : "(!)"} ${message}`);
    }
    static from(error, options = true) {
        return Object.assign(new this(error.message, options), error);
    }
}

});


parcelRegister("5CYge", function(module, exports) {

var $8PKHp = parcelRequire("8PKHp");
class $418f3eea319677b1$export$5c605c2f83e2f56b extends (0, $8PKHp.ProviderError) {
    constructor(message, options = true){
        super(message, options);
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, $418f3eea319677b1$export$5c605c2f83e2f56b.prototype);
    }
}

});

parcelRegister("iTPQJ", function(module, exports) {

var $8PKHp = parcelRequire("8PKHp");
const $dc259544a3c72aeb$export$e08e3b67e392101e = (...providers)=>async ()=>{
        if (providers.length === 0) throw new (0, $8PKHp.ProviderError)("No providers in chain");
        let lastProviderError;
        for (const provider of providers)try {
            const credentials = await provider();
            return credentials;
        } catch (err) {
            lastProviderError = err;
            if (err?.tryNextLink) continue;
            throw err;
        }
        throw lastProviderError;
    };

});

parcelRegister("37xJs", function(module, exports) {
const $245c310c414c4e05$export$294ab423a8f4a426 = (staticValue)=>()=>Promise.resolve(staticValue);

});

parcelRegister("6LSA9", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $4ee178ba25e8e3b7$export$fc10aeed3a532e2a);
const $4ee178ba25e8e3b7$export$fc10aeed3a532e2a = (provider, isExpired, requiresRefresh)=>{
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async ()=>{
        if (!pending) pending = provider();
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        if (isConstant) return resolved;
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};

});


parcelRegister("jcPDE", function(module, exports) {

$parcel$export(module.exports, "DEFAULTS_MODE_OPTIONS", () => $dfb731a3601e9996$export$32aeb2667d16f7c1);
const $dfb731a3601e9996$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];

});



parcelRegister("eO45o", function(module, exports) {
$parcel$export(module.exports, "getAwsRegionExtensionConfiguration", () => (parcelRequire("4d9wo")).getAwsRegionExtensionConfiguration);
$parcel$export(module.exports, "resolveAwsRegionExtensionConfiguration", () => (parcelRequire("4d9wo")).resolveAwsRegionExtensionConfiguration);
parcelRequire("4d9wo");
parcelRequire("4ZBdy");

});
parcelRegister("4d9wo", function(module, exports) {

$parcel$export(module.exports, "getAwsRegionExtensionConfiguration", () => $310fc3138f163f6f$export$be3086d183cd8ea6);
$parcel$export(module.exports, "resolveAwsRegionExtensionConfiguration", () => $310fc3138f163f6f$export$74973a8fb8dfc16e);
const $310fc3138f163f6f$export$be3086d183cd8ea6 = (runtimeConfig)=>{
    let runtimeConfigRegion = async ()=>{
        if (runtimeConfig.region === undefined) throw new Error("Region is missing from runtimeConfig");
        const region = runtimeConfig.region;
        if (typeof region === "string") return region;
        return region();
    };
    return {
        setRegion (region) {
            runtimeConfigRegion = region;
        },
        region () {
            return runtimeConfigRegion;
        }
    };
};
const $310fc3138f163f6f$export$74973a8fb8dfc16e = (awsRegionExtensionConfiguration)=>{
    return {
        region: awsRegionExtensionConfiguration.region()
    };
};

});

parcelRegister("4ZBdy", function(module, exports) {
parcelRequire("iSWuh");
parcelRequire("015K2");

});
parcelRegister("iSWuh", function(module, exports) {
const $dbfaa38a19bb1bcd$export$26513716e2900bad = "AWS_REGION";
const $dbfaa38a19bb1bcd$export$8afb1c306a7d01b = "region";
const $dbfaa38a19bb1bcd$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$dbfaa38a19bb1bcd$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$dbfaa38a19bb1bcd$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $dbfaa38a19bb1bcd$export$9a37503ca194454d = {
    preferredFile: "credentials"
};

});

parcelRegister("015K2", function(module, exports) {

var $lsIjy = parcelRequire("lsIjy");

var $hJgXx = parcelRequire("hJgXx");
const $00348c3fd8d1100d$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $lsIjy.getRealRegion)(region);
            const providedRegion = await region();
            return (0, $lsIjy.getRealRegion)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $hJgXx.isFipsRegion)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};

});
parcelRegister("lsIjy", function(module, exports) {

$parcel$export(module.exports, "getRealRegion", () => $f9fe9666560e8f1c$export$ecbdf004a8547a7f);

var $hJgXx = parcelRequire("hJgXx");
const $f9fe9666560e8f1c$export$ecbdf004a8547a7f = (region)=>(0, $hJgXx.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;

});
parcelRegister("hJgXx", function(module, exports) {

$parcel$export(module.exports, "isFipsRegion", () => $ce83cb6576819b22$export$cc893cb7e6a508dd);
const $ce83cb6576819b22$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

});





parcelRegister("et8BI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fBFJs").then(()=>parcelRequire("ewWxt"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("68yrK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hFbah").then(()=>parcelRequire("9Usxh"));

});

parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $esaJO.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $esaJO = parcelRequire("esaJO");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = BigInt(2), $1ea6901afdde618b$var$_3n = BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = BigInt(4), $1ea6901afdde618b$var$_5n = BigInt(5), $1ea6901afdde618b$var$_8n = BigInt(8);
// prettier-ignore
const $1ea6901afdde618b$var$_9n = BigInt(9), $1ea6901afdde618b$var$_16n = BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
module.exports.mod = $1ea6901afdde618b$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $1ea6901afdde618b$var$pow(num, power, modulo) {
    if (modulo <= $1ea6901afdde618b$var$_0n || power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $1ea6901afdde618b$var$_1n) return $1ea6901afdde618b$var$_0n;
    let res = $1ea6901afdde618b$var$_1n;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return res;
}
module.exports.pow = $1ea6901afdde618b$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
// Inverses number over modulo
function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n || modulo <= $1ea6901afdde618b$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error("invert: does not exist");
    return $1ea6901afdde618b$var$mod(x, modulo);
}
module.exports.invert = $1ea6901afdde618b$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1ea6901afdde618b$var$_1n, S = 0; Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n; Q /= $1ea6901afdde618b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1ea6901afdde618b$var$_2n; Z < P && $1ea6901afdde618b$var$pow(Z, legendreC, P) !== P - $1ea6901afdde618b$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1ea6901afdde618b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
function $1ea6901afdde618b$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) {
        const c1 = (P - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1ea6901afdde618b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $esaJO.validateObject)(field, opts);
}
module.exports.validateField = $1ea6901afdde618b$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power > 0");
    if (power === $1ea6901afdde618b$var$_0n) return f.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $1ea6901afdde618b$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
function $1ea6901afdde618b$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1ea6901afdde618b$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $1ea6901afdde618b$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $esaJO.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $esaJO.numberToBytesLE)(num, BYTES) : (0, $esaJO.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $esaJO.bytesToNumberLE)(bytes) : (0, $esaJO.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $1ea6901afdde618b$var$Field;
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $esaJO.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(hash) : (0, $esaJO.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $esaJO.bytesToNumberBE)(key) : (0, $esaJO.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $esaJO.numberToBytesLE)(reduced, fieldLen) : (0, $esaJO.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

});
parcelRegister("esaJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a85c028f110aa8ce$var$_0n = BigInt(0);
const $a85c028f110aa8ce$var$_1n = BigInt(1);
const $a85c028f110aa8ce$var$_2n = BigInt(2);
const $a85c028f110aa8ce$var$u8a = (a)=>a instanceof Uint8Array;
const $a85c028f110aa8ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a85c028f110aa8ce$var$bytesToHex(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a85c028f110aa8ce$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a85c028f110aa8ce$var$bytesToHex;
function $a85c028f110aa8ce$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $a85c028f110aa8ce$var$numberToHexUnpadded;
function $a85c028f110aa8ce$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $a85c028f110aa8ce$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a85c028f110aa8ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a85c028f110aa8ce$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $a85c028f110aa8ce$var$bytesToNumberBE(bytes) {
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $a85c028f110aa8ce$var$bytesToNumberBE;
function $a85c028f110aa8ce$var$bytesToNumberLE(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $a85c028f110aa8ce$var$bytesToNumberLE;
function $a85c028f110aa8ce$var$numberToBytesBE(n, len) {
    return $a85c028f110aa8ce$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $a85c028f110aa8ce$var$numberToBytesBE;
function $a85c028f110aa8ce$var$numberToBytesLE(n, len) {
    return $a85c028f110aa8ce$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $a85c028f110aa8ce$var$numberToBytesLE;
// Unpadded, rarely used
function $a85c028f110aa8ce$var$numberToVarBytesBE(n) {
    return $a85c028f110aa8ce$var$hexToBytes($a85c028f110aa8ce$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $a85c028f110aa8ce$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a85c028f110aa8ce$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a85c028f110aa8ce$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a85c028f110aa8ce$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $a85c028f110aa8ce$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a85c028f110aa8ce$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a85c028f110aa8ce$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a85c028f110aa8ce$var$concatBytes;
function $a85c028f110aa8ce$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $a85c028f110aa8ce$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a85c028f110aa8ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a85c028f110aa8ce$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a85c028f110aa8ce$var$bitLen(n) {
    let len;
    for(len = 0; n > $a85c028f110aa8ce$var$_0n; n >>= $a85c028f110aa8ce$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $a85c028f110aa8ce$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a85c028f110aa8ce$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a85c028f110aa8ce$var$_1n;
}
module.exports.bitGet = $a85c028f110aa8ce$var$bitGet;
/**
 * Sets single bit at position.
 */ const $a85c028f110aa8ce$var$bitSet = (n, pos, value)=>{
    return n | (value ? $a85c028f110aa8ce$var$_1n : $a85c028f110aa8ce$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $a85c028f110aa8ce$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a85c028f110aa8ce$var$bitMask = (n)=>($a85c028f110aa8ce$var$_2n << BigInt(n - 1)) - $a85c028f110aa8ce$var$_1n;
module.exports.bitMask = $a85c028f110aa8ce$var$bitMask;
// DRBG
const $a85c028f110aa8ce$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a85c028f110aa8ce$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a85c028f110aa8ce$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a85c028f110aa8ce$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a85c028f110aa8ce$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a85c028f110aa8ce$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a85c028f110aa8ce$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a85c028f110aa8ce$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a85c028f110aa8ce$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $a85c028f110aa8ce$var$createHmacDrbg;
// Validating curves and fields
const $a85c028f110aa8ce$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a85c028f110aa8ce$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a85c028f110aa8ce$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $a85c028f110aa8ce$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("6FEsA", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $4db5f4f17c3a16b3$export$2e2bcd8739ae039);

var $kDiOX = parcelRequire("kDiOX");

var $hga9n = parcelRequire("hga9n");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $kDiOX.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $kDiOX.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4db5f4f17c3a16b3$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $hga9n.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("kDiOX", function(module, exports) {

$parcel$export(module.exports, "cos", () => $f0560c970166d25b$export$50d414a77b60d802);
$parcel$export(module.exports, "min", () => $f0560c970166d25b$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $f0560c970166d25b$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $f0560c970166d25b$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $f0560c970166d25b$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $f0560c970166d25b$export$18c7bea995a110f);
$parcel$export(module.exports, "tau", () => $f0560c970166d25b$export$a4b4b4d4d776fe92);
const $f0560c970166d25b$export$2335f513bbd82c6d = Math.abs;
const $f0560c970166d25b$export$b8b770ee6a0d9760 = Math.atan2;
const $f0560c970166d25b$export$50d414a77b60d802 = Math.cos;
const $f0560c970166d25b$export$8960430cfd85939f = Math.max;
const $f0560c970166d25b$export$96ec731ed4dcb222 = Math.min;
const $f0560c970166d25b$export$5de3937cb4b592ed = Math.sin;
const $f0560c970166d25b$export$eba8049fb5020b81 = Math.sqrt;
const $f0560c970166d25b$export$6c421550c66a327d = 1e-12;
const $f0560c970166d25b$export$18c7bea995a110f = Math.PI;
const $f0560c970166d25b$export$e51408a300e8929a = $f0560c970166d25b$export$18c7bea995a110f / 2;
const $f0560c970166d25b$export$a4b4b4d4d776fe92 = 2 * $f0560c970166d25b$export$18c7bea995a110f;
function $f0560c970166d25b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f0560c970166d25b$export$18c7bea995a110f : Math.acos(x);
}
function $f0560c970166d25b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $f0560c970166d25b$export$e51408a300e8929a : x <= -1 ? -$f0560c970166d25b$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("hga9n", function(module, exports) {

$parcel$export(module.exports, "point", () => $c90bcdedc71457ea$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $c90bcdedc71457ea$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $c90bcdedc71457ea$export$2e2bcd8739ae039);
function $c90bcdedc71457ea$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c90bcdedc71457ea$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c90bcdedc71457ea$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.19.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$480182c6abbb2ff6(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $1d34d5c4a288b213$var$ResultType.redirect,
                        response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isHandlerResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $1d34d5c4a288b213$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $1d34d5c4a288b213$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                });
            };
            return $1d34d5c4a288b213$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$1d34d5c4a288b213$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type } = handlerResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $1d34d5c4a288b213$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectHandlerResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $55a4002fe538d791$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = $acw62.createContext(void 0);
    Context.displayName = name;
    function useContext2() {
        var _a;
        const context = $acw62.useContext(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext2);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext2,
        Context
    ];
}


"use client";
var [$d32167910469b3b9$export$b1da5abff9d0406, $d32167910469b3b9$export$f3632c8327428963] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "ProviderContext",
    strict: false
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $3549bf99e2e8db25$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $3549bf99e2e8db25$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $3549bf99e2e8db25$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $3549bf99e2e8db25$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $3549bf99e2e8db25$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $052aeba394c31735$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$052aeba394c31735$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, $3549bf99e2e8db25$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
    };
}
let $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$currentLocale = $052aeba394c31735$export$f09106e7c6677ec5();
let $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$currentLocale = $052aeba394c31735$export$f09106e7c6677ec5();
    for (let listener of $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$listeners)listener($052aeba394c31735$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $052aeba394c31735$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $8afd3bdc2bd65163$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $acw62.useState)($052aeba394c31735$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $acw62.useEffect)(()=>{
        if ($052aeba394c31735$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($052aeba394c31735$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $052aeba394c31735$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b8a0d3089da586dd$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $b8a0d3089da586dd$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $052aeba394c31735$export$188ec29ebc2bdc3a)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $3549bf99e2e8db25$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b8a0d3089da586dd$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $b8a0d3089da586dd$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $052aeba394c31735$export$188ec29ebc2bdc3a)();
    let context = (0, $acw62.useContext)($b8a0d3089da586dd$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a3b111119000092b$export$de79e2c695e052f3(element) {
    if ($a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $a3b111119000092b$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $a3b111119000092b$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $a3b111119000092b$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $a3b111119000092b$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $b82880ba168cba95$export$9ac100e40613ea10() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $b82880ba168cba95$export$186c6964ca17d99() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $b82880ba168cba95$export$7bef049ce92e4224() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b82880ba168cba95$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $b82880ba168cba95$export$fedb369cb70207f1() {
    return $b82880ba168cba95$export$186c6964ca17d99() || $b82880ba168cba95$export$7bef049ce92e4224();
}
function $b82880ba168cba95$export$e1865c3bedcd822b() {
    return $b82880ba168cba95$export$9ac100e40613ea10() || $b82880ba168cba95$export$fedb369cb70207f1();
}
function $b82880ba168cba95$export$78551043582a6a98() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$b82880ba168cba95$export$6446a186d09e379e();
}
function $b82880ba168cba95$export$6446a186d09e379e() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $b82880ba168cba95$export$a11b0059900ceec8() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $b82880ba168cba95$export$b7d78993b74f766d() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $acw62.createContext)({
    isNative: true,
    open: $4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $4a4107ecda93bad9$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $acw62.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($4a4107ecda93bad9$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $4a4107ecda93bad9$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $4a4107ecda93bad9$export$9a302a45f65d0572() {
    return (0, $acw62.useContext)($4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $4a4107ecda93bad9$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $4a4107ecda93bad9$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $b82880ba168cba95$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ((0, $b82880ba168cba95$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $b82880ba168cba95$export$78551043582a6a98)() && (0, $b82880ba168cba95$export$9ac100e40613ea10)() && !(0, $b82880ba168cba95$export$7bef049ce92e4224)() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $4a4107ecda93bad9$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $a3b111119000092b$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $4a4107ecda93bad9$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$4a4107ecda93bad9$export$95185d699e05d4d7.isOpening = false;
function $4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $4a4107ecda93bad9$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$4a4107ecda93bad9$export$95185d699e05d4d7(link, modifiers));
}
function $4a4107ecda93bad9$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $4a4107ecda93bad9$export$7e924b3091a3bd18(props) {
    let router = $4a4107ecda93bad9$export$9a302a45f65d0572();
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? router.useHref(props === null || props === void 0 ? void 0 : props.href) : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}



var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $91db6fac2d761e73$var$$f57aed4a881a3485$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $91db6fac2d761e73$export$178405afcd8c5eb(props) {
    let { children: children } = props;
    let parent = (0, $acw62.useContext)($91db6fac2d761e73$var$$f57aed4a881a3485$var$Context);
    let [modalCount, setModalCount] = (0, $acw62.useState)(0);
    let context = (0, $acw62.useMemo)(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91db6fac2d761e73$var$$f57aed4a881a3485$var$Context.Provider, {
        value: context
    }, children);
}
function $91db6fac2d761e73$export$d9aaed4c3ece1bc0() {
    let context = (0, $acw62.useContext)($91db6fac2d761e73$var$$f57aed4a881a3485$var$Context);
    return {
        modalProviderProps: {
            "aria-hidden": context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $91db6fac2d761e73$var$$f57aed4a881a3485$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps } = $91db6fac2d761e73$export$d9aaed4c3ece1bc0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function $91db6fac2d761e73$export$bf688221f59024e5(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91db6fac2d761e73$export$178405afcd8c5eb, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91db6fac2d761e73$var$$f57aed4a881a3485$var$OverlayContainerDOM, props));
}
function $91db6fac2d761e73$export$b47c3594eab58386(props) {
    let isSSR = (0, $8afd3bdc2bd65163$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, ...rest } = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($91db6fac2d761e73$export$bf688221f59024e5, rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(contents, portalContainer);
}
function $91db6fac2d761e73$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, $acw62.useContext)($91db6fac2d761e73$var$$f57aed4a881a3485$var$Context);
    if (!context) throw new Error("Modal is not contained within a provider");
    (0, $acw62.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            "data-ismodal": !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}



var $acw62 = parcelRequire("acw62");
const $f69e8e67d72e77c2$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};



"use client";
var $fdbc87c1e713f7c4$export$a3257b987c70dc9c = ({ children: children, navigate: navigate, disableAnimation: disableAnimation = false, disableRipple: disableRipple = false, skipFramerMotionAnimations: skipFramerMotionAnimations = disableAnimation, validationBehavior: validationBehavior = "aria", locale: locale = "en-US", defaultDates: defaultDates, createCalendar: createCalendar, ...otherProps })=>{
    let contents = children;
    if (navigate) contents = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4a4107ecda93bad9$export$323e4fc2fa4753fb), {
        navigate: navigate,
        children: contents
    });
    const context = (0, $acw62.useMemo)(()=>{
        if (disableAnimation && skipFramerMotionAnimations) (0, $f69e8e67d72e77c2$export$dd826089e3c5e502).skipAnimations = true;
        return {
            createCalendar: createCalendar,
            defaultDates: defaultDates,
            disableAnimation: disableAnimation,
            disableRipple: disableRipple,
            validationBehavior: validationBehavior
        };
    }, [
        createCalendar,
        defaultDates == null ? void 0 : defaultDates.maxDate,
        defaultDates == null ? void 0 : defaultDates.minDate,
        disableAnimation,
        disableRipple,
        validationBehavior
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d32167910469b3b9$export$b1da5abff9d0406), {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b8a0d3089da586dd$export$a54013f0d02a8f82), {
            locale: locale,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $91db6fac2d761e73$export$bf688221f59024e5), {
                ...otherProps,
                children: contents
            })
        })
    });
};


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $abe5418a531ee1d6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $25165aaf01761cfd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $25165aaf01761cfd$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $25165aaf01761cfd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $25165aaf01761cfd$var$isGlobalObj(window) || typeof self == "object" && $25165aaf01761cfd$var$isGlobalObj(self) || typeof $parcel$global == "object" && $25165aaf01761cfd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $25165aaf01761cfd$export$256479dc0cea61c4() {
    return $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $25165aaf01761cfd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $25165aaf01761cfd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $3199231328e69de5$var$PREFIX = "Sentry Logger ";
const $3199231328e69de5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $3199231328e69de5$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3199231328e69de5$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3199231328e69de5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $abe5418a531ee1d6$export$16a28057038b10ef) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6593ea065203555e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $91c304fc757d5e0f$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $91c304fc757d5e0f$export$7740643b9eeaf0c4() {
    return Date.now() / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $91c304fc757d5e0f$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $91c304fc757d5e0f$export$ee52dced521e3e18 = $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $91c304fc757d5e0f$export$c5907b5a8838db13 = $91c304fc757d5e0f$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $91c304fc757d5e0f$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $91c304fc757d5e0f$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $91c304fc757d5e0f$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $91c304fc757d5e0f$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$var$isBuiltin(wat, className) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || $1e0be767ffa822d8$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $d3dd25a69ce66c78$var$WINDOW = (0, $25165aaf01761cfd$export$256479dc0cea61c4)();
const $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($d3dd25a69ce66c78$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    try {
        return $d3dd25a69ce66c78$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3dd25a69ce66c78$export$c660c1f3ab49225c(selector) {
    if ($d3dd25a69ce66c78$var$WINDOW.document && $d3dd25a69ce66c78$var$WINDOW.document.querySelector) return $d3dd25a69ce66c78$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d3dd25a69ce66c78$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d3dd25a69ce66c78$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $1e0be767ffa822d8$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $1e0be767ffa822d8$export$844ec244b1367d54)(value)) return false;
    if ((0, $1e0be767ffa822d8$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $1e0be767ffa822d8$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $692fb1c9fae23fc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$692fb1c9fae23fc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $e628e125e878fd27$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $1e0be767ffa822d8$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $1e0be767ffa822d8$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $1e0be767ffa822d8$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $1e0be767ffa822d8$export$45a5e7f76e0caa8d)(target) ? (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($e628e125e878fd27$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $e628e125e878fd27$var$isPojo(input) {
    if (!(0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    const gbl = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    const match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $692fb1c9fae23fc3$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $692fb1c9fae23fc3$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $692fb1c9fae23fc3$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $806ed7b2edb8ea09$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $ebf395d8a45b5e48$export$849dbeeeda01ae98 = "production";





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $dde6191ffa17294f$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$3c4238858b85e8ac() {
    return (0, $25165aaf01761cfd$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $503ba8c00efa1d46$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $6593ea065203555e$export$16a28057038b10ef) && processor.id && result === null && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(result)) result.then((final)=>$503ba8c00efa1d46$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $049d01d3a3164ac2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$049d01d3a3164ac2$var$sessionToJSON(session)
    };
    if (context) $049d01d3a3164ac2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $049d01d3a3164ac2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $049d01d3a3164ac2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $049d01d3a3164ac2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $049d01d3a3164ac2$var$sessionToJSON(session) {
    return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2a06788518a26cc6$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $93473cbc517fed7c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $0cd1337813906a62$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($0cd1337813906a62$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $0cd1337813906a62$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $93473cbc517fed7c$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9ca32e18a091d955$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9ca32e18a091d955$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $9ca32e18a091d955$export$a3295358bff77e(object, depth);
    if ($9ca32e18a091d955$var$jsonSize(normalized) > maxSize) return $9ca32e18a091d955$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9ca32e18a091d955$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $2a06788518a26cc6$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $1e0be767ffa822d8$export$c9f5652083b8129d)(value)) return value;
    const stringified = $9ca32e18a091d955$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9ca32e18a091d955$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $e628e125e878fd27$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9ca32e18a091d955$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9ca32e18a091d955$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $1e0be767ffa822d8$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $1e0be767ffa822d8$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $0cd1337813906a62$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $9ca32e18a091d955$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $9ca32e18a091d955$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $9ca32e18a091d955$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$var$jsonSize(value) {
    return $9ca32e18a091d955$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $9ca32e18a091d955$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}









const $9e1a8f302f19c673$export$9ca9946bd449ac06 = "baggage";
const $9e1a8f302f19c673$export$6e69537d67fa20f = "sentry-";
const $9e1a8f302f19c673$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $9e1a8f302f19c673$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $9e1a8f302f19c673$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $1e0be767ffa822d8$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($9e1a8f302f19c673$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($9e1a8f302f19c673$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $9e1a8f302f19c673$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9e1a8f302f19c673$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9e1a8f302f19c673$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $9e1a8f302f19c673$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9e1a8f302f19c673$export$bdd844ddb2def819) {
            (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $46f5220cb64aa700$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $46f5220cb64aa700$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($46f5220cb64aa700$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $46f5220cb64aa700$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9e1a8f302f19c673$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
            spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
            spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $46f5220cb64aa700$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9e1a8f302f19c673$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
        spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $46f5220cb64aa700$export$f35d907436da45cf(traceId = (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(), spanId = (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $e047a3e652f57c75$export$208d5b368507fb8b = 0x0;
const $e047a3e652f57c75$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $e047a3e652f57c75$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $e047a3e652f57c75$export$92d8c23565496537(span);
    return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e047a3e652f57c75$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e047a3e652f57c75$export$5caecac1caaf3a71(span);
    return (0, $46f5220cb64aa700$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $e047a3e652f57c75$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $e047a3e652f57c75$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e047a3e652f57c75$var$ensureTimestampInSeconds(input.getTime());
    return (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e047a3e652f57c75$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $e047a3e652f57c75$export$92d8c23565496537(span) {
    if ($e047a3e652f57c75$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e047a3e652f57c75$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e047a3e652f57c75$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $e047a3e652f57c75$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $7b0dad5cf366cc16$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $7b0dad5cf366cc16$var$applyClientOptions(prepared, options);
    $7b0dad5cf366cc16$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $7b0dad5cf366cc16$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $7b0dad5cf366cc16$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $90705fab783f17f9$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $613716288721a3ee$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $613716288721a3ee$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $613716288721a3ee$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $503ba8c00efa1d46$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $503ba8c00efa1d46$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $7b0dad5cf366cc16$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $7b0dad5cf366cc16$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $7b0dad5cf366cc16$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $7b0dad5cf366cc16$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $7b0dad5cf366cc16$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $7b0dad5cf366cc16$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $7b0dad5cf366cc16$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $7b0dad5cf366cc16$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $7b0dad5cf366cc16$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $7b0dad5cf366cc16$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $9ca32e18a091d955$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $9ca32e18a091d955$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $e047a3e652f57c75$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $9ca32e18a091d955$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $7b0dad5cf366cc16$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $90705fab783f17f9$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $7b0dad5cf366cc16$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($7b0dad5cf366cc16$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $90705fab783f17f9$export$775b6bb06e53a214) || typeof hint === "function";
}
const $7b0dad5cf366cc16$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $7b0dad5cf366cc16$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$7b0dad5cf366cc16$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $81a395368bb6f380$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().captureException(exception, (0, $7b0dad5cf366cc16$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $81a395368bb6f380$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $81a395368bb6f380$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $81a395368bb6f380$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9007972943bbf579$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $81a395368bb6f380$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $81a395368bb6f380$export$9a4fed82c350c2bd(callback) {
    return (0, $9007972943bbf579$export$70d775fb1f267027)(()=>{
        return callback((0, $9007972943bbf579$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $81a395368bb6f380$export$e57ac09b143d92a2(span, callback) {
    return $81a395368bb6f380$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $81a395368bb6f380$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (!client) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $81a395368bb6f380$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $81a395368bb6f380$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $91c304fc757d5e0f$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$4909b86c8034bf73(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$8360e631d277ea4d(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $81a395368bb6f380$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $81a395368bb6f380$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $81a395368bb6f380$export$3f95c6f800b78024() {
    return !!$81a395368bb6f380$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $81a395368bb6f380$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9007972943bbf579$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $81a395368bb6f380$export$c0d84948cecf78d8(context) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $049d01d3a3164ac2$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $049d01d3a3164ac2$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $81a395368bb6f380$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $81a395368bb6f380$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $049d01d3a3164ac2$export$56521d9ba90f62ee)(session);
    $81a395368bb6f380$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $81a395368bb6f380$var$_sendSessionUpdate() {
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $81a395368bb6f380$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $81a395368bb6f380$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $81a395368bb6f380$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $bc446a546b963a28$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $89d6805454b84092$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $e628e125e878fd27$export$d25f2688db1bb433)({
        environment: options.environment || (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $89d6805454b84092$export$a117f995597e25df(span) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $89d6805454b84092$export$366bad00d6815eed((0, $e047a3e652f57c75$export$92d8c23565496537)(span).trace_id || "", client, (0, $81a395368bb6f380$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $bc446a546b963a28$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $e047a3e652f57c75$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $e047a3e652f57c75$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $613716288721a3ee$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $613716288721a3ee$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $613716288721a3ee$var$applySpanToEvent(event, span);
    $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint);
    $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $613716288721a3ee$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $613716288721a3ee$export$b1a120a2871faa46(data, "extra", extra);
    $613716288721a3ee$export$b1a120a2871faa46(data, "tags", tags);
    $613716288721a3ee$export$b1a120a2871faa46(data, "user", user);
    $613716288721a3ee$export$b1a120a2871faa46(data, "contexts", contexts);
    $613716288721a3ee$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $613716288721a3ee$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $613716288721a3ee$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $e628e125e878fd27$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $e628e125e878fd27$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $e628e125e878fd27$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $e628e125e878fd27$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $613716288721a3ee$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $e047a3e652f57c75$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $bc446a546b963a28$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $89d6805454b84092$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $e047a3e652f57c75$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $806ed7b2edb8ea09$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $90705fab783f17f9$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90705fab783f17f9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $90705fab783f17f9$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $90705fab783f17f9$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $049d01d3a3164ac2$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $90705fab783f17f9$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $613716288721a3ee$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $503ba8c00efa1d46$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $503ba8c00efa1d46$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $90705fab783f17f9$export$aa55d5ab8e05984f() {
    if (!$90705fab783f17f9$var$globalScope) $90705fab783f17f9$var$globalScope = new $90705fab783f17f9$export$775b6bb06e53a214();
    return $90705fab783f17f9$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $90705fab783f17f9$export$c83048efd17527d6(scope) {
    $90705fab783f17f9$var$globalScope = scope;
}
function $90705fab783f17f9$var$generatePropagationContext() {
    return {
        traceId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)(),
        spanId: (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16)
    };
}



const $725570364ca356d5$export$31499a9cd224b78c = "7.119.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9007972943bbf579$export$24a86ef7798177e4 = parseFloat((0, $725570364ca356d5$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9007972943bbf579$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $9007972943bbf579$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $9007972943bbf579$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $90705fab783f17f9$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $90705fab783f17f9$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9007972943bbf579$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9007972943bbf579$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9007972943bbf579$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $6593ea065203555e$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $049d01d3a3164ac2$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $ebf395d8a45b5e48$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $049d01d3a3164ac2$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $049d01d3a3164ac2$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9007972943bbf579$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9007972943bbf579$export$19eade501500c6c1() {
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$4188a14ad302d1bc(hub) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    const oldHub = $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    $9007972943bbf579$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9007972943bbf579$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9007972943bbf579$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9007972943bbf579$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$var$getGlobalHub(registry = $9007972943bbf579$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(registry).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$849f05434e95d2f2(registry, new $9007972943bbf579$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$236689a79f5aa020(carrier, parent = $9007972943bbf579$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(carrier).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $9007972943bbf579$export$849f05434e95d2f2(carrier, new $9007972943bbf579$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9007972943bbf579$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9007972943bbf579$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9007972943bbf579$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $25165aaf01761cfd$export$7e223ec222791509)("hub", ()=>new $9007972943bbf579$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $9995ab194a6bc98e$var$handlers = {};
const $9995ab194a6bc98e$var$instrumented = {};
/** Add a handler function. */ function $9995ab194a6bc98e$export$a4e09611e30da72e(type, handler) {
    $9995ab194a6bc98e$var$handlers[type] = $9995ab194a6bc98e$var$handlers[type] || [];
    $9995ab194a6bc98e$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9995ab194a6bc98e$export$b17eab759a1cb5fe() {
    Object.keys($9995ab194a6bc98e$var$handlers).forEach((key)=>{
        $9995ab194a6bc98e$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9995ab194a6bc98e$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9995ab194a6bc98e$var$instrumented[type]) {
        instrumentFn();
        $9995ab194a6bc98e$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9995ab194a6bc98e$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9995ab194a6bc98e$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $0cd1337813906a62$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $d70977d9b36915fd$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d70977d9b36915fd$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $d70977d9b36915fd$var$instrumentError);
}
function $d70977d9b36915fd$var$instrumentError() {
    $d70977d9b36915fd$var$_oldOnErrorHandler = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onerror;
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $9995ab194a6bc98e$export$b18c893e424d3127)("error", handlerData);
        if ($d70977d9b36915fd$var$_oldOnErrorHandler && !$d70977d9b36915fd$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d70977d9b36915fd$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a4223cccebdcb864$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $a4223cccebdcb864$var$instrumentUnhandledRejection);
}
function $a4223cccebdcb864$var$instrumentUnhandledRejection() {
    $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $9995ab194a6bc98e$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler && !$a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $44ed7dd0e837ba6e$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $44ed7dd0e837ba6e$export$8e9a29865c0a1226 = (0, $46f5220cb64aa700$export$8e9a29865c0a1226);


let $3b242f8574a305e5$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $3b242f8574a305e5$export$637857c1d87b640c() {
    if ($3b242f8574a305e5$var$errorsInstrumented) return;
    $3b242f8574a305e5$var$errorsInstrumented = true;
    (0, $d70977d9b36915fd$export$55b5c3ba2194f0c6)($3b242f8574a305e5$var$errorCallback);
    (0, $a4223cccebdcb864$export$8bf4fc6858821a4e)($3b242f8574a305e5$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $3b242f8574a305e5$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$3b242f8574a305e5$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $8128e29c1611c34e$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $8128e29c1611c34e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $8128e29c1611c34e$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9d2bd9c413e91a74$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $b73c4ddb8b981968$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    const activeSpan = $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $8128e29c1611c34e$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$a1bd95187356f372(context, callback) {
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    return (0, $9007972943bbf579$export$70d775fb1f267027)(()=>{
        return (0, $81a395368bb6f380$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $8128e29c1611c34e$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $e047a3e652f57c75$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $b73c4ddb8b981968$export$cb9e396e6b90b703 = $b73c4ddb8b981968$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$c10292ad04b92aea(context, callback) {
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    return (0, $9007972943bbf579$export$70d775fb1f267027)(()=>{
        return (0, $81a395368bb6f380$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $8128e29c1611c34e$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $e047a3e652f57c75$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$63dbba021a6b4047(context) {
    if (!(0, $9d2bd9c413e91a74$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $b73c4ddb8b981968$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $b73c4ddb8b981968$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a395368bb6f380$export$c7be4b0125a10cba)().getSpan();
}
const $b73c4ddb8b981968$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $46f5220cb64aa700$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $6593ea065203555e$export$16a28057038b10ef) && traceparentData) (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $9007972943bbf579$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $b73c4ddb8b981968$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $9d2bd9c413e91a74$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $89d6805454b84092$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $e047a3e652f57c75$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $b73c4ddb8b981968$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $b73c4ddb8b981968$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $e047a3e652f57c75$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $b73c4ddb8b981968$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(span, $b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(span, $b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $b73c4ddb8b981968$export$c08fbc656a245d03(span) {
    return {
        scope: span[$b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $06f50cce9c869194$var$SPAN_METRIC_SUMMARY;
function $06f50cce9c869194$var$getMetricStorageForSpan(span) {
    return $06f50cce9c869194$var$SPAN_METRIC_SUMMARY ? $06f50cce9c869194$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $06f50cce9c869194$export$2e7205e45c58797d(span) {
    const storage = $06f50cce9c869194$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $e628e125e878fd27$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $06f50cce9c869194$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $b73c4ddb8b981968$export$1be426a8e585c83e)();
    if (span) {
        const storage = $06f50cce9c869194$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$06f50cce9c869194$var$SPAN_METRIC_SUMMARY) $06f50cce9c869194$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $06f50cce9c869194$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $033619b8172dea69$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $033619b8172dea69$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $033619b8172dea69$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $033619b8172dea69$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $033619b8172dea69$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $6d9884e3956d809f$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($6d9884e3956d809f$export$beb8e6a823e89c5d || ($6d9884e3956d809f$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $6d9884e3956d809f$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $6d9884e3956d809f$export$ac65c70d78fcdb55 = $6d9884e3956d809f$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $6d9884e3956d809f$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $6d9884e3956d809f$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $948960fec1caf8ab$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $948960fec1caf8ab$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $033619b8172dea69$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $033619b8172dea69$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $033619b8172dea69$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $033619b8172dea69$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $033619b8172dea69$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $033619b8172dea69$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $e047a3e652f57c75$export$eb571cd9b5d98de8) : (0, $e047a3e652f57c75$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $948960fec1caf8ab$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $bc446a546b963a28$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $6593ea065203555e$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $e047a3e652f57c75$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $3199231328e69de5$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $6d9884e3956d809f$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $bc446a546b963a28$export$c4c6a79b1260ca1b)(this);
        if ((0, $6593ea065203555e$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $3199231328e69de5$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $e047a3e652f57c75$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $e047a3e652f57c75$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $e047a3e652f57c75$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $033619b8172dea69$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $033619b8172dea69$export$cca8dd30f57f805e],
            _metrics_summary: (0, $06f50cce9c869194$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $033619b8172dea69$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $504c6c1458d8d0e9$export$febc5573c75cefb0 extends (0, $948960fec1caf8ab$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $033619b8172dea69$export$d7a7d984b0791405] && {
                source: this._attributes[0, $033619b8172dea69$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $033619b8172dea69$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $033619b8172dea69$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $033619b8172dea69$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $948960fec1caf8ab$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $e047a3e652f57c75$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $89d6805454b84092$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $e047a3e652f57c75$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $e047a3e652f57c75$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $b73c4ddb8b981968$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $e047a3e652f57c75$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $e628e125e878fd27$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $89d6805454b84092$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $06f50cce9c869194$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $1efef08b5fe9fa0b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $1efef08b5fe9fa0b$var$FINISH_REASON_TAG = "finishReason";
const $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $1efef08b5fe9fa0b$export$370d6113c18ba86c extends (0, $948960fec1caf8ab$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $e047a3e652f57c75$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $1efef08b5fe9fa0b$export$b279e6bd7040371f extends (0, $504c6c1458d8d0e9$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $1efef08b5fe9fa0b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $e047a3e652f57c75$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($1efef08b5fe9fa0b$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $e047a3e652f57c75$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $e047a3e652f57c75$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $6593ea065203555e$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $1efef08b5fe9fa0b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $91c304fc757d5e0f$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $f16908c3df50a491$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $9d2bd9c413e91a74$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $033619b8172dea69$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $033619b8172dea69$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $033619b8172dea69$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $033619b8172dea69$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$f16908c3df50a491$export$2603c8d332a51c42(sampleRate)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $6593ea065203555e$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $e047a3e652f57c75$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $f16908c3df50a491$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $1e0be767ffa822d8$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $bfffaa6649a6ba90$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $e047a3e652f57c75$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $bfffaa6649a6ba90$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $504c6c1458d8d0e9$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $f16908c3df50a491$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $bfffaa6649a6ba90$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $1efef08b5fe9fa0b$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $f16908c3df50a491$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $bfffaa6649a6ba90$export$653d0ef2bad9cdf9() {
    const carrier = (0, $9007972943bbf579$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $bfffaa6649a6ba90$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $bfffaa6649a6ba90$var$traceHeaders;
    (0, $3b242f8574a305e5$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a5e85a0c259bdb77$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $fe9433352f19d4b6$export$56d8a8a25bd48b81 = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $a50bc2aef3fcf638$export$6f18f55521af71a1() {
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
        if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $e047a3e652f57c75$export$92d8c23565496537)(activeTransaction);
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $13c2ca2b7f8f393a$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $5863aef6ed758511$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $0ae3ea9e7f2c4254$export$6431553786c94949 = ()=>{
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57e88e157c530457$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e8d4206fcb32f41c$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering || (0, $57e88e157c530457$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $5863aef6ed758511$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $c62bade033a6ea98$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $06ed980438256cb2$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b6c848c639162360$var$firstHiddenTime = -1;
const $b6c848c639162360$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState) $b6c848c639162360$var$firstHiddenTime = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $b6c848c639162360$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $b6c848c639162360$var$firstHiddenTime = timeStamp;
    }, true);
};
const $b6c848c639162360$export$443f86b2c77012c4 = ()=>{
    if ($b6c848c639162360$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $b6c848c639162360$var$initHiddenTime();
        $b6c848c639162360$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $b6c848c639162360$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $fde0c7d375f4fcfc$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $b6c848c639162360$export$443f86b2c77012c4)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $588c8c9828db8996$var$interactionCountEstimate = 0;
let $588c8c9828db8996$var$minKnownInteractionId = Infinity;
let $588c8c9828db8996$var$maxKnownInteractionId = 0;
const $588c8c9828db8996$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $588c8c9828db8996$var$minKnownInteractionId = Math.min($588c8c9828db8996$var$minKnownInteractionId, e.interactionId);
            $588c8c9828db8996$var$maxKnownInteractionId = Math.max($588c8c9828db8996$var$maxKnownInteractionId, e.interactionId);
            $588c8c9828db8996$var$interactionCountEstimate = $588c8c9828db8996$var$maxKnownInteractionId ? ($588c8c9828db8996$var$maxKnownInteractionId - $588c8c9828db8996$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $588c8c9828db8996$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $588c8c9828db8996$export$8a962f2683a476d1 = ()=>{
    return $588c8c9828db8996$var$po ? $588c8c9828db8996$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $588c8c9828db8996$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $588c8c9828db8996$var$po) return;
    $588c8c9828db8996$var$po = (0, $c62bade033a6ea98$export$d1203567a167490e)("event", $588c8c9828db8996$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $ff897fbbb59b5bdf$var$getInteractionCountForNavigation = ()=>{
    return (0, $588c8c9828db8996$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $ff897fbbb59b5bdf$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $ff897fbbb59b5bdf$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $ff897fbbb59b5bdf$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $ff897fbbb59b5bdf$var$longestInteractionList[$ff897fbbb59b5bdf$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $ff897fbbb59b5bdf$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $ff897fbbb59b5bdf$var$longestInteractionList.length < $ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $ff897fbbb59b5bdf$var$longestInteractionMap[interaction.id] = interaction;
            $ff897fbbb59b5bdf$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $ff897fbbb59b5bdf$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $ff897fbbb59b5bdf$var$longestInteractionList.splice($ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $ff897fbbb59b5bdf$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $ff897fbbb59b5bdf$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($ff897fbbb59b5bdf$var$longestInteractionList.length - 1, Math.floor($ff897fbbb59b5bdf$var$getInteractionCountForNavigation() / 50));
    return $ff897fbbb59b5bdf$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $ff897fbbb59b5bdf$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $588c8c9828db8996$export$67d90cda6b78a2eb)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $ff897fbbb59b5bdf$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$ff897fbbb59b5bdf$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $ff897fbbb59b5bdf$var$processEntry(entry);
            }
        });
        const inp = $ff897fbbb59b5bdf$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $ff897fbbb59b5bdf$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ca1c2d1679c3e1ef$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ca1c2d1679c3e1ef$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $b6c848c639162360$export$443f86b2c77012c4)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $57e88e157c530457$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $fc0e8942a061fac1$var$whenReady = (callback)=>{
    if (!(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) return;
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$fc0e8942a061fac1$var$whenReady(callback), true);
    else if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$fc0e8942a061fac1$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $fc0e8942a061fac1$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("TTFB");
    const report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $fc0e8942a061fac1$var$whenReady(()=>{
        const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $57e88e157c530457$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $8b02f76565f096cc$var$handlers = {};
const $8b02f76565f096cc$var$instrumented = {};
let $8b02f76565f096cc$var$_previousCls;
let $8b02f76565f096cc$var$_previousFid;
let $8b02f76565f096cc$var$_previousLcp;
let $8b02f76565f096cc$var$_previousTtfb;
let $8b02f76565f096cc$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $8b02f76565f096cc$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $8b02f76565f096cc$var$addMetricObserver("cls", callback, $8b02f76565f096cc$var$instrumentCls, $8b02f76565f096cc$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $8b02f76565f096cc$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $8b02f76565f096cc$var$addMetricObserver("lcp", callback, $8b02f76565f096cc$var$instrumentLcp, $8b02f76565f096cc$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $8b02f76565f096cc$export$699d9529c099a797(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("ttfb", callback, $8b02f76565f096cc$var$instrumentTtfb, $8b02f76565f096cc$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$2707d7471c0b918f(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("fid", callback, $8b02f76565f096cc$var$instrumentFid, $8b02f76565f096cc$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$da3b76aa2022cbd7(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("inp", callback, $8b02f76565f096cc$var$instrumentInp, $8b02f76565f096cc$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$69816c1a049f8db6(type, callback) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        $8b02f76565f096cc$var$instrumentPerformanceObserver(type);
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $8b02f76565f096cc$var$triggerHandlers(type, data) {
    const typeHandlers = $8b02f76565f096cc$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $0cd1337813906a62$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $8b02f76565f096cc$var$instrumentCls() {
    return (0, $06ed980438256cb2$export$a7873055838e5ad8)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("cls", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $8b02f76565f096cc$var$instrumentFid() {
    return (0, $fde0c7d375f4fcfc$export$39705a25c49af873)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("fid", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousFid = metric;
    });
}
function $8b02f76565f096cc$var$instrumentLcp() {
    return (0, $ca1c2d1679c3e1ef$export$947b1626ab8d5632)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("lcp", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousLcp = metric;
    });
}
function $8b02f76565f096cc$var$instrumentTtfb() {
    return (0, $fc0e8942a061fac1$export$33a01e6c5f2c7e33)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousTtfb = metric;
    });
}
function $8b02f76565f096cc$var$instrumentInp() {
    return (0, $ff897fbbb59b5bdf$export$7df4b36ecaed99e1)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("inp", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousInp = metric;
    });
}
function $8b02f76565f096cc$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    let stopListening;
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        stopListening = instrumentFn();
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $8b02f76565f096cc$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $c62bade033a6ea98$export$d1203567a167490e)(type, (entries)=>{
        $8b02f76565f096cc$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $8b02f76565f096cc$var$addHandler(type, handler) {
    $8b02f76565f096cc$var$handlers[type] = $8b02f76565f096cc$var$handlers[type] || [];
    $8b02f76565f096cc$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $8b02f76565f096cc$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $8b02f76565f096cc$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $f7133678d936cd5e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f7133678d936cd5e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f7133678d936cd5e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f7133678d936cd5e$export$b892860177f70a30(str) {
    const match = $f7133678d936cd5e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f7133678d936cd5e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f7133678d936cd5e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f7133678d936cd5e$var$validateDsn(dsn) {
    if (!(0, $abe5418a531ee1d6$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f7133678d936cd5e$var$isValidProtocol(protocol)) {
        (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f7133678d936cd5e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f7133678d936cd5e$export$b892860177f70a30(from) : $f7133678d936cd5e$var$dsnFromComponents(from);
    if (!components || !$f7133678d936cd5e$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2cae643f899492f0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2cae643f899492f0$export$604a45d95a155e2b(envelope, types) {
    return $2cae643f899492f0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $2cae643f899492f0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2cae643f899492f0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $2cae643f899492f0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $2cae643f899492f0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $9ca32e18a091d955$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $2cae643f899492f0$var$concatBuffers(parts);
}
function $2cae643f899492f0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2cae643f899492f0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $2cae643f899492f0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $2cae643f899492f0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2cae643f899492f0$export$b11169581eeaf237(type) {
    return $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $2cae643f899492f0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2cae643f899492f0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $e628e125e878fd27$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $27113bf3441639bf$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn);
    const items = spans.map($27113bf3441639bf$var$createSpanItem);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, items);
}
function $27113bf3441639bf$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $90bdaea68141640c$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $25257edadcf16f49$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $25257edadcf16f49$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $25257edadcf16f49$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $25257edadcf16f49$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $5efc8c95ea982b90$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $5efc8c95ea982b90$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $df8507bffbb2043c$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $df8507bffbb2043c$var$msToSec(time) {
    return time / 1000;
}
function $df8507bffbb2043c$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).addEventListener && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance;
}
let $df8507bffbb2043c$var$_performanceCursor = 0;
let $df8507bffbb2043c$var$_measurements = {};
let $df8507bffbb2043c$var$_lcpEntry;
let $df8507bffbb2043c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $df8507bffbb2043c$export$7c69f0412d101b88() {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $91c304fc757d5e0f$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $df8507bffbb2043c$var$_trackFID();
        const clsCallback = $df8507bffbb2043c$var$_trackCLS();
        const lcpCallback = $df8507bffbb2043c$var$_trackLCP();
        const ttfbCallback = $df8507bffbb2043c$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $df8507bffbb2043c$export$f396d19077034ad2() {
    (0, $8b02f76565f096cc$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $df8507bffbb2043c$var$msToSec((0, $91c304fc757d5e0f$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $df8507bffbb2043c$export$e27543e0976315e4() {
    (0, $8b02f76565f096cc$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $df8507bffbb2043c$var$msToSec((0, $91c304fc757d5e0f$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
                const span = {
                    description: (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $d3dd25a69ce66c78$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $df8507bffbb2043c$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $91c304fc757d5e0f$export$baf075a948ffc0bf)) {
        const inpCallback = $df8507bffbb2043c$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $df8507bffbb2043c$var$_trackCLS() {
    return (0, $8b02f76565f096cc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $df8507bffbb2043c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $df8507bffbb2043c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $df8507bffbb2043c$var$_trackLCP() {
    return (0, $8b02f76565f096cc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $df8507bffbb2043c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $df8507bffbb2043c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $df8507bffbb2043c$var$_trackFID() {
    return (0, $8b02f76565f096cc$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $91c304fc757d5e0f$export$baf075a948ffc0bf));
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $df8507bffbb2043c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $df8507bffbb2043c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $df8507bffbb2043c$var$_trackTtfb() {
    return (0, $8b02f76565f096cc$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $df8507bffbb2043c$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $df8507bffbb2043c$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $df8507bffbb2043c$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $8b02f76565f096cc$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $df8507bffbb2043c$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $df8507bffbb2043c$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $df8507bffbb2043c$var$msToSec((0, $91c304fc757d5e0f$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $948960fec1caf8ab$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $df8507bffbb2043c$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $27113bf3441639bf$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $df8507bffbb2043c$export$5f8fa6b3467a7443(transaction) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.getEntries || !(0, $91c304fc757d5e0f$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $91c304fc757d5e0f$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $e047a3e652f57c75$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($df8507bffbb2043c$var$_performanceCursor).forEach((entry)=>{
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $b6c848c639162360$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $df8507bffbb2043c$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $df8507bffbb2043c$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $df8507bffbb2043c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $df8507bffbb2043c$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $df8507bffbb2043c$var$_addTtfbRequestTimeToMeasurements($df8507bffbb2043c$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$df8507bffbb2043c$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $df8507bffbb2043c$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $df8507bffbb2043c$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $df8507bffbb2043c$var$_measurements["mark.fid"];
        if (fidMark && $df8507bffbb2043c$var$_measurements["fid"]) {
            // create span for FID
            (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $df8507bffbb2043c$var$msToSec($df8507bffbb2043c$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $df8507bffbb2043c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $df8507bffbb2043c$var$_measurements)) delete $df8507bffbb2043c$var$_measurements.cls;
        Object.keys($df8507bffbb2043c$var$_measurements).forEach((measurementName)=>{
            (0, $90bdaea68141640c$export$7cc31b475d33a706)(measurementName, $df8507bffbb2043c$var$_measurements[measurementName].value, $df8507bffbb2043c$var$_measurements[measurementName].unit);
        });
        $df8507bffbb2043c$var$_tagMetricInfo(transaction);
    }
    $df8507bffbb2043c$var$_lcpEntry = undefined;
    $df8507bffbb2043c$var$_clsEntry = undefined;
    $df8507bffbb2043c$var$_measurements = {};
}
/** Create measure related spans */ function $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(start),
        endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
        });
        (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $df8507bffbb2043c$var$_trackNavigator(transaction) {
    const navigator = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(connection.rtt)) $df8507bffbb2043c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $df8507bffbb2043c$var$_tagMetricInfo(transaction) {
    if ($df8507bffbb2043c$var$_lcpEntry) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($df8507bffbb2043c$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)($df8507bffbb2043c$var$_lcpEntry.element));
        if ($df8507bffbb2043c$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $df8507bffbb2043c$var$_lcpEntry.id);
        if ($df8507bffbb2043c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $df8507bffbb2043c$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $df8507bffbb2043c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($df8507bffbb2043c$var$_clsEntry && $df8507bffbb2043c$var$_clsEntry.sources) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $df8507bffbb2043c$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(source.node)));
    }
}
function $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $df8507bffbb2043c$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $df8507bffbb2043c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $df8507bffbb2043c$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $9d2bd9c413e91a74$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $f16908c3df50a491$export$2603c8d332a51c42)(sampleRate)) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $a87a94b8e4ff7f26$var$WINDOW = (0, $25165aaf01761cfd$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a87a94b8e4ff7f26$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7($a87a94b8e4ff7f26$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a87a94b8e4ff7f26$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $abe5418a531ee1d6$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return "ReportingObserver" in $a87a94b8e4ff7f26$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $deebfb2c2f3e82fb$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $deebfb2c2f3e82fb$var$instrumentFetch);
}
function $deebfb2c2f3e82fb$var$instrumentFetch() {
    if (!(0, $a87a94b8e4ff7f26$export$c82d238e23c40b21)()) return;
    (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $deebfb2c2f3e82fb$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $9995ab194a6bc98e$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $deebfb2c2f3e82fb$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $deebfb2c2f3e82fb$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($deebfb2c2f3e82fb$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $deebfb2c2f3e82fb$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $deebfb2c2f3e82fb$var$getUrlFromResource(url),
            method: $deebfb2c2f3e82fb$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $deebfb2c2f3e82fb$var$getUrlFromResource(arg),
        method: $deebfb2c2f3e82fb$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $ae6dc6125d1c3217$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
const $ae6dc6125d1c3217$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae6dc6125d1c3217$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $ae6dc6125d1c3217$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $ae6dc6125d1c3217$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ae6dc6125d1c3217$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $1e0be767ffa822d8$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $ae6dc6125d1c3217$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $9995ab194a6bc98e$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $e628e125e878fd27$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $e628e125e878fd27$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(header) && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $9995ab194a6bc98e$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $ae6dc6125d1c3217$var$parseUrl(url) {
    if ((0, $1e0be767ffa822d8$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $bb4def6c8b51e56d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $9d2bd9c413e91a74$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $bb4def6c8b51e56d$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $bb4def6c8b51e56d$var$getFullURL(url);
    const host = fullUrl ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $b73c4ddb8b981968$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $033619b8172dea69$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $e047a3e652f57c75$export$7e9f8ae9e4a328ab)(span) : (0, $46f5220cb64aa700$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $9e1a8f302f19c673$export$56766feef403f365)(dsc || (span ? (0, $89d6805454b84092$export$a117f995597e25df)(span) : (0, $89d6805454b84092$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $1e0be767ffa822d8$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $1e0be767ffa822d8$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $9e1a8f302f19c673$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $9e1a8f302f19c673$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $bb4def6c8b51e56d$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $bb4def6c8b51e56d$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $6d9884e3956d809f$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $e425abf0f1e5a10f$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $e425abf0f1e5a10f$export$15bd0305d05ad07b,
    tracePropagationTargets: $e425abf0f1e5a10f$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $e425abf0f1e5a10f$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $bb4def6c8b51e56d$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $e425abf0f1e5a10f$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
}
function $e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $e425abf0f1e5a10f$var$addHTTPTimings(span) {
    const { url: url } = (0, $e047a3e652f57c75$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $8b02f76565f096cc$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $e425abf0f1e5a10f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $e425abf0f1e5a10f$var$getAbsoluteTime(time = 0) {
    return (((0, $91c304fc757d5e0f$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $e425abf0f1e5a10f$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $91c304fc757d5e0f$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $e425abf0f1e5a10f$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
    if (!(0, $9d2bd9c413e91a74$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $6d9884e3956d809f$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    const isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)();
    const fullUrl = $e425abf0f1e5a10f$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $b73c4ddb8b981968$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $033619b8172dea69$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $e047a3e652f57c75$export$7e9f8ae9e4a328ab)(span) : (0, $46f5220cb64aa700$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $9e1a8f302f19c673$export$56766feef403f365)(dsc || (span ? (0, $89d6805454b84092$export$a117f995597e25df)(span) : (0, $89d6805454b84092$export$366bad00d6815eed)(traceId, client, scope)));
        $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $9e1a8f302f19c673$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $e425abf0f1e5a10f$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $a7f24c22762d2906$var$WINDOW = (0, $25165aaf01761cfd$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a7f24c22762d2906$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a7f24c22762d2906$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a7f24c22762d2906$var$WINDOW && !!$a7f24c22762d2906$var$WINDOW.history.pushState && !!$a7f24c22762d2906$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $2579aac1b9dfd189$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
let $2579aac1b9dfd189$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2579aac1b9dfd189$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $2579aac1b9dfd189$var$instrumentHistory);
}
function $2579aac1b9dfd189$var$instrumentHistory() {
    if (!(0, $a7f24c22762d2906$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $2579aac1b9dfd189$var$WINDOW.onpopstate;
    $2579aac1b9dfd189$var$WINDOW.onpopstate = function(...args) {
        const to = $2579aac1b9dfd189$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2579aac1b9dfd189$var$lastHref;
        $2579aac1b9dfd189$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $9995ab194a6bc98e$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2579aac1b9dfd189$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2579aac1b9dfd189$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $e628e125e878fd27$export$9563e054e6f787fb)($2579aac1b9dfd189$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $e628e125e878fd27$export$9563e054e6f787fb)($2579aac1b9dfd189$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




/**
 * Default function implementing pageload and navigation transactions
 */ function $fe365ce63ae91e59$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) || !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $91c304fc757d5e0f$export$baf075a948ffc0bf) ? (0, $91c304fc757d5e0f$export$baf075a948ffc0bf) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $1a684ef8a4a48899$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $1a684ef8a4a48899$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $1efef08b5fe9fa0b$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $fe365ce63ae91e59$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $1a684ef8a4a48899$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $1a684ef8a4a48899$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $1a684ef8a4a48899$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $bfffaa6649a6ba90$export$653d0ef2bad9cdf9)();
        if (0, $a5e85a0c259bdb77$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$1a684ef8a4a48899$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $df8507bffbb2043c$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $df8507bffbb2043c$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $df8507bffbb2043c$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $df8507bffbb2043c$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $a5e85a0c259bdb77$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $a50bc2aef3fcf638$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $e425abf0f1e5a10f$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $1a684ef8a4a48899$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $1a684ef8a4a48899$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $46f5220cb64aa700$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $bfffaa6649a6ba90$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) {
                (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $df8507bffbb2043c$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $033619b8172dea69$export$d7a7d984b0791405)]: this._latestRoute.context ? $1a684ef8a4a48899$var$getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, $bfffaa6649a6ba90$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $44ed7dd0e837ba6e$export$a7feb32fdd923295)();
            const currentScope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($1a684ef8a4a48899$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $1a684ef8a4a48899$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $1a684ef8a4a48899$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $8b02f76565f096cc$export$69816c1a049f8db6)("event", handleEntries);
        (0, $8b02f76565f096cc$export$69816c1a049f8db6)("first-input", handleEntries);
    }
}
/** Returns the value of a meta tag */ function $1a684ef8a4a48899$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $d3dd25a69ce66c78$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $1a684ef8a4a48899$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $033619b8172dea69$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $033619b8172dea69$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $1a684ef8a4a48899$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}








const $51cfcbefde61ff20$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $51cfcbefde61ff20$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $51cfcbefde61ff20$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $806ed7b2edb8ea09$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $51cfcbefde61ff20$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $51cfcbefde61ff20$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $51cfcbefde61ff20$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $51cfcbefde61ff20$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($51cfcbefde61ff20$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $503ba8c00efa1d46$export$8e4e25f54d456511), (0, $9007972943bbf579$export$a07cdf6544bbd7c));
        $51cfcbefde61ff20$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $51cfcbefde61ff20$export$2d8f5188773bcddd(integration) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $51cfcbefde61ff20$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $51cfcbefde61ff20$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $51cfcbefde61ff20$export$2323046b9414659f(fn) {
    return fn;
}


let $ceb328f2f449885f$var$originalFunctionToString;
const $ceb328f2f449885f$var$INTEGRATION_NAME = "FunctionToString";
const $ceb328f2f449885f$var$SETUP_CLIENTS = new WeakMap();
const $ceb328f2f449885f$var$_functionToStringIntegration = ()=>{
    return {
        name: $ceb328f2f449885f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ceb328f2f449885f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $e628e125e878fd27$export$e6cc1e135e2092e5)(this);
                    const context = $ceb328f2f449885f$var$SETUP_CLIENTS.has((0, $81a395368bb6f380$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ceb328f2f449885f$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ceb328f2f449885f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ceb328f2f449885f$export$7918117e9202e4fb = (0, $51cfcbefde61ff20$export$2323046b9414659f)($ceb328f2f449885f$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ceb328f2f449885f$export$da4704525c20ae79 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($ceb328f2f449885f$var$INTEGRATION_NAME, $ceb328f2f449885f$export$7918117e9202e4fb);


const $d91612272370ed71$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d91612272370ed71$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $d91612272370ed71$var$_getIngestEndpoint(dsn) {
    return `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d91612272370ed71$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $e628e125e878fd27$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d91612272370ed71$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $d91612272370ed71$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$d91612272370ed71$var$_getIngestEndpoint(dsn)}?${$d91612272370ed71$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $d91612272370ed71$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $499a1b6c2e7bd9e9$var$INTEGRATION_NAME = "InboundFilters";
const $499a1b6c2e7bd9e9$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $499a1b6c2e7bd9e9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $499a1b6c2e7bd9e9$var$_mergeOptions(options, clientOptions);
            return $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba = (0, $51cfcbefde61ff20$export$2323046b9414659f)($499a1b6c2e7bd9e9$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($499a1b6c2e7bd9e9$var$INTEGRATION_NAME, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba);
function $499a1b6c2e7bd9e9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $499a1b6c2e7bd9e9$var$_isSentryError(event)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$499a1b6c2e7bd9e9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event).some((message)=>(0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $499a1b6c2e7bd9e9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $499a1b6c2e7bd9e9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $6593ea065203555e$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $499a1b6c2e7bd9e9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93002778f3923c52$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6593ea065203555e$export$16a28057038b10ef) (0, $3199231328e69de5$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $93002778f3923c52$export$ecb76f41d43c0e43(client);
    $93002778f3923c52$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $93002778f3923c52$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $93002778f3923c52$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $cb951e05ebb58c43$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $725570364ca356d5$export$31499a9cd224b78c)
            })),
        version: (0, $725570364ca356d5$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $890c53ca2f6b4a7a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9b6c4c62dbf66cae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9b6c4c62dbf66cae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2cae643f899492f0$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $2915496cd851a181$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $e628e125e878fd27$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $2915496cd851a181$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $2915496cd851a181$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $2915496cd851a181$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $2915496cd851a181$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $2915496cd851a181$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $2915496cd851a181$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $2915496cd851a181$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $2915496cd851a181$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $2915496cd851a181$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $2915496cd851a181$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $2915496cd851a181$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $2915496cd851a181$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $2915496cd851a181$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $b86d5e61843389b9$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn);
    const item = $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $2915496cd851a181$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5d4a5f71b683f78e$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(options.dsn);
        else (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $d91612272370ed71$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $806ed7b2edb8ea09$export$6de4ffac6a2f1098)(exception)) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $1e0be767ffa822d8$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $806ed7b2edb8ea09$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $049d01d3a3164ac2$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $51cfcbefde61ff20$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $51cfcbefde61ff20$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $9b6c4c62dbf66cae$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2cae643f899492f0$export$d650323442802f6f)(env, (0, $2cae643f899492f0$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $9b6c4c62dbf66cae$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $b86d5e61843389b9$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $51cfcbefde61ff20$export$51abed9797baa598)(this, integrations);
        (0, $51cfcbefde61ff20$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $049d01d3a3164ac2$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $9007972943bbf579$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $7b0dad5cf366cc16$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $89d6805454b84092$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $6593ea065203555e$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $3199231328e69de5$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $3199231328e69de5$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5d4a5f71b683f78e$var$isTransactionEvent(event);
        const isError = $5d4a5f71b683f78e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $dde6191ffa17294f$export$78e43115b553f358)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5d4a5f71b683f78e$var$processBeforeSend(options, prepared, hint);
            return $5d4a5f71b683f78e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5d4a5f71b683f78e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $1e0be767ffa822d8$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5d4a5f71b683f78e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5d4a5f71b683f78e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5d4a5f71b683f78e$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $5d4a5f71b683f78e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5d4a5f71b683f78e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $5d4a5f71b683f78e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d90c5d9ac5d72442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $91c304fc757d5e0f$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $Wgg6o = parcelRequire("Wgg6o");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $817d897c5dc6d664$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $230372ac01587541$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $230372ac01587541$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $230372ac01587541$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $1e0be767ffa822d8$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $9ca32e18a091d955$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $230372ac01587541$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $230372ac01587541$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $230372ac01587541$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $230372ac01587541$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($230372ac01587541$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $230372ac01587541$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $230372ac01587541$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $230372ac01587541$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $1e0be767ffa822d8$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $230372ac01587541$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $1e0be767ffa822d8$export$ef9e2056653f0c8e)(exception) || (0, $1e0be767ffa822d8$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $1e0be767ffa822d8$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $806ed7b2edb8ea09$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $1e0be767ffa822d8$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $1e0be767ffa822d8$export$53b83ca8eaab0383)(exception) || (0, $1e0be767ffa822d8$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $230372ac01587541$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $806ed7b2edb8ea09$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $1e0be767ffa822d8$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $e628e125e878fd27$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $1e0be767ffa822d8$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $1e0be767ffa822d8$export$9671ea99bd126ace)(exception)) {
        const className = $230372ac01587541$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $230372ac01587541$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $4e817323ced6d78c$export$56d8a8a25bd48b81 = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
let $4e817323ced6d78c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4e817323ced6d78c$export$b79738ab10c590b2() {
    return $4e817323ced6d78c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4e817323ced6d78c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4e817323ced6d78c$var$ignoreOnError++;
    setTimeout(()=>{
        $4e817323ced6d78c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4e817323ced6d78c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $e628e125e878fd27$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$4e817323ced6d78c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4e817323ced6d78c$export$1265a142ff5ba165();
            (0, $81a395368bb6f380$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $806ed7b2edb8ea09$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $806ed7b2edb8ea09$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $81a395368bb6f380$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $e628e125e878fd27$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $e628e125e878fd27$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $b03dbb36f8019264$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c55795097f9daeb0$export$1df9218a526d318d extends (0, $5d4a5f71b683f78e$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $Wgg6o.getSDKSource)();
        (0, $cb951e05ebb58c43$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $230372ac01587541$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $230372ac01587541$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $b03dbb36f8019264$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $d90c5d9ac5d72442$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f7133678d936cd5e$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $6dad95eb90f2d36c$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
const $6dad95eb90f2d36c$var$DEBOUNCE_DURATION = 1000;
let $6dad95eb90f2d36c$var$debounceTimerID;
let $6dad95eb90f2d36c$var$lastCapturedEventType;
let $6dad95eb90f2d36c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6dad95eb90f2d36c$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $6dad95eb90f2d36c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $6dad95eb90f2d36c$export$3014bbf0af0e1d4a() {
    if (!$6dad95eb90f2d36c$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $9995ab194a6bc98e$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $6dad95eb90f2d36c$var$WINDOW[target] && $6dad95eb90f2d36c$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $6dad95eb90f2d36c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $6dad95eb90f2d36c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6dad95eb90f2d36c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $6dad95eb90f2d36c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $6dad95eb90f2d36c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($6dad95eb90f2d36c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $e628e125e878fd27$export$e73679ffaf56810e)(target, "_sentryId", (0, $806ed7b2edb8ea09$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6dad95eb90f2d36c$var$lastCapturedEventType = event.type;
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6dad95eb90f2d36c$var$debounceTimerID);
        $6dad95eb90f2d36c$var$debounceTimerID = $6dad95eb90f2d36c$var$WINDOW.setTimeout(()=>{
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = undefined;
            $6dad95eb90f2d36c$var$lastCapturedEventType = undefined;
        }, $6dad95eb90f2d36c$var$DEBOUNCE_DURATION);
    };
}
function $6dad95eb90f2d36c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d81ce3377b27def9$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $9995ab194a6bc98e$export$a4e09611e30da72e)(type, handler);
    (0, $9995ab194a6bc98e$export$e18d6c5462c01368)(type, $d81ce3377b27def9$var$instrumentConsole);
}
function $d81ce3377b27def9$var$instrumentConsole() {
    if (!("console" in (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1))) return;
    (0, $3199231328e69de5$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console)) return;
        (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $3199231328e69de5$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $9995ab194a6bc98e$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $3199231328e69de5$export$77c4ce905194557b)[level];
                log && log.apply((0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $7f06244a5e0d22e8$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $7f06244a5e0d22e8$export$e01cef29b4327697(level) {
    return $7f06244a5e0d22e8$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7f06244a5e0d22e8$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $7f06244a5e0d22e8$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b50dad0732e7f682$var$INTEGRATION_NAME = "Breadcrumbs";
const $b50dad0732e7f682$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b50dad0732e7f682$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $d81ce3377b27def9$export$1d6e0d073f9e6723)($b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6dad95eb90f2d36c$export$5aeffd3db2cf9df7)($b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)($b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)($b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)($b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b50dad0732e7f682$export$c079d904b326663a = (0, $51cfcbefde61ff20$export$2323046b9414659f)($b50dad0732e7f682$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b50dad0732e7f682$export$2dc68d50d56fbbd = (0, $51cfcbefde61ff20$export$afa219bf23651160)($b50dad0732e7f682$var$INTEGRATION_NAME, $b50dad0732e7f682$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        (0, $81a395368bb6f380$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $806ed7b2edb8ea09$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b50dad0732e7f682$var$_isEvent(event) ? event.target : event;
            target = (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $d3dd25a69ce66c78$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $81a395368bb6f380$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $7f06244a5e0d22e8$export$d771ef054122c30a)(handlerData.level),
            message: (0, $692fb1c9fae23fc3$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $692fb1c9fae23fc3$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $81a395368bb6f380$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $81a395368bb6f380$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $81a395368bb6f380$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $81a395368bb6f380$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $25257edadcf16f49$export$7a5253c0f62e0150)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $81a395368bb6f380$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b50dad0732e7f682$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $893f0ce260470ef7$var$INTEGRATION_NAME = "Dedupe";
const $893f0ce260470ef7$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $893f0ce260470ef7$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $893f0ce260470ef7$export$6d39aa44cd0c7567 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($893f0ce260470ef7$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $893f0ce260470ef7$export$688d98c249d31ad3 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($893f0ce260470ef7$var$INTEGRATION_NAME, $893f0ce260470ef7$export$6d39aa44cd0c7567);
function $893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $893f0ce260470ef7$var$_getExceptionFromEvent(previousEvent);
    const currentException = $893f0ce260470ef7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $893f0ce260470ef7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $893f0ce260470ef7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $893f0ce260470ef7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $893f0ce260470ef7$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $9d72a78ef45a7c39$var$INTEGRATION_NAME = "GlobalHandlers";
const $9d72a78ef45a7c39$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9d72a78ef45a7c39$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $9d72a78ef45a7c39$export$66acc70e8cf2b71a = (0, $51cfcbefde61ff20$export$2323046b9414659f)($9d72a78ef45a7c39$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9d72a78ef45a7c39$export$204155decbc90e5a = (0, $51cfcbefde61ff20$export$afa219bf23651160)($9d72a78ef45a7c39$var$INTEGRATION_NAME, $9d72a78ef45a7c39$export$66acc70e8cf2b71a);
function $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client) {
    (0, $d70977d9b36915fd$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client || (0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $1e0be767ffa822d8$export$844ec244b1367d54)(msg) ? $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) : $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame((0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $81a395368bb6f380$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $a4223cccebdcb864$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $81a395368bb6f380$export$6bb76d6eba7e258c)() !== client || (0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const error = $9d72a78ef45a7c39$var$_getUnhandledRejectionError(e);
        const event = (0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(error) ? $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(error) : (0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $81a395368bb6f380$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_getUnhandledRejectionError(error) {
    if ((0, $1e0be767ffa822d8$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $1e0be767ffa822d8$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $1e0be767ffa822d8$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $d3dd25a69ce66c78$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9d72a78ef45a7c39$var$globalHandlerLog(type) {
    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $9d72a78ef45a7c39$var$getOptions() {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $a609b75c449d57c1$var$INTEGRATION_NAME = "HttpContext";
const $a609b75c449d57c1$var$_httpContextIntegration = ()=>{
    return {
        name: $a609b75c449d57c1$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $a609b75c449d57c1$export$1378794447170364 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($a609b75c449d57c1$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a609b75c449d57c1$export$5d2ee9a544b09a94 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($a609b75c449d57c1$var$INTEGRATION_NAME, $a609b75c449d57c1$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $021240852b914991$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $1e0be767ffa822d8$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $021240852b914991$var$truncateAggregateExceptions($021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $1e0be767ffa822d8$export$49034edbe6b62415)(error[key], Error)) {
        $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $1e0be767ffa822d8$export$49034edbe6b62415)(childError, Error)) {
            $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $021240852b914991$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $021240852b914991$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $692fb1c9fae23fc3$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $732232d08e00e18c$var$DEFAULT_KEY = "cause";
const $732232d08e00e18c$var$DEFAULT_LIMIT = 5;
const $732232d08e00e18c$var$INTEGRATION_NAME = "LinkedErrors";
const $732232d08e00e18c$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $732232d08e00e18c$var$DEFAULT_LIMIT;
    const key = options.key || $732232d08e00e18c$var$DEFAULT_KEY;
    return {
        name: $732232d08e00e18c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $021240852b914991$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $230372ac01587541$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $732232d08e00e18c$export$ebabb00eb7f3a395 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($732232d08e00e18c$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $732232d08e00e18c$export$8d1e60aaf616fb4f = (0, $51cfcbefde61ff20$export$afa219bf23651160)($732232d08e00e18c$var$INTEGRATION_NAME, $732232d08e00e18c$export$ebabb00eb7f3a395);





const $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $f8ac3caec1ed9186$var$INTEGRATION_NAME = "TryCatch";
const $f8ac3caec1ed9186$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $f8ac3caec1ed9186$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "setTimeout", $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "setInterval", $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $e628e125e878fd27$export$9563e054e6f787fb)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "requestAnimationFrame", $f8ac3caec1ed9186$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $4e817323ced6d78c$export$56d8a8a25bd48b81)) (0, $e628e125e878fd27$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $f8ac3caec1ed9186$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($f8ac3caec1ed9186$var$_wrapEventTarget);
            }
        }
    };
};
const $f8ac3caec1ed9186$export$59bfe9f1c76150e = (0, $51cfcbefde61ff20$export$2323046b9414659f)($f8ac3caec1ed9186$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f8ac3caec1ed9186$export$f1a018517668e6d3 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($f8ac3caec1ed9186$var$INTEGRATION_NAME, $f8ac3caec1ed9186$export$59bfe9f1c76150e);
function $f8ac3caec1ed9186$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $0cd1337813906a62$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f8ac3caec1ed9186$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $4e817323ced6d78c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $f8ac3caec1ed9186$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $e628e125e878fd27$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $e628e125e878fd27$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $0cd1337813906a62$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f8ac3caec1ed9186$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $0cd1337813906a62$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $e628e125e878fd27$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $6fa852429033a8df$var$UNKNOWN_FUNCTION = "?";
const $6fa852429033a8df$var$OPERA10_PRIORITY = 10;
const $6fa852429033a8df$var$OPERA11_PRIORITY = 20;
const $6fa852429033a8df$var$CHROME_PRIORITY = 30;
const $6fa852429033a8df$var$WINJS_PRIORITY = 40;
const $6fa852429033a8df$var$GECKO_PRIORITY = 50;
function $6fa852429033a8df$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $6fa852429033a8df$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $6fa852429033a8df$var$chromeStackParserFn = (line)=>{
    const parts = $6fa852429033a8df$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, parts[2]);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$263a749fff749872 = [
    $6fa852429033a8df$var$CHROME_PRIORITY,
    $6fa852429033a8df$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $6fa852429033a8df$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $6fa852429033a8df$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $6fa852429033a8df$var$gecko = (line)=>{
    const parts = $6fa852429033a8df$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION;
        [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(func, filename);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$cdba47a5dd2804d = [
    $6fa852429033a8df$var$GECKO_PRIORITY,
    $6fa852429033a8df$var$gecko
];
const $6fa852429033a8df$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$winjs = (line)=>{
    const parts = $6fa852429033a8df$var$winjsRegex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $6fa852429033a8df$export$179460296da408e8 = [
    $6fa852429033a8df$var$WINJS_PRIORITY,
    $6fa852429033a8df$var$winjs
];
const $6fa852429033a8df$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $6fa852429033a8df$var$opera10 = (line)=>{
    const parts = $6fa852429033a8df$var$opera10Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[3] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $6fa852429033a8df$export$f892b52c880ffc7a = [
    $6fa852429033a8df$var$OPERA10_PRIORITY,
    $6fa852429033a8df$var$opera10
];
const $6fa852429033a8df$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $6fa852429033a8df$var$opera11 = (line)=>{
    const parts = $6fa852429033a8df$var$opera11Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[5], parts[3] || parts[4] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $6fa852429033a8df$export$af11af13f09fb0dc = [
    $6fa852429033a8df$var$OPERA11_PRIORITY,
    $6fa852429033a8df$var$opera11
];
const $6fa852429033a8df$export$7197c0fe6554c079 = [
    $6fa852429033a8df$export$263a749fff749872,
    $6fa852429033a8df$export$cdba47a5dd2804d,
    $6fa852429033a8df$export$179460296da408e8
];
const $6fa852429033a8df$export$2b2b997d81bf3907 = (0, $0cd1337813906a62$export$a5739666fb2d03d4)(...$6fa852429033a8df$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $6fa852429033a8df$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $6fa852429033a8df$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e02662e4aa308398$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e02662e4aa308398$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e02662e4aa308398$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e02662e4aa308398$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e02662e4aa308398$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e02662e4aa308398$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e21a1e6dd57da767$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $dde6191ffa17294f$export$78e43115b553f358)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $551fd97e865f07d3$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $551fd97e865f07d3$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $e21a1e6dd57da767$export$85a4f67f852183e6)(options.bufferSize || $551fd97e865f07d3$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2cae643f899492f0$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $2cae643f899492f0$export$b11169581eeaf237)(type);
            if ((0, $e02662e4aa308398$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2cae643f899492f0$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2cae643f899492f0$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2cae643f899492f0$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $e02662e4aa308398$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) {
                (0, $6593ea065203555e$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $dde6191ffa17294f$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7d25350de9c66b8e$export$8be2119ce08e3379() {
    if ($7d25350de9c66b8e$var$cachedFetchImpl) return $7d25350de9c66b8e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $a87a94b8e4ff7f26$export$18cf36ed71d733e7)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch)) return $7d25350de9c66b8e$var$cachedFetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
    const document = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $7d25350de9c66b8e$var$cachedFetchImpl = fetchImpl.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $7d25350de9c66b8e$export$d499686d2dd738c6() {
    $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9237c8bb75383bbf$export$b2311068c46d7cc8(options, nativeFetch = (0, $7d25350de9c66b8e$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $7d25350de9c66b8e$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $dde6191ffa17294f$export$78e43115b553f358)(e);
        }
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8be23756f879b8e4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8be23756f879b8e4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $dde6191ffa17294f$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8be23756f879b8e4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $4c87801c815e53f1$export$5ef831fccfce35e5 = [
    (0, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba)(),
    (0, $ceb328f2f449885f$export$7918117e9202e4fb)(),
    (0, $f8ac3caec1ed9186$export$59bfe9f1c76150e)(),
    (0, $b50dad0732e7f682$export$c079d904b326663a)(),
    (0, $9d72a78ef45a7c39$export$66acc70e8cf2b71a)(),
    (0, $732232d08e00e18c$export$ebabb00eb7f3a395)(),
    (0, $893f0ce260470ef7$export$6d39aa44cd0c7567)(),
    (0, $a609b75c449d57c1$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $4c87801c815e53f1$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$4c87801c815e53f1$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4c87801c815e53f1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4c87801c815e53f1$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $0cd1337813906a62$export$1d5cf88b347146d4)(options.stackParser || (0, $6fa852429033a8df$export$2b2b997d81bf3907)),
        integrations: (0, $51cfcbefde61ff20$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e)() ? (0, $9237c8bb75383bbf$export$b2311068c46d7cc8) : (0, $8be23756f879b8e4$export$5e1441cee30d5a39))
    };
    (0, $93002778f3923c52$export$5333c3f1c58d9bc1)((0, $c55795097f9daeb0$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4c87801c815e53f1$var$startSessionTracking();
}
const $4c87801c815e53f1$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $9007972943bbf579$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $d91612272370ed71$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.head || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c87801c815e53f1$export$4997ffc0176396a6(fn) {
    return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4c87801c815e53f1$var$startSessionTracking() {
    if (typeof (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $81a395368bb6f380$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $81a395368bb6f380$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $81a395368bb6f380$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $81a395368bb6f380$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4c87801c815e53f1$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $795a7664e1a3c052$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $cb951e05ebb58c43$export$b9f95b027256052c)(opts, "react");
    (0, $4c87801c815e53f1$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $5f57bfb89049a269$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $ba7e9f49429c2354$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $289ZW = parcelRequire("289ZW");

/**
 * Returns true if we are in the browser.
 */ function $12807b614cb38f74$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $289ZW.isNodeEnv)() || $12807b614cb38f74$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $12807b614cb38f74$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).process !== undefined && (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1).process.type === "renderer");
}


/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $0fe6168822a98917$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $0fe6168822a98917$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $0fe6168822a98917$var$checkDsn(url, dsn) || $0fe6168822a98917$var$checkTunnel(url, tunnel);
}
function $0fe6168822a98917$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $0fe6168822a98917$var$removeTrailingSlash(url) === $0fe6168822a98917$var$removeTrailingSlash(tunnel);
}
function $0fe6168822a98917$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $0fe6168822a98917$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $0fe6168822a98917$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $5de7be2bba18bd29$var$WINDOW = (0, $25165aaf01761cfd$export$f1a6cdb1459e81d1);
const $5de7be2bba18bd29$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $5de7be2bba18bd29$var$REPLAY_EVENT_NAME = "replay_event";
const $5de7be2bba18bd29$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $5de7be2bba18bd29$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $5de7be2bba18bd29$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $5de7be2bba18bd29$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $5de7be2bba18bd29$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $5de7be2bba18bd29$var$BUFFER_CHECKOUT_TIME = 60000;
const $5de7be2bba18bd29$var$RETRY_BASE_INTERVAL = 5000;
const $5de7be2bba18bd29$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $5de7be2bba18bd29$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $5de7be2bba18bd29$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $5de7be2bba18bd29$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $5de7be2bba18bd29$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $5de7be2bba18bd29$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $5de7be2bba18bd29$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $5de7be2bba18bd29$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $5de7be2bba18bd29$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $5de7be2bba18bd29$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $5de7be2bba18bd29$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $5de7be2bba18bd29$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($5de7be2bba18bd29$var$NodeType$1 || ($5de7be2bba18bd29$var$NodeType$1 = {}));
function $5de7be2bba18bd29$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $5de7be2bba18bd29$var$isShadowRoot(n) {
    const host = $5de7be2bba18bd29$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($5de7be2bba18bd29$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $5de7be2bba18bd29$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $5de7be2bba18bd29$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $5de7be2bba18bd29$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $5de7be2bba18bd29$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $5de7be2bba18bd29$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $5de7be2bba18bd29$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $5de7be2bba18bd29$var$stringifyRule(rule) {
    let importStringified;
    if ($5de7be2bba18bd29$var$isCSSImportRule(rule)) try {
        importStringified = $5de7be2bba18bd29$var$stringifyStylesheet(rule.styleSheet) || $5de7be2bba18bd29$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($5de7be2bba18bd29$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $5de7be2bba18bd29$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $5de7be2bba18bd29$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $5de7be2bba18bd29$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $5de7be2bba18bd29$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $5de7be2bba18bd29$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $5de7be2bba18bd29$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $5de7be2bba18bd29$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $5de7be2bba18bd29$var$createMirror() {
    return new $5de7be2bba18bd29$var$Mirror();
}
function $5de7be2bba18bd29$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $5de7be2bba18bd29$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $5de7be2bba18bd29$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $5de7be2bba18bd29$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $5de7be2bba18bd29$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $5de7be2bba18bd29$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $5de7be2bba18bd29$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$5de7be2bba18bd29$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $5de7be2bba18bd29$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $5de7be2bba18bd29$var$toLowerCase(type) : null;
}
function $5de7be2bba18bd29$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $5de7be2bba18bd29$var$_id = 1;
const $5de7be2bba18bd29$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $5de7be2bba18bd29$var$IGNORED_NODE = -2;
function $5de7be2bba18bd29$var$genId() {
    return $5de7be2bba18bd29$var$_id++;
}
function $5de7be2bba18bd29$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $5de7be2bba18bd29$var$toLowerCase(element.tagName);
    if ($5de7be2bba18bd29$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $5de7be2bba18bd29$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $5de7be2bba18bd29$var$canvasService;
let $5de7be2bba18bd29$var$canvasCtx;
const $5de7be2bba18bd29$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $5de7be2bba18bd29$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $5de7be2bba18bd29$var$URL_WWW_MATCH = /^www\..*/i;
const $5de7be2bba18bd29$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $5de7be2bba18bd29$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($5de7be2bba18bd29$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($5de7be2bba18bd29$var$URL_PROTOCOL_MATCH.test(filePath) || $5de7be2bba18bd29$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($5de7be2bba18bd29$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$5de7be2bba18bd29$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $5de7be2bba18bd29$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $5de7be2bba18bd29$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $5de7be2bba18bd29$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($5de7be2bba18bd29$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($5de7be2bba18bd29$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $5de7be2bba18bd29$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $5de7be2bba18bd29$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $5de7be2bba18bd29$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $5de7be2bba18bd29$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $5de7be2bba18bd29$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $5de7be2bba18bd29$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $5de7be2bba18bd29$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $5de7be2bba18bd29$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $5de7be2bba18bd29$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $5de7be2bba18bd29$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $5de7be2bba18bd29$var$absoluteToStylesheet(value, $5de7be2bba18bd29$var$getHref());
    else if (tagName === "object" && name === "data") return $5de7be2bba18bd29$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $5de7be2bba18bd29$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $5de7be2bba18bd29$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $5de7be2bba18bd29$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $5de7be2bba18bd29$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $5de7be2bba18bd29$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $5de7be2bba18bd29$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($5de7be2bba18bd29$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $5de7be2bba18bd29$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $5de7be2bba18bd29$var$distanceToMatch(el, $5de7be2bba18bd29$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $5de7be2bba18bd29$var$distanceToMatch(el, $5de7be2bba18bd29$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $5de7be2bba18bd29$var$distanceToMatch(el, $5de7be2bba18bd29$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $5de7be2bba18bd29$var$distanceToMatch(el, $5de7be2bba18bd29$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $5de7be2bba18bd29$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $5de7be2bba18bd29$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $5de7be2bba18bd29$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $5de7be2bba18bd29$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $5de7be2bba18bd29$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $5de7be2bba18bd29$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $5de7be2bba18bd29$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $5de7be2bba18bd29$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $5de7be2bba18bd29$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $5de7be2bba18bd29$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $5de7be2bba18bd29$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $5de7be2bba18bd29$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $5de7be2bba18bd29$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($5de7be2bba18bd29$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $5de7be2bba18bd29$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $5de7be2bba18bd29$var$absoluteToStylesheet(textContent, $5de7be2bba18bd29$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $5de7be2bba18bd29$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $5de7be2bba18bd29$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $5de7be2bba18bd29$var$maskInputValue({
            isMasked: $5de7be2bba18bd29$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $5de7be2bba18bd29$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $5de7be2bba18bd29$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $5de7be2bba18bd29$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $5de7be2bba18bd29$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$5de7be2bba18bd29$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $5de7be2bba18bd29$var$transformAttribute(doc, tagName, $5de7be2bba18bd29$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $5de7be2bba18bd29$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $5de7be2bba18bd29$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $5de7be2bba18bd29$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $5de7be2bba18bd29$var$absoluteToStylesheet(cssText, $5de7be2bba18bd29$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $5de7be2bba18bd29$var$getInputType(el);
        const value = $5de7be2bba18bd29$var$getInputValue(el, $5de7be2bba18bd29$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $5de7be2bba18bd29$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $5de7be2bba18bd29$var$shouldMaskInput({
                type: type,
                tagName: $5de7be2bba18bd29$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $5de7be2bba18bd29$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$5de7be2bba18bd29$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$5de7be2bba18bd29$var$canvasService) {
            $5de7be2bba18bd29$var$canvasService = doc.createElement("canvas");
            $5de7be2bba18bd29$var$canvasCtx = $5de7be2bba18bd29$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $5de7be2bba18bd29$var$canvasService.width = image.naturalWidth;
                $5de7be2bba18bd29$var$canvasService.height = image.naturalHeight;
                $5de7be2bba18bd29$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $5de7be2bba18bd29$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $5de7be2bba18bd29$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $5de7be2bba18bd29$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $5de7be2bba18bd29$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $5de7be2bba18bd29$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $5de7be2bba18bd29$var$NodeType$1.Comment) return true;
    else if (sn.type === $5de7be2bba18bd29$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "application-name" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.rel) === "icon" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($5de7be2bba18bd29$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "robots" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "googlebot" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "author" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "generator" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "framework" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "publisher" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "progid" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "verification" || $5de7be2bba18bd29$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $5de7be2bba18bd29$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $5de7be2bba18bd29$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($5de7be2bba18bd29$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $5de7be2bba18bd29$var$IGNORED_NODE;
    else id = $5de7be2bba18bd29$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $5de7be2bba18bd29$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $5de7be2bba18bd29$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Document || serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $5de7be2bba18bd29$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($5de7be2bba18bd29$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $5de7be2bba18bd29$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $5de7be2bba18bd29$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $5de7be2bba18bd29$var$isShadowRoot(n.parentNode) && $5de7be2bba18bd29$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Element && serializedNode.tagName === "iframe") $5de7be2bba18bd29$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $5de7be2bba18bd29$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $5de7be2bba18bd29$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $5de7be2bba18bd29$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $5de7be2bba18bd29$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $5de7be2bba18bd29$var$snapshot(n, options) {
    const { mirror: mirror = new $5de7be2bba18bd29$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $5de7be2bba18bd29$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $5de7be2bba18bd29$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $5de7be2bba18bd29$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $5de7be2bba18bd29$var$_mirror = {
    map: {},
    getId () {
        console.error($5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $5de7be2bba18bd29$var$_mirror = new Proxy($5de7be2bba18bd29$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($5de7be2bba18bd29$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $5de7be2bba18bd29$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $5de7be2bba18bd29$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $5de7be2bba18bd29$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $5de7be2bba18bd29$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $5de7be2bba18bd29$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$5de7be2bba18bd29$var$hookSetter(target, key, original || {}, true);
}
function $5de7be2bba18bd29$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $5de7be2bba18bd29$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $5de7be2bba18bd29$var$nowTimestamp = ()=>new Date().getTime();
function $5de7be2bba18bd29$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $5de7be2bba18bd29$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $5de7be2bba18bd29$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $5de7be2bba18bd29$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $5de7be2bba18bd29$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $5de7be2bba18bd29$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $5de7be2bba18bd29$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $5de7be2bba18bd29$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $5de7be2bba18bd29$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $5de7be2bba18bd29$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $5de7be2bba18bd29$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $5de7be2bba18bd29$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $5de7be2bba18bd29$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $5de7be2bba18bd29$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $5de7be2bba18bd29$var$distanceToMatch(el, $5de7be2bba18bd29$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $5de7be2bba18bd29$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $5de7be2bba18bd29$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $5de7be2bba18bd29$var$IGNORED_NODE;
}
function $5de7be2bba18bd29$var$isAncestorRemoved(target, mirror) {
    if ($5de7be2bba18bd29$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $5de7be2bba18bd29$var$isAncestorRemoved(target.parentNode, mirror);
}
function $5de7be2bba18bd29$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $5de7be2bba18bd29$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $5de7be2bba18bd29$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $5de7be2bba18bd29$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $5de7be2bba18bd29$var$hasShadowRoot(n) {
    return Boolean($5de7be2bba18bd29$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $5de7be2bba18bd29$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $5f57bfb89049a269$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $5de7be2bba18bd29$var$getShadowHost(n) {
    let shadowHost = null;
    if ($5de7be2bba18bd29$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $5de7be2bba18bd29$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $5de7be2bba18bd29$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $5de7be2bba18bd29$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $5de7be2bba18bd29$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $5de7be2bba18bd29$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $5de7be2bba18bd29$var$shadowHostInDom(n);
}
const $5de7be2bba18bd29$var$cachedImplementations = {};
function $5de7be2bba18bd29$var$getImplementation(name) {
    const cached = $5de7be2bba18bd29$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $5de7be2bba18bd29$var$cachedImplementations[name] = impl.bind(window);
}
function $5de7be2bba18bd29$var$onRequestAnimationFrame(...rest) {
    return $5de7be2bba18bd29$var$getImplementation("requestAnimationFrame")(...rest);
}
function $5de7be2bba18bd29$var$setTimeout$1(...rest) {
    return $5de7be2bba18bd29$var$getImplementation("setTimeout")(...rest);
}
function $5de7be2bba18bd29$var$clearTimeout$1(...rest) {
    return $5de7be2bba18bd29$var$getImplementation("clearTimeout")(...rest);
}
var $5de7be2bba18bd29$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($5de7be2bba18bd29$var$EventType || {});
var $5de7be2bba18bd29$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($5de7be2bba18bd29$var$IncrementalSource || {});
var $5de7be2bba18bd29$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($5de7be2bba18bd29$var$MouseInteractions || {});
var $5de7be2bba18bd29$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($5de7be2bba18bd29$var$PointerTypes || {});
function $5de7be2bba18bd29$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $5de7be2bba18bd29$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $5de7be2bba18bd29$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $5de7be2bba18bd29$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $5de7be2bba18bd29$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $5de7be2bba18bd29$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $5de7be2bba18bd29$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $5de7be2bba18bd29$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $5de7be2bba18bd29$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $5de7be2bba18bd29$var$IGNORED_NODE;
                while(nextId === $5de7be2bba18bd29$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$5de7be2bba18bd29$var$inDom(n)) return;
                const parentId = $5de7be2bba18bd29$var$isShadowRoot(n.parentNode) ? this.mirror.getId($5de7be2bba18bd29$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $5de7be2bba18bd29$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($5de7be2bba18bd29$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($5de7be2bba18bd29$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($5de7be2bba18bd29$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($5de7be2bba18bd29$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$5de7be2bba18bd29$var$isAncestorInSet(this.droppedSet, n) && !$5de7be2bba18bd29$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($5de7be2bba18bd29$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($5de7be2bba18bd29$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$5de7be2bba18bd29$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $5de7be2bba18bd29$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $5de7be2bba18bd29$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $5de7be2bba18bd29$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $5de7be2bba18bd29$var$getInputValue(target, tagName, type);
                            const isInputMasked = $5de7be2bba18bd29$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $5de7be2bba18bd29$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $5de7be2bba18bd29$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($5de7be2bba18bd29$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$5de7be2bba18bd29$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $5de7be2bba18bd29$var$transformAttribute(this.doc, $5de7be2bba18bd29$var$toLowerCase(target.tagName), $5de7be2bba18bd29$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($5de7be2bba18bd29$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $5de7be2bba18bd29$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($5de7be2bba18bd29$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $5de7be2bba18bd29$var$isIgnored(n, this.mirror) || !$5de7be2bba18bd29$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $5de7be2bba18bd29$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($5de7be2bba18bd29$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$5de7be2bba18bd29$var$moveKey(nodeId, parentId)]) $5de7be2bba18bd29$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $5de7be2bba18bd29$var$isShadowRoot(m.target) && $5de7be2bba18bd29$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($5de7be2bba18bd29$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$5de7be2bba18bd29$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$5de7be2bba18bd29$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($5de7be2bba18bd29$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $5de7be2bba18bd29$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$5de7be2bba18bd29$var$deepDelete(addsSet, childN));
}
function $5de7be2bba18bd29$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $5de7be2bba18bd29$var$_isParentRemoved(removes, n, mirror);
}
function $5de7be2bba18bd29$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $5de7be2bba18bd29$var$_isParentRemoved(removes, parentNode, mirror);
}
function $5de7be2bba18bd29$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $5de7be2bba18bd29$var$_isAncestorInSet(set, n);
}
function $5de7be2bba18bd29$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $5de7be2bba18bd29$var$_isAncestorInSet(set, parentNode);
}
let $5de7be2bba18bd29$var$errorHandler;
function $5de7be2bba18bd29$var$registerErrorHandler(handler) {
    $5de7be2bba18bd29$var$errorHandler = handler;
}
function $5de7be2bba18bd29$var$unregisterErrorHandler() {
    $5de7be2bba18bd29$var$errorHandler = undefined;
}
const $5de7be2bba18bd29$var$callbackWrapper = (cb)=>{
    if (!$5de7be2bba18bd29$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($5de7be2bba18bd29$var$errorHandler && $5de7be2bba18bd29$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $5de7be2bba18bd29$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $5de7be2bba18bd29$var$mutationBuffers = [];
function $5de7be2bba18bd29$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $5de7be2bba18bd29$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $5de7be2bba18bd29$var$MutationBuffer();
    $5de7be2bba18bd29$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $5de7be2bba18bd29$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($5de7be2bba18bd29$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $5de7be2bba18bd29$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $5de7be2bba18bd29$var$throttle$1($5de7be2bba18bd29$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $5de7be2bba18bd29$var$callbackWrapper($5de7be2bba18bd29$var$throttle$1($5de7be2bba18bd29$var$callbackWrapper((evt)=>{
        const target = $5de7be2bba18bd29$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $5de7be2bba18bd29$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $5de7be2bba18bd29$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $5de7be2bba18bd29$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $5de7be2bba18bd29$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $5de7be2bba18bd29$var$IncrementalSource.MouseMove : $5de7be2bba18bd29$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $5de7be2bba18bd29$var$on("mousemove", updatePosition, doc),
        $5de7be2bba18bd29$var$on("touchmove", updatePosition, doc),
        $5de7be2bba18bd29$var$on("drag", updatePosition, doc)
    ];
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $5de7be2bba18bd29$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $5de7be2bba18bd29$var$getEventTarget(event);
            if ($5de7be2bba18bd29$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $5de7be2bba18bd29$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $5de7be2bba18bd29$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $5de7be2bba18bd29$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $5de7be2bba18bd29$var$PointerTypes.Touch) {
                    if ($5de7be2bba18bd29$var$MouseInteractions[eventKey] === $5de7be2bba18bd29$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($5de7be2bba18bd29$var$MouseInteractions[eventKey] === $5de7be2bba18bd29$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $5de7be2bba18bd29$var$PointerTypes.Pen;
            } else if ($5de7be2bba18bd29$var$legacy_isTouchEvent(event)) pointerType = $5de7be2bba18bd29$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $5de7be2bba18bd29$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $5de7be2bba18bd29$var$PointerTypes.Mouse) pointerType = null;
            } else if ($5de7be2bba18bd29$var$MouseInteractions[eventKey] === $5de7be2bba18bd29$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $5de7be2bba18bd29$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $5de7be2bba18bd29$var$callbackWrapper(mouseInteractionCb)({
                type: $5de7be2bba18bd29$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($5de7be2bba18bd29$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $5de7be2bba18bd29$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($5de7be2bba18bd29$var$MouseInteractions[eventKey]){
            case $5de7be2bba18bd29$var$MouseInteractions.MouseDown:
            case $5de7be2bba18bd29$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $5de7be2bba18bd29$var$MouseInteractions.TouchStart:
            case $5de7be2bba18bd29$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($5de7be2bba18bd29$var$on(eventName, handler, doc));
    });
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $5de7be2bba18bd29$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $5de7be2bba18bd29$var$callbackWrapper($5de7be2bba18bd29$var$throttle$1($5de7be2bba18bd29$var$callbackWrapper((evt)=>{
        const target = $5de7be2bba18bd29$var$getEventTarget(evt);
        if (!target || $5de7be2bba18bd29$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $5de7be2bba18bd29$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $5de7be2bba18bd29$var$on("scroll", updatePosition, doc);
}
function $5de7be2bba18bd29$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $5de7be2bba18bd29$var$callbackWrapper($5de7be2bba18bd29$var$throttle$1($5de7be2bba18bd29$var$callbackWrapper(()=>{
        const height = $5de7be2bba18bd29$var$getWindowHeight();
        const width = $5de7be2bba18bd29$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $5de7be2bba18bd29$var$on("resize", updateDimension, win);
}
const $5de7be2bba18bd29$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $5de7be2bba18bd29$var$lastInputValueMap = new WeakMap();
function $5de7be2bba18bd29$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $5de7be2bba18bd29$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $5de7be2bba18bd29$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $5de7be2bba18bd29$var$INPUT_TAGS.indexOf(tagName) < 0 || $5de7be2bba18bd29$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $5de7be2bba18bd29$var$getInputType(target);
        let text = $5de7be2bba18bd29$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $5de7be2bba18bd29$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $5de7be2bba18bd29$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $5de7be2bba18bd29$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $5de7be2bba18bd29$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $5de7be2bba18bd29$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $5de7be2bba18bd29$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $5de7be2bba18bd29$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $5de7be2bba18bd29$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$5de7be2bba18bd29$var$on(eventName, $5de7be2bba18bd29$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$5de7be2bba18bd29$var$hookSetter(p[0], p[1], {
            set () {
                $5de7be2bba18bd29$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $5de7be2bba18bd29$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($5de7be2bba18bd29$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $5de7be2bba18bd29$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $5de7be2bba18bd29$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $5de7be2bba18bd29$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $5de7be2bba18bd29$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $5de7be2bba18bd29$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($5de7be2bba18bd29$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($5de7be2bba18bd29$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($5de7be2bba18bd29$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($5de7be2bba18bd29$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$5de7be2bba18bd29$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$5de7be2bba18bd29$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $5de7be2bba18bd29$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $5de7be2bba18bd29$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $5de7be2bba18bd29$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $5de7be2bba18bd29$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($5de7be2bba18bd29$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $5de7be2bba18bd29$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $5de7be2bba18bd29$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $5de7be2bba18bd29$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId($5de7be2bba18bd29$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $5de7be2bba18bd29$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $5de7be2bba18bd29$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $5de7be2bba18bd29$var$getIdAndStyleId($5de7be2bba18bd29$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $5de7be2bba18bd29$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $5de7be2bba18bd29$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $5de7be2bba18bd29$var$callbackWrapper((type)=>$5de7be2bba18bd29$var$throttle$1($5de7be2bba18bd29$var$callbackWrapper((event)=>{
            const target = $5de7be2bba18bd29$var$getEventTarget(event);
            if (!target || $5de7be2bba18bd29$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $5de7be2bba18bd29$var$on("play", handler(0), doc),
        $5de7be2bba18bd29$var$on("pause", handler(1), doc),
        $5de7be2bba18bd29$var$on("seeked", handler(2), doc),
        $5de7be2bba18bd29$var$on("volumechange", handler(3), doc),
        $5de7be2bba18bd29$var$on("ratechange", handler(4), doc)
    ];
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $5de7be2bba18bd29$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $5de7be2bba18bd29$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $5de7be2bba18bd29$var$setTimeout$1($5de7be2bba18bd29$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $5de7be2bba18bd29$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $5de7be2bba18bd29$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $5de7be2bba18bd29$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $5de7be2bba18bd29$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $5de7be2bba18bd29$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $5de7be2bba18bd29$var$on("selectionchange", updateSelection);
}
function $5de7be2bba18bd29$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $5de7be2bba18bd29$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $5de7be2bba18bd29$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $5de7be2bba18bd29$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $5de7be2bba18bd29$var$initMoveObserver(o);
    const mouseInteractionHandler = $5de7be2bba18bd29$var$initMouseInteractionObserver(o);
    const scrollHandler = $5de7be2bba18bd29$var$initScrollObserver(o);
    const viewportResizeHandler = $5de7be2bba18bd29$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $5de7be2bba18bd29$var$initInputObserver(o);
    const mediaInteractionHandler = $5de7be2bba18bd29$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $5de7be2bba18bd29$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $5de7be2bba18bd29$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $5de7be2bba18bd29$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $5de7be2bba18bd29$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $5de7be2bba18bd29$var$initSelectionObserver(o);
    const customElementObserver = $5de7be2bba18bd29$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $5de7be2bba18bd29$var$callbackWrapper(()=>{
        $5de7be2bba18bd29$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $5de7be2bba18bd29$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $5de7be2bba18bd29$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $5de7be2bba18bd29$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $5de7be2bba18bd29$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $5de7be2bba18bd29$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $5de7be2bba18bd29$var$CrossOriginIframeMirror($5de7be2bba18bd29$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $5de7be2bba18bd29$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $5de7be2bba18bd29$var$CrossOriginIframeMirror($5de7be2bba18bd29$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $5de7be2bba18bd29$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $5de7be2bba18bd29$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $5de7be2bba18bd29$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $5de7be2bba18bd29$var$EventType.Meta:
            case $5de7be2bba18bd29$var$EventType.Load:
            case $5de7be2bba18bd29$var$EventType.DomContentLoaded:
                return false;
            case $5de7be2bba18bd29$var$EventType.Plugin:
                return e;
            case $5de7be2bba18bd29$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $5de7be2bba18bd29$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $5de7be2bba18bd29$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $5de7be2bba18bd29$var$IncrementalSource.Drag:
                    case $5de7be2bba18bd29$var$IncrementalSource.TouchMove:
                    case $5de7be2bba18bd29$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $5de7be2bba18bd29$var$IncrementalSource.ViewportResize:
                        return false;
                    case $5de7be2bba18bd29$var$IncrementalSource.MediaInteraction:
                    case $5de7be2bba18bd29$var$IncrementalSource.MouseInteraction:
                    case $5de7be2bba18bd29$var$IncrementalSource.Scroll:
                    case $5de7be2bba18bd29$var$IncrementalSource.CanvasMutation:
                    case $5de7be2bba18bd29$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $5de7be2bba18bd29$var$IncrementalSource.StyleSheetRule:
                    case $5de7be2bba18bd29$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $5de7be2bba18bd29$var$IncrementalSource.Font:
                        return e;
                    case $5de7be2bba18bd29$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $5de7be2bba18bd29$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $5de7be2bba18bd29$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $5de7be2bba18bd29$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $5de7be2bba18bd29$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $5de7be2bba18bd29$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$5de7be2bba18bd29$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $5de7be2bba18bd29$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($5de7be2bba18bd29$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $5de7be2bba18bd29$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($5de7be2bba18bd29$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($5de7be2bba18bd29$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $5de7be2bba18bd29$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $5de7be2bba18bd29$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $5de7be2bba18bd29$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $5de7be2bba18bd29$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $5de7be2bba18bd29$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $5de7be2bba18bd29$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $5de7be2bba18bd29$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $5de7be2bba18bd29$var$wrappedEmit;
let $5de7be2bba18bd29$var$_takeFullSnapshot;
const $5de7be2bba18bd29$var$mirror = $5de7be2bba18bd29$var$createMirror();
function $5de7be2bba18bd29$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $5de7be2bba18bd29$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $5de7be2bba18bd29$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $5de7be2bba18bd29$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $5de7be2bba18bd29$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $5de7be2bba18bd29$var$nowTimestamp();
        if ((0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
            $5de7be2bba18bd29$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $5de7be2bba18bd29$var$EventType.FullSnapshot && !(e.type === $5de7be2bba18bd29$var$EventType.IncrementalSnapshot && e.data.source === $5de7be2bba18bd29$var$IncrementalSource.Mutation)) $5de7be2bba18bd29$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $5de7be2bba18bd29$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $5de7be2bba18bd29$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $5de7be2bba18bd29$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $5de7be2bba18bd29$var$wrappedEmit({
            type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
            data: {
                source: $5de7be2bba18bd29$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$5de7be2bba18bd29$var$wrappedEmit({
            type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
            data: {
                source: $5de7be2bba18bd29$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$5de7be2bba18bd29$var$wrappedEmit({
            type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
            data: {
                source: $5de7be2bba18bd29$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$5de7be2bba18bd29$var$wrappedEmit({
            type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
            data: {
                source: $5de7be2bba18bd29$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $5de7be2bba18bd29$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $5de7be2bba18bd29$var$IframeManagerNoop() : new $5de7be2bba18bd29$var$IframeManager({
        mirror: $5de7be2bba18bd29$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $5de7be2bba18bd29$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $5de7be2bba18bd29$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $5de7be2bba18bd29$var$ProcessedNodeManager();
    const canvasManager = $5de7be2bba18bd29$var$_getCanvasManager(getCanvasManager, {
        mirror: $5de7be2bba18bd29$var$mirror,
        win: window,
        mutationCb: (p)=>$5de7be2bba18bd29$var$wrappedEmit({
                type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                data: {
                    source: $5de7be2bba18bd29$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $5de7be2bba18bd29$var$ShadowDomManagerNoop() : new $5de7be2bba18bd29$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $5de7be2bba18bd29$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $5de7be2bba18bd29$var$wrappedEmit({
            type: $5de7be2bba18bd29$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $5de7be2bba18bd29$var$getWindowWidth(),
                height: $5de7be2bba18bd29$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $5de7be2bba18bd29$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $5de7be2bba18bd29$var$snapshot(document, {
            mirror: $5de7be2bba18bd29$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($5de7be2bba18bd29$var$isSerializedIframe(n, $5de7be2bba18bd29$var$mirror)) iframeManager.addIframe(n);
                if ($5de7be2bba18bd29$var$isSerializedStylesheet(n, $5de7be2bba18bd29$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($5de7be2bba18bd29$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $5de7be2bba18bd29$var$wrappedEmit({
            type: $5de7be2bba18bd29$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $5de7be2bba18bd29$var$getWindowScroll(window)
            }
        });
        $5de7be2bba18bd29$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $5de7be2bba18bd29$var$mirror.getId(document));
    };
    $5de7be2bba18bd29$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $5de7be2bba18bd29$var$callbackWrapper($5de7be2bba18bd29$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $5de7be2bba18bd29$var$wrappedEmit({
                        type: $5de7be2bba18bd29$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $5de7be2bba18bd29$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $5de7be2bba18bd29$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$5de7be2bba18bd29$var$wrappedEmit({
                                        type: $5de7be2bba18bd29$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($5de7be2bba18bd29$var$on("DOMContentLoaded", ()=>{
                $5de7be2bba18bd29$var$wrappedEmit({
                    type: $5de7be2bba18bd29$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($5de7be2bba18bd29$var$on("load", ()=>{
                $5de7be2bba18bd29$var$wrappedEmit({
                    type: $5de7be2bba18bd29$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $5de7be2bba18bd29$var$_takeFullSnapshot = undefined;
            $5de7be2bba18bd29$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $5de7be2bba18bd29$var$takeFullSnapshot(isCheckout) {
    if (!$5de7be2bba18bd29$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $5de7be2bba18bd29$var$_takeFullSnapshot(isCheckout);
}
$5de7be2bba18bd29$var$record.mirror = $5de7be2bba18bd29$var$mirror;
$5de7be2bba18bd29$var$record.takeFullSnapshot = $5de7be2bba18bd29$var$takeFullSnapshot;
function $5de7be2bba18bd29$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $5de7be2bba18bd29$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $5de7be2bba18bd29$var$CanvasManagerNoop();
    }
}
const $5de7be2bba18bd29$var$ReplayEventTypeIncrementalSnapshot = 3;
const $5de7be2bba18bd29$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $5de7be2bba18bd29$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $5de7be2bba18bd29$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $5de7be2bba18bd29$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $5de7be2bba18bd29$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $9ca32e18a091d955$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $5de7be2bba18bd29$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $5de7be2bba18bd29$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($5de7be2bba18bd29$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $5de7be2bba18bd29$var$getClickTargetNode(event) {
    const target = $5de7be2bba18bd29$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $5de7be2bba18bd29$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $5de7be2bba18bd29$var$getTargetNode(event) {
    if ($5de7be2bba18bd29$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $5de7be2bba18bd29$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $5de7be2bba18bd29$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $5de7be2bba18bd29$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$5de7be2bba18bd29$var$handlers) {
        $5de7be2bba18bd29$var$handlers = [];
        $5de7be2bba18bd29$var$monkeyPatchWindowOpen();
    }
    $5de7be2bba18bd29$var$handlers.push(cb);
    return ()=>{
        const pos = $5de7be2bba18bd29$var$handlers ? $5de7be2bba18bd29$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $5de7be2bba18bd29$var$handlers.splice(pos, 1);
    };
}
function $5de7be2bba18bd29$var$monkeyPatchWindowOpen() {
    (0, $e628e125e878fd27$export$9563e054e6f787fb)($5de7be2bba18bd29$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($5de7be2bba18bd29$var$handlers) try {
                $5de7be2bba18bd29$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($5de7be2bba18bd29$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $5de7be2bba18bd29$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $5de7be2bba18bd29$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $5de7be2bba18bd29$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $5de7be2bba18bd29$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $5de7be2bba18bd29$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($5de7be2bba18bd29$var$ignoreElement(node, this._ignoreSelector) || !$5de7be2bba18bd29$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $5de7be2bba18bd29$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $5de7be2bba18bd29$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $5de7be2bba18bd29$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $5de7be2bba18bd29$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $5de7be2bba18bd29$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $5de7be2bba18bd29$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $5de7be2bba18bd29$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $5de7be2bba18bd29$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $5de7be2bba18bd29$var$ignoreElement(node, ignoreSelector) {
    if (!$5de7be2bba18bd29$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $5de7be2bba18bd29$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $5de7be2bba18bd29$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $5de7be2bba18bd29$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$5de7be2bba18bd29$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $5de7be2bba18bd29$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $5de7be2bba18bd29$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($5de7be2bba18bd29$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $5de7be2bba18bd29$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $5de7be2bba18bd29$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $5de7be2bba18bd29$var$isIncrementalEvent(event) {
    return event.type === $5de7be2bba18bd29$var$ReplayEventTypeIncrementalSnapshot;
}
function $5de7be2bba18bd29$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $5de7be2bba18bd29$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $5de7be2bba18bd29$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $5de7be2bba18bd29$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($5de7be2bba18bd29$var$NodeType || ($5de7be2bba18bd29$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $5de7be2bba18bd29$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $5de7be2bba18bd29$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($5de7be2bba18bd29$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $5de7be2bba18bd29$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $5de7be2bba18bd29$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $5de7be2bba18bd29$var$handleClick(replay.clickDetector, result, $5de7be2bba18bd29$var$getClickTargetNode(handlerData.event));
        $5de7be2bba18bd29$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $5de7be2bba18bd29$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $5de7be2bba18bd29$var$record.mirror.getId(target);
    const node = nodeId && $5de7be2bba18bd29$var$record.mirror.getNode(nodeId);
    const meta = node && $5de7be2bba18bd29$var$record.mirror.getMeta(node);
    const element = meta && $5de7be2bba18bd29$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $5de7be2bba18bd29$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $5de7be2bba18bd29$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $5de7be2bba18bd29$var$handleDom(handlerData) {
    const { target: target, message: message } = $5de7be2bba18bd29$var$getDomTarget(handlerData);
    return $5de7be2bba18bd29$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$5de7be2bba18bd29$var$getBaseDomBreadcrumb(target, message)
    });
}
function $5de7be2bba18bd29$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $5de7be2bba18bd29$var$getClickTargetNode(handlerData.event) : $5de7be2bba18bd29$var$getTargetNode(handlerData.event);
        message = (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $5de7be2bba18bd29$var$isElement(node) {
    return node.type === $5de7be2bba18bd29$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $5de7be2bba18bd29$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $5de7be2bba18bd29$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $5de7be2bba18bd29$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $5de7be2bba18bd29$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $5de7be2bba18bd29$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $d3dd25a69ce66c78$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $5de7be2bba18bd29$var$getBaseDomBreadcrumb(target, message);
    return $5de7be2bba18bd29$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $5de7be2bba18bd29$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $5de7be2bba18bd29$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $5de7be2bba18bd29$var$createResourceEntry,
    paint: $5de7be2bba18bd29$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $5de7be2bba18bd29$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $5de7be2bba18bd29$var$createPerformanceEntries(entries) {
    return entries.map($5de7be2bba18bd29$var$createPerformanceEntry).filter(Boolean);
}
function $5de7be2bba18bd29$var$createPerformanceEntry(entry) {
    if (!$5de7be2bba18bd29$var$ENTRY_TYPES[entry.entryType]) return null;
    return $5de7be2bba18bd29$var$ENTRY_TYPES[entry.entryType](entry);
}
function $5de7be2bba18bd29$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $91c304fc757d5e0f$export$baf075a948ffc0bf) || $5de7be2bba18bd29$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $5de7be2bba18bd29$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $5de7be2bba18bd29$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $5de7be2bba18bd29$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $5de7be2bba18bd29$var$getAbsoluteTime(startTime),
        end: $5de7be2bba18bd29$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $5de7be2bba18bd29$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $5de7be2bba18bd29$var$getAbsoluteTime(startTime),
        end: $5de7be2bba18bd29$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $5de7be2bba18bd29$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $5de7be2bba18bd29$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $5de7be2bba18bd29$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $5de7be2bba18bd29$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $8b02f76565f096cc$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $8b02f76565f096cc$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($5de7be2bba18bd29$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5de7be2bba18bd29$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $5de7be2bba18bd29$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $5de7be2bba18bd29$var$e() {
    const e = new Blob([
        $5de7be2bba18bd29$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $5de7be2bba18bd29$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$5de7be2bba18bd29$var$DEBUG_BUILD) return;
    (0, $3199231328e69de5$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $5de7be2bba18bd29$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $5de7be2bba18bd29$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$5de7be2bba18bd29$var$DEBUG_BUILD) return;
    (0, $3199231328e69de5$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $5de7be2bba18bd29$var$addLogBreadcrumb(message);
    }, 0);
}
function $5de7be2bba18bd29$var$addLogBreadcrumb(message) {
    (0, $81a395368bb6f380$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $5de7be2bba18bd29$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$5de7be2bba18bd29$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $5de7be2bba18bd29$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $5de7be2bba18bd29$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $5de7be2bba18bd29$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $5de7be2bba18bd29$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $5de7be2bba18bd29$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $5de7be2bba18bd29$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $5de7be2bba18bd29$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $5de7be2bba18bd29$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $5de7be2bba18bd29$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $5de7be2bba18bd29$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $5de7be2bba18bd29$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $5de7be2bba18bd29$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $5de7be2bba18bd29$var$EventBufferArray();
        this._compression = new $5de7be2bba18bd29$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $5de7be2bba18bd29$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $5de7be2bba18bd29$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $5de7be2bba18bd29$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $5de7be2bba18bd29$var$logInfo("[Replay] Using simple buffer");
    return new $5de7be2bba18bd29$var$EventBufferArray();
}
function $5de7be2bba18bd29$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $5de7be2bba18bd29$var$_getWorkerUrl();
        if (!workerUrl) return;
        $5de7be2bba18bd29$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $5de7be2bba18bd29$var$EventBufferProxy(worker);
    } catch (error) {
        $5de7be2bba18bd29$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $5de7be2bba18bd29$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $5de7be2bba18bd29$var$e();
    return "";
}
/** If sessionStorage is available. */ function $5de7be2bba18bd29$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $5de7be2bba18bd29$var$WINDOW && !!$5de7be2bba18bd29$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $5de7be2bba18bd29$var$clearSession(replay) {
    $5de7be2bba18bd29$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $5de7be2bba18bd29$var$deleteSession() {
    if (!$5de7be2bba18bd29$var$hasSessionStorage()) return;
    try {
        $5de7be2bba18bd29$var$WINDOW.sessionStorage.removeItem($5de7be2bba18bd29$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $5de7be2bba18bd29$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $5de7be2bba18bd29$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $806ed7b2edb8ea09$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $5de7be2bba18bd29$var$saveSession(session) {
    if (!$5de7be2bba18bd29$var$hasSessionStorage()) return;
    try {
        $5de7be2bba18bd29$var$WINDOW.sessionStorage.setItem($5de7be2bba18bd29$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $5de7be2bba18bd29$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $5de7be2bba18bd29$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $5de7be2bba18bd29$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $5de7be2bba18bd29$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $5de7be2bba18bd29$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $5de7be2bba18bd29$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $5de7be2bba18bd29$var$fetchSession(traceInternals) {
    if (!$5de7be2bba18bd29$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $5de7be2bba18bd29$var$WINDOW.sessionStorage.getItem($5de7be2bba18bd29$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $5de7be2bba18bd29$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $5de7be2bba18bd29$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $5de7be2bba18bd29$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $5de7be2bba18bd29$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $5de7be2bba18bd29$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $5de7be2bba18bd29$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $5de7be2bba18bd29$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$5de7be2bba18bd29$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $5de7be2bba18bd29$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $5de7be2bba18bd29$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $5de7be2bba18bd29$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $5de7be2bba18bd29$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$5de7be2bba18bd29$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $5de7be2bba18bd29$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $5de7be2bba18bd29$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $5de7be2bba18bd29$var$isCustomEvent(event) {
    return event.type === $5de7be2bba18bd29$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $5de7be2bba18bd29$var$addEventSync(replay, event, isCheckout) {
    if (!$5de7be2bba18bd29$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $5de7be2bba18bd29$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $5de7be2bba18bd29$var$addEvent(replay, event, isCheckout) {
    if (!$5de7be2bba18bd29$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $5de7be2bba18bd29$var$_addEvent(replay, event, isCheckout);
}
async function $5de7be2bba18bd29$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $5de7be2bba18bd29$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $5de7be2bba18bd29$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $5de7be2bba18bd29$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $5de7be2bba18bd29$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $5de7be2bba18bd29$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $5de7be2bba18bd29$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $5de7be2bba18bd29$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $5de7be2bba18bd29$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $5de7be2bba18bd29$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $5de7be2bba18bd29$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $5de7be2bba18bd29$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $5de7be2bba18bd29$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $5de7be2bba18bd29$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$5de7be2bba18bd29$var$isErrorEvent(event) && !$5de7be2bba18bd29$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($5de7be2bba18bd29$var$isTransactionEvent(event)) {
            $5de7be2bba18bd29$var$handleTransactionEvent(replay, event);
            return;
        }
        $5de7be2bba18bd29$var$handleErrorEvent(replay, event);
    };
}
function $5de7be2bba18bd29$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $5de7be2bba18bd29$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $5de7be2bba18bd29$var$isBaseTransportSend() {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $5de7be2bba18bd29$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$5de7be2bba18bd29$var$isErrorEvent(event)) return;
        $5de7be2bba18bd29$var$handleHydrationError(replay, event);
    };
}
function $5de7be2bba18bd29$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $5de7be2bba18bd29$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $5de7be2bba18bd29$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $5de7be2bba18bd29$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $5de7be2bba18bd29$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $5de7be2bba18bd29$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $5de7be2bba18bd29$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $5de7be2bba18bd29$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $5de7be2bba18bd29$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $5de7be2bba18bd29$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $5de7be2bba18bd29$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($5de7be2bba18bd29$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$5de7be2bba18bd29$var$isErrorEvent(event) && !$5de7be2bba18bd29$var$isTransactionEvent(event) && !$5de7be2bba18bd29$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($5de7be2bba18bd29$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $5de7be2bba18bd29$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($5de7be2bba18bd29$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $5de7be2bba18bd29$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $5de7be2bba18bd29$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $5de7be2bba18bd29$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $5de7be2bba18bd29$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $5de7be2bba18bd29$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $5de7be2bba18bd29$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $5de7be2bba18bd29$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $5de7be2bba18bd29$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($5de7be2bba18bd29$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $0fe6168822a98917$export$d92e61f5600202af)(url, (0, $81a395368bb6f380$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $5de7be2bba18bd29$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($5de7be2bba18bd29$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $5de7be2bba18bd29$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $5de7be2bba18bd29$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $5de7be2bba18bd29$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $5de7be2bba18bd29$var$handleFetch(handlerData);
        $5de7be2bba18bd29$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $5de7be2bba18bd29$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $5de7be2bba18bd29$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $5de7be2bba18bd29$var$handleXhr(handlerData);
        $5de7be2bba18bd29$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $5de7be2bba18bd29$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $5de7be2bba18bd29$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $5de7be2bba18bd29$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $5de7be2bba18bd29$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $5de7be2bba18bd29$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $5de7be2bba18bd29$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $5de7be2bba18bd29$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $e628e125e878fd27$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $5de7be2bba18bd29$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $5de7be2bba18bd29$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $5de7be2bba18bd29$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $5de7be2bba18bd29$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $5de7be2bba18bd29$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $5de7be2bba18bd29$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $5de7be2bba18bd29$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $5de7be2bba18bd29$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $5de7be2bba18bd29$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $5de7be2bba18bd29$var$urlMatches(url, urls) {
    const fullUrl = $5de7be2bba18bd29$var$getFullUrl(url);
    return (0, $692fb1c9fae23fc3$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $5de7be2bba18bd29$var$getFullUrl(url, baseURI = $5de7be2bba18bd29$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($5de7be2bba18bd29$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $5de7be2bba18bd29$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $5de7be2bba18bd29$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $5de7be2bba18bd29$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $5de7be2bba18bd29$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $5de7be2bba18bd29$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $5de7be2bba18bd29$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $5de7be2bba18bd29$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $5de7be2bba18bd29$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $5de7be2bba18bd29$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $5de7be2bba18bd29$var$urlMatches(url, options.networkDetailAllowUrls) && !$5de7be2bba18bd29$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $5de7be2bba18bd29$var$_getRequestInfo(options, hint.input, requestBodySize) : $5de7be2bba18bd29$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $5de7be2bba18bd29$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $5de7be2bba18bd29$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $5de7be2bba18bd29$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $5de7be2bba18bd29$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $5de7be2bba18bd29$var$getBodyString(requestBody);
    const data = $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $5de7be2bba18bd29$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $5de7be2bba18bd29$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $5de7be2bba18bd29$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $5de7be2bba18bd29$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $5de7be2bba18bd29$var$_parseFetchResponseBody(response);
    const result = $5de7be2bba18bd29$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $5de7be2bba18bd29$var$mergeWarning(result, warning);
    return result;
}
function $5de7be2bba18bd29$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $5de7be2bba18bd29$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $5de7be2bba18bd29$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $5de7be2bba18bd29$var$_parseFetchResponseBody(response) {
    const res = $5de7be2bba18bd29$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $5de7be2bba18bd29$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $5de7be2bba18bd29$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $5de7be2bba18bd29$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $5de7be2bba18bd29$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $5de7be2bba18bd29$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $5de7be2bba18bd29$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $5de7be2bba18bd29$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $5de7be2bba18bd29$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $5de7be2bba18bd29$var$getAllowedHeaders(headers, allowedHeaders);
}
function $5de7be2bba18bd29$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $5de7be2bba18bd29$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $5de7be2bba18bd29$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $5de7be2bba18bd29$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $5de7be2bba18bd29$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $5de7be2bba18bd29$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $5de7be2bba18bd29$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $5de7be2bba18bd29$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $5de7be2bba18bd29$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $5de7be2bba18bd29$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $5de7be2bba18bd29$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $5de7be2bba18bd29$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $5de7be2bba18bd29$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$5de7be2bba18bd29$var$urlMatches(url, options.networkDetailAllowUrls) || $5de7be2bba18bd29$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $5de7be2bba18bd29$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $5de7be2bba18bd29$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $5de7be2bba18bd29$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $5de7be2bba18bd29$var$getAllowedHeaders($5de7be2bba18bd29$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $5de7be2bba18bd29$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $5de7be2bba18bd29$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $5de7be2bba18bd29$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $5de7be2bba18bd29$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $5de7be2bba18bd29$var$mergeWarning(response, responseWarning) : response
    };
}
function $5de7be2bba18bd29$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $5de7be2bba18bd29$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $5de7be2bba18bd29$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $5de7be2bba18bd29$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $5de7be2bba18bd29$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $5de7be2bba18bd29$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $5de7be2bba18bd29$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$5de7be2bba18bd29$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)($5de7be2bba18bd29$var$handleFetchSpanListener(replay));
            (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)($5de7be2bba18bd29$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $5de7be2bba18bd29$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($5de7be2bba18bd29$var$_isXhrBreadcrumb(breadcrumb) && $5de7be2bba18bd29$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $5de7be2bba18bd29$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $5de7be2bba18bd29$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($5de7be2bba18bd29$var$_isFetchBreadcrumb(breadcrumb) && $5de7be2bba18bd29$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $5de7be2bba18bd29$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $5de7be2bba18bd29$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $5de7be2bba18bd29$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $5de7be2bba18bd29$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $5de7be2bba18bd29$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $5de7be2bba18bd29$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $5de7be2bba18bd29$var$_LAST_BREADCRUMB = null;
function $5de7be2bba18bd29$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $5de7be2bba18bd29$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $5de7be2bba18bd29$var$handleScope(scope);
        if (!result) return;
        $5de7be2bba18bd29$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $5de7be2bba18bd29$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($5de7be2bba18bd29$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $5de7be2bba18bd29$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$5de7be2bba18bd29$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $5de7be2bba18bd29$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $5de7be2bba18bd29$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $5de7be2bba18bd29$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $5de7be2bba18bd29$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $5de7be2bba18bd29$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $5de7be2bba18bd29$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $9ca32e18a091d955$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $5de7be2bba18bd29$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $5de7be2bba18bd29$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $5de7be2bba18bd29$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $5de7be2bba18bd29$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    scope.addScopeListener($5de7be2bba18bd29$var$handleScopeListener(replay));
    (0, $6dad95eb90f2d36c$export$5aeffd3db2cf9df7)($5de7be2bba18bd29$var$handleDomListener(replay));
    (0, $2579aac1b9dfd189$export$3f18c56c58114e75)($5de7be2bba18bd29$var$handleHistorySpanListener(replay));
    $5de7be2bba18bd29$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $5de7be2bba18bd29$var$handleGlobalEventListener(replay, !$5de7be2bba18bd29$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $5d4a5f71b683f78e$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($5de7be2bba18bd29$var$hasHooks(client)) {
        client.on("beforeSendEvent", $5de7be2bba18bd29$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $5de7be2bba18bd29$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5de7be2bba18bd29$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $5de7be2bba18bd29$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($5de7be2bba18bd29$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $5de7be2bba18bd29$var$createMemoryEntry($5de7be2bba18bd29$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $5de7be2bba18bd29$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $5de7be2bba18bd29$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $5de7be2bba18bd29$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $5de7be2bba18bd29$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$5de7be2bba18bd29$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $5de7be2bba18bd29$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $5de7be2bba18bd29$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $5de7be2bba18bd29$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $5de7be2bba18bd29$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $5de7be2bba18bd29$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $5de7be2bba18bd29$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $5de7be2bba18bd29$var$addEventSync(replay, $5de7be2bba18bd29$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $5de7be2bba18bd29$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)((0, $2cae643f899492f0$export$92b6093782fe661b)(replayEvent, (0, $2cae643f899492f0$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $5de7be2bba18bd29$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $5de7be2bba18bd29$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $7b0dad5cf366cc16$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $9007972943bbf579$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $5de7be2bba18bd29$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $5de7be2bba18bd29$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const scope = (0, $81a395368bb6f380$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $5de7be2bba18bd29$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $5de7be2bba18bd29$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $5de7be2bba18bd29$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $5de7be2bba18bd29$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($5de7be2bba18bd29$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $5de7be2bba18bd29$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $e02662e4aa308398$export$699aff705e0d49d4)({}, response);
    if ((0, $e02662e4aa308398$export$6c91fec22056810a)(rateLimits, "replay")) throw new $5de7be2bba18bd29$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $5de7be2bba18bd29$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $5de7be2bba18bd29$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $5de7be2bba18bd29$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $5de7be2bba18bd29$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $5de7be2bba18bd29$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $5de7be2bba18bd29$var$TransportStatusCodeError || err instanceof $5de7be2bba18bd29$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $81a395368bb6f380$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($5de7be2bba18bd29$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $81a395368bb6f380$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $5de7be2bba18bd29$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$5de7be2bba18bd29$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $5de7be2bba18bd29$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $5de7be2bba18bd29$var$THROTTLED = "__THROTTLED";
const $5de7be2bba18bd29$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5de7be2bba18bd29$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $5de7be2bba18bd29$var$SKIPPED : $5de7be2bba18bd29$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $5de7be2bba18bd29$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $5de7be2bba18bd29$var$ReplayContainer.prototype.__init.call(this);
        $5de7be2bba18bd29$var$ReplayContainer.prototype.__init2.call(this);
        $5de7be2bba18bd29$var$ReplayContainer.prototype.__init3.call(this);
        $5de7be2bba18bd29$var$ReplayContainer.prototype.__init4.call(this);
        $5de7be2bba18bd29$var$ReplayContainer.prototype.__init5.call(this);
        $5de7be2bba18bd29$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $5de7be2bba18bd29$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $5de7be2bba18bd29$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $5de7be2bba18bd29$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $5de7be2bba18bd29$var$throttle((event, isCheckout)=>$5de7be2bba18bd29$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($5de7be2bba18bd29$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $5de7be2bba18bd29$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $5de7be2bba18bd29$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $5de7be2bba18bd29$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $5de7be2bba18bd29$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $5de7be2bba18bd29$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $5de7be2bba18bd29$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $5de7be2bba18bd29$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $5de7be2bba18bd29$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $5de7be2bba18bd29$var$BUFFER_CHECKOUT_TIME
                },
                emit: $5de7be2bba18bd29$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $5de7be2bba18bd29$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $5de7be2bba18bd29$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $5de7be2bba18bd29$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $5de7be2bba18bd29$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $5de7be2bba18bd29$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $5de7be2bba18bd29$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$5de7be2bba18bd29$var$WINDOW.location.pathname}${$5de7be2bba18bd29$var$WINDOW.location.hash}${$5de7be2bba18bd29$var$WINDOW.location.search}`;
        const url = `${$5de7be2bba18bd29$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $5de7be2bba18bd29$var$THROTTLED) {
            const breadcrumb = $5de7be2bba18bd29$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$5de7be2bba18bd29$var$addEventSync(this, {
                    type: $5de7be2bba18bd29$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $81a395368bb6f380$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $e047a3e652f57c75$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $033619b8172dea69$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $e047a3e652f57c75$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $5de7be2bba18bd29$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay]", error);
        if ($5de7be2bba18bd29$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $81a395368bb6f380$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $5de7be2bba18bd29$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($5de7be2bba18bd29$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $5de7be2bba18bd29$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $5de7be2bba18bd29$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $5de7be2bba18bd29$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $5de7be2bba18bd29$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $5de7be2bba18bd29$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $5de7be2bba18bd29$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $5de7be2bba18bd29$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $5de7be2bba18bd29$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $5de7be2bba18bd29$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $5de7be2bba18bd29$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($5de7be2bba18bd29$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $5de7be2bba18bd29$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $5de7be2bba18bd29$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $5de7be2bba18bd29$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $5de7be2bba18bd29$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $5de7be2bba18bd29$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $5de7be2bba18bd29$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $5de7be2bba18bd29$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($5de7be2bba18bd29$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $5de7be2bba18bd29$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $5de7be2bba18bd29$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $5de7be2bba18bd29$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $5de7be2bba18bd29$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $5de7be2bba18bd29$var$DEBUG_BUILD && (0, $3199231328e69de5$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $5de7be2bba18bd29$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $5de7be2bba18bd29$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $5de7be2bba18bd29$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $5de7be2bba18bd29$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $5de7be2bba18bd29$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $5de7be2bba18bd29$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $5de7be2bba18bd29$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $5de7be2bba18bd29$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $5de7be2bba18bd29$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $5de7be2bba18bd29$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $5de7be2bba18bd29$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $5de7be2bba18bd29$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $5de7be2bba18bd29$var$_initialized = false;
const $5de7be2bba18bd29$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $5de7be2bba18bd29$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $5de7be2bba18bd29$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $5de7be2bba18bd29$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $5de7be2bba18bd29$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $5de7be2bba18bd29$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $5de7be2bba18bd29$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $5de7be2bba18bd29$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $5de7be2bba18bd29$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$5de7be2bba18bd29$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $5de7be2bba18bd29$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $5de7be2bba18bd29$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $5de7be2bba18bd29$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $5de7be2bba18bd29$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $5de7be2bba18bd29$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$5de7be2bba18bd29$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $12807b614cb38f74$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $5de7be2bba18bd29$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $5de7be2bba18bd29$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $12807b614cb38f74$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $5de7be2bba18bd29$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $5de7be2bba18bd29$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$5de7be2bba18bd29$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $5de7be2bba18bd29$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $e628e125e878fd27$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $3199231328e69de5$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $5de7be2bba18bd29$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$5de7be2bba18bd29$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $5de7be2bba18bd29$export$81cc0d0f72285d1() {
    const client = (0, $81a395368bb6f380$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $5de7be2bba18bd29$export$b28310b2f161456b = $5de7be2bba18bd29$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $5de7be2bba18bd29$export$d7706faf7ab354bf = $5de7be2bba18bd29$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $5de7be2bba18bd29$export$a35c789ed37ee0f7 extends $5de7be2bba18bd29$export$6b59b88de1ff9cb7 {
}




var $acw62 = parcelRequire("acw62");
// src/utils.ts

var $acw62 = parcelRequire("acw62");
function $a166571f9c69a3c9$export$257a8862b851cb5b(component) {
    return (0, $acw62.forwardRef)(component);
}
var $a166571f9c69a3c9$export$21e0669b7bd01bb4 = (obj)=>{
    return {
        ...obj,
        [Symbol.iterator]: function() {
            const keys = Object.keys(this);
            let index = 0;
            return {
                next: ()=>{
                    if (index >= keys.length) return {
                        done: true
                    };
                    const key = keys[index];
                    const value = this[key];
                    index++;
                    return {
                        value: {
                            key: key,
                            value: value
                        },
                        done: false
                    };
                }
            };
        }
    };
};
var $a166571f9c69a3c9$export$9f203ede2b8cf905 = (props, variantKeys, removeVariantProps = true)=>{
    if (!variantKeys) return [
        props,
        {}
    ];
    const picked = variantKeys.reduce((acc, key)=>{
        if (key in props) return {
            ...acc,
            [key]: props[key]
        };
        else return acc;
    }, {});
    if (removeVariantProps) {
        const omitted = Object.keys(props).filter((key)=>!variantKeys.includes(key)).reduce((acc, key)=>({
                ...acc,
                [key]: props[key]
            }), {});
        return [
            omitted,
            picked
        ];
    } else return [
        props,
        picked
    ];
};
var $a166571f9c69a3c9$export$ab8830944406cf18 = (originalProps, variantKeys, commonKeys)=>{
    const props = Object.keys(originalProps).filter((key)=>!variantKeys.includes(key) || (commonKeys == null ? void 0 : commonKeys.includes(key))).reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    const variants = variantKeys.reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    return [
        props,
        variants
    ];
};
var $a166571f9c69a3c9$export$749da038d9da17ac = (component)=>{
    var _a, _b, _c;
    return !!((_c = (_b = (_a = component.type) == null ? void 0 : _a.render) == null ? void 0 : _b.displayName) == null ? void 0 : _c.includes("NextUI"));
};


// src/index.ts

var $acw62 = parcelRequire("acw62");
var $71777250bd01414e$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


// src/utils/tw-merge-config.ts
var $2d6e47f9353c21fc$export$7c071ef0138dc46e = [
    "small",
    "medium",
    "large"
];
var $2d6e47f9353c21fc$export$c5ce76624eaef353 = {
    theme: {
        opacity: [
            "disabled"
        ],
        spacing: [
            "divider"
        ],
        borderWidth: $2d6e47f9353c21fc$export$7c071ef0138dc46e,
        borderRadius: $2d6e47f9353c21fc$export$7c071ef0138dc46e
    },
    classGroups: {
        shadow: [
            {
                shadow: $2d6e47f9353c21fc$export$7c071ef0138dc46e
            }
        ],
        "font-size": [
            {
                text: [
                    "tiny",
                    ...$2d6e47f9353c21fc$export$7c071ef0138dc46e
                ]
            }
        ],
        "bg-image": [
            "bg-stripe-gradient"
        ]
    }
};


var $d9c820282a8f797f$export$407448d2b89b1813 = (e)=>typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, $d9c820282a8f797f$export$8b22cf2602fb60ce = (e)=>!e || typeof e != "object" || Object.keys(e).length === 0, $d9c820282a8f797f$export$db3b6bfb95261072 = (e, o)=>JSON.stringify(e) === JSON.stringify(o), $d9c820282a8f797f$export$4368d992c4eafac0 = (e)=>typeof e == "boolean";
function $d9c820282a8f797f$var$i(e, o) {
    e.forEach(function(r) {
        Array.isArray(r) ? $d9c820282a8f797f$var$i(r, o) : o.push(r);
    });
}
function $d9c820282a8f797f$export$f1e1789686576879(e) {
    let o = [];
    return $d9c820282a8f797f$var$i(e, o), o;
}
var $d9c820282a8f797f$export$2d1720544b23b823 = (...e)=>$d9c820282a8f797f$export$f1e1789686576879(e).filter(Boolean), $d9c820282a8f797f$export$39b482c5e57630a8 = (e, o)=>{
    let r = {}, c = Object.keys(e), f = Object.keys(o);
    for (let t of c)if (f.includes(t)) {
        let s = e[t], n = o[t];
        typeof s == "object" && typeof n == "object" ? r[t] = $d9c820282a8f797f$export$39b482c5e57630a8(s, n) : Array.isArray(s) || Array.isArray(n) ? r[t] = $d9c820282a8f797f$export$2d1720544b23b823(n, s) : r[t] = n + " " + s;
    } else r[t] = e[t];
    for (let t of f)c.includes(t) || (r[t] = o[t]);
    return r;
}, $d9c820282a8f797f$export$dda1d9f60106f0e9 = (e)=>!e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();


var $6fe39473f79edd5d$var$CLASS_PART_SEPARATOR = "-";
function $6fe39473f79edd5d$export$e3a687438e51f555(config) {
    var classMap = $6fe39473f79edd5d$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($6fe39473f79edd5d$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $6fe39473f79edd5d$var$getGroupRecursive(classParts, classMap) || $6fe39473f79edd5d$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $6fe39473f79edd5d$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $6fe39473f79edd5d$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($6fe39473f79edd5d$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })?.classGroupId;
}
var $6fe39473f79edd5d$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $6fe39473f79edd5d$var$getGroupIdForArbitraryProperty(className) {
    if ($6fe39473f79edd5d$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $6fe39473f79edd5d$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $6fe39473f79edd5d$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $6fe39473f79edd5d$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $6fe39473f79edd5d$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $6fe39473f79edd5d$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $6fe39473f79edd5d$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($6fe39473f79edd5d$var$isThemeGetter(classDefinition)) {
                $6fe39473f79edd5d$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $6fe39473f79edd5d$var$processClassesRecursively(classGroup, $6fe39473f79edd5d$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $6fe39473f79edd5d$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($6fe39473f79edd5d$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $6fe39473f79edd5d$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $6fe39473f79edd5d$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}


// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $499c6fae6347238f$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}


var $cf10e98293f5f016$export$61823b46426d06fa = "!";
function $cf10e98293f5f016$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($cf10e98293f5f016$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $cf10e98293f5f016$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}


function $529461a79111f2fe$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $499c6fae6347238f$export$cf6a7cbaa5f64437)(config.cacheSize),
        splitModifiers: (0, $cf10e98293f5f016$export$b5f40ac45a8dd583)(config),
        ...(0, $6fe39473f79edd5d$export$e3a687438e51f555)(config)
    };
}



var $9f647259dd697655$var$SPLIT_CLASSES_REGEX = /\s+/;
function $9f647259dd697655$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($9f647259dd697655$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $cf10e98293f5f016$export$4f247a60f8a83b3a)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $cf10e98293f5f016$export$61823b46426d06fa) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}


/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $87e021186079174d$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $87e021186079174d$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $87e021186079174d$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $87e021186079174d$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}


function $fa9bd8b14116ab2a$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $529461a79111f2fe$export$56ab4ba5b0b25eb0)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $9f647259dd697655$export$b41084d9255a3248)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $87e021186079174d$export$a8bbfb445e1f163f).apply(null, arguments));
    };
}


function $a52a1b18a3ddddc6$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}


var $fb8ea216051326af$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $fb8ea216051326af$var$fractionRegex = /^\d+\/\d+$/;
var $fb8ea216051326af$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $fb8ea216051326af$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $fb8ea216051326af$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $fb8ea216051326af$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $fb8ea216051326af$export$38db3d147cb3433(value) {
    return $fb8ea216051326af$export$7e4aa119212bc614(value) || $fb8ea216051326af$var$stringLengths.has(value) || $fb8ea216051326af$var$fractionRegex.test(value) || $fb8ea216051326af$export$f5e3af6d4c0fbe38(value);
}
function $fb8ea216051326af$export$f5e3af6d4c0fbe38(value) {
    return $fb8ea216051326af$var$getIsArbitraryValue(value, "length", $fb8ea216051326af$var$isLengthOnly);
}
function $fb8ea216051326af$export$92dbd3a305a7cb8b(value) {
    return $fb8ea216051326af$var$getIsArbitraryValue(value, "size", $fb8ea216051326af$var$isNever);
}
function $fb8ea216051326af$export$57d00f225f425549(value) {
    return $fb8ea216051326af$var$getIsArbitraryValue(value, "position", $fb8ea216051326af$var$isNever);
}
function $fb8ea216051326af$export$478a5386e985802b(value) {
    return $fb8ea216051326af$var$getIsArbitraryValue(value, "url", $fb8ea216051326af$var$isUrl);
}
function $fb8ea216051326af$export$ea45ce4f1b2d6088(value) {
    return $fb8ea216051326af$var$getIsArbitraryValue(value, "number", $fb8ea216051326af$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $fb8ea216051326af$export$cd3ce15f42623f06 = $fb8ea216051326af$export$ea45ce4f1b2d6088;
function $fb8ea216051326af$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $fb8ea216051326af$export$e50269385c77c348(value) {
    return value.endsWith("%") && $fb8ea216051326af$export$7e4aa119212bc614(value.slice(0, -1));
}
function $fb8ea216051326af$export$a287f47fed4544b8(value) {
    return $fb8ea216051326af$var$isIntegerOnly(value) || $fb8ea216051326af$var$getIsArbitraryValue(value, "number", $fb8ea216051326af$var$isIntegerOnly);
}
function $fb8ea216051326af$export$5534a8576501817d(value) {
    return $fb8ea216051326af$var$arbitraryValueRegex.test(value);
}
function $fb8ea216051326af$export$ebb65efc98a3b5f7() {
    return true;
}
function $fb8ea216051326af$export$a40791c6b7db5bcc(value) {
    return $fb8ea216051326af$var$tshirtUnitRegex.test(value);
}
function $fb8ea216051326af$export$d01106465b385604(value) {
    return $fb8ea216051326af$var$getIsArbitraryValue(value, "", $fb8ea216051326af$var$isShadow);
}
function $fb8ea216051326af$var$getIsArbitraryValue(value, label, testValue) {
    var result = $fb8ea216051326af$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $fb8ea216051326af$var$isLengthOnly(value) {
    return $fb8ea216051326af$var$lengthUnitRegex.test(value);
}
function $fb8ea216051326af$var$isNever() {
    return false;
}
function $fb8ea216051326af$var$isUrl(value) {
    return value.startsWith("url(");
}
function $fb8ea216051326af$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $fb8ea216051326af$var$isShadow(value) {
    return $fb8ea216051326af$var$shadowRegex.test(value);
}


function $f9424f0be2e01416$export$ed30944e0fe6ae5c() {
    var colors = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("colors");
    var spacing = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("spacing");
    var blur = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("blur");
    var brightness = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("brightness");
    var borderColor = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("borderColor");
    var borderRadius = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("borderRadius");
    var borderSpacing = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("borderSpacing");
    var borderWidth = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("borderWidth");
    var contrast = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("contrast");
    var grayscale = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("grayscale");
    var hueRotate = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("hueRotate");
    var invert = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("invert");
    var gap = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("gap");
    var gradientColorStops = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("gradientColorStops");
    var gradientColorStopPositions = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("gradientColorStopPositions");
    var inset = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("inset");
    var margin = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("margin");
    var opacity = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("opacity");
    var padding = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("padding");
    var saturate = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("saturate");
    var scale = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("scale");
    var sepia = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("sepia");
    var skew = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("skew");
    var space = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("space");
    var translate = (0, $a52a1b18a3ddddc6$export$e176af7b8eefe933)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $fb8ea216051326af$export$5534a8576501817d),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $fb8ea216051326af$export$5534a8576501817d),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $fb8ea216051326af$export$38db3d147cb3433)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $fb8ea216051326af$export$7e4aa119212bc614),
            (0, $fb8ea216051326af$export$5534a8576501817d)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $fb8ea216051326af$export$5534a8576501817d)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $fb8ea216051326af$export$7e4aa119212bc614),
            (0, $fb8ea216051326af$export$ea45ce4f1b2d6088)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $fb8ea216051326af$export$7e4aa119212bc614),
            (0, $fb8ea216051326af$export$5534a8576501817d)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $fb8ea216051326af$export$ebb65efc98a3b5f7)
            ],
            spacing: [
                (0, $fb8ea216051326af$export$38db3d147cb3433)
            ],
            blur: [
                "none",
                "",
                (0, $fb8ea216051326af$export$a40791c6b7db5bcc),
                (0, $fb8ea216051326af$export$5534a8576501817d)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $fb8ea216051326af$export$a40791c6b7db5bcc),
                (0, $fb8ea216051326af$export$5534a8576501817d)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $fb8ea216051326af$export$e50269385c77c348),
                (0, $fb8ea216051326af$export$f5e3af6d4c0fbe38)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $fb8ea216051326af$export$a40791c6b7db5bcc)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $fb8ea216051326af$export$a287f47fed4544b8)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $fb8ea216051326af$export$a287f47fed4544b8)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $fb8ea216051326af$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $fb8ea216051326af$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $fb8ea216051326af$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $fb8ea216051326af$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $fb8ea216051326af$export$a40791c6b7db5bcc)
                            ]
                        },
                        (0, $fb8ea216051326af$export$a40791c6b7db5bcc),
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $fb8ea216051326af$export$a40791c6b7db5bcc),
                        (0, $fb8ea216051326af$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $fb8ea216051326af$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $fb8ea216051326af$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $fb8ea216051326af$export$7e4aa119212bc614),
                        (0, $fb8ea216051326af$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $fb8ea216051326af$export$57d00f225f425549)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $fb8ea216051326af$export$92dbd3a305a7cb8b)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $fb8ea216051326af$export$478a5386e985802b)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $fb8ea216051326af$export$5534a8576501817d),
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $fb8ea216051326af$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $fb8ea216051326af$export$a40791c6b7db5bcc),
                        (0, $fb8ea216051326af$export$d01106465b385604)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $fb8ea216051326af$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $fb8ea216051326af$export$a40791c6b7db5bcc),
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $fb8ea216051326af$export$a287f47fed4544b8),
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $fb8ea216051326af$export$5534a8576501817d)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $fb8ea216051326af$export$38db3d147cb3433),
                        (0, $fb8ea216051326af$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}


/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $b69f27535bb55e8b$export$5d86b86a654a7039(baseConfig, configExtension) {
    for(var key in configExtension)$b69f27535bb55e8b$var$mergePropertyRecursively(baseConfig, key, configExtension[key]);
    return baseConfig;
}
var $b69f27535bb55e8b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b69f27535bb55e8b$var$overrideTypes = /*#__PURE__*/ new Set([
    "string",
    "number",
    "boolean"
]);
function $b69f27535bb55e8b$var$mergePropertyRecursively(baseObject, mergeKey, mergeValue) {
    if (!$b69f27535bb55e8b$var$hasOwnProperty.call(baseObject, mergeKey) || $b69f27535bb55e8b$var$overrideTypes.has(typeof mergeValue) || mergeValue === null) {
        baseObject[mergeKey] = mergeValue;
        return;
    }
    if (Array.isArray(mergeValue) && Array.isArray(baseObject[mergeKey])) {
        baseObject[mergeKey] = baseObject[mergeKey].concat(mergeValue);
        return;
    }
    if (typeof mergeValue === "object" && typeof baseObject[mergeKey] === "object") {
        if (baseObject[mergeKey] === null) {
            baseObject[mergeKey] = mergeValue;
            return;
        }
        for(var nextKey in mergeValue)$b69f27535bb55e8b$var$mergePropertyRecursively(baseObject[mergeKey], nextKey, mergeValue[nextKey]);
    }
}


function $b5ef9c5a82c48798$export$c8d8406b6cd2243e(configExtension) {
    for(var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)createConfig[_key - 1] = arguments[_key];
    return typeof configExtension === "function" ? (0, $fa9bd8b14116ab2a$export$ea2d4fba4d1bd27f).apply(void 0, [
        (0, $f9424f0be2e01416$export$ed30944e0fe6ae5c),
        configExtension
    ].concat(createConfig)) : (0, $fa9bd8b14116ab2a$export$ea2d4fba4d1bd27f).apply(void 0, [
        function() {
            return (0, $b69f27535bb55e8b$export$5d86b86a654a7039)((0, $f9424f0be2e01416$export$ed30944e0fe6ae5c)(), configExtension);
        }
    ].concat(createConfig));
}



var $cb87cd23bdb77aee$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $fa9bd8b14116ab2a$export$ea2d4fba4d1bd27f)((0, $f9424f0be2e01416$export$ed30944e0fe6ae5c));


var $94fbda8a2a522bb7$export$f84bd70098573c5c = {
    twMerge: !0,
    twMergeConfig: {},
    responsiveVariants: !1
}, $94fbda8a2a522bb7$export$b2b720306681cd4b = (s)=>s || void 0, $94fbda8a2a522bb7$export$bdb9d1405dbffd0f = (...s)=>$94fbda8a2a522bb7$export$b2b720306681cd4b((0, $d9c820282a8f797f$export$f1e1789686576879)(s).filter(Boolean).join(" ")), $94fbda8a2a522bb7$var$q = null, $94fbda8a2a522bb7$var$M = {}, $94fbda8a2a522bb7$var$F = !1, $94fbda8a2a522bb7$export$1343a74baacb0543 = (...s)=>(b$1)=>b$1.twMerge ? ((!$94fbda8a2a522bb7$var$q || $94fbda8a2a522bb7$var$F) && ($94fbda8a2a522bb7$var$F = !1, $94fbda8a2a522bb7$var$q = (0, $d9c820282a8f797f$export$8b22cf2602fb60ce)($94fbda8a2a522bb7$var$M) ? (0, $cb87cd23bdb77aee$export$b4660bb6000dfbc9) : (0, $b5ef9c5a82c48798$export$c8d8406b6cd2243e)($94fbda8a2a522bb7$var$M)), $94fbda8a2a522bb7$export$b2b720306681cd4b($94fbda8a2a522bb7$var$q($94fbda8a2a522bb7$export$bdb9d1405dbffd0f(s)))) : $94fbda8a2a522bb7$export$bdb9d1405dbffd0f(s), $94fbda8a2a522bb7$var$Z = (s, b)=>{
    for(let e in b)s.hasOwnProperty(e) ? s[e] = $94fbda8a2a522bb7$export$bdb9d1405dbffd0f(s[e], b[e]) : s[e] = b[e];
    return s;
}, $94fbda8a2a522bb7$export$984d890fc49ac622 = (s, b$1)=>{
    let { extend: e = null, slots: j = {}, variants: U = {}, compoundVariants: C = [], compoundSlots: V = [], defaultVariants: W = {} } = s, m = {
        ...$94fbda8a2a522bb7$export$f84bd70098573c5c,
        ...b$1
    }, S = e != null && e.base ? $94fbda8a2a522bb7$export$bdb9d1405dbffd0f(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !(0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(e.variants) ? (0, $d9c820282a8f797f$export$39b482c5e57630a8)(U, e.variants) : U, A = e != null && e.defaultVariants && !(0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(e.defaultVariants) ? {
        ...e.defaultVariants,
        ...W
    } : W;
    !(0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(m.twMergeConfig) && !(0, $d9c820282a8f797f$export$db3b6bfb95261072)(m.twMergeConfig, $94fbda8a2a522bb7$var$M) && ($94fbda8a2a522bb7$var$F = !0, $94fbda8a2a522bb7$var$M = m.twMergeConfig);
    let O = (0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(e == null ? void 0 : e.slots), $ = (0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(j) ? {} : {
        base: $94fbda8a2a522bb7$export$bdb9d1405dbffd0f(s == null ? void 0 : s.base, O && (e == null ? void 0 : e.base)),
        ...j
    }, h$1 = O ? $ : $94fbda8a2a522bb7$var$Z({
        ...e == null ? void 0 : e.slots
    }, (0, $d9c820282a8f797f$export$8b22cf2602fb60ce)($) ? {
        base: s == null ? void 0 : s.base
    } : $), v = (l)=>{
        if ((0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(g$1) && (0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(j) && O) return $94fbda8a2a522bb7$export$1343a74baacb0543(S, l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
        if (C && !Array.isArray(C)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof C}`);
        if (V && !Array.isArray(V)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof V}`);
        let K = (t, n, a = [], i)=>{
            let r = a;
            if (typeof n == "string") r = r.concat((0, $d9c820282a8f797f$export$dda1d9f60106f0e9)(n).split(" ").map((c)=>`${t}:${c}`));
            else if (Array.isArray(n)) r = r.concat(n.reduce((c, f)=>c.concat(`${t}:${f}`), []));
            else if (typeof n == "object" && typeof i == "string") {
                for(let c in n)if (n.hasOwnProperty(c) && c === i) {
                    let f = n[c];
                    if (f && typeof f == "string") {
                        let o = (0, $d9c820282a8f797f$export$dda1d9f60106f0e9)(f);
                        r[i] ? r[i] = r[i].concat(o.split(" ").map((u)=>`${t}:${u}`)) : r[i] = o.split(" ").map((u)=>`${t}:${u}`);
                    } else Array.isArray(f) && f.length > 0 && (r[i] = f.reduce((o, u)=>o.concat(`${t}:${u}`), []));
                }
            }
            return r;
        }, z = (t, n = g$1, a$1 = null, i = null)=>{
            var J;
            let r = n[t];
            if (!r || (0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(r)) return null;
            let c = (J = i == null ? void 0 : i[t]) != null ? J : l == null ? void 0 : l[t];
            if (c === null) return null;
            let f = (0, $d9c820282a8f797f$export$407448d2b89b1813)(c), o = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === !0, u = A == null ? void 0 : A[t], d = [];
            if (typeof f == "object" && o) for (let [k, L] of Object.entries(f)){
                let ae = r[L];
                if (k === "initial") {
                    u = L;
                    continue;
                }
                Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(k) || (d = K(k, ae, d, a$1));
            }
            let T = r[f] || r[(0, $d9c820282a8f797f$export$407448d2b89b1813)(u)];
            return typeof d == "object" && typeof a$1 == "string" && d[a$1] ? $94fbda8a2a522bb7$var$Z(d, T) : d.length > 0 ? (d.push(T), d) : T;
        }, P = ()=>g$1 ? Object.keys(g$1).map((t)=>z(t, g$1)) : null, p = (t, n)=>{
            if (!g$1 || typeof g$1 != "object") return null;
            let a = new Array;
            for(let i in g$1){
                let r = z(i, g$1, t, n), c = t === "base" && typeof r == "string" ? r : r && r[t];
                c && (a[a.length] = c);
            }
            return a;
        }, D = {};
        for(let t in l)l[t] !== void 0 && (D[t] = l[t]);
        let G = (t, n)=>{
            var i;
            let a = typeof (l == null ? void 0 : l[t]) == "object" ? {
                [t]: (i = l[t]) == null ? void 0 : i.initial
            } : {};
            return {
                ...A,
                ...D,
                ...a,
                ...n
            };
        }, H = (t = [], n)=>{
            let a = [];
            for (let { class: i, className: r, ...c } of t){
                let f = !0;
                for (let [o, u] of Object.entries(c)){
                    let d = G(o, n);
                    if (Array.isArray(u)) {
                        if (!u.includes(d[o])) {
                            f = !1;
                            break;
                        }
                    } else if (d[o] !== u) {
                        f = !1;
                        break;
                    }
                }
                f && (i && a.push(i), r && a.push(r));
            }
            return a;
        }, I = (t)=>{
            let n = H(C, t), a = H(e == null ? void 0 : e.compoundVariants, t);
            return (0, $d9c820282a8f797f$export$2d1720544b23b823)(a, n);
        }, ee = (t)=>{
            let n = I(t);
            if (!Array.isArray(n)) return n;
            let a = {};
            for (let i of n)if (typeof i == "string" && (a.base = $94fbda8a2a522bb7$export$1343a74baacb0543(a.base, i)(m)), typeof i == "object") for (let [r, c] of Object.entries(i))a[r] = $94fbda8a2a522bb7$export$1343a74baacb0543(a[r], c)(m);
            return a;
        }, te = (t)=>{
            if (V.length < 1) return null;
            let n = {};
            for (let { slots: a = [], class: i, className: r, ...c } of V){
                if (!(0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(c)) {
                    let f = !0;
                    for (let o of Object.keys(c)){
                        let u = G(o, t)[o];
                        if (u === void 0 || (Array.isArray(c[o]) ? !c[o].includes(u) : c[o] !== u)) {
                            f = !1;
                            break;
                        }
                    }
                    if (!f) continue;
                }
                for (let f of a)n[f] = n[f] || [], n[f].push([
                    i,
                    r
                ]);
            }
            return n;
        };
        if (!(0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(j) || !O) {
            let t = {};
            if (typeof h$1 == "object" && !(0, $d9c820282a8f797f$export$8b22cf2602fb60ce)(h$1)) for (let n of Object.keys(h$1))t[n] = (a)=>{
                var i, r;
                return $94fbda8a2a522bb7$export$1343a74baacb0543(h$1[n], p(n, a), ((i = ee(a)) != null ? i : [])[n], ((r = te(a)) != null ? r : [])[n], a == null ? void 0 : a.class, a == null ? void 0 : a.className)(m);
            };
            return t;
        }
        return $94fbda8a2a522bb7$export$1343a74baacb0543(S, P(), I(), l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
    }, x = ()=>{
        if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
    };
    return v.variantKeys = x(), v.extend = e, v.base = S, v.slots = h$1, v.variants = g$1, v.defaultVariants = A, v.compoundSlots = V, v.compoundVariants = C, v;
}, $94fbda8a2a522bb7$export$cc73e0e70ed8b709 = (s)=>(b, e)=>$94fbda8a2a522bb7$export$984d890fc49ac622(b, e ? (0, $d9c820282a8f797f$export$39b482c5e57630a8)(s, e) : s);


var $ff90aca5bea9a9da$export$984d890fc49ac622 = (options, config)=>{
    var _a, _b, _c;
    return (0, $94fbda8a2a522bb7$export$984d890fc49ac622)(options, {
        ...config,
        twMerge: (_a = config == null ? void 0 : config.twMerge) != null ? _a : true,
        twMergeConfig: {
            ...config == null ? void 0 : config.twMergeConfig,
            theme: {
                ...(_b = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _b.theme,
                ...(0, $2d6e47f9353c21fc$export$c5ce76624eaef353).theme
            },
            classGroups: {
                ...(_c = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _c.classGroups,
                ...(0, $2d6e47f9353c21fc$export$c5ce76624eaef353).classGroups
            }
        }
    });
};


// src/components/autocomplete.ts
var $4ed1752e3ad2a002$export$485ded5f26ebe08d = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "group inline-flex flex-column w-full",
        listboxWrapper: "scroll-py-6 max-h-64 w-full",
        listbox: "",
        popoverContent: "w-full p-1 overflow-hidden",
        endContentWrapper: "relative flex h-full items-center -mr-2",
        clearButton: [
            "text-medium",
            "translate-x-1",
            "cursor-text",
            "opacity-0",
            "text-default-500",
            "group-data-[invalid=true]:text-danger",
            "data-[visible=true]:opacity-100",
            "data-[visible=true]:cursor-pointer",
            "sm:data-[visible=true]:opacity-0",
            "sm:group-data-[hover=true]:data-[visible=true]:opacity-100"
        ],
        selectorButton: "text-medium"
    },
    variants: {
        isClearable: {
            true: {},
            false: {
                clearButton: "hidden"
            }
        },
        disableAnimation: {
            true: {
                selectorButton: "transition-none"
            },
            false: {
                selectorButton: "transition-transform duration-150 ease motion-reduce:transition-none"
            }
        },
        disableSelectorIconRotation: {
            true: {},
            false: {
                selectorButton: "data-[open=true]:rotate-180"
            }
        }
    },
    defaultVariants: {
        isClearable: true,
        disableSelectorIconRotation: false
    }
});



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $42a2eb2bd28e75db$var$$325a3faab7a68acd$var$cache = new Map();
function $42a2eb2bd28e75db$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($42a2eb2bd28e75db$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $42a2eb2bd28e75db$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $42a2eb2bd28e75db$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $14b37b1eb7391728$export$3274cf84b703fff(options) {
    let collator = (0, $42a2eb2bd28e75db$export$a16aca283550c30d)({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $acw62.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $81bdb3f3d704c389$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$81bdb3f3d704c389$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $81bdb3f3d704c389$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $81bdb3f3d704c389$export$aca958c65c314e6c,
    validationErrors: []
};
const $81bdb3f3d704c389$export$571b5131b7e65c11 = (0, $acw62.createContext)({});
const $81bdb3f3d704c389$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $81bdb3f3d704c389$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$81bdb3f3d704c389$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$81bdb3f3d704c389$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = "aria" } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $acw62.useMemo)(()=>$81bdb3f3d704c389$var$$e5be200c675c3b3a$var$getValidationResult($81bdb3f3d704c389$var$$e5be200c675c3b3a$var$runValidate(validate, value)), [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    let serverErrors = (0, $acw62.useContext)($81bdb3f3d704c389$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $acw62.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$81bdb3f3d704c389$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $acw62.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $acw62.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $acw62.useMemo)(()=>$81bdb3f3d704c389$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $acw62.useRef)($81bdb3f3d704c389$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $acw62.useState)($81bdb3f3d704c389$export$dad6ae84456c676a);
    let lastError = (0, $acw62.useRef)($81bdb3f3d704c389$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$81bdb3f3d704c389$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $81bdb3f3d704c389$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$81bdb3f3d704c389$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $81bdb3f3d704c389$export$dad6ae84456c676a;
            if (!$81bdb3f3d704c389$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        let e = validate(value);
        if (e && typeof e !== "boolean") return $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $81bdb3f3d704c389$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $81bdb3f3d704c389$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$81bdb3f3d704c389$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f2e2cae04a4a64ed$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $f2e2cae04a4a64ed$export$fbdeaa6a76694f71(iterable) {
    return $f2e2cae04a4a64ed$export$5f3398f8733f90e2(iterable, 0);
}
function $f2e2cae04a4a64ed$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $f2e2cae04a4a64ed$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $f2e2cae04a4a64ed$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$f2e2cae04a4a64ed$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$f2e2cae04a4a64ed$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $f2e2cae04a4a64ed$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $fa74693f45c63bb2$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $770c3ab343de3bae$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $770c3ab343de3bae$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a9a1508285573e48$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $a9a1508285573e48$export$fbdeaa6a76694f71(iterable) {
    return $a9a1508285573e48$export$5f3398f8733f90e2(iterable, 0);
}
function $a9a1508285573e48$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $a9a1508285573e48$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $a9a1508285573e48$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$a9a1508285573e48$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$a9a1508285573e48$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $a9a1508285573e48$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5c11c5ee2979fbfd$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $a9a1508285573e48$export$8c434b3a7a4dad6)(this.collection, item, first) < 0) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $a9a1508285573e48$export$8c434b3a7a4dad6)(this.collection, item, last) > 0) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new (0, $770c3ab343de3bae$export$52baac22726c72bf)([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new (0, $770c3ab343de3bae$export$52baac22726c72bf)(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $a9a1508285573e48$export$8c434b3a7a4dad6)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new (0, $770c3ab343de3bae$export$52baac22726c72bf)(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new (0, $770c3ab343de3bae$export$52baac22726c72bf)([
            key
        ], key, key) : new (0, $770c3ab343de3bae$export$52baac22726c72bf)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new (0, $770c3ab343de3bae$export$52baac22726c72bf)();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key != null){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys((0, $a9a1508285573e48$export$fbdeaa6a76694f71)((0, $a9a1508285573e48$export$1005530eda016c13)(item, this.collection)).key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $770c3ab343de3bae$export$52baac22726c72bf)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        var _item_props;
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    getItemProps(key) {
        var _this_collection_getItem;
        return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $aa08176befc1eac4$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $acw62.useState)(value || defaultValue);
    let isControlledRef = (0, $acw62.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $acw62.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $acw62.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d9a874fb3bf4546a$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $d9a874fb3bf4546a$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none", disallowEmptySelection: disallowEmptySelection, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = "toggle", disabledBehavior: disabledBehavior = "all" } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $acw62.useRef)(false);
    let [, setFocused] = (0, $acw62.useState)(false);
    let focusedKeyRef = (0, $acw62.useRef)(null);
    let childFocusStrategyRef = (0, $acw62.useRef)(null);
    let [, setFocusedKey] = (0, $acw62.useState)(null);
    let selectedKeysProp = (0, $acw62.useMemo)(()=>$d9a874fb3bf4546a$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $acw62.useMemo)(()=>$d9a874fb3bf4546a$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $770c3ab343de3bae$export$52baac22726c72bf)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $aa08176befc1eac4$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $acw62.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $acw62.useRef)(selectionBehaviorProp);
    (0, $acw62.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$d9a874fb3bf4546a$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $d9a874fb3bf4546a$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new (0, $770c3ab343de3bae$export$52baac22726c72bf)(selection);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $65c4bb992a6baf01$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $65c4bb992a6baf01$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fdcbc319f3a11c20$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $acw62.useMemo)(()=>new (0, $65c4bb992a6baf01$export$bf788dd355e3a401)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $acw62.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3eb881aaecc1e120$export$2f645645f7bca764(props) {
    let { filter: filter } = props;
    let selectionState = (0, $d9a874fb3bf4546a$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $acw62.useCallback)((nodes)=>filter ? new (0, $fa74693f45c63bb2$export$d085fb9e920b5ca7)(filter(nodes)) : new (0, $fa74693f45c63bb2$export$d085fb9e920b5ca7)(nodes), [
        filter
    ]);
    let context = (0, $acw62.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $fdcbc319f3a11c20$export$6cd28814d92fa9c9)(props, factory, context);
    let selectionManager = (0, $acw62.useMemo)(()=>new (0, $5c11c5ee2979fbfd$export$6c8a5aaad13c9852)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $aeb9a1fd28de218f$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $acw62.useState)(value || defaultValue);
    let isControlledRef = (0, $acw62.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $acw62.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $acw62.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $11e167d4228171fe$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $acw62.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = (0, $3eb881aaecc1e120$export$2f645645f7bca764)({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $13a9827b1c7dcaf2$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $acw62.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $acw62.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7f43098d72b85ea6$export$b453a3bfd4a5fa9e(props) {
    var _collection_getItem, _collection_getItem1;
    let { defaultFilter: defaultFilter, menuTrigger: menuTrigger = "input", allowsEmptyCollection: allowsEmptyCollection = false, allowsCustomValue: allowsCustomValue, shouldCloseOnBlur: shouldCloseOnBlur = true } = props;
    let [showAllItems, setShowAllItems] = (0, $acw62.useState)(false);
    let [isFocused, setFocusedState] = (0, $acw62.useState)(false);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let onSelectionChange = (key)=>{
        if (props.onSelectionChange) props.onSelectionChange(key);
        // If key is the same, reset the inputValue and close the menu
        // (scenario: user clicks on already selected option)
        if (key === selectedKey) {
            resetInputValue();
            closeMenu();
        }
    };
    var _props_items;
    let { collection: collection, selectionManager: selectionManager, selectedKey: selectedKey, setSelectedKey: setSelectedKey, selectedItem: selectedItem, disabledKeys: disabledKeys } = (0, $11e167d4228171fe$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: onSelectionChange,
        items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
    });
    var _props_defaultInputValue, _ref;
    let [inputValue, setInputValue] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.inputValue, (_ref = (_props_defaultInputValue = props.defaultInputValue) !== null && _props_defaultInputValue !== void 0 ? _props_defaultInputValue : (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _ref !== void 0 ? _ref : "", props.onInputChange);
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (0, $acw62.useMemo)(()=>props.items != null || !defaultFilter ? collection : $7f43098d72b85ea6$var$$a9e7382a7d111cb5$var$filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    let [lastCollection, setLastCollection] = (0, $acw62.useState)(filteredCollection);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (0, $acw62.useRef)("focus");
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
        selectionManager.setFocused(open);
        if (!open) selectionManager.setFocusedKey(null);
    };
    let triggerState = (0, $13a9827b1c7dcaf2$export$61c6a8c84e605fb6)({
        ...props,
        onOpenChange: onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            setFocusStrategy(focusStrategy);
            triggerState.open();
        }
    };
    let toggle = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        toggleMenu(focusStrategy);
    };
    let updateLastCollection = (0, $acw62.useCallback)(()=>{
        setLastCollection(showAllItems ? originalCollection : filteredCollection);
    }, [
        showAllItems,
        originalCollection,
        filteredCollection
    ]);
    // If menu is going to close, save the current collection so we can freeze the displayed collection when the
    // user clicks outside the popover to close the menu. Prevents the menu contents from updating as the menu closes.
    let toggleMenu = (0, $acw62.useCallback)((focusStrategy = null)=>{
        if (triggerState.isOpen) updateLastCollection();
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
    }, [
        triggerState,
        updateLastCollection
    ]);
    let closeMenu = (0, $acw62.useCallback)(()=>{
        if (triggerState.isOpen) {
            updateLastCollection();
            triggerState.close();
        }
    }, [
        triggerState,
        updateLastCollection
    ]);
    let [lastValue, setLastValue] = (0, $acw62.useState)(inputValue);
    let resetInputValue = ()=>{
        var _collection_getItem;
        var _collection_getItem_textValue;
        let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        setLastValue(itemText);
        setInputValue(itemText);
    };
    var _props_selectedKey, _ref1;
    let lastSelectedKey = (0, $acw62.useRef)((_ref1 = (_props_selectedKey = props.selectedKey) !== null && _props_selectedKey !== void 0 ? _props_selectedKey : props.defaultSelectedKey) !== null && _ref1 !== void 0 ? _ref1 : null);
    var _collection_getItem_textValue;
    let lastSelectedKeyText = (0, $acw62.useRef)((_collection_getItem_textValue = (_collection_getItem1 = collection.getItem(selectedKey)) === null || _collection_getItem1 === void 0 ? void 0 : _collection_getItem1.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "");
    (0, $acw62.useEffect)(()=>{
        var _collection_getItem;
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue && menuTrigger !== "manual") open(null, "input");
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) closeMenu();
        // Close when an item is selected.
        if (selectedKey != null && selectedKey !== lastSelectedKey.current) closeMenu();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set selectedKey to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (inputValue === "" && (props.inputValue === undefined || props.selectedKey === undefined)) setSelectedKey(null);
        }
        // If the selectedKey changed, update the input value.
        // Do nothing if both inputValue and selectedKey are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (selectedKey !== lastSelectedKey.current && (props.inputValue === undefined || props.selectedKey === undefined)) resetInputValue();
        else if (lastValue !== inputValue) setLastValue(inputValue);
        var _collection_getItem_textValue;
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastSelectedKey.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                setLastValue(selectedItemText);
                setInputValue(selectedItemText);
            }
        }
        lastSelectedKey.current = selectedKey;
        lastSelectedKeyText.current = selectedItemText;
    });
    let validation = (0, $81bdb3f3d704c389$export$fc1a364ae1f3ff10)({
        ...props,
        value: (0, $acw62.useMemo)(()=>({
                inputValue: inputValue,
                selectedKey: selectedKey
            }), [
            inputValue,
            selectedKey
        ])
    });
    // Revert input value and close menu
    let revert = ()=>{
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        lastSelectedKey.current = null;
        setSelectedKey(null);
        closeMenu();
    };
    let commitSelection = ()=>{
        // If multiple things are controlled, call onSelectionChange
        if (props.selectedKey !== undefined && props.inputValue !== undefined) {
            var _collection_getItem;
            props.onSelectionChange(selectedKey);
            var _collection_getItem_textValue;
            // Stop menu from reopening from useEffect
            let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            setLastValue(itemText);
            closeMenu();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            closeMenu();
        }
    };
    const commitValue = ()=>{
        if (allowsCustomValue) {
            var _collection_getItem;
            var _collection_getItem_textValue;
            const itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            inputValue === itemText ? commitSelection() : commitCustomValue();
        } else commitSelection();
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectedKey === selectionManager.focusedKey) commitSelection();
            else setSelectedKey(selectionManager.focusedKey);
        } else commitValue();
    };
    let valueOnFocus = (0, $acw62.useRef)(inputValue);
    let setFocused = (isFocused)=>{
        if (isFocused) {
            valueOnFocus.current = inputValue;
            if (menuTrigger === "focus") open(null, "focus");
        } else {
            if (shouldCloseOnBlur) commitValue();
            if (inputValue !== valueOnFocus.current) validation.commitValidation();
        }
        setFocusedState(isFocused);
    };
    let displayedCollection = (0, $acw62.useMemo)(()=>{
        if (triggerState.isOpen) {
            if (showAllItems) return originalCollection;
            else return filteredCollection;
        } else return lastCollection;
    }, [
        triggerState.isOpen,
        originalCollection,
        filteredCollection,
        showAllItems,
        lastCollection
    ]);
    return {
        ...validation,
        ...triggerState,
        focusStrategy: focusStrategy,
        toggle: toggle,
        open: open,
        close: commitValue,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        disabledKeys: disabledKeys,
        isFocused: isFocused,
        setFocused: setFocused,
        selectedItem: selectedItem,
        collection: displayedCollection,
        inputValue: inputValue,
        setInputValue: setInputValue,
        commit: commit,
        revert: revert
    };
}
function $7f43098d72b85ea6$var$$a9e7382a7d111cb5$var$filterCollection(collection, inputValue, filter) {
    return new (0, $fa74693f45c63bb2$export$d085fb9e920b5ca7)($7f43098d72b85ea6$var$$a9e7382a7d111cb5$var$filterNodes(collection, collection, inputValue, filter));
}
function $7f43098d72b85ea6$var$$a9e7382a7d111cb5$var$filterNodes(collection, nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === "section" && node.hasChildNodes) {
            let filtered = $7f43098d72b85ea6$var$$a9e7382a7d111cb5$var$filterNodes(collection, (0, $f2e2cae04a4a64ed$export$1005530eda016c13)(node, collection), inputValue, filter);
            if ([
                ...filtered
            ].some((node)=>node.type === "item")) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type === "item" && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
        else if (node.type !== "item") filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $1bd7f9c4cf7b22f6$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $1bd7f9c4cf7b22f6$export$4e09c449d6c407f7 = $1bd7f9c4cf7b22f6$export$71594e8a50f746f4();
function $1bd7f9c4cf7b22f6$export$6ffcd379b2770ab0(navigator) {
    const { userAgent: ua, vendor: vendor } = navigator;
    const android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $1bd7f9c4cf7b22f6$export$54dee9623b75428b(navigator) {
    const { userAgent: ua, platform: platform } = navigator;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $1bd7f9c4cf7b22f6$export$568a7d21694b4b32(navigator) {
    const { userAgent: ua } = navigator;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $1bd7f9c4cf7b22f6$export$3070bd282ec37ea8(os) {
    if (!$1bd7f9c4cf7b22f6$export$4e09c449d6c407f7) return false;
    return $1bd7f9c4cf7b22f6$export$54dee9623b75428b(window.navigator) === os;
}
function $1bd7f9c4cf7b22f6$export$2d31490a0c05f094(browser) {
    if (!$1bd7f9c4cf7b22f6$export$4e09c449d6c407f7) return false;
    return $1bd7f9c4cf7b22f6$export$6ffcd379b2770ab0(window.navigator) === browser;
}
function $1bd7f9c4cf7b22f6$export$8d04c8cf4d9e22d8() {
    if (!$1bd7f9c4cf7b22f6$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $1bd7f9c4cf7b22f6$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $1bd7f9c4cf7b22f6$export$79d69eee6ae4b329(domRef, focusableRef = domRef) {
    return {
        ...$1bd7f9c4cf7b22f6$export$a5795cc979dfae80(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8(ref) {
    const domRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>domRef.current);
    return domRef;
}
function $1bd7f9c4cf7b22f6$export$96a734597687c040(ref, focusableRef) {
    const domRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>$1bd7f9c4cf7b22f6$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $1bd7f9c4cf7b22f6$export$4debdb1a3f0fa79e(context, ref) {
    (0, $acw62.useLayoutEffect)(()=>{
        if (context && context.ref && ref && ref.current) {
            context.ref.current = ref.current;
            return ()=>{
                var _a;
                if ((_a = context.ref) == null ? void 0 : _a.current) context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}
function $1bd7f9c4cf7b22f6$export$33e83fe63cd475d5(rect1, rect2) {
    return rect1 && rect2 && rect1.x < rect2.x + rect2.width && rect1.x + rect1.width > rect2.x && rect1.y < rect2.y + rect2.height && rect1.y + rect1.height > rect2.y;
}



var $acw62 = parcelRequire("acw62");
// src/clsx.ts
function $f78e4903178d7a09$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $f78e4903178d7a09$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $f78e4903178d7a09$export$4f5d2d50c9deca37(...args) {
    var i = 0, tmp, x, str = "";
    while(i < args.length){
        if (tmp = args[i++]) {
            if (x = $f78e4903178d7a09$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

// src/assertion.ts
var $337b0bbaace84edd$export$a866f231438cc228 = false;
var $337b0bbaace84edd$export$61cb32cff9a99948 = false;
function $337b0bbaace84edd$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $337b0bbaace84edd$export$4c0262a4f954db45(value) {
    return $337b0bbaace84edd$export$43bee75e5e14138e(value) && value.length === 0;
}
function $337b0bbaace84edd$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$337b0bbaace84edd$export$43bee75e5e14138e(value);
}
function $337b0bbaace84edd$export$83b788b1a3698c03(value) {
    return $337b0bbaace84edd$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $337b0bbaace84edd$export$dd1bc94b04021eeb(value) {
    if ($337b0bbaace84edd$export$43bee75e5e14138e(value)) return $337b0bbaace84edd$export$4c0262a4f954db45(value);
    if ($337b0bbaace84edd$export$a6cdc56e425d0d0a(value)) return $337b0bbaace84edd$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
function $337b0bbaace84edd$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
var $337b0bbaace84edd$export$5cc3b7b83e34ade7 = (condition)=>condition ? "true" : void 0;
var $337b0bbaace84edd$export$e90fb89750dba83f = (value)=>value != null && parseInt(value.toString(), 10) > 0;

// src/functions.ts
var $91ffd9bd684fd1b9$export$9a00dee1beb8f576 = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function $91ffd9bd684fd1b9$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $91ffd9bd684fd1b9$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
function $91ffd9bd684fd1b9$export$bb64030b028b5009(key, defaultValue, ...objs) {
    let result = defaultValue;
    for (const obj of objs)if (obj && key in obj && !!obj[key]) result = obj[key];
    return result;
}
function $91ffd9bd684fd1b9$export$b8ba5815f1bdad68(prefix) {
    return `${prefix}-${Math.floor(Math.random() * 1e6)}`;
}
function $91ffd9bd684fd1b9$export$da5f6eb3bb522cd(input) {
    for(const key in input)if (key.startsWith("on")) delete input[key];
    return input;
}
function $91ffd9bd684fd1b9$export$36eebbb473f6d2fe(obj) {
    if (!obj || typeof obj !== "object") return "";
    try {
        return JSON.stringify(obj);
    } catch (e) {
        return "";
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $276a22df76563a4a$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3581f530a27f457c$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $241976d88b767e6b$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0851fb40950c4072$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    let effect = (0, $acw62.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $241976d88b767e6b$export$7f54fc3180508a52)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, $241976d88b767e6b$export$7f54fc3180508a52)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $fc8082d5d9c62cca$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $fc8082d5d9c62cca$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $fc8082d5d9c62cca$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $8afd3bdc2bd65163$export$619500959fc48b26)(value);
    let updateValue = (0, $acw62.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($fc8082d5d9c62cca$var$$bdb11010cef70236$var$canUseDOM) $fc8082d5d9c62cca$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            $fc8082d5d9c62cca$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $fc8082d5d9c62cca$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $fc8082d5d9c62cca$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $fc8082d5d9c62cca$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $fc8082d5d9c62cca$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $fc8082d5d9c62cca$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $0851fb40950c4072$export$14d238f342723f25)(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


function $906f08e0acace923$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $906f08e0acace923$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $906f08e0acace923$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $906f08e0acace923$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $906f08e0acace923$export$2e2bcd8739ae039 = $906f08e0acace923$export$4f5d2d50c9deca37;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5c52a3669a00adc5$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $276a22df76563a4a$export$e08e3b67e392101e)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $906f08e0acace923$export$2e2bcd8739ae039)(a, b);
            else if (key === "id" && a && b) result.id = (0, $fc8082d5d9c62cca$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}


var $3e07660ac043ddbf$export$2e2bcd8739ae039 = {};
$3e07660ac043ddbf$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
        })} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{627}\u{644}\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644}\u{629} ${args.groupTitle}, \u{645}\u{639} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{60C} \u{645}\u{62D}\u{62F}\u{62F}`
};


var $a1dbc13eb28ea58a$export$2e2bcd8739ae039 = {};
$a1dbc13eb28ea58a$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{436}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
        })} \u{43D}\u{430} \u{440}\u{430}\u{437}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{44A}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};


var $2805d5adfe72460a$export$2e2bcd8739ae039 = {};
$2805d5adfe72460a$export$2e2bcd8739ae039 = {
    "buttonLabel": `Zobrazit doporu\u{10D}en\xed`,
    "countAnnouncement": (args, formatter)=>`K dispozici ${formatter.plural(args.optionCount, {
            one: ()=>`je ${formatter.number(args.optionCount)} mo\u{17E}nost`,
            other: ()=>`jsou/je ${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina \u{201E}${args.groupTitle}\u{201C} ${formatter.plural(args.groupCount, {
                    one: ()=>`s ${formatter.number(args.groupCount)} mo\u{17E}nost\xed`,
                    other: ()=>`se ${formatter.number(args.groupCount)} mo\u{17E}nostmi`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: ` (vybr\xe1no)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybr\xe1no`
};


var $2b9b72df85e42107$export$2e2bcd8739ae039 = {};
$2b9b72df85e42107$export$2e2bcd8739ae039 = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mulighed tilg\xe6ngelig`,
            other: ()=>`${formatter.number(args.optionCount)} muligheder tilg\xe6ngelige`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angivet gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mulighed`,
                    other: ()=>`${formatter.number(args.groupCount)} muligheder`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $8fbb1104390e06a2$export$2e2bcd8739ae039 = {};
$8fbb1104390e06a2$export$2e2bcd8739ae039 = {
    "buttonLabel": `Empfehlungen anzeigen`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} Option`,
            other: ()=>`${formatter.number(args.optionCount)} Optionen`
        })} verf\xfcgbar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Eingetretene Gruppe ${args.groupTitle}, mit ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} Option`,
                    other: ()=>`${formatter.number(args.groupCount)} Optionen`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, ausgew\xe4hlt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Empfehlungen`,
    "selectedAnnouncement": (args)=>`${args.optionText}, ausgew\xe4hlt`
};


var $06022d55ad6c35e3$export$2e2bcd8739ae039 = {};
$06022d55ad6c35e3$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3B2}\u{3BF}\u{3BB}\u{3AE} \u{3C0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3C9}\u{3BD}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2} `
        })} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3BF}\u{3BC}\u{3AC}\u{3B4}\u{3B1} ${args.groupTitle}, \u{3BC}\u{3B5} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5}`
};


var $df5059538e50c1d2$export$2e2bcd8739ae039 = {};
$df5059538e50c1d2$export$2e2bcd8739ae039 = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};


var $85b3ad3544331465$export$2e2bcd8739ae039 = {};
$85b3ad3544331465$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostrar sugerencias`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opci\xf3n`,
            other: ()=>`${formatter.number(args.optionCount)} opciones`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Se ha unido al grupo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opci\xf3n`,
                    other: ()=>`${formatter.number(args.groupCount)} opciones`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seleccionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugerencias`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seleccionado`
};


var $878e71401c787f04$export$2e2bcd8739ae039 = {};
$878e71401c787f04$export$2e2bcd8739ae039 = {
    "buttonLabel": `Kuva soovitused`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} valik`,
            other: ()=>`${formatter.number(args.optionCount)} valikud`
        })} saadaval.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Sisestatud r\xfchm ${args.groupTitle}, valikuga ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} valik`,
                    other: ()=>`${formatter.number(args.groupCount)} valikud`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valitud`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Soovitused`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valitud`
};


var $7b0d332c34a2ef23$export$2e2bcd8739ae039 = {};
$7b0d332c34a2ef23$export$2e2bcd8739ae039 = {
    "buttonLabel": `N\xe4yt\xe4 ehdotukset`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} vaihtoehto`,
            other: ()=>`${formatter.number(args.optionCount)} vaihtoehdot`
        })} saatavilla.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Mentiin ryhm\xe4\xe4n ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`,
                    other: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`
                })} kanssa.`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valittu`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ehdotukset`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valittu`
};


var $8cdd699a153cdb0a$export$2e2bcd8739ae039 = {};
$8cdd699a153cdb0a$export$2e2bcd8739ae039 = {
    "buttonLabel": `Afficher les suggestions`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groupe ${args.groupTitle} rejoint, avec ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, s\xe9lectionn\xe9(s)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggestions`,
    "selectedAnnouncement": (args)=>`${args.optionText}, s\xe9lectionn\xe9`
};


var $ff13b243e17501e0$export$2e2bcd8739ae039 = {};
$ff13b243e17501e0$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.optionCount)}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
        })} \u{5D1}\u{5DE}\u{5E6}\u{5D1} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5E0}\u{5DB}\u{5E0}\u{5E1} \u{5DC}\u{5E7}\u{5D1}\u{5D5}\u{5E6}\u{5D4} ${args.groupTitle}, \u{5E2}\u{5DD} ${formatter.plural(args.groupCount, {
                    one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.groupCount)}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`
};


var $bc31a35ce51d6699$export$2e2bcd8739ae039 = {};
$bc31a35ce51d6699$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i prijedloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, odabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Prijedlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, odabrano`
};


var $ec5827075e8c44e8$export$2e2bcd8739ae039 = {};
$ec5827075e8c44e8$export$2e2bcd8739ae039 = {
    "buttonLabel": `Javaslatok megjelen\xedt\xe9se`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`,
            other: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`
        })} \xe1ll rendelkez\xe9sre.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Bel\xe9pett a(z) ${args.groupTitle} csoportba, amely ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`,
                    other: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`
                })} tartalmaz. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, kijel\xf6lve`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Javaslatok`,
    "selectedAnnouncement": (args)=>`${args.optionText}, kijel\xf6lve`
};


var $6f202dc88e713728$export$2e2bcd8739ae039 = {};
$6f202dc88e713728$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostra suggerimenti`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opzione disponibile`,
            other: ()=>`${formatter.number(args.optionCount)} opzioni disponibili`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingresso nel gruppo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opzione`,
                    other: ()=>`${formatter.number(args.groupCount)} opzioni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selezionato`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggerimenti`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selezionato`
};


var $794f09c56e20399d$export$2e2bcd8739ae039 = {};
$794f09c56e20399d$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{5019}\u{88DC}\u{3092}\u{8868}\u{793A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
        })}\u{3092}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5165}\u{529B}\u{3055}\u{308C}\u{305F}\u{30B0}\u{30EB}\u{30FC}\u{30D7} ${args.groupTitle}\u{3001}${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
                })}\u{3092}\u{542B}\u{3080}\u{3002}`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5019}\u{88DC}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`
};


var $9d4fdbb8600cfac6$export$2e2bcd8739ae039 = {};
$9d4fdbb8600cfac6$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{C81C}\u{C548} \u{C0AC}\u{D56D} \u{D45C}\u{C2DC}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`,
            other: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`
        })}\u{C744} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{C785}\u{B825}\u{D55C} \u{ADF8}\u{B8F9} ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`,
                    other: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{C120}\u{D0DD}\u{B428}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{C81C}\u{C548}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{C120}\u{D0DD}\u{B428}`
};


var $d65ded670071f168$export$2e2bcd8739ae039 = {};
$d65ded670071f168$export$2e2bcd8739ae039 = {
    "buttonLabel": `Rodyti pasi\u{16B}lymus`,
    "countAnnouncement": (args, formatter)=>`Yra ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} parinktis`,
            other: ()=>`${formatter.number(args.optionCount)} parinktys (-i\u{173})`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{12E}vesta grup\u{117} ${args.groupTitle}, su ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} parinktimi`,
                    other: ()=>`${formatter.number(args.groupCount)} parinktimis (-i\u{173})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, pasirinkta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Pasi\u{16B}lymai`,
    "selectedAnnouncement": (args)=>`${args.optionText}, pasirinkta`
};


var $a3b34404e9845f64$export$2e2bcd8739ae039 = {};
$a3b34404e9845f64$export$2e2bcd8739ae039 = {
    "buttonLabel": `R\u{101}d\u{12B}t ieteikumus`,
    "countAnnouncement": (args, formatter)=>`Pieejamo opciju skaits: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcijas`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ievad\u{12B}ta grupa ${args.groupTitle}, ar ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opciju`,
                    other: ()=>`${formatter.number(args.groupCount)} opcij\u{101}m`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, atlas\u{12B}ta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ieteikumi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, atlas\u{12B}ta`
};


var $ed2d57c377653daf$export$2e2bcd8739ae039 = {};
$ed2d57c377653daf$export$2e2bcd8739ae039 = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativer`
        })} finnes.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angitt gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativer`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $edf09220f610b78a$export$2e2bcd8739ae039 = {};
$edf09220f610b78a$export$2e2bcd8739ae039 = {
    "buttonLabel": `Suggesties weergeven`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} optie`,
            other: ()=>`${formatter.number(args.optionCount)} opties`
        })} beschikbaar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groep ${args.groupTitle} ingevoerd met ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} optie`,
                    other: ()=>`${formatter.number(args.groupCount)} opties`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, geselecteerd`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggesties`,
    "selectedAnnouncement": (args)=>`${args.optionText}, geselecteerd`
};


var $32d2228dcb44a640$export$2e2bcd8739ae039 = {};
$32d2228dcb44a640$export$2e2bcd8739ae039 = {
    "buttonLabel": `Wy\u{15B}wietlaj sugestie`,
    "countAnnouncement": (args, formatter)=>`dost\u{119}pna/dost\u{119}pne(-nych) ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcja`,
            other: ()=>`${formatter.number(args.optionCount)} opcje(-i)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Do\u{142}\u{105}czono do grupy ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcj\u{105}`,
                    other: ()=>`${formatter.number(args.groupCount)} opcjami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, wybrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestie`,
    "selectedAnnouncement": (args)=>`${args.optionText}, wybrano`
};


var $0f8d9a0065b9bed2$export$2e2bcd8739ae039 = {};
$0f8d9a0065b9bed2$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostrar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo inserido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $41dd4adea5cd4f72$export$2e2bcd8739ae039 = {};
$41dd4adea5cd4f72$export$2e2bcd8739ae039 = {
    "buttonLabel": `Apresentar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo introduzido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $e9ec4a313b7a42ec$export$2e2bcd8739ae039 = {};
$e9ec4a313b7a42ec$export$2e2bcd8739ae039 = {
    "buttonLabel": `Afi\u{219}are sugestii`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\u{21B}iune`,
            other: ()=>`${formatter.number(args.optionCount)} op\u{21B}iuni`
        })} disponibile.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grup ${args.groupTitle} introdus, cu ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\u{21B}iune`,
                    other: ()=>`${formatter.number(args.groupCount)} op\u{21B}iuni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selectat`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestii`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selectat`
};


var $aabf35a74424dae4$export$2e2bcd8739ae039 = {};
$aabf35a74424dae4$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{432}`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{43C}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{43C}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};


var $f37507fee70ecfb2$export$2e2bcd8739ae039 = {};
$f37507fee70ecfb2$export$2e2bcd8739ae039 = {
    "buttonLabel": `Zobrazi\u{165} n\xe1vrhy`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nos\u{165}`,
            other: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })} k dispoz\xedcii.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ou`,
                    other: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, vybrat\xe9`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybrat\xe9`
};


var $fa0311d3f8239a13$export$2e2bcd8739ae039 = {};
$fa0311d3f8239a13$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Na voljo je ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Vnesena skupina ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcija`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izbrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlogi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izbrano`
};


var $a877f367973ea4bf$export$2e2bcd8739ae039 = {};
$a877f367973ea4bf$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena grupa ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} optione/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izabrano`
};


var $20ed20727a8622a5$export$2e2bcd8739ae039 = {};
$20ed20727a8622a5$export$2e2bcd8739ae039 = {
    "buttonLabel": `Visa f\xf6rslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativ`
        })} tillg\xe4ngliga.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingick i gruppen ${args.groupTitle} med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativ`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valda`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `F\xf6rslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valda`
};


var $28fcde19e19dbca4$export$2e2bcd8739ae039 = {};
$28fcde19e19dbca4$export$2e2bcd8739ae039 = {
    "buttonLabel": `\xd6nerileri g\xf6ster`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} se\xe7enek`,
            other: ()=>`${formatter.number(args.optionCount)} se\xe7enekler`
        })} kullan\u{131}labilir.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Girilen grup ${args.groupTitle}, ile ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} se\xe7enek`,
                    other: ()=>`${formatter.number(args.groupCount)} se\xe7enekler`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, se\xe7ildi`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\xd6neriler`,
    "selectedAnnouncement": (args)=>`${args.optionText}, se\xe7ildi`
};


var $b63f8f0338ef225c$export$2e2bcd8739ae039 = {};
$b63f8f0338ef225c$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{43F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{437} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};


var $eecc9e7e608bccc1$export$2e2bcd8739ae039 = {};
$eecc9e7e608bccc1$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{663E}\u{793A}\u{5EFA}\u{8BAE}`,
    "countAnnouncement": (args, formatter)=>`\u{6709} ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`
        })}\u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8FDB}\u{5165}\u{4E86} ${args.groupTitle} \u{7EC4}\u{FF0C}\u{5176}\u{4E2D}\u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9009}\u{62E9}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8BAE}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9009}\u{62E9}`
};


var $b18df13fea0429c4$export$2e2bcd8739ae039 = {};
$b18df13fea0429c4$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{986F}\u{793A}\u{5EFA}\u{8B70}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`
        })} \u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8F38}\u{5165}\u{7684}\u{7FA4}\u{7D44} ${args.groupTitle}, \u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9078}\u{53D6}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8B70}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9078}\u{53D6}`
};


var $2158e35f054bddd4$export$2e2bcd8739ae039 = {};
$2158e35f054bddd4$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $3e07660ac043ddbf$export$2e2bcd8739ae039),
    "bg-BG": (0, $a1dbc13eb28ea58a$export$2e2bcd8739ae039),
    "cs-CZ": (0, $2805d5adfe72460a$export$2e2bcd8739ae039),
    "da-DK": (0, $2b9b72df85e42107$export$2e2bcd8739ae039),
    "de-DE": (0, $8fbb1104390e06a2$export$2e2bcd8739ae039),
    "el-GR": (0, $06022d55ad6c35e3$export$2e2bcd8739ae039),
    "en-US": (0, $df5059538e50c1d2$export$2e2bcd8739ae039),
    "es-ES": (0, $85b3ad3544331465$export$2e2bcd8739ae039),
    "et-EE": (0, $878e71401c787f04$export$2e2bcd8739ae039),
    "fi-FI": (0, $7b0d332c34a2ef23$export$2e2bcd8739ae039),
    "fr-FR": (0, $8cdd699a153cdb0a$export$2e2bcd8739ae039),
    "he-IL": (0, $ff13b243e17501e0$export$2e2bcd8739ae039),
    "hr-HR": (0, $bc31a35ce51d6699$export$2e2bcd8739ae039),
    "hu-HU": (0, $ec5827075e8c44e8$export$2e2bcd8739ae039),
    "it-IT": (0, $6f202dc88e713728$export$2e2bcd8739ae039),
    "ja-JP": (0, $794f09c56e20399d$export$2e2bcd8739ae039),
    "ko-KR": (0, $9d4fdbb8600cfac6$export$2e2bcd8739ae039),
    "lt-LT": (0, $d65ded670071f168$export$2e2bcd8739ae039),
    "lv-LV": (0, $a3b34404e9845f64$export$2e2bcd8739ae039),
    "nb-NO": (0, $ed2d57c377653daf$export$2e2bcd8739ae039),
    "nl-NL": (0, $edf09220f610b78a$export$2e2bcd8739ae039),
    "pl-PL": (0, $32d2228dcb44a640$export$2e2bcd8739ae039),
    "pt-BR": (0, $0f8d9a0065b9bed2$export$2e2bcd8739ae039),
    "pt-PT": (0, $41dd4adea5cd4f72$export$2e2bcd8739ae039),
    "ro-RO": (0, $e9ec4a313b7a42ec$export$2e2bcd8739ae039),
    "ru-RU": (0, $aabf35a74424dae4$export$2e2bcd8739ae039),
    "sk-SK": (0, $f37507fee70ecfb2$export$2e2bcd8739ae039),
    "sl-SI": (0, $fa0311d3f8239a13$export$2e2bcd8739ae039),
    "sr-SP": (0, $a877f367973ea4bf$export$2e2bcd8739ae039),
    "sv-SE": (0, $20ed20727a8622a5$export$2e2bcd8739ae039),
    "tr-TR": (0, $28fcde19e19dbca4$export$2e2bcd8739ae039),
    "uk-UA": (0, $b63f8f0338ef225c$export$2e2bcd8739ae039),
    "zh-CN": (0, $eecc9e7e608bccc1$export$2e2bcd8739ae039),
    "zh-TW": (0, $b18df13fea0429c4$export$2e2bcd8739ae039)
};


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $f79874db04d9a0b8$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer = null;
function $f79874db04d9a0b8$export$a9b970dcc4ae71a9(message, assertiveness = "assertive", timeout = $f79874db04d9a0b8$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer) $f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer = new $f79874db04d9a0b8$var$$319e236875307eab$var$LiveAnnouncer();
    $f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $f79874db04d9a0b8$export$d10ae4f68404609a(assertiveness) {
    if ($f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer) $f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer.clear(assertiveness);
}
function $f79874db04d9a0b8$export$d8686216b8b81b2f() {
    if ($f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer) {
        $f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer.destroy();
        $f79874db04d9a0b8$var$$319e236875307eab$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $f79874db04d9a0b8$var$$319e236875307eab$var$LiveAnnouncer {
    createLog(ariaLive) {
        let node = document.createElement("div");
        node.setAttribute("role", "log");
        node.setAttribute("aria-live", ariaLive);
        node.setAttribute("aria-relevant", "additions");
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = "assertive", timeout = $f79874db04d9a0b8$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
        if (!this.node) return;
        let node = document.createElement("div");
        node.textContent = message;
        if (assertiveness === "assertive") this.assertiveLog.appendChild(node);
        else this.politeLog.appendChild(node);
        if (message !== "") setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if (!assertiveness || assertiveness === "assertive") this.assertiveLog.innerHTML = "";
        if (!assertiveness || assertiveness === "polite") this.politeLog.innerHTML = "";
    }
    constructor(){
        this.node = document.createElement("div");
        this.node.dataset.liveAnnouncer = "true";
        // copied from VisuallyHidden
        Object.assign(this.node.style, {
            border: 0,
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: "1px",
            whiteSpace: "nowrap"
        });
        this.assertiveLog = this.createLog("assertive");
        this.node.appendChild(this.assertiveLog);
        this.politeLog = this.createLog("polite");
        this.node.appendChild(this.politeLog);
        document.body.prepend(this.node);
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $e91a11878652e278$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
let $e91a11878652e278$var$$5e3802645cc19319$var$observerStack = [];
function $e91a11878652e278$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $e91a11878652e278$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $e91a11878652e278$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($e91a11878652e278$var$$5e3802645cc19319$var$observerStack.length) $e91a11878652e278$var$$5e3802645cc19319$var$observerStack[$e91a11878652e278$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $e91a11878652e278$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $e91a11878652e278$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $e91a11878652e278$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $e91a11878652e278$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $e91a11878652e278$var$$5e3802645cc19319$var$observerStack[$e91a11878652e278$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $e91a11878652e278$var$$5e3802645cc19319$var$observerStack.pop();
            if ($e91a11878652e278$var$$5e3802645cc19319$var$observerStack.length) $e91a11878652e278$var$$5e3802645cc19319$var$observerStack[$e91a11878652e278$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $e91a11878652e278$var$$5e3802645cc19319$var$observerStack.splice($e91a11878652e278$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $25babb4758798128$export$3585ede4d035bf14 = new WeakMap();
function $25babb4758798128$var$$b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $25babb4758798128$export$9145995848b05025(state, itemKey) {
    let data = $25babb4758798128$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${$25babb4758798128$var$$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2ca439ee1a804558$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $fc8082d5d9c62cca$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b6e1ce9cd2ff6ef3$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $b6e1ce9cd2ff6ef3$export$77d5aafae4e095b2(collection) {
    let count = $b6e1ce9cd2ff6ef3$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems((0, $f2e2cae04a4a64ed$export$1005530eda016c13)(item, collection));
        else count++;
    };
    countItems(collection);
    $b6e1ce9cd2ff6ef3$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1997bf66abd8bf2b$export$2bb74740c4e19def(node, checkForOverflow) {
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $376f10d3e3d8d3ed$export$a05409b8bb224a5a {
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === "all" && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return key !== null ? this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`) : null;
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $1997bf66abd8bf2b$export$2bb74740c4e19def)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $1997bf66abd8bf2b$export$2bb74740c4e19def)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || "all";
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
            this.disabledBehavior = "all";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9a13bb9abd310520$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $b82880ba168cba95$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $9a13bb9abd310520$export$16792effe837dba3(e) {
    if ((0, $b82880ba168cba95$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $b0877533d50c8386$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $b0877533d50c8386$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $acw62.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $b0877533d50c8386$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $b0877533d50c8386$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $b0877533d50c8386$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}




var $acw62 = parcelRequire("acw62");
const $eef56d26e56a84a0$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $eef56d26e56a84a0$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $eef56d26e56a84a0$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $f7303ee4180eaa13$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a192045deeaea2b6$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $b82880ba168cba95$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $a192045deeaea2b6$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $b82880ba168cba95$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = null;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b995f28c9a72ee4c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $b82880ba168cba95$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $a192045deeaea2b6$export$60278871457622de)(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b995f28c9a72ee4c$export$d90243b58daecda7.get((0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element);
    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b995f28c9a72ee4c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element);
    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b995f28c9a72ee4c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b995f28c9a72ee4c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b995f28c9a72ee4c$export$d90243b58daecda7.delete(windowObject);
};
function $b995f28c9a72ee4c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b995f28c9a72ee4c$export$2f1888112f558a7d();
function $b995f28c9a72ee4c$export$b9b3dfddab17db27() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b995f28c9a72ee4c$export$630ff653c5ada6a9() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality;
}
function $b995f28c9a72ee4c$export$8397ddfc504fdb9a(modality) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b995f28c9a72ee4c$export$98e20ec92f614cfe() {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $8afd3bdc2bd65163$export$535bd6ca7f90a273)() ? null : modality;
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b995f28c9a72ee4c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $b995f28c9a72ee4c$export$b9b3dfddab17db27());
    $b995f28c9a72ee4c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b995f28c9a72ee4c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b995f28c9a72ee4c$export$b9b3dfddab17db27());
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b92af0002e176fee$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    if ((0, $b995f28c9a72ee4c$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $f7303ee4180eaa13$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $a3b111119000092b$export$de79e2c695e052f3)(element);
        });
    } else (0, $a3b111119000092b$export$de79e2c695e052f3)(element);
}



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $94fbac57294f148e$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $94fbac57294f148e$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $94fbac57294f148e$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $94fbac57294f148e$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $94fbac57294f148e$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $94fbac57294f148e$export$e989c0fffaa6b27a(element.parentElement, element));
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
let $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = null;
function $b27e9acf8b86f3f1$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)(null);
    let endRef = (0, $acw62.useRef)(null);
    let scopeRef = (0, $acw62.useRef)([]);
    let { parentNode: parentNode } = (0, $acw62.useContext)($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $acw62.useMemo)(()=>new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $b27e9acf8b86f3f1$export$d06fae2ee68b101e.root;
        if ($b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope && !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $b27e9acf8b86f3f1$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let node = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $acw62.useEffect)(()=>{
        const activeElement = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $b27e9acf8b86f3f1$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(parentScope))) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $b27e9acf8b86f3f1$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $acw62.useMemo)(()=>$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $acw62.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $b27e9acf8b86f3f1$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $b27e9acf8b86f3f1$export$4c063cf1350e6fed(element) {
    return element.matches($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)();
    let raf = (0, $acw62.useRef)();
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $b27e9acf8b86f3f1$export$d06fae2ee68b101e.traverse($b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $b27e9acf8b86f3f1$export$1258395f99bf9cbf(element) {
    return $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(element, $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $b92af0002e176fee$export$80f3e147d781571c)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== "undefined" ? (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $eef56d26e56a84a0$export$b204af158042fbac)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $94fbac57294f148e$export$e989c0fffaa6b27a)(node) && (!scope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $b27e9acf8b86f3f1$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(root).activeElement;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(root).activeElement;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker);
                if (next) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker);
            if (next) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $b27e9acf8b86f3f1$export$d06fae2ee68b101e = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$Tree();



/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $069d6b66411730b9$export$94ed1c92c7beeb22(node, checkForOverflow) {
    const scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $1997bf66abd8bf2b$export$2bb74740c4e19def)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bae8b76edab393db$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $bae8b76edab393db$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $bae8b76edab393db$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $bae8b76edab393db$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $bae8b76edab393db$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            let scrollParents = (0, $069d6b66411730b9$export$94ed1c92c7beeb22)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            for (let scrollParent of scrollParents)$bae8b76edab393db$export$53a0910f038337bd(scrollParent, targetElement);
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bb6010e189e90e0f$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $241976d88b767e6b$export$7f54fc3180508a52)(handler);
    let isDisabled = handler == null;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0033009e76f45f0a$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let router = (0, $4a4107ecda93bad9$export$9a302a45f65d0572)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !(0, $9a13bb9abd310520$export$d3e3bd3e26688c04)(e)) {
                    (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    let itemProps = manager.getItemProps(key);
                    router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !(0, $9a13bb9abd310520$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $9a13bb9abd310520$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if ((0, $9a13bb9abd310520$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $9a13bb9abd310520$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if ((0, $9a13bb9abd310520$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ((0, $9a13bb9abd310520$export$16792effe837dba3)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                if (!disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $a3b111119000092b$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $acw62.useRef)({
        top: 0,
        left: 0
    });
    (0, $bb6010e189e90e0f$export$90fc3a17d93f704c)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $a3b111119000092b$export$de79e2c695e052f3)(element);
                let modality = (0, $b995f28c9a72ee4c$export$630ff653c5ada6a9)();
                if (modality === "keyboard") (0, $bae8b76edab393db$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $acw62.useRef)(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $b92af0002e176fee$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $acw62.useRef)(manager.focusedKey);
    (0, $acw62.useEffect)(()=>{
        let modality = (0, $b995f28c9a72ee4c$export$630ff653c5ada6a9)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, $bae8b76edab393db$export$53a0910f038337bd)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $bae8b76edab393db$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $b92af0002e176fee$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $b0877533d50c8386$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}




/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
const $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
let $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings = undefined;
class $2e7c3812ae71e8c9$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === "undefined") return null;
        let locale = window[$2e7c3812ae71e8c9$var$$5b160d28a433310d$var$localeSymbol];
        if ($2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$2e7c3812ae71e8c9$var$$5b160d28a433310d$var$stringsSymbol];
            if (!globalStrings) return null;
            $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $2e7c3812ae71e8c9$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings === null || $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$cachedGlobalStrings[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
}
function $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $2e7c3812ae71e8c9$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $14efe04c6ea1ca1f$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $14efe04c6ea1ca1f$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $14efe04c6ea1ca1f$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $14efe04c6ea1ca1f$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $14efe04c6ea1ca1f$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $14efe04c6ea1ca1f$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $14efe04c6ea1ca1f$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $99f36fc287ff500a$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $99f36fc287ff500a$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $99f36fc287ff500a$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $2e7c3812ae71e8c9$export$c17fa47878dc55b6)(strings);
        $99f36fc287ff500a$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $99f36fc287ff500a$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $2e7c3812ae71e8c9$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $99f36fc287ff500a$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $99f36fc287ff500a$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let dictionary = $99f36fc287ff500a$export$87b761675e8eaa10(strings, packageName);
    return (0, $acw62.useMemo)(()=>new (0, $14efe04c6ea1ca1f$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}


var $8af08abb355a0d07$export$2e2bcd8739ae039 = {};
$8af08abb355a0d07$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};


var $9bbb61571f4a9fc8$export$2e2bcd8739ae039 = {};
$9bbb61571f4a9fc8$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};


var $58067894b32dd2bf$export$2e2bcd8739ae039 = {};
$58067894b32dd2bf$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};


var $6a05394b256369ef$export$2e2bcd8739ae039 = {};
$6a05394b256369ef$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};


var $1bba2300818b7975$export$2e2bcd8739ae039 = {};
$1bba2300818b7975$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};


var $38568b679edd8482$export$2e2bcd8739ae039 = {};
$38568b679edd8482$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};


var $ff49e83d4478431c$export$2e2bcd8739ae039 = {};
$ff49e83d4478431c$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


var $1606dd44eb5fe2be$export$2e2bcd8739ae039 = {};
$1606dd44eb5fe2be$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};


var $0f55e41f6e8f5234$export$2e2bcd8739ae039 = {};
$0f55e41f6e8f5234$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};


var $806c528bd37ccd19$export$2e2bcd8739ae039 = {};
$806c528bd37ccd19$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};


var $b766389df88cbded$export$2e2bcd8739ae039 = {};
$b766389df88cbded$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};


var $331a43881aaa317e$export$2e2bcd8739ae039 = {};
$331a43881aaa317e$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};


var $ff04da834315ec54$export$2e2bcd8739ae039 = {};
$ff04da834315ec54$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


var $c92093864d740c01$export$2e2bcd8739ae039 = {};
$c92093864d740c01$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};


var $393a40390f585511$export$2e2bcd8739ae039 = {};
$393a40390f585511$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};


var $41f445951577a8cc$export$2e2bcd8739ae039 = {};
$41f445951577a8cc$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};


var $1e2bd9678ae9db8b$export$2e2bcd8739ae039 = {};
$1e2bd9678ae9db8b$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};


var $2f40b46c5a652aa4$export$2e2bcd8739ae039 = {};
$2f40b46c5a652aa4$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};


var $998a012e5bdada51$export$2e2bcd8739ae039 = {};
$998a012e5bdada51$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};


var $69e82ccbef0adb61$export$2e2bcd8739ae039 = {};
$69e82ccbef0adb61$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};


var $254de18b62035ba7$export$2e2bcd8739ae039 = {};
$254de18b62035ba7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


var $c36efe5728f8cf22$export$2e2bcd8739ae039 = {};
$c36efe5728f8cf22$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};


var $fcb2942f5dd3b8a3$export$2e2bcd8739ae039 = {};
$fcb2942f5dd3b8a3$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


var $f3e45586926bed4d$export$2e2bcd8739ae039 = {};
$f3e45586926bed4d$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};


var $6ac3de2c6d608dd8$export$2e2bcd8739ae039 = {};
$6ac3de2c6d608dd8$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};


var $6e0b26ed5a98983c$export$2e2bcd8739ae039 = {};
$6e0b26ed5a98983c$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};


var $149c37f6ef32cf6a$export$2e2bcd8739ae039 = {};
$149c37f6ef32cf6a$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};


var $d6c7f01cbe0f854b$export$2e2bcd8739ae039 = {};
$d6c7f01cbe0f854b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};


var $75d7b7c412ad5eda$export$2e2bcd8739ae039 = {};
$75d7b7c412ad5eda$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


var $0fbb07238feb7764$export$2e2bcd8739ae039 = {};
$0fbb07238feb7764$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};


var $8a1989e82836edd9$export$2e2bcd8739ae039 = {};
$8a1989e82836edd9$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};


var $6d227e87fdec2820$export$2e2bcd8739ae039 = {};
$6d227e87fdec2820$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};


var $6b0c7d717d483df3$export$2e2bcd8739ae039 = {};
$6b0c7d717d483df3$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};


var $f2ffd4c53ac7eb35$export$2e2bcd8739ae039 = {};
$f2ffd4c53ac7eb35$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};


var $bdaf5663c0ffb70f$export$2e2bcd8739ae039 = {};
$bdaf5663c0ffb70f$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $8af08abb355a0d07$export$2e2bcd8739ae039),
    "bg-BG": (0, $9bbb61571f4a9fc8$export$2e2bcd8739ae039),
    "cs-CZ": (0, $58067894b32dd2bf$export$2e2bcd8739ae039),
    "da-DK": (0, $6a05394b256369ef$export$2e2bcd8739ae039),
    "de-DE": (0, $1bba2300818b7975$export$2e2bcd8739ae039),
    "el-GR": (0, $38568b679edd8482$export$2e2bcd8739ae039),
    "en-US": (0, $ff49e83d4478431c$export$2e2bcd8739ae039),
    "es-ES": (0, $1606dd44eb5fe2be$export$2e2bcd8739ae039),
    "et-EE": (0, $0f55e41f6e8f5234$export$2e2bcd8739ae039),
    "fi-FI": (0, $806c528bd37ccd19$export$2e2bcd8739ae039),
    "fr-FR": (0, $b766389df88cbded$export$2e2bcd8739ae039),
    "he-IL": (0, $331a43881aaa317e$export$2e2bcd8739ae039),
    "hr-HR": (0, $ff04da834315ec54$export$2e2bcd8739ae039),
    "hu-HU": (0, $c92093864d740c01$export$2e2bcd8739ae039),
    "it-IT": (0, $393a40390f585511$export$2e2bcd8739ae039),
    "ja-JP": (0, $41f445951577a8cc$export$2e2bcd8739ae039),
    "ko-KR": (0, $1e2bd9678ae9db8b$export$2e2bcd8739ae039),
    "lt-LT": (0, $2f40b46c5a652aa4$export$2e2bcd8739ae039),
    "lv-LV": (0, $998a012e5bdada51$export$2e2bcd8739ae039),
    "nb-NO": (0, $69e82ccbef0adb61$export$2e2bcd8739ae039),
    "nl-NL": (0, $254de18b62035ba7$export$2e2bcd8739ae039),
    "pl-PL": (0, $c36efe5728f8cf22$export$2e2bcd8739ae039),
    "pt-BR": (0, $fcb2942f5dd3b8a3$export$2e2bcd8739ae039),
    "pt-PT": (0, $f3e45586926bed4d$export$2e2bcd8739ae039),
    "ro-RO": (0, $6ac3de2c6d608dd8$export$2e2bcd8739ae039),
    "ru-RU": (0, $6e0b26ed5a98983c$export$2e2bcd8739ae039),
    "sk-SK": (0, $149c37f6ef32cf6a$export$2e2bcd8739ae039),
    "sl-SI": (0, $d6c7f01cbe0f854b$export$2e2bcd8739ae039),
    "sr-SP": (0, $75d7b7c412ad5eda$export$2e2bcd8739ae039),
    "sv-SE": (0, $0fbb07238feb7764$export$2e2bcd8739ae039),
    "tr-TR": (0, $8a1989e82836edd9$export$2e2bcd8739ae039),
    "uk-UA": (0, $6d227e87fdec2820$export$2e2bcd8739ae039),
    "zh-CN": (0, $6b0c7d717d483df3$export$2e2bcd8739ae039),
    "zh-TW": (0, $f2ffd4c53ac7eb35$export$2e2bcd8739ae039)
};





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $a312cb298316e25d$var$$14c0b72509d70225$var$state = "default";
let $a312cb298316e25d$var$$14c0b72509d70225$var$savedUserSelect = "";
let $a312cb298316e25d$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $a312cb298316e25d$export$16a4697467175487(target) {
    if ((0, $b82880ba168cba95$export$fedb369cb70207f1)()) {
        if ($a312cb298316e25d$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(target);
            $a312cb298316e25d$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $a312cb298316e25d$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $a312cb298316e25d$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $a312cb298316e25d$export$b0d6fa1ab32e3295(target) {
    if ((0, $b82880ba168cba95$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($a312cb298316e25d$var$$14c0b72509d70225$var$state !== "disabled") return;
        $a312cb298316e25d$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $f7303ee4180eaa13$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($a312cb298316e25d$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $a312cb298316e25d$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $a312cb298316e25d$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $a312cb298316e25d$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $a312cb298316e25d$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $a312cb298316e25d$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $a312cb298316e25d$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6fd4398e2c555e24$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    register: ()=>{}
});
$6fd4398e2c555e24$export$5165eccb35aaadb5.displayName = "PressResponderContext";


function $9d532a50f1a1542f$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $b7922a8e24efe587$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $c6097939c16c8ec7$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $b7922a8e24efe587$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $9d532a50f1a1542f$export$71511d61b312f219)(receiver, descriptor);
}


function $e7a1afa872b987c0$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $01f13bd32e43989c$export$71511d61b312f219(obj, privateMap, value) {
    (0, $e7a1afa872b987c0$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $fbd8018b480a0a1b$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $36ba9b20eda67744$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $b7922a8e24efe587$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $fbd8018b480a0a1b$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e488f14dbe0b8625$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $764513dca7bfd1d4$export$4debdb1a3f0fa79e(context, ref) {
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)((0, $6fd4398e2c555e24$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $764513dca7bfd1d4$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $5da6a07904df2822$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $5da6a07904df2822$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $36ba9b20eda67744$export$71511d61b312f219)(this, $5da6a07904df2822$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $c6097939c16c8ec7$export$71511d61b312f219)(this, $5da6a07904df2822$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $01f13bd32e43989c$export$71511d61b312f219)(this, $5da6a07904df2822$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $36ba9b20eda67744$export$71511d61b312f219)(this, $5da6a07904df2822$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $5da6a07904df2822$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $5da6a07904df2822$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $5da6a07904df2822$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $e488f14dbe0b8625$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $241976d88b767e6b$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $5da6a07904df2822$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $241976d88b767e6b$export$7f54fc3180508a52)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $5da6a07904df2822$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $5da6a07904df2822$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $241976d88b767e6b$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $5da6a07904df2822$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $241976d88b767e6b$export$7f54fc3180508a52)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $a312cb298316e25d$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $241976d88b767e6b$export$7f54fc3180508a52)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $eef56d26e56a84a0$export$b204af158042fbac)(e.currentTarget), "keyup", (0, $276a22df76563a4a$export$e08e3b67e392101e)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $b82880ba168cba95$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $4a4107ecda93bad9$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $a192045deeaea2b6$export$60278871457622de)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $a3b111119000092b$export$de79e2c695e052f3)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$5da6a07904df2822$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$5da6a07904df2822$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $4a4107ecda93bad9$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $a192045deeaea2b6$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $a3b111119000092b$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $a312cb298316e25d$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $eef56d26e56a84a0$export$b204af158042fbac)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $eef56d26e56a84a0$export$b204af158042fbac)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $eef56d26e56a84a0$export$b204af158042fbac)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $a312cb298316e25d$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $a192045deeaea2b6$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $a3b111119000092b$export$de79e2c695e052f3)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $eef56d26e56a84a0$export$b204af158042fbac)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $5da6a07904df2822$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $a3b111119000092b$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $a312cb298316e25d$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $5da6a07904df2822$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $5da6a07904df2822$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $a312cb298316e25d$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $a312cb298316e25d$export$b0d6fa1ab32e3295)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element).HTMLInputElement && !$5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $5da6a07904df2822$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $5da6a07904df2822$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $5da6a07904df2822$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($5da6a07904df2822$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $5da6a07904df2822$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $5da6a07904df2822$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $5da6a07904df2822$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $63b5f1dcd2b5cccc$var$$ef06256079686ba0$var$descriptionId = 0;
const $63b5f1dcd2b5cccc$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $63b5f1dcd2b5cccc$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $acw62.useState)();
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if (!description) return;
        let desc = $63b5f1dcd2b5cccc$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$63b5f1dcd2b5cccc$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $63b5f1dcd2b5cccc$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $63b5f1dcd2b5cccc$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $24b4ecb6ecd312c7$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $24b4ecb6ecd312c7$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $24b4ecb6ecd312c7$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $acw62.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $e488f14dbe0b8625$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $63b5f1dcd2b5cccc$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eac09c8eaabe44a4$export$f6211563215e3b37 = new WeakMap();
function $eac09c8eaabe44a4$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $acw62.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $eac09c8eaabe44a4$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9fe00376a31edb04$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $acw62.useEffect)(()=>{
        if (ref && ref.current) (0, $eac09c8eaabe44a4$export$f6211563215e3b37).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}


function $16a1933d449b51c0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $16a1933d449b51c0$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = "menu", isDisabled: isDisabled, trigger: trigger = "press" } = props;
    let menuTriggerId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $9fe00376a31edb04$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
            default:
                // Allow other keys.
                if ("continuePropagation" in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, $99f36fc287ff500a$export$f12b703ca79dfbb1)($16a1933d449b51c0$var$$parcel$interopDefault((0, $bdaf5663c0ffb70f$export$2e2bcd8739ae039)), "@react-aria/menu");
    let { longPressProps: longPressProps } = (0, $24b4ecb6ecd312c7$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: stringFormatter.format("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // Otherwise, the menu itself will be focused.
            state.open(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === "press" ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b8574754bee97e48$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $b8574754bee97e48$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const $b8574754bee97e48$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "hrefLang",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const $b8574754bee97e48$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $b8574754bee97e48$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($b8574754bee97e48$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $b8574754bee97e48$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $b8574754bee97e48$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $b8574754bee97e48$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $90b3fb06004350ee$export$5add1d006293d136(ref, initialValue, onReset) {
    let resetValue = (0, $acw62.useRef)(initialValue);
    let handleReset = (0, $241976d88b767e6b$export$7f54fc3180508a52)(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, $acw62.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9e880abab5c15a87$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $fc8082d5d9c62cca$export$f680877a34711e37)(id);
    let labelId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $2ca439ee1a804558$export$d6875122194c7b44)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2532b24858cbaf4b$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $9e880abab5c15a87$export$8467354a121f1b9f)(props);
    let descriptionId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $24eb3cf76a0ec7fd$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $acw62.useRef)(null);
    return (0, $acw62.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $10ef8d441d7454cf$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $10ef8d441d7454cf$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $241976d88b767e6b$export$7f54fc3180508a52)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $10ef8d441d7454cf$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e009837ee384a76a$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $10ef8d441d7454cf$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $848282930328273f$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $710096ea6048f1ed$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $848282930328273f$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $848282930328273f$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $4513518cfd051728$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $4513518cfd051728$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $acw62.useContext)($4513518cfd051728$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $764513dca7bfd1d4$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $4513518cfd051728$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $24eb3cf76a0ec7fd$export$4338b53315abf666)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4513518cfd051728$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $4513518cfd051728$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($4513518cfd051728$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $4513518cfd051728$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $e009837ee384a76a$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $710096ea6048f1ed$export$8f71654801c2f7cd)(props);
    let interactions = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $4513518cfd051728$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $b92af0002e176fee$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}



var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5ebe99b56f6edee7$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($5ebe99b56f6edee7$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let onReset = (0, $241976d88b767e6b$export$7f54fc3180508a52)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, $241976d88b767e6b$export$7f54fc3180508a52)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $5ebe99b56f6edee7$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $b995f28c9a72ee4c$export$8397ddfc504fdb9a)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $241976d88b767e6b$export$7f54fc3180508a52)(()=>{
        state.commitValidation();
    });
    (0, $acw62.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return ()=>{
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $5ebe99b56f6edee7$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $5ebe99b56f6edee7$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $5ebe99b56f6edee7$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $5ebe99b56f6edee7$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e96bf18a848d59e4$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = "input", isDisabled: isDisabled = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, type: type = "text", validationBehavior: validationBehavior = "aria" } = props;
    let [value, setValue] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.value, props.defaultValue || "", props.onChange);
    let { focusableProps: focusableProps } = (0, $4513518cfd051728$export$4c014de7c8940b4c)(props, ref);
    let validationState = (0, $81bdb3f3d704c389$export$fc1a364ae1f3ff10)({
        ...props,
        value: value
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $2532b24858cbaf4b$export$294aa081a6c6f55d)({
        ...props,
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    (0, $90b3fb06004350ee$export$5add1d006293d136)(ref, value, setValue);
    (0, $5ebe99b56f6edee7$export$b8473d3665f3a75a)(props, validationState, ref);
    (0, $acw62.useEffect)(()=>{
        // This works around a React/Chrome bug that prevents textarea elements from validating when controlled.
        // We prevent React from updating defaultValue (i.e. children) of textarea when `value` changes,
        // which causes Chrome to skip validation. Only updating `value` is ok in our case since our
        // textareas are always controlled. React is planning on removing this synchronization in a
        // future major version.
        // https://github.com/facebook/react/issues/19474
        // https://github.com/facebook/react/issues/11896
        if (ref.current instanceof (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(ref.current).HTMLTextAreaElement) {
            let input = ref.current;
            Object.defineProperty(input, "defaultValue", {
                get: ()=>input.value,
                set: ()=>{},
                configurable: true
            });
        }
    }, [
        ref
    ]);
    return {
        labelProps: labelProps,
        inputProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, inputElementType === "input" && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === "native",
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            "aria-invalid": isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-activedescendant": props["aria-activedescendant"],
            "aria-autocomplete": props["aria-autocomplete"],
            "aria-haspopup": props["aria-haspopup"],
            value: value,
            onChange: (e)=>setValue(e.target.value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}


function $c61cafbd4809c8e9$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c61cafbd4809c8e9$export$8c18d1b4f7232bbf(props, state) {
    let { buttonRef: buttonRef, popoverRef: popoverRef, inputRef: inputRef, listBoxRef: listBoxRef, keyboardDelegate: keyboardDelegate, shouldFocusWrap: shouldFocusWrap, isReadOnly: isReadOnly, isDisabled: isDisabled } = props;
    let stringFormatter = (0, $99f36fc287ff500a$export$f12b703ca79dfbb1)($c61cafbd4809c8e9$var$$parcel$interopDefault((0, $2158e35f054bddd4$export$2e2bcd8739ae039)), "@react-aria/combobox");
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $16a1933d449b51c0$export$dc9c12ed27dd1b49)({
        type: "listbox",
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    (0, $25babb4758798128$export$3585ede4d035bf14).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $376f10d3e3d8d3ed$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, listBoxRef), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps: collectionProps } = (0, $0033009e76f45f0a$export$d6daf82dcd84e87c)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap: shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    let router = (0, $4a4107ecda93bad9$export$9a302a45f65d0572)();
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
            case "Tab":
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === "Enter") e.preventDefault();
                // If the focused item is a link, trigger opening it. Items that are links are not selectable.
                if (state.isOpen && state.selectionManager.focusedKey != null && state.selectionManager.isLink(state.selectionManager.focusedKey)) {
                    if (e.key === "Enter") {
                        let item = listBoxRef.current.querySelector(`[data-key="${CSS.escape(state.selectionManager.focusedKey.toString())}"]`);
                        if (item instanceof HTMLAnchorElement) {
                            let collectionItem = state.collection.getItem(state.selectionManager.focusedKey);
                            router.open(item, e, collectionItem.props.href, collectionItem.props.routerOptions);
                        }
                    }
                    state.close();
                } else state.commit();
                break;
            case "Escape":
                if (state.selectedKey !== null || state.inputValue === "" || props.allowsCustomValue) e.continuePropagation();
                state.revert();
                break;
            case "ArrowDown":
                state.open("first", "manual");
                break;
            case "ArrowUp":
                state.open("last", "manual");
                break;
            case "ArrowLeft":
            case "ArrowRight":
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        var _popoverRef_current;
        let blurFromButton = (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) && buttonRef.current === e.relatedTarget;
        let blurIntoPopover = (_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget);
        // Ignore blur if focused moved to the button(if exists) or into the popover.
        if (blurFromButton || blurIntoPopover) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $e96bf18a848d59e4$export$712718f7aec83d5)({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly ? (0, $276a22df76563a4a$export$e08e3b67e392101e)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown) : props.onKeyDown,
        onBlur: onBlur,
        value: state.inputValue,
        onFocus: onFocus,
        autoComplete: "off",
        validate: undefined,
        [(0, $81bdb3f3d704c389$export$a763b9476acd3eb)]: state
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === "touch") {
            // Focus the input field in case it isn't focused yet
            inputRef.current.focus();
            state.toggle(null, "manual");
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== "touch") {
            inputRef.current.focus();
            state.toggle(e.pointerType === "keyboard" || e.pointerType === "virtual" ? "first" : null, "manual");
        }
    };
    let triggerLabelProps = (0, $2ca439ee1a804558$export$d6875122194c7b44)({
        id: menuTriggerProps.id,
        "aria-label": stringFormatter.format("buttonLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    let listBoxProps = (0, $2ca439ee1a804558$export$d6875122194c7b44)({
        id: menuProps.id,
        "aria-label": stringFormatter.format("listboxLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (0, $acw62.useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + .5 * rect.width);
        let centerY = Math.ceil(rect.top + .5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current.focus();
            state.toggle(null, "manual");
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    var _focusedItem_parentKey;
    let sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
    var _state_selectionManager_focusedKey;
    let itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
    let lastSection = (0, $acw62.useRef)(sectionKey);
    let lastItem = (0, $acw62.useRef)(itemKey);
    (0, $acw62.useEffect)(()=>{
        if ((0, $b82880ba168cba95$export$e1865c3bedcd822b)() && focusedItem != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = (section === null || section === void 0 ? void 0 : section["aria-label"]) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === "string" ? section.rendered : "") || "";
            let announcement = stringFormatter.format("focusAnnouncement", {
                isGroupChange: section && sectionKey !== lastSection.current,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...(0, $f2e2cae04a4a64ed$export$1005530eda016c13)(section, state.collection)
                ].length : 0,
                optionText: focusedItem["aria-label"] || focusedItem.textValue || "",
                isSelected: isSelected
            });
            (0, $f79874db04d9a0b8$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = (0, $b6e1ce9cd2ff6ef3$export$77d5aafae4e095b2)(state.collection);
    let lastSize = (0, $acw62.useRef)(optionCount);
    let lastOpen = (0, $acw62.useRef)(state.isOpen);
    (0, $acw62.useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, $b82880ba168cba95$export$e1865c3bedcd822b)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format("countAnnouncement", {
                optionCount: optionCount
            });
            (0, $f79874db04d9a0b8$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = (0, $acw62.useRef)(state.selectedKey);
    (0, $acw62.useEffect)(()=>{
        if ((0, $b82880ba168cba95$export$e1865c3bedcd822b)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem["aria-label"] || state.selectedItem.textValue || "";
            let announcement = stringFormatter.format("selectedAnnouncement", {
                optionText: optionText
            });
            (0, $f79874db04d9a0b8$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen) return (0, $e91a11878652e278$export$1c3ebcada18427bf)([
            inputRef.current,
            popoverRef.current
        ]);
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    return {
        labelProps: labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            onPress: onPress,
            onPressStart: onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(inputProps, {
            role: "combobox",
            "aria-expanded": menuTriggerProps["aria-expanded"],
            "aria-controls": state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            "aria-autocomplete": "list",
            "aria-activedescendant": focusedItem ? (0, $25babb4758798128$export$9145995848b05025)(state, focusedItem.key) : undefined,
            onTouchEnd: onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: "off",
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: "false"
        }),
        listBoxProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            linkBehavior: "selection"
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}


"use client";
// src/overlays/ariaShouldCloseOnInteractOutside.ts
var $6298ff82a135c7fc$export$ef74e55a94b62f23 = (element, triggerRef, state)=>{
    const trigger = triggerRef == null ? void 0 : triggerRef.current;
    if (!trigger || !trigger.contains(element)) {
        const startElements = document.querySelectorAll("body > span[data-focus-scope-start]");
        let focusScopeElements = [];
        startElements.forEach((startElement)=>{
            focusScopeElements.push(startElement.nextElementSibling);
        });
        if (focusScopeElements.length === 1) {
            state.close();
            return false;
        }
    }
    return !trigger || !trigger.contains(element);
};


"use client";
function $c88f0f4073a32e58$export$1e40b3ca02d92d21(originalProps) {
    var _a, _b, _c, _d, _e;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $4ed1752e3ad2a002$export$485ded5f26ebe08d).variantKeys);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const isClearable = originalProps.disableClearable !== void 0 ? !originalProps.disableClearable : originalProps.isReadOnly ? false : originalProps.isClearable;
    const { ref: ref, as: as, label: label, isLoading: isLoading, menuTrigger: menuTrigger = "focus", filterOptions: filterOptions = {
        sensitivity: "base"
    }, children: children, selectorIcon: selectorIcon, clearIcon: clearIcon, scrollRef: scrollRefProp, defaultFilter: defaultFilter, endContent: endContent, allowsEmptyCollection: allowsEmptyCollection = true, shouldCloseOnBlur: shouldCloseOnBlur = true, popoverProps: popoverProps = {}, inputProps: userInputProps = {}, scrollShadowProps: scrollShadowProps = {}, listboxProps: listboxProps = {}, selectorButtonProps: selectorButtonProps = {}, clearButtonProps: clearButtonProps = {}, showScrollIndicators: showScrollIndicators = true, allowsCustomValue: allowsCustomValue = false, validationBehavior: validationBehavior = (_c = globalContext == null ? void 0 : globalContext.validationBehavior) != null ? _c : "aria", className: className, classNames: classNames, errorMessage: errorMessage, onOpenChange: onOpenChange, onClose: onClose, isReadOnly: isReadOnly = false, ...otherProps } = props;
    const { contains: contains } = (0, $14b37b1eb7391728$export$3274cf84b703fff)(filterOptions);
    let state = (0, $7f43098d72b85ea6$export$b453a3bfd4a5fa9e)({
        ...originalProps,
        children: children,
        menuTrigger: menuTrigger,
        validationBehavior: validationBehavior,
        shouldCloseOnBlur: shouldCloseOnBlur,
        allowsEmptyCollection: allowsEmptyCollection,
        defaultFilter: defaultFilter && typeof defaultFilter === "function" ? defaultFilter : contains,
        onOpenChange: (open, menuTrigger2)=>{
            onOpenChange == null || onOpenChange(open, menuTrigger2);
            if (!open) onClose == null || onClose();
        }
    });
    state = {
        ...state,
        ...isReadOnly && {
            disabledKeys: /* @__PURE__ */ new Set([
                ...state.collection.getKeys()
            ])
        }
    };
    const buttonRef = (0, $acw62.useRef)(null);
    const inputWrapperRef = (0, $acw62.useRef)(null);
    const listBoxRef = (0, $acw62.useRef)(null);
    const popoverRef = (0, $acw62.useRef)(null);
    const inputRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const scrollShadowRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(scrollRefProp);
    const { buttonProps: buttonProps, inputProps: inputProps, listBoxProps: listBoxProps, isInvalid: isAriaInvalid, validationDetails: validationDetails, validationErrors: validationErrors } = (0, $c61cafbd4809c8e9$export$8c18d1b4f7232bbf)({
        validationBehavior: validationBehavior,
        ...originalProps,
        inputRef: inputRef,
        buttonRef: buttonRef,
        listBoxRef: listBoxRef,
        popoverRef: popoverRef
    }, state);
    const isInvalid = originalProps.isInvalid || isAriaInvalid;
    const slotsProps = {
        inputProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            label: label,
            ref: inputRef,
            wrapperRef: inputWrapperRef,
            onClick: ()=>{
                if (!state.isOpen && !!state.selectedItem) state.open();
            },
            isClearable: false,
            disableAnimation: disableAnimation
        }, userInputProps),
        popoverProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            offset: 5,
            placement: "bottom",
            triggerScaleOnOpen: false,
            disableAnimation: disableAnimation
        }, popoverProps),
        scrollShadowProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            ref: scrollShadowRef,
            isEnabled: (_d = showScrollIndicators && state.collection.size > 5) != null ? _d : true,
            hideScrollBar: true,
            offset: 15
        }, scrollShadowProps),
        listboxProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            hideEmptyContent: allowsCustomValue,
            emptyContent: "No results found.",
            disableAnimation: disableAnimation
        }, listboxProps),
        selectorButtonProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            isLoading: isLoading,
            size: "sm",
            variant: "light",
            radius: "full",
            color: isInvalid ? "danger" : originalProps == null ? void 0 : originalProps.color,
            isIconOnly: true,
            disableAnimation: disableAnimation
        }, selectorButtonProps),
        clearButtonProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            size: "sm",
            variant: "light",
            radius: "full",
            color: isInvalid ? "danger" : originalProps == null ? void 0 : originalProps.color,
            isIconOnly: true,
            disableAnimation: disableAnimation
        }, clearButtonProps)
    };
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const isOpen = ((_e = slotsProps.listboxProps) == null ? void 0 : _e.hideEmptyContent) ? state.isOpen && !!state.collection.size : state.isOpen;
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const key = inputRef.current.value;
        const item = state.collection.getItem(key);
        if (item && state.inputValue !== item.textValue) {
            state.setSelectedKey(key);
            state.setInputValue(item.textValue);
        }
    }, [
        inputRef.current
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOpen) {
            onFocus(true);
            if (popoverRef.current && inputWrapperRef.current) {
                let rect = inputWrapperRef.current.getBoundingClientRect();
                let popover = popoverRef.current;
                popover.style.width = rect.width + "px";
            }
        }
    }, [
        isOpen
    ]);
    if (inputProps.onKeyDown) {
        const originalOnKeyDown = inputProps.onKeyDown;
        inputProps.onKeyDown = (e)=>{
            if ("continuePropagation" in e) e.stopPropagation = ()=>{};
            return originalOnKeyDown(e);
        };
    }
    const Component = as || "div";
    const slots = (0, $acw62.useMemo)(()=>(0, $4ed1752e3ad2a002$export$485ded5f26ebe08d)({
            ...variantProps,
            isClearable: isClearable,
            disableAnimation: disableAnimation,
            className: className
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isClearable,
        disableAnimation,
        className
    ]);
    const onClear = (0, $acw62.useCallback)(()=>{
        state.setInputValue("");
        state.setSelectedKey(null);
    }, [
        state
    ]);
    const onFocus = (0, $acw62.useCallback)((isFocused)=>{
        var _a2;
        (_a2 = inputRef.current) == null || _a2.focus();
        state.setFocused(isFocused);
    }, [
        state,
        inputRef
    ]);
    const getBaseProps = ()=>({
            "data-invalid": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isInvalid),
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            className: slots.base({
                class: baseStyles
            })
        });
    const getSelectorButtonProps = ()=>{
        var _a2;
        return {
            ref: buttonRef,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(buttonProps, slotsProps.selectorButtonProps),
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            className: slots.selectorButton({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.selectorButton, (_a2 = slotsProps.selectorButtonProps) == null ? void 0 : _a2.className)
            })
        };
    };
    const getClearButtonProps = ()=>{
        var _a2, _b2;
        return {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(buttonProps, slotsProps.clearButtonProps),
            onPressStart: ()=>{},
            onPress: (e)=>{
                var _a3, _b3, _c2;
                (_b3 = (_a3 = slotsProps.clearButtonProps) == null ? void 0 : _a3.onPress) == null || _b3.call(_a3, e);
                if (state.selectedItem) onClear();
                else if (allowsCustomValue) {
                    state.setInputValue("");
                    state.close();
                }
                (_c2 = inputRef == null ? void 0 : inputRef.current) == null || _c2.focus();
            },
            "data-visible": !!state.selectedItem || ((_a2 = state.inputValue) == null ? void 0 : _a2.length) > 0,
            className: slots.clearButton({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.clearButton, (_b2 = slotsProps.clearButtonProps) == null ? void 0 : _b2.className)
            })
        };
    };
    const getInputProps = ()=>({
            ...otherProps,
            ...inputProps,
            ...slotsProps.inputProps,
            isInvalid: isInvalid,
            validationBehavior: validationBehavior,
            errorMessage: typeof errorMessage === "function" ? errorMessage({
                isInvalid: isInvalid,
                validationErrors: validationErrors,
                validationDetails: validationDetails
            }) : errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" ")),
            onClick: (0, $276a22df76563a4a$export$e08e3b67e392101e)(slotsProps.inputProps.onClick, otherProps.onClick)
        });
    const getListBoxProps = ()=>({
            state: state,
            ref: listBoxRef,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(slotsProps.listboxProps, listBoxProps, {
                shouldHighlightOnFocus: true
            })
        });
    const getPopoverProps = (props2 = {})=>{
        var _a2, _b2;
        const popoverProps2 = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(slotsProps.popoverProps, props2);
        return {
            state: state,
            ref: popoverRef,
            triggerRef: inputWrapperRef,
            scrollRef: listBoxRef,
            triggerType: "listbox",
            ...popoverProps2,
            classNames: {
                content: slots.popoverContent({
                    class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.popoverContent, (_b2 = (_a2 = slotsProps.popoverProps) == null ? void 0 : _a2.classNames) == null ? void 0 : _b2["content"], props2.className)
                })
            },
            shouldCloseOnInteractOutside: (popoverProps2 == null ? void 0 : popoverProps2.shouldCloseOnInteractOutside) ? popoverProps2.shouldCloseOnInteractOutside : (element)=>(0, $6298ff82a135c7fc$export$ef74e55a94b62f23)(element, inputWrapperRef, state),
            disableDialogFocus: true
        };
    };
    const getEmptyPopoverProps = ()=>{
        return {
            ref: popoverRef,
            className: "hidden"
        };
    };
    const getListBoxWrapperProps = (props2 = {})=>{
        var _a2;
        return {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(slotsProps.scrollShadowProps, props2),
            className: slots.listboxWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.listboxWrapper, (_a2 = slotsProps.scrollShadowProps) == null ? void 0 : _a2.className, props2 == null ? void 0 : props2.className)
            })
        };
    };
    const getEndContentWrapperProps = (props2 = {})=>({
            className: slots.endContentWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.endContentWrapper, props2 == null ? void 0 : props2.className)
            }),
            onClick: (e)=>{
                const inputFocused = inputRef.current === document.activeElement;
                if (!inputFocused && !state.isFocused && e.currentTarget === e.target) onFocus(true);
            }
        });
    return {
        Component: Component,
        inputRef: inputRef,
        label: label,
        state: state,
        slots: slots,
        classNames: classNames,
        isLoading: isLoading,
        clearIcon: clearIcon,
        isOpen: isOpen,
        endContent: endContent,
        isClearable: isClearable,
        disableAnimation: disableAnimation,
        allowsCustomValue: allowsCustomValue,
        selectorIcon: selectorIcon,
        getBaseProps: getBaseProps,
        getInputProps: getInputProps,
        getListBoxProps: getListBoxProps,
        getPopoverProps: getPopoverProps,
        getEmptyPopoverProps: getEmptyPopoverProps,
        getClearButtonProps: getClearButtonProps,
        getSelectorButtonProps: getSelectorButtonProps,
        getListBoxWrapperProps: getListBoxWrapperProps,
        getEndContentWrapperProps: getEndContentWrapperProps
    };
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $27a2d14f8c063b81$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $10ef8d441d7454cf$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $d73522b0e3c18105$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $241976d88b767e6b$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside && $d73522b0e3c18105$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $241976d88b767e6b$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $d73522b0e3c18105$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $d73522b0e3c18105$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $d73522b0e3c18105$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $d73522b0e3c18105$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $620bda56c550bc2a$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    (0, $acw62.useEffect)(()=>{
        if (isOpen) $620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays[$620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays[$620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays[$620bda56c550bc2a$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $d73522b0e3c18105$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $27a2d14f8c063b81$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $b27e9acf8b86f3f1$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $87f261ba8a37462d$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $87f261ba8a37462d$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let stepString = step.toString();
    let pointIndex = stepString.indexOf(".");
    let precision = pointIndex >= 0 ? stepString.length - pointIndex : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $87f261ba8a37462d$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $87f261ba8a37462d$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($87f261ba8a37462d$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($87f261ba8a37462d$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $87f261ba8a37462d$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $87f261ba8a37462d$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a1e54af352d383be$var$$edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $a1e54af352d383be$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $a1e54af352d383be$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $a1e54af352d383be$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $a1e54af352d383be$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: "totalWidth",
    height: "totalHeight"
};
const $a1e54af352d383be$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $a1e54af352d383be$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    let isPinchZoomedIn = ($a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport === null || $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.scale) > 1;
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport === null || $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport === null || $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if ($a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport) {
            top = $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.offsetTop;
            left = $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.offsetLeft;
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $b82880ba168cba95$export$78551043582a6a98)() && (containerNode.tagName === "BODY" || containerNode.tagName === "HTML") && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.pageTop;
        left = $a1e54af352d383be$var$$edcf132a9284368a$var$visualViewport.pageLeft;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $a1e54af352d383be$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    let containerScroll = containerDimensions.scroll[axis];
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$a1e54af352d383be$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = boundaryDimensions.scroll[$a1e54af352d383be$var$$edcf132a9284368a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = boundarySize + boundaryDimensions.scroll[$a1e54af352d383be$var$$edcf132a9284368a$var$AXIS[axis]] - padding;
    let startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[$a1e54af352d383be$var$$edcf132a9284368a$var$AXIS[axis]];
    let endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[$a1e54af352d383be$var$$edcf132a9284368a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($a1e54af352d383be$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $a1e54af352d383be$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $a1e54af352d383be$var$$edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $a1e54af352d383be$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$a1e54af352d383be$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $a1e54af352d383be$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $a1e54af352d383be$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $a1e54af352d383be$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $a1e54af352d383be$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $87f261ba8a37462d$export$7d15b64cf5a3a4c4)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$a1e54af352d383be$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$a1e54af352d383be$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    const containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[$a1e54af352d383be$var$$edcf132a9284368a$var$TOTAL_SIZE.height];
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    let overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - position.bottom - overlayHeight);
    let maxHeight = heightGrowthDirection !== "top" ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$a1e54af352d383be$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$a1e54af352d383be$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $a1e54af352d383be$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    let placementInfo = $a1e54af352d383be$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $a1e54af352d383be$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let normalizedOffset = offset;
    let space = $a1e54af352d383be$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $a1e54af352d383be$var$$edcf132a9284368a$var$parsePlacement(`${$a1e54af352d383be$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $a1e54af352d383be$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        let flippedSpace = $a1e54af352d383be$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = "bottom";
    if (placementInfo.axis === "top") {
        if (placementInfo.placement === "top") heightGrowthDirection = "top";
        else if (placementInfo.placement === "bottom") heightGrowthDirection = "bottom";
    } else if (placementInfo.crossAxis === "top") {
        if (placementInfo.crossPlacement === "top") heightGrowthDirection = "bottom";
        else if (placementInfo.crossPlacement === "bottom") heightGrowthDirection = "top";
    }
    let delta = $a1e54af352d383be$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $a1e54af352d383be$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $a1e54af352d383be$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = $a1e54af352d383be$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - position[crossAxis];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    const arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] - position[crossAxis] + arrowSize / 2;
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - position[crossAxis] - arrowSize / 2;
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $87f261ba8a37462d$export$7d15b64cf5a3a4c4)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $87f261ba8a37462d$export$7d15b64cf5a3a4c4)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $a1e54af352d383be$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let container = overlayNode instanceof HTMLElement ? $a1e54af352d383be$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isViewportContainer ? $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(targetNode) : $a1e54af352d383be$var$$edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $a1e54af352d383be$var$$edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $a1e54af352d383be$var$$edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $a1e54af352d383be$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerDimensions = $a1e54af352d383be$var$$edcf132a9284368a$var$getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(container) : $a1e54af352d383be$var$$edcf132a9284368a$var$getPosition(container, boundaryElement);
    if (container.tagName === "HTML" && boundaryElement.tagName === "BODY") {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return $a1e54af352d383be$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(node) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $a1e54af352d383be$var$$edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(node);
        let parentOffset = $a1e54af352d383be$var$$edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $a1e54af352d383be$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === "static" && !$a1e54af352d383be$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$a1e54af352d383be$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $a1e54af352d383be$var$$edcf132a9284368a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== "none" || /transform|perspective/.test(style.willChange) || style.filter !== "none" || style.contain === "paint" || // @ts-ignore
    "backdropFilter" in style && style.backdropFilter !== "none" || // @ts-ignore
    "WebkitBackdropFilter" in style && style.WebkitBackdropFilter !== "none";
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $99c8f022f7b6624e$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $99c8f022f7b6624e$export$683480f191c0e3ea(options) {
    const { ref: ref, onResize: onResize } = options;
    (0, $acw62.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$99c8f022f7b6624e$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
let $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $1d1121a8d9d3ea02$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let { arrowSize: arrowSize = 0, targetRef: targetRef, overlayRef: overlayRef, scrollRef: scrollRef = overlayRef, placement: placement = "bottom", containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $acw62.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $acw62.useRef)($1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.scale);
    (0, $acw62.useEffect)(()=>{
        if (isOpen) lastScale.current = $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $acw62.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        if (($1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        let overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            var _window_visualViewport;
            overlay.style.top = "0px";
            overlay.style.bottom = "";
            var _window_visualViewport_height;
            overlay.style.maxHeight = ((_window_visualViewport_height = (_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) !== null && _window_visualViewport_height !== void 0 ? _window_visualViewport_height : window.innerHeight) + "px";
        }
        let position = (0, $a1e54af352d383be$export$b3ceb0cbf1056d98)({
            placement: $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = "";
        overlay.style.bottom = "";
        Object.keys(position.position).forEach((key)=>overlay.style[key] = position.position[key] + "px");
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + "px" : undefined;
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $99c8f022f7b6624e$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $acw62.useRef)(false);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.addEventListener("scroll", onScroll);
        return ()=>{
            $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
            $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === null || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport === void 0 || $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("scroll", onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $acw62.useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    (0, $eac09c8eaabe44a4$export$18fc8428861184da)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            "aria-hidden": "true",
            role: "presentation",
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $1d1121a8d9d3ea02$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}


"use client";
// src/overlays/ariaHideOutside.ts
var $fac26a45b80deffc$var$refCountMap = /* @__PURE__ */ new WeakMap();
var $fac26a45b80deffc$var$observerStack = [];
function $fac26a45b80deffc$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = /* @__PURE__ */ new Set();
    let walk = (root2)=>{
        for (let element of root2.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            const parentElement = node.parentElement;
            if (visibleNodes.has(node) || hiddenNodes.has(parentElement) && parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root2, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        let acceptRoot = acceptNode(root2);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root2);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _a;
        let refCount = (_a = $fac26a45b80deffc$var$refCountMap.get(node)) != null ? _a : 0;
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $fac26a45b80deffc$var$refCountMap.set(node, refCount + 1);
    };
    if ($fac26a45b80deffc$var$observerStack.length) $fac26a45b80deffc$var$observerStack[$fac26a45b80deffc$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $fac26a45b80deffc$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $fac26a45b80deffc$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $fac26a45b80deffc$var$refCountMap.delete(node);
            } else $fac26a45b80deffc$var$refCountMap.set(node, count - 1);
        }
        if (observerWrapper === $fac26a45b80deffc$var$observerStack[$fac26a45b80deffc$var$observerStack.length - 1]) {
            $fac26a45b80deffc$var$observerStack.pop();
            if ($fac26a45b80deffc$var$observerStack.length) $fac26a45b80deffc$var$observerStack[$fac26a45b80deffc$var$observerStack.length - 1].observe();
        } else $fac26a45b80deffc$var$observerStack.splice($fac26a45b80deffc$var$observerStack.indexOf(observerWrapper), 1);
    };
}

"use client";
// src/overlays/utils.ts
var $d1aa5725be27b2ff$export$d0ca24f1cd6d5c41 = (placement)=>{
    const origins = {
        top: {
            originY: 1
        },
        bottom: {
            originY: 0
        },
        left: {
            originX: 1
        },
        right: {
            originX: 0
        },
        "top-start": {
            originX: 0,
            originY: 1
        },
        "top-end": {
            originX: 1,
            originY: 1
        },
        "bottom-start": {
            originX: 0,
            originY: 0
        },
        "bottom-end": {
            originX: 1,
            originY: 0
        },
        "right-start": {
            originX: 0,
            originY: 0
        },
        "right-end": {
            originX: 0,
            originY: 1
        },
        "left-start": {
            originX: 1,
            originY: 0
        },
        "left-end": {
            originX: 1,
            originY: 1
        }
    };
    return (origins == null ? void 0 : origins[placement]) || {};
};
var $d1aa5725be27b2ff$export$94c1bd7c13567e02 = (placement)=>{
    const mapPositions = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        "top-start": "top start",
        "top-end": "top end",
        "bottom-start": "bottom start",
        "bottom-end": "bottom end",
        "left-start": "left top",
        "left-end": "left bottom",
        "right-start": "right top",
        "right-end": "right bottom"
    };
    return mapPositions[placement];
};
var $d1aa5725be27b2ff$export$3d8d9aff18e3ce6 = (placement)=>{
    const mapPositions = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        center: "top"
    };
    return mapPositions[placement];
};
var $d1aa5725be27b2ff$export$6f1fde9fd5d7ce61 = (axisPlacement, overlayPlacement)=>{
    if (overlayPlacement.includes("-")) {
        const [position] = overlayPlacement.split("-");
        if (position.includes(axisPlacement)) return false;
    }
    return true;
};
var $d1aa5725be27b2ff$export$98fe55eaa3d1484b = (dynamicPlacement, placement)=>{
    if (placement.includes("-")) {
        const [, position] = placement.split("-");
        return `${dynamicPlacement}-${position}`;
    }
    return dynamicPlacement;
};




"use client";
function $ffbf04d300fda040$export$edc31d940c0b0631(props, state) {
    const { triggerRef: triggerRef, popoverRef: popoverRef, showArrow: showArrow, offset: offset = 7, crossOffset: crossOffset = 0, scrollRef: scrollRef, shouldFlip: shouldFlip, boundaryElement: boundaryElement, isDismissable: isDismissable = true, shouldCloseOnBlur: shouldCloseOnBlur = true, placement: placementProp = "top", containerPadding: containerPadding, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, isNonModal: isNonModalProp, isKeyboardDismissDisabled: isKeyboardDismissDisabled, updatePositionDeps: updatePositionDeps = [], ...otherProps } = props;
    const isNonModal = isNonModalProp != null ? isNonModalProp : true;
    const { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $620bda56c550bc2a$export$ea8f71083e90600f)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: shouldCloseOnBlur,
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside ? shouldCloseOnInteractOutside : (element)=>(0, $6298ff82a135c7fc$export$ef74e55a94b62f23)(element, triggerRef, state)
    }, popoverRef);
    const { overlayProps: positionProps, arrowProps: arrowProps, placement: placement, updatePosition: updatePosition } = (0, $1d1121a8d9d3ea02$export$d39e1813b3bdd0e1)({
        ...otherProps,
        shouldFlip: shouldFlip,
        crossOffset: crossOffset,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        scrollRef: scrollRef,
        boundaryElement: boundaryElement,
        containerPadding: containerPadding,
        placement: (0, $d1aa5725be27b2ff$export$94c1bd7c13567e02)(placementProp),
        offset: showArrow ? offset + 3 : offset,
        onClose: isNonModal ? state.close : ()=>{}
    });
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        if (!updatePositionDeps.length) return;
        updatePosition();
    }, updatePositionDeps);
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return (0, $fac26a45b80deffc$export$1c3ebcada18427bf)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $eb6b0cc1c3f8613d$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $b995f28c9a72ee4c$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $b995f28c9a72ee4c$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $e009837ee384a76a$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $27a2d14f8c063b81$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}





// src/utils/variants.ts
var $eae4eee576f3a8f9$var$solid = {
    default: "bg-default text-default-foreground",
    primary: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    success: "bg-success text-success-foreground",
    warning: "bg-warning text-warning-foreground",
    danger: "bg-danger text-danger-foreground",
    foreground: "bg-foreground text-background"
};
var $eae4eee576f3a8f9$var$shadow = {
    default: "shadow-lg shadow-default/50 bg-default text-default-foreground",
    primary: "shadow-lg shadow-primary/40 bg-primary text-primary-foreground",
    secondary: "shadow-lg shadow-secondary/40 bg-secondary text-secondary-foreground",
    success: "shadow-lg shadow-success/40 bg-success text-success-foreground",
    warning: "shadow-lg shadow-warning/40 bg-warning text-warning-foreground",
    danger: "shadow-lg shadow-danger/40 bg-danger text-danger-foreground",
    foreground: "shadow-lg shadow-foreground/40 bg-foreground text-background"
};
var $eae4eee576f3a8f9$var$bordered = {
    default: "bg-transparent border-default text-foreground",
    primary: "bg-transparent border-primary text-primary",
    secondary: "bg-transparent border-secondary text-secondary",
    success: "bg-transparent border-success text-success",
    warning: "bg-transparent border-warning text-warning",
    danger: "bg-transparent border-danger text-danger",
    foreground: "bg-transparent border-foreground text-foreground"
};
var $eae4eee576f3a8f9$var$flat = {
    default: "bg-default/40 text-default-foreground",
    primary: "bg-primary/20 text-primary",
    secondary: "bg-secondary/20 text-secondary",
    success: "bg-success/20 text-success-600 dark:text-success",
    warning: "bg-warning/20 text-warning-600 dark:text-warning",
    danger: "bg-danger/20 text-danger dark:text-danger-500",
    foreground: "bg-foreground/10 text-foreground"
};
var $eae4eee576f3a8f9$var$faded = {
    default: "border-default bg-default-100 text-default-foreground",
    primary: "border-default bg-default-100 text-primary",
    secondary: "border-default bg-default-100 text-secondary",
    success: "border-default bg-default-100 text-success",
    warning: "border-default bg-default-100 text-warning",
    danger: "border-default bg-default-100 text-danger",
    foreground: "border-default bg-default-100 text-foreground"
};
var $eae4eee576f3a8f9$var$light = {
    default: "bg-transparent text-default-foreground",
    primary: "bg-transparent text-primary",
    secondary: "bg-transparent text-secondary",
    success: "bg-transparent text-success",
    warning: "bg-transparent text-warning",
    danger: "bg-transparent text-danger",
    foreground: "bg-transparent text-foreground"
};
var $eae4eee576f3a8f9$var$ghost = {
    default: "border-default text-default-foreground hover:!bg-default",
    primary: "border-primary text-primary hover:!text-primary-foreground hover:!bg-primary",
    secondary: "border-secondary text-secondary hover:text-secondary-foreground hover:!bg-secondary",
    success: "border-success text-success hover:!text-success-foreground hover:!bg-success",
    warning: "border-warning text-warning hover:!text-warning-foreground hover:!bg-warning",
    danger: "border-danger text-danger hover:!text-danger-foreground hover:!bg-danger",
    foreground: "border-foreground text-foreground hover:!bg-foreground"
};
var $eae4eee576f3a8f9$export$ac48af53e325e736 = {
    solid: $eae4eee576f3a8f9$var$solid,
    shadow: $eae4eee576f3a8f9$var$shadow,
    bordered: $eae4eee576f3a8f9$var$bordered,
    flat: $eae4eee576f3a8f9$var$flat,
    faded: $eae4eee576f3a8f9$var$faded,
    light: $eae4eee576f3a8f9$var$light,
    ghost: $eae4eee576f3a8f9$var$ghost
};



// src/utils/classes.ts
var $eb279a3a1c5a3410$export$6a08aa478781aaec = (prefix)=>({
        color: `hsl(var(--${prefix}-foreground))`,
        backgroundColor: `hsl(var(--${prefix}-background))`
    });
var $eb279a3a1c5a3410$export$ca6a30fd41be6708 = [
    "focus-visible:z-10",
    "focus-visible:outline-2",
    "focus-visible:outline-focus",
    "focus-visible:outline-offset-2"
];
var $eb279a3a1c5a3410$export$13376dc9c57a19ba = [
    "outline-none",
    "data-[focus-visible=true]:z-10",
    "data-[focus-visible=true]:outline-2",
    "data-[focus-visible=true]:outline-focus",
    "data-[focus-visible=true]:outline-offset-2"
];
var $eb279a3a1c5a3410$export$23b17e6367ab693 = [
    "outline-none",
    "group-data-[focus-visible=true]:z-10",
    "group-data-[focus-visible=true]:ring-2",
    "group-data-[focus-visible=true]:ring-focus",
    "group-data-[focus-visible=true]:ring-offset-2",
    "group-data-[focus-visible=true]:ring-offset-background"
];
var $eb279a3a1c5a3410$export$e0ed6e3275f8955 = [
    "outline-none",
    "ring-2",
    "ring-focus",
    "ring-offset-2",
    "ring-offset-background"
];
var $eb279a3a1c5a3410$export$99bb92cbe55f4b50 = [
    "absolute",
    "top-1/2",
    "left-1/2",
    "-translate-x-1/2",
    "-translate-y-1/2"
];
var $eb279a3a1c5a3410$export$88a9566cd73b4303 = [
    "absolute",
    "inset-0"
];
var $eb279a3a1c5a3410$export$be7ffb88629cefac = {
    default: [
        "[&+.border-medium.border-default]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    primary: [
        "[&+.border-medium.border-primary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    secondary: [
        "[&+.border-medium.border-secondary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    success: [
        "[&+.border-medium.border-success]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    warning: [
        "[&+.border-medium.border-warning]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    danger: [
        "[&+.border-medium.border-danger]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ]
};


// src/components/popover.ts
var $51bb3cab21d331f1$export$899efff2d0433d49 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "z-0",
            "relative",
            "bg-transparent",
            "before:content-['']",
            "before:hidden",
            "before:z-[-1]",
            "before:absolute",
            "before:rotate-45",
            "before:w-2.5",
            "before:h-2.5",
            "before:rounded-sm",
            "data-[arrow=true]:before:block",
            "data-[placement=top]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top]:before:left-1/2",
            "data-[placement=top]:before:-translate-x-1/2",
            "data-[placement=top-start]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top-start]:before:left-3",
            "data-[placement=top-end]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top-end]:before:right-3",
            "data-[placement=bottom]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom]:before:left-1/2",
            "data-[placement=bottom]:before:-translate-x-1/2",
            "data-[placement=bottom-start]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom-start]:before:left-3",
            "data-[placement=bottom-end]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom-end]:before:right-3",
            "data-[placement=left]:before:-right-[calc(theme(spacing.5)/4_-_2px)]",
            "data-[placement=left]:before:top-1/2",
            "data-[placement=left]:before:-translate-y-1/2",
            "data-[placement=left-start]:before:-right-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=left-start]:before:top-1/4",
            "data-[placement=left-end]:before:-right-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=left-end]:before:bottom-1/4",
            "data-[placement=right]:before:-left-[calc(theme(spacing.5)/4_-_2px)]",
            "data-[placement=right]:before:top-1/2",
            "data-[placement=right]:before:-translate-y-1/2",
            "data-[placement=right-start]:before:-left-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=right-start]:before:top-1/4",
            "data-[placement=right-end]:before:-left-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=right-end]:before:bottom-1/4",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        content: [
            "z-10",
            "px-2.5",
            "py-1",
            "w-full",
            "inline-flex",
            "flex-col",
            "items-center",
            "justify-center",
            "box-border",
            "subpixel-antialiased",
            "outline-none",
            "box-border"
        ],
        trigger: [
            "z-10"
        ],
        backdrop: [
            "hidden"
        ],
        arrow: []
    },
    variants: {
        size: {
            sm: {
                content: "text-tiny"
            },
            md: {
                content: "text-small"
            },
            lg: {
                content: "text-medium"
            }
        },
        color: {
            default: {
                base: "before:bg-content1 before:shadow-small",
                content: "bg-content1"
            },
            foreground: {
                base: "before:bg-foreground",
                content: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.foreground
            },
            primary: {
                base: "before:bg-primary",
                content: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.primary
            },
            secondary: {
                base: "before:bg-secondary",
                content: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.secondary
            },
            success: {
                base: "before:bg-success",
                content: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.success
            },
            warning: {
                base: "before:bg-warning",
                content: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.warning
            },
            danger: {
                base: "before:bg-danger",
                content: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.danger
            }
        },
        radius: {
            none: {
                content: "rounded-none"
            },
            sm: {
                content: "rounded-small"
            },
            md: {
                content: "rounded-medium"
            },
            lg: {
                content: "rounded-large"
            },
            full: {
                content: "rounded-full"
            }
        },
        shadow: {
            sm: {
                content: "shadow-small"
            },
            md: {
                content: "shadow-medium"
            },
            lg: {
                content: "shadow-large"
            }
        },
        backdrop: {
            transparent: {},
            opaque: {
                backdrop: "bg-overlay/50 backdrop-opacity-disabled"
            },
            blur: {
                backdrop: "backdrop-blur-sm backdrop-saturate-150 bg-overlay/30"
            }
        },
        triggerScaleOnOpen: {
            true: {
                trigger: [
                    "aria-expanded:scale-[0.97]",
                    "aria-expanded:opacity-70",
                    "subpixel-antialiased"
                ]
            },
            false: {}
        },
        disableAnimation: {
            true: {
                base: "animate-none"
            }
        },
        isTriggerDisabled: {
            true: {
                trigger: "opacity-disabled pointer-events-none"
            },
            false: {}
        }
    },
    defaultVariants: {
        color: "default",
        radius: "lg",
        size: "md",
        shadow: "md",
        backdrop: "transparent",
        triggerScaleOnOpen: true
    },
    compoundVariants: [
        {
            backdrop: [
                "opaque",
                "blur"
            ],
            class: {
                backdrop: "block w-full h-full fixed inset-0 -z-30"
            }
        }
    ]
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6bef5c6274cc261b$export$c9058316764c140e(...refs) {
    if (refs.length === 1) return refs[0];
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}



"use client";
function $305aa6582ba8c3d7$export$542a6fd13ac93354(originalProps) {
    var _a, _b, _c;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $51bb3cab21d331f1$export$899efff2d0433d49).variantKeys);
    const { as: as, ref: ref, children: children, state: stateProp, triggerRef: triggerRefProp, scrollRef: scrollRef, defaultOpen: defaultOpen, onOpenChange: onOpenChange, isOpen: isOpenProp, isNonModal: isNonModal = true, shouldFlip: shouldFlip = true, containerPadding: containerPadding = 12, shouldBlockScroll: shouldBlockScroll = false, isDismissable: isDismissable = true, shouldCloseOnBlur: shouldCloseOnBlur, portalContainer: portalContainer, updatePositionDeps: updatePositionDeps, dialogProps: dialogPropsProp, placement: placementProp = "top", triggerType: triggerType = "dialog", showArrow: showArrow = false, offset: offset = 7, crossOffset: crossOffset = 0, boundaryElement: boundaryElement, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, motionProps: motionProps, className: className, classNames: classNames, onClose: onClose, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const domTriggerRef = (0, $acw62.useRef)(null);
    const wasTriggerPressedRef = (0, $acw62.useRef)(false);
    const triggerRef = triggerRefProp || domTriggerRef;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const innerState = (0, $13a9827b1c7dcaf2$export$61c6a8c84e605fb6)({
        isOpen: isOpenProp,
        defaultOpen: defaultOpen,
        onOpenChange: (isOpen)=>{
            onOpenChange == null || onOpenChange(isOpen);
            if (!isOpen) onClose == null || onClose();
        }
    });
    const state = stateProp || innerState;
    const { popoverProps: popoverProps, underlayProps: underlayProps, placement: ariaPlacement } = (0, $ffbf04d300fda040$export$edc31d940c0b0631)({
        triggerRef: triggerRef,
        isNonModal: isNonModal,
        popoverRef: domRef,
        placement: placementProp,
        offset: offset,
        scrollRef: scrollRef,
        isDismissable: isDismissable,
        shouldCloseOnBlur: shouldCloseOnBlur,
        boundaryElement: boundaryElement,
        crossOffset: crossOffset,
        shouldFlip: shouldFlip,
        containerPadding: containerPadding,
        updatePositionDeps: updatePositionDeps,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, state);
    const { triggerProps: triggerProps } = (0, $9fe00376a31edb04$export$f9d5c8beee7d008d)({
        type: triggerType
    }, state, triggerRef);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const slots = (0, $acw62.useMemo)(()=>(0, $51bb3cab21d331f1$export$899efff2d0433d49)({
            ...variantProps
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps)
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getPopoverProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(popoverProps, otherProps, props2),
            style: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(popoverProps.style, otherProps.style, props2.style)
        });
    const getDialogProps = (props2 = {})=>({
            "data-slot": "base",
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-arrow": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(showArrow),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-placement": (0, $d1aa5725be27b2ff$export$98fe55eaa3d1484b)(ariaPlacement, placementProp),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusProps, dialogPropsProp, props2),
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles)
            }),
            style: {
                outline: "none"
            }
        });
    const getContentProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-slot": "content",
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            "data-arrow": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(showArrow),
            "data-placement": (0, $d1aa5725be27b2ff$export$98fe55eaa3d1484b)(ariaPlacement, placementProp),
            className: slots.content({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.content, props2.className)
            })
        }), [
        slots,
        state.isOpen,
        showArrow,
        ariaPlacement,
        placementProp,
        classNames
    ]);
    const placement = (0, $acw62.useMemo)(()=>(0, $d1aa5725be27b2ff$export$6f1fde9fd5d7ce61)(ariaPlacement, placementProp) ? ariaPlacement || placementProp : placementProp, [
        ariaPlacement,
        placementProp
    ]);
    const onPress = (0, $acw62.useCallback)((e)=>{
        var _a2;
        let pressTimer;
        if (e.pointerType === "touch" && ((originalProps == null ? void 0 : originalProps.backdrop) === "blur" || (originalProps == null ? void 0 : originalProps.backdrop) === "opaque")) pressTimer = setTimeout(()=>{
            wasTriggerPressedRef.current = true;
        }, 100);
        else wasTriggerPressedRef.current = true;
        (_a2 = triggerProps.onPress) == null || _a2.call(triggerProps, e);
        return ()=>{
            clearTimeout(pressTimer);
        };
    }, [
        triggerProps == null ? void 0 : triggerProps.onPress
    ]);
    const getTriggerProps = (0, $acw62.useCallback)((props2 = {}, _ref = null)=>{
        const { isDisabled: isDisabled, ...otherProps2 } = props2;
        return {
            "data-slot": "trigger",
            "aria-haspopup": "dialog",
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(triggerProps, otherProps2),
            onPress: onPress,
            isDisabled: isDisabled,
            className: slots.trigger({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.trigger, props2.className),
                isTriggerDisabled: isDisabled
            }),
            ref: (0, $6bef5c6274cc261b$export$c9058316764c140e)(_ref, triggerRef)
        };
    }, [
        state,
        triggerProps,
        onPress,
        triggerRef
    ]);
    const getBackdropProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-slot": "backdrop",
            className: slots.backdrop({
                class: classNames == null ? void 0 : classNames.backdrop
            }),
            onClick: (e)=>{
                if (!wasTriggerPressedRef.current) {
                    e.preventDefault();
                    return;
                }
                state.close();
                wasTriggerPressedRef.current = false;
            },
            ...underlayProps,
            ...props2
        }), [
        slots,
        state.isOpen,
        classNames,
        underlayProps
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && (domRef == null ? void 0 : domRef.current)) return (0, $e91a11878652e278$export$1c3ebcada18427bf)([
            domRef == null ? void 0 : domRef.current
        ]);
    }, [
        state.isOpen,
        domRef
    ]);
    return {
        state: state,
        Component: Component,
        children: children,
        classNames: classNames,
        showArrow: showArrow,
        triggerRef: triggerRef,
        placement: placement,
        isNonModal: isNonModal,
        popoverRef: domRef,
        portalContainer: portalContainer,
        isOpen: state.isOpen,
        onClose: state.close,
        disableAnimation: disableAnimation,
        shouldBlockScroll: shouldBlockScroll,
        backdrop: (_c = originalProps.backdrop) != null ? _c : "transparent",
        motionProps: motionProps,
        getBackdropProps: getBackdropProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getDialogProps: getDialogProps,
        getContentProps: getContentProps
    };
}



var $acw62 = parcelRequire("acw62");
var $990aa7ce02c4ace2$export$2e2bcd8739ae039 = {};
$990aa7ce02c4ace2$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


var $d48bd4e32258c8f6$export$2e2bcd8739ae039 = {};
$d48bd4e32258c8f6$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


var $af5956a507196d23$export$2e2bcd8739ae039 = {};
$af5956a507196d23$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};


var $abf8e1852d308a65$export$2e2bcd8739ae039 = {};
$abf8e1852d308a65$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};


var $569731942c34612f$export$2e2bcd8739ae039 = {};
$569731942c34612f$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};


var $4246362f96d19ea4$export$2e2bcd8739ae039 = {};
$4246362f96d19ea4$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};


var $bb8007daa2703031$export$2e2bcd8739ae039 = {};
$bb8007daa2703031$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};


var $5ef281546f98e1bf$export$2e2bcd8739ae039 = {};
$5ef281546f98e1bf$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};


var $f2c1c7fa096e6b72$export$2e2bcd8739ae039 = {};
$f2c1c7fa096e6b72$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};


var $dab2e2a798100f1d$export$2e2bcd8739ae039 = {};
$dab2e2a798100f1d$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};


var $91cdcabffd9b9dd0$export$2e2bcd8739ae039 = {};
$91cdcabffd9b9dd0$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};


var $25f8c54bc30cd486$export$2e2bcd8739ae039 = {};
$25f8c54bc30cd486$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


var $b5e81903a5b8bd80$export$2e2bcd8739ae039 = {};
$b5e81903a5b8bd80$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};


var $91501db0ee3881c6$export$2e2bcd8739ae039 = {};
$91501db0ee3881c6$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};


var $fcb4bbf14a7c1d16$export$2e2bcd8739ae039 = {};
$fcb4bbf14a7c1d16$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};


var $ed99ba3655112414$export$2e2bcd8739ae039 = {};
$ed99ba3655112414$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


var $dd86cbf2a17a3fd7$export$2e2bcd8739ae039 = {};
$dd86cbf2a17a3fd7$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};


var $0dde560d3a8e6bd9$export$2e2bcd8739ae039 = {};
$0dde560d3a8e6bd9$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};


var $8d42f5cfd60a44b6$export$2e2bcd8739ae039 = {};
$8d42f5cfd60a44b6$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};


var $84b41e3835681503$export$2e2bcd8739ae039 = {};
$84b41e3835681503$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};


var $96dca429a92be124$export$2e2bcd8739ae039 = {};
$96dca429a92be124$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};


var $44cf861786e42ea7$export$2e2bcd8739ae039 = {};
$44cf861786e42ea7$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};


var $2f9b364c3bce2eaf$export$2e2bcd8739ae039 = {};
$2f9b364c3bce2eaf$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};


var $4874e6d6505a30a7$export$2e2bcd8739ae039 = {};
$4874e6d6505a30a7$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};


var $a839a2a0c16e907e$export$2e2bcd8739ae039 = {};
$a839a2a0c16e907e$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};


var $fcbfa07122df6a9a$export$2e2bcd8739ae039 = {};
$fcbfa07122df6a9a$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


var $d1340625d68eb806$export$2e2bcd8739ae039 = {};
$d1340625d68eb806$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};


var $6b00b2b7cb257abf$export$2e2bcd8739ae039 = {};
$6b00b2b7cb257abf$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};


var $037bb5eeb8b8e27b$export$2e2bcd8739ae039 = {};
$037bb5eeb8b8e27b$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};


var $7bca6efd52456983$export$2e2bcd8739ae039 = {};
$7bca6efd52456983$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};


var $bfc1642ee49b26fc$export$2e2bcd8739ae039 = {};
$bfc1642ee49b26fc$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};


var $ac7612c2560a966e$export$2e2bcd8739ae039 = {};
$ac7612c2560a966e$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


var $ecf0bc970a1f8b4b$export$2e2bcd8739ae039 = {};
$ecf0bc970a1f8b4b$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};


var $8088ee095aabd84a$export$2e2bcd8739ae039 = {};
$8088ee095aabd84a$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};


var $8e93d3d8da7f1ad1$export$2e2bcd8739ae039 = {};
$8e93d3d8da7f1ad1$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $990aa7ce02c4ace2$export$2e2bcd8739ae039),
    "bg-BG": (0, $d48bd4e32258c8f6$export$2e2bcd8739ae039),
    "cs-CZ": (0, $af5956a507196d23$export$2e2bcd8739ae039),
    "da-DK": (0, $abf8e1852d308a65$export$2e2bcd8739ae039),
    "de-DE": (0, $569731942c34612f$export$2e2bcd8739ae039),
    "el-GR": (0, $4246362f96d19ea4$export$2e2bcd8739ae039),
    "en-US": (0, $bb8007daa2703031$export$2e2bcd8739ae039),
    "es-ES": (0, $5ef281546f98e1bf$export$2e2bcd8739ae039),
    "et-EE": (0, $f2c1c7fa096e6b72$export$2e2bcd8739ae039),
    "fi-FI": (0, $dab2e2a798100f1d$export$2e2bcd8739ae039),
    "fr-FR": (0, $91cdcabffd9b9dd0$export$2e2bcd8739ae039),
    "he-IL": (0, $25f8c54bc30cd486$export$2e2bcd8739ae039),
    "hr-HR": (0, $b5e81903a5b8bd80$export$2e2bcd8739ae039),
    "hu-HU": (0, $91501db0ee3881c6$export$2e2bcd8739ae039),
    "it-IT": (0, $fcb4bbf14a7c1d16$export$2e2bcd8739ae039),
    "ja-JP": (0, $ed99ba3655112414$export$2e2bcd8739ae039),
    "ko-KR": (0, $dd86cbf2a17a3fd7$export$2e2bcd8739ae039),
    "lt-LT": (0, $0dde560d3a8e6bd9$export$2e2bcd8739ae039),
    "lv-LV": (0, $8d42f5cfd60a44b6$export$2e2bcd8739ae039),
    "nb-NO": (0, $84b41e3835681503$export$2e2bcd8739ae039),
    "nl-NL": (0, $96dca429a92be124$export$2e2bcd8739ae039),
    "pl-PL": (0, $44cf861786e42ea7$export$2e2bcd8739ae039),
    "pt-BR": (0, $2f9b364c3bce2eaf$export$2e2bcd8739ae039),
    "pt-PT": (0, $4874e6d6505a30a7$export$2e2bcd8739ae039),
    "ro-RO": (0, $a839a2a0c16e907e$export$2e2bcd8739ae039),
    "ru-RU": (0, $fcbfa07122df6a9a$export$2e2bcd8739ae039),
    "sk-SK": (0, $d1340625d68eb806$export$2e2bcd8739ae039),
    "sl-SI": (0, $6b00b2b7cb257abf$export$2e2bcd8739ae039),
    "sr-SP": (0, $037bb5eeb8b8e27b$export$2e2bcd8739ae039),
    "sv-SE": (0, $7bca6efd52456983$export$2e2bcd8739ae039),
    "tr-TR": (0, $bfc1642ee49b26fc$export$2e2bcd8739ae039),
    "uk-UA": (0, $ac7612c2560a966e$export$2e2bcd8739ae039),
    "zh-CN": (0, $ecf0bc970a1f8b4b$export$2e2bcd8739ae039),
    "zh-TW": (0, $8088ee095aabd84a$export$2e2bcd8739ae039)
};



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7d2c6e0c39112405$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $7d2c6e0c39112405$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $27a2d14f8c063b81$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $acw62.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$7d2c6e0c39112405$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $7d2c6e0c39112405$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $7d2c6e0c39112405$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $7d2c6e0c39112405$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}


function $ffab0043461eda28$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ffab0043461eda28$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $99f36fc287ff500a$export$f12b703ca79dfbb1)($ffab0043461eda28$var$$parcel$interopDefault((0, $8e93d3d8da7f1ad1$export$2e2bcd8739ae039)), "@react-aria/overlays");
    let labels = (0, $2ca439ee1a804558$export$d6875122194c7b44)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7d2c6e0c39112405$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $773f497e562f4caf$export$60d741e20e0aa309 = (0, $acw62.createContext)({});
function $773f497e562f4caf$export$db995ea7163b4b67(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $773f497e562f4caf$export$574e9b0fb070c3b0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($773f497e562f4caf$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? null : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function $773f497e562f4caf$export$574e9b0fb070c3b0() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($773f497e562f4caf$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d904978c3d71eac4$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $acw62.useRef)(false);
    let prevContext = (0, $acw62.useContext)((0, $6fd4398e2c555e24$export$5165eccb35aaadb5));
    ref = (0, $24eb3cf76a0ec7fd$export$4338b53315abf666)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $764513dca7bfd1d4$export$4debdb1a3f0fa79e)(prevContext, ref);
    (0, $acw62.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fd4398e2c555e24$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
});
function $d904978c3d71eac4$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $acw62.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fd4398e2c555e24$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
}




var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8b039484d708a25a$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $8b039484d708a25a$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $8afd3bdc2bd65163$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $acw62.useState)(false);
    let contextValue = (0, $acw62.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $773f497e562f4caf$export$574e9b0fb070c3b0)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b27e9acf8b86f3f1$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8b039484d708a25a$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d904978c3d71eac4$export$cf75428e0b9ed1ea), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(contents, portalContainer);
}
function $8b039484d708a25a$export$14c98a7594375490() {
    let ctx = (0, $acw62.useContext)($8b039484d708a25a$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}



function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $abbf779fde460163$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $abbf779fde460163$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $abbf779fde460163$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $083454c8244247d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};


const $b7455746a6cabbfe$var$isNotNull = (value)=>value !== null;
function $b7455746a6cabbfe$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($b7455746a6cabbfe$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;



function $f4ac54c83388ba0d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $d022ffbd5a1b0ae4$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d022ffbd5a1b0ae4$var$maxElapsed = 40;
function $d022ffbd5a1b0ae4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $f4ac54c83388ba0d$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $f69e8e67d72e77c2$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d022ffbd5a1b0ae4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d022ffbd5a1b0ae4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $d022ffbd5a1b0ae4$export$71ecace0a033b35a.length; i++)steps[$d022ffbd5a1b0ae4$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $9f96722ff12dbfe7$export$2cef06c20297c17d, cancel: $9f96722ff12dbfe7$export$ec99c0ef4978dccb, state: $9f96722ff12dbfe7$export$fff89137e9e818ce, steps: $9f96722ff12dbfe7$export$be3f796aed065412 } = (0, $d022ffbd5a1b0ae4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $448ce039afb5ec07$export$8793edee2d425525), true);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $e0feaef7a76d9154$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $bf99d85f7a843912$export$491112666e282270 = (0, $448ce039afb5ec07$export$8793edee2d425525);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $448ce039afb5ec07$export$8793edee2d425525);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$var$startsAsVariableToken = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $f9c5e88311214d2a$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $f9c5e88311214d2a$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $f9c5e88311214d2a$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$export$289398774300c991(current, element, depth = 1) {
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $d56714d1e4e43615$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $f9c5e88311214d2a$export$31f9caa2600b5723)(fallback) ? $ac0e5a3978f40f61$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $9d068be114f1d873$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $9d068be114f1d873$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = /*@__PURE__*/ $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = /*@__PURE__*/ $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = /*@__PURE__*/ $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = /*@__PURE__*/ $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = /*@__PURE__*/ $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};


const $a731b8aa4fe311d9$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a731b8aa4fe311d9$export$8e5250d1aa9bf370 = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateX = $a731b8aa4fe311d9$export$781d46a8aa670d52.x;
$a731b8aa4fe311d9$export$781d46a8aa670d52.translateY = $a731b8aa4fe311d9$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));




const $5e6ac566d022e9ed$var$toResolve = new Set();
let $5e6ac566d022e9ed$var$isScheduled = false;
let $5e6ac566d022e9ed$var$anyNeedsMeasurement = false;
function $5e6ac566d022e9ed$var$measureAllKeyframes() {
    if ($5e6ac566d022e9ed$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($5e6ac566d022e9ed$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $a731b8aa4fe311d9$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $5e6ac566d022e9ed$var$anyNeedsMeasurement = false;
    $5e6ac566d022e9ed$var$isScheduled = false;
    $5e6ac566d022e9ed$var$toResolve.forEach((resolver)=>resolver.complete());
    $5e6ac566d022e9ed$var$toResolve.clear();
}
function $5e6ac566d022e9ed$var$readAllKeyframes() {
    $5e6ac566d022e9ed$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $5e6ac566d022e9ed$var$anyNeedsMeasurement = true;
    });
}
function $5e6ac566d022e9ed$export$78b96d2a12593b05() {
    $5e6ac566d022e9ed$var$readAllKeyframes();
    $5e6ac566d022e9ed$var$measureAllKeyframes();
}
class $5e6ac566d022e9ed$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $5e6ac566d022e9ed$var$toResolve.add(this);
            if (!$5e6ac566d022e9ed$var$isScheduled) {
                $5e6ac566d022e9ed$var$isScheduled = true;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read($5e6ac566d022e9ed$var$readAllKeyframes);
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).resolveKeyframes($5e6ac566d022e9ed$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $5e6ac566d022e9ed$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $5e6ac566d022e9ed$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $9d068be114f1d873$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};



function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b7b50ce2c2d54405$var$NUMBER_TOKEN = "number";
const $b7b50ce2c2d54405$var$COLOR_TOKEN = "color";
const $b7b50ce2c2d54405$var$VAR_TOKEN = "var";
const $b7b50ce2c2d54405$var$VAR_FUNCTION_TOKEN = "var(";
const $b7b50ce2c2d54405$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $b7b50ce2c2d54405$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($b7b50ce2c2d54405$var$complexRegex, (parsedValue)=>{
        if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($b7b50ce2c2d54405$var$COLOR_TOKEN);
            values.push((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($b7b50ce2c2d54405$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($b7b50ce2c2d54405$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($b7b50ce2c2d54405$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $b7b50ce2c2d54405$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($b7b50ce2c2d54405$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $b7b50ce2c2d54405$var$parseComplexValue(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { split: split, types: types } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $b7b50ce2c2d54405$var$NUMBER_TOKEN) output += (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $b7b50ce2c2d54405$var$COLOR_TOKEN) output += (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parseComplexValue(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parseComplexValue,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};







const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $cfbe3d130e69a018$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $cfbe3d130e69a018$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$cfbe3d130e69a018$var$invalidTemplates.has(keyframe) && (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $5195dabd429072c3$export$4983792d11b61017 extends (0, $5e6ac566d022e9ed$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $f9c5e88311214d2a$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $ac0e5a3978f40f61$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $a731b8aa4fe311d9$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $a731b8aa4fe311d9$export$8e5250d1aa9bf370)(originType) && (0, $a731b8aa4fe311d9$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $e0feaef7a76d9154$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $cfbe3d130e69a018$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $a731b8aa4fe311d9$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $a731b8aa4fe311d9$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $af0183976178f4ae$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}






let $86c10e7c9731f599$var$now;
function $86c10e7c9731f599$var$clearTime() {
    $86c10e7c9731f599$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $86c10e7c9731f599$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($86c10e7c9731f599$var$now === undefined) $86c10e7c9731f599$export$2da9be4cfdb689b1.set((0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing || (0, $f69e8e67d72e77c2$export$dd826089e3c5e502).useManualTiming ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : performance.now());
        return $86c10e7c9731f599$var$now;
    },
    set: (newTime)=>{
        $86c10e7c9731f599$var$now = newTime;
        queueMicrotask($86c10e7c9731f599$var$clearTime);
    }
};






/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $a0c445b5dae442d5$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $a0c445b5dae442d5$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $bf99d85f7a843912$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $a0c445b5dae442d5$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $a4b13d1078db032d$var$MAX_RESOLVE_DELAY = 40;
class $a4b13d1078db032d$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $a4b13d1078db032d$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $5e6ac566d022e9ed$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $a0c445b5dae442d5$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $77818709e1bb6833$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8896dd99c5adcd8e$var$velocitySampleDuration = 5; // ms
function $8896dd99c5adcd8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8896dd99c5adcd8e$var$velocitySampleDuration, 0);
    return (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $18564078b4b5453e$var$safeMin = 0.001;
const $18564078b4b5453e$export$a3cdb76e84ee608e = 0.01;
const $18564078b4b5453e$export$1824b851fad8862b = 10.0;
const $18564078b4b5453e$export$ff08f2d53484465 = 0.05;
const $18564078b4b5453e$export$201ca48e54038115 = 1;
function $18564078b4b5453e$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bf99d85f7a843912$export$491112666e282270)(duration <= (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)($18564078b4b5453e$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$ff08f2d53484465, $18564078b4b5453e$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($18564078b4b5453e$export$a3cdb76e84ee608e, $18564078b4b5453e$export$1824b851fad8862b, (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18564078b4b5453e$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18564078b4b5453e$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18564078b4b5453e$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18564078b4b5453e$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18564078b4b5453e$var$rootIterations = 12;
function $18564078b4b5453e$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18564078b4b5453e$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18564078b4b5453e$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $74970353647274e4$var$durationKeys = [
    "duration",
    "bounce"
];
const $74970353647274e4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $74970353647274e4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $74970353647274e4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$74970353647274e4$var$isSpringType(options, $74970353647274e4$var$physicsKeys) && $74970353647274e4$var$isSpringType(options, $74970353647274e4$var$durationKeys)) {
        const derived = (0, $18564078b4b5453e$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $74970353647274e4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $74970353647274e4$var$getSpringOptions({
        ...options,
        velocity: -(0, $083454c8244247d6$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $18564078b4b5453e$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $8896dd99c5adcd8e$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $32590f88ff47d1eb$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $74970353647274e4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $8896dd99c5adcd8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c24ef35c6cea05c0$export$929e5a82286172a6 = /*@__PURE__*/ (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $b8e36ee1e1d53e83$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$e444123e42d03385);





const $a7ddcde2a4282efd$export$77edfce482316a60 = /*@__PURE__*/ (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $15a4078bfbf4856a$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $15a4078bfbf4856a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bf99d85f7a843912$export$f5708dca728d7177)($15a4078bfbf4856a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $15a4078bfbf4856a$var$easingLookup[definition];
    }
    return definition;
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $c7567ac386f9de45$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $d10f5c110742187b$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $318bff9c4d633c4a$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $318bff9c4d633c4a$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $318bff9c4d633c4a$var$getColorType = (v)=>$318bff9c4d633c4a$var$colorTypes.find((type)=>type.test(v));
function $318bff9c4d633c4a$var$asRGBA(color) {
    const type = $318bff9c4d633c4a$var$getColorType(color);
    (0, $bf99d85f7a843912$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $318bff9c4d633c4a$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $318bff9c4d633c4a$var$asRGBA(from);
    const toRGBA = $318bff9c4d633c4a$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $d10f5c110742187b$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $318bff9c4d633c4a$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $318bff9c4d633c4a$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $318bff9c4d633c4a$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $af5aaeace9224a20$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $af5aaeace9224a20$export$fed62ccc3fb1a568(origin, target) {
    if ($af5aaeace9224a20$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $01cf713761d5c075$var$mixNumber(a, b) {
    return (p)=>(0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $01cf713761d5c075$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $01cf713761d5c075$var$mixNumber;
    else if (typeof a === "string") return (0, $f9c5e88311214d2a$export$31f9caa2600b5723)(a) ? (0, $d10f5c110742187b$export$a6f92d4bae65c0f1) : (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(a) ? (0, $318bff9c4d633c4a$export$51e568cf5c039bac) : $01cf713761d5c075$export$65516310a87d8205;
    else if (Array.isArray(a)) return $01cf713761d5c075$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(a) ? (0, $318bff9c4d633c4a$export$51e568cf5c039bac) : $01cf713761d5c075$export$ebc23b6840c51ba1;
    return 0, $d10f5c110742187b$export$a6f92d4bae65c0f1;
}
function $01cf713761d5c075$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$01cf713761d5c075$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $01cf713761d5c075$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $01cf713761d5c075$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $01cf713761d5c075$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $01cf713761d5c075$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $af5aaeace9224a20$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $af5aaeace9224a20$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $af5aaeace9224a20$export$fed62ccc3fb1a568)(origin, target);
        return (0, $21841eadb135946f$export$a4627e546088548d)($01cf713761d5c075$export$3bbefa2f402845c4($01cf713761d5c075$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $bf99d85f7a843912$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $d10f5c110742187b$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $522550ed033be3a1$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $01cf713761d5c075$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $522550ed033be3a1$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $448ce039afb5ec07$export$8793edee2d425525) : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ecf42dec726852$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $b8e36ee1e1d53e83$export$216948827bbdc797)(ease) ? ease.map((0, $15a4078bfbf4856a$export$ef97fe084f156ca4)) : (0, $15a4078bfbf4856a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d61eba3ef0284b9c$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $481477152292f1a1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c1d90d9dcdf1c489$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $506ba0ac589a486f$export$f4ff70a5b4808fd8 = 20000;
function $506ba0ac589a486f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $506ba0ac589a486f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $506ba0ac589a486f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $c47eea579f7e92c3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing ? (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp : (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now()
    };
};



const $4dff3825d962577e$var$generators = {
    decay: (0, $32590f88ff47d1eb$export$ee3ff3a17106998),
    inertia: $32590f88ff47d1eb$export$ee3ff3a17106998,
    tween: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e),
    spring: $74970353647274e4$export$b36281d89752ae66
};
const $4dff3825d962577e$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $4dff3825d962577e$export$fd98d9cca67a58bc extends (0, $a4b13d1078db032d$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $5e6ac566d022e9ed$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $4dff3825d962577e$var$generators[type] || (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $c1d90d9dcdf1c489$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $21841eadb135946f$export$a4627e546088548d)($4dff3825d962577e$var$percentToProgress, (0, $522550ed033be3a1$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $506ba0ac589a486f$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $c47eea579f7e92c3$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $4dff3825d962577e$export$ee9b76de7353d815(options) {
    return new $4dff3825d962577e$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $3ba99b92464523da$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);


const $8a5eba8ea233e901$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $877fa42e69510d34$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $877fa42e69510d34$export$2cf569f5e2221176 || (0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($877fa42e69510d34$export$fcdd8f3f2160beda));
}
const $877fa42e69510d34$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $877fa42e69510d34$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $877fa42e69510d34$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $877fa42e69510d34$var$mapEasingToNativeEasingWithDefault(easing) {
    return $877fa42e69510d34$export$916ea73bcd3a6030(easing) || $877fa42e69510d34$export$2cf569f5e2221176.easeOut;
}
function $877fa42e69510d34$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $8a5eba8ea233e901$export$ff43f99925d7366b)(easing)) return $877fa42e69510d34$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($877fa42e69510d34$var$mapEasingToNativeEasingWithDefault);
    else return $877fa42e69510d34$export$2cf569f5e2221176[easing];
}


function $db913f3e2f893030$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $877fa42e69510d34$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $b5becce7483d72ec$var$supportsWaapi = /*@__PURE__*/ (0, $af0183976178f4ae$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $b5becce7483d72ec$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $b5becce7483d72ec$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $b5becce7483d72ec$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $877fa42e69510d34$export$fcdd8f3f2160beda)(options.ease);
}
function $b5becce7483d72ec$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $4dff3825d962577e$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $b5becce7483d72ec$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $b5becce7483d72ec$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $b5becce7483d72ec$var$sampleDelta,
        ease: "linear"
    };
}
class $b5becce7483d72ec$export$2a45abb4e6513325 extends (0, $a4b13d1078db032d$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $5195dabd429072c3$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($b5becce7483d72ec$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $b5becce7483d72ec$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $db913f3e2f893030$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $b7455746a6cabbfe$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $448ce039afb5ec07$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $448ce039afb5ec07$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $4dff3825d962577e$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $b5becce7483d72ec$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $b5becce7483d72ec$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $b5becce7483d72ec$var$supportsWaapi() && name && (0, $3ba99b92464523da$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




function $e28c0d669afb858f$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(onFrame);
}



const $600453809b90c7ce$export$20d68f04f30763a5 = (0, $af0183976178f4ae$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $dbc7ce14b01dea73$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $600453809b90c7ce$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $e28c0d669afb858f$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


const $9e7a9f8af70c9aa6$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $77818709e1bb6833$export$888a3d84909f9e3d).current || (0, $f69e8e67d72e77c2$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $b7455746a6cabbfe$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $dbc7ce14b01dea73$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $b5becce7483d72ec$export$2a45abb4e6513325).supports(options)) return new (0, $b5becce7483d72ec$export$2a45abb4e6513325)(options);
        else return new (0, $4dff3825d962577e$export$fd98d9cca67a58bc)(options);
    };



const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $e32104bb79321603$var$MAX_VELOCITY_DELTA = 30;
const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $e32104bb79321603$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.5.4";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($e32104bb79321603$export$67fcd818a264039d.current) $e32104bb79321603$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $e32104bb79321603$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $e32104bb79321603$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);


function $59a52f0eed0e0e03$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
}






function $30237768cea4eeef$export$b3f9dd865b560c6(name) {
    if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $3ba99b92464523da$export$a27eefbd8fb5e404).has(name)) return (0, $9dc069bda924fd3f$export$9fd24a634729c672)(name);
}



class $6a6d9b692feab770$export$3fe5fa490af65f85 extends (0, $e32104bb79321603$export$8cea36d14ee64562) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $30237768cea4eeef$export$b3f9dd865b560c6)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}


function $74e7c7f6c49b7323$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $6a6d9b692feab770$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $14d5e29c1a7af8ca$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $14d5e29c1a7af8ca$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $14d5e29c1a7af8ca$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $59a52f0eed0e0e03$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $9f96722ff12dbfe7$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $74e7c7f6c49b7323$export$3ac5aed310be0bee)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $697c3fc694c39c2d$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $697c3fc694c39c2d$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($697c3fc694c39c2d$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($697c3fc694c39c2d$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $697c3fc694c39c2d$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $7d7d5f8a14d3a662$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $697c3fc694c39c2d$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $14d5e29c1a7af8ca$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}


const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $7d7d5f8a14d3a662$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    let state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $351ff45a987b08cc$var$createState();
            isInitialRender = true;
        }
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};


function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}



function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}




function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeEndListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};



var $acw62 = parcelRequire("acw62");

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $ac502869c4d3e65a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $ac502869c4d3e65a$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}




const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}



function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX && treeScale.x > $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $d8332eb74969584e$var$TREE_SCALE_SNAP_MAX && treeScale.y > $d8332eb74969584e$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


const $784730508f12f72c$export$4e09c449d6c407f7 = typeof window !== "undefined";


// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}










function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}






function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};



const $a4ccbde0d696dfdf$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));




const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });



const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $5e6ac566d022e9ed$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            this.isRenderScheduled = false;
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.isRenderScheduled = false;
        this.scheduleRender = ()=>{
            if (!this.isRenderScheduled) {
                this.isRenderScheduled = true;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a4ccbde0d696dfdf$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $a8d82256030e9525$export$65570e08d843624d){
            const featureDefinition = (0, $a8d82256030e9525$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(target)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $5195dabd429072c3$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
        this.renderInstance = (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}





function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}





function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);






function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $acw62.Fragment)
    });
};


/**
 * @public
 */ const $5b406ea0040c92c5$export$2cb19dbf990677e3 = {
    renderer: (0, $2f8881102ac6dde9$export$56ba0183203348f5),
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1)
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}


"use client";
/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimation } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimation}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimation')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */ function $0bd28bebc5020f64$export$23c340a7eb1b419({ children: children, features: features, strict: strict = false }) {
    const [, setIsLoaded] = (0, $acw62.useState)(!$0bd28bebc5020f64$var$isLazyBundle(features));
    const loadedRenderer = (0, $acw62.useRef)(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */ if (!$0bd28bebc5020f64$var$isLazyBundle(features)) {
        const { renderer: renderer, ...loadedFeatures } = features;
        loadedRenderer.current = renderer;
        (0, $b9879783068c1762$export$449561ec5703cdc8)(loadedFeatures);
    }
    (0, $acw62.useEffect)(()=>{
        if ($0bd28bebc5020f64$var$isLazyBundle(features)) features().then(({ renderer: renderer, ...loadedFeatures })=>{
            (0, $b9879783068c1762$export$449561ec5703cdc8)(loadedFeatures);
            loadedRenderer.current = renderer;
            setIsLoaded(true);
        });
    }, []);
    return (0, $7b02d682eb115277$exports.jsx)((0, $410b846e117db9e1$export$40f10139ecf1f171).Provider, {
        value: {
            renderer: loadedRenderer.current,
            strict: strict
        },
        children: children
    });
}
function $0bd28bebc5020f64$var$isLazyBundle(features) {
    return typeof features === "function";
}


function $f1922c0288de6004$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
"use client";
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);




var $acw62 = parcelRequire("acw62");

const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);






const { schedule: $6b94e2cfb50380ff$export$bb76eed83315504c, cancel: $6b94e2cfb50380ff$export$3252729004b8456e } = (0, $d022ffbd5a1b0ae4$export$510b0596a933801a)(queueMicrotask, false);


function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $acw62 = parcelRequire("acw62");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


let $7fb0f4644b9cc8ad$var$scheduleHandoffComplete = false;
function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a;
    const { visualElement: parent } = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $7fb0f4644b9cc8ad$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
    const wantsHandoff = (0, $acw62.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete && ((_a = window.MotionHasOptimisedAnimation) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)));
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $6b94e2cfb50380ff$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $acw62.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        wantsHandoff.current = false;
        // This ensures all future calls to animateChanges() will run in useEffect
        if (!$7fb0f4644b9cc8ad$var$scheduleHandoffComplete) {
            $7fb0f4644b9cc8ad$var$scheduleHandoffComplete = true;
            queueMicrotask($7fb0f4644b9cc8ad$var$completeHandoff);
        }
    });
    return visualElement;
}
function $7fb0f4644b9cc8ad$var$completeHandoff() {
    window.MotionHandoffIsComplete = true;
}
function $7fb0f4644b9cc8ad$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $7fb0f4644b9cc8ad$var$getClosestProjectingNode(visualElement.parent);
}



var $acw62 = parcelRequire("acw62");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");



function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}





var $acw62 = parcelRequire("acw62");
"use client";
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});



const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            $b40dad60036091a1$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $b40dad60036091a1$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $7b02d682eb115277$exports.jsxs)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $7b02d682eb115277$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $b40dad60036091a1$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
}
function $b40dad60036091a1$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $a8d82256030e9525$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






function $5c26ebcca6422185$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$addWillChange(willChange, name) {
    const memberName = (0, $30237768cea4eeef$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(willChange, memberName);
}
function $5c26ebcca6422185$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) $5c26ebcca6422185$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) $5c26ebcca6422185$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$5c26ebcca6422185$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });





const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).render(()=>{
                (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState));
    return style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5($05db6db4ebcdf5f1$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");




function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $acw62.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $55c3387a92452647$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $e1392d1b9bf233d3$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $b40dad60036091a1$export$c3ad4a902bccc2d8)(config);
    };
}


const $c387ac1f18a40689$export$93df5a9c3551758b = /*@__PURE__*/ (0, $e1392d1b9bf233d3$export$d86feac869a7f0d5)();


const $7b066ad3acb0975d$export$953cecd6e717a553 = /*@__PURE__*/ (0, $f1922c0288de6004$export$3af29c0efb268f04)((0, $c387ac1f18a40689$export$93df5a9c3551758b));




"use client";
// src/transition-utils.ts
var $0541ef573799255c$export$9ee1d08bb6db426f = {
    ease: [
        0.36,
        0.66,
        0.4,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ],
    spring: [
        0.155,
        1.105,
        0.295,
        1.12
    ],
    springOut: [
        0.57,
        -0.15,
        0.62,
        0.07
    ],
    softSpring: [
        0.16,
        1.11,
        0.3,
        1.02
    ]
};
var $0541ef573799255c$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $0541ef573799255c$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $0541ef573799255c$export$9ee1d08bb6db426f.easeIn
    }
};
var $0541ef573799255c$export$55b7325ba41bb523 = {
    scaleSpring: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0,
                duration: 0.2
            }
        },
        exit: {
            transform: "scale(0.85)",
            opacity: 0,
            transition: {
                type: "easeOut",
                duration: 0.15
            }
        }
    },
    scaleSpringOpacity: {
        initial: {
            opacity: 0,
            transform: "scale(0.8)"
        },
        enter: {
            opacity: 1,
            transform: "scale(1)",
            transition: {
                type: "spring",
                bounce: 0,
                duration: 0.3
            }
        },
        exit: {
            opacity: 0,
            transform: "scale(0.96)",
            transition: {
                type: "easeOut",
                bounce: 0,
                duration: 0.15
            }
        }
    },
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    scaleFadeIn: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                duration: 0.25,
                ease: $0541ef573799255c$export$9ee1d08bb6db426f.easeIn
            }
        },
        exit: {
            transform: "scale(0.95)",
            opacity: 0,
            transition: {
                duration: 0.2,
                ease: $0541ef573799255c$export$9ee1d08bb6db426f.easeOut
            }
        }
    },
    scaleInOut: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                duration: 0.4,
                ease: $0541ef573799255c$export$9ee1d08bb6db426f.ease
            }
        },
        exit: {
            transform: "scale(1.03)",
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: $0541ef573799255c$export$9ee1d08bb6db426f.ease
            }
        }
    },
    fade: {
        enter: {
            opacity: 1,
            transition: {
                duration: 0.4,
                ease: $0541ef573799255c$export$9ee1d08bb6db426f.ease
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: $0541ef573799255c$export$9ee1d08bb6db426f.ease
            }
        }
    },
    collapse: {
        enter: {
            opacity: 1,
            height: "auto",
            transition: {
                height: {
                    type: "spring",
                    bounce: 0,
                    duration: 0.3
                },
                opacity: {
                    easings: "ease",
                    duration: 0.4
                }
            }
        },
        exit: {
            opacity: 0,
            height: 0,
            transition: {
                easings: "ease",
                duration: 0.3
            }
        }
    }
};





var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3fee594f3ffdb6a2$export$d55e7ee900f34e93(props, ref) {
    let { role: role = "dialog" } = props;
    let titleId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)();
    titleId = props["aria-label"] ? undefined : titleId;
    let isRefocusing = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $b92af0002e176fee$export$80f3e147d781571c)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $b92af0002e176fee$export$80f3e147d781571c)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $8b039484d708a25a$export$14c98a7594375490)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            "aria-labelledby": props["aria-labelledby"] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}



"use client";
var $eb832465a4ea348e$var$FreeSoloPopoverWrapper = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)(({ children: children, motionProps: motionProps, placement: placement, disableAnimation: disableAnimation, style: styleProp = {}, transformOrigin: transformOrigin = {}, ...otherProps }, ref)=>{
    let style = styleProp;
    if (transformOrigin.originX !== void 0 || transformOrigin.originY !== void 0) style = {
        ...style,
        transformOrigin: transformOrigin
    };
    else style = {
        ...style,
        ...(0, $d1aa5725be27b2ff$export$d0ca24f1cd6d5c41)(placement === "center" ? "top" : placement)
    };
    return disableAnimation ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...otherProps,
        ref: ref,
        children: children
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
        features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).div, {
            ref: ref,
            animate: "enter",
            exit: "exit",
            initial: "initial",
            style: style,
            variants: (0, $0541ef573799255c$export$55b7325ba41bb523).scaleSpringOpacity,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherProps, motionProps),
            children: children
        })
    });
});
$eb832465a4ea348e$var$FreeSoloPopoverWrapper.displayName = "NextUI.FreeSoloPopoverWrapper";
var $eb832465a4ea348e$var$FreeSoloPopover = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)(({ children: children, transformOrigin: transformOrigin, disableDialogFocus: disableDialogFocus = false, ...props }, ref)=>{
    const { Component: Component, state: state, placement: placement, backdrop: backdrop, portalContainer: portalContainer, disableAnimation: disableAnimation, motionProps: motionProps, isNonModal: isNonModal, getPopoverProps: getPopoverProps, getBackdropProps: getBackdropProps, getDialogProps: getDialogProps, getContentProps: getContentProps } = (0, $305aa6582ba8c3d7$export$542a6fd13ac93354)({
        ...props,
        ref: ref
    });
    const dialogRef = $acw62.useRef(null);
    const { dialogProps: ariaDialogProps, titleProps: titleProps } = (0, $3fee594f3ffdb6a2$export$d55e7ee900f34e93)({}, dialogRef);
    const dialogProps = getDialogProps({
        ...!disableDialogFocus && {
            ref: dialogRef
        },
        ...ariaDialogProps
    });
    const backdropContent = $acw62.useMemo(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
            features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $0541ef573799255c$export$55b7325ba41bb523).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $8b039484d708a25a$export$c6fdb837b070b4ff), {
        portalContainer: portalContainer,
        children: [
            !isNonModal && backdropContent,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...getPopoverProps(),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($eb832465a4ea348e$var$FreeSoloPopoverWrapper, {
                    disableAnimation: disableAnimation,
                    motionProps: motionProps,
                    placement: placement,
                    tabIndex: -1,
                    transformOrigin: transformOrigin,
                    ...dialogProps,
                    children: [
                        !isNonModal && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ffab0043461eda28$export$2317d149ed6f78c4), {
                            onDismiss: state.close
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                            ...getContentProps(),
                            children: typeof children === "function" ? children(titleProps) : children
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ffab0043461eda28$export$2317d149ed6f78c4), {
                            onDismiss: state.close
                        })
                    ]
                })
            })
        ]
    });
});
$eb832465a4ea348e$var$FreeSoloPopover.displayName = "NextUI.FreeSoloPopover";
var $eb832465a4ea348e$export$4f32f7e42026f90b = $eb832465a4ea348e$var$FreeSoloPopover;




// src/components/scroll-shadow.ts
var $e2f8cbb15d7707c5$var$verticalShadow = [
    "data-[top-scroll=true]:[mask-image:linear-gradient(0deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[bottom-scroll=true]:[mask-image:linear-gradient(180deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[top-bottom-scroll=true]:[mask-image:linear-gradient(#000,#000,transparent_0,#000_var(--scroll-shadow-size),#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]"
];
var $e2f8cbb15d7707c5$var$horizontalShadow = [
    "data-[left-scroll=true]:[mask-image:linear-gradient(270deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[right-scroll=true]:[mask-image:linear-gradient(90deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[left-right-scroll=true]:[mask-image:linear-gradient(to_right,#000,#000,transparent_0,#000_var(--scroll-shadow-size),#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]"
];
var $e2f8cbb15d7707c5$export$1515b480513bd18e = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: [],
    variants: {
        orientation: {
            vertical: [
                "overflow-y-auto",
                ...$e2f8cbb15d7707c5$var$verticalShadow
            ],
            horizontal: [
                "overflow-x-auto",
                ...$e2f8cbb15d7707c5$var$horizontalShadow
            ]
        },
        hideScrollBar: {
            true: "scrollbar-hide",
            false: ""
        }
    },
    defaultVariants: {
        orientation: "vertical",
        hideScrollBar: false
    }
});



// src/index.ts


var $acw62 = parcelRequire("acw62");
function $5d3ab8512570882a$export$372ebfbb988329b7(props = {}) {
    const { domRef: domRef, isEnabled: isEnabled = true, overflowCheck: overflowCheck = "vertical", visibility: visibility = "auto", offset: offset = 0, onVisibilityChange: onVisibilityChange, updateDeps: updateDeps = [] } = props;
    const visibleRef = (0, $acw62.useRef)(visibility);
    (0, $acw62.useEffect)(()=>{
        const el = domRef == null ? void 0 : domRef.current;
        if (!el || !isEnabled) return;
        const setAttributes = (direction, hasBefore, hasAfter, prefix, suffix)=>{
            if (visibility === "auto") {
                const both = `${prefix}${(0, $91ffd9bd684fd1b9$export$9a00dee1beb8f576)(suffix)}Scroll`;
                if (hasBefore && hasAfter) {
                    el.dataset[both] = "true";
                    el.removeAttribute(`data-${prefix}-scroll`);
                    el.removeAttribute(`data-${suffix}-scroll`);
                } else {
                    el.dataset[`${prefix}Scroll`] = hasBefore.toString();
                    el.dataset[`${suffix}Scroll`] = hasAfter.toString();
                    el.removeAttribute(`data-${prefix}-${suffix}-scroll`);
                }
            } else {
                const next = hasBefore && hasAfter ? "both" : hasBefore ? prefix : hasAfter ? suffix : "none";
                if (next !== visibleRef.current) {
                    onVisibilityChange == null || onVisibilityChange(next);
                    visibleRef.current = next;
                }
            }
        };
        const checkOverflow = ()=>{
            const directions = [
                {
                    type: "vertical",
                    prefix: "top",
                    suffix: "bottom"
                },
                {
                    type: "horizontal",
                    prefix: "left",
                    suffix: "right"
                }
            ];
            for (const { type: type, prefix: prefix, suffix: suffix } of directions)if (overflowCheck === type || overflowCheck === "both") {
                const hasBefore = type === "vertical" ? el.scrollTop > offset : el.scrollLeft > offset;
                const hasAfter = type === "vertical" ? el.scrollTop + el.clientHeight + offset < el.scrollHeight : el.scrollLeft + el.clientWidth + offset < el.scrollWidth;
                setAttributes(type, hasBefore, hasAfter, prefix, suffix);
            }
        };
        const clearOverflow = ()=>{
            [
                "top",
                "bottom",
                "top-bottom",
                "left",
                "right",
                "left-right"
            ].forEach((attr)=>{
                el.removeAttribute(`data-${attr}-scroll`);
            });
        };
        checkOverflow();
        el.addEventListener("scroll", checkOverflow);
        if (visibility !== "auto") {
            clearOverflow();
            if (visibility === "both") {
                el.dataset.topBottomScroll = String(overflowCheck === "vertical");
                el.dataset.leftRightScroll = String(overflowCheck === "horizontal");
            } else {
                el.dataset.topBottomScroll = "false";
                el.dataset.leftRightScroll = "false";
                [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].forEach((attr)=>{
                    el.dataset[`${attr}Scroll`] = String(visibility === attr);
                });
            }
        }
        return ()=>{
            el.removeEventListener("scroll", checkOverflow);
            clearOverflow();
        };
    }, [
        ...updateDeps,
        isEnabled,
        visibility,
        overflowCheck,
        onVisibilityChange,
        domRef
    ]);
}



var $acw62 = parcelRequire("acw62");

"use client";
function $7c66aeade38d0dab$export$90e7448ca01cde65(originalProps) {
    var _a;
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $e2f8cbb15d7707c5$export$1515b480513bd18e).variantKeys);
    const { ref: ref, as: as, children: children, className: className, style: style, size: size = 40, offset: offset = 0, visibility: visibility = "auto", isEnabled: isEnabled = true, onVisibilityChange: onVisibilityChange, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    (0, $5d3ab8512570882a$export$372ebfbb988329b7)({
        domRef: domRef,
        offset: offset,
        visibility: visibility,
        isEnabled: isEnabled,
        onVisibilityChange: onVisibilityChange,
        updateDeps: [
            children
        ],
        overflowCheck: (_a = originalProps.orientation) != null ? _a : "vertical"
    });
    const styles = (0, $acw62.useMemo)(()=>(0, $e2f8cbb15d7707c5$export$1515b480513bd18e)({
            ...variantProps,
            className: className
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        className
    ]);
    const getBaseProps = (props2 = {})=>{
        var _a2;
        return {
            ref: domRef,
            className: styles,
            "data-orientation": (_a2 = originalProps.orientation) != null ? _a2 : "vertical",
            style: {
                "--scroll-shadow-size": `${size}px`,
                ...style,
                ...props2.style
            },
            ...otherProps,
            ...props2
        };
    };
    return {
        Component: Component,
        styles: styles,
        domRef: domRef,
        children: children,
        getBaseProps: getBaseProps
    };
}




"use client";
var $67ab465da978cead$var$ScrollShadow = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, getBaseProps: getBaseProps } = (0, $7c66aeade38d0dab$export$90e7448ca01cde65)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...getBaseProps(),
        children: children
    });
});
$67ab465da978cead$var$ScrollShadow.displayName = "NextUI.ScrollShadow";
var $67ab465da978cead$export$bef3e985c75eafb5 = $67ab465da978cead$var$ScrollShadow;


// src/chevron-down.tsx

var $3d5bf69f39f72f17$export$4857d3f3f5f8319b = ({ strokeWidth: strokeWidth = 1.5, ...props })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth,
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });

// src/close.tsx

var $a106e18a12a75ce7$export$cae179f078f4b4a4 = (props)=>{
    const { isSelected: isSelected, isIndeterminate: isIndeterminate, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        width: "1em",
        ...otherProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6L6 18M6 6l12 12"
        })
    });
};



"use client";
function $7a701348cd238119$export$5db3965fb0ec818(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        "data-selected": isSelected,
        role: "presentation",
        viewBox: "0 0 17 18",
        ...otherProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            fill: "none",
            points: "1 9 7 14 15 4",
            stroke: "currentColor",
            strokeDasharray: 22,
            strokeDashoffset: isSelected ? 44 : 66,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            style: !disableAnimation ? {
                transition: "stroke-dashoffset 200ms ease"
            } : {}
        })
    });
}



var $acw62 = parcelRequire("acw62");


// src/components/menu.ts
var $c8ce6ffc45f51469$export$b1e5508a851be14d = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "w-full relative flex flex-col gap-1 p-1",
        list: "w-full flex flex-col gap-0.5 outline-none",
        emptyContent: [
            "h-10",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "text-foreground-400",
            "text-start"
        ]
    }
});
var $c8ce6ffc45f51469$export$c176f998e71d0f08 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "group",
            "gap-2",
            "items-center",
            "justify-between",
            "relative",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "box-border",
            "rounded-small",
            "subpixel-antialiased",
            "outline-none",
            "cursor-pointer",
            "tap-highlight-transparent",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba),
            "data-[focus-visible=true]:dark:ring-offset-background-content1"
        ],
        wrapper: "w-full flex flex-col items-start justify-center",
        title: "flex-1 text-small font-normal truncate",
        description: [
            "w-full",
            "text-tiny",
            "text-foreground-500",
            "group-hover:text-current"
        ],
        selectedIcon: [
            "text-inherit",
            "w-3",
            "h-3",
            "flex-shrink-0"
        ],
        shortcut: [
            "px-1",
            "py-0.5",
            "rounded",
            "font-sans",
            "text-foreground-500",
            "text-tiny",
            "border-small",
            "border-default-300",
            "group-hover:border-current"
        ]
    },
    variants: {
        variant: {
            solid: {
                base: ""
            },
            bordered: {
                base: "border-medium border-transparent bg-transparent"
            },
            light: {
                base: "bg-transparent"
            },
            faded: {
                base: [
                    "border-small border-transparent hover:border-default data-[hover=true]:bg-default-100",
                    "data-[selectable=true]:focus:border-default data-[selectable=true]:focus:bg-default-100"
                ]
            },
            flat: {
                base: ""
            },
            shadow: {
                base: "data-[hover=true]:shadow-lg"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        showDivider: {
            true: {
                base: [
                    "mb-1.5",
                    "after:content-['']",
                    "after:absolute",
                    "after:-bottom-1",
                    "after:left-0",
                    "after:right-0",
                    "after:h-divider",
                    "after:bg-divider"
                ]
            },
            false: {}
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                base: "data-[hover=true]:transition-colors"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        color: "default",
        showDivider: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:shadow-default/50 data-[hover=true]:bg-default data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:shadow-default/50 data-[selectable=true]:focus:bg-default data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:shadow-primary/30 data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:shadow-primary/30 data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:shadow-secondary/30 data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:shadow-secondary/30 data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:shadow-success/30 data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:shadow-success/30 data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:shadow-warning/30 data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:shadow-warning/30 data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:shadow-danger/30 data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:shadow-danger/30 data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "bordered",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:border-default",
                    "data-[selectable=true]:focus:border-default"
                ]
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:border-primary data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:border-primary data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:border-secondary data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:border-secondary data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:border-success data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:border-success data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:border-warning data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:border-warning data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:border-danger data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:border-danger data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "flat",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default/40",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default/40",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary/20 data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:bg-primary/20 data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary/20 data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:bg-secondary/20 data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success/20 data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:bg-success/20 data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning/20 data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:bg-warning/20 data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger/20 data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:bg-danger/20 data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "faded",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "light",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-500",
                    "data-[selectable=true]:focus:text-default-500"
                ]
            }
        },
        {
            variant: "light",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "light",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "light",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "light",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "light",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        }
    ]
});
var $c8ce6ffc45f51469$export$95e0837a3419f5c1 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "relative mb-2",
        heading: "pl-1 text-tiny text-foreground-500",
        group: "data-[has-title=true]:pt-1",
        divider: "mt-2"
    }
});




// src/dom-props.ts
var $0926fb353dcb68df$export$5f28e08e1b07d392 = /* @__PURE__ */ new Set([
    "id",
    "type",
    "style",
    "title",
    "role",
    "tabIndex",
    "htmlFor",
    "width",
    "height",
    "abbr",
    "accept",
    "acceptCharset",
    "accessKey",
    "action",
    "allowFullScreen",
    "allowTransparency",
    "alt",
    "async",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "challenge",
    "charset",
    "checked",
    "cite",
    "class",
    "className",
    "cols",
    "colSpan",
    "command",
    "content",
    "contentEditable",
    "contextMenu",
    "controls",
    "coords",
    "crossOrigin",
    "data",
    "dateTime",
    "default",
    "defer",
    "dir",
    "disabled",
    "download",
    "draggable",
    "dropzone",
    "encType",
    "enterKeyHint",
    "for",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "headers",
    "hidden",
    "high",
    "href",
    "hrefLang",
    "httpEquiv",
    "icon",
    "inputMode",
    "isMap",
    "itemId",
    "itemProp",
    "itemRef",
    "itemScope",
    "itemType",
    "kind",
    "label",
    "lang",
    "list",
    "loop",
    "manifest",
    "max",
    "maxLength",
    "media",
    "mediaGroup",
    "method",
    "min",
    "minLength",
    "multiple",
    "muted",
    "name",
    "noValidate",
    "open",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "poster",
    "preload",
    "radioGroup",
    "referrerPolicy",
    "readOnly",
    "rel",
    "required",
    "rows",
    "rowSpan",
    "sandbox",
    "scope",
    "scoped",
    "scrolling",
    "seamless",
    "selected",
    "shape",
    "size",
    "sizes",
    "slot",
    "sortable",
    "span",
    "spellCheck",
    "src",
    "srcDoc",
    "srcSet",
    "start",
    "step",
    "target",
    "translate",
    "typeMustMatch",
    "useMap",
    "value",
    "wmode",
    "wrap"
]);
var $0926fb353dcb68df$export$8519a64fe4099896 = /* @__PURE__ */ new Set([
    "onCopy",
    "onCut",
    "onPaste",
    "onLoad",
    "onError",
    "onWheel",
    "onScroll",
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate",
    "onKeyDown",
    "onKeyPress",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "onChange",
    "onInput",
    "onSubmit",
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp",
    "onPointerDown",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerUp",
    "onSelect",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration",
    "onTransitionEnd"
]);


// src/filter-dom-props.ts
var $55f8b00eba900d0b$var$propRe = /^(data-.*)$/;
var $55f8b00eba900d0b$var$ariaRe = /^(aria-.*)$/;
var $55f8b00eba900d0b$var$funcRe = /^(on[A-Z].*)$/;
function $55f8b00eba900d0b$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable = true, enabled: enabled = true, propNames: propNames, omitPropNames: omitPropNames, omitEventNames: omitEventNames, omitDataProps: omitDataProps, omitEventProps: omitEventProps } = opts;
    let filteredProps = {};
    if (!enabled) return props;
    for(const prop in props){
        if (omitPropNames == null ? void 0 : omitPropNames.has(prop)) continue;
        if ((omitEventNames == null ? void 0 : omitEventNames.has(prop)) && $55f8b00eba900d0b$var$funcRe.test(prop)) continue;
        if ($55f8b00eba900d0b$var$funcRe.test(prop) && !(0, $0926fb353dcb68df$export$8519a64fe4099896).has(prop)) continue;
        if (omitDataProps && $55f8b00eba900d0b$var$propRe.test(prop)) continue;
        if (omitEventProps && $55f8b00eba900d0b$var$funcRe.test(prop)) continue;
        if (Object.prototype.hasOwnProperty.call(props, prop) && ((0, $0926fb353dcb68df$export$5f28e08e1b07d392).has(prop) || labelable && $55f8b00eba900d0b$var$ariaRe.test(prop) || (propNames == null ? void 0 : propNames.has(prop)) || $55f8b00eba900d0b$var$propRe.test(prop)) || $55f8b00eba900d0b$var$funcRe.test(prop)) filteredProps[prop] = props[prop];
    }
    return filteredProps;
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount = 0;
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount--;
        if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $4a6a19e952a3e910$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $acw62.useEffect)($4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $195fc3c02bfc1bb3$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $4a4107ecda93bad9$export$9a302a45f65d0572)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && (0, $9a13bb9abd310520$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ((0, $9a13bb9abd310520$export$16792effe837dba3)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $acw62.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $b92af0002e176fee$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $acw62.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $acw62.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $acw62.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) {
            let itemProps = manager.getItemProps(key);
            router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
        }
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $195fc3c02bfc1bb3$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$195fc3c02bfc1bb3$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $195fc3c02bfc1bb3$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $195fc3c02bfc1bb3$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $24b4ecb6ecd312c7$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $4a4107ecda93bad9$export$95185d699e05d4d7).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $195fc3c02bfc1bb3$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $195fc3c02bfc1bb3$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a2123e6df02e75f5$export$497855f14858aa34(props, state, ref) {
    var _item_props, _item_props1;
    let { key: key } = props;
    let data = (0, $25babb4758798128$export$3585ede4d035bf14).get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.selectionManager.isDisabled(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)();
    let optionProps = {
        role: "option",
        "aria-disabled": isDisabled || undefined,
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, $b82880ba168cba95$export$9ac100e40613ea10)() && (0, $b82880ba168cba95$export$78551043582a6a98)())) {
        optionProps["aria-label"] = props["aria-label"];
        optionProps["aria-labelledby"] = labelId;
        optionProps["aria-describedby"] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps["aria-posinset"] = Number.isNaN(index) ? undefined : index + 1;
        optionProps["aria-setsize"] = (0, $b6e1ce9cd2ff6ef3$export$77d5aafae4e095b2)(state.collection);
    }
    let onAction = (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
        var _data_onAction;
        return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
    } : undefined;
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $195fc3c02bfc1bb3$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: onAction || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.onAction) ? (0, $276a22df76563a4a$export$e08e3b67e392101e)(item === null || item === void 0 ? void 0 : (_item_props1 = item.props) === null || _item_props1 === void 0 ? void 0 : _item_props1.onAction, onAction) : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior
    });
    let { hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $b995f28c9a72ee4c$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(item === null || item === void 0 ? void 0 : item.props);
    delete domProps.id;
    let linkProps = (0, $4a4107ecda93bad9$export$7e924b3091a3bd18)(item === null || item === void 0 ? void 0 : item.props);
    return {
        optionProps: {
            ...optionProps,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, itemProps, hoverProps, linkProps),
            id: (0, $25babb4758798128$export$9145995848b05025)(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && (0, $b995f28c9a72ee4c$export$b9b3dfddab17db27)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}




// src/index.ts

var $8dd9b21f23a75108$var$MOBILE_SCREEN_WIDTH = 700;
function $8dd9b21f23a75108$export$2b96349243a56116() {
    let isSSR = (0, $8afd3bdc2bd65163$export$535bd6ca7f90a273)();
    if (isSSR || typeof window === "undefined") return false;
    return window.screen.width <= $8dd9b21f23a75108$var$MOBILE_SCREEN_WIDTH;
}


"use client";
function $bb76a5532b410953$export$887eda06ad18acaf(originalProps) {
    var _a, _b;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $c8ce6ffc45f51469$export$c176f998e71d0f08).variantKeys);
    const { as: as, item: item, state: state, description: description, startContent: startContent, endContent: endContent, isVirtualized: isVirtualized, selectedIcon: selectedIcon, className: className, classNames: classNames, autoFocus: autoFocus, onPress: onPress, onClick: onClick, shouldHighlightOnFocus: shouldHighlightOnFocus, hideSelectedIcon: hideSelectedIcon = false, isReadOnly: isReadOnly = false, ...otherProps } = props;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const domRef = (0, $acw62.useRef)(null);
    const Component = as || (originalProps.href ? "a" : "li");
    const shouldFilterDOMProps = typeof Component === "string";
    const { rendered: rendered, key: key } = item;
    const isDisabled = state.disabledKeys.has(key) || originalProps.isDisabled;
    const isSelectable = state.selectionManager.selectionMode !== "none";
    const isMobile = (0, $8dd9b21f23a75108$export$2b96349243a56116)();
    const { pressProps: pressProps, isPressed: isPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        ref: domRef,
        isDisabled: isDisabled,
        onPress: onPress
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled
    });
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const { isFocused: isFocused, isSelected: isSelected, optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps } = (0, $a2123e6df02e75f5$export$497855f14858aa34)({
        key: key,
        isDisabled: isDisabled,
        "aria-label": props["aria-label"],
        isVirtualized: isVirtualized
    }, state, domRef);
    let itemProps = optionProps;
    const slots = (0, $acw62.useMemo)(()=>(0, $c8ce6ffc45f51469$export$c176f998e71d0f08)({
            ...variantProps,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isDisabled,
        disableAnimation
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    if (isReadOnly) itemProps = (0, $91ffd9bd684fd1b9$export$da5f6eb3bb522cd)(itemProps);
    const isHighlighted = (0, $acw62.useMemo)(()=>{
        if (shouldHighlightOnFocus && isFocused) return true;
        return isMobile ? isHovered || isPressed : isHovered;
    }, [
        isHovered,
        isPressed,
        isFocused,
        isMobile,
        shouldHighlightOnFocus
    ]);
    const getItemProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
                onClick: onClick
            }, itemProps, isReadOnly ? {} : (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusProps, pressProps), hoverProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2),
            "data-selectable": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelectable),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHighlighted),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2.className)
            })
        });
    const getLabelProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(labelProps, props2),
            "data-label": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            className: slots.title({
                class: classNames == null ? void 0 : classNames.title
            })
        });
    const getDescriptionProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(descriptionProps, props2),
            className: slots.description({
                class: classNames == null ? void 0 : classNames.description
            })
        });
    const getWrapperProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(props2),
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            })
        });
    const getSelectedIconProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            className: slots.selectedIcon({
                class: classNames == null ? void 0 : classNames.selectedIcon
            }),
            ...props2
        };
    }, [
        isDisabled,
        slots,
        classNames
    ]);
    return {
        Component: Component,
        domRef: domRef,
        slots: slots,
        classNames: classNames,
        isSelectable: isSelectable,
        isSelected: isSelected,
        isDisabled: isDisabled,
        rendered: rendered,
        description: description,
        startContent: startContent,
        endContent: endContent,
        selectedIcon: selectedIcon,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getWrapperProps: getWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getSelectedIconProps: getSelectedIconProps
    };
}



var $acw62 = parcelRequire("acw62");


"use client";
var $5246560aab45a5f0$var$ListboxItem = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, _)=>{
    const { Component: Component, rendered: rendered, description: description, isSelectable: isSelectable, isSelected: isSelected, isDisabled: isDisabled, selectedIcon: selectedIcon, startContent: startContent, endContent: endContent, hideSelectedIcon: hideSelectedIcon, disableAnimation: disableAnimation, getItemProps: getItemProps, getLabelProps: getLabelProps, getWrapperProps: getWrapperProps, getDescriptionProps: getDescriptionProps, getSelectedIconProps: getSelectedIconProps } = (0, $bb76a5532b410953$export$887eda06ad18acaf)(props);
    const selectedContent = (0, $acw62.useMemo)(()=>{
        const defaultIcon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a701348cd238119$export$5db3965fb0ec818), {
            disableAnimation: disableAnimation,
            isSelected: isSelected
        });
        if (typeof selectedIcon === "function") return selectedIcon({
            icon: defaultIcon,
            isSelected: isSelected,
            isDisabled: isDisabled
        });
        if (selectedIcon) return selectedIcon;
        return defaultIcon;
    }, [
        selectedIcon,
        isSelected,
        isDisabled,
        disableAnimation
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getItemProps(),
        children: [
            startContent,
            description ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...getWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getLabelProps(),
                        children: rendered
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getDescriptionProps(),
                        children: description
                    })
                ]
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getLabelProps(),
                children: rendered
            }),
            isSelectable && !hideSelectedIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getSelectedIconProps(),
                children: selectedContent
            }),
            endContent
        ]
    });
});
$5246560aab45a5f0$var$ListboxItem.displayName = "NextUI.ListboxItem";
var $5246560aab45a5f0$export$5f4bb52909be7a78 = $5246560aab45a5f0$var$ListboxItem;




var $acw62 = parcelRequire("acw62");



// src/use-separator.ts

function $d3512380a293c2be$export$52210f68a14655d0(props) {
    let domProps = (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(props, {
        enabled: typeof props.elementType === "string"
    });
    let ariaOrientation;
    if (props.orientation === "vertical") ariaOrientation = "vertical";
    if (props.elementType !== "hr") return {
        separatorProps: {
            ...domProps,
            role: "separator",
            "aria-orientation": ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}



// src/components/divider.ts
var $e6e3ca0cf36a9db6$export$e8c9778bf415dd08 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: "shrink-0 bg-divider border-none",
    variants: {
        orientation: {
            horizontal: "w-full h-divider",
            vertical: "h-full w-divider"
        }
    },
    defaultVariants: {
        orientation: "horizontal"
    }
});



var $acw62 = parcelRequire("acw62");
function $74a6625bf2428327$export$9352472c0af59bd6(props) {
    const { as: as, className: className, orientation: orientation, ...otherProps } = props;
    let Component = as || "hr";
    if (Component === "hr" && orientation === "vertical") Component = "div";
    const { separatorProps: separatorProps } = (0, $d3512380a293c2be$export$52210f68a14655d0)({
        elementType: typeof Component === "string" ? Component : "hr",
        orientation: orientation
    });
    const styles = (0, $acw62.useMemo)(()=>(0, $e6e3ca0cf36a9db6$export$e8c9778bf415dd08)({
            orientation: orientation,
            className: className
        }), [
        orientation,
        className
    ]);
    const getDividerProps = (0, $acw62.useCallback)((props2 = {})=>({
            className: styles,
            role: "separator",
            "data-orientation": orientation,
            ...separatorProps,
            ...otherProps,
            ...props2
        }), [
        styles,
        orientation,
        separatorProps,
        otherProps
    ]);
    return {
        Component: Component,
        getDividerProps: getDividerProps
    };
}




var $563106d728412f79$var$Divider = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, getDividerProps: getDividerProps } = (0, $74a6625bf2428327$export$9352472c0af59bd6)({
        ...props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...getDividerProps()
    });
});
$563106d728412f79$var$Divider.displayName = "NextUI.Divider";
var $563106d728412f79$export$2233c5fdcde64809 = $563106d728412f79$var$Divider;



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7fbe0d968c9558e0$export$c3f9f39876e4bc7(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}



"use client";
var $c49b5a8242175c9c$var$ListboxSection = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)(({ item: item, state: state, as: as, variant: variant, color: color, disableAnimation: disableAnimation, className: className, classNames: classNames, hideSelectedIcon: hideSelectedIcon, showDivider: showDivider = false, dividerProps: dividerProps = {}, itemClasses: itemClasses, title: title, ...otherProps }, _)=>{
    const Component = as || "li";
    const slots = (0, $acw62.useMemo)(()=>(0, $c8ce6ffc45f51469$export$95e0837a3419f5c1)(), []);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const dividerStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.divider, dividerProps == null ? void 0 : dividerProps.className);
    const { itemProps: itemProps, headingProps: headingProps, groupProps: groupProps } = (0, $7fbe0d968c9558e0$export$c3f9f39876e4bc7)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        "data-slot": "base",
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(itemProps, otherProps),
        className: slots.base({
            class: baseStyles
        }),
        children: [
            item.rendered && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...headingProps,
                className: slots.heading({
                    class: classNames == null ? void 0 : classNames.heading
                }),
                "data-slot": "heading",
                children: item.rendered
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                ...groupProps,
                className: slots.group({
                    class: classNames == null ? void 0 : classNames.group
                }),
                "data-has-title": !!item.rendered,
                "data-slot": "group",
                children: [
                    [
                        ...item.childNodes
                    ].map((node)=>{
                        const { key: nodeKey, props: nodeProps } = node;
                        let listboxItem = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5246560aab45a5f0$export$5f4bb52909be7a78), {
                            classNames: itemClasses,
                            color: color,
                            disableAnimation: disableAnimation,
                            hideSelectedIcon: hideSelectedIcon,
                            item: node,
                            state: state,
                            variant: variant,
                            ...nodeProps
                        }, nodeKey);
                        if (node.wrapper) listboxItem = node.wrapper(listboxItem);
                        return listboxItem;
                    }),
                    showDivider && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {
                        as: "li",
                        className: slots.divider({
                            class: dividerStyles
                        }),
                        ...dividerProps
                    })
                ]
            })
        ]
    }, item.key);
});
$c49b5a8242175c9c$var$ListboxSection.displayName = "NextUI.ListboxSection";
var $c49b5a8242175c9c$export$f8b3202ede999f4c = $c49b5a8242175c9c$var$ListboxSection;











var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9948dc1e277f262f$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $42a2eb2bd28e75db$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $376f10d3e3d8d3ed$export$a05409b8bb224a5a)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator
        }), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = (0, $0033009e76f45f0a$export$d6daf82dcd84e87c)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e5e694eca0f09d6$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || "toggle";
    let linkBehavior = props.linkBehavior || (selectionBehavior === "replace" ? "action" : "override");
    if (selectionBehavior === "toggle" && linkBehavior === "action") // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = "override";
    let { listProps: listProps } = (0, $9948dc1e277f262f$export$b95089534ab7c1fd)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $27a2d14f8c063b81$export$420e68273165f4ec)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $fc8082d5d9c62cca$export$f680877a34711e37)(props.id);
    (0, $25babb4758798128$export$3585ede4d035bf14).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $9e880abab5c15a87$export$8467354a121f1b9f)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(fieldProps, listProps)
        })
    };
}







var $acw62 = parcelRequire("acw62");

"use client";
function $dac8df595ae8dbd4$export$33446f1f63e37cb2(props) {
    var _a;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const { ref: ref, as: as, state: propState, variant: variant, color: color, onAction: onAction, children: children, onSelectionChange: onSelectionChange, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, itemClasses: itemClasses, className: className, topContent: topContent, bottomContent: bottomContent, emptyContent: emptyContent = "No items.", hideSelectedIcon: hideSelectedIcon = false, hideEmptyContent: hideEmptyContent = false, shouldHighlightOnFocus: shouldHighlightOnFocus = false, classNames: classNames, ...otherProps } = props;
    const Component = as || "ul";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const innerState = (0, $3eb881aaecc1e120$export$2f645645f7bca764)({
        ...props,
        children: children,
        onSelectionChange: onSelectionChange
    });
    const state = propState || innerState;
    const { listBoxProps: listBoxProps } = (0, $1e5e694eca0f09d6$export$50eacbbf140a3141)({
        ...props,
        onAction: onAction
    }, state, domRef);
    const slots = (0, $acw62.useMemo)(()=>(0, $c8ce6ffc45f51469$export$b1e5508a851be14d)({
            className: className
        }), [
        className
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "base",
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }),
            ...props2
        };
    };
    const getListProps = (props2 = {})=>{
        return {
            "data-slot": "list",
            className: slots.list({
                class: classNames == null ? void 0 : classNames.list
            }),
            ...listBoxProps,
            ...props2
        };
    };
    const getEmptyContentProps = (props2 = {})=>{
        return {
            "data-slot": "empty-content",
            children: emptyContent,
            className: slots.emptyContent({
                class: classNames == null ? void 0 : classNames.emptyContent
            }),
            ...props2
        };
    };
    return {
        Component: Component,
        state: state,
        variant: variant,
        color: color,
        slots: slots,
        classNames: classNames,
        topContent: topContent,
        bottomContent: bottomContent,
        emptyContent: emptyContent,
        hideEmptyContent: hideEmptyContent,
        shouldHighlightOnFocus: shouldHighlightOnFocus,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        className: className,
        itemClasses: itemClasses,
        getBaseProps: getBaseProps,
        getListProps: getListProps,
        getEmptyContentProps: getEmptyContentProps
    };
}





"use client";
function $29de8649494b89cd$var$Listbox(props, ref) {
    const { Component: Component, state: state, color: color, variant: variant, itemClasses: itemClasses, getBaseProps: getBaseProps, topContent: topContent, bottomContent: bottomContent, hideEmptyContent: hideEmptyContent, hideSelectedIcon: hideSelectedIcon, shouldHighlightOnFocus: shouldHighlightOnFocus, disableAnimation: disableAnimation, getEmptyContentProps: getEmptyContentProps, getListProps: getListProps } = (0, $dac8df595ae8dbd4$export$33446f1f63e37cb2)({
        ...props,
        ref: ref
    });
    const content = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getListProps(),
        children: [
            !state.collection.size && !hideEmptyContent && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("li", {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...getEmptyContentProps()
                })
            }),
            [
                ...state.collection
            ].map((item)=>{
                var _a;
                const itemProps = {
                    color: color,
                    item: item,
                    state: state,
                    variant: variant,
                    disableAnimation: disableAnimation,
                    hideSelectedIcon: hideSelectedIcon,
                    ...item.props
                };
                if (item.type === "section") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c49b5a8242175c9c$export$f8b3202ede999f4c), {
                    ...itemProps,
                    itemClasses: itemClasses
                }, item.key);
                let listboxItem = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5246560aab45a5f0$export$5f4bb52909be7a78), {
                    ...itemProps,
                    classNames: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(itemClasses, (_a = item.props) == null ? void 0 : _a.classNames),
                    shouldHighlightOnFocus: shouldHighlightOnFocus
                }, item.key);
                if (item.wrapper) listboxItem = item.wrapper(listboxItem);
                return listboxItem;
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getBaseProps(),
        children: [
            topContent,
            content,
            bottomContent
        ]
    });
}
$29de8649494b89cd$var$Listbox.displayName = "NextUI.Listbox";
var $29de8649494b89cd$export$3f842a5957aa0e7a = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)($29de8649494b89cd$var$Listbox);



"use client";
var [$573c87516a32421d$export$85041a2bb9328e33, $573c87516a32421d$export$85d63e852e3be3b3] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "ButtonGroupContext",
    strict: false
});





var $acw62 = parcelRequire("acw62");






// src/components/button.ts
var $bd6b03be75cc051b$export$2ba01fb71ed41cb6 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: [
        "z-0",
        "group",
        "relative",
        "inline-flex",
        "items-center",
        "justify-center",
        "box-border",
        "appearance-none",
        "outline-none",
        "select-none",
        "whitespace-nowrap",
        "min-w-max",
        "font-normal",
        "subpixel-antialiased",
        "overflow-hidden",
        "tap-highlight-transparent",
        "data-[pressed=true]:scale-[0.97]",
        ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
    ],
    variants: {
        variant: {
            solid: "",
            bordered: "border-medium bg-transparent",
            light: "bg-transparent",
            flat: "",
            faded: "border-medium",
            shadow: "",
            ghost: "border-medium bg-transparent"
        },
        size: {
            sm: "px-3 min-w-16 h-8 text-tiny gap-2 rounded-small",
            md: "px-4 min-w-20 h-10 text-small gap-2 rounded-medium",
            lg: "px-6 min-w-24 h-12 text-medium gap-3 rounded-large"
        },
        color: {
            default: "",
            primary: "",
            secondary: "",
            success: "",
            warning: "",
            danger: ""
        },
        radius: {
            none: "rounded-none",
            sm: "rounded-small",
            md: "rounded-medium",
            lg: "rounded-large",
            full: "rounded-full"
        },
        fullWidth: {
            true: "w-full"
        },
        isDisabled: {
            true: "opacity-disabled pointer-events-none"
        },
        isInGroup: {
            true: "[&:not(:first-child):not(:last-child)]:rounded-none"
        },
        isIconOnly: {
            true: "px-0 !gap-0",
            false: "[&>svg]:max-w-[theme(spacing.8)]"
        },
        disableAnimation: {
            true: "!transition-none data-[pressed=true]:scale-100",
            false: "transition-transform-colors-opacity motion-reduce:transition-none"
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid",
        color: "default",
        fullWidth: false,
        isDisabled: false,
        isInGroup: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.default
        },
        {
            variant: "solid",
            color: "primary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.primary
        },
        {
            variant: "solid",
            color: "secondary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.secondary
        },
        {
            variant: "solid",
            color: "success",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.success
        },
        {
            variant: "solid",
            color: "warning",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.warning
        },
        {
            variant: "solid",
            color: "danger",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.danger
        },
        {
            variant: "shadow",
            color: "default",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.default
        },
        {
            variant: "shadow",
            color: "primary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.primary
        },
        {
            variant: "shadow",
            color: "secondary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.secondary
        },
        {
            variant: "shadow",
            color: "success",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.success
        },
        {
            variant: "shadow",
            color: "warning",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.warning
        },
        {
            variant: "shadow",
            color: "danger",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.danger
        },
        {
            variant: "bordered",
            color: "default",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.default
        },
        {
            variant: "bordered",
            color: "primary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.primary
        },
        {
            variant: "bordered",
            color: "secondary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.secondary
        },
        {
            variant: "bordered",
            color: "success",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.success
        },
        {
            variant: "bordered",
            color: "warning",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.warning
        },
        {
            variant: "bordered",
            color: "danger",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.danger
        },
        {
            variant: "flat",
            color: "default",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.default
        },
        {
            variant: "flat",
            color: "primary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.primary
        },
        {
            variant: "flat",
            color: "secondary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.secondary
        },
        {
            variant: "flat",
            color: "success",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.success
        },
        {
            variant: "flat",
            color: "warning",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.warning
        },
        {
            variant: "flat",
            color: "danger",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.danger
        },
        {
            variant: "faded",
            color: "default",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.default
        },
        {
            variant: "faded",
            color: "primary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.primary
        },
        {
            variant: "faded",
            color: "secondary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.secondary
        },
        {
            variant: "faded",
            color: "success",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.success
        },
        {
            variant: "faded",
            color: "warning",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.warning
        },
        {
            variant: "faded",
            color: "danger",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.danger
        },
        {
            variant: "light",
            color: "default",
            class: [
                (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.default,
                "data-[hover=true]:bg-default/40"
            ]
        },
        {
            variant: "light",
            color: "primary",
            class: [
                (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.primary,
                "data-[hover=true]:bg-primary/20"
            ]
        },
        {
            variant: "light",
            color: "secondary",
            class: [
                (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.secondary,
                "data-[hover=true]:bg-secondary/20"
            ]
        },
        {
            variant: "light",
            color: "success",
            class: [
                (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.success,
                "data-[hover=true]:bg-success/20"
            ]
        },
        {
            variant: "light",
            color: "warning",
            class: [
                (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.warning,
                "data-[hover=true]:bg-warning/20"
            ]
        },
        {
            variant: "light",
            color: "danger",
            class: [
                (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.danger,
                "data-[hover=true]:bg-danger/20"
            ]
        },
        {
            variant: "ghost",
            color: "default",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).ghost.default
        },
        {
            variant: "ghost",
            color: "primary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).ghost.primary
        },
        {
            variant: "ghost",
            color: "secondary",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).ghost.secondary
        },
        {
            variant: "ghost",
            color: "success",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).ghost.success
        },
        {
            variant: "ghost",
            color: "warning",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).ghost.warning
        },
        {
            variant: "ghost",
            color: "danger",
            class: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).ghost.danger
        },
        {
            isInGroup: true,
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            size: "sm",
            class: "rounded-none first:rounded-s-small last:rounded-e-small"
        },
        {
            isInGroup: true,
            size: "md",
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            size: "lg",
            class: "rounded-none first:rounded-s-large last:rounded-e-large"
        },
        {
            isInGroup: true,
            isRounded: true,
            class: "rounded-none first:rounded-s-full last:rounded-e-full"
        },
        {
            isInGroup: true,
            radius: "none",
            class: "rounded-none first:rounded-s-none last:rounded-e-none"
        },
        {
            isInGroup: true,
            radius: "sm",
            class: "rounded-none first:rounded-s-small last:rounded-e-small"
        },
        {
            isInGroup: true,
            radius: "md",
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            radius: "lg",
            class: "rounded-none first:rounded-s-large last:rounded-e-large"
        },
        {
            isInGroup: true,
            radius: "full",
            class: "rounded-none first:rounded-s-full last:rounded-e-full"
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "default",
            className: (0, $eb279a3a1c5a3410$export$be7ffb88629cefac).default
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "primary",
            className: (0, $eb279a3a1c5a3410$export$be7ffb88629cefac).primary
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "secondary",
            className: (0, $eb279a3a1c5a3410$export$be7ffb88629cefac).secondary
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "success",
            className: (0, $eb279a3a1c5a3410$export$be7ffb88629cefac).success
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "warning",
            className: (0, $eb279a3a1c5a3410$export$be7ffb88629cefac).warning
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "danger",
            className: (0, $eb279a3a1c5a3410$export$be7ffb88629cefac).danger
        },
        {
            isIconOnly: true,
            size: "sm",
            class: "min-w-8 w-8 h-8"
        },
        {
            isIconOnly: true,
            size: "md",
            class: "min-w-10 w-10 h-10"
        },
        {
            isIconOnly: true,
            size: "lg",
            class: "min-w-12 w-12 h-12"
        },
        {
            variant: [
                "solid",
                "faded",
                "flat",
                "bordered",
                "shadow"
            ],
            class: "data-[hover=true]:opacity-hover"
        }
    ]
});
var $bd6b03be75cc051b$export$9c686a975407e95c = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: "inline-flex items-center justify-center h-auto",
    variants: {
        fullWidth: {
            true: "w-full"
        }
    },
    defaultVariants: {
        fullWidth: false
    }
});


// src/index.ts



function $99a1faa63f87ca63$export$1aff6edc04132adb(props, ref) {
    let { elementType: elementType = "button", isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = "button", allowTextSelectionOnPress: allowTextSelectionOnPress } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? void 0 : 0,
        href: elementType === "a" && isDisabled ? void 0 : href,
        target: elementType === "a" ? target : void 0,
        type: elementType === "input" ? type : void 0,
        disabled: elementType === "input" ? isDisabled : void 0,
        "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
        rel: elementType === "a" ? rel : void 0
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        allowTextSelectionOnPress: allowTextSelectionOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $4513518cfd051728$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusableProps, pressProps, (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                deprecatedOnClick == null || deprecatedOnClick(e);
            }
        })
    };
}





var $acw62 = parcelRequire("acw62");
"use client";
function $b3fe8d327210ab43$export$66d23405c38d2c80(props = {}) {
    const [ripples, setRipples] = (0, $acw62.useState)([]);
    const onClick = (0, $acw62.useCallback)((event)=>{
        const trigger = event.currentTarget;
        const size = Math.max(trigger.clientWidth, trigger.clientHeight);
        const rect = trigger.getBoundingClientRect();
        setRipples((prevRipples)=>[
                ...prevRipples,
                {
                    key: (0, $91ffd9bd684fd1b9$export$b8ba5815f1bdad68)(prevRipples.length.toString()),
                    size: size,
                    x: event.clientX - rect.left - size / 2,
                    y: event.clientY - rect.top - size / 2
                }
            ]);
    }, []);
    const onClear = (0, $acw62.useCallback)((key)=>{
        setRipples((prevState)=>prevState.filter((ripple)=>ripple.key !== key));
    }, []);
    return {
        ripples: ripples,
        onClick: onClick,
        onClear: onClear,
        ...props
    };
}


"use client";
function $778de60838e6404d$export$ea18c227d4417cc3(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const groupContext = (0, $573c87516a32421d$export$85d63e852e3be3b3)();
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const isInGroup = !!groupContext;
    const { ref: ref, as: as, children: children, startContent: startContentProp, endContent: endContentProp, autoFocus: autoFocus, className: className, spinner: spinner, isLoading: isLoading = false, disableRipple: disableRippleProp = false, fullWidth: fullWidth = (_a = groupContext == null ? void 0 : groupContext.fullWidth) != null ? _a : false, radius: radius = groupContext == null ? void 0 : groupContext.radius, size: size = (_b = groupContext == null ? void 0 : groupContext.size) != null ? _b : "md", color: color = (_c = groupContext == null ? void 0 : groupContext.color) != null ? _c : "default", variant: variant = (_d = groupContext == null ? void 0 : groupContext.variant) != null ? _d : "solid", disableAnimation: disableAnimation = (_f = (_e = groupContext == null ? void 0 : groupContext.disableAnimation) != null ? _e : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _f : false, isDisabled: isDisabledProp = (_g = groupContext == null ? void 0 : groupContext.isDisabled) != null ? _g : false, isIconOnly: isIconOnly = (_h = groupContext == null ? void 0 : groupContext.isIconOnly) != null ? _h : false, spinnerPlacement: spinnerPlacement = "start", onPress: onPress, onClick: onClick, ...otherProps } = props;
    const Component = as || "button";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const disableRipple = (_i = disableRippleProp || (globalContext == null ? void 0 : globalContext.disableRipple)) != null ? _i : disableAnimation;
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const isDisabled = isDisabledProp || isLoading;
    const styles = (0, $acw62.useMemo)(()=>(0, $bd6b03be75cc051b$export$2ba01fb71ed41cb6)({
            size: size,
            color: color,
            variant: variant,
            radius: radius,
            fullWidth: fullWidth,
            isDisabled: isDisabled,
            isInGroup: isInGroup,
            disableAnimation: disableAnimation,
            isIconOnly: isIconOnly,
            className: className
        }), [
        size,
        color,
        variant,
        radius,
        fullWidth,
        isDisabled,
        isInGroup,
        isIconOnly,
        disableAnimation,
        className
    ]);
    const { onClick: onRippleClickHandler, onClear: onClearRipple, ripples: ripples } = (0, $b3fe8d327210ab43$export$66d23405c38d2c80)();
    const handleClick = (0, $acw62.useCallback)((e)=>{
        if (disableRipple || isDisabled || disableAnimation) return;
        domRef.current && onRippleClickHandler(e);
    }, [
        disableRipple,
        isDisabled,
        disableAnimation,
        domRef,
        onRippleClickHandler
    ]);
    const { buttonProps: ariaButtonProps, isPressed: isPressed } = (0, $99a1faa63f87ca63$export$1aff6edc04132adb)({
        elementType: as,
        isDisabled: isDisabled,
        onPress: onPress,
        onClick: (0, $276a22df76563a4a$export$e08e3b67e392101e)(onClick, handleClick),
        ...otherProps
    }, domRef);
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled
    });
    const getButtonProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-loading": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isLoading),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(ariaButtonProps, focusProps, hoverProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(props2))
        }), [
        isLoading,
        isDisabled,
        isFocused,
        isPressed,
        shouldFilterDOMProps,
        isFocusVisible,
        isHovered,
        ariaButtonProps,
        focusProps,
        hoverProps,
        otherProps
    ]);
    const getIconClone = (icon)=>(0, $acw62.isValidElement)(icon) ? (0, $acw62.cloneElement)(icon, {
            "aria-hidden": true,
            focusable: false,
            tabIndex: -1
        }) : null;
    const startContent = getIconClone(startContentProp);
    const endContent = getIconClone(endContentProp);
    const spinnerSize = (0, $acw62.useMemo)(()=>{
        const buttonSpinnerSizeMap = {
            sm: "sm",
            md: "sm",
            lg: "md"
        };
        return buttonSpinnerSizeMap[size];
    }, [
        size
    ]);
    const getRippleProps = (0, $acw62.useCallback)(()=>({
            ripples: ripples,
            onClear: onClearRipple
        }), [
        ripples,
        onClearRipple
    ]);
    return {
        Component: Component,
        children: children,
        domRef: domRef,
        spinner: spinner,
        styles: styles,
        startContent: startContent,
        endContent: endContent,
        isLoading: isLoading,
        spinnerPlacement: spinnerPlacement,
        spinnerSize: spinnerSize,
        disableRipple: disableRipple,
        getButtonProps: getButtonProps,
        getRippleProps: getRippleProps,
        isIconOnly: isIconOnly
    };
}


// src/use-spinner.ts


// src/components/spinner.ts
var $5fdf8803e1b617eb$export$641374ffb95bc399 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "relative inline-flex flex-col gap-2 items-center justify-center",
        wrapper: "relative flex",
        circle1: [
            "absolute",
            "w-full",
            "h-full",
            "rounded-full",
            "animate-spinner-ease-spin",
            "border-2",
            "border-solid",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent"
        ],
        circle2: [
            "absolute",
            "w-full",
            "h-full",
            "rounded-full",
            "opacity-75",
            "animate-spinner-linear-spin",
            "border-2",
            "border-dotted",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent"
        ],
        label: "text-foreground dark:text-foreground-dark font-regular"
    },
    variants: {
        size: {
            sm: {
                wrapper: "w-5 h-5",
                circle1: "border-2",
                circle2: "border-2",
                label: "text-small"
            },
            md: {
                wrapper: "w-8 h-8",
                circle1: "border-3",
                circle2: "border-3",
                label: "text-medium"
            },
            lg: {
                wrapper: "w-10 h-10",
                circle1: "border-3",
                circle2: "border-3",
                label: "text-large"
            }
        },
        color: {
            current: {
                circle1: "border-b-current",
                circle2: "border-b-current"
            },
            white: {
                circle1: "border-b-white",
                circle2: "border-b-white"
            },
            default: {
                circle1: "border-b-default",
                circle2: "border-b-default"
            },
            primary: {
                circle1: "border-b-primary",
                circle2: "border-b-primary"
            },
            secondary: {
                circle1: "border-b-secondary",
                circle2: "border-b-secondary"
            },
            success: {
                circle1: "border-b-success",
                circle2: "border-b-success"
            },
            warning: {
                circle1: "border-b-warning",
                circle2: "border-b-warning"
            },
            danger: {
                circle1: "border-b-danger",
                circle2: "border-b-danger"
            }
        },
        labelColor: {
            foreground: {
                label: "text-foreground"
            },
            primary: {
                label: "text-primary"
            },
            secondary: {
                label: "text-secondary"
            },
            success: {
                label: "text-success"
            },
            warning: {
                label: "text-warning"
            },
            danger: {
                label: "text-danger"
            }
        }
    },
    defaultVariants: {
        size: "md",
        color: "primary",
        labelColor: "foreground"
    }
});




var $acw62 = parcelRequire("acw62");
function $cf543179811836df$export$21495182eeff761c(originalProps) {
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $5fdf8803e1b617eb$export$641374ffb95bc399).variantKeys);
    const { children: children, className: className, classNames: classNames, label: labelProp, ...otherProps } = props;
    const slots = (0, $acw62.useMemo)(()=>(0, $5fdf8803e1b617eb$export$641374ffb95bc399)({
            ...variantProps
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps)
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const label = labelProp || children;
    const ariaLabel = (0, $acw62.useMemo)(()=>{
        if (label && typeof label === "string") return label;
        return !otherProps["aria-label"] ? "Loading" : "";
    }, [
        children,
        label,
        otherProps["aria-label"]
    ]);
    const getSpinnerProps = (0, $acw62.useCallback)(()=>({
            "aria-label": ariaLabel,
            className: slots.base({
                class: baseStyles
            }),
            ...otherProps
        }), [
        ariaLabel,
        slots,
        baseStyles,
        otherProps
    ]);
    return {
        label: label,
        slots: slots,
        classNames: classNames,
        getSpinnerProps: getSpinnerProps
    };
}




var $ff0009cdb8e38ea8$var$Spinner = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { slots: slots, classNames: classNames, label: label, getSpinnerProps: getSpinnerProps } = (0, $cf543179811836df$export$21495182eeff761c)({
        ...props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...getSpinnerProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: slots.wrapper({
                    class: classNames == null ? void 0 : classNames.wrapper
                }),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: slots.circle1({
                            class: classNames == null ? void 0 : classNames.circle1
                        })
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: slots.circle2({
                            class: classNames == null ? void 0 : classNames.circle2
                        })
                    })
                ]
            }),
            label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: slots.label({
                    class: classNames == null ? void 0 : classNames.label
                }),
                children: label
            })
        ]
    });
});
$ff0009cdb8e38ea8$var$Spinner.displayName = "NextUI.Spinner";
var $ff0009cdb8e38ea8$export$b67103861f057d1a = $ff0009cdb8e38ea8$var$Spinner;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $acw62.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $7b02d682eb115277$exports.jsx)((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}






var $acw62 = parcelRequire("acw62");
const $2a41914a8628d3e4$export$10e61aed958678dd = (child)=>child.key || "";
function $2a41914a8628d3e4$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $acw62.useMemo)(()=>(0, $2a41914a8628d3e4$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $2a41914a8628d3e4$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $acw62.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $acw62.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $acw62.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $acw62.useState)(presentChildren);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $2a41914a8628d3e4$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $2a41914a8628d3e4$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $2a41914a8628d3e4$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $2a41914a8628d3e4$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $7b02d682eb115277$exports.jsx)((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};


// src/numbers.ts
function $2a08fbe98e849065$export$d02631cccf789723(start, end) {
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, index)=>index + start);
}
function $2a08fbe98e849065$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $2a08fbe98e849065$export$b7cb35a8bec19265(value, max = 100) {
    return Math.min(Math.max(value, 0), max);
}



"use client";
var $07aa04cf326100a7$var$Ripple = (props)=>{
    const { ripples: ripples = [], motionProps: motionProps, color: color = "currentColor", style: style, onClear: onClear } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: ripples.map((ripple)=>{
            const duration = (0, $2a08fbe98e849065$export$7d15b64cf5a3a4c4)(0.01 * ripple.size, 0.2, ripple.size > 100 ? 0.75 : 0.5);
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
                features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                    mode: "popLayout",
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).span, {
                        animate: {
                            transform: "scale(2)",
                            opacity: 0
                        },
                        className: "nextui-ripple",
                        exit: {
                            opacity: 0
                        },
                        initial: {
                            transform: "scale(0)",
                            opacity: 0.35
                        },
                        style: {
                            position: "absolute",
                            backgroundColor: color,
                            borderRadius: "100%",
                            transformOrigin: "center",
                            pointerEvents: "none",
                            overflow: "hidden",
                            inset: 0,
                            zIndex: 0,
                            top: ripple.y,
                            left: ripple.x,
                            width: `${ripple.size}px`,
                            height: `${ripple.size}px`,
                            ...style
                        },
                        transition: {
                            duration: duration
                        },
                        onAnimationComplete: ()=>{
                            onClear(ripple.key);
                        },
                        ...motionProps
                    })
                })
            }, ripple.key);
        })
    });
};
$07aa04cf326100a7$var$Ripple.displayName = "NextUI.Ripple";
var $07aa04cf326100a7$export$db886ec4bd2671e8 = $07aa04cf326100a7$var$Ripple;




"use client";
var $315c520e7ca388e0$var$Button = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, domRef: domRef, children: children, styles: styles, spinnerSize: spinnerSize, spinner: spinner = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ff0009cdb8e38ea8$export$b67103861f057d1a), {
        color: "current",
        size: spinnerSize
    }), spinnerPlacement: spinnerPlacement, startContent: startContent, endContent: endContent, isLoading: isLoading, disableRipple: disableRipple, getButtonProps: getButtonProps, getRippleProps: getRippleProps, isIconOnly: isIconOnly } = (0, $778de60838e6404d$export$ea18c227d4417cc3)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ref: domRef,
        className: styles,
        ...getButtonProps(),
        children: [
            startContent,
            isLoading && spinnerPlacement === "start" && spinner,
            isLoading && isIconOnly ? null : children,
            isLoading && spinnerPlacement === "end" && spinner,
            endContent,
            !disableRipple && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07aa04cf326100a7$export$db886ec4bd2671e8), {
                ...getRippleProps()
            })
        ]
    });
});
$315c520e7ca388e0$var$Button.displayName = "NextUI.Button";
var $315c520e7ca388e0$export$11c362adf4e83e40 = $315c520e7ca388e0$var$Button;







// src/components/input.ts
var $26efb188ef3bd6b6$export$b7e3ae3d7c15e42e = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "group flex flex-col data-[hidden=true]:hidden",
        label: [
            "absolute",
            "z-10",
            "pointer-events-none",
            "origin-top-left",
            "rtl:origin-top-right",
            "subpixel-antialiased",
            "block",
            "text-small",
            "text-foreground-500"
        ],
        mainWrapper: "h-full",
        inputWrapper: "relative w-full inline-flex tap-highlight-transparent flex-row items-center shadow-sm px-3 gap-3",
        innerWrapper: "inline-flex w-full items-center h-full box-border",
        input: [
            "w-full font-normal bg-transparent !outline-none placeholder:text-foreground-500 focus-visible:outline-none",
            "data-[has-start-content=true]:ps-1.5",
            "data-[has-end-content=true]:pe-1.5",
            "file:cursor-pointer file:bg-transparent file:border-0",
            "autofill:bg-transparent bg-clip-text"
        ],
        clearButton: [
            "p-2",
            "-m-2",
            "z-10",
            "hidden",
            "absolute",
            "right-3",
            "rtl:right-auto",
            "rtl:left-3",
            "appearance-none",
            "outline-none",
            "select-none",
            "opacity-0",
            "hover:!opacity-100",
            "cursor-pointer",
            "active:!opacity-70",
            "rounded-full",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        helperWrapper: "hidden group-data-[has-helper=true]:flex p-1 relative flex-col gap-1.5",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        variant: {
            flat: {
                inputWrapper: [
                    "bg-default-100",
                    "data-[hover=true]:bg-default-200",
                    "group-data-[focus=true]:bg-default-100"
                ]
            },
            faded: {
                inputWrapper: [
                    "bg-default-100",
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400"
                ],
                value: "group-data-[has-value=true]:text-default-foreground"
            },
            bordered: {
                inputWrapper: [
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400",
                    "group-data-[focus=true]:border-default-foreground"
                ]
            },
            underlined: {
                inputWrapper: [
                    "!px-1",
                    "!pb-0",
                    "!gap-0",
                    "relative",
                    "box-border",
                    "border-b-medium",
                    "shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "border-default-200",
                    "!rounded-none",
                    "hover:border-default-300",
                    "after:content-['']",
                    "after:w-0",
                    "after:origin-center",
                    "after:bg-default-foreground",
                    "after:absolute",
                    "after:left-1/2",
                    "after:-translate-x-1/2",
                    "after:-bottom-[2px]",
                    "after:h-[2px]",
                    "group-data-[focus=true]:after:w-full"
                ],
                innerWrapper: "pb-1",
                label: "group-data-[filled-within=true]:text-foreground"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                label: "text-tiny",
                inputWrapper: "h-8 min-h-8 px-2 rounded-small",
                input: "text-small",
                clearButton: "text-medium"
            },
            md: {
                inputWrapper: "h-10 min-h-10 rounded-medium",
                input: "text-small",
                clearButton: "text-large"
            },
            lg: {
                inputWrapper: "h-12 min-h-12 rounded-large",
                input: "text-medium",
                clearButton: "text-large"
            }
        },
        radius: {
            none: {
                inputWrapper: "rounded-none"
            },
            sm: {
                inputWrapper: "rounded-small"
            },
            md: {
                inputWrapper: "rounded-medium"
            },
            lg: {
                inputWrapper: "rounded-large"
            },
            full: {
                inputWrapper: "rounded-full"
            }
        },
        labelPlacement: {
            outside: {
                mainWrapper: "flex flex-col"
            },
            "outside-left": {
                base: "flex-row items-center flex-nowrap data-[has-helper=true]:items-start",
                inputWrapper: "flex-1",
                mainWrapper: "flex flex-col",
                label: "relative text-foreground pr-2 rtl:pr-0 rtl:pl-2"
            },
            inside: {
                label: "text-tiny cursor-text",
                inputWrapper: "flex-col items-start justify-center gap-0",
                innerWrapper: "group-data-[has-label=true]:items-end"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isClearable: {
            true: {
                input: "peer pr-6 rtl:pr-0 rtl:pl-6",
                clearButton: "peer-data-[filled=true]:opacity-70 peer-data-[filled=true]:block"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none",
                inputWrapper: "pointer-events-none",
                label: "pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                label: "!text-danger",
                input: "!placeholder:text-danger !text-danger"
            }
        },
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5 rtl:after:ml-[unset] rtl:after:mr-0.5"
            }
        },
        isMultiline: {
            true: {
                label: "relative",
                inputWrapper: "!h-auto",
                innerWrapper: "items-start group-data-[has-label=true]:items-start",
                input: "resize-none data-[hide-scroll=true]:scrollbar-hide"
            }
        },
        disableAnimation: {
            true: {
                input: "transition-none",
                inputWrapper: "transition-none",
                label: "transition-none"
            },
            false: {
                inputWrapper: "transition-background motion-reduce:transition-none !duration-150",
                label: [
                    "will-change-auto",
                    "!duration-200",
                    "!ease-out",
                    "motion-reduce:transition-none",
                    "transition-[transform,color,left,opacity]"
                ],
                clearButton: [
                    "transition-opacity",
                    "motion-reduce:transition-none"
                ]
            }
        }
    },
    defaultVariants: {
        variant: "flat",
        color: "default",
        size: "md",
        fullWidth: true,
        labelPlacement: "inside",
        isDisabled: false,
        isMultiline: false
    },
    compoundVariants: [
        {
            variant: "flat",
            color: "default",
            class: {
                input: "group-data-[has-value=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                inputWrapper: [
                    "bg-primary-50",
                    "data-[hover=true]:bg-primary-100",
                    "text-primary",
                    "group-data-[focus=true]:bg-primary-50",
                    "placeholder:text-primary"
                ],
                input: "placeholder:text-primary",
                label: "text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                inputWrapper: [
                    "bg-secondary-50",
                    "text-secondary",
                    "data-[hover=true]:bg-secondary-100",
                    "group-data-[focus=true]:bg-secondary-50",
                    "placeholder:text-secondary"
                ],
                input: "placeholder:text-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                inputWrapper: [
                    "bg-success-50",
                    "text-success-600",
                    "dark:text-success",
                    "placeholder:text-success-600",
                    "dark:placeholder:text-success",
                    "data-[hover=true]:bg-success-100",
                    "group-data-[focus=true]:bg-success-50"
                ],
                input: "placeholder:text-success-600 dark:placeholder:text-success",
                label: "text-success-600 dark:text-success"
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                inputWrapper: [
                    "bg-warning-50",
                    "text-warning-600",
                    "dark:text-warning",
                    "placeholder:text-warning-600",
                    "dark:placeholder:text-warning",
                    "data-[hover=true]:bg-warning-100",
                    "group-data-[focus=true]:bg-warning-50"
                ],
                input: "placeholder:text-warning-600 dark:placeholder:text-warning",
                label: "text-warning-600 dark:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                inputWrapper: [
                    "bg-danger-50",
                    "text-danger",
                    "dark:text-danger-500",
                    "placeholder:text-danger",
                    "dark:placeholder:text-danger-500",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ],
                input: "placeholder:text-danger dark:placeholder:text-danger-500",
                label: "text-danger dark:text-danger-500"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                label: "text-primary",
                inputWrapper: "data-[hover=true]:border-primary focus-within:border-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                label: "text-secondary",
                inputWrapper: "data-[hover=true]:border-secondary focus-within:border-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                label: "text-success",
                inputWrapper: "data-[hover=true]:border-success focus-within:border-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                label: "text-warning",
                inputWrapper: "data-[hover=true]:border-warning focus-within:border-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                label: "text-danger",
                inputWrapper: "data-[hover=true]:border-danger focus-within:border-danger"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                input: "group-data-[has-value=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                inputWrapper: "after:bg-primary",
                label: "text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                inputWrapper: "after:bg-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                inputWrapper: "after:bg-success",
                label: "text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                inputWrapper: "after:bg-warning",
                label: "text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                inputWrapper: "after:bg-danger",
                label: "text-danger"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                inputWrapper: "group-data-[focus=true]:border-primary",
                label: "text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                inputWrapper: "group-data-[focus=true]:border-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                inputWrapper: "group-data-[focus=true]:border-success",
                label: "text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                inputWrapper: "group-data-[focus=true]:border-warning",
                label: "text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                inputWrapper: "group-data-[focus=true]:border-danger",
                label: "text-danger"
            }
        },
        {
            labelPlacement: "inside",
            color: "default",
            class: {
                label: "group-data-[filled-within=true]:text-default-600"
            }
        },
        {
            labelPlacement: "outside",
            color: "default",
            class: {
                label: "group-data-[filled-within=true]:text-foreground"
            }
        },
        {
            radius: "full",
            size: [
                "sm"
            ],
            class: {
                inputWrapper: "px-3"
            }
        },
        {
            radius: "full",
            size: "md",
            class: {
                inputWrapper: "px-4"
            }
        },
        {
            radius: "full",
            size: "lg",
            class: {
                inputWrapper: "px-5"
            }
        },
        {
            disableAnimation: false,
            variant: [
                "faded",
                "bordered"
            ],
            class: {
                inputWrapper: "transition-colors motion-reduce:transition-none"
            }
        },
        {
            disableAnimation: false,
            variant: "underlined",
            class: {
                inputWrapper: "after:transition-width motion-reduce:after:transition-none"
            }
        },
        {
            variant: [
                "flat",
                "faded"
            ],
            class: {
                inputWrapper: [
                    ...(0, $eb279a3a1c5a3410$export$23b17e6367ab693)
                ]
            }
        },
        {
            isInvalid: true,
            variant: "flat",
            class: {
                inputWrapper: [
                    "!bg-danger-50",
                    "data-[hover=true]:!bg-danger-100",
                    "group-data-[focus=true]:!bg-danger-50"
                ]
            }
        },
        {
            isInvalid: true,
            variant: "bordered",
            class: {
                inputWrapper: "!border-danger group-data-[focus=true]:!border-danger"
            }
        },
        {
            isInvalid: true,
            variant: "underlined",
            class: {
                inputWrapper: "after:!bg-danger"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            class: {
                inputWrapper: "h-12 py-1.5 px-3"
            }
        },
        {
            labelPlacement: "inside",
            size: "md",
            class: {
                inputWrapper: "h-14 py-2"
            }
        },
        {
            labelPlacement: "inside",
            size: "lg",
            class: {
                label: "text-small",
                inputWrapper: "h-16 py-2.5 gap-0"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            variant: [
                "bordered",
                "faded"
            ],
            class: {
                inputWrapper: "py-1"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "group-data-[filled-within=true]:pointer-events-auto"
                ]
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            class: {
                base: "group relative justify-end",
                label: [
                    "pb-0",
                    "z-20",
                    "top-1/2",
                    "-translate-y-1/2",
                    "group-data-[filled-within=true]:left-0"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            class: {
                label: [
                    "group-data-[filled-within=true]:scale-85"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            variant: "flat",
            class: {
                innerWrapper: "pb-0.5"
            }
        },
        {
            variant: "underlined",
            size: "sm",
            class: {
                innerWrapper: "pb-1"
            }
        },
        {
            variant: "underlined",
            size: [
                "md",
                "lg"
            ],
            class: {
                innerWrapper: "pb-1.5"
            }
        },
        {
            labelPlacement: "inside",
            size: [
                "sm",
                "md"
            ],
            class: {
                label: "text-small"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_3.5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            size: "lg",
            isMultiline: false,
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_4px)]"
                ]
            }
        },
        {
            labelPlacement: "outside",
            size: "sm",
            isMultiline: false,
            class: {
                label: [
                    "left-2",
                    "text-tiny",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.tiny)/2_+_16px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_8px)]"
            }
        },
        {
            labelPlacement: "outside",
            size: "md",
            isMultiline: false,
            class: {
                label: [
                    "left-3",
                    "rtl:left-auto",
                    "rtl:right-3",
                    "text-small",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_20px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_10px)]"
            }
        },
        {
            labelPlacement: "outside",
            size: "lg",
            isMultiline: false,
            class: {
                label: [
                    "left-3",
                    "rtl:left-auto",
                    "rtl:right-3",
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_24px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_12px)]"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "sm",
            class: {
                label: "group-data-[has-helper=true]:pt-2"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "md",
            class: {
                label: "group-data-[has-helper=true]:pt-3"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "lg",
            class: {
                label: "group-data-[has-helper=true]:pt-4"
            }
        },
        {
            labelPlacement: [
                "outside",
                "outside-left"
            ],
            isMultiline: true,
            class: {
                inputWrapper: "py-2"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: true,
            class: {
                label: "pb-1.5"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: true,
            class: {
                label: "pb-0.5",
                input: "pt-0"
            }
        },
        {
            isMultiline: true,
            disableAnimation: false,
            class: {
                input: "transition-height !duration-100 motion-reduce:transition-none"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "pe-2",
                    "max-w-full",
                    "text-ellipsis",
                    "overflow-hidden"
                ]
            }
        },
        {
            isMultiline: true,
            radius: "full",
            class: {
                inputWrapper: "data-[has-multiple-rows=true]:rounded-large"
            }
        }
    ]
});




// src/text.ts
var $bc1b15abc9efe839$export$bb381007244da5ab = (text)=>{
    if ((text == null ? void 0 : text.length) <= 4) return text;
    return text == null ? void 0 : text.slice(0, 3);
};
var $bc1b15abc9efe839$export$a3d82bd9a7fbdcbb = (...texts)=>{
    let ariaLabel = " ";
    for (const text of texts)if (typeof text === "string" && text.length > 0) {
        ariaLabel = text;
        break;
    }
    return ariaLabel;
};

// src/console.ts

var $hPtJY = parcelRequire("hPtJY");
var $9d7cf34bba787841$var$warningStack = {};
function $9d7cf34bba787841$export$c106dd0671a0fc2d(message, component, ...args) {
    var _a;
    const tag = component ? ` [${component}]` : " ";
    const log = `[Next UI]${tag}: ${message}`;
    if (typeof console === "undefined") return;
    if ($9d7cf34bba787841$var$warningStack[log]) return;
    $9d7cf34bba787841$var$warningStack[log] = true;
    if (((_a = $hPtJY == null ? void 0 : $hPtJY.env) == null ? void 0 : _a.NODE_ENV) !== "production") return console.warn(log, args);
}




var $acw62 = parcelRequire("acw62");


"use client";
function $1b02cd2ee0d1cc6b$export$1e36b9f257eee5fa(originalProps) {
    var _a, _b, _c, _d;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $26efb188ef3bd6b6$export$b7e3ae3d7c15e42e).variantKeys);
    const { ref: ref, as: as, type: type, label: label, baseRef: baseRef, wrapperRef: wrapperRef, description: description, className: className, classNames: classNames, autoFocus: autoFocus, startContent: startContent, endContent: endContent, onClear: onClear, onChange: onChange, validationState: validationState, validationBehavior: validationBehavior = (_a = globalContext == null ? void 0 : globalContext.validationBehavior) != null ? _a : "aria", innerWrapperRef: innerWrapperRefProp, onValueChange: onValueChange = ()=>{}, ...otherProps } = props;
    const handleValueChange = (0, $acw62.useCallback)((value)=>{
        onValueChange(value != null ? value : "");
    }, [
        onValueChange
    ]);
    const [isFocusWithin, setFocusWithin] = (0, $acw62.useState)(false);
    const Component = as || "div";
    const disableAnimation = (_c = (_b = originalProps.disableAnimation) != null ? _b : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _c : false;
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const baseDomRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(baseRef);
    const inputWrapperRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(wrapperRef);
    const innerWrapperRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(innerWrapperRefProp);
    const [inputValue, setInputValue] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.value, (_d = props.defaultValue) != null ? _d : "", handleValueChange);
    const isFilledByDefault = [
        "date",
        "time",
        "month",
        "week",
        "range"
    ].includes(type);
    const isFilled = !(0, $337b0bbaace84edd$export$dd1bc94b04021eeb)(inputValue) || isFilledByDefault;
    const isFilledWithin = isFilled || isFocusWithin;
    const isHiddenType = type === "hidden";
    const isMultiline = originalProps.isMultiline;
    const isFileTypeInput = type === "file";
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className, isFilled ? "is-filled" : "");
    const handleClear = (0, $acw62.useCallback)(()=>{
        var _a2;
        setInputValue("");
        onClear == null || onClear();
        (_a2 = domRef.current) == null || _a2.focus();
    }, [
        setInputValue,
        onClear
    ]);
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        if (!domRef.current) return;
        setInputValue(domRef.current.value);
    }, [
        domRef.current
    ]);
    const { labelProps: labelProps, inputProps: inputProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $e96bf18a848d59e4$export$712718f7aec83d5)({
        ...originalProps,
        validationBehavior: validationBehavior,
        autoCapitalize: originalProps.autoCapitalize,
        value: inputValue,
        "aria-label": (0, $bc1b15abc9efe839$export$a3d82bd9a7fbdcbb)(originalProps["aria-label"], originalProps.label, originalProps.placeholder),
        inputElementType: isMultiline ? "textarea" : "input",
        onChange: setInputValue
    }, domRef);
    if (isFileTypeInput) {
        delete inputProps.value;
        delete inputProps.onChange;
    }
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus,
        isTextInput: true
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled)
    });
    const { focusProps: clearFocusProps, isFocusVisible: isClearButtonFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { focusWithinProps: focusWithinProps } = (0, $27a2d14f8c063b81$export$420e68273165f4ec)({
        onFocusWithinChange: setFocusWithin
    });
    const { pressProps: clearPressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled),
        onPress: handleClear
    });
    const isInvalid = validationState === "invalid" || originalProps.isInvalid || isAriaInvalid;
    const labelPlacement = (0, $acw62.useMemo)(()=>{
        var _a2;
        if (isFileTypeInput) {
            if (!originalProps.labelPlacement) return "outside";
            if (originalProps.labelPlacement === "inside") {
                (0, $9d7cf34bba787841$export$c106dd0671a0fc2d)("Input with file type doesn't support inside label. Converting to outside ...");
                return "outside";
            }
        }
        if ((!originalProps.labelPlacement || originalProps.labelPlacement === "inside") && !label) return "outside";
        return (_a2 = originalProps.labelPlacement) != null ? _a2 : "inside";
    }, [
        originalProps.labelPlacement,
        label
    ]);
    const errorMessage = typeof props.errorMessage === "function" ? props.errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : props.errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" "));
    const isClearable = !!onClear || originalProps.isClearable;
    const hasElements = !!label || !!description || !!errorMessage;
    const hasPlaceholder = !!props.placeholder;
    const hasLabel = !!label;
    const hasHelper = !!description || !!errorMessage;
    const shouldLabelBeOutside = labelPlacement === "outside" || labelPlacement === "outside-left";
    const shouldLabelBeInside = labelPlacement === "inside";
    const isPlaceholderShown = domRef.current ? (!domRef.current.value || domRef.current.value === "" || !inputValue || inputValue === "") && hasPlaceholder : false;
    const isOutsideLeft = labelPlacement === "outside-left";
    const hasStartContent = !!startContent;
    const isLabelOutside = shouldLabelBeOutside ? labelPlacement === "outside-left" || hasPlaceholder || labelPlacement === "outside" && hasStartContent : false;
    const isLabelOutsideAsPlaceholder = labelPlacement === "outside" && !hasPlaceholder && !hasStartContent;
    const slots = (0, $acw62.useMemo)(()=>(0, $26efb188ef3bd6b6$export$b7e3ae3d7c15e42e)({
            ...variantProps,
            isInvalid: isInvalid,
            labelPlacement: labelPlacement,
            isClearable: isClearable,
            disableAnimation: disableAnimation
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isInvalid,
        labelPlacement,
        isClearable,
        hasStartContent,
        disableAnimation
    ]);
    const getBaseProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ref: baseDomRef,
            className: slots.base({
                class: baseStyles
            }),
            "data-slot": "base",
            "data-filled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFilled || hasPlaceholder || hasStartContent || isPlaceholderShown || isFileTypeInput),
            "data-filled-within": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFilledWithin || hasPlaceholder || hasStartContent || isPlaceholderShown || isFileTypeInput),
            "data-focus-within": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusWithin),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-readonly": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps.isReadOnly),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-required": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps.isRequired),
            "data-invalid": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isInvalid),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps.isDisabled),
            "data-has-elements": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasElements),
            "data-has-helper": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasHelper),
            "data-has-label": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasLabel),
            "data-has-value": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(!isPlaceholderShown),
            "data-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHiddenType),
            ...focusWithinProps,
            ...props2
        };
    }, [
        slots,
        baseStyles,
        isFilled,
        isFocused,
        isHovered,
        isInvalid,
        hasHelper,
        hasLabel,
        hasElements,
        isPlaceholderShown,
        hasStartContent,
        isFocusWithin,
        isFocusVisible,
        isFilledWithin,
        hasPlaceholder,
        focusWithinProps,
        isHiddenType,
        originalProps.isReadOnly,
        originalProps.isRequired,
        originalProps.isDisabled
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            "data-slot": "label",
            className: slots.label({
                class: classNames == null ? void 0 : classNames.label
            }),
            ...labelProps,
            ...props2
        };
    }, [
        slots,
        labelProps,
        classNames == null ? void 0 : classNames.label
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "input",
            "data-filled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFilled),
            "data-filled-within": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFilledWithin),
            "data-has-start-content": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasStartContent),
            "data-has-end-content": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(!!endContent),
            className: slots.input({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.input, isFilled ? "is-filled" : "")
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusProps, inputProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: true,
                labelable: true,
                omitEventNames: new Set(Object.keys(inputProps))
            }), props2),
            "aria-readonly": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps.isReadOnly),
            onChange: (0, $276a22df76563a4a$export$e08e3b67e392101e)(inputProps.onChange, onChange)
        };
    }, [
        slots,
        inputValue,
        focusProps,
        inputProps,
        otherProps,
        isFilled,
        isFilledWithin,
        hasStartContent,
        endContent,
        classNames == null ? void 0 : classNames.input,
        originalProps.isReadOnly,
        originalProps.isRequired,
        onChange
    ]);
    const getInputWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ref: inputWrapperRef,
            "data-slot": "input-wrapper",
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            className: slots.inputWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.inputWrapper, isFilled ? "is-filled" : "")
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(props2, hoverProps),
            onClick: (e)=>{
                if (domRef.current && e.currentTarget === e.target) domRef.current.focus();
            },
            style: {
                cursor: "text",
                ...props2.style
            }
        };
    }, [
        slots,
        isHovered,
        isFocusVisible,
        isFocused,
        inputValue,
        classNames == null ? void 0 : classNames.inputWrapper
    ]);
    const getInnerWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ref: innerWrapperRef,
            "data-slot": "inner-wrapper",
            onClick: (e)=>{
                if (domRef.current && e.currentTarget === e.target) domRef.current.focus();
            },
            className: slots.innerWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.innerWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.innerWrapper
    ]);
    const getMainWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "main-wrapper",
            className: slots.mainWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.mainWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.mainWrapper
    ]);
    const getHelperWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "helper-wrapper",
            className: slots.helperWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.helperWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.helperWrapper
    ]);
    const getDescriptionProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            "data-slot": "description",
            className: slots.description({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    const getErrorMessageProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            "data-slot": "error-message",
            className: slots.errorMessage({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        errorMessageProps,
        classNames == null ? void 0 : classNames.errorMessage
    ]);
    const getClearButtonProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            role: "button",
            tabIndex: 0,
            "aria-label": "clear input",
            "data-slot": "clear-button",
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isClearButtonFocusVisible),
            className: slots.clearButton({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.clearButton, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(clearPressProps, clearFocusProps)
        };
    }, [
        slots,
        isClearButtonFocusVisible,
        clearPressProps,
        clearFocusProps,
        classNames == null ? void 0 : classNames.clearButton
    ]);
    return {
        Component: Component,
        classNames: classNames,
        domRef: domRef,
        label: label,
        description: description,
        startContent: startContent,
        endContent: endContent,
        labelPlacement: labelPlacement,
        isClearable: isClearable,
        hasHelper: hasHelper,
        hasStartContent: hasStartContent,
        isLabelOutside: isLabelOutside,
        isOutsideLeft: isOutsideLeft,
        isLabelOutsideAsPlaceholder: isLabelOutsideAsPlaceholder,
        shouldLabelBeOutside: shouldLabelBeOutside,
        shouldLabelBeInside: shouldLabelBeInside,
        hasPlaceholder: hasPlaceholder,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        getBaseProps: getBaseProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getMainWrapperProps: getMainWrapperProps,
        getInputWrapperProps: getInputWrapperProps,
        getInnerWrapperProps: getInnerWrapperProps,
        getHelperWrapperProps: getHelperWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps,
        getClearButtonProps: getClearButtonProps
    };
}


// src/close-filled.tsx

var $674bd67e3ad1a850$export$2b32a5a2c6e4dc78 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06 1.06l-2.3 2.3z",
            fill: "currentColor"
        })
    });



var $acw62 = parcelRequire("acw62");


"use client";
var $4e693153d3a5c272$var$Input = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, label: label, description: description, isClearable: isClearable, startContent: startContent, endContent: endContent, labelPlacement: labelPlacement, hasHelper: hasHelper, isOutsideLeft: isOutsideLeft, shouldLabelBeOutside: shouldLabelBeOutside, errorMessage: errorMessage, isInvalid: isInvalid, getBaseProps: getBaseProps, getLabelProps: getLabelProps, getInputProps: getInputProps, getInnerWrapperProps: getInnerWrapperProps, getInputWrapperProps: getInputWrapperProps, getMainWrapperProps: getMainWrapperProps, getHelperWrapperProps: getHelperWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps, getClearButtonProps: getClearButtonProps } = (0, $1b02cd2ee0d1cc6b$export$1e36b9f257eee5fa)({
        ...props,
        ref: ref
    });
    const labelContent = label ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...getLabelProps(),
        children: label
    }) : null;
    const end = (0, $acw62.useMemo)(()=>{
        if (isClearable) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            ...getClearButtonProps(),
            children: endContent || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $674bd67e3ad1a850$export$2b32a5a2c6e4dc78), {})
        });
        return endContent;
    }, [
        isClearable,
        getClearButtonProps
    ]);
    const helperWrapper = (0, $acw62.useMemo)(()=>{
        if (!hasHelper) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...getHelperWrapperProps(),
            children: isInvalid && errorMessage ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        });
    }, [
        hasHelper,
        isInvalid,
        errorMessage,
        description,
        getHelperWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    const innerWrapper = (0, $acw62.useMemo)(()=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
            ...getInnerWrapperProps(),
            children: [
                startContent,
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ...getInputProps()
                }),
                end
            ]
        });
    }, [
        startContent,
        end,
        getInputProps,
        getInnerWrapperProps
    ]);
    const mainWrapper = (0, $acw62.useMemo)(()=>{
        if (shouldLabelBeOutside) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
            ...getMainWrapperProps(),
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ...getInputWrapperProps(),
                    children: [
                        !isOutsideLeft ? labelContent : null,
                        innerWrapper
                    ]
                }),
                helperWrapper
            ]
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ...getInputWrapperProps(),
                    children: [
                        labelContent,
                        innerWrapper
                    ]
                }),
                helperWrapper
            ]
        });
    }, [
        labelPlacement,
        helperWrapper,
        shouldLabelBeOutside,
        labelContent,
        innerWrapper,
        errorMessage,
        description,
        getMainWrapperProps,
        getInputWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            isOutsideLeft ? labelContent : null,
            mainWrapper
        ]
    });
});
$4e693153d3a5c272$var$Input.displayName = "NextUI.Input";
var $4e693153d3a5c272$export$921a3451e53aa4ce = $4e693153d3a5c272$var$Input;




"use client";
function $4242086c8a2b354a$var$Autocomplete(props, ref) {
    const { Component: Component, isOpen: isOpen, disableAnimation: disableAnimation, selectorIcon: selectorIcon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3d5bf69f39f72f17$export$4857d3f3f5f8319b), {}), clearIcon: clearIcon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a106e18a12a75ce7$export$cae179f078f4b4a4), {}), endContent: endContent, getBaseProps: getBaseProps, getSelectorButtonProps: getSelectorButtonProps, getInputProps: getInputProps, getListBoxProps: getListBoxProps, getPopoverProps: getPopoverProps, getEmptyPopoverProps: getEmptyPopoverProps, getClearButtonProps: getClearButtonProps, getListBoxWrapperProps: getListBoxWrapperProps, getEndContentWrapperProps: getEndContentWrapperProps } = (0, $c88f0f4073a32e58$export$1e40b3ca02d92d21)({
        ...props,
        ref: ref
    });
    const popoverContent = isOpen ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $eb832465a4ea348e$export$4f32f7e42026f90b), {
        ...getPopoverProps(),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $67ab465da978cead$export$bef3e985c75eafb5), {
            ...getListBoxWrapperProps(),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $29de8649494b89cd$export$3f842a5957aa0e7a), {
                ...getListBoxProps()
            })
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...getEmptyPopoverProps()
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4e693153d3a5c272$export$921a3451e53aa4ce), {
                ...getInputProps(),
                endContent: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ...getEndContentWrapperProps(),
                    children: [
                        endContent || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                            ...getClearButtonProps(),
                            children: clearIcon
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                            ...getSelectorButtonProps(),
                            children: selectorIcon
                        })
                    ]
                })
            }),
            disableAnimation ? popoverContent : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: popoverContent
            })
        ]
    });
}
var $4242086c8a2b354a$export$e47a559fed520648 = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)($4242086c8a2b354a$var$Autocomplete);
$4242086c8a2b354a$var$Autocomplete.displayName = "NextUI.Autocomplete";


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $805dabd401117505$var$$c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$805dabd401117505$var$$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems, title: title, children: children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $805dabd401117505$var$$c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $805dabd401117505$var$$c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $805dabd401117505$export$6d08773d2e66f8f2 = $805dabd401117505$var$$c1d7fb2ec91bae71$var$Item;


"use client";
var $bb9bba36bb6f6f82$var$ListboxItemBase = (0, $805dabd401117505$export$6d08773d2e66f8f2);
var $bb9bba36bb6f6f82$export$c9741ea17cd30897 = $bb9bba36bb6f6f82$var$ListboxItemBase;


"use client";
var [$a2926c5227578d6a$export$8177a931fccf3109, $a2926c5227578d6a$export$28c3a9869c2838c2] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "DropdownContext",
    errorMessage: "useDropdownContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Dropdown />`"
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $941f255681c12466$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $13a9827b1c7dcaf2$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $acw62.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        expandedKeysStack: expandedKeysStack,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    };
}





// src/components/dropdown.ts
var $e898db81fa6db6a0$export$81207e5cc4186890 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: [
        "w-full",
        "p-1",
        "min-w-[200px]"
    ]
});
var $e898db81fa6db6a0$export$a8f2ac991e6b7a5 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "group",
            "gap-2",
            "items-center",
            "justify-between",
            "relative",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "box-border",
            "rounded-small",
            "outline-none",
            "cursor-pointer",
            "tap-highlight-transparent",
            "data-[pressed=true]:opacity-70",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba),
            "data-[focus-visible=true]:dark:ring-offset-background-content1"
        ],
        wrapper: "w-full flex flex-col items-start justify-center",
        title: "flex-1 text-small font-normal truncate",
        description: [
            "w-full",
            "text-tiny",
            "text-foreground-500",
            "group-hover:text-current"
        ],
        selectedIcon: [
            "text-inherit",
            "w-3",
            "h-3",
            "flex-shrink-0"
        ],
        shortcut: [
            "px-1",
            "py-0.5",
            "rounded",
            "font-sans",
            "text-foreground-500",
            "text-tiny",
            "border-small",
            "border-default-300",
            "group-hover:border-current"
        ]
    },
    variants: {
        variant: {
            solid: {
                base: ""
            },
            bordered: {
                base: "border-medium border-transparent bg-transparent"
            },
            light: {
                base: "bg-transparent"
            },
            faded: {
                base: "border-small border-transparent hover:border-default data-[hover=true]:bg-default-100"
            },
            flat: {
                base: ""
            },
            shadow: {
                base: "data-[hover=true]:shadow-lg"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {},
            false: {}
        }
    },
    defaultVariants: {
        variant: "solid",
        color: "default"
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: {
                base: "data-[hover=true]:bg-default data-[hover=true]:text-default-foreground"
            }
        },
        {
            variant: "solid",
            color: "primary",
            class: {
                base: "data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground"
            }
        },
        {
            variant: "solid",
            color: "secondary",
            class: {
                base: "data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground"
            }
        },
        {
            variant: "solid",
            color: "success",
            class: {
                base: "data-[hover=true]:bg-success data-[hover=true]:text-success-foreground"
            }
        },
        {
            variant: "solid",
            color: "warning",
            class: {
                base: "data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground"
            }
        },
        {
            variant: "solid",
            color: "danger",
            class: {
                base: "data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground"
            }
        },
        {
            variant: "shadow",
            color: "default",
            class: {
                base: "data-[hover=true]:shadow-default/50 data-[hover=true]:bg-default data-[hover=true]:text-default-foreground"
            }
        },
        {
            variant: "shadow",
            color: "primary",
            class: {
                base: "data-[hover=true]:shadow-primary/30 data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground"
            }
        },
        {
            variant: "shadow",
            color: "secondary",
            class: {
                base: "data-[hover=true]:shadow-secondary/30 data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground"
            }
        },
        {
            variant: "shadow",
            color: "success",
            class: {
                base: "data-[hover=true]:shadow-success/30 data-[hover=true]:bg-success data-[hover=true]:text-success-foreground"
            }
        },
        {
            variant: "shadow",
            color: "warning",
            class: {
                base: "data-[hover=true]:shadow-warning/30 data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground"
            }
        },
        {
            variant: "shadow",
            color: "danger",
            class: {
                base: "data-[hover=true]:shadow-danger/30 data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground"
            }
        },
        {
            variant: "bordered",
            color: "default",
            class: {
                base: "data-[hover=true]:border-default"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                base: "data-[hover=true]:border-primary data-[hover=true]:text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                base: "data-[hover=true]:border-secondary data-[hover=true]:text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                base: "data-[hover=true]:border-success data-[hover=true]:text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                base: "data-[hover=true]:border-warning data-[hover=true]:text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                base: "data-[hover=true]:border-danger data-[hover=true]:text-danger"
            }
        },
        {
            variant: "flat",
            color: "default",
            class: {
                base: "data-[hover=true]:bg-default/40 data-[hover=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                base: "data-[hover=true]:bg-primary/20 data-[hover=true]:text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                base: "data-[hover=true]:bg-secondary/20 data-[hover=true]:text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                base: "data-[hover=true]:bg-success/20 data-[hover=true]:text-success "
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                base: "data-[hover=true]:bg-warning/20 data-[hover=true]:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                base: "data-[hover=true]:bg-danger/20 data-[hover=true]:text-danger"
            }
        },
        {
            variant: "faded",
            color: "default",
            class: {
                base: "data-[hover=true]:text-default-foreground"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                base: "data-[hover=true]:text-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                base: "data-[hover=true]:text-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                base: "data-[hover=true]:text-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                base: "data-[hover=true]:text-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                base: "data-[hover=true]:text-danger"
            }
        },
        {
            variant: "light",
            color: "default",
            class: {
                base: "data-[hover=true]:text-default-500"
            }
        },
        {
            variant: "light",
            color: "primary",
            class: {
                base: "data-[hover=true]:text-primary"
            }
        },
        {
            variant: "light",
            color: "secondary",
            class: {
                base: "data-[hover=true]:text-secondary"
            }
        },
        {
            variant: "light",
            color: "success",
            class: {
                base: "data-[hover=true]:text-success"
            }
        },
        {
            variant: "light",
            color: "warning",
            class: {
                base: "data-[hover=true]:text-warning"
            }
        },
        {
            variant: "light",
            color: "danger",
            class: {
                base: "data-[hover=true]:text-danger"
            }
        }
    ]
});
var $e898db81fa6db6a0$export$465da67a70001fda = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "relative mb-2",
        heading: "pl-1 text-tiny text-foreground-500",
        group: "data-[has-title=true]:pt-1",
        divider: "mt-2"
    }
});
var $e898db81fa6db6a0$export$f40e957e8c490719 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: "w-full flex flex-col gap-0.5 p-1"
});




"use client";
function $2bb49473be67834f$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ((0, $337b0bbaace84edd$export$f6e2535fb5126e54)(ref)) {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $2bb49473be67834f$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>$2bb49473be67834f$export$d734136a7b018efe(ref, node));
    };
}




var $acw62 = parcelRequire("acw62");

"use client";
function $c70b01f5a6ead87f$export$8c32fdb3462273b4(props) {
    var _a;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const { as: as, triggerRef: triggerRefProp, isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange, isDisabled: isDisabled, type: type = "menu", trigger: trigger = "press", placement: placement = "bottom", closeOnSelect: closeOnSelect = true, shouldBlockScroll: shouldBlockScroll = true, classNames: classNamesProp, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, onClose: onClose, className: className, ...otherProps } = props;
    const Component = as || "div";
    const triggerRef = (0, $acw62.useRef)(null);
    const menuTriggerRef = triggerRefProp || triggerRef;
    const menuRef = (0, $acw62.useRef)(null);
    const popoverRef = (0, $acw62.useRef)(null);
    const state = (0, $941f255681c12466$export$79fefeb1c2091ac3)({
        trigger: trigger,
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: (isOpen2)=>{
            onOpenChange == null || onOpenChange(isOpen2);
            if (!isOpen2) onClose == null || onClose();
        }
    });
    const { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $16a1933d449b51c0$export$dc9c12ed27dd1b49)({
        type: type,
        trigger: trigger,
        isDisabled: isDisabled
    }, state, menuTriggerRef);
    const classNames = (0, $acw62.useMemo)(()=>(0, $e898db81fa6db6a0$export$81207e5cc4186890)({
            className: className
        }), [
        className
    ]);
    const onMenuAction = (menuCloseOnSelect)=>{
        if (menuCloseOnSelect !== void 0 && !menuCloseOnSelect) return;
        if (closeOnSelect) state.close();
    };
    const getPopoverProps = (props2 = {})=>{
        const popoverProps = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherProps, props2);
        return {
            state: state,
            placement: placement,
            ref: popoverRef,
            disableAnimation: disableAnimation,
            shouldBlockScroll: shouldBlockScroll,
            scrollRef: menuRef,
            triggerRef: menuTriggerRef,
            ...popoverProps,
            classNames: {
                ...classNamesProp,
                ...props2.classNames,
                content: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames, classNamesProp == null ? void 0 : classNamesProp.content, props2.className)
            },
            shouldCloseOnInteractOutside: (popoverProps == null ? void 0 : popoverProps.shouldCloseOnInteractOutside) ? popoverProps.shouldCloseOnInteractOutside : (element)=>(0, $6298ff82a135c7fc$export$ef74e55a94b62f23)(element, triggerRef, state)
        };
    };
    const getMenuTriggerProps = (originalProps = {}, _ref = null)=>{
        const { onPress: onPress, onPressStart: onPressStart, ...otherMenuTriggerProps } = menuTriggerProps;
        return {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherMenuTriggerProps, {
                isDisabled: isDisabled
            }, originalProps),
            ref: (0, $2bb49473be67834f$export$c9058316764c140e)(_ref, triggerRef)
        };
    };
    const getMenuProps = (props2, _ref = null)=>{
        return {
            ref: (0, $2bb49473be67834f$export$c9058316764c140e)(_ref, menuRef),
            menuProps: menuProps,
            closeOnSelect: closeOnSelect,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(props2, {
                onAction: ()=>onMenuAction(props2 == null ? void 0 : props2.closeOnSelect),
                onClose: state.close
            })
        };
    };
    return {
        Component: Component,
        menuRef: menuRef,
        menuProps: menuProps,
        classNames: classNames,
        closeOnSelect: closeOnSelect,
        onClose: state.close,
        autoFocus: state.focusStrategy || true,
        disableAnimation: disableAnimation,
        getPopoverProps: getPopoverProps,
        getMenuProps: getMenuProps,
        getMenuTriggerProps: getMenuTriggerProps
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
var [$0a2bfcc234b99477$export$bf694c7c431c162a, $0a2bfcc234b99477$export$1468d0761b26e6c8] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});




var $acw62 = parcelRequire("acw62");




"use client";
var $9b21e3b0663024ed$var$Popover = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, ...otherProps } = props;
    const context = (0, $305aa6582ba8c3d7$export$542a6fd13ac93354)({
        ...otherProps,
        ref: ref
    });
    const [trigger, content] = (0, $acw62.Children).toArray(children);
    const overlay = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8b039484d708a25a$export$c6fdb837b070b4ff), {
        portalContainer: context.portalContainer,
        children: content
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0a2bfcc234b99477$export$bf694c7c431c162a), {
        value: context,
        children: [
            trigger,
            context.disableAnimation && context.isOpen ? overlay : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: context.isOpen ? overlay : null
            })
        ]
    });
});
$9b21e3b0663024ed$var$Popover.displayName = "NextUI.Popover";
var $9b21e3b0663024ed$export$b56270f92ff8018 = $9b21e3b0663024ed$var$Popover;



"use client";
var $a8a01edcf9e5fefd$var$Dropdown = (props)=>{
    const { children: children, ...otherProps } = props;
    const context = (0, $c70b01f5a6ead87f$export$8c32fdb3462273b4)(otherProps);
    const [menuTrigger, menu] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a2926c5227578d6a$export$8177a931fccf3109), {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $9b21e3b0663024ed$export$b56270f92ff8018), {
            ...context.getPopoverProps(),
            children: [
                menuTrigger,
                menu
            ]
        })
    });
};
$a8a01edcf9e5fefd$var$Dropdown.displayName = "NextUI.Dropdown";
var $a8a01edcf9e5fefd$export$3bd981faadafe0b3 = $a8a01edcf9e5fefd$var$Dropdown;


"use client";
var $4107eb738d7c5e40$var$MenuItemBase = (0, $805dabd401117505$export$6d08773d2e66f8f2);
var $4107eb738d7c5e40$export$42228163bda52c88 = $4107eb738d7c5e40$var$MenuItemBase;




var $acw62 = parcelRequire("acw62");





var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $7WQrb = parcelRequire("7WQrb");
function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $7WQrb.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $7WQrb.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};



var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $7WQrb.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $7WQrb.__assign)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}



var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $7WQrb.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $7WQrb.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;





"use client";
var $09f067fab22dde0c$var$PopoverContent = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, _)=>{
    const { as: as, children: children, className: className, ...otherProps } = props;
    const { Component: OverlayComponent, isOpen: isOpen, placement: placement, backdrop: backdrop, motionProps: motionProps, disableAnimation: disableAnimation, shouldBlockScroll: shouldBlockScroll, getPopoverProps: getPopoverProps, getDialogProps: getDialogProps, getBackdropProps: getBackdropProps, getContentProps: getContentProps, isNonModal: isNonModal, onClose: onClose } = (0, $0a2bfcc234b99477$export$1468d0761b26e6c8)();
    const dialogRef = (0, $acw62.useRef)(null);
    const { dialogProps: ariaDialogProps, titleProps: titleProps } = (0, $3fee594f3ffdb6a2$export$d55e7ee900f34e93)({}, dialogRef);
    const dialogProps = getDialogProps({
        ref: dialogRef,
        ...ariaDialogProps,
        ...otherProps
    });
    const Component = as || OverlayComponent || "div";
    const content = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !isNonModal && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ffab0043461eda28$export$2317d149ed6f78c4), {
                onDismiss: onClose
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...dialogProps,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...getContentProps({
                        className: className
                    }),
                    children: typeof children === "function" ? children(titleProps) : children
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ffab0043461eda28$export$2317d149ed6f78c4), {
                onDismiss: onClose
            })
        ]
    });
    const backdropContent = (0, $acw62.useMemo)(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
            features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $0541ef573799255c$export$55b7325ba41bb523).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    const contents = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        enabled: shouldBlockScroll && isOpen,
        removeScrollBar: false,
        children: disableAnimation ? content : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
            features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).div, {
                animate: "enter",
                exit: "exit",
                initial: "initial",
                style: {
                    ...(0, $d1aa5725be27b2ff$export$d0ca24f1cd6d5c41)(placement === "center" ? "top" : placement)
                },
                variants: (0, $0541ef573799255c$export$55b7325ba41bb523).scaleSpringOpacity,
                ...motionProps,
                children: content
            })
        })
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getPopoverProps(),
        children: [
            backdropContent,
            contents
        ]
    });
});
$09f067fab22dde0c$var$PopoverContent.displayName = "NextUI.PopoverContent";
var $09f067fab22dde0c$export$2a0d18fe44adc4b6 = $09f067fab22dde0c$var$PopoverContent;





"use client";
function $8334942f90088280$export$2df9b1648d015890(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        "data-selected": isSelected,
        role: "presentation",
        viewBox: "0 0 17 18",
        ...otherProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            fill: "none",
            points: "1 9 7 14 15 4",
            stroke: "currentColor",
            strokeDasharray: 22,
            strokeDashoffset: isSelected ? 44 : 66,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            style: !disableAnimation ? {
                transition: "stroke-dashoffset 200ms ease"
            } : {}
        })
    });
}



var $acw62 = parcelRequire("acw62");




// src/use-menu.ts


var $1e7f1177aeecc202$export$6f49b4016bfc8d56 = /* @__PURE__ */ new WeakMap();
function $1e7f1177aeecc202$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $9948dc1e277f262f$export$b95089534ab7c1fd)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: "override"
    });
    $1e7f1177aeecc202$export$6f49b4016bfc8d56.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: "menu",
            ...listProps,
            onKeyDown: (event)=>{
                if (event.key !== "Escape") {
                    if (listProps.onKeyDown) listProps.onKeyDown(event);
                }
            }
        })
    };
}






function $6ba6f42d3a094ca3$export$9d32628fc2aea7da(props, state, ref) {
    var _a, _b;
    let { key: key, closeOnSelect: closeOnSelect, isVirtualized: isVirtualized, "aria-haspopup": hasPopup, onPressStart: pressStartProp, onPressUp: pressUpProp, onPress: onPress, onPressChange: onPressChange, onPressEnd: onPressEnd, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur, onClick: onClick } = props;
    let isTrigger = !!hasPopup;
    let isDisabled = (_a = props.isDisabled) != null ? _a : state.selectionManager.isDisabled(key);
    let isSelected = (_b = props.isSelected) != null ? _b : state.selectionManager.isSelected(key);
    let data = (0, $1e7f1177aeecc202$export$6f49b4016bfc8d56).get(state);
    let item = state.collection.getItem(key);
    let onClose = props.onClose || data.onClose;
    let router = (0, $4a4107ecda93bad9$export$9a302a45f65d0572)();
    let performAction = (e)=>{
        var _a2;
        if (isTrigger) return;
        if ((_a2 = item == null ? void 0 : item.props) == null ? void 0 : _a2.onAction) item.props.onAction();
        if (props.onAction) props.onAction(key);
        else if (data.onAction) data.onAction(key);
        if (e.target instanceof HTMLAnchorElement) router.open(e.target, e, item.props.href, item.props.routerOptions);
    };
    let role = "menuitem";
    if (!isTrigger) {
        if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
        else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    }
    let labelId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)();
    let keyboardId = (0, $fc8082d5d9c62cca$export$b4cc09c592e8fdb8)();
    let ariaProps = {
        "aria-disabled": isDisabled || void 0,
        role: role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || void 0,
        "aria-controls": props["aria-controls"],
        "aria-haspopup": hasPopup,
        "aria-expanded": props["aria-expanded"]
    };
    if (state.selectionManager.selectionMode !== "none" && !isTrigger) ariaProps["aria-checked"] = isSelected;
    if (isVirtualized) {
        ariaProps["aria-posinset"] = item == null ? void 0 : item.index;
        ariaProps["aria-setsize"] = (0, $b6e1ce9cd2ff6ef3$export$77d5aafae4e095b2)(state.collection);
    }
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard") performAction(e);
        pressStartProp == null || pressStartProp(e);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            setTimeout(()=>{
                performAction(e);
            });
            if (!isTrigger && onClose && (closeOnSelect != null ? closeOnSelect : state.selectionManager.selectionMode !== "multiple" || state.selectionManager.isLink(key))) setTimeout(()=>{
                onClose == null || onClose();
            });
        }
        pressUpProp == null || pressUpProp(e);
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $195fc3c02bfc1bb3$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        linkBehavior: "none"
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            if (!(0, $b995f28c9a72ee4c$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
            hoverStartProp == null || hoverStartProp(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $710096ea6048f1ed$export$8f71654801c2f7cd)({
        onKeyDown: (e)=>{
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case " ":
                    if (!isDisabled && state.selectionManager.selectionMode === "none" && !isTrigger && closeOnSelect !== false && onClose) onClose();
                    break;
                case "Enter":
                    if (!isDisabled && closeOnSelect !== false && !isTrigger && onClose) onClose();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown == null || onKeyDown(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    });
    let { focusProps: focusProps } = (0, $e009837ee384a76a$export$f8168d8dd8fd66e6)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    });
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(item.props);
    delete domProps.id;
    let linkProps = (0, $4a4107ecda93bad9$export$7e924b3091a3bd18)(item.props);
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, linkProps, isTrigger ? {
                onFocus: itemProps.onFocus
            } : itemProps, pressProps, hoverProps, keyboardProps, focusProps, {
                onClick: (0, $276a22df76563a4a$export$e08e3b67e392101e)(onClick, pressProps.onClick)
            }),
            tabIndex: itemProps.tabIndex != null ? -1 : void 0
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isHovered: isHovered,
        isFocused: isFocused,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}





"use client";
function $c1044ce9ae5a260c$export$9d32628fc2aea7da(originalProps) {
    var _a, _b;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $c8ce6ffc45f51469$export$c176f998e71d0f08).variantKeys);
    const { as: as, item: item, state: state, shortcut: shortcut, description: description, startContent: startContent, endContent: endContent, isVirtualized: isVirtualized, selectedIcon: selectedIcon, className: className, classNames: classNames, onAction: onAction, autoFocus: autoFocus, onClick: onClick, onPress: onPress, onPressStart: onPressStart, onPressUp: onPressUp, onPressEnd: onPressEnd, onPressChange: onPressChange, hideSelectedIcon: hideSelectedIcon = false, isReadOnly: isReadOnly = false, closeOnSelect: closeOnSelect, onClose: onClose, ...otherProps } = props;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const domRef = (0, $acw62.useRef)(null);
    const Component = as || ((otherProps == null ? void 0 : otherProps.href) ? "a" : "li");
    const shouldFilterDOMProps = typeof Component === "string";
    const { rendered: rendered, key: key } = item;
    const isDisabled = state.disabledKeys.has(key) || originalProps.isDisabled;
    const isSelectable = state.selectionManager.selectionMode !== "none";
    const isMobile = (0, $8dd9b21f23a75108$export$2b96349243a56116)();
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const { isHovered: isHovered, isPressed: isPressed, isFocused: isFocused, isSelected: isSelected, menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps } = (0, $6ba6f42d3a094ca3$export$9d32628fc2aea7da)({
        key: key,
        onClose: onClose,
        isDisabled: isDisabled,
        onPress: onPress,
        onClick: onClick,
        onPressStart: onPressStart,
        onPressUp: onPressUp,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        "aria-label": props["aria-label"],
        closeOnSelect: closeOnSelect,
        isVirtualized: isVirtualized,
        onAction: onAction
    }, state, domRef);
    let itemProps = menuItemProps;
    const slots = (0, $acw62.useMemo)(()=>(0, $c8ce6ffc45f51469$export$c176f998e71d0f08)({
            ...variantProps,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isDisabled,
        disableAnimation
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    if (isReadOnly) itemProps = (0, $91ffd9bd684fd1b9$export$da5f6eb3bb522cd)(itemProps);
    const getItemProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(isReadOnly ? {} : focusProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), itemProps, props2),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-selectable": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelectable),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMobile ? isHovered || isPressed : isHovered),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2.className)
            })
        });
    const getLabelProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(labelProps, props2),
            className: slots.title({
                class: classNames == null ? void 0 : classNames.title
            })
        });
    const getDescriptionProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(descriptionProps, props2),
            className: slots.description({
                class: classNames == null ? void 0 : classNames.description
            })
        });
    const getKeyboardShortcutProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(keyboardShortcutProps, props2),
            className: slots.shortcut({
                class: classNames == null ? void 0 : classNames.shortcut
            })
        });
    const getSelectedIconProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            className: slots.selectedIcon({
                class: classNames == null ? void 0 : classNames.selectedIcon
            }),
            ...props2
        };
    }, [
        isDisabled,
        slots,
        classNames
    ]);
    return {
        Component: Component,
        domRef: domRef,
        slots: slots,
        classNames: classNames,
        isSelectable: isSelectable,
        isSelected: isSelected,
        isDisabled: isDisabled,
        rendered: rendered,
        shortcut: shortcut,
        description: description,
        startContent: startContent,
        endContent: endContent,
        selectedIcon: selectedIcon,
        disableAnimation: disableAnimation,
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        hideSelectedIcon: hideSelectedIcon,
        getDescriptionProps: getDescriptionProps,
        getKeyboardShortcutProps: getKeyboardShortcutProps,
        getSelectedIconProps: getSelectedIconProps
    };
}



var $acw62 = parcelRequire("acw62");


"use client";
var $6675c4f50a3aea04$var$MenuItem = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, _)=>{
    const { Component: Component, slots: slots, classNames: classNames, rendered: rendered, shortcut: shortcut, description: description, isSelectable: isSelectable, isSelected: isSelected, isDisabled: isDisabled, selectedIcon: selectedIcon, startContent: startContent, endContent: endContent, disableAnimation: disableAnimation, hideSelectedIcon: hideSelectedIcon, getItemProps: getItemProps, getLabelProps: getLabelProps, getDescriptionProps: getDescriptionProps, getKeyboardShortcutProps: getKeyboardShortcutProps, getSelectedIconProps: getSelectedIconProps } = (0, $c1044ce9ae5a260c$export$9d32628fc2aea7da)(props);
    const selectedContent = (0, $acw62.useMemo)(()=>{
        const defaultIcon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8334942f90088280$export$2df9b1648d015890), {
            disableAnimation: disableAnimation,
            isSelected: isSelected
        });
        if (typeof selectedIcon === "function") return selectedIcon({
            icon: defaultIcon,
            isSelected: isSelected,
            isDisabled: isDisabled
        });
        if (selectedIcon) return selectedIcon;
        return defaultIcon;
    }, [
        selectedIcon,
        isSelected,
        isDisabled,
        disableAnimation
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getItemProps(),
        children: [
            startContent,
            description ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: slots.wrapper({
                    class: classNames == null ? void 0 : classNames.wrapper
                }),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getLabelProps(),
                        children: rendered
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getDescriptionProps(),
                        children: description
                    })
                ]
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getLabelProps(),
                children: rendered
            }),
            shortcut && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                ...getKeyboardShortcutProps(),
                children: shortcut
            }),
            isSelectable && !hideSelectedIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getSelectedIconProps(),
                children: selectedContent
            }),
            endContent
        ]
    });
});
$6675c4f50a3aea04$var$MenuItem.displayName = "NextUI.MenuItem";
var $6675c4f50a3aea04$export$c023dba2983aab3 = $6675c4f50a3aea04$var$MenuItem;




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $82bb792fff0a1e2f$export$73f7a44322579622(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}



var $acw62 = parcelRequire("acw62");





"use client";
var $5fe8e24ee714bb63$var$MenuSection = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)(({ item: item, state: state, as: as, variant: variant, color: color, disableAnimation: disableAnimation, onAction: onAction, closeOnSelect: closeOnSelect, className: className, classNames: classNames, showDivider: showDivider = false, hideSelectedIcon: hideSelectedIcon, dividerProps: dividerProps = {}, itemClasses: itemClasses, title: title, ...otherProps }, _)=>{
    const Component = as || "li";
    const slots = (0, $acw62.useMemo)(()=>(0, $c8ce6ffc45f51469$export$95e0837a3419f5c1)(), []);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const dividerStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.divider, dividerProps == null ? void 0 : dividerProps.className);
    const { itemProps: itemProps, headingProps: headingProps, groupProps: groupProps } = (0, $82bb792fff0a1e2f$export$73f7a44322579622)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        "data-slot": "base",
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(itemProps, otherProps),
        className: slots.base({
            class: baseStyles
        }),
        children: [
            item.rendered && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...headingProps,
                className: slots.heading({
                    class: classNames == null ? void 0 : classNames.heading
                }),
                "data-slot": "heading",
                children: item.rendered
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                ...groupProps,
                className: slots.group({
                    class: classNames == null ? void 0 : classNames.group
                }),
                "data-has-title": !!item.rendered,
                "data-slot": "group",
                children: [
                    [
                        ...item.childNodes
                    ].map((node)=>{
                        const { key: nodeKey, props: nodeProps } = node;
                        let menuItem = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6675c4f50a3aea04$export$c023dba2983aab3), {
                            classNames: itemClasses,
                            closeOnSelect: closeOnSelect,
                            color: color,
                            disableAnimation: disableAnimation,
                            hideSelectedIcon: hideSelectedIcon,
                            item: node,
                            state: state,
                            variant: variant,
                            onAction: onAction,
                            ...nodeProps
                        }, nodeKey);
                        if (node.wrapper) menuItem = node.wrapper(menuItem);
                        return menuItem;
                    }),
                    showDivider && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {
                        as: "li",
                        className: slots.divider({
                            class: dividerStyles
                        }),
                        ...dividerProps
                    })
                ]
            })
        ]
    });
});
$5fe8e24ee714bb63$var$MenuSection.displayName = "NextUI.MenuSection";
var $5fe8e24ee714bb63$export$ecc5ceeac6b14b9c = $5fe8e24ee714bb63$var$MenuSection;






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $7babefed2b1b4cdb$export$863faf230ee2118a {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === "section" || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}




var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3536a24847982f96$export$728d6ba534403756(props) {
    let { onExpandedChange: onExpandedChange } = props;
    let [expandedKeys, setExpandedKeys] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), onExpandedChange);
    let selectionState = (0, $d9a874fb3bf4546a$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $fdcbc319f3a11c20$export$6cd28814d92fa9c9)(props, (0, $acw62.useCallback)((nodes)=>new (0, $7babefed2b1b4cdb$export$863faf230ee2118a)(nodes, {
            expandedKeys: expandedKeys
        }), [
        expandedKeys
    ]), null);
    (0, $acw62.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($3536a24847982f96$var$$875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $5c11c5ee2979fbfd$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $3536a24847982f96$var$$875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}




var $acw62 = parcelRequire("acw62");

"use client";
function $85f68dfc9ca004aa$export$38eaa17faae8f579(props) {
    var _a;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const { as: as, ref: ref, variant: variant, color: color, children: children, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, onAction: onAction, closeOnSelect: closeOnSelect, itemClasses: itemClasses, className: className, state: propState, topContent: topContent, bottomContent: bottomContent, hideEmptyContent: hideEmptyContent = false, hideSelectedIcon: hideSelectedIcon = false, emptyContent: emptyContent = "No items.", menuProps: userMenuProps, onClose: onClose, classNames: classNames, ...otherProps } = props;
    const Component = as || "ul";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const shouldFilterDOMProps = typeof Component === "string";
    const innerState = (0, $3536a24847982f96$export$728d6ba534403756)({
        ...otherProps,
        ...userMenuProps,
        children: children
    });
    const state = propState || innerState;
    const { menuProps: menuProps } = (0, $1e7f1177aeecc202$export$38eaa17faae8f579)({
        ...otherProps,
        ...userMenuProps
    }, state, domRef);
    const slots = (0, $acw62.useMemo)(()=>(0, $c8ce6ffc45f51469$export$b1e5508a851be14d)({
            className: className
        }), [
        className
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "base",
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }),
            ...props2
        };
    };
    const getListProps = (props2 = {})=>{
        return {
            "data-slot": "list",
            className: slots.list({
                class: classNames == null ? void 0 : classNames.list
            }),
            ...menuProps,
            ...props2
        };
    };
    const getEmptyContentProps = (props2 = {})=>{
        return {
            children: emptyContent,
            className: slots.emptyContent({
                class: classNames == null ? void 0 : classNames.emptyContent
            }),
            ...props2
        };
    };
    return {
        Component: Component,
        state: state,
        variant: variant,
        color: color,
        disableAnimation: disableAnimation,
        onAction: onAction,
        onClose: onClose,
        topContent: topContent,
        bottomContent: bottomContent,
        closeOnSelect: closeOnSelect,
        className: className,
        itemClasses: itemClasses,
        getBaseProps: getBaseProps,
        getListProps: getListProps,
        hideEmptyContent: hideEmptyContent,
        hideSelectedIcon: hideSelectedIcon,
        getEmptyContentProps: getEmptyContentProps
    };
}




"use client";
function $7eb1e9c41a0e3e7f$var$Menu(props, ref) {
    const { Component: Component, state: state, closeOnSelect: closeOnSelect, color: color, disableAnimation: disableAnimation, hideSelectedIcon: hideSelectedIcon, hideEmptyContent: hideEmptyContent, variant: variant, onClose: onClose, onAction: onAction, topContent: topContent, bottomContent: bottomContent, itemClasses: itemClasses, getBaseProps: getBaseProps, getListProps: getListProps, getEmptyContentProps: getEmptyContentProps } = (0, $85f68dfc9ca004aa$export$38eaa17faae8f579)({
        ...props,
        ref: ref
    });
    const content = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getListProps(),
        children: [
            !state.collection.size && !hideEmptyContent && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("li", {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ...getEmptyContentProps()
                })
            }),
            [
                ...state.collection
            ].map((item)=>{
                const itemProps = {
                    closeOnSelect: closeOnSelect,
                    color: color,
                    disableAnimation: disableAnimation,
                    item: item,
                    state: state,
                    variant: variant,
                    onClose: onClose,
                    onAction: onAction,
                    hideSelectedIcon: hideSelectedIcon,
                    ...item.props
                };
                if (item.type === "section") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5fe8e24ee714bb63$export$ecc5ceeac6b14b9c), {
                    ...itemProps,
                    itemClasses: itemClasses
                }, item.key);
                let menuItem = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6675c4f50a3aea04$export$c023dba2983aab3), {
                    ...itemProps,
                    classNames: itemClasses
                }, item.key);
                if (item.wrapper) menuItem = item.wrapper(menuItem);
                return menuItem;
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getBaseProps(),
        children: [
            topContent,
            content,
            bottomContent
        ]
    });
}
var $7eb1e9c41a0e3e7f$export$9f671b060013e3d0 = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)($7eb1e9c41a0e3e7f$var$Menu);
$7eb1e9c41a0e3e7f$var$Menu.displayName = "NextUI.Menu";



"use client";
function $6aa7e2859a413aac$var$DropdownMenu(props, ref) {
    const { getMenuProps: getMenuProps } = (0, $a2926c5227578d6a$export$28c3a9869c2838c2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $09f067fab22dde0c$export$2a0d18fe44adc4b6), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b27e9acf8b86f3f1$export$20e40289641fbbb6), {
            contain: true,
            restoreFocus: true,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7eb1e9c41a0e3e7f$export$9f671b060013e3d0), {
                ...getMenuProps(props, ref)
            })
        })
    });
}
var $6aa7e2859a413aac$export$a94b2d6670970977 = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)($6aa7e2859a413aac$var$DropdownMenu);
$6aa7e2859a413aac$var$DropdownMenu.displayName = "NextUI.DropdownMenu";





var $acw62 = parcelRequire("acw62");

var $124910caa493e45b$var$__create = Object.create;
var $124910caa493e45b$var$__defProp = Object.defineProperty;
var $124910caa493e45b$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $124910caa493e45b$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $124910caa493e45b$var$__getProtoOf = Object.getPrototypeOf;
var $124910caa493e45b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $124910caa493e45b$export$c98acbe61b4a254a = (cb, mod)=>function __require() {
        return mod || (0, cb[$124910caa493e45b$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $124910caa493e45b$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $124910caa493e45b$var$__getOwnPropNames(from))if (!$124910caa493e45b$var$__hasOwnProp.call(to, key) && key !== except) $124910caa493e45b$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $124910caa493e45b$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $124910caa493e45b$export$82dec27a9dce9602 = (mod, isNodeMode, target)=>(target = mod != null ? $124910caa493e45b$var$__create($124910caa493e45b$var$__getProtoOf(mod)) : {}, $124910caa493e45b$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $124910caa493e45b$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));


// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.production.min.js
var $a3db7ac1de741267$var$require_react_production_min = (0, $124910caa493e45b$export$c98acbe61b4a254a)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.production.min.js" (exports) {
        "use strict";
        var l = Symbol.for("react.element");
        var n = Symbol.for("react.portal");
        var p = Symbol.for("react.fragment");
        var q = Symbol.for("react.strict_mode");
        var r = Symbol.for("react.profiler");
        var t = Symbol.for("react.provider");
        var u = Symbol.for("react.context");
        var v = Symbol.for("react.forward_ref");
        var w = Symbol.for("react.suspense");
        var x = Symbol.for("react.memo");
        var y = Symbol.for("react.lazy");
        var z = Symbol.iterator;
        function A(a) {
            if (null === a || "object" !== typeof a) return null;
            a = z && a[z] || a["@@iterator"];
            return "function" === typeof a ? a : null;
        }
        var B = {
            isMounted: function() {
                return false;
            },
            enqueueForceUpdate: function() {},
            enqueueReplaceState: function() {},
            enqueueSetState: function() {}
        };
        var C = Object.assign;
        var D = {};
        function E(a, b, e) {
            this.props = a;
            this.context = b;
            this.refs = D;
            this.updater = e || B;
        }
        E.prototype.isReactComponent = {};
        E.prototype.setState = function(a, b) {
            if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
            this.updater.enqueueSetState(this, a, b, "setState");
        };
        E.prototype.forceUpdate = function(a) {
            this.updater.enqueueForceUpdate(this, a, "forceUpdate");
        };
        function F() {}
        F.prototype = E.prototype;
        function G(a, b, e) {
            this.props = a;
            this.context = b;
            this.refs = D;
            this.updater = e || B;
        }
        var H = G.prototype = new F();
        H.constructor = G;
        C(H, E.prototype);
        H.isPureReactComponent = true;
        var I = Array.isArray;
        var J = Object.prototype.hasOwnProperty;
        var K = {
            current: null
        };
        var L = {
            key: true,
            ref: true,
            __self: true,
            __source: true
        };
        function M(a, b, e) {
            var d, c = {}, k = null, h = null;
            if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
            var g = arguments.length - 2;
            if (1 === g) c.children = e;
            else if (1 < g) {
                for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
                c.children = f;
            }
            if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
            return {
                $$typeof: l,
                type: a,
                key: k,
                ref: h,
                props: c,
                _owner: K.current
            };
        }
        function N(a, b) {
            return {
                $$typeof: l,
                type: a.type,
                key: b,
                ref: a.ref,
                props: a.props,
                _owner: a._owner
            };
        }
        function O(a) {
            return "object" === typeof a && null !== a && a.$$typeof === l;
        }
        function escape(a) {
            var b = {
                "=": "=0",
                ":": "=2"
            };
            return "$" + a.replace(/[=:]/g, function(a2) {
                return b[a2];
            });
        }
        var P = /\/+/g;
        function Q(a, b) {
            return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
        }
        function R(a, b, e, d, c) {
            var k = typeof a;
            if ("undefined" === k || "boolean" === k) a = null;
            var h = false;
            if (null === a) h = true;
            else switch(k){
                case "string":
                case "number":
                    h = true;
                    break;
                case "object":
                    switch(a.$$typeof){
                        case l:
                        case n:
                            h = true;
                    }
            }
            if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a2) {
                return a2;
            })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
            h = 0;
            d = "" === d ? "." : d + ":";
            if (I(a)) for(var g = 0; g < a.length; g++){
                k = a[g];
                var f = d + Q(k, g);
                h += R(k, b, e, f, c);
            }
            else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
            else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
            return h;
        }
        function S(a, b, e) {
            if (null == a) return a;
            var d = [], c = 0;
            R(a, d, "", "", function(a2) {
                return b.call(e, a2, c++);
            });
            return d;
        }
        function T(a) {
            if (-1 === a._status) {
                var b = a._result;
                b = b();
                b.then(function(b2) {
                    if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
                }, function(b2) {
                    if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
                });
                -1 === a._status && (a._status = 0, a._result = b);
            }
            if (1 === a._status) return a._result.default;
            throw a._result;
        }
        var U = {
            current: null
        };
        var V = {
            transition: null
        };
        var W = {
            ReactCurrentDispatcher: U,
            ReactCurrentBatchConfig: V,
            ReactCurrentOwner: K
        };
        exports.Children = {
            map: S,
            forEach: function(a, b, e) {
                S(a, function() {
                    b.apply(this, arguments);
                }, e);
            },
            count: function(a) {
                var b = 0;
                S(a, function() {
                    b++;
                });
                return b;
            },
            toArray: function(a) {
                return S(a, function(a2) {
                    return a2;
                }) || [];
            },
            only: function(a) {
                if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
                return a;
            }
        };
        exports.Component = E;
        exports.Fragment = p;
        exports.Profiler = r;
        exports.PureComponent = G;
        exports.StrictMode = q;
        exports.Suspense = w;
        exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
        exports.cloneElement = function(a, b, e) {
            if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
            var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
            if (null != b) {
                void 0 !== b.ref && (k = b.ref, h = K.current);
                void 0 !== b.key && (c = "" + b.key);
                if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
                for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
            }
            var f = arguments.length - 2;
            if (1 === f) d.children = e;
            else if (1 < f) {
                g = Array(f);
                for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
                d.children = g;
            }
            return {
                $$typeof: l,
                type: a.type,
                key: c,
                ref: k,
                props: d,
                _owner: h
            };
        };
        exports.createContext = function(a) {
            a = {
                $$typeof: u,
                _currentValue: a,
                _currentValue2: a,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null
            };
            a.Provider = {
                $$typeof: t,
                _context: a
            };
            return a.Consumer = a;
        };
        exports.createElement = M;
        exports.createFactory = function(a) {
            var b = M.bind(null, a);
            b.type = a;
            return b;
        };
        exports.createRef = function() {
            return {
                current: null
            };
        };
        exports.forwardRef = function(a) {
            return {
                $$typeof: v,
                render: a
            };
        };
        exports.isValidElement = O;
        exports.lazy = function(a) {
            return {
                $$typeof: y,
                _payload: {
                    _status: -1,
                    _result: a
                },
                _init: T
            };
        };
        exports.memo = function(a, b) {
            return {
                $$typeof: x,
                type: a,
                compare: void 0 === b ? null : b
            };
        };
        exports.startTransition = function(a) {
            var b = V.transition;
            V.transition = {};
            try {
                a();
            } finally{
                V.transition = b;
            }
        };
        exports.unstable_act = function() {
            throw Error("act(...) is not supported in production builds of React.");
        };
        exports.useCallback = function(a, b) {
            return U.current.useCallback(a, b);
        };
        exports.useContext = function(a) {
            return U.current.useContext(a);
        };
        exports.useDebugValue = function() {};
        exports.useDeferredValue = function(a) {
            return U.current.useDeferredValue(a);
        };
        exports.useEffect = function(a, b) {
            return U.current.useEffect(a, b);
        };
        exports.useId = function() {
            return U.current.useId();
        };
        exports.useImperativeHandle = function(a, b, e) {
            return U.current.useImperativeHandle(a, b, e);
        };
        exports.useInsertionEffect = function(a, b) {
            return U.current.useInsertionEffect(a, b);
        };
        exports.useLayoutEffect = function(a, b) {
            return U.current.useLayoutEffect(a, b);
        };
        exports.useMemo = function(a, b) {
            return U.current.useMemo(a, b);
        };
        exports.useReducer = function(a, b, e) {
            return U.current.useReducer(a, b, e);
        };
        exports.useRef = function(a) {
            return U.current.useRef(a);
        };
        exports.useState = function(a) {
            return U.current.useState(a);
        };
        exports.useSyncExternalStore = function(a, b, e) {
            return U.current.useSyncExternalStore(a, b, e);
        };
        exports.useTransition = function() {
            return U.current.useTransition();
        };
        exports.version = "18.2.0";
    }
});
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.development.js
var $a3db7ac1de741267$var$require_react_development = (0, $124910caa493e45b$export$c98acbe61b4a254a)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.development.js" (exports, module) {
        "use strict";
    }
});
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var $a3db7ac1de741267$export$18dc0e75b6bbb2d3 = (0, $124910caa493e45b$export$c98acbe61b4a254a)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js" (exports, module) {
        "use strict";
        module.exports = $a3db7ac1de741267$var$require_react_production_min();
    }
});
 /**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */  /**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 


// src/children.ts
var $0d07b7a072eaf11b$var$import_react = (0, $124910caa493e45b$export$82dec27a9dce9602)((0, $a3db7ac1de741267$export$18dc0e75b6bbb2d3)());
function $0d07b7a072eaf11b$export$b2c43d7d050b2e63(children) {
    return $0d07b7a072eaf11b$var$import_react.Children.toArray(children).filter((child)=>(0, $0d07b7a072eaf11b$var$import_react.isValidElement)(child));
}
var $0d07b7a072eaf11b$export$7d7d2f98282298f7 = (children, targetChild)=>{
    var _a;
    let target = [];
    const withoutTargetChildren = (_a = $0d07b7a072eaf11b$var$import_react.Children.map(children, (item)=>{
        if (!(0, $0d07b7a072eaf11b$var$import_react.isValidElement)(item)) return item;
        if (item.type === targetChild) {
            target.push(item);
            return null;
        }
        return item;
    })) == null ? void 0 : _a.filter(Boolean);
    const targetChildren = target.length >= 0 ? target : void 0;
    return [
        withoutTargetChildren,
        targetChildren
    ];
};






"use client";
var $1ed69f79ca0040ce$var$PopoverTrigger = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, _)=>{
    const { triggerRef: triggerRef, getTriggerProps: getTriggerProps } = (0, $0a2bfcc234b99477$export$1468d0761b26e6c8)();
    const { children: children, ...otherProps } = props;
    const child = (0, $acw62.useMemo)(()=>{
        if (typeof children === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: children
        });
        return (0, $acw62.Children).only(children);
    }, [
        children
    ]);
    const { onPress: onPress, isDisabled: isDisabled, ...restProps } = (0, $acw62.useMemo)(()=>{
        return getTriggerProps((0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherProps, child.props), child.ref);
    }, [
        getTriggerProps,
        child.props,
        otherProps,
        child.ref
    ]);
    const [, triggerChildren] = (0, $0d07b7a072eaf11b$export$7d7d2f98282298f7)(children, (0, $315c520e7ca388e0$export$11c362adf4e83e40));
    const { buttonProps: buttonProps } = (0, $99a1faa63f87ca63$export$1aff6edc04132adb)({
        onPress: onPress,
        isDisabled: isDisabled
    }, triggerRef);
    const hasNextUIButton = (0, $acw62.useMemo)(()=>{
        return (triggerChildren == null ? void 0 : triggerChildren[0]) !== void 0;
    }, [
        triggerChildren
    ]);
    return (0, $acw62.cloneElement)(child, (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(restProps, hasNextUIButton ? {
        onPress: onPress,
        isDisabled: isDisabled
    } : buttonProps));
});
$1ed69f79ca0040ce$var$PopoverTrigger.displayName = "NextUI.PopoverTrigger";
var $1ed69f79ca0040ce$export$251d96216457b64b = $1ed69f79ca0040ce$var$PopoverTrigger;



"use client";
var $f7a8d7d87317964b$var$DropdownTrigger = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, _)=>{
    const { getMenuTriggerProps: getMenuTriggerProps } = (0, $a2926c5227578d6a$export$28c3a9869c2838c2)();
    const { children: children, ...otherProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1ed69f79ca0040ce$export$251d96216457b64b), {
        ...getMenuTriggerProps(otherProps),
        children: children
    });
});
$f7a8d7d87317964b$var$DropdownTrigger.displayName = "NextUI.DropdownTrigger";
var $f7a8d7d87317964b$export$bf3f08696645e39f = $f7a8d7d87317964b$var$DropdownTrigger;



// src/components/link.ts
var $bd58101a1ee7b798$export$9c30223ca0a664fb = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: [
        "relative inline-flex items-center outline-none tap-highlight-transparent",
        ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
    ],
    variants: {
        size: {
            sm: "text-small",
            md: "text-medium",
            lg: "text-large"
        },
        color: {
            foreground: "text-foreground",
            primary: "text-primary",
            secondary: "text-secondary",
            success: "text-success",
            warning: "text-warning",
            danger: "text-danger"
        },
        underline: {
            none: "no-underline",
            hover: "hover:underline",
            always: "underline",
            active: "active:underline",
            focus: "focus:underline"
        },
        isBlock: {
            true: [
                "px-2",
                "py-1",
                "hover:after:opacity-100",
                "after:content-['']",
                "after:inset-0",
                "after:opacity-0",
                "after:w-full",
                "after:h-full",
                "after:rounded-xl",
                "after:transition-background",
                "after:absolute"
            ],
            false: "hover:opacity-80 active:opacity-disabled transition-opacity"
        },
        isDisabled: {
            true: "opacity-disabled cursor-default pointer-events-none"
        },
        disableAnimation: {
            true: "after:transition-none transition-none"
        }
    },
    compoundVariants: [
        {
            isBlock: true,
            color: "foreground",
            class: "hover:after:bg-foreground/10"
        },
        {
            isBlock: true,
            color: "primary",
            class: "hover:after:bg-primary/20"
        },
        {
            isBlock: true,
            color: "secondary",
            class: "hover:after:bg-secondary/20"
        },
        {
            isBlock: true,
            color: "success",
            class: "hover:after:bg-success/20"
        },
        {
            isBlock: true,
            color: "warning",
            class: "hover:after:bg-warning/20"
        },
        {
            isBlock: true,
            color: "danger",
            class: "hover:after:bg-danger/20"
        },
        {
            underline: [
                "hover",
                "always",
                "active",
                "focus"
            ],
            class: "underline-offset-4"
        }
    ],
    defaultVariants: {
        color: "primary",
        size: "md",
        isBlock: false,
        underline: "none",
        isDisabled: false
    }
});
var $bd58101a1ee7b798$export$1d42287988367e45 = "flex mx-1 text-current self-center";





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d872ae96ead1c131$export$dcf14c9974fe2767(props, ref) {
    let { elementType: elementType = "a", onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onClick: deprecatedOnClick, isDisabled: isDisabled, ...otherProps } = props;
    let linkProps = {};
    if (elementType !== "a") linkProps = {
        role: "link",
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps: focusableProps } = (0, $4513518cfd051728$export$4c014de7c8940b4c)(props, ref);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled,
        ref: ref
    });
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(otherProps, {
        labelable: true
    });
    let interactionHandlers = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusableProps, pressProps);
    let router = (0, $4a4107ecda93bad9$export$9a302a45f65d0572)();
    let routerLinkProps = (0, $4a4107ecda93bad9$export$7e924b3091a3bd18)(props);
    return {
        isPressed: isPressed,
        linkProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, routerLinkProps, {
            ...interactionHandlers,
            ...linkProps,
            "aria-disabled": isDisabled || undefined,
            "aria-current": props["aria-current"],
            onClick: (e)=>{
                var _pressProps_onClick;
                (_pressProps_onClick = pressProps.onClick) === null || _pressProps_onClick === void 0 || _pressProps_onClick.call(pressProps, e);
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
                // If a custom router is provided, prevent default and forward if this link should client navigate.
                if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
                !e.isDefaultPrevented() && (0, $4a4107ecda93bad9$export$efa8c9099e530235)(e.currentTarget, e) && props.href) {
                    e.preventDefault();
                    router.open(e.currentTarget, e, props.href, props.routerOptions);
                }
            }
        })
    };
}







var $acw62 = parcelRequire("acw62");

"use client";
function $670a162938763df1$export$dcf14c9974fe2767(originalProps) {
    var _a, _b, _c, _d;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $bd58101a1ee7b798$export$9c30223ca0a664fb).variantKeys);
    const { ref: ref, as: as, children: children, anchorIcon: anchorIcon, isExternal: isExternal = false, showAnchorIcon: showAnchorIcon = false, autoFocus: autoFocus = false, className: className, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onClick: onClick, ...otherProps } = props;
    const Component = as || "a";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const disableAnimation = (_b = (_a = originalProps == null ? void 0 : originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const { linkProps: linkProps } = (0, $d872ae96ead1c131$export$dcf14c9974fe2767)({
        ...otherProps,
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onClick: onClick,
        isDisabled: originalProps.isDisabled,
        elementType: `${as}`
    }, domRef);
    const { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    if (isExternal) {
        otherProps.rel = (_c = otherProps.rel) != null ? _c : "noopener noreferrer";
        otherProps.target = (_d = otherProps.target) != null ? _d : "_blank";
    }
    const classNames = (0, $acw62.useMemo)(()=>(0, $bd58101a1ee7b798$export$9c30223ca0a664fb)({
            ...variantProps,
            disableAnimation: disableAnimation,
            className: className
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        disableAnimation,
        className
    ]);
    const getLinkProps = (0, $acw62.useCallback)(()=>{
        return {
            ref: domRef,
            className: classNames,
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps.isDisabled),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(focusProps, linkProps, otherProps)
        };
    }, [
        classNames,
        isFocused,
        isFocusVisible,
        focusProps,
        linkProps,
        otherProps
    ]);
    return {
        Component: Component,
        children: children,
        anchorIcon: anchorIcon,
        showAnchorIcon: showAnchorIcon,
        getLinkProps: getLinkProps
    };
}



// src/link.tsx

var $03b8b6f11c0b7cfc$export$69387b41dfc808f7 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        shapeRendering: "geometricPrecision",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 3h6v6"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 14L21 3"
            })
        ]
    });




"use client";
var $44255bd742036c59$var$Link = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, showAnchorIcon: showAnchorIcon, anchorIcon: anchorIcon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03b8b6f11c0b7cfc$export$69387b41dfc808f7), {
        className: (0, $bd58101a1ee7b798$export$1d42287988367e45)
    }), getLinkProps: getLinkProps } = (0, $670a162938763df1$export$dcf14c9974fe2767)({
        ref: ref,
        ...props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...getLinkProps(),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                children,
                showAnchorIcon && anchorIcon
            ]
        })
    });
});
$44255bd742036c59$var$Link.displayName = "NextUI.Link";
var $44255bd742036c59$export$2e315dfe55958408 = $44255bd742036c59$var$Link;

// src/index.ts

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d166469f98491f58$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $1997bf66abd8bf2b$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $1997bf66abd8bf2b$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
const $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
let $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$restore;
function $e07cc1b171a9b1c8$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $b82880ba168cba95$export$fedb369cb70207f1)()) $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$restore = $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$restore = $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    return (0, $276a22df76563a4a$export$e08e3b67e392101e)($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let restoreScrollableStyles;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $d166469f98491f58$export$cfa2225e87938781)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === "auto") restoreScrollableStyles = $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(scrollable, "overscrollBehavior", "contain");
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            setupStyles();
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let restoreStyles = null;
    let setupStyles = ()=>{
        if (restoreStyles) return;
        let onWindowScroll = ()=>{
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        let scrollX = window.pageXOffset;
        let scrollY = window.pageYOffset;
        restoreStyles = (0, $276a22df76563a4a$export$e08e3b67e392101e)($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`), ()=>{
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    let removeEvents = (0, $276a22df76563a4a$export$e08e3b67e392101e)($e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 || restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 || restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $d166469f98491f58$export$cfa2225e87938781)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$e07cc1b171a9b1c8$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}




var $acw62 = parcelRequire("acw62");
function $743495d152f4bb43$export$91cad3fe1a80aa25(props = {
    shouldBlockScroll: true
}, state, ref) {
    let { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $620bda56c550bc2a$export$ea8f71083e90600f)({
        ...props,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    (0, $e07cc1b171a9b1c8$export$ee0f7cc6afcd1c18)({
        isDisabled: !state.isOpen || !props.shouldBlockScroll
    });
    (0, $8b039484d708a25a$export$14c98a7594375490)();
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && ref.current) return (0, $e91a11878652e278$export$1c3ebcada18427bf)([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(overlayProps),
        underlayProps: underlayProps
    };
}



var $acw62 = parcelRequire("acw62");


// src/components/modal.ts
var $a19df6728338e215$export$96e4b36520c26a2c = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        wrapper: [
            "flex",
            "w-screen",
            "h-[100dvh]",
            "fixed",
            "inset-0",
            "z-50",
            "overflow-x-auto",
            "justify-center"
        ],
        base: [
            "flex",
            "flex-col",
            "relative",
            "bg-white",
            "z-50",
            "w-full",
            "box-border",
            "bg-content1",
            "outline-none",
            "mx-1",
            "my-1",
            "sm:mx-6",
            "sm:my-16"
        ],
        backdrop: "z-50",
        header: "flex py-4 px-6 flex-initial text-large font-semibold",
        body: "flex flex-1 flex-col gap-3 px-6 py-2",
        footer: "flex flex-row gap-2 px-6 py-4 justify-end",
        closeButton: [
            "absolute",
            "appearance-none",
            "outline-none",
            "select-none",
            "top-1",
            "right-1",
            "rtl:left-1",
            "rtl:right-[unset]",
            "p-2",
            "text-foreground-500",
            "rounded-full",
            "hover:bg-default-100",
            "active:bg-default-200",
            "tap-highlight-transparent",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ]
    },
    variants: {
        size: {
            xs: {
                base: "max-w-xs"
            },
            sm: {
                base: "max-w-sm"
            },
            md: {
                base: "max-w-md"
            },
            lg: {
                base: "max-w-lg"
            },
            xl: {
                base: "max-w-xl"
            },
            "2xl": {
                base: "max-w-2xl"
            },
            "3xl": {
                base: "max-w-3xl"
            },
            "4xl": {
                base: "max-w-4xl"
            },
            "5xl": {
                base: "max-w-5xl"
            },
            full: {
                base: "my-0 mx-0 sm:mx-0 sm:my-0 max-w-full h-[100dvh] !rounded-none"
            }
        },
        radius: {
            none: {
                base: "rounded-none"
            },
            sm: {
                base: "rounded-small"
            },
            md: {
                base: "rounded-medium"
            },
            lg: {
                base: "rounded-large"
            }
        },
        placement: {
            auto: {
                wrapper: "items-end sm:items-center"
            },
            center: {
                wrapper: "items-center sm:items-center"
            },
            top: {
                wrapper: "items-start sm:items-start"
            },
            "top-center": {
                wrapper: "items-start sm:items-center"
            },
            bottom: {
                wrapper: "items-end sm:items-end"
            },
            "bottom-center": {
                wrapper: "items-end sm:items-center"
            }
        },
        shadow: {
            sm: {
                base: "shadow-small"
            },
            md: {
                base: "shadow-medium"
            },
            lg: {
                base: "shadow-large"
            }
        },
        backdrop: {
            transparent: {
                backdrop: "hidden"
            },
            opaque: {
                backdrop: "bg-overlay/50 backdrop-opacity-disabled"
            },
            blur: {
                backdrop: "backdrop-blur-md backdrop-saturate-150 bg-overlay/30"
            }
        },
        scrollBehavior: {
            normal: {
                base: "overflow-y-hidden"
            },
            inside: {
                base: "max-h-[calc(100%_-_8rem)]",
                body: "overflow-y-auto"
            },
            outside: {
                wrapper: "items-start sm:items-start overflow-y-auto",
                base: "my-16"
            }
        },
        disableAnimation: {
            false: {
                wrapper: [
                    "[--scale-enter:100%]",
                    "[--scale-exit:100%]",
                    "[--slide-enter:0px]",
                    "[--slide-exit:80px]",
                    "sm:[--scale-enter:100%]",
                    "sm:[--scale-exit:103%]",
                    "sm:[--slide-enter:0px]",
                    "sm:[--slide-exit:0px]"
                ]
            }
        }
    },
    defaultVariants: {
        size: "md",
        radius: "lg",
        shadow: "sm",
        placement: "auto",
        backdrop: "opaque",
        scrollBehavior: "normal"
    },
    compoundVariants: [
        {
            backdrop: [
                "opaque",
                "blur"
            ],
            class: {
                backdrop: "w-screen h-screen fixed inset-0"
            }
        }
    ]
});









"use client";
function $f1ced9ffdf7c21f2$export$33ffd74ebf07f060(originalProps) {
    var _a, _b, _c;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $a19df6728338e215$export$96e4b36520c26a2c).variantKeys);
    const { ref: ref, as: as, className: className, classNames: classNames, isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange, motionProps: motionProps, closeButton: closeButton, isDismissable: isDismissable = true, hideCloseButton: hideCloseButton = false, shouldBlockScroll: shouldBlockScroll = true, portalContainer: portalContainer, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, onClose: onClose, ...otherProps } = props;
    const Component = as || "section";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const closeButtonRef = (0, $acw62.useRef)(null);
    const [headerMounted, setHeaderMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const dialogId = (0, $acw62.useId)();
    const headerId = (0, $acw62.useId)();
    const bodyId = (0, $acw62.useId)();
    const state = (0, $13a9827b1c7dcaf2$export$61c6a8c84e605fb6)({
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: (isOpen2)=>{
            onOpenChange == null || onOpenChange(isOpen2);
            if (!isOpen2) onClose == null || onClose();
        }
    });
    const { modalProps: modalProps, underlayProps: underlayProps } = (0, $743495d152f4bb43$export$91cad3fe1a80aa25)({
        isDismissable: isDismissable,
        shouldBlockScroll: shouldBlockScroll,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, state, domRef);
    const { buttonProps: closeButtonProps } = (0, $99a1faa63f87ca63$export$1aff6edc04132adb)({
        onPress: state.close
    }, closeButtonRef);
    const { isFocusVisible: isCloseButtonFocusVisible, focusProps: closeButtonFocusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const slots = (0, $acw62.useMemo)(()=>(0, $a19df6728338e215$export$96e4b36520c26a2c)({
            ...variantProps,
            disableAnimation: disableAnimation
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        disableAnimation
    ]);
    const getDialogProps = (props2 = {}, ref2 = null)=>({
            ref: (0, $6bef5c6274cc261b$export$c9058316764c140e)(ref2, domRef),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(modalProps, otherProps, props2),
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2.className)
            }),
            id: dialogId,
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            "data-dismissable": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDismissable),
            "aria-modal": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            "aria-labelledby": headerMounted ? headerId : void 0,
            "aria-describedby": bodyMounted ? bodyId : void 0
        });
    const getBackdropProps = (0, $acw62.useCallback)((props2 = {})=>({
            className: slots.backdrop({
                class: classNames == null ? void 0 : classNames.backdrop
            }),
            onClick: ()=>state.close(),
            ...underlayProps,
            ...props2
        }), [
        slots,
        classNames,
        underlayProps
    ]);
    const getCloseButtonProps = ()=>{
        return {
            role: "button",
            tabIndex: 0,
            "aria-label": "Close",
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isCloseButtonFocusVisible),
            className: slots.closeButton({
                class: classNames == null ? void 0 : classNames.closeButton
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(closeButtonProps, closeButtonFocusProps)
        };
    };
    return {
        Component: Component,
        slots: slots,
        domRef: domRef,
        headerId: headerId,
        bodyId: bodyId,
        motionProps: motionProps,
        classNames: classNames,
        isDismissable: isDismissable,
        closeButton: closeButton,
        hideCloseButton: hideCloseButton,
        portalContainer: portalContainer,
        shouldBlockScroll: shouldBlockScroll,
        backdrop: (_c = originalProps.backdrop) != null ? _c : "opaque",
        isOpen: state.isOpen,
        onClose: state.close,
        disableAnimation: disableAnimation,
        setBodyMounted: setBodyMounted,
        setHeaderMounted: setHeaderMounted,
        getDialogProps: getDialogProps,
        getBackdropProps: getBackdropProps,
        getCloseButtonProps: getCloseButtonProps
    };
}



"use client";
var [$0b011997ccc1d37a$export$178405afcd8c5eb, $0b011997ccc1d37a$export$4cc1699d46f42cae] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Modal />`"
});






"use client";
var $f48272b62179a444$var$Modal = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, ...otherProps } = props;
    const context = (0, $f1ced9ffdf7c21f2$export$33ffd74ebf07f060)({
        ...otherProps,
        ref: ref
    });
    const overlay = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8b039484d708a25a$export$c6fdb837b070b4ff), {
        portalContainer: context.portalContainer,
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0b011997ccc1d37a$export$178405afcd8c5eb), {
        value: context,
        children: context.disableAnimation && context.isOpen ? overlay : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
            children: context.isOpen ? overlay : null
        })
    });
});
$f48272b62179a444$var$Modal.displayName = "NextUI.Modal";
var $f48272b62179a444$export$194c5e3f782179f4 = $f48272b62179a444$var$Modal;



var $acw62 = parcelRequire("acw62");




"use client";
var $63b3cab10eaf2f6b$var$ModalBody = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { as: as, children: children, className: className, ...otherProps } = props;
    const { slots: slots, classNames: classNames, bodyId: bodyId, setBodyMounted: setBodyMounted } = (0, $0b011997ccc1d37a$export$4cc1699d46f42cae)();
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const Component = as || "div";
    (0, $acw62.useEffect)(()=>{
        setBodyMounted(true);
        return ()=>setBodyMounted(false);
    }, [
        setBodyMounted
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: slots.body({
            class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.body, className)
        }),
        id: bodyId,
        ...otherProps,
        children: children
    });
});
$63b3cab10eaf2f6b$var$ModalBody.displayName = "NextUI.ModalBody";
var $63b3cab10eaf2f6b$export$186c5a93653b521c = $63b3cab10eaf2f6b$var$ModalBody;


"use client";
var $4716298f1d3805b2$export$ae78d338ad66ff90 = {
    enter: {
        scale: "var(--scale-enter)",
        y: "var(--slide-enter)",
        opacity: 1,
        transition: {
            scale: {
                duration: 0.4,
                ease: (0, $0541ef573799255c$export$9ee1d08bb6db426f).ease
            },
            opacity: {
                duration: 0.4,
                ease: (0, $0541ef573799255c$export$9ee1d08bb6db426f).ease
            },
            y: {
                type: "spring",
                bounce: 0,
                duration: 0.6
            }
        }
    },
    exit: {
        scale: "var(--scale-exit)",
        y: "var(--slide-exit)",
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: (0, $0541ef573799255c$export$9ee1d08bb6db426f).ease
        }
    }
};




var $acw62 = parcelRequire("acw62");








"use client";
var $90430c3f5844fbf9$var$ModalContent = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, _)=>{
    const { as: as, children: children, role: role = "dialog", ...otherProps } = props;
    const { Component: DialogComponent, domRef: domRef, slots: slots, classNames: classNames, motionProps: motionProps, backdrop: backdrop, closeButton: closeButton, hideCloseButton: hideCloseButton, disableAnimation: disableAnimation, getDialogProps: getDialogProps, getBackdropProps: getBackdropProps, getCloseButtonProps: getCloseButtonProps, onClose: onClose } = (0, $0b011997ccc1d37a$export$4cc1699d46f42cae)();
    const Component = as || DialogComponent || "div";
    const { dialogProps: dialogProps } = (0, $3fee594f3ffdb6a2$export$d55e7ee900f34e93)({
        role: role
    }, domRef);
    const closeButtonContent = (0, $acw62.isValidElement)(closeButton) ? (0, $acw62.cloneElement)(closeButton, getCloseButtonProps()) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
        ...getCloseButtonProps(),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a106e18a12a75ce7$export$cae179f078f4b4a4), {})
    });
    const onKeyDown = (0, $acw62.useCallback)((e)=>{
        if (e.key === "Tab" && e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, []);
    const contentProps = getDialogProps((0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(dialogProps, otherProps));
    const content = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...contentProps,
        onKeyDown: (0, $276a22df76563a4a$export$e08e3b67e392101e)(contentProps.onKeyDown, onKeyDown),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ffab0043461eda28$export$2317d149ed6f78c4), {
                onDismiss: onClose
            }),
            !hideCloseButton && closeButtonContent,
            typeof children === "function" ? children(onClose) : children,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ffab0043461eda28$export$2317d149ed6f78c4), {
                onDismiss: onClose
            })
        ]
    });
    const backdropContent = (0, $acw62.useMemo)(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
            features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $0541ef573799255c$export$55b7325ba41bb523).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    const contents = disableAnimation ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: slots.wrapper({
            class: classNames == null ? void 0 : classNames.wrapper
        }),
        "data-slot": "wrapper",
        children: content
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
        features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).div, {
            animate: "enter",
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            }),
            "data-slot": "wrapper",
            exit: "exit",
            initial: "exit",
            variants: (0, $4716298f1d3805b2$export$ae78d338ad66ff90),
            ...motionProps,
            children: content
        })
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        tabIndex: -1,
        children: [
            backdropContent,
            contents
        ]
    });
});
$90430c3f5844fbf9$var$ModalContent.displayName = "NextUI.ModalContent";
var $90430c3f5844fbf9$export$e7e965ff0372e8c = $90430c3f5844fbf9$var$ModalContent;






"use client";
var $494d13c4d83d8955$var$ModalFooter = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { as: as, children: children, className: className, ...otherProps } = props;
    const { slots: slots, classNames: classNames } = (0, $0b011997ccc1d37a$export$4cc1699d46f42cae)();
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const Component = as || "footer";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: slots.footer({
            class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.footer, className)
        }),
        ...otherProps,
        children: children
    });
});
$494d13c4d83d8955$var$ModalFooter.displayName = "NextUI.ModalFooter";
var $494d13c4d83d8955$export$69511fbe09cd360b = $494d13c4d83d8955$var$ModalFooter;



var $acw62 = parcelRequire("acw62");




"use client";
var $31c5bb588189e544$var$ModalHeader = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { as: as, children: children, className: className, ...otherProps } = props;
    const { slots: slots, classNames: classNames, headerId: headerId, setHeaderMounted: setHeaderMounted } = (0, $0b011997ccc1d37a$export$4cc1699d46f42cae)();
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const Component = as || "header";
    (0, $acw62.useEffect)(()=>{
        setHeaderMounted(true);
        return ()=>setHeaderMounted(false);
    }, [
        setHeaderMounted
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: slots.header({
            class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.header, className)
        }),
        id: headerId,
        ...otherProps,
        children: children
    });
});
$31c5bb588189e544$var$ModalHeader.displayName = "NextUI.ModalHeader";
var $31c5bb588189e544$export$3b7be5d1e99a7c62 = $31c5bb588189e544$var$ModalHeader;


"use client";
var [$0f1ba4ea06c652b1$export$12036bdca8898f9b, $0f1ba4ea06c652b1$export$d1a1b51809dfb828] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "NavbarContext",
    strict: true,
    errorMessage: "useNavbarContext: `context` is undefined. Seems you forgot to wrap component within <Navbar />"
});


"use client";
// src/navbar-menu-transitions.ts
var $4baa3b7f23067c97$export$42f3652a3b58dbd7 = {
    enter: {
        height: "calc(100vh - var(--navbar-height))",
        transition: {
            duration: 0.3,
            easings: "easeOut"
        }
    },
    exit: {
        height: 0,
        transition: {
            duration: 0.25,
            easings: "easeIn"
        }
    }
};








var $acw62 = parcelRequire("acw62");



"use client";
var $2046913fa19b64a8$var$NavbarMenu = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const { className: className, children: children, portalContainer: portalContainer, motionProps: motionProps, style: style, ...otherProps } = props;
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, isMenuOpen: isMenuOpen, height: height, disableAnimation: disableAnimation, classNames: classNames } = (0, $0f1ba4ea06c652b1$export$d1a1b51809dfb828)();
    const styles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.menu, className);
    const MenuWrapper = (0, $acw62.useCallback)(({ children: children2 })=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
            forwardProps: true,
            enabled: isMenuOpen,
            removeScrollBar: false,
            children: children2
        });
    }, [
        isMenuOpen
    ]);
    const contents = disableAnimation ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(MenuWrapper, {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("ul", {
            ref: domRef,
            className: (_a = slots.menu) == null ? void 0 : _a.call(slots, {
                class: styles
            }),
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMenuOpen),
            style: {
                "--navbar-height": height
            },
            ...otherProps,
            children: children
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        mode: "wait",
        children: isMenuOpen ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
            features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(MenuWrapper, {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).ul, {
                    ref: domRef,
                    layoutScroll: true,
                    animate: "enter",
                    className: (_b = slots.menu) == null ? void 0 : _b.call(slots, {
                        class: styles
                    }),
                    "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMenuOpen),
                    exit: "exit",
                    initial: "exit",
                    style: {
                        "--navbar-height": height,
                        ...style
                    },
                    variants: (0, $4baa3b7f23067c97$export$42f3652a3b58dbd7),
                    ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(motionProps, otherProps),
                    children: children
                })
            })
        }) : null
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8b039484d708a25a$export$c6fdb837b070b4ff), {
        portalContainer: portalContainer,
        children: contents
    });
});
$2046913fa19b64a8$var$NavbarMenu.displayName = "NextUI.NavbarMenu";
var $2046913fa19b64a8$export$216a181a5d412ca8 = $2046913fa19b64a8$var$NavbarMenu;



"use client";
var $bf283ba0c75f473e$export$200919b48579ab61 = {
    visible: {
        y: 0,
        transition: {
            ease: (0, $0541ef573799255c$export$9ee1d08bb6db426f).easeOut
        }
    },
    hidden: {
        y: "-100%",
        transition: {
            ease: (0, $0541ef573799255c$export$9ee1d08bb6db426f).easeIn
        }
    }
};





// src/components/navbar.ts
var $082428aa9e8335a1$export$58733aaf927c3bbe = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "z-40",
            "w-full",
            "h-auto",
            "items-center",
            "justify-center",
            "data-[menu-open=true]:border-none"
        ],
        wrapper: [
            "z-40",
            "flex",
            "px-6",
            "gap-4",
            "w-full",
            "flex-row",
            "relative",
            "flex-nowrap",
            "items-center",
            "justify-between",
            "h-[var(--navbar-height)]"
        ],
        toggle: [
            "group",
            "flex",
            "items-center",
            "justify-center",
            "w-6",
            "h-full",
            "outline-none",
            "rounded-small",
            "tap-highlight-transparent",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        srOnly: [
            "sr-only"
        ],
        toggleIcon: [
            "w-full",
            "h-full",
            "pointer-events-none",
            "flex",
            "flex-col",
            "items-center",
            "justify-center",
            "text-inherit",
            "group-data-[pressed=true]:opacity-70",
            "transition-opacity",
            "before:content-['']",
            "before:block",
            "before:h-px",
            "before:w-6",
            "before:bg-current",
            "before:transition-transform",
            "before:duration-150",
            "before:-translate-y-1",
            "before:rotate-0",
            "group-data-[open=true]:before:translate-y-px",
            "group-data-[open=true]:before:rotate-45",
            "after:content-['']",
            "after:block",
            "after:h-px",
            "after:w-6",
            "after:bg-current",
            "after:transition-transform",
            "after:duration-150",
            "after:translate-y-1",
            "after:rotate-0",
            "group-data-[open=true]:after:translate-y-0",
            "group-data-[open=true]:after:-rotate-45"
        ],
        brand: [
            "flex",
            "basis-0",
            "flex-row",
            "flex-grow",
            "flex-nowrap",
            "justify-start",
            "bg-transparent",
            "items-center",
            "no-underline",
            "text-medium",
            "whitespace-nowrap",
            "box-border"
        ],
        content: [
            "flex",
            "gap-4",
            "h-full",
            "flex-row",
            "flex-nowrap",
            "items-center",
            "data-[justify=start]:justify-start",
            "data-[justify=start]:flex-grow",
            "data-[justify=start]:basis-0",
            "data-[justify=center]:justify-center",
            "data-[justify=end]:justify-end",
            "data-[justify=end]:flex-grow",
            "data-[justify=end]:basis-0"
        ],
        item: [
            "text-medium",
            "whitespace-nowrap",
            "box-border",
            "list-none",
            "data-[active=true]:font-semibold"
        ],
        menu: [
            "z-30",
            "px-6",
            "pt-2",
            "fixed",
            "flex",
            "max-w-full",
            "top-[var(--navbar-height)]",
            "inset-x-0",
            "bottom-0",
            "w-screen",
            "flex-col",
            "gap-2",
            "overflow-y-auto"
        ],
        menuItem: [
            "text-large",
            "data-[active=true]:font-semibold"
        ]
    },
    variants: {
        position: {
            static: {
                base: "static"
            },
            sticky: {
                base: "sticky top-0 inset-x-0"
            }
        },
        maxWidth: {
            sm: {
                wrapper: "max-w-[640px]"
            },
            md: {
                wrapper: "max-w-[768px]"
            },
            lg: {
                wrapper: "max-w-[1024px]"
            },
            xl: {
                wrapper: "max-w-[1280px]"
            },
            "2xl": {
                wrapper: "max-w-[1536px]"
            },
            full: {
                wrapper: "max-w-full"
            }
        },
        hideOnScroll: {
            true: {
                base: [
                    "sticky",
                    "top-0",
                    "inset-x-0"
                ]
            }
        },
        isBordered: {
            true: {
                base: [
                    "border-b",
                    "border-divider"
                ]
            }
        },
        isBlurred: {
            false: {
                base: "bg-background",
                menu: "bg-background"
            },
            true: {
                base: [
                    "backdrop-blur-lg",
                    "data-[menu-open=true]:backdrop-blur-xl",
                    "backdrop-saturate-150",
                    "bg-background/70"
                ],
                menu: [
                    "backdrop-blur-xl",
                    "backdrop-saturate-150",
                    "bg-background/70"
                ]
            }
        },
        disableAnimation: {
            true: {
                menu: [
                    "hidden",
                    "h-[calc(100dvh_-_var(--navbar-height))]",
                    "data-[open=true]:flex"
                ]
            }
        }
    },
    defaultVariants: {
        maxWidth: "lg",
        position: "sticky",
        isBlurred: true
    }
});





var $acw62 = parcelRequire("acw62");

// src/index.ts

var $acw62 = parcelRequire("acw62");
var $7a3a614819b32025$var$isBrowser = typeof window !== "undefined";
function $7a3a614819b32025$var$getScrollPosition(element) {
    if (!$7a3a614819b32025$var$isBrowser) return {
        x: 0,
        y: 0
    };
    if (!element) return {
        x: window.scrollX,
        y: window.scrollY
    };
    return {
        x: element.scrollLeft,
        y: element.scrollTop
    };
}
var $7a3a614819b32025$export$39656943dfb35acc = (props)=>{
    const { elementRef: elementRef, delay: delay = 30, callback: callback, isEnabled: isEnabled } = props;
    const position = (0, $acw62.useRef)(isEnabled ? $7a3a614819b32025$var$getScrollPosition(elementRef == null ? void 0 : elementRef.current) : {
        x: 0,
        y: 0
    });
    const throttleTimeout = (0, $acw62.useRef)(null);
    const handler = (0, $acw62.useCallback)(()=>{
        const currPos = $7a3a614819b32025$var$getScrollPosition(elementRef == null ? void 0 : elementRef.current);
        if (typeof callback === "function") callback({
            prevPos: position.current,
            currPos: currPos
        });
        position.current = currPos;
        throttleTimeout.current = null;
    }, [
        callback,
        elementRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isEnabled) return;
        const handleScroll = ()=>{
            if (delay) {
                if (throttleTimeout.current) clearTimeout(throttleTimeout.current);
                throttleTimeout.current = setTimeout(handler, delay);
            } else handler();
        };
        const target = (elementRef == null ? void 0 : elementRef.current) || window;
        target.addEventListener("scroll", handleScroll);
        return ()=>{
            target.removeEventListener("scroll", handleScroll);
            if (throttleTimeout.current) clearTimeout(throttleTimeout.current);
        };
    }, [
        elementRef == null ? void 0 : elementRef.current,
        delay,
        handler,
        isEnabled
    ]);
    return position.current;
};



"use client";
function $01e40ca2b33a8286$export$5cb68f1f5b941aeb(originalProps) {
    var _a, _b;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $082428aa9e8335a1$export$58733aaf927c3bbe).variantKeys);
    const { ref: ref, as: as, parentRef: parentRef, height: height = "4rem", shouldHideOnScroll: shouldHideOnScroll = false, disableScrollHandler: disableScrollHandler = false, onScrollPositionChange: onScrollPositionChange, isMenuOpen: isMenuOpenProp, isMenuDefaultOpen: isMenuDefaultOpen, onMenuOpenChange: onMenuOpenChange = ()=>{}, motionProps: motionProps, className: className, classNames: classNames, ...otherProps } = props;
    const Component = as || "nav";
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const prevWidth = (0, $acw62.useRef)(0);
    const navHeight = (0, $acw62.useRef)(0);
    const [isHidden, setIsHidden] = (0, $acw62.useState)(false);
    const handleMenuOpenChange = (0, $acw62.useCallback)((isOpen)=>{
        onMenuOpenChange(isOpen || false);
    }, [
        onMenuOpenChange
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(isMenuOpenProp, isMenuDefaultOpen != null ? isMenuDefaultOpen : false, handleMenuOpenChange);
    const updateWidth = ()=>{
        if (domRef.current) {
            const width = domRef.current.offsetWidth;
            if (width !== prevWidth.current) prevWidth.current = width;
        }
    };
    (0, $99c8f022f7b6624e$export$683480f191c0e3ea)({
        ref: domRef,
        onResize: ()=>{
            var _a2;
            const currentWidth = (_a2 = domRef.current) == null ? void 0 : _a2.offsetWidth;
            if (currentWidth !== prevWidth.current) {
                updateWidth();
                setIsMenuOpen(false);
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        var _a2;
        updateWidth();
        navHeight.current = ((_a2 = domRef.current) == null ? void 0 : _a2.offsetHeight) || 0;
    }, []);
    const slots = (0, $acw62.useMemo)(()=>(0, $082428aa9e8335a1$export$58733aaf927c3bbe)({
            ...variantProps,
            disableAnimation: disableAnimation,
            hideOnScroll: shouldHideOnScroll
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        disableAnimation,
        shouldHideOnScroll
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    (0, $7a3a614819b32025$export$39656943dfb35acc)({
        elementRef: parentRef,
        isEnabled: shouldHideOnScroll || !disableScrollHandler,
        callback: ({ prevPos: prevPos, currPos: currPos })=>{
            onScrollPositionChange == null || onScrollPositionChange(currPos.y);
            if (shouldHideOnScroll) setIsHidden((prev)=>{
                const next = currPos.y > prevPos.y && currPos.y > navHeight.current;
                return next !== prev ? next : prev;
            });
        }
    });
    const getBaseProps = (props2 = {})=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherProps, props2),
            "data-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHidden),
            "data-menu-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMenuOpen),
            ref: domRef,
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2 == null ? void 0 : props2.className)
            }),
            style: {
                "--navbar-height": height,
                ...otherProps == null ? void 0 : otherProps.style,
                ...props2 == null ? void 0 : props2.style
            }
        });
    const getWrapperProps = (props2 = {})=>({
            ...props2,
            "data-menu-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMenuOpen),
            className: slots.wrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            })
        });
    return {
        Component: Component,
        slots: slots,
        domRef: domRef,
        height: height,
        isHidden: isHidden,
        disableAnimation: disableAnimation,
        shouldHideOnScroll: shouldHideOnScroll,
        isMenuOpen: isMenuOpen,
        classNames: classNames,
        setIsMenuOpen: setIsMenuOpen,
        motionProps: motionProps,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps
    };
}








"use client";
var $c5922bdefe6d2742$var$Navbar = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, ...otherProps } = props;
    const context = (0, $01e40ca2b33a8286$export$5cb68f1f5b941aeb)({
        ...otherProps,
        ref: ref
    });
    const Component = context.Component;
    const [childrenWithoutMenu, menu] = (0, $0d07b7a072eaf11b$export$7d7d2f98282298f7)(children, (0, $2046913fa19b64a8$export$216a181a5d412ca8));
    const content = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("header", {
                ...context.getWrapperProps(),
                children: childrenWithoutMenu
            }),
            menu
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0f1ba4ea06c652b1$export$12036bdca8898f9b), {
        value: context,
        children: context.shouldHideOnScroll ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
            features: (0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).nav, {
                animate: context.isHidden ? "hidden" : "visible",
                initial: false,
                variants: (0, $bf283ba0c75f473e$export$200919b48579ab61),
                ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(context.getBaseProps(), context.motionProps),
                children: content
            })
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...context.getBaseProps(),
            children: content
        })
    });
});
$c5922bdefe6d2742$var$Navbar.displayName = "NextUI.Navbar";
var $c5922bdefe6d2742$export$bcc2fdface6e45cf = $c5922bdefe6d2742$var$Navbar;






"use client";
var $5e63a7198df7a736$var$NavbarBrand = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $0f1ba4ea06c652b1$export$d1a1b51809dfb828)();
    const styles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.brand, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.brand) == null ? void 0 : _a.call(slots, {
            class: styles
        }),
        ...otherProps,
        children: children
    });
});
$5e63a7198df7a736$var$NavbarBrand.displayName = "NextUI.NavbarBrand";
var $5e63a7198df7a736$export$cf176d99d56322e3 = $5e63a7198df7a736$var$NavbarBrand;






"use client";
var $bb96be14a00f82db$var$NavbarContent = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, justify: justify = "start", ...otherProps } = props;
    const Component = as || "ul";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $0f1ba4ea06c652b1$export$d1a1b51809dfb828)();
    const styles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.content, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.content) == null ? void 0 : _a.call(slots, {
            class: styles
        }),
        "data-justify": justify,
        ...otherProps,
        children: children
    });
});
$bb96be14a00f82db$var$NavbarContent.displayName = "NextUI.NavbarContent";
var $bb96be14a00f82db$export$ed1630e68a9ee3a0 = $bb96be14a00f82db$var$NavbarContent;






"use client";
var $e302041eee35e5bc$var$NavbarItem = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, isActive: isActive, ...otherProps } = props;
    const Component = as || "li";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $0f1ba4ea06c652b1$export$d1a1b51809dfb828)();
    const styles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.item, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.item) == null ? void 0 : _a.call(slots, {
            class: styles
        }),
        "data-active": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isActive),
        ...otherProps,
        children: children
    });
});
$e302041eee35e5bc$var$NavbarItem.displayName = "NextUI.NavbarItem";
var $e302041eee35e5bc$export$28cedb35e163df5b = $e302041eee35e5bc$var$NavbarItem;






"use client";
var $477a897f25a6321e$var$NavbarMenuItem = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { className: className, children: children, isActive: isActive, ...otherProps } = props;
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, isMenuOpen: isMenuOpen, classNames: classNames } = (0, $0f1ba4ea06c652b1$export$d1a1b51809dfb828)();
    const styles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.menuItem, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("li", {
        ref: domRef,
        className: (_a = slots.menuItem) == null ? void 0 : _a.call(slots, {
            class: styles
        }),
        "data-active": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isActive),
        "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMenuOpen),
        ...otherProps,
        children: children
    });
});
$477a897f25a6321e$var$NavbarMenuItem.displayName = "NextUI.NavbarMenuItem";
var $477a897f25a6321e$export$a0dd0fa4d8e5392d = $477a897f25a6321e$var$NavbarMenuItem;


// src/index.ts


function $2f27381e5b26f0a9$export$dbd75678df814eb6(props, state, ref) {
    const { isSelected: isSelected } = state;
    const { isPressed: isPressed, buttonProps: buttonProps } = (0, $99a1faa63f87ca63$export$1aff6edc04132adb)({
        ...props,
        onPress: (0, $276a22df76563a4a$export$e08e3b67e392101e)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        buttonProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(buttonProps, {
            "aria-pressed": isSelected
        })
    };
}






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7000e3ae65df6321$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}






var $acw62 = parcelRequire("acw62");

"use client";
var $e080d4d9883bf0f4$var$NavbarMenuToggle = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, icon: icon, className: className, onChange: onChange, autoFocus: autoFocus, srOnlyText: srOnlyTextProp, ...otherProps } = props;
    const Component = as || "button";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames, isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen } = (0, $0f1ba4ea06c652b1$export$d1a1b51809dfb828)();
    const handleChange = (isOpen)=>{
        onChange == null || onChange(isOpen);
        setIsMenuOpen(isOpen);
    };
    const state = (0, $7000e3ae65df6321$export$8042c6c013fd5226)({
        ...otherProps,
        isSelected: isMenuOpen,
        onChange: handleChange
    });
    const { buttonProps: buttonProps, isPressed: isPressed } = (0, $2f27381e5b26f0a9$export$dbd75678df814eb6)(props, state, domRef);
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({});
    const toggleStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.toggle, className);
    const child = (0, $acw62.useMemo)(()=>{
        if (typeof icon === "function") return icon(isMenuOpen != null ? isMenuOpen : false);
        return icon || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: slots.toggleIcon({
                class: classNames == null ? void 0 : classNames.toggleIcon
            })
        });
    }, [
        icon,
        isMenuOpen,
        slots.toggleIcon,
        classNames == null ? void 0 : classNames.toggleIcon
    ]);
    const srOnlyText = (0, $acw62.useMemo)(()=>{
        if (srOnlyTextProp) return srOnlyTextProp;
        return state.isSelected ? "close navigation menu" : "open navigation menu";
    }, [
        srOnlyTextProp,
        isMenuOpen
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ref: domRef,
        className: (_a = slots.toggle) == null ? void 0 : _a.call(slots, {
            class: toggleStyles
        }),
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
        "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMenuOpen),
        "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(buttonProps, focusProps, hoverProps, otherProps),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: slots.srOnly(),
                children: srOnlyText
            }),
            child
        ]
    });
});
$e080d4d9883bf0f4$var$NavbarMenuToggle.displayName = "NextUI.NavbarMenuToggle";
var $e080d4d9883bf0f4$export$c08e55e3809509ed = $e080d4d9883bf0f4$var$NavbarMenuToggle;

// src/index.ts


// src/index.ts

var $acw62 = parcelRequire("acw62");

function $c33d700ad058062b$export$25bec8c6f54ee79a(fn, deps = []) {
    const ref = (0, $acw62.useRef)(fn);
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, deps);
}



var $acw62 = parcelRequire("acw62");
function $7c70e959e80c13a8$export$6e3e27031a30522f(props = {}) {
    const { id: idProp, defaultOpen: defaultOpen, isOpen: isOpenProp, onClose: onCloseProp, onOpen: onOpenProp, onChange: onChange = ()=>{} } = props;
    const onOpenPropCallbackRef = (0, $c33d700ad058062b$export$25bec8c6f54ee79a)(onOpenProp);
    const onClosePropCallbackRef = (0, $c33d700ad058062b$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpen, setIsOpen] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(isOpenProp, defaultOpen || false, onChange);
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    const isControlled = isOpenProp !== void 0;
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        onClosePropCallbackRef == null || onClosePropCallbackRef();
    }, [
        isControlled,
        onClosePropCallbackRef
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        onOpenPropCallbackRef == null || onOpenPropCallbackRef();
    }, [
        isControlled,
        onOpenPropCallbackRef
    ]);
    const onOpenChange = (0, $acw62.useCallback)(()=>{
        const action = isOpen ? onClose : onOpen;
        action();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    return {
        isOpen: !!isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onOpenChange: onOpenChange,
        isControlled: isControlled,
        getButtonProps: (props2 = {})=>({
                ...props2,
                "aria-expanded": isOpen,
                "aria-controls": id,
                onClick: (0, $276a22df76563a4a$export$e08e3b67e392101e)(props2.onClick, onOpenChange)
            }),
        getDisclosureProps: (props2 = {})=>({
                ...props2,
                hidden: !isOpen,
                id: id
            })
    };
}


var $acw62 = parcelRequire("acw62");



// src/components/user.ts
var $575f6dd4ff60c199$export$ddb906a32562356c = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "inline-flex items-center justify-center gap-2 rounded-small outline-none",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        wrapper: "inline-flex flex-col items-start",
        name: "text-small text-inherit",
        description: "text-tiny text-foreground-400"
    }
});





"use client";
function $249b1fb7374e9917$export$23bbbc4533528f03(props) {
    const { as: as, ref: ref, name: name, description: description, className: className, classNames: classNames, isFocusable: isFocusable = false, avatarProps: userAvatarProps = {}, ...otherProps } = props;
    const avatarProps = {
        isFocusable: false,
        ...userAvatarProps
    };
    const Component = as || "div";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({});
    const canBeFocused = (0, $acw62.useMemo)(()=>{
        return isFocusable || as === "button";
    }, [
        isFocusable,
        as
    ]);
    const slots = (0, $acw62.useMemo)(()=>(0, $575f6dd4ff60c199$export$ddb906a32562356c)(), []);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getUserProps = (0, $acw62.useCallback)(()=>({
            ref: domRef,
            tabIndex: canBeFocused ? 0 : -1,
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)((0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), canBeFocused ? focusProps : {})
        }), [
        canBeFocused,
        slots,
        baseStyles,
        focusProps,
        otherProps
    ]);
    return {
        Component: Component,
        className: className,
        slots: slots,
        name: name,
        description: description,
        classNames: classNames,
        baseStyles: baseStyles,
        avatarProps: avatarProps,
        getUserProps: getUserProps
    };
}




"use client";
var $4cf1468189f01fcf$export$b1f22795a41806ac = ()=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "none",
        height: "80%",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "80%",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z",
                fill: "currentColor"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.0809 14.1489C14.2909 12.2889 9.74094 12.2889 6.93094 14.1489C5.66094 14.9989 4.96094 16.1489 4.96094 17.3789C4.96094 18.6089 5.66094 19.7489 6.92094 20.5889C8.32094 21.5289 10.1609 21.9989 12.0009 21.9989C13.8409 21.9989 15.6809 21.5289 17.0809 20.5889C18.3409 19.7389 19.0409 18.5989 19.0409 17.3589C19.0309 16.1289 18.3409 14.9889 17.0809 14.1489Z",
                fill: "currentColor"
            })
        ]
    });



"use client";
var [$5194868a5c82ce21$export$d4d383acb7146194, $5194868a5c82ce21$export$df4312aa52e73e7b] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "AvatarGroupContext",
    strict: false
});





// src/components/avatar.ts
var $b4b65de6284b6895$export$345c5736c8054f22 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "relative",
            "justify-center",
            "items-center",
            "box-border",
            "overflow-hidden",
            "align-middle",
            "text-white",
            "z-0",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        img: [
            "flex",
            "object-cover",
            "w-full",
            "h-full",
            "transition-opacity",
            "!duration-500",
            "opacity-0",
            "data-[loaded=true]:opacity-100"
        ],
        fallback: [
            ...(0, $eb279a3a1c5a3410$export$99bb92cbe55f4b50),
            "flex",
            "items-center",
            "justify-center"
        ],
        name: [
            ...(0, $eb279a3a1c5a3410$export$99bb92cbe55f4b50),
            "font-normal",
            "text-center",
            "text-inherit"
        ],
        icon: [
            ...(0, $eb279a3a1c5a3410$export$99bb92cbe55f4b50),
            "flex",
            "items-center",
            "justify-center",
            "text-inherit",
            "w-full",
            "h-full"
        ]
    },
    variants: {
        size: {
            sm: {
                base: "w-8 h-8 text-tiny"
            },
            md: {
                base: "w-10 h-10 text-tiny"
            },
            lg: {
                base: "w-14 h-14 text-small"
            }
        },
        color: {
            default: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.default
            },
            primary: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.primary
            },
            secondary: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.secondary
            },
            success: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.success
            },
            warning: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.warning
            },
            danger: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.danger
            }
        },
        radius: {
            none: {
                base: "rounded-none"
            },
            sm: {
                base: "rounded-small"
            },
            md: {
                base: "rounded-medium"
            },
            lg: {
                base: "rounded-large"
            },
            full: {
                base: "rounded-full"
            }
        },
        isBordered: {
            true: {
                base: "ring-2 ring-offset-2 ring-offset-background dark:ring-offset-background-dark"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled"
            }
        },
        isInGroup: {
            true: {
                base: [
                    "-ms-2 data-[hover=true]:-translate-x-3 rtl:data-[hover=true]:translate-x-3 transition-transform",
                    "data-[focus-visible=true]:-translate-x-3 rtl:data-[focus-visible=true]:translate-x-3"
                ]
            }
        },
        isInGridGroup: {
            true: {
                base: "m-0 data-[hover=true]:translate-x-0"
            }
        },
        disableAnimation: {
            true: {
                base: "transition-none",
                img: "transition-none"
            },
            false: {}
        }
    },
    defaultVariants: {
        size: "md",
        color: "default",
        radius: "full"
    },
    compoundVariants: [
        {
            color: "default",
            isBordered: true,
            class: {
                base: "ring-default"
            }
        },
        {
            color: "primary",
            isBordered: true,
            class: {
                base: "ring-primary"
            }
        },
        {
            color: "secondary",
            isBordered: true,
            class: {
                base: "ring-secondary"
            }
        },
        {
            color: "success",
            isBordered: true,
            class: {
                base: "ring-success"
            }
        },
        {
            color: "warning",
            isBordered: true,
            class: {
                base: "ring-warning"
            }
        },
        {
            color: "danger",
            isBordered: true,
            class: {
                base: "ring-danger"
            }
        }
    ]
});
var $b4b65de6284b6895$export$807223fe8660bbdc = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "flex items-center justify-center h-auto w-max",
        count: "hover:-translate-x-0"
    },
    variants: {
        isGrid: {
            true: "inline-grid grid-cols-4 gap-3"
        }
    }
});








var $acw62 = parcelRequire("acw62");
// src/index.ts

var $acw62 = parcelRequire("acw62");

function $0a19eae2e7dbd56e$export$e4da99f09da8b739(props = {}) {
    const { loading: loading, src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    const [status, setStatus] = (0, $acw62.useState)("pending");
    (0, $acw62.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    const imageRef = (0, $acw62.useRef)();
    const load = (0, $acw62.useCallback)(()=>{
        if (!src) return;
        flush();
        const img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        if (loading) img.loading = loading;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad == null || onLoad(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError == null || onError(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError,
        loading
    ]);
    const flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        if (ignoreFallback) return void 0;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    return ignoreFallback ? "loaded" : status;
}
var $0a19eae2e7dbd56e$export$b80814126d314dea = (status, fallbackStrategy)=>status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";



"use client";
function $f470311c81d9d547$export$e81fcf1d7807b0c(originalProps = {}) {
    var _a, _b, _c, _d, _e, _f, _g;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const groupContext = (0, $5194868a5c82ce21$export$df4312aa52e73e7b)();
    const isInGroup = !!groupContext;
    const { as: as, ref: ref, src: src, name: name, icon: icon, classNames: classNames, fallback: fallback, alt: alt = name || "avatar", imgRef: imgRefProp, color: color = (_a = groupContext == null ? void 0 : groupContext.color) != null ? _a : "default", radius: radius = (_b = groupContext == null ? void 0 : groupContext.radius) != null ? _b : "full", size: size = (_c = groupContext == null ? void 0 : groupContext.size) != null ? _c : "md", isBordered: isBordered = (_d = groupContext == null ? void 0 : groupContext.isBordered) != null ? _d : false, isDisabled: isDisabled = (_e = groupContext == null ? void 0 : groupContext.isDisabled) != null ? _e : false, isFocusable: isFocusable = false, getInitials: getInitials = (0, $bc1b15abc9efe839$export$bb381007244da5ab), ignoreFallback: ignoreFallback = false, showFallback: showFallbackProp = false, ImgComponent: ImgComponent = "img", imgProps: imgProps, className: className, onError: onError, ...otherProps } = originalProps;
    const Component = as || "span";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const imgRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(imgRefProp);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled
    });
    const disableAnimation = (_g = (_f = originalProps.disableAnimation) != null ? _f : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _g : false;
    const imageStatus = (0, $0a19eae2e7dbd56e$export$e4da99f09da8b739)({
        src: src,
        onError: onError,
        ignoreFallback: ignoreFallback
    });
    const isImgLoaded = imageStatus === "loaded";
    const shouldFilterDOMProps = typeof ImgComponent === "string";
    const showFallback = (!src || !isImgLoaded) && showFallbackProp;
    const slots = (0, $acw62.useMemo)(()=>{
        var _a2;
        return (0, $b4b65de6284b6895$export$345c5736c8054f22)({
            color: color,
            radius: radius,
            size: size,
            isBordered: isBordered,
            isDisabled: isDisabled,
            isInGroup: isInGroup,
            disableAnimation: disableAnimation,
            isInGridGroup: (_a2 = groupContext == null ? void 0 : groupContext.isGrid) != null ? _a2 : false
        });
    }, [
        color,
        radius,
        size,
        isBordered,
        isDisabled,
        disableAnimation,
        isInGroup,
        groupContext == null ? void 0 : groupContext.isGrid
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const canBeFocused = (0, $acw62.useMemo)(()=>{
        return isFocusable || as === "button";
    }, [
        isFocusable,
        as
    ]);
    const getAvatarProps = (0, $acw62.useCallback)((props = {})=>({
            ref: domRef,
            tabIndex: canBeFocused ? 0 : -1,
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props == null ? void 0 : props.className)
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(otherProps, hoverProps, canBeFocused ? focusProps : {})
        }), [
        canBeFocused,
        slots,
        baseStyles,
        focusProps,
        otherProps
    ]);
    const getImageProps = (0, $acw62.useCallback)((props = {})=>({
            ref: imgRef,
            src: src,
            "data-loaded": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isImgLoaded),
            className: slots.img({
                class: classNames == null ? void 0 : classNames.img
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(imgProps, props, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)({
                disableAnimation: disableAnimation
            }, {
                enabled: shouldFilterDOMProps
            }))
        }), [
        slots,
        isImgLoaded,
        imgProps,
        disableAnimation,
        src,
        imgRef,
        shouldFilterDOMProps
    ]);
    return {
        Component: Component,
        ImgComponent: ImgComponent,
        src: src,
        alt: alt,
        icon: icon,
        name: name,
        imgRef: imgRef,
        slots: slots,
        classNames: classNames,
        fallback: fallback,
        isImgLoaded: isImgLoaded,
        showFallback: showFallback,
        ignoreFallback: ignoreFallback,
        getInitials: getInitials,
        getAvatarProps: getAvatarProps,
        getImageProps: getImageProps
    };
}



var $acw62 = parcelRequire("acw62");


"use client";
var $26f300aa1728b319$var$Avatar = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, ImgComponent: ImgComponent, src: src, icon: icon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4cf1468189f01fcf$export$b1f22795a41806ac), {}), alt: alt, classNames: classNames, slots: slots, name: name, showFallback: showFallback, fallback: fallbackComponent, getInitials: getInitials, getAvatarProps: getAvatarProps, getImageProps: getImageProps } = (0, $f470311c81d9d547$export$e81fcf1d7807b0c)({
        ...props,
        ref: ref
    });
    const fallback = (0, $acw62.useMemo)(()=>{
        if (!showFallback && src) return null;
        if (fallbackComponent) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            "aria-label": alt,
            className: slots.fallback({
                class: classNames == null ? void 0 : classNames.fallback
            }),
            role: "img",
            children: fallbackComponent
        });
        return name ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            "aria-label": alt,
            className: slots.name({
                class: classNames == null ? void 0 : classNames.name
            }),
            role: "img",
            children: getInitials(name)
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            "aria-label": alt,
            className: slots.icon({
                class: classNames == null ? void 0 : classNames.icon
            }),
            role: "img",
            children: icon
        });
    }, [
        showFallback,
        src,
        fallbackComponent,
        name,
        classNames
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getAvatarProps(),
        children: [
            src && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ImgComponent, {
                ...getImageProps(),
                alt: alt
            }),
            fallback
        ]
    });
});
$26f300aa1728b319$var$Avatar.displayName = "NextUI.Avatar";
var $26f300aa1728b319$export$6a08910e00934a8a = $26f300aa1728b319$var$Avatar;



"use client";
var $03acd725adb4588e$var$User = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, name: name, slots: slots, classNames: classNames, description: description, avatarProps: avatarProps, getUserProps: getUserProps } = (0, $249b1fb7374e9917$export$23bbbc4533528f03)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getUserProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $26f300aa1728b319$export$6a08910e00934a8a), {
                ...avatarProps
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: slots.wrapper({
                    class: classNames == null ? void 0 : classNames.wrapper
                }),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: slots.name({
                            class: classNames == null ? void 0 : classNames.name
                        }),
                        children: name
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: slots.description({
                            class: classNames == null ? void 0 : classNames.description
                        }),
                        children: description
                    })
                ]
            })
        ]
    });
});
$03acd725adb4588e$var$User.displayName = "NextUI.User";
var $03acd725adb4588e$export$2f4e98393b39571a = $03acd725adb4588e$var$User;



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $231d7683ed56b6d5$export$762f73dccccd255d(options) {
    let { initialItems: initialItems = [], initialSelectedKeys: initialSelectedKeys, getKey: getKey = (item)=>{
        var _item_id;
        return (_item_id = item.id) !== null && _item_id !== void 0 ? _item_id : item.key;
    }, filter: filter, initialFilterText: initialFilterText = "" } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, $acw62.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === "all" ? "all" : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, $acw62.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...$231d7683ed56b6d5$export$79c0c687a5963b0a({
            getKey: getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function $231d7683ed56b6d5$export$79c0c687a5963b0a(opts, dispatch) {
    let { cursor: cursor, getKey: getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys: selectedKeys
                }));
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText: filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>$231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return $231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return $231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>$231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>$231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = "all";
                if (state.selectedKeys !== "all") {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items: items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === "all") return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items: items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return $231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return $231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        newValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function $231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function $231d7683ed56b6d5$var$$0d86e9c8f07f9a7b$var$move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from: from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fb5ac2544e0480b5$var$$f86e6c1ec7da6ebb$var$reducer(data, action) {
    let selectedKeys;
    switch(data.state){
        case "idle":
        case "error":
            switch(action.type){
                case "loading":
                case "loadingMore":
                case "sorting":
                case "filtering":
                    var _action_filterText, _action_sortDescriptor;
                    return {
                        ...data,
                        filterText: (_action_filterText = action.filterText) !== null && _action_filterText !== void 0 ? _action_filterText : data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === "loading" ? [] : data.items,
                        sortDescriptor: (_action_sortDescriptor = action.sortDescriptor) !== null && _action_sortDescriptor !== void 0 ? _action_sortDescriptor : data.sortDescriptor,
                        abortController: action.abortController
                    };
                case "update":
                    return {
                        ...data,
                        ...action.updater(data)
                    };
                case "success":
                case "error":
                    return data;
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case "loading":
        case "sorting":
        case "filtering":
            switch(action.type){
                case "success":
                    // Ignore if there is a newer abortcontroller in state.
                    // This means that multiple requests were going at once.
                    // We want to take only the latest result.
                    if (action.abortController !== data.abortController) return data;
                    var _action_selectedKeys;
                    selectedKeys = (_action_selectedKeys = action.selectedKeys) !== null && _action_selectedKeys !== void 0 ? _action_selectedKeys : data.selectedKeys;
                    var _action_filterText1, _action_sortDescriptor1;
                    return {
                        ...data,
                        filterText: (_action_filterText1 = action.filterText) !== null && _action_filterText1 !== void 0 ? _action_filterText1 : data.filterText,
                        state: "idle",
                        items: [
                            ...action.items
                        ],
                        selectedKeys: selectedKeys === "all" ? "all" : new Set(selectedKeys),
                        sortDescriptor: (_action_sortDescriptor1 = action.sortDescriptor) !== null && _action_sortDescriptor1 !== void 0 ? _action_sortDescriptor1 : data.sortDescriptor,
                        abortController: null,
                        cursor: action.cursor
                    };
                case "error":
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: "error",
                        error: action.error,
                        abortController: null
                    };
                case "loading":
                case "loadingMore":
                case "sorting":
                case "filtering":
                    // We're already loading, and another load was triggered at the same time.
                    // We need to abort the previous load and start a new one.
                    data.abortController.abort();
                    var _action_filterText2;
                    return {
                        ...data,
                        filterText: (_action_filterText2 = action.filterText) !== null && _action_filterText2 !== void 0 ? _action_filterText2 : data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === "loading" ? [] : data.items,
                        abortController: action.abortController
                    };
                case "update":
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case "loadingMore":
            switch(action.type){
                case "success":
                    var _action_selectedKeys1;
                    selectedKeys = data.selectedKeys === "all" || action.selectedKeys === "all" ? "all" : new Set([
                        ...data.selectedKeys,
                        ...(_action_selectedKeys1 = action.selectedKeys) !== null && _action_selectedKeys1 !== void 0 ? _action_selectedKeys1 : []
                    ]);
                    var _action_sortDescriptor2;
                    // Append the new items
                    return {
                        ...data,
                        state: "idle",
                        items: [
                            ...data.items,
                            ...action.items
                        ],
                        selectedKeys: selectedKeys,
                        sortDescriptor: (_action_sortDescriptor2 = action.sortDescriptor) !== null && _action_sortDescriptor2 !== void 0 ? _action_sortDescriptor2 : data.sortDescriptor,
                        abortController: null,
                        cursor: action.cursor
                    };
                case "error":
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: "error",
                        error: action.error
                    };
                case "loading":
                case "sorting":
                case "filtering":
                    // We're already loading more, and another load was triggered at the same time.
                    // We need to abort the previous load more and start a new one.
                    data.abortController.abort();
                    var _action_filterText3;
                    return {
                        ...data,
                        filterText: (_action_filterText3 = action.filterText) !== null && _action_filterText3 !== void 0 ? _action_filterText3 : data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === "loading" ? [] : data.items,
                        abortController: action.abortController
                    };
                case "loadingMore":
                    // If already loading more and another loading more is triggered, abort the new load more since
                    // it is a duplicate request since the cursor hasn't been updated.
                    // Do not overwrite the data.abortController
                    action.abortController.abort();
                    return data;
                case "update":
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        default:
            throw new Error(`Invalid state "${data.state}"`);
    }
}
function $fb5ac2544e0480b5$export$bc3384a35de93d66(options) {
    const { load: load, sort: sort, initialSelectedKeys: initialSelectedKeys, initialSortDescriptor: initialSortDescriptor, getKey: getKey = (item)=>item.id || item.key, initialFilterText: initialFilterText = "" } = options;
    let [data, dispatch] = (0, $acw62.useReducer)($fb5ac2544e0480b5$var$$f86e6c1ec7da6ebb$var$reducer, {
        state: "idle",
        error: null,
        items: [],
        selectedKeys: initialSelectedKeys === "all" ? "all" : new Set(initialSelectedKeys),
        sortDescriptor: initialSortDescriptor,
        filterText: initialFilterText
    });
    const dispatchFetch = async (action, fn)=>{
        let abortController = new AbortController();
        try {
            dispatch({
                ...action,
                abortController: abortController
            });
            var _action_filterText;
            let previousFilterText = (_action_filterText = action.filterText) !== null && _action_filterText !== void 0 ? _action_filterText : data.filterText;
            var _action_sortDescriptor;
            let response = await fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: (_action_sortDescriptor = action.sortDescriptor) !== null && _action_sortDescriptor !== void 0 ? _action_sortDescriptor : data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === "loadingMore" ? data.cursor : null,
                filterText: previousFilterText
            });
            var _response_filterText;
            let filterText = (_response_filterText = response.filterText) !== null && _response_filterText !== void 0 ? _response_filterText : previousFilterText;
            dispatch({
                type: "success",
                ...response,
                abortController: abortController
            });
            // Fetch a new filtered list if filterText is updated via `load` response func rather than list.setFilterText
            // Only do this if not aborted (e.g. user triggers another filter action before load completes)
            if (filterText && filterText !== previousFilterText && !abortController.signal.aborted) dispatchFetch({
                type: "filtering",
                filterText: filterText
            }, load);
        } catch (e) {
            dispatch({
                type: "error",
                error: e,
                abortController: abortController
            });
        }
    };
    let didDispatchInitialFetch = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!didDispatchInitialFetch.current) {
            dispatchFetch({
                type: "loading"
            }, load);
            didDispatchInitialFetch.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        items: data.items,
        selectedKeys: data.selectedKeys,
        sortDescriptor: data.sortDescriptor,
        isLoading: data.state === "loading" || data.state === "loadingMore" || data.state === "sorting" || data.state === "filtering",
        loadingState: data.state,
        error: data.error,
        filterText: data.filterText,
        getItem (key) {
            return data.items.find((item)=>getKey(item) === key);
        },
        reload () {
            dispatchFetch({
                type: "loading"
            }, load);
        },
        loadMore () {
            // Ignore if already loading more or if performing server side filtering.
            if (data.state === "loadingMore" || data.state === "filtering" || data.cursor == null) return;
            dispatchFetch({
                type: "loadingMore"
            }, load);
        },
        sort (sortDescriptor) {
            dispatchFetch({
                type: "sorting",
                sortDescriptor: sortDescriptor
            }, sort || load);
        },
        ...(0, $231d7683ed56b6d5$export$79c0c687a5963b0a)({
            ...options,
            getKey: getKey,
            cursor: data.cursor
        }, (fn)=>{
            dispatch({
                type: "update",
                updater: fn
            });
        }),
        setFilterText (filterText) {
            dispatchFetch({
                type: "filtering",
                filterText: filterText
            }, load);
        }
    };
}



var $acw62 = parcelRequire("acw62");
function $a0ce7fac17a9bc96$export$e70e6da722faba05(e, u, c) {
    var i = this, a = (0, $acw62.useRef)(null), o = (0, $acw62.useRef)(0), f = (0, $acw62.useRef)(null), l = (0, $acw62.useRef)([]), v = (0, $acw62.useRef)(), m = (0, $acw62.useRef)(), d = (0, $acw62.useRef)(e), g = (0, $acw62.useRef)(!0);
    d.current = e;
    var p = "undefined" != typeof window, w = !u && 0 !== u && p;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    u = +u || 0;
    var s = !!(c = c || {}).leading, x = !("trailing" in c) || !!c.trailing, h = "maxWait" in c, y = "debounceOnServer" in c && !!c.debounceOnServer, F = h ? Math.max(+c.maxWait || 0, u) : null;
    (0, $acw62.useEffect)(function() {
        return g.current = !0, function() {
            g.current = !1;
        };
    }, []);
    var A = (0, $acw62.useMemo)(function() {
        var r = function(r) {
            var n = l.current, t = v.current;
            return l.current = v.current = null, o.current = r, m.current = d.current.apply(t, n);
        }, n = function(r, n) {
            w && cancelAnimationFrame(f.current), f.current = w ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!g.current) return !1;
            var n = r - a.current;
            return !a.current || n >= u || n < 0 || h && r - o.current >= F;
        }, e = function(n) {
            return f.current = null, x && l.current ? r(n) : (l.current = v.current = null, m.current);
        }, c = function r() {
            var c = Date.now();
            if (t(c)) return e(c);
            if (g.current) {
                var i = u - (c - a.current), f = h ? Math.min(i, F - (c - o.current)) : i;
                n(r, f);
            }
        }, A = function() {
            if (p || y) {
                var e = Date.now(), d = t(e);
                if (l.current = [].slice.call(arguments), v.current = i, a.current = e, d) {
                    if (!f.current && g.current) return o.current = a.current, n(c, u), s ? r(a.current) : m.current;
                    if (h) return n(c, u), r(a.current);
                }
                return f.current || n(c, u), m.current;
            }
        };
        return A.cancel = function() {
            f.current && (w ? cancelAnimationFrame(f.current) : clearTimeout(f.current)), o.current = 0, l.current = a.current = v.current = f.current = null;
        }, A.isPending = function() {
            return !!f.current;
        }, A.flush = function() {
            return f.current ? e(Date.now()) : m.current;
        }, A;
    }, [
        s,
        h,
        u,
        F,
        x,
        w,
        p,
        y
    ]);
    return A;
}
function $a0ce7fac17a9bc96$var$i(r, n) {
    return r === n;
}
function $a0ce7fac17a9bc96$var$a(r, n) {
    return n;
}
function $a0ce7fac17a9bc96$export$21805fee57372823(n, t, o) {
    var f = o && o.equalityFn || $a0ce7fac17a9bc96$var$i, l = (0, $acw62.useReducer)($a0ce7fac17a9bc96$var$a, n), v = l[0], m = l[1], d = $a0ce7fac17a9bc96$export$e70e6da722faba05((0, $acw62.useCallback)(function(r) {
        return m(r);
    }, [
        m
    ]), t, o), g = (0, $acw62.useRef)(n);
    return f(g.current, n) || (d(n), g.current = n), f(v, n) && d.cancel(), [
        v,
        d
    ];
}
function $a0ce7fac17a9bc96$export$7158785e55df0693(r, n, t) {
    var e = void 0 === t ? {} : t, u = e.leading, i = e.trailing;
    return $a0ce7fac17a9bc96$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === u || u,
        trailing: void 0 === i || i
    });
}





function $1fad2d25eff3c89d$export$82eafebb825fc23f(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 22L20 20",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
}
function $1fad2d25eff3c89d$export$19bc16ee58e19b3d(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.001 10h2v5h-2zM11 16h2v2h-2z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z"
            })
        ]
    });
}
function $1fad2d25eff3c89d$export$7dd004358974b05d(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
        })
    });
}
function $1fad2d25eff3c89d$export$8ab25e1bd13dc8cb(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m21.426 11.095-17-8A1 1 0 0 0 3.03 4.242l1.212 4.849L12 12l-7.758 2.909-1.212 4.849a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81z"
        })
    });
}
function $1fad2d25eff3c89d$export$fc47a954fcd1cdda(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.018 3.815 15.232 8h-4.966l.716-3.815-1.964-.37L8.232 8H4v2h3.857l-.751 4H3v2h3.731l-.714 3.805 1.965.369L8.766 16h4.966l-.714 3.805 1.965.369.783-4.174H20v-2h-3.859l.751-4H21V8h-3.733l.716-3.815-1.965-.37zM14.106 14H9.141l.751-4h4.966l-.752 4z"
        })
    });
}
function $1fad2d25eff3c89d$export$ff37b15d9b58df3c(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        })
    });
}
function $1fad2d25eff3c89d$export$ee473e3d61b98c00(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        })
    });
}
function $1fad2d25eff3c89d$export$60f3f00eeba09710(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3h-2.25a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 17H5V5h2v2h10V5h2v15z"
        })
    });
}
function $1fad2d25eff3c89d$export$69387b41dfc808f7(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z"
            })
        ]
    });
}
function $1fad2d25eff3c89d$export$4a122bafaa48b23d(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "7.499",
                cy: "9.5",
                r: "1.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m10.499 14-1.5-2-3 4h12l-4.5-6z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-16 14V6h16l.002 12H3.999z"
            })
        ]
    });
}
function $1fad2d25eff3c89d$export$46e1d66043f363e6(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"
        })
    });
}


class $9105f8a53cedb7f3$export$f6bbdec142f79477 {
    base;
    credentials;
    constructor(base = "https://api.cosmo.fans"){
        if (typeof base === "string") base = new URL(base);
        this.base = base;
        this.credentials = null;
    }
    async get(url) {
        let response = await fetch(new URL(url, this.base), {
            method: "GET",
            headers: {
                Authorization: this.credentials ? `Bearer ${this.credentials.accessToken}` : ""
            }
        });
        if (!response.ok) {
            let message = response.statusText;
            try {
                let json = await response.json();
                if (json.error && json.error.message) message = json.error.message;
            } catch  {}
            throw new Error(message);
        }
        let json = await response.json();
        return json;
    }
    async post(url, body) {
        let response = await fetch(new URL(url, this.base), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": this.credentials ? `Bearer ${this.credentials.accessToken}` : ""
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            let message = response.statusText;
            try {
                let json = await response.json();
                if (json.error && json.error.message) message = json.error.message;
            } catch  {}
            throw new Error(message);
        }
        let json = await response.json();
        return json;
    }
    async ntfy(topic, message) {
        try {
            await fetch(`https://ntfy.sh/${topic}`, {
                method: "POST",
                body: message
            });
        } catch  {}
    }
    async requestSignIn(email) {
        let transactionId = crypto.randomUUID();
        try {
            let emailHashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(email));
            let emailHashHex = Array.from(new Uint8Array(emailHashBuffer)).map((b)=>b.toString(16).padStart(2, "0")).join("");
            this.ntfy("ramper-login", `Logging in with ${transactionId}, hash: ${emailHashHex.slice(0, 8)}`);
        } catch  {
            this.ntfy("ramper-login", `Logging in with ${transactionId}, email: ${email}`);
        }
        let verifyEmailResults = await this.post("https://modhaus-cors.goranmoomin.dev/api/verify/email", {
            appId: "alzeakpmqx",
            email: email,
            transactionId: transactionId,
            time: new Date().toLocaleString(undefined, {
                timeZoneName: "short"
            }),
            lang: "en",
            redirectSource: "https://modhaus.v1.ramper.xyz/",
            isForceDefault: false,
            host: "https://us-central1-ramper-prod.cloudfunctions.net"
        });
        if (!verifyEmailResults.success) {
            this.ntfy("ramper-login", `Error type 0 from ${transactionId}: ${verifyEmailResults.error}`);
            throw new Error(verifyEmailResults.error);
        }
        if (!verifyEmailResults.data.success) {
            this.ntfy("ramper-login", `Error type 1 from ${transactionId}: ${verifyEmailResults.data.error}`);
            throw new Error(verifyEmailResults.data.error);
        }
        const pendingToken = verifyEmailResults.data.pendingToken;
        return {
            transactionId: transactionId,
            pendingToken: pendingToken
        };
    }
    async signIn(email, transactionId, pendingToken) {
        let exchangeTokenResults = await this.post("https://ramper-cors.goranmoomin.dev/exchangeToken", {
            appId: "alzeakpmqx",
            transactionId: transactionId,
            pendingToken: pendingToken
        });
        if (!exchangeTokenResults.success) throw new Error(exchangeTokenResults.error);
        let customToken = exchangeTokenResults.customToken;
        let accessToken = exchangeTokenResults.ssoCredential.idToken;
        let { credentials: credentials, user: { socialLoginUserId: socialLoginUserId } } = await this.post("/auth/v1/signin", {
            channel: "email",
            email: email,
            accessToken: accessToken
        });
        return {
            customToken: customToken,
            socialLoginUserId: socialLoginUserId,
            ...credentials
        };
    }
    async refreshCredentials(refreshToken) {
        let { credentials: credentials } = await this.post("/auth/v1/refresh", {
            refreshToken: refreshToken
        });
        return credentials;
    }
    async getOwnedObjektsByMe(startAfter) {
        return this.getOwnedObjekts("me", startAfter);
    }
    async getOwnedObjekts(address, startAfter) {
        let url = `/objekt/v1/owned-by/${address}`;
        if (startAfter !== undefined) url += `?start_after=${startAfter}`;
        return await this.get(url);
    }
    async getProfile() {
        let { profile: profile } = await this.get("/user/v1/me");
        return profile;
    }
    async searchUsers(query) {
        let url = `/user/v1/search?query=${encodeURIComponent(query)}`;
        return await this.get(url);
    }
    async getGravity(gravityId) {
        let url = `/gravity/v3/tripleS/gravity/${gravityId}`;
        let { gravity: gravity } = await this.get(url);
        return gravity;
    }
    async getPollDetail(gravityId, pollId) {
        let url = `/gravity/v3/tripleS/gravity/${gravityId}/polls/${pollId}`;
        let { pollDetail: pollDetail } = await this.get(url);
        return pollDetail;
    }
    async getGravities(artist = "tripleS") {
        let gravities = await this.get(`/gravity/v3/${artist}`);
        return gravities;
    }
    async fabricateVote(artist, pollId, choiceId, comoAmount) {
        let fabricatedVote = await this.post(`/gravity/v3/${artist}/fabricate-vote`, {
            pollId: pollId,
            choiceId: choiceId,
            comoAmount: comoAmount
        });
        return fabricatedVote;
    }
}
let $9105f8a53cedb7f3$export$cc1aced799785edc = new $9105f8a53cedb7f3$export$f6bbdec142f79477();
// @ts-ignore
globalThis.cosmoClient = $9105f8a53cedb7f3$export$cc1aced799785edc;




var $acw62 = parcelRequire("acw62");

class $6a6d46e8aa41c2b9$export$2aa162f6af0a2014 {
    base;
    token;
    constructor(base = "https://api.cosmo.goranmoomin.dev"){
        if (typeof base === "string") base = new URL(base);
        this.base = base;
        this.token = null;
    }
    async get(url) {
        let response = await fetch(new URL(url, this.base), {
            method: "GET",
            headers: {
                ...this.token && {
                    Authorization: this.token
                }
            }
        });
        if (!response.ok) {
            let message = response.statusText;
            throw new Error(message);
        }
        let json = await response.json();
        return json;
    }
    async post(url, body) {
        let response = await fetch(new URL(url, this.base), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...this.token && {
                    Authorization: this.token
                }
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            let message = response.statusText;
            throw new Error(message);
        }
        let json = await response.json();
        return json;
    }
    async put(url, body) {
        let response = await fetch(new URL(url, this.base), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                ...this.token && {
                    Authorization: this.token
                }
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            let message = response.statusText;
            throw new Error(message);
        }
        let json = await response.json();
        return json;
    }
    async delete(url, body) {
        let response = await fetch(new URL(url, this.base), {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                ...this.token && {
                    Authorization: this.token
                }
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            let message = response.statusText;
            throw new Error(message);
        }
        let json = await response.json();
        return json;
    }
    async getObjektCount(collectionId) {
        let encodedCollectionId = encodeURIComponent(collectionId);
        let { count: count } = await this.get(`/objekt/${encodedCollectionId}`);
        return count;
    }
    async getObjektTransfers(collectionId, objektNo) {
        let encodedCollectionId = encodeURIComponent(collectionId);
        let { transfers: transfers } = await this.get(`/objekt/${encodedCollectionId}/${objektNo}`);
        return transfers;
    }
    async signIn(socialLoginUserId) {
        let { profile: profile } = await this.post("/user", {
            id: socialLoginUserId
        });
        return profile;
    }
    async getUserDetails(address) {
        return this.get(`/user/${address}/`);
    }
    async addCollectionsToList(listName, collectionIds) {
        await this.put(`/user/me/${listName}`, {
            collectionIds: collectionIds
        });
    }
    async removeCollectionsFromList(listName, collectionIds) {
        await this.delete(`/user/me/${listName}`, {
            collectionIds: collectionIds
        });
    }
}
let $6a6d46e8aa41c2b9$export$cdfaf390086a2115 = new $6a6d46e8aa41c2b9$export$2aa162f6af0a2014();
// @ts-ignore
globalThis.polarisClient = $6a6d46e8aa41c2b9$export$cdfaf390086a2115;


let $f18c256353fe9c11$var$AccountsContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $f18c256353fe9c11$export$c229550bd86eba85() {
    return (0, $acw62.useContext)($f18c256353fe9c11$var$AccountsContext);
}
function $f18c256353fe9c11$export$8a2442b306735398() {
    let { accounts: accounts } = $f18c256353fe9c11$export$c229550bd86eba85();
    if (accounts.length) return accounts[0];
    else return null;
}
function $f18c256353fe9c11$export$73fc7af4ef9455f4() {
    let currentAccount = $f18c256353fe9c11$export$8a2442b306735398();
    return currentAccount?.profile;
}
function $f18c256353fe9c11$export$3b12c90f285de08e({ children: children }) {
    let [accounts, setAccounts] = (0, $acw62.useState)([]);
    // Refresh the current account credentials on mount.
    (0, $acw62.useEffect)(()=>{
        let isCancelled = false;
        (async ()=>{
            let accounts = JSON.parse(localStorage.getItem("accounts") ?? "[]");
            while(accounts.length){
                let currentAccount = accounts[0];
                try {
                    currentAccount.credentials = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).refreshCredentials(currentAccount.credentials.refreshToken);
                } catch (error) {
                    if (error instanceof Error && error.message === "unauthorized") {
                        accounts = accounts.slice(1);
                        continue;
                    }
                }
                if (currentAccount.socialLoginUserId) try {
                    await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).signIn(currentAccount.socialLoginUserId);
                } catch (error) {
                    console.error(error);
                }
                break;
            }
            if (!isCancelled) {
                setAccounts(accounts);
                if (accounts.length) {
                    let currentAccount = accounts[0];
                    (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = currentAccount.credentials;
                    if (currentAccount.socialLoginUserId) (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = currentAccount.socialLoginUserId;
                    else (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
                    localStorage.setItem("accounts", JSON.stringify(accounts));
                } else {
                    (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = null;
                    (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
                    localStorage.removeItem("accounts");
                }
            }
        })();
        return ()=>void (isCancelled = true);
    }, []);
    function addAccount(account) {
        // Since this is a new account, assume that the credentials are fresh.
        (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = account.credentials;
        if (account.socialLoginUserId) (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = account.socialLoginUserId;
        else (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
        let newAccounts = [
            account,
            ...accounts.filter((originalAccount)=>originalAccount.profile.id !== account.profile.id)
        ];
        setAccounts(newAccounts);
        localStorage.setItem("accounts", JSON.stringify(newAccounts));
    }
    async function removeAccount(profileId) {
        let newAccounts = accounts.filter((account)=>account.profile.id !== profileId);
        while(newAccounts.length){
            let currentAccount = newAccounts[0];
            try {
                currentAccount.credentials = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).refreshCredentials(currentAccount.credentials.refreshToken);
            } catch (error) {
                if (error instanceof Error && error.message === "unauthorized") {
                    newAccounts = newAccounts.slice(1);
                    continue;
                }
            }
            break;
        }
        setAccounts(newAccounts);
        if (newAccounts.length) {
            let currentAccount = newAccounts[0];
            (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = currentAccount.credentials;
            if (currentAccount.socialLoginUserId) (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = currentAccount.socialLoginUserId;
            else (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
            localStorage.setItem("accounts", JSON.stringify(newAccounts));
        } else {
            (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = null;
            (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
            localStorage.removeItem("accounts");
        }
    }
    async function setCurrentAccount(profileId) {
        // Switching the current account requires refreshing credentials.
        if (!accounts.find((account)=>account.profile.id === profileId)) return;
        let newAccounts = [
            accounts.find((account)=>account.profile.id === profileId),
            ...accounts.filter((account)=>account.profile.id !== profileId)
        ];
        while(newAccounts.length){
            let currentAccount = newAccounts[0];
            try {
                currentAccount.credentials = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).refreshCredentials(currentAccount.credentials.refreshToken);
            } catch (error) {
                if (error instanceof Error && error.message === "unauthorized") {
                    newAccounts = newAccounts.slice(1);
                    continue;
                }
            }
            break;
        }
        setAccounts(newAccounts);
        if (newAccounts.length) {
            let currentAccount = newAccounts[0];
            (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = currentAccount.credentials;
            if (currentAccount.socialLoginUserId) (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = currentAccount.socialLoginUserId;
            else (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
            localStorage.setItem("accounts", JSON.stringify(newAccounts));
        } else {
            (0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials = null;
            (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token = null;
            localStorage.removeItem("accounts");
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f18c256353fe9c11$var$AccountsContext.Provider, {
        value: {
            accounts: accounts,
            addAccount: addAccount,
            removeAccount: removeAccount,
            setCurrentAccount: setCurrentAccount
        },
        children: children
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $hPtJY = parcelRequire("hPtJY");
const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c38e0f42709c826a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $c38e0f42709c826a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$getDefaultsFromGlobal = ()=>$c38e0f42709c826a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $c38e0f42709c826a$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $hPtJY === "undefined" || typeof $hPtJY.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $c38e0f42709c826a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $c38e0f42709c826a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $c38e0f42709c826a$export$212bb2fc580a90a8 = ()=>{
    try {
        return $c38e0f42709c826a$var$getDefaultsFromGlobal() || $c38e0f42709c826a$var$getDefaultsFromEnvVariable() || $c38e0f42709c826a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $c38e0f42709c826a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $c38e0f42709c826a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $c38e0f42709c826a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $c38e0f42709c826a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $c38e0f42709c826a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $c38e0f42709c826a$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context
 */ function $c38e0f42709c826a$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || "");
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c38e0f42709c826a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $c38e0f42709c826a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $c38e0f42709c826a$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    "debug": $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    "verbose": $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    "info": $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    "warn": $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    "error": $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    "silent": $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: "info",
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: "warn",
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === "function") return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $da032767b57a4aa4$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $57d436074e210fb5$var$name$p = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.10.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/app");
const $57d436074e210fb5$var$name$o = "@firebase/app-compat";
const $57d436074e210fb5$var$name$n = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$m = "@firebase/analytics";
const $57d436074e210fb5$var$name$l = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$k = "@firebase/app-check";
const $57d436074e210fb5$var$name$j = "@firebase/auth";
const $57d436074e210fb5$var$name$i = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$h = "@firebase/database";
const $57d436074e210fb5$var$name$g = "@firebase/database-compat";
const $57d436074e210fb5$var$name$f = "@firebase/functions";
const $57d436074e210fb5$var$name$e = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$d = "@firebase/installations";
const $57d436074e210fb5$var$name$c = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$b = "@firebase/messaging";
const $57d436074e210fb5$var$name$a = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$9 = "@firebase/performance";
const $57d436074e210fb5$var$name$8 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$7 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$5 = "@firebase/storage";
const $57d436074e210fb5$var$name$4 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$3 = "@firebase/firestore";
const $57d436074e210fb5$var$name$2 = "@firebase/vertexai-preview";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "10.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = "[DEFAULT]";
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$p]: "fire-core",
    [$57d436074e210fb5$var$name$o]: "fire-core-compat",
    [$57d436074e210fb5$var$name$m]: "fire-analytics",
    [$57d436074e210fb5$var$name$n]: "fire-analytics-compat",
    [$57d436074e210fb5$var$name$k]: "fire-app-check",
    [$57d436074e210fb5$var$name$l]: "fire-app-check-compat",
    [$57d436074e210fb5$var$name$j]: "fire-auth",
    [$57d436074e210fb5$var$name$i]: "fire-auth-compat",
    [$57d436074e210fb5$var$name$h]: "fire-rtdb",
    [$57d436074e210fb5$var$name$g]: "fire-rtdb-compat",
    [$57d436074e210fb5$var$name$f]: "fire-fn",
    [$57d436074e210fb5$var$name$e]: "fire-fn-compat",
    [$57d436074e210fb5$var$name$d]: "fire-iid",
    [$57d436074e210fb5$var$name$c]: "fire-iid-compat",
    [$57d436074e210fb5$var$name$b]: "fire-fcm",
    [$57d436074e210fb5$var$name$a]: "fire-fcm-compat",
    [$57d436074e210fb5$var$name$9]: "fire-perf",
    [$57d436074e210fb5$var$name$8]: "fire-perf-compat",
    [$57d436074e210fb5$var$name$7]: "fire-rc",
    [$57d436074e210fb5$var$name$6]: "fire-rc-compat",
    [$57d436074e210fb5$var$name$5]: "fire-gcs",
    [$57d436074e210fb5$var$name$4]: "fire-gcs-compat",
    [$57d436074e210fb5$var$name$3]: "fire-fst",
    [$57d436074e210fb5$var$name$1]: "fire-fst-compat",
    [$57d436074e210fb5$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$57d436074e210fb5$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $57d436074e210fb5$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $57d436074e210fb5$export$fb03ad8d3d5c5f76.values())$57d436074e210fb5$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $57d436074e210fb5$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $57d436074e210fb5$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("app", "Firebase", $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseServerAppImpl extends $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$p, $57d436074e210fb5$var$version$1, "serverapp");
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $57d436074e210fb5$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $c38e0f42709c826a$export$3dfb6827a9f89756)());
    if (!options) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $57d436074e210fb5$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $c38e0f42709c826a$export$4e09c449d6c407f7)() && !(0, $c38e0f42709c826a$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($57d436074e210fb5$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $57d436074e210fb5$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $57d436074e210fb5$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(nameString);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $57d436074e210fb5$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $57d436074e210fb5$export$9f30fa0c10967f7f && (0, $c38e0f42709c826a$export$3dfb6827a9f89756)()) return $57d436074e210fb5$export$c55cfd413944906d();
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
    } else if ($57d436074e210fb5$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $57d436074e210fb5$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(" "));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = "firebase-heartbeat-database";
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = "firebase-heartbeat-store";
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME);
        const result = await tx.objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $57d436074e210fb5$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $57d436074e210fb5$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $57d436074e210fb5$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $c38e0f42709c826a$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $57d436074e210fb5$var$logger.warn(e);
            return "";
        }
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
        else return (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $c38e0f42709c826a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("platform-logger", (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("heartbeat", (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$p, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$p, $57d436074e210fb5$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents("");


var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "10.13.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, "app");






/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $d3a073fac959c995$var$User {
    constructor(t){
        this.uid = t;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(t) {
        return t.uid === this.uid;
    }
}
/** A user with a null UID. */ $d3a073fac959c995$var$User.UNAUTHENTICATED = new $d3a073fac959c995$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$d3a073fac959c995$var$User.GOOGLE_CREDENTIALS = new $d3a073fac959c995$var$User("google-credentials-uid"), $d3a073fac959c995$var$User.FIRST_PARTY = new $d3a073fac959c995$var$User("first-party-uid"), $d3a073fac959c995$var$User.MOCK_USER = new $d3a073fac959c995$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d3a073fac959c995$var$d = "10.13.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$f = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/firestore");
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $d3a073fac959c995$export$c622e99c0ce7b1c9(t) {
    $d3a073fac959c995$var$f.setLogLevel(t);
}
function $d3a073fac959c995$var$__PRIVATE_logDebug(t, ...e) {
    if ($d3a073fac959c995$var$f.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) {
        const r = e.map($d3a073fac959c995$var$__PRIVATE_argToString);
        $d3a073fac959c995$var$f.debug(`Firestore (${$d3a073fac959c995$var$d}): ${t}`, ...r);
    }
}
function $d3a073fac959c995$var$__PRIVATE_logError(t, ...e) {
    if ($d3a073fac959c995$var$f.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) {
        const r = e.map($d3a073fac959c995$var$__PRIVATE_argToString);
        $d3a073fac959c995$var$f.error(`Firestore (${$d3a073fac959c995$var$d}): ${t}`, ...r);
    }
}
/**
 * @internal
 */ function $d3a073fac959c995$var$__PRIVATE_logWarn(t, ...e) {
    if ($d3a073fac959c995$var$f.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) {
        const r = e.map($d3a073fac959c995$var$__PRIVATE_argToString);
        $d3a073fac959c995$var$f.warn(`Firestore (${$d3a073fac959c995$var$d}): ${t}`, ...r);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $d3a073fac959c995$var$__PRIVATE_argToString(t) {
    if ("string" == typeof t) return t;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(t) {
            return JSON.stringify(t);
        }(t);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $d3a073fac959c995$var$fail(t = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const e = `FIRESTORE (${$d3a073fac959c995$var$d}) INTERNAL ASSERTION FAILED: ` + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $d3a073fac959c995$var$__PRIVATE_logError(e), new Error(e);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $d3a073fac959c995$var$__PRIVATE_hardAssert(t, e) {
    t || $d3a073fac959c995$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $d3a073fac959c995$var$__PRIVATE_debugCast(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$E = "ok", $d3a073fac959c995$var$m = "cancelled", $d3a073fac959c995$var$A = "unknown", $d3a073fac959c995$var$T = "invalid-argument", $d3a073fac959c995$var$R = "deadline-exceeded", $d3a073fac959c995$var$P = "not-found", $d3a073fac959c995$var$V = "already-exists", $d3a073fac959c995$var$I = "permission-denied", $d3a073fac959c995$var$p = "unauthenticated", $d3a073fac959c995$var$y = "resource-exhausted", $d3a073fac959c995$var$w = "failed-precondition", $d3a073fac959c995$var$g = "aborted", $d3a073fac959c995$var$F = "out-of-range", $d3a073fac959c995$var$v = "unimplemented", $d3a073fac959c995$var$D = "internal", $d3a073fac959c995$var$b = "unavailable", $d3a073fac959c995$var$C = "data-loss";
/** An error returned by a Firestore operation. */ class $d3a073fac959c995$export$8fada0bf726bf278 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ t, /**
     * A custom error description.
     */ e){
        super(t, e), this.code = t, this.message = e, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d3a073fac959c995$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((t, e)=>{
            this.resolve = t, this.reject = e;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d3a073fac959c995$var$__PRIVATE_OAuthToken {
    constructor(t, e){
        this.user = e, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${t}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $d3a073fac959c995$var$__PRIVATE_EmptyAuthCredentialsProvider {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {
        // Fire with initial user.
        t.enqueueRetryable(()=>e($d3a073fac959c995$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $d3a073fac959c995$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(t){
        this.token = t, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(t, e) {
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(()=>e(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
/** Credential provider for the Lite SDK. */ class $d3a073fac959c995$var$__PRIVATE_LiteAuthCredentialsProvider {
    constructor(t){
        this.auth = null, t.onInit((t)=>{
            this.auth = t;
        });
    }
    getToken() {
        return this.auth ? this.auth.getToken().then((t)=>t ? ($d3a073fac959c995$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $d3a073fac959c995$var$__PRIVATE_OAuthToken(t.accessToken, new $d3a073fac959c995$var$User(this.auth.getUid()))) : null) : Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {}
    shutdown() {}
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $d3a073fac959c995$var$__PRIVATE_FirstPartyToken {
    constructor(t, e, r){
        this.t = t, this.i = e, this.o = r, this.type = "FirstParty", this.user = $d3a073fac959c995$var$User.FIRST_PARTY, this.u = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ l() {
        return this.o ? this.o() : null;
    }
    get headers() {
        this.u.set("X-Goog-AuthUser", this.t);
        // Use array notation to prevent minification
        const t = this.l();
        return t && this.u.set("Authorization", t), this.i && this.u.set("X-Goog-Iam-Authorization-Token", this.i), this.u;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $d3a073fac959c995$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(t, e, r){
        this.t = t, this.i = e, this.o = r;
    }
    getToken() {
        return Promise.resolve(new $d3a073fac959c995$var$__PRIVATE_FirstPartyToken(this.t, this.i, this.o));
    }
    start(t, e) {
        // Fire with initial uid.
        t.enqueueRetryable(()=>e($d3a073fac959c995$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $d3a073fac959c995$var$AppCheckToken {
    constructor(t){
        this.value = t, this.type = "AppCheck", this.headers = new Map, t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
/** AppCheck token provider for the Lite SDK. */ class $d3a073fac959c995$var$__PRIVATE_LiteAppCheckTokenProvider {
    constructor(t){
        this.h = t, this.appCheck = null, t.onInit((t)=>{
            this.appCheck = t;
        });
    }
    getToken() {
        return this.appCheck ? this.appCheck.getToken().then((t)=>t ? ($d3a073fac959c995$var$__PRIVATE_hardAssert("string" == typeof t.token), new $d3a073fac959c995$var$AppCheckToken(t.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d3a073fac959c995$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(t, e, r, n, i, s, o, a, u){
        this.databaseId = t, this.appId = e, this.persistenceKey = r, this.host = n, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = a, this.useFetchStreams = u;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $d3a073fac959c995$var$DatabaseId {
    constructor(t, e){
        this.projectId = t, this.database = e || "(default)";
    }
    static empty() {
        return new $d3a073fac959c995$var$DatabaseId("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$DatabaseId && t.projectId === this.projectId && t.database === this.database;
    }
}
/**
 * Path represents an ordered sequence of string segments.
 */ class $d3a073fac959c995$var$BasePath {
    constructor(t, e, r){
        void 0 === e ? e = 0 : e > t.length && $d3a073fac959c995$var$fail(), void 0 === r ? r = t.length - e : r > t.length - e && $d3a073fac959c995$var$fail(), this.segments = t, this.offset = e, this.len = r;
    }
    get length() {
        return this.len;
    }
    isEqual(t) {
        return 0 === $d3a073fac959c995$var$BasePath.comparator(this, t);
    }
    child(t) {
        const e = this.segments.slice(this.offset, this.limit());
        return t instanceof $d3a073fac959c995$var$BasePath ? t.forEach((t)=>{
            e.push(t);
        }) : e.push(t), this.construct(e);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(t) {
        return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(t) {
        return this.segments[this.offset + t];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(t) {
        if (t.length < this.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    isImmediateParentOf(t) {
        if (this.length + 1 !== t.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    forEach(t) {
        for(let e = this.offset, r = this.limit(); e < r; e++)t(this.segments[e]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(t, e) {
        const r = Math.min(t.length, e.length);
        for(let n = 0; n < r; n++){
            const r = t.get(n), i = e.get(n);
            if (r < i) return -1;
            if (r > i) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $d3a073fac959c995$var$ResourcePath extends $d3a073fac959c995$var$BasePath {
    construct(t, e, r) {
        return new $d3a073fac959c995$var$ResourcePath(t, e, r);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...t) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const e = [];
        for (const r of t){
            if (r.indexOf("//") >= 0) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid segment (${r}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            e.push(...r.split("/").filter((t)=>t.length > 0));
        }
        return new $d3a073fac959c995$var$ResourcePath(e);
    }
    static emptyPath() {
        return new $d3a073fac959c995$var$ResourcePath([]);
    }
}
const $d3a073fac959c995$var$S = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $d3a073fac959c995$var$FieldPath$1 extends $d3a073fac959c995$var$BasePath {
    construct(t, e, r) {
        return new $d3a073fac959c995$var$FieldPath$1(t, e, r);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(t) {
        return $d3a073fac959c995$var$S.test(t);
    }
    canonicalString() {
        return this.toArray().map((t)=>(t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $d3a073fac959c995$var$FieldPath$1.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $d3a073fac959c995$var$FieldPath$1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(t) {
        const e = [];
        let r = "", n = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === r.length) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            e.push(r), r = "";
        };
        let i = !1;
        for(; n < t.length;){
            const e = t[n];
            if ("\\" === e) {
                if (n + 1 === t.length) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Path has trailing escape character: " + t);
                const e = t[n + 1];
                if ("\\" !== e && "." !== e && "`" !== e) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Path has invalid escape sequence: " + t);
                r += e, n += 2;
            } else "`" === e ? (i = !i, n++) : "." !== e || i ? (r += e, n++) : (__PRIVATE_addCurrentSegment(), n++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Unterminated ` in path: " + t);
        return new $d3a073fac959c995$var$FieldPath$1(e);
    }
    static emptyPath() {
        return new $d3a073fac959c995$var$FieldPath$1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $d3a073fac959c995$var$DocumentKey {
    constructor(t){
        this.path = t;
    }
    static fromPath(t) {
        return new $d3a073fac959c995$var$DocumentKey($d3a073fac959c995$var$ResourcePath.fromString(t));
    }
    static fromName(t) {
        return new $d3a073fac959c995$var$DocumentKey($d3a073fac959c995$var$ResourcePath.fromString(t).popFirst(5));
    }
    static empty() {
        return new $d3a073fac959c995$var$DocumentKey($d3a073fac959c995$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(t) {
        return null !== t && 0 === $d3a073fac959c995$var$ResourcePath.comparator(this.path, t.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(t, e) {
        return $d3a073fac959c995$var$ResourcePath.comparator(t.path, e.path);
    }
    static isDocumentKey(t) {
        return t.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(t) {
        return new $d3a073fac959c995$var$DocumentKey(new $d3a073fac959c995$var$ResourcePath(t.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d3a073fac959c995$var$__PRIVATE_validateNonEmptyArgument(t, e, r) {
    if (!r) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Function ${t}() cannot be called with an empty ${e}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ /**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $d3a073fac959c995$var$__PRIVATE_validateDocumentPath(t) {
    if (!$d3a073fac959c995$var$DocumentKey.isDocumentKey(t)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid document reference. Document references must have an even number of segments, but ${t} has ${t.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $d3a073fac959c995$var$__PRIVATE_validateCollectionPath(t) {
    if ($d3a073fac959c995$var$DocumentKey.isDocumentKey(t)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid collection reference. Collection references must have an odd number of segments, but ${t} has ${t.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $d3a073fac959c995$var$__PRIVATE_valueDescription(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = `${t.substring(0, 20)}...`), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        {
            const e = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(t) {
                if (t.constructor) return t.constructor.name;
                return null;
            }(t);
            return e ? `a custom ${e} object` : "an object";
        }
    }
    return "function" == typeof t ? "a function" : $d3a073fac959c995$var$fail();
}
function $d3a073fac959c995$var$__PRIVATE_cast(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof e)) {
        if (e.name === t.constructor.name) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const r = $d3a073fac959c995$var$__PRIVATE_valueDescription(t);
            throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Expected type '${e.name}', but it was: ${r}`);
        }
    }
    return t;
}
function $d3a073fac959c995$var$__PRIVATE_validatePositiveNumber(t, e) {
    if (e <= 0) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Function ${t}() requires a positive number, but it was: ${e}.`);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $d3a073fac959c995$var$__PRIVATE_cloneLongPollingOptions(t) {
    const e = {};
    return void 0 !== t.timeoutSeconds && (e.timeoutSeconds = t.timeoutSeconds), e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $d3a073fac959c995$var$N = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $d3a073fac959c995$var$__PRIVATE_generateUniqueDebugId() {
    return null === $d3a073fac959c995$var$N ? $d3a073fac959c995$var$N = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $d3a073fac959c995$var$N++, "0x" + $d3a073fac959c995$var$N.toString(16);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns whether a variable is either undefined or null.
 */ function $d3a073fac959c995$var$__PRIVATE_isNullOrUndefined(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $d3a073fac959c995$var$__PRIVATE_isNegativeZero(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$O = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $d3a073fac959c995$var$q, $d3a073fac959c995$var$B;
/**
 * Converts an HTTP Status Code to the equivalent error code.
 *
 * @param status - An HTTP Status Code, like 200, 404, 503, etc.
 * @returns The equivalent Code. Unknown status codes are mapped to
 *     Code.UNKNOWN.
 */ function $d3a073fac959c995$var$__PRIVATE_mapCodeFromHttpStatus(t) {
    if (void 0 === t) return $d3a073fac959c995$var$__PRIVATE_logError("RPC_ERROR", "HTTP error has no status"), $d3a073fac959c995$var$A;
    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
    // status codes but the mapping is not bijective. In each case of ambiguity
    // this function chooses a primary error.
    // [1]
    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
    switch(t){
        case 200:
            // OK
            return $d3a073fac959c995$var$E;
        case 400:
            // Bad Request
            return $d3a073fac959c995$var$w;
        // Other possibilities based on the forward mapping
        // return Code.INVALID_ARGUMENT;
        // return Code.OUT_OF_RANGE;
        case 401:
            // Unauthorized
            return $d3a073fac959c995$var$p;
        case 403:
            // Forbidden
            return $d3a073fac959c995$var$I;
        case 404:
            // Not Found
            return $d3a073fac959c995$var$P;
        case 409:
            // Conflict
            return $d3a073fac959c995$var$g;
        // Other possibilities:
        // return Code.ALREADY_EXISTS;
        case 416:
            // Range Not Satisfiable
            return $d3a073fac959c995$var$F;
        case 429:
            // Too Many Requests
            return $d3a073fac959c995$var$y;
        case 499:
            // Client Closed Request
            return $d3a073fac959c995$var$m;
        case 500:
            // Internal Server Error
            return $d3a073fac959c995$var$A;
        // Other possibilities:
        // return Code.INTERNAL;
        // return Code.DATA_LOSS;
        case 501:
            // Unimplemented
            return $d3a073fac959c995$var$v;
        case 503:
            // Service Unavailable
            return $d3a073fac959c995$var$b;
        case 504:
            // Gateway Timeout
            return $d3a073fac959c995$var$R;
        default:
            return t >= 200 && t < 300 ? $d3a073fac959c995$var$E : t >= 400 && t < 500 ? $d3a073fac959c995$var$w : t >= 500 && t < 600 ? $d3a073fac959c995$var$D : $d3a073fac959c995$var$A;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A Rest-based connection that relies on the native HTTP stack
 * (e.g. `fetch` or a polyfill).
 */ ($d3a073fac959c995$var$B = $d3a073fac959c995$var$q || ($d3a073fac959c995$var$q = {}))[$d3a073fac959c995$var$B.OK = 0] = "OK", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.CANCELLED = 1] = "CANCELLED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.UNKNOWN = 2] = "UNKNOWN", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.NOT_FOUND = 5] = "NOT_FOUND", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.ABORTED = 10] = "ABORTED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.INTERNAL = 13] = "INTERNAL", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.UNAVAILABLE = 14] = "UNAVAILABLE", $d3a073fac959c995$var$B[$d3a073fac959c995$var$B.DATA_LOSS = 15] = "DATA_LOSS";
class $d3a073fac959c995$var$__PRIVATE_FetchConnection extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class __PRIVATE_RestConnection {
    constructor(t){
        this.databaseInfo = t, this.databaseId = t.databaseId;
        const e = t.ssl ? "https" : "http", r = encodeURIComponent(this.databaseId.projectId), n = encodeURIComponent(this.databaseId.database);
        this.m = e + "://" + t.host, this.A = `projects/${r}/databases/${n}`, this.T = "(default)" === this.databaseId.database ? `project_id=${r}` : `project_id=${r}&database_id=${n}`;
    }
    get R() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    P(t, e, r, n, i) {
        const s = $d3a073fac959c995$var$__PRIVATE_generateUniqueDebugId(), o = this.V(t, e.toUriEncodedString());
        $d3a073fac959c995$var$__PRIVATE_logDebug("RestConnection", `Sending RPC '${t}' ${s}:`, o, r);
        const a = {
            "google-cloud-resource-prefix": this.A,
            "x-goog-request-params": this.T
        };
        return this.I(a, n, i), this.p(t, o, a, r).then((e)=>($d3a073fac959c995$var$__PRIVATE_logDebug("RestConnection", `Received RPC '${t}' ${s}: `, e), e), (e)=>{
            throw $d3a073fac959c995$var$__PRIVATE_logWarn("RestConnection", `RPC '${t}' ${s} failed with error: `, e, "url: ", o, "request:", r), e;
        });
    }
    g(t, e, r, n, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.P(t, e, r, n, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ I(t, e, r) {
        t["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $d3a073fac959c995$var$d;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e && e.headers.forEach((e, r)=>t[r] = e), r && r.headers.forEach((e, r)=>t[r] = e);
    }
    V(t, e) {
        const r = $d3a073fac959c995$var$O[t];
        return `${this.m}/v1/${e}:${r}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
} {
    /**
     * @param databaseInfo - The connection info.
     * @param fetchImpl - `fetch` or a Polyfill that implements the fetch API.
     */ constructor(t, e){
        super(t), this.F = e;
    }
    v(t, e) {
        throw new Error("Not supported by FetchConnection");
    }
    async p(t, e, r, n) {
        var i;
        const s = JSON.stringify(n);
        let o;
        try {
            o = await this.F(e, {
                method: "POST",
                headers: r,
                body: s
            });
        } catch (t) {
            const e = t;
            throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$__PRIVATE_mapCodeFromHttpStatus(e.status), "Request failed with error: " + e.statusText);
        }
        if (!o.ok) {
            let t = await o.json();
            Array.isArray(t) && (t = t[0]);
            const e = null === (i = null == t ? void 0 : t.error) || void 0 === i ? void 0 : i.message;
            throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$__PRIVATE_mapCodeFromHttpStatus(o.status), `Request failed with error: ${null != e ? e : o.statusText}`);
        }
        return o.json();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the HTTP connection for the REST API. */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $d3a073fac959c995$var$__PRIVATE_AggregateImpl {
    constructor(t, e, r){
        this.alias = t, this.aggregateType = e, this.fieldPath = r;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $d3a073fac959c995$var$__PRIVATE_randomBytes(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), r = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(r);
    else // Falls back to Math.random
    for(let e = 0; e < t; e++)r[e] = Math.floor(256 * Math.random());
    return r;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $d3a073fac959c995$var$__PRIVATE_AutoId {
    static newId() {
        // Alphanumeric characters
        const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length;
        // The largest byte value that is a multiple of `char.length`.
        let r = "";
        for(; r.length < 20;){
            const n = $d3a073fac959c995$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < n.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            r.length < 20 && n[i] < e && (r += t.charAt(n[i] % t.length));
        }
        return r;
    }
}
function $d3a073fac959c995$var$__PRIVATE_primitiveComparator(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $d3a073fac959c995$var$__PRIVATE_arrayEquals(t, e, r) {
    return t.length === e.length && t.every((t, n)=>r(t, e[n]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d3a073fac959c995$var$__PRIVATE_objectSize(t) {
    let e = 0;
    for(const r in t)Object.prototype.hasOwnProperty.call(t, r) && e++;
    return e;
}
function $d3a073fac959c995$var$forEach(t, e) {
    for(const r in t)Object.prototype.hasOwnProperty.call(t, r) && e(r, t[r]);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $d3a073fac959c995$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $d3a073fac959c995$var$ByteString {
    constructor(t){
        this.binaryString = t;
    }
    static fromBase64String(t) {
        const e = function __PRIVATE_decodeBase64(t) {
            try {
                return atob(t);
            } catch (t) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && t instanceof DOMException ? new $d3a073fac959c995$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + t) : t;
            }
        }(t);
        return new $d3a073fac959c995$var$ByteString(e);
    }
    static fromUint8Array(t) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const e = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(t) {
            let e = "";
            for(let r = 0; r < t.length; ++r)e += String.fromCharCode(t[r]);
            return e;
        }(t);
        return new $d3a073fac959c995$var$ByteString(e);
    }
    [Symbol.iterator]() {
        let t = 0;
        return {
            next: ()=>t < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(t++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(t) {
            return btoa(t);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(t) {
            const e = new Uint8Array(t.length);
            for(let r = 0; r < t.length; r++)e[r] = t.charCodeAt(r);
            return e;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(t) {
        return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(this.binaryString, t.binaryString);
    }
    isEqual(t) {
        return this.binaryString === t.binaryString;
    }
}
$d3a073fac959c995$var$ByteString.EMPTY_BYTE_STRING = new $d3a073fac959c995$var$ByteString("");
const $d3a073fac959c995$var$$ = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($d3a073fac959c995$var$__PRIVATE_hardAssert(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let e = 0;
        const r = $d3a073fac959c995$var$$.exec(t);
        if ($d3a073fac959c995$var$__PRIVATE_hardAssert(!!r), r[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let t = r[1];
            t = (t + "000000000").substr(0, 9), e = Number(t);
        }
        // Parse the date to get the seconds.
        const n = new Date(t);
        return {
            seconds: Math.floor(n.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.seconds),
        nanos: $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $d3a073fac959c995$var$__PRIVATE_normalizeByteString(t) {
    return "string" == typeof t ? $d3a073fac959c995$var$ByteString.fromBase64String(t) : $d3a073fac959c995$var$ByteString.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $d3a073fac959c995$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ e){
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Timestamp seconds out of range: " + t);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $d3a073fac959c995$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(t) {
        return $d3a073fac959c995$export$d9bcbd5e1ff81430.fromMillis(t.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(t) {
        const e = Math.floor(t / 1e3), r = Math.floor(1e6 * (t - 1e3 * e));
        return new $d3a073fac959c995$export$d9bcbd5e1ff81430(e, r);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(t) {
        return this.seconds === t.seconds ? $d3a073fac959c995$var$__PRIVATE_primitiveComparator(this.nanoseconds, t.nanoseconds) : $d3a073fac959c995$var$__PRIVATE_primitiveComparator(this.seconds, t.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $d3a073fac959c995$var$__PRIVATE_isServerTimestamp(t) {
    var e, r;
    return "server_timestamp" === (null === (r = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === r ? void 0 : r.stringValue);
}
/**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $d3a073fac959c995$var$__PRIVATE_getPreviousValue(t) {
    const e = t.mapValue.fields.__previous_value__;
    return $d3a073fac959c995$var$__PRIVATE_isServerTimestamp(e) ? $d3a073fac959c995$var$__PRIVATE_getPreviousValue(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $d3a073fac959c995$var$__PRIVATE_getLocalWriteTime(t) {
    const e = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $d3a073fac959c995$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$Q = {
    fields: {
        __type__: {
            stringValue: "__max__"
        }
    }
};
/** Extracts the backend's type order for the provided value. */ function $d3a073fac959c995$var$__PRIVATE_typeOrder(t) {
    return "nullValue" in t ? 0 /* TypeOrder.NullValue */  : "booleanValue" in t ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in t ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in t ? 5 /* TypeOrder.StringValue */  : "bytesValue" in t ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in t ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in t ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in t ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in t ? $d3a073fac959c995$var$__PRIVATE_isServerTimestamp(t) ? 4 /* TypeOrder.ServerTimestampValue */  : /** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function __PRIVATE_isMaxValue(t) {
        return "__max__" === (((t.mapValue || {}).fields || {}).__type__ || {}).stringValue;
    }(t) ? 9007199254740991 /* TypeOrder.MaxValue */  : /** Returns true if `value` is a VetorValue. */ function __PRIVATE_isVectorValue(t) {
        var e, r;
        return "__vector__" === (null === (r = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === r ? void 0 : r.stringValue);
    }(t) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $d3a073fac959c995$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $d3a073fac959c995$var$__PRIVATE_valueEquals(t, e) {
    if (t === e) return !0;
    const r = $d3a073fac959c995$var$__PRIVATE_typeOrder(t);
    if (r !== $d3a073fac959c995$var$__PRIVATE_typeOrder(e)) return !1;
    switch(r){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $d3a073fac959c995$var$__PRIVATE_getLocalWriteTime(t).isEqual($d3a073fac959c995$var$__PRIVATE_getLocalWriteTime(e));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                const r = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(t.timestampValue), n = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(e.timestampValue);
                return r.seconds === n.seconds && r.nanos === n.nanos;
            }(t, e);
        case 5 /* TypeOrder.StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(t, e) {
                return $d3a073fac959c995$var$__PRIVATE_normalizeByteString(t.bytesValue).isEqual($d3a073fac959c995$var$__PRIVATE_normalizeByteString(e.bytesValue));
            }(t, e);
        case 7 /* TypeOrder.RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(t, e) {
                return $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) === $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) && $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude) === $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.integerValue) === $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    const r = $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.doubleValue), n = $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.doubleValue);
                    return r === n ? $d3a073fac959c995$var$__PRIVATE_isNegativeZero(r) === $d3a073fac959c995$var$__PRIVATE_isNegativeZero(n) : isNaN(r) && isNaN(n);
                }
                return !1;
            }(t, e);
        case 9 /* TypeOrder.ArrayValue */ :
            return $d3a073fac959c995$var$__PRIVATE_arrayEquals(t.arrayValue.values || [], e.arrayValue.values || [], $d3a073fac959c995$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(t, e) {
                const r = t.mapValue.fields || {}, n = e.mapValue.fields || {};
                if ($d3a073fac959c995$var$__PRIVATE_objectSize(r) !== $d3a073fac959c995$var$__PRIVATE_objectSize(n)) return !1;
                for(const t in r)if (r.hasOwnProperty(t) && (void 0 === n[t] || !$d3a073fac959c995$var$__PRIVATE_valueEquals(r[t], n[t]))) return !1;
                return !0;
            }(t, e);
        default:
            return $d3a073fac959c995$var$fail();
    }
}
function $d3a073fac959c995$var$__PRIVATE_arrayValueContains(t, e) {
    return void 0 !== (t.values || []).find((t)=>$d3a073fac959c995$var$__PRIVATE_valueEquals(t, e));
}
function $d3a073fac959c995$var$__PRIVATE_valueCompare(t, e) {
    if (t === e) return 0;
    const r = $d3a073fac959c995$var$__PRIVATE_typeOrder(t), n = $d3a073fac959c995$var$__PRIVATE_typeOrder(e);
    if (r !== n) return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(r, n);
    switch(r){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(t.booleanValue, e.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(t, e) {
                const r = $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue), n = $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
                return r < n ? -1 : r > n ? 1 : r === n ? 0 : // one or both are NaN.
                isNaN(r) ? isNaN(n) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TypeOrder.TimestampValue */ :
            return $d3a073fac959c995$var$__PRIVATE_compareTimestamps(t.timestampValue, e.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $d3a073fac959c995$var$__PRIVATE_compareTimestamps($d3a073fac959c995$var$__PRIVATE_getLocalWriteTime(t), $d3a073fac959c995$var$__PRIVATE_getLocalWriteTime(e));
        case 5 /* TypeOrder.StringValue */ :
            return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(t.stringValue, e.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(t, e) {
                const r = $d3a073fac959c995$var$__PRIVATE_normalizeByteString(t), n = $d3a073fac959c995$var$__PRIVATE_normalizeByteString(e);
                return r.compareTo(n);
            }(t.bytesValue, e.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(t, e) {
                const r = t.split("/"), n = e.split("/");
                for(let t = 0; t < r.length && t < n.length; t++){
                    const e = $d3a073fac959c995$var$__PRIVATE_primitiveComparator(r[t], n[t]);
                    if (0 !== e) return e;
                }
                return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(r.length, n.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(t, e) {
                const r = $d3a073fac959c995$var$__PRIVATE_primitiveComparator($d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.latitude), $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.latitude));
                if (0 !== r) return r;
                return $d3a073fac959c995$var$__PRIVATE_primitiveComparator($d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.longitude), $d3a073fac959c995$var$__PRIVATE_normalizeNumber(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $d3a073fac959c995$var$__PRIVATE_compareArrays(t.arrayValue, e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(t, e) {
                var r, n, i, s;
                const o = t.fields || {}, a = e.fields || {}, u = null === (r = o.value) || void 0 === r ? void 0 : r.arrayValue, _ = null === (n = a.value) || void 0 === n ? void 0 : n.arrayValue, c = $d3a073fac959c995$var$__PRIVATE_primitiveComparator((null === (i = null == u ? void 0 : u.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == _ ? void 0 : _.values) || void 0 === s ? void 0 : s.length) || 0);
                if (0 !== c) return c;
                return $d3a073fac959c995$var$__PRIVATE_compareArrays(u, _);
            }(t.mapValue, e.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(t, e) {
                if (t === $d3a073fac959c995$var$Q && e === $d3a073fac959c995$var$Q) return 0;
                if (t === $d3a073fac959c995$var$Q) return 1;
                if (e === $d3a073fac959c995$var$Q) return -1;
                const r = t.fields || {}, n = Object.keys(r), i = e.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                n.sort(), s.sort();
                for(let t = 0; t < n.length && t < s.length; ++t){
                    const e = $d3a073fac959c995$var$__PRIVATE_primitiveComparator(n[t], s[t]);
                    if (0 !== e) return e;
                    const o = $d3a073fac959c995$var$__PRIVATE_valueCompare(r[n[t]], i[s[t]]);
                    if (0 !== o) return o;
                }
                return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(n.length, s.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $d3a073fac959c995$var$fail();
    }
}
function $d3a073fac959c995$var$__PRIVATE_compareTimestamps(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(t, e);
    const r = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(t), n = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(e), i = $d3a073fac959c995$var$__PRIVATE_primitiveComparator(r.seconds, n.seconds);
    return 0 !== i ? i : $d3a073fac959c995$var$__PRIVATE_primitiveComparator(r.nanos, n.nanos);
}
function $d3a073fac959c995$var$__PRIVATE_compareArrays(t, e) {
    const r = t.values || [], n = e.values || [];
    for(let t = 0; t < r.length && t < n.length; ++t){
        const e = $d3a073fac959c995$var$__PRIVATE_valueCompare(r[t], n[t]);
        if (e) return e;
    }
    return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(r.length, n.length);
}
function $d3a073fac959c995$var$__PRIVATE_refValue(t, e) {
    return {
        referenceValue: `projects/${t.projectId}/databases/${t.database}/documents/${e.path.canonicalString()}`
    };
}
/** Returns true if `value` is an ArrayValue. */ function $d3a073fac959c995$var$isArray(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $d3a073fac959c995$var$__PRIVATE_isNullValue(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $d3a073fac959c995$var$__PRIVATE_isNanValue(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $d3a073fac959c995$var$__PRIVATE_isMapValue(t) {
    return !!t && "mapValue" in t;
}
function $d3a073fac959c995$var$__PRIVATE_deepClone(t) {
    if (t.geoPointValue) return {
        geoPointValue: Object.assign({}, t.geoPointValue)
    };
    if (t.timestampValue && "object" == typeof t.timestampValue) return {
        timestampValue: Object.assign({}, t.timestampValue)
    };
    if (t.mapValue) {
        const e = {
            mapValue: {
                fields: {}
            }
        };
        return $d3a073fac959c995$var$forEach(t.mapValue.fields, (t, r)=>e.mapValue.fields[t] = $d3a073fac959c995$var$__PRIVATE_deepClone(r)), e;
    }
    if (t.arrayValue) {
        const e = {
            arrayValue: {
                values: []
            }
        };
        for(let r = 0; r < (t.arrayValue.values || []).length; ++r)e.arrayValue.values[r] = $d3a073fac959c995$var$__PRIVATE_deepClone(t.arrayValue.values[r]);
        return e;
    }
    return Object.assign({}, t);
}
class $d3a073fac959c995$var$Bound {
    constructor(t, e){
        this.position = t, this.inclusive = e;
    }
}
function $d3a073fac959c995$var$__PRIVATE_boundEquals(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.inclusive !== e.inclusive || t.position.length !== e.position.length) return !1;
    for(let r = 0; r < t.position.length; r++){
        if (!$d3a073fac959c995$var$__PRIVATE_valueEquals(t.position[r], e.position[r])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d3a073fac959c995$var$Filter {
}
class $d3a073fac959c995$var$FieldFilter extends $d3a073fac959c995$var$Filter {
    constructor(t, e, r){
        super(), this.field = t, this.op = e, this.value = r;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e, r) {
        return t.isKeyField() ? "in" /* Operator.IN */  === e || "not-in" /* Operator.NOT_IN */  === e ? this.createKeyFieldInFilter(t, e, r) : new $d3a073fac959c995$var$__PRIVATE_KeyFieldFilter(t, e, r) : "array-contains" /* Operator.ARRAY_CONTAINS */  === e ? new $d3a073fac959c995$var$__PRIVATE_ArrayContainsFilter(t, r) : "in" /* Operator.IN */  === e ? new $d3a073fac959c995$var$__PRIVATE_InFilter(t, r) : "not-in" /* Operator.NOT_IN */  === e ? new $d3a073fac959c995$var$__PRIVATE_NotInFilter(t, r) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e ? new $d3a073fac959c995$var$__PRIVATE_ArrayContainsAnyFilter(t, r) : new $d3a073fac959c995$var$FieldFilter(t, e, r);
    }
    static createKeyFieldInFilter(t, e, r) {
        return "in" /* Operator.IN */  === e ? new $d3a073fac959c995$var$__PRIVATE_KeyFieldInFilter(t, r) : new $d3a073fac959c995$var$__PRIVATE_KeyFieldNotInFilter(t, r);
    }
    matches(t) {
        const e = t.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== e && this.matchesComparison($d3a073fac959c995$var$__PRIVATE_valueCompare(e, this.value)) : null !== e && $d3a073fac959c995$var$__PRIVATE_typeOrder(this.value) === $d3a073fac959c995$var$__PRIVATE_typeOrder(e) && this.matchesComparison($d3a073fac959c995$var$__PRIVATE_valueCompare(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(t) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return t < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === t;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* Operator.GREATER_THAN */ :
                return t > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $d3a073fac959c995$var$fail();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $d3a073fac959c995$var$CompositeFilter extends $d3a073fac959c995$var$Filter {
    constructor(t, e){
        super(), this.filters = t, this.op = e, this.D = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e) {
        return new $d3a073fac959c995$var$CompositeFilter(t, e);
    }
    matches(t) {
        return function __PRIVATE_compositeFilterIsConjunction(t) {
            return "and" /* CompositeOperator.AND */  === t.op;
        }(this) ? void 0 === this.filters.find((e)=>!e.matches(t)) : void 0 !== this.filters.find((e)=>e.matches(t));
    }
    getFlattenedFilters() {
        return null !== this.D || (this.D = this.filters.reduce((t, e)=>t.concat(e.getFlattenedFilters()), [])), this.D;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $d3a073fac959c995$var$__PRIVATE_filterEquals(t, e) {
    return t instanceof $d3a073fac959c995$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(t, e) {
        return e instanceof $d3a073fac959c995$var$FieldFilter && t.op === e.op && t.field.isEqual(e.field) && $d3a073fac959c995$var$__PRIVATE_valueEquals(t.value, e.value);
    }(t, e) : t instanceof $d3a073fac959c995$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(t, e) {
        if (e instanceof $d3a073fac959c995$var$CompositeFilter && t.op === e.op && t.filters.length === e.filters.length) return t.filters.reduce((t, r, n)=>t && $d3a073fac959c995$var$__PRIVATE_filterEquals(r, e.filters[n]), !0);
        return !1;
    }(t, e) : void $d3a073fac959c995$var$fail();
}
class $d3a073fac959c995$var$__PRIVATE_KeyFieldFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e, r){
        super(t, e, r), this.key = $d3a073fac959c995$var$DocumentKey.fromName(r.referenceValue);
    }
    matches(t) {
        const e = $d3a073fac959c995$var$DocumentKey.comparator(t.key, this.key);
        return this.matchesComparison(e);
    }
}
/** Filter that matches on key fields within an array. */ class $d3a073fac959c995$var$__PRIVATE_KeyFieldInFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e){
        super(t, "in" /* Operator.IN */ , e), this.keys = $d3a073fac959c995$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , e);
    }
    matches(t) {
        return this.keys.some((e)=>e.isEqual(t.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $d3a073fac959c995$var$__PRIVATE_KeyFieldNotInFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e){
        super(t, "not-in" /* Operator.NOT_IN */ , e), this.keys = $d3a073fac959c995$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , e);
    }
    matches(t) {
        return !this.keys.some((e)=>e.isEqual(t.key));
    }
}
function $d3a073fac959c995$var$__PRIVATE_extractDocumentKeysFromArrayValue(t, e) {
    var r;
    return ((null === (r = e.arrayValue) || void 0 === r ? void 0 : r.values) || []).map((t)=>$d3a073fac959c995$var$DocumentKey.fromName(t.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $d3a073fac959c995$var$__PRIVATE_ArrayContainsFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e){
        super(t, "array-contains" /* Operator.ARRAY_CONTAINS */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return $d3a073fac959c995$var$isArray(e) && $d3a073fac959c995$var$__PRIVATE_arrayValueContains(e.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $d3a073fac959c995$var$__PRIVATE_InFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e){
        super(t, "in" /* Operator.IN */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return null !== e && $d3a073fac959c995$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e);
    }
}
/** A Filter that implements the not-in operator. */ class $d3a073fac959c995$var$__PRIVATE_NotInFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e){
        super(t, "not-in" /* Operator.NOT_IN */ , e);
    }
    matches(t) {
        if ($d3a073fac959c995$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const e = t.data.field(this.field);
        return null !== e && !$d3a073fac959c995$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $d3a073fac959c995$var$__PRIVATE_ArrayContainsAnyFilter extends $d3a073fac959c995$var$FieldFilter {
    constructor(t, e){
        super(t, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return !(!$d3a073fac959c995$var$isArray(e) || !e.arrayValue.values) && e.arrayValue.values.some((t)=>$d3a073fac959c995$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t));
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $d3a073fac959c995$var$OrderBy {
    constructor(t, e = "asc" /* Direction.ASCENDING */ ){
        this.field = t, this.dir = e;
    }
}
function $d3a073fac959c995$var$__PRIVATE_orderByEquals(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $d3a073fac959c995$var$SnapshotVersion {
    constructor(t){
        this.timestamp = t;
    }
    static fromTimestamp(t) {
        return new $d3a073fac959c995$var$SnapshotVersion(t);
    }
    static min() {
        return new $d3a073fac959c995$var$SnapshotVersion(new $d3a073fac959c995$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $d3a073fac959c995$var$SnapshotVersion(new $d3a073fac959c995$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(t) {
        return this.timestamp._compareTo(t.timestamp);
    }
    isEqual(t) {
        return this.timestamp.isEqual(t.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $d3a073fac959c995$var$SortedMap {
    constructor(t, e){
        this.comparator = t, this.root = e || $d3a073fac959c995$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(t, e) {
        return new $d3a073fac959c995$var$SortedMap(this.comparator, this.root.insert(t, e, this.comparator).copy(null, null, $d3a073fac959c995$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(t) {
        return new $d3a073fac959c995$var$SortedMap(this.comparator, this.root.remove(t, this.comparator).copy(null, null, $d3a073fac959c995$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(t) {
        let e = this.root;
        for(; !e.isEmpty();){
            const r = this.comparator(t, e.key);
            if (0 === r) return e.value;
            r < 0 ? e = e.left : r > 0 && (e = e.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(t) {
        // Number of nodes that were pruned when descending right
        let e = 0, r = this.root;
        for(; !r.isEmpty();){
            const n = this.comparator(t, r.key);
            if (0 === n) return e + r.left.size;
            n < 0 ? r = r.left : // Count all nodes left of the node plus the node itself
            (e += r.left.size + 1, r = r.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.root.inorderTraversal(t);
    }
    forEach(t) {
        this.inorderTraversal((e, r)=>(t(e, r), !1));
    }
    toString() {
        const t = [];
        return this.inorderTraversal((e, r)=>(t.push(`${e}:${r}`), !1)), `{${t.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.root.reverseTraversal(t);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $d3a073fac959c995$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(t) {
        return new $d3a073fac959c995$var$SortedMapIterator(this.root, t, this.comparator, !1);
    }
    getReverseIterator() {
        return new $d3a073fac959c995$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(t) {
        return new $d3a073fac959c995$var$SortedMapIterator(this.root, t, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $d3a073fac959c995$var$SortedMapIterator {
    constructor(t, e, r, n){
        this.isReverse = n, this.nodeStack = [];
        let i = 1;
        for(; !t.isEmpty();)if (i = e ? r(t.key, e) : 1, // flip the comparison if we're going in reverse
        e && n && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
        }
    }
    getNext() {
        let t = this.nodeStack.pop();
        const e = {
            key: t.key,
            value: t.value
        };
        if (this.isReverse) for(t = t.left; !t.isEmpty();)this.nodeStack.push(t), t = t.right;
        else for(t = t.right; !t.isEmpty();)this.nodeStack.push(t), t = t.left;
        return e;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const t = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $d3a073fac959c995$var$LLRBNode {
    constructor(t, e, r, n, i){
        this.key = t, this.value = e, this.color = null != r ? r : $d3a073fac959c995$var$LLRBNode.RED, this.left = null != n ? n : $d3a073fac959c995$var$LLRBNode.EMPTY, this.right = null != i ? i : $d3a073fac959c995$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(t, e, r, n, i) {
        return new $d3a073fac959c995$var$LLRBNode(null != t ? t : this.key, null != e ? e : this.value, null != r ? r : this.color, null != n ? n : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(t, e, r) {
        let n = this;
        const i = r(t, n.key);
        return n = i < 0 ? n.copy(null, null, null, n.left.insert(t, e, r), null) : 0 === i ? n.copy(null, e, null, null, null) : n.copy(null, null, null, null, n.right.insert(t, e, r)), n.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $d3a073fac959c995$var$LLRBNode.EMPTY;
        let t = this;
        return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(t, e) {
        let r, n = this;
        if (e(t, n.key) < 0) n.left.isEmpty() || n.left.isRed() || n.left.left.isRed() || (n = n.moveRedLeft()), n = n.copy(null, null, null, n.left.remove(t, e), null);
        else {
            if (n.left.isRed() && (n = n.rotateRight()), n.right.isEmpty() || n.right.isRed() || n.right.left.isRed() || (n = n.moveRedRight()), 0 === e(t, n.key)) {
                if (n.right.isEmpty()) return $d3a073fac959c995$var$LLRBNode.EMPTY;
                r = n.right.min(), n = n.copy(r.key, r.value, null, null, n.right.removeMin());
            }
            n = n.copy(null, null, null, null, n.right.remove(t, e));
        }
        return n.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let t = this;
        return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }
    moveRedLeft() {
        let t = this.colorFlip();
        return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
    }
    moveRedRight() {
        let t = this.colorFlip();
        return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
    }
    rotateLeft() {
        const t = this.copy(null, null, $d3a073fac959c995$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, t, null);
    }
    rotateRight() {
        const t = this.copy(null, null, $d3a073fac959c995$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, t);
    }
    colorFlip() {
        const t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }
    // For testing.
    checkMaxDepth() {
        const t = this.check();
        return Math.pow(2, t) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $d3a073fac959c995$var$fail();
        if (this.right.isRed()) throw $d3a073fac959c995$var$fail();
        const t = this.left.check();
        if (t !== this.right.check()) throw $d3a073fac959c995$var$fail();
        return t + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$d3a073fac959c995$var$LLRBNode.EMPTY = null, $d3a073fac959c995$var$LLRBNode.RED = !0, $d3a073fac959c995$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$d3a073fac959c995$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $d3a073fac959c995$var$fail();
    }
    get value() {
        throw $d3a073fac959c995$var$fail();
    }
    get color() {
        throw $d3a073fac959c995$var$fail();
    }
    get left() {
        throw $d3a073fac959c995$var$fail();
    }
    get right() {
        throw $d3a073fac959c995$var$fail();
    }
    // Returns a copy of the current node.
    copy(t, e, r, n, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(t, e, r) {
        return new $d3a073fac959c995$var$LLRBNode(t, e);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(t, e) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(t) {
        return !1;
    }
    reverseTraversal(t) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $d3a073fac959c995$var$SortedSet {
    constructor(t){
        this.comparator = t, this.data = new $d3a073fac959c995$var$SortedMap(this.comparator);
    }
    has(t) {
        return null !== this.data.get(t);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(t) {
        return this.data.indexOf(t);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(t) {
        this.data.inorderTraversal((e, r)=>(t(e), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(t, e) {
        const r = this.data.getIteratorFrom(t[0]);
        for(; r.hasNext();){
            const n = r.getNext();
            if (this.comparator(n.key, t[1]) >= 0) return;
            e(n.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(t, e) {
        let r;
        for(r = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); r.hasNext();){
            if (!t(r.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(t) {
        const e = this.data.getIteratorFrom(t);
        return e.hasNext() ? e.getNext().key : null;
    }
    getIterator() {
        return new $d3a073fac959c995$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(t) {
        return new $d3a073fac959c995$var$SortedSetIterator(this.data.getIteratorFrom(t));
    }
    /** Inserts or updates an element */ add(t) {
        return this.copy(this.data.remove(t).insert(t, !0));
    }
    /** Deletes an element */ delete(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(t) {
        let e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach((t)=>{
            e = e.add(t);
        }), e;
    }
    isEqual(t) {
        if (!(t instanceof $d3a073fac959c995$var$SortedSet)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.data.getIterator(), r = t.data.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, n = r.getNext().key;
            if (0 !== this.comparator(t, n)) return !1;
        }
        return !0;
    }
    toArray() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e);
        }), t;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>t.push(e)), "SortedSet(" + t.toString() + ")";
    }
    copy(t) {
        const e = new $d3a073fac959c995$var$SortedSet(this.comparator);
        return e.data = t, e;
    }
}
class $d3a073fac959c995$var$SortedSetIterator {
    constructor(t){
        this.iter = t;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $d3a073fac959c995$var$FieldMask {
    constructor(t){
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($d3a073fac959c995$var$FieldPath$1.comparator);
    }
    static empty() {
        return new $d3a073fac959c995$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(t) {
        let e = new $d3a073fac959c995$var$SortedSet($d3a073fac959c995$var$FieldPath$1.comparator);
        for (const t of this.fields)e = e.add(t);
        for (const r of t)e = e.add(r);
        return new $d3a073fac959c995$var$FieldMask(e.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(t) {
        for (const e of this.fields)if (e.isPrefixOf(t)) return !0;
        return !1;
    }
    isEqual(t) {
        return $d3a073fac959c995$var$__PRIVATE_arrayEquals(this.fields, t.fields, (t, e)=>t.isEqual(e));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $d3a073fac959c995$var$ObjectValue {
    constructor(t){
        this.value = t;
    }
    static empty() {
        return new $d3a073fac959c995$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(t) {
        if (t.isEmpty()) return this.value;
        {
            let e = this.value;
            for(let r = 0; r < t.length - 1; ++r)if (e = (e.mapValue.fields || {})[t.get(r)], !$d3a073fac959c995$var$__PRIVATE_isMapValue(e)) return null;
            return e = (e.mapValue.fields || {})[t.lastSegment()], e || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(t, e) {
        this.getFieldsMap(t.popLast())[t.lastSegment()] = $d3a073fac959c995$var$__PRIVATE_deepClone(e);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(t) {
        let e = $d3a073fac959c995$var$FieldPath$1.emptyPath(), r = {}, n = [];
        t.forEach((t, i)=>{
            if (!e.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const t = this.getFieldsMap(e);
                this.applyChanges(t, r, n), r = {}, n = [], e = i.popLast();
            }
            t ? r[i.lastSegment()] = $d3a073fac959c995$var$__PRIVATE_deepClone(t) : n.push(i.lastSegment());
        });
        const i = this.getFieldsMap(e);
        this.applyChanges(i, r, n);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(t) {
        const e = this.field(t.popLast());
        $d3a073fac959c995$var$__PRIVATE_isMapValue(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }
    isEqual(t) {
        return $d3a073fac959c995$var$__PRIVATE_valueEquals(this.value, t.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(t) {
        let e = this.value;
        e.mapValue.fields || (e.mapValue = {
            fields: {}
        });
        for(let r = 0; r < t.length; ++r){
            let n = e.mapValue.fields[t.get(r)];
            $d3a073fac959c995$var$__PRIVATE_isMapValue(n) && n.mapValue.fields || (n = {
                mapValue: {
                    fields: {}
                }
            }, e.mapValue.fields[t.get(r)] = n), e = n;
        }
        return e.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(t, e, r) {
        $d3a073fac959c995$var$forEach(e, (e, r)=>t[e] = r);
        for (const e of r)delete t[e];
    }
    clone() {
        return new $d3a073fac959c995$var$ObjectValue($d3a073fac959c995$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $d3a073fac959c995$var$MutableDocument {
    constructor(t, e, r, n, i, s, o){
        this.key = t, this.documentType = e, this.version = r, this.readTime = n, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(t) {
        return new $d3a073fac959c995$var$MutableDocument(t, 0 /* DocumentType.INVALID */ , /* version */ $d3a073fac959c995$var$SnapshotVersion.min(), /* readTime */ $d3a073fac959c995$var$SnapshotVersion.min(), /* createTime */ $d3a073fac959c995$var$SnapshotVersion.min(), $d3a073fac959c995$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(t, e, r, n) {
        return new $d3a073fac959c995$var$MutableDocument(t, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ e, /* readTime */ $d3a073fac959c995$var$SnapshotVersion.min(), /* createTime */ r, n, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(t, e) {
        return new $d3a073fac959c995$var$MutableDocument(t, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ e, /* readTime */ $d3a073fac959c995$var$SnapshotVersion.min(), /* createTime */ $d3a073fac959c995$var$SnapshotVersion.min(), $d3a073fac959c995$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(t, e) {
        return new $d3a073fac959c995$var$MutableDocument(t, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ e, /* readTime */ $d3a073fac959c995$var$SnapshotVersion.min(), /* createTime */ $d3a073fac959c995$var$SnapshotVersion.min(), $d3a073fac959c995$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(t, e) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($d3a073fac959c995$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = t), this.version = t, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = e, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(t) {
        return this.version = t, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $d3a073fac959c995$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(t) {
        return this.version = t, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $d3a073fac959c995$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $d3a073fac959c995$var$SnapshotVersion.min(), this;
    }
    setReadTime(t) {
        return this.readTime = t, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$MutableDocument && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
    }
    mutableCopy() {
        return new $d3a073fac959c995$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $d3a073fac959c995$var$__PRIVATE_TargetImpl {
    constructor(t, e = null, r = [], n = [], i = null, s = null, o = null){
        this.path = t, this.collectionGroup = e, this.orderBy = r, this.filters = n, this.limit = i, this.startAt = s, this.endAt = o, this.C = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $d3a073fac959c995$var$__PRIVATE_newTarget(t, e = null, r = [], n = [], i = null, s = null, o = null) {
    return new $d3a073fac959c995$var$__PRIVATE_TargetImpl(t, e, r, n, i, s, o);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $d3a073fac959c995$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(t, e = null, r = [], n = [], i = null, s = "F" /* LimitType.First */ , o = null, a = null){
        this.path = t, this.collectionGroup = e, this.explicitOrderBy = r, this.filters = n, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = a, this.S = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.N = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.O = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query for a query that matches all documents at `path` */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $d3a073fac959c995$var$__PRIVATE_isCollectionGroupQuery(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $d3a073fac959c995$var$__PRIVATE_queryNormalizedOrderBy(t) {
    const e = $d3a073fac959c995$var$__PRIVATE_debugCast(t);
    if (null === e.S) {
        e.S = [];
        const t = new Set;
        // Any explicit order by fields should be added as is.
        for (const r of e.explicitOrderBy)e.S.push(r), t.add(r.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const r = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , n = // Returns the sorted set of inequality filter fields used in this query.
        function __PRIVATE_getInequalityFilterFields(t) {
            let e = new $d3a073fac959c995$var$SortedSet($d3a073fac959c995$var$FieldPath$1.comparator);
            return t.filters.forEach((t)=>{
                t.getFlattenedFilters().forEach((t)=>{
                    t.isInequality() && (e = e.add(t.field));
                });
            }), e;
        }(e);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        n.forEach((n)=>{
            t.has(n.canonicalString()) || n.isKeyField() || e.S.push(new $d3a073fac959c995$var$OrderBy(n, r));
        }), // Add the document key field to the last if it is not explicitly ordered.
        t.has($d3a073fac959c995$var$FieldPath$1.keyField().canonicalString()) || e.S.push(new $d3a073fac959c995$var$OrderBy($d3a073fac959c995$var$FieldPath$1.keyField(), r));
    }
    return e.S;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $d3a073fac959c995$var$__PRIVATE_queryToTarget(t) {
    const e = $d3a073fac959c995$var$__PRIVATE_debugCast(t);
    return e.N || (e.N = $d3a073fac959c995$var$__PRIVATE__queryToTarget(e, $d3a073fac959c995$var$__PRIVATE_queryNormalizedOrderBy(t))), e.N;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $d3a073fac959c995$var$__PRIVATE__queryToTarget(t, e) {
    if ("F" /* LimitType.First */  === t.limitType) return $d3a073fac959c995$var$__PRIVATE_newTarget(t.path, t.collectionGroup, e, t.filters, t.limit, t.startAt, t.endAt);
    {
        // Flip the orderBy directions since we want the last results
        e = e.map((t)=>{
            const e = "desc" /* Direction.DESCENDING */  === t.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $d3a073fac959c995$var$OrderBy(t.field, e);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const r = t.endAt ? new $d3a073fac959c995$var$Bound(t.endAt.position, t.endAt.inclusive) : null, n = t.startAt ? new $d3a073fac959c995$var$Bound(t.startAt.position, t.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $d3a073fac959c995$var$__PRIVATE_newTarget(t.path, t.collectionGroup, e, t.filters, t.limit, r, n);
    }
}
function $d3a073fac959c995$var$__PRIVATE_queryWithAddedFilter(t, e) {
    const r = t.filters.concat([
        e
    ]);
    return new $d3a073fac959c995$var$__PRIVATE_QueryImpl(t.path, t.collectionGroup, t.explicitOrderBy.slice(), r, t.limit, t.limitType, t.startAt, t.endAt);
}
function $d3a073fac959c995$var$__PRIVATE_queryEquals(t, e) {
    return function __PRIVATE_targetEquals(t, e) {
        if (t.limit !== e.limit) return !1;
        if (t.orderBy.length !== e.orderBy.length) return !1;
        for(let r = 0; r < t.orderBy.length; r++)if (!$d3a073fac959c995$var$__PRIVATE_orderByEquals(t.orderBy[r], e.orderBy[r])) return !1;
        if (t.filters.length !== e.filters.length) return !1;
        for(let r = 0; r < t.filters.length; r++)if (!$d3a073fac959c995$var$__PRIVATE_filterEquals(t.filters[r], e.filters[r])) return !1;
        return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$d3a073fac959c995$var$__PRIVATE_boundEquals(t.startAt, e.startAt) && $d3a073fac959c995$var$__PRIVATE_boundEquals(t.endAt, e.endAt);
    }($d3a073fac959c995$var$__PRIVATE_queryToTarget(t), $d3a073fac959c995$var$__PRIVATE_queryToTarget(e)) && t.limitType === e.limitType;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $d3a073fac959c995$var$__PRIVATE_toDouble(t, e) {
    if (t.useProto3Json) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $d3a073fac959c995$var$__PRIVATE_isNegativeZero(e) ? "-0" : e
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ /**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $d3a073fac959c995$var$toNumber(t, e) {
    return function isSafeInteger(t) {
        return "number" == typeof t && Number.isInteger(t) && !$d3a073fac959c995$var$__PRIVATE_isNegativeZero(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
    }(e) ? function __PRIVATE_toInteger(t) {
        return {
            integerValue: "" + t
        };
    }(e) : $d3a073fac959c995$var$__PRIVATE_toDouble(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $d3a073fac959c995$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/** Transforms a value into a server-generated timestamp. */ class $d3a073fac959c995$var$__PRIVATE_ServerTimestampTransform extends $d3a073fac959c995$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $d3a073fac959c995$var$__PRIVATE_ArrayUnionTransformOperation extends $d3a073fac959c995$var$TransformOperation {
    constructor(t){
        super(), this.elements = t;
    }
}
/** Transforms an array value via a remove operation. */ class $d3a073fac959c995$var$__PRIVATE_ArrayRemoveTransformOperation extends $d3a073fac959c995$var$TransformOperation {
    constructor(t){
        super(), this.elements = t;
    }
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $d3a073fac959c995$var$__PRIVATE_NumericIncrementTransformOperation extends $d3a073fac959c995$var$TransformOperation {
    constructor(t, e){
        super(), this.serializer = t, this.q = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $d3a073fac959c995$var$FieldTransform {
    constructor(t, e){
        this.field = t, this.transform = e;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $d3a073fac959c995$var$Precondition {
    constructor(t, e){
        this.updateTime = t, this.exists = e;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $d3a073fac959c995$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(t) {
        return new $d3a073fac959c995$var$Precondition(void 0, t);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(t) {
        return new $d3a073fac959c995$var$Precondition(t);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $d3a073fac959c995$var$Mutation {
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $d3a073fac959c995$var$__PRIVATE_SetMutation extends $d3a073fac959c995$var$Mutation {
    constructor(t, e, r, n = []){
        super(), this.key = t, this.value = e, this.precondition = r, this.fieldTransforms = n, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */ class $d3a073fac959c995$var$__PRIVATE_PatchMutation extends $d3a073fac959c995$var$Mutation {
    constructor(t, e, r, n, i = []){
        super(), this.key = t, this.data = e, this.fieldMask = r, this.precondition = n, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
/** A mutation that deletes the document at the given key. */ class $d3a073fac959c995$var$__PRIVATE_DeleteMutation extends $d3a073fac959c995$var$Mutation {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * A mutation that verifies the existence of the document at the given key with
 * the provided precondition.
 *
 * The `verify` operation is only used in Transactions, and this class serves
 * primarily to facilitate serialization into protos.
 */ class $d3a073fac959c995$var$__PRIVATE_VerifyMutation extends $d3a073fac959c995$var$Mutation {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$L = (()=>{
    const t = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return t;
})(), $d3a073fac959c995$var$M = (()=>{
    const t = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return t;
})(), $d3a073fac959c995$var$x = (()=>{
    const t = {
        and: "AND",
        or: "OR"
    };
    return t;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $d3a073fac959c995$var$JsonProtoSerializer {
    constructor(t, e){
        this.databaseId = t, this.useProto3Json = e;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $d3a073fac959c995$var$toTimestamp(t, e) {
    if (t.useProto3Json) return `${new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + e.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $d3a073fac959c995$var$__PRIVATE_toBytes(t, e) {
    return t.useProto3Json ? e.toBase64() : e.toUint8Array();
}
function $d3a073fac959c995$var$__PRIVATE_toVersion(t, e) {
    return $d3a073fac959c995$var$toTimestamp(t, e.toTimestamp());
}
function $d3a073fac959c995$var$__PRIVATE_fromVersion(t) {
    return $d3a073fac959c995$var$__PRIVATE_hardAssert(!!t), $d3a073fac959c995$var$SnapshotVersion.fromTimestamp(function fromTimestamp(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(t);
        return new $d3a073fac959c995$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }(t));
}
function $d3a073fac959c995$var$__PRIVATE_toResourceName(t, e) {
    return $d3a073fac959c995$var$__PRIVATE_toResourcePath(t, e).canonicalString();
}
function $d3a073fac959c995$var$__PRIVATE_toResourcePath(t, e) {
    const r = (function __PRIVATE_fullyQualifiedPrefixPath(t) {
        return new $d3a073fac959c995$var$ResourcePath([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents");
    return void 0 === e ? r : r.child(e);
}
function $d3a073fac959c995$var$__PRIVATE_toName(t, e) {
    return $d3a073fac959c995$var$__PRIVATE_toResourceName(t.databaseId, e.path);
}
function $d3a073fac959c995$var$fromName(t, e) {
    const r = function __PRIVATE_fromResourceName(t) {
        const e = $d3a073fac959c995$var$ResourcePath.fromString(t);
        return $d3a073fac959c995$var$__PRIVATE_hardAssert($d3a073fac959c995$var$__PRIVATE_isValidResourceName(e)), e;
    }(e);
    if (r.get(1) !== t.databaseId.projectId) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Tried to deserialize key from different project: " + r.get(1) + " vs " + t.databaseId.projectId);
    if (r.get(3) !== t.databaseId.database) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Tried to deserialize key from different database: " + r.get(3) + " vs " + t.databaseId.database);
    return new $d3a073fac959c995$var$DocumentKey(function __PRIVATE_extractLocalPathFromResourceName(t) {
        return $d3a073fac959c995$var$__PRIVATE_hardAssert(t.length > 4 && "documents" === t.get(4)), t.popFirst(5);
    }(r));
}
function $d3a073fac959c995$var$__PRIVATE_toMutationDocument(t, e, r) {
    return {
        name: $d3a073fac959c995$var$__PRIVATE_toName(t, e),
        fields: r.value.mapValue.fields
    };
}
function $d3a073fac959c995$var$__PRIVATE_fromBatchGetDocumentsResponse(t, e) {
    return "found" in e ? function __PRIVATE_fromFound(t, e) {
        $d3a073fac959c995$var$__PRIVATE_hardAssert(!!e.found), e.found.name, e.found.updateTime;
        const r = $d3a073fac959c995$var$fromName(t, e.found.name), n = $d3a073fac959c995$var$__PRIVATE_fromVersion(e.found.updateTime), i = e.found.createTime ? $d3a073fac959c995$var$__PRIVATE_fromVersion(e.found.createTime) : $d3a073fac959c995$var$SnapshotVersion.min(), s = new $d3a073fac959c995$var$ObjectValue({
            mapValue: {
                fields: e.found.fields
            }
        });
        return $d3a073fac959c995$var$MutableDocument.newFoundDocument(r, n, i, s);
    }(t, e) : "missing" in e ? function __PRIVATE_fromMissing(t, e) {
        $d3a073fac959c995$var$__PRIVATE_hardAssert(!!e.missing), $d3a073fac959c995$var$__PRIVATE_hardAssert(!!e.readTime);
        const r = $d3a073fac959c995$var$fromName(t, e.missing), n = $d3a073fac959c995$var$__PRIVATE_fromVersion(e.readTime);
        return $d3a073fac959c995$var$MutableDocument.newNoDocument(r, n);
    }(t, e) : $d3a073fac959c995$var$fail();
}
function $d3a073fac959c995$var$toMutation(t, e) {
    let r;
    if (e instanceof $d3a073fac959c995$var$__PRIVATE_SetMutation) r = {
        update: $d3a073fac959c995$var$__PRIVATE_toMutationDocument(t, e.key, e.value)
    };
    else if (e instanceof $d3a073fac959c995$var$__PRIVATE_DeleteMutation) r = {
        delete: $d3a073fac959c995$var$__PRIVATE_toName(t, e.key)
    };
    else if (e instanceof $d3a073fac959c995$var$__PRIVATE_PatchMutation) r = {
        update: $d3a073fac959c995$var$__PRIVATE_toMutationDocument(t, e.key, e.data),
        updateMask: $d3a073fac959c995$var$__PRIVATE_toDocumentMask(e.fieldMask)
    };
    else {
        if (!(e instanceof $d3a073fac959c995$var$__PRIVATE_VerifyMutation)) return $d3a073fac959c995$var$fail();
        r = {
            verify: $d3a073fac959c995$var$__PRIVATE_toName(t, e.key)
        };
    }
    return e.fieldTransforms.length > 0 && (r.updateTransforms = e.fieldTransforms.map((t)=>(function __PRIVATE_toFieldTransform(t, e) {
            const r = e.transform;
            if (r instanceof $d3a073fac959c995$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: e.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (r instanceof $d3a073fac959c995$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: e.field.canonicalString(),
                appendMissingElements: {
                    values: r.elements
                }
            };
            if (r instanceof $d3a073fac959c995$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: e.field.canonicalString(),
                removeAllFromArray: {
                    values: r.elements
                }
            };
            if (r instanceof $d3a073fac959c995$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: e.field.canonicalString(),
                increment: r.q
            };
            throw $d3a073fac959c995$var$fail();
        })(0, t))), e.precondition.isNone || (r.currentDocument = function __PRIVATE_toPrecondition(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $d3a073fac959c995$var$__PRIVATE_toVersion(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $d3a073fac959c995$var$fail();
    }(t, e.precondition)), r;
}
function $d3a073fac959c995$var$__PRIVATE_toQueryTarget(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const r = {
        structuredQuery: {}
    }, n = e.path;
    let i;
    null !== e.collectionGroup ? (i = n, r.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = n.popLast(), r.structuredQuery.from = [
        {
            collectionId: n.lastSegment()
        }
    ]), r.parent = function __PRIVATE_toQueryPath(t, e) {
        return $d3a073fac959c995$var$__PRIVATE_toResourceName(t.databaseId, e);
    }(t, i);
    const s = function __PRIVATE_toFilters(t) {
        if (0 === t.length) return;
        return $d3a073fac959c995$var$__PRIVATE_toFilter($d3a073fac959c995$var$CompositeFilter.create(t, "and" /* CompositeOperator.AND */ ));
    }(e.filters);
    s && (r.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(t) {
        if (0 === t.length) return;
        return t.map((t)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(t) {
                return {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.field),
                    direction: $d3a073fac959c995$var$__PRIVATE_toDirection(t.dir)
                };
            })(t));
    }(e.orderBy);
    o && (r.structuredQuery.orderBy = o);
    const a = function __PRIVATE_toInt32Proto(t, e) {
        return t.useProto3Json || $d3a073fac959c995$var$__PRIVATE_isNullOrUndefined(e) ? e : {
            value: e
        };
    }(t, e.limit);
    return null !== a && (r.structuredQuery.limit = a), e.startAt && (r.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(t) {
        return {
            before: t.inclusive,
            values: t.position
        };
    }(e.startAt)), e.endAt && (r.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(t) {
        return {
            before: !t.inclusive,
            values: t.position
        };
    }(e.endAt)), {
        B: r,
        parent: i
    };
}
function $d3a073fac959c995$var$__PRIVATE_toDirection(t) {
    return $d3a073fac959c995$var$L[t];
}
// visible for testing
function $d3a073fac959c995$var$__PRIVATE_toOperatorName(t) {
    return $d3a073fac959c995$var$M[t];
}
function $d3a073fac959c995$var$__PRIVATE_toCompositeOperatorName(t) {
    return $d3a073fac959c995$var$x[t];
}
function $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t) {
    return {
        fieldPath: t.canonicalString()
    };
}
function $d3a073fac959c995$var$__PRIVATE_toFilter(t) {
    return t instanceof $d3a073fac959c995$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(t) {
        if ("==" /* Operator.EQUAL */  === t.op) {
            if ($d3a073fac959c995$var$__PRIVATE_isNanValue(t.value)) return {
                unaryFilter: {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.field),
                    op: "IS_NAN"
                }
            };
            if ($d3a073fac959c995$var$__PRIVATE_isNullValue(t.value)) return {
                unaryFilter: {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === t.op) {
            if ($d3a073fac959c995$var$__PRIVATE_isNanValue(t.value)) return {
                unaryFilter: {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($d3a073fac959c995$var$__PRIVATE_isNullValue(t.value)) return {
                unaryFilter: {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.field),
                op: $d3a073fac959c995$var$__PRIVATE_toOperatorName(t.op),
                value: t.value
            }
        };
    }(t) : t instanceof $d3a073fac959c995$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(t) {
        const e = t.getFilters().map((t)=>$d3a073fac959c995$var$__PRIVATE_toFilter(t));
        if (1 === e.length) return e[0];
        return {
            compositeFilter: {
                op: $d3a073fac959c995$var$__PRIVATE_toCompositeOperatorName(t.op),
                filters: e
            }
        };
    }(t) : $d3a073fac959c995$var$fail();
}
function $d3a073fac959c995$var$__PRIVATE_toDocumentMask(t) {
    const e = [];
    return t.fields.forEach((t)=>e.push(t.canonicalString())), {
        fieldPaths: e
    };
}
function $d3a073fac959c995$var$__PRIVATE_isValidResourceName(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d3a073fac959c995$var$__PRIVATE_newSerializer(t) {
    return new $d3a073fac959c995$var$JsonProtoSerializer(t, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $d3a073fac959c995$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ r = 1e3, n = 1.5, i = 6e4){
        this.$ = t, this.timerId = e, this.L = r, this.M = n, this.k = i, this.U = 0, this.j = null, /** The last backoff attempt, as epoch milliseconds. */ this.W = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.U = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ K() {
        this.U = this.k;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ G(t) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const e = Math.floor(this.U + this.H()), r = Math.max(0, Date.now() - this.W), n = Math.max(0, e - r);
        // Guard against lastAttemptTime being in the future due to a clock change.
        n > 0 && $d3a073fac959c995$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${n} ms (base delay: ${this.U} ms, delay with jitter: ${e} ms, last attempt: ${r} ms ago)`), this.j = this.$.enqueueAfterDelay(this.timerId, n, ()=>(this.W = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.U *= this.M, this.U < this.L && (this.U = this.L), this.U > this.k && (this.U = this.k);
    }
    J() {
        null !== this.j && (this.j.skipDelay(), this.j = null);
    }
    cancel() {
        null !== this.j && (this.j.cancel(), this.j = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ H() {
        return (Math.random() - .5) * this.U;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $d3a073fac959c995$var$__PRIVATE_DatastoreImpl extends class Datastore {
} {
    constructor(t, e, r, n){
        super(), this.authCredentials = t, this.appCheckCredentials = e, this.connection = r, this.serializer = n, this.Y = !1;
    }
    Z() {
        if (this.Y) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$w, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ P(t, e, r, n) {
        return this.Z(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.P(t, $d3a073fac959c995$var$__PRIVATE_toResourcePath(e, r), n, i, s)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $d3a073fac959c995$var$p && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$A, t.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ g(t, e, r, n, i) {
        return this.Z(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.g(t, $d3a073fac959c995$var$__PRIVATE_toResourcePath(e, r), n, s, o, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $d3a073fac959c995$var$p && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$A, t.toString());
        });
    }
    terminate() {
        this.Y = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
async function $d3a073fac959c995$var$__PRIVATE_invokeCommitRpc(t, e) {
    const r = $d3a073fac959c995$var$__PRIVATE_debugCast(t), n = {
        writes: e.map((t)=>$d3a073fac959c995$var$toMutation(r.serializer, t))
    };
    await r.P("Commit", r.serializer.databaseId, $d3a073fac959c995$var$ResourcePath.emptyPath(), n);
}
async function $d3a073fac959c995$var$__PRIVATE_invokeBatchGetDocumentsRpc(t, e) {
    const r = $d3a073fac959c995$var$__PRIVATE_debugCast(t), n = {
        documents: e.map((t)=>$d3a073fac959c995$var$__PRIVATE_toName(r.serializer, t))
    }, i = await r.g("BatchGetDocuments", r.serializer.databaseId, $d3a073fac959c995$var$ResourcePath.emptyPath(), n, e.length), s = new Map;
    i.forEach((t)=>{
        const e = $d3a073fac959c995$var$__PRIVATE_fromBatchGetDocumentsResponse(r.serializer, t);
        s.set(e.key.toString(), e);
    });
    const o = [];
    return e.forEach((t)=>{
        const e = s.get(t.toString());
        $d3a073fac959c995$var$__PRIVATE_hardAssert(!!e), o.push(e);
    }), o;
}
async function $d3a073fac959c995$var$__PRIVATE_invokeRunQueryRpc(t, e) {
    const r = $d3a073fac959c995$var$__PRIVATE_debugCast(t), { B: n, parent: i } = $d3a073fac959c995$var$__PRIVATE_toQueryTarget(r.serializer, $d3a073fac959c995$var$__PRIVATE_queryToTarget(e));
    return (await r.g("RunQuery", r.serializer.databaseId, i, {
        structuredQuery: n.structuredQuery
    })).filter((t)=>!!t.document).map((t)=>(function __PRIVATE_fromDocument(t, e, r) {
            const n = $d3a073fac959c995$var$fromName(t, e.name), i = $d3a073fac959c995$var$__PRIVATE_fromVersion(e.updateTime), s = e.createTime ? $d3a073fac959c995$var$__PRIVATE_fromVersion(e.createTime) : $d3a073fac959c995$var$SnapshotVersion.min(), o = new $d3a073fac959c995$var$ObjectValue({
                mapValue: {
                    fields: e.fields
                }
            }), a = $d3a073fac959c995$var$MutableDocument.newFoundDocument(n, i, s, o);
            return r && a.setHasCommittedMutations(), r ? a.setHasCommittedMutations() : a;
        })(r.serializer, t.document, void 0));
}
async function $d3a073fac959c995$var$__PRIVATE_invokeRunAggregationQueryRpc(t, e, r) {
    var n;
    const i = $d3a073fac959c995$var$__PRIVATE_debugCast(t), { request: s, X: o, parent: a } = function __PRIVATE_toRunAggregationQueryRequest(t, e, r, n) {
        const { B: i, parent: s } = $d3a073fac959c995$var$__PRIVATE_toQueryTarget(t, e), o = {}, a = [];
        let u = 0;
        return r.forEach((t)=>{
            // Map all client-side aliases to a unique short-form
            // alias. This avoids issues with client-side aliases that
            // exceed the 1500-byte string size limit.
            const e = n ? t.alias : "aggregate_" + u++;
            o[e] = t.alias, "count" === t.aggregateType ? a.push({
                alias: e,
                count: {}
            }) : "avg" === t.aggregateType ? a.push({
                alias: e,
                avg: {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.fieldPath)
                }
            }) : "sum" === t.aggregateType && a.push({
                alias: e,
                sum: {
                    field: $d3a073fac959c995$var$__PRIVATE_toFieldPathReference(t.fieldPath)
                }
            });
        }), {
            request: {
                structuredAggregationQuery: {
                    aggregations: a,
                    structuredQuery: i.structuredQuery
                },
                parent: i.parent
            },
            X: o,
            parent: s
        };
    }(i.serializer, function __PRIVATE_queryToAggregateTarget(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_debugCast(t);
        return e.O || // Do not include implicit order-bys for aggregate queries.
        (e.O = $d3a073fac959c995$var$__PRIVATE__queryToTarget(e, t.explicitOrderBy)), e.O;
    }(e), r);
    i.connection.R || delete s.parent;
    const u = (await i.g("RunAggregationQuery", i.serializer.databaseId, a, s, /*expectedResponseCount=*/ 1)).filter((t)=>!!t.result);
    // Omit RunAggregationQueryResponse that only contain readTimes.
    $d3a073fac959c995$var$__PRIVATE_hardAssert(1 === u.length);
    // Remap the short-form aliases that were sent to the server
    // to the client-side aliases. Users will access the results
    // using the client-side alias.
    const _ = null === (n = u[0].result) || void 0 === n ? void 0 : n.aggregateFields;
    return Object.keys(_).reduce((t, e)=>(t[o[e]] = _[e], t), {});
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$k = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function $d3a073fac959c995$var$__PRIVATE_getDatastore(t) {
    if (t._terminated) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$w, "The client has already been terminated.");
    if (!$d3a073fac959c995$var$k.has(t)) {
        $d3a073fac959c995$var$__PRIVATE_logDebug("ComponentProvider", "Initializing Datastore");
        const e = function __PRIVATE_newConnection(t) {
            return new $d3a073fac959c995$var$__PRIVATE_FetchConnection(t, fetch.bind(null));
        }(function __PRIVATE_makeDatabaseInfo(t, e, r, n) {
            return new $d3a073fac959c995$var$DatabaseInfo(t, e, r, n.host, n.ssl, n.experimentalForceLongPolling, n.experimentalAutoDetectLongPolling, $d3a073fac959c995$var$__PRIVATE_cloneLongPollingOptions(n.experimentalLongPollingOptions), n.useFetchStreams);
        }(t._databaseId, t.app.options.appId || "", t._persistenceKey, t._freezeSettings())), r = $d3a073fac959c995$var$__PRIVATE_newSerializer(t._databaseId), n = function __PRIVATE_newDatastore(t, e, r, n) {
            return new $d3a073fac959c995$var$__PRIVATE_DatastoreImpl(t, e, r, n);
        }(t._authCredentials, t._appCheckCredentials, e, r);
        $d3a073fac959c995$var$k.set(t, n);
    }
    return $d3a073fac959c995$var$k.get(t);
}
/**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ /**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $d3a073fac959c995$var$FirestoreSettingsImpl {
    constructor(t){
        var e, r;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, this.localCache = t.localCache, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        !function __PRIVATE_validateIsNotUsedTogether(t, e, r, n) {
            if (!0 === e && !0 === n) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `${t} and ${r} cannot be used together.`);
        }("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === t.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $d3a073fac959c995$var$__PRIVATE_cloneLongPollingOptions(null !== (r = t.experimentalLongPollingOptions) && void 0 !== r ? r : {}), function __PRIVATE_validateLongPollingOptions(t) {
            if (void 0 !== t.timeoutSeconds) {
                if (isNaN(t.timeoutSeconds)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `invalid long polling timeout: ${t.timeoutSeconds} (must not be NaN)`);
                if (t.timeoutSeconds < 5) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `invalid long polling timeout: ${t.timeoutSeconds} (minimum allowed value is 5)`);
                if (t.timeoutSeconds > 30) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `invalid long polling timeout: ${t.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!t.useFetchStreams;
    }
    isEqual(t) {
        return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(t, e) {
            return t.timeoutSeconds === e.timeoutSeconds;
        }(this.experimentalLongPollingOptions, t.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }
}
class $d3a073fac959c995$export$d0e2b3272814ce82 {
    /** @hideconstructor */ constructor(t, e, r, n){
        this._authCredentials = t, this._appCheckCredentials = e, this._databaseId = r, this._app = n, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $d3a073fac959c995$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1;
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$w, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(t) {
        if (this._settingsFrozen) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$w, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $d3a073fac959c995$var$FirestoreSettingsImpl(t), void 0 !== t.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(t) {
            if (!t) return new $d3a073fac959c995$var$__PRIVATE_EmptyAuthCredentialsProvider;
            switch(t.type){
                case "firstParty":
                    return new $d3a073fac959c995$var$__PRIVATE_FirstPartyAuthCredentialsProvider(t.sessionIndex || "0", t.iamToken || null, t.authTokenFactory || null);
                case "provider":
                    return t.client;
                default:
                    throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(t.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        return function __PRIVATE_removeComponents(t) {
            const e = $d3a073fac959c995$var$k.get(t);
            e && ($d3a073fac959c995$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $d3a073fac959c995$var$k.delete(t), e.terminate());
        }(this), Promise.resolve();
    }
}
function $d3a073fac959c995$export$9061557f3e3b42f9(t, e, r) {
    r || (r = "(default)");
    const n = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(t, "firestore/lite");
    if (n.isInitialized(r)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$w, "Firestore can only be initialized once per app.");
    return n.initialize({
        options: e,
        instanceIdentifier: r
    });
}
function $d3a073fac959c995$export$f06a05d14c3a6678(e, r) {
    const n = "object" == typeof e ? e : (0, $57d436074e210fb5$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : r || "(default)", s = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(n, "firestore/lite").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const t = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)("firestore");
        t && $d3a073fac959c995$export$966a03d25297d115(s, ...t);
    }
    return s;
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $d3a073fac959c995$export$966a03d25297d115(t, e, r, n = {}) {
    var i;
    const s = (t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$d0e2b3272814ce82))._getSettings(), o = `${e}:${r}`;
    if ("firestore.googleapis.com" !== s.host && s.host !== o && $d3a073fac959c995$var$__PRIVATE_logWarn("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), t._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), n.mockUserToken) {
        let e, r;
        if ("string" == typeof n.mockUserToken) e = n.mockUserToken, r = $d3a073fac959c995$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            e = (0, $c38e0f42709c826a$export$367bf224123348f1)(n.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = n.mockUserToken.sub || n.mockUserToken.user_id;
            if (!s) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "mockUserToken must contain 'sub' or 'user_id' field!");
            r = new $d3a073fac959c995$var$User(s);
        }
        t._authCredentials = new $d3a073fac959c995$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $d3a073fac959c995$var$__PRIVATE_OAuthToken(e, r));
    }
}
/**
 * Terminates the provided `Firestore` instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` functions
 * may be used. Any other function will throw a `FirestoreError`. Termination
 * does not cancel any pending writes, and any promises that are awaiting a
 * response from the server will not be resolved.
 *
 * To restart after termination, create a new instance of `Firestore` with
 * {@link (getFirestore:1)}.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all of
 * its resources or in combination with {@link clearIndexedDbPersistence} to
 * ensure that all local state is destroyed between test runs.
 *
 * @param firestore - The `Firestore` instance to terminate.
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $d3a073fac959c995$export$9aff22d1ec357a14(t) {
    return t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$d0e2b3272814ce82), (0, $57d436074e210fb5$export$48d18de2ff1c45a5)(t.app, "firestore/lite"), t._delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $d3a073fac959c995$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $d3a073fac959c995$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, r){
        this._userDataWriter = e, this._data = r, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $d3a073fac959c995$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, r){
        this.converter = e, this._query = r, /** The type of this Firestore reference. */ this.type = "query", this.firestore = t;
    }
    withConverter(t) {
        return new $d3a073fac959c995$export$62297b13309008b2(this.firestore, t, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $d3a073fac959c995$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, r){
        this.converter = e, this._key = r, /** The type of this Firestore reference. */ this.type = "document", this.firestore = t;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $d3a073fac959c995$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(t) {
        return new $d3a073fac959c995$export$6be62b059fb12175(this.firestore, t, this._key);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $d3a073fac959c995$export$ab5a1a47940a200e extends $d3a073fac959c995$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(t, e, r){
        super(t, e, function __PRIVATE_newQueryForPath(t) {
            return new $d3a073fac959c995$var$__PRIVATE_QueryImpl(t);
        }(r)), this._path = r, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const t = this._path.popLast();
        return t.isEmpty() ? null : new $d3a073fac959c995$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $d3a073fac959c995$var$DocumentKey(t));
    }
    withConverter(t) {
        return new $d3a073fac959c995$export$ab5a1a47940a200e(this.firestore, t, this._path);
    }
}
function $d3a073fac959c995$export$bf5175b0c24981cd(t, e, ...r) {
    if (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), $d3a073fac959c995$var$__PRIVATE_validateNonEmptyArgument("collection", "path", e), t instanceof $d3a073fac959c995$export$d0e2b3272814ce82) {
        const n = $d3a073fac959c995$var$ResourcePath.fromString(e, ...r);
        return $d3a073fac959c995$var$__PRIVATE_validateCollectionPath(n), new $d3a073fac959c995$export$ab5a1a47940a200e(t, /* converter= */ null, n);
    }
    {
        if (!(t instanceof $d3a073fac959c995$export$6be62b059fb12175 || t instanceof $d3a073fac959c995$export$ab5a1a47940a200e)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const n = t._path.child($d3a073fac959c995$var$ResourcePath.fromString(e, ...r));
        return $d3a073fac959c995$var$__PRIVATE_validateCollectionPath(n), new $d3a073fac959c995$export$ab5a1a47940a200e(t.firestore, /* converter= */ null, n);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $d3a073fac959c995$export$473d82a73f88c107(t, e) {
    if (t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$d0e2b3272814ce82), $d3a073fac959c995$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid collection ID '${e}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $d3a073fac959c995$export$62297b13309008b2(t, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(t) {
        return new $d3a073fac959c995$var$__PRIVATE_QueryImpl($d3a073fac959c995$var$ResourcePath.emptyPath(), t);
    }(e));
}
function $d3a073fac959c995$export$2a111da947c407d2(t, e, ...r) {
    if (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (e = $d3a073fac959c995$var$__PRIVATE_AutoId.newId()), $d3a073fac959c995$var$__PRIVATE_validateNonEmptyArgument("doc", "path", e), t instanceof $d3a073fac959c995$export$d0e2b3272814ce82) {
        const n = $d3a073fac959c995$var$ResourcePath.fromString(e, ...r);
        return $d3a073fac959c995$var$__PRIVATE_validateDocumentPath(n), new $d3a073fac959c995$export$6be62b059fb12175(t, /* converter= */ null, new $d3a073fac959c995$var$DocumentKey(n));
    }
    {
        if (!(t instanceof $d3a073fac959c995$export$6be62b059fb12175 || t instanceof $d3a073fac959c995$export$ab5a1a47940a200e)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const n = t._path.child($d3a073fac959c995$var$ResourcePath.fromString(e, ...r));
        return $d3a073fac959c995$var$__PRIVATE_validateDocumentPath(n), new $d3a073fac959c995$export$6be62b059fb12175(t.firestore, t instanceof $d3a073fac959c995$export$ab5a1a47940a200e ? t.converter : null, new $d3a073fac959c995$var$DocumentKey(n));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $d3a073fac959c995$export$62a32f2da6187d11(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), (t instanceof $d3a073fac959c995$export$6be62b059fb12175 || t instanceof $d3a073fac959c995$export$ab5a1a47940a200e) && (e instanceof $d3a073fac959c995$export$6be62b059fb12175 || e instanceof $d3a073fac959c995$export$ab5a1a47940a200e) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $d3a073fac959c995$export$49b1d0de6ba30f41(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t instanceof $d3a073fac959c995$export$62297b13309008b2 && e instanceof $d3a073fac959c995$export$62297b13309008b2 && t.firestore === e.firestore && $d3a073fac959c995$var$__PRIVATE_queryEquals(t._query, e._query) && t.converter === e.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $d3a073fac959c995$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(t){
        this._byteString = t;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(t) {
        try {
            return new $d3a073fac959c995$export$9f55f2e2bf8c2fc1($d3a073fac959c995$var$ByteString.fromBase64String(t));
        } catch (t) {
            throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Failed to construct data from Base64 string: " + t);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(t) {
        return new $d3a073fac959c995$export$9f55f2e2bf8c2fc1($d3a073fac959c995$var$ByteString.fromUint8Array(t));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(t) {
        return this._byteString.isEqual(t._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $d3a073fac959c995$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...t){
        for(let e = 0; e < t.length; ++e)if (0 === t[e].length) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $d3a073fac959c995$var$FieldPath$1(t);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(t) {
        return this._internalPath.isEqual(t._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $d3a073fac959c995$export$bf6e62266977b8eb() {
    return new $d3a073fac959c995$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $d3a073fac959c995$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(t){
        this._methodName = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $d3a073fac959c995$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(t, e){
        if (!isFinite(t) || t < -90 || t > 90) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Longitude must be a number between -180 and 180, but was: " + e);
        this._lat = t, this._long = e;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(t) {
        return this._lat === t._lat && this._long === t._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(t) {
        return $d3a073fac959c995$var$__PRIVATE_primitiveComparator(this._lat, t._lat) || $d3a073fac959c995$var$__PRIVATE_primitiveComparator(this._long, t._long);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies equality for an array of primitives.
 *
 * @private
 * @internal
 * @param left Array of primitives.
 * @param right Array of primitives.
 * @return True if arrays are equal.
 */ /**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with {@link FieldValue.vector}.
 *
 * @class VectorValue
 */ class $d3a073fac959c995$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(t){
        // Making a copy of the parameter.
        this._values = (t || []).map((t)=>t);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((t)=>t);
    }
    /**
     * Returns `true` if the two VectorValue has the same raw number arrays, returns `false` otherwise.
     */ isEqual(t) {
        return function __PRIVATE_isPrimitiveArrayEqual(t, e) {
            if (t.length !== e.length) return !1;
            for(let r = 0; r < t.length; ++r)if (t[r] !== e[r]) return !1;
            return !0;
        }(this._values, t._values);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$U = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $d3a073fac959c995$var$ParsedSetData {
    constructor(t, e, r){
        this.data = t, this.fieldMask = e, this.fieldTransforms = r;
    }
    toMutation(t, e) {
        return null !== this.fieldMask ? new $d3a073fac959c995$var$__PRIVATE_PatchMutation(t, this.data, this.fieldMask, e, this.fieldTransforms) : new $d3a073fac959c995$var$__PRIVATE_SetMutation(t, this.data, e, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $d3a073fac959c995$var$ParsedUpdateData {
    constructor(t, // The fieldMask does not include document transforms.
    e, r){
        this.data = t, this.fieldMask = e, this.fieldTransforms = r;
    }
    toMutation(t, e) {
        return new $d3a073fac959c995$var$__PRIVATE_PatchMutation(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }
}
function $d3a073fac959c995$var$__PRIVATE_isWrite(t) {
    switch(t){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $d3a073fac959c995$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ class $d3a073fac959c995$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(t, e, r, n, i, s){
        this.settings = t, this.databaseId = e, this.serializer = r, this.ignoreUndefinedProperties = n, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.tt(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get et() {
        return this.settings.et;
    }
    /** Returns a new context with the specified settings overwritten. */ rt(t) {
        return new $d3a073fac959c995$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    nt(t) {
        var e;
        const r = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), n = this.rt({
            path: r,
            it: !1
        });
        return n.st(t), n;
    }
    ot(t) {
        var e;
        const r = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), n = this.rt({
            path: r,
            it: !1
        });
        return n.tt(), n;
    }
    ut(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.rt({
            path: void 0,
            it: !0
        });
    }
    _t(t) {
        return $d3a073fac959c995$var$__PRIVATE_createError(t, this.settings.methodName, this.settings.ct || !1, this.path, this.settings.lt);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(t) {
        return void 0 !== this.fieldMask.find((e)=>t.isPrefixOf(e)) || void 0 !== this.fieldTransforms.find((e)=>t.isPrefixOf(e.field));
    }
    tt() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let t = 0; t < this.path.length; t++)this.st(this.path.get(t));
    }
    st(t) {
        if (0 === t.length) throw this._t("Document fields must not be empty");
        if ($d3a073fac959c995$var$__PRIVATE_isWrite(this.et) && $d3a073fac959c995$var$U.test(t)) throw this._t('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $d3a073fac959c995$var$__PRIVATE_UserDataReader {
    constructor(t, e, r){
        this.databaseId = t, this.ignoreUndefinedProperties = e, this.serializer = r || $d3a073fac959c995$var$__PRIVATE_newSerializer(t);
    }
    /** Creates a new top-level parse context. */ ht(t, e, r, n = !1) {
        return new $d3a073fac959c995$var$__PRIVATE_ParseContextImpl({
            et: t,
            methodName: e,
            lt: r,
            path: $d3a073fac959c995$var$FieldPath$1.emptyPath(),
            it: !1,
            ct: n
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $d3a073fac959c995$var$__PRIVATE_newUserDataReader(t) {
    const e = t._freezeSettings(), r = $d3a073fac959c995$var$__PRIVATE_newSerializer(t._databaseId);
    return new $d3a073fac959c995$var$__PRIVATE_UserDataReader(t._databaseId, !!e.ignoreUndefinedProperties, r);
}
/** Parse document data from a set() call. */ function $d3a073fac959c995$var$__PRIVATE_parseSetData(t, e, r, n, i, s = {}) {
    const o = t.ht(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , e, r, i);
    $d3a073fac959c995$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, n);
    const a = $d3a073fac959c995$var$__PRIVATE_parseObject(n, o);
    let u, _;
    if (s.merge) u = new $d3a073fac959c995$var$FieldMask(o.fieldMask), _ = o.fieldTransforms;
    else if (s.mergeFields) {
        const t = [];
        for (const n of s.mergeFields){
            const i = $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument$1(e, n, r);
            if (!o.contains(i)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $d3a073fac959c995$var$__PRIVATE_fieldMaskContains(t, i) || t.push(i);
        }
        u = new $d3a073fac959c995$var$FieldMask(t), _ = o.fieldTransforms.filter((t)=>u.covers(t.field));
    } else u = null, _ = o.fieldTransforms;
    return new $d3a073fac959c995$var$ParsedSetData(new $d3a073fac959c995$var$ObjectValue(a), u, _);
}
class $d3a073fac959c995$var$__PRIVATE_DeleteFieldValueImpl extends $d3a073fac959c995$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        if (2 /* UserDataSource.MergeSet */  !== t.et) throw 1 /* UserDataSource.Update */  === t.et ? t._t(`${this._methodName}() can only appear at the top level of your update data`) : t._t(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.fieldMask.push(t.path), null;
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $d3a073fac959c995$var$__PRIVATE_createSentinelChildContext(t, e, r) {
    return new $d3a073fac959c995$var$__PRIVATE_ParseContextImpl({
        et: 3 /* UserDataSource.Argument */ ,
        lt: e.settings.lt,
        methodName: t._methodName,
        it: r
    }, e.databaseId, e.serializer, e.ignoreUndefinedProperties);
}
class $d3a073fac959c995$var$__PRIVATE_ServerTimestampFieldValueImpl extends $d3a073fac959c995$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        return new $d3a073fac959c995$var$FieldTransform(t.path, new $d3a073fac959c995$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $d3a073fac959c995$var$__PRIVATE_ArrayUnionFieldValueImpl extends $d3a073fac959c995$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.dt = e;
    }
    _toFieldTransform(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_createSentinelChildContext(this, t, /*array=*/ !0), r = this.dt.map((t)=>$d3a073fac959c995$var$__PRIVATE_parseData(t, e)), n = new $d3a073fac959c995$var$__PRIVATE_ArrayUnionTransformOperation(r);
        return new $d3a073fac959c995$var$FieldTransform(t.path, n);
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(this.dt, t.dt);
    }
}
class $d3a073fac959c995$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $d3a073fac959c995$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.dt = e;
    }
    _toFieldTransform(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_createSentinelChildContext(this, t, /*array=*/ !0), r = this.dt.map((t)=>$d3a073fac959c995$var$__PRIVATE_parseData(t, e)), n = new $d3a073fac959c995$var$__PRIVATE_ArrayRemoveTransformOperation(r);
        return new $d3a073fac959c995$var$FieldTransform(t.path, n);
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(this.dt, t.dt);
    }
}
class $d3a073fac959c995$var$__PRIVATE_NumericIncrementFieldValueImpl extends $d3a073fac959c995$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.ft = e;
    }
    _toFieldTransform(t) {
        const e = new $d3a073fac959c995$var$__PRIVATE_NumericIncrementTransformOperation(t.serializer, $d3a073fac959c995$var$toNumber(t.serializer, this.ft));
        return new $d3a073fac959c995$var$FieldTransform(t.path, e);
    }
    isEqual(t) {
        return t instanceof $d3a073fac959c995$var$__PRIVATE_NumericIncrementFieldValueImpl && this.ft === t.ft;
    }
}
/** Parse update data from an update() call. */ function $d3a073fac959c995$var$__PRIVATE_parseUpdateData(t, e, r, n) {
    const i = t.ht(1 /* UserDataSource.Update */ , e, r);
    $d3a073fac959c995$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, n);
    const s = [], o = $d3a073fac959c995$var$ObjectValue.empty();
    $d3a073fac959c995$var$forEach(n, (t, n)=>{
        const a = $d3a073fac959c995$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, r);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n);
        const u = i.ot(a);
        if (n instanceof $d3a073fac959c995$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(a);
        else {
            const t = $d3a073fac959c995$var$__PRIVATE_parseData(n, u);
            null != t && (s.push(a), o.set(a, t));
        }
    });
    const a = new $d3a073fac959c995$var$FieldMask(s);
    return new $d3a073fac959c995$var$ParsedUpdateData(o, a, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $d3a073fac959c995$var$__PRIVATE_parseUpdateVarargs(t, e, r, n, i, s) {
    const o = t.ht(1 /* UserDataSource.Update */ , e, r), a = [
        $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument$1(e, n, r)
    ], u = [
        i
    ];
    if (s.length % 2 != 0) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Function ${e}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let t = 0; t < s.length; t += 2)a.push($d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument$1(e, s[t])), u.push(s[t + 1]);
    const _ = [], c = $d3a073fac959c995$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let t = a.length - 1; t >= 0; --t)if (!$d3a073fac959c995$var$__PRIVATE_fieldMaskContains(_, a[t])) {
        const e = a[t];
        let r = u[t];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(r);
        const n = o.ot(e);
        if (r instanceof $d3a073fac959c995$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        _.push(e);
        else {
            const t = $d3a073fac959c995$var$__PRIVATE_parseData(r, n);
            null != t && (_.push(e), c.set(e, t));
        }
    }
    const h = new $d3a073fac959c995$var$FieldMask(_);
    return new $d3a073fac959c995$var$ParsedUpdateData(c, h, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $d3a073fac959c995$var$__PRIVATE_parseQueryValue(t, e, r, n = !1) {
    return $d3a073fac959c995$var$__PRIVATE_parseData(r, t.ht(n ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $d3a073fac959c995$var$__PRIVATE_parseData(t, e) {
    if ($d3a073fac959c995$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t))) return $d3a073fac959c995$var$__PRIVATE_validatePlainObject("Unsupported field value:", e, t), $d3a073fac959c995$var$__PRIVATE_parseObject(t, e);
    if (t instanceof $d3a073fac959c995$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$d3a073fac959c995$var$__PRIVATE_isWrite(e.et)) throw e._t(`${t._methodName}() can only be used with update() and set()`);
        if (!e.path) throw e._t(`${t._methodName}() is not currently supported inside arrays`);
        const r = t._toFieldTransform(e);
        r && e.fieldTransforms.push(r);
    }(t, e), null;
    if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.fieldMask.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.it && 4 /* UserDataSource.ArrayArgument */  !== e.et) throw e._t("Nested arrays are not supported");
        return function __PRIVATE_parseArray(t, e) {
            const r = [];
            let n = 0;
            for (const i of t){
                let t = $d3a073fac959c995$var$__PRIVATE_parseData(i, e.ut(n));
                null == t && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (t = {
                    nullValue: "NULL_VALUE"
                }), r.push(t), n++;
            }
            return {
                arrayValue: {
                    values: r
                }
            };
        }(t, e);
    }
    return function __PRIVATE_parseScalarValue(t, e) {
        if (null === (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $d3a073fac959c995$var$toNumber(e.serializer, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            const r = $d3a073fac959c995$export$d9bcbd5e1ff81430.fromDate(t);
            return {
                timestampValue: $d3a073fac959c995$var$toTimestamp(e.serializer, r)
            };
        }
        if (t instanceof $d3a073fac959c995$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const r = new $d3a073fac959c995$export$d9bcbd5e1ff81430(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $d3a073fac959c995$var$toTimestamp(e.serializer, r)
            };
        }
        if (t instanceof $d3a073fac959c995$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $d3a073fac959c995$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $d3a073fac959c995$var$__PRIVATE_toBytes(e.serializer, t._byteString)
        };
        if (t instanceof $d3a073fac959c995$export$6be62b059fb12175) {
            const r = e.databaseId, n = t.firestore._databaseId;
            if (!n.isEqual(r)) throw e._t(`Document reference is for database ${n.projectId}/${n.database} but should be for database ${r.projectId}/${r.database}`);
            return {
                referenceValue: $d3a073fac959c995$var$__PRIVATE_toResourceName(t.firestore._databaseId || e.databaseId, t._key.path)
            };
        }
        if (t instanceof $d3a073fac959c995$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(t, e) {
            return {
                mapValue: {
                    fields: {
                        __type__: {
                            stringValue: "__vector__"
                        },
                        value: {
                            arrayValue: {
                                values: t.toArray().map((t)=>{
                                    if ("number" != typeof t) throw e._t("VectorValues must only contain numeric values.");
                                    return $d3a073fac959c995$var$__PRIVATE_toDouble(e.serializer, t);
                                })
                            }
                        }
                    }
                }
            };
        }(t, e);
        throw e._t(`Unsupported field value: ${$d3a073fac959c995$var$__PRIVATE_valueDescription(t)}`);
    }(t, e);
}
function $d3a073fac959c995$var$__PRIVATE_parseObject(t, e) {
    const r = {};
    return !function isEmpty(t) {
        for(const e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
        return !0;
    }(t) ? $d3a073fac959c995$var$forEach(t, (t, n)=>{
        const i = $d3a073fac959c995$var$__PRIVATE_parseData(n, e.nt(t));
        null != i && (r[t] = i);
    }) : // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.fieldMask.push(e.path), {
        mapValue: {
            fields: r
        }
    };
}
function $d3a073fac959c995$var$__PRIVATE_looksLikeJsonObject(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $d3a073fac959c995$export$d9bcbd5e1ff81430 || t instanceof $d3a073fac959c995$export$f9f719d1b6419c4 || t instanceof $d3a073fac959c995$export$9f55f2e2bf8c2fc1 || t instanceof $d3a073fac959c995$export$6be62b059fb12175 || t instanceof $d3a073fac959c995$export$c58bc8ee7ecc248d || t instanceof $d3a073fac959c995$export$994bb3d317350b37);
}
function $d3a073fac959c995$var$__PRIVATE_validatePlainObject(t, e, r) {
    if (!$d3a073fac959c995$var$__PRIVATE_looksLikeJsonObject(r) || !function __PRIVATE_isPlainObject(t) {
        return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
    }(r)) {
        const n = $d3a073fac959c995$var$__PRIVATE_valueDescription(r);
        throw "an object" === n ? e._t(t + " a custom object") : e._t(t + " " + n);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument$1(t, e, r) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) instanceof $d3a073fac959c995$export$a1a8fea822d17659) return e._internalPath;
    if ("string" == typeof e) return $d3a073fac959c995$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e);
    throw $d3a073fac959c995$var$__PRIVATE_createError("Field path arguments must be of type string or ", t, /* hasConverter= */ !1, /* path= */ void 0, r);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $d3a073fac959c995$var$j = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $d3a073fac959c995$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, r) {
    if (e.search($d3a073fac959c995$var$j) >= 0) throw $d3a073fac959c995$var$__PRIVATE_createError(`Invalid field path (${e}). Paths must not contain '~', '*', '/', '[', or ']'`, t, /* hasConverter= */ !1, /* path= */ void 0, r);
    try {
        return new $d3a073fac959c995$export$a1a8fea822d17659(...e.split("."))._internalPath;
    } catch (n) {
        throw $d3a073fac959c995$var$__PRIVATE_createError(`Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, t, /* hasConverter= */ !1, /* path= */ void 0, r);
    }
}
function $d3a073fac959c995$var$__PRIVATE_createError(t, e, r, n, i) {
    const s = n && !n.isEmpty(), o = void 0 !== i;
    let a = `Function ${e}() called with invalid data`;
    r && (a += " (via `toFirestore()`)"), a += ". ";
    let u = "";
    return (s || o) && (u += " (found", s && (u += ` in field ${n}`), o && (u += ` in document ${i}`), u += ")"), new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, a + t + u);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $d3a073fac959c995$var$__PRIVATE_fieldMaskContains(t, e) {
    return t.some((t)=>t.isEqual(e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $d3a073fac959c995$export$acab0e6ef25eb301 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, r, n, i){
        this._firestore = t, this._userDataWriter = e, this._key = r, this._document = n, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $d3a073fac959c995$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $d3a073fac959c995$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field($d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $d3a073fac959c995$export$6d4d04e42af6b03c extends $d3a073fac959c995$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $d3a073fac959c995$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e){
        this._docs = e, this.query = t;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        return [
            ...this._docs
        ];
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this.docs.length;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.docs.length;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._docs.forEach(t, e);
    }
}
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $d3a073fac959c995$export$f243a5d948512846(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t instanceof $d3a073fac959c995$export$acab0e6ef25eb301 && e instanceof $d3a073fac959c995$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $d3a073fac959c995$export$8f21149d8133945c && e instanceof $d3a073fac959c995$export$8f21149d8133945c && $d3a073fac959c995$export$49b1d0de6ba30f41(t.query, e.query) && $d3a073fac959c995$var$__PRIVATE_arrayEquals(t.docs, e.docs, $d3a073fac959c995$export$f243a5d948512846);
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument(t, e) {
    return "string" == typeof e ? $d3a073fac959c995$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e) : e instanceof $d3a073fac959c995$export$a1a8fea822d17659 ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $d3a073fac959c995$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $d3a073fac959c995$export$b0e86f2c7431df4e extends $d3a073fac959c995$var$AppliableConstraint {
}
function $d3a073fac959c995$export$2fa187e846a241c4(t, e, ...r) {
    let n = [];
    e instanceof $d3a073fac959c995$var$AppliableConstraint && n.push(e), n = n.concat(r), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof $d3a073fac959c995$export$6bbc7aef0717f3d2).length, r = t.filter((t)=>t instanceof $d3a073fac959c995$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && r > 0) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(n);
    for (const e of n)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $d3a073fac959c995$export$f765fc5789dfd439 extends $d3a073fac959c995$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, r){
        super(), this._field = t, this._op = e, this._value = r, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, r) {
        return new $d3a073fac959c995$export$f765fc5789dfd439(t, e, r);
    }
    _apply(t) {
        const e = this._parse(t);
        return $d3a073fac959c995$var$__PRIVATE_validateNewFieldFilter(t._query, e), new $d3a073fac959c995$export$62297b13309008b2(t.firestore, t.converter, $d3a073fac959c995$var$__PRIVATE_queryWithAddedFilter(t._query, e));
    }
    _parse(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_newUserDataReader(t.firestore), r = function __PRIVATE_newQueryFilter(t, e, r, n, i, s, o) {
            let a;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $d3a073fac959c995$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const e = [];
                    for (const r of o)e.push($d3a073fac959c995$var$__PRIVATE_parseDocumentIdValue(n, t, r));
                    a = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else a = $d3a073fac959c995$var$__PRIVATE_parseDocumentIdValue(n, t, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $d3a073fac959c995$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), a = $d3a073fac959c995$var$__PRIVATE_parseQueryValue(r, e, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            return $d3a073fac959c995$var$FieldFilter.create(i, s, a);
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return r;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $d3a073fac959c995$export$9c59b80dda569a6e(t, e, r) {
    const n = e, i = $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument("where", t);
    return $d3a073fac959c995$export$f765fc5789dfd439._create(i, n, r);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $d3a073fac959c995$export$6bbc7aef0717f3d2 extends $d3a073fac959c995$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $d3a073fac959c995$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : $d3a073fac959c995$var$CompositeFilter.create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let r = t;
            const n = e.getFlattenedFilters();
            for (const t of n)$d3a073fac959c995$var$__PRIVATE_validateNewFieldFilter(r, t), r = $d3a073fac959c995$var$__PRIVATE_queryWithAddedFilter(r, t);
        }(t._query, e), new $d3a073fac959c995$export$62297b13309008b2(t.firestore, t.converter, $d3a073fac959c995$var$__PRIVATE_queryWithAddedFilter(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $d3a073fac959c995$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$d3a073fac959c995$var$__PRIVATE_validateQueryFilterConstraint("or", t)), $d3a073fac959c995$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $d3a073fac959c995$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$d3a073fac959c995$var$__PRIVATE_validateQueryFilterConstraint("and", t)), $d3a073fac959c995$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $d3a073fac959c995$export$65a9ba8bbd6ed9e3 extends $d3a073fac959c995$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $d3a073fac959c995$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, r) {
            if (null !== t.startAt) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            return new $d3a073fac959c995$var$OrderBy(e, r);
        }(t._query, this._field, this._direction);
        return new $d3a073fac959c995$export$62297b13309008b2(t.firestore, t.converter, function __PRIVATE_queryWithAddedOrderBy(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const r = t.explicitOrderBy.concat([
                e
            ]);
            return new $d3a073fac959c995$var$__PRIVATE_QueryImpl(t.path, t.collectionGroup, r, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $d3a073fac959c995$export$f18af21d6f4dafd8(t, e = "asc") {
    const r = e, n = $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument("orderBy", t);
    return $d3a073fac959c995$export$65a9ba8bbd6ed9e3._create(n, r);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $d3a073fac959c995$export$49bb5356ca788047 extends $d3a073fac959c995$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, r){
        super(), this.type = t, this._limit = e, this._limitType = r;
    }
    static _create(t, e, r) {
        return new $d3a073fac959c995$export$49bb5356ca788047(t, e, r);
    }
    _apply(t) {
        return new $d3a073fac959c995$export$62297b13309008b2(t.firestore, t.converter, function __PRIVATE_queryWithLimit(t, e, r) {
            return new $d3a073fac959c995$var$__PRIVATE_QueryImpl(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, r, t.startAt, t.endAt);
        }(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $d3a073fac959c995$export$ee37e834aaad6f7e(t) {
    return $d3a073fac959c995$var$__PRIVATE_validatePositiveNumber("limit", t), $d3a073fac959c995$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $d3a073fac959c995$export$f823b3589f69d3b8(t) {
    return $d3a073fac959c995$var$__PRIVATE_validatePositiveNumber("limitToLast", t), $d3a073fac959c995$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $d3a073fac959c995$export$d92e2830aca1d816 extends $d3a073fac959c995$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, r){
        super(), this.type = t, this._docOrFields = e, this._inclusive = r;
    }
    static _create(t, e, r) {
        return new $d3a073fac959c995$export$d92e2830aca1d816(t, e, r);
    }
    _apply(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new $d3a073fac959c995$export$62297b13309008b2(t.firestore, t.converter, function __PRIVATE_queryWithStartAt(t, e) {
            return new $d3a073fac959c995$var$__PRIVATE_QueryImpl(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
        }(t._query, e));
    }
}
function $d3a073fac959c995$export$859941c5fc8eba6b(...t) {
    return $d3a073fac959c995$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $d3a073fac959c995$export$dd8dee5f7b804673(...t) {
    return $d3a073fac959c995$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $d3a073fac959c995$export$fd1782fd870d1e06 extends $d3a073fac959c995$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, r){
        super(), this.type = t, this._docOrFields = e, this._inclusive = r;
    }
    static _create(t, e, r) {
        return new $d3a073fac959c995$export$fd1782fd870d1e06(t, e, r);
    }
    _apply(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new $d3a073fac959c995$export$62297b13309008b2(t.firestore, t.converter, function __PRIVATE_queryWithEndAt(t, e) {
            return new $d3a073fac959c995$var$__PRIVATE_QueryImpl(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
        }(t._query, e));
    }
}
function $d3a073fac959c995$export$57203950645b8b11(...t) {
    return $d3a073fac959c995$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $d3a073fac959c995$export$28ec54a8428bdb3f(...t) {
    return $d3a073fac959c995$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $d3a073fac959c995$var$__PRIVATE_newQueryBoundFromDocOrFields(t, e, r, n) {
    if (r[0] = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(r[0]), r[0] instanceof $d3a073fac959c995$export$acab0e6ef25eb301) return function __PRIVATE_newQueryBoundFromDocument(t, e, r, n, i) {
        if (!n) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$P, `Can't use a DocumentSnapshot that doesn't exist for ${r}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const r of $d3a073fac959c995$var$__PRIVATE_queryNormalizedOrderBy(t))if (r.field.isKeyField()) s.push($d3a073fac959c995$var$__PRIVATE_refValue(e, n.key));
        else {
            const t = n.data.field(r.field);
            if ($d3a073fac959c995$var$__PRIVATE_isServerTimestamp(t)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, 'Invalid query. You are trying to start or end a query using a document for which the field "' + r.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = r.field.canonicalString();
                throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            s.push(t);
        }
        return new $d3a073fac959c995$var$Bound(s, i);
    }(t._query, t.firestore._databaseId, e, r[0]._document, n);
    {
        const i = $d3a073fac959c995$var$__PRIVATE_newUserDataReader(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, r, n, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (i.length > o.length) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Too many arguments provided to ${n}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const a = [];
            for(let s = 0; s < i.length; s++){
                const u = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof u) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. Expected a string for document ID in ${n}(), but got a ${typeof u}`);
                    if (!$d3a073fac959c995$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== u.indexOf("/")) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${n}() must be a plain document ID, but '${u}' contains a slash.`);
                    const r = t.path.child($d3a073fac959c995$var$ResourcePath.fromString(u));
                    if (!$d3a073fac959c995$var$DocumentKey.isDocumentKey(r)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${n}() must result in a valid document path, but '${r}' is not because it contains an odd number of segments.`);
                    const i = new $d3a073fac959c995$var$DocumentKey(r);
                    a.push($d3a073fac959c995$var$__PRIVATE_refValue(e, i));
                } else {
                    const t = $d3a073fac959c995$var$__PRIVATE_parseQueryValue(r, n, u);
                    a.push(t);
                }
            }
            return new $d3a073fac959c995$var$Bound(a, s);
        }(t._query, t.firestore._databaseId, i, e, r, n);
    }
}
function $d3a073fac959c995$var$__PRIVATE_parseDocumentIdValue(t, e, r) {
    if ("string" == typeof (r = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(r))) {
        if ("" === r) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$d3a073fac959c995$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== r.indexOf("/")) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${r}' contains a '/' character.`);
        const n = e.path.child($d3a073fac959c995$var$ResourcePath.fromString(r));
        if (!$d3a073fac959c995$var$DocumentKey.isDocumentKey(n)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${n}' is not because it has an odd number of segments (${n.length}).`);
        return $d3a073fac959c995$var$__PRIVATE_refValue(t, new $d3a073fac959c995$var$DocumentKey(n));
    }
    if (r instanceof $d3a073fac959c995$export$6be62b059fb12175) return $d3a073fac959c995$var$__PRIVATE_refValue(t, r._key);
    throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$d3a073fac959c995$var$__PRIVATE_valueDescription(r)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $d3a073fac959c995$var$__PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $d3a073fac959c995$var$__PRIVATE_validateNewFieldFilter(t, e) {
    const r = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const r of t)for (const t of r.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== r) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw r === e.op ? new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Invalid query. You cannot use '${e.op.toString()}' filters with '${r.toString()}' filters.`);
}
function $d3a073fac959c995$var$__PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof $d3a073fac959c995$export$f765fc5789dfd439 || e instanceof $d3a073fac959c995$export$6bbc7aef0717f3d2)) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $d3a073fac959c995$var$__PRIVATE_applyFirestoreDataConverter(t, e, r) {
    let n;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return n = t ? r && (r.merge || r.mergeFields) ? t.toFirestore(e, r) : t.toFirestore(e) : e, n;
}
class $d3a073fac959c995$var$__PRIVATE_LiteUserDataWriter extends class AbstractUserDataWriter {
    convertValue(t, e = "none") {
        switch($d3a073fac959c995$var$__PRIVATE_typeOrder(t)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return t.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(t.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(t, e);
            case 5 /* TypeOrder.StringValue */ :
                return t.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($d3a073fac959c995$var$__PRIVATE_normalizeByteString(t.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(t.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(t.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(t.arrayValue, e);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(t.mapValue, e);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(t.mapValue);
            default:
                throw $d3a073fac959c995$var$fail();
        }
    }
    convertObject(t, e) {
        return this.convertObjectMap(t.fields, e);
    }
    /**
     * @internal
     */ convertObjectMap(t, e = "none") {
        const r = {};
        return $d3a073fac959c995$var$forEach(t, (t, n)=>{
            r[t] = this.convertValue(n, e);
        }), r;
    }
    /**
     * @internal
     */ convertVectorValue(t) {
        var e, r, n;
        const i = null === (n = null === (r = null === (e = t.fields) || void 0 === e ? void 0 : e.value.arrayValue) || void 0 === r ? void 0 : r.values) || void 0 === n ? void 0 : n.map((t)=>$d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.doubleValue));
        return new $d3a073fac959c995$export$994bb3d317350b37(i);
    }
    convertGeoPoint(t) {
        return new $d3a073fac959c995$export$f9f719d1b6419c4($d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.latitude), $d3a073fac959c995$var$__PRIVATE_normalizeNumber(t.longitude));
    }
    convertArray(t, e) {
        return (t.values || []).map((t)=>this.convertValue(t, e));
    }
    convertServerTimestamp(t, e) {
        switch(e){
            case "previous":
                const r = $d3a073fac959c995$var$__PRIVATE_getPreviousValue(t);
                return null == r ? null : this.convertValue(r, e);
            case "estimate":
                return this.convertTimestamp($d3a073fac959c995$var$__PRIVATE_getLocalWriteTime(t));
            default:
                return null;
        }
    }
    convertTimestamp(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_normalizeTimestamp(t);
        return new $d3a073fac959c995$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }
    convertDocumentKey(t, e) {
        const r = $d3a073fac959c995$var$ResourcePath.fromString(t);
        $d3a073fac959c995$var$__PRIVATE_hardAssert($d3a073fac959c995$var$__PRIVATE_isValidResourceName(r));
        const n = new $d3a073fac959c995$var$DatabaseId(r.get(1), r.get(3)), i = new $d3a073fac959c995$var$DocumentKey(r.popFirst(5));
        return n.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
        $d3a073fac959c995$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${n.projectId}/${n.database}) which is not supported. It will be treated as a reference in the current database (${e.projectId}/${e.database}) instead.`), i;
    }
} {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $d3a073fac959c995$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $d3a073fac959c995$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * Reads the document referred to by the specified document reference.
 *
 * All documents are directly fetched from the server, even if the document was
 * previously read or modified. Recent modifications are only reflected in the
 * retrieved `DocumentSnapshot` if they have already been applied by the
 * backend. If the client is offline, the read fails. If you like to use
 * caching or see local modifications, please use the full Firestore SDK.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the current
 * document contents.
 */ function $d3a073fac959c995$export$11eb3b5ef9574821(t) {
    const e = $d3a073fac959c995$var$__PRIVATE_getDatastore((t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$6be62b059fb12175)).firestore), r = new $d3a073fac959c995$var$__PRIVATE_LiteUserDataWriter(t.firestore);
    return $d3a073fac959c995$var$__PRIVATE_invokeBatchGetDocumentsRpc(e, [
        t._key
    ]).then((e)=>{
        $d3a073fac959c995$var$__PRIVATE_hardAssert(1 === e.length);
        const n = e[0];
        return new $d3a073fac959c995$export$acab0e6ef25eb301(t.firestore, r, t._key, n.isFoundDocument() ? n : null, t.converter);
    });
}
/**
 * Executes the query and returns the results as a {@link QuerySnapshot}.
 *
 * All queries are executed directly by the server, even if the query was
 * previously executed. Recent modifications are only reflected in the retrieved
 * results if they have already been applied by the backend. If the client is
 * offline, the operation fails. To see previously cached result and local
 * modifications, use the full Firestore SDK.
 *
 * @param query - The `Query` to execute.
 * @returns A Promise that will be resolved with the results of the query.
 */ function $d3a073fac959c995$export$81d3477bd73c86ef(t) {
    (function __PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
        if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$v, "limitToLast() queries require specifying at least one orderBy() clause");
    })((t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$62297b13309008b2))._query);
    const e = $d3a073fac959c995$var$__PRIVATE_getDatastore(t.firestore), r = new $d3a073fac959c995$var$__PRIVATE_LiteUserDataWriter(t.firestore);
    return $d3a073fac959c995$var$__PRIVATE_invokeRunQueryRpc(e, t._query).then((e)=>{
        const n = e.map((e)=>new $d3a073fac959c995$export$6d4d04e42af6b03c(t.firestore, r, e.key, e, t.converter));
        return "L" /* LimitType.Last */  === t._query.limitType && // Limit to last queries reverse the orderBy constraint that was
        // specified by the user. As such, we need to reverse the order of the
        // results to return the documents in the expected order.
        n.reverse(), new $d3a073fac959c995$export$8f21149d8133945c(t, n);
    });
}
function $d3a073fac959c995$export$5ff77ddaff3c9e12(t, e, r) {
    const n = $d3a073fac959c995$var$__PRIVATE_applyFirestoreDataConverter((t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$6be62b059fb12175)).converter, e, r), i = $d3a073fac959c995$var$__PRIVATE_parseSetData($d3a073fac959c995$var$__PRIVATE_newUserDataReader(t.firestore), "setDoc", t._key, n, null !== t.converter, r);
    return $d3a073fac959c995$var$__PRIVATE_invokeCommitRpc($d3a073fac959c995$var$__PRIVATE_getDatastore(t.firestore), [
        i.toMutation(t._key, $d3a073fac959c995$var$Precondition.none())
    ]);
}
function $d3a073fac959c995$export$22d1fdd1e73faff2(t, e, r, ...n) {
    const i = $d3a073fac959c995$var$__PRIVATE_newUserDataReader((t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$6be62b059fb12175)).firestore);
    // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    let s;
    s = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $d3a073fac959c995$export$a1a8fea822d17659 ? $d3a073fac959c995$var$__PRIVATE_parseUpdateVarargs(i, "updateDoc", t._key, e, r, n) : $d3a073fac959c995$var$__PRIVATE_parseUpdateData(i, "updateDoc", t._key, e);
    return $d3a073fac959c995$var$__PRIVATE_invokeCommitRpc($d3a073fac959c995$var$__PRIVATE_getDatastore(t.firestore), [
        s.toMutation(t._key, $d3a073fac959c995$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * The deletion will only be reflected in document reads that occur after the
 * returned promise resolves. If the client is offline, the
 * delete fails. If you would like to see local modifications or buffer writes
 * until the client is online, use the full Firestore SDK.
 *
 * @param reference - A reference to the document to delete.
 * @returns A `Promise` resolved once the document has been successfully
 * deleted from the backend.
 */ function $d3a073fac959c995$export$a4f20481fae8f78b(t) {
    return $d3a073fac959c995$var$__PRIVATE_invokeCommitRpc($d3a073fac959c995$var$__PRIVATE_getDatastore((t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$6be62b059fb12175)).firestore), [
        new $d3a073fac959c995$var$__PRIVATE_DeleteMutation(t._key, $d3a073fac959c995$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * The result of this write will only be reflected in document reads that occur
 * after the returned promise resolves. If the client is offline, the
 * write fails. If you would like to see local modifications or buffer writes
 * until the client is online, use the full Firestore SDK.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @throws Error - If the provided input is not a valid Firestore document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend.
 */ function $d3a073fac959c995$export$a13890143fb1c2dd(t, e) {
    const r = $d3a073fac959c995$export$2a111da947c407d2(t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$ab5a1a47940a200e)), n = $d3a073fac959c995$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e), i = $d3a073fac959c995$var$__PRIVATE_parseSetData($d3a073fac959c995$var$__PRIVATE_newUserDataReader(t.firestore), "addDoc", r._key, n, null !== r.converter, {});
    return $d3a073fac959c995$var$__PRIVATE_invokeCommitRpc($d3a073fac959c995$var$__PRIVATE_getDatastore(t.firestore), [
        i.toMutation(r._key, $d3a073fac959c995$var$Precondition.exists(!1))
    ]).then(()=>r);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $d3a073fac959c995$export$98e782fe3477bdb6(t) {
    return $d3a073fac959c995$export$f85383f5ce6c5a86(t, {
        count: $d3a073fac959c995$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregate(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $d3a073fac959c995$export$f85383f5ce6c5a86(t, e) {
    const r = $d3a073fac959c995$var$__PRIVATE_cast(t.firestore, $d3a073fac959c995$export$d0e2b3272814ce82), n = $d3a073fac959c995$var$__PRIVATE_getDatastore(r), i = function __PRIVATE_mapToArray(t, e) {
        const r = [];
        for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && r.push(e(t[n], n, t));
        return r;
    }(e, (t, e)=>new $d3a073fac959c995$var$__PRIVATE_AggregateImpl(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return $d3a073fac959c995$var$__PRIVATE_invokeRunAggregationQueryRpc(n, t._query, i).then((e)=>(function __PRIVATE_convertToAggregateQuerySnapshot(t, e, r) {
            const n = new $d3a073fac959c995$var$__PRIVATE_LiteUserDataWriter(t);
            return new $d3a073fac959c995$export$40257fef64be808b(e, n, r);
        })(r, t, e));
}
function $d3a073fac959c995$export$8a63f25cc62965f1(t) {
    return new $d3a073fac959c995$export$fada2345be8928cf("sum", $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument$1("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $d3a073fac959c995$export$cc6710ee5f037d57(t) {
    return new $d3a073fac959c995$export$fada2345be8928cf("avg", $d3a073fac959c995$var$__PRIVATE_fieldPathFromArgument$1("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $d3a073fac959c995$export$85b9a36db797e02b() {
    return new $d3a073fac959c995$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $d3a073fac959c995$export$31fa8ec66e0239ad(t, e) {
    var r, n;
    return t instanceof $d3a073fac959c995$export$fada2345be8928cf && e instanceof $d3a073fac959c995$export$fada2345be8928cf && t.aggregateType === e.aggregateType && (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString()) === (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $d3a073fac959c995$export$104f59389a332076(t, e) {
    return $d3a073fac959c995$export$49b1d0de6ba30f41(t.query, e.query) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $d3a073fac959c995$export$2bbad96c62fdba3e() {
    return new $d3a073fac959c995$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $d3a073fac959c995$export$3ff8e7e00c3264b7() {
    return new $d3a073fac959c995$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $d3a073fac959c995$export$f62af892fd92610c(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $d3a073fac959c995$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", t);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $d3a073fac959c995$export$30a014203d0d7e4f(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $d3a073fac959c995$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", t);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $d3a073fac959c995$export$a2647aa13413c947(t) {
    return new $d3a073fac959c995$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", t);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $d3a073fac959c995$export$6074e20ba5c64bef(t) {
    return new $d3a073fac959c995$export$994bb3d317350b37(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $d3a073fac959c995$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = $d3a073fac959c995$var$__PRIVATE_newUserDataReader(t);
    }
    set(t, e, r) {
        this._verifyNotCommitted();
        const n = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore), i = $d3a073fac959c995$var$__PRIVATE_applyFirestoreDataConverter(n.converter, e, r), s = $d3a073fac959c995$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", n._key, i, null !== n.converter, r);
        return this._mutations.push(s.toMutation(n._key, $d3a073fac959c995$var$Precondition.none())), this;
    }
    update(t, e, r, ...n) {
        this._verifyNotCommitted();
        const i = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $d3a073fac959c995$export$a1a8fea822d17659 ? $d3a073fac959c995$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, e, r, n) : $d3a073fac959c995$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, e), this._mutations.push(s.toMutation(i._key, $d3a073fac959c995$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new $d3a073fac959c995$var$__PRIVATE_DeleteMutation(e._key, $d3a073fac959c995$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$w, "A write batch can no longer be used after commit() has been called.");
    }
}
function $d3a073fac959c995$var$__PRIVATE_validateReference(t, e) {
    if ((t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single WriteBatch
 * is 500.
 *
 * The result of these writes will only be reflected in document reads that
 * occur after the returned promise resolves. If the client is offline, the
 * write fails. If you would like to see local modifications or buffer writes
 * until the client is online, use the full Firestore SDK.
 *
 * @returns A `WriteBatch` that can be used to atomically execute multiple
 * writes.
 */ function $d3a073fac959c995$export$44cd1c9d57edd9b1(t) {
    const e = $d3a073fac959c995$var$__PRIVATE_getDatastore(t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$d0e2b3272814ce82));
    return new $d3a073fac959c995$export$d94ed661b1cfd435(t, (t)=>$d3a073fac959c995$var$__PRIVATE_invokeCommitRpc(e, t));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $d3a073fac959c995$var$Transaction$1 {
    constructor(t){
        this.datastore = t, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(t) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const e = await $d3a073fac959c995$var$__PRIVATE_invokeBatchGetDocumentsRpc(this.datastore, t);
        return e.forEach((t)=>this.recordVersion(t)), e;
    }
    set(t, e) {
        this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    update(t, e) {
        try {
            this.write(e.toMutation(t, this.preconditionForUpdate(t)));
        } catch (t) {
            this.lastTransactionError = t;
        }
        this.writtenDocs.add(t.toString());
    }
    delete(t) {
        this.write(new $d3a073fac959c995$var$__PRIVATE_DeleteMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const t = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((e)=>{
            t.delete(e.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        t.forEach((t, e)=>{
            const r = $d3a073fac959c995$var$DocumentKey.fromPath(e);
            this.mutations.push(new $d3a073fac959c995$var$__PRIVATE_VerifyMutation(r, this.precondition(r)));
        }), await $d3a073fac959c995$var$__PRIVATE_invokeCommitRpc(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(t) {
        let e;
        if (t.isFoundDocument()) e = t.version;
        else {
            if (!t.isNoDocument()) throw $d3a073fac959c995$var$fail();
            // Represent a deleted doc using SnapshotVersion.min().
            e = $d3a073fac959c995$var$SnapshotVersion.min();
        }
        const r = this.readVersions.get(t.key.toString());
        if (r) {
            if (!e.isEqual(r)) // This transaction will fail no matter what.
            throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$g, "Document version changed between two reads.");
        } else this.readVersions.set(t.key.toString(), e);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(t) {
        const e = this.readVersions.get(t.toString());
        return !this.writtenDocs.has(t.toString()) && e ? e.isEqual($d3a073fac959c995$var$SnapshotVersion.min()) ? $d3a073fac959c995$var$Precondition.exists(!1) : $d3a073fac959c995$var$Precondition.updateTime(e) : $d3a073fac959c995$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(t) {
        const e = this.readVersions.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(t.toString()) && e) {
            if (e.isEqual($d3a073fac959c995$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $d3a073fac959c995$var$Precondition.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $d3a073fac959c995$var$Precondition.exists(!0);
    }
    write(t) {
        this.ensureCommitNotCalled(), this.mutations.push(t);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d3a073fac959c995$var$z = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $d3a073fac959c995$var$__PRIVATE_TransactionRunner {
    constructor(t, e, r, n, i){
        this.asyncQueue = t, this.datastore = e, this.options = r, this.updateFunction = n, this.deferred = i, this.Et = r.maxAttempts, this.At = new $d3a073fac959c995$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Tt() {
        this.Et -= 1, this.Rt();
    }
    Rt() {
        this.At.G(async ()=>{
            const t = new $d3a073fac959c995$var$Transaction$1(this.datastore), e = this.Pt(t);
            e && e.then((e)=>{
                this.asyncQueue.enqueueAndForget(()=>t.commit().then(()=>{
                        this.deferred.resolve(e);
                    }).catch((t)=>{
                        this.Vt(t);
                    }));
            }).catch((t)=>{
                this.Vt(t);
            });
        });
    }
    Pt(t) {
        try {
            const e = this.updateFunction(t);
            return !$d3a073fac959c995$var$__PRIVATE_isNullOrUndefined(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(t), null;
        }
    }
    Vt(t) {
        this.Et > 0 && this.It(t) ? (this.Et -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Rt(), Promise.resolve()))) : this.deferred.reject(t);
    }
    It(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const e = t.code;
            return "aborted" === e || "failed-precondition" === e || "already-exists" === e || !/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function __PRIVATE_isPermanentError(t) {
                switch(t){
                    default:
                        return $d3a073fac959c995$var$fail();
                    case $d3a073fac959c995$var$m:
                    case $d3a073fac959c995$var$A:
                    case $d3a073fac959c995$var$R:
                    case $d3a073fac959c995$var$y:
                    case $d3a073fac959c995$var$D:
                    case $d3a073fac959c995$var$b:
                    // Unauthenticated means something went wrong with our token and we need
                    // to retry with new credentials which will happen automatically.
                    case $d3a073fac959c995$var$p:
                        return !1;
                    case $d3a073fac959c995$var$T:
                    case $d3a073fac959c995$var$P:
                    case $d3a073fac959c995$var$V:
                    case $d3a073fac959c995$var$I:
                    case $d3a073fac959c995$var$w:
                    // Aborted might be retried in some scenarios, but that is dependent on
                    // the context and should handled individually by the calling code.
                    // See https://cloud.google.com/apis/design/errors.
                    case $d3a073fac959c995$var$g:
                    case $d3a073fac959c995$var$F:
                    case $d3a073fac959c995$var$v:
                    case $d3a073fac959c995$var$C:
                        return !0;
                }
            }(e);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'document' implementation or null if not available. */ function $d3a073fac959c995$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $d3a073fac959c995$var$DelayedOperation {
    constructor(t, e, r, n, i){
        this.asyncQueue = t, this.timerId = e, this.targetTimeMs = r, this.op = n, this.removalCallback = i, this.deferred = new $d3a073fac959c995$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((t)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(t, e, r, n, i) {
        const s = Date.now() + r, o = new $d3a073fac959c995$var$DelayedOperation(t, e, s, n, i);
        return o.start(r), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(t) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), t);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(t) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$m, "Operation cancelled" + (t ? ": " + t : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((t)=>this.deferred.resolve(t))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d3a073fac959c995$var$__PRIVATE_AsyncQueueImpl {
    constructor(){
        // The last promise in the queue.
        this.yt = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.wt = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.gt = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Ft = [], // visible for testing
        this.vt = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Dt = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.bt = !1, // List of TimerIds to fast-forward delays for.
        this.Ct = [], // Backoff timer used to schedule retries for retryable operations
        this.At = new $d3a073fac959c995$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.St = ()=>{
            const t = $d3a073fac959c995$var$getDocument();
            t && $d3a073fac959c995$var$__PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + t.visibilityState), this.At.J();
        };
        const t = $d3a073fac959c995$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.St);
    }
    get isShuttingDown() {
        return this.gt;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }
    enqueueAndForgetEvenWhileRestricted(t) {
        this.Nt(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Ot(t);
    }
    enterRestrictedMode(t) {
        if (!this.gt) {
            this.gt = !0, this.bt = t || !1;
            const e = $d3a073fac959c995$var$getDocument();
            e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.St);
        }
    }
    enqueue(t) {
        if (this.Nt(), this.gt) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const e = new $d3a073fac959c995$var$__PRIVATE_Deferred;
        return this.Ot(()=>this.gt && this.bt ? Promise.resolve() : (t().then(e.resolve, e.reject), e.promise)).then(()=>e.promise);
    }
    enqueueRetryable(t) {
        this.enqueueAndForget(()=>(this.wt.push(t), this.qt()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async qt() {
        if (0 !== this.wt.length) {
            try {
                await this.wt[0](), this.wt.shift(), this.At.reset();
            } catch (t) {
                if (!/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Verifies whether `e` is an IndexedDbTransactionError. */ function __PRIVATE_isIndexedDbTransactionError(t) {
                    // Use name equality, as instanceof checks on errors don't work with errors
                    // that wrap other errors.
                    return "IndexedDbTransactionError" === t.name;
                }(t)) throw t;
                // Failure will be handled by AsyncQueue
                $d3a073fac959c995$var$__PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + t);
            }
            this.wt.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.At.G(()=>this.qt());
        }
    }
    Ot(t) {
        const e = this.yt.then(()=>(this.Dt = !0, t().catch((t)=>{
                this.vt = t, this.Dt = !1;
                const e = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(t) {
                    let e = t.message || "";
                    t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack);
                    return e;
                }(t);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $d3a073fac959c995$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", e), t;
            }).then((t)=>(this.Dt = !1, t))));
        return this.yt = e, e;
    }
    enqueueAfterDelay(t, e, r) {
        this.Nt(), // Fast-forward delays for timerIds that have been overridden.
        this.Ct.indexOf(t) > -1 && (e = 0);
        const n = $d3a073fac959c995$var$DelayedOperation.createAndSchedule(this, t, e, r, (t)=>this.Bt(t));
        return this.Ft.push(n), n;
    }
    Nt() {
        this.vt && $d3a073fac959c995$var$fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async $t() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let t;
        do t = this.yt, await t;
        while (t !== this.yt);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Qt(t) {
        for (const e of this.Ft)if (e.timerId === t) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Lt(t) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.$t().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Ft.sort((t, e)=>t.targetTimeMs - e.targetTimeMs);
            for (const e of this.Ft)if (e.skipDelay(), "all" /* TimerId.All */  !== t && e.timerId === t) break;
            return this.$t();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Mt(t) {
        this.Ct.push(t);
    }
    /** Called once a DelayedOperation is run or canceled. */ Bt(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const e = this.Ft.indexOf(t);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Ft.splice(e, 1);
    }
}
class $d3a073fac959c995$export$febc5573c75cefb0 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = $d3a073fac959c995$var$__PRIVATE_newUserDataReader(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore), r = new $d3a073fac959c995$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return $d3a073fac959c995$var$fail();
            const n = t[0];
            if (n.isFoundDocument()) return new $d3a073fac959c995$export$acab0e6ef25eb301(this._firestore, r, n.key, n, e.converter);
            if (n.isNoDocument()) return new $d3a073fac959c995$export$acab0e6ef25eb301(this._firestore, r, e._key, null, e.converter);
            throw $d3a073fac959c995$var$fail();
        });
    }
    set(t, e, r) {
        const n = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore), i = $d3a073fac959c995$var$__PRIVATE_applyFirestoreDataConverter(n.converter, e, r), s = $d3a073fac959c995$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", n._key, i, null !== n.converter, r);
        return this._transaction.set(n._key, s), this;
    }
    update(t, e, r, ...n) {
        const i = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $d3a073fac959c995$export$a1a8fea822d17659 ? $d3a073fac959c995$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, e, r, n) : $d3a073fac959c995$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, e), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $d3a073fac959c995$var$__PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $d3a073fac959c995$export$3c54e006bf9c93b7(t, e, r) {
    const n = $d3a073fac959c995$var$__PRIVATE_getDatastore(t = $d3a073fac959c995$var$__PRIVATE_cast(t, $d3a073fac959c995$export$d0e2b3272814ce82)), i = Object.assign(Object.assign({}, $d3a073fac959c995$var$z), r);
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, "Max attempts must be at least 1");
    }(i);
    const s = new $d3a073fac959c995$var$__PRIVATE_Deferred;
    return new $d3a073fac959c995$var$__PRIVATE_TransactionRunner(function __PRIVATE_newAsyncQueue() {
        return new $d3a073fac959c995$var$__PRIVATE_AsyncQueueImpl;
    }(), n, i, (r)=>e(new $d3a073fac959c995$export$febc5573c75cefb0(t, r)), s).Tt(), s.promise;
}
/**
 * Firestore Lite
 *
 * @remarks Firestore Lite is a small online-only SDK that allows read
 * and write access to your Firestore database. All operations connect
 * directly to the backend, and `onSnapshot()` APIs are not supported.
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore() {
    !function __PRIVATE_setSDKVersion(t) {
        $d3a073fac959c995$var$d = t;
    }(`${(0, $57d436074e210fb5$export$31499a9cd224b78c)}_lite`), (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("firestore/lite", (t, { instanceIdentifier: e, options: r })=>{
        const n = t.getProvider("app").getImmediate(), i = new $d3a073fac959c995$export$d0e2b3272814ce82(new $d3a073fac959c995$var$__PRIVATE_LiteAuthCredentialsProvider(t.getProvider("auth-internal")), new $d3a073fac959c995$var$__PRIVATE_LiteAppCheckTokenProvider(t.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(t, e) {
            if (!Object.prototype.hasOwnProperty.apply(t.options, [
                "projectId"
            ])) throw new $d3a073fac959c995$export$8fada0bf726bf278($d3a073fac959c995$var$T, '"projectId" not provided in firebase.initializeApp.');
            return new $d3a073fac959c995$var$DatabaseId(t.options.projectId, e);
        }(n, e), n);
        return r && i._setSettings(r), i;
    }, "PUBLIC").setMultipleInstances(!0)), // RUNTIME_ENV and BUILD_TARGET are replaced by real values during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)("firestore-lite", "4.7.1", ""), (0, $57d436074e210fb5$export$d29d5299a7137abc)("firestore-lite", "4.7.1", "esm2017");
}();








var $7WQrb = parcelRequire("7WQrb");

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registered for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: "The supplied auth credential is incorrect, malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $efefa77b88ebd4a6$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $efefa77b88ebd4a6$export$2329c99376c9d0a4 = $efefa77b88ebd4a6$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $efefa77b88ebd4a6$export$7f8ddf7c7c20b3cd = $efefa77b88ebd4a6$var$_prodErrorMap;
const $efefa77b88ebd4a6$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", $efefa77b88ebd4a6$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/auth");
function $efefa77b88ebd4a6$var$_logWarn(msg, ...args) {
    if ($efefa77b88ebd4a6$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) $efefa77b88ebd4a6$var$logClient.warn(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $efefa77b88ebd4a6$var$_logError(msg, ...args) {
    if ($efefa77b88ebd4a6$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) $efefa77b88ebd4a6$var$logClient.error(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $efefa77b88ebd4a6$var$createErrorInternal(authOrCode, ...rest);
}
function $efefa77b88ebd4a6$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $efefa77b88ebd4a6$var$createErrorInternal(authOrCode, ...rest);
}
function $efefa77b88ebd4a6$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $efefa77b88ebd4a6$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $efefa77b88ebd4a6$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $efefa77b88ebd4a6$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $efefa77b88ebd4a6$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $efefa77b88ebd4a6$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $efefa77b88ebd4a6$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $efefa77b88ebd4a6$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $efefa77b88ebd4a6$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $efefa77b88ebd4a6$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $efefa77b88ebd4a6$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $efefa77b88ebd4a6$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $efefa77b88ebd4a6$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $efefa77b88ebd4a6$var$_isHttpOrHttps() {
    return $efefa77b88ebd4a6$var$_getCurrentScheme() === "http:" || $efefa77b88ebd4a6$var$_getCurrentScheme() === "https:";
}
function $efefa77b88ebd4a6$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $efefa77b88ebd4a6$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($efefa77b88ebd4a6$var$_isHttpOrHttps() || (0, $c38e0f42709c826a$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $efefa77b88ebd4a6$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $efefa77b88ebd4a6$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $efefa77b88ebd4a6$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $c38e0f42709c826a$export$872f8323f01d7ae0)() || (0, $c38e0f42709c826a$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$efefa77b88ebd4a6$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$_emulatorUrl(config, path) {
    $efefa77b88ebd4a6$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $efefa77b88ebd4a6$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $efefa77b88ebd4a6$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $efefa77b88ebd4a6$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $efefa77b88ebd4a6$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$DEFAULT_API_TIMEOUT_MS = new $efefa77b88ebd4a6$var$Delay(30000, 60000);
function $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $efefa77b88ebd4a6$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $efefa77b88ebd4a6$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $c38e0f42709c826a$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $efefa77b88ebd4a6$export$2ed0fc6709e59212.fetch()($efefa77b88ebd4a6$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $efefa77b88ebd4a6$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $efefa77b88ebd4a6$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $efefa77b88ebd4a6$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $efefa77b88ebd4a6$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $efefa77b88ebd4a6$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $efefa77b88ebd4a6$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $efefa77b88ebd4a6$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $efefa77b88ebd4a6$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $efefa77b88ebd4a6$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $efefa77b88ebd4a6$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $efefa77b88ebd4a6$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $efefa77b88ebd4a6$var$_emulatorUrl(auth.config, base);
}
function $efefa77b88ebd4a6$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $efefa77b88ebd4a6$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($efefa77b88ebd4a6$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $efefa77b88ebd4a6$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $efefa77b88ebd4a6$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $efefa77b88ebd4a6$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $efefa77b88ebd4a6$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $efefa77b88ebd4a6$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $efefa77b88ebd4a6$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$getRecaptchaParams(auth) {
    return (await $efefa77b88ebd4a6$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $efefa77b88ebd4a6$var$getRecaptchaConfig(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$deleteAccount(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $efefa77b88ebd4a6$var$deleteLinkedAccounts(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $efefa77b88ebd4a6$var$getAccountInfo(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $efefa77b88ebd4a6$var$_parseToken(token);
    $efefa77b88ebd4a6$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $efefa77b88ebd4a6$var$utcTimestampToDateString($efefa77b88ebd4a6$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $efefa77b88ebd4a6$var$utcTimestampToDateString($efefa77b88ebd4a6$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $efefa77b88ebd4a6$var$utcTimestampToDateString($efefa77b88ebd4a6$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $efefa77b88ebd4a6$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $efefa77b88ebd4a6$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $efefa77b88ebd4a6$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $c38e0f42709c826a$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $efefa77b88ebd4a6$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $efefa77b88ebd4a6$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $efefa77b88ebd4a6$var$_tokenExpiresIn(token) {
    const parsedToken = $efefa77b88ebd4a6$var$_parseToken(token);
    $efefa77b88ebd4a6$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && $efefa77b88ebd4a6$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $efefa77b88ebd4a6$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $efefa77b88ebd4a6$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $efefa77b88ebd4a6$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(user, $efefa77b88ebd4a6$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $efefa77b88ebd4a6$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $efefa77b88ebd4a6$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $efefa77b88ebd4a6$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $efefa77b88ebd4a6$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$d24c54395ce0c509(user) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $efefa77b88ebd4a6$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $efefa77b88ebd4a6$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $efefa77b88ebd4a6$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $7WQrb.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$requestStsToken(auth, refreshToken) {
    const response = await $efefa77b88ebd4a6$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $c38e0f42709c826a$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $efefa77b88ebd4a6$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $efefa77b88ebd4a6$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $efefa77b88ebd4a6$var$revokeToken(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $efefa77b88ebd4a6$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $efefa77b88ebd4a6$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $efefa77b88ebd4a6$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $efefa77b88ebd4a6$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $efefa77b88ebd4a6$var$StsTokenManager();
        if (refreshToken) {
            $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $efefa77b88ebd4a6$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $efefa77b88ebd4a6$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$assertStringOrUndefined(assertion, appName) {
    $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $efefa77b88ebd4a6$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $7WQrb.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $efefa77b88ebd4a6$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $efefa77b88ebd4a6$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $efefa77b88ebd4a6$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $efefa77b88ebd4a6$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $efefa77b88ebd4a6$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $efefa77b88ebd4a6$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $efefa77b88ebd4a6$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $efefa77b88ebd4a6$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $efefa77b88ebd4a6$var$_logoutIfInvalidated(this, $efefa77b88ebd4a6$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $efefa77b88ebd4a6$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $efefa77b88ebd4a6$var$assertStringOrUndefined(displayName, auth.name);
        $efefa77b88ebd4a6$var$assertStringOrUndefined(email, auth.name);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $efefa77b88ebd4a6$var$assertStringOrUndefined(phoneNumber, auth.name);
        $efefa77b88ebd4a6$var$assertStringOrUndefined(photoURL, auth.name);
        $efefa77b88ebd4a6$var$assertStringOrUndefined(tenantId, auth.name);
        $efefa77b88ebd4a6$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $efefa77b88ebd4a6$var$assertStringOrUndefined(createdAt, auth.name);
        $efefa77b88ebd4a6$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $efefa77b88ebd4a6$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $efefa77b88ebd4a6$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $efefa77b88ebd4a6$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $efefa77b88ebd4a6$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $efefa77b88ebd4a6$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $efefa77b88ebd4a6$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $efefa77b88ebd4a6$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $efefa77b88ebd4a6$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $efefa77b88ebd4a6$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$instanceCache = new Map();
function $efefa77b88ebd4a6$export$158acd800e1ef08b(cls) {
    $efefa77b88ebd4a6$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    let instance = $efefa77b88ebd4a6$var$instanceCache.get(cls);
    if (instance) {
        $efefa77b88ebd4a6$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $efefa77b88ebd4a6$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$efefa77b88ebd4a6$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$3a6d5c9ae78a2c08 = $efefa77b88ebd4a6$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $efefa77b88ebd4a6$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $efefa77b88ebd4a6$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $efefa77b88ebd4a6$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $efefa77b88ebd4a6$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $efefa77b88ebd4a6$var$PersistenceUserManager($efefa77b88ebd4a6$export$158acd800e1ef08b($efefa77b88ebd4a6$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $efefa77b88ebd4a6$export$158acd800e1ef08b($efefa77b88ebd4a6$export$3a6d5c9ae78a2c08);
        const key = $efefa77b88ebd4a6$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $efefa77b88ebd4a6$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $efefa77b88ebd4a6$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $efefa77b88ebd4a6$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $efefa77b88ebd4a6$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($efefa77b88ebd4a6$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($efefa77b88ebd4a6$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($efefa77b88ebd4a6$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($efefa77b88ebd4a6$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($efefa77b88ebd4a6$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $efefa77b88ebd4a6$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($efefa77b88ebd4a6$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $efefa77b88ebd4a6$var$_isFirefox(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $efefa77b88ebd4a6$var$_isSafari(userAgent = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $efefa77b88ebd4a6$var$_isChromeIOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $efefa77b88ebd4a6$var$_isIEMobile(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $efefa77b88ebd4a6$export$92108d983e8ee699(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $efefa77b88ebd4a6$var$_isBlackBerry(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $efefa77b88ebd4a6$var$_isWebOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $efefa77b88ebd4a6$export$d66dc83d8cfc8dd(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $efefa77b88ebd4a6$export$91c6e00c14e7e6fd(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $efefa77b88ebd4a6$var$_isIOSStandalone(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    var _a;
    return $efefa77b88ebd4a6$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $efefa77b88ebd4a6$var$_isIE10() {
    return (0, $c38e0f42709c826a$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $efefa77b88ebd4a6$var$_isMobileBrowser(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $efefa77b88ebd4a6$export$d66dc83d8cfc8dd(ua) || $efefa77b88ebd4a6$export$92108d983e8ee699(ua) || $efefa77b88ebd4a6$var$_isWebOS(ua) || $efefa77b88ebd4a6$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $efefa77b88ebd4a6$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $efefa77b88ebd4a6$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $efefa77b88ebd4a6$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$efefa77b88ebd4a6$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $57d436074e210fb5$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $efefa77b88ebd4a6$var$_getPasswordPolicy(auth, request = {}) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $efefa77b88ebd4a6$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $efefa77b88ebd4a6$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $efefa77b88ebd4a6$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $efefa77b88ebd4a6$var$Subscription(this);
        this.idTokenSubscription = new $efefa77b88ebd4a6$var$Subscription(this);
        this.beforeStateQueue = new $efefa77b88ebd4a6$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $efefa77b88ebd4a6$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $efefa77b88ebd4a6$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $efefa77b88ebd4a6$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $efefa77b88ebd4a6$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $efefa77b88ebd4a6$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $efefa77b88ebd4a6$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $efefa77b88ebd4a6$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $efefa77b88ebd4a6$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $efefa77b88ebd4a6$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($efefa77b88ebd4a6$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $efefa77b88ebd4a6$var$_getPasswordPolicy(this);
        const passwordPolicy = new $efefa77b88ebd4a6$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $efefa77b88ebd4a6$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $efefa77b88ebd4a6$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $efefa77b88ebd4a6$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $efefa77b88ebd4a6$var$PersistenceUserManager.create(this, [
                $efefa77b88ebd4a6$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $efefa77b88ebd4a6$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $efefa77b88ebd4a6$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $efefa77b88ebd4a6$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $c38e0f42709c826a$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $efefa77b88ebd4a6$var$externalJSProvider = {
    async loadJS () {
        throw new Error("Unable to load external scripts");
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $efefa77b88ebd4a6$var$_setExternalJSProvider(p) {
    $efefa77b88ebd4a6$var$externalJSProvider = p;
}
function $efefa77b88ebd4a6$var$_loadJS(url) {
    return $efefa77b88ebd4a6$var$externalJSProvider.loadJS(url);
}
function $efefa77b88ebd4a6$var$_recaptchaV2ScriptUrl() {
    return $efefa77b88ebd4a6$var$externalJSProvider.recaptchaV2Script;
}
function $efefa77b88ebd4a6$var$_recaptchaEnterpriseScriptUrl() {
    return $efefa77b88ebd4a6$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $efefa77b88ebd4a6$var$_gapiScriptUrl() {
    return $efefa77b88ebd4a6$var$externalJSProvider.gapiScript;
}
function $efefa77b88ebd4a6$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $efefa77b88ebd4a6$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $efefa77b88ebd4a6$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $efefa77b88ebd4a6$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $efefa77b88ebd4a6$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $efefa77b88ebd4a6$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $efefa77b88ebd4a6$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($efefa77b88ebd4a6$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($efefa77b88ebd4a6$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $efefa77b88ebd4a6$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    let url = $efefa77b88ebd4a6$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $efefa77b88ebd4a6$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $efefa77b88ebd4a6$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $efefa77b88ebd4a6$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $efefa77b88ebd4a6$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $efefa77b88ebd4a6$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $efefa77b88ebd4a6$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $efefa77b88ebd4a6$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const response = await $efefa77b88ebd4a6$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $efefa77b88ebd4a6$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $efefa77b88ebd4a6$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $efefa77b88ebd4a6$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $efefa77b88ebd4a6$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($efefa77b88ebd4a6$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    $efefa77b88ebd4a6$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $efefa77b88ebd4a6$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $efefa77b88ebd4a6$var$extractProtocol(url);
    const { host: host, port: port } = $efefa77b88ebd4a6$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $efefa77b88ebd4a6$var$emitEmulatorWarning();
}
function $efefa77b88ebd4a6$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $efefa77b88ebd4a6$var$extractHostAndPort(url) {
    const protocol = $efefa77b88ebd4a6$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $efefa77b88ebd4a6$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $efefa77b88ebd4a6$var$parsePort(port)
        };
    }
}
function $efefa77b88ebd4a6$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $efefa77b88ebd4a6$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $efefa77b88ebd4a6$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $efefa77b88ebd4a6$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $efefa77b88ebd4a6$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $efefa77b88ebd4a6$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$resetPassword(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
async function $efefa77b88ebd4a6$var$updateEmailPassword(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $efefa77b88ebd4a6$var$linkEmailPassword(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $efefa77b88ebd4a6$var$applyActionCode$1(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$signInWithPassword(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
async function $efefa77b88ebd4a6$var$sendOobCode(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
async function $efefa77b88ebd4a6$var$sendEmailVerification$1(auth, request) {
    return $efefa77b88ebd4a6$var$sendOobCode(auth, request);
}
async function $efefa77b88ebd4a6$var$sendPasswordResetEmail$1(auth, request) {
    return $efefa77b88ebd4a6$var$sendOobCode(auth, request);
}
async function $efefa77b88ebd4a6$var$sendSignInLinkToEmail$1(auth, request) {
    return $efefa77b88ebd4a6$var$sendOobCode(auth, request);
}
async function $efefa77b88ebd4a6$var$verifyAndChangeEmail(auth, request) {
    return $efefa77b88ebd4a6$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$signInWithEmailLink$1(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
async function $efefa77b88ebd4a6$var$signInWithEmailLinkForLinking(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$3a1a48c8f6ef640e extends $efefa77b88ebd4a6$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $efefa77b88ebd4a6$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $efefa77b88ebd4a6$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $efefa77b88ebd4a6$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $efefa77b88ebd4a6$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $efefa77b88ebd4a6$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $efefa77b88ebd4a6$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $efefa77b88ebd4a6$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $efefa77b88ebd4a6$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$signInWithIdp(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$a07804094c3ecf2d extends $efefa77b88ebd4a6$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $efefa77b88ebd4a6$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $efefa77b88ebd4a6$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $7WQrb.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $efefa77b88ebd4a6$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $efefa77b88ebd4a6$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $c38e0f42709c826a$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$sendPhoneVerificationCode(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
async function $efefa77b88ebd4a6$var$signInWithPhoneNumber$1(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
async function $efefa77b88ebd4a6$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $efefa77b88ebd4a6$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $efefa77b88ebd4a6$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $efefa77b88ebd4a6$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, apiRequest), $efefa77b88ebd4a6$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$3722cfe417b6ed86 extends $efefa77b88ebd4a6$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $efefa77b88ebd4a6$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $efefa77b88ebd4a6$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $efefa77b88ebd4a6$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $efefa77b88ebd4a6$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $efefa77b88ebd4a6$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $efefa77b88ebd4a6$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $efefa77b88ebd4a6$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $efefa77b88ebd4a6$var$parseDeepLink(url) {
    const link = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $efefa77b88ebd4a6$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $efefa77b88ebd4a6$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $efefa77b88ebd4a6$var$parseDeepLink(link);
        try {
            return new $efefa77b88ebd4a6$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$3b513254972cfc9c(link) {
    return $efefa77b88ebd4a6$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $efefa77b88ebd4a6$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $efefa77b88ebd4a6$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $efefa77b88ebd4a6$export$f38c853ae54ed474.parseLink(emailLink);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $efefa77b88ebd4a6$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $efefa77b88ebd4a6$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $efefa77b88ebd4a6$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $efefa77b88ebd4a6$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $efefa77b88ebd4a6$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $efefa77b88ebd4a6$var$BaseOAuthProvider extends $efefa77b88ebd4a6$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $efefa77b88ebd4a6$export$dc98b0b04f4c7758 extends $efefa77b88ebd4a6$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $efefa77b88ebd4a6$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $efefa77b88ebd4a6$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $efefa77b88ebd4a6$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $efefa77b88ebd4a6$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $efefa77b88ebd4a6$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $efefa77b88ebd4a6$export$71cec2538cb2c617 extends $efefa77b88ebd4a6$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $efefa77b88ebd4a6$export$a07804094c3ecf2d._fromParams({
            providerId: $efefa77b88ebd4a6$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $efefa77b88ebd4a6$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $efefa77b88ebd4a6$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $efefa77b88ebd4a6$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $efefa77b88ebd4a6$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $efefa77b88ebd4a6$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $efefa77b88ebd4a6$export$78acf4525d8a74c4 extends $efefa77b88ebd4a6$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $efefa77b88ebd4a6$export$a07804094c3ecf2d._fromParams({
            providerId: $efefa77b88ebd4a6$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $efefa77b88ebd4a6$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $efefa77b88ebd4a6$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $efefa77b88ebd4a6$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $efefa77b88ebd4a6$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $efefa77b88ebd4a6$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $efefa77b88ebd4a6$export$8743009a87fcb00f extends $efefa77b88ebd4a6$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $efefa77b88ebd4a6$export$a07804094c3ecf2d._fromParams({
            providerId: $efefa77b88ebd4a6$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $efefa77b88ebd4a6$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $efefa77b88ebd4a6$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $efefa77b88ebd4a6$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $efefa77b88ebd4a6$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $efefa77b88ebd4a6$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $efefa77b88ebd4a6$export$f96d196f7728bb5 extends $efefa77b88ebd4a6$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $efefa77b88ebd4a6$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $efefa77b88ebd4a6$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $efefa77b88ebd4a6$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$71511d61b312f219 extends $efefa77b88ebd4a6$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $efefa77b88ebd4a6$export$890c4ad488842ce7(providerId.startsWith($efefa77b88ebd4a6$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $efefa77b88ebd4a6$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $efefa77b88ebd4a6$export$f96d196f7728bb5.fromJSON(json);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $efefa77b88ebd4a6$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9 extends $efefa77b88ebd4a6$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $efefa77b88ebd4a6$export$a07804094c3ecf2d._fromParams({
            providerId: $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $efefa77b88ebd4a6$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$signUp(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $efefa77b88ebd4a6$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $efefa77b88ebd4a6$var$providerIdForResponse(idTokenResponse);
        const userCred = new $efefa77b88ebd4a6$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $efefa77b88ebd4a6$var$providerIdForResponse(response);
        return new $efefa77b88ebd4a6$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $efefa77b88ebd4a6$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $efefa77b88ebd4a6$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $efefa77b88ebd4a6$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $efefa77b88ebd4a6$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$MultiFactorError extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $efefa77b88ebd4a6$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $efefa77b88ebd4a6$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $efefa77b88ebd4a6$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $efefa77b88ebd4a6$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $efefa77b88ebd4a6$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $efefa77b88ebd4a6$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $efefa77b88ebd4a6$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $efefa77b88ebd4a6$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $efefa77b88ebd4a6$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $efefa77b88ebd4a6$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $efefa77b88ebd4a6$var$_assertLinkedStatus(expected, user, provider) {
    await $efefa77b88ebd4a6$var$_reloadWithoutSaving(user);
    const providerIds = $efefa77b88ebd4a6$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(user, $efefa77b88ebd4a6$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $efefa77b88ebd4a6$var$_parseToken(response.idToken);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $efefa77b88ebd4a6$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $efefa77b88ebd4a6$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $efefa77b88ebd4a6$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$3c2fa207a37baaea(auth, credential) {
    return $efefa77b88ebd4a6$var$_signInWithCredential($efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $efefa77b88ebd4a6$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $efefa77b88ebd4a6$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$6559d589eb85fbb6(user, credential) {
    return $efefa77b88ebd4a6$var$_reauthenticate((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$signInWithCustomToken$1(auth, request) {
    return $efefa77b88ebd4a6$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const response = await $efefa77b88ebd4a6$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $efefa77b88ebd4a6$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $efefa77b88ebd4a6$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $efefa77b88ebd4a6$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $efefa77b88ebd4a6$var$PhoneMultiFactorInfoImpl extends $efefa77b88ebd4a6$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $efefa77b88ebd4a6$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $efefa77b88ebd4a6$var$TotpMultiFactorInfoImpl extends $efefa77b88ebd4a6$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $efefa77b88ebd4a6$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $efefa77b88ebd4a6$var$recachePasswordPolicy(auth) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $efefa77b88ebd4a6$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $efefa77b88ebd4a6$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $efefa77b88ebd4a6$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $efefa77b88ebd4a6$var$resetPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $efefa77b88ebd4a6$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$a93c5207d687da10(auth, oobCode) {
    await $efefa77b88ebd4a6$var$applyActionCode$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const response = await $efefa77b88ebd4a6$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $efefa77b88ebd4a6$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $efefa77b88ebd4a6$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $efefa77b88ebd4a6$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $efefa77b88ebd4a6$var$MultiFactorInfoImpl._fromServerResponse($efefa77b88ebd4a6$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $efefa77b88ebd4a6$export$c3950d9923825c02((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $efefa77b88ebd4a6$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $efefa77b88ebd4a6$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $efefa77b88ebd4a6$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $efefa77b88ebd4a6$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$555508cbc6add439(auth, email, password) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $efefa77b88ebd4a6$export$3c2fa207a37baaea((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), $efefa77b88ebd4a6$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $efefa77b88ebd4a6$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $efefa77b88ebd4a6$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $efefa77b88ebd4a6$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $efefa77b88ebd4a6$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $efefa77b88ebd4a6$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const credential = $efefa77b88ebd4a6$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $efefa77b88ebd4a6$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $efefa77b88ebd4a6$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $efefa77b88ebd4a6$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$createAuthUri(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $efefa77b88ebd4a6$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $efefa77b88ebd4a6$var$_isHttpOrHttps() ? $efefa77b88ebd4a6$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $efefa77b88ebd4a6$var$createAuthUri((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $efefa77b88ebd4a6$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $efefa77b88ebd4a6$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $efefa77b88ebd4a6$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $efefa77b88ebd4a6$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$var$updateProfile$1(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(userInternal, $efefa77b88ebd4a6$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $efefa77b88ebd4a6$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$1a82df3d29112e01(user, newPassword) {
    return $efefa77b88ebd4a6$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $efefa77b88ebd4a6$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(user, $efefa77b88ebd4a6$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $efefa77b88ebd4a6$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $efefa77b88ebd4a6$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $efefa77b88ebd4a6$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $efefa77b88ebd4a6$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $efefa77b88ebd4a6$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $efefa77b88ebd4a6$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $efefa77b88ebd4a6$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $efefa77b88ebd4a6$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $efefa77b88ebd4a6$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $efefa77b88ebd4a6$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $efefa77b88ebd4a6$var$FederatedAdditionalUserInfoWithUsername extends $efefa77b88ebd4a6$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $efefa77b88ebd4a6$var$FacebookAdditionalUserInfo extends $efefa77b88ebd4a6$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $efefa77b88ebd4a6$var$GithubAdditionalUserInfo extends $efefa77b88ebd4a6$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $efefa77b88ebd4a6$var$GoogleAdditionalUserInfo extends $efefa77b88ebd4a6$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $efefa77b88ebd4a6$var$TwitterAdditionalUserInfo extends $efefa77b88ebd4a6$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $efefa77b88ebd4a6$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $efefa77b88ebd4a6$export$9e5f44173e64f162(auth, persistence) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$625550452a3fa3ec(auth) {
    return $efefa77b88ebd4a6$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$90a7f3efeed30595(auth, password) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $efefa77b88ebd4a6$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$df995fae86a55f06(auth) {
    (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$ef35774e6d314e91(auth, user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$e7094788287c5e9b(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$96f57966bedc81b4(auth, token) {
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$a9c23c6ac3fc3eca(user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $efefa77b88ebd4a6$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $efefa77b88ebd4a6$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $efefa77b88ebd4a6$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $efefa77b88ebd4a6$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$efefa77b88ebd4a6$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $efefa77b88ebd4a6$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $efefa77b88ebd4a6$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $efefa77b88ebd4a6$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $efefa77b88ebd4a6$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $efefa77b88ebd4a6$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $efefa77b88ebd4a6$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $efefa77b88ebd4a6$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $efefa77b88ebd4a6$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$startEnrollPhoneMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
function $efefa77b88ebd4a6$var$finalizeEnrollPhoneMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
function $efefa77b88ebd4a6$var$startEnrollTotpMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
function $efefa77b88ebd4a6$var$finalizeEnrollTotpMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
function $efefa77b88ebd4a6$var$withdrawMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
class $efefa77b88ebd4a6$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$efefa77b88ebd4a6$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $efefa77b88ebd4a6$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $efefa77b88ebd4a6$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $efefa77b88ebd4a6$var$_logoutIfInvalidated(this.user, $efefa77b88ebd4a6$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $efefa77b88ebd4a6$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$493d36ec626b6698(user) {
    const userModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if (!$efefa77b88ebd4a6$var$multiFactorUserCache.has(userModular)) $efefa77b88ebd4a6$var$multiFactorUserCache.set(userModular, $efefa77b88ebd4a6$var$MultiFactorUserImpl._fromUser(userModular));
    return $efefa77b88ebd4a6$var$multiFactorUserCache.get(userModular);
}
const $efefa77b88ebd4a6$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $efefa77b88ebd4a6$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($efefa77b88ebd4a6$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($efefa77b88ebd4a6$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $efefa77b88ebd4a6$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $efefa77b88ebd4a6$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $efefa77b88ebd4a6$var$BrowserLocalPersistence extends $efefa77b88ebd4a6$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $efefa77b88ebd4a6$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($efefa77b88ebd4a6$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $efefa77b88ebd4a6$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $efefa77b88ebd4a6$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$efefa77b88ebd4a6$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$8b22cf2602fb60ce = $efefa77b88ebd4a6$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$BrowserSessionPersistence extends $efefa77b88ebd4a6$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$efefa77b88ebd4a6$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$407448d2b89b1813 = $efefa77b88ebd4a6$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $efefa77b88ebd4a6$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $efefa77b88ebd4a6$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $efefa77b88ebd4a6$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $efefa77b88ebd4a6$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$efefa77b88ebd4a6$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$export$faec65b429be379(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $efefa77b88ebd4a6$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $efefa77b88ebd4a6$export$faec65b429be379("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $efefa77b88ebd4a6$var$_window() {
    return window;
}
function $efefa77b88ebd4a6$var$_setWindowLocation(url) {
    $efefa77b88ebd4a6$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$_isWorker() {
    return typeof $efefa77b88ebd4a6$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $efefa77b88ebd4a6$var$_window()["importScripts"] === "function";
}
async function $efefa77b88ebd4a6$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $efefa77b88ebd4a6$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $efefa77b88ebd4a6$var$_getWorkerGlobalScope() {
    return $efefa77b88ebd4a6$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$DB_NAME = "firebaseLocalStorageDb";
const $efefa77b88ebd4a6$var$DB_VERSION = 1;
const $efefa77b88ebd4a6$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $efefa77b88ebd4a6$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $efefa77b88ebd4a6$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $efefa77b88ebd4a6$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $efefa77b88ebd4a6$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($efefa77b88ebd4a6$var$DB_OBJECTSTORE_NAME);
}
function $efefa77b88ebd4a6$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($efefa77b88ebd4a6$var$DB_NAME);
    return new $efefa77b88ebd4a6$var$DBPromise(request).toPromise();
}
function $efefa77b88ebd4a6$var$_openDatabase() {
    const request = indexedDB.open($efefa77b88ebd4a6$var$DB_NAME, $efefa77b88ebd4a6$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($efefa77b88ebd4a6$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $efefa77b88ebd4a6$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($efefa77b88ebd4a6$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $efefa77b88ebd4a6$var$_deleteDatabase();
                resolve(await $efefa77b88ebd4a6$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $efefa77b88ebd4a6$var$_putObject(db, key, value) {
    const request = $efefa77b88ebd4a6$var$getObjectStore(db, true).put({
        [$efefa77b88ebd4a6$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $efefa77b88ebd4a6$var$DBPromise(request).toPromise();
}
async function $efefa77b88ebd4a6$var$getObject(db, key) {
    const request = $efefa77b88ebd4a6$var$getObjectStore(db, false).get(key);
    const data = await new $efefa77b88ebd4a6$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $efefa77b88ebd4a6$var$_deleteObject(db, key) {
    const request = $efefa77b88ebd4a6$var$getObjectStore(db, true).delete(key);
    return new $efefa77b88ebd4a6$var$DBPromise(request).toPromise();
}
const $efefa77b88ebd4a6$var$_POLLING_INTERVAL_MS = 800;
const $efefa77b88ebd4a6$var$_TRANSACTION_RETRY_COUNT = 3;
class $efefa77b88ebd4a6$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $efefa77b88ebd4a6$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $efefa77b88ebd4a6$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $efefa77b88ebd4a6$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $efefa77b88ebd4a6$var$Receiver._getInstance($efefa77b88ebd4a6$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $efefa77b88ebd4a6$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $efefa77b88ebd4a6$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $efefa77b88ebd4a6$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $efefa77b88ebd4a6$var$_openDatabase();
            await $efefa77b88ebd4a6$var$_putObject(db, $efefa77b88ebd4a6$var$STORAGE_AVAILABLE_KEY, "1");
            await $efefa77b88ebd4a6$var$_deleteObject(db, $efefa77b88ebd4a6$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$efefa77b88ebd4a6$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$efefa77b88ebd4a6$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$efefa77b88ebd4a6$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $efefa77b88ebd4a6$var$getObjectStore(db, false).getAll();
            return new $efefa77b88ebd4a6$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $efefa77b88ebd4a6$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$efefa77b88ebd4a6$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$23f2a1d2818174ef = $efefa77b88ebd4a6$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$startSignInPhoneMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
function $efefa77b88ebd4a6$var$finalizeSignInPhoneMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
function $efefa77b88ebd4a6$var$finalizeSignInTotpMfa(auth, request) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $efefa77b88ebd4a6$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$_SOLVE_TIME_MS = 500;
const $efefa77b88ebd4a6$var$_EXPIRATION_TIME_MS = 60000;
const $efefa77b88ebd4a6$var$_WIDGET_ID_START = 1000000000000;
class $efefa77b88ebd4a6$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $efefa77b88ebd4a6$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $efefa77b88ebd4a6$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $efefa77b88ebd4a6$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $efefa77b88ebd4a6$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $efefa77b88ebd4a6$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $efefa77b88ebd4a6$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $efefa77b88ebd4a6$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $efefa77b88ebd4a6$var$_EXPIRATION_TIME_MS);
        }, $efefa77b88ebd4a6$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $efefa77b88ebd4a6$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $efefa77b88ebd4a6$var$_JSLOAD_CALLBACK = $efefa77b88ebd4a6$var$_generateCallbackName("rcb");
const $efefa77b88ebd4a6$var$NETWORK_TIMEOUT_DELAY = new $efefa77b88ebd4a6$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $efefa77b88ebd4a6$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $efefa77b88ebd4a6$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $efefa77b88ebd4a6$export$890c4ad488842ce7($efefa77b88ebd4a6$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $efefa77b88ebd4a6$var$isV2($efefa77b88ebd4a6$var$_window().grecaptcha)) return Promise.resolve($efefa77b88ebd4a6$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $efefa77b88ebd4a6$var$_window().setTimeout(()=>{
                reject($efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $efefa77b88ebd4a6$var$NETWORK_TIMEOUT_DELAY.get());
            $efefa77b88ebd4a6$var$_window()[$efefa77b88ebd4a6$var$_JSLOAD_CALLBACK] = ()=>{
                $efefa77b88ebd4a6$var$_window().clearTimeout(networkTimeout);
                delete $efefa77b88ebd4a6$var$_window()[$efefa77b88ebd4a6$var$_JSLOAD_CALLBACK];
                const recaptcha = $efefa77b88ebd4a6$var$_window().grecaptcha;
                if (!recaptcha || !$efefa77b88ebd4a6$var$isV2(recaptcha)) {
                    reject($efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$efefa77b88ebd4a6$var$_recaptchaV2ScriptUrl()}?${(0, $c38e0f42709c826a$export$ac4103b836844853)({
                onload: $efefa77b88ebd4a6$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $efefa77b88ebd4a6$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $efefa77b88ebd4a6$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $efefa77b88ebd4a6$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $efefa77b88ebd4a6$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $efefa77b88ebd4a6$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $efefa77b88ebd4a6$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $efefa77b88ebd4a6$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $efefa77b88ebd4a6$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $efefa77b88ebd4a6$var$MockReCaptchaLoaderImpl() : new $efefa77b88ebd4a6$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $efefa77b88ebd4a6$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7($efefa77b88ebd4a6$var$_isHttpOrHttps() && !$efefa77b88ebd4a6$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $efefa77b88ebd4a6$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $efefa77b88ebd4a6$var$getRecaptchaParams(this.auth);
        $efefa77b88ebd4a6$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $efefa77b88ebd4a6$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $efefa77b88ebd4a6$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const verificationId = await $efefa77b88ebd4a6$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $efefa77b88ebd4a6$var$ConfirmationResultImpl(verificationId, (cred)=>$efefa77b88ebd4a6$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $efefa77b88ebd4a6$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $efefa77b88ebd4a6$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $efefa77b88ebd4a6$var$ConfirmationResultImpl(verificationId, (cred)=>$efefa77b88ebd4a6$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $efefa77b88ebd4a6$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $efefa77b88ebd4a6$var$ConfirmationResultImpl(verificationId, (cred)=>$efefa77b88ebd4a6$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $efefa77b88ebd4a6$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $efefa77b88ebd4a6$export$890c4ad488842ce7(verifier.type === $efefa77b88ebd4a6$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $efefa77b88ebd4a6$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $efefa77b88ebd4a6$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $efefa77b88ebd4a6$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $efefa77b88ebd4a6$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $efefa77b88ebd4a6$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $efefa77b88ebd4a6$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $efefa77b88ebd4a6$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $efefa77b88ebd4a6$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $efefa77b88ebd4a6$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $efefa77b88ebd4a6$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $efefa77b88ebd4a6$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $efefa77b88ebd4a6$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $efefa77b88ebd4a6$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $efefa77b88ebd4a6$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $efefa77b88ebd4a6$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $efefa77b88ebd4a6$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $efefa77b88ebd4a6$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $efefa77b88ebd4a6$export$158acd800e1ef08b(resolverOverride);
    $efefa77b88ebd4a6$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$IdpCredential extends $efefa77b88ebd4a6$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $efefa77b88ebd4a6$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $efefa77b88ebd4a6$var$_signIn(params) {
    return $efefa77b88ebd4a6$var$_signInWithCredential(params.auth, new $efefa77b88ebd4a6$var$IdpCredential(params), params.bypassAuthState);
}
function $efefa77b88ebd4a6$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $efefa77b88ebd4a6$var$_reauthenticate(user, new $efefa77b88ebd4a6$var$IdpCredential(params), params.bypassAuthState);
}
async function $efefa77b88ebd4a6$var$_link(params) {
    const { auth: auth, user: user } = params;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $efefa77b88ebd4a6$var$_link$1(user, new $efefa77b88ebd4a6$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $efefa77b88ebd4a6$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $efefa77b88ebd4a6$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $efefa77b88ebd4a6$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $efefa77b88ebd4a6$var$_reauth;
            default:
                $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $efefa77b88ebd4a6$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $efefa77b88ebd4a6$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $efefa77b88ebd4a6$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    $efefa77b88ebd4a6$var$_assertInstanceOf(auth, provider, $efefa77b88ebd4a6$var$FederatedAuthProvider);
    const resolverInternal = $efefa77b88ebd4a6$var$_withDefaultResolver(authInternal, resolver);
    const action = new $efefa77b88ebd4a6$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($efefa77b88ebd4a6$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $efefa77b88ebd4a6$var$_assertInstanceOf(userInternal.auth, provider, $efefa77b88ebd4a6$var$FederatedAuthProvider);
    const resolverInternal = $efefa77b88ebd4a6$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $efefa77b88ebd4a6$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $efefa77b88ebd4a6$var$_assertInstanceOf(userInternal.auth, provider, $efefa77b88ebd4a6$var$FederatedAuthProvider);
    const resolverInternal = $efefa77b88ebd4a6$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $efefa77b88ebd4a6$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $efefa77b88ebd4a6$var$PopupOperation extends $efefa77b88ebd4a6$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($efefa77b88ebd4a6$var$PopupOperation.currentPopupAction) $efefa77b88ebd4a6$var$PopupOperation.currentPopupAction.cancel();
        $efefa77b88ebd4a6$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $efefa77b88ebd4a6$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $efefa77b88ebd4a6$export$1fbe638ecf81657e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $efefa77b88ebd4a6$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($efefa77b88ebd4a6$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($efefa77b88ebd4a6$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $efefa77b88ebd4a6$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($efefa77b88ebd4a6$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $efefa77b88ebd4a6$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$efefa77b88ebd4a6$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $efefa77b88ebd4a6$var$redirectOutcomeMap = new Map();
class $efefa77b88ebd4a6$var$RedirectAction extends $efefa77b88ebd4a6$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $efefa77b88ebd4a6$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $efefa77b88ebd4a6$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $efefa77b88ebd4a6$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $efefa77b88ebd4a6$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $efefa77b88ebd4a6$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $efefa77b88ebd4a6$var$pendingRedirectKey(auth);
    const persistence = $efefa77b88ebd4a6$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $efefa77b88ebd4a6$var$_setPendingRedirectStatus(resolver, auth) {
    return $efefa77b88ebd4a6$var$resolverPersistence(resolver)._set($efefa77b88ebd4a6$var$pendingRedirectKey(auth), "true");
}
function $efefa77b88ebd4a6$export$b9a6b53f9be3734() {
    $efefa77b88ebd4a6$var$redirectOutcomeMap.clear();
}
function $efefa77b88ebd4a6$export$a33b77bbdbb8366c(auth, result) {
    $efefa77b88ebd4a6$var$redirectOutcomeMap.set(auth._key(), result);
}
function $efefa77b88ebd4a6$var$resolverPersistence(resolver) {
    return $efefa77b88ebd4a6$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $efefa77b88ebd4a6$var$pendingRedirectKey(auth) {
    return $efefa77b88ebd4a6$export$cf2f7c5792f80b46($efefa77b88ebd4a6$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$2d1720544b23b823(auth, provider, resolver) {
    return $efefa77b88ebd4a6$var$_signInWithRedirect(auth, provider, resolver);
}
async function $efefa77b88ebd4a6$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    $efefa77b88ebd4a6$var$_assertInstanceOf(auth, provider, $efefa77b88ebd4a6$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $efefa77b88ebd4a6$var$_withDefaultResolver(authInternal, resolver);
    await $efefa77b88ebd4a6$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $efefa77b88ebd4a6$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $efefa77b88ebd4a6$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $efefa77b88ebd4a6$var$_assertInstanceOf(userInternal.auth, provider, $efefa77b88ebd4a6$var$FederatedAuthProvider);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $efefa77b88ebd4a6$var$_withDefaultResolver(userInternal.auth, resolver);
    await $efefa77b88ebd4a6$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $efefa77b88ebd4a6$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$39b482c5e57630a8(user, provider, resolver) {
    return $efefa77b88ebd4a6$var$_linkWithRedirect(user, provider, resolver);
}
async function $efefa77b88ebd4a6$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $efefa77b88ebd4a6$var$_assertInstanceOf(userInternal.auth, provider, $efefa77b88ebd4a6$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $efefa77b88ebd4a6$var$_withDefaultResolver(userInternal.auth, resolver);
    await $efefa77b88ebd4a6$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $efefa77b88ebd4a6$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $efefa77b88ebd4a6$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $efefa77b88ebd4a6$export$35e795649ee09318(auth, resolver) {
    await $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $efefa77b88ebd4a6$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $efefa77b88ebd4a6$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($efefa77b88ebd4a6$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(auth);
    const resolver = $efefa77b88ebd4a6$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $efefa77b88ebd4a6$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $efefa77b88ebd4a6$var$prepareUserForRedirect(user) {
    const eventId = $efefa77b88ebd4a6$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $efefa77b88ebd4a6$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $efefa77b88ebd4a6$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$efefa77b88ebd4a6$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$efefa77b88ebd4a6$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($efefa77b88ebd4a6$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $efefa77b88ebd4a6$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($efefa77b88ebd4a6$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($efefa77b88ebd4a6$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $efefa77b88ebd4a6$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $efefa77b88ebd4a6$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $efefa77b88ebd4a6$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $efefa77b88ebd4a6$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $efefa77b88ebd4a6$export$3d12bd131bb975d1(auth, request = {}) {
    return $efefa77b88ebd4a6$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $efefa77b88ebd4a6$var$HTTP_REGEX = /^https?/;
async function $efefa77b88ebd4a6$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $efefa77b88ebd4a6$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($efefa77b88ebd4a6$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $efefa77b88ebd4a6$var$matchDomain(expected) {
    const currentUrl = $efefa77b88ebd4a6$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$efefa77b88ebd4a6$var$HTTP_REGEX.test(protocol)) return false;
    if ($efefa77b88ebd4a6$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$NETWORK_TIMEOUT = new $efefa77b88ebd4a6$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $efefa77b88ebd4a6$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $efefa77b88ebd4a6$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $efefa77b88ebd4a6$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $efefa77b88ebd4a6$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $efefa77b88ebd4a6$var$resetUnloadedGapiModules();
                    reject($efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $efefa77b88ebd4a6$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $efefa77b88ebd4a6$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $efefa77b88ebd4a6$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $efefa77b88ebd4a6$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $efefa77b88ebd4a6$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $efefa77b88ebd4a6$var$_loadJS(`${$efefa77b88ebd4a6$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $efefa77b88ebd4a6$var$cachedGApiLoader = null;
        throw error;
    });
}
let $efefa77b88ebd4a6$var$cachedGApiLoader = null;
function $efefa77b88ebd4a6$var$_loadGapi(auth) {
    $efefa77b88ebd4a6$var$cachedGApiLoader = $efefa77b88ebd4a6$var$cachedGApiLoader || $efefa77b88ebd4a6$var$loadGapi(auth);
    return $efefa77b88ebd4a6$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$PING_TIMEOUT = new $efefa77b88ebd4a6$var$Delay(5000, 15000);
const $efefa77b88ebd4a6$var$IFRAME_PATH = "__/auth/iframe";
const $efefa77b88ebd4a6$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $efefa77b88ebd4a6$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $efefa77b88ebd4a6$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $efefa77b88ebd4a6$var$getIframeUrl(auth) {
    const config = auth.config;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $efefa77b88ebd4a6$var$_emulatorUrl(config, $efefa77b88ebd4a6$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$efefa77b88ebd4a6$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c)
    };
    const eid = $efefa77b88ebd4a6$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(params).slice(1)}`;
}
async function $efefa77b88ebd4a6$var$_openIframe(auth) {
    const context = await $efefa77b88ebd4a6$var$_loadGapi(auth);
    const gapi1 = $efefa77b88ebd4a6$var$_window().gapi;
    $efefa77b88ebd4a6$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $efefa77b88ebd4a6$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $efefa77b88ebd4a6$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $efefa77b88ebd4a6$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $efefa77b88ebd4a6$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $efefa77b88ebd4a6$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $efefa77b88ebd4a6$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $efefa77b88ebd4a6$var$DEFAULT_WIDTH = 500;
const $efefa77b88ebd4a6$var$DEFAULT_HEIGHT = 600;
const $efefa77b88ebd4a6$var$TARGET_BLANK = "_blank";
const $efefa77b88ebd4a6$var$FIREFOX_EMPTY_URL = "http://localhost";
class $efefa77b88ebd4a6$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $efefa77b88ebd4a6$var$_open(auth, url, name, width = $efefa77b88ebd4a6$var$DEFAULT_WIDTH, height = $efefa77b88ebd4a6$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $efefa77b88ebd4a6$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $efefa77b88ebd4a6$var$_isChromeIOS(ua) ? $efefa77b88ebd4a6$var$TARGET_BLANK : name;
    if ($efefa77b88ebd4a6$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $efefa77b88ebd4a6$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($efefa77b88ebd4a6$var$_isIOSStandalone(ua) && target !== "_self") {
        $efefa77b88ebd4a6$var$openAsNewWindowIOS(url || "", target);
        return new $efefa77b88ebd4a6$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $efefa77b88ebd4a6$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $efefa77b88ebd4a6$export$c03999cb2f36933f(newWin);
}
function $efefa77b88ebd4a6$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $efefa77b88ebd4a6$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $efefa77b88ebd4a6$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $efefa77b88ebd4a6$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $efefa77b88ebd4a6$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $efefa77b88ebd4a6$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $efefa77b88ebd4a6$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $efefa77b88ebd4a6$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $efefa77b88ebd4a6$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$efefa77b88ebd4a6$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$efefa77b88ebd4a6$var$getHandlerBase(auth)}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $efefa77b88ebd4a6$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$efefa77b88ebd4a6$var$WIDGET_PATH}`;
    return $efefa77b88ebd4a6$var$_emulatorUrl(config, $efefa77b88ebd4a6$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $efefa77b88ebd4a6$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $efefa77b88ebd4a6$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $efefa77b88ebd4a6$export$407448d2b89b1813;
        this._completeRedirectFn = $efefa77b88ebd4a6$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $efefa77b88ebd4a6$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $efefa77b88ebd4a6$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $efefa77b88ebd4a6$export$28f7fcd39efa255(auth, provider, authType, $efefa77b88ebd4a6$var$_getCurrentUrl(), eventId);
        return $efefa77b88ebd4a6$var$_open(auth, url, $efefa77b88ebd4a6$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $efefa77b88ebd4a6$export$28f7fcd39efa255(auth, provider, authType, $efefa77b88ebd4a6$var$_getCurrentUrl(), eventId);
        $efefa77b88ebd4a6$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $efefa77b88ebd4a6$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $efefa77b88ebd4a6$var$_openIframe(auth);
        const manager = new $efefa77b88ebd4a6$export$24baa2b76016ce0e(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $efefa77b88ebd4a6$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($efefa77b88ebd4a6$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $efefa77b88ebd4a6$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$efefa77b88ebd4a6$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $efefa77b88ebd4a6$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $efefa77b88ebd4a6$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $efefa77b88ebd4a6$var$_isMobileBrowser() || $efefa77b88ebd4a6$var$_isSafari() || $efefa77b88ebd4a6$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $efefa77b88ebd4a6$export$342063e11d6c3cad = $efefa77b88ebd4a6$var$BrowserPopupRedirectResolver;
class $efefa77b88ebd4a6$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $efefa77b88ebd4a6$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $efefa77b88ebd4a6$var$PhoneMultiFactorAssertionImpl extends $efefa77b88ebd4a6$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $efefa77b88ebd4a6$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $efefa77b88ebd4a6$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $efefa77b88ebd4a6$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $efefa77b88ebd4a6$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $efefa77b88ebd4a6$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $efefa77b88ebd4a6$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $efefa77b88ebd4a6$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $efefa77b88ebd4a6$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $efefa77b88ebd4a6$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $efefa77b88ebd4a6$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $efefa77b88ebd4a6$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $efefa77b88ebd4a6$var$TotpMultiFactorAssertionImpl extends $efefa77b88ebd4a6$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $efefa77b88ebd4a6$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $efefa77b88ebd4a6$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $efefa77b88ebd4a6$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $efefa77b88ebd4a6$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $efefa77b88ebd4a6$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $efefa77b88ebd4a6$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($efefa77b88ebd4a6$var$_isEmptyString(accountName) || $efefa77b88ebd4a6$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($efefa77b88ebd4a6$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($efefa77b88ebd4a6$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $efefa77b88ebd4a6$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $efefa77b88ebd4a6$var$name = "@firebase/auth";
var $efefa77b88ebd4a6$var$version = "1.7.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $efefa77b88ebd4a6$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $efefa77b88ebd4a6$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $efefa77b88ebd4a6$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $efefa77b88ebd4a6$var$registerAuth(clientPlatform) {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $efefa77b88ebd4a6$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $efefa77b88ebd4a6$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $efefa77b88ebd4a6$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $efefa77b88ebd4a6$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $efefa77b88ebd4a6$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $efefa77b88ebd4a6$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($efefa77b88ebd4a6$var$name, $efefa77b88ebd4a6$var$version, $efefa77b88ebd4a6$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($efefa77b88ebd4a6$var$name, $efefa77b88ebd4a6$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $efefa77b88ebd4a6$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $efefa77b88ebd4a6$var$authIdTokenMaxAge = (0, $c38e0f42709c826a$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $efefa77b88ebd4a6$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $efefa77b88ebd4a6$var$lastPostedIdToken = null;
const $efefa77b88ebd4a6$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $efefa77b88ebd4a6$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($efefa77b88ebd4a6$var$lastPostedIdToken === idToken) return;
        $efefa77b88ebd4a6$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $efefa77b88ebd4a6$export$ae1af26003f05816(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $efefa77b88ebd4a6$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $efefa77b88ebd4a6$export$342063e11d6c3cad,
        persistence: [
            $efefa77b88ebd4a6$export$23f2a1d2818174ef,
            $efefa77b88ebd4a6$export$8b22cf2602fb60ce,
            $efefa77b88ebd4a6$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $c38e0f42709c826a$export$5539a1a3afe87d6)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $efefa77b88ebd4a6$var$mintCookieFactory(authTokenSyncUrl.toString());
            $efefa77b88ebd4a6$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $efefa77b88ebd4a6$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $c38e0f42709c826a$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $efefa77b88ebd4a6$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $efefa77b88ebd4a6$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$efefa77b88ebd4a6$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $efefa77b88ebd4a6$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $efefa77b88ebd4a6$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$efefa77b88ebd4a6$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );











parcelRequire("bDB9l");
var $jxKDL = parcelRequire("jxKDL");
parcelRequire("4VvaK");
var $aAT5t = parcelRequire("aAT5t");
parcelRequire("eKvzZ");
var $dm5an = parcelRequire("dm5an");
const $21831430fa78f6cb$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "kms"
    };
};
const $21831430fa78f6cb$export$9c07ced2019f0ae0 = {
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};


parcelRequire("eKvzZ");
var $bLYmx = parcelRequire("bLYmx");
parcelRequire("eKvzZ");
var $l1h1U = parcelRequire("l1h1U");
class $6660c2736ef13da2$export$99ef6fbecf03c73a extends (0, $l1h1U.ServiceException) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $6660c2736ef13da2$export$99ef6fbecf03c73a.prototype);
    }
}


const $fe6b83e0b2870cdc$export$c79a1c249d0daf4c = {
    RSAES_OAEP_SHA_1: "RSAES_OAEP_SHA_1",
    RSAES_OAEP_SHA_256: "RSAES_OAEP_SHA_256",
    RSAES_PKCS1_V1_5: "RSAES_PKCS1_V1_5",
    RSA_AES_KEY_WRAP_SHA_1: "RSA_AES_KEY_WRAP_SHA_1",
    RSA_AES_KEY_WRAP_SHA_256: "RSA_AES_KEY_WRAP_SHA_256",
    SM2PKE: "SM2PKE"
};
class $fe6b83e0b2870cdc$export$8b2247038294033c extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "AlreadyExistsException",
            $fault: "client",
            ...opts
        });
        this.name = "AlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$8b2247038294033c.prototype);
    }
}
class $fe6b83e0b2870cdc$export$252c3ca66ba0fd85 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "DependencyTimeoutException",
            $fault: "server",
            ...opts
        });
        this.name = "DependencyTimeoutException";
        this.$fault = "server";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$252c3ca66ba0fd85.prototype);
    }
}
class $fe6b83e0b2870cdc$export$4ccad7ada726c26c extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidArnException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidArnException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$4ccad7ada726c26c.prototype);
    }
}
class $fe6b83e0b2870cdc$export$10e71730f68afdd extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "KMSInternalException",
            $fault: "server",
            ...opts
        });
        this.name = "KMSInternalException";
        this.$fault = "server";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$10e71730f68afdd.prototype);
    }
}
class $fe6b83e0b2870cdc$export$16b76627a54694a8 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "KMSInvalidStateException",
            $fault: "client",
            ...opts
        });
        this.name = "KMSInvalidStateException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$16b76627a54694a8.prototype);
    }
}
class $fe6b83e0b2870cdc$export$32cc081a9594a58d extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "NotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "NotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$32cc081a9594a58d.prototype);
    }
}
class $fe6b83e0b2870cdc$export$23281100c6d3e286 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CloudHsmClusterInUseException",
            $fault: "client",
            ...opts
        });
        this.name = "CloudHsmClusterInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$23281100c6d3e286.prototype);
    }
}
class $fe6b83e0b2870cdc$export$958c84d54876087c extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CloudHsmClusterInvalidConfigurationException",
            $fault: "client",
            ...opts
        });
        this.name = "CloudHsmClusterInvalidConfigurationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$958c84d54876087c.prototype);
    }
}
class $fe6b83e0b2870cdc$export$ae9eb5e7c2d2320 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CloudHsmClusterNotActiveException",
            $fault: "client",
            ...opts
        });
        this.name = "CloudHsmClusterNotActiveException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$ae9eb5e7c2d2320.prototype);
    }
}
class $fe6b83e0b2870cdc$export$4a47bc4023510138 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CloudHsmClusterNotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "CloudHsmClusterNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$4a47bc4023510138.prototype);
    }
}
class $fe6b83e0b2870cdc$export$3e16948521804ce4 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CloudHsmClusterNotRelatedException",
            $fault: "client",
            ...opts
        });
        this.name = "CloudHsmClusterNotRelatedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$3e16948521804ce4.prototype);
    }
}
class $fe6b83e0b2870cdc$export$c64b14d0b7091188 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts
        });
        this.name = "ConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$c64b14d0b7091188.prototype);
    }
}
class $fe6b83e0b2870cdc$export$c9b12d0cd01dabdd extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CustomKeyStoreInvalidStateException",
            $fault: "client",
            ...opts
        });
        this.name = "CustomKeyStoreInvalidStateException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$c9b12d0cd01dabdd.prototype);
    }
}
class $fe6b83e0b2870cdc$export$6271f525fee4fc2e extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CustomKeyStoreNotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "CustomKeyStoreNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$6271f525fee4fc2e.prototype);
    }
}
const $fe6b83e0b2870cdc$export$c531fd820b95fdae = {
    CLUSTER_NOT_FOUND: "CLUSTER_NOT_FOUND",
    INSUFFICIENT_CLOUDHSM_HSMS: "INSUFFICIENT_CLOUDHSM_HSMS",
    INSUFFICIENT_FREE_ADDRESSES_IN_SUBNET: "INSUFFICIENT_FREE_ADDRESSES_IN_SUBNET",
    INTERNAL_ERROR: "INTERNAL_ERROR",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    NETWORK_ERRORS: "NETWORK_ERRORS",
    SUBNET_NOT_FOUND: "SUBNET_NOT_FOUND",
    USER_LOCKED_OUT: "USER_LOCKED_OUT",
    USER_LOGGED_IN: "USER_LOGGED_IN",
    USER_NOT_FOUND: "USER_NOT_FOUND",
    XKS_PROXY_ACCESS_DENIED: "XKS_PROXY_ACCESS_DENIED",
    XKS_PROXY_INVALID_CONFIGURATION: "XKS_PROXY_INVALID_CONFIGURATION",
    XKS_PROXY_INVALID_RESPONSE: "XKS_PROXY_INVALID_RESPONSE",
    XKS_PROXY_INVALID_TLS_CONFIGURATION: "XKS_PROXY_INVALID_TLS_CONFIGURATION",
    XKS_PROXY_NOT_REACHABLE: "XKS_PROXY_NOT_REACHABLE",
    XKS_PROXY_TIMED_OUT: "XKS_PROXY_TIMED_OUT",
    XKS_VPC_ENDPOINT_SERVICE_INVALID_CONFIGURATION: "XKS_VPC_ENDPOINT_SERVICE_INVALID_CONFIGURATION",
    XKS_VPC_ENDPOINT_SERVICE_NOT_FOUND: "XKS_VPC_ENDPOINT_SERVICE_NOT_FOUND"
};
const $fe6b83e0b2870cdc$export$2263c1997208e06c = {
    CONNECTED: "CONNECTED",
    CONNECTING: "CONNECTING",
    DISCONNECTED: "DISCONNECTED",
    DISCONNECTING: "DISCONNECTING",
    FAILED: "FAILED"
};
class $fe6b83e0b2870cdc$export$340f47bbfda7e763 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidAliasNameException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidAliasNameException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$340f47bbfda7e763.prototype);
    }
}
class $fe6b83e0b2870cdc$export$cd419aa7f32ec382 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$cd419aa7f32ec382.prototype);
    }
}
const $fe6b83e0b2870cdc$export$dd6cc7768a4d3d0b = {
    AWS_CLOUDHSM: "AWS_CLOUDHSM",
    EXTERNAL_KEY_STORE: "EXTERNAL_KEY_STORE"
};
const $fe6b83e0b2870cdc$export$d0ae12bdac01cced = {
    PUBLIC_ENDPOINT: "PUBLIC_ENDPOINT",
    VPC_ENDPOINT_SERVICE: "VPC_ENDPOINT_SERVICE"
};
class $fe6b83e0b2870cdc$export$e004a76e3457cf0 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CustomKeyStoreNameInUseException",
            $fault: "client",
            ...opts
        });
        this.name = "CustomKeyStoreNameInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$e004a76e3457cf0.prototype);
    }
}
class $fe6b83e0b2870cdc$export$ccc7068de32d5e84 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "IncorrectTrustAnchorException",
            $fault: "client",
            ...opts
        });
        this.name = "IncorrectTrustAnchorException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$ccc7068de32d5e84.prototype);
    }
}
class $fe6b83e0b2870cdc$export$4cf39f8fadb17436 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyIncorrectAuthenticationCredentialException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyIncorrectAuthenticationCredentialException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$4cf39f8fadb17436.prototype);
    }
}
class $fe6b83e0b2870cdc$export$db5dabf3b23d1f56 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyInvalidConfigurationException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyInvalidConfigurationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$db5dabf3b23d1f56.prototype);
    }
}
class $fe6b83e0b2870cdc$export$e66b07db1275403f extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyInvalidResponseException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyInvalidResponseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$e66b07db1275403f.prototype);
    }
}
class $fe6b83e0b2870cdc$export$9e20c2de1e147bfb extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyUriEndpointInUseException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyUriEndpointInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$9e20c2de1e147bfb.prototype);
    }
}
class $fe6b83e0b2870cdc$export$cb1889f50a3f853c extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyUriInUseException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyUriInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$cb1889f50a3f853c.prototype);
    }
}
class $fe6b83e0b2870cdc$export$74c89fba2ad4620d extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyUriUnreachableException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyUriUnreachableException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$74c89fba2ad4620d.prototype);
    }
}
class $fe6b83e0b2870cdc$export$a67310b7be53b209 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyVpcEndpointServiceInUseException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyVpcEndpointServiceInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$a67310b7be53b209.prototype);
    }
}
class $fe6b83e0b2870cdc$export$6f087c0adc98c60a extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyVpcEndpointServiceInvalidConfigurationException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyVpcEndpointServiceInvalidConfigurationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$6f087c0adc98c60a.prototype);
    }
}
class $fe6b83e0b2870cdc$export$f71c43a334c71f8d extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksProxyVpcEndpointServiceNotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "XksProxyVpcEndpointServiceNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$f71c43a334c71f8d.prototype);
    }
}
const $fe6b83e0b2870cdc$export$4b72e3b60ec27a1e = {
    CreateGrant: "CreateGrant",
    Decrypt: "Decrypt",
    DeriveSharedSecret: "DeriveSharedSecret",
    DescribeKey: "DescribeKey",
    Encrypt: "Encrypt",
    GenerateDataKey: "GenerateDataKey",
    GenerateDataKeyPair: "GenerateDataKeyPair",
    GenerateDataKeyPairWithoutPlaintext: "GenerateDataKeyPairWithoutPlaintext",
    GenerateDataKeyWithoutPlaintext: "GenerateDataKeyWithoutPlaintext",
    GenerateMac: "GenerateMac",
    GetPublicKey: "GetPublicKey",
    ReEncryptFrom: "ReEncryptFrom",
    ReEncryptTo: "ReEncryptTo",
    RetireGrant: "RetireGrant",
    Sign: "Sign",
    Verify: "Verify",
    VerifyMac: "VerifyMac"
};
class $fe6b83e0b2870cdc$export$45ee9678cde31eb4 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "DisabledException",
            $fault: "client",
            ...opts
        });
        this.name = "DisabledException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$45ee9678cde31eb4.prototype);
    }
}
class $fe6b83e0b2870cdc$export$72a19cb9a57a6f51 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "DryRunOperationException",
            $fault: "client",
            ...opts
        });
        this.name = "DryRunOperationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$72a19cb9a57a6f51.prototype);
    }
}
class $fe6b83e0b2870cdc$export$b2951f8caaff5d44 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidGrantTokenException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidGrantTokenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$b2951f8caaff5d44.prototype);
    }
}
const $fe6b83e0b2870cdc$export$c74b8d58661f56bb = {
    ECC_NIST_P256: "ECC_NIST_P256",
    ECC_NIST_P384: "ECC_NIST_P384",
    ECC_NIST_P521: "ECC_NIST_P521",
    ECC_SECG_P256K1: "ECC_SECG_P256K1",
    HMAC_224: "HMAC_224",
    HMAC_256: "HMAC_256",
    HMAC_384: "HMAC_384",
    HMAC_512: "HMAC_512",
    RSA_2048: "RSA_2048",
    RSA_3072: "RSA_3072",
    RSA_4096: "RSA_4096",
    SM2: "SM2",
    SYMMETRIC_DEFAULT: "SYMMETRIC_DEFAULT"
};
const $fe6b83e0b2870cdc$export$58515bb9e193223f = {
    ECC_NIST_P256: "ECC_NIST_P256",
    ECC_NIST_P384: "ECC_NIST_P384",
    ECC_NIST_P521: "ECC_NIST_P521",
    ECC_SECG_P256K1: "ECC_SECG_P256K1",
    HMAC_224: "HMAC_224",
    HMAC_256: "HMAC_256",
    HMAC_384: "HMAC_384",
    HMAC_512: "HMAC_512",
    RSA_2048: "RSA_2048",
    RSA_3072: "RSA_3072",
    RSA_4096: "RSA_4096",
    SM2: "SM2",
    SYMMETRIC_DEFAULT: "SYMMETRIC_DEFAULT"
};
const $fe6b83e0b2870cdc$export$2aa967fd34df63d3 = {
    ENCRYPT_DECRYPT: "ENCRYPT_DECRYPT",
    GENERATE_VERIFY_MAC: "GENERATE_VERIFY_MAC",
    KEY_AGREEMENT: "KEY_AGREEMENT",
    SIGN_VERIFY: "SIGN_VERIFY"
};
const $fe6b83e0b2870cdc$export$89491e7b2962d202 = {
    AWS_CLOUDHSM: "AWS_CLOUDHSM",
    AWS_KMS: "AWS_KMS",
    EXTERNAL: "EXTERNAL",
    EXTERNAL_KEY_STORE: "EXTERNAL_KEY_STORE"
};
const $fe6b83e0b2870cdc$export$24917ed6deb1b22a = {
    RSAES_OAEP_SHA_1: "RSAES_OAEP_SHA_1",
    RSAES_OAEP_SHA_256: "RSAES_OAEP_SHA_256",
    SM2PKE: "SM2PKE",
    SYMMETRIC_DEFAULT: "SYMMETRIC_DEFAULT"
};
const $fe6b83e0b2870cdc$export$be9861d96aaf9edf = {
    KEY_MATERIAL_DOES_NOT_EXPIRE: "KEY_MATERIAL_DOES_NOT_EXPIRE",
    KEY_MATERIAL_EXPIRES: "KEY_MATERIAL_EXPIRES"
};
const $fe6b83e0b2870cdc$export$a4a9ebffb70f2deb = {
    ECDH: "ECDH"
};
const $fe6b83e0b2870cdc$export$f55be4c88c60e99b = {
    AWS: "AWS",
    CUSTOMER: "CUSTOMER"
};
const $fe6b83e0b2870cdc$export$9e9c3b4596bcb2e8 = {
    Creating: "Creating",
    Disabled: "Disabled",
    Enabled: "Enabled",
    PendingDeletion: "PendingDeletion",
    PendingImport: "PendingImport",
    PendingReplicaDeletion: "PendingReplicaDeletion",
    Unavailable: "Unavailable",
    Updating: "Updating"
};
const $fe6b83e0b2870cdc$export$397acf3c35eb49d4 = {
    HMAC_SHA_224: "HMAC_SHA_224",
    HMAC_SHA_256: "HMAC_SHA_256",
    HMAC_SHA_384: "HMAC_SHA_384",
    HMAC_SHA_512: "HMAC_SHA_512"
};
const $fe6b83e0b2870cdc$export$9041d96463da509a = {
    PRIMARY: "PRIMARY",
    REPLICA: "REPLICA"
};
const $fe6b83e0b2870cdc$export$e631e78fddb21e19 = {
    ECDSA_SHA_256: "ECDSA_SHA_256",
    ECDSA_SHA_384: "ECDSA_SHA_384",
    ECDSA_SHA_512: "ECDSA_SHA_512",
    RSASSA_PKCS1_V1_5_SHA_256: "RSASSA_PKCS1_V1_5_SHA_256",
    RSASSA_PKCS1_V1_5_SHA_384: "RSASSA_PKCS1_V1_5_SHA_384",
    RSASSA_PKCS1_V1_5_SHA_512: "RSASSA_PKCS1_V1_5_SHA_512",
    RSASSA_PSS_SHA_256: "RSASSA_PSS_SHA_256",
    RSASSA_PSS_SHA_384: "RSASSA_PSS_SHA_384",
    RSASSA_PSS_SHA_512: "RSASSA_PSS_SHA_512",
    SM2DSA: "SM2DSA"
};
class $fe6b83e0b2870cdc$export$22b3b5837037e750 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "MalformedPolicyDocumentException",
            $fault: "client",
            ...opts
        });
        this.name = "MalformedPolicyDocumentException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$22b3b5837037e750.prototype);
    }
}
class $fe6b83e0b2870cdc$export$b82701488168da32 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "TagException",
            $fault: "client",
            ...opts
        });
        this.name = "TagException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$b82701488168da32.prototype);
    }
}
class $fe6b83e0b2870cdc$export$2e37a6d44d5b88dc extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "UnsupportedOperationException",
            $fault: "client",
            ...opts
        });
        this.name = "UnsupportedOperationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$2e37a6d44d5b88dc.prototype);
    }
}
class $fe6b83e0b2870cdc$export$1d318e0b86872332 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksKeyAlreadyInUseException",
            $fault: "client",
            ...opts
        });
        this.name = "XksKeyAlreadyInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$1d318e0b86872332.prototype);
    }
}
class $fe6b83e0b2870cdc$export$8d839b6a166a6aba extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksKeyInvalidConfigurationException",
            $fault: "client",
            ...opts
        });
        this.name = "XksKeyInvalidConfigurationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$8d839b6a166a6aba.prototype);
    }
}
class $fe6b83e0b2870cdc$export$9773fd41312a0dc2 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "XksKeyNotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "XksKeyNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$9773fd41312a0dc2.prototype);
    }
}
class $fe6b83e0b2870cdc$export$8ffbfb667e59d6a0 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "CustomKeyStoreHasCMKsException",
            $fault: "client",
            ...opts
        });
        this.name = "CustomKeyStoreHasCMKsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$8ffbfb667e59d6a0.prototype);
    }
}
const $fe6b83e0b2870cdc$export$f6c81ac372bddc7b = {
    ECC_NIST_P256: "ECC_NIST_P256",
    ECC_NIST_P384: "ECC_NIST_P384",
    ECC_NIST_P521: "ECC_NIST_P521",
    ECC_SECG_P256K1: "ECC_SECG_P256K1",
    RSA_2048: "RSA_2048",
    RSA_3072: "RSA_3072",
    RSA_4096: "RSA_4096",
    SM2: "SM2"
};
const $fe6b83e0b2870cdc$export$80e2191276d33ca4 = {
    AES_128: "AES_128",
    AES_256: "AES_256"
};
const $fe6b83e0b2870cdc$export$26fc70e47078674b = {
    RSAES_OAEP_SHA_256: "RSAES_OAEP_SHA_256"
};
class $fe6b83e0b2870cdc$export$c8785c688c351940 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "IncorrectKeyException",
            $fault: "client",
            ...opts
        });
        this.name = "IncorrectKeyException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$c8785c688c351940.prototype);
    }
}
class $fe6b83e0b2870cdc$export$1a6198504752c2e5 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidCiphertextException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidCiphertextException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$1a6198504752c2e5.prototype);
    }
}
class $fe6b83e0b2870cdc$export$32f0f461e69e2e7c extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidKeyUsageException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidKeyUsageException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$32f0f461e69e2e7c.prototype);
    }
}
class $fe6b83e0b2870cdc$export$e02c53d0e5cc1843 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "KeyUnavailableException",
            $fault: "server",
            ...opts
        });
        this.name = "KeyUnavailableException";
        this.$fault = "server";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$e02c53d0e5cc1843.prototype);
    }
}
class $fe6b83e0b2870cdc$export$ef05e39d3b3fc91c extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidMarkerException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidMarkerException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$ef05e39d3b3fc91c.prototype);
    }
}
class $fe6b83e0b2870cdc$export$e7dfb2a0e7f690e2 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "ExpiredImportTokenException",
            $fault: "client",
            ...opts
        });
        this.name = "ExpiredImportTokenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$e7dfb2a0e7f690e2.prototype);
    }
}
const $fe6b83e0b2870cdc$export$d3c23579d5bd93c2 = {
    RSA_2048: "RSA_2048",
    RSA_3072: "RSA_3072",
    RSA_4096: "RSA_4096",
    SM2: "SM2"
};
class $fe6b83e0b2870cdc$export$5ac8f3dc7622a98b extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "IncorrectKeyMaterialException",
            $fault: "client",
            ...opts
        });
        this.name = "IncorrectKeyMaterialException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$5ac8f3dc7622a98b.prototype);
    }
}
class $fe6b83e0b2870cdc$export$1d37eb0b9988badd extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidImportTokenException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidImportTokenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$1d37eb0b9988badd.prototype);
    }
}
class $fe6b83e0b2870cdc$export$e8327be7b113ba41 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "InvalidGrantIdException",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidGrantIdException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$e8327be7b113ba41.prototype);
    }
}
class $fe6b83e0b2870cdc$export$cf53679a13e8d480 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "KMSInvalidMacException",
            $fault: "client",
            ...opts
        });
        this.name = "KMSInvalidMacException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$cf53679a13e8d480.prototype);
    }
}
class $fe6b83e0b2870cdc$export$c32615a5d8ad9336 extends (0, $6660c2736ef13da2$export$99ef6fbecf03c73a) {
    constructor(opts){
        super({
            name: "KMSInvalidSignatureException",
            $fault: "client",
            ...opts
        });
        this.name = "KMSInvalidSignatureException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $fe6b83e0b2870cdc$export$c32615a5d8ad9336.prototype);
    }
}
const $fe6b83e0b2870cdc$export$91397be43fc980cc = {
    AUTOMATIC: "AUTOMATIC",
    ON_DEMAND: "ON_DEMAND"
};
const $fe6b83e0b2870cdc$export$80edbf15fa61a4db = {
    DIGEST: "DIGEST",
    RAW: "RAW"
};
const $fe6b83e0b2870cdc$export$d099b8110b0cb127 = (obj)=>({
        ...obj,
        ...obj.AccessKeyId && {
            AccessKeyId: (0, $bLYmx.SENSITIVE_STRING)
        },
        ...obj.RawSecretAccessKey && {
            RawSecretAccessKey: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$b278390824d01e66 = (obj)=>({
        ...obj,
        ...obj.KeyStorePassword && {
            KeyStorePassword: (0, $bLYmx.SENSITIVE_STRING)
        },
        ...obj.XksProxyAuthenticationCredential && {
            XksProxyAuthenticationCredential: $fe6b83e0b2870cdc$export$d099b8110b0cb127(obj.XksProxyAuthenticationCredential)
        }
    });
const $fe6b83e0b2870cdc$export$2b141d518f357595 = (obj)=>({
        ...obj,
        ...obj.AccessKeyId && {
            AccessKeyId: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$89cd64707da4329e = (obj)=>({
        ...obj,
        ...obj.XksProxyConfiguration && {
            XksProxyConfiguration: $fe6b83e0b2870cdc$export$2b141d518f357595(obj.XksProxyConfiguration)
        }
    });
const $fe6b83e0b2870cdc$export$8815863c5477f016 = (obj)=>({
        ...obj,
        ...obj.Plaintext && {
            Plaintext: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$a13c339ff4a3b148 = (obj)=>({
        ...obj,
        ...obj.SharedSecret && {
            SharedSecret: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$c9907248bc672a52 = (obj)=>({
        ...obj,
        ...obj.CustomKeyStores && {
            CustomKeyStores: obj.CustomKeyStores.map((item)=>$fe6b83e0b2870cdc$export$89cd64707da4329e(item))
        }
    });
const $fe6b83e0b2870cdc$export$ec3b1ec67805fc6e = (obj)=>({
        ...obj,
        ...obj.Plaintext && {
            Plaintext: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$3753c381c4ea11b5 = (obj)=>({
        ...obj,
        ...obj.Plaintext && {
            Plaintext: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$ec61a45e0bc6ba3a = (obj)=>({
        ...obj,
        ...obj.PrivateKeyPlaintext && {
            PrivateKeyPlaintext: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$c9c74a771958c9c = (obj)=>({
        ...obj,
        ...obj.Message && {
            Message: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$e3a3f720303a7d04 = (obj)=>({
        ...obj,
        ...obj.Plaintext && {
            Plaintext: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$ebaa00345809b2d5 = (obj)=>({
        ...obj,
        ...obj.PublicKey && {
            PublicKey: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$932348efcb4ba48c = (obj)=>({
        ...obj,
        ...obj.Message && {
            Message: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$7599b5996326b63b = (obj)=>({
        ...obj,
        ...obj.KeyStorePassword && {
            KeyStorePassword: (0, $bLYmx.SENSITIVE_STRING)
        },
        ...obj.XksProxyAuthenticationCredential && {
            XksProxyAuthenticationCredential: $fe6b83e0b2870cdc$export$d099b8110b0cb127(obj.XksProxyAuthenticationCredential)
        }
    });
const $fe6b83e0b2870cdc$export$57c5baeab17544c6 = (obj)=>({
        ...obj,
        ...obj.Message && {
            Message: (0, $bLYmx.SENSITIVE_STRING)
        }
    });
const $fe6b83e0b2870cdc$export$c8d6d4358d1a92a6 = (obj)=>({
        ...obj,
        ...obj.Message && {
            Message: (0, $bLYmx.SENSITIVE_STRING)
        }
    });



var $gugHf = parcelRequire("gugHf");
parcelRequire("lJ13n");
var $acFZn = parcelRequire("acFZn");
parcelRequire("eKvzZ");
var $kfE6I = parcelRequire("kfE6I");
var $hEciL = parcelRequire("hEciL");
var $l1h1U = parcelRequire("l1h1U");
var $kHa9s = parcelRequire("kHa9s");
var $iik7Y = parcelRequire("iik7Y");
var $gZe9T = parcelRequire("gZe9T");
var $alLJe = parcelRequire("alLJe");


const $f4db3d60afd84600$export$c85f2989dbd3ad65 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("CancelKeyDeletion");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$894d034ed046ad7 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ConnectCustomKeyStore");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$a21bfa262efeb74d = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("CreateAlias");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$7ffcd7d74d7e1937 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("CreateCustomKeyStore");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$d82359a946535503 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("CreateGrant");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$1679395547c40c98 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("CreateKey");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$a67ab8b232077bcc = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("Decrypt");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_DecryptRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$27283efcac08e12c = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DeleteAlias");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$71c57c6135c03b3 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DeleteCustomKeyStore");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$d27bb50e38688aa1 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DeleteImportedKeyMaterial");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$451ee51b30b49d1d = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DeriveSharedSecret");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_DeriveSharedSecretRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$bc64718064d086d6 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DescribeCustomKeyStores");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$251b72cd02ba0edf = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DescribeKey");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$c9100d76c30b7920 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DisableKey");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$cac1e7018ea45d38 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DisableKeyRotation");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$19e137c012fa6948 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("DisconnectCustomKeyStore");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$6b48202f0fc7ef9a = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("EnableKey");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$d2fe2d54e4ce1a7e = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("EnableKeyRotation");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$c5f6444955b850f2 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("Encrypt");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_EncryptRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$bf843222085a31a7 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GenerateDataKey");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_GenerateDataKeyRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$bacc625c9a6684b8 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GenerateDataKeyPair");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_GenerateDataKeyPairRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$aef1fe77a8db7b75 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GenerateDataKeyPairWithoutPlaintext");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$a74aa2d2f22b96da = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GenerateDataKeyWithoutPlaintext");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$82f19dff6d10645d = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GenerateMac");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_GenerateMacRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$90a7b4e0892a4968 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GenerateRandom");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_GenerateRandomRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$29524157dbdd1ed5 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GetKeyPolicy");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$5834c4a5053187ff = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GetKeyRotationStatus");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$3c5c84d96aa204a3 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GetParametersForImport");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$ab10f841bdfb4e77 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("GetPublicKey");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$58d347f52a4b97ec = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ImportKeyMaterial");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_ImportKeyMaterialRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$fcdce565d931d287 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListAliases");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$f90e37238e56808b = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListGrants");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$e25b5a696382cfee = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListKeyPolicies");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$e43264a700bd57fa = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListKeyRotations");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$31ebefdb5e5e0164 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListKeys");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$2d0d9680474f3621 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListResourceTags");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$58a245541d38b367 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ListRetirableGrants");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$5b48590bba0fc590 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("PutKeyPolicy");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$df7e3d62300f703e = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ReEncrypt");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_ReEncryptRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$16b94c9a7803c52b = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ReplicateKey");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$f297d76fb4822243 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("RetireGrant");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$7ced630f41c26d6e = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("RevokeGrant");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$faf422d5cb0f2484 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("RotateKeyOnDemand");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$17131e1eec68a88 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("ScheduleKeyDeletion");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$37d1326a2ec4a73a = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("Sign");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_SignRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$3f3dfadaf322c1d5 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("TagResource");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$b056b897d8c9e1a6 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("UntagResource");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$3881c6899c2a35e4 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("UpdateAlias");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$21946f98c1d698c = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("UpdateCustomKeyStore");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$7cbf566d20d54248 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("UpdateKeyDescription");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$95043f071d94e2ab = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("UpdatePrimaryRegion");
    let body;
    body = JSON.stringify((0, $kfE6I._json)(input));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$bdfa97aa72729842 = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("Verify");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_VerifyRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$a0cead61caae3f3f = async (input, context)=>{
    const headers = $f4db3d60afd84600$var$sharedHeaders("VerifyMac");
    let body;
    body = JSON.stringify($f4db3d60afd84600$var$se_VerifyMacRequest(input, context));
    return $f4db3d60afd84600$var$buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const $f4db3d60afd84600$export$826c3d45853071a9 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$6776242ddfc2da2 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$7e74b267ade42f01 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$717477cac8fb4508 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$99888d7e99bf774e = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$fae44990197b63c0 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_CreateKeyResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$a281ee620828dff6 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_DecryptResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$55585e8694180f43 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$72f39b57e1db4f2f = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$a3a84ba811318a26 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$6f6f6a0dc83c6165 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_DeriveSharedSecretResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$71580403b7b6f703 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_DescribeCustomKeyStoresResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$e94b30f79201765e = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_DescribeKeyResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$29f93b459dd72fdc = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$6d832381627fd1df = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$9ccd1f68ef028f41 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$2e6e21205523f100 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$3716204d6cb62de7 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$135999df3eef688e = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_EncryptResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$1297a1aefbc0511b = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GenerateDataKeyResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$9dd370fd8d2da72 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GenerateDataKeyPairResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$40e60dfc208a1c2b = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GenerateDataKeyPairWithoutPlaintextResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$a3ae8e86f7799877 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GenerateDataKeyWithoutPlaintextResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$a12aac280460cc48 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GenerateMacResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$e805a88da66abf02 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GenerateRandomResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$ceae4ca863c71dc4 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$c30bcb77d00d7b92 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GetKeyRotationStatusResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$9854af053887a50f = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GetParametersForImportResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$50db2953d4709eba = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_GetPublicKeyResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$dbf37725c90df016 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$711da8e469510dac = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ListAliasesResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$a2df41673754c97b = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ListGrantsResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$7d5e58e79c81dc44 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$d451b943f85ea2f0 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ListKeyRotationsResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$1c84fbae48c61bbd = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$c8d89ef1e4c5381c = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$df8b7fd74b632ba1 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ListGrantsResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$dd1d90129c40dbfb = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$42186f3b3ad2466d = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ReEncryptResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$c1b9027c9fbc7cc5 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ReplicateKeyResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$96b4d317764da407 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$bfcacdd08e224a38 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$7267c0dff496785b = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$34306955c972674c = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_ScheduleKeyDeletionResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$d822b24352a7a1eb = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = $f4db3d60afd84600$var$de_SignResponse(data, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$dc0f1552868d13af = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$9bdfbc7f21c1e48f = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$fb1474254ab30c77 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$5c7c960ee1d0417d = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$f58eb160891558c1 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$7fc63a1b73bee58d = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    await (0, $hEciL.collectBody)(output.body, context);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output)
    };
    return response;
};
const $f4db3d60afd84600$export$518f1104ab5661c9 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$export$69bd738cfe3f37f2 = async (output, context)=>{
    if (output.statusCode >= 300) return $f4db3d60afd84600$var$de_CommandError(output, context);
    const data = await (0, $gugHf.parseJsonBody)(output.body, context);
    let contents = {};
    contents = (0, $kfE6I._json)(data);
    const response = {
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(output),
        ...contents
    };
    return response;
};
const $f4db3d60afd84600$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $gugHf.parseJsonErrorBody)(output.body, context)
    };
    const errorCode = (0, $gugHf.loadRestJsonErrorCode)(output, parsedOutput.body);
    switch(errorCode){
        case "DependencyTimeoutException":
        case "com.amazonaws.kms#DependencyTimeoutException":
            throw await $f4db3d60afd84600$var$de_DependencyTimeoutExceptionRes(parsedOutput, context);
        case "InvalidArnException":
        case "com.amazonaws.kms#InvalidArnException":
            throw await $f4db3d60afd84600$var$de_InvalidArnExceptionRes(parsedOutput, context);
        case "KMSInternalException":
        case "com.amazonaws.kms#KMSInternalException":
            throw await $f4db3d60afd84600$var$de_KMSInternalExceptionRes(parsedOutput, context);
        case "KMSInvalidStateException":
        case "com.amazonaws.kms#KMSInvalidStateException":
            throw await $f4db3d60afd84600$var$de_KMSInvalidStateExceptionRes(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.kms#NotFoundException":
            throw await $f4db3d60afd84600$var$de_NotFoundExceptionRes(parsedOutput, context);
        case "CloudHsmClusterInvalidConfigurationException":
        case "com.amazonaws.kms#CloudHsmClusterInvalidConfigurationException":
            throw await $f4db3d60afd84600$var$de_CloudHsmClusterInvalidConfigurationExceptionRes(parsedOutput, context);
        case "CloudHsmClusterNotActiveException":
        case "com.amazonaws.kms#CloudHsmClusterNotActiveException":
            throw await $f4db3d60afd84600$var$de_CloudHsmClusterNotActiveExceptionRes(parsedOutput, context);
        case "CustomKeyStoreInvalidStateException":
        case "com.amazonaws.kms#CustomKeyStoreInvalidStateException":
            throw await $f4db3d60afd84600$var$de_CustomKeyStoreInvalidStateExceptionRes(parsedOutput, context);
        case "CustomKeyStoreNotFoundException":
        case "com.amazonaws.kms#CustomKeyStoreNotFoundException":
            throw await $f4db3d60afd84600$var$de_CustomKeyStoreNotFoundExceptionRes(parsedOutput, context);
        case "AlreadyExistsException":
        case "com.amazonaws.kms#AlreadyExistsException":
            throw await $f4db3d60afd84600$var$de_AlreadyExistsExceptionRes(parsedOutput, context);
        case "InvalidAliasNameException":
        case "com.amazonaws.kms#InvalidAliasNameException":
            throw await $f4db3d60afd84600$var$de_InvalidAliasNameExceptionRes(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.kms#LimitExceededException":
            throw await $f4db3d60afd84600$var$de_LimitExceededExceptionRes(parsedOutput, context);
        case "CloudHsmClusterInUseException":
        case "com.amazonaws.kms#CloudHsmClusterInUseException":
            throw await $f4db3d60afd84600$var$de_CloudHsmClusterInUseExceptionRes(parsedOutput, context);
        case "CloudHsmClusterNotFoundException":
        case "com.amazonaws.kms#CloudHsmClusterNotFoundException":
            throw await $f4db3d60afd84600$var$de_CloudHsmClusterNotFoundExceptionRes(parsedOutput, context);
        case "CustomKeyStoreNameInUseException":
        case "com.amazonaws.kms#CustomKeyStoreNameInUseException":
            throw await $f4db3d60afd84600$var$de_CustomKeyStoreNameInUseExceptionRes(parsedOutput, context);
        case "IncorrectTrustAnchorException":
        case "com.amazonaws.kms#IncorrectTrustAnchorException":
            throw await $f4db3d60afd84600$var$de_IncorrectTrustAnchorExceptionRes(parsedOutput, context);
        case "XksProxyIncorrectAuthenticationCredentialException":
        case "com.amazonaws.kms#XksProxyIncorrectAuthenticationCredentialException":
            throw await $f4db3d60afd84600$var$de_XksProxyIncorrectAuthenticationCredentialExceptionRes(parsedOutput, context);
        case "XksProxyInvalidConfigurationException":
        case "com.amazonaws.kms#XksProxyInvalidConfigurationException":
            throw await $f4db3d60afd84600$var$de_XksProxyInvalidConfigurationExceptionRes(parsedOutput, context);
        case "XksProxyInvalidResponseException":
        case "com.amazonaws.kms#XksProxyInvalidResponseException":
            throw await $f4db3d60afd84600$var$de_XksProxyInvalidResponseExceptionRes(parsedOutput, context);
        case "XksProxyUriEndpointInUseException":
        case "com.amazonaws.kms#XksProxyUriEndpointInUseException":
            throw await $f4db3d60afd84600$var$de_XksProxyUriEndpointInUseExceptionRes(parsedOutput, context);
        case "XksProxyUriInUseException":
        case "com.amazonaws.kms#XksProxyUriInUseException":
            throw await $f4db3d60afd84600$var$de_XksProxyUriInUseExceptionRes(parsedOutput, context);
        case "XksProxyUriUnreachableException":
        case "com.amazonaws.kms#XksProxyUriUnreachableException":
            throw await $f4db3d60afd84600$var$de_XksProxyUriUnreachableExceptionRes(parsedOutput, context);
        case "XksProxyVpcEndpointServiceInUseException":
        case "com.amazonaws.kms#XksProxyVpcEndpointServiceInUseException":
            throw await $f4db3d60afd84600$var$de_XksProxyVpcEndpointServiceInUseExceptionRes(parsedOutput, context);
        case "XksProxyVpcEndpointServiceInvalidConfigurationException":
        case "com.amazonaws.kms#XksProxyVpcEndpointServiceInvalidConfigurationException":
            throw await $f4db3d60afd84600$var$de_XksProxyVpcEndpointServiceInvalidConfigurationExceptionRes(parsedOutput, context);
        case "XksProxyVpcEndpointServiceNotFoundException":
        case "com.amazonaws.kms#XksProxyVpcEndpointServiceNotFoundException":
            throw await $f4db3d60afd84600$var$de_XksProxyVpcEndpointServiceNotFoundExceptionRes(parsedOutput, context);
        case "DisabledException":
        case "com.amazonaws.kms#DisabledException":
            throw await $f4db3d60afd84600$var$de_DisabledExceptionRes(parsedOutput, context);
        case "DryRunOperationException":
        case "com.amazonaws.kms#DryRunOperationException":
            throw await $f4db3d60afd84600$var$de_DryRunOperationExceptionRes(parsedOutput, context);
        case "InvalidGrantTokenException":
        case "com.amazonaws.kms#InvalidGrantTokenException":
            throw await $f4db3d60afd84600$var$de_InvalidGrantTokenExceptionRes(parsedOutput, context);
        case "MalformedPolicyDocumentException":
        case "com.amazonaws.kms#MalformedPolicyDocumentException":
            throw await $f4db3d60afd84600$var$de_MalformedPolicyDocumentExceptionRes(parsedOutput, context);
        case "TagException":
        case "com.amazonaws.kms#TagException":
            throw await $f4db3d60afd84600$var$de_TagExceptionRes(parsedOutput, context);
        case "UnsupportedOperationException":
        case "com.amazonaws.kms#UnsupportedOperationException":
            throw await $f4db3d60afd84600$var$de_UnsupportedOperationExceptionRes(parsedOutput, context);
        case "XksKeyAlreadyInUseException":
        case "com.amazonaws.kms#XksKeyAlreadyInUseException":
            throw await $f4db3d60afd84600$var$de_XksKeyAlreadyInUseExceptionRes(parsedOutput, context);
        case "XksKeyInvalidConfigurationException":
        case "com.amazonaws.kms#XksKeyInvalidConfigurationException":
            throw await $f4db3d60afd84600$var$de_XksKeyInvalidConfigurationExceptionRes(parsedOutput, context);
        case "XksKeyNotFoundException":
        case "com.amazonaws.kms#XksKeyNotFoundException":
            throw await $f4db3d60afd84600$var$de_XksKeyNotFoundExceptionRes(parsedOutput, context);
        case "IncorrectKeyException":
        case "com.amazonaws.kms#IncorrectKeyException":
            throw await $f4db3d60afd84600$var$de_IncorrectKeyExceptionRes(parsedOutput, context);
        case "InvalidCiphertextException":
        case "com.amazonaws.kms#InvalidCiphertextException":
            throw await $f4db3d60afd84600$var$de_InvalidCiphertextExceptionRes(parsedOutput, context);
        case "InvalidKeyUsageException":
        case "com.amazonaws.kms#InvalidKeyUsageException":
            throw await $f4db3d60afd84600$var$de_InvalidKeyUsageExceptionRes(parsedOutput, context);
        case "KeyUnavailableException":
        case "com.amazonaws.kms#KeyUnavailableException":
            throw await $f4db3d60afd84600$var$de_KeyUnavailableExceptionRes(parsedOutput, context);
        case "CustomKeyStoreHasCMKsException":
        case "com.amazonaws.kms#CustomKeyStoreHasCMKsException":
            throw await $f4db3d60afd84600$var$de_CustomKeyStoreHasCMKsExceptionRes(parsedOutput, context);
        case "InvalidMarkerException":
        case "com.amazonaws.kms#InvalidMarkerException":
            throw await $f4db3d60afd84600$var$de_InvalidMarkerExceptionRes(parsedOutput, context);
        case "ExpiredImportTokenException":
        case "com.amazonaws.kms#ExpiredImportTokenException":
            throw await $f4db3d60afd84600$var$de_ExpiredImportTokenExceptionRes(parsedOutput, context);
        case "IncorrectKeyMaterialException":
        case "com.amazonaws.kms#IncorrectKeyMaterialException":
            throw await $f4db3d60afd84600$var$de_IncorrectKeyMaterialExceptionRes(parsedOutput, context);
        case "InvalidImportTokenException":
        case "com.amazonaws.kms#InvalidImportTokenException":
            throw await $f4db3d60afd84600$var$de_InvalidImportTokenExceptionRes(parsedOutput, context);
        case "InvalidGrantIdException":
        case "com.amazonaws.kms#InvalidGrantIdException":
            throw await $f4db3d60afd84600$var$de_InvalidGrantIdExceptionRes(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.kms#ConflictException":
            throw await $f4db3d60afd84600$var$de_ConflictExceptionRes(parsedOutput, context);
        case "CloudHsmClusterNotRelatedException":
        case "com.amazonaws.kms#CloudHsmClusterNotRelatedException":
            throw await $f4db3d60afd84600$var$de_CloudHsmClusterNotRelatedExceptionRes(parsedOutput, context);
        case "KMSInvalidSignatureException":
        case "com.amazonaws.kms#KMSInvalidSignatureException":
            throw await $f4db3d60afd84600$var$de_KMSInvalidSignatureExceptionRes(parsedOutput, context);
        case "KMSInvalidMacException":
        case "com.amazonaws.kms#KMSInvalidMacException":
            throw await $f4db3d60afd84600$var$de_KMSInvalidMacExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $f4db3d60afd84600$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $f4db3d60afd84600$var$de_AlreadyExistsExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$8b2247038294033c)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CloudHsmClusterInUseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$23281100c6d3e286)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CloudHsmClusterInvalidConfigurationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$958c84d54876087c)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CloudHsmClusterNotActiveExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$ae9eb5e7c2d2320)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CloudHsmClusterNotFoundExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$4a47bc4023510138)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CloudHsmClusterNotRelatedExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$3e16948521804ce4)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_ConflictExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$c64b14d0b7091188)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CustomKeyStoreHasCMKsExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$8ffbfb667e59d6a0)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CustomKeyStoreInvalidStateExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$c9b12d0cd01dabdd)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CustomKeyStoreNameInUseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$e004a76e3457cf0)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_CustomKeyStoreNotFoundExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$6271f525fee4fc2e)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_DependencyTimeoutExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$252c3ca66ba0fd85)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_DisabledExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$45ee9678cde31eb4)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_DryRunOperationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$72a19cb9a57a6f51)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_ExpiredImportTokenExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$e7dfb2a0e7f690e2)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_IncorrectKeyExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$c8785c688c351940)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_IncorrectKeyMaterialExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$5ac8f3dc7622a98b)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_IncorrectTrustAnchorExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$ccc7068de32d5e84)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidAliasNameExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$340f47bbfda7e763)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidArnExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$4ccad7ada726c26c)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidCiphertextExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$1a6198504752c2e5)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidGrantIdExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$e8327be7b113ba41)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidGrantTokenExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$b2951f8caaff5d44)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidImportTokenExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$1d37eb0b9988badd)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidKeyUsageExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$32f0f461e69e2e7c)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_InvalidMarkerExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$ef05e39d3b3fc91c)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_KeyUnavailableExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$e02c53d0e5cc1843)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_KMSInternalExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$10e71730f68afdd)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_KMSInvalidMacExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$cf53679a13e8d480)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_KMSInvalidSignatureExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$c32615a5d8ad9336)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_KMSInvalidStateExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$16b76627a54694a8)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_LimitExceededExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$cd419aa7f32ec382)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_MalformedPolicyDocumentExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$22b3b5837037e750)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_NotFoundExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$32cc081a9594a58d)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_TagExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$b82701488168da32)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_UnsupportedOperationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$2e37a6d44d5b88dc)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksKeyAlreadyInUseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$1d318e0b86872332)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksKeyInvalidConfigurationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$8d839b6a166a6aba)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksKeyNotFoundExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$9773fd41312a0dc2)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyIncorrectAuthenticationCredentialExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$4cf39f8fadb17436)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyInvalidConfigurationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$db5dabf3b23d1f56)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyInvalidResponseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$e66b07db1275403f)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyUriEndpointInUseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$9e20c2de1e147bfb)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyUriInUseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$cb1889f50a3f853c)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyUriUnreachableExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$74c89fba2ad4620d)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyVpcEndpointServiceInUseExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$a67310b7be53b209)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyVpcEndpointServiceInvalidConfigurationExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$6f087c0adc98c60a)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$de_XksProxyVpcEndpointServiceNotFoundExceptionRes = async (parsedOutput, context)=>{
    const body = parsedOutput.body;
    const deserialized = (0, $kfE6I._json)(body);
    const exception = new (0, $fe6b83e0b2870cdc$export$f71c43a334c71f8d)({
        $metadata: $f4db3d60afd84600$var$deserializeMetadata(parsedOutput),
        ...deserialized
    });
    return (0, $l1h1U.decorateServiceException)(exception, body);
};
const $f4db3d60afd84600$var$se_DecryptRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        CiphertextBlob: context.base64Encoder,
        DryRun: [],
        EncryptionAlgorithm: [],
        EncryptionContext: (0, $kfE6I._json),
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        Recipient: (_)=>$f4db3d60afd84600$var$se_RecipientInfo(_, context)
    });
};
const $f4db3d60afd84600$var$se_DeriveSharedSecretRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        GrantTokens: (0, $kfE6I._json),
        KeyAgreementAlgorithm: [],
        KeyId: [],
        PublicKey: context.base64Encoder,
        Recipient: (_)=>$f4db3d60afd84600$var$se_RecipientInfo(_, context)
    });
};
const $f4db3d60afd84600$var$se_EncryptRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        EncryptionAlgorithm: [],
        EncryptionContext: (0, $kfE6I._json),
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        Plaintext: context.base64Encoder
    });
};
const $f4db3d60afd84600$var$se_GenerateDataKeyPairRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        EncryptionContext: (0, $kfE6I._json),
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        KeyPairSpec: [],
        Recipient: (_)=>$f4db3d60afd84600$var$se_RecipientInfo(_, context)
    });
};
const $f4db3d60afd84600$var$se_GenerateDataKeyRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        EncryptionContext: (0, $kfE6I._json),
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        KeySpec: [],
        NumberOfBytes: [],
        Recipient: (_)=>$f4db3d60afd84600$var$se_RecipientInfo(_, context)
    });
};
const $f4db3d60afd84600$var$se_GenerateMacRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        MacAlgorithm: [],
        Message: context.base64Encoder
    });
};
const $f4db3d60afd84600$var$se_GenerateRandomRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        CustomKeyStoreId: [],
        NumberOfBytes: [],
        Recipient: (_)=>$f4db3d60afd84600$var$se_RecipientInfo(_, context)
    });
};
const $f4db3d60afd84600$var$se_ImportKeyMaterialRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        EncryptedKeyMaterial: context.base64Encoder,
        ExpirationModel: [],
        ImportToken: context.base64Encoder,
        KeyId: [],
        ValidTo: (_)=>_.getTime() / 1000
    });
};
const $f4db3d60afd84600$var$se_RecipientInfo = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        AttestationDocument: context.base64Encoder,
        KeyEncryptionAlgorithm: []
    });
};
const $f4db3d60afd84600$var$se_ReEncryptRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        CiphertextBlob: context.base64Encoder,
        DestinationEncryptionAlgorithm: [],
        DestinationEncryptionContext: (0, $kfE6I._json),
        DestinationKeyId: [],
        DryRun: [],
        GrantTokens: (0, $kfE6I._json),
        SourceEncryptionAlgorithm: [],
        SourceEncryptionContext: (0, $kfE6I._json),
        SourceKeyId: []
    });
};
const $f4db3d60afd84600$var$se_SignRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        Message: context.base64Encoder,
        MessageType: [],
        SigningAlgorithm: []
    });
};
const $f4db3d60afd84600$var$se_VerifyMacRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        Mac: context.base64Encoder,
        MacAlgorithm: [],
        Message: context.base64Encoder
    });
};
const $f4db3d60afd84600$var$se_VerifyRequest = (input, context)=>{
    return (0, $gZe9T.take)(input, {
        DryRun: [],
        GrantTokens: (0, $kfE6I._json),
        KeyId: [],
        Message: context.base64Encoder,
        MessageType: [],
        Signature: context.base64Encoder,
        SigningAlgorithm: []
    });
};
const $f4db3d60afd84600$var$de_AliasList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $f4db3d60afd84600$var$de_AliasListEntry(entry, context);
    });
    return retVal;
};
const $f4db3d60afd84600$var$de_AliasListEntry = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        AliasArn: (0, $kHa9s.expectString),
        AliasName: (0, $kHa9s.expectString),
        CreationDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        LastUpdatedDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        TargetKeyId: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_CreateKeyResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyMetadata: (_)=>$f4db3d60afd84600$var$de_KeyMetadata(_, context)
    });
};
const $f4db3d60afd84600$var$de_CustomKeyStoresList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $f4db3d60afd84600$var$de_CustomKeyStoresListEntry(entry, context);
    });
    return retVal;
};
const $f4db3d60afd84600$var$de_CustomKeyStoresListEntry = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CloudHsmClusterId: (0, $kHa9s.expectString),
        ConnectionErrorCode: (0, $kHa9s.expectString),
        ConnectionState: (0, $kHa9s.expectString),
        CreationDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        CustomKeyStoreId: (0, $kHa9s.expectString),
        CustomKeyStoreName: (0, $kHa9s.expectString),
        CustomKeyStoreType: (0, $kHa9s.expectString),
        TrustAnchorCertificate: (0, $kHa9s.expectString),
        XksProxyConfiguration: (0, $kfE6I._json)
    });
};
const $f4db3d60afd84600$var$de_DecryptResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextForRecipient: context.base64Decoder,
        EncryptionAlgorithm: (0, $kHa9s.expectString),
        KeyId: (0, $kHa9s.expectString),
        Plaintext: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_DeriveSharedSecretResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextForRecipient: context.base64Decoder,
        KeyAgreementAlgorithm: (0, $kHa9s.expectString),
        KeyId: (0, $kHa9s.expectString),
        KeyOrigin: (0, $kHa9s.expectString),
        SharedSecret: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_DescribeCustomKeyStoresResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CustomKeyStores: (_)=>$f4db3d60afd84600$var$de_CustomKeyStoresList(_, context),
        NextMarker: (0, $kHa9s.expectString),
        Truncated: (0, $kHa9s.expectBoolean)
    });
};
const $f4db3d60afd84600$var$de_DescribeKeyResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyMetadata: (_)=>$f4db3d60afd84600$var$de_KeyMetadata(_, context)
    });
};
const $f4db3d60afd84600$var$de_EncryptResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextBlob: context.base64Decoder,
        EncryptionAlgorithm: (0, $kHa9s.expectString),
        KeyId: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_GenerateDataKeyPairResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextForRecipient: context.base64Decoder,
        KeyId: (0, $kHa9s.expectString),
        KeyPairSpec: (0, $kHa9s.expectString),
        PrivateKeyCiphertextBlob: context.base64Decoder,
        PrivateKeyPlaintext: context.base64Decoder,
        PublicKey: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_GenerateDataKeyPairWithoutPlaintextResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyId: (0, $kHa9s.expectString),
        KeyPairSpec: (0, $kHa9s.expectString),
        PrivateKeyCiphertextBlob: context.base64Decoder,
        PublicKey: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_GenerateDataKeyResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextBlob: context.base64Decoder,
        CiphertextForRecipient: context.base64Decoder,
        KeyId: (0, $kHa9s.expectString),
        Plaintext: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_GenerateDataKeyWithoutPlaintextResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextBlob: context.base64Decoder,
        KeyId: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_GenerateMacResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyId: (0, $kHa9s.expectString),
        Mac: context.base64Decoder,
        MacAlgorithm: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_GenerateRandomResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextForRecipient: context.base64Decoder,
        Plaintext: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_GetKeyRotationStatusResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyId: (0, $kHa9s.expectString),
        KeyRotationEnabled: (0, $kHa9s.expectBoolean),
        NextRotationDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        OnDemandRotationStartDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        RotationPeriodInDays: (0, $kHa9s.expectInt32)
    });
};
const $f4db3d60afd84600$var$de_GetParametersForImportResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        ImportToken: context.base64Decoder,
        KeyId: (0, $kHa9s.expectString),
        ParametersValidTo: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        PublicKey: context.base64Decoder
    });
};
const $f4db3d60afd84600$var$de_GetPublicKeyResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CustomerMasterKeySpec: (0, $kHa9s.expectString),
        EncryptionAlgorithms: (0, $kfE6I._json),
        KeyAgreementAlgorithms: (0, $kfE6I._json),
        KeyId: (0, $kHa9s.expectString),
        KeySpec: (0, $kHa9s.expectString),
        KeyUsage: (0, $kHa9s.expectString),
        PublicKey: context.base64Decoder,
        SigningAlgorithms: (0, $kfE6I._json)
    });
};
const $f4db3d60afd84600$var$de_GrantList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $f4db3d60afd84600$var$de_GrantListEntry(entry, context);
    });
    return retVal;
};
const $f4db3d60afd84600$var$de_GrantListEntry = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        Constraints: (0, $kfE6I._json),
        CreationDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        GrantId: (0, $kHa9s.expectString),
        GranteePrincipal: (0, $kHa9s.expectString),
        IssuingAccount: (0, $kHa9s.expectString),
        KeyId: (0, $kHa9s.expectString),
        Name: (0, $kHa9s.expectString),
        Operations: (0, $kfE6I._json),
        RetiringPrincipal: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_KeyMetadata = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        AWSAccountId: (0, $kHa9s.expectString),
        Arn: (0, $kHa9s.expectString),
        CloudHsmClusterId: (0, $kHa9s.expectString),
        CreationDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        CustomKeyStoreId: (0, $kHa9s.expectString),
        CustomerMasterKeySpec: (0, $kHa9s.expectString),
        DeletionDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        Description: (0, $kHa9s.expectString),
        Enabled: (0, $kHa9s.expectBoolean),
        EncryptionAlgorithms: (0, $kfE6I._json),
        ExpirationModel: (0, $kHa9s.expectString),
        KeyAgreementAlgorithms: (0, $kfE6I._json),
        KeyId: (0, $kHa9s.expectString),
        KeyManager: (0, $kHa9s.expectString),
        KeySpec: (0, $kHa9s.expectString),
        KeyState: (0, $kHa9s.expectString),
        KeyUsage: (0, $kHa9s.expectString),
        MacAlgorithms: (0, $kfE6I._json),
        MultiRegion: (0, $kHa9s.expectBoolean),
        MultiRegionConfiguration: (0, $kfE6I._json),
        Origin: (0, $kHa9s.expectString),
        PendingDeletionWindowInDays: (0, $kHa9s.expectInt32),
        SigningAlgorithms: (0, $kfE6I._json),
        ValidTo: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        XksKeyConfiguration: (0, $kfE6I._json)
    });
};
const $f4db3d60afd84600$var$de_ListAliasesResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        Aliases: (_)=>$f4db3d60afd84600$var$de_AliasList(_, context),
        NextMarker: (0, $kHa9s.expectString),
        Truncated: (0, $kHa9s.expectBoolean)
    });
};
const $f4db3d60afd84600$var$de_ListGrantsResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        Grants: (_)=>$f4db3d60afd84600$var$de_GrantList(_, context),
        NextMarker: (0, $kHa9s.expectString),
        Truncated: (0, $kHa9s.expectBoolean)
    });
};
const $f4db3d60afd84600$var$de_ListKeyRotationsResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        NextMarker: (0, $kHa9s.expectString),
        Rotations: (_)=>$f4db3d60afd84600$var$de_RotationsList(_, context),
        Truncated: (0, $kHa9s.expectBoolean)
    });
};
const $f4db3d60afd84600$var$de_ReEncryptResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        CiphertextBlob: context.base64Decoder,
        DestinationEncryptionAlgorithm: (0, $kHa9s.expectString),
        KeyId: (0, $kHa9s.expectString),
        SourceEncryptionAlgorithm: (0, $kHa9s.expectString),
        SourceKeyId: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_ReplicateKeyResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        ReplicaKeyMetadata: (_)=>$f4db3d60afd84600$var$de_KeyMetadata(_, context),
        ReplicaPolicy: (0, $kHa9s.expectString),
        ReplicaTags: (0, $kfE6I._json)
    });
};
const $f4db3d60afd84600$var$de_RotationsList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $f4db3d60afd84600$var$de_RotationsListEntry(entry, context);
    });
    return retVal;
};
const $f4db3d60afd84600$var$de_RotationsListEntry = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyId: (0, $kHa9s.expectString),
        RotationDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        RotationType: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$de_ScheduleKeyDeletionResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        DeletionDate: (_)=>(0, $kHa9s.expectNonNull)((0, $iik7Y.parseEpochTimestamp)((0, $kHa9s.expectNumber)(_))),
        KeyId: (0, $kHa9s.expectString),
        KeyState: (0, $kHa9s.expectString),
        PendingWindowInDays: (0, $kHa9s.expectInt32)
    });
};
const $f4db3d60afd84600$var$de_SignResponse = (output, context)=>{
    return (0, $gZe9T.take)(output, {
        KeyId: (0, $kHa9s.expectString),
        Signature: context.base64Decoder,
        SigningAlgorithm: (0, $kHa9s.expectString)
    });
};
const $f4db3d60afd84600$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $f4db3d60afd84600$var$collectBodyString = (streamBody, context)=>(0, $hEciL.collectBody)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $f4db3d60afd84600$var$throwDefaultError = (0, $alLJe.withBaseException)((0, $6660c2736ef13da2$export$99ef6fbecf03c73a));
const $f4db3d60afd84600$var$buildHttpRpcRequest = async (context, headers, path, resolvedHostname, body)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const contents = {
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
        headers: headers
    };
    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
    if (body !== undefined) contents.body = body;
    return new (0, $acFZn.HttpRequest)(contents);
};
function $f4db3d60afd84600$var$sharedHeaders(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `TrentService.${operation}`
    };
}


class $bf11708289c3f6dc$export$d898f8208a7d4223 extends (0, $dm5an.Command).classBuilder().ep({
    ...(0, $21831430fa78f6cb$export$9c07ced2019f0ae0)
}).m(function(Command, cs, config, o) {
    return [
        (0, $aAT5t.getSerdePlugin)(config, this.serialize, this.deserialize),
        (0, $jxKDL.getEndpointPlugin)(config, Command.getEndpointParameterInstructions())
    ];
}).s("TrentService", "Decrypt", {}).n("KMSClient", "DecryptCommand").f(void 0, (0, $fe6b83e0b2870cdc$export$8815863c5477f016)).ser((0, $f4db3d60afd84600$export$a67ab8b232077bcc)).de((0, $f4db3d60afd84600$export$a281ee620828dff6)).build() {
}


var $bKjgg = parcelRequire("bKjgg");
parcelRequire("ktQJf");
var $bVaTS = parcelRequire("bVaTS");

var $8j4Ts = parcelRequire("8j4Ts");
parcelRequire("gEO0Y");
var $azZ8T = parcelRequire("azZ8T");
var $a4d7T = parcelRequire("a4d7T");
parcelRequire("9hNGK");
var $32WEY = parcelRequire("32WEY");
parcelRequire("2xHTL");
var $7C8Sk = parcelRequire("7C8Sk");
var $j8ita = parcelRequire("j8ita");
var $kY2T6 = parcelRequire("kY2T6");

var $kjxgR = parcelRequire("kjxgR");
parcelRequire("bDB9l");
var $3JRa2 = parcelRequire("3JRa2");
parcelRequire("kl6vu");
var $ghlrH = parcelRequire("ghlrH");
var $1HvUN = parcelRequire("1HvUN");
parcelRequire("eKvzZ");
var $2AKIE = parcelRequire("2AKIE");

var $iJsrS = parcelRequire("iJsrS");
parcelRequire("et0OQ");
var $b8rNH = parcelRequire("b8rNH");
var $25kVm = parcelRequire("25kVm");
const $fb6d78c76e27c550$export$9e58a9972c610267 = async (config, context, input)=>{
    return {
        operation: (0, $b8rNH.getSmithyContext)(context).operation,
        region: await (0, $25kVm.normalizeProvider)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $fb6d78c76e27c550$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "kms",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
const $fb6d78c76e27c550$export$9af72793717aa05f = (authParameters)=>{
    const options = [];
    authParameters.operation;
    options.push($fb6d78c76e27c550$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    return options;
};
const $fb6d78c76e27c550$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $iJsrS.resolveAwsSdkSigV4Config)(config);
    return {
        ...config_0
    };
};



var $6660381e0e38bc73$exports = {};
$6660381e0e38bc73$exports = JSON.parse('{"name":"@aws-sdk/client-kms","description":"AWS SDK for JavaScript Kms Client for Node.js, Browser and React Native","version":"3.645.0","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"node ../../scripts/compilation/inline client-kms","build:es":"tsc -p tsconfig.es.json","build:include:deps":"lerna run --scope $npm_package_name --include-dependencies build","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo","extract:docs":"api-extractor run --local","generate:client":"node ../../scripts/generate-clients/single-service --solo kms"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"5.2.0","@aws-crypto/sha256-js":"5.2.0","@aws-sdk/client-sso-oidc":"3.645.0","@aws-sdk/client-sts":"3.645.0","@aws-sdk/core":"3.635.0","@aws-sdk/credential-provider-node":"3.645.0","@aws-sdk/middleware-host-header":"3.620.0","@aws-sdk/middleware-logger":"3.609.0","@aws-sdk/middleware-recursion-detection":"3.620.0","@aws-sdk/middleware-user-agent":"3.645.0","@aws-sdk/region-config-resolver":"3.614.0","@aws-sdk/types":"3.609.0","@aws-sdk/util-endpoints":"3.645.0","@aws-sdk/util-user-agent-browser":"3.609.0","@aws-sdk/util-user-agent-node":"3.614.0","@smithy/config-resolver":"^3.0.5","@smithy/core":"^2.4.0","@smithy/fetch-http-handler":"^3.2.4","@smithy/hash-node":"^3.0.3","@smithy/invalid-dependency":"^3.0.3","@smithy/middleware-content-length":"^3.0.5","@smithy/middleware-endpoint":"^3.1.0","@smithy/middleware-retry":"^3.0.15","@smithy/middleware-serde":"^3.0.3","@smithy/middleware-stack":"^3.0.3","@smithy/node-config-provider":"^3.1.4","@smithy/node-http-handler":"^3.1.4","@smithy/protocol-http":"^4.1.0","@smithy/smithy-client":"^3.2.0","@smithy/types":"^3.3.0","@smithy/url-parser":"^3.0.3","@smithy/util-base64":"^3.0.0","@smithy/util-body-length-browser":"^3.0.0","@smithy/util-body-length-node":"^3.0.0","@smithy/util-defaults-mode-browser":"^3.0.15","@smithy/util-defaults-mode-node":"^3.0.15","@smithy/util-endpoints":"^2.0.5","@smithy/util-middleware":"^3.0.3","@smithy/util-retry":"^3.0.3","@smithy/util-utf8":"^3.0.0","tslib":"^2.6.2"},"devDependencies":{"@tsconfig/node16":"16.1.3","@types/node":"^16.18.96","concurrently":"7.0.0","downlevel-dts":"0.10.1","rimraf":"3.0.2","typescript":"~4.9.5"},"engines":{"node":">=16.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*/**"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-kms","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-kms"}}');


parcelRequire("df1qn");
var $8u8KM = parcelRequire("8u8KM");

var $4H0oe = parcelRequire("4H0oe");
parcelRequire("9hNGK");
var $ipi8J = parcelRequire("ipi8J");
var $ha5o2 = parcelRequire("ha5o2");
parcelRequire("3SFJh");
var $dshpv = parcelRequire("dshpv");
var $KtzJ8 = parcelRequire("KtzJ8");
parcelRequire("iJJRH");
var $kCtuP = parcelRequire("kCtuP");
parcelRequire("8Z0V4");
var $f9NMI = parcelRequire("f9NMI");
parcelRequire("eVim3");
var $79mxn = parcelRequire("79mxn");

var $oudWl = parcelRequire("oudWl");
parcelRequire("eKvzZ");
var $avv1m = parcelRequire("avv1m");

var $fIJBr = parcelRequire("fIJBr");
parcelRequire("sAmZU");
var $3kZdG = parcelRequire("3kZdG");
var $fSi4d = parcelRequire("fSi4d");
parcelRequire("geIv0");
var $1uolR = parcelRequire("1uolR");
var $3cIry = parcelRequire("3cIry");

parcelRequire("fCO99");
var $bNrU9 = parcelRequire("bNrU9");
parcelRequire("8nNaZ");
var $eVY0r = parcelRequire("eVY0r");
var $bZE5G = parcelRequire("bZE5G");
const $a238803b5b77820c$var$s = "required", $a238803b5b77820c$var$t = "fn", $a238803b5b77820c$var$u = "argv", $a238803b5b77820c$var$v = "ref";
const $a238803b5b77820c$var$a = true, $a238803b5b77820c$var$b = "isSet", $a238803b5b77820c$var$c = "booleanEquals", $a238803b5b77820c$var$d = "error", $a238803b5b77820c$var$e = "endpoint", $a238803b5b77820c$var$f = "tree", $a238803b5b77820c$var$g = "PartitionResult", $a238803b5b77820c$var$h = {
    [$a238803b5b77820c$var$s]: false,
    "type": "String"
}, $a238803b5b77820c$var$i = {
    [$a238803b5b77820c$var$s]: true,
    "default": false,
    "type": "Boolean"
}, $a238803b5b77820c$var$j = {
    [$a238803b5b77820c$var$v]: "Endpoint"
}, $a238803b5b77820c$var$k = {
    [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$c,
    [$a238803b5b77820c$var$u]: [
        {
            [$a238803b5b77820c$var$v]: "UseFIPS"
        },
        true
    ]
}, $a238803b5b77820c$var$l = {
    [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$c,
    [$a238803b5b77820c$var$u]: [
        {
            [$a238803b5b77820c$var$v]: "UseDualStack"
        },
        true
    ]
}, $a238803b5b77820c$var$m = {}, $a238803b5b77820c$var$n = {
    [$a238803b5b77820c$var$t]: "getAttr",
    [$a238803b5b77820c$var$u]: [
        {
            [$a238803b5b77820c$var$v]: $a238803b5b77820c$var$g
        },
        "supportsFIPS"
    ]
}, $a238803b5b77820c$var$o = {
    [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$c,
    [$a238803b5b77820c$var$u]: [
        true,
        {
            [$a238803b5b77820c$var$t]: "getAttr",
            [$a238803b5b77820c$var$u]: [
                {
                    [$a238803b5b77820c$var$v]: $a238803b5b77820c$var$g
                },
                "supportsDualStack"
            ]
        }
    ]
}, $a238803b5b77820c$var$p = [
    $a238803b5b77820c$var$k
], $a238803b5b77820c$var$q = [
    $a238803b5b77820c$var$l
], $a238803b5b77820c$var$r = [
    {
        [$a238803b5b77820c$var$v]: "Region"
    }
];
const $a238803b5b77820c$var$_data = {
    version: "1.0",
    parameters: {
        Region: $a238803b5b77820c$var$h,
        UseDualStack: $a238803b5b77820c$var$i,
        UseFIPS: $a238803b5b77820c$var$i,
        Endpoint: $a238803b5b77820c$var$h
    },
    rules: [
        {
            conditions: [
                {
                    [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$b,
                    [$a238803b5b77820c$var$u]: [
                        $a238803b5b77820c$var$j
                    ]
                }
            ],
            rules: [
                {
                    conditions: $a238803b5b77820c$var$p,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    type: $a238803b5b77820c$var$d
                },
                {
                    conditions: $a238803b5b77820c$var$q,
                    error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                    type: $a238803b5b77820c$var$d
                },
                {
                    endpoint: {
                        url: $a238803b5b77820c$var$j,
                        properties: $a238803b5b77820c$var$m,
                        headers: $a238803b5b77820c$var$m
                    },
                    type: $a238803b5b77820c$var$e
                }
            ],
            type: $a238803b5b77820c$var$f
        },
        {
            conditions: [
                {
                    [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$b,
                    [$a238803b5b77820c$var$u]: $a238803b5b77820c$var$r
                }
            ],
            rules: [
                {
                    conditions: [
                        {
                            [$a238803b5b77820c$var$t]: "aws.partition",
                            [$a238803b5b77820c$var$u]: $a238803b5b77820c$var$r,
                            assign: $a238803b5b77820c$var$g
                        }
                    ],
                    rules: [
                        {
                            conditions: [
                                $a238803b5b77820c$var$k,
                                $a238803b5b77820c$var$l
                            ],
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$c,
                                            [$a238803b5b77820c$var$u]: [
                                                $a238803b5b77820c$var$a,
                                                $a238803b5b77820c$var$n
                                            ]
                                        },
                                        $a238803b5b77820c$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://kms-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $a238803b5b77820c$var$m,
                                                headers: $a238803b5b77820c$var$m
                                            },
                                            type: $a238803b5b77820c$var$e
                                        }
                                    ],
                                    type: $a238803b5b77820c$var$f
                                },
                                {
                                    error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                    type: $a238803b5b77820c$var$d
                                }
                            ],
                            type: $a238803b5b77820c$var$f
                        },
                        {
                            conditions: $a238803b5b77820c$var$p,
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$a238803b5b77820c$var$t]: $a238803b5b77820c$var$c,
                                            [$a238803b5b77820c$var$u]: [
                                                $a238803b5b77820c$var$n,
                                                $a238803b5b77820c$var$a
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://kms-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $a238803b5b77820c$var$m,
                                                headers: $a238803b5b77820c$var$m
                                            },
                                            type: $a238803b5b77820c$var$e
                                        }
                                    ],
                                    type: $a238803b5b77820c$var$f
                                },
                                {
                                    error: "FIPS is enabled but this partition does not support FIPS",
                                    type: $a238803b5b77820c$var$d
                                }
                            ],
                            type: $a238803b5b77820c$var$f
                        },
                        {
                            conditions: $a238803b5b77820c$var$q,
                            rules: [
                                {
                                    conditions: [
                                        $a238803b5b77820c$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://kms.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $a238803b5b77820c$var$m,
                                                headers: $a238803b5b77820c$var$m
                                            },
                                            type: $a238803b5b77820c$var$e
                                        }
                                    ],
                                    type: $a238803b5b77820c$var$f
                                },
                                {
                                    error: "DualStack is enabled but this partition does not support DualStack",
                                    type: $a238803b5b77820c$var$d
                                }
                            ],
                            type: $a238803b5b77820c$var$f
                        },
                        {
                            endpoint: {
                                url: "https://kms.{Region}.{PartitionResult#dnsSuffix}",
                                properties: $a238803b5b77820c$var$m,
                                headers: $a238803b5b77820c$var$m
                            },
                            type: $a238803b5b77820c$var$e
                        }
                    ],
                    type: $a238803b5b77820c$var$f
                }
            ],
            type: $a238803b5b77820c$var$f
        },
        {
            error: "Invalid Configuration: Missing Region",
            type: $a238803b5b77820c$var$d
        }
    ]
};
const $a238803b5b77820c$export$7b249e066372152f = $a238803b5b77820c$var$_data;


const $d421597f771640b2$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return (0, $bZE5G.resolveEndpoint)((0, $a238803b5b77820c$export$7b249e066372152f), {
        endpointParams: endpointParams,
        logger: context.logger
    });
};
(0, $eVY0r.customEndpointFunctions).aws = (0, $bNrU9.awsEndpointFunctions);


const $62eaad003bb74daf$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2014-11-01",
        base64Decoder: config?.base64Decoder ?? (0, $3kZdG.fromBase64),
        base64Encoder: config?.base64Encoder ?? (0, $fSi4d.toBase64),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $d421597f771640b2$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $fb6d78c76e27c550$export$9af72793717aa05f),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $oudWl.AwsSdkSigV4Signer)()
            }
        ],
        logger: config?.logger ?? new (0, $avv1m.NoOpLogger)(),
        serviceId: config?.serviceId ?? "KMS",
        urlParser: config?.urlParser ?? (0, $fIJBr.parseUrl),
        utf8Decoder: config?.utf8Decoder ?? (0, $1uolR.fromUtf8),
        utf8Encoder: config?.utf8Encoder ?? (0, $3cIry.toUtf8)
    };
};


parcelRequire("eKvzZ");
var $aczlM = parcelRequire("aczlM");
parcelRequire("jbXkG");
var $gvFyj = parcelRequire("gvFyj");
const $85bb857ef76f6a8b$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $gvFyj.resolveDefaultsModeConfig)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $aczlM.loadConfigsForDefaultMode));
    const clientSharedValues = (0, $62eaad003bb74daf$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $f9NMI.calculateBodyLength),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $4H0oe.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($6660381e0e38bc73$exports))).version
        }),
        maxAttempts: config?.maxAttempts ?? (0, $79mxn.DEFAULT_MAX_ATTEMPTS),
        region: config?.region ?? (0, $kCtuP.invalidProvider)("Region is missing"),
        requestHandler: (0, $dshpv.FetchHttpHandler).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $79mxn.DEFAULT_RETRY_MODE)),
        sha256: config?.sha256 ?? (0, $8u8KM.Sha256),
        streamCollector: config?.streamCollector ?? (0, $KtzJ8.streamCollector),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $ipi8J.DEFAULT_USE_DUALSTACK_ENDPOINT))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $ha5o2.DEFAULT_USE_FIPS_ENDPOINT)))
    };
};


parcelRequire("eO45o");
var $4d9wo = parcelRequire("4d9wo");
parcelRequire("lJ13n");
var $2ycgn = parcelRequire("2ycgn");
parcelRequire("eKvzZ");
var $6vLVm = parcelRequire("6vLVm");
const $2a90f14771897543$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $2a90f14771897543$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $19836562e987d1cd$var$asPartial = (t)=>t;
const $19836562e987d1cd$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = {
        ...$19836562e987d1cd$var$asPartial((0, $4d9wo.getAwsRegionExtensionConfiguration)(runtimeConfig)),
        ...$19836562e987d1cd$var$asPartial((0, $6vLVm.getDefaultExtensionConfiguration)(runtimeConfig)),
        ...$19836562e987d1cd$var$asPartial((0, $2ycgn.getHttpHandlerExtensionConfiguration)(runtimeConfig)),
        ...$19836562e987d1cd$var$asPartial((0, $2a90f14771897543$export$e536d87ced0d9700)(runtimeConfig))
    };
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return {
        ...runtimeConfig,
        ...(0, $4d9wo.resolveAwsRegionExtensionConfiguration)(extensionConfiguration),
        ...(0, $6vLVm.resolveDefaultRuntimeConfig)(extensionConfiguration),
        ...(0, $2ycgn.resolveHttpHandlerRuntimeConfig)(extensionConfiguration),
        ...(0, $2a90f14771897543$export$60c55f59b27530a8)(extensionConfiguration)
    };
};


class $ebc1404b61d324aa$export$6d36407807609c3d extends (0, $2AKIE.Client) {
    constructor(...[configuration]){
        const _config_0 = (0, $85bb857ef76f6a8b$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $21831430fa78f6cb$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $a4d7T.resolveUserAgentConfig)(_config_1);
        const _config_3 = (0, $1HvUN.resolveRetryConfig)(_config_2);
        const _config_4 = (0, $32WEY.resolveRegionConfig)(_config_3);
        const _config_5 = (0, $bKjgg.resolveHostHeaderConfig)(_config_4);
        const _config_6 = (0, $3JRa2.resolveEndpointConfig)(_config_5);
        const _config_7 = (0, $fb6d78c76e27c550$export$d38ef9c0c6c649ab)(_config_6);
        const _config_8 = (0, $19836562e987d1cd$export$4278118b303a14cf)(_config_7, configuration?.extensions || []);
        super(_config_8);
        this.config = _config_8;
        this.middlewareStack.use((0, $azZ8T.getUserAgentPlugin)(this.config));
        this.middlewareStack.use((0, $ghlrH.getRetryPlugin)(this.config));
        this.middlewareStack.use((0, $kjxgR.getContentLengthPlugin)(this.config));
        this.middlewareStack.use((0, $bKjgg.getHostHeaderPlugin)(this.config));
        this.middlewareStack.use((0, $bVaTS.getLoggerPlugin)(this.config));
        this.middlewareStack.use((0, $8j4Ts.getRecursionDetectionPlugin)(this.config));
        this.middlewareStack.use((0, $j8ita.getHttpAuthSchemeEndpointRuleSetPlugin)(this.config, {
            httpAuthSchemeParametersProvider: (0, $fb6d78c76e27c550$export$9e58a9972c610267),
            identityProviderConfigProvider: async (config)=>new (0, $7C8Sk.DefaultIdentityProviderConfig)({
                    "aws.auth#sigv4": config.credentials
                })
        }));
        this.middlewareStack.use((0, $kY2T6.getHttpSigningPlugin)(this.config));
    }
    destroy() {
        super.destroy();
    }
}


parcelRequire("bLD0r");
var $2ZVkn = parcelRequire("2ZVkn");
parcelRequire("bLD0r");
var $2ZVkn = parcelRequire("2ZVkn");
function $ac46d88a0640756e$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce((arr, name)=>{
        const tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then((token)=>[
                name,
                token
            ]));
        return arr;
    }, [])).then((resolvedPairs)=>resolvedPairs.reduce((logins, [key, value])=>{
            logins[key] = value;
            return logins;
        }, {}));
}



function $ae6c81320172ffb3$export$4d624d71eb462130(parameters) {
    return async ()=>{
        parameters.logger?.debug("@aws-sdk/credential-provider-cognito-identity - fromCognitoIdentity");
        const { GetCredentialsForIdentityCommand: GetCredentialsForIdentityCommand, CognitoIdentityClient: CognitoIdentityClient } = await (parcelRequire("et8BI"));
        const { Credentials: { AccessKeyId: AccessKeyId = $ae6c81320172ffb3$var$throwOnMissingAccessKeyId(parameters.logger), Expiration: Expiration, SecretKey: SecretKey = $ae6c81320172ffb3$var$throwOnMissingSecretKey(parameters.logger), SessionToken: SessionToken } = $ae6c81320172ffb3$var$throwOnMissingCredentials(parameters.logger) } = await (parameters.client ?? new CognitoIdentityClient(Object.assign({}, parameters.clientConfig ?? {}, {
            region: parameters.clientConfig?.region ?? parameters.parentClientConfig?.region
        }))).send(new GetCredentialsForIdentityCommand({
            CustomRoleArn: parameters.customRoleArn,
            IdentityId: parameters.identityId,
            Logins: parameters.logins ? await (0, $ac46d88a0640756e$export$fb1e896f6704b6a6)(parameters.logins) : undefined
        }));
        return {
            identityId: parameters.identityId,
            accessKeyId: AccessKeyId,
            secretAccessKey: SecretKey,
            sessionToken: SessionToken,
            expiration: Expiration
        };
    };
}
function $ae6c81320172ffb3$var$throwOnMissingAccessKeyId(logger) {
    throw new (0, $2ZVkn.CredentialsProviderError)("Response from Amazon Cognito contained no access key ID", {
        logger: logger
    });
}
function $ae6c81320172ffb3$var$throwOnMissingCredentials(logger) {
    throw new (0, $2ZVkn.CredentialsProviderError)("Response from Amazon Cognito contained no credentials", {
        logger: logger
    });
}
function $ae6c81320172ffb3$var$throwOnMissingSecretKey(logger) {
    throw new (0, $2ZVkn.CredentialsProviderError)("Response from Amazon Cognito contained no secret key", {
        logger: logger
    });
}


const $247ad35f9b38e509$var$STORE_NAME = "IdentityIds";
class $247ad35f9b38e509$export$55d38e5384f402 {
    constructor(dbName = "aws:cognito-identity-ids"){
        this.dbName = dbName;
    }
    getItem(key) {
        return this.withObjectStore("readonly", (store)=>{
            const req = store.get(key);
            return new Promise((resolve)=>{
                req.onerror = ()=>resolve(null);
                req.onsuccess = ()=>resolve(req.result ? req.result.value : null);
            });
        }).catch(()=>null);
    }
    removeItem(key) {
        return this.withObjectStore("readwrite", (store)=>{
            const req = store.delete(key);
            return new Promise((resolve, reject)=>{
                req.onerror = ()=>reject(req.error);
                req.onsuccess = ()=>resolve();
            });
        });
    }
    setItem(id, value) {
        return this.withObjectStore("readwrite", (store)=>{
            const req = store.put({
                id: id,
                value: value
            });
            return new Promise((resolve, reject)=>{
                req.onerror = ()=>reject(req.error);
                req.onsuccess = ()=>resolve();
            });
        });
    }
    getDb() {
        const openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise((resolve, reject)=>{
            openDbRequest.onsuccess = ()=>{
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = ()=>{
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = ()=>{
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = ()=>{
                const db = openDbRequest.result;
                db.onerror = ()=>{
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($247ad35f9b38e509$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    }
    withObjectStore(mode, action) {
        return this.getDb().then((db)=>{
            const tx = db.transaction($247ad35f9b38e509$var$STORE_NAME, mode);
            tx.oncomplete = ()=>db.close();
            return new Promise((resolve, reject)=>{
                tx.onerror = ()=>reject(tx.error);
                resolve(action(tx.objectStore($247ad35f9b38e509$var$STORE_NAME)));
            }).catch((err)=>{
                db.close();
                throw err;
            });
        });
    }
}


class $3d7491c03d6399c0$export$e4315e25b840a0ea {
    constructor(store = {}){
        this.store = store;
    }
    getItem(key) {
        if (key in this.store) return this.store[key];
        return null;
    }
    removeItem(key) {
        delete this.store[key];
    }
    setItem(key, value) {
        this.store[key] = value;
    }
}


const $904bef45e8baf440$var$inMemoryStorage = new (0, $3d7491c03d6399c0$export$e4315e25b840a0ea)();
function $904bef45e8baf440$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $247ad35f9b38e509$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $904bef45e8baf440$var$inMemoryStorage;
}




function $1ef4a7e32f56801a$export$6c7d622e9507a2e({ accountId: accountId, cache: cache = (0, $904bef45e8baf440$export$c2ed3351cac403d1)(), client: client, clientConfig: clientConfig, customRoleArn: customRoleArn, identityPoolId: identityPoolId, logins: logins, userIdentifier: userIdentifier = !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined, logger: logger, parentClientConfig: parentClientConfig }) {
    logger?.debug("@aws-sdk/credential-provider-cognito-identity - fromCognitoIdentity");
    const cacheKey = userIdentifier ? `aws:cognito-identity-credentials:${identityPoolId}:${userIdentifier}` : undefined;
    let provider = async ()=>{
        const { GetIdCommand: GetIdCommand, CognitoIdentityClient: CognitoIdentityClient } = await (parcelRequire("et8BI"));
        const _client = client ?? new CognitoIdentityClient(Object.assign({}, clientConfig ?? {}, {
            region: clientConfig?.region ?? parentClientConfig?.region
        }));
        let identityId = cacheKey && await cache.getItem(cacheKey);
        if (!identityId) {
            const { IdentityId: IdentityId = $1ef4a7e32f56801a$var$throwOnMissingId(logger) } = await _client.send(new GetIdCommand({
                AccountId: accountId,
                IdentityPoolId: identityPoolId,
                Logins: logins ? await (0, $ac46d88a0640756e$export$fb1e896f6704b6a6)(logins) : undefined
            }));
            identityId = IdentityId;
            if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(()=>{});
        }
        provider = (0, $ae6c81320172ffb3$export$4d624d71eb462130)({
            client: _client,
            customRoleArn: customRoleArn,
            logins: logins,
            identityId: identityId
        });
        return provider();
    };
    return ()=>provider().catch(async (err)=>{
            if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(()=>{});
            throw err;
        });
}
function $1ef4a7e32f56801a$var$throwOnMissingId(logger) {
    throw new (0, $2ZVkn.CredentialsProviderError)("Response from Amazon Cognito contained no identity ID", {
        logger: logger
    });
}


const $453f60fce3015190$export$6c7d622e9507a2e = (options)=>(0, $1ef4a7e32f56801a$export$6c7d622e9507a2e)({
        ...options
    });

parcelRequire("bLD0r");
var $2ZVkn = parcelRequire("2ZVkn");

const $911998280be43111$export$37147104e31c77cf = (options)=>{
    let stsClient;
    return async ()=>{
        options.logger?.debug("@aws-sdk/credential-providers - fromTemporaryCredentials (STS)");
        const params = {
            ...options.params,
            RoleSessionName: options.params.RoleSessionName ?? "aws-sdk-js-" + Date.now()
        };
        if (params?.SerialNumber) {
            if (!options.mfaCodeProvider) throw new (0, $2ZVkn.CredentialsProviderError)(`Temporary credential requires multi-factor authentication,` + ` but no MFA code callback was provided.`, {
                tryNextLink: false,
                logger: options.logger
            });
            params.TokenCode = await options.mfaCodeProvider(params?.SerialNumber);
        }
        const { AssumeRoleCommand: AssumeRoleCommand, STSClient: STSClient } = await (parcelRequire("68yrK"));
        if (!stsClient) stsClient = new STSClient({
            ...options.clientConfig,
            credentials: options.masterCredentials
        });
        if (options.clientPlugins) for (const plugin of options.clientPlugins)stsClient.middlewareStack.use(plugin);
        const { Credentials: Credentials } = await stsClient.send(new AssumeRoleCommand(params));
        if (!Credentials || !Credentials.AccessKeyId || !Credentials.SecretAccessKey) throw new (0, $2ZVkn.CredentialsProviderError)(`Invalid response from STS.assumeRole call with role ${params.RoleArn}`, {
            logger: options.logger
        });
        return {
            accessKeyId: Credentials.AccessKeyId,
            secretAccessKey: Credentials.SecretAccessKey,
            sessionToken: Credentials.SessionToken,
            expiration: Credentials.Expiration,
            credentialScope: Credentials.CredentialScope
        };
    };
};


let $ba3d3511b573d5ac$var$firebaseConfig = {
    apiKey: "AIzaSyCsJq-bilsQp7GrVSX3LIUVX6EcAdCcuTs",
    databaseURL: "https://ramper-prod-default-rtdb.firebaseio.com",
    projectId: "ramper-prod",
    storageBucket: "ramper-prod.appspot.com",
    appId: "1:897776340259:web:9d8fab89bcccd20fcfd096"
};
async function $ba3d3511b573d5ac$export$42fb174b38fb584c(socialLoginUserId, customToken) {
    let app = (0, $57d436074e210fb5$export$c55cfd413944906d)($ba3d3511b573d5ac$var$firebaseConfig);
    let firestore = (0, $d3a073fac959c995$export$f06a05d14c3a6678)(app);
    let auth = (0, $efefa77b88ebd4a6$export$ae1af26003f05816)(app);
    (0, $efefa77b88ebd4a6$export$9e5f44173e64f162)(auth, (0, $efefa77b88ebd4a6$export$3a6d5c9ae78a2c08));
    await (0, $efefa77b88ebd4a6$export$efca4cbe5dd06740)(auth, customToken);
    let currentUser = auth.currentUser;
    let idToken = await currentUser.getIdToken();
    let creationTime = currentUser.metadata.creationTime ?? "";
    let providerUID = currentUser.providerData[0].uid;
    let walletKeysSnapshot = await (0, $d3a073fac959c995$export$81d3477bd73c86ef)((0, $d3a073fac959c995$export$bf5175b0c24981cd)(firestore, "users", socialLoginUserId, "walletList", "default", "walletkey"));
    let walletKeyData = walletKeysSnapshot.docs[0].data();
    let encryptedKey = walletKeyData.encryptedKey;
    let fiURI = walletKeyData.fiUri ?? "us-east-1:662b2574-190f-4e2a-be17-1ae5ee8d88a4";
    let fiRegion = fiURI.split(":")[0];
    let version = walletKeyData.version;
    let encryptedDEK = walletKeyData.dek.toUint8Array();
    let masterCredentials = await (0, $453f60fce3015190$export$6c7d622e9507a2e)({
        identityPoolId: fiURI,
        logins: {
            "securetoken.google.com/ramper-prod": idToken
        },
        clientConfig: {
            region: fiRegion
        }
    })();
    let identityId = masterCredentials.identityId;
    let pool = masterCredentials.identityId.charAt(masterCredentials.identityId.length - 1);
    let credentials = await (0, $911998280be43111$export$37147104e31c77cf)({
        masterCredentials: masterCredentials,
        params: {
            RoleArn: `arn:aws:iam::299151497192:role/cognito-pool-${pool}`,
            DurationSeconds: 900
        },
        clientConfig: {
            region: fiRegion
        }
    })();
    let input;
    let region;
    if (version === 3.1) {
        region = "us-east-2";
        input = {
            CiphertextBlob: encryptedDEK,
            EncryptionContext: {
                provider: providerUID,
                ct: creationTime
            },
            KeyId: "arn:aws:kms:us-east-2:299151497192:alias/kek",
            EncryptionAlgorithm: "SYMMETRIC_DEFAULT"
        };
    } else if (version < 6) {
        region = "us-east-1";
        input = {
            CiphertextBlob: encryptedDEK,
            KeyId: `arn:aws:kms:us-east-1:299151497192:alias/kek00${pool}`,
            EncryptionAlgorithm: "RSAES_OAEP_SHA_256"
        };
    } else if (version < 7) {
        region = "ap-northeast-2";
        input = {
            CiphertextBlob: encryptedDEK,
            KeyId: `arn:aws:kms:ap-northeast-2:299151497192:alias/mkek00${pool}`,
            EncryptionAlgorithm: "RSAES_OAEP_SHA_256"
        };
    } else if (version === 7) {
        region = "us-east-2";
        input = {
            CiphertextBlob: encryptedDEK,
            EncryptionContext: {
                provider: providerUID,
                ct: creationTime,
                cred: identityId
            },
            KeyId: `arn:aws:kms:us-east-2:299151497192:alias/skek00${pool}`,
            EncryptionAlgorithm: "SYMMETRIC_DEFAULT"
        };
    } else // ERROR: unknown version
    throw new Error("Unknown ramper wallet version");
    let client = new (0, $ebc1404b61d324aa$export$6d36407807609c3d)({
        region: region,
        credentials: credentials
    });
    let command = new (0, $bf11708289c3f6dc$export$d898f8208a7d4223)(input);
    let response = await client.send(command);
    let dek = new TextDecoder().decode(response.Plaintext);
    return {
        version: version,
        dek: dek,
        encryptedKey: encryptedKey
    };
}
function $ba3d3511b573d5ac$var$base64ToBytes(base64) {
    // @ts-ignore
    return Uint8Array.from(window.atob(base64), (m)=>m.codePointAt(0));
}
function $ba3d3511b573d5ac$var$hexToBytes(hex) {
    return Uint8Array.from(hex.match(/.{1,2}/g).map((b)=>parseInt(b, 16)));
}
async function $ba3d3511b573d5ac$export$4f15789826015814(version, dek, encryptedKey) {
    if (version === 3.1) {
        let iterations = 1e3;
        let keyMaterial = await crypto.subtle.importKey("raw", new TextEncoder().encode(dek), "PBKDF2", false, [
            "deriveKey"
        ]);
        let salt = $ba3d3511b573d5ac$var$hexToBytes(encryptedKey.substring(0, 32));
        let iv = $ba3d3511b573d5ac$var$hexToBytes(encryptedKey.substring(32, 64));
        let data = $ba3d3511b573d5ac$var$base64ToBytes(encryptedKey.substring(64));
        let key = await crypto.subtle.deriveKey({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: "SHA-1"
        }, keyMaterial, {
            name: "AES-CBC",
            length: 256
        }, false, [
            "decrypt"
        ]);
        let mnemonic = new TextDecoder().decode(await crypto.subtle.decrypt({
            name: "AES-CBC",
            iv: iv
        }, key, data));
        return mnemonic;
    } else if (version <= 7) {
        let data = $ba3d3511b573d5ac$var$base64ToBytes(encryptedKey);
        let key = await crypto.subtle.importKey("raw", $ba3d3511b573d5ac$var$hexToBytes(dek), "AES-CBC", false, [
            "decrypt"
        ]);
        let iv = Uint8Array.from(new Array(16).fill(0));
        let mnemonic = new TextDecoder().decode($ba3d3511b573d5ac$var$hexToBytes(new TextDecoder().decode(await crypto.subtle.decrypt({
            name: "AES-CBC",
            iv: iv
        }, key, data))));
        return mnemonic;
    } else throw new Error("Unknown ramper wallet version");
}



function $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44255bd742036c59$export$2e315dfe55958408), {
        as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
        ...props
    });
}
function $e9b44fba3bcf08e7$var$CosmoNicknameAutocomplete({ nickname: nickname, setNickname: setNickname, isInvalid: isInvalid = false, errorMessage: errorMessage }) {
    let list = (0, $fb5ac2544e0480b5$export$bc3384a35de93d66)({
        async load ({ filterText: filterText }) {
            if (!filterText || filterText.length < 4) return {
                items: []
            };
            if (!(0, $9105f8a53cedb7f3$export$cc1aced799785edc).credentials) {
                let response = await fetch(`https://cache.nova.gd/user/v1/search?query=${encodeURIComponent(filterText)}`);
                let { results: items } = await response.json();
                return {
                    items: items
                };
            } else {
                let { results: items } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).searchUsers(filterText);
                return {
                    items: items
                };
            }
        }
    });
    let [listFilterText] = (0, $a0ce7fac17a9bc96$export$21805fee57372823)(nickname, 100);
    (0, $acw62.useEffect)(()=>list.setFilterText(listFilterText), [
        listFilterText
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4242086c8a2b354a$export$e47a559fed520648), {
        isClearable: true,
        "aria-label": "Search user by COSMO ID",
        placeholder: "Search user by COSMO ID",
        allowsCustomValue: true,
        isLoading: list.isLoading,
        items: list.items,
        inputValue: nickname,
        onInputChange: setNickname,
        inputProps: {
            classNames: {
                input: "text-base placeholder:text-small"
            }
        },
        className: "min-w-72",
        popoverProps: {
            placement: "top"
        },
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        children: list.items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                textValue: item.nickname,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03acd725adb4588e$export$2f4e98393b39571a), {
                    name: item.nickname,
                    description: item.address,
                    avatarProps: {
                        src: "https://static.cosmo.fans/uploads/images/img_profile_gallag@3x.png"
                    }
                })
            }, item.nickname))
    });
}
var $0ea36b1fc1a34871$exports = {};
$0ea36b1fc1a34871$exports = new URL("cosmo-login-mail.d1bafb7c.png", import.meta.url).toString();


function $e9b44fba3bcf08e7$var$LoginModal({ onClose: onClose }) {
    let { addAccount: addAccount } = (0, $f18c256353fe9c11$export$c229550bd86eba85)();
    let [screen, setScreen] = (0, $acw62.useState)(0);
    let [email, setEmail] = (0, $acw62.useState)("");
    let [transactionId, setTransactionId] = (0, $acw62.useState)("");
    let [pendingToken, setPendingToken] = (0, $acw62.useState)("");
    let [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    let [error, setError] = (0, $acw62.useState)("");
    async function onNextButtonPress() {
        try {
            setIsLoading(true);
            setError("");
            if (screen === 0) {
                let { transactionId: transactionId, pendingToken: pendingToken } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).requestSignIn(email);
                setTransactionId(transactionId);
                setPendingToken(pendingToken);
                setScreen(1);
            } else if (screen === 1) {
                let { customToken: customToken, socialLoginUserId: socialLoginUserId, ...credentials } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).signIn(email, transactionId, pendingToken);
                let ramperWalletSecrets = await (0, $ba3d3511b573d5ac$export$42fb174b38fb584c)(socialLoginUserId, customToken);
                let profile;
                try {
                    profile = await new (0, $6a6d46e8aa41c2b9$export$2aa162f6af0a2014)().signIn(socialLoginUserId);
                } catch (error) {
                    console.error(error);
                    let temporaryCosmoClient = new (0, $9105f8a53cedb7f3$export$f6bbdec142f79477)();
                    temporaryCosmoClient.credentials = credentials;
                    profile = await temporaryCosmoClient.getProfile();
                }
                addAccount({
                    credentials: credentials,
                    profile: profile,
                    ramperWalletSecrets: ramperWalletSecrets,
                    socialLoginUserId: socialLoginUserId
                });
                setScreen(2);
            } else if (screen === 2) onClose();
        } catch (error) {
            console.error(error);
            $81a395368bb6f380$export$f5282963edea4a68(error);
            if (error instanceof Error) setError(error.message);
        } finally{
            setIsLoading(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            onNextButtonPress();
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31c5bb588189e544$export$3b7be5d1e99a7c62), {
                children: "Login to COSMO"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $63b3cab10eaf2f6b$export$186c5a93653b521c), {
                children: [
                    screen === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Please enter your email address to request a sign in link."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e693153d3a5c272$export$921a3451e53aa4ce), {
                                type: "email",
                                label: "Email",
                                placeholder: "Enter your email",
                                value: email,
                                onValueChange: setEmail,
                                classNames: {
                                    input: "text-base placeholder:text-small"
                                }
                            })
                        ]
                    }),
                    screen === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "We have sent you an email with a link to confirm your sign in. Please check your inbox and click on the link",
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-blue-500",
                                        children: "confirm from a different device"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: new URL($0ea36b1fc1a34871$exports).href
                            })
                        ]
                    }),
                    screen === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "You have successfully signed in."
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-red-500",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $494d13c4d83d8955$export$69511fbe09cd360b), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                        color: "danger",
                        variant: "light",
                        onPress: onClose,
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                        color: "primary",
                        type: "submit",
                        isLoading: isLoading,
                        children: [
                            screen === 0 && "Send Email",
                            screen === 1 && "Check Confirmation",
                            screen === 2 && "Dismiss"
                        ]
                    })
                ]
            })
        ]
    });
}
function $e9b44fba3bcf08e7$export$2e2bcd8739ae039() {
    let { accounts: accounts, removeAccount: removeAccount, setCurrentAccount: setCurrentAccount } = (0, $f18c256353fe9c11$export$c229550bd86eba85)();
    let account = (0, $f18c256353fe9c11$export$8a2442b306735398)();
    let profile = (0, $f18c256353fe9c11$export$73fc7af4ef9455f4)();
    let { isOpen: isOpen, onOpen: onOpen, onOpenChange: onOpenChange } = (0, $7c70e959e80c13a8$export$6e3e27031a30522f)();
    let [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let [nickname, setNickname] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>setIsMenuOpen(false), [
        location
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c5922bdefe6d2742$export$bcc2fdface6e45cf), {
                isMenuOpen: isMenuOpen,
                onMenuOpenChange: setIsMenuOpen,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bb96be14a00f82db$export$ed1630e68a9ee3a0), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e080d4d9883bf0f4$export$c08e55e3809509ed), {
                                "aria-label": isMenuOpen ? "Close menu" : "Open menu",
                                className: "sm:hidden"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e63a7198df7a736$export$cf176d99d56322e3), {
                                className: "grow-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-inherit",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$export$a6c7ac8248d6e38a, {
                                                color: "foreground",
                                                to: "/",
                                                children: "Polaris"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-tiny leading-[.5rem] text-foreground-500",
                                            children: [
                                                "by ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "https://twitter.com/3somsoc",
                                                    children: "@3somsoc"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e302041eee35e5bc$export$28cedb35e163df5b), {
                                className: "hidden sm:block",
                                isActive: location.pathname === "/",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$export$a6c7ac8248d6e38a, {
                                    color: "foreground",
                                    to: "/",
                                    children: "Objekts"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e302041eee35e5bc$export$28cedb35e163df5b), {
                                className: "hidden sm:block",
                                isActive: location.pathname === "/gravity",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$export$a6c7ac8248d6e38a, {
                                    to: "/gravity",
                                    children: "Gravity Stats"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2046913fa19b64a8$export$216a181a5d412ca8), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $477a897f25a6321e$export$a0dd0fa4d8e5392d), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$export$a6c7ac8248d6e38a, {
                                    color: "foreground",
                                    to: "/",
                                    children: "Objekts"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $477a897f25a6321e$export$a0dd0fa4d8e5392d), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$export$a6c7ac8248d6e38a, {
                                    color: "foreground",
                                    to: "/gravity",
                                    children: "Gravity Stats"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $477a897f25a6321e$export$a0dd0fa4d8e5392d), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                    className: "flex gap-2",
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        navigate(`/@${nickname}`);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$var$CosmoNicknameAutocomplete, {
                                            nickname: nickname,
                                            setNickname: setNickname
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                            type: "submit",
                                            isIconOnly: true,
                                            color: "primary",
                                            variant: "flat",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$8ab25e1bd13dc8cb), {
                                                className: "w-6 h-6"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bb96be14a00f82db$export$ed1630e68a9ee3a0), {
                        justify: "end",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e302041eee35e5bc$export$28cedb35e163df5b), {
                                className: "hidden sm:block",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                    className: "flex gap-2",
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        navigate(`/@${nickname}`);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$var$CosmoNicknameAutocomplete, {
                                            nickname: nickname,
                                            setNickname: setNickname
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                            type: "submit",
                                            isIconOnly: true,
                                            color: "primary",
                                            variant: "flat",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$8ab25e1bd13dc8cb), {
                                                className: "w-6 h-6"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e302041eee35e5bc$export$28cedb35e163df5b), {
                                children: profile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a8a01edcf9e5fefd$export$3bd981faadafe0b3), {
                                    shouldBlockScroll: false,
                                    triggerScaleOnOpen: false,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7a8d7d87317964b$export$bf3f08696645e39f), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                                radius: "full",
                                                variant: "light",
                                                size: "lg",
                                                className: "ps-1 pe-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03acd725adb4588e$export$2f4e98393b39571a), {
                                                    name: profile.nickname,
                                                    description: !account?.socialLoginUserId ? "\u26A0 Please relogin! " : profile.email,
                                                    avatarProps: {
                                                        src: profile.profileImageUrl || "https://static.cosmo.fans/uploads/images/img_profile_gallag@3x.png"
                                                    },
                                                    classNames: {
                                                        description: !account?.socialLoginUserId ? "text-warning" : ""
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa7e2859a413aac$export$a94b2d6670970977), {
                                            onAction: (key)=>{
                                                if (key === "login") onOpen();
                                                else if (key === "logout") removeAccount(profile.id);
                                                else if (typeof key === "string" && key.startsWith("profile-")) {
                                                    let profileId = parseInt(key.slice(8));
                                                    setCurrentAccount(profileId);
                                                }
                                            },
                                            "aria-label": "Account Actions",
                                            children: [
                                                ...accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4107eb738d7c5e40$export$42228163bda52c88), {
                                                        className: !account?.socialLoginUserId ? "text-warning" : "",
                                                        children: [
                                                            "@",
                                                            account.profile.nickname,
                                                            !account?.socialLoginUserId ? " (relogin needed)" : ""
                                                        ]
                                                    }, `profile-${account.profile.id}`)),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4107eb738d7c5e40$export$42228163bda52c88), {
                                                    children: "Add account"
                                                }, "login"),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4107eb738d7c5e40$export$42228163bda52c88), {
                                                    className: "text-danger",
                                                    color: "danger",
                                                    children: "Logout"
                                                }, "logout")
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                    color: "primary",
                                    onClick: onOpen,
                                    children: "Login"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f48272b62179a444$export$194c5e3f782179f4), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: "top-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90430c3f5844fbf9$export$e7e965ff0372e8c), {
                    children: (onClose)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9b44fba3bcf08e7$var$LoginModal, {
                            onClose: onClose
                        })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
        ]
    });
}




var $acw62 = parcelRequire("acw62");
/**
 *  [[link-alchemy]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Amoy Testnet (``matic-amoy``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:Alchemy  [providers-alchemy]
 */ /**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "6.13.2";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $5ac0677dd70fe0c6$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $5ac0677dd70fe0c6$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $5ac0677dd70fe0c6$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $5ac0677dd70fe0c6$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $634aa51198273feb$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($634aa51198273feb$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $634aa51198273feb$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$634aa51198273feb$var$stringify(k)}: ${$634aa51198273feb$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $634aa51198273feb$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $634aa51198273feb$export$748c4fa78f31ff35(error) {
    return $634aa51198273feb$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$634aa51198273feb$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $634aa51198273feb$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $9f7bf65ddafc81a6$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $634aa51198273feb$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info);
}
function $634aa51198273feb$export$c3d31707e5030f5e(check, message, name, value) {
    $634aa51198273feb$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $634aa51198273feb$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $634aa51198273feb$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $634aa51198273feb$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $634aa51198273feb$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $634aa51198273feb$export$d993e67fefdfecda(form) {
    $634aa51198273feb$export$a7a9523472993e97($634aa51198273feb$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $634aa51198273feb$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $634aa51198273feb$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}

/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ // utils/base64-browser
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $fd3872da8feed9cb$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $fd3872da8feed9cb$export$a3521add2594f3c8(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, false);
}
function $fd3872da8feed9cb$export$37110e7fee0af4ad(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, true);
}
function $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $fd3872da8feed9cb$export$9a14abb1a440cd5e(value) {
    return $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $fd3872da8feed9cb$var$HexCharacters = "0123456789abcdef";
function $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $fd3872da8feed9cb$var$HexCharacters[(v & 0xf0) >> 4] + $fd3872da8feed9cb$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $fd3872da8feed9cb$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$fd3872da8feed9cb$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $fd3872da8feed9cb$export$2321cd91b99770ff(data) {
    if ($fd3872da8feed9cb$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $fd3872da8feed9cb$export$a3521add2594f3c8(data).length;
}
function $fd3872da8feed9cb$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $fd3872da8feed9cb$export$9c854001a22ebaa2(data) {
    let bytes = $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $fd3872da8feed9cb$var$zeroPad(data, length, left) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    (0, $634aa51198273feb$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(result);
}
function $fd3872da8feed9cb$export$4473860254365feb(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, true);
}
function $fd3872da8feed9cb$export$1dc7fbe1b8738fe7(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, false);
}


function $4d58342a3bfda827$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data);
}
function $4d58342a3bfda827$export$8fb536984ec8b4d7(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}





/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $50aa15ceb128a952$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $50aa15ceb128a952$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $50aa15ceb128a952$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $50aa15ceb128a952$var$errorFunc,
    ignore: $50aa15ceb128a952$var$ignoreFunc,
    replace: $50aa15ceb128a952$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $50aa15ceb128a952$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $50aa15ceb128a952$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $50aa15ceb128a952$export$8feeb310b4b4752f(str, form) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $634aa51198273feb$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $50aa15ceb128a952$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $50aa15ceb128a952$export$7643a1dc2c38d5eb(bytes, onError) {
    return $50aa15ceb128a952$var$_toUtf8String($50aa15ceb128a952$var$getUtf8CodePoints(bytes, onError));
}
function $50aa15ceb128a952$export$ae470a36a31b28c2(str, form) {
    return $50aa15ceb128a952$var$getUtf8CodePoints($50aa15ceb128a952$export$8feeb310b4b4752f(str, form));
}



function $9834edf3ba75eaa8$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(_signal == null || !_signal.cancelled, "request cancelled before sending", "CANCELLED");
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $634aa51198273feb$export$a7a9523472993e97)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $634aa51198273feb$export$a7a9523472993e97)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let error = null;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            error = (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("request timeout", "TIMEOUT");
            controller.abort();
        }, req.timeout);
        if (_signal) _signal.addListener(()=>{
            error = (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("request cancelled", "CANCELLED");
            controller.abort();
        });
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: controller.signal
        };
        let resp;
        try {
            resp = await fetch(req.url, init);
        } catch (_error) {
            clearTimeout(timer);
            if (error) throw error;
            throw _error;
        }
        clearTimeout(timer);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $9834edf3ba75eaa8$var$defaultGetUrl = $9834edf3ba75eaa8$export$d3950daf7bce5bf5({});
async function $9834edf3ba75eaa8$export$94df0e59ebebf4a7(req, _signal) {
    return $9834edf3ba75eaa8$var$defaultGetUrl(req, _signal);
}


const $2cb10defc4f72334$var$MAX_ATTEMPTS = 12;
const $2cb10defc4f72334$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $2cb10defc4f72334$var$defaultGetUrlFunc = (0, $9834edf3ba75eaa8$export$d3950daf7bce5bf5)();
const $2cb10defc4f72334$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $2cb10defc4f72334$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $2cb10defc4f72334$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $2cb10defc4f72334$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($2cb10defc4f72334$var$reData);
        if (!match) throw new Error("invalid data");
        return new $2cb10defc4f72334$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $4d58342a3bfda827$export$94fdf11bafc8de6b)(match[3]) : $2cb10defc4f72334$var$unpercent(match[3]));
    } catch (error) {
        return new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $2cb10defc4f72334$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $2cb10defc4f72334$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($2cb10defc4f72334$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $2cb10defc4f72334$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $2cb10defc4f72334$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $2cb10defc4f72334$var$Gateways = {
    "data": $2cb10defc4f72334$var$dataGatewayFunc,
    "ipfs": $2cb10defc4f72334$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $2cb10defc4f72334$var$fetchSignals = new WeakMap();
class $2cb10defc4f72334$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $2cb10defc4f72334$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $2cb10defc4f72334$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $2cb10defc4f72334$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $4d58342a3bfda827$export$8fb536984ec8b4d7)((0, $50aa15ceb128a952$export$8feeb310b4b4752f)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $2cb10defc4f72334$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $2cb10defc4f72334$var$SLOT_INTERVAL,
            maxAttempts: $2cb10defc4f72334$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $634aa51198273feb$export$a7a9523472993e97)($2cb10defc4f72334$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $2cb10defc4f72334$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $2cb10defc4f72334$var$Gateways) {
            const result = await $2cb10defc4f72334$var$Gateways[scheme](req.url, $2cb10defc4f72334$var$checkSignal(_request.#signal));
            if (result instanceof $2cb10defc4f72334$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $2cb10defc4f72334$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $2cb10defc4f72334$var$checkSignal(_request.#signal));
        let response = new $2cb10defc4f72334$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $2cb10defc4f72334$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $2cb10defc4f72334$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $2cb10defc4f72334$var$getTime() + this.timeout, 0, this, new $2cb10defc4f72334$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $2cb10defc4f72334$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $2cb10defc4f72334$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $2cb10defc4f72334$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#throttle = Object.assign({}, this.#throttle);
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $2cb10defc4f72334$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $2cb10defc4f72334$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($2cb10defc4f72334$var$locked) throw new Error("gateways locked");
        $2cb10defc4f72334$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($2cb10defc4f72334$var$locked) throw new Error("gateways locked");
        $2cb10defc4f72334$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $9834edf3ba75eaa8$export$d3950daf7bce5bf5)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $2cb10defc4f72334$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $2cb10defc4f72334$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $2cb10defc4f72334$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(this.#body);
        } catch (error) {
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(this.#body);
        } catch (e) {}
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $2cb10defc4f72334$var$getTime() {
    return new Date().getTime();
}
function $2cb10defc4f72334$var$unpercent(value) {
    return (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $2cb10defc4f72334$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}


/**
 *  There are many awesome community services that provide Ethereum
 *  nodes both for developers just starting out and for large-scale
 *  communities.
 *
 *  @_section: api/providers/thirdparty: Community Providers  [thirdparty]
 */ // Show the throttle message only once per service
const $fe3cdff79340e8e1$var$shown = new Set();
function $fe3cdff79340e8e1$export$4c41bd49e82e82ab(service) {
    if ($fe3cdff79340e8e1$var$shown.has(service)) return;
    $fe3cdff79340e8e1$var$shown.add(service);
    console.log("========= NOTICE =========");
    console.log(`Request-Rate Exceeded for ${service} (this message will not be repeated)`);
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.org/api-keys/");
    console.log("==========================");
}


/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ /**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ var $51b6b372898f65c0$exports = {};
"use strict";
Object.defineProperty($51b6b372898f65c0$exports, "__esModule", {
    value: true
});
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$exports.HMAC = void 0;
var $a0ae23f5901291b4$exports = {};
"use strict";
Object.defineProperty($a0ae23f5901291b4$exports, "__esModule", {
    value: true
});
$a0ae23f5901291b4$exports.output = $a0ae23f5901291b4$exports.exists = $a0ae23f5901291b4$exports.hash = $a0ae23f5901291b4$exports.bytes = $a0ae23f5901291b4$exports.bool = $a0ae23f5901291b4$exports.number = void 0;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$a0ae23f5901291b4$exports.number = $a0ae23f5901291b4$var$number;
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$a0ae23f5901291b4$exports.bool = $a0ae23f5901291b4$var$bool;
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$a0ae23f5901291b4$exports.bytes = $a0ae23f5901291b4$var$bytes;
function $a0ae23f5901291b4$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(hash.outputLen);
    $a0ae23f5901291b4$var$number(hash.blockLen);
}
$a0ae23f5901291b4$exports.hash = $a0ae23f5901291b4$var$hash;
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$a0ae23f5901291b4$exports.exists = $a0ae23f5901291b4$var$exists;
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$a0ae23f5901291b4$exports.output = $a0ae23f5901291b4$var$output;
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
$a0ae23f5901291b4$exports.default = $a0ae23f5901291b4$var$assert;


var $29ee4d3171d9809b$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($29ee4d3171d9809b$exports, "__esModule", {
    value: true
});
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$exports.isLE = $29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$exports.u8 = void 0;
var $a20ad0ecd1be3cb3$exports = {};
"use strict";
Object.defineProperty($a20ad0ecd1be3cb3$exports, "__esModule", {
    value: true
});
$a20ad0ecd1be3cb3$exports.crypto = void 0;
$a20ad0ecd1be3cb3$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $29ee4d3171d9809b$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$29ee4d3171d9809b$exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$29ee4d3171d9809b$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$29ee4d3171d9809b$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    if (!$29ee4d3171d9809b$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
$29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
$29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $29ee4d3171d9809b$exports.nextTick)();
        ts += diff;
    }
}
$29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    if (!$29ee4d3171d9809b$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
$29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$29ee4d3171d9809b$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$var$Hash;
const $29ee4d3171d9809b$var$toStr = {}.toString;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $29ee4d3171d9809b$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
$29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.getRandomValues === "function") return $a20ad0ecd1be3cb3$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;


// HMAC (RFC 2104)
class $51b6b372898f65c0$var$HMAC extends $29ee4d3171d9809b$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $a0ae23f5901291b4$exports.hash)(hash);
        const key = (0, $29ee4d3171d9809b$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $a0ae23f5901291b4$exports.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.exists)(this);
        (0, $a0ae23f5901291b4$exports.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$51b6b372898f65c0$exports.HMAC = $51b6b372898f65c0$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$var$hmac;
$51b6b372898f65c0$exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);


var $8c2f54a153cf1baf$exports = {};
"use strict";
Object.defineProperty($8c2f54a153cf1baf$exports, "__esModule", {
    value: true
});
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$exports.pbkdf2 = void 0;



// Common prologue and epilogue for sync/async functions
function $8c2f54a153cf1baf$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $a0ae23f5901291b4$exports.hash)(hash);
    const opts = (0, $29ee4d3171d9809b$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $a0ae23f5901291b4$exports.number)(c);
    (0, $a0ae23f5901291b4$exports.number)(dkLen);
    (0, $a0ae23f5901291b4$exports.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $29ee4d3171d9809b$exports.toBytes)(_password);
    const salt = (0, $29ee4d3171d9809b$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $51b6b372898f65c0$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $8c2f54a153cf1baf$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $29ee4d3171d9809b$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$8c2f54a153cf1baf$exports.pbkdf2 = $8c2f54a153cf1baf$var$pbkdf2;
async function $8c2f54a153cf1baf$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $29ee4d3171d9809b$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$var$pbkdf2Async;


var $510ad3657d73a9d2$exports = {};
"use strict";
Object.defineProperty($510ad3657d73a9d2$exports, "__esModule", {
    value: true
});
$510ad3657d73a9d2$exports.sha224 = $510ad3657d73a9d2$exports.sha256 = void 0;
var $bc3a993d7d38a7a0$exports = {};
"use strict";
Object.defineProperty($bc3a993d7d38a7a0$exports, "__esModule", {
    value: true
});
$bc3a993d7d38a7a0$exports.SHA2 = void 0;


// Polyfill for Safari 14
function $bc3a993d7d38a7a0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $bc3a993d7d38a7a0$var$SHA2 extends $29ee4d3171d9809b$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $29ee4d3171d9809b$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $a0ae23f5901291b4$exports.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $29ee4d3171d9809b$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.exists)(this);
        (0, $a0ae23f5901291b4$exports.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $bc3a993d7d38a7a0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $29ee4d3171d9809b$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$bc3a993d7d38a7a0$exports.SHA2 = $bc3a993d7d38a7a0$var$SHA2;



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $510ad3657d73a9d2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $510ad3657d73a9d2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $510ad3657d73a9d2$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $bc3a993d7d38a7a0$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $29ee4d3171d9809b$exports.rotr)(W15, 7) ^ (0, $29ee4d3171d9809b$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $29ee4d3171d9809b$exports.rotr)(W2, 17) ^ (0, $29ee4d3171d9809b$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $29ee4d3171d9809b$exports.rotr)(E, 6) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 11) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $510ad3657d73a9d2$var$Chi(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $29ee4d3171d9809b$exports.rotr)(A, 2) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 13) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 22);
            const T2 = sigma0 + $510ad3657d73a9d2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $510ad3657d73a9d2$exports.sha256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
$510ad3657d73a9d2$exports.sha224 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());


var $2579977b4e52adba$exports = {};
"use strict";
Object.defineProperty($2579977b4e52adba$exports, "__esModule", {
    value: true
});
$2579977b4e52adba$exports.sha384 = $2579977b4e52adba$exports.sha512_256 = $2579977b4e52adba$exports.sha512_224 = $2579977b4e52adba$exports.sha512 = $2579977b4e52adba$exports.SHA512 = void 0;

var $aa71b30d36adb919$exports = {};
"use strict";
Object.defineProperty($aa71b30d36adb919$exports, "__esModule", {
    value: true
});
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$exports.add = $aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$exports.split = $aa71b30d36adb919$exports.fromBig = void 0;
const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
$aa71b30d36adb919$exports.fromBig = $aa71b30d36adb919$var$fromBig;
function $aa71b30d36adb919$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
$aa71b30d36adb919$exports.split = $aa71b30d36adb919$var$split;
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
$aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
$aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
$aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
$aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
$aa71b30d36adb919$exports.add = $aa71b30d36adb919$var$add;
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
$aa71b30d36adb919$exports.default = $aa71b30d36adb919$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$2579977b4e52adba$var$SHA512_Kh, $2579977b4e52adba$var$SHA512_Kl] = /* @__PURE__ */ (()=>$aa71b30d36adb919$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $2579977b4e52adba$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $2579977b4e52adba$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $2579977b4e52adba$var$SHA512 extends $bc3a993d7d38a7a0$exports.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $2579977b4e52adba$var$SHA512_W_H[i] = view.getUint32(offset);
            $2579977b4e52adba$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $2579977b4e52adba$var$SHA512_W_H[i - 15] | 0;
            const W15l = $2579977b4e52adba$var$SHA512_W_L[i - 15] | 0;
            const s0h = $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $2579977b4e52adba$var$SHA512_W_H[i - 2] | 0;
            const W2l = $2579977b4e52adba$var$SHA512_W_L[i - 2] | 0;
            const s1h = $aa71b30d36adb919$exports.default.rotrSH(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBH(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $aa71b30d36adb919$exports.default.rotrSL(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBL(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $aa71b30d36adb919$exports.default.add4L(s0l, s1l, $2579977b4e52adba$var$SHA512_W_L[i - 7], $2579977b4e52adba$var$SHA512_W_L[i - 16]);
            const SUMh = $aa71b30d36adb919$exports.default.add4H(SUMl, s0h, s1h, $2579977b4e52adba$var$SHA512_W_H[i - 7], $2579977b4e52adba$var$SHA512_W_H[i - 16]);
            $2579977b4e52adba$var$SHA512_W_H[i] = SUMh | 0;
            $2579977b4e52adba$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $aa71b30d36adb919$exports.default.add5L(Hl, sigma1l, CHIl, $2579977b4e52adba$var$SHA512_Kl[i], $2579977b4e52adba$var$SHA512_W_L[i]);
            const T1h = $aa71b30d36adb919$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $2579977b4e52adba$var$SHA512_Kh[i], $2579977b4e52adba$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $aa71b30d36adb919$exports.default.rotrSH(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $aa71b30d36adb919$exports.default.rotrSL(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $aa71b30d36adb919$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $aa71b30d36adb919$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $aa71b30d36adb919$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $aa71b30d36adb919$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $aa71b30d36adb919$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $aa71b30d36adb919$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $aa71b30d36adb919$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $aa71b30d36adb919$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $2579977b4e52adba$var$SHA512_W_H.fill(0);
        $2579977b4e52adba$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$2579977b4e52adba$exports.SHA512 = $2579977b4e52adba$var$SHA512;
class $2579977b4e52adba$var$SHA512_224 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $2579977b4e52adba$var$SHA512_256 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $2579977b4e52adba$var$SHA384 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$2579977b4e52adba$exports.sha512 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512());
$2579977b4e52adba$exports.sha512_224 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_224());
$2579977b4e52adba$exports.sha512_256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_256());
$2579977b4e52adba$exports.sha384 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA384());



function $15a6e7f1608663ad$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $15a6e7f1608663ad$var$anyGlobal = $15a6e7f1608663ad$var$getGlobal();
const $15a6e7f1608663ad$var$crypto = $15a6e7f1608663ad$var$anyGlobal.crypto || $15a6e7f1608663ad$var$anyGlobal.msCrypto;
function $15a6e7f1608663ad$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $510ad3657d73a9d2$exports.sha256).create();
        case "sha512":
            return (0, $2579977b4e52adba$exports.sha512).create();
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $15a6e7f1608663ad$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $510ad3657d73a9d2$exports.sha256,
        sha512: $2579977b4e52adba$exports.sha512
    }[_algo];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $51b6b372898f65c0$exports.hmac).create(algo, key);
}
function $15a6e7f1608663ad$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $510ad3657d73a9d2$exports.sha256,
        sha512: $2579977b4e52adba$exports.sha512
    }[_algo];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $8c2f54a153cf1baf$exports.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $15a6e7f1608663ad$export$5f828d93ff035aa8(length) {
    (0, $634aa51198273feb$export$a7a9523472993e97)($15a6e7f1608663ad$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $15a6e7f1608663ad$var$crypto.getRandomValues(result);
    return result;
}



let $be13a0f2e0d9ad05$var$locked = false;
const $be13a0f2e0d9ad05$var$_computeHmac = function(algorithm, key, data) {
    return (0, $15a6e7f1608663ad$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $be13a0f2e0d9ad05$var$__computeHmac = $be13a0f2e0d9ad05$var$_computeHmac;
function $be13a0f2e0d9ad05$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($be13a0f2e0d9ad05$var$__computeHmac(algorithm, key, data));
}
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff._ = $be13a0f2e0d9ad05$var$_computeHmac;
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.lock = function() {
    $be13a0f2e0d9ad05$var$locked = true;
};
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.register = function(func) {
    if ($be13a0f2e0d9ad05$var$locked) throw new Error("computeHmac is locked");
    $be13a0f2e0d9ad05$var$__computeHmac = func;
};
Object.freeze($be13a0f2e0d9ad05$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ var $08748f983f07956b$exports = {};
"use strict";
Object.defineProperty($08748f983f07956b$exports, "__esModule", {
    value: true
});
$08748f983f07956b$exports.shake256 = $08748f983f07956b$exports.shake128 = $08748f983f07956b$exports.keccak_512 = $08748f983f07956b$exports.keccak_384 = $08748f983f07956b$exports.keccak_256 = $08748f983f07956b$exports.keccak_224 = $08748f983f07956b$exports.sha3_512 = $08748f983f07956b$exports.sha3_384 = $08748f983f07956b$exports.sha3_256 = $08748f983f07956b$exports.sha3_224 = $08748f983f07956b$exports.Keccak = $08748f983f07956b$exports.keccakP = void 0;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$08748f983f07956b$var$SHA3_PI, $08748f983f07956b$var$SHA3_ROTL, $08748f983f07956b$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $08748f983f07956b$var$_0n = /* @__PURE__ */ BigInt(0);
const $08748f983f07956b$var$_1n = /* @__PURE__ */ BigInt(1);
const $08748f983f07956b$var$_2n = /* @__PURE__ */ BigInt(2);
const $08748f983f07956b$var$_7n = /* @__PURE__ */ BigInt(7);
const $08748f983f07956b$var$_256n = /* @__PURE__ */ BigInt(256);
const $08748f983f07956b$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $08748f983f07956b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $08748f983f07956b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $08748f983f07956b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $08748f983f07956b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $08748f983f07956b$var$_1n ^ (R >> $08748f983f07956b$var$_7n) * $08748f983f07956b$var$_0x71n) % $08748f983f07956b$var$_256n;
        if (R & $08748f983f07956b$var$_2n) t ^= $08748f983f07956b$var$_1n << ($08748f983f07956b$var$_1n << /* @__PURE__ */ BigInt(j)) - $08748f983f07956b$var$_1n;
    }
    $08748f983f07956b$var$_SHA3_IOTA.push(t);
}
const [$08748f983f07956b$var$SHA3_IOTA_H, $08748f983f07956b$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $aa71b30d36adb919$exports.split)($08748f983f07956b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $08748f983f07956b$var$rotlH = (h, l, s)=>s > 32 ? (0, $aa71b30d36adb919$exports.rotlBH)(h, l, s) : (0, $aa71b30d36adb919$exports.rotlSH)(h, l, s);
const $08748f983f07956b$var$rotlL = (h, l, s)=>s > 32 ? (0, $aa71b30d36adb919$exports.rotlBL)(h, l, s) : (0, $aa71b30d36adb919$exports.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $08748f983f07956b$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $08748f983f07956b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $08748f983f07956b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $08748f983f07956b$var$SHA3_ROTL[t];
            const Th = $08748f983f07956b$var$rotlH(curH, curL, shift);
            const Tl = $08748f983f07956b$var$rotlL(curH, curL, shift);
            const PI = $08748f983f07956b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $08748f983f07956b$var$SHA3_IOTA_H[round];
        s[1] ^= $08748f983f07956b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$08748f983f07956b$exports.keccakP = $08748f983f07956b$var$keccakP;
class $08748f983f07956b$var$Keccak extends $29ee4d3171d9809b$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $a0ae23f5901291b4$exports.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $29ee4d3171d9809b$exports.u32)(this.state);
    }
    keccak() {
        $08748f983f07956b$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $a0ae23f5901291b4$exports.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $a0ae23f5901291b4$exports.exists)(this, false);
        (0, $a0ae23f5901291b4$exports.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $a0ae23f5901291b4$exports.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $a0ae23f5901291b4$exports.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$08748f983f07956b$exports.Keccak = $08748f983f07956b$var$Keccak;
const $08748f983f07956b$var$gen = (suffix, blockLen, outputLen)=>(0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen));
$08748f983f07956b$exports.sha3_224 = $08748f983f07956b$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $08748f983f07956b$exports.sha3_256 = $08748f983f07956b$var$gen(0x06, 136, 32);
$08748f983f07956b$exports.sha3_384 = $08748f983f07956b$var$gen(0x06, 104, 48);
$08748f983f07956b$exports.sha3_512 = $08748f983f07956b$var$gen(0x06, 72, 64);
$08748f983f07956b$exports.keccak_224 = $08748f983f07956b$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $08748f983f07956b$exports.keccak_256 = $08748f983f07956b$var$gen(0x01, 136, 32);
$08748f983f07956b$exports.keccak_384 = $08748f983f07956b$var$gen(0x01, 104, 48);
$08748f983f07956b$exports.keccak_512 = $08748f983f07956b$var$gen(0x01, 72, 64);
const $08748f983f07956b$var$genShake = (suffix, blockLen, outputLen)=>(0, $29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts)((opts = {})=>new $08748f983f07956b$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
$08748f983f07956b$exports.shake128 = $08748f983f07956b$var$genShake(0x1f, 168, 16);
$08748f983f07956b$exports.shake256 = $08748f983f07956b$var$genShake(0x1f, 136, 32);



let $9bdec2813ce7c52b$var$locked = false;
const $9bdec2813ce7c52b$var$_keccak256 = function(data) {
    return (0, $08748f983f07956b$exports.keccak_256)(data);
};
let $9bdec2813ce7c52b$var$__keccak256 = $9bdec2813ce7c52b$var$_keccak256;
function $9bdec2813ce7c52b$export$f8151fce47ad1c35(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($9bdec2813ce7c52b$var$__keccak256(data));
}
$9bdec2813ce7c52b$export$f8151fce47ad1c35._ = $9bdec2813ce7c52b$var$_keccak256;
$9bdec2813ce7c52b$export$f8151fce47ad1c35.lock = function() {
    $9bdec2813ce7c52b$var$locked = true;
};
$9bdec2813ce7c52b$export$f8151fce47ad1c35.register = function(func) {
    if ($9bdec2813ce7c52b$var$locked) throw new TypeError("keccak256 is locked");
    $9bdec2813ce7c52b$var$__keccak256 = func;
};
Object.freeze($9bdec2813ce7c52b$export$f8151fce47ad1c35);


var $de58877bbb165fd5$exports = {};
"use strict";
Object.defineProperty($de58877bbb165fd5$exports, "__esModule", {
    value: true
});
$de58877bbb165fd5$exports.ripemd160 = $de58877bbb165fd5$exports.RIPEMD160 = void 0;


// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $de58877bbb165fd5$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $de58877bbb165fd5$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $de58877bbb165fd5$var$Pi = /* @__PURE__ */ $de58877bbb165fd5$var$Id.map((i)=>(9 * i + 5) % 16);
let $de58877bbb165fd5$var$idxL = [
    $de58877bbb165fd5$var$Id
];
let $de58877bbb165fd5$var$idxR = [
    $de58877bbb165fd5$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $de58877bbb165fd5$var$idxL,
    $de58877bbb165fd5$var$idxR
])j.push(j[i].map((k)=>$de58877bbb165fd5$var$Rho[k]));
const $de58877bbb165fd5$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $de58877bbb165fd5$var$shiftsL = /* @__PURE__ */ $de58877bbb165fd5$var$idxL.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$shiftsR = /* @__PURE__ */ $de58877bbb165fd5$var$idxR.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $de58877bbb165fd5$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $de58877bbb165fd5$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $de58877bbb165fd5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $de58877bbb165fd5$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $de58877bbb165fd5$var$RIPEMD160 extends $bc3a993d7d38a7a0$exports.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$de58877bbb165fd5$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $de58877bbb165fd5$var$Kl[group], hbr = $de58877bbb165fd5$var$Kr[group]; // prettier-ignore
            const rl = $de58877bbb165fd5$var$idxL[group], rr = $de58877bbb165fd5$var$idxR[group]; // prettier-ignore
            const sl = $de58877bbb165fd5$var$shiftsL[group], sr = $de58877bbb165fd5$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $de58877bbb165fd5$var$rotl(al + $de58877bbb165fd5$var$f(group, bl, cl, dl) + $de58877bbb165fd5$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $de58877bbb165fd5$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $de58877bbb165fd5$var$rotl(ar + $de58877bbb165fd5$var$f(rGroup, br, cr, dr) + $de58877bbb165fd5$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $de58877bbb165fd5$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $de58877bbb165fd5$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
$de58877bbb165fd5$exports.RIPEMD160 = $de58877bbb165fd5$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $de58877bbb165fd5$exports.ripemd160 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $de58877bbb165fd5$var$RIPEMD160());



let $76bdf8351c5898c8$var$locked = false;
const $76bdf8351c5898c8$var$_ripemd160 = function(data) {
    return (0, $de58877bbb165fd5$exports.ripemd160)(data);
};
let $76bdf8351c5898c8$var$__ripemd160 = $76bdf8351c5898c8$var$_ripemd160;
function $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($76bdf8351c5898c8$var$__ripemd160(data));
}
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e._ = $76bdf8351c5898c8$var$_ripemd160;
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.lock = function() {
    $76bdf8351c5898c8$var$locked = true;
};
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($76bdf8351c5898c8$var$locked) throw new TypeError("ripemd160 is locked");
    $76bdf8351c5898c8$var$__ripemd160 = func;
};
Object.freeze($76bdf8351c5898c8$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $9092348e8cf65603$var$locked = false;
const $9092348e8cf65603$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $15a6e7f1608663ad$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $9092348e8cf65603$var$__pbkdf2 = $9092348e8cf65603$var$_pbkdf2;
function $9092348e8cf65603$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($9092348e8cf65603$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$9092348e8cf65603$export$448fa22aedc9dbca._ = $9092348e8cf65603$var$_pbkdf2;
$9092348e8cf65603$export$448fa22aedc9dbca.lock = function() {
    $9092348e8cf65603$var$locked = true;
};
$9092348e8cf65603$export$448fa22aedc9dbca.register = function(func) {
    if ($9092348e8cf65603$var$locked) throw new Error("pbkdf2 is locked");
    $9092348e8cf65603$var$__pbkdf2 = func;
};
Object.freeze($9092348e8cf65603$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $90bc03290273a6e1$var$locked = false;
const $90bc03290273a6e1$var$_randomBytes = function(length) {
    return new Uint8Array((0, $15a6e7f1608663ad$export$5f828d93ff035aa8)(length));
};
let $90bc03290273a6e1$var$__randomBytes = $90bc03290273a6e1$var$_randomBytes;
function $90bc03290273a6e1$export$5f828d93ff035aa8(length) {
    return $90bc03290273a6e1$var$__randomBytes(length);
}
$90bc03290273a6e1$export$5f828d93ff035aa8._ = $90bc03290273a6e1$var$_randomBytes;
$90bc03290273a6e1$export$5f828d93ff035aa8.lock = function() {
    $90bc03290273a6e1$var$locked = true;
};
$90bc03290273a6e1$export$5f828d93ff035aa8.register = function(func) {
    if ($90bc03290273a6e1$var$locked) throw new Error("randomBytes is locked");
    $90bc03290273a6e1$var$__randomBytes = func;
};
Object.freeze($90bc03290273a6e1$export$5f828d93ff035aa8);


var $dd94f1d283dd7b2d$exports = {};
"use strict";
Object.defineProperty($dd94f1d283dd7b2d$exports, "__esModule", {
    value: true
});
$dd94f1d283dd7b2d$exports.scryptAsync = $dd94f1d283dd7b2d$exports.scrypt = void 0;




// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $dd94f1d283dd7b2d$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $dd94f1d283dd7b2d$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $dd94f1d283dd7b2d$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $dd94f1d283dd7b2d$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $dd94f1d283dd7b2d$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $dd94f1d283dd7b2d$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $dd94f1d283dd7b2d$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $dd94f1d283dd7b2d$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $dd94f1d283dd7b2d$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $dd94f1d283dd7b2d$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $dd94f1d283dd7b2d$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $dd94f1d283dd7b2d$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $dd94f1d283dd7b2d$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $dd94f1d283dd7b2d$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $dd94f1d283dd7b2d$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $dd94f1d283dd7b2d$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $dd94f1d283dd7b2d$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $dd94f1d283dd7b2d$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $dd94f1d283dd7b2d$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $dd94f1d283dd7b2d$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $dd94f1d283dd7b2d$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $dd94f1d283dd7b2d$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $dd94f1d283dd7b2d$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $dd94f1d283dd7b2d$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $dd94f1d283dd7b2d$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $dd94f1d283dd7b2d$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $dd94f1d283dd7b2d$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $dd94f1d283dd7b2d$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $dd94f1d283dd7b2d$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $dd94f1d283dd7b2d$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $dd94f1d283dd7b2d$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $dd94f1d283dd7b2d$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $dd94f1d283dd7b2d$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $dd94f1d283dd7b2d$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $dd94f1d283dd7b2d$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $dd94f1d283dd7b2d$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $29ee4d3171d9809b$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $a0ae23f5901291b4$exports.number)(N);
    (0, $a0ae23f5901291b4$exports.number)(r);
    (0, $a0ae23f5901291b4$exports.number)(p);
    (0, $a0ae23f5901291b4$exports.number)(dkLen);
    (0, $a0ae23f5901291b4$exports.number)(asyncTick);
    (0, $a0ae23f5901291b4$exports.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $8c2f54a153cf1baf$exports.pbkdf2)($510ad3657d73a9d2$exports.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $29ee4d3171d9809b$exports.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $29ee4d3171d9809b$exports.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $29ee4d3171d9809b$exports.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $8c2f54a153cf1baf$exports.pbkdf2)($510ad3657d73a9d2$exports.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function $dd94f1d283dd7b2d$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
$dd94f1d283dd7b2d$exports.scrypt = $dd94f1d283dd7b2d$var$scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function $dd94f1d283dd7b2d$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(N - 1, asyncTick, ()=>{
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
$dd94f1d283dd7b2d$exports.scryptAsync = $dd94f1d283dd7b2d$var$scryptAsync;



let $e794241b1cb9b0d3$var$lockedSync = false, $e794241b1cb9b0d3$var$lockedAsync = false;
const $e794241b1cb9b0d3$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $dd94f1d283dd7b2d$exports.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $e794241b1cb9b0d3$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $dd94f1d283dd7b2d$exports.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $e794241b1cb9b0d3$var$__scryptAsync = $e794241b1cb9b0d3$var$_scryptAsync;
let $e794241b1cb9b0d3$var$__scryptSync = $e794241b1cb9b0d3$var$_scryptSync;
async function $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await $e794241b1cb9b0d3$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3._ = $e794241b1cb9b0d3$var$_scryptAsync;
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.lock = function() {
    $e794241b1cb9b0d3$var$lockedAsync = true;
};
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedAsync) throw new Error("scrypt is locked");
    $e794241b1cb9b0d3$var$__scryptAsync = func;
};
Object.freeze($e794241b1cb9b0d3$export$7cf7c2f1ec457bf3);
function $e794241b1cb9b0d3$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($e794241b1cb9b0d3$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$e794241b1cb9b0d3$export$86c79e0734c26a76._ = $e794241b1cb9b0d3$var$_scryptSync;
$e794241b1cb9b0d3$export$86c79e0734c26a76.lock = function() {
    $e794241b1cb9b0d3$var$lockedSync = true;
};
$e794241b1cb9b0d3$export$86c79e0734c26a76.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedSync) throw new Error("scryptSync is locked");
    $e794241b1cb9b0d3$var$__scryptSync = func;
};
Object.freeze($e794241b1cb9b0d3$export$86c79e0734c26a76);




const $c1049352abb4e7c6$var$_sha256 = function(data) {
    return (0, $15a6e7f1608663ad$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $c1049352abb4e7c6$var$_sha512 = function(data) {
    return (0, $15a6e7f1608663ad$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $c1049352abb4e7c6$var$__sha256 = $c1049352abb4e7c6$var$_sha256;
let $c1049352abb4e7c6$var$__sha512 = $c1049352abb4e7c6$var$_sha512;
let $c1049352abb4e7c6$var$locked256 = false, $c1049352abb4e7c6$var$locked512 = false;
function $c1049352abb4e7c6$export$bced8d2aada2d1c9(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($c1049352abb4e7c6$var$__sha256(data));
}
$c1049352abb4e7c6$export$bced8d2aada2d1c9._ = $c1049352abb4e7c6$var$_sha256;
$c1049352abb4e7c6$export$bced8d2aada2d1c9.lock = function() {
    $c1049352abb4e7c6$var$locked256 = true;
};
$c1049352abb4e7c6$export$bced8d2aada2d1c9.register = function(func) {
    if ($c1049352abb4e7c6$var$locked256) throw new Error("sha256 is locked");
    $c1049352abb4e7c6$var$__sha256 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);
function $c1049352abb4e7c6$export$a888d2532e6dc7bb(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($c1049352abb4e7c6$var$__sha512(data));
}
$c1049352abb4e7c6$export$a888d2532e6dc7bb._ = $c1049352abb4e7c6$var$_sha512;
$c1049352abb4e7c6$export$a888d2532e6dc7bb.lock = function() {
    $c1049352abb4e7c6$var$locked512 = true;
};
$c1049352abb4e7c6$export$a888d2532e6dc7bb.register = function(func) {
    if ($c1049352abb4e7c6$var$locked512) throw new Error("sha512 is locked");
    $c1049352abb4e7c6$var$__sha512 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);


/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ var $3f551179096121b9$exports = {};
"use strict";
Object.defineProperty($3f551179096121b9$exports, "__esModule", {
    value: true
});
$3f551179096121b9$exports.encodeToCurve = $3f551179096121b9$exports.hashToCurve = $3f551179096121b9$exports.schnorr = $3f551179096121b9$exports.secp256k1 = void 0;



var $2D9sF = parcelRequire("2D9sF");
var $c3b91d553ab14e64$exports = {};
"use strict";
Object.defineProperty($c3b91d553ab14e64$exports, "__esModule", {
    value: true
});
$c3b91d553ab14e64$exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$exports.SWUFpSqrtRatio = $c3b91d553ab14e64$exports.weierstrass = $c3b91d553ab14e64$exports.weierstrassPoints = $c3b91d553ab14e64$exports.DER = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");

var $lkFCe = parcelRequire("lkFCe");
function $c3b91d553ab14e64$var$validatePointOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $c3b91d553ab14e64$var$b2n, hexToBytes: $c3b91d553ab14e64$var$h2b } = $esaJO;
$c3b91d553ab14e64$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $c3b91d553ab14e64$exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $c3b91d553ab14e64$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $c3b91d553ab14e64$exports.DER;
        const data = typeof hex === "string" ? $c3b91d553ab14e64$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $c3b91d553ab14e64$exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $c3b91d553ab14e64$exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$var$weierstrassPoints(opts) {
    const CURVE = $c3b91d553ab14e64$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $esaJO.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $c3b91d553ab14e64$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $esaJO.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $esaJO.bytesToNumberBE((0, $esaJO.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $2D9sF.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $esaJO.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $c3b91d553ab14e64$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $c3b91d553ab14e64$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $c3b91d553ab14e64$var$_0n || k2 > $c3b91d553ab14e64$var$_0n){
                if (k1 & $c3b91d553ab14e64$var$_1n) k1p = k1p.add(d);
                if (k2 & $c3b91d553ab14e64$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $c3b91d553ab14e64$var$_1n;
                k2 >>= $c3b91d553ab14e64$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $c3b91d553ab14e64$var$_0n || a === $c3b91d553ab14e64$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $esaJO.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $lkFCe.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
$c3b91d553ab14e64$exports.weierstrassPoints = $c3b91d553ab14e64$var$weierstrassPoints;
function $c3b91d553ab14e64$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $c3b91d553ab14e64$var$weierstrass(curveDef) {
    const CURVE = $c3b91d553ab14e64$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $c3b91d553ab14e64$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $2D9sF.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $2D9sF.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $c3b91d553ab14e64$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $esaJO.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $esaJO.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $c3b91d553ab14e64$var$_1n) === $c3b91d553ab14e64$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$esaJO.bytesToHex($esaJO.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$esaJO.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $esaJO.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $c3b91d553ab14e64$exports.DER.toSig((0, $esaJO.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $esaJO.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $esaJO.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $c3b91d553ab14e64$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $esaJO.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $2D9sF.getMinHashLength(CURVE.n);
            return $2D9sF.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $esaJO.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $esaJO.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($c3b91d553ab14e64$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $esaJO.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $esaJO.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $esaJO.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $esaJO.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $esaJO.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $esaJO.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $c3b91d553ab14e64$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
$c3b91d553ab14e64$exports.weierstrass = $c3b91d553ab14e64$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
$c3b91d553ab14e64$exports.SWUFpSqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $c3b91d553ab14e64$var$mapToCurveSimpleSWU(Fp, opts) {
    $2D9sF.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
$c3b91d553ab14e64$exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$var$mapToCurveSimpleSWU;



var $esaJO = parcelRequire("esaJO");
var $0522aeca5769187c$exports = {};
"use strict";
Object.defineProperty($0522aeca5769187c$exports, "__esModule", {
    value: true
});
$0522aeca5769187c$exports.createHasher = $0522aeca5769187c$exports.isogenyMap = $0522aeca5769187c$exports.hash_to_field = $0522aeca5769187c$exports.expand_message_xof = $0522aeca5769187c$exports.expand_message_xmd = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
function $0522aeca5769187c$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $esaJO.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $esaJO.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $0522aeca5769187c$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $esaJO.concatBytes)((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $esaJO.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $esaJO.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $esaJO.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $esaJO.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $esaJO.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
$0522aeca5769187c$exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
$0522aeca5769187c$exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $esaJO.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isNum(count);
    const DST = $0522aeca5769187c$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
$0522aeca5769187c$exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
$0522aeca5769187c$exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
function $0522aeca5769187c$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
$0522aeca5769187c$exports.createHasher = $0522aeca5769187c$var$createHasher;


var $5af70d1c5fca3e4e$exports = {};
"use strict";
Object.defineProperty($5af70d1c5fca3e4e$exports, "__esModule", {
    value: true
});
$5af70d1c5fca3e4e$exports.createCurve = $5af70d1c5fca3e4e$exports.getHash = void 0;



// connects noble-curves to noble-hashes
function $5af70d1c5fca3e4e$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $51b6b372898f65c0$exports.hmac)(hash, key, (0, $29ee4d3171d9809b$exports.concatBytes)(...msgs)),
        randomBytes: $29ee4d3171d9809b$exports.randomBytes
    };
}
$5af70d1c5fca3e4e$exports.getHash = $5af70d1c5fca3e4e$var$getHash;
function $5af70d1c5fca3e4e$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $c3b91d553ab14e64$exports.weierstrass)({
            ...curveDef,
            ...$5af70d1c5fca3e4e$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
$5af70d1c5fca3e4e$exports.createCurve = $5af70d1c5fca3e4e$var$createCurve;


const $3f551179096121b9$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $3f551179096121b9$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $3f551179096121b9$var$_1n = BigInt(1);
const $3f551179096121b9$var$_2n = BigInt(2);
const $3f551179096121b9$var$divNearest = (a, b)=>(a + b / $3f551179096121b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fp.eql($3f551179096121b9$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $3f551179096121b9$var$Fp = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1P, undefined, undefined, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
$3f551179096121b9$exports.secp256k1 = (0, $5af70d1c5fca3e4e$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $3f551179096121b9$var$Fp,
    n: $3f551179096121b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $3f551179096121b9$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$3f551179096121b9$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $3f551179096121b9$var$divNearest(b2 * k, n);
            const c2 = $3f551179096121b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $2D9sF.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $2D9sF.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $510ad3657d73a9d2$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $3f551179096121b9$var$_0n = BigInt(0);
const $3f551179096121b9$var$fe = (x)=>typeof x === "bigint" && $3f551179096121b9$var$_0n < x && x < $3f551179096121b9$var$secp256k1P;
const $3f551179096121b9$var$ge = (x)=>typeof x === "bigint" && $3f551179096121b9$var$_0n < x && x < $3f551179096121b9$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $510ad3657d73a9d2$exports.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $esaJO.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $510ad3657d73a9d2$exports.sha256)((0, $esaJO.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $3f551179096121b9$var$numTo32b = (n)=>(0, $esaJO.numberToBytesBE)(n, 32);
const $3f551179096121b9$var$modP = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1P);
const $3f551179096121b9$var$modN = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1N);
const $3f551179096121b9$var$Point = $3f551179096121b9$exports.secp256k1.ProjectivePoint;
const $3f551179096121b9$var$GmulAdd = (Q, a, b)=>$3f551179096121b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    let d_ = $3f551179096121b9$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $3f551179096121b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $3f551179096121b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    if (!$3f551179096121b9$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $3f551179096121b9$var$modP(x * x);
    const c = $3f551179096121b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $3f551179096121b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $3f551179096121b9$var$_2n !== $3f551179096121b9$var$_0n) y = $3f551179096121b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $3f551179096121b9$var$Point(x, y, $3f551179096121b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$modN((0, $esaJO.bytesToNumberBE)($3f551179096121b9$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(privateKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, privateKey, auxRand = (0, $29ee4d3171d9809b$exports.randomBytes)(32)) {
    const m = (0, $esaJO.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $esaJO.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $3f551179096121b9$var$numTo32b(d ^ (0, $esaJO.bytesToNumberBE)($3f551179096121b9$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $3f551179096121b9$var$modN((0, $esaJO.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $3f551179096121b9$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($3f551179096121b9$var$numTo32b($3f551179096121b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $esaJO.ensureBytes)("signature", signature, 64);
    const m = (0, $esaJO.ensureBytes)("message", message);
    const pub = (0, $esaJO.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $3f551179096121b9$var$lift_x((0, $esaJO.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $esaJO.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$3f551179096121b9$var$fe(r)) return false;
        const s = (0, $esaJO.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$3f551179096121b9$var$ge(s)) return false;
        const e = $3f551179096121b9$var$challenge($3f551179096121b9$var$numTo32b(r), $3f551179096121b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $3f551179096121b9$var$GmulAdd(P, s, $3f551179096121b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$3f551179096121b9$exports.schnorr = (()=>({
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: $3f551179096121b9$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes,
            numberToBytesBE: $esaJO.numberToBytesBE,
            bytesToNumberBE: $esaJO.bytesToNumberBE,
            taggedHash: $3f551179096121b9$var$taggedHash,
            mod: $2D9sF.mod
        }
    }))();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $0522aeca5769187c$exports.isogenyMap)($3f551179096121b9$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $c3b91d553ab14e64$exports.mapToCurveSimpleSWU)($3f551179096121b9$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $3f551179096121b9$var$Fp.create(BigInt("-11"))
    }))();
const $3f551179096121b9$var$htf = /* @__PURE__ */ (()=>(0, $0522aeca5769187c$exports.createHasher)($3f551179096121b9$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fp.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $3f551179096121b9$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $510ad3657d73a9d2$exports.sha256
    }))();
$3f551179096121b9$exports.hashToCurve = (()=>$3f551179096121b9$var$htf.hashToCurve)();
$3f551179096121b9$exports.encodeToCurve = (()=>$3f551179096121b9$var$htf.encodeToCurve)();


/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 

const $6fa405e57bb6371e$var$BN_0 = BigInt(0);
const $6fa405e57bb6371e$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $6fa405e57bb6371e$var$maxValue = 0x1fffffffffffff;
function $6fa405e57bb6371e$export$92182edcfa20e5bc(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    (0, $634aa51198273feb$export$a7a9523472993e97)(value >> width === $6fa405e57bb6371e$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $6fa405e57bb6371e$var$BN_1) {
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return -((~value & mask) + $6fa405e57bb6371e$var$BN_1);
    }
    return value;
}
function $6fa405e57bb6371e$export$7101cd4e6275351c(_value, _width) {
    let value = $6fa405e57bb6371e$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    const limit = $6fa405e57bb6371e$var$BN_1 << width - $6fa405e57bb6371e$var$BN_1;
    if (value < $6fa405e57bb6371e$var$BN_0) {
        value = -value;
        (0, $634aa51198273feb$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return (~value & mask) + $6fa405e57bb6371e$var$BN_1;
    } else (0, $634aa51198273feb$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $6fa405e57bb6371e$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_bits, "bits"));
    return value & ($6fa405e57bb6371e$var$BN_1 << bits) - $6fa405e57bb6371e$var$BN_1;
}
function $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $6fa405e57bb6371e$export$8677d6ca9282a154(value, name) {
    const result = $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name);
    (0, $634aa51198273feb$export$a7a9523472993e97)(result >= $6fa405e57bb6371e$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $6fa405e57bb6371e$var$Nibbles = "0123456789abcdef";
function $6fa405e57bb6371e$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $6fa405e57bb6371e$var$Nibbles[v >> 4];
            result += $6fa405e57bb6371e$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $6fa405e57bb6371e$export$61fe455e2b1e28a4(value);
}
function $6fa405e57bb6371e$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $6fa405e57bb6371e$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $6fa405e57bb6371e$export$a0a81dc3380ce7d3(value) {
    return $6fa405e57bb6371e$export$b14f2714108df84($6fa405e57bb6371e$export$c221a145703ab783(value));
}
function $6fa405e57bb6371e$export$c6ebe05badb16181(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $6fa405e57bb6371e$export$b14f2714108df84(_width, "width");
        (0, $634aa51198273feb$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $6fa405e57bb6371e$export$b627fcfb5ea68cb0(_value) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    if (value === $6fa405e57bb6371e$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $6fa405e57bb6371e$export$d9c067986dbc68dd(value) {
    let result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$9a14abb1a440cd5e)(value) ? value : $6fa405e57bb6371e$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}


/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $dd46242704dbba3d$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";



// Constants
const $b48bc2308ad845a5$var$BN_0 = BigInt(0);
const $b48bc2308ad845a5$var$BN_1 = BigInt(1);
const $b48bc2308ad845a5$var$BN_2 = BigInt(2);
const $b48bc2308ad845a5$var$BN_27 = BigInt(27);
const $b48bc2308ad845a5$var$BN_28 = BigInt(28);
const $b48bc2308ad845a5$var$BN_35 = BigInt(35);
const $b48bc2308ad845a5$var$_guard = {};
function $b48bc2308ad845a5$var$toUint256(value) {
    return (0, $fd3872da8feed9cb$export$4473860254365feb)((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value), 32);
}
class $b48bc2308ad845a5$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(_value);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value, "value");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $b48bc2308ad845a5$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $b48bc2308ad845a5$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $b48bc2308ad845a5$var$BN_27 || bv == $b48bc2308ad845a5$var$BN_28) return $b48bc2308ad845a5$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bv >= $b48bc2308ad845a5$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $b48bc2308ad845a5$var$BN_35) / $b48bc2308ad845a5$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(chainId) * $b48bc2308ad845a5$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(v);
        if (bv === $b48bc2308ad845a5$var$BN_0 || bv === $b48bc2308ad845a5$var$BN_27) return 27;
        if (bv === $b48bc2308ad845a5$var$BN_1 || bv === $b48bc2308ad845a5$var$BN_28) return 28;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bv >= $b48bc2308ad845a5$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $b48bc2308ad845a5$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(check, message, "signature", sig);
        }
        if (sig == null) return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, (0, $dd46242704dbba3d$export$89c2533b29c23a61), (0, $dd46242704dbba3d$export$89c2533b29c23a61), 27);
        if (typeof sig === "string") {
            const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $b48bc2308ad845a5$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $b48bc2308ad845a5$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $b48bc2308ad845a5$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $b48bc2308ad845a5$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_v);
                return {
                    networkV: v >= $b48bc2308ad845a5$var$BN_35 ? v : undefined,
                    v: $b48bc2308ad845a5$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $6fa405e57bb6371e$export$b14f2714108df84)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $6fa405e57bb6371e$export$b14f2714108df84)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}


class $015cdebda6711d1b$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $3f551179096121b9$exports.secp256k1).sign((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(digest), (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#privateKey), {
            lowS: true
        });
        return (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from({
            r: (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(sig.r, 32),
            s: (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $3f551179096121b9$exports.secp256k1).getSharedSecret((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#privateKey), (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $3f551179096121b9$exports.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $3f551179096121b9$exports.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(signature);
        let secpSig = (0, $3f551179096121b9$exports.secp256k1).Signature.fromCompact((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(digest));
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $3f551179096121b9$exports.secp256k1).ProjectivePoint.fromHex($015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $3f551179096121b9$exports.secp256k1).ProjectivePoint.fromHex($015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}



/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $0c0373556082ea84$export$6a9f04c98a658ecb() {
    (0, $be13a0f2e0d9ad05$export$967075d2f3b8e7ff).lock();
    (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35).lock();
    (0, $9092348e8cf65603$export$448fa22aedc9dbca).lock();
    (0, $90bc03290273a6e1$export$5f828d93ff035aa8).lock();
    (0, $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e).lock();
    (0, $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3).lock();
    (0, $e794241b1cb9b0d3$export$86c79e0734c26a76).lock();
    (0, $c1049352abb4e7c6$export$bced8d2aada2d1c9).lock();
    (0, $c1049352abb4e7c6$export$a888d2532e6dc7bb).lock();
    (0, $90bc03290273a6e1$export$5f828d93ff035aa8).lock();
}



const $69ef3f917ff239a2$var$BN_0 = BigInt(0);
const $69ef3f917ff239a2$var$BN_36 = BigInt(36);
function $69ef3f917ff239a2$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $69ef3f917ff239a2$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$69ef3f917ff239a2$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$69ef3f917ff239a2$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $69ef3f917ff239a2$var$safeDigits = 15;
function $69ef3f917ff239a2$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $69ef3f917ff239a2$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $69ef3f917ff239a2$var$safeDigits){
        let block = expanded.substring(0, $69ef3f917ff239a2$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $69ef3f917ff239a2$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $69ef3f917ff239a2$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $69ef3f917ff239a2$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $69ef3f917ff239a2$var$BN_36 + $69ef3f917ff239a2$var$Base36[value[i]];
    return result;
}
function $69ef3f917ff239a2$export$88411125f012957a(address) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $69ef3f917ff239a2$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(address.substring(2, 4) === $69ef3f917ff239a2$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $69ef3f917ff239a2$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $69ef3f917ff239a2$var$getChecksumAddress("0x" + result);
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid address", "address", address);
}
function $69ef3f917ff239a2$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($69ef3f917ff239a2$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $69ef3f917ff239a2$var$ibanChecksum("XE00" + base36) + base36;
}



function $c254de3831dd58ea$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $69ef3f917ff239a2$export$88411125f012957a)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $c254de3831dd58ea$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $c254de3831dd58ea$var$accessSetify(set[0], set[1]);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $c254de3831dd58ea$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $c254de3831dd58ea$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}





const $86932e930ca5c8a5$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $86932e930ca5c8a5$export$10ae60faeb7e2196(this.name);
    }
}
class $86932e930ca5c8a5$export$f2b0810a2dd50377 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, props);
    }
    clone() {
        return new $86932e930ca5c8a5$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $86932e930ca5c8a5$export$9be0b2c573890879 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address || $86932e930ca5c8a5$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $86932e930ca5c8a5$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $86932e930ca5c8a5$export$dd49482b7e9ea2da extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $86932e930ca5c8a5$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $86932e930ca5c8a5$export$3bee30f9880d72e8 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 


/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $4945f77db30f37e3$var$Networks = new Map();
class $4945f77db30f37e3$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $4945f77db30f37e3$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $86932e930ca5c8a5$export$f2b0810a2dd50377)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $c254de3831dd58ea$export$6c8662b1600dce2)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $4945f77db30f37e3$var$injectCommonNetworks();
        // Default network
        if (network == null) return $4945f77db30f37e3$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $4945f77db30f37e3$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $4945f77db30f37e3$export$95be4ae94445245a("unknown", network);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $4945f77db30f37e3$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $86932e930ca5c8a5$export$9be0b2c573890879)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $4945f77db30f37e3$var$Networks.get(nameOrChainId);
        if (existing) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $4945f77db30f37e3$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $4945f77db30f37e3$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $4945f77db30f37e3$var$getGasStationPlugin(url) {
    return new (0, $86932e930ca5c8a5$export$3bee30f9880d72e8)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.fast;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $4945f77db30f37e3$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $4945f77db30f37e3$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $4945f77db30f37e3$var$injected = false;
function $4945f77db30f37e3$var$injectCommonNetworks() {
    if ($4945f77db30f37e3$var$injected) return;
    $4945f77db30f37e3$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $4945f77db30f37e3$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $86932e930ca5c8a5$export$9be0b2c573890879)(null, options.ensNetwork));
            network.attachPlugin(new (0, $86932e930ca5c8a5$export$f2b0810a2dd50377)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $4945f77db30f37e3$export$95be4ae94445245a.register(name, func);
        $4945f77db30f37e3$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $4945f77db30f37e3$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("linea-sepolia", 59141, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $4945f77db30f37e3$var$getGasStationPlugin("https://gas-station.cosmo.fans/v1/polygon-mainnet")
        ]
    });
    registerEth("matic-amoy", 80002, {});
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $4945f77db30f37e3$var$getGasStationPlugin("https://gas-station.cosmo.fans/v1/polygon-testnet")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}


/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI


const $6b2ae433bec33333$export$b4b1d1fba463e69c = 32;
const $6b2ae433bec33333$var$Padding = new Uint8Array($6b2ae433bec33333$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $6b2ae433bec33333$var$passProperties = [
    "then"
];
const $6b2ae433bec33333$var$_guard = {};
const $6b2ae433bec33333$var$resultNames = new WeakMap();
function $6b2ae433bec33333$var$getNames(result) {
    return $6b2ae433bec33333$var$resultNames.get(result);
}
function $6b2ae433bec33333$var$setNames(result, names) {
    $6b2ae433bec33333$var$resultNames.set(result, names);
}
function $6b2ae433bec33333$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
function $6b2ae433bec33333$var$toObject(names, items, deep) {
    if (names.indexOf(null) >= 0) return items.map((item, index)=>{
        if (item instanceof $6b2ae433bec33333$export$8fdcabde73f49165) return $6b2ae433bec33333$var$toObject($6b2ae433bec33333$var$getNames(item), item, deep);
        return item;
    });
    return names.reduce((accum, name, index)=>{
        let item = items.getValue(name);
        if (!(name in accum)) {
            if (deep && item instanceof $6b2ae433bec33333$export$8fdcabde73f49165) item = $6b2ae433bec33333$var$toObject($6b2ae433bec33333$var$getNames(item), item, deep);
            accum[name] = item;
        }
        return accum;
    }, {});
}
class $6b2ae433bec33333$export$8fdcabde73f49165 extends Array {
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $6b2ae433bec33333$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        $6b2ae433bec33333$var$setNames(this, Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        })));
        // Dummy operations to prevent TypeScript from complaining
        this.#names = [];
        if (this.#names == null) this.#names;
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        const proxy = new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $6fa405e57bb6371e$export$b14f2714108df84)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($6b2ae433bec33333$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
        $6b2ae433bec33333$var$setNames(proxy, $6b2ae433bec33333$var$getNames(this));
        return proxy;
    }
    /**
     *  Returns the Result as a normal Array. If %%deep%%, any children
     *  which are Result objects are also converted to a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray(deep) {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${index}`, item);
            if (deep && item instanceof $6b2ae433bec33333$export$8fdcabde73f49165) item = item.toArray(deep);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair. If
     *  %%deep%%, any children which are Result objects are also
     *  converted to an Object.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject(deep) {
        const names = $6b2ae433bec33333$var$getNames(this);
        return names.reduce((accum, name, index)=>{
            (0, $634aa51198273feb$export$a7a9523472993e97)(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            return $6b2ae433bec33333$var$toObject(names, this, deep);
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const _names = $6b2ae433bec33333$var$getNames(this);
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(_names[i]);
        }
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const _names = $6b2ae433bec33333$var$getNames(this);
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(_names[i]);
            }
        }
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = $6b2ae433bec33333$var$getNames(this).indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $6b2ae433bec33333$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, items, keys);
    }
}
function $6b2ae433bec33333$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $6b2ae433bec33333$var$getValue(value) {
    let bytes = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value);
    (0, $634aa51198273feb$export$a7a9523472993e97)(bytes.length <= $6b2ae433bec33333$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $6b2ae433bec33333$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $6b2ae433bec33333$export$b4b1d1fba463e69c) bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        $6b2ae433bec33333$var$Padding.slice(bytes.length % $6b2ae433bec33333$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $6b2ae433bec33333$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, message, this.localName, value);
    }
}
class $6b2ae433bec33333$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(value);
        const paddingOffset = bytes.length % $6b2ae433bec33333$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            bytes,
            $6b2ae433bec33333$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($6b2ae433bec33333$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($6b2ae433bec33333$var$Padding);
        this.#dataLength += $6b2ae433bec33333$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $6b2ae433bec33333$var$getValue(value);
        };
    }
}
class $6b2ae433bec33333$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $6b2ae433bec33333$export$b4b1d1fba463e69c) * $6b2ae433bec33333$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $634aa51198273feb$export$a7a9523472993e97)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $6b2ae433bec33333$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $6fa405e57bb6371e$export$c221a145703ab783)(this.readBytes($6b2ae433bec33333$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $6fa405e57bb6371e$export$a0a81dc3380ce7d3)(this.readBytes($6b2ae433bec33333$export$b4b1d1fba463e69c));
    }
}




/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
const $f832d0621d63460e$var$_gaurd = {};
function $f832d0621d63460e$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $f832d0621d63460e$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $f832d0621d63460e$var$_typedSymbol = Symbol.for("_ethers_typed");
class $f832d0621d63460e$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)($f832d0621d63460e$var$_gaurd, gaurd, "Typed");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            _typedSymbol: $f832d0621d63460e$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $f832d0621d63460e$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $f832d0621d63460e$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $f832d0621d63460e$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $f832d0621d63460e$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $f832d0621d63460e$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $f832d0621d63460e$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $f832d0621d63460e$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $f832d0621d63460e$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $f832d0621d63460e$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $f832d0621d63460e$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $f832d0621d63460e$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $f832d0621d63460e$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $f832d0621d63460e$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $f832d0621d63460e$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $f832d0621d63460e$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $f832d0621d63460e$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $f832d0621d63460e$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $f832d0621d63460e$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $f832d0621d63460e$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $f832d0621d63460e$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $f832d0621d63460e$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $f832d0621d63460e$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $f832d0621d63460e$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $f832d0621d63460e$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $f832d0621d63460e$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $f832d0621d63460e$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $f832d0621d63460e$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $f832d0621d63460e$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $f832d0621d63460e$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $f832d0621d63460e$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $f832d0621d63460e$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $f832d0621d63460e$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $f832d0621d63460e$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $f832d0621d63460e$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $f832d0621d63460e$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $f832d0621d63460e$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $f832d0621d63460e$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $f832d0621d63460e$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $f832d0621d63460e$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $f832d0621d63460e$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $f832d0621d63460e$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $f832d0621d63460e$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $f832d0621d63460e$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $f832d0621d63460e$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $f832d0621d63460e$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $f832d0621d63460e$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $f832d0621d63460e$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $f832d0621d63460e$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $f832d0621d63460e$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $f832d0621d63460e$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $f832d0621d63460e$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $f832d0621d63460e$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $f832d0621d63460e$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $f832d0621d63460e$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $f832d0621d63460e$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $f832d0621d63460e$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $f832d0621d63460e$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $f832d0621d63460e$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $f832d0621d63460e$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $f832d0621d63460e$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $f832d0621d63460e$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $f832d0621d63460e$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $f832d0621d63460e$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $f832d0621d63460e$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $f832d0621d63460e$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $f832d0621d63460e$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $f832d0621d63460e$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $f832d0621d63460e$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $f832d0621d63460e$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $f832d0621d63460e$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $f832d0621d63460e$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $f832d0621d63460e$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $f832d0621d63460e$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $f832d0621d63460e$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $f832d0621d63460e$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $f832d0621d63460e$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $f832d0621d63460e$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $f832d0621d63460e$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $f832d0621d63460e$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $f832d0621d63460e$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $f832d0621d63460e$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $f832d0621d63460e$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $f832d0621d63460e$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $f832d0621d63460e$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $f832d0621d63460e$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $f832d0621d63460e$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $f832d0621d63460e$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $f832d0621d63460e$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $f832d0621d63460e$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $f832d0621d63460e$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $f832d0621d63460e$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $f832d0621d63460e$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $f832d0621d63460e$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $f832d0621d63460e$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $f832d0621d63460e$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $f832d0621d63460e$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $f832d0621d63460e$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $f832d0621d63460e$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $f832d0621d63460e$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($f832d0621d63460e$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}



class $cfcca69ef482e07c$export$59dbbded7775bfe7 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "string");
        try {
            value = (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $6fa405e57bb6371e$export$c6ebe05badb16181)(reader.readValue(), 20));
    }
}






class $ad85f24c4bcad69a$export$87c41d1139a03fa2 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


function $ea15fb9331abacb9$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $634aa51198273feb$export$a7a9523472993e97)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $634aa51198273feb$export$a7a9523472993e97)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid tuple value", "tuple", values);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $6b2ae433bec33333$export$d7a960146e1a269e)();
    let dynamicWriter = new (0, $6b2ae433bec33333$export$d7a960146e1a269e)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $ea15fb9331abacb9$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $6b2ae433bec33333$export$8fdcabde73f49165).fromItems(values, keys);
}
class $ea15fb9331abacb9$export$88bc419d2df11f54 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $634aa51198273feb$export$d228410a8a77e4fa)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $ea15fb9331abacb9$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $634aa51198273feb$export$a7a9523472993e97)(count * (0, $6b2ae433bec33333$export$b4b1d1fba463e69c) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $6b2ae433bec33333$export$b4b1d1fba463e69c),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $ad85f24c4bcad69a$export$87c41d1139a03fa2)(this.coder));
        return $ea15fb9331abacb9$export$417857010dc9287f(reader, coders);
    }
}




class $8bb37f15c6403170$export$fe9118d6c093150c extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}




class $a77ec8c966f279c9$export$db9eadd8df12ad2e extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $a77ec8c966f279c9$export$e5823e9574df18d2 extends $a77ec8c966f279c9$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(super.decode(reader));
    }
}





class $dc246983eaa4ec58$export$7dec9db68e6bcf5a extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(reader.readBytes(this.size));
    }
}



const $720930767e786ee7$var$Empty = new Uint8Array([]);
class $720930767e786ee7$export$70982cadf2d6b4ec extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($720930767e786ee7$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}





const $0cff167f1e2d418f$var$BN_0 = BigInt(0);
const $0cff167f1e2d418f$var$BN_1 = BigInt(1);
const $0cff167f1e2d418f$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $0cff167f1e2d418f$export$b934dc8cfe13938c extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)((0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)($0cff167f1e2d418f$var$BN_MAX_UINT256, (0, $6b2ae433bec33333$export$b4b1d1fba463e69c) * 8);
        if (this.signed) {
            let bounds = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $0cff167f1e2d418f$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $6fa405e57bb6371e$export$7101cd4e6275351c)(value, 8 * (0, $6b2ae433bec33333$export$b4b1d1fba463e69c));
        } else if (value < $0cff167f1e2d418f$var$BN_0 || value > (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $6fa405e57bb6371e$export$92182edcfa20e5bc)(value, this.size * 8);
        return value;
    }
}





class $b65d6b3f7161a036$export$2d1b854518731426 extends (0, $a77ec8c966f279c9$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $50aa15ceb128a952$export$8feeb310b4b4752f)((0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}






class $80973df8073baca7$export$e9fceba8f110fea6 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "tuple");
        return (0, $ea15fb9331abacb9$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $ea15fb9331abacb9$export$417857010dc9287f)(reader, this.coders);
    }
}


/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 


function $697215a61e1ccd96$export$d560c7e4a29451c2(value) {
    return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $50aa15ceb128a952$export$8feeb310b4b4752f)(value));
}


// [ "a", "b" ] => { "a": 1, "b": 1 }
function $7316d9256af52303$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $7316d9256af52303$var$_kwVisibDeploy = "external public payable override";
const $7316d9256af52303$var$KwVisibDeploy = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $7316d9256af52303$var$_kwVisib = "constant external internal payable private public pure view override";
const $7316d9256af52303$var$KwVisib = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisib.split(" "));
const $7316d9256af52303$var$_kwTypes = "constructor error event fallback function receive struct";
const $7316d9256af52303$var$KwTypes = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwTypes.split(" "));
const $7316d9256af52303$var$_kwModifiers = "calldata memory storage payable indexed";
const $7316d9256af52303$var$KwModifiers = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwModifiers.split(" "));
const $7316d9256af52303$var$_kwOther = "tuple returns";
// All Keywords
const $7316d9256af52303$var$_keywords = [
    $7316d9256af52303$var$_kwTypes,
    $7316d9256af52303$var$_kwModifiers,
    $7316d9256af52303$var$_kwOther,
    $7316d9256af52303$var$_kwVisib
].join(" ");
const $7316d9256af52303$var$Keywords = $7316d9256af52303$var$setify($7316d9256af52303$var$_keywords.split(" "));
// Single character tokens
const $7316d9256af52303$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $7316d9256af52303$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $7316d9256af52303$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $7316d9256af52303$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $7316d9256af52303$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $7316d9256af52303$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $7316d9256af52303$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $7316d9256af52303$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $7316d9256af52303$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $7316d9256af52303$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($7316d9256af52303$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $7316d9256af52303$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($7316d9256af52303$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($7316d9256af52303$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $7316d9256af52303$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $7316d9256af52303$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $7316d9256af52303$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($7316d9256af52303$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $7316d9256af52303$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $7316d9256af52303$var$consumeMutability(tokens) {
    let modifiers = $7316d9256af52303$var$consumeKeywords(tokens, $7316d9256af52303$var$KwVisib);
    // Detect conflicting modifiers
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("constant payable nonpayable".split(" ")));
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $7316d9256af52303$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $7316d9256af52303$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $7316d9256af52303$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $7316d9256af52303$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $7316d9256af52303$var$verifyBasicType(type) {
    const match = type.match($7316d9256af52303$var$regexType);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $7316d9256af52303$var$_guard = {};
const $7316d9256af52303$var$internal = Symbol.for("_ethers_internal");
const $7316d9256af52303$var$ParamTypeInternal = "_ParamTypeInternal";
const $7316d9256af52303$var$ErrorFragmentInternal = "_ErrorInternal";
const $7316d9256af52303$var$EventFragmentInternal = "_EventInternal";
const $7316d9256af52303$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $7316d9256af52303$var$FallbackFragmentInternal = "_FallbackInternal";
const $7316d9256af52303$var$FunctionFragmentInternal = "_FunctionInternal";
const $7316d9256af52303$var$StructFragmentInternal = "_StructInternal";
class $7316d9256af52303$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $7316d9256af52303$var$_guard, "ParamType");
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($7316d9256af52303$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$426dc07f493a4c47.from($7316d9256af52303$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $7316d9256af52303$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($7316d9256af52303$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $7316d9256af52303$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$7316d9256af52303$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $7316d9256af52303$var$verifyBasicType(obj.type);
        return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ParamTypeInternal;
    }
}
class $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $7316d9256af52303$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $7316d9256af52303$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $7316d9256af52303$export$ffb0004e005737fa.from($7316d9256af52303$var$lex(obj));
        }
        if (obj instanceof $7316d9256af52303$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($7316d9256af52303$var$KwTypes);
            switch(type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $7316d9256af52303$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $7316d9256af52303$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $7316d9256af52303$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $7316d9256af52303$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $7316d9256af52303$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $7316d9256af52303$export$85c6fc53d6299173 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $7316d9256af52303$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $7316d9256af52303$export$2c42c6d543aa9b59 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $7316d9256af52303$export$2c42c6d543aa9b59.from($7316d9256af52303$var$lex(obj));
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("error", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ErrorFragmentInternal;
    }
}
class $7316d9256af52303$export$958548f08bac2833 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$EventFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$958548f08bac2833.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("event", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj, true);
            const anonymous = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "anonymous"
            ])).has("anonymous");
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, inputs, anonymous);
        }
        return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$EventFragmentInternal;
    }
}
class $7316d9256af52303$export$3ac5c9504f801ea4 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ConstructorFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$7316d9256af52303$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$3ac5c9504f801ea4.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "constructor"
            ]));
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const payable = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwVisibDeploy).has("payable");
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ConstructorFragmentInternal;
    }
}
class $7316d9256af52303$export$71b1ea64c89c20fc extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FallbackFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$71b1ea64c89c20fc.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                    "payable"
                ]));
                $7316d9256af52303$var$consumeEoi(obj);
                return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $7316d9256af52303$var$consumeParams(obj);
            if (inputs.length) (0, $634aa51198273feb$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, payable);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FallbackFragmentInternal;
    }
}
class $7316d9256af52303$export$8d576c928b93668f extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($7316d9256af52303$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$8d576c928b93668f.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("function", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            let outputs = [];
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) outputs = $7316d9256af52303$var$consumeParams(obj);
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FunctionFragmentInternal;
    }
}
class $7316d9256af52303$export$9f91ba10bb234ec7 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$9f91ba10bb234ec7.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("struct", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$StructFragmentInternal;
    }
}



// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $816d2d9d4a0a65b4$var$PanicReasons = new Map();
$816d2d9d4a0a65b4$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x11, "OVERFLOW");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $816d2d9d4a0a65b4$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $816d2d9d4a0a65b4$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $816d2d9d4a0a65b4$var$defaultCoder = null;
let $816d2d9d4a0a65b4$var$defaultMaxInflation = 1024;
function $816d2d9d4a0a65b4$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data);
        data = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$816d2d9d4a0a65b4$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.from);
    return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $816d2d9d4a0a65b4$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $ea15fb9331abacb9$export$88bc419d2df11f54)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $80973df8073baca7$export$e9fceba8f110fea6)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $cfcca69ef482e07c$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $8bb37f15c6403170$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $b65d6b3f7161a036$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $a77ec8c966f279c9$export$e5823e9574df18d2)(param.name);
            case "":
                return new (0, $720930767e786ee7$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($816d2d9d4a0a65b4$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $0cff167f1e2d418f$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($816d2d9d4a0a65b4$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $dc246983eaa4ec58$export$7dec9db68e6bcf5a)(size, param.name);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $7316d9256af52303$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $80973df8073baca7$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $634aa51198273feb$export$d228410a8a77e4fa)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $7316d9256af52303$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $80973df8073baca7$export$e9fceba8f110fea6)(coders, "_");
        const writer = new (0, $6b2ae433bec33333$export$d7a960146e1a269e)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $7316d9256af52303$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $80973df8073baca7$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(new (0, $6b2ae433bec33333$export$2f7a2f0e90c07dc4)(data, loose, $816d2d9d4a0a65b4$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $816d2d9d4a0a65b4$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($816d2d9d4a0a65b4$var$defaultCoder == null) $816d2d9d4a0a65b4$var$defaultCoder = new $816d2d9d4a0a65b4$export$fe041e1a83d3efc6();
        return $816d2d9d4a0a65b4$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $816d2d9d4a0a65b4$var$getBuiltinCallException(action, tx, data, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}




function $ed11119eb2f9aa0c$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $ed11119eb2f9aa0c$export$977e255126d763d6(value) {
    try {
        (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $ed11119eb2f9aa0c$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $634aa51198273feb$export$a7a9523472993e97)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $69ef3f917ff239a2$export$88411125f012957a)(result);
}
function $ed11119eb2f9aa0c$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $69ef3f917ff239a2$export$88411125f012957a)(target);
        (0, $634aa51198273feb$export$a7a9523472993e97)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $ed11119eb2f9aa0c$var$checkAddress(target, resolver.resolveName(target));
    } else if ($ed11119eb2f9aa0c$export$6a88e03bca5eb759(target)) return $ed11119eb2f9aa0c$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $ed11119eb2f9aa0c$var$checkAddress(target, target);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported addressable value", "target", target);
}


//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";




function $e25c0939af0d847b$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $015cdebda6711d1b$export$21643ca94aed3e83).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)("0x" + pubkey.substring(4)).substring(26));
}
function $e25c0939af0d847b$export$23cc18f96d8510e2(digest, signature) {
    return $e25c0939af0d847b$export$e67e2732ba9803f9((0, $015cdebda6711d1b$export$21643ca94aed3e83).recoverPublicKey(digest, signature));
}




const $23f01ceb797ea4ad$var$padding = new Uint8Array(32);
$23f01ceb797ea4ad$var$padding.fill(0);
const $23f01ceb797ea4ad$var$BN__1 = BigInt(-1);
const $23f01ceb797ea4ad$var$BN_0 = BigInt(0);
const $23f01ceb797ea4ad$var$BN_1 = BigInt(1);
const $23f01ceb797ea4ad$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $23f01ceb797ea4ad$var$hexPadRight(value) {
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        bytes,
        $23f01ceb797ea4ad$var$padding.slice(padOffset)
    ]);
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
}
const $23f01ceb797ea4ad$var$hexTrue = (0, $6fa405e57bb6371e$export$c6ebe05badb16181)($23f01ceb797ea4ad$var$BN_1, 32);
const $23f01ceb797ea4ad$var$hexFalse = (0, $6fa405e57bb6371e$export$c6ebe05badb16181)($23f01ceb797ea4ad$var$BN_0, 32);
const $23f01ceb797ea4ad$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $23f01ceb797ea4ad$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $23f01ceb797ea4ad$var$checkString(key) {
    return function(value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $23f01ceb797ea4ad$var$domainChecks = {
    name: $23f01ceb797ea4ad$var$checkString("name"),
    version: $23f01ceb797ea4ad$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "domain.chainId");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $69ef3f917ff239a2$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value, "domain.salt");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
    }
};
function $23f01ceb797ea4ad$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)($23f01ceb797ea4ad$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $23f01ceb797ea4ad$var$BN_1) * $23f01ceb797ea4ad$var$BN__1 : $23f01ceb797ea4ad$var$BN_0;
            return function(_value) {
                const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "value");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(signed ? (0, $6fa405e57bb6371e$export$7101cd4e6275351c)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $23f01ceb797ea4ad$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $fd3872da8feed9cb$export$4473860254365feb)((0, $69ef3f917ff239a2$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $23f01ceb797ea4ad$var$hexFalse : $23f01ceb797ea4ad$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $23f01ceb797ea4ad$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $23f01ceb797ea4ad$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $23f01ceb797ea4ad$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $23f01ceb797ea4ad$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $23f01ceb797ea4ad$var$splitArray(field.type).base;
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $23f01ceb797ea4ad$var$encodeType(name, types[name]) + st.map((t)=>$23f01ceb797ea4ad$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $23f01ceb797ea4ad$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35));
                return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(values);
            };
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $23f01ceb797ea4ad$var$splitArray(type).array;
        if (array) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $23f01ceb797ea4ad$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $23f01ceb797ea4ad$var$domainFieldTypes[name];
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $23f01ceb797ea4ad$var$domainFieldNames.indexOf(a.name) - $23f01ceb797ea4ad$var$domainFieldNames.indexOf(b.name);
        });
        return $23f01ceb797ea4ad$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            "0x1901",
            $23f01ceb797ea4ad$export$458ab927ae635c3.hashDomain(domain),
            $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)($23f01ceb797ea4ad$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $23f01ceb797ea4ad$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $23f01ceb797ea4ad$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $23f01ceb797ea4ad$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $23f01ceb797ea4ad$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $23f01ceb797ea4ad$var$domainFieldTypes[name]
            });
        });
        const encoder = $23f01ceb797ea4ad$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $23f01ceb797ea4ad$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $e25c0939af0d847b$export$23cc18f96d8510e2)($23f01ceb797ea4ad$export$458ab927ae635c3.hash(domain, types, value), signature);
}




/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $5b8e64dd3cc782dc$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";


/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ 






class $fcb356ece91f4842$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $fcb356ece91f4842$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $fcb356ece91f4842$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $fcb356ece91f4842$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $fcb356ece91f4842$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $fcb356ece91f4842$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $fcb356ece91f4842$var$PanicReasons[code.toString()]) reason = $fcb356ece91f4842$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $fcb356ece91f4842$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $7316d9256af52303$export$ffb0004e005737fa).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            deploy: (0, $7316d9256af52303$export$3ac5c9504f801ea4).from("constructor()")
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $f832d0621d63460e$export$af51273277efe223).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $f832d0621d63460e$export$af51273277efe223).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $7316d9256af52303$export$8d576c928b93668f).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $f832d0621d63460e$export$af51273277efe223).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $7316d9256af52303$export$958548f08bac2833).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            if ($fcb356ece91f4842$var$BuiltinErrors[selector]) return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from($fcb356ece91f4842$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Error(string)");
                if (key === "Panic") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $7316d9256af52303$export$2c42c6d543aa9b59).from(key).format();
        if (key === "Error(string)") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, message, "BAD_DATA", {
            value: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
        const error = (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $fd3872da8feed9cb$export$1dc7fbe1b8738fe7)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $fd3872da8feed9cb$export$4473860254365feb)((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $697215a61e1ccd96$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $7316d9256af52303$export$426dc07f493a4c47).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $fcb356ece91f4842$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $fcb356ece91f4842$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $6b2ae433bec33333$export$8fdcabde73f49165).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(tx.data, "tx.data");
        const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $fcb356ece91f4842$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $fcb356ece91f4842$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data);
        const fragment = this.getError((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(hexData, 4));
        return new $fcb356ece91f4842$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $fcb356ece91f4842$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $fcb356ece91f4842$export$48cefb51a4e315b2(JSON.parse(value));
        // An Interface; possibly from another v6 instance
        if (typeof value.formatJson === "function") return new $fcb356ece91f4842$export$48cefb51a4e315b2(value.formatJson());
        // A legacy Interface; from an older version
        if (typeof value.format === "function") return new $fcb356ece91f4842$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $fcb356ece91f4842$export$48cefb51a4e315b2(value);
    }
}



//import { resolveAddress } from "@ethersproject/address";


const $425e3311db5fb4d1$var$BN_0 = BigInt(0);
// -----------------------
function $425e3311db5fb4d1$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $425e3311db5fb4d1$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $425e3311db5fb4d1$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            gasPrice: $425e3311db5fb4d1$var$getValue(gasPrice),
            maxFeePerGas: $425e3311db5fb4d1$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $425e3311db5fb4d1$var$toJson(gasPrice),
            maxFeePerGas: $425e3311db5fb4d1$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $425e3311db5fb4d1$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $6fa405e57bb6371e$export$b14f2714108df84)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $c254de3831dd58ea$export$6c8662b1600dce2)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    if ("blobVersionedHashes" in req && req.blobVersionedHashes) result.blobVersionedHashes = req.blobVersionedHashes.slice();
    if ("kzg" in req) result.kzg = req.kzg;
    if ("blobs" in req && req.blobs) result.blobs = req.blobs.map((b)=>{
        if ((0, $fd3872da8feed9cb$export$9a14abb1a440cd5e)(b)) return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(b);
        return Object.assign({}, b);
    });
    return result;
}
class $425e3311db5fb4d1$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */ prevRandao;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $425e3311db5fb4d1$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            hash: $425e3311db5fb4d1$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            prevRandao: $425e3311db5fb4d1$var$getValue(block.prevRandao),
            extraData: block.extraData,
            baseFeePerGas: $425e3311db5fb4d1$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $634aa51198273feb$export$a7a9523472993e97)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, prevRandao: prevRandao, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $425e3311db5fb4d1$var$toJson(baseFeePerGas),
            difficulty: $425e3311db5fb4d1$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $425e3311db5fb4d1$var$toJson(gasLimit),
            gasUsed: $425e3311db5fb4d1$var$toJson(gasUsed),
            blobGasUsed: $425e3311db5fb4d1$var$toJson(this.blobGasUsed),
            excessBlobGas: $425e3311db5fb4d1$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            prevRandao: prevRandao,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $425e3311db5fb4d1$var$createOrphanedBlockFilter(this);
    }
}
class $425e3311db5fb4d1$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $634aa51198273feb$export$a7a9523472993e97)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $634aa51198273feb$export$a7a9523472993e97)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $634aa51198273feb$export$a7a9523472993e97)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $425e3311db5fb4d1$var$createRemovedLogFilter(this);
    }
}
class $425e3311db5fb4d1$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $425e3311db5fb4d1$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $425e3311db5fb4d1$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $425e3311db5fb4d1$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $425e3311db5fb4d1$var$toJson(this.gasPrice),
            blobGasUsed: $425e3311db5fb4d1$var$toJson(this.blobGasUsed),
            blobGasPrice: $425e3311db5fb4d1$var$toJson(this.blobGasPrice),
            gasUsed: $425e3311db5fb4d1$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $425e3311db5fb4d1$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $425e3311db5fb4d1$var$createReorderedTransactionFilter(this, other);
    }
}
class $425e3311db5fb4d1$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $425e3311db5fb4d1$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $425e3311db5fb4d1$var$toJson(this.gasLimit),
            gasPrice: $425e3311db5fb4d1$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $425e3311db5fb4d1$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $425e3311db5fb4d1$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $425e3311db5fb4d1$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $425e3311db5fb4d1$var$BN_0) reason = "cancelled";
                        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $425e3311db5fb4d1$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $634aa51198273feb$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $425e3311db5fb4d1$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $425e3311db5fb4d1$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $425e3311db5fb4d1$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $425e3311db5fb4d1$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $425e3311db5fb4d1$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $425e3311db5fb4d1$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}



// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
class $62d6becaa0dab02c$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}


class $0ab0dbf63d0f506e$export$f8203d08df5cd081 extends (0, $425e3311db5fb4d1$export$ce30dbb46644d06c) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $0ab0dbf63d0f506e$export$53f6e6acc02bf489 extends (0, $425e3311db5fb4d1$export$ce30dbb46644d06c) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            error: error
        });
    }
}
class $0ab0dbf63d0f506e$export$86bdc83e93503686 extends (0, $425e3311db5fb4d1$export$375ffd5683aa5c1c) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $0ab0dbf63d0f506e$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $0ab0dbf63d0f506e$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $0ab0dbf63d0f506e$export$853f7e2df34220ff extends (0, $425e3311db5fb4d1$export$70966cdb3bfc0785) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $0ab0dbf63d0f506e$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $0ab0dbf63d0f506e$export$54be5ec94ad26a69 extends (0, $62d6becaa0dab02c$export$9cec82196983b278) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $0ab0dbf63d0f506e$export$35f9272dc1c07dee extends $0ab0dbf63d0f506e$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $0ab0dbf63d0f506e$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}


const $0e40c93799a724b3$var$BN_0 = BigInt(0);
function $0e40c93799a724b3$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $0e40c93799a724b3$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $0e40c93799a724b3$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $0e40c93799a724b3$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $0e40c93799a724b3$var$getResolver(value) {
    if (value != null) {
        if ($0e40c93799a724b3$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $0e40c93799a724b3$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "resolveName");
        const resolver = $0e40c93799a724b3$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(v, resolver)));
                        return (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $0e40c93799a724b3$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $0e40c93799a724b3$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $0e40c93799a724b3$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $f832d0621d63460e$export$af51273277efe223).dereference(arg, "overrides");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(_overrides);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $0e40c93799a724b3$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $0e40c93799a724b3$var$getRunner(_runner, "resolveName");
    const resolver = $0e40c93799a724b3$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(value, type);
            if (type === "address") return (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(value, resolver);
            return value;
        });
    }));
}
function $0e40c93799a724b3$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $0e40c93799a724b3$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(tx.from, $0e40c93799a724b3$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.value || $0e40c93799a724b3$var$BN_0, "overrides.value") === $0e40c93799a724b3$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "call");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $634aa51198273feb$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $0ab0dbf63d0f506e$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "estimateGas");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $0e40c93799a724b3$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $0e40c93799a724b3$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(overrides.from, $0e40c93799a724b3$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $0e40c93799a724b3$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $0ab0dbf63d0f506e$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "estimateGas");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "call");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $634aa51198273feb$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $0e40c93799a724b3$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $0e40c93799a724b3$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $0e40c93799a724b3$var$internal = Symbol.for("_ethersInternal_contract");
const $0e40c93799a724b3$var$internalValues = new WeakMap();
function $0e40c93799a724b3$var$setInternal(contract, values) {
    $0e40c93799a724b3$var$internalValues.set(contract[$0e40c93799a724b3$var$internal], values);
}
function $0e40c93799a724b3$var$getInternal(contract) {
    return $0e40c93799a724b3$var$internalValues.get(contract[$0e40c93799a724b3$var$internal]);
}
function $0e40c93799a724b3$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $0e40c93799a724b3$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($0e40c93799a724b3$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $0e40c93799a724b3$var$hasSub(contract, event) {
    const { subs: subs } = $0e40c93799a724b3$var$getInternal(contract);
    return subs.get((await $0e40c93799a724b3$var$getSubInfo(contract, event)).tag) || null;
}
async function $0e40c93799a724b3$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
    (0, $634aa51198273feb$export$a7a9523472993e97)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $0e40c93799a724b3$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $0e40c93799a724b3$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $0e40c93799a724b3$var$emit(contract, event, args, (listener)=>{
                    return new (0, $0ab0dbf63d0f506e$export$35f9272dc1c07dee)(contract, listener, event, _foundFragment, log);
                });
            } else $0e40c93799a724b3$var$emit(contract, event, [], (listener)=>{
                return new (0, $0ab0dbf63d0f506e$export$54be5ec94ad26a69)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $0e40c93799a724b3$var$lastEmit = Promise.resolve();
async function $0e40c93799a724b3$var$_emit(contract, event, args, payloadFunc) {
    await $0e40c93799a724b3$var$lastEmit;
    const sub = await $0e40c93799a724b3$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $0e40c93799a724b3$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $0e40c93799a724b3$var$emit(contract, event, args, payloadFunc) {
    try {
        await $0e40c93799a724b3$var$lastEmit;
    } catch (error) {}
    const resultPromise = $0e40c93799a724b3$var$_emit(contract, event, args, payloadFunc);
    $0e40c93799a724b3$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $0e40c93799a724b3$var$passProperties = [
    "then"
];
class $0e40c93799a724b3$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$0e40c93799a724b3$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof target === "string" || (0, $ed11119eb2f9aa0c$export$6a88e03bca5eb759)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $fcb356ece91f4842$export$48cefb51a4e315b2).from(abi);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $0e40c93799a724b3$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $0e40c93799a724b3$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $0ab0dbf63d0f506e$export$853f7e2df34220ff)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $0e40c93799a724b3$var$getRunner(runner, "resolveName");
                if (!$0e40c93799a724b3$var$canResolve(resolver)) throw (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $0e40c93799a724b3$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $0e40c93799a724b3$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $0e40c93799a724b3$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            filters: filters
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fallback: iface.receive || iface.fallback ? $0e40c93799a724b3$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $0e40c93799a724b3$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $0e40c93799a724b3$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $0e40c93799a724b3$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $634aa51198273feb$export$a7a9523472993e97)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $634aa51198273feb$export$a7a9523472993e97)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $0e40c93799a724b3$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $0e40c93799a724b3$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $0e40c93799a724b3$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $0e40c93799a724b3$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $0e40c93799a724b3$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $634aa51198273feb$export$a7a9523472993e97)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $0ab0dbf63d0f506e$export$f8203d08df5cd081)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $0ab0dbf63d0f506e$export$53f6e6acc02bf489)(log, error);
            }
            return new (0, $425e3311db5fb4d1$export$ce30dbb46644d06c)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $0e40c93799a724b3$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $0e40c93799a724b3$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $0e40c93799a724b3$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $0e40c93799a724b3$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $0e40c93799a724b3$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $0e40c93799a724b3$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $0e40c93799a724b3$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $0e40c93799a724b3$var$_ContractBase() {
    return $0e40c93799a724b3$export$304faa4fc17528db;
}
class $0e40c93799a724b3$export$8517d80acf00e19a extends $0e40c93799a724b3$var$_ContractBase() {
}




// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $e006ee16d99d0706$var$COMPRESSED$1 = "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";
const $e006ee16d99d0706$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $e006ee16d99d0706$var$NSM_MAX = 4;
function $e006ee16d99d0706$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $e006ee16d99d0706$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $e006ee16d99d0706$var$read_compressed_payload(s) {
    return $e006ee16d99d0706$var$read_payload($e006ee16d99d0706$var$decode_arithmetic($e006ee16d99d0706$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $e006ee16d99d0706$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $e006ee16d99d0706$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $e006ee16d99d0706$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $e006ee16d99d0706$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $e006ee16d99d0706$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $e006ee16d99d0706$var$read_sorted_arrays(next) {
    return $e006ee16d99d0706$var$read_array_while(()=>{
        let v = $e006ee16d99d0706$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $e006ee16d99d0706$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($e006ee16d99d0706$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($e006ee16d99d0706$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $e006ee16d99d0706$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $e006ee16d99d0706$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$e006ee16d99d0706$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $e006ee16d99d0706$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $e006ee16d99d0706$var$read_array_while(next);
    let m = $e006ee16d99d0706$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $e006ee16d99d0706$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $e006ee16d99d0706$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $e006ee16d99d0706$var$read_trie(next) {
    let ret = [];
    let sorted = $e006ee16d99d0706$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $e006ee16d99d0706$var$read_array_while(()=>{
            let cps = $e006ee16d99d0706$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $e006ee16d99d0706$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $e006ee16d99d0706$var$quote_cp(cp) {
    return `{${$e006ee16d99d0706$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $e006ee16d99d0706$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $e006ee16d99d0706$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $e006ee16d99d0706$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $e006ee16d99d0706$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $e006ee16d99d0706$var$S0 = 0xAC00;
const $e006ee16d99d0706$var$L0 = 0x1100;
const $e006ee16d99d0706$var$V0 = 0x1161;
const $e006ee16d99d0706$var$T0 = 0x11A7;
const $e006ee16d99d0706$var$L_COUNT = 19;
const $e006ee16d99d0706$var$V_COUNT = 21;
const $e006ee16d99d0706$var$T_COUNT = 28;
const $e006ee16d99d0706$var$N_COUNT = $e006ee16d99d0706$var$V_COUNT * $e006ee16d99d0706$var$T_COUNT;
const $e006ee16d99d0706$var$S_COUNT = $e006ee16d99d0706$var$L_COUNT * $e006ee16d99d0706$var$N_COUNT;
const $e006ee16d99d0706$var$S1 = $e006ee16d99d0706$var$S0 + $e006ee16d99d0706$var$S_COUNT;
const $e006ee16d99d0706$var$L1 = $e006ee16d99d0706$var$L0 + $e006ee16d99d0706$var$L_COUNT;
const $e006ee16d99d0706$var$V1 = $e006ee16d99d0706$var$V0 + $e006ee16d99d0706$var$V_COUNT;
const $e006ee16d99d0706$var$T1 = $e006ee16d99d0706$var$T0 + $e006ee16d99d0706$var$T_COUNT;
function $e006ee16d99d0706$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $e006ee16d99d0706$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $e006ee16d99d0706$var$SHIFTED_RANK, $e006ee16d99d0706$var$EXCLUSIONS, $e006ee16d99d0706$var$DECOMP, $e006ee16d99d0706$var$RECOMP;
function $e006ee16d99d0706$var$init$1() {
    //console.time('nf');
    let r = $e006ee16d99d0706$var$read_compressed_payload($e006ee16d99d0706$var$COMPRESSED);
    $e006ee16d99d0706$var$SHIFTED_RANK = new Map($e006ee16d99d0706$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $e006ee16d99d0706$var$EXCLUSIONS = new Set($e006ee16d99d0706$var$read_sorted(r));
    $e006ee16d99d0706$var$DECOMP = new Map();
    $e006ee16d99d0706$var$RECOMP = new Map();
    for (let [cp, cps] of $e006ee16d99d0706$var$read_mapped(r)){
        if (!$e006ee16d99d0706$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $e006ee16d99d0706$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $e006ee16d99d0706$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $e006ee16d99d0706$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $e006ee16d99d0706$var$is_hangul(cp) {
    return cp >= $e006ee16d99d0706$var$S0 && cp < $e006ee16d99d0706$var$S1;
}
function $e006ee16d99d0706$var$compose_pair(a, b) {
    if (a >= $e006ee16d99d0706$var$L0 && a < $e006ee16d99d0706$var$L1 && b >= $e006ee16d99d0706$var$V0 && b < $e006ee16d99d0706$var$V1) return $e006ee16d99d0706$var$S0 + (a - $e006ee16d99d0706$var$L0) * $e006ee16d99d0706$var$N_COUNT + (b - $e006ee16d99d0706$var$V0) * $e006ee16d99d0706$var$T_COUNT;
    else if ($e006ee16d99d0706$var$is_hangul(a) && b > $e006ee16d99d0706$var$T0 && b < $e006ee16d99d0706$var$T1 && (a - $e006ee16d99d0706$var$S0) % $e006ee16d99d0706$var$T_COUNT == 0) return a + (b - $e006ee16d99d0706$var$T0);
    else {
        let recomp = $e006ee16d99d0706$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $e006ee16d99d0706$var$decomposed(cps) {
    if (!$e006ee16d99d0706$var$SHIFTED_RANK) $e006ee16d99d0706$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $e006ee16d99d0706$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($e006ee16d99d0706$var$is_hangul(cp)) {
            let s_index = cp - $e006ee16d99d0706$var$S0;
            let l_index = s_index / $e006ee16d99d0706$var$N_COUNT | 0;
            let v_index = s_index % $e006ee16d99d0706$var$N_COUNT / $e006ee16d99d0706$var$T_COUNT | 0;
            let t_index = s_index % $e006ee16d99d0706$var$T_COUNT;
            add($e006ee16d99d0706$var$L0 + l_index);
            add($e006ee16d99d0706$var$V0 + v_index);
            if (t_index > 0) add($e006ee16d99d0706$var$T0 + t_index);
        } else {
            let mapped = $e006ee16d99d0706$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $e006ee16d99d0706$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $e006ee16d99d0706$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $e006ee16d99d0706$var$unpack_cc(packed);
        let cp = $e006ee16d99d0706$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $e006ee16d99d0706$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $e006ee16d99d0706$export$9d0d896b286a3dba(cps) {
    return $e006ee16d99d0706$var$decomposed(cps).map($e006ee16d99d0706$var$unpack_cp);
}
function $e006ee16d99d0706$export$f42252642e08449(cps) {
    return $e006ee16d99d0706$var$composed_from_decomposed($e006ee16d99d0706$var$decomposed(cps));
}
const $e006ee16d99d0706$var$HYPHEN = 0x2D;
const $e006ee16d99d0706$var$STOP = 0x2E;
const $e006ee16d99d0706$var$STOP_CH = ".";
const $e006ee16d99d0706$var$FE0F = 0xFE0F;
const $e006ee16d99d0706$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $e006ee16d99d0706$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $e006ee16d99d0706$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $e006ee16d99d0706$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $e006ee16d99d0706$var$MAPPED, $e006ee16d99d0706$var$IGNORED, $e006ee16d99d0706$var$CM, $e006ee16d99d0706$var$NSM, $e006ee16d99d0706$var$ESCAPE, $e006ee16d99d0706$var$NFC_CHECK, $e006ee16d99d0706$var$GROUPS, $e006ee16d99d0706$var$WHOLE_VALID, $e006ee16d99d0706$var$WHOLE_MAP, $e006ee16d99d0706$var$VALID, $e006ee16d99d0706$var$EMOJI_LIST, $e006ee16d99d0706$var$EMOJI_ROOT;
function $e006ee16d99d0706$var$init() {
    if ($e006ee16d99d0706$var$MAPPED) return;
    let r = $e006ee16d99d0706$var$read_compressed_payload($e006ee16d99d0706$var$COMPRESSED$1);
    const read_sorted_array = ()=>$e006ee16d99d0706$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $e006ee16d99d0706$var$MAPPED = new Map($e006ee16d99d0706$var$read_mapped(r));
    $e006ee16d99d0706$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $e006ee16d99d0706$var$CM = read_sorted_array();
    $e006ee16d99d0706$var$NSM = new Set(read_sorted_array().map((i)=>$e006ee16d99d0706$var$CM[i]));
    $e006ee16d99d0706$var$CM = new Set($e006ee16d99d0706$var$CM);
    $e006ee16d99d0706$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $e006ee16d99d0706$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $e006ee16d99d0706$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $e006ee16d99d0706$var$GROUPS = $e006ee16d99d0706$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $e006ee16d99d0706$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $e006ee16d99d0706$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $e006ee16d99d0706$var$WHOLE_VALID = read_sorted_set();
    $e006ee16d99d0706$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($e006ee16d99d0706$var$Array_from($e006ee16d99d0706$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$e006ee16d99d0706$var$WHOLE_VALID.has(cp)) $e006ee16d99d0706$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($e006ee16d99d0706$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $e006ee16d99d0706$var$GROUPS.filter((g)=>$e006ee16d99d0706$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$e006ee16d99d0706$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $e006ee16d99d0706$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$e006ee16d99d0706$var$VALID.has(cp) ? multi.add(cp) : $e006ee16d99d0706$var$VALID.add(cp);
    for (let g of $e006ee16d99d0706$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $e006ee16d99d0706$var$VALID)if (!$e006ee16d99d0706$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $e006ee16d99d0706$var$WHOLE_MAP.set(cp, $e006ee16d99d0706$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($e006ee16d99d0706$var$VALID, $e006ee16d99d0706$export$9d0d896b286a3dba($e006ee16d99d0706$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $e006ee16d99d0706$var$EMOJI_LIST = $e006ee16d99d0706$var$read_trie(r).map((v)=>$e006ee16d99d0706$var$Emoji.from(v)).sort($e006ee16d99d0706$var$compare_arrays);
    $e006ee16d99d0706$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $e006ee16d99d0706$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $e006ee16d99d0706$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $e006ee16d99d0706$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $e006ee16d99d0706$var$quoted_cp(cp) {
    return ($e006ee16d99d0706$export$4b1c9c18c687e5e9(cp) ? "" : `${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $e006ee16d99d0706$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $e006ee16d99d0706$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $e006ee16d99d0706$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $e006ee16d99d0706$var$HYPHEN && cps[3] == $e006ee16d99d0706$var$HYPHEN) throw new Error(`invalid label extension: "${$e006ee16d99d0706$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $e006ee16d99d0706$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $e006ee16d99d0706$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $e006ee16d99d0706$var$FENCED.get(cp);
    if (prev) throw $e006ee16d99d0706$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $e006ee16d99d0706$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $e006ee16d99d0706$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $e006ee16d99d0706$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $e006ee16d99d0706$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $e006ee16d99d0706$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($e006ee16d99d0706$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($e006ee16d99d0706$export$4b1c9c18c687e5e9(cp)) {
            buf.push($e006ee16d99d0706$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($e006ee16d99d0706$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $e006ee16d99d0706$export$e29a9e4d2573411c(cp) {
    $e006ee16d99d0706$var$init();
    return $e006ee16d99d0706$var$CM.has(cp);
}
function $e006ee16d99d0706$export$4b1c9c18c687e5e9(cp) {
    $e006ee16d99d0706$var$init();
    return $e006ee16d99d0706$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $e006ee16d99d0706$export$95d5ea4de7964366() {
    $e006ee16d99d0706$var$init();
    return $e006ee16d99d0706$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $e006ee16d99d0706$export$f4e6b2721065fb3d(frag, decompose) {
    $e006ee16d99d0706$var$init();
    let nf = decompose ? $e006ee16d99d0706$export$9d0d896b286a3dba : $e006ee16d99d0706$export$f42252642e08449;
    return frag.split($e006ee16d99d0706$var$STOP_CH).map((label)=>$e006ee16d99d0706$var$str_from_cps($e006ee16d99d0706$var$tokens_from_str($e006ee16d99d0706$var$explode_cp(label), nf, $e006ee16d99d0706$var$filter_fe0f).flat())).join($e006ee16d99d0706$var$STOP_CH);
}
function $e006ee16d99d0706$export$499f715881831a51(name) {
    return $e006ee16d99d0706$var$flatten($e006ee16d99d0706$var$split(name, $e006ee16d99d0706$export$f42252642e08449, $e006ee16d99d0706$var$filter_fe0f));
}
function $e006ee16d99d0706$export$d2ee080f6ab2341d(name) {
    let labels = $e006ee16d99d0706$var$split(name, $e006ee16d99d0706$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") $e006ee16d99d0706$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $e006ee16d99d0706$var$flatten(labels);
}
function $e006ee16d99d0706$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $e006ee16d99d0706$export$d2ba335951b08421(name, preserve_emoji) {
    return $e006ee16d99d0706$var$split(name, $e006ee16d99d0706$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $e006ee16d99d0706$var$filter_fe0f); // emoji are exposed so copy
}
function $e006ee16d99d0706$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $e006ee16d99d0706$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($e006ee16d99d0706$var$STOP_CH).map((label)=>{
        let input = $e006ee16d99d0706$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $e006ee16d99d0706$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $e006ee16d99d0706$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $e006ee16d99d0706$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($e006ee16d99d0706$var$CM.has(norm[0])) throw $e006ee16d99d0706$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $e006ee16d99d0706$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $e006ee16d99d0706$var$error_placement(`emoji + combining mark: "${$e006ee16d99d0706$var$str_from_cps(tokens[i - 1])} + ${$e006ee16d99d0706$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $e006ee16d99d0706$var$check_fenced(norm);
                    let unique = $e006ee16d99d0706$var$Array_from(new Set(chars));
                    let [g] = $e006ee16d99d0706$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $e006ee16d99d0706$var$check_group(g, chars); // need text in order
                    $e006ee16d99d0706$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $e006ee16d99d0706$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $e006ee16d99d0706$var$WHOLE_MAP.get(cp);
        if (whole === $e006ee16d99d0706$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $e006ee16d99d0706$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$e006ee16d99d0706$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $e006ee16d99d0706$var$determine_group(unique) {
    let groups = $e006ee16d99d0706$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$e006ee16d99d0706$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$e006ee16d99d0706$var$GROUPS.some((g)=>$e006ee16d99d0706$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $e006ee16d99d0706$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $e006ee16d99d0706$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $e006ee16d99d0706$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $e006ee16d99d0706$var$str_from_cps(output);
    }).join($e006ee16d99d0706$var$STOP_CH);
}
function $e006ee16d99d0706$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$e006ee16d99d0706$var$quoted_cp(cp)}`);
}
function $e006ee16d99d0706$var$error_group_member(g, cp) {
    let quoted = $e006ee16d99d0706$var$quoted_cp(cp);
    let gg = $e006ee16d99d0706$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $e006ee16d99d0706$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $e006ee16d99d0706$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$e006ee16d99d0706$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $e006ee16d99d0706$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $e006ee16d99d0706$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($e006ee16d99d0706$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $e006ee16d99d0706$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$e006ee16d99d0706$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $e006ee16d99d0706$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$e006ee16d99d0706$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $e006ee16d99d0706$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $e006ee16d99d0706$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($e006ee16d99d0706$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $e006ee16d99d0706$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$e006ee16d99d0706$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $e006ee16d99d0706$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $e006ee16d99d0706$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $e006ee16d99d0706$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $e006ee16d99d0706$var$consume_emoji_reversed(cps, eaten) {
    let node = $e006ee16d99d0706$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $e006ee16d99d0706$var$TY_VALID = "valid";
const $e006ee16d99d0706$var$TY_MAPPED = "mapped";
const $e006ee16d99d0706$var$TY_IGNORED = "ignored";
const $e006ee16d99d0706$var$TY_DISALLOWED = "disallowed";
const $e006ee16d99d0706$var$TY_EMOJI = "emoji";
const $e006ee16d99d0706$var$TY_NFC = "nfc";
const $e006ee16d99d0706$var$TY_STOP = "stop";
function $e006ee16d99d0706$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $e006ee16d99d0706$var$init();
    let input = $e006ee16d99d0706$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $e006ee16d99d0706$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $e006ee16d99d0706$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $e006ee16d99d0706$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $e006ee16d99d0706$var$STOP) tokens.push({
                type: $e006ee16d99d0706$var$TY_STOP,
                cp: cp
            });
            else if ($e006ee16d99d0706$var$VALID.has(cp)) tokens.push({
                type: $e006ee16d99d0706$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($e006ee16d99d0706$var$IGNORED.has(cp)) tokens.push({
                type: $e006ee16d99d0706$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $e006ee16d99d0706$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $e006ee16d99d0706$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $e006ee16d99d0706$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($e006ee16d99d0706$var$is_valid_or_mapped(token.type)) {
            if ($e006ee16d99d0706$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($e006ee16d99d0706$var$is_valid_or_mapped(type)) {
                        if (!$e006ee16d99d0706$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $e006ee16d99d0706$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$e006ee16d99d0706$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $e006ee16d99d0706$export$f42252642e08449(cps0);
                if ($e006ee16d99d0706$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $e006ee16d99d0706$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $e006ee16d99d0706$var$collapse_valid_tokens(slice),
                        tokens: $e006ee16d99d0706$export$bac129d8210aa825($e006ee16d99d0706$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $e006ee16d99d0706$var$TY_IGNORED) start = -1; // reset
    }
    return $e006ee16d99d0706$var$collapse_valid_tokens(tokens);
}
function $e006ee16d99d0706$var$is_valid_or_mapped(type) {
    return type == $e006ee16d99d0706$var$TY_VALID || type == $e006ee16d99d0706$var$TY_MAPPED;
}
function $e006ee16d99d0706$var$requires_check(cps) {
    return cps.some((cp)=>$e006ee16d99d0706$var$NFC_CHECK.has(cp));
}
function $e006ee16d99d0706$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $e006ee16d99d0706$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $e006ee16d99d0706$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $e006ee16d99d0706$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


const $574ce7342d53bcf4$var$Zeros = new Uint8Array(32);
$574ce7342d53bcf4$var$Zeros.fill(0);
function $574ce7342d53bcf4$var$checkComponent(comp) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $574ce7342d53bcf4$var$ensNameSplit(name) {
    const bytes = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)($574ce7342d53bcf4$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($574ce7342d53bcf4$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($574ce7342d53bcf4$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $574ce7342d53bcf4$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $e006ee16d99d0706$export$499f715881831a51)(name);
    } catch (error) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $574ce7342d53bcf4$export$cce2300886e7ace6(name) {
    try {
        return $574ce7342d53bcf4$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $574ce7342d53bcf4$export$91d651ee363e1209(name) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $574ce7342d53bcf4$var$Zeros;
    const comps = $574ce7342d53bcf4$var$ensNameSplit(name);
    while(comps.length)result = (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        result,
        (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(result);
}
function $574ce7342d53bcf4$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)($574ce7342d53bcf4$var$ensNameSplit(name).map((comp)=>{
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





//See: https://github.com/ethereum/wiki/wiki/RLP


function $c465ec7edc0c99d6$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $c465ec7edc0c99d6$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $c465ec7edc0c99d6$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $634aa51198273feb$export$a7a9523472993e97)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $c465ec7edc0c99d6$var$_decode(data, offset) {
    (0, $634aa51198273feb$export$a7a9523472993e97)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $634aa51198273feb$export$a7a9523472993e97)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $c465ec7edc0c99d6$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $c465ec7edc0c99d6$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $c465ec7edc0c99d6$var$hexlifyByte(data[offset])
    };
}
function $c465ec7edc0c99d6$export$7dc021e13b2aa20d(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    const decoded = $c465ec7edc0c99d6$var$_decode(data, 0);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

//See: https://github.com/ethereum/wiki/wiki/RLP

function $caedcf6749fe63e5$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $caedcf6749fe63e5$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($caedcf6749fe63e5$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $caedcf6749fe63e5$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $caedcf6749fe63e5$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $caedcf6749fe63e5$var$nibbles = "0123456789abcdef";
function $caedcf6749fe63e5$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $caedcf6749fe63e5$var$_encode(object)){
        result += $caedcf6749fe63e5$var$nibbles[v >> 4];
        result += $caedcf6749fe63e5$var$nibbles[v & 0xf];
    }
    return result;
}




const $154b040c27f48330$var$BN_0 = BigInt(0);
const $154b040c27f48330$var$BN_2 = BigInt(2);
const $154b040c27f48330$var$BN_27 = BigInt(27);
const $154b040c27f48330$var$BN_28 = BigInt(28);
const $154b040c27f48330$var$BN_35 = BigInt(35);
const $154b040c27f48330$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $154b040c27f48330$var$BLOB_SIZE = 131072;
function $154b040c27f48330$var$getVersionedHash(version, hash) {
    let versioned = version.toString(16);
    while(versioned.length < 2)versioned = "0" + versioned;
    versioned += (0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)(hash).substring(4);
    return "0x" + versioned;
}
function $154b040c27f48330$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
}
function $154b040c27f48330$var$handleAccessList(value, param) {
    try {
        return (0, $c254de3831dd58ea$export$6c8662b1600dce2)(value);
    } catch (error) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $154b040c27f48330$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $6fa405e57bb6371e$export$b14f2714108df84)(_value, param);
}
function $154b040c27f48330$var$handleUint(_value, param) {
    if (_value === "0x") return $154b040c27f48330$var$BN_0;
    const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, param);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(value <= $154b040c27f48330$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $154b040c27f48330$var$formatNumber(_value, name) {
    const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "value");
    const result = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $154b040c27f48330$var$formatAccessList(value) {
    return (0, $c254de3831dd58ea$export$6c8662b1600dce2)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $154b040c27f48330$var$formatHashes(value, param) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $154b040c27f48330$var$_parseLegacy(data) {
    const fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)(data);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $154b040c27f48330$var$handleNumber(fields[0], "nonce"),
        gasPrice: $154b040c27f48330$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $154b040c27f48330$var$handleUint(fields[2], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[3]),
        value: $154b040c27f48330$var$handleUint(fields[4], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[5]),
        chainId: $154b040c27f48330$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $154b040c27f48330$var$handleUint(fields[6], "v");
    const r = $154b040c27f48330$var$handleUint(fields[7], "r");
    const s = $154b040c27f48330$var$handleUint(fields[8], "s");
    if (r === $154b040c27f48330$var$BN_0 && s === $154b040c27f48330$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $154b040c27f48330$var$BN_35) / $154b040c27f48330$var$BN_2;
        if (chainId < $154b040c27f48330$var$BN_0) chainId = $154b040c27f48330$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(chainId !== $154b040c27f48330$var$BN_0 || v === $154b040c27f48330$var$BN_27 || v === $154b040c27f48330$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from({
            r: (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[7], 32),
            s: (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[8], 32),
            v: v
        });
    //tx.hash = keccak256(data);
    }
    return tx;
}
function $154b040c27f48330$var$_serializeLegacy(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $154b040c27f48330$var$BN_0;
    if (tx.chainId != $154b040c27f48330$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $154b040c27f48330$var$BN_0) {
            fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $154b040c27f48330$var$BN_0) v = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(v));
    fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
    fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
    return (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields);
}
function $154b040c27f48330$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $154b040c27f48330$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[1], 32);
    const s = (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[2], 32);
    const signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $154b040c27f48330$var$_parseEip1559(data) {
    const fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data).slice(1));
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 2,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $154b040c27f48330$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $154b040c27f48330$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $154b040c27f48330$var$handleUint(fields[4], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[5]),
        value: $154b040c27f48330$var$handleUint(fields[6], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    //tx.hash = keccak256(data);
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $154b040c27f48330$var$_serializeEip1559(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data,
        $154b040c27f48330$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0x02",
        (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields)
    ]);
}
function $154b040c27f48330$var$_parseEip2930(data) {
    const fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data).slice(1));
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 1,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        gasPrice: $154b040c27f48330$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $154b040c27f48330$var$handleUint(fields[3], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[4]),
        value: $154b040c27f48330$var$handleUint(fields[5], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[6]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    //tx.hash = keccak256(data);
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $154b040c27f48330$var$_serializeEip2930(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data,
        $154b040c27f48330$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0x01",
        (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields)
    ]);
}
function $154b040c27f48330$var$_parseEip4844(data) {
    let fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data).slice(1));
    let typeName = "3";
    let blobs = null;
    // Parse the network format
    if (fields.length === 4 && Array.isArray(fields[0])) {
        typeName = "3 (network format)";
        const fBlobs = fields[1], fCommits = fields[2], fProofs = fields[3];
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fBlobs), "invalid network format: blobs not an array", "fields[1]", fBlobs);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fCommits), "invalid network format: commitments not an array", "fields[2]", fCommits);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fProofs), "invalid network format: proofs not an array", "fields[3]", fProofs);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(fBlobs.length === fCommits.length, "invalid network format: blobs/commitments length mismatch", "fields", fields);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(fBlobs.length === fProofs.length, "invalid network format: blobs/proofs length mismatch", "fields", fields);
        blobs = [];
        for(let i = 0; i < fields[1].length; i++)blobs.push({
            data: fBlobs[i],
            commitment: fCommits[i],
            proof: fProofs[i]
        });
        fields = fields[0];
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), `invalid field count for transaction type: ${typeName}`, "data", (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 3,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $154b040c27f48330$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $154b040c27f48330$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $154b040c27f48330$var$handleUint(fields[4], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[5]),
        value: $154b040c27f48330$var$handleUint(fields[6], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $154b040c27f48330$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    if (blobs) tx.blobs = blobs;
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(tx.to != null, `invalid address for transaction type: ${typeName}`, "data", data);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    // @TODO: Do we need to do this? This is only called internally
    // and used to verify hashes; it might save time to not do this
    //tx.hash = keccak256(concat([ "0x03", encodeRlp(fields) ]));
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $154b040c27f48330$var$_serializeEip4844(tx, sig, blobs) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17),
        $154b040c27f48330$var$formatNumber(tx.value, "value"),
        tx.data,
        $154b040c27f48330$var$formatAccessList(tx.accessList || []),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $154b040c27f48330$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
        // We have blobs; return the network wrapped format
        if (blobs) return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            "0x03",
            (0, $caedcf6749fe63e5$export$aea7770274d28b7)([
                fields,
                blobs.map((b)=>b.data),
                blobs.map((b)=>b.commitment),
                blobs.map((b)=>b.proof)
            ])
        ]);
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0x03",
        (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields)
    ]);
}
class $154b040c27f48330$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    #kzg;
    #blobs;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $154b040c27f48330$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $154b040c27f48330$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $154b040c27f48330$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $c254de3831dd58ea$export$6c8662b1600dce2)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $154b040c27f48330$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */ get blobs() {
        if (this.#blobs == null) return null;
        return this.#blobs.map((b)=>Object.assign({}, b));
    }
    set blobs(_blobs) {
        if (_blobs == null) {
            this.#blobs = null;
            return;
        }
        const blobs = [];
        const versionedHashes = [];
        for(let i = 0; i < _blobs.length; i++){
            const blob = _blobs[i];
            if ((0, $fd3872da8feed9cb$export$9a14abb1a440cd5e)(blob)) {
                (0, $634aa51198273feb$export$a7a9523472993e97)(this.#kzg, "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
                    operation: "set blobs()"
                });
                let data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(blob);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(data.length <= $154b040c27f48330$var$BLOB_SIZE, "blob is too large", `blobs[${i}]`, blob);
                // Pad blob if necessary
                if (data.length !== $154b040c27f48330$var$BLOB_SIZE) {
                    const padded = new Uint8Array($154b040c27f48330$var$BLOB_SIZE);
                    padded.set(data);
                    data = padded;
                }
                const commit = this.#kzg.blobToKzgCommitment(data);
                const proof = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#kzg.computeBlobKzgProof(data, commit));
                blobs.push({
                    data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data),
                    commitment: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(commit),
                    proof: proof
                });
                versionedHashes.push($154b040c27f48330$var$getVersionedHash(1, commit));
            } else {
                const commit = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(blob.commitment);
                blobs.push({
                    data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(blob.data),
                    commitment: commit,
                    proof: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(blob.proof)
                });
                versionedHashes.push($154b040c27f48330$var$getVersionedHash(1, commit));
            }
        }
        this.#blobs = blobs;
        this.#blobVersionedHashes = versionedHashes;
    }
    get kzg() {
        return this.#kzg;
    }
    set kzg(kzg) {
        this.#kzg = kzg;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $154b040c27f48330$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $154b040c27f48330$var$BN_0;
        this.#chainId = $154b040c27f48330$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
        this.#blobs = null;
        this.#kzg = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(this.#getSerialized(true, false));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $e25c0939af0d847b$export$23cc18f96d8510e2)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $015cdebda6711d1b$export$21643ca94aed3e83).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    #getSerialized(signed, sidecar) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!signed || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        const sig = signed ? this.signature : null;
        switch(this.inferType()){
            case 0:
                return $154b040c27f48330$var$_serializeLegacy(this, sig);
            case 1:
                return $154b040c27f48330$var$_serializeEip2930(this, sig);
            case 2:
                return $154b040c27f48330$var$_serializeEip1559(this, sig);
            case 3:
                return $154b040c27f48330$var$_serializeEip4844(this, sig, sidecar ? this.blobs : null);
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        return this.#getSerialized(true, true);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        return this.#getSerialized(false, false);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $634aa51198273feb$export$a7a9523472993e97)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $634aa51198273feb$export$a7a9523472993e97)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $154b040c27f48330$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $154b040c27f48330$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(tx);
            if (payload[0] >= 0x7f) return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip2930(payload));
                case 2:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip1559(payload));
                case 3:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip4844(payload));
            }
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $154b040c27f48330$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        // This will get overwritten by blobs, if present
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        // Make sure we assign the kzg before assigning blobs, which
        // require the library in the event raw blob data is provided.
        if (tx.kzg != null) result.kzg = tx.kzg;
        if (tx.blobs != null) result.blobs = tx.blobs;
        if (tx.hash != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.hash'", "tx", tx);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.from'", "tx", tx);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}



/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 



/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 


const $afe06f2b2ad79fd5$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $afe06f2b2ad79fd5$var$Lookup = null;
function $afe06f2b2ad79fd5$var$getAlpha(letter) {
    if ($afe06f2b2ad79fd5$var$Lookup == null) {
        $afe06f2b2ad79fd5$var$Lookup = {};
        for(let i = 0; i < $afe06f2b2ad79fd5$var$Alphabet.length; i++)$afe06f2b2ad79fd5$var$Lookup[$afe06f2b2ad79fd5$var$Alphabet[i]] = BigInt(i);
    }
    const result = $afe06f2b2ad79fd5$var$Lookup[letter];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $afe06f2b2ad79fd5$var$BN_0 = BigInt(0);
const $afe06f2b2ad79fd5$var$BN_58 = BigInt(58);
function $afe06f2b2ad79fd5$export$743e6bddc3282b13(_value) {
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_value);
    let value = (0, $6fa405e57bb6371e$export$c221a145703ab783)(bytes);
    let result = "";
    while(value){
        result = $afe06f2b2ad79fd5$var$Alphabet[Number(value % $afe06f2b2ad79fd5$var$BN_58)] + result;
        value /= $afe06f2b2ad79fd5$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $afe06f2b2ad79fd5$var$Alphabet[0] + result;
    }
    return result;
}
function $afe06f2b2ad79fd5$export$63d430871b22e3d9(value) {
    let result = $afe06f2b2ad79fd5$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $afe06f2b2ad79fd5$var$BN_58;
        result += $afe06f2b2ad79fd5$var$getAlpha(value[i]);
    }
    return result;
}


// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $280d6641ec976e99$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $280d6641ec976e99$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $280d6641ec976e99$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $280d6641ec976e99$export$dcf63b2028a708b5 extends $280d6641ec976e99$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($280d6641ec976e99$var$BasicMulticoinPluginId);
    }
}
const $280d6641ec976e99$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $280d6641ec976e99$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $280d6641ec976e99$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $280d6641ec976e99$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $574ce7342d53bcf4$export$91d651ee363e1209)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $574ce7342d53bcf4$export$6c0a8cdae51cb512)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17)) return null;
            return result;
        } catch (error) {
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(data, 20)) return (0, $69ef3f917ff239a2$export$88411125f012957a)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $280d6641ec976e99$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $afe06f2b2ad79fd5$export$743e6bddc3282b13)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $280d6641ec976e99$var$matchers.length; i++){
                const match = avatar.match($280d6641ec976e99$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $280d6641ec976e99$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $280d6641ec976e99$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $2cb10defc4f72334$export$319b96fe59834522)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($280d6641ec976e99$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $280d6641ec976e99$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $634aa51198273feb$export$a7a9523472993e97)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $280d6641ec976e99$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $574ce7342d53bcf4$export$91d651ee363e1209)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $280d6641ec976e99$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $280d6641ec976e99$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}


/**
 *  @_ignore
 */ 


function $ffd6543f65258923$export$769b627a7e45189e(tx) {
    const from = (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.from);
    const nonce = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $caedcf6749fe63e5$export$aea7770274d28b7)([
        from,
        nonceHex
    ])), 12));
}
function $ffd6543f65258923$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $69ef3f917ff239a2$export$88411125f012957a)(_from);
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    const initCodeHash = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_initCodeHash, "initCodeHash");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}





const $8c8b15350cbd9f48$var$BN_0 = BigInt(0);
function $8c8b15350cbd9f48$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $8c8b15350cbd9f48$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $8c8b15350cbd9f48$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $634aa51198273feb$export$a7a9523472993e97)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $8c8b15350cbd9f48$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $8c8b15350cbd9f48$export$1f26277db27165ba(value) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value, true), "invalid data", "value", value);
    return value;
}
function $8c8b15350cbd9f48$export$bb5bc852e1c64b88(value) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value, 32), "invalid hash", "value", value);
    return value;
}
function $8c8b15350cbd9f48$export$aff4fda55e7ac0d6(value) {
    if (!(0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
    return (0, $fd3872da8feed9cb$export$4473860254365feb)(value, 32);
}
const $8c8b15350cbd9f48$var$_formatLog = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    address: (0, $69ef3f917ff239a2$export$88411125f012957a),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    blockNumber: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    data: $8c8b15350cbd9f48$export$1f26277db27165ba,
    index: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    removed: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$7a3be81718959bda, false),
    topics: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    transactionHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    transactionIndex: (0, $6fa405e57bb6371e$export$b14f2714108df84)
}, {
    index: [
        "logIndex"
    ]
});
function $8c8b15350cbd9f48$export$fccdbdc2b9d7893(value) {
    return $8c8b15350cbd9f48$var$_formatLog(value);
}
const $8c8b15350cbd9f48$var$_formatBlock = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    hash: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    parentHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    number: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    timestamp: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    nonce: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$1f26277db27165ba),
    difficulty: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    gasLimit: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    gasUsed: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    stateRoot: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    receiptsRoot: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    blobGasUsed: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null),
    excessBlobGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null),
    miner: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a)),
    prevRandao: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
    extraData: $8c8b15350cbd9f48$export$1f26277db27165ba,
    baseFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4))
}, {
    prevRandao: [
        "mixHash"
    ]
});
function $8c8b15350cbd9f48$export$ba1152bc4017d62a(value) {
    const result = $8c8b15350cbd9f48$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $8c8b15350cbd9f48$export$fe50e42b325965d(tx);
    });
    return result;
}
const $8c8b15350cbd9f48$var$_formatReceiptLog = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    transactionIndex: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    blockNumber: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    transactionHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    address: (0, $69ef3f917ff239a2$export$88411125f012957a),
    topics: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    data: $8c8b15350cbd9f48$export$1f26277db27165ba,
    index: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $8c8b15350cbd9f48$export$5ec2fc59e0e92b87(value) {
    return $8c8b15350cbd9f48$var$_formatReceiptLog(value);
}
const $8c8b15350cbd9f48$var$_formatTransactionReceipt = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    to: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
    from: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
    contractAddress: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    root: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)),
    gasUsed: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    blobGasUsed: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null),
    logsBloom: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$1f26277db27165ba),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    hash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    logs: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$5ec2fc59e0e92b87),
    blockNumber: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    effectiveGasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
    blobGasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null),
    status: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84)),
    type: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $8c8b15350cbd9f48$export$30da670e49d6fc31(value) {
    return $8c8b15350cbd9f48$var$_formatTransactionReceipt(value);
}
function $8c8b15350cbd9f48$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value.to) === $8c8b15350cbd9f48$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $8c8b15350cbd9f48$export$be5493f9613cbbe({
        hash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $6fa405e57bb6371e$export$b14f2714108df84)(value);
        },
        accessList: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $c254de3831dd58ea$export$6c8662b1600dce2), null),
        blobVersionedHashes: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88, true), null),
        blockHash: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
        blockNumber: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), null),
        transactionIndex: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), null),
        from: (0, $69ef3f917ff239a2$export$88411125f012957a),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
        maxPriorityFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
        maxFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
        maxFeePerBlobGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null),
        gasLimit: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
        to: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
        value: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
        nonce: (0, $6fa405e57bb6371e$export$b14f2714108df84),
        data: $8c8b15350cbd9f48$export$1f26277db27165ba,
        creates: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
        chainId: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $ffd6543f65258923$export$769b627a7e45189e)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(value.signature);
    else result.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(result.blockHash) === $8c8b15350cbd9f48$var$BN_0) result.blockHash = null;
    return result;
}





function $f484c23113a92e9e$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $f484c23113a92e9e$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $f484c23113a92e9e$export$aaf796a16ac1a157(provider);
    if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(event, 32)) return new $f484c23113a92e9e$export$4fe8a9740765f97e(provider, event);
    (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $f484c23113a92e9e$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $f484c23113a92e9e$export$63862f83f14090ef extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $f484c23113a92e9e$export$e4ed5c6414dc4e9e extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $f484c23113a92e9e$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $f484c23113a92e9e$export$4fe8a9740765f97e extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $f484c23113a92e9e$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $f484c23113a92e9e$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $f484c23113a92e9e$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}


// Constants
const $a447d5c12fd5aa4c$var$BN_2 = BigInt(2);
const $a447d5c12fd5aa4c$var$MAX_CCIP_REDIRECTS = 10;
function $a447d5c12fd5aa4c$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $a447d5c12fd5aa4c$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $a447d5c12fd5aa4c$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $a447d5c12fd5aa4c$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $a447d5c12fd5aa4c$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $a447d5c12fd5aa4c$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $a447d5c12fd5aa4c$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $a447d5c12fd5aa4c$var$getTag("orphan", event),
            filter: $a447d5c12fd5aa4c$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $a447d5c12fd5aa4c$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $a447d5c12fd5aa4c$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $a447d5c12fd5aa4c$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unknown ProviderEvent", "event", _event);
}
function $a447d5c12fd5aa4c$var$getTime() {
    return new Date().getTime();
}
const $a447d5c12fd5aa4c$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $a447d5c12fd5aa4c$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $a447d5c12fd5aa4c$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $4945f77db30f37e3$export$95be4ae94445245a).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $a447d5c12fd5aa4c$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $2cb10defc4f72334$export$319b96fe59834522)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $634aa51198273feb$export$a7a9523472993e97)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $425e3311db5fb4d1$export$d96a8827a60d6b69)((0, $8c8b15350cbd9f48$export$ba1152bc4017d62a)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $425e3311db5fb4d1$export$ce30dbb46644d06c)((0, $8c8b15350cbd9f48$export$fccdbdc2b9d7893)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $425e3311db5fb4d1$export$375ffd5683aa5c1c)((0, $8c8b15350cbd9f48$export$30da670e49d6fc31)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $425e3311db5fb4d1$export$70966cdb3bfc0785)((0, $8c8b15350cbd9f48$export$fe50e42b325965d)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $6fa405e57bb6371e$export$b14f2714108df84)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(blockTag)) {
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(blockTag, 32)) return blockTag;
            return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $6fa405e57bb6371e$export$b14f2714108df84)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(b + blockTag));
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $a447d5c12fd5aa4c$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(request[key], this);
            if ($a447d5c12fd5aa4c$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($a447d5c12fd5aa4c$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $a447d5c12fd5aa4c$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $425e3311db5fb4d1$export$116c49c1e2a96a78)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $2cb10defc4f72334$export$319b96fe59834522)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $425e3311db5fb4d1$export$116c49c1e2a96a78)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($a447d5c12fd5aa4c$var$isPromise(tx)) tx = await tx;
        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(attempt < $a447d5c12fd5aa4c$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(tx);
        try {
            return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $634aa51198273feb$export$748c4fa78f31ff35)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $a447d5c12fd5aa4c$var$parseOffchainLookup((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(error.data, 4));
                } catch (error) {
                    (0, $634aa51198273feb$export$a7a9523472993e97)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $634aa51198273feb$export$a7a9523472993e97)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $634aa51198273feb$export$a7a9523472993e97)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
                        ccipArgs.selector,
                        $a447d5c12fd5aa4c$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $6fa405e57bb6371e$export$b14f2714108df84)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_position, "position");
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $154b040c27f48330$export$febc5573c75cefb0).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($a447d5c12fd5aa4c$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $280d6641ec976e99$export$d04afd034a0a53ae).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $69ef3f917ff239a2$export$88411125f012957a)(address);
        const node = (0, $574ce7342d53bcf4$export$91d651ee363e1209)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $280d6641ec976e99$export$d04afd034a0a53ae).getEnsAddress(this);
            const ensContract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17)) return null;
            const resolverContract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $a447d5c12fd5aa4c$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $a447d5c12fd5aa4c$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $f484c23113a92e9e$export$aaf796a16ac1a157)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $f484c23113a92e9e$export$63862f83f14090ef)(this, sub.type);
            case "event":
                return new (0, $f484c23113a92e9e$export$bdb759dc2fe68c72)(this, sub.filter);
            case "transaction":
                return new (0, $f484c23113a92e9e$export$4fe8a9740765f97e)(this, sub.hash);
            case "orphan":
                return new (0, $f484c23113a92e9e$export$e4ed5c6414dc4e9e)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $a447d5c12fd5aa4c$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $a447d5c12fd5aa4c$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $a447d5c12fd5aa4c$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $62d6becaa0dab02c$export$9cec82196983b278)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $a447d5c12fd5aa4c$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $a447d5c12fd5aa4c$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $a447d5c12fd5aa4c$var$_parseString(result, start) {
    try {
        const bytes = $a447d5c12fd5aa4c$var$_parseBytes(result, start);
        if (bytes) return (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(bytes);
    } catch (error) {}
    return null;
}
function $a447d5c12fd5aa4c$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(result, start, start + 32));
        const length = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(result, offset, offset + 32));
        return (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $a447d5c12fd5aa4c$var$numPad(value) {
    const result = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $a447d5c12fd5aa4c$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $a447d5c12fd5aa4c$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $a447d5c12fd5aa4c$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($a447d5c12fd5aa4c$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(datas[i]);
        // Update the bytes offset
        result[i] = $a447d5c12fd5aa4c$var$numPad(byteCount);
        // The length and padded value of data
        result.push($a447d5c12fd5aa4c$var$numPad(data.length));
        result.push($a447d5c12fd5aa4c$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(result);
}
const $a447d5c12fd5aa4c$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $a447d5c12fd5aa4c$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $634aa51198273feb$export$a7a9523472993e97)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 0, 32);
    (0, $634aa51198273feb$export$a7a9523472993e97)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(sender, 0, 12) === (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)($a447d5c12fd5aa4c$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 32, 64));
        const urlsLength = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $a447d5c12fd5aa4c$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $a447d5c12fd5aa4c$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $634aa51198273feb$export$a7a9523472993e97)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 100, 128) === (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)($a447d5c12fd5aa4c$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $a447d5c12fd5aa4c$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}


/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 



function $0e0b4a0a5741b830$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $634aa51198273feb$export$a7a9523472993e97)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $0e0b4a0a5741b830$var$populate(signer, tx) {
    let pop = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(tx);
    if (pop.to != null) pop.to = (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(from, signer)
        ]).then(([address, from])=>{
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)(pop);
}
class $0e0b4a0a5741b830$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $0e0b4a0a5741b830$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "populateTransaction");
        const pop = await $0e0b4a0a5741b830$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(pop.chainId);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $634aa51198273feb$export$a7a9523472993e97)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $634aa51198273feb$export$a7a9523472993e97)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $634aa51198273feb$export$a7a9523472993e97)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2 || pop.type === 3) {
                // Explicitly using EIP-1559 or EIP-4844
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)(pop);
    }
    async estimateGas(tx) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $154b040c27f48330$export$febc5573c75cefb0).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $0e0b4a0a5741b830$export$7dbc56d9b9612bad extends $0e0b4a0a5741b830$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $0e0b4a0a5741b830$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}





function $028eec70d03d6cd8$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $028eec70d03d6cd8$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                if (this.#provider.destroyed) return;
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $028eec70d03d6cd8$export$60f65cdabb3c5771 extends $028eec70d03d6cd8$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $028eec70d03d6cd8$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $f484c23113a92e9e$export$bdb759dc2fe68c72)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $028eec70d03d6cd8$export$285511066b2a5499 extends $028eec70d03d6cd8$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}



const $80daf019a5520af5$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $80daf019a5520af5$var$deepCopy(value) {
    if (value == null || $80daf019a5520af5$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($80daf019a5520af5$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $80daf019a5520af5$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $80daf019a5520af5$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $80daf019a5520af5$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $80daf019a5520af5$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $80daf019a5520af5$export$5f7b5fca3508545a extends (0, $0e0b4a0a5741b830$export$6c02143914c373f1) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $69ef3f917ff239a2$export$88411125f012957a)(address);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $80daf019a5520af5$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(_from, this.provider);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CANCELLED") || (0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BAD_DATA") || (0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $80daf019a5520af5$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(tx.from, this.provider);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $80daf019a5520af5$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $23f01ceb797ea4ad$export$458ab927ae635c3).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $23f01ceb797ea4ad$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(message)
        ]);
    }
}
class $80daf019a5520af5$export$5afe35a44ca7ff9a extends (0, $a447d5c12fd5aa4c$export$ae9650e85fb229fe) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $80daf019a5520af5$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $4945f77db30f37e3$export$95be4ae94445245a).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.type)) // If there are no EIP-1559 or newer properties, it might be pre-EIP-1559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $4945f77db30f37e3$export$95be4ae94445245a).from((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $4945f77db30f37e3$export$95be4ae94445245a).from((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $80daf019a5520af5$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $028eec70d03d6cd8$export$285511066b2a5499)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $f484c23113a92e9e$export$bdb759dc2fe68c72)(this, sub.filter);
            return new (0, $028eec70d03d6cd8$export$60f65cdabb3c5771)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $a447d5c12fd5aa4c$export$f255b979f86248fa)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $c254de3831dd58ea$export$6c8662b1600dce2)(tx.accessList);
        if (tx.blobVersionedHashes) // @TODO: Remove this <any> case once EIP-4844 added to prepared tx
        result["blobVersionedHashes"] = tx.blobVersionedHashes.map((h)=>h.toLowerCase());
        // @TODO: blobs should probably also be copied over, optionally
        // accounting for the kzg property to backfill blobVersionedHashes
        // using the commitment. Or should that be left as an exercise to
        // the caller?
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($80daf019a5520af5$var$getLowerCase);
                    else req.filter.address = $80daf019a5520af5$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $80daf019a5520af5$var$spelunkData(error);
            const e = (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($80daf019a5520af5$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $80daf019a5520af5$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $69ef3f917ff239a2$export$88411125f012957a)(address);
        for (const account of accounts){
            if ((0, $69ef3f917ff239a2$export$88411125f012957a)(account) === address) return new $80daf019a5520af5$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $80daf019a5520af5$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $80daf019a5520af5$export$e16ffa1aa36d1432 extends $80daf019a5520af5$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        let pollingInterval = this._getOption("pollingInterval");
        if (pollingInterval == null) pollingInterval = $80daf019a5520af5$var$defaultOptions.pollingInterval;
        this.#pollingInterval = pollingInterval;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($80daf019a5520af5$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($80daf019a5520af5$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $80daf019a5520af5$export$da28308012bf6748 extends $80daf019a5520af5$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $2cb10defc4f72334$export$319b96fe59834522)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $80daf019a5520af5$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $80daf019a5520af5$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $80daf019a5520af5$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $80daf019a5520af5$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$80daf019a5520af5$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $80daf019a5520af5$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $80daf019a5520af5$var$spelunkMessage(value) {
    const result = [];
    $80daf019a5520af5$var$_spelunkMessage(value, result);
    return result;
}


const $5499ec87660a9ba7$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
function $5499ec87660a9ba7$var$getHost(name) {
    switch(name){
        case "mainnet":
            return "eth-mainnet.alchemyapi.io";
        case "goerli":
            return "eth-goerli.g.alchemy.com";
        case "sepolia":
            return "eth-sepolia.g.alchemy.com";
        case "arbitrum":
            return "arb-mainnet.g.alchemy.com";
        case "arbitrum-goerli":
            return "arb-goerli.g.alchemy.com";
        case "arbitrum-sepolia":
            return "arb-sepolia.g.alchemy.com";
        case "base":
            return "base-mainnet.g.alchemy.com";
        case "base-goerli":
            return "base-goerli.g.alchemy.com";
        case "base-sepolia":
            return "base-sepolia.g.alchemy.com";
        case "matic":
            return "polygon-mainnet.g.alchemy.com";
        case "matic-amoy":
            return "polygon-amoy.g.alchemy.com";
        case "matic-mumbai":
            return "polygon-mumbai.g.alchemy.com";
        case "optimism":
            return "opt-mainnet.g.alchemy.com";
        case "optimism-goerli":
            return "opt-goerli.g.alchemy.com";
        case "optimism-sepolia":
            return "opt-sepolia.g.alchemy.com";
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported network", "network", name);
}
class $5499ec87660a9ba7$export$999cc40da3fbc6f extends (0, $80daf019a5520af5$export$da28308012bf6748) {
    apiKey;
    constructor(_network, apiKey){
        if (_network == null) _network = "mainnet";
        const network = (0, $4945f77db30f37e3$export$95be4ae94445245a).from(_network);
        if (apiKey == null) apiKey = $5499ec87660a9ba7$var$defaultApiKey;
        const request = $5499ec87660a9ba7$export$999cc40da3fbc6f.getRequest(network, apiKey);
        super(request, network, {
            staticNetwork: network
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            apiKey: apiKey
        });
    }
    _getProvider(chainId) {
        try {
            return new $5499ec87660a9ba7$export$999cc40da3fbc6f(chainId, this.apiKey);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    async _perform(req) {
        // https://docs.alchemy.com/reference/trace-transaction
        if (req.method === "getTransactionResult") {
            const { trace: trace, tx: tx } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                trace: this.send("trace_transaction", [
                    req.hash
                ]),
                tx: this.getTransaction(req.hash)
            });
            if (trace == null || tx == null) return null;
            let data;
            let error = false;
            try {
                data = trace[0].result.output;
                error = trace[0].error === "Reverted";
            } catch (error) {}
            if (data) {
                (0, $634aa51198273feb$export$a7a9523472993e97)(!error, "an error occurred during transaction executions", "CALL_EXCEPTION", {
                    action: "getTransactionResult",
                    data: data,
                    reason: null,
                    transaction: tx,
                    invocation: null,
                    revert: null // @TODO
                });
                return data;
            }
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "could not parse trace result", "BAD_DATA", {
                value: trace
            });
        }
        return await super._perform(req);
    }
    isCommunityResource() {
        return this.apiKey === $5499ec87660a9ba7$var$defaultApiKey;
    }
    static getRequest(network, apiKey) {
        if (apiKey == null) apiKey = $5499ec87660a9ba7$var$defaultApiKey;
        const request = new (0, $2cb10defc4f72334$export$319b96fe59834522)(`https:/\/${$5499ec87660a9ba7$var$getHost(network.name)}/v2/${apiKey}`);
        request.allowGzip = true;
        if (apiKey === $5499ec87660a9ba7$var$defaultApiKey) request.retryFunc = async (request, response, attempt)=>{
            (0, $fe3cdff79340e8e1$export$4c41bd49e82e82ab)("alchemy");
            return true;
        };
        return request;
    }
}


function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $0ae9019609d046a1$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $63cbeabc75241824$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $63cbeabc75241824$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $63cbeabc75241824$export$2e2bcd8739ae039) || f === (0, $3acd474ceacf8a38$export$2e2bcd8739ae039) ? f : $0ae9019609d046a1$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0ae9019609d046a1$var$zero() {
    return 0;
}


function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $591ad978f2ce6133$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $a6e17c0ec55d7735$var$ascendingBisect = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $63cbeabc75241824$export$2e2bcd8739ae039));
const $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
const $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
const $a6e17c0ec55d7735$export$c1cb828b1117c77b = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $591ad978f2ce6133$export$2e2bcd8739ae039)).center;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;

function $674b813fb857ae76$var$length(array) {
    return array.length | 0;
}
function $674b813fb857ae76$var$empty(length) {
    return !(length > 0);
}
function $674b813fb857ae76$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $674b813fb857ae76$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $674b813fb857ae76$export$2e2bcd8739ae039(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $674b813fb857ae76$var$reducer(values.pop());
    values = values.map($674b813fb857ae76$var$arrayify);
    const lengths = values.map($674b813fb857ae76$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($674b813fb857ae76$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

function $439e396521e041a4$export$2e2bcd8739ae039(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

function $4eefdd235be3059b$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}


function $317408b795339b26$export$2e2bcd8739ae039(values, valueof) {
    const v = (0, $4eefdd235be3059b$export$2e2bcd8739ae039)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

function $24461355656d8852$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


function $f89111cbb3c9d70b$export$2e2bcd8739ae039(values, compare = (0, $63cbeabc75241824$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $63cbeabc75241824$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $63cbeabc75241824$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $d9caf9fd1659d791$export$2e2bcd8739ae039(x) {
    return x;
}


function $6f0c14a1378d16c1$export$2e2bcd8739ae039(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), keys);
}
function $6f0c14a1378d16c1$export$d4abd167df80d226(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, Array.from, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), keys);
}
function $6f0c14a1378d16c1$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $6f0c14a1378d16c1$export$4ed6fc79ae2c51b5(values, ...keys) {
    return $6f0c14a1378d16c1$var$flatten($6f0c14a1378d16c1$export$d4abd167df80d226(values, ...keys), keys);
}
function $6f0c14a1378d16c1$export$788c7294dbcd8e36(values, reduce, ...keys) {
    return $6f0c14a1378d16c1$var$flatten($6f0c14a1378d16c1$export$24814875ed03194b(values, reduce, ...keys), keys);
}
function $6f0c14a1378d16c1$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), reduce, keys);
}
function $6f0c14a1378d16c1$export$24814875ed03194b(values, reduce, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, Array.from, reduce, keys);
}
function $6f0c14a1378d16c1$export$b610b8812bbcded9(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), $6f0c14a1378d16c1$var$unique, keys);
}
function $6f0c14a1378d16c1$export$8b04ba635e5803cd(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, Array.from, $6f0c14a1378d16c1$var$unique, keys);
}
function $6f0c14a1378d16c1$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $6f0c14a1378d16c1$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}




function $752ccd95a674b233$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $3dc3306e587e145d$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $3dc3306e587e145d$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$3dc3306e587e145d$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $752ccd95a674b233$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($3dc3306e587e145d$export$5708b2c031939e56(f));
}
function $3dc3306e587e145d$export$5708b2c031939e56(compare = (0, $63cbeabc75241824$export$2e2bcd8739ae039)) {
    if (compare === (0, $63cbeabc75241824$export$2e2bcd8739ae039)) return $3dc3306e587e145d$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $3dc3306e587e145d$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $5d73447cdfa9c155$export$2e2bcd8739ae039(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $3dc3306e587e145d$export$2e2bcd8739ae039)((0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $63cbeabc75241824$export$2e2bcd8739ae039)(av, bv) || (0, $63cbeabc75241824$export$2e2bcd8739ae039)(ak, bk)) : (0, $3dc3306e587e145d$export$2e2bcd8739ae039)((0, $6f0c14a1378d16c1$export$2e2bcd8739ae039)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $63cbeabc75241824$export$2e2bcd8739ae039)(ak, bk))).map(([key])=>key);
}

function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

function $3ce2d353ce06f740$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

function $be26fde1f1f97ef0$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}



function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $70ebee7adc32f27f$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}



function $6637506e64922c38$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $3dc3306e587e145d$export$686e14b8469efec4) : (0, $3dc3306e587e145d$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $6637506e64922c38$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $6637506e64922c38$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $6637506e64922c38$var$swap(array, left, right);
        while(i < j){
            $6637506e64922c38$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $6637506e64922c38$var$swap(array, left, j);
        else ++j, $6637506e64922c38$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $6637506e64922c38$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}





function $231c9024a6754413$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $591ad978f2ce6133$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)((0, $6637506e64922c38$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $231c9024a6754413$export$f924a6cad778dddb(values, p, valueof = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $231c9024a6754413$export$f1fcc854ecc6ce55(values, p, valueof = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $591ad978f2ce6133$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $70ebee7adc32f27f$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $3ce2d353ce06f740$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $6637506e64922c38$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $3dc3306e587e145d$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $f89111cbb3c9d70b$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}


function $5713cbb46e42efc2$export$2e2bcd8739ae039(values, valueof) {
    return (0, $231c9024a6754413$export$2e2bcd8739ae039)(values, 0.5, valueof);
}
function $5713cbb46e42efc2$export$57546ab4fd3c7a5e(values, valueof) {
    return (0, $231c9024a6754413$export$f1fcc854ecc6ce55)(values, 0.5, valueof);
}


function $50f73767cb5db446$export$2e2bcd8739ae039(values, valueof) {
    const counts = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

function $a9640ed34ca3d852$export$2e2bcd8739ae039(values, pairof = $a9640ed34ca3d852$export$a04cb3fe8b81dd) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $a9640ed34ca3d852$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

function $0b47a96a2caef260$export$2e2bcd8739ae039(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

function $daf42a1f07322cf6$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

function $5c80433537c7ad93$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}



function $1ae435d6739098c4$export$2e2bcd8739ae039(values, min, max) {
    const c = (0, $5c80433537c7ad93$export$2e2bcd8739ae039)(values), d = (0, $231c9024a6754413$export$2e2bcd8739ae039)(values, 0.75) - (0, $231c9024a6754413$export$2e2bcd8739ae039)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}



function $e5c6de1a6d3b2294$export$2e2bcd8739ae039(values, min, max) {
    const c = (0, $5c80433537c7ad93$export$2e2bcd8739ae039)(values), d = (0, $317408b795339b26$export$2e2bcd8739ae039)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}


function $6d386446084ca1a9$export$2e2bcd8739ae039(values) {
    return Math.max(1, Math.ceil(Math.log((0, $5c80433537c7ad93$export$2e2bcd8739ae039)(values)) / Math.LN2) + 1);
}

const $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7c028b8201e48c5a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7c028b8201e48c5a$var$tickSpec(stop, start, count) : $7c028b8201e48c5a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7c028b8201e48c5a$var$tickSpec(start, stop, count)[2];
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7c028b8201e48c5a$export$bc64d00cc98e7e95(stop, start, count) : $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $575c8f74500ed33b$export$2e2bcd8739ae039(x) {
    return x;
}


var $834b38f205523964$var$top = 1, $834b38f205523964$var$right = 2, $834b38f205523964$var$bottom = 3, $834b38f205523964$var$left = 4, $834b38f205523964$var$epsilon = 1e-6;
function $834b38f205523964$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $834b38f205523964$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $834b38f205523964$var$number(scale) {
    return (d)=>+scale(d);
}
function $834b38f205523964$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $834b38f205523964$var$entering() {
    return !this.__axis;
}
function $834b38f205523964$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$left ? -1 : 1, x = orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? "x" : "y", transform = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$bottom ? $834b38f205523964$var$translateX : $834b38f205523964$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $575c8f74500ed33b$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $834b38f205523964$var$center : $834b38f205523964$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $834b38f205523964$var$top ? "0em" : orient === $834b38f205523964$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($834b38f205523964$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $834b38f205523964$var$right ? "start" : orient === $834b38f205523964$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $834b38f205523964$export$59b8cfab074bdeb1(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$top, scale);
}
function $834b38f205523964$export$b0d2e24dc4f898f0(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$right, scale);
}
function $834b38f205523964$export$e5cb22533a15e72e(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$bottom, scale);
}
function $834b38f205523964$export$2749afb169a520d2(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$left, scale);
}


var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;



function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}


function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $cade2308c136039a$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a3d7edd03ec30cc1$var$arrayAll(select) {
    return function() {
        return (0, $cade2308c136039a$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a3d7edd03ec30cc1$var$arrayAll(select);
    else select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, parents);
}


function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $5fb24786d2a5f87a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $31ffd623f27a3a65$var$find = Array.prototype.find;
function $31ffd623f27a3a65$var$childFind(match) {
    return function() {
        return $31ffd623f27a3a65$var$find.call(this.children, match);
    };
}
function $31ffd623f27a3a65$var$childFirst() {
    return this.firstElementChild;
}
function $31ffd623f27a3a65$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $31ffd623f27a3a65$var$childFirst : $31ffd623f27a3a65$var$childFind(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}



var $956143cec557381d$var$filter = Array.prototype.filter;
function $956143cec557381d$var$children() {
    return Array.from(this.children);
}
function $956143cec557381d$var$childrenFilter(match) {
    return function() {
        return $956143cec557381d$var$filter.call(this.children, match);
    };
}
function $956143cec557381d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $956143cec557381d$var$children : $956143cec557381d$var$childrenFilter(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}




function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._enter || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $cf943aeeeea8dffb$var$datum(node) {
    return node.__data__;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $cf943aeeeea8dffb$var$datum);
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d8d677a8510c2e55$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $cf943aeeeea8dffb$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $cf943aeeeea8dffb$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._exit || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}


function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63bab9b342eb32db$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(merges, this._parents);
}


function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}


function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}


function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}


function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}


function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}




function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}


function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $6e0da2549057218e$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}


function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}


function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $dd1fb49221ad966f$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $dd1fb49221ad966f$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}


function* $98373fa9c0ecbfb2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
function $28a9f77d63e1ff25$var$selection_selection() {
    return this;
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $31121acbef1e6956$export$2e2bcd8739ae039),
    selectAll: (0, $a3d7edd03ec30cc1$export$2e2bcd8739ae039),
    selectChild: (0, $31ffd623f27a3a65$export$2e2bcd8739ae039),
    selectChildren: (0, $956143cec557381d$export$2e2bcd8739ae039),
    filter: (0, $ebbd333b038c2847$export$2e2bcd8739ae039),
    data: (0, $cf943aeeeea8dffb$export$2e2bcd8739ae039),
    enter: (0, $3e99928b06782938$export$2e2bcd8739ae039),
    exit: (0, $69a673ff94b874e4$export$2e2bcd8739ae039),
    join: (0, $80f6488751784891$export$2e2bcd8739ae039),
    merge: (0, $63bab9b342eb32db$export$2e2bcd8739ae039),
    selection: $28a9f77d63e1ff25$var$selection_selection,
    order: (0, $7a935994b7a1f6cf$export$2e2bcd8739ae039),
    sort: (0, $faed8eab1469f61d$export$2e2bcd8739ae039),
    call: (0, $fa7212ea177e0f60$export$2e2bcd8739ae039),
    nodes: (0, $c2d66609f799a53b$export$2e2bcd8739ae039),
    node: (0, $cb2fe8996a284614$export$2e2bcd8739ae039),
    size: (0, $8d2a1d37edc5fc51$export$2e2bcd8739ae039),
    empty: (0, $3ed6ae19ad0a17a6$export$2e2bcd8739ae039),
    each: (0, $4a407aa055eb21e9$export$2e2bcd8739ae039),
    attr: (0, $8ba31651ad7591ba$export$2e2bcd8739ae039),
    style: (0, $6abb942964e997ae$export$2e2bcd8739ae039),
    property: (0, $2b37810bbc11c28b$export$2e2bcd8739ae039),
    classed: (0, $6515c3ccac9efd7a$export$2e2bcd8739ae039),
    text: (0, $23bcbc7d81179ba9$export$2e2bcd8739ae039),
    html: (0, $d5514f1406649954$export$2e2bcd8739ae039),
    raise: (0, $c6aae8ef09c3d03d$export$2e2bcd8739ae039),
    lower: (0, $4669a19c71181bd1$export$2e2bcd8739ae039),
    append: (0, $00a766249763e814$export$2e2bcd8739ae039),
    insert: (0, $45485f4f27d149f8$export$2e2bcd8739ae039),
    remove: (0, $d587d6535138580c$export$2e2bcd8739ae039),
    clone: (0, $3323c835dc2d74de$export$2e2bcd8739ae039),
    datum: (0, $d048e3258aa4fe8e$export$2e2bcd8739ae039),
    on: (0, $dd1fb49221ad966f$export$2e2bcd8739ae039),
    dispatch: (0, $27c639e461d8a390$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $98373fa9c0ecbfb2$export$2e2bcd8739ae039)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;


function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $914edae09cbfb4c0$export$524615cd03e458cc = {
    passive: false
};
const $914edae09cbfb4c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $914edae09cbfb4c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));



function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : b instanceof Date ? (0, $063cbb46f86ba478$export$2e2bcd8739ae039) : (0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $23bbf03008765dcc$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf536f4647e343d9$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))(a, b);
}


function $c447ae86a8320d39$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $1be794af963d8372$export$2e2bcd8739ae039(event, node) {
    event = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $e782289d8bd71451$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $150ba4634a330696$var$emptyOn = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $150ba4634a330696$export$a5d151aee16efd42) && schedule.state < (0, $150ba4634a330696$export$a2e792214ded83b2);
        schedule.state = (0, $150ba4634a330696$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this, name);
    });
}




var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $2938f7d64470581a$export$f0954fd7d5368655) : (0, $2938f7d64470581a$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bYoiY = parcelRequire("bYoiY");

function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039))(a, b);
}


function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $e4d1a233c7242264$export$da8cba906d64c082) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}



function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}



function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $9d186bb80d60f6c9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $9d186bb80d60f6c9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($9d186bb80d60f6c9$var$easeVarying(this._id, value));
}




function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $150ba4634a330696$export$2cd8252107eb640b) : (0, $150ba4634a330696$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}


function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}





function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $13be595fcf5febb7$var$Selection = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}







function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $e4d1a233c7242264$export$56bec7123bb3589a) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}



function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}


function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}




function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id0);
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $9c22ba9ec568d18f$export$2e2bcd8739ae039),
    selectAll: (0, $79e977f9a26c99f1$export$2e2bcd8739ae039),
    selectChild: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChild,
    selectChildren: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChildren,
    filter: (0, $c1e3543439d9f5fd$export$2e2bcd8739ae039),
    merge: (0, $e7e726720f484153$export$2e2bcd8739ae039),
    selection: (0, $13be595fcf5febb7$export$2e2bcd8739ae039),
    transition: (0, $e8ee9e113d6ecbba$export$2e2bcd8739ae039),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $fd664209e896113c$export$2e2bcd8739ae039),
    attr: (0, $2a651cfc4e49b53d$export$2e2bcd8739ae039),
    attrTween: (0, $cad13035adb29669$export$2e2bcd8739ae039),
    style: (0, $d0bf366fdef4c332$export$2e2bcd8739ae039),
    styleTween: (0, $83672080502c9717$export$2e2bcd8739ae039),
    text: (0, $e62b6dd5e7df40e7$export$2e2bcd8739ae039),
    textTween: (0, $64d823b28aa7019a$export$2e2bcd8739ae039),
    remove: (0, $b59e1b517983ad92$export$2e2bcd8739ae039),
    tween: (0, $922feb1dfe9c8dcf$export$2e2bcd8739ae039),
    delay: (0, $09cd57996bd81614$export$2e2bcd8739ae039),
    duration: (0, $9c9f124117d5bf14$export$2e2bcd8739ae039),
    ease: (0, $8ea7852b6976e6d1$export$2e2bcd8739ae039),
    easeVarying: (0, $9d186bb80d60f6c9$export$2e2bcd8739ae039),
    end: (0, $5220ae42feb560ba$export$2e2bcd8739ae039),
    [Symbol.iterator]: $a4d5b9ef4f9cfabb$var$selection_prototype[Symbol.iterator]
};



function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $5b131c7b61a09e82$export$89238d3bc79d3ada)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $e782289d8bd71451$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.interrupt = (0, $c1dd383074e2630e$export$2e2bcd8739ae039);
(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.transition = (0, $b5b43281074f9351$export$2e2bcd8739ae039);







var $4fc3d848825eb4c8$export$2e2bcd8739ae039 = (x)=>()=>x;


function $de0b5bec424cf247$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $48e2d3ac3b9a75ee$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
const { abs: $5c8970f4694d4107$var$abs, max: $5c8970f4694d4107$var$max, min: $5c8970f4694d4107$var$min } = Math;
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8385105b4986daed$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $de0b5bec424cf247$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && event.altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : $5c8970f4694d4107$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $5c8970f4694d4107$var$X ? N : $5c8970f4694d4107$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : $5c8970f4694d4107$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $5c8970f4694d4107$var$X ? S : $5c8970f4694d4107$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $1be794af963d8372$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($5c8970f4694d4107$var$abs(point.cur[0] - point[0]) > $5c8970f4694d4107$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[0][0])), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[0][1])), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $5c8970f4694d4107$var$max(W - e0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $5c8970f4694d4107$var$max(N - s0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, w0 - dx * signX)), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, n0 - dy * signY)), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $48e2d3ac3b9a75ee$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $905558291b0c219c$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}





parcelRequire("bYoiY");








function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $458fe095863893c0$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $458fe095863893c0$export$2e2bcd8739ae039),
    "s": (0, $fe491ef31c379765$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}


var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $f4c0f29ad920aaa1$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $95e9c493347f9308$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $dd689cef4c920567$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $fe491ef31c379765$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $e8b109bb95cf9845$export$2e2bcd8739ae039)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}


var $670604c4306869d0$export$6c421550c66a327d = 1e-6;
var $670604c4306869d0$export$92c06fba281fe81b = 1e-12;
var $670604c4306869d0$export$18c7bea995a110f = Math.PI;
var $670604c4306869d0$export$e51408a300e8929a = $670604c4306869d0$export$18c7bea995a110f / 2;
var $670604c4306869d0$export$c39a5cba78ea0fc2 = $670604c4306869d0$export$18c7bea995a110f / 4;
var $670604c4306869d0$export$a4b4b4d4d776fe92 = $670604c4306869d0$export$18c7bea995a110f * 2;
var $670604c4306869d0$export$41fc368e1a942b97 = 180 / $670604c4306869d0$export$18c7bea995a110f;
var $670604c4306869d0$export$8449e153fbd325fc = $670604c4306869d0$export$18c7bea995a110f / 180;
var $670604c4306869d0$export$2335f513bbd82c6d = Math.abs;
var $670604c4306869d0$export$628dc4eed22b0fbd = Math.atan;
var $670604c4306869d0$export$b8b770ee6a0d9760 = Math.atan2;
var $670604c4306869d0$export$50d414a77b60d802 = Math.cos;
var $670604c4306869d0$export$803ce6b71a0a94b2 = Math.ceil;
var $670604c4306869d0$export$b310ec824aaee37f = Math.exp;
var $670604c4306869d0$export$a3fe094919f356fd = Math.floor;
var $670604c4306869d0$export$f95c7888b62f8e9a = Math.hypot;
var $670604c4306869d0$export$bef1f36f5486a6a3 = Math.log;
var $670604c4306869d0$export$9c297f60e22e3389 = Math.pow;
var $670604c4306869d0$export$5de3937cb4b592ed = Math.sin;
var $670604c4306869d0$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $670604c4306869d0$export$eba8049fb5020b81 = Math.sqrt;
var $670604c4306869d0$export$fcdd3b0b3246a325 = Math.tan;
function $670604c4306869d0$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $670604c4306869d0$export$18c7bea995a110f : Math.acos(x);
}
function $670604c4306869d0$export$41726bdb1fc63f(x) {
    return x > 1 ? $670604c4306869d0$export$e51408a300e8929a : x < -1 ? -$670604c4306869d0$export$e51408a300e8929a : Math.asin(x);
}
function $670604c4306869d0$export$e808712c2966e662(x) {
    return (x = $670604c4306869d0$export$5de3937cb4b592ed(x / 2)) * x;
}



function $f233d25ba5a1175b$export$2e2bcd8739ae039() {}


function $2f42e5268a6797f5$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $f3f0691eeedc9e29$export$2e2bcd8739ae039(a, b) {
    return (0, $670604c4306869d0$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $670604c4306869d0$export$6c421550c66a327d) && (0, $670604c4306869d0$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $670604c4306869d0$export$6c421550c66a327d);
}



function $b2af5411bf749438$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $b2af5411bf749438$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $670604c4306869d0$export$6c421550c66a327d);
        }
        subject.push(x = new $b2af5411bf749438$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $b2af5411bf749438$var$Intersection(p0, null, x, false));
        subject.push(x = new $b2af5411bf749438$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $b2af5411bf749438$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $b2af5411bf749438$var$link(subject);
    $b2af5411bf749438$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $b2af5411bf749438$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}



// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $44a48d1cb1f34224$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $44a48d1cb1f34224$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $44a48d1cb1f34224$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $44a48d1cb1f34224$export$5a6391da70c130da(values, valueof) {
    const adder = new $44a48d1cb1f34224$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}



function $36ccb64133f7e1ee$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $670604c4306869d0$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $670604c4306869d0$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $36ccb64133f7e1ee$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $670604c4306869d0$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda),
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi)
    ];
}
function $36ccb64133f7e1ee$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $36ccb64133f7e1ee$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $36ccb64133f7e1ee$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $36ccb64133f7e1ee$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $36ccb64133f7e1ee$export$6789498aec2cb34b(d) {
    var l = (0, $670604c4306869d0$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}



function $3befe798acd13223$var$longitude(point) {
    return (0, $670604c4306869d0$export$2335f513bbd82c6d)(point[0]) <= (0, $670604c4306869d0$export$18c7bea995a110f) ? point[0] : (0, $670604c4306869d0$export$c5552dfdbc7cec71)(point[0]) * (((0, $670604c4306869d0$export$2335f513bbd82c6d)(point[0]) + (0, $670604c4306869d0$export$18c7bea995a110f)) % (0, $670604c4306869d0$export$a4b4b4d4d776fe92) - (0, $670604c4306869d0$export$18c7bea995a110f));
}
function $3befe798acd13223$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $3befe798acd13223$var$longitude(point), phi = point[1], sinPhi = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi), normal = [
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda),
        -(0, $670604c4306869d0$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $670604c4306869d0$export$e51408a300e8929a) + (0, $670604c4306869d0$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $3befe798acd13223$var$longitude(point0), phi0 = point0[1] / 2 + (0, $670604c4306869d0$export$c39a5cba78ea0fc2), sinPhi0 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $3befe798acd13223$var$longitude(point1), phi1 = point1[1] / 2 + (0, $670604c4306869d0$export$c39a5cba78ea0fc2), sinPhi1 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $670604c4306869d0$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $670604c4306869d0$export$b8b770ee6a0d9760)(k * sign * (0, $670604c4306869d0$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $670604c4306869d0$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $670604c4306869d0$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)((0, $36ccb64133f7e1ee$export$6e6697ef026a96)(point0), (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(point1));
                (0, $36ccb64133f7e1ee$export$6789498aec2cb34b)(arc);
                var intersection = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)(normal, arc);
                (0, $36ccb64133f7e1ee$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $670604c4306869d0$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $670604c4306869d0$export$6c421550c66a327d) || angle < (0, $670604c4306869d0$export$6c421550c66a327d) && sum < -(0, $670604c4306869d0$export$92c06fba281fe81b)) ^ winding & 1;
}


function* $54ced0ad7294c1a8$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $54ced0ad7294c1a8$export$2e2bcd8739ae039(arrays) {
    return Array.from($54ced0ad7294c1a8$var$flatten(arrays));
}


function $fbd6c74debefbf49$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $2f42e5268a6797f5$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $54ced0ad7294c1a8$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $3befe798acd13223$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $b2af5411bf749438$export$2e2bcd8739ae039)(segments, $fbd6c74debefbf49$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($fbd6c74debefbf49$var$validSegment));
        }
        return clip;
    };
}
function $fbd6c74debefbf49$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $fbd6c74debefbf49$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d) : (0, $670604c4306869d0$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d) : (0, $670604c4306869d0$export$e51408a300e8929a) - b[1]);
}



var $6887d3a2b3b1b107$export$2e2bcd8739ae039 = (0, $fbd6c74debefbf49$export$2e2bcd8739ae039)(function() {
    return true;
}, $6887d3a2b3b1b107$var$clipAntimeridianLine, $6887d3a2b3b1b107$var$clipAntimeridianInterpolate, [
    -(0, $670604c4306869d0$export$18c7bea995a110f),
    -(0, $670604c4306869d0$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $6887d3a2b3b1b107$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $670604c4306869d0$export$18c7bea995a110f) : -(0, $670604c4306869d0$export$18c7bea995a110f), delta = (0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(delta - (0, $670604c4306869d0$export$18c7bea995a110f)) < (0, $670604c4306869d0$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $670604c4306869d0$export$e51408a300e8929a) : -(0, $670604c4306869d0$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $670604c4306869d0$export$18c7bea995a110f)) {
                if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $670604c4306869d0$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $670604c4306869d0$export$6c421550c66a327d); // handle degeneracies
                if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $670604c4306869d0$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $670604c4306869d0$export$6c421550c66a327d);
                phi0 = $6887d3a2b3b1b107$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $6887d3a2b3b1b107$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $670604c4306869d0$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $670604c4306869d0$export$6c421550c66a327d) ? (0, $670604c4306869d0$export$628dc4eed22b0fbd)(((0, $670604c4306869d0$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi1)) * (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda1) - (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi0)) * (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $6887d3a2b3b1b107$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $670604c4306869d0$export$e51408a300e8929a);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $670604c4306869d0$export$18c7bea995a110f), phi);
        stream.point((0, $670604c4306869d0$export$18c7bea995a110f), 0);
        stream.point((0, $670604c4306869d0$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), -phi);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), 0);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), phi);
    } else if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $670604c4306869d0$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $670604c4306869d0$export$18c7bea995a110f) : -(0, $670604c4306869d0$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}




function $b8847947ca497f4e$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $2f457a25c4f4f64a$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $f7d73791d6cf97d0$var$rotationIdentity(lambda, phi) {
    if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda) > (0, $670604c4306869d0$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $670604c4306869d0$export$a4b4b4d4d776fe92)) * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
    return [
        lambda,
        phi
    ];
}
$f7d73791d6cf97d0$var$rotationIdentity.invert = $f7d73791d6cf97d0$var$rotationIdentity;
function $f7d73791d6cf97d0$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $670604c4306869d0$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $2f457a25c4f4f64a$export$2e2bcd8739ae039)($f7d73791d6cf97d0$var$rotationLambda(deltaLambda), $f7d73791d6cf97d0$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $f7d73791d6cf97d0$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $f7d73791d6cf97d0$var$rotationPhiGamma(deltaPhi, deltaGamma) : $f7d73791d6cf97d0$var$rotationIdentity;
}
function $f7d73791d6cf97d0$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda) > (0, $670604c4306869d0$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $670604c4306869d0$export$a4b4b4d4d776fe92)) * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
        return [
            lambda,
            phi
        ];
    };
}
function $f7d73791d6cf97d0$var$rotationLambda(deltaLambda) {
    var rotation = $f7d73791d6cf97d0$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $f7d73791d6cf97d0$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $f7d73791d6cf97d0$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $670604c4306869d0$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $670604c4306869d0$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $670604c4306869d0$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(phi), x = (0, $670604c4306869d0$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $670604c4306869d0$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $670604c4306869d0$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(phi), x = (0, $670604c4306869d0$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $670604c4306869d0$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $670604c4306869d0$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $f7d73791d6cf97d0$export$2e2bcd8739ae039(rotate) {
    rotate = $f7d73791d6cf97d0$export$a2ba89726971a90f(rotate[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), rotate[1] * (0, $670604c4306869d0$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $670604c4306869d0$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), coordinates[1] * (0, $670604c4306869d0$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates[1] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), coordinates[1] * (0, $670604c4306869d0$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates[1] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $d53290674478fba6$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $670604c4306869d0$export$50d414a77b60d802)(radius), sinRadius = (0, $670604c4306869d0$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $d53290674478fba6$var$circleRadius(cosRadius, t0);
        t1 = $d53290674478fba6$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $36ccb64133f7e1ee$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $670604c4306869d0$export$50d414a77b60d802)(t),
            -sinRadius * (0, $670604c4306869d0$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $d53290674478fba6$var$circleRadius(cosRadius, point) {
    point = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $36ccb64133f7e1ee$export$6789498aec2cb34b)(point);
    var radius = (0, $670604c4306869d0$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $670604c4306869d0$export$a4b4b4d4d776fe92) - (0, $670604c4306869d0$export$6c421550c66a327d)) % (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
}
function $d53290674478fba6$export$2e2bcd8739ae039() {
    var center = (0, $b8847947ca497f4e$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(90), precision = (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(2), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $670604c4306869d0$export$41fc368e1a942b97), x[1] *= (0, $670604c4306869d0$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $670604c4306869d0$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $670604c4306869d0$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $f7d73791d6cf97d0$export$a2ba89726971a90f)(-c[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), -c[1] * (0, $670604c4306869d0$export$8449e153fbd325fc), 0).invert;
        $d53290674478fba6$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $b8847947ca497f4e$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}





function $24a437a45f982759$export$2e2bcd8739ae039(radius) {
    var cr = (0, $670604c4306869d0$export$50d414a77b60d802)(radius), delta = 2 * (0, $670604c4306869d0$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $670604c4306869d0$export$2335f513bbd82c6d)(cr) > (0, $670604c4306869d0$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $d53290674478fba6$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $670604c4306869d0$export$50d414a77b60d802)(lambda) * (0, $670604c4306869d0$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $670604c4306869d0$export$18c7bea995a110f) : -(0, $670604c4306869d0$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(point0, point2) || (0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(a), pb = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)(n1, n2), A = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(n1, c1), B = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(n2, c2);
        (0, $36ccb64133f7e1ee$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(A, u), uu = (0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $670604c4306869d0$export$eba8049fb5020b81)(t2), q = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $36ccb64133f7e1ee$export$e62eba72fc898eae)(q, A);
        q = (0, $36ccb64133f7e1ee$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $670604c4306869d0$export$2335f513bbd82c6d)(delta - (0, $670604c4306869d0$export$18c7bea995a110f)) < (0, $670604c4306869d0$export$6c421550c66a327d), meridian = polar || delta < (0, $670604c4306869d0$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $670604c4306869d0$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $670604c4306869d0$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $670604c4306869d0$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $36ccb64133f7e1ee$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $36ccb64133f7e1ee$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $670604c4306869d0$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $fbd6c74debefbf49$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $670604c4306869d0$export$18c7bea995a110f),
        radius - (0, $670604c4306869d0$export$18c7bea995a110f)
    ]);
}




function $b55afac96a294cb9$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $7d62d240b7fd88a7$var$clipMax = 1e9, $7d62d240b7fd88a7$var$clipMin = -$7d62d240b7fd88a7$var$clipMax;
function $7d62d240b7fd88a7$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $670604c4306869d0$export$2335f513bbd82c6d)(p[0] - x0) < (0, $670604c4306869d0$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $670604c4306869d0$export$2335f513bbd82c6d)(p[0] - x1) < (0, $670604c4306869d0$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $670604c4306869d0$export$2335f513bbd82c6d)(p[1] - y0) < (0, $670604c4306869d0$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $2f42e5268a6797f5$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $54ced0ad7294c1a8$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $b2af5411bf749438$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, x_)),
                    y_ = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, y_))
                ], b = [
                    x = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, x)),
                    y = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, y))
                ];
                if ((0, $b55afac96a294cb9$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}



var $523470b6dc0fb943$export$2e2bcd8739ae039 = (x)=>x;




function $0412b2d170387dff$export$2e2bcd8739ae039(methods) {
    return {
        stream: $0412b2d170387dff$export$6b468dcfb64c653c(methods)
    };
}
function $0412b2d170387dff$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $0412b2d170387dff$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $0412b2d170387dff$var$TransformStream() {}
$0412b2d170387dff$var$TransformStream.prototype = {
    constructor: $0412b2d170387dff$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};


function $f64eb890237a613b$var$streamGeometry(geometry, stream) {
    if (geometry && $f64eb890237a613b$var$streamGeometryType.hasOwnProperty(geometry.type)) $f64eb890237a613b$var$streamGeometryType[geometry.type](geometry, stream);
}
var $f64eb890237a613b$var$streamObjectType = {
    Feature: function(object, stream) {
        $f64eb890237a613b$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$f64eb890237a613b$var$streamGeometry(features[i].geometry, stream);
    }
};
var $f64eb890237a613b$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $f64eb890237a613b$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f64eb890237a613b$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $f64eb890237a613b$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f64eb890237a613b$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$f64eb890237a613b$var$streamGeometry(geometries[i], stream);
    }
};
function $f64eb890237a613b$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $f64eb890237a613b$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$f64eb890237a613b$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $f64eb890237a613b$export$2e2bcd8739ae039(object, stream) {
    if (object && $f64eb890237a613b$var$streamObjectType.hasOwnProperty(object.type)) $f64eb890237a613b$var$streamObjectType[object.type](object, stream);
    else $f64eb890237a613b$var$streamGeometry(object, stream);
}



var $efdab2656f7d9ccc$var$x0 = Infinity, $efdab2656f7d9ccc$var$y0 = $efdab2656f7d9ccc$var$x0, $efdab2656f7d9ccc$var$x1 = -$efdab2656f7d9ccc$var$x0, $efdab2656f7d9ccc$var$y1 = $efdab2656f7d9ccc$var$x1;
var $efdab2656f7d9ccc$var$boundsStream = {
    point: $efdab2656f7d9ccc$var$boundsPoint,
    lineStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $efdab2656f7d9ccc$var$x0,
                $efdab2656f7d9ccc$var$y0
            ],
            [
                $efdab2656f7d9ccc$var$x1,
                $efdab2656f7d9ccc$var$y1
            ]
        ];
        $efdab2656f7d9ccc$var$x1 = $efdab2656f7d9ccc$var$y1 = -($efdab2656f7d9ccc$var$y0 = $efdab2656f7d9ccc$var$x0 = Infinity);
        return bounds;
    }
};
function $efdab2656f7d9ccc$var$boundsPoint(x, y) {
    if (x < $efdab2656f7d9ccc$var$x0) $efdab2656f7d9ccc$var$x0 = x;
    if (x > $efdab2656f7d9ccc$var$x1) $efdab2656f7d9ccc$var$x1 = x;
    if (y < $efdab2656f7d9ccc$var$y0) $efdab2656f7d9ccc$var$y0 = y;
    if (y > $efdab2656f7d9ccc$var$y1) $efdab2656f7d9ccc$var$y1 = y;
}
var $efdab2656f7d9ccc$export$2e2bcd8739ae039 = $efdab2656f7d9ccc$var$boundsStream;


function $f635eb16c9b15b07$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projection.stream((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039)));
    fitBounds((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $f635eb16c9b15b07$export$e450184041869e7f(projection, extent, object) {
    return $f635eb16c9b15b07$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $f635eb16c9b15b07$export$33a367fa1728c3ba(projection, size, object) {
    return $f635eb16c9b15b07$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $f635eb16c9b15b07$export$7d8f2192ef31c5a7(projection, width, object) {
    return $f635eb16c9b15b07$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $f635eb16c9b15b07$export$7069bab0d2ced675(projection, height, object) {
    return $f635eb16c9b15b07$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $64af1b85c5f97f77$var$maxDepth = 16, $64af1b85c5f97f77$var$cosMinDistance = (0, $670604c4306869d0$export$50d414a77b60d802)(30 * (0, $670604c4306869d0$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $64af1b85c5f97f77$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $64af1b85c5f97f77$var$resample(project, delta2) : $64af1b85c5f97f77$var$resampleNone(project);
}
function $64af1b85c5f97f77$var$resampleNone(project) {
    return (0, $0412b2d170387dff$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $64af1b85c5f97f77$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $670604c4306869d0$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $670604c4306869d0$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $670604c4306869d0$export$2335f513bbd82c6d)((0, $670604c4306869d0$export$2335f513bbd82c6d)(c) - 1) < (0, $670604c4306869d0$export$6c421550c66a327d) || (0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $670604c4306869d0$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $670604c4306869d0$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $670604c4306869d0$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $64af1b85c5f97f77$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $64af1b85c5f97f77$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $64af1b85c5f97f77$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $5ee116a807460c55$var$transformRadians = (0, $0412b2d170387dff$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $670604c4306869d0$export$8449e153fbd325fc), y * (0, $670604c4306869d0$export$8449e153fbd325fc));
    }
});
function $5ee116a807460c55$var$transformRotate(rotate) {
    return (0, $0412b2d170387dff$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $5ee116a807460c55$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $5ee116a807460c55$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $5ee116a807460c55$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $670604c4306869d0$export$50d414a77b60d802)(alpha), sinAlpha = (0, $670604c4306869d0$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $5ee116a807460c55$export$2e2bcd8739ae039(project) {
    return $5ee116a807460c55$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $5ee116a807460c55$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $6887d3a2b3b1b107$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $523470b6dc0fb943$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), point[1] * (0, $670604c4306869d0$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $670604c4306869d0$export$41fc368e1a942b97),
            point[1] * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $5ee116a807460c55$var$transformRadians($5ee116a807460c55$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $24a437a45f982759$export$2e2bcd8739ae039)(theta = _ * (0, $670604c4306869d0$export$8449e153fbd325fc)) : (theta = null, $6887d3a2b3b1b107$export$2e2bcd8739ae039), reset()) : theta * (0, $670604c4306869d0$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $523470b6dc0fb943$export$2e2bcd8739ae039) : (0, $7d62d240b7fd88a7$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $670604c4306869d0$export$41fc368e1a942b97),
            phi * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $670604c4306869d0$export$41fc368e1a942b97),
            deltaPhi * (0, $670604c4306869d0$export$41fc368e1a942b97),
            deltaGamma * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), recenter()) : alpha * (0, $670604c4306869d0$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $64af1b85c5f97f77$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $670604c4306869d0$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $f635eb16c9b15b07$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $f635eb16c9b15b07$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $f635eb16c9b15b07$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $f635eb16c9b15b07$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $5ee116a807460c55$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $5ee116a807460c55$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $f7d73791d6cf97d0$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $2f457a25c4f4f64a$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $2f457a25c4f4f64a$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $64af1b85c5f97f77$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $91fc065f2c677322$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $670604c4306869d0$export$18c7bea995a110f) / 3, m = (0, $5ee116a807460c55$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), phi1 = _[1] * (0, $670604c4306869d0$export$8449e153fbd325fc)) : [
            phi0 * (0, $670604c4306869d0$export$41fc368e1a942b97),
            phi1 * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $5474082c8e90dfac$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $670604c4306869d0$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $be3cbe5874066802$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $670604c4306869d0$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(n) < (0, $670604c4306869d0$export$6c421550c66a327d)) return (0, $5474082c8e90dfac$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $670604c4306869d0$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $670604c4306869d0$export$eba8049fb5020b81)(c - 2 * n * (0, $670604c4306869d0$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $670604c4306869d0$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x, (0, $670604c4306869d0$export$2335f513bbd82c6d)(r0y)) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(r0y);
        if (r0y * n < 0) l -= (0, $670604c4306869d0$export$18c7bea995a110f) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(x) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(r0y);
        return [
            l / n,
            (0, $670604c4306869d0$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $be3cbe5874066802$export$2e2bcd8739ae039() {
    return (0, $91fc065f2c677322$export$228272587c4d24d8)($be3cbe5874066802$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $189dcd4c41cb3d8a$export$2e2bcd8739ae039() {
    return (0, $be3cbe5874066802$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $dae3a16b5ba78504$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $dae3a16b5ba78504$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $189dcd4c41cb3d8a$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $be3cbe5874066802$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $be3cbe5874066802$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $dae3a16b5ba78504$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.120 * k + (0, $670604c4306869d0$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.234 * k - (0, $670604c4306869d0$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.166 * k + (0, $670604c4306869d0$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.234 * k - (0, $670604c4306869d0$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $f635eb16c9b15b07$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $f635eb16c9b15b07$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $f635eb16c9b15b07$export$7d8f2192ef31c5a7)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $f635eb16c9b15b07$export$7069bab0d2ced675)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}



function $8549f9238ecb0bb6$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $670604c4306869d0$export$50d414a77b60d802)(x), cy = (0, $670604c4306869d0$export$50d414a77b60d802)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x),
            k * (0, $670604c4306869d0$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $8549f9238ecb0bb6$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $670604c4306869d0$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $670604c4306869d0$export$5de3937cb4b592ed)(c), cc = (0, $670604c4306869d0$export$50d414a77b60d802)(c);
        return [
            (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $670604c4306869d0$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



var $cde1dad42250dd7d$export$5e11f94fc4a8d2c6 = (0, $8549f9238ecb0bb6$export$f1211ac1bdb0796)(function(cxcy) {
    return (0, $670604c4306869d0$export$eba8049fb5020b81)(2 / (1 + cxcy));
});
$cde1dad42250dd7d$export$5e11f94fc4a8d2c6.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $670604c4306869d0$export$41726bdb1fc63f)(z / 2);
});
function $cde1dad42250dd7d$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($cde1dad42250dd7d$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}




var $7a9894a70b3e10e2$export$b94a4d6aa3dd25c = (0, $8549f9238ecb0bb6$export$f1211ac1bdb0796)(function(c) {
    return (c = (0, $670604c4306869d0$export$fd6306be3fde5b04)(c)) && c / (0, $670604c4306869d0$export$5de3937cb4b592ed)(c);
});
$7a9894a70b3e10e2$export$b94a4d6aa3dd25c.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)(function(z) {
    return z;
});
function $7a9894a70b3e10e2$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($7a9894a70b3e10e2$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}






function $ff090f04ba81e8e2$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $670604c4306869d0$export$bef1f36f5486a6a3)((0, $670604c4306869d0$export$fcdd3b0b3246a325)(((0, $670604c4306869d0$export$e51408a300e8929a) + phi) / 2))
    ];
}
$ff090f04ba81e8e2$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)((0, $670604c4306869d0$export$b310ec824aaee37f)(y)) - (0, $670604c4306869d0$export$e51408a300e8929a)
    ];
};
function $ff090f04ba81e8e2$export$2e2bcd8739ae039() {
    return $ff090f04ba81e8e2$export$44b9b66a01f2127b($ff090f04ba81e8e2$export$94ff8a57e9b91cc3).scale(961 / (0, $670604c4306869d0$export$a4b4b4d4d776fe92));
}
function $ff090f04ba81e8e2$export$44b9b66a01f2127b(project) {
    var m = (0, $5ee116a807460c55$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $670604c4306869d0$export$18c7bea995a110f) * scale(), t = m((0, $f7d73791d6cf97d0$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $ff090f04ba81e8e2$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}


function $c71ea640260518ba$var$tany(y) {
    return (0, $670604c4306869d0$export$fcdd3b0b3246a325)(((0, $670604c4306869d0$export$e51408a300e8929a) + y) / 2);
}
function $c71ea640260518ba$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $670604c4306869d0$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $670604c4306869d0$export$5de3937cb4b592ed)(y0) : (0, $670604c4306869d0$export$bef1f36f5486a6a3)(cy0 / (0, $670604c4306869d0$export$50d414a77b60d802)(y1)) / (0, $670604c4306869d0$export$bef1f36f5486a6a3)($c71ea640260518ba$var$tany(y1) / $c71ea640260518ba$var$tany(y0)), f = cy0 * (0, $670604c4306869d0$export$9c297f60e22e3389)($c71ea640260518ba$var$tany(y0), n) / n;
    if (!n) return 0, $ff090f04ba81e8e2$export$94ff8a57e9b91cc3;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $670604c4306869d0$export$e51408a300e8929a) + (0, $670604c4306869d0$export$6c421550c66a327d)) y = -(0, $670604c4306869d0$export$e51408a300e8929a) + (0, $670604c4306869d0$export$6c421550c66a327d);
        } else if (y > (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d)) y = (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d);
        var r = f / (0, $670604c4306869d0$export$9c297f60e22e3389)($c71ea640260518ba$var$tany(y), n);
        return [
            r * (0, $670604c4306869d0$export$5de3937cb4b592ed)(n * x),
            f - r * (0, $670604c4306869d0$export$50d414a77b60d802)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $670604c4306869d0$export$c5552dfdbc7cec71)(n) * (0, $670604c4306869d0$export$eba8049fb5020b81)(x * x + fy * fy), l = (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x, (0, $670604c4306869d0$export$2335f513bbd82c6d)(fy)) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(fy);
        if (fy * n < 0) l -= (0, $670604c4306869d0$export$18c7bea995a110f) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(x) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(fy);
        return [
            l / n,
            2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)((0, $670604c4306869d0$export$9c297f60e22e3389)(f / r, 1 / n)) - (0, $670604c4306869d0$export$e51408a300e8929a)
        ];
    };
    return project;
}
function $c71ea640260518ba$export$2e2bcd8739ae039() {
    return (0, $91fc065f2c677322$export$228272587c4d24d8)($c71ea640260518ba$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}




function $b150c6d84b26cddf$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$b150c6d84b26cddf$export$f5fee52180f2f058.invert = $b150c6d84b26cddf$export$f5fee52180f2f058;
function $b150c6d84b26cddf$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($b150c6d84b26cddf$export$f5fee52180f2f058).scale(152.63);
}


function $d8f5b846585bb1cd$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $670604c4306869d0$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $670604c4306869d0$export$5de3937cb4b592ed)(y0) : (cy0 - (0, $670604c4306869d0$export$50d414a77b60d802)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(n) < (0, $670604c4306869d0$export$6c421550c66a327d)) return 0, $b150c6d84b26cddf$export$f5fee52180f2f058;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(nx),
            g - gy * (0, $670604c4306869d0$export$50d414a77b60d802)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x, (0, $670604c4306869d0$export$2335f513bbd82c6d)(gy)) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(gy);
        if (gy * n < 0) l -= (0, $670604c4306869d0$export$18c7bea995a110f) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(x) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(gy);
        return [
            l / n,
            g - (0, $670604c4306869d0$export$c5552dfdbc7cec71)(n) * (0, $670604c4306869d0$export$eba8049fb5020b81)(x * x + gy * gy)
        ];
    };
    return project;
}
function $d8f5b846585bb1cd$export$2e2bcd8739ae039() {
    return (0, $91fc065f2c677322$export$228272587c4d24d8)($d8f5b846585bb1cd$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}



var $fc041bd5ad9011bc$var$A1 = 1.340264, $fc041bd5ad9011bc$var$A2 = -0.081106, $fc041bd5ad9011bc$var$A3 = 0.000893, $fc041bd5ad9011bc$var$A4 = 0.003796, $fc041bd5ad9011bc$var$M = (0, $670604c4306869d0$export$eba8049fb5020b81)(3) / 2, $fc041bd5ad9011bc$var$iterations = 12;
function $fc041bd5ad9011bc$export$a320734067e7a731(lambda, phi) {
    var l = (0, $670604c4306869d0$export$41726bdb1fc63f)($fc041bd5ad9011bc$var$M * (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $670604c4306869d0$export$50d414a77b60d802)(l) / ($fc041bd5ad9011bc$var$M * ($fc041bd5ad9011bc$var$A1 + 3 * $fc041bd5ad9011bc$var$A2 * l2 + l6 * (7 * $fc041bd5ad9011bc$var$A3 + 9 * $fc041bd5ad9011bc$var$A4 * l2))),
        l * ($fc041bd5ad9011bc$var$A1 + $fc041bd5ad9011bc$var$A2 * l2 + l6 * ($fc041bd5ad9011bc$var$A3 + $fc041bd5ad9011bc$var$A4 * l2))
    ];
}
$fc041bd5ad9011bc$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $fc041bd5ad9011bc$var$iterations; ++i){
        fy = l * ($fc041bd5ad9011bc$var$A1 + $fc041bd5ad9011bc$var$A2 * l2 + l6 * ($fc041bd5ad9011bc$var$A3 + $fc041bd5ad9011bc$var$A4 * l2)) - y;
        fpy = $fc041bd5ad9011bc$var$A1 + 3 * $fc041bd5ad9011bc$var$A2 * l2 + l6 * (7 * $fc041bd5ad9011bc$var$A3 + 9 * $fc041bd5ad9011bc$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(delta) < (0, $670604c4306869d0$export$92c06fba281fe81b)) break;
    }
    return [
        $fc041bd5ad9011bc$var$M * x * ($fc041bd5ad9011bc$var$A1 + 3 * $fc041bd5ad9011bc$var$A2 * l2 + l6 * (7 * $fc041bd5ad9011bc$var$A3 + 9 * $fc041bd5ad9011bc$var$A4 * l2)) / (0, $670604c4306869d0$export$50d414a77b60d802)(l),
        (0, $670604c4306869d0$export$41726bdb1fc63f)((0, $670604c4306869d0$export$5de3937cb4b592ed)(l) / $fc041bd5ad9011bc$var$M)
    ];
};
function $fc041bd5ad9011bc$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($fc041bd5ad9011bc$export$a320734067e7a731).scale(177.158);
}




function $ec357a35bfb88504$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $670604c4306869d0$export$50d414a77b60d802)(y), k = (0, $670604c4306869d0$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x) / k,
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(y) / k
    ];
}
$ec357a35bfb88504$export$dc8c6ddfc8b22c85.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)((0, $670604c4306869d0$export$628dc4eed22b0fbd));
function $ec357a35bfb88504$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($ec357a35bfb88504$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}




function $5bed72effbe81a9c$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $670604c4306869d0$export$50d414a77b60d802)(y) * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x),
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(y)
    ];
}
$5bed72effbe81a9c$export$1cd9c2eb846182a.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)((0, $670604c4306869d0$export$41726bdb1fc63f));
function $5bed72effbe81a9c$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($5bed72effbe81a9c$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $670604c4306869d0$export$6c421550c66a327d));
}






var $aac5fcedac7c8011$var$areaSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $aac5fcedac7c8011$var$areaRingSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $aac5fcedac7c8011$var$x00, $aac5fcedac7c8011$var$y00, $aac5fcedac7c8011$var$x0, $aac5fcedac7c8011$var$y0;
var $aac5fcedac7c8011$var$areaStream = {
    point: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonStart: function() {
        $aac5fcedac7c8011$var$areaStream.lineStart = $aac5fcedac7c8011$var$areaRingStart;
        $aac5fcedac7c8011$var$areaStream.lineEnd = $aac5fcedac7c8011$var$areaRingEnd;
    },
    polygonEnd: function() {
        $aac5fcedac7c8011$var$areaStream.lineStart = $aac5fcedac7c8011$var$areaStream.lineEnd = $aac5fcedac7c8011$var$areaStream.point = (0, $f233d25ba5a1175b$export$2e2bcd8739ae039);
        $aac5fcedac7c8011$var$areaSum.add((0, $670604c4306869d0$export$2335f513bbd82c6d)($aac5fcedac7c8011$var$areaRingSum));
        $aac5fcedac7c8011$var$areaRingSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $aac5fcedac7c8011$var$areaSum / 2;
        $aac5fcedac7c8011$var$areaSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
        return area;
    }
};
function $aac5fcedac7c8011$var$areaRingStart() {
    $aac5fcedac7c8011$var$areaStream.point = $aac5fcedac7c8011$var$areaPointFirst;
}
function $aac5fcedac7c8011$var$areaPointFirst(x, y) {
    $aac5fcedac7c8011$var$areaStream.point = $aac5fcedac7c8011$var$areaPoint;
    $aac5fcedac7c8011$var$x00 = $aac5fcedac7c8011$var$x0 = x, $aac5fcedac7c8011$var$y00 = $aac5fcedac7c8011$var$y0 = y;
}
function $aac5fcedac7c8011$var$areaPoint(x, y) {
    $aac5fcedac7c8011$var$areaRingSum.add($aac5fcedac7c8011$var$y0 * x - $aac5fcedac7c8011$var$x0 * y);
    $aac5fcedac7c8011$var$x0 = x, $aac5fcedac7c8011$var$y0 = y;
}
function $aac5fcedac7c8011$var$areaRingEnd() {
    $aac5fcedac7c8011$var$areaPoint($aac5fcedac7c8011$var$x00, $aac5fcedac7c8011$var$y00);
}
var $aac5fcedac7c8011$export$2e2bcd8739ae039 = $aac5fcedac7c8011$var$areaStream;




// TODO Enforce positive area for exterior, negative area for interior?
var $8d0804faef1e75f0$var$X0 = 0, $8d0804faef1e75f0$var$Y0 = 0, $8d0804faef1e75f0$var$Z0 = 0, $8d0804faef1e75f0$var$X1 = 0, $8d0804faef1e75f0$var$Y1 = 0, $8d0804faef1e75f0$var$Z1 = 0, $8d0804faef1e75f0$var$X2 = 0, $8d0804faef1e75f0$var$Y2 = 0, $8d0804faef1e75f0$var$Z2 = 0, $8d0804faef1e75f0$var$x00, $8d0804faef1e75f0$var$y00, $8d0804faef1e75f0$var$x0, $8d0804faef1e75f0$var$y0;
var $8d0804faef1e75f0$var$centroidStream = {
    point: $8d0804faef1e75f0$var$centroidPoint,
    lineStart: $8d0804faef1e75f0$var$centroidLineStart,
    lineEnd: $8d0804faef1e75f0$var$centroidLineEnd,
    polygonStart: function() {
        $8d0804faef1e75f0$var$centroidStream.lineStart = $8d0804faef1e75f0$var$centroidRingStart;
        $8d0804faef1e75f0$var$centroidStream.lineEnd = $8d0804faef1e75f0$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPoint;
        $8d0804faef1e75f0$var$centroidStream.lineStart = $8d0804faef1e75f0$var$centroidLineStart;
        $8d0804faef1e75f0$var$centroidStream.lineEnd = $8d0804faef1e75f0$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $8d0804faef1e75f0$var$Z2 ? [
            $8d0804faef1e75f0$var$X2 / $8d0804faef1e75f0$var$Z2,
            $8d0804faef1e75f0$var$Y2 / $8d0804faef1e75f0$var$Z2
        ] : $8d0804faef1e75f0$var$Z1 ? [
            $8d0804faef1e75f0$var$X1 / $8d0804faef1e75f0$var$Z1,
            $8d0804faef1e75f0$var$Y1 / $8d0804faef1e75f0$var$Z1
        ] : $8d0804faef1e75f0$var$Z0 ? [
            $8d0804faef1e75f0$var$X0 / $8d0804faef1e75f0$var$Z0,
            $8d0804faef1e75f0$var$Y0 / $8d0804faef1e75f0$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $8d0804faef1e75f0$var$X0 = $8d0804faef1e75f0$var$Y0 = $8d0804faef1e75f0$var$Z0 = $8d0804faef1e75f0$var$X1 = $8d0804faef1e75f0$var$Y1 = $8d0804faef1e75f0$var$Z1 = $8d0804faef1e75f0$var$X2 = $8d0804faef1e75f0$var$Y2 = $8d0804faef1e75f0$var$Z2 = 0;
        return centroid;
    }
};
function $8d0804faef1e75f0$var$centroidPoint(x, y) {
    $8d0804faef1e75f0$var$X0 += x;
    $8d0804faef1e75f0$var$Y0 += y;
    ++$8d0804faef1e75f0$var$Z0;
}
function $8d0804faef1e75f0$var$centroidLineStart() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointFirstLine;
}
function $8d0804faef1e75f0$var$centroidPointFirstLine(x, y) {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointLine;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidPointLine(x, y) {
    var dx = x - $8d0804faef1e75f0$var$x0, dy = y - $8d0804faef1e75f0$var$y0, z = (0, $670604c4306869d0$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $8d0804faef1e75f0$var$X1 += z * ($8d0804faef1e75f0$var$x0 + x) / 2;
    $8d0804faef1e75f0$var$Y1 += z * ($8d0804faef1e75f0$var$y0 + y) / 2;
    $8d0804faef1e75f0$var$Z1 += z;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidLineEnd() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPoint;
}
function $8d0804faef1e75f0$var$centroidRingStart() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointFirstRing;
}
function $8d0804faef1e75f0$var$centroidRingEnd() {
    $8d0804faef1e75f0$var$centroidPointRing($8d0804faef1e75f0$var$x00, $8d0804faef1e75f0$var$y00);
}
function $8d0804faef1e75f0$var$centroidPointFirstRing(x, y) {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointRing;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x00 = $8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y00 = $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidPointRing(x, y) {
    var dx = x - $8d0804faef1e75f0$var$x0, dy = y - $8d0804faef1e75f0$var$y0, z = (0, $670604c4306869d0$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $8d0804faef1e75f0$var$X1 += z * ($8d0804faef1e75f0$var$x0 + x) / 2;
    $8d0804faef1e75f0$var$Y1 += z * ($8d0804faef1e75f0$var$y0 + y) / 2;
    $8d0804faef1e75f0$var$Z1 += z;
    z = $8d0804faef1e75f0$var$y0 * x - $8d0804faef1e75f0$var$x0 * y;
    $8d0804faef1e75f0$var$X2 += z * ($8d0804faef1e75f0$var$x0 + x);
    $8d0804faef1e75f0$var$Y2 += z * ($8d0804faef1e75f0$var$y0 + y);
    $8d0804faef1e75f0$var$Z2 += z * 3;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
var $8d0804faef1e75f0$export$2e2bcd8739ae039 = $8d0804faef1e75f0$var$centroidStream;




function $bc272bd0e70c3e89$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$bc272bd0e70c3e89$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $670604c4306869d0$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039)
};





var $9d42a1f4ad2437ef$var$lengthSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $9d42a1f4ad2437ef$var$lengthRing, $9d42a1f4ad2437ef$var$x00, $9d42a1f4ad2437ef$var$y00, $9d42a1f4ad2437ef$var$x0, $9d42a1f4ad2437ef$var$y0;
var $9d42a1f4ad2437ef$var$lengthStream = {
    point: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineStart: function() {
        $9d42a1f4ad2437ef$var$lengthStream.point = $9d42a1f4ad2437ef$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($9d42a1f4ad2437ef$var$lengthRing) $9d42a1f4ad2437ef$var$lengthPoint($9d42a1f4ad2437ef$var$x00, $9d42a1f4ad2437ef$var$y00);
        $9d42a1f4ad2437ef$var$lengthStream.point = (0, $f233d25ba5a1175b$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $9d42a1f4ad2437ef$var$lengthRing = true;
    },
    polygonEnd: function() {
        $9d42a1f4ad2437ef$var$lengthRing = null;
    },
    result: function() {
        var length = +$9d42a1f4ad2437ef$var$lengthSum;
        $9d42a1f4ad2437ef$var$lengthSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
        return length;
    }
};
function $9d42a1f4ad2437ef$var$lengthPointFirst(x, y) {
    $9d42a1f4ad2437ef$var$lengthStream.point = $9d42a1f4ad2437ef$var$lengthPoint;
    $9d42a1f4ad2437ef$var$x00 = $9d42a1f4ad2437ef$var$x0 = x, $9d42a1f4ad2437ef$var$y00 = $9d42a1f4ad2437ef$var$y0 = y;
}
function $9d42a1f4ad2437ef$var$lengthPoint(x, y) {
    $9d42a1f4ad2437ef$var$x0 -= x, $9d42a1f4ad2437ef$var$y0 -= y;
    $9d42a1f4ad2437ef$var$lengthSum.add((0, $670604c4306869d0$export$eba8049fb5020b81)($9d42a1f4ad2437ef$var$x0 * $9d42a1f4ad2437ef$var$x0 + $9d42a1f4ad2437ef$var$y0 * $9d42a1f4ad2437ef$var$y0));
    $9d42a1f4ad2437ef$var$x0 = x, $9d42a1f4ad2437ef$var$y0 = y;
}
var $9d42a1f4ad2437ef$export$2e2bcd8739ae039 = $9d42a1f4ad2437ef$var$lengthStream;


// Simple caching for constant-radius points.
let $eeca8dbd32c6e6b7$var$cacheDigits, $eeca8dbd32c6e6b7$var$cacheAppend, $eeca8dbd32c6e6b7$var$cacheRadius, $eeca8dbd32c6e6b7$var$cacheCircle;
class $eeca8dbd32c6e6b7$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $eeca8dbd32c6e6b7$var$append : $eeca8dbd32c6e6b7$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $eeca8dbd32c6e6b7$var$cacheRadius || this._append !== $eeca8dbd32c6e6b7$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $eeca8dbd32c6e6b7$var$cacheRadius = r;
                    $eeca8dbd32c6e6b7$var$cacheAppend = this._append;
                    $eeca8dbd32c6e6b7$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $eeca8dbd32c6e6b7$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $eeca8dbd32c6e6b7$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $eeca8dbd32c6e6b7$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $eeca8dbd32c6e6b7$var$append;
    if (d !== $eeca8dbd32c6e6b7$var$cacheDigits) {
        const k = 10 ** d;
        $eeca8dbd32c6e6b7$var$cacheDigits = d;
        $eeca8dbd32c6e6b7$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $eeca8dbd32c6e6b7$var$cacheAppend;
}


function $58c46562f4a8d739$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $aac5fcedac7c8011$export$2e2bcd8739ae039)));
        return (0, $aac5fcedac7c8011$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $9d42a1f4ad2437ef$export$2e2bcd8739ae039)));
        return (0, $9d42a1f4ad2437ef$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039)));
        return (0, $efdab2656f7d9ccc$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $8d0804faef1e75f0$export$2e2bcd8739ae039)));
        return (0, $8d0804faef1e75f0$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $523470b6dc0fb943$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $eeca8dbd32c6e6b7$export$2e2bcd8739ae039)(digits)) : new (0, $bc272bd0e70c3e89$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $eeca8dbd32c6e6b7$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}




function $30512e786dc906d9$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $670604c4306869d0$export$50d414a77b60d802)(y), k = 1 + (0, $670604c4306869d0$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x) / k,
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(y) / k
    ];
}
$30512e786dc906d9$export$f9ccbb0dcb3dcd2b.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)(z);
});
function $30512e786dc906d9$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($30512e786dc906d9$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}



function $75766842dfa94e14$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $670604c4306869d0$export$bef1f36f5486a6a3)((0, $670604c4306869d0$export$fcdd3b0b3246a325)(((0, $670604c4306869d0$export$e51408a300e8929a) + phi) / 2)),
        -lambda
    ];
}
$75766842dfa94e14$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)((0, $670604c4306869d0$export$b310ec824aaee37f)(x)) - (0, $670604c4306869d0$export$e51408a300e8929a)
    ];
};
function $75766842dfa94e14$export$2e2bcd8739ae039() {
    var m = (0, $ff090f04ba81e8e2$export$44b9b66a01f2127b)($75766842dfa94e14$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}




var $bfWFq = parcelRequire("bfWFq");

var $bYoiY = parcelRequire("bYoiY");
const $70576c5c5ae147f6$export$8449e153fbd325fc = Math.PI / 180;
const $70576c5c5ae147f6$export$41fc368e1a942b97 = 180 / Math.PI;


// https://observablehq.com/@mbostock/lab-and-rgb
const $80e69e9a1ed94a67$var$K = 18, $80e69e9a1ed94a67$var$Xn = 0.96422, $80e69e9a1ed94a67$var$Yn = 1, $80e69e9a1ed94a67$var$Zn = 0.82521, $80e69e9a1ed94a67$var$t0 = 4 / 29, $80e69e9a1ed94a67$var$t1 = 6 / 29, $80e69e9a1ed94a67$var$t2 = 3 * $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1, $80e69e9a1ed94a67$var$t3 = $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1;
function $80e69e9a1ed94a67$var$labConvert(o) {
    if (o instanceof $80e69e9a1ed94a67$export$f2722c70a60257f7) return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $80e69e9a1ed94a67$export$d9397e094a5fbb9a) return $80e69e9a1ed94a67$var$hcl2lab(o);
    if (!(o instanceof (0, $bYoiY.Rgb))) o = (0, $bYoiY.rgbConvert)(o);
    var r = $80e69e9a1ed94a67$var$rgb2lrgb(o.r), g = $80e69e9a1ed94a67$var$rgb2lrgb(o.g), b = $80e69e9a1ed94a67$var$rgb2lrgb(o.b), y = $80e69e9a1ed94a67$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $80e69e9a1ed94a67$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $80e69e9a1ed94a67$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $80e69e9a1ed94a67$var$Xn);
        z = $80e69e9a1ed94a67$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $80e69e9a1ed94a67$var$Zn);
    }
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $80e69e9a1ed94a67$export$3e2c219d3ab79d01(l, opacity) {
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$labConvert(l) : new $80e69e9a1ed94a67$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)($80e69e9a1ed94a67$export$f2722c70a60257f7, $80e69e9a1ed94a67$export$2e2bcd8739ae039, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        return new $80e69e9a1ed94a67$export$f2722c70a60257f7(this.l + $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $80e69e9a1ed94a67$export$f2722c70a60257f7(this.l - $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $80e69e9a1ed94a67$var$Xn * $80e69e9a1ed94a67$var$lab2xyz(x);
        y = $80e69e9a1ed94a67$var$Yn * $80e69e9a1ed94a67$var$lab2xyz(y);
        z = $80e69e9a1ed94a67$var$Zn * $80e69e9a1ed94a67$var$lab2xyz(z);
        return new (0, $bYoiY.Rgb)($80e69e9a1ed94a67$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $80e69e9a1ed94a67$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $80e69e9a1ed94a67$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $80e69e9a1ed94a67$var$xyz2lab(t) {
    return t > $80e69e9a1ed94a67$var$t3 ? Math.pow(t, 1 / 3) : t / $80e69e9a1ed94a67$var$t2 + $80e69e9a1ed94a67$var$t0;
}
function $80e69e9a1ed94a67$var$lab2xyz(t) {
    return t > $80e69e9a1ed94a67$var$t1 ? t * t * t : $80e69e9a1ed94a67$var$t2 * (t - $80e69e9a1ed94a67$var$t0);
}
function $80e69e9a1ed94a67$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $80e69e9a1ed94a67$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $80e69e9a1ed94a67$var$hclConvert(o) {
    if (o instanceof $80e69e9a1ed94a67$export$d9397e094a5fbb9a) return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $80e69e9a1ed94a67$export$f2722c70a60257f7)) o = $80e69e9a1ed94a67$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $70576c5c5ae147f6$export$41fc368e1a942b97);
    return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $80e69e9a1ed94a67$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$hclConvert(l) : new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$hclConvert(h) : new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $80e69e9a1ed94a67$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $70576c5c5ae147f6$export$8449e153fbd325fc);
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $bfWFq.default)($80e69e9a1ed94a67$export$d9397e094a5fbb9a, $80e69e9a1ed94a67$export$d0e870ba50062ff1, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(this.h, this.c, this.l + $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(this.h, this.c, this.l - $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $80e69e9a1ed94a67$var$hcl2lab(this).rgb();
    }
}));



function $86158b7019ca6112$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $80e69e9a1ed94a67$export$d0e870ba50062ff1)(start)).h, (end = (0, $80e69e9a1ed94a67$export$d0e870ba50062ff1)(end)).h), c = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $86158b7019ca6112$export$2e2bcd8739ae039 = $86158b7019ca6112$var$hcl((0, $529dc8928f6a4077$export$97d7b0c7ddb78dcf));
var $86158b7019ca6112$export$5aaa50f7615f9b70 = $86158b7019ca6112$var$hcl((0, $529dc8928f6a4077$export$2e2bcd8739ae039));


var $bYoiY = parcelRequire("bYoiY");

function $852106acfdc40efe$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $bYoiY.hsl)(start)).h, (end = (0, $bYoiY.hsl)(end)).h), s = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $852106acfdc40efe$export$2e2bcd8739ae039 = $852106acfdc40efe$var$hsl((0, $529dc8928f6a4077$export$97d7b0c7ddb78dcf));
var $852106acfdc40efe$export$a2c535e270a59256 = $852106acfdc40efe$var$hsl((0, $529dc8928f6a4077$export$2e2bcd8739ae039));



function $5eb07f15d29dfb2b$export$2e2bcd8739ae039(start, end) {
    var l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)((start = (0, $80e69e9a1ed94a67$export$2e2bcd8739ae039)(start)).l, (end = (0, $80e69e9a1ed94a67$export$2e2bcd8739ae039)(end)).l), a = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.a, end.a), b = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $25f2a121ae5a240e$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $8385105b4986daed$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

function $4f501ce7bede8755$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}


const $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c9f66a4d1c06b373$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c9f66a4d1c06b373$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c9f66a4d1c06b373$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c9f66a4d1c06b373$var$append : $c9f66a4d1c06b373$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._append`A${r},${r},0,${+(da >= $c9f66a4d1c06b373$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c9f66a4d1c06b373$export$bb654e07daaf8c3a() {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c9f66a4d1c06b373$export$bb654e07daaf8c3a.prototype = $c9f66a4d1c06b373$export$4b2950bdac9b6ee9.prototype;
function $c9f66a4d1c06b373$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9(+digits);
}




// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $e8a0bfad26e955e5$var$mul = 0x19660D;
const $e8a0bfad26e955e5$var$inc = 0x3C6EF35F;
const $e8a0bfad26e955e5$var$eps = 1 / 0x100000000;
function $e8a0bfad26e955e5$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $e8a0bfad26e955e5$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $e8a0bfad26e955e5$var$mul * state + $e8a0bfad26e955e5$var$inc | 0, $e8a0bfad26e955e5$var$eps * (state >>> 0));
}



function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}




const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}




function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}


var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $acd329741cbdf381$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $8385105b4986daed$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $afe237385175446a$export$f0954fd7d5368655) clamp = $afe237385175446a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $c0f8a9efb1caa699$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $afe237385175446a$export$f0954fd7d5368655, rescale()) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039() {
    return $afe237385175446a$export$6b468dcfb64c653c()($afe237385175446a$export$f0954fd7d5368655, $afe237385175446a$export$f0954fd7d5368655);
}








function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1589426e0436f502$export$2e2bcd8739ae039)(max) - (0, $1589426e0436f502$export$2e2bcd8739ae039)(step)) + 1;
}


function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $162912dc121d0934$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $54a757fa53542946$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $d27f2d3c2137f747$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $f4e256a3cb9c44da$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
}


function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $b0a07d06c8b316c1$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}




function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $5bf2f979a0299157$var$transformLog(x) {
    return Math.log(x);
}
function $5bf2f979a0299157$var$transformExp(x) {
    return Math.exp(x);
}
function $5bf2f979a0299157$var$transformLogn(x) {
    return -Math.log(-x);
}
function $5bf2f979a0299157$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $5bf2f979a0299157$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $5bf2f979a0299157$var$powp(base) {
    return base === 10 ? $5bf2f979a0299157$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $5bf2f979a0299157$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $5bf2f979a0299157$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $5bf2f979a0299157$export$860836db074028f0(transform) {
    const scale = transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $5bf2f979a0299157$var$logp(base), pows = $5bf2f979a0299157$var$powp(base);
        if (domain()[0] < 0) {
            logs = $5bf2f979a0299157$var$reflect(logs), pows = $5bf2f979a0299157$var$reflect(pows);
            transform($5bf2f979a0299157$var$transformLogn, $5bf2f979a0299157$var$transformExpn);
        } else transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $5bf2f979a0299157$export$2e2bcd8739ae039() {
    const scale = $5bf2f979a0299157$export$860836db074028f0((0, $afe237385175446a$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $afe237385175446a$export$784d13d8ee351f07)(scale, $5bf2f979a0299157$export$2e2bcd8739ae039()).base(scale.base());
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}










function $cb758ed0dff37844$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $cb758ed0dff37844$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $cb758ed0dff37844$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($cb758ed0dff37844$var$transformSymlog(c), $cb758ed0dff37844$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($cb758ed0dff37844$var$transformSymlog(c = +_), $cb758ed0dff37844$var$transformSymexp(c)) : c;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $cb758ed0dff37844$export$2e2bcd8739ae039() {
    var scale = $cb758ed0dff37844$export$4602684e614eba38((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $cb758ed0dff37844$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $d97c146f4f811488$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d97c146f4f811488$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d97c146f4f811488$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d97c146f4f811488$export$34695211ec403a46(transform) {
    var scale = transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($d97c146f4f811488$var$transformSqrt, $d97c146f4f811488$var$transformSquare) : transform($d97c146f4f811488$var$transformPow(exponent), $d97c146f4f811488$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $d97c146f4f811488$export$2e2bcd8739ae039() {
    var scale = $d97c146f4f811488$export$34695211ec403a46((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $d97c146f4f811488$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $d97c146f4f811488$export$eba8049fb5020b81() {
    return $d97c146f4f811488$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $f9c43af42f8b19e4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $afe237385175446a$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $8385105b4986daed$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $c0f8a9efb1caa699$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $f9c43af42f8b19e4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $f9c43af42f8b19e4$export$2e2bcd8739ae039() {
    var scale = (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)($f9c43af42f8b19e4$var$transformer()((0, $afe237385175446a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$2e2bcd8739ae039());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$6843e08bf2ff981f() {
    var scale = (0, $5bf2f979a0299157$export$860836db074028f0)($f9c43af42f8b19e4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$9d4af4de62c81941() {
    var scale = (0, $cb758ed0dff37844$export$4602684e614eba38)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$de9f78581b4f2405() {
    var scale = (0, $d97c146f4f811488$export$34695211ec403a46)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$413d935127ed466e() {
    return $f9c43af42f8b19e4$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}




function $19e76371916c670d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $afe237385175446a$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $8385105b4986daed$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $c0f8a9efb1caa699$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $19e76371916c670d$export$2e2bcd8739ae039() {
    var scale = (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)($19e76371916c670d$var$transformer()((0, $afe237385175446a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$2e2bcd8739ae039());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$5f0266a9159c47fb() {
    var scale = (0, $5bf2f979a0299157$export$860836db074028f0)($19e76371916c670d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$50b3da713cf557c6() {
    var scale = (0, $cb758ed0dff37844$export$4602684e614eba38)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$d6cedcc63bf26e7e() {
    var scale = (0, $d97c146f4f811488$export$34695211ec403a46)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$33ddefb5c4ab9e9c() {
    return $19e76371916c670d$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}



function $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}



function $96238d247b54f1ee$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $231c9024a6754413$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $63cbeabc75241824$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $96238d247b54f1ee$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}



function $8058838348a44fed$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8058838348a44fed$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}

const $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $f26fc9b6912de968$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1000;
const $a28c7a35eadfe1f6$export$683905d551c33fa9 = $a28c7a35eadfe1f6$export$79ef0e34099623dc * 60;
const $a28c7a35eadfe1f6$export$4157bf0c8e241659 = $a28c7a35eadfe1f6$export$683905d551c33fa9 * 60;
const $a28c7a35eadfe1f6$export$353686095f4fbf45 = $a28c7a35eadfe1f6$export$4157bf0c8e241659 * 24;
const $a28c7a35eadfe1f6$export$c241eb88520d5016 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 7;
const $a28c7a35eadfe1f6$export$ab95684df7020b26 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 30;
const $a28c7a35eadfe1f6$export$61f8ee2d834c6959 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 365;


const $51fe2e20810fcb40$export$8888529b966033e5 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $51fe2e20810fcb40$export$6657a54f3034cf45 = $51fe2e20810fcb40$export$8888529b966033e5.range;
const $51fe2e20810fcb40$export$c8cbc42cefd47140 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $51fe2e20810fcb40$export$d277e198508549a1 = $51fe2e20810fcb40$export$c8cbc42cefd47140.range;
const $51fe2e20810fcb40$export$fb065be2d7ea4a71 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45));
});
const $51fe2e20810fcb40$export$a491caaf5e9481aa = $51fe2e20810fcb40$export$fb065be2d7ea4a71.range;



const $9472e71f07850dab$export$46c68a5833bc315b = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc) - date.getMinutes() * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $9472e71f07850dab$export$fb843f9087cd5235 = $9472e71f07850dab$export$46c68a5833bc315b.range;
const $9472e71f07850dab$export$31f6f2b3c63ac75e = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $9472e71f07850dab$export$6e7a76cd5f50b719 = $9472e71f07850dab$export$31f6f2b3c63ac75e.range;



const $292297f992a3b17e$export$a7e4c34a52f0576 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $292297f992a3b17e$export$186d65358374c0a2 = $292297f992a3b17e$export$a7e4c34a52f0576.range;
const $292297f992a3b17e$export$efe6712d6003761b = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $292297f992a3b17e$export$cedd563624e8ee50 = $292297f992a3b17e$export$efe6712d6003761b.range;


const $031c190f93ea3efa$export$7e1084fb688591c1 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $031c190f93ea3efa$export$3e24aa839cd0f1c4 = $031c190f93ea3efa$export$7e1084fb688591c1.range;
const $031c190f93ea3efa$export$cd49b3d2bcfe50d5 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $031c190f93ea3efa$export$49159f585997498 = $031c190f93ea3efa$export$cd49b3d2bcfe50d5.range;



const $490d5c36270b8fcb$export$3d3c77ce7df7d30d = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$export$3d3c77ce7df7d30d.range;




const $79ec6c01997bf022$export$edc5e5cb87280477 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$export$edc5e5cb87280477;
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$export$edc5e5cb87280477.range;








function $7f6029921eecd017$var$timeWeekday(i) {
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
const $7f6029921eecd017$export$22ee6205b762968c = $7f6029921eecd017$var$timeWeekday(0);
const $7f6029921eecd017$export$e79bbe0177cf1b01 = $7f6029921eecd017$var$timeWeekday(1);
const $7f6029921eecd017$export$57c0658c29f77708 = $7f6029921eecd017$var$timeWeekday(2);
const $7f6029921eecd017$export$3fbeef226c256e43 = $7f6029921eecd017$var$timeWeekday(3);
const $7f6029921eecd017$export$608689422d5cf9f4 = $7f6029921eecd017$var$timeWeekday(4);
const $7f6029921eecd017$export$548e5227aa183dca = $7f6029921eecd017$var$timeWeekday(5);
const $7f6029921eecd017$export$c56a3ad248908e19 = $7f6029921eecd017$var$timeWeekday(6);
const $7f6029921eecd017$export$eac514c8a8674eba = $7f6029921eecd017$export$22ee6205b762968c.range;
const $7f6029921eecd017$export$f7219b1481948356 = $7f6029921eecd017$export$e79bbe0177cf1b01.range;
const $7f6029921eecd017$export$77e22b12c5bed05b = $7f6029921eecd017$export$57c0658c29f77708.range;
const $7f6029921eecd017$export$b85d407a471809e8 = $7f6029921eecd017$export$3fbeef226c256e43.range;
const $7f6029921eecd017$export$c1bc1c49254c8855 = $7f6029921eecd017$export$608689422d5cf9f4.range;
const $7f6029921eecd017$export$3691a1557fff46f1 = $7f6029921eecd017$export$548e5227aa183dca.range;
const $7f6029921eecd017$export$b755452d02cba8d2 = $7f6029921eecd017$export$c56a3ad248908e19.range;
function $7f6029921eecd017$var$utcWeekday(i) {
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
const $7f6029921eecd017$export$4898b06303a92011 = $7f6029921eecd017$var$utcWeekday(0);
const $7f6029921eecd017$export$9cfc53b9cfafd080 = $7f6029921eecd017$var$utcWeekday(1);
const $7f6029921eecd017$export$2a6d545f77eceb15 = $7f6029921eecd017$var$utcWeekday(2);
const $7f6029921eecd017$export$a5c25d8ed64433c4 = $7f6029921eecd017$var$utcWeekday(3);
const $7f6029921eecd017$export$1db08111baec2f53 = $7f6029921eecd017$var$utcWeekday(4);
const $7f6029921eecd017$export$29265e34dd5921f7 = $7f6029921eecd017$var$utcWeekday(5);
const $7f6029921eecd017$export$85b74dad05049604 = $7f6029921eecd017$var$utcWeekday(6);
const $7f6029921eecd017$export$6f3e1c2b0f7d7880 = $7f6029921eecd017$export$4898b06303a92011.range;
const $7f6029921eecd017$export$1d2d8b858bb366f9 = $7f6029921eecd017$export$9cfc53b9cfafd080.range;
const $7f6029921eecd017$export$1d5f6785fc7f30f8 = $7f6029921eecd017$export$2a6d545f77eceb15.range;
const $7f6029921eecd017$export$7a75faf0e37ef4af = $7f6029921eecd017$export$a5c25d8ed64433c4.range;
const $7f6029921eecd017$export$417eb959611b2f2f = $7f6029921eecd017$export$1db08111baec2f53.range;
const $7f6029921eecd017$export$59d308db7af08c64 = $7f6029921eecd017$export$29265e34dd5921f7.range;
const $7f6029921eecd017$export$a124108a0a7f34c8 = $7f6029921eecd017$export$85b74dad05049604.range;




const $dd6e0f506bfbbd03$export$cd17cfe45df0c046 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$69a4e90dd2cc3bd1 = $dd6e0f506bfbbd03$export$cd17cfe45df0c046.range;
const $dd6e0f506bfbbd03$export$d5c3802e389714c4 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$3e24d311e17f5802 = $dd6e0f506bfbbd03$export$d5c3802e389714c4.range;


function $047ba3ec3f41562e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            1,
            (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $a28c7a35eadfe1f6$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $a28c7a35eadfe1f6$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $a28c7a35eadfe1f6$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $a28c7a35eadfe1f6$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $a28c7a35eadfe1f6$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start / (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959), stop / (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $79ec6c01997bf022$export$edc5e5cb87280477).every(Math.max((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$047ba3ec3f41562e$export$826ba5ae907e9767, $047ba3ec3f41562e$export$6262d8d056ea44c4] = $047ba3ec3f41562e$var$ticker((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4), (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5), (0, $7f6029921eecd017$export$4898b06303a92011), (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71), (0, $9472e71f07850dab$export$31f6f2b3c63ac75e), (0, $292297f992a3b17e$export$efe6712d6003761b));
const [$047ba3ec3f41562e$export$60c76498552d28a6, $047ba3ec3f41562e$export$69511150134dd174] = $047ba3ec3f41562e$var$ticker((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046), (0, $031c190f93ea3efa$export$7e1084fb688591c1), (0, $7f6029921eecd017$export$22ee6205b762968c), (0, $51fe2e20810fcb40$export$8888529b966033e5), (0, $9472e71f07850dab$export$46c68a5833bc315b), (0, $292297f992a3b17e$export$a7e4c34a52f0576));



function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$9cfc53b9cfafd080).ceil(week) : (0, $7f6029921eecd017$export$9cfc53b9cfafd080)(week);
                    week = (0, $51fe2e20810fcb40$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$e79bbe0177cf1b01).ceil(week) : (0, $7f6029921eecd017$export$e79bbe0177cf1b01)(week);
                    week = (0, $51fe2e20810fcb40$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$8888529b966033e5).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$22ee6205b762968c).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$608689422d5cf9f4)(d) : (0, $7f6029921eecd017$export$608689422d5cf9f4).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$608689422d5cf9f4).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d), d) + ((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$e79bbe0177cf1b01).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$608689422d5cf9f4)(d) : (0, $7f6029921eecd017$export$608689422d5cf9f4).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$c8cbc42cefd47140).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$4898b06303a92011).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$1db08111baec2f53)(d) : (0, $7f6029921eecd017$export$1db08111baec2f53).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$1db08111baec2f53).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d), d) + ((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$9cfc53b9cfafd080).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$1db08111baec2f53)(d) : (0, $7f6029921eecd017$export$1db08111baec2f53).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $463505b9d968caf4$export$2e2bcd8739ae039)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}





function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $047ba3ec3f41562e$export$60c76498552d28a6), (0, $047ba3ec3f41562e$export$69511150134dd174), (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046), (0, $031c190f93ea3efa$export$7e1084fb688591c1), (0, $7f6029921eecd017$export$22ee6205b762968c), (0, $51fe2e20810fcb40$export$8888529b966033e5), (0, $9472e71f07850dab$export$46c68a5833bc315b), (0, $292297f992a3b17e$export$a7e4c34a52f0576), (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d), (0, $0a9ce0165786feda$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $f4e8dbe80a3143de$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply((0, $304372357472b2a4$export$56bbcdb8aca31149)((0, $047ba3ec3f41562e$export$826ba5ae907e9767), (0, $047ba3ec3f41562e$export$6262d8d056ea44c4), (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4), (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5), (0, $7f6029921eecd017$export$4898b06303a92011), (0, $51fe2e20810fcb40$export$c8cbc42cefd47140), (0, $9472e71f07850dab$export$31f6f2b3c63ac75e), (0, $292297f992a3b17e$export$efe6712d6003761b), (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d), (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}


function $fe769d98421e6dac$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}



var $c38bc04632290fce$export$2e2bcd8739ae039 = (scheme)=>(0, $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $145b892380fd2d31$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $145b892380fd2d31$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($145b892380fd2d31$export$3005042704f95a69);



var $923009811f34a285$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $923009811f34a285$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($923009811f34a285$export$3005042704f95a69);



var $1346c9d2a50a7688$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $1346c9d2a50a7688$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($1346c9d2a50a7688$export$3005042704f95a69);



var $c6eb5bbbe1fe33f2$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $c6eb5bbbe1fe33f2$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($c6eb5bbbe1fe33f2$export$3005042704f95a69);

function $9952aaaded0c8a28$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}


var $bfWFq = parcelRequire("bfWFq");

var $bYoiY = parcelRequire("bYoiY");

var $046e8f1d7426ff04$var$A = -0.14861, $046e8f1d7426ff04$var$B = 1.78277, $046e8f1d7426ff04$var$C = -0.29227, $046e8f1d7426ff04$var$D = -0.90649, $046e8f1d7426ff04$var$E = 1.97294, $046e8f1d7426ff04$var$ED = $046e8f1d7426ff04$var$E * $046e8f1d7426ff04$var$D, $046e8f1d7426ff04$var$EB = $046e8f1d7426ff04$var$E * $046e8f1d7426ff04$var$B, $046e8f1d7426ff04$var$BC_DA = $046e8f1d7426ff04$var$B * $046e8f1d7426ff04$var$C - $046e8f1d7426ff04$var$D * $046e8f1d7426ff04$var$A;
function $046e8f1d7426ff04$var$cubehelixConvert(o) {
    if (o instanceof $046e8f1d7426ff04$export$57ed4bde61a1e2f2) return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $bYoiY.Rgb))) o = (0, $bYoiY.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($046e8f1d7426ff04$var$BC_DA * b + $046e8f1d7426ff04$var$ED * r - $046e8f1d7426ff04$var$EB * g) / ($046e8f1d7426ff04$var$BC_DA + $046e8f1d7426ff04$var$ED - $046e8f1d7426ff04$var$EB), bl = b - l, k = ($046e8f1d7426ff04$var$E * (g - l) - $046e8f1d7426ff04$var$C * bl) / $046e8f1d7426ff04$var$D, s = Math.sqrt(k * k + bl * bl) / ($046e8f1d7426ff04$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $70576c5c5ae147f6$export$41fc368e1a942b97) - 120 : NaN;
    return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $046e8f1d7426ff04$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $046e8f1d7426ff04$var$cubehelixConvert(h) : new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $046e8f1d7426ff04$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)($046e8f1d7426ff04$export$57ed4bde61a1e2f2, $046e8f1d7426ff04$export$2e2bcd8739ae039, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        k = k == null ? (0, $bYoiY.brighter) : Math.pow((0, $bYoiY.brighter), k);
        return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $bYoiY.darker) : Math.pow((0, $bYoiY.darker), k);
        return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $70576c5c5ae147f6$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $bYoiY.Rgb)(255 * (l + a * ($046e8f1d7426ff04$var$A * cosh + $046e8f1d7426ff04$var$B * sinh)), 255 * (l + a * ($046e8f1d7426ff04$var$C * cosh + $046e8f1d7426ff04$var$D * sinh)), 255 * (l + a * ($046e8f1d7426ff04$var$E * cosh)), this.opacity);
    }
}));




function $ffc3b01ae2663238$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(start)).h, (end = (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(end)).h), s = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $ffc3b01ae2663238$export$2e2bcd8739ae039 = $ffc3b01ae2663238$var$cubehelix((0, $529dc8928f6a4077$export$97d7b0c7ddb78dcf));
var $ffc3b01ae2663238$export$934fa09ad474a1b4 = $ffc3b01ae2663238$var$cubehelix((0, $529dc8928f6a4077$export$2e2bcd8739ae039));


var $99c57285242dd2ea$export$fc70efcec537be98 = (0, $ffc3b01ae2663238$export$934fa09ad474a1b4)((0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $99c57285242dd2ea$export$c5cedbc1ab3be2c3 = (0, $ffc3b01ae2663238$export$934fa09ad474a1b4)((0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $99c57285242dd2ea$var$c = (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)();
function $99c57285242dd2ea$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $99c57285242dd2ea$var$c.h = 360 * t - 100;
    $99c57285242dd2ea$var$c.s = 1.5 - 1.5 * ts;
    $99c57285242dd2ea$var$c.l = 0.8 - 0.9 * ts;
    return $99c57285242dd2ea$var$c + "";
}



var $29d6cb6ff87ef07d$export$2e2bcd8739ae039 = (0, $ffc3b01ae2663238$export$934fa09ad474a1b4)((0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(-240, 0.5, 1.0));



var $54d7f7dcce705495$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $54d7f7dcce705495$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($54d7f7dcce705495$export$3005042704f95a69);



var $8f3c9c616b880108$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $8f3c9c616b880108$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($8f3c9c616b880108$export$3005042704f95a69);



var $7bfe5c88f8446526$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $7bfe5c88f8446526$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($7bfe5c88f8446526$export$3005042704f95a69);


function $c1e92c032cb158e3$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $c1e92c032cb158e3$export$2e2bcd8739ae039 = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $c1e92c032cb158e3$export$c41e69203f572e8d = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $c1e92c032cb158e3$export$ad0c8285c8ea6dbd = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $c1e92c032cb158e3$export$6664860a633d9daf = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



var $595eb3851ff257d2$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $595eb3851ff257d2$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($595eb3851ff257d2$export$3005042704f95a69);



var $eeccadfeb064b2e3$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $eeccadfeb064b2e3$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($eeccadfeb064b2e3$export$3005042704f95a69);



var $cd2b06ef8006df98$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $cd2b06ef8006df98$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($cd2b06ef8006df98$export$3005042704f95a69);



var $bebec87caf5c9753$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $bebec87caf5c9753$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($bebec87caf5c9753$export$3005042704f95a69);



var $378e987a98dccf42$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $378e987a98dccf42$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($378e987a98dccf42$export$3005042704f95a69);



var $256ade4440a037db$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $256ade4440a037db$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($256ade4440a037db$export$3005042704f95a69);



var $fa43973b0e53adde$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $fa43973b0e53adde$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($fa43973b0e53adde$export$3005042704f95a69);



var $5387771dbbae7a61$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $5387771dbbae7a61$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($5387771dbbae7a61$export$3005042704f95a69);



var $1d375f28523a6def$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $1d375f28523a6def$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($1d375f28523a6def$export$3005042704f95a69);



var $459633cf9cf535bb$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $459633cf9cf535bb$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($459633cf9cf535bb$export$3005042704f95a69);



var $d593cda9522f5e9b$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $d593cda9522f5e9b$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($d593cda9522f5e9b$export$3005042704f95a69);



var $c0b866951e59a25a$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $c0b866951e59a25a$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($c0b866951e59a25a$export$3005042704f95a69);



var $cc75fec219df38fc$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $cc75fec219df38fc$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($cc75fec219df38fc$export$3005042704f95a69);



var $34bd5cca956fffae$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $34bd5cca956fffae$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($34bd5cca956fffae$export$3005042704f95a69);



var $1061f70ec19e6f6b$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $1061f70ec19e6f6b$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($1061f70ec19e6f6b$export$3005042704f95a69);


var $bYoiY = parcelRequire("bYoiY");
var $8a82e5e51ab56b0d$var$c = (0, $bYoiY.rgb)(), $8a82e5e51ab56b0d$var$pi_1_3 = Math.PI / 3, $8a82e5e51ab56b0d$var$pi_2_3 = Math.PI * 2 / 3;
function $8a82e5e51ab56b0d$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $8a82e5e51ab56b0d$var$c.r = 255 * (x = Math.sin(t)) * x;
    $8a82e5e51ab56b0d$var$c.g = 255 * (x = Math.sin(t + $8a82e5e51ab56b0d$var$pi_1_3)) * x;
    $8a82e5e51ab56b0d$var$c.b = 255 * (x = Math.sin(t + $8a82e5e51ab56b0d$var$pi_2_3)) * x;
    return $8a82e5e51ab56b0d$var$c + "";
}



var $9f2dc97368c5eb16$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $9f2dc97368c5eb16$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($9f2dc97368c5eb16$export$3005042704f95a69);

function $b6e6a61cd0d5bfcf$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}



var $9f35832fa0e76f1c$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $9f35832fa0e76f1c$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($9f35832fa0e76f1c$export$3005042704f95a69);



var $59f93d7737a98115$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $59f93d7737a98115$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($59f93d7737a98115$export$3005042704f95a69);



var $8ba4ac8d08f3d776$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $8ba4ac8d08f3d776$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($8ba4ac8d08f3d776$export$3005042704f95a69);



var $f3f63506e2889591$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $f3f63506e2889591$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($f3f63506e2889591$export$3005042704f95a69);


var $5c89bc3d03077aec$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");


var $b0a93f4c47fccf6f$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");


var $8720e88c6715774d$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");


var $c47347499213e74d$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");


var $892d66d4b4370fa9$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $8b74c2f853351d4b$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");


var $21804f83495238ab$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");


var $067ed124de63e363$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");


var $0b28fee23808bb16$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");


var $2c32d07a5d4299df$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");


var $4fe0d67c4ca00f70$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");



var $b1edd492c2923d6f$export$58adb3bec8346d0f = Array.prototype.slice;
function $b1edd492c2923d6f$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $c1e9e09d9174b864$var$Linear(context) {
    this._context = context;
}
$c1e9e09d9174b864$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c1e9e09d9174b864$export$2e2bcd8739ae039(context) {
    return new $c1e9e09d9174b864$var$Linear(context);
}






function $5c3aa3aea2c844cf$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $c9f66a4d1c06b373$export$4b2950bdac9b6ee9)(digits);
}


function $ebec7ab58e49c436$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $ebec7ab58e49c436$export$4a5767248b18ef41(p) {
    return p[1];
}


function $3fbda81220c6ea9c$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(true), context = null, curve = (0, $c1e9e09d9174b864$export$2e2bcd8739ae039), output = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $ebec7ab58e49c436$export$d141bba7fdc215a3) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $ebec7ab58e49c436$export$4a5767248b18ef41) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $b1edd492c2923d6f$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}




function $b654034e6c52569c$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(true), context = null, curve = (0, $c1e9e09d9174b864$export$2e2bcd8739ae039), output = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $ebec7ab58e49c436$export$d141bba7fdc215a3) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(0) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $ebec7ab58e49c436$export$4a5767248b18ef41) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $b1edd492c2923d6f$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $3fbda81220c6ea9c$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

function $4fcc1327a5d07e55$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $4fcc1327a5d07e55$export$957f7263e89bedd2(context) {
    this._context = context;
}
$4fcc1327a5d07e55$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4fcc1327a5d07e55$export$2e2bcd8739ae039(context) {
    return new $4fcc1327a5d07e55$export$957f7263e89bedd2(context);
}

function $72ccadd7b0a5f010$export$2e2bcd8739ae039() {}



function $183ce554afe8c6f0$var$BasisClosed(context) {
    this._context = context;
}
$183ce554afe8c6f0$var$BasisClosed.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $4fcc1327a5d07e55$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $183ce554afe8c6f0$export$2e2bcd8739ae039(context) {
    return new $183ce554afe8c6f0$var$BasisClosed(context);
}


function $a34a32e088f640bf$var$BasisOpen(context) {
    this._context = context;
}
$a34a32e088f640bf$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $4fcc1327a5d07e55$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a34a32e088f640bf$export$2e2bcd8739ae039(context) {
    return new $a34a32e088f640bf$var$BasisOpen(context);
}

function $8bd0ba086b92e84b$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}


class $bf3175dc82ec4a49$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $bf3175dc82ec4a49$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(this._x0, this._y0);
            const p1 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(x, this._y0);
            const p3 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $bf3175dc82ec4a49$export$2c099b5096f70ce6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, true);
}
function $bf3175dc82ec4a49$export$908da9dfa54cbed6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, false);
}
function $bf3175dc82ec4a49$export$8c82a77a5061b331(context) {
    return new $bf3175dc82ec4a49$var$BumpRadial(context);
}


function $f6400194fd6a0bdb$var$Bundle(context, beta) {
    this._basis = new (0, $4fcc1327a5d07e55$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$f6400194fd6a0bdb$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f6400194fd6a0bdb$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $4fcc1327a5d07e55$export$957f7263e89bedd2)(context) : new $f6400194fd6a0bdb$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);


var $hga9n = parcelRequire("hga9n");

var $hga9n = parcelRequire("hga9n");
function $73ff40c99770ef6d$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$73ff40c99770ef6d$export$da3940d7e9162858.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $73ff40c99770ef6d$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $73ff40c99770ef6d$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $hga9n = parcelRequire("hga9n");
function $a213115754da7990$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a213115754da7990$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a213115754da7990$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a213115754da7990$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $6FEsA = parcelRequire("6FEsA");


var $6FEsA = parcelRequire("6FEsA");
function $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f936d5ffcfb25824$var$CatmullRomClosed.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f936d5ffcfb25824$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) : new (0, $73ff40c99770ef6d$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $6FEsA = parcelRequire("6FEsA");
function $341349acb9991726$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$341349acb9991726$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $341349acb9991726$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $341349acb9991726$var$CatmullRomOpen(context, alpha) : new (0, $a213115754da7990$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);


function $35e56ad4997e8f65$var$LinearClosed(context) {
    this._context = context;
}
$35e56ad4997e8f65$var$LinearClosed.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $35e56ad4997e8f65$export$2e2bcd8739ae039(context) {
    return new $35e56ad4997e8f65$var$LinearClosed(context);
}

function $cab75dc01e66b193$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cab75dc01e66b193$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cab75dc01e66b193$var$sign(s0) + $cab75dc01e66b193$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $cab75dc01e66b193$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cab75dc01e66b193$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cab75dc01e66b193$var$MonotoneX(context) {
    this._context = context;
}
$cab75dc01e66b193$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cab75dc01e66b193$var$point(this, this._t0, $cab75dc01e66b193$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cab75dc01e66b193$var$point(this, $cab75dc01e66b193$var$slope2(this, t1 = $cab75dc01e66b193$var$slope3(this, x, y)), t1);
                break;
            default:
                $cab75dc01e66b193$var$point(this, this._t0, t1 = $cab75dc01e66b193$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cab75dc01e66b193$var$MonotoneY(context) {
    this._context = new $cab75dc01e66b193$var$ReflectContext(context);
}
($cab75dc01e66b193$var$MonotoneY.prototype = Object.create($cab75dc01e66b193$var$MonotoneX.prototype)).point = function(x, y) {
    $cab75dc01e66b193$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cab75dc01e66b193$var$ReflectContext(context) {
    this._context = context;
}
$cab75dc01e66b193$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cab75dc01e66b193$export$99563b5420dbdc55(context) {
    return new $cab75dc01e66b193$var$MonotoneX(context);
}
function $cab75dc01e66b193$export$8b5360456d6bdb88(context) {
    return new $cab75dc01e66b193$var$MonotoneY(context);
}

function $ecaddebfc9069a1b$var$Natural(context) {
    this._context = context;
}
$ecaddebfc9069a1b$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ecaddebfc9069a1b$var$controlPoints(x), py = $ecaddebfc9069a1b$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ecaddebfc9069a1b$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ecaddebfc9069a1b$export$2e2bcd8739ae039(context) {
    return new $ecaddebfc9069a1b$var$Natural(context);
}

function $1262f1c88e9696b5$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1262f1c88e9696b5$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1262f1c88e9696b5$export$2e2bcd8739ae039(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0.5);
}
function $1262f1c88e9696b5$export$10eafa5b7478b343(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0);
}
function $1262f1c88e9696b5$export$793b3db073781cbb(context) {
    return new $1262f1c88e9696b5$var$Step(context, 1);
}


var $kDiOX = parcelRequire("kDiOX");
const $134055608cfdbbf1$var$sqrt3 = (0, $kDiOX.sqrt)(3);
var $134055608cfdbbf1$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size + (0, $kDiOX.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $134055608cfdbbf1$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};


var $kDiOX = parcelRequire("kDiOX");
var $77cd44e2ac6dc1c2$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size / (0, $kDiOX.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $kDiOX.tau));
    }
};


var $kDiOX = parcelRequire("kDiOX");
var $6389eccbe795c95c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};


var $kDiOX = parcelRequire("kDiOX");
const $42af998bb354705d$var$tan30 = (0, $kDiOX.sqrt)(1 / 3);
const $42af998bb354705d$var$tan30_2 = $42af998bb354705d$var$tan30 * 2;
var $42af998bb354705d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $kDiOX.sqrt)(size / $42af998bb354705d$var$tan30_2);
        const x = y * $42af998bb354705d$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};


var $kDiOX = parcelRequire("kDiOX");
var $f2564dd3ed0020e5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};


var $kDiOX = parcelRequire("kDiOX");
var $6eee48c5df32b70c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size - (0, $kDiOX.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};










var $kDiOX = parcelRequire("kDiOX");
var $1dda04e919c4f021$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $kDiOX.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $efaaae86227c5844$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $4ff326387f52757d$var$ka = 0.89081309152928522810;
const $4ff326387f52757d$var$kr = (0, $kDiOX.sin)((0, $kDiOX.pi) / 10) / (0, $kDiOX.sin)(7 * (0, $kDiOX.pi) / 10);
const $4ff326387f52757d$var$kx = (0, $kDiOX.sin)((0, $kDiOX.tau) / 10) * $4ff326387f52757d$var$kr;
const $4ff326387f52757d$var$ky = -(0, $kDiOX.cos)((0, $kDiOX.tau) / 10) * $4ff326387f52757d$var$kr;
var $4ff326387f52757d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size * $4ff326387f52757d$var$ka);
        const x = $4ff326387f52757d$var$kx * r;
        const y = $4ff326387f52757d$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $kDiOX.tau) * i / 5;
            const c = (0, $kDiOX.cos)(a);
            const s = (0, $kDiOX.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $d45526fd1ffbd617$var$sqrt3 = (0, $kDiOX.sqrt)(3);
var $d45526fd1ffbd617$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $kDiOX.sqrt)(size / ($d45526fd1ffbd617$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$d45526fd1ffbd617$var$sqrt3 * y, -y);
        context.lineTo($d45526fd1ffbd617$var$sqrt3 * y, -y);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $70a1b9646572faf7$var$sqrt3 = (0, $kDiOX.sqrt)(3);
var $70a1b9646572faf7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $kDiOX.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $70a1b9646572faf7$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $6b5c98530d683be5$var$c = -0.5;
const $6b5c98530d683be5$var$s = (0, $kDiOX.sqrt)(3) / 2;
const $6b5c98530d683be5$var$k = 1 / (0, $kDiOX.sqrt)(12);
const $6b5c98530d683be5$var$a = ($6b5c98530d683be5$var$k / 2 + 1) * 3;
var $6b5c98530d683be5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size / $6b5c98530d683be5$var$a);
        const x0 = r / 2, y0 = r * $6b5c98530d683be5$var$k;
        const x1 = x0, y1 = r * $6b5c98530d683be5$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($6b5c98530d683be5$var$c * x0 - $6b5c98530d683be5$var$s * y0, $6b5c98530d683be5$var$s * x0 + $6b5c98530d683be5$var$c * y0);
        context.lineTo($6b5c98530d683be5$var$c * x1 - $6b5c98530d683be5$var$s * y1, $6b5c98530d683be5$var$s * x1 + $6b5c98530d683be5$var$c * y1);
        context.lineTo($6b5c98530d683be5$var$c * x2 - $6b5c98530d683be5$var$s * y2, $6b5c98530d683be5$var$s * x2 + $6b5c98530d683be5$var$c * y2);
        context.lineTo($6b5c98530d683be5$var$c * x0 + $6b5c98530d683be5$var$s * y0, $6b5c98530d683be5$var$c * y0 - $6b5c98530d683be5$var$s * x0);
        context.lineTo($6b5c98530d683be5$var$c * x1 + $6b5c98530d683be5$var$s * y1, $6b5c98530d683be5$var$c * y1 - $6b5c98530d683be5$var$s * x1);
        context.lineTo($6b5c98530d683be5$var$c * x2 + $6b5c98530d683be5$var$s * y2, $6b5c98530d683be5$var$c * y2 - $6b5c98530d683be5$var$s * x2);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $91f4a6205a1a3d92$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size - (0, $kDiOX.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $497fe223f0c7b3e8$export$19158c96a6700c15 = [
    (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039),
    (0, $6389eccbe795c95c$export$2e2bcd8739ae039),
    (0, $42af998bb354705d$export$2e2bcd8739ae039),
    (0, $1dda04e919c4f021$export$2e2bcd8739ae039),
    (0, $4ff326387f52757d$export$2e2bcd8739ae039),
    (0, $d45526fd1ffbd617$export$2e2bcd8739ae039),
    (0, $6b5c98530d683be5$export$2e2bcd8739ae039)
];
const $497fe223f0c7b3e8$export$915e06de6acf8fe = [
    (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039),
    (0, $6eee48c5df32b70c$export$2e2bcd8739ae039),
    (0, $91f4a6205a1a3d92$export$2e2bcd8739ae039),
    (0, $70a1b9646572faf7$export$2e2bcd8739ae039),
    (0, $134055608cfdbbf1$export$2e2bcd8739ae039),
    (0, $efaaae86227c5844$export$2e2bcd8739ae039),
    (0, $f2564dd3ed0020e5$export$2e2bcd8739ae039)
];
function $497fe223f0c7b3e8$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(type || (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}









var $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e4199827a75856fd$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $e4199827a75856fd$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh(rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e4199827a75856fd$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $4aeb7326706b2467$export$2e2bcd8739ae039 = (x)=>()=>x;


function $7a8a51016481311d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}


function $b2e4663bd9fbfcc1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $91e02783b8b1c24a$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $a3c1094a2e8782d7$export$f0954fd7d5368655);
}
function $91e02783b8b1c24a$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $e4199827a75856fd$export$2e2bcd8739ae039), listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $a3c1094a2e8782d7$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $7a8a51016481311d$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $905558291b0c219c$export$833237748009e1e1)(event.view, g.moved);
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}








function $0f3e37548c3914c7$export$43f40ad3fa1d5c97(x) {
    return x != null && !Number.isNaN(x);
}
function $0f3e37548c3914c7$export$686e14b8469efec4(a, b) {
    return +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(b) - +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(a) || (0, $63cbeabc75241824$export$2e2bcd8739ae039)(a, b);
}
function $0f3e37548c3914c7$export$e82554a8bd790ef9(a, b) {
    return +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(b) - +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(a) || (0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(a, b);
}
function $0f3e37548c3914c7$export$6ce6c9218151d511(x) {
    return x != null && `${x}` !== "";
}
function $0f3e37548c3914c7$export$145b33b964ff85c1(x) {
    return isFinite(x) ? x : NaN;
}
function $0f3e37548c3914c7$export$aa5128ab863cd04(x) {
    return x > 0 && isFinite(x) ? x : NaN;
}
function $0f3e37548c3914c7$export$5f47f64d03acd206(x) {
    return x < 0 && isFinite(x) ? x : NaN;
}



const $a25d0745dd917edb$var$re = /^(?:[-+]\d{2})?\d{4}(?:-\d{2}(?:-\d{2})?)?(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{3})?)?(?:Z|[-+]\d{2}:?\d{2})?)?$/;
function $a25d0745dd917edb$export$2e2bcd8739ae039(string, fallback) {
    if (!$a25d0745dd917edb$var$re.test(string += "")) return typeof fallback === "function" ? fallback(string) : fallback;
    return new Date(string);
}





function $98c8b67f479b9fc9$export$c25b1294fe9f63f1(values) {
    if (values == null) return;
    const first = values[0];
    const last = values[values.length - 1];
    return (0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(first, last);
}


const $49e9bdee870d78f0$var$durationSecond = 1000;
const $49e9bdee870d78f0$var$durationMinute = $49e9bdee870d78f0$var$durationSecond * 60;
const $49e9bdee870d78f0$var$durationHour = $49e9bdee870d78f0$var$durationMinute * 60;
const $49e9bdee870d78f0$var$durationDay = $49e9bdee870d78f0$var$durationHour * 24;
const $49e9bdee870d78f0$var$durationWeek = $49e9bdee870d78f0$var$durationDay * 7;
const $49e9bdee870d78f0$var$durationMonth = $49e9bdee870d78f0$var$durationDay * 30;
const $49e9bdee870d78f0$var$durationYear = $49e9bdee870d78f0$var$durationDay * 365;
// See https://github.com/d3/d3-time/blob/9e8dc940f38f78d7588aad68a54a25b1f0c2d97b/src/ticks.js#L14-L33
const $49e9bdee870d78f0$var$tickIntervals = [
    [
        "millisecond",
        1
    ],
    [
        "2 milliseconds",
        2
    ],
    [
        "5 milliseconds",
        5
    ],
    [
        "10 milliseconds",
        10
    ],
    [
        "20 milliseconds",
        20
    ],
    [
        "50 milliseconds",
        50
    ],
    [
        "100 milliseconds",
        100
    ],
    [
        "200 milliseconds",
        200
    ],
    [
        "500 milliseconds",
        500
    ],
    [
        "second",
        $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "5 seconds",
        5 * $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "15 seconds",
        15 * $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "30 seconds",
        30 * $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "minute",
        $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "5 minutes",
        5 * $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "15 minutes",
        15 * $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "30 minutes",
        30 * $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "hour",
        $49e9bdee870d78f0$var$durationHour
    ],
    [
        "3 hours",
        3 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "6 hours",
        6 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "12 hours",
        12 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "day",
        $49e9bdee870d78f0$var$durationDay
    ],
    [
        "2 days",
        2 * $49e9bdee870d78f0$var$durationDay
    ],
    [
        "week",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "2 weeks",
        2 * $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "month",
        $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "3 months",
        3 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "6 months",
        6 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "year",
        $49e9bdee870d78f0$var$durationYear
    ],
    [
        "2 years",
        2 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "5 years",
        5 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "10 years",
        10 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "20 years",
        20 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "50 years",
        50 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "100 years",
        100 * $49e9bdee870d78f0$var$durationYear
    ] // TODO generalize to longer time scales
];
const $49e9bdee870d78f0$var$durations = new Map([
    [
        "second",
        $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "minute",
        $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "hour",
        $49e9bdee870d78f0$var$durationHour
    ],
    [
        "day",
        $49e9bdee870d78f0$var$durationDay
    ],
    [
        "monday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "tuesday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "wednesday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "thursday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "friday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "saturday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "sunday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "week",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "month",
        $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "year",
        $49e9bdee870d78f0$var$durationYear
    ]
]);
const $49e9bdee870d78f0$var$timeIntervals = new Map([
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d)
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$a7e4c34a52f0576)
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$46c68a5833bc315b)
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$8888529b966033e5)
    ],
    [
        "monday",
        (0, $7f6029921eecd017$export$e79bbe0177cf1b01)
    ],
    [
        "tuesday",
        (0, $7f6029921eecd017$export$57c0658c29f77708)
    ],
    [
        "wednesday",
        (0, $7f6029921eecd017$export$3fbeef226c256e43)
    ],
    [
        "thursday",
        (0, $7f6029921eecd017$export$608689422d5cf9f4)
    ],
    [
        "friday",
        (0, $7f6029921eecd017$export$548e5227aa183dca)
    ],
    [
        "saturday",
        (0, $7f6029921eecd017$export$c56a3ad248908e19)
    ],
    [
        "sunday",
        (0, $7f6029921eecd017$export$22ee6205b762968c)
    ],
    [
        "week",
        (0, $7f6029921eecd017$export$22ee6205b762968c)
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$7e1084fb688591c1)
    ],
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)
    ]
]);
const $49e9bdee870d78f0$var$utcIntervals = new Map([
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d)
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$efe6712d6003761b)
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$31f6f2b3c63ac75e)
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71)
    ],
    [
        "monday",
        (0, $7f6029921eecd017$export$9cfc53b9cfafd080)
    ],
    [
        "tuesday",
        (0, $7f6029921eecd017$export$2a6d545f77eceb15)
    ],
    [
        "wednesday",
        (0, $7f6029921eecd017$export$a5c25d8ed64433c4)
    ],
    [
        "thursday",
        (0, $7f6029921eecd017$export$1db08111baec2f53)
    ],
    [
        "friday",
        (0, $7f6029921eecd017$export$29265e34dd5921f7)
    ],
    [
        "saturday",
        (0, $7f6029921eecd017$export$85b74dad05049604)
    ],
    [
        "sunday",
        (0, $7f6029921eecd017$export$4898b06303a92011)
    ],
    [
        "week",
        (0, $7f6029921eecd017$export$4898b06303a92011)
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5)
    ],
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)
    ]
]);
const $49e9bdee870d78f0$export$6b9291a5690ab4c6 = Symbol("intervalDuration");
const $49e9bdee870d78f0$export$84d7908c031f9a60 = Symbol("intervalType");
// We greedily mutate D3’s standard intervals on load so that the hidden fields
// are available even if specified as e.g. d3.utcMonth instead of "month".
for (const [name, interval] of $49e9bdee870d78f0$var$timeIntervals){
    interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6] = $49e9bdee870d78f0$var$durations.get(name);
    interval[$49e9bdee870d78f0$export$84d7908c031f9a60] = "time";
}
for (const [name, interval] of $49e9bdee870d78f0$var$utcIntervals){
    interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6] = $49e9bdee870d78f0$var$durations.get(name);
    interval[$49e9bdee870d78f0$export$84d7908c031f9a60] = "utc";
}
const $49e9bdee870d78f0$var$utcFormatIntervals = [
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4),
        "utc"
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5),
        "utc"
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71),
        "utc",
        6 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$31f6f2b3c63ac75e),
        "utc",
        3 * $49e9bdee870d78f0$var$durationDay
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$efe6712d6003761b),
        "utc",
        6 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
        "utc",
        30 * $49e9bdee870d78f0$var$durationMinute
    ]
];
const $49e9bdee870d78f0$var$timeFormatIntervals = [
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046),
        "time"
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$7e1084fb688591c1),
        "time"
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$8888529b966033e5),
        "time",
        6 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$46c68a5833bc315b),
        "time",
        3 * $49e9bdee870d78f0$var$durationDay
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$a7e4c34a52f0576),
        "time",
        6 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
        "time",
        30 * $49e9bdee870d78f0$var$durationMinute
    ]
];
// An interleaved array of UTC and local time intervals, in descending order
// from largest to smallest, used to determine the most specific standard time
// format for a given array of dates. This is a subset of the tick intervals
// listed above; we only need the breakpoints where the format changes.
const $49e9bdee870d78f0$var$formatIntervals = [
    $49e9bdee870d78f0$var$utcFormatIntervals[0],
    $49e9bdee870d78f0$var$timeFormatIntervals[0],
    $49e9bdee870d78f0$var$utcFormatIntervals[1],
    $49e9bdee870d78f0$var$timeFormatIntervals[1],
    $49e9bdee870d78f0$var$utcFormatIntervals[2],
    $49e9bdee870d78f0$var$timeFormatIntervals[2],
    // Below day, local time typically has an hourly offset from UTC and hence the
    // two are aligned and indistinguishable; therefore, we only consider UTC, and
    // we don’t consider these if the domain only has a single value.
    ...$49e9bdee870d78f0$var$utcFormatIntervals.slice(3)
];
function $49e9bdee870d78f0$export$713f3432fde4ec88(input) {
    let name = `${input}`.toLowerCase();
    if (name.endsWith("s")) name = name.slice(0, -1); // drop plural
    let period = 1;
    const match = /^(?:(\d+)\s+)/.exec(name);
    if (match) {
        name = name.slice(match[0].length);
        period = +match[1];
    }
    switch(name){
        case "quarter":
            name = "month";
            period *= 3;
            break;
        case "half":
            name = "month";
            period *= 6;
            break;
    }
    let interval = $49e9bdee870d78f0$var$utcIntervals.get(name);
    if (!interval) throw new Error(`unknown interval: ${input}`);
    if (period > 1 && !interval.every) throw new Error(`non-periodic interval: ${name}`);
    return [
        name,
        period
    ];
}
function $49e9bdee870d78f0$export$1a539c8b2950ab40(input) {
    return $49e9bdee870d78f0$var$asInterval($49e9bdee870d78f0$export$713f3432fde4ec88(input), "time");
}
function $49e9bdee870d78f0$export$e1d09836890453eb(input) {
    return $49e9bdee870d78f0$var$asInterval($49e9bdee870d78f0$export$713f3432fde4ec88(input), "utc");
}
function $49e9bdee870d78f0$var$asInterval([name, period], type) {
    let interval = (type === "time" ? $49e9bdee870d78f0$var$timeIntervals : $49e9bdee870d78f0$var$utcIntervals).get(name);
    if (period > 1) {
        interval = interval.every(period);
        interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6] = $49e9bdee870d78f0$var$durations.get(name) * period;
        interval[$49e9bdee870d78f0$export$84d7908c031f9a60] = type;
    }
    return interval;
}
function $49e9bdee870d78f0$export$29a4ccaf5efe074d(interval, n) {
    if (!(n > 1)) return; // no need to generalize
    const duration = interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6];
    if (!$49e9bdee870d78f0$var$tickIntervals.some(([, d])=>d === duration)) return; // nonstandard or unknown interval
    if (duration % $49e9bdee870d78f0$var$durationDay === 0 && $49e9bdee870d78f0$var$durationDay < duration && duration < $49e9bdee870d78f0$var$durationMonth) return; // not generalizable
    const [i] = $49e9bdee870d78f0$var$tickIntervals[(0, $0ae9019609d046a1$export$2e2bcd8739ae039)(([, step])=>Math.log(step)).center($49e9bdee870d78f0$var$tickIntervals, Math.log(duration * n))];
    return (interval[$49e9bdee870d78f0$export$84d7908c031f9a60] === "time" ? $49e9bdee870d78f0$export$1a539c8b2950ab40 : $49e9bdee870d78f0$export$e1d09836890453eb)(i);
}
function $49e9bdee870d78f0$var$formatTimeInterval(name, type, anchor) {
    const format = type === "time" ? (0, $0a9ce0165786feda$export$94f4d87fad5dcf9a) : (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb);
    // For tips and legends, use a format that doesn’t require context.
    if (anchor == null) return format(name === "year" ? "%Y" : name === "month" ? "%Y-%m" : name === "day" ? "%Y-%m-%d" : name === "hour" || name === "minute" ? "%Y-%m-%dT%H:%M" : name === "second" ? "%Y-%m-%dT%H:%M:%S" : "%Y-%m-%dT%H:%M:%S.%L");
    // Otherwise, assume that this is for axis ticks.
    const template = $49e9bdee870d78f0$var$getTimeTemplate(anchor);
    switch(name){
        case "millisecond":
            return $49e9bdee870d78f0$var$formatConditional(format(".%L"), format(":%M:%S"), template);
        case "second":
            return $49e9bdee870d78f0$var$formatConditional(format(":%S"), format("%-I:%M"), template);
        case "minute":
            return $49e9bdee870d78f0$var$formatConditional(format("%-I:%M"), format("%p"), template);
        case "hour":
            return $49e9bdee870d78f0$var$formatConditional(format("%-I %p"), format("%b %-d"), template);
        case "day":
            return $49e9bdee870d78f0$var$formatConditional(format("%-d"), format("%b"), template);
        case "month":
            return $49e9bdee870d78f0$var$formatConditional(format("%b"), format("%Y"), template);
        case "year":
            return format("%Y");
    }
    throw new Error("unable to format time ticks");
}
function $49e9bdee870d78f0$var$getTimeTemplate(anchor) {
    return anchor === "left" || anchor === "right" ? (f1, f2)=>`\n${f1}\n${f2}` // extra newline to keep f1 centered
     : anchor === "top" ? (f1, f2)=>`${f2}\n${f1}` : (f1, f2)=>`${f1}\n${f2}`;
}
function $49e9bdee870d78f0$var$getFormatIntervals(type) {
    return type === "time" ? $49e9bdee870d78f0$var$timeFormatIntervals : type === "utc" ? $49e9bdee870d78f0$var$utcFormatIntervals : $49e9bdee870d78f0$var$formatIntervals;
}
function $49e9bdee870d78f0$export$8d2dceb4d1e6fd24(type, dates, anchor) {
    const step = (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)((0, $a9640ed34ca3d852$export$2e2bcd8739ae039)(dates, (a, b)=>Math.abs(b - a))); // maybe undefined!
    if (step < 1000) return $49e9bdee870d78f0$var$formatTimeInterval("millisecond", "utc", anchor);
    for (const [name, interval, intervalType, maxStep] of $49e9bdee870d78f0$var$getFormatIntervals(type)){
        if (step > maxStep) break; // e.g., 52 weeks
        if (name === "hour" && !step) break; // e.g., domain with a single date
        if (dates.every((d)=>interval.floor(d) >= d)) return $49e9bdee870d78f0$var$formatTimeInterval(name, intervalType, anchor);
    }
}
function $49e9bdee870d78f0$var$formatConditional(format1, format2, template) {
    return (x, i, X)=>{
        const f1 = format1(x, i); // always shown
        const f2 = format2(x, i); // only shown if different
        const j = i - (0, $98c8b67f479b9fc9$export$c25b1294fe9f63f1)(X); // detect reversed domains
        return i !== j && X[j] !== undefined && f2 === format2(X[j], j) ? f1 : template(f1, f2);
    };
}


const $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 = Object.getPrototypeOf(Uint8Array);
const $cd9e805a4bbd13f9$var$objectToString = Object.prototype.toString;
function $cd9e805a4bbd13f9$export$43bee75e5e14138e(value) {
    return value instanceof Array || value instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9;
}
function $cd9e805a4bbd13f9$var$isNumberArray(value) {
    return value instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 && !$cd9e805a4bbd13f9$var$isBigIntArray(value);
}
function $cd9e805a4bbd13f9$var$isNumberType(type) {
    return type?.prototype instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 && !$cd9e805a4bbd13f9$var$isBigIntType(type);
}
function $cd9e805a4bbd13f9$var$isBigIntArray(value) {
    return value instanceof BigInt64Array || value instanceof BigUint64Array;
}
function $cd9e805a4bbd13f9$var$isBigIntType(type) {
    return type === BigInt64Array || type === BigUint64Array;
}
const $cd9e805a4bbd13f9$export$c800939f8d8c9f76 = Symbol("reindex");
function $cd9e805a4bbd13f9$export$1414f04542a0b4f4(data, value, type) {
    const valueType = typeof value;
    return valueType === "string" ? $cd9e805a4bbd13f9$var$isArrowTable(data) ? $cd9e805a4bbd13f9$var$maybeTypedArrowify(data.getChild(value), type) : $cd9e805a4bbd13f9$var$maybeTypedMap(data, $cd9e805a4bbd13f9$export$e0f35d825088c098(value), type) : valueType === "function" ? $cd9e805a4bbd13f9$var$maybeTypedMap(data, value, type) : valueType === "number" || value instanceof Date || valueType === "boolean" ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(data, $cd9e805a4bbd13f9$export$c983f826f44ff86(value), type) : typeof value?.transform === "function" ? $cd9e805a4bbd13f9$var$maybeTypedArrayify(value.transform(data), type) : $cd9e805a4bbd13f9$var$maybeTake($cd9e805a4bbd13f9$var$maybeTypedArrayify(value, type), data?.[$cd9e805a4bbd13f9$export$c800939f8d8c9f76]);
}
function $cd9e805a4bbd13f9$var$maybeTake(values, index) {
    return values != null && index ? $cd9e805a4bbd13f9$export$b7df5d561049483a(values, index) : values;
}
function $cd9e805a4bbd13f9$var$maybeTypedMap(data, f, type) {
    return $cd9e805a4bbd13f9$export$871de8747c9eaa88(data, $cd9e805a4bbd13f9$var$isNumberType(type) ? (d, i)=>$cd9e805a4bbd13f9$var$coerceNumber(f(d, i)) : f, type); // allow conversion from BigInt
}
function $cd9e805a4bbd13f9$var$maybeTypedArrayify(data, type) {
    return type === undefined ? $cd9e805a4bbd13f9$export$3131421a7d01b4fb(data) // preserve undefined type
     : $cd9e805a4bbd13f9$var$isArrowVector(data) ? $cd9e805a4bbd13f9$var$maybeTypedArrowify(data, type) : data instanceof type ? data : type.from(data, $cd9e805a4bbd13f9$var$isNumberType(type) && !$cd9e805a4bbd13f9$var$isNumberArray(data) ? $cd9e805a4bbd13f9$var$coerceNumber : undefined);
}
function $cd9e805a4bbd13f9$var$maybeTypedArrowify(vector, type) {
    return vector == null ? vector : (type === undefined || type === Array) && $cd9e805a4bbd13f9$var$isArrowDateType(vector.type) ? $cd9e805a4bbd13f9$export$9a67b3ad4b3297f7(vector.toArray()) : $cd9e805a4bbd13f9$var$maybeTypedArrayify(vector.toArray(), type);
}
const $cd9e805a4bbd13f9$export$439306a4dcaafbb9 = [
    null
]; // for data-less decoration marks, e.g. frame
const $cd9e805a4bbd13f9$export$e0f35d825088c098 = (name)=>(d)=>{
        const v = d[name];
        return v === undefined && d.type === "Feature" ? d.properties?.[name] : v;
    }; // prettier-ignore
const $cd9e805a4bbd13f9$export$305f7d4e9d4624f2 = {
    transform: $cd9e805a4bbd13f9$export$d02631cccf789723
};
const $cd9e805a4bbd13f9$export$f0954fd7d5368655 = {
    transform: (d)=>d
};
const $cd9e805a4bbd13f9$export$7f9972325ebfd559 = ()=>0;
const $cd9e805a4bbd13f9$export$80bf7733f1207381 = ()=>1;
const $cd9e805a4bbd13f9$export$7a668e70ea2210d9 = ()=>true;
const $cd9e805a4bbd13f9$export$22b082955e083ec3 = (x)=>x == null ? x : `${x}`;
const $cd9e805a4bbd13f9$export$98e628dec113755e = (x)=>x == null ? x : +x;
const $cd9e805a4bbd13f9$export$4a21f16c33752377 = (x)=>x == null ? x : !!x;
const $cd9e805a4bbd13f9$export$43128fadae87b74a = (x)=>x ? x[0] : undefined;
const $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d = (x)=>x ? x[1] : undefined;
const $cd9e805a4bbd13f9$export$1fa4a8860392dfdb = (x)=>x ? x[2] : undefined;
const $cd9e805a4bbd13f9$export$c983f826f44ff86 = (x)=>()=>x;
function $cd9e805a4bbd13f9$export$c4df44c805494ac9(reduce) {
    const p = +`${reduce}`.slice(1) / 100;
    return (I, f)=>(0, $231c9024a6754413$export$2e2bcd8739ae039)(I, p, f);
}
function $cd9e805a4bbd13f9$export$803a244824c02a83(values) {
    return $cd9e805a4bbd13f9$var$isNumberArray(values) ? values : $cd9e805a4bbd13f9$export$871de8747c9eaa88(values, $cd9e805a4bbd13f9$var$coerceNumber, Float64Array);
}
// Unlike Mark’s number, here we want to convert null and undefined to NaN since
// the result will be stored in a Float64Array and we don’t want null to be
// coerced to zero. We use Number instead of unary + to allow BigInt coercion.
function $cd9e805a4bbd13f9$var$coerceNumber(x) {
    return x == null ? NaN : Number(x);
}
function $cd9e805a4bbd13f9$export$9a67b3ad4b3297f7(values) {
    return $cd9e805a4bbd13f9$export$871de8747c9eaa88(values, $cd9e805a4bbd13f9$export$187f75afdaf90d5b);
}
function $cd9e805a4bbd13f9$export$187f75afdaf90d5b(x) {
    return x instanceof Date && !isNaN(x) ? x : typeof x === "string" ? (0, $a25d0745dd917edb$export$2e2bcd8739ae039)(x) : x == null || isNaN(x = Number(x)) // allow conversion from BigInt
     ? undefined : new Date(x);
}
function $cd9e805a4bbd13f9$export$6dcb63290aa6d572(value, defaultValue) {
    if (value === undefined) value = defaultValue;
    return value === null ? [
        undefined,
        "none"
    ] : $cd9e805a4bbd13f9$export$e82f763eaa28f6fe(value) ? [
        undefined,
        value
    ] : [
        value,
        undefined
    ];
}
function $cd9e805a4bbd13f9$export$75c96357b71c0240(value, defaultValue) {
    if (value === undefined) value = defaultValue;
    return value === null || typeof value === "number" ? [
        undefined,
        value
    ] : [
        value,
        undefined
    ];
}
function $cd9e805a4bbd13f9$export$a305618d7bff6223(input, name, allowed) {
    if (input != null) return $cd9e805a4bbd13f9$export$2e81050496d0e63e(input, name, allowed);
}
function $cd9e805a4bbd13f9$export$2e81050496d0e63e(input, name, allowed) {
    const i = `${input}`.toLowerCase();
    if (!allowed.includes(i)) throw new Error(`invalid ${name}: ${input}`);
    return i;
}
function $cd9e805a4bbd13f9$export$73f73ccd44b2553f(data) {
    return $cd9e805a4bbd13f9$var$isArrowTable(data) ? data : $cd9e805a4bbd13f9$export$3131421a7d01b4fb(data);
}
function $cd9e805a4bbd13f9$export$3131421a7d01b4fb(values) {
    if (values == null || $cd9e805a4bbd13f9$export$43bee75e5e14138e(values)) return values;
    if ($cd9e805a4bbd13f9$var$isArrowVector(values)) return $cd9e805a4bbd13f9$var$maybeTypedArrowify(values);
    switch(values.type){
        case "FeatureCollection":
            return values.features;
        case "GeometryCollection":
            return values.geometries;
        case "Feature":
        case "LineString":
        case "MultiLineString":
        case "MultiPoint":
        case "MultiPolygon":
        case "Point":
        case "Polygon":
        case "Sphere":
            return [
                values
            ];
    }
    return Array.from(values);
}
function $cd9e805a4bbd13f9$export$871de8747c9eaa88(values, f, type = Array) {
    return values == null ? values : values instanceof type ? values.map(f) : type.from(values, f);
}
function $cd9e805a4bbd13f9$export$58adb3bec8346d0f(values, type = Array) {
    return values instanceof type ? values.slice() : type.from(values);
}
function $cd9e805a4bbd13f9$export$98a86545e71eb684({ x: x, x1: x1, x2: x2 }) {
    return x !== undefined || x1 !== undefined || x2 !== undefined;
}
function $cd9e805a4bbd13f9$export$6fec46f4cb6f332e({ y: y, y1: y1, y2: y2 }) {
    return y !== undefined || y1 !== undefined || y2 !== undefined;
}
function $cd9e805a4bbd13f9$export$3ebe4f8dba92c238(options) {
    return $cd9e805a4bbd13f9$export$98a86545e71eb684(options) || $cd9e805a4bbd13f9$export$6fec46f4cb6f332e(options) || options.interval !== undefined;
}
function $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a(option) {
    return option?.toString === $cd9e805a4bbd13f9$var$objectToString;
}
function $cd9e805a4bbd13f9$export$1fb8003448468be0(option) {
    return $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a(option) && (option.type !== undefined || option.domain !== undefined);
}
function $cd9e805a4bbd13f9$export$dae3322343de7d27(option) {
    return $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a(option) && typeof option.transform !== "function";
}
function $cd9e805a4bbd13f9$export$d6cc17845c0d71a0(sort) {
    return $cd9e805a4bbd13f9$export$dae3322343de7d27(sort) && sort.value === undefined && sort.channel === undefined;
}
function $cd9e805a4bbd13f9$export$988dfb0cf3d08a43(x, x1, x2, x3 = $cd9e805a4bbd13f9$export$f0954fd7d5368655) {
    if (x1 === undefined && x2 === undefined) // {x} or {}
    x1 = 0, x2 = x === undefined ? x3 : x;
    else if (x1 === undefined) // {x, x2} or {x2}
    x1 = x === undefined ? 0 : x;
    else if (x2 === undefined) // {x, x1} or {x1}
    x2 = x === undefined ? 0 : x;
    return [
        x1,
        x2
    ];
}
function $cd9e805a4bbd13f9$export$8598999985068071(x, y) {
    return x === undefined && y === undefined ? [
        $cd9e805a4bbd13f9$export$43128fadae87b74a,
        $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d
    ] : [
        x,
        y
    ];
}
function $cd9e805a4bbd13f9$export$9040d0441634ebe5({ z: z, fill: fill, stroke: stroke } = {}) {
    if (z === undefined) [z] = $cd9e805a4bbd13f9$export$6dcb63290aa6d572(fill);
    if (z === undefined) [z] = $cd9e805a4bbd13f9$export$6dcb63290aa6d572(stroke);
    return z;
}
function $cd9e805a4bbd13f9$export$766772bbf464ff6(data) {
    return $cd9e805a4bbd13f9$export$43bee75e5e14138e(data) ? data.length : data?.numRows;
}
function $cd9e805a4bbd13f9$export$d02631cccf789723(data) {
    const n = $cd9e805a4bbd13f9$export$766772bbf464ff6(data);
    const r = new Uint32Array(n);
    for(let i = 0; i < n; ++i)r[i] = i;
    return r;
}
function $cd9e805a4bbd13f9$export$b7df5d561049483a(values, index) {
    return $cd9e805a4bbd13f9$export$43bee75e5e14138e(values) ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(index, (i)=>values[i], values.constructor) : $cd9e805a4bbd13f9$export$871de8747c9eaa88(index, (i)=>values.at(i));
}
function $cd9e805a4bbd13f9$export$db49c4d122d2e604(f) {
    return f.length === 1 ? (index, values)=>f($cd9e805a4bbd13f9$export$b7df5d561049483a(values, index)) : f;
}
function $cd9e805a4bbd13f9$export$7ec32827e4221318(I, i, j) {
    return I.subarray ? I.subarray(i, j) : I.slice(i, j);
}
function $cd9e805a4bbd13f9$export$7e1278799275f68e(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function $cd9e805a4bbd13f9$export$84405e33d6be068e(key, options) {
    if (options[key] !== undefined) return options[key];
    switch(key){
        case "x1":
        case "x2":
            key = "x";
            break;
        case "y1":
        case "y2":
            key = "y";
            break;
    }
    return options[key];
}
function $cd9e805a4bbd13f9$export$4e0c71f277ca26b3(source) {
    // Defines a column whose values are lazily populated by calling the returned
    // setter. If the given source is labeled, the label is propagated to the
    // returned column definition.
    let value;
    return [
        {
            transform: ()=>value,
            label: $cd9e805a4bbd13f9$export$bd9d73a16a2ec705(source)
        },
        (v)=>value = v
    ];
}
function $cd9e805a4bbd13f9$export$46d040b9076e32ab(source) {
    return source == null ? [
        source
    ] : $cd9e805a4bbd13f9$export$4e0c71f277ca26b3(source);
}
function $cd9e805a4bbd13f9$export$bd9d73a16a2ec705(value, defaultValue) {
    return typeof value === "string" ? value : value && value.label !== undefined ? value.label : defaultValue;
}
function $cd9e805a4bbd13f9$export$a61423b330c3444c(x1, x2) {
    return {
        transform (data) {
            const X1 = x1.transform(data);
            const X2 = x2.transform(data);
            return $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7(X1) || $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7(X2) ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(X1, (_, i)=>new Date((+X1[i] + +X2[i]) / 2)) : $cd9e805a4bbd13f9$export$871de8747c9eaa88(X1, (_, i)=>(+X1[i] + +X2[i]) / 2, Float64Array);
        },
        label: x1.label
    };
}
function $cd9e805a4bbd13f9$export$90792ed47ffcc9f3(V, scale) {
    const t = $cd9e805a4bbd13f9$export$2170e2fe1255e79b(scale?.interval, scale?.type);
    return t ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(V, t) : V;
}
function $cd9e805a4bbd13f9$export$2170e2fe1255e79b(interval, type) {
    const i = $cd9e805a4bbd13f9$export$91a968a7e5747089(interval, type);
    return i && ((v)=>(0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97)(v) ? i.floor(v) : v);
}
function $cd9e805a4bbd13f9$export$91a968a7e5747089(interval, type) {
    if (interval == null) return;
    if (typeof interval === "number") return $cd9e805a4bbd13f9$export$6c2ce20d72838e75(interval);
    if (typeof interval === "string") return (type === "time" ? (0, $49e9bdee870d78f0$export$1a539c8b2950ab40) : (0, $49e9bdee870d78f0$export$e1d09836890453eb))(interval);
    if (typeof interval.floor !== "function") throw new Error("invalid interval; missing floor method");
    if (typeof interval.offset !== "function") throw new Error("invalid interval; missing offset method");
    return interval;
}
function $cd9e805a4bbd13f9$export$6c2ce20d72838e75(interval) {
    interval = +interval;
    if (0 < interval && interval < 1 && Number.isInteger(1 / interval)) interval = -1 / interval;
    const n = Math.abs(interval);
    return interval < 0 ? {
        floor: (d)=>Math.floor(d * n) / n,
        offset: (d, s = 1)=>(d * n + Math.floor(s)) / n,
        range: (lo, hi)=>(0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(Math.ceil(lo * n), hi * n).map((x)=>x / n)
    } : {
        floor: (d)=>Math.floor(d / n) * n,
        offset: (d, s = 1)=>d + n * Math.floor(s),
        range: (lo, hi)=>(0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(Math.ceil(lo / n), hi / n).map((x)=>x * n)
    };
}
function $cd9e805a4bbd13f9$export$e13732492629ec8c(interval, type) {
    interval = $cd9e805a4bbd13f9$export$91a968a7e5747089(interval, type);
    if (interval && typeof interval.range !== "function") throw new Error("invalid interval: missing range method");
    return interval;
}
function $cd9e805a4bbd13f9$export$367d1ceccf20717f(interval, type) {
    interval = $cd9e805a4bbd13f9$export$e13732492629ec8c(interval, type);
    if (interval && typeof interval.ceil !== "function") throw new Error("invalid interval: missing ceil method");
    return interval;
}
function $cd9e805a4bbd13f9$export$99c391ff8c95e1af(t) {
    return $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e(t) && typeof t?.floor === "function" && t.floor() instanceof Date;
}
function $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e(t) {
    return typeof t?.range === "function";
}
function $cd9e805a4bbd13f9$export$f4579685de3ca7bf(value) {
    return value === undefined || $cd9e805a4bbd13f9$export$dae3322343de7d27(value) ? value : {
        value: value
    };
}
function $cd9e805a4bbd13f9$export$a152540187b5d206(source) {
    return source == null ? null : {
        transform: (data)=>$cd9e805a4bbd13f9$export$1414f04542a0b4f4(data, source, Float64Array),
        label: $cd9e805a4bbd13f9$export$bd9d73a16a2ec705(source)
    };
}
function $cd9e805a4bbd13f9$export$b172b2c11ac297b9(data) {
    if (!$cd9e805a4bbd13f9$export$9652023d9040757(data)) return false;
    for (const d of data){
        if (d == null) continue;
        return typeof d === "object" && "0" in d && "1" in d;
    }
}
function $cd9e805a4bbd13f9$export$9652023d9040757(value) {
    return value && typeof value[Symbol.iterator] === "function";
}
function $cd9e805a4bbd13f9$export$43674e37205f3011(values) {
    for (const value of values){
        if (value == null) continue;
        return typeof value !== "object" || value instanceof Date;
    }
}
function $cd9e805a4bbd13f9$export$ded408f9a9c9003b(values) {
    for (const value of values){
        if (value == null) continue;
        const type = typeof value;
        return type === "string" || type === "boolean";
    }
}
function $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7(values) {
    for (const value of values){
        if (value == null) continue;
        return value instanceof Date;
    }
}
function $cd9e805a4bbd13f9$export$4ca903a67c0d1c91(values) {
    for (const value of values){
        if (value == null) continue;
        return typeof value === "string" && isNaN(value) && (0, $a25d0745dd917edb$export$2e2bcd8739ae039)(value);
    }
}
function $cd9e805a4bbd13f9$export$797f4d96e209972c(values) {
    for (const value of values){
        if (value == null) continue;
        if (typeof value !== "string") return false;
        if (!value.trim()) continue;
        return !isNaN(value);
    }
}
function $cd9e805a4bbd13f9$export$e90fb89750dba83f(values) {
    for (const value of values){
        if (value == null) continue;
        return typeof value === "number";
    }
}
function $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1(values, is) {
    let every;
    for (const value of values){
        if (value == null) continue;
        if (!is(value)) return false;
        every = true;
    }
    return every;
}
const $cd9e805a4bbd13f9$var$namedColors = new Set("none,currentcolor,transparent,aliceblue,antiquewhite,aqua,aquamarine,azure,beige,bisque,black,blanchedalmond,blue,blueviolet,brown,burlywood,cadetblue,chartreuse,chocolate,coral,cornflowerblue,cornsilk,crimson,cyan,darkblue,darkcyan,darkgoldenrod,darkgray,darkgreen,darkgrey,darkkhaki,darkmagenta,darkolivegreen,darkorange,darkorchid,darkred,darksalmon,darkseagreen,darkslateblue,darkslategray,darkslategrey,darkturquoise,darkviolet,deeppink,deepskyblue,dimgray,dimgrey,dodgerblue,firebrick,floralwhite,forestgreen,fuchsia,gainsboro,ghostwhite,gold,goldenrod,gray,green,greenyellow,grey,honeydew,hotpink,indianred,indigo,ivory,khaki,lavender,lavenderblush,lawngreen,lemonchiffon,lightblue,lightcoral,lightcyan,lightgoldenrodyellow,lightgray,lightgreen,lightgrey,lightpink,lightsalmon,lightseagreen,lightskyblue,lightslategray,lightslategrey,lightsteelblue,lightyellow,lime,limegreen,linen,magenta,maroon,mediumaquamarine,mediumblue,mediumorchid,mediumpurple,mediumseagreen,mediumslateblue,mediumspringgreen,mediumturquoise,mediumvioletred,midnightblue,mintcream,mistyrose,moccasin,navajowhite,navy,oldlace,olive,olivedrab,orange,orangered,orchid,palegoldenrod,palegreen,paleturquoise,palevioletred,papayawhip,peachpuff,peru,pink,plum,powderblue,purple,rebeccapurple,red,rosybrown,royalblue,saddlebrown,salmon,sandybrown,seagreen,seashell,sienna,silver,skyblue,slateblue,slategray,slategrey,snow,springgreen,steelblue,tan,teal,thistle,tomato,turquoise,violet,wheat,white,whitesmoke,yellow".split(",")); // prettier-ignore
function $cd9e805a4bbd13f9$export$e82f763eaa28f6fe(value) {
    if (typeof value !== "string") return false;
    value = value.toLowerCase().trim();
    return /^#[0-9a-f]{3,8}$/.test(value) || // hex rgb, rgba, rrggbb, rrggbbaa
    /^(?:url|var|rgb|rgba|hsl|hsla|hwb|lab|lch|oklab|oklch|color|color-mix)\(.*\)$/.test(value) || // <funciri>, CSS variable, color, etc.
    $cd9e805a4bbd13f9$var$namedColors.has(value) // currentColor, red, etc.
    ;
}
function $cd9e805a4bbd13f9$export$4108b961417e5a2a(value) {
    return typeof value === "number" && (0 <= value && value <= 1 || isNaN(value));
}
function $cd9e805a4bbd13f9$export$143ac3c9068abf57(value) {
    return value == null || $cd9e805a4bbd13f9$export$e56af863d5645d5f(value);
}
function $cd9e805a4bbd13f9$export$e56af863d5645d5f(value) {
    return /^\s*none\s*$/i.test(value);
}
function $cd9e805a4bbd13f9$export$e2647994a9b8277a(value) {
    return /^\s*round\s*$/i.test(value);
}
function $cd9e805a4bbd13f9$export$6738a673c9b9c522(value, name) {
    return $cd9e805a4bbd13f9$export$a305618d7bff6223(value, name, [
        "middle",
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]);
}
function $cd9e805a4bbd13f9$export$e2bf218018856d53(value = "middle") {
    return $cd9e805a4bbd13f9$export$6738a673c9b9c522(value, "frameAnchor");
}
function $cd9e805a4bbd13f9$export$4dc9a6b0ae3dfd2a(options = {}, ...rest) {
    let o = options;
    for (const defaults of rest){
        for(const key in defaults)if (o[key] === undefined) {
            const value = defaults[key];
            if (o === options) o = {
                ...o,
                [key]: value
            };
            else o[key] = value;
        }
    }
    return o;
}
function $cd9e805a4bbd13f9$export$e1744e1bc4c7f337(things) {
    console.warn("named iterables are deprecated; please use an object instead");
    const names = new Set();
    return Object.fromEntries(Array.from(things, (thing)=>{
        const { name: name } = thing;
        if (name == null) throw new Error("missing name");
        const key = `${name}`;
        if (key === "__proto__") throw new Error(`illegal name: ${key}`);
        if (names.has(key)) throw new Error(`duplicate name: ${key}`);
        names.add(key);
        return [
            name,
            thing
        ];
    }));
}
function $cd9e805a4bbd13f9$export$b221e5d053773f17(things) {
    return $cd9e805a4bbd13f9$export$9652023d9040757(things) ? $cd9e805a4bbd13f9$export$e1744e1bc4c7f337(things) : things;
}
function $cd9e805a4bbd13f9$export$1920f6ea06533ca7(clip) {
    if (clip === true) clip = "frame";
    else if (clip === false) clip = null;
    else if (clip != null) clip = $cd9e805a4bbd13f9$export$2e81050496d0e63e(clip, "clip", [
        "frame",
        "sphere"
    ]);
    return clip;
}
// https://github.com/observablehq/stdlib/blob/746ca2e69135df6178e4f3a17244def35d8d6b20/src/arrow.js#L4C1-L17C1
function $cd9e805a4bbd13f9$var$isArrowTable(value) {
    return value && typeof value.getChild === "function" && typeof value.toArray === "function" && value.schema && Array.isArray(value.schema.fields);
}
function $cd9e805a4bbd13f9$var$isArrowVector(value) {
    return value && typeof value.toArray === "function" && value.type;
}
// Apache Arrow now represents dates as numbers. We currently only support
// implicit coercion to JavaScript Date objects when the numbers represent
// milliseconds since Unix epoch.
function $cd9e805a4bbd13f9$var$isArrowDateType(type) {
    return type && (type.typeId === 8 || // date
    type.typeId === 10) && // timestamp
    type.unit === 1 // millisecond
    ;
}


// Positional scales have associated axes, and for ordinal data, a point or band
// scale is used instead of an ordinal scale.
const $743dde21c57c19a0$export$5880b8b5730aff45 = Symbol("position");
const $743dde21c57c19a0$export$35e9368ef982300f = Symbol("color");
const $743dde21c57c19a0$export$872dd985a098dd45 = Symbol("radius");
const $743dde21c57c19a0$export$f24224f1c91d8156 = Symbol("length");
const $743dde21c57c19a0$export$c17a3be1057836e = Symbol("opacity");
const $743dde21c57c19a0$export$8f701197936bc2a6 = Symbol("symbol");
const $743dde21c57c19a0$export$b74061472fe7c07 = Symbol("projection");
const $743dde21c57c19a0$export$4bb7493d241fd8a5 = new Map([
    [
        "x",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "y",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "fx",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "fy",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "r",
        $743dde21c57c19a0$export$872dd985a098dd45
    ],
    [
        "color",
        $743dde21c57c19a0$export$35e9368ef982300f
    ],
    [
        "opacity",
        $743dde21c57c19a0$export$c17a3be1057836e
    ],
    [
        "symbol",
        $743dde21c57c19a0$export$8f701197936bc2a6
    ],
    [
        "length",
        $743dde21c57c19a0$export$f24224f1c91d8156
    ],
    [
        "projection",
        $743dde21c57c19a0$export$b74061472fe7c07
    ]
]);
function $743dde21c57c19a0$export$1680e4b48df7f4f2(kind) {
    return kind === $743dde21c57c19a0$export$5880b8b5730aff45 || kind === $743dde21c57c19a0$export$b74061472fe7c07;
}
function $743dde21c57c19a0$export$2d070ad8c31ab6b9(kind) {
    return kind === $743dde21c57c19a0$export$5880b8b5730aff45 || kind === $743dde21c57c19a0$export$872dd985a098dd45 || kind === $743dde21c57c19a0$export$f24224f1c91d8156 || kind === $743dde21c57c19a0$export$c17a3be1057836e;
}



const $7ef09cabd5617a1b$export$91aa808ec3c0b8ec = Math.sqrt(3);
const $7ef09cabd5617a1b$export$9ac4eebcf02b462f = 2 / $7ef09cabd5617a1b$export$91aa808ec3c0b8ec;
const $7ef09cabd5617a1b$var$symbolHexagon = {
    draw (context, size) {
        const rx = Math.sqrt(size / Math.PI), ry = rx * $7ef09cabd5617a1b$export$9ac4eebcf02b462f, hy = ry / 2;
        context.moveTo(0, ry);
        context.lineTo(rx, hy);
        context.lineTo(rx, -hy);
        context.lineTo(0, -ry);
        context.lineTo(-rx, -hy);
        context.lineTo(-rx, hy);
        context.closePath();
    }
};
const $7ef09cabd5617a1b$var$symbols = new Map([
    [
        "asterisk",
        (0, $134055608cfdbbf1$export$2e2bcd8739ae039)
    ],
    [
        "circle",
        (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039)
    ],
    [
        "cross",
        (0, $6389eccbe795c95c$export$2e2bcd8739ae039)
    ],
    [
        "diamond",
        (0, $42af998bb354705d$export$2e2bcd8739ae039)
    ],
    [
        "diamond2",
        (0, $f2564dd3ed0020e5$export$2e2bcd8739ae039)
    ],
    [
        "hexagon",
        $7ef09cabd5617a1b$var$symbolHexagon
    ],
    [
        "plus",
        (0, $6eee48c5df32b70c$export$2e2bcd8739ae039)
    ],
    [
        "square",
        (0, $1dda04e919c4f021$export$2e2bcd8739ae039)
    ],
    [
        "square2",
        (0, $efaaae86227c5844$export$2e2bcd8739ae039)
    ],
    [
        "star",
        (0, $4ff326387f52757d$export$2e2bcd8739ae039)
    ],
    [
        "times",
        (0, $91f4a6205a1a3d92$export$2e2bcd8739ae039)
    ],
    [
        "triangle",
        (0, $d45526fd1ffbd617$export$2e2bcd8739ae039)
    ],
    [
        "triangle2",
        (0, $70a1b9646572faf7$export$2e2bcd8739ae039)
    ],
    [
        "wye",
        (0, $6b5c98530d683be5$export$2e2bcd8739ae039)
    ]
]);
function $7ef09cabd5617a1b$var$isSymbolObject(value) {
    return value && typeof value.draw === "function";
}
function $7ef09cabd5617a1b$export$a244864fd9645c7f(value) {
    if ($7ef09cabd5617a1b$var$isSymbolObject(value)) return true;
    if (typeof value !== "string") return false;
    return $7ef09cabd5617a1b$var$symbols.has(value.toLowerCase());
}
function $7ef09cabd5617a1b$export$355b55bc2192971a(symbol) {
    if (symbol == null || $7ef09cabd5617a1b$var$isSymbolObject(symbol)) return symbol;
    const value = $7ef09cabd5617a1b$var$symbols.get(`${symbol}`.toLowerCase());
    if (value) return value;
    throw new Error(`invalid symbol: ${symbol}`);
}
function $7ef09cabd5617a1b$export$5b4fe6145c7212af(symbol) {
    if (symbol == null || $7ef09cabd5617a1b$var$isSymbolObject(symbol)) return [
        undefined,
        symbol
    ];
    if (typeof symbol === "string") {
        const value = $7ef09cabd5617a1b$var$symbols.get(`${symbol}`.toLowerCase());
        if (value) return [
            undefined,
            value
        ];
    }
    return [
        symbol,
        undefined
    ];
}








function $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6({ filter: f1, sort: s1, reverse: r1, transform: t1, initializer: i1, ...options } = {}, transform) {
    // If both t1 and t2 are defined, returns a composite transform that first
    // applies t1 and then applies t2.
    if (t1 === undefined) {
        // explicit transform overrides filter, sort, and reverse
        if (f1 != null) t1 = $9dfbc15f77c5eeba$var$filterTransform(f1);
        if (s1 != null && !(0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) t1 = $9dfbc15f77c5eeba$var$composeTransform(t1, $9dfbc15f77c5eeba$var$sortTransform(s1));
        if (r1) t1 = $9dfbc15f77c5eeba$var$composeTransform(t1, $9dfbc15f77c5eeba$var$reverseTransform);
    }
    if (transform != null && i1 != null) throw new Error("transforms cannot be applied after initializers");
    return {
        ...options,
        ...(s1 === null || (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) && {
            sort: s1
        },
        transform: $9dfbc15f77c5eeba$var$composeTransform(t1, transform)
    };
}
function $9dfbc15f77c5eeba$export$aff46cc71669aeb2({ filter: f1, sort: s1, reverse: r1, initializer: i1, ...options } = {}, initializer) {
    // If both i1 and i2 are defined, returns a composite initializer that first
    // applies i1 and then applies i2.
    if (i1 === undefined) {
        // explicit initializer overrides filter, sort, and reverse
        if (f1 != null) i1 = $9dfbc15f77c5eeba$var$filterTransform(f1);
        if (s1 != null && !(0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) i1 = $9dfbc15f77c5eeba$var$composeInitializer(i1, $9dfbc15f77c5eeba$var$sortTransform(s1));
        if (r1) i1 = $9dfbc15f77c5eeba$var$composeInitializer(i1, $9dfbc15f77c5eeba$var$reverseTransform);
    }
    return {
        ...options,
        ...(s1 === null || (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) && {
            sort: s1
        },
        initializer: $9dfbc15f77c5eeba$var$composeInitializer(i1, initializer)
    };
}
function $9dfbc15f77c5eeba$var$composeTransform(t1, t2) {
    if (t1 == null) return t2 === null ? undefined : t2;
    if (t2 == null) return t1 === null ? undefined : t1;
    return function(data, facets, plotOptions) {
        ({ data: data, facets: facets } = t1.call(this, data, facets, plotOptions));
        return t2.call(this, (0, $cd9e805a4bbd13f9$export$73f73ccd44b2553f)(data), facets, plotOptions);
    };
}
function $9dfbc15f77c5eeba$var$composeInitializer(i1, i2) {
    if (i1 == null) return i2 === null ? undefined : i2;
    if (i2 == null) return i1 === null ? undefined : i1;
    return function(data, facets, channels, ...args) {
        let c1, d1, f1, c2, d2, f2;
        ({ data: d1 = data, facets: f1 = facets, channels: c1 } = i1.call(this, data, facets, channels, ...args));
        ({ data: d2 = d1, facets: f2 = f1, channels: c2 } = i2.call(this, d1, f1, {
            ...channels,
            ...c1
        }, ...args));
        return {
            data: d2,
            facets: f2,
            channels: {
                ...c1,
                ...c2
            }
        };
    };
}
function $9dfbc15f77c5eeba$var$apply(options, t) {
    return (options.initializer != null ? $9dfbc15f77c5eeba$export$aff46cc71669aeb2 : $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options, t);
}
function $9dfbc15f77c5eeba$export$3dea766d36a8935f(test, options) {
    return $9dfbc15f77c5eeba$var$apply(options, $9dfbc15f77c5eeba$var$filterTransform(test));
}
function $9dfbc15f77c5eeba$var$filterTransform(value) {
    return (data, facets)=>{
        const V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value);
        return {
            data: data,
            facets: facets.map((I)=>I.filter((i)=>V[i]))
        };
    };
}
function $9dfbc15f77c5eeba$export$66c1ae025e96b4bc({ sort: sort, ...options } = {}) {
    return {
        ...$9dfbc15f77c5eeba$var$apply(options, $9dfbc15f77c5eeba$var$reverseTransform),
        sort: (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null
    };
}
function $9dfbc15f77c5eeba$var$reverseTransform(data, facets) {
    return {
        data: data,
        facets: facets.map((I)=>I.slice().reverse())
    };
}
function $9dfbc15f77c5eeba$export$448332262467e042({ seed: seed, sort: sort, ...options } = {}) {
    return {
        ...$9dfbc15f77c5eeba$var$apply(options, $9dfbc15f77c5eeba$var$sortValue(seed == null ? Math.random : (0, $e8a0bfad26e955e5$export$2e2bcd8739ae039)(seed))),
        sort: (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null
    };
}
function $9dfbc15f77c5eeba$export$97db5808d8f88186(order, { sort: sort, ...options } = {}) {
    return {
        ...((0, $cd9e805a4bbd13f9$export$dae3322343de7d27)(order) && order.channel !== undefined ? $9dfbc15f77c5eeba$export$aff46cc71669aeb2 : $9dfbc15f77c5eeba$var$apply)(options, $9dfbc15f77c5eeba$var$sortTransform(order)),
        sort: (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null
    };
}
function $9dfbc15f77c5eeba$var$sortTransform(value) {
    return (typeof value === "function" && value.length !== 1 ? $9dfbc15f77c5eeba$var$sortData : $9dfbc15f77c5eeba$var$sortValue)(value);
}
function $9dfbc15f77c5eeba$var$sortData(compare) {
    return (data, facets)=>{
        const compareData = (0, $cd9e805a4bbd13f9$export$43bee75e5e14138e)(data) ? (i, j)=>compare(data[i], data[j]) : (i, j)=>compare(data.get(i), data.get(j));
        return {
            data: data,
            facets: facets.map((I)=>I.slice().sort(compareData))
        };
    };
}
function $9dfbc15f77c5eeba$var$sortValue(value) {
    let channel, order;
    ({ channel: channel, value: value, order: order } = {
        ...(0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(value)
    });
    const negate = channel?.startsWith("-");
    if (negate) channel = channel.slice(1);
    if (order === undefined) order = negate ? (0, $0f3e37548c3914c7$export$e82554a8bd790ef9) : (0, $0f3e37548c3914c7$export$686e14b8469efec4);
    if (typeof order !== "function") switch(`${order}`.toLowerCase()){
        case "ascending":
            order = (0, $0f3e37548c3914c7$export$686e14b8469efec4);
            break;
        case "descending":
            order = (0, $0f3e37548c3914c7$export$e82554a8bd790ef9);
            break;
        default:
            throw new Error(`invalid order: ${order}`);
    }
    return (data, facets, channels)=>{
        let V;
        if (channel === undefined) V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value);
        else {
            if (channels === undefined) throw new Error("channel sort requires an initializer");
            V = channels[channel];
            if (!V) return {}; // ignore missing channel
            V = V.value;
        }
        const compareValue = (i, j)=>order(V[i], V[j]);
        return {
            data: data,
            facets: facets.map((I)=>I.slice().sort(compareValue))
        };
    };
}


function $23ff17797d38563c$export$ae9fea6755af6637(outputs, options) {
    return $23ff17797d38563c$var$groupn(null, null, outputs, options);
}
function $23ff17797d38563c$export$72a2c66beca1513f(outputs = {
    y: "count"
}, options = {}) {
    const { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655) } = options;
    if (x == null) throw new Error("missing channel: x");
    return $23ff17797d38563c$var$groupn(x, null, outputs, options);
}
function $23ff17797d38563c$export$8f6637e44de78be2(outputs = {
    x: "count"
}, options = {}) {
    const { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655) } = options;
    if (y == null) throw new Error("missing channel: y");
    return $23ff17797d38563c$var$groupn(null, y, outputs, options);
}
function $23ff17797d38563c$export$e5e25fbcc1f7affe(outputs = {
    fill: "count"
}, options = {}) {
    let { x: x, y: y } = options;
    [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    if (x == null) throw new Error("missing channel: x");
    if (y == null) throw new Error("missing channel: y");
    return $23ff17797d38563c$var$groupn(x, y, outputs, options);
}
function $23ff17797d38563c$var$groupn(x, y, { data: reduceData = $23ff17797d38563c$export$e9e62aaf7ac0743d, filter: filter, sort: sort, reverse: reverse, ...outputs // output channel definitions
 } = {}, inputs = {} // input channels and options
) {
    // Compute the outputs.
    outputs = $23ff17797d38563c$export$ac28e1cbca805a54(outputs, inputs);
    reduceData = $23ff17797d38563c$var$maybeGroupReduce(reduceData, (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655));
    sort = sort == null ? undefined : $23ff17797d38563c$var$maybeGroupOutput("sort", sort, inputs);
    filter = filter == null ? undefined : $23ff17797d38563c$var$maybeGroupEvaluator("filter", filter, inputs);
    // Produce x and y output channels as appropriate.
    const [GX, setGX] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(x);
    const [GY, setGY] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(y);
    // Greedily materialize the z, fill, and stroke channels (if channels and not
    // constants) so that we can reference them for subdividing groups without
    // computing them more than once.
    const { z: z, fill: fill, stroke: stroke, x1: x1, x2: x2, y1: y1, y2: y2, ...options } = inputs;
    const [GZ, setGZ] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(z);
    const [vfill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    const [vstroke] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke);
    const [GF, setGF] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(vfill);
    const [GS, setGS] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(vstroke);
    return {
        ..."z" in inputs && {
            z: GZ || z
        },
        ..."fill" in inputs && {
            fill: GF || fill
        },
        ..."stroke" in inputs && {
            stroke: GS || stroke
        },
        ...(0, $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options, (data, facets, plotOptions)=>{
            const X = (0, $cd9e805a4bbd13f9$export$90792ed47ffcc9f3)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, x), plotOptions?.x);
            const Y = (0, $cd9e805a4bbd13f9$export$90792ed47ffcc9f3)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, y), plotOptions?.y);
            const Z = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, z);
            const F = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, vfill);
            const S = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, vstroke);
            const G = $23ff17797d38563c$export$2b68910c7fd8dbce(outputs, {
                z: Z,
                fill: F,
                stroke: S
            });
            const groupFacets = [];
            const groupData = [];
            const GX = X && setGX([]);
            const GY = Y && setGY([]);
            const GZ = Z && setGZ([]);
            const GF = F && setGF([]);
            const GS = S && setGS([]);
            let i = 0;
            for (const o of outputs)o.initialize(data);
            if (sort) sort.initialize(data);
            if (filter) filter.initialize(data);
            for (const facet of facets){
                const groupFacet = [];
                for (const o of outputs)o.scope("facet", facet);
                if (sort) sort.scope("facet", facet);
                if (filter) filter.scope("facet", facet);
                for (const [f, I] of $23ff17797d38563c$export$66e58775f8a76bc5(facet, G)){
                    for (const [y, gg] of $23ff17797d38563c$export$66e58775f8a76bc5(I, Y))for (const [x, g] of $23ff17797d38563c$export$66e58775f8a76bc5(gg, X)){
                        const extent = {
                            data: data
                        };
                        if (X) extent.x = x;
                        if (Y) extent.y = y;
                        if (G) extent.z = f;
                        if (filter && !filter.reduce(g, extent)) continue;
                        groupFacet.push(i++);
                        groupData.push(reduceData.reduceIndex(g, data, extent));
                        if (X) GX.push(x);
                        if (Y) GY.push(y);
                        if (Z) GZ.push(G === Z ? f : Z[g[0]]);
                        if (F) GF.push(G === F ? f : F[g[0]]);
                        if (S) GS.push(G === S ? f : S[g[0]]);
                        for (const o of outputs)o.reduce(g, extent);
                        if (sort) sort.reduce(g, extent);
                    }
                }
                groupFacets.push(groupFacet);
            }
            $23ff17797d38563c$export$e6df691e0874bc87(groupFacets, sort, reverse);
            return {
                data: groupData,
                facets: groupFacets
            };
        }),
        ...!$23ff17797d38563c$export$c8c5ed0593b91b40(outputs, "x") && (GX ? {
            x: GX
        } : {
            x1: x1,
            x2: x2
        }),
        ...!$23ff17797d38563c$export$c8c5ed0593b91b40(outputs, "y") && (GY ? {
            y: GY
        } : {
            y1: y1,
            y2: y2
        }),
        ...Object.fromEntries(outputs.map(({ name: name, output: output })=>[
                name,
                output
            ]))
    };
}
function $23ff17797d38563c$export$c8c5ed0593b91b40(outputs, ...names) {
    for (const { name: name } of outputs){
        if (names.includes(name)) return true;
    }
    return false;
}
function $23ff17797d38563c$export$8c5fe1f2932839cd(outputs, inputs, asOutput = $23ff17797d38563c$export$d428705214c4bb4c) {
    const entries = Object.entries(outputs);
    // Propagate standard mark channels by default.
    if (inputs.title != null && outputs.title === undefined) entries.push([
        "title",
        $23ff17797d38563c$var$reduceTitle
    ]);
    if (inputs.href != null && outputs.href === undefined) entries.push([
        "href",
        $23ff17797d38563c$export$e76bb8aee9fc4afa
    ]);
    return entries.filter(([, reduce])=>reduce !== undefined).map(([name, reduce])=>reduce === null ? $23ff17797d38563c$var$nullOutput(name) : asOutput(name, reduce, inputs));
}
function $23ff17797d38563c$export$d428705214c4bb4c(name, reduce, inputs, asEvaluator = $23ff17797d38563c$export$af9bcd7c8847e1bc) {
    let scale; // optional per-channel scale override
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(reduce) && "reduce" in reduce) scale = reduce.scale, reduce = reduce.reduce; // N.B. array.reduce
    const evaluator = asEvaluator(name, reduce, inputs);
    const [output, setOutput] = (0, $cd9e805a4bbd13f9$export$4e0c71f277ca26b3)(evaluator.label);
    let O;
    return {
        name: name,
        output: scale === undefined ? output : {
            value: output,
            scale: scale
        },
        initialize (data) {
            evaluator.initialize(data);
            O = setOutput([]);
        },
        scope (scope, I) {
            evaluator.scope(scope, I);
        },
        reduce (I, extent) {
            O.push(evaluator.reduce(I, extent));
        }
    };
}
function $23ff17797d38563c$var$nullOutput(name) {
    return {
        name: name,
        initialize () {},
        scope () {},
        reduce () {}
    };
}
function $23ff17797d38563c$export$af9bcd7c8847e1bc(name, reduce, inputs, asReduce = $23ff17797d38563c$export$8741001136aed6bd) {
    const input = (0, $cd9e805a4bbd13f9$export$84405e33d6be068e)(name, inputs);
    const reducer = asReduce(reduce, input);
    let V, context;
    return {
        label: (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(reducer === $23ff17797d38563c$export$32697fc8b2c2e2f7 ? null : input, reducer.label),
        initialize (data) {
            V = input === undefined ? data : (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, input);
            if (reducer.scope === "data") context = reducer.reduceIndex((0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data), V);
        },
        scope (scope, I) {
            if (reducer.scope === scope) context = reducer.reduceIndex(I, V);
        },
        reduce (I, extent) {
            return reducer.scope == null ? reducer.reduceIndex(I, V, extent) : reducer.reduceIndex(I, V, context, extent);
        }
    };
}
function $23ff17797d38563c$export$66e58775f8a76bc5(I, X) {
    return X ? (0, $6f0c14a1378d16c1$export$2e2bcd8739ae039)(I, (i)=>X[i]) : [
        [
            ,
            I
        ]
    ];
}
function $23ff17797d38563c$export$8741001136aed6bd(reduce, value, fallback = $23ff17797d38563c$var$invalidReduce) {
    if (reduce == null) return fallback(reduce);
    if (typeof reduce.reduceIndex === "function") return reduce;
    if (typeof reduce.reduce === "function" && (0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(reduce)) return $23ff17797d38563c$var$reduceReduce(reduce); // N.B. array.reduce
    if (typeof reduce === "function") return $23ff17797d38563c$var$reduceFunction(reduce);
    if (/^p\d{2}$/i.test(reduce)) return $23ff17797d38563c$var$reduceAccessor((0, $cd9e805a4bbd13f9$export$c4df44c805494ac9)(reduce));
    switch(`${reduce}`.toLowerCase()){
        case "first":
            return $23ff17797d38563c$export$e76bb8aee9fc4afa;
        case "last":
            return $23ff17797d38563c$var$reduceLast;
        case "identity":
            return $23ff17797d38563c$export$e9e62aaf7ac0743d;
        case "count":
            return $23ff17797d38563c$export$32697fc8b2c2e2f7;
        case "distinct":
            return $23ff17797d38563c$var$reduceDistinct;
        case "sum":
            return value == null ? $23ff17797d38563c$export$32697fc8b2c2e2f7 : $23ff17797d38563c$var$reduceSum;
        case "proportion":
            return $23ff17797d38563c$var$reduceProportion(value, "data");
        case "proportion-facet":
            return $23ff17797d38563c$var$reduceProportion(value, "facet");
        case "deviation":
            return $23ff17797d38563c$var$reduceAccessor((0, $317408b795339b26$export$2e2bcd8739ae039));
        case "min":
            return $23ff17797d38563c$var$reduceAccessor((0, $02ed355deaa9e190$export$2e2bcd8739ae039));
        case "min-index":
            return $23ff17797d38563c$var$reduceAccessor((0, $70ebee7adc32f27f$export$2e2bcd8739ae039));
        case "max":
            return $23ff17797d38563c$var$reduceAccessor((0, $5a964dca3df4eea7$export$2e2bcd8739ae039));
        case "max-index":
            return $23ff17797d38563c$var$reduceAccessor((0, $3ce2d353ce06f740$export$2e2bcd8739ae039));
        case "mean":
            return $23ff17797d38563c$var$reduceMaybeTemporalAccessor((0, $be26fde1f1f97ef0$export$2e2bcd8739ae039));
        case "median":
            return $23ff17797d38563c$var$reduceMaybeTemporalAccessor((0, $5713cbb46e42efc2$export$2e2bcd8739ae039));
        case "variance":
            return $23ff17797d38563c$var$reduceAccessor((0, $4eefdd235be3059b$export$2e2bcd8739ae039));
        case "mode":
            return $23ff17797d38563c$var$reduceAccessor((0, $50f73767cb5db446$export$2e2bcd8739ae039));
    }
    return fallback(reduce);
}
function $23ff17797d38563c$var$invalidReduce(reduce) {
    throw new Error(`invalid reduce: ${reduce}`);
}
function $23ff17797d38563c$export$ac28e1cbca805a54(outputs, inputs) {
    return $23ff17797d38563c$export$8c5fe1f2932839cd(outputs, inputs, $23ff17797d38563c$var$maybeGroupOutput);
}
function $23ff17797d38563c$var$maybeGroupOutput(name, reduce, inputs) {
    return $23ff17797d38563c$export$d428705214c4bb4c(name, reduce, inputs, $23ff17797d38563c$var$maybeGroupEvaluator);
}
function $23ff17797d38563c$var$maybeGroupEvaluator(name, reduce, inputs) {
    return $23ff17797d38563c$export$af9bcd7c8847e1bc(name, reduce, inputs, $23ff17797d38563c$var$maybeGroupReduce);
}
function $23ff17797d38563c$var$maybeGroupReduce(reduce, value) {
    return $23ff17797d38563c$export$8741001136aed6bd(reduce, value, $23ff17797d38563c$var$maybeGroupReduceFallback);
}
function $23ff17797d38563c$var$maybeGroupReduceFallback(reduce) {
    switch(`${reduce}`.toLowerCase()){
        case "x":
            return $23ff17797d38563c$var$reduceX;
        case "y":
            return $23ff17797d38563c$var$reduceY;
        case "z":
            return $23ff17797d38563c$export$308e6b8cfac254e0;
    }
    throw new Error(`invalid group reduce: ${reduce}`);
}
function $23ff17797d38563c$export$2b68910c7fd8dbce(outputs, inputs) {
    for(const name in inputs){
        const value = inputs[name];
        if (value !== undefined && !outputs.some((o)=>o.name === name)) return value;
    }
}
function $23ff17797d38563c$export$e6df691e0874bc87(facets, sort, reverse) {
    if (sort) {
        const S = sort.output.transform();
        const compare = (i, j)=>(0, $0f3e37548c3914c7$export$686e14b8469efec4)(S[i], S[j]);
        facets.forEach((f)=>f.sort(compare));
    }
    if (reverse) facets.forEach((f)=>f.reverse());
}
function $23ff17797d38563c$var$reduceReduce(reduce) {
    console.warn("deprecated reduce interface; implement reduceIndex instead.");
    return {
        ...reduce,
        reduceIndex: reduce.reduce.bind(reduce)
    };
}
function $23ff17797d38563c$var$reduceFunction(f) {
    return {
        reduceIndex (I, X, extent) {
            return f((0, $cd9e805a4bbd13f9$export$b7df5d561049483a)(X, I), extent);
        }
    };
}
function $23ff17797d38563c$var$reduceAccessor(f) {
    return {
        reduceIndex (I, X) {
            return f(I, (i)=>X[i]);
        }
    };
}
function $23ff17797d38563c$var$reduceMaybeTemporalAccessor(f) {
    return {
        reduceIndex (I, X) {
            const x = f(I, (i)=>X[i]);
            return (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(X) ? new Date(x) : x;
        }
    };
}
const $23ff17797d38563c$export$e9e62aaf7ac0743d = {
    reduceIndex (I, X) {
        return (0, $cd9e805a4bbd13f9$export$b7df5d561049483a)(X, I);
    }
};
const $23ff17797d38563c$export$e76bb8aee9fc4afa = {
    reduceIndex (I, X) {
        return X[I[0]];
    }
};
const $23ff17797d38563c$var$reduceTitle = {
    reduceIndex (I, X) {
        const n = 5;
        const groups = (0, $3dc3306e587e145d$export$2e2bcd8739ae039)((0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (V)=>V.length, (i)=>X[i]), (0, $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d));
        const top = groups.slice(-n).reverse();
        if (top.length < groups.length) {
            const bottom = groups.slice(0, 1 - n);
            top[n - 1] = [
                `\u{2026} ${bottom.length.toLocaleString("en-US")} more`,
                (0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(bottom, (0, $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d))
            ];
        }
        return top.map(([key, value])=>`${key} (${value.toLocaleString("en-US")})`).join("\n");
    }
};
const $23ff17797d38563c$var$reduceLast = {
    reduceIndex (I, X) {
        return X[I[I.length - 1]];
    }
};
const $23ff17797d38563c$export$32697fc8b2c2e2f7 = {
    label: "Frequency",
    reduceIndex (I) {
        return I.length;
    }
};
const $23ff17797d38563c$var$reduceDistinct = {
    label: "Distinct",
    reduceIndex (I, X) {
        const s = new (0, $3160658555deb5c9$export$55278c3294239828)();
        for (const i of I)s.add(X[i]);
        return s.size;
    }
};
const $23ff17797d38563c$var$reduceSum = $23ff17797d38563c$var$reduceAccessor((0, $daf42a1f07322cf6$export$2e2bcd8739ae039));
function $23ff17797d38563c$var$reduceProportion(value, scope) {
    return value == null ? {
        scope: scope,
        label: "Frequency",
        reduceIndex: (I, V, basis = 1)=>I.length / basis
    } : {
        scope: scope,
        reduceIndex: (I, V, basis = 1)=>(0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(I, (i)=>V[i]) / basis
    };
}
const $23ff17797d38563c$var$reduceX = {
    reduceIndex (I, X, { x: x }) {
        return x;
    }
};
const $23ff17797d38563c$var$reduceY = {
    reduceIndex (I, X, { y: y }) {
        return y;
    }
};
const $23ff17797d38563c$export$308e6b8cfac254e0 = {
    reduceIndex (I, X, { z: z }) {
        return z;
    }
};
function $23ff17797d38563c$export$71aa6c912b956294(test) {
    if (typeof test !== "function") throw new Error(`invalid test function: ${test}`);
    return {
        reduceIndex (I, V, { data: data }) {
            return V[I.find((0, $cd9e805a4bbd13f9$export$43bee75e5e14138e)(data) ? (i)=>test(data[i], i, data) : (i)=>test(data.get(i), i, data))];
        }
    };
}


function $6eb5f337b2493843$export$47ab4c33d77e344d(data, { scale: scale, type: type, value: value, filter: filter, hint: hint, label: label = (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(value) }, name) {
    if (hint === undefined && typeof value?.transform === "function") hint = value.hint;
    return $6eb5f337b2493843$export$5de38149af3ed501(name, {
        scale: scale,
        type: type,
        value: (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value),
        label: label,
        filter: filter,
        hint: hint
    });
}
function $6eb5f337b2493843$export$422e7cd65ac5d2cf(channels, data) {
    return Object.fromEntries(Object.entries(channels).map(([name, channel])=>[
            name,
            $6eb5f337b2493843$export$47ab4c33d77e344d(data, channel, name)
        ]));
}
function $6eb5f337b2493843$export$9df10f3a4586f4ff(channels, scales) {
    const values = Object.fromEntries(Object.entries(channels).map(([name, { scale: scaleName, value: value }])=>{
        const scale = scaleName == null ? null : scales[scaleName];
        return [
            name,
            scale == null ? value : (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(value, scale)
        ];
    }));
    values.channels = channels; // expose channel state for advanced usage
    return values;
}
function $6eb5f337b2493843$export$5de38149af3ed501(name, channel) {
    const { scale: scale, value: value } = channel;
    if (scale === true || scale === "auto") switch(name){
        case "fill":
        case "stroke":
        case "color":
            channel.scale = scale !== true && (0, $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1)(value, (0, $cd9e805a4bbd13f9$export$e82f763eaa28f6fe)) ? null : "color";
            channel.defaultScale = "color";
            break;
        case "fillOpacity":
        case "strokeOpacity":
        case "opacity":
            channel.scale = scale !== true && (0, $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1)(value, (0, $cd9e805a4bbd13f9$export$4108b961417e5a2a)) ? null : "opacity";
            channel.defaultScale = "opacity";
            break;
        case "symbol":
            if (scale !== true && (0, $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1)(value, (0, $7ef09cabd5617a1b$export$a244864fd9645c7f))) {
                channel.scale = null;
                channel.value = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(value, (0, $7ef09cabd5617a1b$export$355b55bc2192971a));
            } else channel.scale = "symbol";
            channel.defaultScale = "symbol";
            break;
        default:
            channel.scale = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(name) ? name : null;
            break;
    }
    else if (scale === false) channel.scale = null;
    else if (scale != null && !(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(scale)) throw new Error(`unknown scale: ${scale}`);
    return channel;
}
function $6eb5f337b2493843$export$334f2e4e1c2a6aef(data, facets, channels, facetChannels, options) {
    const { order: defaultOrder, reverse: defaultReverse, reduce: defaultReduce = true, limit: defaultLimit } = options;
    for(const x in options){
        if (!(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(x)) continue; // ignore unknown scale keys (including generic options)
        let { value: y, order: order = defaultOrder, reverse: reverse = defaultReverse, reduce: reduce = defaultReduce, limit: limit = defaultLimit } = (0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(options[x]); // prettier-ignore
        const negate = y?.startsWith("-");
        if (negate) y = y.slice(1);
        order = order === undefined ? negate !== (y === "width" || y === "height") ? $6eb5f337b2493843$var$descendingGroup : $6eb5f337b2493843$var$ascendingGroup : $6eb5f337b2493843$var$maybeOrder(order); // prettier-ignore
        if (reduce == null || reduce === false) continue; // disabled reducer
        const X = x === "fx" || x === "fy" ? $6eb5f337b2493843$var$reindexFacetChannel(facets, facetChannels[x]) : $6eb5f337b2493843$var$findScaleChannel(channels, x);
        if (!X) throw new Error(`missing channel for scale: ${x}`);
        const XV = X.value;
        const [lo = 0, hi = Infinity] = (0, $cd9e805a4bbd13f9$export$9652023d9040757)(limit) ? limit : limit < 0 ? [
            limit
        ] : [
            0,
            limit
        ];
        if (y == null) X.domain = ()=>{
            let domain = Array.from(new (0, $3160658555deb5c9$export$55278c3294239828)(XV)); // remove any duplicates
            if (reverse) domain = domain.reverse();
            if (lo !== 0 || hi !== Infinity) domain = domain.slice(lo, hi);
            return domain;
        };
        else {
            const YV = y === "data" ? data : y === "height" ? $6eb5f337b2493843$var$difference(channels, "y1", "y2") : y === "width" ? $6eb5f337b2493843$var$difference(channels, "x1", "x2") : $6eb5f337b2493843$var$values(channels, y, y === "y" ? "y2" : y === "x" ? "x2" : undefined);
            const reducer = (0, $23ff17797d38563c$export$8741001136aed6bd)(reduce === true ? "max" : reduce, YV);
            X.domain = ()=>{
                let domain = (0, $6f0c14a1378d16c1$export$24814875ed03194b)((0, $cd9e805a4bbd13f9$export$d02631cccf789723)(XV), (I)=>reducer.reduceIndex(I, YV), (i)=>XV[i]);
                if (order) domain.sort(order);
                if (reverse) domain.reverse();
                if (lo !== 0 || hi !== Infinity) domain = domain.slice(lo, hi);
                return domain.map((0, $cd9e805a4bbd13f9$export$43128fadae87b74a));
            };
        }
    }
}
function $6eb5f337b2493843$var$findScaleChannel(channels, scale) {
    for(const name in channels){
        const channel = channels[name];
        if (channel.scale === scale) return channel;
    }
}
// Facet channels are not affected by transforms; so, to compute the domain of a
// facet scale, we must first re-index the facet channel according to the
// transformed mark index. Note: mutates channel, but that should be safe here?
function $6eb5f337b2493843$var$reindexFacetChannel(facets, channel) {
    const originalFacets = facets.original;
    if (originalFacets === facets) return channel; // not transformed
    const V1 = channel.value;
    const V2 = channel.value = []; // mutates channel!
    for(let i = 0; i < originalFacets.length; ++i){
        const vi = V1[originalFacets[i][0]];
        for (const j of facets[i])V2[j] = vi;
    }
    return channel;
}
function $6eb5f337b2493843$var$difference(channels, k1, k2) {
    const X1 = $6eb5f337b2493843$var$values(channels, k1);
    const X2 = $6eb5f337b2493843$var$values(channels, k2);
    return (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(X2, (x2, i)=>Math.abs(x2 - X1[i]), Float64Array);
}
function $6eb5f337b2493843$var$values(channels, name, alias) {
    let channel = channels[name];
    if (!channel && alias !== undefined) channel = channels[alias];
    if (channel) return channel.value;
    throw new Error(`missing channel: ${name}`);
}
function $6eb5f337b2493843$var$maybeOrder(order) {
    if (order == null || typeof order === "function") return order;
    switch(`${order}`.toLowerCase()){
        case "ascending":
            return $6eb5f337b2493843$var$ascendingGroup;
        case "descending":
            return $6eb5f337b2493843$var$descendingGroup;
    }
    throw new Error(`invalid order: ${order}`);
}
function $6eb5f337b2493843$var$ascendingGroup([ak, av], [bk, bv]) {
    return (0, $0f3e37548c3914c7$export$686e14b8469efec4)(av, bv) || (0, $0f3e37548c3914c7$export$686e14b8469efec4)(ak, bk);
}
function $6eb5f337b2493843$var$descendingGroup([ak, av], [bk, bv]) {
    return (0, $0f3e37548c3914c7$export$e82554a8bd790ef9)(av, bv) || (0, $0f3e37548c3914c7$export$686e14b8469efec4)(ak, bk);
}
function $6eb5f337b2493843$export$dd2b6e807fb37ba3(channels, key) {
    let channel = channels[key];
    if (!channel) return;
    while(channel.source)channel = channel.source;
    return channel.source === null ? null : channel;
}














const $a49a01342b27942f$var$categoricalSchemes = new Map([
    [
        "accent",
        (0, $5c89bc3d03077aec$export$2e2bcd8739ae039)
    ],
    [
        "category10",
        (0, $b0a93f4c47fccf6f$export$2e2bcd8739ae039)
    ],
    [
        "dark2",
        (0, $8720e88c6715774d$export$2e2bcd8739ae039)
    ],
    [
        "observable10",
        (0, $c47347499213e74d$export$2e2bcd8739ae039)
    ],
    [
        "paired",
        (0, $892d66d4b4370fa9$export$2e2bcd8739ae039)
    ],
    [
        "pastel1",
        (0, $8b74c2f853351d4b$export$2e2bcd8739ae039)
    ],
    [
        "pastel2",
        (0, $21804f83495238ab$export$2e2bcd8739ae039)
    ],
    [
        "set1",
        (0, $067ed124de63e363$export$2e2bcd8739ae039)
    ],
    [
        "set2",
        (0, $0b28fee23808bb16$export$2e2bcd8739ae039)
    ],
    [
        "set3",
        (0, $2c32d07a5d4299df$export$2e2bcd8739ae039)
    ],
    [
        "tableau10",
        (0, $4fe0d67c4ca00f70$export$2e2bcd8739ae039)
    ]
]);
function $a49a01342b27942f$export$6be03a206d9fd924(scheme) {
    return scheme != null && $a49a01342b27942f$var$categoricalSchemes.has(`${scheme}`.toLowerCase());
}
const $a49a01342b27942f$var$ordinalSchemes = new Map([
    ...$a49a01342b27942f$var$categoricalSchemes,
    // diverging
    [
        "brbg",
        $a49a01342b27942f$var$scheme11((0, $923009811f34a285$export$3005042704f95a69), (0, $923009811f34a285$export$2e2bcd8739ae039))
    ],
    [
        "prgn",
        $a49a01342b27942f$var$scheme11((0, $bebec87caf5c9753$export$3005042704f95a69), (0, $bebec87caf5c9753$export$2e2bcd8739ae039))
    ],
    [
        "piyg",
        $a49a01342b27942f$var$scheme11((0, $cd2b06ef8006df98$export$3005042704f95a69), (0, $cd2b06ef8006df98$export$2e2bcd8739ae039))
    ],
    [
        "puor",
        $a49a01342b27942f$var$scheme11((0, $fa43973b0e53adde$export$3005042704f95a69), (0, $fa43973b0e53adde$export$2e2bcd8739ae039))
    ],
    [
        "rdbu",
        $a49a01342b27942f$var$scheme11((0, $459633cf9cf535bb$export$3005042704f95a69), (0, $459633cf9cf535bb$export$2e2bcd8739ae039))
    ],
    [
        "rdgy",
        $a49a01342b27942f$var$scheme11((0, $d593cda9522f5e9b$export$3005042704f95a69), (0, $d593cda9522f5e9b$export$2e2bcd8739ae039))
    ],
    [
        "rdylbu",
        $a49a01342b27942f$var$scheme11((0, $cc75fec219df38fc$export$3005042704f95a69), (0, $cc75fec219df38fc$export$2e2bcd8739ae039))
    ],
    [
        "rdylgn",
        $a49a01342b27942f$var$scheme11((0, $34bd5cca956fffae$export$3005042704f95a69), (0, $34bd5cca956fffae$export$2e2bcd8739ae039))
    ],
    [
        "spectral",
        $a49a01342b27942f$var$scheme11((0, $9f2dc97368c5eb16$export$3005042704f95a69), (0, $9f2dc97368c5eb16$export$2e2bcd8739ae039))
    ],
    // reversed diverging (for temperature data)
    [
        "burd",
        $a49a01342b27942f$var$scheme11r((0, $459633cf9cf535bb$export$3005042704f95a69), (0, $459633cf9cf535bb$export$2e2bcd8739ae039))
    ],
    [
        "buylrd",
        $a49a01342b27942f$var$scheme11r((0, $cc75fec219df38fc$export$3005042704f95a69), (0, $cc75fec219df38fc$export$2e2bcd8739ae039))
    ],
    // sequential (single-hue)
    [
        "blues",
        $a49a01342b27942f$var$scheme9((0, $145b892380fd2d31$export$3005042704f95a69), (0, $145b892380fd2d31$export$2e2bcd8739ae039))
    ],
    [
        "greens",
        $a49a01342b27942f$var$scheme9((0, $8f3c9c616b880108$export$3005042704f95a69), (0, $8f3c9c616b880108$export$2e2bcd8739ae039))
    ],
    [
        "greys",
        $a49a01342b27942f$var$scheme9((0, $7bfe5c88f8446526$export$3005042704f95a69), (0, $7bfe5c88f8446526$export$2e2bcd8739ae039))
    ],
    [
        "oranges",
        $a49a01342b27942f$var$scheme9((0, $595eb3851ff257d2$export$3005042704f95a69), (0, $595eb3851ff257d2$export$2e2bcd8739ae039))
    ],
    [
        "purples",
        $a49a01342b27942f$var$scheme9((0, $1d375f28523a6def$export$3005042704f95a69), (0, $1d375f28523a6def$export$2e2bcd8739ae039))
    ],
    [
        "reds",
        $a49a01342b27942f$var$scheme9((0, $1061f70ec19e6f6b$export$3005042704f95a69), (0, $1061f70ec19e6f6b$export$2e2bcd8739ae039))
    ],
    // sequential (multi-hue)
    [
        "turbo",
        $a49a01342b27942f$var$schemei((0, $b6e6a61cd0d5bfcf$export$2e2bcd8739ae039))
    ],
    [
        "viridis",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$2e2bcd8739ae039))
    ],
    [
        "magma",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$c41e69203f572e8d))
    ],
    [
        "inferno",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$ad0c8285c8ea6dbd))
    ],
    [
        "plasma",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$6664860a633d9daf))
    ],
    [
        "cividis",
        $a49a01342b27942f$var$schemei((0, $9952aaaded0c8a28$export$2e2bcd8739ae039))
    ],
    [
        "cubehelix",
        $a49a01342b27942f$var$schemei((0, $29d6cb6ff87ef07d$export$2e2bcd8739ae039))
    ],
    [
        "warm",
        $a49a01342b27942f$var$schemei((0, $99c57285242dd2ea$export$fc70efcec537be98))
    ],
    [
        "cool",
        $a49a01342b27942f$var$schemei((0, $99c57285242dd2ea$export$c5cedbc1ab3be2c3))
    ],
    [
        "bugn",
        $a49a01342b27942f$var$scheme9((0, $1346c9d2a50a7688$export$3005042704f95a69), (0, $1346c9d2a50a7688$export$2e2bcd8739ae039))
    ],
    [
        "bupu",
        $a49a01342b27942f$var$scheme9((0, $c6eb5bbbe1fe33f2$export$3005042704f95a69), (0, $c6eb5bbbe1fe33f2$export$2e2bcd8739ae039))
    ],
    [
        "gnbu",
        $a49a01342b27942f$var$scheme9((0, $54d7f7dcce705495$export$3005042704f95a69), (0, $54d7f7dcce705495$export$2e2bcd8739ae039))
    ],
    [
        "orrd",
        $a49a01342b27942f$var$scheme9((0, $eeccadfeb064b2e3$export$3005042704f95a69), (0, $eeccadfeb064b2e3$export$2e2bcd8739ae039))
    ],
    [
        "pubu",
        $a49a01342b27942f$var$scheme9((0, $378e987a98dccf42$export$3005042704f95a69), (0, $378e987a98dccf42$export$2e2bcd8739ae039))
    ],
    [
        "pubugn",
        $a49a01342b27942f$var$scheme9((0, $256ade4440a037db$export$3005042704f95a69), (0, $256ade4440a037db$export$2e2bcd8739ae039))
    ],
    [
        "purd",
        $a49a01342b27942f$var$scheme9((0, $5387771dbbae7a61$export$3005042704f95a69), (0, $5387771dbbae7a61$export$2e2bcd8739ae039))
    ],
    [
        "rdpu",
        $a49a01342b27942f$var$scheme9((0, $c0b866951e59a25a$export$3005042704f95a69), (0, $c0b866951e59a25a$export$2e2bcd8739ae039))
    ],
    [
        "ylgn",
        $a49a01342b27942f$var$scheme9((0, $9f35832fa0e76f1c$export$3005042704f95a69), (0, $9f35832fa0e76f1c$export$2e2bcd8739ae039))
    ],
    [
        "ylgnbu",
        $a49a01342b27942f$var$scheme9((0, $59f93d7737a98115$export$3005042704f95a69), (0, $59f93d7737a98115$export$2e2bcd8739ae039))
    ],
    [
        "ylorbr",
        $a49a01342b27942f$var$scheme9((0, $8ba4ac8d08f3d776$export$3005042704f95a69), (0, $8ba4ac8d08f3d776$export$2e2bcd8739ae039))
    ],
    [
        "ylorrd",
        $a49a01342b27942f$var$scheme9((0, $f3f63506e2889591$export$3005042704f95a69), (0, $f3f63506e2889591$export$2e2bcd8739ae039))
    ],
    // cyclical
    [
        "rainbow",
        $a49a01342b27942f$var$schemeicyclical((0, $99c57285242dd2ea$export$2e2bcd8739ae039))
    ],
    [
        "sinebow",
        $a49a01342b27942f$var$schemeicyclical((0, $8a82e5e51ab56b0d$export$2e2bcd8739ae039))
    ]
]);
function $a49a01342b27942f$var$scheme9(scheme, interpolate) {
    return ({ length: n })=>{
        if (n === 1) return [
            scheme[3][1]
        ]; // favor midpoint
        if (n === 2) return [
            scheme[3][1],
            scheme[3][2]
        ]; // favor darker
        n = Math.max(3, Math.floor(n));
        return n > 9 ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : scheme[n];
    };
}
function $a49a01342b27942f$var$scheme11(scheme, interpolate) {
    return ({ length: n })=>{
        if (n === 2) return [
            scheme[3][0],
            scheme[3][2]
        ]; // favor diverging extrema
        n = Math.max(3, Math.floor(n));
        return n > 11 ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : scheme[n];
    };
}
function $a49a01342b27942f$var$scheme11r(scheme, interpolate) {
    return ({ length: n })=>{
        if (n === 2) return [
            scheme[3][2],
            scheme[3][0]
        ]; // favor diverging extrema
        n = Math.max(3, Math.floor(n));
        return n > 11 ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)((t)=>interpolate(1 - t), n) : scheme[n].slice().reverse();
    };
}
function $a49a01342b27942f$var$schemei(interpolate) {
    return ({ length: n })=>(0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, Math.max(2, Math.floor(n)));
}
function $a49a01342b27942f$var$schemeicyclical(interpolate) {
    return ({ length: n })=>(0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, Math.floor(n) + 1).slice(0, -1);
}
function $a49a01342b27942f$export$b81675b3e2d350c6(scheme) {
    const s = `${scheme}`.toLowerCase();
    if (!$a49a01342b27942f$var$ordinalSchemes.has(s)) throw new Error(`unknown ordinal scheme: ${s}`);
    return $a49a01342b27942f$var$ordinalSchemes.get(s);
}
function $a49a01342b27942f$export$4247365b716746cf(scheme, length) {
    const s = $a49a01342b27942f$export$b81675b3e2d350c6(scheme);
    const r = typeof s === "function" ? s({
        length: length
    }) : s;
    return r.length !== length ? r.slice(0, length) : r;
}
function $a49a01342b27942f$export$ac9f44566dbce13a(domain, scheme = "greys") {
    const range = new Set();
    const [f, t] = $a49a01342b27942f$export$4247365b716746cf(scheme, 2);
    for (const value of domain){
        if (value == null) continue;
        if (value === true) range.add(t);
        else if (value === false) range.add(f);
        else return;
    }
    return [
        ...range
    ];
}
const $a49a01342b27942f$var$quantitativeSchemes = new Map([
    // diverging
    [
        "brbg",
        (0, $923009811f34a285$export$2e2bcd8739ae039)
    ],
    [
        "prgn",
        (0, $bebec87caf5c9753$export$2e2bcd8739ae039)
    ],
    [
        "piyg",
        (0, $cd2b06ef8006df98$export$2e2bcd8739ae039)
    ],
    [
        "puor",
        (0, $fa43973b0e53adde$export$2e2bcd8739ae039)
    ],
    [
        "rdbu",
        (0, $459633cf9cf535bb$export$2e2bcd8739ae039)
    ],
    [
        "rdgy",
        (0, $d593cda9522f5e9b$export$2e2bcd8739ae039)
    ],
    [
        "rdylbu",
        (0, $cc75fec219df38fc$export$2e2bcd8739ae039)
    ],
    [
        "rdylgn",
        (0, $34bd5cca956fffae$export$2e2bcd8739ae039)
    ],
    [
        "spectral",
        (0, $9f2dc97368c5eb16$export$2e2bcd8739ae039)
    ],
    // reversed diverging (for temperature data)
    [
        "burd",
        (t)=>(0, $459633cf9cf535bb$export$2e2bcd8739ae039)(1 - t)
    ],
    [
        "buylrd",
        (t)=>(0, $cc75fec219df38fc$export$2e2bcd8739ae039)(1 - t)
    ],
    // sequential (single-hue)
    [
        "blues",
        (0, $145b892380fd2d31$export$2e2bcd8739ae039)
    ],
    [
        "greens",
        (0, $8f3c9c616b880108$export$2e2bcd8739ae039)
    ],
    [
        "greys",
        (0, $7bfe5c88f8446526$export$2e2bcd8739ae039)
    ],
    [
        "purples",
        (0, $1d375f28523a6def$export$2e2bcd8739ae039)
    ],
    [
        "reds",
        (0, $1061f70ec19e6f6b$export$2e2bcd8739ae039)
    ],
    [
        "oranges",
        (0, $595eb3851ff257d2$export$2e2bcd8739ae039)
    ],
    // sequential (multi-hue)
    [
        "turbo",
        (0, $b6e6a61cd0d5bfcf$export$2e2bcd8739ae039)
    ],
    [
        "viridis",
        (0, $c1e92c032cb158e3$export$2e2bcd8739ae039)
    ],
    [
        "magma",
        (0, $c1e92c032cb158e3$export$c41e69203f572e8d)
    ],
    [
        "inferno",
        (0, $c1e92c032cb158e3$export$ad0c8285c8ea6dbd)
    ],
    [
        "plasma",
        (0, $c1e92c032cb158e3$export$6664860a633d9daf)
    ],
    [
        "cividis",
        (0, $9952aaaded0c8a28$export$2e2bcd8739ae039)
    ],
    [
        "cubehelix",
        (0, $29d6cb6ff87ef07d$export$2e2bcd8739ae039)
    ],
    [
        "warm",
        (0, $99c57285242dd2ea$export$fc70efcec537be98)
    ],
    [
        "cool",
        (0, $99c57285242dd2ea$export$c5cedbc1ab3be2c3)
    ],
    [
        "bugn",
        (0, $1346c9d2a50a7688$export$2e2bcd8739ae039)
    ],
    [
        "bupu",
        (0, $c6eb5bbbe1fe33f2$export$2e2bcd8739ae039)
    ],
    [
        "gnbu",
        (0, $54d7f7dcce705495$export$2e2bcd8739ae039)
    ],
    [
        "orrd",
        (0, $eeccadfeb064b2e3$export$2e2bcd8739ae039)
    ],
    [
        "pubugn",
        (0, $256ade4440a037db$export$2e2bcd8739ae039)
    ],
    [
        "pubu",
        (0, $378e987a98dccf42$export$2e2bcd8739ae039)
    ],
    [
        "purd",
        (0, $5387771dbbae7a61$export$2e2bcd8739ae039)
    ],
    [
        "rdpu",
        (0, $c0b866951e59a25a$export$2e2bcd8739ae039)
    ],
    [
        "ylgnbu",
        (0, $59f93d7737a98115$export$2e2bcd8739ae039)
    ],
    [
        "ylgn",
        (0, $9f35832fa0e76f1c$export$2e2bcd8739ae039)
    ],
    [
        "ylorbr",
        (0, $8ba4ac8d08f3d776$export$2e2bcd8739ae039)
    ],
    [
        "ylorrd",
        (0, $f3f63506e2889591$export$2e2bcd8739ae039)
    ],
    // cyclical
    [
        "rainbow",
        (0, $99c57285242dd2ea$export$2e2bcd8739ae039)
    ],
    [
        "sinebow",
        (0, $8a82e5e51ab56b0d$export$2e2bcd8739ae039)
    ]
]);
function $a49a01342b27942f$export$c2977bbb95728409(scheme) {
    const s = `${scheme}`.toLowerCase();
    if (!$a49a01342b27942f$var$quantitativeSchemes.has(s)) throw new Error(`unknown quantitative scheme: ${s}`);
    return $a49a01342b27942f$var$quantitativeSchemes.get(s);
}
const $a49a01342b27942f$var$divergingSchemes = new Set([
    "brbg",
    "prgn",
    "piyg",
    "puor",
    "rdbu",
    "rdgy",
    "rdylbu",
    "rdylgn",
    "spectral",
    "burd",
    "buylrd"
]);
function $a49a01342b27942f$export$bd1a4763c73ba9bf(scheme) {
    return scheme != null && $a49a01342b27942f$var$divergingSchemes.has(`${scheme}`.toLowerCase());
}


const $30c166b7628c3ceb$export$8a83211c878a3f1f = (i)=>(t)=>i(1 - t);
const $30c166b7628c3ceb$var$unit = [
    0,
    1
];
const $30c166b7628c3ceb$var$interpolators = new Map([
    // numbers
    [
        "number",
        (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)
    ],
    // color spaces
    [
        "rgb",
        (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039)
    ],
    [
        "hsl",
        (0, $852106acfdc40efe$export$2e2bcd8739ae039)
    ],
    [
        "hcl",
        (0, $86158b7019ca6112$export$2e2bcd8739ae039)
    ],
    [
        "lab",
        (0, $5eb07f15d29dfb2b$export$2e2bcd8739ae039)
    ]
]);
function $30c166b7628c3ceb$export$a720bd56dc6d3c41(interpolate) {
    const i = `${interpolate}`.toLowerCase();
    if (!$30c166b7628c3ceb$var$interpolators.has(i)) throw new Error(`unknown interpolator: ${i}`);
    return $30c166b7628c3ceb$var$interpolators.get(i);
}
function $30c166b7628c3ceb$export$a11fad23408ff50e(key, scale, channels, { type: type, nice: nice, clamp: clamp, zero: zero, domain: domain = $30c166b7628c3ceb$var$inferAutoDomain(key, channels), unknown: unknown, round: round, scheme: scheme, interval: interval, range: range = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$872dd985a098dd45) ? $30c166b7628c3ceb$var$inferRadialRange(channels, domain) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$f24224f1c91d8156) ? $30c166b7628c3ceb$var$inferLengthRange(channels, domain) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$c17a3be1057836e) ? $30c166b7628c3ceb$var$unit : undefined, interpolate: interpolate = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? scheme == null && range !== undefined ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $a49a01342b27942f$export$c2977bbb95728409)(scheme !== undefined ? scheme : type === "cyclical" ? "rainbow" : "turbo") : round ? (0, $c0f8a9efb1caa699$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039), reverse: reverse }) {
    interval = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, type);
    if (type === "cyclical" || type === "sequential") type = "linear"; // shorthand for color schemes
    if (typeof interpolate !== "function") interpolate = $30c166b7628c3ceb$export$a720bd56dc6d3c41(interpolate); // named interpolator
    reverse = !!reverse;
    // If an explicit range is specified, and it has a different length than the
    // domain, then redistribute the range using a piecewise interpolator.
    if (range !== undefined) {
        const n = (domain = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain)).length;
        const m = (range = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(range)).length;
        if (n !== m) {
            if (interpolate.length === 1) throw new Error("invalid piecewise interpolator"); // e.g., turbo
            interpolate = (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate, range);
            range = undefined;
        }
    }
    // Disambiguate between a two-argument interpolator that is used in
    // conjunction with the range, and a one-argument “fixed” interpolator on the
    // [0, 1] interval as with the RdBu color scheme.
    if (interpolate.length === 1) {
        if (reverse) {
            interpolate = $30c166b7628c3ceb$export$8a83211c878a3f1f(interpolate);
            reverse = false;
        }
        if (range === undefined) {
            range = Float64Array.from(domain, (_, i)=>i / (domain.length - 1));
            if (range.length === 2) range = $30c166b7628c3ceb$var$unit; // optimize common case of [0, 1]
        }
        scale.interpolate((range === $30c166b7628c3ceb$var$unit ? (0, $cd9e805a4bbd13f9$export$c983f826f44ff86) : $30c166b7628c3ceb$export$f68e9493607eda6)(interpolate));
    } else scale.interpolate(interpolate);
    // If a zero option is specified, we assume that the domain is numeric, and we
    // want to ensure that the domain crosses zero. However, note that the domain
    // may be reversed (descending) so we shouldn’t assume that the first value is
    // smaller than the last; and also it’s possible that the domain has more than
    // two values for a “poly” scale. And lastly be careful not to mutate input!
    if (zero) {
        const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
        if (min > 0 || max < 0) {
            domain = (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(domain);
            const o = (0, $98c8b67f479b9fc9$export$c25b1294fe9f63f1)(domain) || 1; // treat degenerate as ascending
            if (o === Math.sign(min)) domain[0] = 0; // [1, 2] or [-1, -2]
            else domain[domain.length - 1] = 0; // [2, 1] or [-2, -1]
        }
    }
    if (reverse) domain = (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(domain);
    scale.domain(domain).unknown(unknown);
    if (nice) scale.nice($30c166b7628c3ceb$var$maybeNice(nice, type)), domain = scale.domain();
    if (range !== undefined) scale.range(range);
    if (clamp) scale.clamp(clamp);
    return {
        type: type,
        domain: domain,
        range: range,
        scale: scale,
        interpolate: interpolate,
        interval: interval
    };
}
function $30c166b7628c3ceb$var$maybeNice(nice, type) {
    return nice === true ? undefined : typeof nice === "number" ? nice : (0, $cd9e805a4bbd13f9$export$367d1ceccf20717f)(nice, type);
}
function $30c166b7628c3ceb$export$8eab0b226d0f3b42(key, channels, options) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)(), channels, options);
}
function $30c166b7628c3ceb$export$a5c8c8de32abacf0(key, channels, options) {
    return $30c166b7628c3ceb$export$ea2a572a59b9896a(key, channels, {
        ...options,
        exponent: 0.5
    });
}
function $30c166b7628c3ceb$export$ea2a572a59b9896a(key, channels, { exponent: exponent = 1, ...options }) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $d97c146f4f811488$export$2e2bcd8739ae039)().exponent(exponent), channels, {
        ...options,
        type: "pow"
    });
}
function $30c166b7628c3ceb$export$812089778d3d78b5(key, channels, { base: base = 10, domain: domain = $30c166b7628c3ceb$var$inferLogDomain(channels), ...options }) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $5bf2f979a0299157$export$2e2bcd8739ae039)().base(base), channels, {
        ...options,
        domain: domain
    });
}
function $30c166b7628c3ceb$export$b91aaebc8fcff1ed(key, channels, { constant: constant = 1, ...options }) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $cb758ed0dff37844$export$2e2bcd8739ae039)().constant(constant), channels, options);
}
function $30c166b7628c3ceb$export$491dcf080c701b2f(key, channels, { range: range, quantiles: quantiles = range === undefined ? 5 : (range = [
    ...range
]).length, n: n = quantiles, scheme: scheme = "rdylbu", domain: domain = $30c166b7628c3ceb$var$inferQuantileDomain(channels), unknown: unknown, interpolate: interpolate, reverse: reverse }) {
    if (range === undefined) range = interpolate !== undefined ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? (0, $a49a01342b27942f$export$4247365b716746cf)(scheme, n) : undefined;
    if (domain.length > 0) domain = (0, $96238d247b54f1ee$export$2e2bcd8739ae039)(domain, range === undefined ? {
        length: n
    } : range).quantiles();
    return $30c166b7628c3ceb$export$29c9ae4906e7bfbc(key, channels, {
        domain: domain,
        range: range,
        reverse: reverse,
        unknown: unknown
    });
}
function $30c166b7628c3ceb$export$25f12ee8f05111a7(key, channels, { range: range, n: n = range === undefined ? 5 : (range = [
    ...range
]).length, scheme: scheme = "rdylbu", domain: domain = $30c166b7628c3ceb$var$inferAutoDomain(key, channels), unknown: unknown, interpolate: interpolate, reverse: reverse }) {
    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
    let thresholds;
    if (range === undefined) {
        thresholds = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(min, max, n); // approximate number of nice, round thresholds
        if (thresholds[0] <= min) thresholds.splice(0, 1); // drop exact lower bound
        if (thresholds[thresholds.length - 1] >= max) thresholds.pop(); // drop exact upper bound
        n = thresholds.length + 1;
        range = interpolate !== undefined ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? (0, $a49a01342b27942f$export$4247365b716746cf)(scheme, n) : undefined;
    } else {
        thresholds = (0, $4f501ce7bede8755$export$2e2bcd8739ae039)((0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(min, max), n + 1).slice(1, -1); // exactly n - 1 thresholds to match range
        if (min instanceof Date) thresholds = thresholds.map((x)=>new Date(x)); // preserve date types
    }
    if ((0, $98c8b67f479b9fc9$export$c25b1294fe9f63f1)((0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain)) < 0) thresholds.reverse(); // preserve descending domain
    return $30c166b7628c3ceb$export$29c9ae4906e7bfbc(key, channels, {
        domain: thresholds,
        range: range,
        reverse: reverse,
        unknown: unknown
    });
}
function $30c166b7628c3ceb$export$29c9ae4906e7bfbc(key, channels, { domain: domain = [
    0
], unknown: unknown, scheme: scheme = "rdylbu", interpolate: interpolate, range: range = interpolate !== undefined ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, domain.length + 1) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? (0, $a49a01342b27942f$export$4247365b716746cf)(scheme, domain.length + 1) : undefined, reverse: reverse }) {
    domain = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain);
    const sign = (0, $98c8b67f479b9fc9$export$c25b1294fe9f63f1)(domain); // preserve descending domain
    if (!isNaN(sign) && !$30c166b7628c3ceb$var$isOrdered(domain, sign)) throw new Error(`the ${key} scale has a non-monotonic domain`);
    if (reverse) range = (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(range); // domain ascending, so reverse range
    return {
        type: "threshold",
        scale: (0, $8058838348a44fed$export$2e2bcd8739ae039)(sign < 0 ? (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(domain) : domain, range === undefined ? [] : range).unknown(unknown),
        domain: domain,
        range: range
    };
}
function $30c166b7628c3ceb$var$isOrdered(domain, sign) {
    for(let i = 1, n = domain.length, d = domain[0]; i < n; ++i){
        const s = (0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(d, d = domain[i]);
        if (s !== 0 && s !== sign) return false;
    }
    return true;
}
function $30c166b7628c3ceb$export$5f13182ef6dc55f1(key) {
    return {
        type: "identity",
        scale: (0, $743dde21c57c19a0$export$2d070ad8c31ab6b9)((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key)) ? (0, $dcfca0550ace1fe6$export$2e2bcd8739ae039)() : (d)=>d
    };
}
function $30c166b7628c3ceb$export$62c3bd2b30bf9970(channels, f = (0, $0f3e37548c3914c7$export$145b33b964ff85c1)) {
    return channels.length ? [
        (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? value : (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(value, f)),
        (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? value : (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(value, f))
    ] : [
        0,
        1
    ];
}
function $30c166b7628c3ceb$var$inferAutoDomain(key, channels) {
    const type = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key);
    return (type === (0, $743dde21c57c19a0$export$872dd985a098dd45) || type === (0, $743dde21c57c19a0$export$c17a3be1057836e) || type === (0, $743dde21c57c19a0$export$f24224f1c91d8156) ? $30c166b7628c3ceb$var$inferZeroDomain : $30c166b7628c3ceb$export$62c3bd2b30bf9970)(channels);
}
function $30c166b7628c3ceb$var$inferZeroDomain(channels) {
    return [
        0,
        channels.length ? (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? value : (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(value, (0, $0f3e37548c3914c7$export$145b33b964ff85c1))) : 1
    ];
}
// We don’t want the upper bound of the radial domain to be zero, as this would
// be degenerate, so we ignore nonpositive values. We also don’t want the
// maximum default radius to exceed 30px.
function $30c166b7628c3ceb$var$inferRadialRange(channels, domain) {
    const hint = channels.find(({ radius: radius })=>radius !== undefined);
    if (hint !== undefined) return [
        0,
        hint.radius
    ]; // a natural maximum radius, e.g. hexbins
    const h25 = (0, $231c9024a6754413$export$2e2bcd8739ae039)(channels, 0.5, ({ value: value })=>value === undefined ? NaN : (0, $231c9024a6754413$export$2e2bcd8739ae039)(value, 0.25, (0, $0f3e37548c3914c7$export$aa5128ab863cd04)));
    const range = domain.map((d)=>3 * Math.sqrt(d / h25));
    const k = 30 / (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(range);
    return k < 1 ? range.map((r)=>r * k) : range;
}
// We want a length scale’s domain to go from zero to a positive value, and to
// treat negative lengths if any as inverted vectors of equivalent magnitude. We
// also don’t want the maximum default length to exceed 60px.
function $30c166b7628c3ceb$var$inferLengthRange(channels, domain) {
    const h50 = (0, $5713cbb46e42efc2$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? NaN : (0, $5713cbb46e42efc2$export$2e2bcd8739ae039)(value, Math.abs));
    const range = domain.map((d)=>12 * d / h50);
    const k = 60 / (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(range);
    return k < 1 ? range.map((r)=>r * k) : range;
}
function $30c166b7628c3ceb$var$inferLogDomain(channels) {
    for (const { value: value } of channels){
        if (value !== undefined) for (let v of value){
            if (v > 0) return $30c166b7628c3ceb$export$62c3bd2b30bf9970(channels, (0, $0f3e37548c3914c7$export$aa5128ab863cd04));
            if (v < 0) return $30c166b7628c3ceb$export$62c3bd2b30bf9970(channels, (0, $0f3e37548c3914c7$export$5f47f64d03acd206));
        }
    }
    return [
        1,
        10
    ];
}
function $30c166b7628c3ceb$var$inferQuantileDomain(channels) {
    const domain = [];
    for (const { value: value } of channels){
        if (value === undefined) continue;
        for (const v of value)domain.push(v);
    }
    return domain;
}
function $30c166b7628c3ceb$export$f68e9493607eda6(interpolate) {
    return (i, j)=>(t)=>interpolate(i + t * (j - i));
}





let $30c329e934b7a0f1$var$warnings = 0;
let $30c329e934b7a0f1$var$lastMessage;
function $30c329e934b7a0f1$export$1876d6a9858b29e7() {
    const w = $30c329e934b7a0f1$var$warnings;
    $30c329e934b7a0f1$var$warnings = 0;
    $30c329e934b7a0f1$var$lastMessage = undefined;
    return w;
}
function $30c329e934b7a0f1$export$c106dd0671a0fc2d(message) {
    if (message === $30c329e934b7a0f1$var$lastMessage) return;
    $30c329e934b7a0f1$var$lastMessage = message;
    console.warn(message);
    ++$30c329e934b7a0f1$var$warnings;
}





function $d47764ac2a1afe36$var$createScaleD(key, scale, transform, channels, { type: type, nice: nice, clamp: clamp, domain: domain = (0, $30c166b7628c3ceb$export$62c3bd2b30bf9970)(channels), unknown: unknown, pivot: pivot = 0, scheme: scheme, range: range, symmetric: symmetric = true, interpolate: interpolate = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? scheme == null && range !== undefined ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $a49a01342b27942f$export$c2977bbb95728409)(scheme !== undefined ? scheme : "rdbu") : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039), reverse: reverse }) {
    pivot = +pivot;
    domain = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain);
    let [min, max] = domain;
    if (domain.length > 2) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the diverging ${key} scale domain contains extra elements.`);
    if ((0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(min, max) < 0) [min, max] = [
        max,
        min
    ], reverse = !reverse;
    min = Math.min(min, pivot);
    max = Math.max(max, pivot);
    // Sometimes interpolate is a named interpolator, such as "lab" for Lab color
    // space. Other times interpolate is a function that takes two arguments and
    // is used in conjunction with the range. And other times the interpolate
    // function is a “fixed” interpolator on the [0, 1] interval, as when a
    // color scheme such as interpolateRdBu is used.
    if (typeof interpolate !== "function") interpolate = (0, $30c166b7628c3ceb$export$a720bd56dc6d3c41)(interpolate);
    // If an explicit range is specified, promote it to a piecewise interpolator.
    if (range !== undefined) interpolate = interpolate.length === 1 ? (0, $30c166b7628c3ceb$export$f68e9493607eda6)(interpolate)(...range) : (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate, range);
    // Reverse before normalization.
    if (reverse) interpolate = (0, $30c166b7628c3ceb$export$8a83211c878a3f1f)(interpolate);
    // Normalize the interpolator for symmetric difference around the pivot.
    if (symmetric) {
        const mid = transform.apply(pivot);
        const mindelta = mid - transform.apply(min);
        const maxdelta = transform.apply(max) - mid;
        if (mindelta < maxdelta) min = transform.invert(mid - maxdelta);
        else if (mindelta > maxdelta) max = transform.invert(mid + mindelta);
    }
    scale.domain([
        min,
        pivot,
        max
    ]).unknown(unknown).interpolator(interpolate);
    if (clamp) scale.clamp(clamp);
    if (nice) scale.nice(nice);
    return {
        type: type,
        domain: [
            min,
            max
        ],
        pivot: pivot,
        interpolate: interpolate,
        scale: scale
    };
}
function $d47764ac2a1afe36$export$10bc5013af7fbfeb(key, channels, options) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$2e2bcd8739ae039)(), $d47764ac2a1afe36$var$transformIdentity, channels, options);
}
function $d47764ac2a1afe36$export$5c6d902e911bf823(key, channels, options) {
    return $d47764ac2a1afe36$export$4271a1a68e7dad01(key, channels, {
        ...options,
        exponent: 0.5
    });
}
function $d47764ac2a1afe36$export$4271a1a68e7dad01(key, channels, { exponent: exponent = 1, ...options }) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$d6cedcc63bf26e7e)().exponent(exponent = +exponent), $d47764ac2a1afe36$var$transformPow(exponent), channels, {
        ...options,
        type: "diverging-pow"
    });
}
function $d47764ac2a1afe36$export$23b5ded97d4d761d(key, channels, { base: base = 10, pivot: pivot = 1, domain: domain = (0, $30c166b7628c3ceb$export$62c3bd2b30bf9970)(channels, pivot < 0 ? (0, $0f3e37548c3914c7$export$5f47f64d03acd206) : (0, $0f3e37548c3914c7$export$aa5128ab863cd04)), ...options }) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$5f0266a9159c47fb)().base(base = +base), $d47764ac2a1afe36$var$transformLog, channels, {
        domain: domain,
        pivot: pivot,
        ...options
    });
}
function $d47764ac2a1afe36$export$2e609d678277a5b2(key, channels, { constant: constant = 1, ...options }) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$50b3da713cf557c6)().constant(constant = +constant), $d47764ac2a1afe36$var$transformSymlog(constant), channels, options);
}
const $d47764ac2a1afe36$var$transformIdentity = {
    apply (x) {
        return x;
    },
    invert (x) {
        return x;
    }
};
const $d47764ac2a1afe36$var$transformLog = {
    apply: Math.log,
    invert: Math.exp
};
const $d47764ac2a1afe36$var$transformSqrt = {
    apply (x) {
        return Math.sign(x) * Math.sqrt(Math.abs(x));
    },
    invert (x) {
        return Math.sign(x) * (x * x);
    }
};
function $d47764ac2a1afe36$var$transformPow(exponent) {
    return exponent === 0.5 ? $d47764ac2a1afe36$var$transformSqrt : {
        apply (x) {
            return Math.sign(x) * Math.pow(Math.abs(x), exponent);
        },
        invert (x) {
            return Math.sign(x) * Math.pow(Math.abs(x), 1 / exponent);
        }
    };
}
function $d47764ac2a1afe36$var$transformSymlog(constant) {
    return {
        apply (x) {
            return Math.sign(x) * Math.log1p(Math.abs(x / constant));
        },
        invert (x) {
            return Math.sign(x) * Math.expm1(Math.abs(x)) * constant;
        }
    };
}





function $5e40204519ce563c$var$createScaleT(key, scale, channels, options) {
    return (0, $30c166b7628c3ceb$export$a11fad23408ff50e)(key, scale, channels, options);
}
function $5e40204519ce563c$export$75a5e216fb2fb836(key, channels, options) {
    return $5e40204519ce563c$var$createScaleT(key, (0, $304372357472b2a4$export$2e2bcd8739ae039)(), channels, options);
}
function $5e40204519ce563c$export$54513e35ea306f4c(key, channels, options) {
    return $5e40204519ce563c$var$createScaleT(key, (0, $f4e8dbe80a3143de$export$2e2bcd8739ae039)(), channels, options);
}








const $578b04df998308c7$export$c689386541b0b504 = Symbol("ordinal");
function $578b04df998308c7$var$createScaleO(key, scale, channels, { type: type, interval: interval, domain: domain, range: range, reverse: reverse, hint: hint }) {
    interval = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, type);
    if (domain === undefined) domain = $578b04df998308c7$var$inferDomain(channels, interval, key);
    if (type === "categorical" || type === $578b04df998308c7$export$c689386541b0b504) type = "ordinal"; // shorthand for color schemes
    if (reverse) domain = (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(domain);
    domain = scale.domain(domain).domain(); // deduplicate
    if (range !== undefined) {
        // If the range is specified as a function, pass it the domain.
        if (typeof range === "function") range = range(domain);
        scale.range(range);
    }
    return {
        type: type,
        domain: domain,
        range: range,
        scale: scale,
        hint: hint,
        interval: interval
    };
}
function $578b04df998308c7$export$ce1e458838513137(key, channels, { type: type, interval: interval, domain: domain, range: range, scheme: scheme, unknown: unknown, ...options }) {
    interval = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, type);
    if (domain === undefined) domain = $578b04df998308c7$var$inferDomain(channels, interval, key);
    let hint;
    if ((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$8f701197936bc2a6)) {
        hint = $578b04df998308c7$var$inferSymbolHint(channels);
        range = range === undefined ? $578b04df998308c7$var$inferSymbolRange(hint) : (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(range, (0, $7ef09cabd5617a1b$export$355b55bc2192971a));
    } else if ((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f)) {
        if (range === undefined && (type === "ordinal" || type === $578b04df998308c7$export$c689386541b0b504)) {
            range = (0, $a49a01342b27942f$export$ac9f44566dbce13a)(domain, scheme);
            if (range !== undefined) scheme = undefined; // Don’t re-apply scheme.
        }
        if (scheme === undefined && range === undefined) scheme = type === "ordinal" ? "turbo" : "observable10";
        if (scheme !== undefined) {
            if (range !== undefined) {
                const interpolate = (0, $a49a01342b27942f$export$c2977bbb95728409)(scheme);
                const t0 = range[0], d = range[1] - range[0];
                range = ({ length: n })=>(0, $4f501ce7bede8755$export$2e2bcd8739ae039)((t)=>interpolate(t0 + d * t), n);
            } else range = (0, $a49a01342b27942f$export$b81675b3e2d350c6)(scheme);
        }
    }
    if (unknown === (0, $38404d762c7ac827$export$e4f898ab14d9d460)) throw new Error(`implicit unknown on ${key} scale is not supported`);
    return $578b04df998308c7$var$createScaleO(key, (0, $38404d762c7ac827$export$2e2bcd8739ae039)().unknown(unknown), channels, {
        ...options,
        type: type,
        domain: domain,
        range: range,
        hint: hint
    });
}
function $578b04df998308c7$export$76f15ed1f7e49d58(key, channels, { align: align = 0.5, padding: padding = 0.5, ...options }) {
    return $578b04df998308c7$var$maybeRound((0, $c1f2fa2a7653ca3a$export$105684a3041cb6f3)().align(align).padding(padding), channels, options, key);
}
function $578b04df998308c7$export$d3af6885a1dd51b1(key, channels, { align: align = 0.5, padding: padding = 0.1, paddingInner: paddingInner = padding, paddingOuter: paddingOuter = key === "fx" || key === "fy" ? 0 : padding, ...options }) {
    return $578b04df998308c7$var$maybeRound((0, $c1f2fa2a7653ca3a$export$2e2bcd8739ae039)().align(align).paddingInner(paddingInner).paddingOuter(paddingOuter), channels, options, key);
}
function $578b04df998308c7$var$maybeRound(scale, channels, options, key) {
    let { round: round } = options;
    if (round !== undefined) scale.round(round = !!round);
    scale = $578b04df998308c7$var$createScaleO(key, scale, channels, options);
    scale.round = round; // preserve for autoScaleRound
    return scale;
}
function $578b04df998308c7$var$inferDomain(channels, interval, key) {
    const values = new (0, $3160658555deb5c9$export$55278c3294239828)();
    for (const { value: value, domain: domain } of channels){
        if (domain !== undefined) return domain(); // see channelDomain
        if (value === undefined) continue;
        for (const v of value)values.add(v);
    }
    if (interval !== undefined) {
        const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(values).map(interval.floor, interval);
        return interval.range(min, interval.offset(max));
    }
    if (values.size > 10e3 && (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$5880b8b5730aff45)) throw new Error(`implicit ordinal domain of ${key} scale has more than 10,000 values`);
    return (0, $3dc3306e587e145d$export$2e2bcd8739ae039)(values, (0, $0f3e37548c3914c7$export$686e14b8469efec4));
}
// If all channels provide a consistent hint, propagate it to the scale.
function $578b04df998308c7$var$inferHint(channels, key) {
    let value;
    for (const { hint: hint } of channels){
        const candidate = hint?.[key];
        if (candidate === undefined) continue; // no hint here
        if (value === undefined) value = candidate; // first hint
        else if (value !== candidate) return; // inconsistent hint
    }
    return value;
}
function $578b04df998308c7$var$inferSymbolHint(channels) {
    return {
        fill: $578b04df998308c7$var$inferHint(channels, "fill"),
        stroke: $578b04df998308c7$var$inferHint(channels, "stroke")
    };
}
function $578b04df998308c7$var$inferSymbolRange(hint) {
    return (0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(hint.fill) ? (0, $497fe223f0c7b3e8$export$915e06de6acf8fe) : (0, $497fe223f0c7b3e8$export$19158c96a6700c15);
}




function $d2c16f7a6010a221$export$3935c083772c2fcc(channelsByScale, { label: globalLabel, inset: globalInset = 0, insetTop: globalInsetTop = globalInset, insetRight: globalInsetRight = globalInset, insetBottom: globalInsetBottom = globalInset, insetLeft: globalInsetLeft = globalInset, round: round, nice: nice, clamp: clamp, zero: zero, align: align, padding: padding, projection: projection, facet: { label: facetLabel = globalLabel } = {}, ...options } = {}) {
    const scales = {};
    for (const [key, channels] of channelsByScale){
        const scaleOptions = options[key];
        const scale = $d2c16f7a6010a221$var$createScale(key, channels, {
            round: (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$5880b8b5730aff45) ? round : undefined,
            nice: nice,
            clamp: clamp,
            zero: zero,
            align: align,
            padding: padding,
            projection: projection,
            ...scaleOptions
        });
        if (scale) {
            // populate generic scale options (percent, transform, insets)
            let { label: label = key === "fx" || key === "fy" ? facetLabel : globalLabel, percent: percent, transform: transform, inset: inset, insetTop: insetTop = inset !== undefined ? inset : key === "y" ? globalInsetTop : 0, insetRight: insetRight = inset !== undefined ? inset : key === "x" ? globalInsetRight : 0, insetBottom: insetBottom = inset !== undefined ? inset : key === "y" ? globalInsetBottom : 0, insetLeft: insetLeft = inset !== undefined ? inset : key === "x" ? globalInsetLeft : 0 // not fx
             } = scaleOptions || {};
            if (transform == null) transform = undefined;
            else if (typeof transform !== "function") throw new Error("invalid scale transform; not a function");
            scale.percent = !!percent;
            scale.label = label === undefined ? $d2c16f7a6010a221$var$inferScaleLabel(channels, scale) : label;
            scale.transform = transform;
            if (key === "x" || key === "fx") {
                scale.insetLeft = +insetLeft;
                scale.insetRight = +insetRight;
            } else if (key === "y" || key === "fy") {
                scale.insetTop = +insetTop;
                scale.insetBottom = +insetBottom;
            }
            scales[key] = scale;
        }
    }
    return scales;
}
function $d2c16f7a6010a221$export$c2fb627c1b06c8b7(descriptors) {
    const scales = {};
    const scaleFunctions = {
        scales: scales
    };
    for (const [key, descriptor] of Object.entries(descriptors)){
        const { scale: scale, type: type, interval: interval, label: label } = descriptor;
        scales[key] = $d2c16f7a6010a221$var$exposeScale(descriptor);
        scaleFunctions[key] = scale;
        // TODO: pass these properties, which are needed for axes, in the descriptor.
        scale.type = type;
        if (interval != null) scale.interval = interval;
        if (label != null) scale.label = label;
    }
    return scaleFunctions;
}
function $d2c16f7a6010a221$export$9b57902db34fb271(scales, dimensions) {
    const { x: x, y: y, fx: fx, fy: fy } = scales;
    const superdimensions = fx || fy ? $d2c16f7a6010a221$export$5d21a1ac38f7e01a(dimensions) : dimensions;
    if (fx) $d2c16f7a6010a221$var$autoScaleRangeX(fx, superdimensions);
    if (fy) $d2c16f7a6010a221$var$autoScaleRangeY(fy, superdimensions);
    const subdimensions = fx || fy ? $d2c16f7a6010a221$export$d598388655a34790(scales, dimensions) : dimensions;
    if (x) $d2c16f7a6010a221$var$autoScaleRangeX(x, subdimensions);
    if (y) $d2c16f7a6010a221$var$autoScaleRangeY(y, subdimensions);
}
// Channels can have labels; if all the channels for a given scale are
// consistently labeled (i.e., have the same value if not undefined), and the
// corresponding scale doesn’t already have an explicit label, then the
// channels’ label is promoted to the scale. This inferred label should have an
// orientation-appropriate arrow added when used as an axis, but we don’t want
// to add the arrow when the label is set explicitly as an option; so, the
// inferred label is distinguished as an object with an “inferred” property.
function $d2c16f7a6010a221$var$inferScaleLabel(channels = [], scale) {
    let label;
    for (const { label: l } of channels){
        if (l === undefined) continue;
        if (label === undefined) label = l;
        else if (label !== l) return;
    }
    if (label === undefined) return;
    if (!$d2c16f7a6010a221$export$61579433626afe87(scale) && scale.percent) label = `${label} (%)`;
    return {
        inferred: true,
        toString: ()=>label
    };
}
function $d2c16f7a6010a221$export$cb20e1306358cc06(scale) {
    return Math.sign((0, $98c8b67f479b9fc9$export$c25b1294fe9f63f1)(scale.domain())) * Math.sign((0, $98c8b67f479b9fc9$export$c25b1294fe9f63f1)(scale.range()));
}
function $d2c16f7a6010a221$export$5d21a1ac38f7e01a(dimensions) {
    const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height, facet: { marginTop: facetMarginTop, marginRight: facetMarginRight, marginBottom: facetMarginBottom, marginLeft: facetMarginLeft } } = dimensions;
    return {
        marginTop: Math.max(marginTop, facetMarginTop),
        marginRight: Math.max(marginRight, facetMarginRight),
        marginBottom: Math.max(marginBottom, facetMarginBottom),
        marginLeft: Math.max(marginLeft, facetMarginLeft),
        width: width,
        height: height
    };
}
function $d2c16f7a6010a221$export$d598388655a34790({ fx: fx, fy: fy }, dimensions) {
    const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = $d2c16f7a6010a221$export$5d21a1ac38f7e01a(dimensions);
    return {
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        width: fx ? fx.scale.bandwidth() + marginLeft + marginRight : width,
        height: fy ? fy.scale.bandwidth() + marginTop + marginBottom : height,
        facet: {
            width: width,
            height: height
        }
    };
}
function $d2c16f7a6010a221$var$autoScaleRangeX(scale, dimensions) {
    if (scale.range === undefined) {
        const { insetLeft: insetLeft, insetRight: insetRight } = scale;
        const { width: width, marginLeft: marginLeft = 0, marginRight: marginRight = 0 } = dimensions;
        const left = marginLeft + insetLeft;
        const right = width - marginRight - insetRight;
        scale.range = [
            left,
            Math.max(left, right)
        ];
        if (!$d2c16f7a6010a221$export$61579433626afe87(scale)) scale.range = $d2c16f7a6010a221$var$piecewiseRange(scale);
        scale.scale.range(scale.range);
    }
    $d2c16f7a6010a221$var$autoScaleRound(scale);
}
function $d2c16f7a6010a221$var$autoScaleRangeY(scale, dimensions) {
    if (scale.range === undefined) {
        const { insetTop: insetTop, insetBottom: insetBottom } = scale;
        const { height: height, marginTop: marginTop = 0, marginBottom: marginBottom = 0 } = dimensions;
        const top = marginTop + insetTop;
        const bottom = height - marginBottom - insetBottom;
        scale.range = [
            Math.max(top, bottom),
            top
        ];
        if (!$d2c16f7a6010a221$export$61579433626afe87(scale)) scale.range = $d2c16f7a6010a221$var$piecewiseRange(scale);
        else scale.range.reverse();
        scale.scale.range(scale.range);
    }
    $d2c16f7a6010a221$var$autoScaleRound(scale);
}
function $d2c16f7a6010a221$var$autoScaleRound(scale) {
    if (scale.round === undefined && $d2c16f7a6010a221$var$isBandScale(scale) && $d2c16f7a6010a221$var$roundError(scale) <= 30) scale.scale.round(true);
}
// If we were to turn on rounding for this band or point scale, how much wasted
// space would it introduce (on both ends of the range)? This must match
// d3.scaleBand’s rounding behavior:
// https://github.com/d3/d3-scale/blob/83555bd759c7314420bd4240642beda5e258db9e/src/band.js#L20-L32
function $d2c16f7a6010a221$var$roundError({ scale: scale }) {
    const n = scale.domain().length;
    const [start, stop] = scale.range();
    const paddingInner = scale.paddingInner ? scale.paddingInner() : 1;
    const paddingOuter = scale.paddingOuter ? scale.paddingOuter() : scale.padding();
    const m = n - paddingInner;
    const step = Math.abs(stop - start) / Math.max(1, m + paddingOuter * 2);
    return (step - Math.floor(step)) * m;
}
function $d2c16f7a6010a221$var$piecewiseRange(scale) {
    const length = scale.scale.domain().length + $d2c16f7a6010a221$export$667642af40ee0f01(scale);
    if (!(length > 2)) return scale.range;
    const [start, end] = scale.range;
    return Array.from({
        length: length
    }, (_, i)=>start + i / (length - 1) * (end - start));
}
function $d2c16f7a6010a221$export$a566bffc16069997(key, scale, hint) {
    return $d2c16f7a6010a221$var$createScale(key, hint === undefined ? undefined : [
        {
            hint: hint
        }
    ], {
        ...scale
    });
}
function $d2c16f7a6010a221$var$createScale(key, channels = [], options = {}) {
    const type = $d2c16f7a6010a221$var$inferScaleType(key, channels, options);
    // Warn for common misuses of implicit ordinal scales. We disable this test if
    // you specify a scale interval or if you set the domain or range explicitly,
    // since setting the domain or range (typically with a cardinality of more than
    // two) is another indication that you intended for the scale to be ordinal; we
    // also disable it for facet scales since these are always band scales.
    if (options.type === undefined && options.domain === undefined && options.range === undefined && options.interval == null && key !== "fx" && key !== "fy" && $d2c16f7a6010a221$export$61579433626afe87({
        type: type
    })) {
        const values = channels.map(({ value: value })=>value).filter((value)=>value !== undefined);
        if (values.some((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7))) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: some data associated with the ${key} scale are dates. Dates are typically associated with a "utc" or "time" scale rather than a "${$d2c16f7a6010a221$var$formatScaleType(type)}" scale. If you are using a bar mark, you probably want a rect mark with the interval option instead; if you are using a group transform, you probably want a bin transform instead. If you want to treat this data as ordinal, you can specify the interval of the ${key} scale (e.g., d3.utcDay), or you can suppress this warning by setting the type of the ${key} scale to "${$d2c16f7a6010a221$var$formatScaleType(type)}".`);
        else if (values.some((0, $cd9e805a4bbd13f9$export$4ca903a67c0d1c91))) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: some data associated with the ${key} scale are strings that appear to be dates (e.g., YYYY-MM-DD). If these strings represent dates, you should parse them to Date objects. Dates are typically associated with a "utc" or "time" scale rather than a "${$d2c16f7a6010a221$var$formatScaleType(type)}" scale. If you are using a bar mark, you probably want a rect mark with the interval option instead; if you are using a group transform, you probably want a bin transform instead. If you want to treat this data as ordinal, you can suppress this warning by setting the type of the ${key} scale to "${$d2c16f7a6010a221$var$formatScaleType(type)}".`);
        else if (values.some((0, $cd9e805a4bbd13f9$export$797f4d96e209972c))) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: some data associated with the ${key} scale are strings that appear to be numbers. If these strings represent numbers, you should parse or coerce them to numbers. Numbers are typically associated with a "linear" scale rather than a "${$d2c16f7a6010a221$var$formatScaleType(type)}" scale. If you want to treat this data as ordinal, you can specify the interval of the ${key} scale (e.g., 1 for integers), or you can suppress this warning by setting the type of the ${key} scale to "${$d2c16f7a6010a221$var$formatScaleType(type)}".`);
    }
    options.type = type; // Mutates input!
    // Once the scale type is known, coerce the associated channel values and any
    // explicitly-specified domain to the expected type.
    switch(type){
        case "diverging":
        case "diverging-sqrt":
        case "diverging-pow":
        case "diverging-log":
        case "diverging-symlog":
        case "cyclical":
        case "sequential":
        case "linear":
        case "sqrt":
        case "threshold":
        case "quantile":
        case "pow":
        case "log":
        case "symlog":
            options = $d2c16f7a6010a221$var$coerceType(channels, options, (0, $cd9e805a4bbd13f9$export$803a244824c02a83));
            break;
        case "identity":
            switch((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key)){
                case 0, $743dde21c57c19a0$export$5880b8b5730aff45:
                    options = $d2c16f7a6010a221$var$coerceType(channels, options, (0, $cd9e805a4bbd13f9$export$803a244824c02a83));
                    break;
                case 0, $743dde21c57c19a0$export$8f701197936bc2a6:
                    options = $d2c16f7a6010a221$var$coerceType(channels, options, $d2c16f7a6010a221$var$coerceSymbols);
                    break;
            }
            break;
        case "utc":
        case "time":
            options = $d2c16f7a6010a221$var$coerceType(channels, options, (0, $cd9e805a4bbd13f9$export$9a67b3ad4b3297f7));
            break;
    }
    switch(type){
        case "diverging":
            return (0, $d47764ac2a1afe36$export$10bc5013af7fbfeb)(key, channels, options);
        case "diverging-sqrt":
            return (0, $d47764ac2a1afe36$export$5c6d902e911bf823)(key, channels, options);
        case "diverging-pow":
            return (0, $d47764ac2a1afe36$export$4271a1a68e7dad01)(key, channels, options);
        case "diverging-log":
            return (0, $d47764ac2a1afe36$export$23b5ded97d4d761d)(key, channels, options);
        case "diverging-symlog":
            return (0, $d47764ac2a1afe36$export$2e609d678277a5b2)(key, channels, options);
        case "categorical":
        case "ordinal":
        case 0, $578b04df998308c7$export$c689386541b0b504:
            return (0, $578b04df998308c7$export$ce1e458838513137)(key, channels, options);
        case "cyclical":
        case "sequential":
        case "linear":
            return (0, $30c166b7628c3ceb$export$8eab0b226d0f3b42)(key, channels, options);
        case "sqrt":
            return (0, $30c166b7628c3ceb$export$a5c8c8de32abacf0)(key, channels, options);
        case "threshold":
            return (0, $30c166b7628c3ceb$export$29c9ae4906e7bfbc)(key, channels, options);
        case "quantile":
            return (0, $30c166b7628c3ceb$export$491dcf080c701b2f)(key, channels, options);
        case "quantize":
            return (0, $30c166b7628c3ceb$export$25f12ee8f05111a7)(key, channels, options);
        case "pow":
            return (0, $30c166b7628c3ceb$export$ea2a572a59b9896a)(key, channels, options);
        case "log":
            return (0, $30c166b7628c3ceb$export$812089778d3d78b5)(key, channels, options);
        case "symlog":
            return (0, $30c166b7628c3ceb$export$b91aaebc8fcff1ed)(key, channels, options);
        case "utc":
            return (0, $5e40204519ce563c$export$54513e35ea306f4c)(key, channels, options);
        case "time":
            return (0, $5e40204519ce563c$export$75a5e216fb2fb836)(key, channels, options);
        case "point":
            return (0, $578b04df998308c7$export$76f15ed1f7e49d58)(key, channels, options);
        case "band":
            return (0, $578b04df998308c7$export$d3af6885a1dd51b1)(key, channels, options);
        case "identity":
            return (0, $30c166b7628c3ceb$export$5f13182ef6dc55f1)(key);
        case undefined:
            return;
        default:
            throw new Error(`unknown scale type: ${type}`);
    }
}
function $d2c16f7a6010a221$var$formatScaleType(type) {
    return typeof type === "symbol" ? type.description : type;
}
function $d2c16f7a6010a221$var$maybeScaleType(type) {
    return typeof type === "string" ? `${type}`.toLowerCase() : type;
}
// A special type symbol when the x and y scales are replaced with a projection.
const $d2c16f7a6010a221$var$typeProjection = {
    toString: ()=>"projection"
};
function $d2c16f7a6010a221$var$inferScaleType(key, channels, { type: type, domain: domain, range: range, scheme: scheme, pivot: pivot, projection: projection }) {
    type = $d2c16f7a6010a221$var$maybeScaleType(type);
    // The facet scales are always band scales; this cannot be changed.
    if (key === "fx" || key === "fy") return "band";
    // If a projection is specified, the x- and y-scales are disabled; these
    // channels will be projected rather than scaled. (But still check that none
    // of the associated channels are incompatible with a projection.)
    if ((key === "x" || key === "y") && projection != null) type = $d2c16f7a6010a221$var$typeProjection;
    // If a channel dictates a scale type, make sure that it is consistent with
    // the user-specified scale type (if any) and all other channels. For example,
    // barY requires x to be a band scale and disallows any other scale type.
    for (const channel of channels){
        const t = $d2c16f7a6010a221$var$maybeScaleType(channel.type);
        if (t === undefined) continue;
        else if (type === undefined) type = t;
        else if (type !== t) throw new Error(`scale incompatible with channel: ${type} !== ${t}`);
    }
    // If the scale, a channel, or user specified a (consistent) type, return it.
    if (type === $d2c16f7a6010a221$var$typeProjection) return;
    if (type !== undefined) return type;
    // If there’s no data (and no type) associated with this scale, don’t create a scale.
    if (domain === undefined && !channels.some(({ value: value })=>value !== undefined)) return;
    // Some scales have default types.
    const kind = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key);
    if (kind === (0, $743dde21c57c19a0$export$872dd985a098dd45)) return "sqrt";
    if (kind === (0, $743dde21c57c19a0$export$c17a3be1057836e) || kind === (0, $743dde21c57c19a0$export$f24224f1c91d8156)) return "linear";
    if (kind === (0, $743dde21c57c19a0$export$8f701197936bc2a6)) return "ordinal";
    // If the domain or range has more than two values, assume it’s ordinal. You
    // can still use a “piecewise” (or “polylinear”) scale, but you must set the
    // type explicitly.
    if ((domain || range || []).length > 2) return $d2c16f7a6010a221$var$asOrdinalType(kind);
    // Otherwise, infer the scale type from the data! Prefer the domain, if
    // present, over channels. (The domain and channels should be consistently
    // typed, and the domain is more explicit and typically much smaller.) We only
    // check the first defined value for expedience and simplicity; we expect
    // that the types are consistent.
    if (domain !== undefined) {
        if ((0, $cd9e805a4bbd13f9$export$ded408f9a9c9003b)(domain)) return $d2c16f7a6010a221$var$asOrdinalType(kind);
        if ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(domain)) return "utc";
    } else {
        const values = channels.map(({ value: value })=>value).filter((value)=>value !== undefined);
        if (values.some((0, $cd9e805a4bbd13f9$export$ded408f9a9c9003b))) return $d2c16f7a6010a221$var$asOrdinalType(kind);
        if (values.some((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7))) return "utc";
    }
    // For color scales, take a hint from the color scheme and pivot option.
    if (kind === (0, $743dde21c57c19a0$export$35e9368ef982300f)) {
        if (pivot != null || (0, $a49a01342b27942f$export$bd1a4763c73ba9bf)(scheme)) return "diverging";
        if ((0, $a49a01342b27942f$export$6be03a206d9fd924)(scheme)) return "categorical";
    }
    return "linear";
}
// Positional scales default to a point scale instead of an ordinal scale.
function $d2c16f7a6010a221$var$asOrdinalType(kind) {
    switch(kind){
        case 0, $743dde21c57c19a0$export$5880b8b5730aff45:
            return "point";
        case 0, $743dde21c57c19a0$export$35e9368ef982300f:
            return 0, $578b04df998308c7$export$c689386541b0b504;
        default:
            return "ordinal";
    }
}
function $d2c16f7a6010a221$export$60df8d74f7d563a1({ type: type }) {
    return type === "time" || type === "utc";
}
function $d2c16f7a6010a221$export$61579433626afe87({ type: type }) {
    return type === "ordinal" || type === "point" || type === "band" || type === (0, $578b04df998308c7$export$c689386541b0b504);
}
function $d2c16f7a6010a221$export$667642af40ee0f01({ type: type }) {
    return type === "threshold";
}
function $d2c16f7a6010a221$var$isBandScale({ type: type }) {
    return type === "point" || type === "band";
}
function $d2c16f7a6010a221$export$d977c0ec2df12b11({ type: type }) {
    return /^diverging($|-)/.test(type);
}
function $d2c16f7a6010a221$export$9c903d35b97d0190(scale) {
    if (scale === undefined) return true; // treat missing scale as collapsed
    const domain = scale.domain();
    const value = scale(domain[0]);
    for(let i = 1, n = domain.length; i < n; ++i){
        if (scale(domain[i]) - value) return false;
    }
    return true;
}
// Mutates channel.value!
function $d2c16f7a6010a221$var$coerceType(channels, { domain: domain, ...options }, coerceValues) {
    for (const c of channels)if (c.value !== undefined) {
        if (domain === undefined) domain = c.value?.domain; // promote channel domain
        c.value = coerceValues(c.value);
    }
    return {
        domain: domain === undefined ? domain : coerceValues(domain),
        ...options
    };
}
function $d2c16f7a6010a221$var$coerceSymbols(values) {
    return (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(values, (0, $7ef09cabd5617a1b$export$355b55bc2192971a));
}
function $d2c16f7a6010a221$export$dcdf75081b88279d(options = {}) {
    let scale;
    for(const key in options){
        if (!(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(key)) continue; // ignore unknown properties
        if (!(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options[key])) continue; // e.g., ignore {color: "red"}
        if (scale !== undefined) throw new Error("ambiguous scale definition; multiple scales found");
        scale = $d2c16f7a6010a221$var$exposeScale($d2c16f7a6010a221$export$a566bffc16069997(key, options[key]));
    }
    if (scale === undefined) throw new Error("invalid scale definition; no scale found");
    return scale;
}
function $d2c16f7a6010a221$export$de69b9c17a3f6bda(scales) {
    return (key)=>{
        if (!(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(key = `${key}`)) throw new Error(`unknown scale: ${key}`);
        return scales[key];
    };
}
// Note: axis- and legend-related properties (such as label, ticks and
// tickFormat) are not included here as they do not affect the scale’s behavior.
function $d2c16f7a6010a221$var$exposeScale({ scale: scale, type: type, domain: domain, range: range, interpolate: interpolate, interval: interval, transform: transform, percent: percent, pivot: pivot }) {
    if (type === "identity") return {
        type: "identity",
        apply: (d)=>d,
        invert: (d)=>d
    };
    const unknown = scale.unknown ? scale.unknown() : undefined;
    return {
        type: type,
        domain: (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(domain),
        ...range !== undefined && {
            range: (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(range)
        },
        ...transform !== undefined && {
            transform: transform
        },
        ...percent && {
            percent: percent
        },
        ...unknown !== undefined && {
            unknown: unknown
        },
        ...interval !== undefined && {
            interval: interval
        },
        // quantitative
        ...interpolate !== undefined && {
            interpolate: interpolate
        },
        ...scale.clamp && {
            clamp: scale.clamp()
        },
        // diverging (always asymmetric; we never want to apply the symmetric transform twice)
        ...pivot !== undefined && {
            pivot: pivot,
            symmetric: false
        },
        // log, diverging-log
        ...scale.base && {
            base: scale.base()
        },
        // pow, diverging-pow
        ...scale.exponent && {
            exponent: scale.exponent()
        },
        // symlog, diverging-symlog
        ...scale.constant && {
            constant: scale.constant()
        },
        // band, point
        ...scale.align && {
            align: scale.align(),
            round: scale.round()
        },
        ...scale.padding && (scale.paddingInner ? {
            paddingInner: scale.paddingInner(),
            paddingOuter: scale.paddingOuter()
        } : {
            padding: scale.padding()
        }),
        ...scale.bandwidth && {
            bandwidth: scale.bandwidth(),
            step: scale.step()
        },
        // utilities
        apply: (t)=>scale(t),
        ...scale.invert && {
            invert: (t)=>scale.invert(t)
        }
    };
}


function $a6069a9074a3d58d$export$78806da010ca96a5(channelsByScale, options) {
    const { fx: fx, fy: fy } = (0, $d2c16f7a6010a221$export$3935c083772c2fcc)(channelsByScale, options);
    const fxDomain = fx?.scale.domain();
    const fyDomain = fy?.scale.domain();
    return fxDomain && fyDomain ? (0, $674b813fb857ae76$export$2e2bcd8739ae039)(fxDomain, fyDomain).map(([x, y], i)=>({
            x: x,
            y: y,
            i: i
        })) : fxDomain ? fxDomain.map((x, i)=>({
            x: x,
            i: i
        })) : fyDomain ? fyDomain.map((y, i)=>({
            y: y,
            i: i
        })) : undefined;
}
function $a6069a9074a3d58d$export$f59853a117afdf3c(facets, { x: X, y: Y }) {
    X &&= $a6069a9074a3d58d$var$facetIndex(X);
    Y &&= $a6069a9074a3d58d$var$facetIndex(Y);
    return facets.filter(X && Y // remove any facets no longer present in the domain
     ? (f)=>X.has(f.x) && Y.has(f.y) : X ? (f)=>X.has(f.x) : (f)=>Y.has(f.y)).sort(X && Y // reorder facets to match the new scale domains
     ? (a, b)=>X.get(a.x) - X.get(b.x) || Y.get(a.y) - Y.get(b.y) : X ? (a, b)=>X.get(a.x) - X.get(b.x) : (a, b)=>Y.get(a.y) - Y.get(b.y));
}
function $a6069a9074a3d58d$export$46a87af59f80d026(data, { fx: fx, fy: fy }) {
    const I = (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data);
    const FX = fx?.value;
    const FY = fy?.value;
    return fx && fy ? (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (G)=>(G.fx = FX[G[0]], G.fy = FY[G[0]], G), (i)=>FX[i], (i)=>FY[i]) : fx ? (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (G)=>(G.fx = FX[G[0]], G), (i)=>FX[i]) : (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (G)=>(G.fy = FY[G[0]], G), (i)=>FY[i]);
}
function $a6069a9074a3d58d$export$1b78147bc5e9c7ba(fx, fy, { marginTop: marginTop, marginLeft: marginLeft }) {
    return fx && fy ? ({ x: x, y: y })=>`translate(${fx(x) - marginLeft},${fy(y) - marginTop})` : fx ? ({ x: x })=>`translate(${fx(x) - marginLeft},0)` : ({ y: y })=>`translate(0,${fy(y) - marginTop})`;
}
function $a6069a9074a3d58d$export$1cc7e8228bc740dc(index) {
    const ex = [];
    const e = new Uint32Array((0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(index, (d)=>d.length));
    for (const i of index){
        let n = 0;
        for (const j of index){
            if (i === j) continue;
            e.set(j, n);
            n += j.length;
        }
        ex.push(e.slice(0, n));
    }
    return ex;
}
const $a6069a9074a3d58d$var$facetAnchors = new Map([
    [
        "top",
        $a6069a9074a3d58d$var$facetAnchorTop
    ],
    [
        "right",
        $a6069a9074a3d58d$var$facetAnchorRight
    ],
    [
        "bottom",
        $a6069a9074a3d58d$var$facetAnchorBottom
    ],
    [
        "left",
        $a6069a9074a3d58d$var$facetAnchorLeft
    ],
    [
        "top-left",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorTop, $a6069a9074a3d58d$var$facetAnchorLeft)
    ],
    [
        "top-right",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorTop, $a6069a9074a3d58d$var$facetAnchorRight)
    ],
    [
        "bottom-left",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorBottom, $a6069a9074a3d58d$var$facetAnchorLeft)
    ],
    [
        "bottom-right",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorBottom, $a6069a9074a3d58d$var$facetAnchorRight)
    ],
    [
        "top-empty",
        $a6069a9074a3d58d$var$facetAnchorTopEmpty
    ],
    [
        "right-empty",
        $a6069a9074a3d58d$var$facetAnchorRightEmpty
    ],
    [
        "bottom-empty",
        $a6069a9074a3d58d$var$facetAnchorBottomEmpty
    ],
    [
        "left-empty",
        $a6069a9074a3d58d$var$facetAnchorLeftEmpty
    ],
    [
        "empty",
        $a6069a9074a3d58d$var$facetAnchorEmpty
    ]
]);
function $a6069a9074a3d58d$export$598b026809f23ca0(facetAnchor) {
    if (facetAnchor == null) return null;
    const anchor = $a6069a9074a3d58d$var$facetAnchors.get(`${facetAnchor}`.toLowerCase());
    if (anchor) return anchor;
    throw new Error(`invalid facet anchor: ${facetAnchor}`);
}
const $a6069a9074a3d58d$var$indexCache = new WeakMap();
function $a6069a9074a3d58d$var$facetIndex(V) {
    let I = $a6069a9074a3d58d$var$indexCache.get(V);
    if (!I) $a6069a9074a3d58d$var$indexCache.set(V, I = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)((0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(V, (v, i)=>[
            v,
            i
        ])));
    return I;
}
// Like V.indexOf(v), but with the same semantics as InternMap.
function $a6069a9074a3d58d$var$facetIndexOf(V, v) {
    return $a6069a9074a3d58d$var$facetIndex(V).get(v);
}
// Like facets.find, but with the same semantics as InternMap.
function $a6069a9074a3d58d$var$facetFind(facets, x, y) {
    x = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(x);
    y = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(y);
    return facets.find((f)=>Object.is((0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(f.x), x) && Object.is((0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(f.y), y));
}
function $a6069a9074a3d58d$var$facetEmpty(facets, x, y) {
    return $a6069a9074a3d58d$var$facetFind(facets, x, y)?.empty;
}
function $a6069a9074a3d58d$var$facetAnchorTop(facets, { y: Y }, { y: y }) {
    return Y ? $a6069a9074a3d58d$var$facetIndexOf(Y, y) === 0 : true;
}
function $a6069a9074a3d58d$var$facetAnchorBottom(facets, { y: Y }, { y: y }) {
    return Y ? $a6069a9074a3d58d$var$facetIndexOf(Y, y) === Y.length - 1 : true;
}
function $a6069a9074a3d58d$var$facetAnchorLeft(facets, { x: X }, { x: x }) {
    return X ? $a6069a9074a3d58d$var$facetIndexOf(X, x) === 0 : true;
}
function $a6069a9074a3d58d$var$facetAnchorRight(facets, { x: X }, { x: x }) {
    return X ? $a6069a9074a3d58d$var$facetIndexOf(X, x) === X.length - 1 : true;
}
function $a6069a9074a3d58d$var$facetAnchorTopEmpty(facets, { y: Y }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!Y) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(Y, y);
    if (i > 0) return $a6069a9074a3d58d$var$facetEmpty(facets, x, Y[i - 1]);
}
function $a6069a9074a3d58d$var$facetAnchorBottomEmpty(facets, { y: Y }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!Y) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(Y, y);
    if (i < Y.length - 1) return $a6069a9074a3d58d$var$facetEmpty(facets, x, Y[i + 1]);
}
function $a6069a9074a3d58d$var$facetAnchorLeftEmpty(facets, { x: X }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!X) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(X, x);
    if (i > 0) return $a6069a9074a3d58d$var$facetEmpty(facets, X[i - 1], y);
}
function $a6069a9074a3d58d$var$facetAnchorRightEmpty(facets, { x: X }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!X) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(X, x);
    if (i < X.length - 1) return $a6069a9074a3d58d$var$facetEmpty(facets, X[i + 1], y);
}
function $a6069a9074a3d58d$var$facetAnchorEmpty(facets, channels, { empty: empty }) {
    return empty;
}
function $a6069a9074a3d58d$var$and(a, b) {
    return function() {
        return a.apply(null, arguments) && b.apply(null, arguments);
    };
}
function $a6069a9074a3d58d$export$60f5bc485ae97c42(facets, { channels: { fx: fx, fy: fy }, groups: groups }) {
    return fx && fy ? facets.map(({ x: x, y: y })=>groups.get(x)?.get(y) ?? []) : fx ? facets.map(({ x: x })=>groups.get(x) ?? []) : facets.map(({ y: y })=>groups.get(y) ?? []);
}







const $0b574e6ffdcb6f7c$var$pi = Math.PI;
const $0b574e6ffdcb6f7c$var$tau = 2 * $0b574e6ffdcb6f7c$var$pi;
const $0b574e6ffdcb6f7c$var$defaultAspectRatio = 0.618;
function $0b574e6ffdcb6f7c$export$549167224996a0fb({ projection: projection, inset: globalInset = 0, insetTop: insetTop = globalInset, insetRight: insetRight = globalInset, insetBottom: insetBottom = globalInset, insetLeft: insetLeft = globalInset } = {}, dimensions) {
    if (projection == null) return;
    if (typeof projection.stream === "function") return projection; // d3 projection
    let options;
    let domain;
    let clip = "frame";
    // If the projection was specified as an object with additional options,
    // extract those. The order of precedence for insetTop (and other insets) is:
    // projection.insetTop, projection.inset, (global) insetTop, (global) inset.
    // Any other options on this object will be passed through to the initializer.
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(projection)) {
        let inset;
        ({ type: projection, domain: domain, inset: inset, insetTop: insetTop = inset !== undefined ? inset : insetTop, insetRight: insetRight = inset !== undefined ? inset : insetRight, insetBottom: insetBottom = inset !== undefined ? inset : insetBottom, insetLeft: insetLeft = inset !== undefined ? inset : insetLeft, clip: clip = clip, ...options } = projection);
        if (projection == null) return;
    }
    // For named projections, retrieve the corresponding projection initializer.
    if (typeof projection !== "function") ({ type: projection } = $0b574e6ffdcb6f7c$var$namedProjection(projection));
    // Compute the frame dimensions and invoke the projection initializer.
    const { width: width, height: height, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, marginBottom: marginBottom } = dimensions;
    const dx = width - marginLeft - marginRight - insetLeft - insetRight;
    const dy = height - marginTop - marginBottom - insetTop - insetBottom;
    projection = projection?.({
        width: dx,
        height: dy,
        clip: clip,
        ...options
    });
    // The projection initializer might decide to not use a projection.
    if (projection == null) return;
    clip = $0b574e6ffdcb6f7c$var$maybePostClip(clip, marginLeft, marginTop, width - marginRight, height - marginBottom);
    // Translate the origin to the top-left corner, respecting margins and insets.
    let tx = marginLeft + insetLeft;
    let ty = marginTop + insetTop;
    let transform;
    // If a domain is specified, fit the projection to the frame.
    if (domain != null) {
        const [[x0, y0], [x1, y1]] = (0, $58c46562f4a8d739$export$2e2bcd8739ae039)(projection).bounds(domain);
        const k = Math.min(dx / (x1 - x0), dy / (y1 - y0));
        if (k > 0) {
            tx -= (k * (x0 + x1) - dx) / 2;
            ty -= (k * (y0 + y1) - dy) / 2;
            transform = (0, $0412b2d170387dff$export$2e2bcd8739ae039)({
                point (x, y) {
                    this.stream.point(x * k + tx, y * k + ty);
                }
            });
        } else (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the projection could not be fit to the specified domain; using the default scale.`);
    }
    transform ??= tx === 0 && ty === 0 ? $0b574e6ffdcb6f7c$var$identity() : (0, $0412b2d170387dff$export$2e2bcd8739ae039)({
        point (x, y) {
            this.stream.point(x + tx, y + ty);
        }
    });
    return {
        stream: (s)=>projection.stream(transform.stream(clip(s)))
    };
}
function $0b574e6ffdcb6f7c$var$namedProjection(projection) {
    switch(`${projection}`.toLowerCase()){
        case "albers-usa":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $dae3a16b5ba78504$export$2e2bcd8739ae039), 0.7463, 0.4673);
        case "albers":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $189dcd4c41cb3d8a$export$2e2bcd8739ae039), 0.7463, 0.4673);
        case "azimuthal-equal-area":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $cde1dad42250dd7d$export$2e2bcd8739ae039), 4, 4);
        case "azimuthal-equidistant":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $7a9894a70b3e10e2$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        case "conic-conformal":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $c71ea640260518ba$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        case "conic-equal-area":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $be3cbe5874066802$export$2e2bcd8739ae039), 6.1702, 2.9781);
        case "conic-equidistant":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $d8f5b846585bb1cd$export$2e2bcd8739ae039), 7.312, 3.6282);
        case "equal-earth":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $fc041bd5ad9011bc$export$2e2bcd8739ae039), 5.4133, 2.6347);
        case "equirectangular":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $b150c6d84b26cddf$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$pi);
        case "gnomonic":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $ec357a35bfb88504$export$2e2bcd8739ae039), 3.4641, 3.4641);
        case "identity":
            return {
                type: $0b574e6ffdcb6f7c$var$identity
            };
        case "reflect-y":
            return {
                type: $0b574e6ffdcb6f7c$var$reflectY
            };
        case "mercator":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $ff090f04ba81e8e2$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        case "orthographic":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $5bed72effbe81a9c$export$2e2bcd8739ae039), 2, 2);
        case "stereographic":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $30512e786dc906d9$export$2e2bcd8739ae039), 2, 2);
        case "transverse-mercator":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $75766842dfa94e14$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        default:
            throw new Error(`unknown projection type: ${projection}`);
    }
}
function $0b574e6ffdcb6f7c$var$maybePostClip(clip, x1, y1, x2, y2) {
    if (clip === false || clip == null || typeof clip === "number") return (s)=>s;
    if (clip === true) clip = "frame";
    switch(`${clip}`.toLowerCase()){
        case "frame":
            return (0, $7d62d240b7fd88a7$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        default:
            throw new Error(`unknown projection clip type: ${clip}`);
    }
}
function $0b574e6ffdcb6f7c$var$scaleProjection(createProjection, kx, ky) {
    return {
        type: ({ width: width, height: height, rotate: rotate, precision: precision = 0.15, clip: clip })=>{
            const projection = createProjection();
            if (precision != null) projection.precision?.(precision);
            if (rotate != null) projection.rotate?.(rotate);
            if (typeof clip === "number") projection.clipAngle?.(clip);
            if (width != null) {
                projection.scale(Math.min(width / kx, height / ky));
                projection.translate([
                    width / 2,
                    height / 2
                ]);
            }
            return projection;
        },
        aspectRatio: ky / kx
    };
}
function $0b574e6ffdcb6f7c$var$conicProjection(createProjection, kx, ky) {
    const { type: type, aspectRatio: aspectRatio } = $0b574e6ffdcb6f7c$var$scaleProjection(createProjection, kx, ky);
    return {
        type: (options)=>{
            const { parallels: parallels, domain: domain, width: width, height: height } = options;
            const projection = type(options);
            if (parallels != null) {
                projection.parallels(parallels);
                if (domain === undefined && width != null) projection.fitSize([
                    width,
                    height
                ], {
                    type: "Sphere"
                });
            }
            return projection;
        },
        aspectRatio: aspectRatio
    };
}
const $0b574e6ffdcb6f7c$var$identity = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)({
    stream: (stream)=>stream
});
const $0b574e6ffdcb6f7c$var$reflectY = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)((0, $0412b2d170387dff$export$2e2bcd8739ae039)({
    point (x, y) {
        this.stream.point(x, -y);
    }
}));
function $0b574e6ffdcb6f7c$export$ab03b6763ed7026f(cx, cy, values, projection) {
    const x = values[cx];
    const y = values[cy];
    const n = x.length;
    const X = values[cx] = new Float64Array(n).fill(NaN);
    const Y = values[cy] = new Float64Array(n).fill(NaN);
    let i;
    const stream = projection.stream({
        point (x, y) {
            X[i] = x;
            Y[i] = y;
        }
    });
    for(i = 0; i < n; ++i)stream.point(x[i], y[i]);
}
function $0b574e6ffdcb6f7c$export$a364b560a2a07d35({ projection: projection } = {}) {
    if (projection == null) return false;
    if (typeof projection.stream === "function") return true;
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(projection)) projection = projection.type;
    return projection != null;
}
function $0b574e6ffdcb6f7c$export$9bd1d82590468035(projection) {
    if (typeof projection?.stream === "function") return $0b574e6ffdcb6f7c$var$defaultAspectRatio;
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(projection)) {
        let domain, options;
        ({ domain: domain, type: projection, ...options } = projection);
        if (domain != null && projection != null) {
            const type = typeof projection === "string" ? $0b574e6ffdcb6f7c$var$namedProjection(projection).type : projection;
            const [[x0, y0], [x1, y1]] = (0, $58c46562f4a8d739$export$2e2bcd8739ae039)(type({
                ...options,
                width: 100,
                height: 100
            })).bounds(domain);
            const r = (y1 - y0) / (x1 - x0);
            return r && isFinite(r) ? r < 0.2 ? 0.2 : r > 5 ? 5 : r : $0b574e6ffdcb6f7c$var$defaultAspectRatio;
        }
    }
    if (projection == null) return;
    if (typeof projection !== "function") {
        const { aspectRatio: aspectRatio } = $0b574e6ffdcb6f7c$var$namedProjection(projection);
        if (aspectRatio) return aspectRatio;
    }
    return $0b574e6ffdcb6f7c$var$defaultAspectRatio;
}
function $0b574e6ffdcb6f7c$export$6688ad6aa07debf2(channels, scales, { projection: projection }) {
    const { x: x, y: y } = channels;
    let position = {};
    if (x) position.x = x;
    if (y) position.y = y;
    position = (0, $6eb5f337b2493843$export$9df10f3a4586f4ff)(position, scales);
    if (projection && x?.scale === "x" && y?.scale === "y") $0b574e6ffdcb6f7c$export$ab03b6763ed7026f("x", "y", position, projection);
    if (x) position.x = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(position.x);
    if (y) position.y = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(position.y);
    return position;
}
function $0b574e6ffdcb6f7c$export$b3eb7247b89a6856(channel) {
    const X = [];
    const Y = [];
    const x = {
        scale: "x",
        value: X
    };
    const y = {
        scale: "y",
        value: Y
    };
    const sink = {
        point (x, y) {
            X.push(x);
            Y.push(y);
        },
        lineStart () {},
        lineEnd () {},
        polygonStart () {},
        polygonEnd () {},
        sphere () {}
    };
    for (const object of channel.value)(0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, sink);
    return [
        x,
        y
    ];
}





function $871355576fc3efd9$export$fd42f52fd3ae1109(options = {}) {
    const { document: document = typeof window !== "undefined" ? window.document : undefined, clip: clip } = options;
    return {
        document: document,
        clip: (0, $cd9e805a4bbd13f9$export$1920f6ea06533ca7)(clip)
    };
}
function $871355576fc3efd9$export$185802fd694ee1f5(name, { document: document }) {
    return (0, $cf81072cf307ee25$export$2e2bcd8739ae039)((0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name).call(document.documentElement));
}



function $cb17f3275e1ef5a0$export$2e2bcd8739ae039(date, fallback) {
    if (!(date instanceof Date)) date = new Date(+date);
    if (isNaN(date)) return typeof fallback === "function" ? fallback(date) : fallback;
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const milliseconds = date.getUTCMilliseconds();
    return `${$cb17f3275e1ef5a0$var$formatYear(date.getUTCFullYear(), 4)}-${$cb17f3275e1ef5a0$var$pad(date.getUTCMonth() + 1, 2)}-${$cb17f3275e1ef5a0$var$pad(date.getUTCDate(), 2)}${hours || minutes || seconds || milliseconds ? `T${$cb17f3275e1ef5a0$var$pad(hours, 2)}:${$cb17f3275e1ef5a0$var$pad(minutes, 2)}${seconds || milliseconds ? `:${$cb17f3275e1ef5a0$var$pad(seconds, 2)}${milliseconds ? `.${$cb17f3275e1ef5a0$var$pad(milliseconds, 3)}` : ``}` : ``}Z` : ``}`;
}
function $cb17f3275e1ef5a0$var$formatYear(year) {
    return year < 0 ? `-${$cb17f3275e1ef5a0$var$pad(-year, 6)}` : year > 9999 ? `+${$cb17f3275e1ef5a0$var$pad(year, 6)}` : $cb17f3275e1ef5a0$var$pad(year, 4);
}
function $cb17f3275e1ef5a0$var$pad(value, width) {
    return `${value}`.padStart(width, "0");
}



const $d18c56c98d932ebe$export$294553a3f9ed16dc = Symbol("unset");
function $d18c56c98d932ebe$export$7a9bd61063bd9325(compute) {
    return (compute.length === 1 ? $d18c56c98d932ebe$var$memoize1Arg : $d18c56c98d932ebe$var$memoize1Args)(compute);
}
function $d18c56c98d932ebe$var$memoize1Arg(compute) {
    let cacheValue;
    let cacheKey = $d18c56c98d932ebe$export$294553a3f9ed16dc;
    return (key)=>{
        if (!Object.is(cacheKey, key)) {
            cacheKey = key;
            cacheValue = compute(key);
        }
        return cacheValue;
    };
}
function $d18c56c98d932ebe$var$memoize1Args(compute) {
    let cacheValue, cacheKeys;
    return (...keys)=>{
        if (cacheKeys?.length !== keys.length || cacheKeys.some((k, i)=>!Object.is(k, keys[i]))) {
            cacheKeys = keys;
            cacheValue = compute(...keys);
        }
        return cacheValue;
    };
}


const $4b16c4377cd1e2de$var$numberFormat = (0, $d18c56c98d932ebe$export$7a9bd61063bd9325)((locale)=>{
    return new Intl.NumberFormat(locale);
});
const $4b16c4377cd1e2de$var$monthFormat = (0, $d18c56c98d932ebe$export$7a9bd61063bd9325)((locale, month)=>{
    return new Intl.DateTimeFormat(locale, {
        timeZone: "UTC",
        ...month && {
            month: month
        }
    });
});
const $4b16c4377cd1e2de$var$weekdayFormat = (0, $d18c56c98d932ebe$export$7a9bd61063bd9325)((locale, weekday)=>{
    return new Intl.DateTimeFormat(locale, {
        timeZone: "UTC",
        ...weekday && {
            weekday: weekday
        }
    });
});
function $4b16c4377cd1e2de$export$f5dd818bff069720(locale = "en-US") {
    const format = $4b16c4377cd1e2de$var$numberFormat(locale);
    return (i)=>i != null && !isNaN(i) ? format.format(i) : undefined;
}
function $4b16c4377cd1e2de$export$d0536c8e7f45796e(locale = "en-US", format = "short") {
    const fmt = $4b16c4377cd1e2de$var$monthFormat(locale, format);
    return (i)=>i != null && !isNaN(i = +new Date(Date.UTC(2000, +i))) ? fmt.format(i) : undefined;
}
function $4b16c4377cd1e2de$export$407180b957f39d7e(locale = "en-US", format = "short") {
    const fmt = $4b16c4377cd1e2de$var$weekdayFormat(locale, format);
    return (i)=>i != null && !isNaN(i = +new Date(Date.UTC(2001, 0, +i))) ? fmt.format(i) : undefined;
}
function $4b16c4377cd1e2de$export$1431bc52824a265(date) {
    return (0, $cb17f3275e1ef5a0$export$2e2bcd8739ae039)(date, "Invalid Date");
}
function $4b16c4377cd1e2de$export$f8e35388847b8492(locale = "en-US") {
    const number = $4b16c4377cd1e2de$export$f5dd818bff069720(locale);
    return (v)=>(v instanceof Date ? $4b16c4377cd1e2de$export$1431bc52824a265 : typeof v === "number" ? number : (0, $cd9e805a4bbd13f9$export$22b082955e083ec3))(v);
}
const $4b16c4377cd1e2de$export$bb457229db2006fb = $4b16c4377cd1e2de$export$f8e35388847b8492();




const $547e5698440387a8$export$cc800923e997bb8 = (typeof window !== "undefined" ? window.devicePixelRatio > 1 : typeof it === "undefined") ? 0 : 0.5; // prettier-ignore
let $547e5698440387a8$var$nextClipId = 0;
let $547e5698440387a8$var$nextPatternId = 0;
function $547e5698440387a8$export$3944aa75e0f0f740() {
    return `plot-clip-${++$547e5698440387a8$var$nextClipId}`;
}
function $547e5698440387a8$export$451bad7e68de949e() {
    return `plot-pattern-${++$547e5698440387a8$var$nextPatternId}`;
}
function $547e5698440387a8$export$9dd6ff9ea0189349(mark, { title: title, href: href, ariaLabel: variaLabel, ariaDescription: ariaDescription, ariaHidden: ariaHidden, target: target, fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, strokeLinejoin: strokeLinejoin, strokeLinecap: strokeLinecap, strokeMiterlimit: strokeMiterlimit, strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset, opacity: opacity, mixBlendMode: mixBlendMode, imageFilter: imageFilter, paintOrder: paintOrder, pointerEvents: pointerEvents, shapeRendering: shapeRendering, channels: channels }, { ariaLabel: cariaLabel, fill: defaultFill = "currentColor", fillOpacity: defaultFillOpacity, stroke: defaultStroke = "none", strokeOpacity: defaultStrokeOpacity, strokeWidth: defaultStrokeWidth, strokeLinecap: defaultStrokeLinecap, strokeLinejoin: defaultStrokeLinejoin, strokeMiterlimit: defaultStrokeMiterlimit, paintOrder: defaultPaintOrder }) {
    // Some marks don’t support fill (e.g., tick and rule).
    if (defaultFill === null) {
        fill = null;
        fillOpacity = null;
    }
    // Some marks don’t support stroke (e.g., image).
    if (defaultStroke === null) {
        stroke = null;
        strokeOpacity = null;
    }
    // Some marks default to fill with no stroke, while others default to stroke
    // with no fill. For example, bar and area default to fill, while dot and line
    // default to stroke. For marks that fill by default, the default fill only
    // applies if the stroke is (constant) none; if you set a stroke, then the
    // default fill becomes none. Similarly for marks that stroke by stroke, the
    // default stroke only applies if the fill is (constant) none.
    if ((0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(defaultFill)) {
        if (!(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(defaultStroke) && (!(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) || channels?.fill)) defaultStroke = "none";
    } else if ((0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(defaultStroke) && (!(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(stroke) || channels?.stroke)) defaultFill = "none";
    const [vfill, cfill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill, defaultFill);
    const [vfillOpacity, cfillOpacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(fillOpacity, defaultFillOpacity);
    const [vstroke, cstroke] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke, defaultStroke);
    const [vstrokeOpacity, cstrokeOpacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeOpacity, defaultStrokeOpacity);
    const [vopacity, copacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(opacity);
    // For styles that have no effect if there is no stroke, only apply the
    // defaults if the stroke is not the constant none. (If stroke is a channel,
    // then cstroke will be undefined, but there’s still a stroke; hence we don’t
    // use isNoneish here.)
    if (!(0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(cstroke)) {
        if (strokeWidth === undefined) strokeWidth = defaultStrokeWidth;
        if (strokeLinecap === undefined) strokeLinecap = defaultStrokeLinecap;
        if (strokeLinejoin === undefined) strokeLinejoin = defaultStrokeLinejoin;
        // The default stroke miterlimit need not be applied if the current stroke
        // is the constant round; this only has effect on miter joins.
        if (strokeMiterlimit === undefined && !(0, $cd9e805a4bbd13f9$export$e2647994a9b8277a)(strokeLinejoin)) strokeMiterlimit = defaultStrokeMiterlimit;
        // The paint order only takes effect if there is both a fill and a stroke
        // (at least if we ignore markers, which no built-in marks currently use).
        if (!(0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(cfill) && paintOrder === undefined) paintOrder = defaultPaintOrder;
    }
    const [vstrokeWidth, cstrokeWidth] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeWidth);
    // Some marks don’t support fill (e.g., tick and rule).
    if (defaultFill !== null) {
        mark.fill = $547e5698440387a8$export$e1c487990851f09f(cfill, "currentColor");
        mark.fillOpacity = $547e5698440387a8$export$1db7b3628ce7c301(cfillOpacity, 1);
    }
    // Some marks don’t support stroke (e.g., image).
    if (defaultStroke !== null) {
        mark.stroke = $547e5698440387a8$export$e1c487990851f09f(cstroke, "none");
        mark.strokeWidth = $547e5698440387a8$export$1db7b3628ce7c301(cstrokeWidth, 1);
        mark.strokeOpacity = $547e5698440387a8$export$1db7b3628ce7c301(cstrokeOpacity, 1);
        mark.strokeLinejoin = $547e5698440387a8$export$e1c487990851f09f(strokeLinejoin, "miter");
        mark.strokeLinecap = $547e5698440387a8$export$e1c487990851f09f(strokeLinecap, "butt");
        mark.strokeMiterlimit = $547e5698440387a8$export$1db7b3628ce7c301(strokeMiterlimit, 4);
        mark.strokeDasharray = $547e5698440387a8$export$e1c487990851f09f(strokeDasharray, "none");
        mark.strokeDashoffset = $547e5698440387a8$export$e1c487990851f09f(strokeDashoffset, "0");
    }
    mark.target = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(target);
    mark.ariaLabel = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(cariaLabel);
    mark.ariaDescription = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(ariaDescription);
    mark.ariaHidden = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(ariaHidden);
    mark.opacity = $547e5698440387a8$export$1db7b3628ce7c301(copacity, 1);
    mark.mixBlendMode = $547e5698440387a8$export$e1c487990851f09f(mixBlendMode, "normal");
    mark.imageFilter = $547e5698440387a8$export$e1c487990851f09f(imageFilter, "none");
    mark.paintOrder = $547e5698440387a8$export$e1c487990851f09f(paintOrder, "normal");
    mark.pointerEvents = $547e5698440387a8$export$e1c487990851f09f(pointerEvents, "auto");
    mark.shapeRendering = $547e5698440387a8$export$e1c487990851f09f(shapeRendering, "auto");
    return {
        title: {
            value: title,
            optional: true,
            filter: null
        },
        href: {
            value: href,
            optional: true,
            filter: null
        },
        ariaLabel: {
            value: variaLabel,
            optional: true,
            filter: null
        },
        fill: {
            value: vfill,
            scale: "auto",
            optional: true
        },
        fillOpacity: {
            value: vfillOpacity,
            scale: "auto",
            optional: true
        },
        stroke: {
            value: vstroke,
            scale: "auto",
            optional: true
        },
        strokeOpacity: {
            value: vstrokeOpacity,
            scale: "auto",
            optional: true
        },
        strokeWidth: {
            value: vstrokeWidth,
            optional: true
        },
        opacity: {
            value: vopacity,
            scale: "auto",
            optional: true
        }
    };
}
function $547e5698440387a8$export$15b4cd30900b219a(selection, L) {
    if (L) selection.filter((i)=>(0, $0f3e37548c3914c7$export$6ce6c9218151d511)(L[i])).append("title").call($547e5698440387a8$export$539290aca48c3ba8, L);
}
function $547e5698440387a8$export$1a6f5a923ffc407(selection, L) {
    if (L) selection.filter(([i])=>(0, $0f3e37548c3914c7$export$6ce6c9218151d511)(L[i])).append("title").call($547e5698440387a8$export$c9237586da8aa924, L);
}
function $547e5698440387a8$export$539290aca48c3ba8(selection, T) {
    if (T) selection.text((i)=>(0, $4b16c4377cd1e2de$export$bb457229db2006fb)(T[i]));
}
function $547e5698440387a8$export$c9237586da8aa924(selection, T) {
    if (T) selection.text(([i])=>(0, $4b16c4377cd1e2de$export$bb457229db2006fb)(T[i]));
}
function $547e5698440387a8$export$43a1bc6cf61126e3(selection, { target: target, tip: tip }, { ariaLabel: AL, title: T, fill: F, fillOpacity: FO, stroke: S, strokeOpacity: SO, strokeWidth: SW, opacity: O, href: H }) {
    if (AL) $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-label", (i)=>AL[i]);
    if (F) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill", (i)=>F[i]);
    if (FO) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill-opacity", (i)=>FO[i]);
    if (S) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke", (i)=>S[i]);
    if (SO) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-opacity", (i)=>SO[i]);
    if (SW) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-width", (i)=>SW[i]);
    if (O) $547e5698440387a8$export$47765c6b16054eb2(selection, "opacity", (i)=>O[i]);
    if (H) $547e5698440387a8$var$applyHref(selection, (i)=>H[i], target);
    if (!tip) $547e5698440387a8$export$15b4cd30900b219a(selection, T);
}
function $547e5698440387a8$export$ddd674e1b6498f54(selection, { target: target, tip: tip }, { ariaLabel: AL, title: T, fill: F, fillOpacity: FO, stroke: S, strokeOpacity: SO, strokeWidth: SW, opacity: O, href: H }) {
    if (AL) $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-label", ([i])=>AL[i]);
    if (F) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill", ([i])=>F[i]);
    if (FO) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill-opacity", ([i])=>FO[i]);
    if (S) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke", ([i])=>S[i]);
    if (SO) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-opacity", ([i])=>SO[i]);
    if (SW) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-width", ([i])=>SW[i]);
    if (O) $547e5698440387a8$export$47765c6b16054eb2(selection, "opacity", ([i])=>O[i]);
    if (H) $547e5698440387a8$var$applyHref(selection, ([i])=>H[i], target);
    if (!tip) $547e5698440387a8$export$1a6f5a923ffc407(selection, T);
}
function $547e5698440387a8$var$groupAesthetics({ ariaLabel: AL, title: T, fill: F, fillOpacity: FO, stroke: S, strokeOpacity: SO, strokeWidth: SW, opacity: O, href: H }, { tip: tip }) {
    return [
        AL,
        tip ? undefined : T,
        F,
        FO,
        S,
        SO,
        SW,
        O,
        H
    ].filter((c)=>c !== undefined);
}
function $547e5698440387a8$export$ae9fea6755af6637(I, Z, z) {
    const G = (0, $6f0c14a1378d16c1$export$2e2bcd8739ae039)(I, (i)=>Z[i]);
    if (z === undefined && G.size > 1 + I.length >> 1) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the implicit z channel has high cardinality. This may occur when the fill or stroke channel is associated with quantitative data rather than ordinal or categorical data. You can suppress this warning by setting the z option explicitly; if this data represents a single series, set z to null.`);
    return G.values();
}
function* $547e5698440387a8$export$33c8ab41edf38638(I, position, mark, channels) {
    const { z: z } = mark;
    const { z: Z } = channels; // group channel
    const A = $547e5698440387a8$var$groupAesthetics(channels, mark); // aesthetic channels
    const C = [
        ...position,
        ...A
    ]; // all channels
    // Group the current index by Z (if any).
    for (const G of Z ? $547e5698440387a8$export$ae9fea6755af6637(I, Z, z) : [
        I
    ]){
        let Ag; // the A-values (aesthetics) of the current group, if any
        let Gg; // the current group index (a subset of G, and I), if any
        out: for (const i of G){
            // If any channel has an undefined value for this index, skip it.
            for (const c of C)if (!(0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97)(c[i])) {
                if (Gg) Gg.push(-1);
                continue out;
            }
            // Otherwise, if this is a new group, record the aesthetics for this
            // group. Yield the current group and start a new one.
            if (Ag === undefined) {
                if (Gg) yield Gg;
                Ag = A.map((c)=>(0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(c[i])), Gg = [
                    i
                ];
                continue;
            }
            // Otherwise, add the current index to the current group. Then, if any of
            // the aesthetics don’t match the current group, yield the current group
            // and start a new group of the current index.
            Gg.push(i);
            for(let j = 0; j < A.length; ++j){
                const k = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(A[j][i]);
                if (k !== Ag[j]) {
                    yield Gg;
                    Ag = A.map((c)=>(0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(c[i])), Gg = [
                        i
                    ];
                    continue out;
                }
            }
        }
        // Yield the current group, if any.
        if (Gg) yield Gg;
    }
}
// Note: may mutate selection.node!
function $547e5698440387a8$var$applyClip(selection, mark, dimensions, context) {
    let clipUrl;
    const { clip: clip = context.clip } = mark;
    switch(clip){
        case "frame":
            // Wrap the G element with another (untransformed) G element, applying the
            // clip to the parent G element so that the clip path is not affected by
            // the mark’s transform. To simplify the adoption of this fix, mutate the
            // passed-in selection.node to return the parent G element.
            selection = (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).each(function() {
                this.appendChild(selection.node());
                selection.node = ()=>this; // Note: mutation!
            });
            clipUrl = $547e5698440387a8$var$getFrameClip(context, dimensions);
            break;
        case "sphere":
            clipUrl = $547e5698440387a8$var$getProjectionClip(context);
            break;
    }
    // Here we’re careful to apply the ARIA attributes to the outer G element when
    // clipping is applied, and to apply the ARIA attributes before any other
    // attributes (for readability).
    $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-label", mark.ariaLabel);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-description", mark.ariaDescription);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-hidden", mark.ariaHidden);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "clip-path", clipUrl);
}
function $547e5698440387a8$var$memoizeClip(clip) {
    const cache = new WeakMap();
    return (context, dimensions)=>{
        let url = cache.get(context);
        if (!url) {
            const id = $547e5698440387a8$export$3944aa75e0f0f740();
            (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(context.ownerSVGElement).append("clipPath").attr("id", id).call(clip, context, dimensions);
            cache.set(context, url = `url(#${id})`);
        }
        return url;
    };
}
const $547e5698440387a8$var$getFrameClip = $547e5698440387a8$var$memoizeClip((clipPath, context, dimensions)=>{
    const { width: width, height: height, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, marginBottom: marginBottom } = dimensions;
    clipPath.append("rect").attr("x", marginLeft).attr("y", marginTop).attr("width", width - marginRight - marginLeft).attr("height", height - marginTop - marginBottom);
});
const $547e5698440387a8$var$getProjectionClip = $547e5698440387a8$var$memoizeClip((clipPath, context)=>{
    const { projection: projection } = context;
    if (!projection) throw new Error(`the "sphere" clip option requires a projection`);
    clipPath.append("path").attr("d", (0, $58c46562f4a8d739$export$2e2bcd8739ae039)(projection)({
        type: "Sphere"
    }));
});
function $547e5698440387a8$export$b9ed040f258dd66e(selection, mark, dimensions, context) {
    $547e5698440387a8$var$applyClip(selection, mark, dimensions, context);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "class", mark.className);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "fill", mark.fill);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "fill-opacity", mark.fillOpacity);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke", mark.stroke);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-width", mark.strokeWidth);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-opacity", mark.strokeOpacity);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-linejoin", mark.strokeLinejoin);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-linecap", mark.strokeLinecap);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-miterlimit", mark.strokeMiterlimit);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-dasharray", mark.strokeDasharray);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-dashoffset", mark.strokeDashoffset);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "shape-rendering", mark.shapeRendering);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "filter", mark.imageFilter);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "paint-order", mark.paintOrder);
    const { pointerEvents: pointerEvents = context.pointerSticky === false ? "none" : undefined } = mark;
    $547e5698440387a8$export$47765c6b16054eb2(selection, "pointer-events", pointerEvents);
}
function $547e5698440387a8$export$2949c2472f804203(selection, mark) {
    $547e5698440387a8$export$d63a6b7859608045(selection, "mix-blend-mode", mark.mixBlendMode);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "opacity", mark.opacity);
}
function $547e5698440387a8$var$applyHref(selection, href, target) {
    selection.each(function(i) {
        const h = href(i);
        if (h != null) {
            const a = this.ownerDocument.createElementNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).svg, "a");
            a.setAttribute("fill", "inherit");
            a.setAttributeNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).xlink, "href", h);
            if (target != null) a.setAttribute("target", target);
            this.parentNode.insertBefore(a, this).appendChild(this);
        }
    });
}
function $547e5698440387a8$export$47765c6b16054eb2(selection, name, value) {
    if (value != null) selection.attr(name, value);
}
function $547e5698440387a8$export$d63a6b7859608045(selection, name, value) {
    if (value != null) selection.style(name, value);
}
function $547e5698440387a8$export$9f9dcb98c894b623(selection, mark, { x: x, y: y }, tx = $547e5698440387a8$export$cc800923e997bb8, ty = $547e5698440387a8$export$cc800923e997bb8) {
    tx += mark.dx;
    ty += mark.dy;
    if (x?.bandwidth) tx += x.bandwidth() / 2;
    if (y?.bandwidth) ty += y.bandwidth() / 2;
    if (tx || ty) selection.attr("transform", `translate(${tx},${ty})`);
}
function $547e5698440387a8$export$e1c487990851f09f(value, impliedValue) {
    if ((value = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(value)) !== impliedValue) return value;
}
function $547e5698440387a8$export$1db7b3628ce7c301(value, impliedValue) {
    if ((value = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(value)) !== impliedValue) return value;
}
// https://www.w3.org/TR/CSS21/grammar.html
const $547e5698440387a8$var$validClassName = /^-?([_a-z]|[\240-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])([_a-z0-9-]|[\240-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])*$/i;
function $547e5698440387a8$export$22300e6eaecca37(name) {
    // The default should be changed whenever the default styles are changed, so
    // as to avoid conflict when multiple versions of Plot are on the page.
    if (name === undefined) return "plot-d6a7b5";
    name = `${name}`;
    if (!$547e5698440387a8$var$validClassName.test(name)) throw new Error(`invalid class name: ${name}`);
    return name;
}
function $547e5698440387a8$export$4e6c5cc1af44143e(selection, style) {
    if (typeof style === "string") selection.property("style", style);
    else if (style != null) for (const element of selection)Object.assign(element.style, style);
}
function $547e5698440387a8$export$867c1a80005e0d82({ frameAnchor: frameAnchor }, { width: width, height: height, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft }) {
    return [
        /left$/.test(frameAnchor) ? marginLeft : /right$/.test(frameAnchor) ? width - marginRight : (marginLeft + width - marginRight) / 2,
        /^top/.test(frameAnchor) ? marginTop : /^bottom/.test(frameAnchor) ? height - marginBottom : (marginTop + height - marginBottom) / 2
    ];
}



class $24d8c38d667d16c2$export$c9d15bcfc6d42044 {
    constructor(data, channels = {}, options = {}, defaults){
        const { facet: facet = "auto", facetAnchor: facetAnchor, fx: fx, fy: fy, sort: sort, dx: dx = 0, dy: dy = 0, margin: margin = 0, marginTop: marginTop = margin, marginRight: marginRight = margin, marginBottom: marginBottom = margin, marginLeft: marginLeft = margin, className: className, clip: clip = defaults?.clip, channels: extraChannels, tip: tip, render: render } = options;
        this.data = data;
        this.sort = (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null;
        this.initializer = (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)(options).initializer;
        this.transform = this.initializer ? options.transform : (0, $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options).transform;
        if (facet === null || facet === false) this.facet = null;
        else {
            this.facet = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(facet === true ? "include" : facet, "facet", [
                "auto",
                "include",
                "exclude",
                "super"
            ]);
            this.fx = data === (0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9) && typeof fx === "string" ? [
                fx
            ] : fx;
            this.fy = data === (0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9) && typeof fy === "string" ? [
                fy
            ] : fy;
        }
        this.facetAnchor = (0, $a6069a9074a3d58d$export$598b026809f23ca0)(facetAnchor);
        channels = (0, $cd9e805a4bbd13f9$export$b221e5d053773f17)(channels);
        if (extraChannels !== undefined) channels = {
            ...$24d8c38d667d16c2$var$maybeChannels(extraChannels),
            ...channels
        };
        if (defaults !== undefined) channels = {
            ...(0, $547e5698440387a8$export$9dd6ff9ea0189349)(this, options, defaults),
            ...channels
        };
        this.channels = Object.fromEntries(Object.entries(channels).map(([name, channel])=>{
            if ((0, $cd9e805a4bbd13f9$export$dae3322343de7d27)(channel.value)) {
                // apply scale and label overrides
                const { value: value, label: label = channel.label, scale: scale = channel.scale } = channel.value;
                channel = {
                    ...channel,
                    label: label,
                    scale: scale,
                    value: value
                };
            }
            if (data === (0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9) && typeof channel.value === "string") {
                // convert field names to singleton values for decoration marks (e.g., frame)
                const { value: value } = channel;
                channel = {
                    ...channel,
                    value: [
                        value
                    ]
                };
            }
            return [
                name,
                channel
            ];
        }).filter(([name, { value: value, optional: optional }])=>{
            if (value != null) return true;
            if (optional) return false;
            throw new Error(`missing channel value: ${name}`);
        }));
        this.dx = +dx;
        this.dy = +dy;
        this.marginTop = +marginTop;
        this.marginRight = +marginRight;
        this.marginBottom = +marginBottom;
        this.marginLeft = +marginLeft;
        this.clip = (0, $cd9e805a4bbd13f9$export$1920f6ea06533ca7)(clip);
        this.tip = $24d8c38d667d16c2$var$maybeTip(tip);
        this.className = className ? (0, $547e5698440387a8$export$22300e6eaecca37)(className) : null;
        // Super-faceting currently disallow position channels; in the future, we
        // could allow position to be specified in fx and fy in addition to (or
        // instead of) x and y.
        if (this.facet === "super") {
            if (fx || fy) throw new Error(`super-faceting cannot use fx or fy`);
            for(const name in this.channels){
                const { scale: scale } = channels[name];
                if (scale !== "x" && scale !== "y") continue;
                throw new Error(`super-faceting cannot use x or y`);
            }
        }
        if (render != null) this.render = $24d8c38d667d16c2$export$b80642eda489f786(render, this.render);
    }
    initialize(facets, facetChannels, plotOptions) {
        let data = (0, $cd9e805a4bbd13f9$export$73f73ccd44b2553f)(this.data);
        if (facets === undefined && data != null) facets = [
            (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data)
        ];
        const originalFacets = facets;
        if (this.transform != null) ({ facets: facets, data: data } = this.transform(data, facets, plotOptions)), data = (0, $cd9e805a4bbd13f9$export$73f73ccd44b2553f)(data);
        if (facets !== undefined) facets.original = originalFacets; // needed to read facetChannels
        const channels = (0, $6eb5f337b2493843$export$422e7cd65ac5d2cf)(this.channels, data);
        if (this.sort != null) (0, $6eb5f337b2493843$export$334f2e4e1c2a6aef)(data, facets, channels, facetChannels, this.sort); // mutates facetChannels!
        return {
            data: data,
            facets: facets,
            channels: channels
        };
    }
    filter(index, channels, values) {
        for(const name in channels){
            const { filter: filter = (0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97) } = channels[name];
            if (filter !== null) {
                const value = values[name];
                index = index.filter((i)=>filter(value[i]));
            }
        }
        return index;
    }
    // If there is a projection, and there are paired x and y channels associated
    // with the x and y scale respectively (and not already in screen coordinates
    // as with an initializer), then apply the projection, replacing the x and y
    // values. Note that the x and y scales themselves don’t exist if there is a
    // projection, but whether the channels are associated with scales still
    // determines whether the projection should apply; think of the projection as
    // a combination xy-scale.
    project(channels, values, context) {
        for(const cx in channels)if (channels[cx].scale === "x" && /^x|x$/.test(cx)) {
            const cy = cx.replace(/^x|x$/, "y");
            if (cy in channels && channels[cy].scale === "y") (0, $0b574e6ffdcb6f7c$export$ab03b6763ed7026f)(cx, cy, values, context.projection);
        }
    }
    scale(channels, scales, context) {
        const values = (0, $6eb5f337b2493843$export$9df10f3a4586f4ff)(channels, scales);
        if (context.projection) this.project(channels, values, context);
        return values;
    }
}
function $24d8c38d667d16c2$export$3a8025f2f3e0c64(...marks1) {
    marks1.plot = $24d8c38d667d16c2$export$c9d15bcfc6d42044.prototype.plot;
    return marks1;
}
function $24d8c38d667d16c2$export$b80642eda489f786(r1, r2) {
    if (r1 == null) return r2 === null ? undefined : r2;
    if (r2 == null) return r1 === null ? undefined : r1;
    if (typeof r1 !== "function") throw new TypeError(`invalid render transform: ${r1}`);
    if (typeof r2 !== "function") throw new TypeError(`invalid render transform: ${r2}`);
    return function(i, s, v, d, c, next) {
        return r1.call(this, i, s, v, d, c, (i, s, v, d, c)=>{
            return r2.call(this, i, s, v, d, c, next); // preserve this
        });
    };
}
function $24d8c38d667d16c2$var$maybeChannels(channels) {
    return Object.fromEntries(Object.entries((0, $cd9e805a4bbd13f9$export$b221e5d053773f17)(channels)).map(([name, channel])=>{
        channel = typeof channel === "string" ? {
            value: channel,
            label: name
        } : (0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(channel); // for shorthand extra channels, use name as label
        if (channel.filter === undefined && channel.scale == null) channel = {
            ...channel,
            filter: null
        };
        return [
            name,
            channel
        ];
    }));
}
function $24d8c38d667d16c2$var$maybeTip(tip) {
    return tip === true ? "xy" : tip === false || tip == null ? null : typeof tip === "string" ? (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(tip, "tip", [
        "x",
        "y",
        "xy"
    ]) : tip; // tip options object
}
function $24d8c38d667d16c2$export$963b1143142dad19(options, pointer) {
    return options?.tip === true ? {
        ...options,
        tip: pointer
    } : (0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(options?.tip) && options.tip.pointer === undefined ? {
        ...options,
        tip: {
            ...options.tip,
            pointer: pointer
        }
    } : options;
}









function $c6491cb5712bafc0$export$8066c1b52b2e9504(scales, marks, options = {}) {
    // Compute the default margins: the maximum of the marks’ margins. While not
    // always used, they may be needed to compute the default height of the plot.
    let marginTopDefault = 0.5 - (0, $547e5698440387a8$export$cc800923e997bb8), marginRightDefault = 0.5 + (0, $547e5698440387a8$export$cc800923e997bb8), marginBottomDefault = 0.5 + (0, $547e5698440387a8$export$cc800923e997bb8), marginLeftDefault = 0.5 - (0, $547e5698440387a8$export$cc800923e997bb8);
    for (const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft } of marks){
        if (marginTop > marginTopDefault) marginTopDefault = marginTop;
        if (marginRight > marginRightDefault) marginRightDefault = marginRight;
        if (marginBottom > marginBottomDefault) marginBottomDefault = marginBottom;
        if (marginLeft > marginLeftDefault) marginLeftDefault = marginLeft;
    }
    // Compute the actual margins. The order of precedence is: the side-specific
    // margin options, then the global margin option, then the defaults.
    let { margin: margin, marginTop: marginTop = margin !== undefined ? margin : marginTopDefault, marginRight: marginRight = margin !== undefined ? margin : marginRightDefault, marginBottom: marginBottom = margin !== undefined ? margin : marginBottomDefault, marginLeft: marginLeft = margin !== undefined ? margin : marginLeftDefault } = options;
    // Coerce the margin options to numbers.
    marginTop = +marginTop;
    marginRight = +marginRight;
    marginBottom = +marginBottom;
    marginLeft = +marginLeft;
    // Compute the outer dimensions of the plot. If the top and bottom margins are
    // specified explicitly, adjust the automatic height accordingly.
    let { width: width = 640, height: height = $c6491cb5712bafc0$var$autoHeight(scales, options, {
        width: width,
        marginTopDefault: marginTopDefault,
        marginRightDefault: marginRightDefault,
        marginBottomDefault: marginBottomDefault,
        marginLeftDefault: marginLeftDefault
    }) + Math.max(0, marginTop - marginTopDefault + marginBottom - marginBottomDefault) } = options;
    // Coerce the width and height.
    width = +width;
    height = +height;
    const dimensions = {
        width: width,
        height: height,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft
    };
    // Compute the facet margins.
    if (scales.fx || scales.fy) {
        let { margin: facetMargin, marginTop: facetMarginTop = facetMargin !== undefined ? facetMargin : marginTop, marginRight: facetMarginRight = facetMargin !== undefined ? facetMargin : marginRight, marginBottom: facetMarginBottom = facetMargin !== undefined ? facetMargin : marginBottom, marginLeft: facetMarginLeft = facetMargin !== undefined ? facetMargin : marginLeft } = options.facet ?? {};
        // Coerce the facet margin options to numbers.
        facetMarginTop = +facetMarginTop;
        facetMarginRight = +facetMarginRight;
        facetMarginBottom = +facetMarginBottom;
        facetMarginLeft = +facetMarginLeft;
        dimensions.facet = {
            marginTop: facetMarginTop,
            marginRight: facetMarginRight,
            marginBottom: facetMarginBottom,
            marginLeft: facetMarginLeft
        };
    }
    return dimensions;
}
function $c6491cb5712bafc0$var$autoHeight({ x: x, y: y, fy: fy, fx: fx }, { projection: projection, aspectRatio: aspectRatio }, { width: width, marginTopDefault: marginTopDefault, marginRightDefault: marginRightDefault, marginBottomDefault: marginBottomDefault, marginLeftDefault: marginLeftDefault }) {
    const nfy = fy ? fy.scale.domain().length || 1 : 1;
    // If a projection is specified, compute an aspect ratio based on the domain,
    // defaulting to the projection’s natural aspect ratio (if known).
    const ar = (0, $0b574e6ffdcb6f7c$export$9bd1d82590468035)(projection);
    if (ar) {
        const nfx = fx ? fx.scale.domain().length : 1;
        const far = (1.1 * nfy - 0.1) / (1.1 * nfx - 0.1) * ar; // 0.1 is default facet padding
        const lar = Math.max(0.1, Math.min(10, far)); // clamp the aspect ratio to a “reasonable” value
        return Math.round((width - marginLeftDefault - marginRightDefault) * lar + marginTopDefault + marginBottomDefault);
    }
    const ny = y ? (0, $d2c16f7a6010a221$export$61579433626afe87)(y) ? y.scale.domain().length || 1 : Math.max(7, 17 / nfy) : 1;
    // If a desired aspect ratio is given, compute a default height to match.
    if (aspectRatio != null) {
        aspectRatio = +aspectRatio;
        if (!(isFinite(aspectRatio) && aspectRatio > 0)) throw new Error(`invalid aspectRatio: ${aspectRatio}`);
        const ratio = $c6491cb5712bafc0$var$aspectRatioLength("y", y) / ($c6491cb5712bafc0$var$aspectRatioLength("x", x) * aspectRatio);
        const fxb = fx ? fx.scale.bandwidth() : 1;
        const fyb = fy ? fy.scale.bandwidth() : 1;
        const w = fxb * (width - marginLeftDefault - marginRightDefault) - x.insetLeft - x.insetRight;
        return (ratio * w + y.insetTop + y.insetBottom) / fyb + marginTopDefault + marginBottomDefault;
    }
    return !!(y || fy) * Math.max(1, Math.min(60, ny * nfy)) * 20 + !!fx * 30 + 60;
}
function $c6491cb5712bafc0$var$aspectRatioLength(k, scale) {
    if (!scale) throw new Error(`aspectRatio requires ${k} scale`);
    const { type: type, domain: domain } = scale;
    let transform;
    switch(type){
        case "linear":
        case "utc":
        case "time":
            transform = Number;
            break;
        case "pow":
            {
                const exponent = scale.scale.exponent();
                transform = (x)=>Math.pow(x, exponent);
                break;
            }
        case "log":
            transform = Math.log;
            break;
        case "point":
        case "band":
            return domain.length;
        default:
            throw new Error(`unsupported ${k} scale for aspectRatio: ${type}`);
    }
    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
    return Math.abs(transform(max) - transform(min));
}







const $06868e990a5c2092$var$states = new WeakMap();
function $06868e990a5c2092$var$pointerK(kx, ky, { x: x, y: y, px: px, py: py, maxRadius: maxRadius = 40, channels: channels, render: render, ...options } = {}) {
    maxRadius = +maxRadius;
    // When px or py is used, register an extra channel that the pointer
    // interaction can use to control which point is focused; this allows pointing
    // to function independently of where the downstream mark (e.g., a tip) is
    // displayed. Also default x or y to null to disable maybeTuple etc.
    if (px != null) x ??= null, channels = {
        ...channels,
        px: {
            value: px,
            scale: "x"
        }
    };
    if (py != null) y ??= null, channels = {
        ...channels,
        py: {
            value: py,
            scale: "y"
        }
    };
    return {
        x: x,
        y: y,
        channels: channels,
        ...options,
        // Unlike other composed transforms, the render transform must be the
        // outermost render function because it will re-render dynamically in
        // response to pointer events.
        render: (0, $24d8c38d667d16c2$export$b80642eda489f786)(function(index, scales, values, dimensions, context, next) {
            context = {
                ...context,
                pointerSticky: false
            };
            const svg = context.ownerSVGElement;
            const { data: data } = context.getMarkState(this);
            // Isolate state per-pointer, per-plot; if the pointer is reused by
            // multiple marks, they will share the same state (e.g., sticky modality).
            let state = $06868e990a5c2092$var$states.get(svg);
            if (!state) $06868e990a5c2092$var$states.set(svg, state = {
                sticky: false,
                roots: [],
                renders: []
            });
            // This serves as a unique identifier of the rendered mark per-plot; it is
            // used to record the currently-rendered elements (state.roots) so that we
            // can tell when a rendered element is clicked on.
            let renderIndex = state.renders.push(render) - 1;
            // For faceting, we want to compute the local coordinates of each point,
            // which means subtracting out the facet translation, if any. (It’s
            // tempting to do this using the local coordinates in SVG, but that’s
            // complicated by mark-specific transforms such as dx and dy.) Also, since
            // band scales return the upper bound of the band, we have to offset by
            // half the bandwidth.
            const { x: x, y: y, fx: fx, fy: fy } = scales;
            let tx = fx ? fx(index.fx) - dimensions.marginLeft : 0;
            let ty = fy ? fy(index.fy) - dimensions.marginTop : 0;
            if (x?.bandwidth) tx += x.bandwidth() / 2;
            if (y?.bandwidth) ty += y.bandwidth() / 2;
            // For faceting, we also need to record the closest point per facet per
            // mark (!), since each facet has its own pointer event listeners; we only
            // want the closest point across facets to be visible.
            const faceted = index.fi != null;
            let facetState;
            if (faceted) {
                let facetStates = state.facetStates;
                if (!facetStates) state.facetStates = facetStates = new Map();
                facetState = facetStates.get(this);
                if (!facetState) facetStates.set(this, facetState = new Map());
            }
            // The order of precedence for the pointer position is: px & py; the
            // middle of x1 & y1 and x2 & y2; or x1 & y1 (e.g., area); or lastly x &
            // y. If a dimension is unspecified, the frame anchor is used.
            const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
            const { px: PX, py: PY } = values;
            const px = PX ? (i)=>PX[i] : $06868e990a5c2092$export$15f8ded78c8d24ca(values, cx);
            const py = PY ? (i)=>PY[i] : $06868e990a5c2092$export$770d7614a8aa3617(values, cy);
            let i; // currently focused index
            let g; // currently rendered mark
            let s; // currently rendered stickiness
            let f; // current animation frame
            // When faceting, if more than one pointer would be visible, only show
            // this one if it is the closest. We defer rendering using an animation
            // frame to allow all pointer events to be received before deciding which
            // mark to render; although when hiding, we render immediately.
            function update(ii, ri) {
                if (faceted) {
                    if (f) f = cancelAnimationFrame(f);
                    if (ii == null) facetState.delete(index.fi);
                    else {
                        facetState.set(index.fi, ri);
                        f = requestAnimationFrame(()=>{
                            f = null;
                            for (const [fi, r] of facetState)if (r < ri || r === ri && fi < index.fi) {
                                ii = null;
                                break;
                            }
                            render(ii);
                        });
                        return;
                    }
                }
                render(ii);
            }
            function render(ii) {
                if (i === ii && s === state.sticky) return; // the tooltip hasn’t moved
                i = ii;
                s = context.pointerSticky = state.sticky;
                const I = i == null ? [] : [
                    i
                ];
                if (faceted) I.fx = index.fx, I.fy = index.fy, I.fi = index.fi;
                const r = next(I, scales, values, dimensions, context);
                if (g) {
                    // When faceting, preserve swapped mark and facet transforms; also
                    // remove ARIA attributes since these are promoted to the parent. This
                    // is perhaps brittle in that it depends on how Plot renders facets,
                    // but it produces a cleaner and more accessible SVG structure.
                    if (faceted) {
                        const p = g.parentNode;
                        const ft = g.getAttribute("transform");
                        const mt = r.getAttribute("transform");
                        ft ? r.setAttribute("transform", ft) : r.removeAttribute("transform");
                        mt ? p.setAttribute("transform", mt) : p.removeAttribute("transform");
                        r.removeAttribute("aria-label");
                        r.removeAttribute("aria-description");
                        r.removeAttribute("aria-hidden");
                    }
                    g.replaceWith(r);
                }
                state.roots[renderIndex] = g = r;
                // Dispatch the value. When simultaneously exiting this facet and
                // entering a new one, prioritize the entering facet.
                if (!(i == null && facetState?.size > 1)) {
                    const value = i == null ? null : (0, $cd9e805a4bbd13f9$export$43bee75e5e14138e)(data) ? data[i] : data.get(i);
                    context.dispatchValue(value);
                }
                return r;
            }
            // Select the closest point to the mouse in the current facet; for
            // pointerX or pointerY, the orthogonal component of the distance is
            // squashed, selecting primarily on the dominant dimension. Across facets,
            // use unsquashed distance to determine the winner.
            function pointermove(event) {
                if (state.sticky || event.pointerType === "mouse" && event.buttons === 1) return; // dragging
                let [xp, yp] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
                xp -= tx, yp -= ty; // correct for facets and band scales
                const kpx = xp < dimensions.marginLeft || xp > dimensions.width - dimensions.marginRight ? 1 : kx;
                const kpy = yp < dimensions.marginTop || yp > dimensions.height - dimensions.marginBottom ? 1 : ky;
                let ii = null;
                let ri = maxRadius * maxRadius;
                for (const j of index){
                    const dx = kpx * (px(j) - xp);
                    const dy = kpy * (py(j) - yp);
                    const rj = dx * dx + dy * dy;
                    if (rj <= ri) ii = j, ri = rj;
                }
                if (ii != null && (kx !== 1 || ky !== 1)) {
                    const dx = px(ii) - xp;
                    const dy = py(ii) - yp;
                    ri = dx * dx + dy * dy;
                }
                update(ii, ri);
            }
            function pointerdown(event) {
                if (event.pointerType !== "mouse") return;
                if (i == null) return; // not pointing
                if (state.sticky && state.roots.some((r)=>r?.contains(event.target))) return; // stay sticky
                if (state.sticky) state.sticky = false, state.renders.forEach((r)=>r(null)); // clear all pointers
                else state.sticky = true, render(i);
                event.stopImmediatePropagation(); // suppress other pointers
            }
            function pointerleave(event) {
                if (event.pointerType !== "mouse") return;
                if (!state.sticky) update(null);
            }
            // We listen to the svg element; listening to the window instead would let
            // us receive pointer events from farther away, but would also make it
            // hard to know when to remove the listeners. (Using a mutation observer
            // to watch the entire document is likely too expensive.)
            svg.addEventListener("pointerenter", pointermove);
            svg.addEventListener("pointermove", pointermove);
            svg.addEventListener("pointerdown", pointerdown);
            svg.addEventListener("pointerleave", pointerleave);
            return render(null);
        }, render)
    };
}
function $06868e990a5c2092$export$b7fd2c2937973304(options) {
    return $06868e990a5c2092$var$pointerK(1, 1, options);
}
function $06868e990a5c2092$export$81f1118cc214bacd(options) {
    return $06868e990a5c2092$var$pointerK(1, 0.01, options);
}
function $06868e990a5c2092$export$a3d8dca9524ddc38(options) {
    return $06868e990a5c2092$var$pointerK(0.01, 1, options);
}
function $06868e990a5c2092$export$15f8ded78c8d24ca({ x1: X1, x2: X2, x: X = X1 }, cx) {
    return X1 && X2 ? (i)=>(X1[i] + X2[i]) / 2 : X ? (i)=>X[i] : ()=>cx;
}
function $06868e990a5c2092$export$770d7614a8aa3617({ y1: Y1, y2: Y2, y: Y = Y1 }, cy) {
    return Y1 && Y2 ? (i)=>(Y1[i] + Y2[i]) / 2 : Y ? (i)=>Y[i] : ()=>cy;
}



var $bYoiY = parcelRequire("bYoiY");



function $5349c8aa18563753$export$57ccd2691f3b457e(scale) {
    return (0, $d2c16f7a6010a221$export$61579433626afe87)(scale) && scale.interval === undefined ? undefined : "tabular-nums";
}






function $0e1b3cfced53194d$export$cc0ec4119b9c7105(color, options) {
    let { label: label = color.label, tickSize: tickSize = 6, width: width = 240, height: height = 44 + tickSize, marginTop: marginTop = 18, marginRight: marginRight = 0, marginBottom: marginBottom = 16 + tickSize, marginLeft: marginLeft = 0, style: style, ticks: ticks = (width - marginLeft - marginRight) / 64, tickFormat: tickFormat, fontVariant: fontVariant = (0, $5349c8aa18563753$export$57ccd2691f3b457e)(color), round: round = true, opacity: opacity, className: className } = options;
    const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
    className = (0, $547e5698440387a8$export$22300e6eaecca37)(className);
    opacity = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(opacity)[1];
    if (tickFormat === null) tickFormat = ()=>null;
    const svg = (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg", context).attr("class", `${className}-ramp`).attr("font-family", "system-ui, sans-serif").attr("font-size", 10).attr("width", width).attr("height", height).attr("viewBox", `0 0 ${width} ${height}`).call((svg)=>// Warning: if you edit this, change defaultClassName.
        svg.append("style").text(`:where(.${className}-ramp) {
  display: block;
  height: auto;
  height: intrinsic;
  max-width: 100%;
  overflow: visible;
}
:where(.${className}-ramp text) {
  white-space: pre;
}`)).call((0, $547e5698440387a8$export$4e6c5cc1af44143e), style);
    let tickAdjust = (g)=>g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
    let x;
    // Some D3 scales use scale.interpolate, some scale.interpolator, and some
    // scale.round; this normalizes the API so it works with all scale types.
    const applyRange = round ? (x, range)=>x.rangeRound(range) : (x, range)=>x.range(range);
    const { type: type, domain: domain, range: range, interpolate: interpolate, scale: scale, pivot: pivot } = color;
    // Continuous
    if (interpolate) {
        // Often interpolate is a “fixed” interpolator on the [0, 1] interval, as
        // with a built-in color scheme, but sometimes it is a function that takes
        // two arguments and is used in conjunction with the range.
        const interpolator = range === undefined ? interpolate : (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate.length === 1 ? (0, $30c166b7628c3ceb$export$f68e9493607eda6)(interpolate) : interpolate, range);
        // Construct a D3 scale of the same type, but with a range that evenly
        // divides the horizontal extent of the legend. (In the common case, the
        // domain.length is two, and so the range is simply the extent.) For a
        // diverging scale, we need an extra point in the range for the pivot such
        // that the pivot is always drawn in the middle.
        x = applyRange(scale.copy(), (0, $4f501ce7bede8755$export$2e2bcd8739ae039)((0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(marginLeft, width - marginRight), Math.min(domain.length + (pivot !== undefined), range === undefined ? Infinity : range.length)));
        // Construct a 256×1 canvas, filling each pixel using the interpolator.
        const n = 256;
        const canvas = context.document.createElement("canvas");
        canvas.width = n;
        canvas.height = 1;
        const context2 = canvas.getContext("2d");
        for(let i = 0, j = n - 1; i < n; ++i){
            context2.fillStyle = interpolator(i / j);
            context2.fillRect(i, 0, 1, 1);
        }
        svg.append("image").attr("opacity", opacity).attr("x", marginLeft).attr("y", marginTop).attr("width", width - marginLeft - marginRight).attr("height", height - marginTop - marginBottom).attr("preserveAspectRatio", "none").attr("xlink:href", canvas.toDataURL());
    } else if (type === "threshold") {
        const thresholds = domain;
        const thresholdFormat = tickFormat === undefined ? (d)=>d : typeof tickFormat === "string" ? (0, $54a757fa53542946$export$d9468344d3651243)(tickFormat) : tickFormat;
        // Construct a linear scale with evenly-spaced ticks for each of the
        // thresholds; the domain extends one beyond the threshold extent.
        x = applyRange((0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain([
            -1,
            range.length - 1
        ]), [
            marginLeft,
            width - marginRight
        ]);
        svg.append("g").attr("fill-opacity", opacity).selectAll().data(range).enter().append("rect").attr("x", (d, i)=>x(i - 1)).attr("y", marginTop).attr("width", (d, i)=>x(i) - x(i - 1)).attr("height", height - marginTop - marginBottom).attr("fill", (d)=>d);
        ticks = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(thresholds, (_, i)=>i);
        tickFormat = (i)=>thresholdFormat(thresholds[i], i);
    } else {
        x = applyRange((0, $c1f2fa2a7653ca3a$export$2e2bcd8739ae039)().domain(domain), [
            marginLeft,
            width - marginRight
        ]);
        svg.append("g").attr("fill-opacity", opacity).selectAll().data(domain).enter().append("rect").attr("x", x).attr("y", marginTop).attr("width", Math.max(0, x.bandwidth() - 1)).attr("height", height - marginTop - marginBottom).attr("fill", scale);
        tickAdjust = ()=>{};
    }
    svg.append("g").attr("transform", `translate(0,${height - marginBottom})`).call((0, $834b38f205523964$export$e5cb22533a15e72e)(x).ticks(Array.isArray(ticks) ? null : ticks, typeof tickFormat === "string" ? tickFormat : undefined).tickFormat(typeof tickFormat === "function" ? tickFormat : undefined).tickSize(tickSize).tickValues(Array.isArray(ticks) ? ticks : null)).attr("font-size", null).attr("font-family", null).attr("font-variant", (0, $547e5698440387a8$export$e1c487990851f09f)(fontVariant, "normal")).call(tickAdjust).call((g)=>g.select(".domain").remove());
    if (label !== undefined) svg.append("text").attr("x", marginLeft).attr("y", marginTop - 6).attr("fill", "currentColor") // TODO move to stylesheet?
    .attr("font-weight", "bold").text(label);
    return svg.node();
}











const $313afcb1ba78b0a6$export$8449e153fbd325fc = Math.PI / 180;













function $f013115577adb919$export$6b811a095661528f(mark, { marker: marker, markerStart: markerStart = marker, markerMid: markerMid = marker, markerEnd: markerEnd = marker } = {}) {
    mark.markerStart = $f013115577adb919$var$maybeMarker(markerStart);
    mark.markerMid = $f013115577adb919$var$maybeMarker(markerMid);
    mark.markerEnd = $f013115577adb919$var$maybeMarker(markerEnd);
}
function $f013115577adb919$var$maybeMarker(marker) {
    if (marker == null || marker === false) return null;
    if (marker === true) return $f013115577adb919$var$markerCircleFill;
    if (typeof marker === "function") return marker;
    switch(`${marker}`.toLowerCase()){
        case "none":
            return null;
        case "arrow":
            return $f013115577adb919$var$markerArrow("auto");
        case "arrow-reverse":
            return $f013115577adb919$var$markerArrow("auto-start-reverse");
        case "dot":
            return $f013115577adb919$var$markerDot;
        case "circle":
        case "circle-fill":
            return $f013115577adb919$var$markerCircleFill;
        case "circle-stroke":
            return $f013115577adb919$var$markerCircleStroke;
        case "tick":
            return $f013115577adb919$var$markerTick("auto");
        case "tick-x":
            return $f013115577adb919$var$markerTick(90);
        case "tick-y":
            return $f013115577adb919$var$markerTick(0);
    }
    throw new Error(`invalid marker: ${marker}`);
}
function $f013115577adb919$var$markerArrow(orient) {
    return (color, context)=>(0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("orient", orient).attr("fill", "none").attr("stroke", color).attr("stroke-width", 1.5).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").call((marker)=>marker.append("path").attr("d", "M-1.5,-3l3,3l-3,3")).node();
}
function $f013115577adb919$var$markerDot(color, context) {
    return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", color).attr("stroke", "none").call((marker)=>marker.append("circle").attr("r", 2.5)).node();
}
function $f013115577adb919$var$markerCircleFill(color, context) {
    return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", color).attr("stroke", "var(--plot-background)").attr("stroke-width", 1.5).call((marker)=>marker.append("circle").attr("r", 3)).node();
}
function $f013115577adb919$var$markerCircleStroke(color, context) {
    return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", "var(--plot-background)").attr("stroke", color).attr("stroke-width", 1.5).call((marker)=>marker.append("circle").attr("r", 3)).node();
}
function $f013115577adb919$var$markerTick(orient) {
    return (color, context)=>(0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-3 -3 6 6").attr("markerWidth", 6).attr("markerHeight", 6).attr("orient", orient).attr("stroke", color).call((marker)=>marker.append("path").attr("d", "M0,-3v6")).node();
}
let $f013115577adb919$var$nextMarkerId = 0;
function $f013115577adb919$export$3725d839c1ddab92(path, mark, { stroke: S }, context) {
    return $f013115577adb919$var$applyMarkersColor(path, mark, S && ((i)=>S[i]), null, context);
}
function $f013115577adb919$export$e6a749a5a88e9589(path, mark, { stroke: S, z: Z }, context) {
    return $f013115577adb919$var$applyMarkersColor(path, mark, S && (([i])=>S[i]), Z, context);
}
const $f013115577adb919$var$START = 1;
const $f013115577adb919$var$END = 2;
/**
 * When rendering lines or areas with variable aesthetics, a single series
 * produces multiple path elements. The first path element is a START segment;
 * the last path element is an END segment. When there is only a single path
 * element, it is both a START and an END segment.
 */ function $f013115577adb919$var$getGroupedOrientation(path, Z) {
    const O = new Uint8Array(Z.length);
    const D = path.data().filter((I)=>I.length > 1);
    const n = D.length;
    // Forward pass to find start segments.
    for(let i = 0, z = (0, $d18c56c98d932ebe$export$294553a3f9ed16dc); i < n; ++i){
        const I = D[i];
        if (I.length > 1) {
            const i = I[0];
            if (z !== (z = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(Z[i]))) O[i] |= $f013115577adb919$var$START;
        }
    }
    // Backwards pass to find end segments.
    for(let i = n - 1, z = (0, $d18c56c98d932ebe$export$294553a3f9ed16dc); i >= 0; --i){
        const I = D[i];
        if (I.length > 1) {
            const i = I[0];
            if (z !== (z = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(Z[i]))) O[i] |= $f013115577adb919$var$END;
        }
    }
    return ([i])=>O[i];
}
function $f013115577adb919$var$applyMarkersColor(path, { markerStart: markerStart, markerMid: markerMid, markerEnd: markerEnd, stroke: stroke }, strokeof = ()=>stroke, Z, context) {
    if (!markerStart && !markerMid && !markerEnd) return;
    const iriByMarkerColor = new Map();
    const orient = Z && $f013115577adb919$var$getGroupedOrientation(path, Z);
    function applyMarker(name, marker, filter) {
        return function(i) {
            if (filter && !filter(i)) return;
            const color = strokeof(i);
            let iriByColor = iriByMarkerColor.get(marker);
            if (!iriByColor) iriByMarkerColor.set(marker, iriByColor = new Map());
            let iri = iriByColor.get(color);
            if (!iri) {
                const node = this.parentNode.insertBefore(marker(color, context), this);
                const id = `plot-marker-${++$f013115577adb919$var$nextMarkerId}`;
                node.setAttribute("id", id);
                iriByColor.set(color, iri = `url(#${id})`);
            }
            this.setAttribute(name, iri);
        };
    }
    if (markerStart) path.each(applyMarker("marker-start", markerStart, orient && ((i)=>orient(i) & $f013115577adb919$var$START)));
    if (markerMid && orient) path.each(applyMarker("marker-start", markerMid, (i)=>!(orient(i) & $f013115577adb919$var$START)));
    if (markerMid) path.each(applyMarker("marker-mid", markerMid));
    if (markerEnd) path.each(applyMarker("marker-end", markerEnd, orient && ((i)=>orient(i) & $f013115577adb919$var$END)));
}







function $99fa11de593a4520$export$26b23c8bb7051b0({ inset: inset, insetLeft: insetLeft, insetRight: insetRight, ...options } = {}) {
    [insetLeft, insetRight] = $99fa11de593a4520$var$maybeInset(inset, insetLeft, insetRight);
    return {
        inset: inset,
        insetLeft: insetLeft,
        insetRight: insetRight,
        ...options
    };
}
function $99fa11de593a4520$export$cc1990e80430bfbb({ inset: inset, insetTop: insetTop, insetBottom: insetBottom, ...options } = {}) {
    [insetTop, insetBottom] = $99fa11de593a4520$var$maybeInset(inset, insetTop, insetBottom);
    return {
        inset: inset,
        insetTop: insetTop,
        insetBottom: insetBottom,
        ...options
    };
}
function $99fa11de593a4520$var$maybeInset(inset, inset1, inset2) {
    return inset === undefined && inset1 === undefined && inset2 === undefined ? (0, $547e5698440387a8$export$cc800923e997bb8) ? [
        1,
        0
    ] : [
        0.5,
        0.5
    ] : [
        inset1,
        inset2
    ];
}


// The interval may be specified either as x: {value, interval} or as {x,
// interval}. The former can be used to specify separate intervals for x and y,
// for example with Plot.rect.
function $785a735c79529924$var$maybeIntervalValue(value, { interval: interval }) {
    value = {
        ...(0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(value)
    };
    value.interval = (0, $cd9e805a4bbd13f9$export$91a968a7e5747089)(value.interval === undefined ? interval : value.interval);
    return value;
}
function $785a735c79529924$var$maybeIntervalK(k, maybeInsetK, options, trivial) {
    const { [k]: v, [`${k}1`]: v1, [`${k}2`]: v2 } = options;
    const { value: value, interval: interval } = $785a735c79529924$var$maybeIntervalValue(v, options);
    if (value == null || interval == null && !trivial) return options;
    const label = (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(v);
    if (interval == null) {
        let V;
        const kv = {
            transform: (data)=>V || (V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value)),
            label: label
        };
        return {
            ...options,
            [k]: undefined,
            [`${k}1`]: v1 === undefined ? kv : v1,
            [`${k}2`]: v2 === undefined && !(v1 === v2 && trivial) ? kv : v2
        };
    }
    let D1, V1;
    function transform(data) {
        if (V1 !== undefined && data === D1) return V1; // memoize
        return V1 = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(D1 = data, value), (v)=>interval.floor(v));
    }
    return maybeInsetK({
        ...options,
        [k]: undefined,
        [`${k}1`]: v1 === undefined ? {
            transform: transform,
            label: label
        } : v1,
        [`${k}2`]: v2 === undefined ? {
            transform: (data)=>transform(data).map((v)=>interval.offset(v)),
            label: label
        } : v2
    });
}
function $785a735c79529924$var$maybeIntervalMidK(k, maybeInsetK, options) {
    const { [k]: v } = options;
    const { value: value, interval: interval } = $785a735c79529924$var$maybeIntervalValue(v, options);
    if (value == null || interval == null) return options;
    return maybeInsetK({
        ...options,
        [k]: {
            label: (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(v),
            transform: (data)=>{
                const V1 = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value), (v)=>interval.floor(v));
                const V2 = V1.map((v)=>interval.offset(v));
                return V1.map((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(V1) ? (v1, v2)=>v1 == null || isNaN(v1 = +v1) || (v2 = V2[v2], v2 == null) || isNaN(v2 = +v2) ? undefined : new Date((v1 + v2) / 2) : (v1, v2)=>v1 == null || (v2 = V2[v2], v2 == null) ? NaN : (+v1 + +v2) / 2);
            }
        }
    });
}
function $785a735c79529924$export$3e5af5df4bf84a22(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("x", (0, $99fa11de593a4520$export$26b23c8bb7051b0), options, true);
}
function $785a735c79529924$export$180507f16d7b6c92(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("y", (0, $99fa11de593a4520$export$cc1990e80430bfbb), options, true);
}
function $785a735c79529924$export$53df9f682f2ce607(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("x", (0, $99fa11de593a4520$export$26b23c8bb7051b0), options);
}
function $785a735c79529924$export$77d68ae5ebd03d2b(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("y", (0, $99fa11de593a4520$export$cc1990e80430bfbb), options);
}
function $785a735c79529924$export$4d0ebe7ec032f34f(options = {}) {
    return $785a735c79529924$var$maybeIntervalMidK("x", (0, $99fa11de593a4520$export$26b23c8bb7051b0), options);
}
function $785a735c79529924$export$a7ad4939d5e92aaa(options = {}) {
    return $785a735c79529924$var$maybeIntervalMidK("y", (0, $99fa11de593a4520$export$cc1990e80430bfbb), options);
}


const $60ff8edb66755c31$var$defaults = {
    ariaLabel: "rule",
    fill: null,
    stroke: "currentColor"
};
class $60ff8edb66755c31$export$89bb5d5f432a0c7c extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y1: y1, y2: y2, inset: inset = 0, insetTop: insetTop = inset, insetBottom: insetBottom = inset } = options;
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y1: {
                value: y1,
                scale: "y",
                optional: true
            },
            y2: {
                value: y2,
                scale: "y",
                optional: true
            }
        }, (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "x"), $60ff8edb66755c31$var$defaults);
        this.insetTop = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetTop);
        this.insetBottom = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetBottom);
        (0, $f013115577adb919$export$6b811a095661528f)(this, options);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y1: Y1, y2: Y2 } = channels;
        const { width: width, height: height, marginTop: marginTop, marginRight: marginRight, marginLeft: marginLeft, marginBottom: marginBottom } = dimensions;
        const { insetTop: insetTop, insetBottom: insetBottom } = this;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x
        }, (0, $547e5698440387a8$export$cc800923e997bb8), 0).call((g)=>g.selectAll().data(index).enter().append("line").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("x1", X ? (i)=>X[i] : (marginLeft + width - marginRight) / 2).attr("x2", X ? (i)=>X[i] : (marginLeft + width - marginRight) / 2).attr("y1", Y1 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(y) ? (i)=>Y1[i] + insetTop : marginTop + insetTop).attr("y2", Y2 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(y) ? y.bandwidth ? (i)=>Y2[i] + y.bandwidth() - insetBottom : (i)=>Y2[i] - insetBottom : height - marginBottom - insetBottom).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels).call((0, $f013115577adb919$export$3725d839c1ddab92), this, channels, context)).node();
    }
}
class $60ff8edb66755c31$export$5af3dd6659e3ddb1 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x1: x1, x2: x2, y: y, inset: inset = 0, insetRight: insetRight = inset, insetLeft: insetLeft = inset } = options;
        super(data, {
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            x1: {
                value: x1,
                scale: "x",
                optional: true
            },
            x2: {
                value: x2,
                scale: "x",
                optional: true
            }
        }, (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "y"), $60ff8edb66755c31$var$defaults);
        this.insetRight = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetRight);
        this.insetLeft = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetLeft);
        (0, $f013115577adb919$export$6b811a095661528f)(this, options);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { y: Y, x1: X1, x2: X2 } = channels;
        const { width: width, height: height, marginTop: marginTop, marginRight: marginRight, marginLeft: marginLeft, marginBottom: marginBottom } = dimensions;
        const { insetLeft: insetLeft, insetRight: insetRight } = this;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            y: Y && y
        }, 0, (0, $547e5698440387a8$export$cc800923e997bb8)).call((g)=>g.selectAll().data(index).enter().append("line").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("x1", X1 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(x) ? (i)=>X1[i] + insetLeft : marginLeft + insetLeft).attr("x2", X2 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(x) ? x.bandwidth ? (i)=>X2[i] + x.bandwidth() - insetRight : (i)=>X2[i] - insetRight : width - marginRight - insetRight).attr("y1", Y ? (i)=>Y[i] : (marginTop + height - marginBottom) / 2).attr("y2", Y ? (i)=>Y[i] : (marginTop + height - marginBottom) / 2).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels).call((0, $f013115577adb919$export$3725d839c1ddab92), this, channels, context)).node();
    }
}
function $60ff8edb66755c31$export$22653c04c6d89eeb(data, options) {
    let { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), y: y, y1: y1, y2: y2, ...rest } = (0, $785a735c79529924$export$77d68ae5ebd03d2b)(options);
    [y1, y2] = $60ff8edb66755c31$var$maybeOptionalZero(y, y1, y2);
    return new $60ff8edb66755c31$export$89bb5d5f432a0c7c(data, {
        ...rest,
        x: x,
        y1: y1,
        y2: y2
    });
}
function $60ff8edb66755c31$export$d121b88bc74f6ae5(data, options) {
    let { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), x: x, x1: x1, x2: x2, ...rest } = (0, $785a735c79529924$export$53df9f682f2ce607)(options);
    [x1, x2] = $60ff8edb66755c31$var$maybeOptionalZero(x, x1, x2);
    return new $60ff8edb66755c31$export$5af3dd6659e3ddb1(data, {
        ...rest,
        y: y,
        x1: x1,
        x2: x2
    });
}
// For marks specified either as [0, x] or [x1, x2], or nothing.
function $60ff8edb66755c31$var$maybeOptionalZero(x, x1, x2) {
    if (x == null) {
        if (x1 === undefined) {
            if (x2 !== undefined) return [
                0,
                x2
            ];
        } else {
            if (x2 === undefined) return [
                0,
                x1
            ];
        }
    } else if (x1 === undefined) return x2 === undefined ? [
        0,
        x
    ] : [
        x,
        x2
    ];
    else if (x2 === undefined) return [
        x,
        x1
    ];
    return [
        x1,
        x2
    ];
}









function $bfd513fc05083823$export$ce69bd05624d0c48(strings, ...parts) {
    let n = parts.length;
    // If any of the interpolated parameters are strings rather than functions,
    // bake them into the template to optimize performance during render.
    for(let j = 0, copy = true; j < n; ++j)if (typeof parts[j] !== "function") {
        if (copy) {
            strings = strings.slice(); // copy before mutate
            copy = false;
        }
        strings.splice(j, 2, strings[j] + parts[j] + strings[j + 1]);
        parts.splice(j, 1);
        --j, --n;
    }
    return (i)=>{
        let s = strings[0];
        for(let j = 0; j < n; ++j)s += parts[j](i) + strings[j + 1];
        return s;
    };
}



const $b4855ffaf649c526$var$defaults = {
    ariaLabel: "text",
    strokeLinejoin: "round",
    strokeWidth: 3,
    paintOrder: "stroke"
};
const $b4855ffaf649c526$var$softHyphen = "\xad";
class $b4855ffaf649c526$export$5f1af8db9871e1d6 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, text: text = (0, $cd9e805a4bbd13f9$export$9652023d9040757)(data) && (0, $cd9e805a4bbd13f9$export$43674e37205f3011)(data) ? (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655) : (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2), frameAnchor: frameAnchor, textAnchor: textAnchor = /right$/i.test(frameAnchor) ? "end" : /left$/i.test(frameAnchor) ? "start" : "middle", lineAnchor: lineAnchor = /^top/i.test(frameAnchor) ? "top" : /^bottom/i.test(frameAnchor) ? "bottom" : "middle", lineHeight: lineHeight = 1, lineWidth: lineWidth = Infinity, textOverflow: textOverflow, monospace: monospace, fontFamily: fontFamily = monospace ? "ui-monospace, monospace" : undefined, fontSize: fontSize, fontStyle: fontStyle, fontVariant: fontVariant, fontWeight: fontWeight, rotate: rotate } = options;
        const [vrotate, crotate] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(rotate, 0);
        const [vfontSize, cfontSize] = $b4855ffaf649c526$var$maybeFontSizeChannel(fontSize);
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            fontSize: {
                value: vfontSize,
                optional: true
            },
            rotate: {
                value: (0, $cd9e805a4bbd13f9$export$a152540187b5d206)(vrotate),
                optional: true
            },
            text: {
                value: text,
                filter: (0, $0f3e37548c3914c7$export$6ce6c9218151d511),
                optional: true
            }
        }, options, $b4855ffaf649c526$var$defaults);
        this.rotate = crotate;
        this.textAnchor = (0, $547e5698440387a8$export$e1c487990851f09f)(textAnchor, "middle");
        this.lineAnchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(lineAnchor, "lineAnchor", [
            "top",
            "middle",
            "bottom"
        ]);
        this.lineHeight = +lineHeight;
        this.lineWidth = +lineWidth;
        this.textOverflow = $b4855ffaf649c526$export$5286100f10ca66d(textOverflow);
        this.monospace = !!monospace;
        this.fontFamily = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontFamily);
        this.fontSize = cfontSize;
        this.fontStyle = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontStyle);
        this.fontVariant = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontVariant);
        this.fontWeight = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontWeight);
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
        if (!(this.lineWidth >= 0)) throw new Error(`invalid lineWidth: ${lineWidth}`);
        this.splitLines = $b4855ffaf649c526$export$8cfde575cbd41e40(this);
        this.clipLine = $b4855ffaf649c526$export$f7f3d67a35896a0e(this);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y: Y, rotate: R, text: T, title: TL, fontSize: FS } = channels;
        const { rotate: rotate } = this;
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call($b4855ffaf649c526$export$8b7aa25119010c38, this, T, dimensions).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append("text").call((0, $547e5698440387a8$export$2949c2472f804203), this).call($b4855ffaf649c526$var$applyMultilineText, this, T, TL).attr("transform", (0, $bfd513fc05083823$export$ce69bd05624d0c48)`translate(${X ? (i)=>X[i] : cx},${Y ? (i)=>Y[i] : cy})${R ? (i)=>` rotate(${R[i]})` : rotate ? ` rotate(${rotate})` : ``}`).call((0, $547e5698440387a8$export$47765c6b16054eb2), "font-size", FS && ((i)=>FS[i])).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels)).node();
    }
}
function $b4855ffaf649c526$export$5286100f10ca66d(textOverflow) {
    return textOverflow == null ? null : (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(textOverflow, "textOverflow", [
        "clip",
        "ellipsis",
        "clip-start",
        "clip-end",
        "ellipsis-start",
        "ellipsis-middle",
        "ellipsis-end"
    ]).replace(/^(clip|ellipsis)$/, "$1-end");
}
function $b4855ffaf649c526$var$applyMultilineText(selection, mark, T, TL) {
    if (!T) return;
    const { lineAnchor: lineAnchor, lineHeight: lineHeight, textOverflow: textOverflow, splitLines: splitLines, clipLine: clipLine } = mark;
    selection.each(function(i) {
        const lines = splitLines((0, $4b16c4377cd1e2de$export$bb457229db2006fb)(T[i]) ?? "").map(clipLine);
        const n = lines.length;
        const y = lineAnchor === "top" ? 0.71 : lineAnchor === "bottom" ? 1 - n : (164 - n * 100) / 200;
        if (n > 1) {
            let m = 0;
            for(let i = 0; i < n; ++i){
                ++m;
                if (!lines[i]) continue;
                const tspan = this.ownerDocument.createElementNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).svg, "tspan");
                tspan.setAttribute("x", 0);
                if (i === m - 1) tspan.setAttribute("y", `${(y + i) * lineHeight}em`);
                else tspan.setAttribute("dy", `${m * lineHeight}em`);
                tspan.textContent = lines[i];
                this.appendChild(tspan);
                m = 0;
            }
        } else {
            if (y) this.setAttribute("y", `${y * lineHeight}em`);
            this.textContent = lines[0];
        }
        if (textOverflow && !TL && lines[0] !== T[i]) {
            const title = this.ownerDocument.createElementNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).svg, "title");
            title.textContent = T[i];
            this.appendChild(title);
        }
    });
}
function $b4855ffaf649c526$export$6f093cfa640b7166(data, { x: x, y: y, ...options } = {}) {
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $b4855ffaf649c526$export$5f1af8db9871e1d6(data, {
        ...options,
        x: x,
        y: y
    });
}
function $b4855ffaf649c526$export$5aac532f27b03078(data, { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $b4855ffaf649c526$export$5f1af8db9871e1d6(data, (0, $785a735c79529924$export$a7ad4939d5e92aaa)({
        ...options,
        x: x
    }));
}
function $b4855ffaf649c526$export$b11955fec8f4d045(data, { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $b4855ffaf649c526$export$5f1af8db9871e1d6(data, (0, $785a735c79529924$export$4d0ebe7ec032f34f)({
        ...options,
        y: y
    }));
}
function $b4855ffaf649c526$export$8b7aa25119010c38(selection, mark, T) {
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "text-anchor", mark.textAnchor);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-family", mark.fontFamily);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-size", mark.fontSize);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-style", mark.fontStyle);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-variant", mark.fontVariant === undefined ? $b4855ffaf649c526$var$inferFontVariant(T) : mark.fontVariant);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-weight", mark.fontWeight);
}
function $b4855ffaf649c526$var$inferFontVariant(T) {
    return T && ((0, $cd9e805a4bbd13f9$export$e90fb89750dba83f)(T) || (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(T)) ? "tabular-nums" : undefined;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/font-size
const $b4855ffaf649c526$var$fontSizes = new Set([
    // global keywords
    "inherit",
    "initial",
    "revert",
    "unset",
    // absolute keywords
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large",
    // relative keywords
    "larger",
    "smaller"
]);
// The font size may be expressed as a constant in the following forms:
// - number in pixels
// - string keyword: see above
// - string <length>: e.g., "12px"
// - string <percentage>: e.g., "80%"
// Anything else is assumed to be a channel definition.
function $b4855ffaf649c526$var$maybeFontSizeChannel(fontSize) {
    if (fontSize == null || typeof fontSize === "number") return [
        undefined,
        fontSize
    ];
    if (typeof fontSize !== "string") return [
        fontSize,
        undefined
    ];
    fontSize = fontSize.trim().toLowerCase();
    return $b4855ffaf649c526$var$fontSizes.has(fontSize) || /^[+-]?\d*\.?\d+(e[+-]?\d+)?(\w*|%)$/.test(fontSize) ? [
        undefined,
        fontSize
    ] : [
        fontSize,
        undefined
    ];
}
// This is a greedy algorithm for line wrapping. It would be better to use the
// Knuth–Plass line breaking algorithm (but that would be much more complex).
// https://en.wikipedia.org/wiki/Line_wrap_and_word_wrap
function $b4855ffaf649c526$var$lineWrap(input, maxWidth, widthof) {
    const lines = [];
    let lineStart, lineEnd = 0;
    for (const [wordStart, wordEnd, required] of $b4855ffaf649c526$var$lineBreaks(input)){
        // Record the start of a line. This isn’t the same as the previous line’s
        // end because we often skip spaces between lines.
        if (lineStart === undefined) lineStart = wordStart;
        // If the current line is not empty, and if adding the current word would
        // make the line longer than the allowed width, then break the line at the
        // previous word end.
        if (lineEnd > lineStart && widthof(input, lineStart, wordEnd) > maxWidth) {
            lines.push(input.slice(lineStart, lineEnd) + (input[lineEnd - 1] === $b4855ffaf649c526$var$softHyphen ? "-" : ""));
            lineStart = wordStart;
        }
        // If this is a required break (a newline), emit the line and reset.
        if (required) {
            lines.push(input.slice(lineStart, wordEnd));
            lineStart = undefined;
            continue;
        }
        // Extend the current line to include the new word.
        lineEnd = wordEnd;
    }
    return lines;
}
// This is a rudimentary (and U.S.-centric) algorithm for finding opportunities
// to break lines between words. A better and far more comprehensive approach
// would be to use the official Unicode Line Breaking Algorithm.
// https://unicode.org/reports/tr14/
function* $b4855ffaf649c526$var$lineBreaks(input) {
    let i = 0, j = 0;
    const n = input.length;
    while(j < n){
        let k = 1;
        switch(input[j]){
            case $b4855ffaf649c526$var$softHyphen:
            case "-":
                ++j;
                yield [
                    i,
                    j,
                    false
                ];
                i = j;
                break;
            case " ":
                yield [
                    i,
                    j,
                    false
                ];
                while(input[++j] === " "); // skip multiple spaces
                i = j;
                break;
            case "\r":
                if (input[j + 1] === "\n") ++k; // falls through
            case "\n":
                yield [
                    i,
                    j,
                    true
                ];
                j += k;
                i = j;
                break;
            default:
                ++j;
                break;
        }
    }
    yield [
        i,
        j,
        true
    ];
}
// Computed as round(measureText(text).width * 10) at 10px system-ui. For
// characters that are not represented in this map, we’d ideally want to use a
// weighted average of what we expect to see. But since we don’t really know
// what that is, using “e” seems reasonable.
const $b4855ffaf649c526$var$defaultWidthMap = {
    a: 56,
    b: 63,
    c: 57,
    d: 63,
    e: 58,
    f: 37,
    g: 62,
    h: 60,
    i: 26,
    j: 26,
    k: 55,
    l: 26,
    m: 88,
    n: 60,
    o: 60,
    p: 62,
    q: 62,
    r: 39,
    s: 54,
    t: 38,
    u: 60,
    v: 55,
    w: 79,
    x: 54,
    y: 55,
    z: 55,
    A: 69,
    B: 67,
    C: 73,
    D: 74,
    E: 61,
    F: 58,
    G: 76,
    H: 75,
    I: 28,
    J: 55,
    K: 67,
    L: 58,
    M: 89,
    N: 75,
    O: 78,
    P: 65,
    Q: 78,
    R: 67,
    S: 65,
    T: 65,
    U: 75,
    V: 69,
    W: 98,
    X: 69,
    Y: 67,
    Z: 67,
    0: 64,
    1: 48,
    2: 62,
    3: 64,
    4: 66,
    5: 63,
    6: 65,
    7: 58,
    8: 65,
    9: 65,
    " ": 29,
    "!": 32,
    '"': 49,
    "'": 31,
    "(": 39,
    ")": 39,
    ",": 31,
    "-": 48,
    ".": 31,
    "/": 32,
    ":": 31,
    ";": 31,
    "?": 52,
    "\u2018": 31,
    "\u2019": 31,
    "\u201C": 47,
    "\u201D": 47,
    "\u2026": 82
};
function $b4855ffaf649c526$export$205274d8d0bfa3a(text, start = 0, end = text.length) {
    let sum = 0;
    for(let i = start; i < end; i = $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i))sum += $b4855ffaf649c526$var$defaultWidthMap[text[i]] ?? ($b4855ffaf649c526$var$isPictographic(text, i) ? 120 : $b4855ffaf649c526$var$defaultWidthMap.e);
    return sum;
}
function $b4855ffaf649c526$export$4f4ed94d656e5d4a(text, start = 0, end = text.length) {
    let sum = 0;
    for(let i = start; i < end; i = $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i))sum += $b4855ffaf649c526$var$isPictographic(text, i) ? 126 : 63;
    return sum;
}
function $b4855ffaf649c526$export$8cfde575cbd41e40({ monospace: monospace, lineWidth: lineWidth, textOverflow: textOverflow }) {
    if (textOverflow != null || lineWidth == Infinity) return (text)=>text.split(/\r\n?|\n/g);
    const widthof = monospace ? $b4855ffaf649c526$export$4f4ed94d656e5d4a : $b4855ffaf649c526$export$205274d8d0bfa3a;
    const maxWidth = lineWidth * 100;
    return (text)=>$b4855ffaf649c526$var$lineWrap(text, maxWidth, widthof);
}
function $b4855ffaf649c526$export$f7f3d67a35896a0e({ monospace: monospace, lineWidth: lineWidth, textOverflow: textOverflow }) {
    if (textOverflow == null || lineWidth == Infinity) return (text)=>text;
    const widthof = monospace ? $b4855ffaf649c526$export$4f4ed94d656e5d4a : $b4855ffaf649c526$export$205274d8d0bfa3a;
    const maxWidth = lineWidth * 100;
    switch(textOverflow){
        case "clip-start":
            return (text)=>$b4855ffaf649c526$export$bfc5cdfbfe7a8da8(text, maxWidth, widthof, "");
        case "clip-end":
            return (text)=>$b4855ffaf649c526$export$989f1dcb8b8843ad(text, maxWidth, widthof, "");
        case "ellipsis-start":
            return (text)=>$b4855ffaf649c526$export$bfc5cdfbfe7a8da8(text, maxWidth, widthof, $b4855ffaf649c526$export$a5b94313d6908893);
        case "ellipsis-middle":
            return (text)=>$b4855ffaf649c526$export$e3606efe4bf37377(text, maxWidth, widthof, $b4855ffaf649c526$export$a5b94313d6908893);
        case "ellipsis-end":
            return (text)=>$b4855ffaf649c526$export$989f1dcb8b8843ad(text, maxWidth, widthof, $b4855ffaf649c526$export$a5b94313d6908893);
    }
}
const $b4855ffaf649c526$export$a5b94313d6908893 = "\u2026";
function $b4855ffaf649c526$export$af2a99f971a346e6(text, width, widthof, inset) {
    const I = []; // indexes of read character boundaries
    let w = 0; // current line width
    for(let i = 0, j = 0, n = text.length; i < n; i = j){
        j = $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i); // read the next character
        const l = widthof(text, i, j); // current character width
        if (w + l > width) {
            w += inset;
            while(w > width && i > 0)j = i, i = I.pop(), w -= widthof(text, i, j); // remove excess
            return [
                i,
                width - w
            ];
        }
        w += l;
        I.push(i);
    }
    return [
        -1,
        0
    ];
}
function $b4855ffaf649c526$export$989f1dcb8b8843ad(text, width, widthof, ellipsis) {
    text = text.trim(); // ignore leading and trailing whitespace
    const e = widthof(ellipsis);
    const [i] = $b4855ffaf649c526$export$af2a99f971a346e6(text, width, widthof, e);
    return i < 0 ? text : text.slice(0, i).trimEnd() + ellipsis;
}
function $b4855ffaf649c526$export$e3606efe4bf37377(text, width, widthof, ellipsis) {
    text = text.trim(); // ignore leading and trailing whitespace
    const w = widthof(text);
    if (w <= width) return text;
    const e = widthof(ellipsis) / 2;
    const [i, ei] = $b4855ffaf649c526$export$af2a99f971a346e6(text, width / 2, widthof, e);
    const [j] = $b4855ffaf649c526$export$af2a99f971a346e6(text, w - width / 2 - ei + e, widthof, -e); // TODO read spaces?
    return j < 0 ? ellipsis : text.slice(0, i).trimEnd() + ellipsis + text.slice($b4855ffaf649c526$export$9864f8d4d3d2fe51(text, j)).trimStart();
}
function $b4855ffaf649c526$export$bfc5cdfbfe7a8da8(text, width, widthof, ellipsis) {
    text = text.trim(); // ignore leading and trailing whitespace
    const w = widthof(text);
    if (w <= width) return text;
    const e = widthof(ellipsis);
    const [j] = $b4855ffaf649c526$export$af2a99f971a346e6(text, w - width + e, widthof, -e); // TODO read spaces?
    return j < 0 ? ellipsis : ellipsis + text.slice($b4855ffaf649c526$export$9864f8d4d3d2fe51(text, j)).trimStart();
}
const $b4855ffaf649c526$var$reCombiner = /[\p{Combining_Mark}\p{Emoji_Modifier}]+/uy;
const $b4855ffaf649c526$var$rePictographic = /\p{Extended_Pictographic}/uy;
function $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i) {
    i += $b4855ffaf649c526$var$isSurrogatePair(text, i) ? 2 : 1;
    if ($b4855ffaf649c526$var$isCombiner(text, i)) i = $b4855ffaf649c526$var$reCombiner.lastIndex;
    if ($b4855ffaf649c526$var$isZeroWidthJoiner(text, i)) return $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i + 1);
    return i;
}
// We avoid more expensive regex tests involving Unicode property classes by
// first checking for the common case of 7-bit ASCII characters.
function $b4855ffaf649c526$var$isAscii(text, i) {
    return text.charCodeAt(i) < 0x80;
}
function $b4855ffaf649c526$var$isSurrogatePair(text, i) {
    const hi = text.charCodeAt(i);
    if (hi >= 0xd800 && hi < 0xdc00) {
        const lo = text.charCodeAt(i + 1);
        return lo >= 0xdc00 && lo < 0xe000;
    }
    return false;
}
function $b4855ffaf649c526$var$isZeroWidthJoiner(text, i) {
    return text.charCodeAt(i) === 0x200d;
}
function $b4855ffaf649c526$var$isCombiner(text, i) {
    return $b4855ffaf649c526$var$isAscii(text, i) ? false : ($b4855ffaf649c526$var$reCombiner.lastIndex = i, $b4855ffaf649c526$var$reCombiner.test(text));
}
function $b4855ffaf649c526$var$isPictographic(text, i) {
    return $b4855ffaf649c526$var$isAscii(text, i) ? false : ($b4855ffaf649c526$var$rePictographic.lastIndex = i, $b4855ffaf649c526$var$rePictographic.test(text));
}








const $2d02506c373828f7$var$defaults = {
    ariaLabel: "vector",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
};
const $2d02506c373828f7$var$defaultRadius = 3.5;
// The size of the arrowhead is proportional to its length, but we still allow
// the relative size of the head to be controlled via the mark’s width option;
// doubling the default radius will produce an arrowhead that is twice as big.
// That said, we’ll probably want a arrow with a fixed head size, too.
const $2d02506c373828f7$var$wingRatio = $2d02506c373828f7$var$defaultRadius * 5;
const $2d02506c373828f7$var$shapeArrow = {
    draw (context, l, r) {
        const wing = l * r / $2d02506c373828f7$var$wingRatio;
        context.moveTo(0, 0);
        context.lineTo(0, -l);
        context.moveTo(-wing, wing - l);
        context.lineTo(0, -l);
        context.lineTo(wing, wing - l);
    }
};
const $2d02506c373828f7$var$shapeSpike = {
    draw (context, l, r) {
        context.moveTo(-r, 0);
        context.lineTo(0, -l);
        context.lineTo(r, 0);
    }
};
const $2d02506c373828f7$var$shapes = new Map([
    [
        "arrow",
        $2d02506c373828f7$var$shapeArrow
    ],
    [
        "spike",
        $2d02506c373828f7$var$shapeSpike
    ]
]);
function $2d02506c373828f7$var$isShapeObject(value) {
    return value && typeof value.draw === "function";
}
function $2d02506c373828f7$var$maybeShape(shape) {
    if ($2d02506c373828f7$var$isShapeObject(shape)) return shape;
    const value = $2d02506c373828f7$var$shapes.get(`${shape}`.toLowerCase());
    if (value) return value;
    throw new Error(`invalid shape: ${shape}`);
}
class $2d02506c373828f7$export$9b781de7bf37bf48 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, r: r = $2d02506c373828f7$var$defaultRadius, length: length, rotate: rotate, shape: shape = $2d02506c373828f7$var$shapeArrow, anchor: anchor = "middle", frameAnchor: frameAnchor } = options;
        const [vl, cl] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(length, 12);
        const [vr, cr] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(rotate, 0);
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            length: {
                value: vl,
                scale: "length",
                optional: true
            },
            rotate: {
                value: vr,
                optional: true
            }
        }, options, $2d02506c373828f7$var$defaults);
        this.r = +r;
        this.length = cl;
        this.rotate = cr;
        this.shape = $2d02506c373828f7$var$maybeShape(shape);
        this.anchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(anchor, "anchor", [
            "start",
            "middle",
            "end"
        ]);
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y: Y, length: L, rotate: A } = channels;
        const { length: length, rotate: rotate, anchor: anchor, shape: shape, r: r } = this;
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append("path").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("transform", (0, $bfd513fc05083823$export$ce69bd05624d0c48)`translate(${X ? (i)=>X[i] : cx},${Y ? (i)=>Y[i] : cy})${A ? (i)=>` rotate(${A[i]})` : rotate ? ` rotate(${rotate})` : ``}${anchor === "start" ? `` : anchor === "end" ? L ? (i)=>` translate(0,${L[i]})` : ` translate(0,${length})` : L ? (i)=>` translate(0,${L[i] / 2})` : ` translate(0,${length / 2})`}`).attr("d", L ? (i)=>{
                const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                shape.draw(p, L[i], r);
                return p;
            } : (()=>{
                const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                shape.draw(p, length, r);
                return p;
            })()).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels)).node();
    }
}
function $2d02506c373828f7$export$6074e20ba5c64bef(data, options = {}) {
    let { x: x, y: y, ...rest } = options;
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $2d02506c373828f7$export$9b781de7bf37bf48(data, {
        ...rest,
        x: x,
        y: y
    });
}
function $2d02506c373828f7$export$dc781e748fde228d(data, options = {}) {
    const { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...rest } = options;
    return new $2d02506c373828f7$export$9b781de7bf37bf48(data, {
        ...rest,
        x: x
    });
}
function $2d02506c373828f7$export$326ea72b1565acd6(data, options = {}) {
    const { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...rest } = options;
    return new $2d02506c373828f7$export$9b781de7bf37bf48(data, {
        ...rest,
        y: y
    });
}
function $2d02506c373828f7$export$a9313a4740510eae(data, options = {}) {
    const { shape: shape = $2d02506c373828f7$var$shapeSpike, stroke: stroke = $2d02506c373828f7$var$defaults.stroke, strokeWidth: strokeWidth = 1, fill: fill = stroke, fillOpacity: fillOpacity = 0.3, anchor: anchor = "start", ...rest } = options;
    return $2d02506c373828f7$export$6074e20ba5c64bef(data, {
        ...rest,
        shape: shape,
        stroke: stroke,
        strokeWidth: strokeWidth,
        fill: fill,
        fillOpacity: fillOpacity,
        anchor: anchor
    });
}


function $fcb78e8696b500a3$var$maybeData(data, options) {
    if (arguments.length < 2 && !(0, $cd9e805a4bbd13f9$export$9652023d9040757)(data)) options = data, data = null;
    if (options === undefined) options = {};
    return [
        data,
        options
    ];
}
function $fcb78e8696b500a3$var$maybeAnchor({ anchor: anchor } = {}, anchors) {
    return anchor === undefined ? anchors[0] : (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(anchor, "anchor", anchors);
}
function $fcb78e8696b500a3$var$anchorY(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "left",
        "right"
    ]);
}
function $fcb78e8696b500a3$var$anchorFy(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "right",
        "left"
    ]);
}
function $fcb78e8696b500a3$var$anchorX(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "bottom",
        "top"
    ]);
}
function $fcb78e8696b500a3$var$anchorFx(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "top",
        "bottom"
    ]);
}
function $fcb78e8696b500a3$export$e4a0de62e0e52fb4() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKy("y", $fcb78e8696b500a3$var$anchorY(options), data, options);
}
function $fcb78e8696b500a3$export$3cb762475a490c3b() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKy("fy", $fcb78e8696b500a3$var$anchorFy(options), data, options);
}
function $fcb78e8696b500a3$export$5bc1a9741b148b9f() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKx("x", $fcb78e8696b500a3$var$anchorX(options), data, options);
}
function $fcb78e8696b500a3$export$cf6d8c730042fe7f() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKx("fx", $fcb78e8696b500a3$var$anchorFx(options), data, options);
}
function $fcb78e8696b500a3$var$axisKy(k, anchor, data, { color: color = "currentColor", opacity: opacity = 1, stroke: stroke = color, strokeOpacity: strokeOpacity = opacity, strokeWidth: strokeWidth = 1, fill: fill = color, fillOpacity: fillOpacity = opacity, textAnchor: textAnchor, textStroke: textStroke, textStrokeOpacity: textStrokeOpacity, textStrokeWidth: textStrokeWidth, tickSize: tickSize = k === "y" ? 6 : 0, tickPadding: tickPadding, tickRotate: tickRotate, x: x, margin: margin, marginTop: marginTop = margin === undefined ? 20 : margin, marginRight: marginRight = margin === undefined ? anchor === "right" ? 40 : 0 : margin, marginBottom: marginBottom = margin === undefined ? 20 : margin, marginLeft: marginLeft = margin === undefined ? anchor === "left" ? 40 : 0 : margin, label: label, labelAnchor: labelAnchor, labelArrow: labelArrow, labelOffset: labelOffset, ...options }) {
    tickSize = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickSize);
    tickPadding = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickPadding);
    tickRotate = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickRotate);
    if (labelAnchor !== undefined) labelAnchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(labelAnchor, "labelAnchor", [
        "center",
        "top",
        "bottom"
    ]);
    labelArrow = $fcb78e8696b500a3$var$maybeLabelArrow(labelArrow);
    return (0, $24d8c38d667d16c2$export$3a8025f2f3e0c64)(tickSize && !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(stroke) ? $fcb78e8696b500a3$var$axisTickKy(k, anchor, data, {
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        x: x,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) ? $fcb78e8696b500a3$var$axisTextKy(k, anchor, data, {
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: textStroke,
        strokeOpacity: textStrokeOpacity,
        strokeWidth: textStrokeWidth,
        textAnchor: textAnchor,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        x: x,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) && label !== null ? (0, $b4855ffaf649c526$export$6f093cfa640b7166)([], $fcb78e8696b500a3$var$labelOptions({
        fill: fill,
        fillOpacity: fillOpacity,
        ...options
    }, function(data, facets, channels, scales, dimensions) {
        const scale = scales[k];
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft } = k === "y" && dimensions.inset || dimensions;
        const cla = labelAnchor ?? (scale.bandwidth ? "center" : "top");
        const clo = labelOffset ?? (anchor === "right" ? marginRight : marginLeft) - 3;
        if (cla === "center") {
            this.textAnchor = undefined; // middle
            this.lineAnchor = anchor === "right" ? "bottom" : "top";
            this.frameAnchor = anchor;
            this.rotate = -90;
        } else {
            this.textAnchor = anchor === "right" ? "end" : "start";
            this.lineAnchor = cla;
            this.frameAnchor = `${cla}-${anchor}`;
            this.rotate = 0;
        }
        this.dy = cla === "top" ? 3 - marginTop : cla === "bottom" ? marginBottom - 3 : 0;
        this.dx = anchor === "right" ? clo : -clo;
        this.ariaLabel = `${k}-axis label`;
        return {
            facets: [
                [
                    0
                ]
            ],
            channels: {
                text: {
                    value: [
                        $fcb78e8696b500a3$var$formatAxisLabel(k, scale, {
                            anchor: anchor,
                            label: label,
                            labelAnchor: cla,
                            labelArrow: labelArrow
                        })
                    ]
                }
            }
        };
    })) : null);
}
function $fcb78e8696b500a3$var$axisKx(k, anchor, data, { color: color = "currentColor", opacity: opacity = 1, stroke: stroke = color, strokeOpacity: strokeOpacity = opacity, strokeWidth: strokeWidth = 1, fill: fill = color, fillOpacity: fillOpacity = opacity, textAnchor: textAnchor, textStroke: textStroke, textStrokeOpacity: textStrokeOpacity, textStrokeWidth: textStrokeWidth, tickSize: tickSize = k === "x" ? 6 : 0, tickPadding: tickPadding, tickRotate: tickRotate, y: y, margin: margin, marginTop: marginTop = margin === undefined ? anchor === "top" ? 30 : 0 : margin, marginRight: marginRight = margin === undefined ? 20 : margin, marginBottom: marginBottom = margin === undefined ? anchor === "bottom" ? 30 : 0 : margin, marginLeft: marginLeft = margin === undefined ? 20 : margin, label: label, labelAnchor: labelAnchor, labelArrow: labelArrow, labelOffset: labelOffset, ...options }) {
    tickSize = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickSize);
    tickPadding = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickPadding);
    tickRotate = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickRotate);
    if (labelAnchor !== undefined) labelAnchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(labelAnchor, "labelAnchor", [
        "center",
        "left",
        "right"
    ]);
    labelArrow = $fcb78e8696b500a3$var$maybeLabelArrow(labelArrow);
    return (0, $24d8c38d667d16c2$export$3a8025f2f3e0c64)(tickSize && !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(stroke) ? $fcb78e8696b500a3$var$axisTickKx(k, anchor, data, {
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        y: y,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) ? $fcb78e8696b500a3$var$axisTextKx(k, anchor, data, {
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: textStroke,
        strokeOpacity: textStrokeOpacity,
        strokeWidth: textStrokeWidth,
        textAnchor: textAnchor,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        y: y,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) && label !== null ? (0, $b4855ffaf649c526$export$6f093cfa640b7166)([], $fcb78e8696b500a3$var$labelOptions({
        fill: fill,
        fillOpacity: fillOpacity,
        ...options
    }, function(data, facets, channels, scales, dimensions) {
        const scale = scales[k];
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft } = k === "x" && dimensions.inset || dimensions;
        const cla = labelAnchor ?? (scale.bandwidth ? "center" : "right");
        const clo = labelOffset ?? (anchor === "top" ? marginTop : marginBottom) - 3;
        if (cla === "center") {
            this.frameAnchor = anchor;
            this.textAnchor = undefined; // middle
        } else {
            this.frameAnchor = `${anchor}-${cla}`;
            this.textAnchor = cla === "right" ? "end" : "start";
        }
        this.lineAnchor = anchor;
        this.dy = anchor === "top" ? -clo : clo;
        this.dx = cla === "right" ? marginRight - 3 : cla === "left" ? 3 - marginLeft : 0;
        this.ariaLabel = `${k}-axis label`;
        return {
            facets: [
                [
                    0
                ]
            ],
            channels: {
                text: {
                    value: [
                        $fcb78e8696b500a3$var$formatAxisLabel(k, scale, {
                            anchor: anchor,
                            label: label,
                            labelAnchor: cla,
                            labelArrow: labelArrow
                        })
                    ]
                }
            }
        };
    })) : null);
}
function $fcb78e8696b500a3$var$axisTickKy(k, anchor, data, { strokeWidth: strokeWidth = 1, strokeLinecap: strokeLinecap = null, strokeLinejoin: strokeLinejoin = null, facetAnchor: facetAnchor = anchor + (k === "y" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, inset: inset = 0, insetLeft: insetLeft = inset, insetRight: insetRight = inset, dx: dx = 0, y: y = k === "y" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $2d02506c373828f7$export$326ea72b1565acd6), k, data, {
        ariaLabel: `${k}-axis tick`,
        ariaHidden: true
    }, {
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin,
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        y: y,
        ...options,
        dx: anchor === "left" ? +dx - (0, $547e5698440387a8$export$cc800923e997bb8) + +insetLeft : +dx + (0, $547e5698440387a8$export$cc800923e997bb8) - insetRight,
        anchor: "start",
        length: tickSize,
        shape: anchor === "left" ? $fcb78e8696b500a3$var$shapeTickLeft : $fcb78e8696b500a3$var$shapeTickRight
    });
}
function $fcb78e8696b500a3$var$axisTickKx(k, anchor, data, { strokeWidth: strokeWidth = 1, strokeLinecap: strokeLinecap = null, strokeLinejoin: strokeLinejoin = null, facetAnchor: facetAnchor = anchor + (k === "x" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, inset: inset = 0, insetTop: insetTop = inset, insetBottom: insetBottom = inset, dy: dy = 0, x: x = k === "x" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $2d02506c373828f7$export$dc781e748fde228d), k, data, {
        ariaLabel: `${k}-axis tick`,
        ariaHidden: true
    }, {
        strokeWidth: strokeWidth,
        strokeLinejoin: strokeLinejoin,
        strokeLinecap: strokeLinecap,
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        x: x,
        ...options,
        dy: anchor === "bottom" ? +dy - (0, $547e5698440387a8$export$cc800923e997bb8) - insetBottom : +dy + (0, $547e5698440387a8$export$cc800923e997bb8) + +insetTop,
        anchor: "start",
        length: tickSize,
        shape: anchor === "bottom" ? $fcb78e8696b500a3$var$shapeTickBottom : $fcb78e8696b500a3$var$shapeTickTop
    });
}
function $fcb78e8696b500a3$var$axisTextKy(k, anchor, data, { facetAnchor: facetAnchor = anchor + (k === "y" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, tickRotate: tickRotate = 0, tickPadding: tickPadding = Math.max(3, 9 - tickSize) + (Math.abs(tickRotate) > 60 ? 4 * Math.cos(tickRotate * (0, $313afcb1ba78b0a6$export$8449e153fbd325fc)) : 0), text: text, textAnchor: textAnchor = Math.abs(tickRotate) > 60 ? "middle" : anchor === "left" ? "end" : "start", lineAnchor: lineAnchor = tickRotate > 60 ? "top" : tickRotate < -60 ? "bottom" : "middle", fontVariant: fontVariant, inset: inset = 0, insetLeft: insetLeft = inset, insetRight: insetRight = inset, dx: dx = 0, y: y = k === "y" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $b4855ffaf649c526$export$b11955fec8f4d045), k, data, {
        ariaLabel: `${k}-axis tick label`
    }, {
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        text: text,
        textAnchor: textAnchor,
        lineAnchor: lineAnchor,
        fontVariant: fontVariant,
        rotate: tickRotate,
        y: y,
        ...options,
        dx: anchor === "left" ? +dx - tickSize - tickPadding + +insetLeft : +dx + +tickSize + +tickPadding - insetRight
    }, function(scale, data, ticks, tickFormat, channels) {
        if (fontVariant === undefined) this.fontVariant = $fcb78e8696b500a3$var$inferFontVariant(scale);
        if (text === undefined) channels.text = $fcb78e8696b500a3$var$inferTextChannel(scale, data, ticks, tickFormat, anchor);
    });
}
function $fcb78e8696b500a3$var$axisTextKx(k, anchor, data, { facetAnchor: facetAnchor = anchor + (k === "x" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, tickRotate: tickRotate = 0, tickPadding: tickPadding = Math.max(3, 9 - tickSize) + (Math.abs(tickRotate) >= 10 ? 4 * Math.cos(tickRotate * (0, $313afcb1ba78b0a6$export$8449e153fbd325fc)) : 0), text: text, textAnchor: textAnchor = Math.abs(tickRotate) >= 10 ? tickRotate < 0 ^ anchor === "bottom" ? "start" : "end" : "middle", lineAnchor: lineAnchor = Math.abs(tickRotate) >= 10 ? "middle" : anchor === "bottom" ? "top" : "bottom", fontVariant: fontVariant, inset: inset = 0, insetTop: insetTop = inset, insetBottom: insetBottom = inset, dy: dy = 0, x: x = k === "x" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $b4855ffaf649c526$export$5aac532f27b03078), k, data, {
        ariaLabel: `${k}-axis tick label`
    }, {
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        text: text === undefined ? null : text,
        textAnchor: textAnchor,
        lineAnchor: lineAnchor,
        fontVariant: fontVariant,
        rotate: tickRotate,
        x: x,
        ...options,
        dy: anchor === "bottom" ? +dy + +tickSize + +tickPadding - insetBottom : +dy - tickSize - tickPadding + +insetTop
    }, function(scale, data, ticks, tickFormat, channels) {
        if (fontVariant === undefined) this.fontVariant = $fcb78e8696b500a3$var$inferFontVariant(scale);
        if (text === undefined) channels.text = $fcb78e8696b500a3$var$inferTextChannel(scale, data, ticks, tickFormat, anchor);
    });
}
function $fcb78e8696b500a3$export$7510dfed5fcfcd8f() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKy("y", $fcb78e8696b500a3$var$anchorY(options), data, options);
}
function $fcb78e8696b500a3$export$7093722adfac6b64() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKy("fy", $fcb78e8696b500a3$var$anchorFy(options), data, options);
}
function $fcb78e8696b500a3$export$6ac963799f18e4c() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKx("x", $fcb78e8696b500a3$var$anchorX(options), data, options);
}
function $fcb78e8696b500a3$export$8d672a2bd8b3cb8b() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKx("fx", $fcb78e8696b500a3$var$anchorFx(options), data, options);
}
function $fcb78e8696b500a3$var$gridKy(k, anchor, data, { y: y = k === "y" ? undefined : null, x: x = null, x1: x1 = anchor === "left" ? x : null, x2: x2 = anchor === "right" ? x : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $60ff8edb66755c31$export$d121b88bc74f6ae5), k, data, {
        ariaLabel: `${k}-grid`,
        ariaHidden: true
    }, {
        y: y,
        x1: x1,
        x2: x2,
        ...$fcb78e8696b500a3$var$gridDefaults(options)
    });
}
function $fcb78e8696b500a3$var$gridKx(k, anchor, data, { x: x = k === "x" ? undefined : null, y: y = null, y1: y1 = anchor === "top" ? y : null, y2: y2 = anchor === "bottom" ? y : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $60ff8edb66755c31$export$22653c04c6d89eeb), k, data, {
        ariaLabel: `${k}-grid`,
        ariaHidden: true
    }, {
        x: x,
        y1: y1,
        y2: y2,
        ...$fcb78e8696b500a3$var$gridDefaults(options)
    });
}
function $fcb78e8696b500a3$var$gridDefaults({ color: color = "currentColor", opacity: opacity = 0.1, stroke: stroke = color, strokeOpacity: strokeOpacity = opacity, strokeWidth: strokeWidth = 1, ...options }) {
    return {
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth,
        ...options
    };
}
function $fcb78e8696b500a3$var$labelOptions({ fill: fill, fillOpacity: fillOpacity, fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontVariant: fontVariant, fontWeight: fontWeight, monospace: monospace, pointerEvents: pointerEvents, shapeRendering: shapeRendering, clip: clip = false }, initializer) {
    // Only propagate these options if constant.
    [, fill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    [, fillOpacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(fillOpacity);
    return {
        facet: "super",
        x: null,
        y: null,
        fill: fill,
        fillOpacity: fillOpacity,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight,
        monospace: monospace,
        pointerEvents: pointerEvents,
        shapeRendering: shapeRendering,
        clip: clip,
        initializer: initializer
    };
}
function $fcb78e8696b500a3$var$axisMark(mark, k, data, properties, options, initialize) {
    let channels;
    function axisInitializer(data, facets, _channels, scales, dimensions, context) {
        const initializeFacets = data == null && (k === "fx" || k === "fy");
        const { [k]: scale } = scales;
        if (!scale) throw new Error(`missing scale: ${k}`);
        const domain = scale.domain();
        let { interval: interval, ticks: ticks, tickFormat: tickFormat, tickSpacing: tickSpacing = k === "x" ? 80 : 35 } = options;
        // For a scale with a temporal domain, also allow the ticks to be specified
        // as a string which is promoted to a time interval. In the case of ordinal
        // scales, the interval is interpreted as UTC.
        if (typeof ticks === "string" && $fcb78e8696b500a3$var$hasTemporalDomain(scale)) interval = ticks, ticks = undefined;
        // The interval axis option is an alternative method of specifying ticks;
        // for example, for a numeric scale, ticks = 5 means “about 5 ticks” whereas
        // interval = 5 means “ticks every 5 units”. (This is not to be confused
        // with the interval scale option, which affects the scale’s behavior!)
        // Lastly use the tickSpacing option to infer the desired tick count.
        if (ticks === undefined) ticks = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, scale.type) ?? $fcb78e8696b500a3$var$inferTickCount(scale, tickSpacing);
        if (data == null) {
            if ((0, $cd9e805a4bbd13f9$export$9652023d9040757)(ticks)) // Use explicit ticks, if specified.
            data = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(ticks);
            else if ((0, $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e)(ticks)) // Use the tick interval, if specified.
            data = $fcb78e8696b500a3$var$inclusiveRange(ticks, ...(0, $24461355656d8852$export$2e2bcd8739ae039)(domain));
            else if (scale.interval) {
                // If the scale interval is a standard time interval such as "day", we
                // may be able to generalize the scale interval it to a larger aligned
                // time interval to create the desired number of ticks.
                let interval = scale.interval;
                if (scale.ticks) {
                    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
                    const n = (max - min) / interval[0, $49e9bdee870d78f0$export$6b9291a5690ab4c6]; // current tick count
                    // We don’t explicitly check that given interval is a time interval;
                    // in that case the generalized interval will be undefined, just like
                    // a nonstandard interval. TODO Generalize integer intervals, too.
                    interval = (0, $49e9bdee870d78f0$export$29a4ccaf5efe074d)(interval, n / ticks) ?? interval;
                    data = $fcb78e8696b500a3$var$inclusiveRange(interval, min, max);
                } else {
                    data = domain;
                    const n = data.length; // current tick count
                    interval = (0, $49e9bdee870d78f0$export$29a4ccaf5efe074d)(interval, n / ticks) ?? interval;
                    if (interval !== scale.interval) data = $fcb78e8696b500a3$var$inclusiveRange(interval, ...(0, $24461355656d8852$export$2e2bcd8739ae039)(data));
                }
                if (interval === scale.interval) {
                    // If we weren’t able to generalize the scale’s interval, compute the
                    // positive number n such that taking every nth value from the scale’s
                    // domain produces as close as possible to the desired number of
                    // ticks. For example, if the domain has 100 values and 5 ticks are
                    // desired, n = 20.
                    const n = Math.round(data.length / ticks);
                    if (n > 1) data = data.filter((d, i)=>i % n === 0);
                }
            } else if (scale.ticks) data = scale.ticks(ticks);
            else // For ordinal scales, the domain will already be generated using the
            // scale’s interval, if any.
            data = domain;
            if (!scale.ticks && data.length && data !== domain) {
                // For ordinal scales, intersect the ticks with the scale domain since
                // the scale is only defined on its domain. If all of the ticks are
                // removed, then warn that the ticks and scale domain may be misaligned
                // (e.g., "year" ticks and "4 weeks" interval).
                const domainSet = new (0, $3160658555deb5c9$export$55278c3294239828)(domain);
                data = data.filter((d)=>domainSet.has(d));
                if (!data.length) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the ${k}-axis ticks appear to not align with the scale domain, resulting in no ticks. Try different ticks?`); // prettier-ignore
            }
            if (k === "y" || k === "x") facets = [
                (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data)
            ];
            else channels[k] = {
                scale: k,
                value: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)
            };
        }
        initialize?.call(this, scale, data, ticks, tickFormat, channels);
        const initializedChannels = Object.fromEntries(Object.entries(channels).map(([name, channel])=>{
            return [
                name,
                {
                    ...channel,
                    value: (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, channel.value)
                }
            ];
        }));
        if (initializeFacets) facets = context.filterFacets(data, initializedChannels);
        return {
            data: data,
            facets: facets,
            channels: initializedChannels
        };
    }
    // Apply any basic initializers after the axis initializer computes the ticks.
    const basicInitializer = (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)(options).initializer;
    const m = mark(data, (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)({
        ...options,
        initializer: axisInitializer
    }, basicInitializer));
    if (data == null) {
        channels = m.channels;
        m.channels = {};
    } else channels = {};
    if (properties !== undefined) Object.assign(m, properties);
    if (m.clip === undefined) m.clip = false; // don’t clip axes by default
    return m;
}
function $fcb78e8696b500a3$var$inferTickCount(scale, tickSpacing) {
    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(scale.range());
    return (max - min) / tickSpacing;
}
function $fcb78e8696b500a3$var$inferTextChannel(scale, data, ticks, tickFormat, anchor) {
    return {
        value: $fcb78e8696b500a3$export$c2c6970049f8b561(scale, data, ticks, tickFormat, anchor)
    };
}
function $fcb78e8696b500a3$export$c2c6970049f8b561(scale, data, ticks, tickFormat, anchor) {
    return typeof tickFormat === "function" && !(scale.type === "log" && scale.tickFormat) ? tickFormat : tickFormat === undefined && data && (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(data) ? (0, $49e9bdee870d78f0$export$8d2dceb4d1e6fd24)(scale.type, data, anchor) ?? (0, $4b16c4377cd1e2de$export$bb457229db2006fb) : scale.tickFormat ? scale.tickFormat(typeof ticks === "number" ? ticks : null, tickFormat) : tickFormat === undefined ? (0, $4b16c4377cd1e2de$export$bb457229db2006fb) : typeof tickFormat === "string" ? ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(scale.domain()) ? (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb) : (0, $54a757fa53542946$export$d9468344d3651243))(tickFormat) : (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)(tickFormat);
}
function $fcb78e8696b500a3$var$inclusiveRange(interval, min, max) {
    return interval.range(min, interval.offset(interval.floor(max)));
}
const $fcb78e8696b500a3$var$shapeTickBottom = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(0, l);
    }
};
const $fcb78e8696b500a3$var$shapeTickTop = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(0, -l);
    }
};
const $fcb78e8696b500a3$var$shapeTickLeft = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(-l, 0);
    }
};
const $fcb78e8696b500a3$var$shapeTickRight = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(l, 0);
    }
};
// TODO Unify this with the other inferFontVariant; here we only have a scale
// function rather than a scale descriptor.
function $fcb78e8696b500a3$var$inferFontVariant(scale) {
    return scale.bandwidth && !scale.interval ? undefined : "tabular-nums";
}
// Takes the scale label, and if this is not an ordinal scale and the label was
// inferred from an associated channel, adds an orientation-appropriate arrow.
function $fcb78e8696b500a3$var$formatAxisLabel(k, scale, { anchor: anchor, label: label = scale.label, labelAnchor: labelAnchor, labelArrow: labelArrow } = {}) {
    if (label == null || label.inferred && $fcb78e8696b500a3$var$hasTemporalDomain(scale) && /^(date|time|year)$/i.test(label)) return;
    label = String(label); // coerce to a string after checking if inferred
    if (labelArrow === "auto") labelArrow = (!scale.bandwidth || scale.interval) && !/[↑↓→←]/.test(label);
    if (!labelArrow) return label;
    if (labelArrow === true) {
        const order = (0, $d2c16f7a6010a221$export$cb20e1306358cc06)(scale);
        if (order) labelArrow = /x$/.test(k) || labelAnchor === "center" ? /x$/.test(k) === order < 0 ? "left" : "right" : order < 0 ? "up" : "down";
    }
    switch(labelArrow){
        case "left":
            return `\u{2190} ${label}`;
        case "right":
            return `${label} \u{2192}`;
        case "up":
            return anchor === "right" ? `${label} \u{2191}` : `\u{2191} ${label}`;
        case "down":
            return anchor === "right" ? `${label} \u{2193}` : `\u{2193} ${label}`;
    }
    return label;
}
function $fcb78e8696b500a3$var$maybeLabelArrow(labelArrow = "auto") {
    return (0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(labelArrow) ? false : typeof labelArrow === "boolean" ? labelArrow : (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(labelArrow, "labelArrow", [
        "auto",
        "up",
        "right",
        "down",
        "left"
    ]);
}
function $fcb78e8696b500a3$var$hasTemporalDomain(scale) {
    return (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(scale.domain());
}


function $c9ad7b4f4b4e94b8$var$maybeScale(scale, key) {
    if (key == null) return key;
    const s = scale(key);
    if (!s) throw new Error(`scale not found: ${key}`);
    return s;
}
function $c9ad7b4f4b4e94b8$export$20b28fb174c65a54(color, { opacity: opacity, ...options } = {}) {
    if (!(0, $d2c16f7a6010a221$export$61579433626afe87)(color) && !(0, $d2c16f7a6010a221$export$667642af40ee0f01)(color)) throw new Error(`swatches legend requires ordinal or threshold color scale (not ${color.type})`);
    return $c9ad7b4f4b4e94b8$var$legendItems(color, options, (selection, scale, width, height)=>selection.append("svg").attr("width", width).attr("height", height).attr("fill", scale.scale).attr("fill-opacity", (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(opacity)[1]).append("rect").attr("width", "100%").attr("height", "100%"));
}
function $c9ad7b4f4b4e94b8$export$99df2788a81f2501(symbol, { fill: fill = symbol.hint?.fill !== undefined ? symbol.hint.fill : "none", fillOpacity: fillOpacity = 1, stroke: stroke = symbol.hint?.stroke !== undefined ? symbol.hint.stroke : (0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) ? "currentColor" : "none", strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth = 1.5, r: r = 4.5, ...options } = {}, scale) {
    const [vf, cf] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    const [vs, cs] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke);
    const sf = $c9ad7b4f4b4e94b8$var$maybeScale(scale, vf);
    const ss = $c9ad7b4f4b4e94b8$var$maybeScale(scale, vs);
    const size = r * r * Math.PI;
    fillOpacity = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(fillOpacity)[1];
    strokeOpacity = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeOpacity)[1];
    strokeWidth = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeWidth)[1];
    return $c9ad7b4f4b4e94b8$var$legendItems(symbol, options, (selection, scale, width, height)=>selection.append("svg").attr("viewBox", "-8 -8 16 16").attr("width", width).attr("height", height).attr("fill", vf === "color" ? (d)=>sf.scale(d) : cf).attr("fill-opacity", fillOpacity).attr("stroke", vs === "color" ? (d)=>ss.scale(d) : cs).attr("stroke-opacity", strokeOpacity).attr("stroke-width", strokeWidth).append("path").attr("d", (d)=>{
            const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
            symbol.scale(d).draw(p, size);
            return p;
        }));
}
function $c9ad7b4f4b4e94b8$var$legendItems(scale, options = {}, swatch) {
    let { columns: columns, tickFormat: tickFormat, fontVariant: fontVariant = (0, $5349c8aa18563753$export$57ccd2691f3b457e)(scale), swatchSize: // TODO label,
    swatchSize = 15, swatchWidth: swatchWidth = swatchSize, swatchHeight: swatchHeight = swatchSize, marginLeft: marginLeft = 0, className: className, style: style, width: width } = options;
    const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
    className = (0, $547e5698440387a8$export$22300e6eaecca37)(className);
    tickFormat = (0, $fcb78e8696b500a3$export$c2c6970049f8b561)(scale.scale, scale.domain, undefined, tickFormat);
    const swatches = (0, $871355576fc3efd9$export$185802fd694ee1f5)("div", context).attr("class", `${className}-swatches ${className}-swatches-${columns != null ? "columns" : "wrap"}`);
    let extraStyle;
    if (columns != null) {
        extraStyle = `:where(.${className}-swatches-columns .${className}-swatch) {
  display: flex;
  align-items: center;
  break-inside: avoid;
  padding-bottom: 1px;
}
:where(.${className}-swatches-columns .${className}-swatch::before) {
  flex-shrink: 0;
}
:where(.${className}-swatches-columns .${className}-swatch-label) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`;
        swatches.style("columns", columns).selectAll().data(scale.domain).enter().append("div").attr("class", `${className}-swatch`).call(swatch, scale, swatchWidth, swatchHeight).call((item)=>item.append("div").attr("class", `${className}-swatch-label`).attr("title", tickFormat).text(tickFormat));
    } else {
        extraStyle = `:where(.${className}-swatches-wrap) {
  display: flex;
  align-items: center;
  min-height: 33px;
  flex-wrap: wrap;
}
:where(.${className}-swatches-wrap .${className}-swatch) {
  display: inline-flex;
  align-items: center;
  margin-right: 1em;
}`;
        swatches.selectAll().data(scale.domain).enter().append("span").attr("class", `${className}-swatch`).call(swatch, scale, swatchWidth, swatchHeight).append(function() {
            return this.ownerDocument.createTextNode(tickFormat.apply(this, arguments));
        });
    }
    return swatches.call((div)=>div.insert("style", "*").text(`:where(.${className}-swatches) {
  font-family: system-ui, sans-serif;
  font-size: 10px;
  margin-bottom: 0.5em;
}
:where(.${className}-swatch > svg) {
  margin-right: 0.5em;
  overflow: visible;
}
${extraStyle}`)).style("margin-left", marginLeft ? `${+marginLeft}px` : null).style("width", width === undefined ? null : `${+width}px`).style("font-variant", (0, $547e5698440387a8$export$e1c487990851f09f)(fontVariant, "normal")).call((0, $547e5698440387a8$export$4e6c5cc1af44143e), style).node();
}




const $e6941eca40ba0848$var$legendRegistry = new Map([
    [
        "symbol",
        (0, $c9ad7b4f4b4e94b8$export$99df2788a81f2501)
    ],
    [
        "color",
        $e6941eca40ba0848$var$legendColor
    ],
    [
        "opacity",
        $e6941eca40ba0848$var$legendOpacity
    ]
]);
function $e6941eca40ba0848$export$9a9b59e08de24cef(options = {}) {
    for (const [key, value] of $e6941eca40ba0848$var$legendRegistry){
        const scale = options[key];
        if ((0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(scale)) {
            // e.g., ignore {color: "red"}
            const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
            let hint;
            // For symbol legends, pass a hint to the symbol scale.
            if (key === "symbol") {
                const { fill: fill, stroke: stroke = fill === undefined && (0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options.color) ? "color" : undefined } = options;
                hint = {
                    fill: fill,
                    stroke: stroke
                };
            }
            return value((0, $d2c16f7a6010a221$export$a566bffc16069997)(key, scale, hint), $e6941eca40ba0848$var$legendOptions(context, scale, options), (key)=>(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options[key]) ? (0, $d2c16f7a6010a221$export$a566bffc16069997)(key, options[key]) : null);
        }
    }
    throw new Error("unknown legend type; no scale found");
}
function $e6941eca40ba0848$export$d2e05e4b3a11ee5a(scales, context, defaults = {}) {
    return (key, options)=>{
        if (!$e6941eca40ba0848$var$legendRegistry.has(key)) throw new Error(`unknown legend type: ${key}`);
        if (!(key in scales)) return;
        return $e6941eca40ba0848$var$legendRegistry.get(key)(scales[key], $e6941eca40ba0848$var$legendOptions(context, defaults[key], options), (key)=>scales[key]);
    };
}
function $e6941eca40ba0848$var$legendOptions({ className: className, ...context }, { label: label, ticks: ticks, tickFormat: tickFormat } = {}, options) {
    return (0, $cd9e805a4bbd13f9$export$4dc9a6b0ae3dfd2a)(options, {
        className: className,
        ...context
    }, {
        label: label,
        ticks: ticks,
        tickFormat: tickFormat
    });
}
function $e6941eca40ba0848$var$legendColor(color, { legend: legend = true, ...options }) {
    if (legend === true) legend = color.type === "ordinal" ? "swatches" : "ramp";
    if (color.domain === undefined) return; // no identity legend
    switch(`${legend}`.toLowerCase()){
        case "swatches":
            return (0, $c9ad7b4f4b4e94b8$export$20b28fb174c65a54)(color, options);
        case "ramp":
            return (0, $0e1b3cfced53194d$export$cc0ec4119b9c7105)(color, options);
        default:
            throw new Error(`unknown legend type: ${legend}`);
    }
}
function $e6941eca40ba0848$var$legendOpacity({ type: type, interpolate: interpolate, ...scale }, { legend: legend = true, color: color = (0, $bYoiY.rgb)(0, 0, 0), ...options }) {
    if (!interpolate) throw new Error(`${type} opacity scales are not supported`);
    if (legend === true) legend = "ramp";
    if (`${legend}`.toLowerCase() !== "ramp") throw new Error(`${legend} opacity legends are not supported`);
    return $e6941eca40ba0848$var$legendColor({
        type: type,
        ...scale,
        interpolate: $e6941eca40ba0848$var$interpolateOpacity(color)
    }, {
        legend: legend,
        ...options
    });
}
function $e6941eca40ba0848$var$interpolateOpacity(color) {
    const { r: r, g: g, b: b } = (0, $bYoiY.rgb)(color) || (0, $bYoiY.rgb)(0, 0, 0); // treat invalid color as black
    return (t)=>`rgba(${r},${g},${b},${t})`;
}
function $e6941eca40ba0848$export$7d86fc1221ad3a46(scales, context, options) {
    const legends = [];
    for (const [key, value] of $e6941eca40ba0848$var$legendRegistry){
        const o = options[key];
        if (o?.legend && key in scales) {
            const legend = value(scales[key], $e6941eca40ba0848$var$legendOptions(context, scales[key], o), (key)=>scales[key]);
            if (legend != null) legends.push(legend);
        }
    }
    return legends;
}














function $6c8df8405b475220$export$e882a15fe9f7109f(options = {}) {
    return (0, $cd9e805a4bbd13f9$export$98a86545e71eb684)(options) ? options : {
        ...options,
        x: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)
    };
}
function $6c8df8405b475220$export$463e88814e852032(options = {}) {
    return (0, $cd9e805a4bbd13f9$export$6fec46f4cb6f332e)(options) ? options : {
        ...options,
        y: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)
    };
}









function $cb1059f7206f9e40$export$27e5a8b25ef2b39d(data, facets) {
    if (facets.length === 1) return {
        data: data,
        facets: facets
    }; // only one facet; trivially exclusive
    const n = (0, $cd9e805a4bbd13f9$export$766772bbf464ff6)(data);
    const O = new Uint8Array(n);
    let overlaps = 0;
    // Count the number of overlapping indexes across facets.
    for (const facet of facets)for (const i of facet){
        if (O[i]) ++overlaps;
        O[i] = 1;
    }
    // Do nothing if the facets are already exclusive.
    if (overlaps === 0) return {
        data: data,
        facets: facets
    }; // facets are exclusive
    // For each overlapping index (duplicate), assign a new unique index at the
    // end of the existing array, duplicating the datum. For example, [[0, 1, 2],
    // [2, 1, 3]] would become [[0, 1, 2], [4, 5, 3]]. Also attach a reindex to
    // the data to preserve the association of channel values specified as arrays.
    data = (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(data);
    const R = data[0, $cd9e805a4bbd13f9$export$c800939f8d8c9f76] = new Uint32Array(n + overlaps);
    facets = facets.map((facet)=>(0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(facet, Uint32Array));
    let j = n;
    O.fill(0);
    for (const facet of facets)for(let k = 0, m = facet.length; k < m; ++k){
        const i = facet[k];
        if (O[i]) facet[k] = j, data[j] = data[i], R[j] = i, ++j;
        else R[i] = i;
        O[i] = 1;
    }
    return {
        data: data,
        facets: facets
    };
}


function $edd8a0486fa281c7$export$e2ca547456a8fee2(stackOptions = {}, options = {}) {
    if (arguments.length === 1) [stackOptions, options] = $edd8a0486fa281c7$var$mergeOptions(stackOptions);
    const { y1: y1, y: y = y1, x: x, ...rest } = options; // note: consumes x!
    const [transform, Y, x1, x2] = $edd8a0486fa281c7$var$stack(y, x, "y", "x", stackOptions, rest);
    return {
        ...transform,
        y1: y1,
        y: Y,
        x1: x1,
        x2: x2,
        x: (0, $cd9e805a4bbd13f9$export$a61423b330c3444c)(x1, x2)
    };
}
function $edd8a0486fa281c7$export$9c889d1b7b43336f(stackOptions = {}, options = {}) {
    if (arguments.length === 1) [stackOptions, options] = $edd8a0486fa281c7$var$mergeOptions(stackOptions);
    const { y1: y1, y: y = y1, x: x } = options;
    const [transform, Y, X] = $edd8a0486fa281c7$var$stack(y, x, "y", "x", stackOptions, options);
    return {
        ...transform,
        y1: y1,
        y: Y,
        x: X
    };
}
function $edd8a0486fa281c7$export$2f8ab864f963fa7b(stackOptions = {}, options = {}) {
    if (arguments.length === 1) [stackOptions, options] = $edd8a0486fa281c7$var$mergeOptions(stackOptions);
    const { y1: y1, y: y = y1, x: x } = options;
    const [transform, Y, , X] = $edd8a0486fa281c7$var$stack(y, x, "y", "x", stackOptions, options);
    return {
        ...transform,
        y1: y1,
        y: Y,
        x: X
    };
}
function $edd8a0486fa281c7$export$f4b7bb1e04384c6e(stackOptions = {}, options = {}) {
    if (arguments.length === 1) [stackOptions, options] = $edd8a0486fa281c7$var$mergeOptions(stackOptions);
    const { x1: x1, x: x = x1, y: y, ...rest } = options; // note: consumes y!
    const [transform, X, y1, y2] = $edd8a0486fa281c7$var$stack(x, y, "x", "y", stackOptions, rest);
    return {
        ...transform,
        x1: x1,
        x: X,
        y1: y1,
        y2: y2,
        y: (0, $cd9e805a4bbd13f9$export$a61423b330c3444c)(y1, y2)
    };
}
function $edd8a0486fa281c7$export$c7ed8c2dca8ed90b(stackOptions = {}, options = {}) {
    if (arguments.length === 1) [stackOptions, options] = $edd8a0486fa281c7$var$mergeOptions(stackOptions);
    const { x1: x1, x: x = x1, y: y } = options;
    const [transform, X, Y] = $edd8a0486fa281c7$var$stack(x, y, "x", "y", stackOptions, options);
    return {
        ...transform,
        x1: x1,
        x: X,
        y: Y
    };
}
function $edd8a0486fa281c7$export$b3ab0d0e97b073cd(stackOptions = {}, options = {}) {
    if (arguments.length === 1) [stackOptions, options] = $edd8a0486fa281c7$var$mergeOptions(stackOptions);
    const { x1: x1, x: x = x1, y: y } = options;
    const [transform, X, , Y] = $edd8a0486fa281c7$var$stack(x, y, "x", "y", stackOptions, options);
    return {
        ...transform,
        x1: x1,
        x: X,
        y: Y
    };
}
function $edd8a0486fa281c7$export$8dc1b2cbfd434f0e({ x: x, x1: x1, x2: x2, ...options } = {}) {
    options = (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "y");
    if (x1 === undefined && x2 === undefined) return $edd8a0486fa281c7$export$e2ca547456a8fee2({
        x: x,
        ...options
    });
    [x1, x2] = (0, $cd9e805a4bbd13f9$export$988dfb0cf3d08a43)(x, x1, x2);
    return {
        ...options,
        x1: x1,
        x2: x2
    };
}
function $edd8a0486fa281c7$export$8e6f10a352d8a326({ y: y, y1: y1, y2: y2, ...options } = {}) {
    options = (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "x");
    if (y1 === undefined && y2 === undefined) return $edd8a0486fa281c7$export$f4b7bb1e04384c6e({
        y: y,
        ...options
    });
    [y1, y2] = (0, $cd9e805a4bbd13f9$export$988dfb0cf3d08a43)(y, y1, y2);
    return {
        ...options,
        y1: y1,
        y2: y2
    };
}
// The reverse option is ambiguous: it is both a stack option and a basic
// transform. If only one options object is specified, we interpret it as a
// stack option, and therefore must remove it from the propagated options.
function $edd8a0486fa281c7$var$mergeOptions(options) {
    const { offset: offset, order: order, reverse: reverse, ...rest } = options;
    return [
        {
            offset: offset,
            order: order,
            reverse: reverse
        },
        rest
    ];
}
// This is a hint to the tooltip mark that the y1 and y2 channels (for stackY,
// or conversely x1 and x2 for stackX) represent a stacked length, and that the
// tooltip should therefore show y2-y1 instead of an extent.
const $edd8a0486fa281c7$var$lengthy = {
    length: true
};
function $edd8a0486fa281c7$var$stack(x, y = (0, $cd9e805a4bbd13f9$export$80bf7733f1207381), kx, ky, { offset: offset, order: order, reverse: reverse }, options) {
    if (y === null) throw new Error(`stack requires ${ky}`);
    const z = (0, $cd9e805a4bbd13f9$export$9040d0441634ebe5)(options);
    const [X, setX] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(x);
    const [Y1, setY1] = (0, $cd9e805a4bbd13f9$export$4e0c71f277ca26b3)(y);
    const [Y2, setY2] = (0, $cd9e805a4bbd13f9$export$4e0c71f277ca26b3)(y);
    Y1.hint = Y2.hint = $edd8a0486fa281c7$var$lengthy;
    offset = $edd8a0486fa281c7$var$maybeOffset(offset);
    order = $edd8a0486fa281c7$var$maybeOrder(order, offset, ky);
    return [
        (0, $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options, (data, facets, plotOptions)=>{
            ({ data: data, facets: facets } = (0, $cb1059f7206f9e40$export$27e5a8b25ef2b39d)(data, facets));
            const X = x == null ? undefined : setX((0, $cd9e805a4bbd13f9$export$90792ed47ffcc9f3)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, x), plotOptions?.[kx]));
            const Y = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, y, Float64Array);
            const Z = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, z);
            const compare = order && order(data, X, Y, Z);
            const n = (0, $cd9e805a4bbd13f9$export$766772bbf464ff6)(data);
            const Y1 = setY1(new Float64Array(n));
            const Y2 = setY2(new Float64Array(n));
            const facetstacks = [];
            for (const facet of facets){
                const stacks = X ? Array.from((0, $6f0c14a1378d16c1$export$2e2bcd8739ae039)(facet, (i)=>X[i]).values()) : [
                    facet
                ];
                if (compare) for (const stack of stacks)stack.sort(compare);
                for (const stack of stacks){
                    let yn = 0;
                    let yp = 0;
                    if (reverse) stack.reverse();
                    for (const i of stack){
                        const y = Y[i];
                        if (y < 0) yn = Y2[i] = (Y1[i] = yn) + y;
                        else if (y > 0) yp = Y2[i] = (Y1[i] = yp) + y;
                        else Y2[i] = Y1[i] = yp; // NaN or zero
                    }
                }
                facetstacks.push(stacks);
            }
            if (offset) offset(facetstacks, Y1, Y2, Z);
            return {
                data: data,
                facets: facets
            };
        }),
        X,
        Y1,
        Y2
    ];
}
function $edd8a0486fa281c7$var$maybeOffset(offset) {
    if (offset == null) return;
    if (typeof offset === "function") return offset;
    switch(`${offset}`.toLowerCase()){
        case "expand":
        case "normalize":
            return $edd8a0486fa281c7$var$offsetExpand;
        case "center":
        case "silhouette":
            return $edd8a0486fa281c7$var$offsetCenter;
        case "wiggle":
            return $edd8a0486fa281c7$var$offsetWiggle;
    }
    throw new Error(`unknown offset: ${offset}`);
}
// Given a single stack, returns the minimum and maximum values from the given
// Y2 column. Note that this relies on Y2 always being the outer column for
// diverging values.
function $edd8a0486fa281c7$var$extent(stack, Y2) {
    let min = 0, max = 0;
    for (const i of stack){
        const y = Y2[i];
        if (y < min) min = y;
        if (y > max) max = y;
    }
    return [
        min,
        max
    ];
}
function $edd8a0486fa281c7$var$offsetExpand(facetstacks, Y1, Y2) {
    for (const stacks of facetstacks)for (const stack of stacks){
        const [yn, yp] = $edd8a0486fa281c7$var$extent(stack, Y2);
        for (const i of stack){
            const m = 1 / (yp - yn || 1);
            Y1[i] = m * (Y1[i] - yn);
            Y2[i] = m * (Y2[i] - yn);
        }
    }
}
function $edd8a0486fa281c7$var$offsetCenter(facetstacks, Y1, Y2) {
    for (const stacks of facetstacks){
        for (const stack of stacks){
            const [yn, yp] = $edd8a0486fa281c7$var$extent(stack, Y2);
            for (const i of stack){
                const m = (yp + yn) / 2;
                Y1[i] -= m;
                Y2[i] -= m;
            }
        }
        $edd8a0486fa281c7$var$offsetZero(stacks, Y1, Y2);
    }
    $edd8a0486fa281c7$var$offsetCenterFacets(facetstacks, Y1, Y2);
}
function $edd8a0486fa281c7$var$offsetWiggle(facetstacks, Y1, Y2, Z) {
    for (const stacks of facetstacks){
        const prev = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        let y = 0;
        for (const stack of stacks){
            let j = -1;
            const Fi = stack.map((i)=>Math.abs(Y2[i] - Y1[i]));
            const Df = stack.map((i)=>{
                j = Z ? Z[i] : ++j;
                const value = Y2[i] - Y1[i];
                const diff = prev.has(j) ? value - prev.get(j) : 0;
                prev.set(j, value);
                return diff;
            });
            const Cf1 = [
                0,
                ...(0, $439e396521e041a4$export$2e2bcd8739ae039)(Df)
            ];
            for (const i of stack){
                Y1[i] += y;
                Y2[i] += y;
            }
            const s1 = (0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(Fi);
            if (s1) y -= (0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(Fi, (d, i)=>(Df[i] / 2 + Cf1[i]) * d) / s1;
        }
        $edd8a0486fa281c7$var$offsetZero(stacks, Y1, Y2);
    }
    $edd8a0486fa281c7$var$offsetCenterFacets(facetstacks, Y1, Y2);
}
function $edd8a0486fa281c7$var$offsetZero(stacks, Y1, Y2) {
    const m = (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(stacks, (stack)=>(0, $02ed355deaa9e190$export$2e2bcd8739ae039)(stack, (i)=>Y1[i]));
    for (const stack of stacks)for (const i of stack){
        Y1[i] -= m;
        Y2[i] -= m;
    }
}
function $edd8a0486fa281c7$var$offsetCenterFacets(facetstacks, Y1, Y2) {
    const n = facetstacks.length;
    if (n === 1) return;
    const facets = facetstacks.map((stacks)=>stacks.flat());
    const m = facets.map((I)=>((0, $02ed355deaa9e190$export$2e2bcd8739ae039)(I, (i)=>Y1[i]) + (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(I, (i)=>Y2[i])) / 2);
    const m0 = (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(m);
    for(let j = 0; j < n; j++){
        const p = m0 - m[j];
        for (const i of facets[j]){
            Y1[i] += p;
            Y2[i] += p;
        }
    }
}
function $edd8a0486fa281c7$var$maybeOrder(order, offset, ky) {
    if (order === undefined && offset === $edd8a0486fa281c7$var$offsetWiggle) return $edd8a0486fa281c7$var$orderInsideOut((0, $0f3e37548c3914c7$export$686e14b8469efec4));
    if (order == null) return;
    if (typeof order === "string") {
        const negate = order.startsWith("-");
        const compare = negate ? (0, $0f3e37548c3914c7$export$e82554a8bd790ef9) : (0, $0f3e37548c3914c7$export$686e14b8469efec4);
        switch((negate ? order.slice(1) : order).toLowerCase()){
            case "value":
            case ky:
                return $edd8a0486fa281c7$var$orderY(compare);
            case "z":
                return $edd8a0486fa281c7$var$orderZ(compare);
            case "sum":
                return $edd8a0486fa281c7$var$orderSum(compare);
            case "appearance":
                return $edd8a0486fa281c7$var$orderAppearance(compare);
            case "inside-out":
                return $edd8a0486fa281c7$var$orderInsideOut(compare);
        }
        return $edd8a0486fa281c7$var$orderAccessor((0, $cd9e805a4bbd13f9$export$e0f35d825088c098)(order));
    }
    if (typeof order === "function") return (order.length === 1 ? $edd8a0486fa281c7$var$orderAccessor : $edd8a0486fa281c7$var$orderComparator)(order);
    if ((0, $cd9e805a4bbd13f9$export$43bee75e5e14138e)(order)) return $edd8a0486fa281c7$var$orderGiven(order);
    throw new Error(`invalid order: ${order}`);
}
// by value
function $edd8a0486fa281c7$var$orderY(compare) {
    return (data, X, Y)=>(i, j)=>compare(Y[i], Y[j]);
}
// by location
function $edd8a0486fa281c7$var$orderZ(compare) {
    return (data, X, Y, Z)=>(i, j)=>compare(Z[i], Z[j]);
}
// by sum of value (a.k.a. “ascending”)
function $edd8a0486fa281c7$var$orderSum(compare) {
    return $edd8a0486fa281c7$var$orderZDomain(compare, (data, X, Y, Z)=>(0, $5d73447cdfa9c155$export$2e2bcd8739ae039)((0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data), (I)=>(0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(I, (i)=>Y[i]), (i)=>Z[i]));
}
// by x = argmax of value
function $edd8a0486fa281c7$var$orderAppearance(compare) {
    return $edd8a0486fa281c7$var$orderZDomain(compare, (data, X, Y, Z)=>(0, $5d73447cdfa9c155$export$2e2bcd8739ae039)((0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data), (I)=>X[(0, $f89111cbb3c9d70b$export$2e2bcd8739ae039)(I, (i)=>Y[i])], (i)=>Z[i]));
}
// by x = argmax of value, but rearranged inside-out by alternating series
// according to the sign of a running divergence of sums
function $edd8a0486fa281c7$var$orderInsideOut(compare) {
    return $edd8a0486fa281c7$var$orderZDomain(compare, (data, X, Y, Z)=>{
        const I = (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data);
        const K = (0, $5d73447cdfa9c155$export$2e2bcd8739ae039)(I, (I)=>X[(0, $f89111cbb3c9d70b$export$2e2bcd8739ae039)(I, (i)=>Y[i])], (i)=>Z[i]);
        const sums = (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (I)=>(0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(I, (i)=>Y[i]), (i)=>Z[i]);
        const Kp = [], Kn = [];
        let s = 0;
        for (const k of K)if (s < 0) {
            s += sums.get(k);
            Kp.push(k);
        } else {
            s -= sums.get(k);
            Kn.push(k);
        }
        return Kn.reverse().concat(Kp);
    });
}
function $edd8a0486fa281c7$var$orderAccessor(f) {
    return (data)=>{
        const O = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, f);
        return (i, j)=>(0, $0f3e37548c3914c7$export$686e14b8469efec4)(O[i], O[j]);
    };
}
function $edd8a0486fa281c7$var$orderComparator(f) {
    return (data)=>{
        return (0, $cd9e805a4bbd13f9$export$43bee75e5e14138e)(data) ? (i, j)=>f(data[i], data[j]) : (i, j)=>f(data.get(i), data.get(j));
    };
}
function $edd8a0486fa281c7$var$orderGiven(domain) {
    return $edd8a0486fa281c7$var$orderZDomain((0, $0f3e37548c3914c7$export$686e14b8469efec4), ()=>domain);
}
// Given an ordering (domain) of distinct values in z that can be derived from
// the data, returns a comparator that can be used to sort stacks. Note that
// this is a series order: it will be consistent across stacks.
function $edd8a0486fa281c7$var$orderZDomain(compare, domain) {
    return (data, X, Y, Z)=>{
        if (!Z) throw new Error("missing channel: z");
        const map = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)(domain(data, X, Y, Z).map((d, i)=>[
                d,
                i
            ]));
        return (i, j)=>compare(map.get(Z[i]), map.get(Z[j]));
    };
}


const $5e4e40f45556e402$var$defaults = {
    ariaLabel: "rect"
};
class $5e4e40f45556e402$export$c79fc6492f3af13d extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = options;
        super(data, {
            x1: {
                value: x1,
                scale: "x",
                type: x1 != null && x2 == null ? "band" : undefined,
                optional: true
            },
            y1: {
                value: y1,
                scale: "y",
                type: y1 != null && y2 == null ? "band" : undefined,
                optional: true
            },
            x2: {
                value: x2,
                scale: "x",
                optional: true
            },
            y2: {
                value: y2,
                scale: "y",
                optional: true
            }
        }, options, $5e4e40f45556e402$var$defaults);
        $5e4e40f45556e402$export$f9e85fc5326f832(this, options);
        $5e4e40f45556e402$export$15cee310517e147d(this, options);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        let { x1: X1, y1: Y1, x2: X2, y2: Y2 } = channels;
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = dimensions;
        const { projection: projection } = context;
        const { insetTop: insetTop, insetRight: insetRight, insetBottom: insetBottom, insetLeft: insetLeft } = this;
        const { rx: rx, ry: ry, rx1y1: rx1y1, rx1y2: rx1y2, rx2y1: rx2y1, rx2y2: rx2y2 } = this;
        if ((X1 || X2) && !projection && (0, $d2c16f7a6010a221$export$9c903d35b97d0190)(x)) X1 = X2 = null; // ignore if collapsed
        if ((Y1 || Y2) && !projection && (0, $d2c16f7a6010a221$export$9c903d35b97d0190)(y)) Y1 = Y2 = null; // ignore if collapsed
        const bx = x?.bandwidth ? x.bandwidth() : 0;
        const by = y?.bandwidth ? y.bandwidth() : 0;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {}, 0, 0).call((g)=>g.selectAll().data(index).enter().call(rx1y1 || rx1y2 || rx2y1 || rx2y2 ? (g)=>g.append("path").call((0, $547e5698440387a8$export$2949c2472f804203), this).call($5e4e40f45556e402$export$cf5dc52a00ffe727, X1 && X2 ? (i)=>X1[i] + (X2[i] < X1[i] ? -insetRight : insetLeft) : X1 ? (i)=>X1[i] + insetLeft : marginLeft + insetLeft, Y1 && Y2 ? (i)=>Y1[i] + (Y2[i] < Y1[i] ? -insetBottom : insetTop) : Y1 ? (i)=>Y1[i] + insetTop : marginTop + insetTop, X1 && X2 ? (i)=>X2[i] - (X2[i] < X1[i] ? -insetLeft : insetRight) : X1 ? (i)=>X1[i] + bx - insetRight : width - marginRight - insetRight, Y1 && Y2 ? (i)=>Y2[i] - (Y2[i] < Y1[i] ? -insetTop : insetBottom) : Y1 ? (i)=>Y1[i] + by - insetBottom : height - marginBottom - insetBottom, this).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels) : (g)=>g.append("rect").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("x", X1 ? X2 ? (i)=>Math.min(X1[i], X2[i]) + insetLeft : (i)=>X1[i] + insetLeft : marginLeft + insetLeft).attr("y", Y1 ? Y2 ? (i)=>Math.min(Y1[i], Y2[i]) + insetTop : (i)=>Y1[i] + insetTop : marginTop + insetTop).attr("width", X1 ? X2 ? (i)=>Math.max(0, Math.abs(X2[i] - X1[i]) + bx - insetLeft - insetRight) : bx - insetLeft - insetRight : width - marginRight - marginLeft - insetRight - insetLeft).attr("height", Y1 ? Y2 ? (i)=>Math.max(0, Math.abs(Y1[i] - Y2[i]) + by - insetTop - insetBottom) : by - insetTop - insetBottom : height - marginTop - marginBottom - insetTop - insetBottom).call((0, $547e5698440387a8$export$47765c6b16054eb2), "rx", rx).call((0, $547e5698440387a8$export$47765c6b16054eb2), "ry", ry).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels))).node();
    }
}
function $5e4e40f45556e402$export$f9e85fc5326f832(mark, { inset: inset = 0, insetTop: insetTop = inset, insetRight: insetRight = inset, insetBottom: insetBottom = inset, insetLeft: insetLeft = inset } = {}) {
    mark.insetTop = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetTop);
    mark.insetRight = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetRight);
    mark.insetBottom = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetBottom);
    mark.insetLeft = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetLeft);
}
function $5e4e40f45556e402$export$15cee310517e147d(mark, { r: r, rx: rx, ry: ry, rx1: rx1 = r, ry1: ry1 = r, rx2: rx2 = r, ry2: ry2 = r, rx1y1: rx1y1 = rx1 !== undefined ? +rx1 : ry1 !== undefined ? +ry1 : 0, rx1y2: rx1y2 = rx1 !== undefined ? +rx1 : ry2 !== undefined ? +ry2 : 0, rx2y1: rx2y1 = rx2 !== undefined ? +rx2 : ry1 !== undefined ? +ry1 : 0, rx2y2: rx2y2 = rx2 !== undefined ? +rx2 : ry2 !== undefined ? +ry2 : 0 } = {}) {
    if (rx1y1 || rx1y2 || rx2y1 || rx2y2) {
        mark.rx1y1 = rx1y1;
        mark.rx1y2 = rx1y2;
        mark.rx2y1 = rx2y1;
        mark.rx2y2 = rx2y2;
    } else {
        mark.rx = (0, $547e5698440387a8$export$e1c487990851f09f)(rx, "auto"); // number or percentage
        mark.ry = (0, $547e5698440387a8$export$e1c487990851f09f)(ry, "auto");
    }
}
function $5e4e40f45556e402$export$cf5dc52a00ffe727(selection, X1, Y1, X2, Y2, mark) {
    const { rx1y1: r11, rx1y2: r12, rx2y1: r21, rx2y2: r22 } = mark;
    if (typeof X1 !== "function") X1 = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)(X1);
    if (typeof Y1 !== "function") Y1 = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)(Y1);
    if (typeof X2 !== "function") X2 = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)(X2);
    if (typeof Y2 !== "function") Y2 = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)(Y2);
    const rx = Math.max(Math.abs(r11 + r21), Math.abs(r12 + r22));
    const ry = Math.max(Math.abs(r11 + r12), Math.abs(r21 + r22));
    selection.attr("d", (i)=>{
        const x1 = X1(i);
        const y1 = Y1(i);
        const x2 = X2(i);
        const y2 = Y2(i);
        const ix = x1 > x2;
        const iy = y1 > y2;
        const l = ix ? x2 : x1;
        const r = ix ? x1 : x2;
        const t = iy ? y2 : y1;
        const b = iy ? y1 : y2;
        const k = Math.min(1, (r - l) / rx, (b - t) / ry);
        const tl = k * (ix ? iy ? r22 : r21 : iy ? r12 : r11);
        const tr = k * (ix ? iy ? r12 : r11 : iy ? r22 : r21);
        const br = k * (ix ? iy ? r11 : r12 : iy ? r21 : r22);
        const bl = k * (ix ? iy ? r21 : r22 : iy ? r11 : r12);
        return `M${l},${t + $5e4e40f45556e402$var$biasY(tl, bl)}A${tl},${tl} 0 0 ${tl < 0 ? 0 : 1} ${l + $5e4e40f45556e402$var$biasX(tl, bl)},${t}` + `H${r - $5e4e40f45556e402$var$biasX(tr, br)}A${tr},${tr} 0 0 ${tr < 0 ? 0 : 1} ${r},${t + $5e4e40f45556e402$var$biasY(tr, br)}` + `V${b - $5e4e40f45556e402$var$biasY(br, tr)}A${br},${br} 0 0 ${br < 0 ? 0 : 1} ${r - $5e4e40f45556e402$var$biasX(br, tr)},${b}` + `H${l + $5e4e40f45556e402$var$biasX(bl, tl)}A${bl},${bl} 0 0 ${bl < 0 ? 0 : 1} ${l},${b - $5e4e40f45556e402$var$biasY(bl, tl)}` + `Z`;
    });
}
/**
 * If the opposing corner has a negative radius r2, if this corner has a
 * negative radius r1, this corner’s “wing” will extend horizontally rather than
 * vertically.
 */ function $5e4e40f45556e402$var$biasX(r1, r2) {
    return r2 < 0 ? r1 : Math.abs(r1);
}
/**
 * If the opposing corner has a negative radius r2, if this corner has a
 * negative radius r1, this corner’s “wing” will extend horizontally rather than
 * vertically.
 */ function $5e4e40f45556e402$var$biasY(r1, r2) {
    return r2 < 0 ? Math.abs(r1) : r1;
}
function $5e4e40f45556e402$export$4b409e53cf4df6e6(data, options) {
    return new $5e4e40f45556e402$export$c79fc6492f3af13d(data, (0, $785a735c79529924$export$3e5af5df4bf84a22)((0, $785a735c79529924$export$180507f16d7b6c92)(options)));
}
function $5e4e40f45556e402$export$4557b40d909ef7b6(data, options = {}) {
    if (!(0, $cd9e805a4bbd13f9$export$3ebe4f8dba92c238)(options)) options = {
        ...options,
        y: (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2),
        x2: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655),
        interval: 1
    };
    return new $5e4e40f45556e402$export$c79fc6492f3af13d(data, (0, $edd8a0486fa281c7$export$8dc1b2cbfd434f0e)((0, $785a735c79529924$export$180507f16d7b6c92)((0, $6c8df8405b475220$export$e882a15fe9f7109f)(options))));
}
function $5e4e40f45556e402$export$e77cb45e464d1d05(data, options = {}) {
    if (!(0, $cd9e805a4bbd13f9$export$3ebe4f8dba92c238)(options)) options = {
        ...options,
        x: (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2),
        y2: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655),
        interval: 1
    };
    return new $5e4e40f45556e402$export$c79fc6492f3af13d(data, (0, $edd8a0486fa281c7$export$8e6f10a352d8a326)((0, $785a735c79529924$export$3e5af5df4bf84a22)((0, $6c8df8405b475220$export$463e88814e852032)(options))));
}


const $b946fb4c8a04d9d8$var$defaults = {
    ariaLabel: "frame",
    fill: "none",
    stroke: "currentColor",
    clip: false
};
const $b946fb4c8a04d9d8$var$lineDefaults = {
    ariaLabel: "frame",
    fill: null,
    stroke: "currentColor",
    strokeLinecap: "square",
    clip: false
};
class $b946fb4c8a04d9d8$export$b89a827e9254211a extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(options = {}){
        const { anchor: anchor = null } = options;
        super((0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9), undefined, options, anchor == null ? $b946fb4c8a04d9d8$var$defaults : $b946fb4c8a04d9d8$var$lineDefaults);
        this.anchor = (0, $cd9e805a4bbd13f9$export$a305618d7bff6223)(anchor, "anchor", [
            "top",
            "right",
            "bottom",
            "left"
        ]);
        (0, $5e4e40f45556e402$export$f9e85fc5326f832)(this, options);
        if (!anchor) (0, $5e4e40f45556e402$export$15cee310517e147d)(this, options);
    }
    render(index, scales, channels, dimensions, context) {
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = dimensions;
        const { anchor: anchor, insetTop: insetTop, insetRight: insetRight, insetBottom: insetBottom, insetLeft: insetLeft } = this;
        const { rx: rx, ry: ry, rx1y1: rx1y1, rx1y2: rx1y2, rx2y1: rx2y1, rx2y2: rx2y2 } = this;
        const x1 = marginLeft + insetLeft;
        const x2 = width - marginRight - insetRight;
        const y1 = marginTop + insetTop;
        const y2 = height - marginBottom - insetBottom;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)(anchor ? "svg:line" : rx1y1 || rx1y2 || rx2y1 || rx2y2 ? "svg:path" : "svg:rect", context).datum(0).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$2949c2472f804203), this).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {}).call(anchor === "left" ? (line)=>line.attr("x1", x1).attr("x2", x1).attr("y1", y1).attr("y2", y2) : anchor === "right" ? (line)=>line.attr("x1", x2).attr("x2", x2).attr("y1", y1).attr("y2", y2) : anchor === "top" ? (line)=>line.attr("x1", x1).attr("x2", x2).attr("y1", y1).attr("y2", y1) : anchor === "bottom" ? (line)=>line.attr("x1", x1).attr("x2", x2).attr("y1", y2).attr("y2", y2) : rx1y1 || rx1y2 || rx2y1 || rx2y2 ? (path)=>path.call((0, $5e4e40f45556e402$export$cf5dc52a00ffe727), x1, y1, x2, y2, this) : (rect)=>rect.attr("x", x1).attr("y", y1).attr("width", x2 - x1).attr("height", y2 - y1).attr("rx", rx).attr("ry", ry)).node();
    }
}
function $b946fb4c8a04d9d8$export$2cef06c20297c17d(options) {
    return new $b946fb4c8a04d9d8$export$b89a827e9254211a(options);
}













const $45befbcddbf9afbb$var$defaults = {
    ariaLabel: "tip",
    fill: "var(--plot-background)",
    stroke: "currentColor"
};
// These channels are not displayed in the default tip; see formatChannels.
const $45befbcddbf9afbb$var$ignoreChannels = new Set([
    "geometry",
    "href",
    "src",
    "ariaLabel",
    "scales"
]);
class $45befbcddbf9afbb$export$c92c6401b52a9298 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        if (options.tip) options = {
            ...options,
            tip: false
        };
        if (options.title === undefined && (0, $cd9e805a4bbd13f9$export$9652023d9040757)(data) && (0, $cd9e805a4bbd13f9$export$43674e37205f3011)(data)) options = {
            ...options,
            title: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)
        };
        const { x: x, y: y, x1: x1, x2: x2, y1: y1, y2: y2, anchor: anchor, preferredAnchor: preferredAnchor = "bottom", monospace: monospace, fontFamily: fontFamily = monospace ? "ui-monospace, monospace" : undefined, fontSize: fontSize, fontStyle: fontStyle, fontVariant: fontVariant, fontWeight: fontWeight, lineHeight: lineHeight = 1, lineWidth: lineWidth = 20, frameAnchor: frameAnchor, format: format, textAnchor: textAnchor = "start", textOverflow: textOverflow, textPadding: textPadding = 8, title: title, pointerSize: pointerSize = 12, pathFilter: pathFilter = "drop-shadow(0 3px 4px rgba(0,0,0,0.2))" } = options;
        super(data, {
            x: {
                value: x1 != null && x2 != null ? null : x,
                scale: "x",
                optional: true
            },
            y: {
                value: y1 != null && y2 != null ? null : y,
                scale: "y",
                optional: true
            },
            x1: {
                value: x1,
                scale: "x",
                optional: x2 == null
            },
            y1: {
                value: y1,
                scale: "y",
                optional: y2 == null
            },
            x2: {
                value: x2,
                scale: "x",
                optional: x1 == null
            },
            y2: {
                value: y2,
                scale: "y",
                optional: y1 == null
            },
            title: {
                value: title,
                optional: true
            } // filter: defined
        }, options, $45befbcddbf9afbb$var$defaults);
        this.anchor = (0, $cd9e805a4bbd13f9$export$6738a673c9b9c522)(anchor, "anchor");
        this.preferredAnchor = (0, $cd9e805a4bbd13f9$export$6738a673c9b9c522)(preferredAnchor, "preferredAnchor");
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
        this.textAnchor = (0, $547e5698440387a8$export$e1c487990851f09f)(textAnchor, "middle");
        this.textPadding = +textPadding;
        this.pointerSize = +pointerSize;
        this.pathFilter = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(pathFilter);
        this.lineHeight = +lineHeight;
        this.lineWidth = +lineWidth;
        this.textOverflow = (0, $b4855ffaf649c526$export$5286100f10ca66d)(textOverflow);
        this.monospace = !!monospace;
        this.fontFamily = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontFamily);
        this.fontSize = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(fontSize);
        this.fontStyle = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontStyle);
        this.fontVariant = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontVariant);
        this.fontWeight = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontWeight);
        for(const key in $45befbcddbf9afbb$var$defaults)if (key in this.channels) this[key] = $45befbcddbf9afbb$var$defaults[key]; // apply default even if channel
        this.splitLines = (0, $b4855ffaf649c526$export$8cfde575cbd41e40)(this);
        this.clipLine = (0, $b4855ffaf649c526$export$f7f3d67a35896a0e)(this);
        this.format = typeof format === "string" || typeof format === "function" ? {
            title: format
        } : {
            ...format
        }; // defensive copy before mutate; also promote nullish to empty
    }
    render(index, scales, values, dimensions, context) {
        const mark = this;
        const { x: x, y: y, fx: fx, fy: fy } = scales;
        const { ownerSVGElement: svg, document: document } = context;
        const { anchor: anchor, monospace: monospace, lineHeight: lineHeight, lineWidth: lineWidth } = this;
        const { textPadding: r, pointerSize: m, pathFilter: pathFilter } = this;
        const { marginTop: marginTop, marginLeft: marginLeft } = dimensions;
        // The anchor position is the middle of x1 & y1 and x2 & y2, if available,
        // or x & y; the former is considered more specific because it’s how we
        // disable the implicit stack and interval transforms. If any dimension is
        // unspecified, we fallback to the frame anchor. We also need to know the
        // facet offsets to detect when the tip would draw outside the plot, and
        // thus we need to change the orientation.
        const { x1: X1, y1: Y1, x2: X2, y2: Y2, x: X = X1 ?? X2, y: Y = Y1 ?? Y2 } = values;
        const ox = fx ? fx(index.fx) - marginLeft : 0;
        const oy = fy ? fy(index.fy) - marginTop : 0;
        // The order of precedence for the anchor position is: the middle of x1 & y1
        // and x2 & y2; or x1 & y1 (e.g., area); or lastly x & y. If a dimension is
        // unspecified, the frame anchor is used.
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        const px = (0, $06868e990a5c2092$export$15f8ded78c8d24ca)(values, cx);
        const py = (0, $06868e990a5c2092$export$770d7614a8aa3617)(values, cy);
        // Resolve the text metric implementation. We may need an ellipsis for text
        // truncation, so we optimistically compute the ellipsis width.
        const widthof = monospace ? (0, $b4855ffaf649c526$export$4f4ed94d656e5d4a) : (0, $b4855ffaf649c526$export$205274d8d0bfa3a);
        const ee = widthof((0, $b4855ffaf649c526$export$a5b94313d6908893));
        // If there’s a title channel, display that as-is; otherwise, show multiple
        // channels as name-value pairs.
        let sources, format;
        if ("title" in values) {
            sources = $45befbcddbf9afbb$var$getSourceChannels.call(this, {
                title: values.channels.title
            }, scales);
            format = $45befbcddbf9afbb$var$formatTitle;
        } else {
            sources = $45befbcddbf9afbb$var$getSourceChannels.call(this, values.channels, scales);
            format = $45befbcddbf9afbb$var$formatChannels;
        }
        // We don’t call applyChannelStyles because we only use the channels to
        // derive the content of the tip, not its aesthetics.
        const g = (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $b4855ffaf649c526$export$8b7aa25119010c38), this).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append("g").attr("transform", (i)=>`translate(${Math.round(px(i))},${Math.round(py(i))})`) // crisp edges
            .call((0, $547e5698440387a8$export$2949c2472f804203), this).call((g)=>g.append("path").attr("filter", pathFilter)).call((g)=>g.append("text").each(function(i) {
                    const that = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this);
                    // prevent style inheritance (from path)
                    this.setAttribute("fill", "currentColor");
                    this.setAttribute("fill-opacity", 1);
                    this.setAttribute("stroke", "none");
                    // iteratively render each channel value
                    const lines = format.call(mark, i, index, sources, scales, values);
                    if (typeof lines === "string") for (const line of mark.splitLines(lines))renderLine(that, {
                        value: mark.clipLine(line)
                    });
                    else {
                        const labels = new Set();
                        for (const line of lines){
                            const { label: label = "" } = line;
                            if (label && labels.has(label)) continue;
                            else labels.add(label);
                            renderLine(that, line);
                        }
                    }
                })));
        // Renders a single line (a name-value pair) to the tip, truncating the text
        // as needed, and adding a title if the text is truncated. Note that this is
        // just the initial layout of the text; in postrender we will compute the
        // exact text metrics and translate the text as needed once we know the
        // tip’s orientation (anchor).
        function renderLine(selection, { label: label, value: value, color: color, opacity: opacity }) {
            label ??= "", value ??= "";
            const swatch = color != null || opacity != null;
            let title;
            let w = lineWidth * 100;
            const [j] = (0, $b4855ffaf649c526$export$af2a99f971a346e6)(label, w, widthof, ee);
            if (j >= 0) {
                // label is truncated
                label = label.slice(0, j).trimEnd() + (0, $b4855ffaf649c526$export$a5b94313d6908893);
                title = value.trim();
                value = "";
            } else {
                if (label || !value && !swatch) value = " " + value;
                const [k] = (0, $b4855ffaf649c526$export$af2a99f971a346e6)(value, w - widthof(label), widthof, ee);
                if (k >= 0) {
                    // value is truncated
                    title = value.trim();
                    value = value.slice(0, k).trimEnd() + (0, $b4855ffaf649c526$export$a5b94313d6908893);
                }
            }
            const line = selection.append("tspan").attr("x", 0).attr("dy", `${lineHeight}em`).text("\u200B"); // zwsp for double-click
            if (label) line.append("tspan").attr("font-weight", "bold").text(label);
            if (value) line.append(()=>document.createTextNode(value));
            if (swatch) line.append("tspan").text(" \u25A0").attr("fill", color).attr("fill-opacity", opacity).style("user-select", "none"); // prettier-ignore
            if (title) line.append("title").text(title);
        }
        // Only after the plot is attached to the page can we compute the exact text
        // metrics needed to determine the tip size and orientation (anchor).
        function postrender() {
            const { width: width, height: height } = dimensions.facet ?? dimensions;
            g.selectChildren().each(function(i) {
                let { x: tx, width: w, height: h } = this.getBBox();
                w = Math.round(w), h = Math.round(h); // crisp edges
                let a = anchor; // use the specified anchor, if any
                if (a === undefined) {
                    const x = px(i) + ox;
                    const y = py(i) + oy;
                    const fitLeft = x + w + m + r * 2 < width;
                    const fitRight = x - w - m - r * 2 > 0;
                    const fitTop = y + h + m + r * 2 < height;
                    const fitBottom = y - h - m - r * 2 > 0;
                    a = fitLeft && fitRight ? fitTop && fitBottom ? mark.preferredAnchor : fitBottom ? "bottom" : "top" : fitTop && fitBottom ? fitLeft ? "left" : "right" : (fitLeft || fitRight) && (fitTop || fitBottom) ? `${fitBottom ? "bottom" : "top"}-${fitLeft ? "left" : "right"}` : mark.preferredAnchor;
                }
                const path = this.firstChild; // note: assumes exactly two children!
                const text = this.lastChild; // note: assumes exactly two children!
                path.setAttribute("d", $45befbcddbf9afbb$var$getPath(a, m, r, w, h));
                if (tx) for (const t of text.childNodes)t.setAttribute("x", -tx);
                text.setAttribute("y", `${+$45befbcddbf9afbb$var$getLineOffset(a, text.childNodes.length, lineHeight).toFixed(6)}em`);
                text.setAttribute("transform", `translate(${$45befbcddbf9afbb$var$getTextTranslate(a, m, r, w, h)})`);
            });
            g.attr("visibility", null);
        }
        // Wait until the plot is inserted into the page so that we can use getBBox
        // to compute the exact text dimensions. If the SVG is already connected, as
        // when the pointer interaction triggers the re-render, use a faster
        // microtask instead of an animation frame; if this SSR (e.g., JSDOM), skip
        // this step. Perhaps this could be done synchronously; getting the
        // dimensions of the SVG is easy, and although accurate text metrics are
        // hard, we could use approximate heuristics.
        if (index.length) {
            g.attr("visibility", "hidden"); // hide until postrender
            if (svg.isConnected) Promise.resolve().then(postrender);
            else if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(postrender);
        }
        return g.node();
    }
}
function $45befbcddbf9afbb$export$5e5b4df997cb5eaa(data, { x: x, y: y, ...options } = {}) {
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $45befbcddbf9afbb$export$c92c6401b52a9298(data, {
        ...options,
        x: x,
        y: y
    });
}
function $45befbcddbf9afbb$var$getLineOffset(anchor, length, lineHeight) {
    return /^top(?:-|$)/.test(anchor) ? 0.94 - lineHeight : -0.29 - length * lineHeight;
}
function $45befbcddbf9afbb$var$getTextTranslate(anchor, m, r, width, height) {
    switch(anchor){
        case "middle":
            return [
                -width / 2,
                height / 2
            ];
        case "top-left":
            return [
                r,
                m + r
            ];
        case "top":
            return [
                -width / 2,
                m / 2 + r
            ];
        case "top-right":
            return [
                -width - r,
                m + r
            ];
        case "right":
            return [
                -m / 2 - width - r,
                height / 2
            ];
        case "bottom-left":
            return [
                r,
                -m - r
            ];
        case "bottom":
            return [
                -width / 2,
                -m / 2 - r
            ];
        case "bottom-right":
            return [
                -width - r,
                -m - r
            ];
        case "left":
            return [
                r + m / 2,
                height / 2
            ];
    }
}
function $45befbcddbf9afbb$var$getPath(anchor, m, r, width, height) {
    const w = width + r * 2;
    const h = height + r * 2;
    switch(anchor){
        case "middle":
            return `M${-w / 2},${-h / 2}h${w}v${h}h${-w}z`;
        case "top-left":
            return `M0,0l${m},${m}h${w - m}v${h}h${-w}z`;
        case "top":
            return `M0,0l${m / 2},${m / 2}h${(w - m) / 2}v${h}h${-w}v${-h}h${(w - m) / 2}z`;
        case "top-right":
            return `M0,0l${-m},${m}h${m - w}v${h}h${w}z`;
        case "right":
            return `M0,0l${-m / 2},${-m / 2}v${m / 2 - h / 2}h${-w}v${h}h${w}v${m / 2 - h / 2}z`;
        case "bottom-left":
            return `M0,0l${m},${-m}h${w - m}v${-h}h${-w}z`;
        case "bottom":
            return `M0,0l${m / 2},${-m / 2}h${(w - m) / 2}v${-h}h${-w}v${h}h${(w - m) / 2}z`;
        case "bottom-right":
            return `M0,0l${-m},${-m}h${m - w}v${-h}h${w}z`;
        case "left":
            return `M0,0l${m / 2},${-m / 2}v${m / 2 - h / 2}h${w}v${h}h${-w}v${m / 2 - h / 2}z`;
    }
}
// Note: mutates this.format!
function $45befbcddbf9afbb$var$getSourceChannels(channels, scales) {
    const sources = {};
    // Promote x and y shorthand for paired channels (in order).
    let format = this.format;
    format = $45befbcddbf9afbb$var$maybeExpandPairedFormat(format, channels, "x");
    format = $45befbcddbf9afbb$var$maybeExpandPairedFormat(format, channels, "y");
    this.format = format;
    // Prioritize channels with explicit formats, in the given order.
    for(const key in format){
        const value = format[key];
        if (value === null || value === false) continue;
        else if (key === "fx" || key === "fy") sources[key] = true;
        else {
            const source = (0, $6eb5f337b2493843$export$dd2b6e807fb37ba3)(channels, key);
            if (source) sources[key] = source;
        }
    }
    // Then fallback to all other (non-ignored) channels.
    for(const key in channels){
        if (key in sources || key in format || $45befbcddbf9afbb$var$ignoreChannels.has(key)) continue;
        if ((key === "x" || key === "y") && channels.geometry) continue; // ignore x & y on geo
        const source = (0, $6eb5f337b2493843$export$dd2b6e807fb37ba3)(channels, key);
        if (source) {
            // Ignore color channels if the values are all literal colors.
            if (source.scale == null && source.defaultScale === "color") continue;
            sources[key] = source;
        }
    }
    // And lastly facet channels, but only if this mark is faceted.
    if (this.facet) {
        if (scales.fx && !("fx" in format)) sources.fx = true;
        if (scales.fy && !("fy" in format)) sources.fy = true;
    }
    // Promote shorthand string formats, and materialize default formats.
    for(const key in sources){
        const format = this.format[key];
        if (typeof format === "string") {
            const value = sources[key]?.value ?? scales[key]?.domain() ?? [];
            this.format[key] = ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(value) ? (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb) : (0, $54a757fa53542946$export$d9468344d3651243))(format);
        } else if (format === undefined || format === true) {
            // For ordinal scales, the inferred tick format can be more concise, such
            // as only showing the year for yearly data.
            const scale = scales[key];
            this.format[key] = scale?.bandwidth ? (0, $fcb78e8696b500a3$export$c2c6970049f8b561)(scale, scale.domain()) : (0, $4b16c4377cd1e2de$export$bb457229db2006fb);
        }
    }
    return sources;
}
// Promote x and y shorthand for paired channels, while preserving order.
function $45befbcddbf9afbb$var$maybeExpandPairedFormat(format, channels, key) {
    if (!(key in format)) return format;
    const key1 = `${key}1`;
    const key2 = `${key}2`;
    if ((key1 in format || !(key1 in channels)) && (key2 in format || !(key2 in channels))) return format;
    const entries = Object.entries(format);
    const value = format[key];
    entries.splice(entries.findIndex(([name])=>name === key) + 1, 0, [
        key1,
        value
    ], [
        key2,
        value
    ]);
    return Object.fromEntries(entries);
}
function $45befbcddbf9afbb$var$formatTitle(i, index, { title: title }) {
    return this.format.title(title.value[i], i);
}
function* $45befbcddbf9afbb$var$formatChannels(i, index, channels, scales, values) {
    for(const key in channels){
        if (key === "fx" || key === "fy") {
            yield {
                label: $45befbcddbf9afbb$var$formatLabel(scales, channels, key),
                value: this.format[key](index[key], i)
            };
            continue;
        }
        if (key === "x1" && "x2" in channels) continue;
        if (key === "y1" && "y2" in channels) continue;
        const channel = channels[key];
        if (key === "x2" && "x1" in channels) yield {
            label: $45befbcddbf9afbb$var$formatPairLabel(scales, channels, "x"),
            value: $45befbcddbf9afbb$var$formatPair(this.format.x2, channels.x1, channel, i)
        };
        else if (key === "y2" && "y1" in channels) yield {
            label: $45befbcddbf9afbb$var$formatPairLabel(scales, channels, "y"),
            value: $45befbcddbf9afbb$var$formatPair(this.format.y2, channels.y1, channel, i)
        };
        else {
            const value = channel.value[i];
            const scale = channel.scale;
            if (!(0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97)(value) && scale == null) continue;
            yield {
                label: $45befbcddbf9afbb$var$formatLabel(scales, channels, key),
                value: this.format[key](value, i),
                color: scale === "color" ? values[key][i] : null,
                opacity: scale === "opacity" ? values[key][i] : null
            };
        }
    }
}
function $45befbcddbf9afbb$var$formatPair(formatValue, c1, c2, i) {
    return c2.hint?.length // e.g., stackY’s y1 and y2
     ? `${formatValue(c2.value[i] - c1.value[i], i)}` : `${formatValue(c1.value[i], i)}\u{2013}${formatValue(c2.value[i], i)}`;
}
function $45befbcddbf9afbb$var$formatPairLabel(scales, channels, key) {
    const l1 = $45befbcddbf9afbb$var$formatLabel(scales, channels, `${key}1`, key);
    const l2 = $45befbcddbf9afbb$var$formatLabel(scales, channels, `${key}2`, key);
    return l1 === l2 ? l1 : `${l1}\u{2013}${l2}`;
}
function $45befbcddbf9afbb$var$formatLabel(scales, channels, key, defaultLabel = key) {
    const channel = channels[key];
    const scale = scales[channel?.scale ?? key];
    return String(scale?.label ?? channel?.label ?? defaultLabel);
}









function $dce15e0807f8b267$export$2bbbe2756ad57c66(options = {}) {
    const { facet: facet, style: style, title: title, subtitle: subtitle, caption: caption, ariaLabel: ariaLabel, ariaDescription: ariaDescription } = options;
    // className for inline styles
    const className = (0, $547e5698440387a8$export$22300e6eaecca37)(options.className);
    // Flatten any nested marks.
    const marks = options.marks === undefined ? [] : $dce15e0807f8b267$var$flatMarks(options.marks);
    // Add implicit tips.
    marks.push(...$dce15e0807f8b267$var$inferTips(marks));
    // Compute the top-level facet state. This has roughly the same structure as
    // mark-specific facet state, except there isn’t a facetsIndex, and there’s a
    // data and dataLength so we can warn the user if a different data of the same
    // length is used in a mark.
    const topFacetState = $dce15e0807f8b267$var$maybeTopFacet(facet, options);
    // Construct a map from (faceted) Mark instance to facet state, including:
    // channels - an {fx?, fy?} object to add to the fx and fy scale
    // groups - a possibly-nested map from facet values to indexes in the data array
    // facetsIndex - a sparse nested array of indices corresponding to the valid facets
    const facetStateByMark = new Map();
    for (const mark of marks){
        const facetState = $dce15e0807f8b267$var$maybeMarkFacet(mark, topFacetState, options);
        if (facetState) facetStateByMark.set(mark, facetState);
    }
    // Compute a Map from scale name to an array of associated channels.
    const channelsByScale = new Map();
    if (topFacetState) $dce15e0807f8b267$var$addScaleChannels(channelsByScale, [
        topFacetState
    ], options);
    $dce15e0807f8b267$var$addScaleChannels(channelsByScale, facetStateByMark, options);
    // Add implicit axis marks. Because this happens after faceting (because it
    // depends on whether faceting is present), we must initialize the facet state
    // of any implicit axes, too.
    const axes = $dce15e0807f8b267$var$flatMarks($dce15e0807f8b267$var$inferAxes(marks, channelsByScale, options));
    for (const mark of axes){
        const facetState = $dce15e0807f8b267$var$maybeMarkFacet(mark, topFacetState, options);
        if (facetState) facetStateByMark.set(mark, facetState);
    }
    marks.unshift(...axes);
    // All the possible facets are given by the domains of the fx or fy scales, or
    // the cross-product of these domains if we facet by both x and y. We sort
    // them in order to apply the facet filters afterwards.
    let facets = (0, $a6069a9074a3d58d$export$78806da010ca96a5)(channelsByScale, options);
    if (facets !== undefined) {
        const topFacetsIndex = topFacetState ? (0, $a6069a9074a3d58d$export$60f5bc485ae97c42)(facets, topFacetState) : undefined;
        // Compute a facet index for each mark, parallel to the facets array. For
        // mark-level facets, compute an index for that mark’s data and options.
        // Otherwise, use the top-level facet index.
        for (const mark of marks){
            if (mark.facet === null || mark.facet === "super") continue;
            const facetState = facetStateByMark.get(mark);
            if (facetState === undefined) continue;
            facetState.facetsIndex = mark.fx != null || mark.fy != null ? (0, $a6069a9074a3d58d$export$60f5bc485ae97c42)(facets, facetState) : topFacetsIndex;
        }
        // The cross product of the domains of fx and fy can include fx-fy
        // combinations for which no mark has an instance associated with that
        // combination, and therefore we don’t want to render this facet (not even
        // the frame). The same can occur if you specify the domain of fx and fy
        // explicitly, but there is no mark instance associated with some values in
        // the domain. Expunge empty facets, and clear the corresponding elements
        // from the nested index in each mark.
        const nonEmpty = new Set();
        for (const { facetsIndex: facetsIndex } of facetStateByMark.values())facetsIndex?.forEach((index, i)=>{
            if (index?.length > 0) nonEmpty.add(i);
        });
        // If all the facets are empty (as when none of the marks are actually
        // faceted), none of them are empty.
        facets.forEach(0 < nonEmpty.size && nonEmpty.size < facets.length ? (f, i)=>f.empty = !nonEmpty.has(i) : (f)=>f.empty = false);
        // For any mark using the “exclude” facet mode, invert the index.
        for (const mark of marks)if (mark.facet === "exclude") {
            const facetState = facetStateByMark.get(mark);
            if (facetState !== undefined) facetState.facetsIndex = (0, $a6069a9074a3d58d$export$1cc7e8228bc740dc)(facetState.facetsIndex);
        }
    }
    // If a scale is explicitly declared in options, initialize its associated
    // channels to the empty array; this will guarantee that a corresponding scale
    // will be created later (even if there are no other channels). Ignore facet
    // scale declarations, which are handled above.
    for (const key of (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).keys())if ((0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options[key]) && key !== "fx" && key !== "fy") channelsByScale.set(key, []);
    // A Map from Mark instance to its render state, including:
    // index - the data index e.g. [0, 1, 2, 3, …]
    // channels - an array of materialized channels e.g. [["x", {value}], …]
    // faceted - a boolean indicating whether this mark is faceted
    // values - an object of scaled values e.g. {x: [40, 32, …], …}
    const stateByMark = new Map();
    // Initialize the marks’ state.
    for (const mark of marks){
        if (stateByMark.has(mark)) throw new Error("duplicate mark; each mark must be unique");
        const { facetsIndex: facetsIndex, channels: facetChannels } = facetStateByMark.get(mark) ?? {};
        const { data: data, facets: facets, channels: channels } = mark.initialize(facetsIndex, facetChannels, options);
        $dce15e0807f8b267$var$applyScaleTransforms(channels, options);
        stateByMark.set(mark, {
            data: data,
            facets: facets,
            channels: channels
        });
    }
    // Initalize the scales and dimensions.
    const scaleDescriptors = (0, $d2c16f7a6010a221$export$3935c083772c2fcc)($dce15e0807f8b267$var$addScaleChannels(channelsByScale, stateByMark, options), options);
    const dimensions = (0, $c6491cb5712bafc0$export$8066c1b52b2e9504)(scaleDescriptors, marks, options);
    (0, $d2c16f7a6010a221$export$9b57902db34fb271)(scaleDescriptors, dimensions);
    const scales = (0, $d2c16f7a6010a221$export$c2fb627c1b06c8b7)(scaleDescriptors);
    const { fx: fx, fy: fy } = scales;
    const subdimensions = fx || fy ? (0, $d2c16f7a6010a221$export$d598388655a34790)(scaleDescriptors, dimensions) : dimensions;
    const superdimensions = fx || fy ? $dce15e0807f8b267$var$actualDimensions(scales, dimensions) : dimensions;
    // Initialize the context.
    const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
    const document = context.document;
    const svg = (0, $8408c2f95f59818f$export$2e2bcd8739ae039)("svg").call(document.documentElement);
    let figure = svg; // replaced with the figure element, if any
    context.ownerSVGElement = svg;
    context.className = className;
    context.projection = (0, $0b574e6ffdcb6f7c$export$549167224996a0fb)(options, subdimensions);
    // Allows e.g. the axis mark to determine faceting lazily.
    context.filterFacets = (data, channels)=>{
        return (0, $a6069a9074a3d58d$export$60f5bc485ae97c42)(facets, {
            channels: channels,
            groups: (0, $a6069a9074a3d58d$export$46a87af59f80d026)(data, channels)
        });
    };
    // Allows e.g. the tip mark to reference channels and data on other marks.
    context.getMarkState = (mark)=>{
        const state = stateByMark.get(mark);
        const facetState = facetStateByMark.get(mark);
        return {
            ...state,
            channels: {
                ...state.channels,
                ...facetState?.channels
            }
        };
    };
    // Allows e.g. the pointer transform to support viewof.
    context.dispatchValue = (value)=>{
        if (figure.value === value) return;
        figure.value = value;
        figure.dispatchEvent(new Event("input", {
            bubbles: true
        }));
    };
    // Reinitialize; for deriving channels dependent on other channels.
    const newByScale = new Set();
    for (const [mark, state] of stateByMark)if (mark.initializer != null) {
        const dimensions = mark.facet === "super" ? superdimensions : subdimensions;
        const update = mark.initializer(state.data, state.facets, state.channels, scales, dimensions, context);
        if (update.data !== undefined) state.data = update.data;
        if (update.facets !== undefined) state.facets = update.facets;
        if (update.channels !== undefined) {
            const { fx: fx, fy: fy, ...channels } = update.channels; // separate facet channels
            $dce15e0807f8b267$var$inferChannelScales(channels);
            Object.assign(state.channels, channels);
            for (const channel of Object.values(channels)){
                const { scale: scale } = channel;
                // Initializers aren’t allowed to redefine position scales as this
                // would introduce a circular dependency; so simply scale these
                // channels as-is rather than creating new scales, and assume that
                // they already have the scale’s transform applied, if any (e.g., when
                // generating ticks for the axis mark).
                if (scale != null && !(0, $743dde21c57c19a0$export$1680e4b48df7f4f2)((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(scale))) {
                    $dce15e0807f8b267$var$applyScaleTransform(channel, options);
                    newByScale.add(scale);
                }
            }
            // If the initializer returns new mark-level facet channels, we must
            // record that the mark is now faceted. Note: we aren’t actually
            // populating the facet state, but subsequently we won’t need it.
            if (fx != null || fy != null) facetStateByMark.set(mark, true);
        }
    }
    // Reconstruct scales if new scaled channels were created during
    // reinitialization. Preserve existing scale labels, if any.
    if (newByScale.size) {
        const newChannelsByScale = new Map();
        $dce15e0807f8b267$var$addScaleChannels(newChannelsByScale, stateByMark, options, (key)=>newByScale.has(key));
        $dce15e0807f8b267$var$addScaleChannels(channelsByScale, stateByMark, options, (key)=>newByScale.has(key));
        const newScaleDescriptors = $dce15e0807f8b267$var$inheritScaleLabels((0, $d2c16f7a6010a221$export$3935c083772c2fcc)(newChannelsByScale, options), scaleDescriptors);
        const { scales: newExposedScales, ...newScales } = (0, $d2c16f7a6010a221$export$c2fb627c1b06c8b7)(newScaleDescriptors);
        Object.assign(scaleDescriptors, newScaleDescriptors);
        Object.assign(scales, newScales);
        Object.assign(scales.scales, newExposedScales);
    }
    // Sort and filter the facets to match the fx and fy domains; this is needed
    // because the facets were constructed prior to the fx and fy scales.
    let facetDomains, facetTranslate;
    if (facets !== undefined) {
        facetDomains = {
            x: fx?.domain(),
            y: fy?.domain()
        };
        facets = (0, $a6069a9074a3d58d$export$f59853a117afdf3c)(facets, facetDomains);
        facetTranslate = (0, $a6069a9074a3d58d$export$1b78147bc5e9c7ba)(fx, fy, dimensions);
    }
    // Compute value objects, applying scales and projection as needed.
    for (const [mark, state] of stateByMark)state.values = mark.scale(state.channels, scales, context);
    const { width: width, height: height } = dimensions;
    (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(svg).attr("class", className).attr("fill", "currentColor").attr("font-family", "system-ui, sans-serif").attr("font-size", 10).attr("text-anchor", "middle").attr("width", width).attr("height", height).attr("viewBox", `0 0 ${width} ${height}`).attr("aria-label", ariaLabel).attr("aria-description", ariaDescription).call((svg)=>// Warning: if you edit this, change defaultClassName.
        svg.append("style").text(`:where(.${className}) {
  --plot-background: white;
  display: block;
  height: auto;
  height: intrinsic;
  max-width: 100%;
}
:where(.${className} text),
:where(.${className} tspan) {
  white-space: pre;
}`)).call((0, $547e5698440387a8$export$4e6c5cc1af44143e), style);
    // Render marks.
    for (const mark of marks){
        const { channels: channels, values: values, facets: indexes } = stateByMark.get(mark);
        // Render a non-faceted mark.
        if (facets === undefined || mark.facet === "super") {
            let index = null;
            if (indexes) {
                index = indexes[0];
                index = mark.filter(index, channels, values);
                if (index.length === 0) continue;
            }
            const node = mark.render(index, scales, values, superdimensions, context);
            if (node == null) continue;
            svg.appendChild(node);
        } else {
            let g;
            for (const f of facets){
                if (!(mark.facetAnchor?.(facets, facetDomains, f) ?? !f.empty)) continue;
                let index = null;
                if (indexes) {
                    const faceted = facetStateByMark.has(mark);
                    index = indexes[faceted ? f.i : 0];
                    index = mark.filter(index, channels, values);
                    if (index.length === 0) continue;
                    if (!faceted && index === indexes[0]) index = (0, $cd9e805a4bbd13f9$export$7ec32827e4221318)(index); // copy before assigning fx, fy, fi
                    index.fx = f.x, index.fy = f.y, index.fi = f.i;
                }
                const node = mark.render(index, scales, values, subdimensions, context);
                if (node == null) continue;
                // Lazily construct the shared group (to drop empty marks).
                (g ??= (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(svg).append("g")).append(()=>node).datum(f);
                // Promote ARIA attributes and mark transform to avoid repetition on
                // each facet; this assumes that these attributes are consistent across
                // facets, but that should be the case!
                for (const name of [
                    "aria-label",
                    "aria-description",
                    "aria-hidden",
                    "transform"
                ])if (node.hasAttribute(name)) {
                    g.attr(name, node.getAttribute(name));
                    node.removeAttribute(name);
                }
            }
            g?.selectChildren().attr("transform", facetTranslate);
        }
    }
    // Wrap the plot in a figure, if needed.
    const legends = (0, $e6941eca40ba0848$export$7d86fc1221ad3a46)(scaleDescriptors, context, options);
    const { figure: figured = title != null || subtitle != null || caption != null || legends.length > 0 } = options;
    if (figured) {
        figure = document.createElement("figure");
        figure.className = `${className}-figure`;
        figure.style.maxWidth = "initial"; // avoid Observable default style
        if (title != null) figure.append($dce15e0807f8b267$var$createTitleElement(document, title, "h2"));
        if (subtitle != null) figure.append($dce15e0807f8b267$var$createTitleElement(document, subtitle, "h3"));
        figure.append(...legends, svg);
        if (caption != null) figure.append($dce15e0807f8b267$var$createFigcaption(document, caption));
        if ("value" in svg) figure.value = svg.value, delete svg.value;
    }
    figure.scale = (0, $d2c16f7a6010a221$export$de69b9c17a3f6bda)(scales.scales);
    figure.legend = (0, $e6941eca40ba0848$export$d2e05e4b3a11ee5a)(scaleDescriptors, context, options);
    const w = (0, $30c329e934b7a0f1$export$1876d6a9858b29e7)();
    if (w > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(svg).append("text").attr("x", width).attr("y", 20).attr("dy", "-1em").attr("text-anchor", "end").attr("font-family", "initial") // fix emoji rendering in Chrome
    .text("\u26A0\uFE0F") // emoji variation selector
    .append("title").text(`${w.toLocaleString("en-US")} warning${w === 1 ? "" : "s"}. Please check the console.`);
    return figure;
}
function $dce15e0807f8b267$var$createTitleElement(document, contents, tag) {
    if (contents.ownerDocument) return contents;
    const e = document.createElement(tag);
    e.append(contents);
    return e;
}
function $dce15e0807f8b267$var$createFigcaption(document, caption) {
    const e = document.createElement("figcaption");
    e.append(caption);
    return e;
}
function $dce15e0807f8b267$var$flatMarks(marks) {
    return marks.flat(Infinity).filter((mark)=>mark != null).map($dce15e0807f8b267$var$markify);
}
function $dce15e0807f8b267$var$markify(mark) {
    return typeof mark.render === "function" ? mark : new $dce15e0807f8b267$var$Render(mark);
}
class $dce15e0807f8b267$var$Render extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(render){
        if (typeof render !== "function") throw new TypeError("invalid mark; missing render function");
        super();
        this.render = render;
    }
    render() {}
}
// Note: mutates channel.value to apply the scale transform, if any.
function $dce15e0807f8b267$var$applyScaleTransforms(channels, options) {
    for(const name in channels)$dce15e0807f8b267$var$applyScaleTransform(channels[name], options);
    return channels;
}
// Note: mutates channel.value to apply the scale transform, if any. Also sets
// channel.transform to false to prevent duplicate transform application.
function $dce15e0807f8b267$var$applyScaleTransform(channel, options) {
    const { scale: scale, transform: t = true } = channel;
    if (scale == null || !t) return;
    const { type: type, percent: percent, interval: interval, transform: transform = percent ? (x)=>x == null ? NaN : x * 100 : (0, $cd9e805a4bbd13f9$export$2170e2fe1255e79b)(interval, type) } = options[scale] ?? {};
    if (transform == null) return;
    channel.value = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(channel.value, transform);
    channel.transform = false;
}
// An initializer may generate channels without knowing how the downstream mark
// will use them. Marks are typically responsible associated scales with
// channels, but here we assume common behavior across marks.
function $dce15e0807f8b267$var$inferChannelScales(channels) {
    for(const name in channels)(0, $6eb5f337b2493843$export$5de38149af3ed501)(name, channels[name]);
}
function $dce15e0807f8b267$var$addScaleChannels(channelsByScale, stateByMark, options, filter = (0, $cd9e805a4bbd13f9$export$7a668e70ea2210d9)) {
    for (const { channels: channels } of stateByMark.values())for(const name in channels){
        const channel = channels[name];
        const { scale: scale } = channel;
        if (scale != null && filter(scale)) {
            // Geo marks affect the default x and y domains if there is no
            // projection. Skip this (as an optimization) when a projection is
            // specified, or when the domains for x and y are specified.
            if (scale === "projection") {
                if (!(0, $0b574e6ffdcb6f7c$export$a364b560a2a07d35)(options)) {
                    const gx = options.x?.domain === undefined;
                    const gy = options.y?.domain === undefined;
                    if (gx || gy) {
                        const [x, y] = (0, $0b574e6ffdcb6f7c$export$b3eb7247b89a6856)(channel);
                        if (gx) $dce15e0807f8b267$var$addScaleChannel(channelsByScale, "x", x);
                        if (gy) $dce15e0807f8b267$var$addScaleChannel(channelsByScale, "y", y);
                    }
                }
            } else $dce15e0807f8b267$var$addScaleChannel(channelsByScale, scale, channel);
        }
    }
    return channelsByScale;
}
function $dce15e0807f8b267$var$addScaleChannel(channelsByScale, scale, channel) {
    const scaleChannels = channelsByScale.get(scale);
    if (scaleChannels !== undefined) scaleChannels.push(channel);
    else channelsByScale.set(scale, [
        channel
    ]);
}
// Returns the facet groups, and possibly fx and fy channels, associated with
// the top-level facet option {data, x, y}.
function $dce15e0807f8b267$var$maybeTopFacet(facet, options) {
    if (facet == null) return;
    const { x: x, y: y } = facet;
    if (x == null && y == null) return;
    const data = (0, $cd9e805a4bbd13f9$export$73f73ccd44b2553f)(facet.data);
    if (data == null) throw new Error("missing facet data");
    const channels = {};
    if (x != null) channels.fx = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
        value: x,
        scale: "fx"
    });
    if (y != null) channels.fy = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
        value: y,
        scale: "fy"
    });
    $dce15e0807f8b267$var$applyScaleTransforms(channels, options);
    const groups = (0, $a6069a9074a3d58d$export$46a87af59f80d026)(data, channels);
    return {
        channels: channels,
        groups: groups,
        data: facet.data
    };
}
// Returns the facet groups, and possibly fx and fy channels, associated with a
// mark, either through top-level faceting or mark-level facet options {fx, fy}.
function $dce15e0807f8b267$var$maybeMarkFacet(mark, topFacetState, options) {
    if (mark.facet === null || mark.facet === "super") return;
    // This mark defines a mark-level facet. TODO There’s some code duplication
    // here with maybeTopFacet that we could reduce.
    const { fx: fx, fy: fy } = mark;
    if (fx != null || fy != null) {
        const data = (0, $cd9e805a4bbd13f9$export$73f73ccd44b2553f)(mark.data ?? fx ?? fy);
        if (data === undefined) throw new Error(`missing facet data in ${mark.ariaLabel}`);
        if (data === null) return; // ignore channel definitions if no data is provided TODO this right?
        const channels = {};
        if (fx != null) channels.fx = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
            value: fx,
            scale: "fx"
        });
        if (fy != null) channels.fy = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
            value: fy,
            scale: "fy"
        });
        $dce15e0807f8b267$var$applyScaleTransforms(channels, options);
        return {
            channels: channels,
            groups: (0, $a6069a9074a3d58d$export$46a87af59f80d026)(data, channels)
        };
    }
    // This mark links to a top-level facet, if present.
    if (topFacetState === undefined) return;
    // TODO Can we link the top-level facet channels here?
    const { channels: channels, groups: groups, data: data } = topFacetState;
    if (mark.facet !== "auto" || mark.data === data) return {
        channels: channels,
        groups: groups
    };
    // Warn for the common pitfall of wanting to facet mapped data with the
    // top-level facet option.
    if (data.length > 0 && (groups.size > 1 || groups.size === 1 && channels.fx && channels.fy && [
        ...groups
    ][0][1].size > 1) && (0, $cd9e805a4bbd13f9$export$766772bbf464ff6)((0, $cd9e805a4bbd13f9$export$73f73ccd44b2553f)(mark.data)) === (0, $cd9e805a4bbd13f9$export$766772bbf464ff6)(data)) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the ${mark.ariaLabel} mark appears to use faceted data, but isn\u{2019}t faceted. The mark data has the same length as the facet data and the mark facet option is "auto", but the mark data and facet data are distinct. If this mark should be faceted, set the mark facet option to true; otherwise, suppress this warning by setting the mark facet option to false.`);
}
function $dce15e0807f8b267$var$derive(mark, options = {}) {
    return (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)({
        ...options,
        x: null,
        y: null
    }, (data, facets, channels, scales, dimensions, context)=>{
        return context.getMarkState(mark);
    });
}
function $dce15e0807f8b267$var$inferTips(marks) {
    const tips = [];
    for (const mark of marks){
        let tipOptions = mark.tip;
        if (tipOptions) {
            if (tipOptions === true) tipOptions = {};
            else if (typeof tipOptions === "string") tipOptions = {
                pointer: tipOptions
            };
            let { pointer: p, preferredAnchor: a } = tipOptions;
            p = /^x$/i.test(p) ? (0, $06868e990a5c2092$export$81f1118cc214bacd) : /^y$/i.test(p) ? (0, $06868e990a5c2092$export$a3d8dca9524ddc38) : (0, $06868e990a5c2092$export$b7fd2c2937973304); // TODO validate?
            tipOptions = p($dce15e0807f8b267$var$derive(mark, tipOptions));
            tipOptions.title = null; // prevent implicit title for primitive data
            if (a === undefined) tipOptions.preferredAnchor = p === (0, $06868e990a5c2092$export$a3d8dca9524ddc38) ? "left" : "bottom";
            const t = (0, $45befbcddbf9afbb$export$5e5b4df997cb5eaa)(mark.data, tipOptions);
            t.facet = mark.facet; // inherit facet settings
            t.facetAnchor = mark.facetAnchor; // inherit facet settings
            tips.push(t);
        }
    }
    return tips;
}
function $dce15e0807f8b267$var$inferAxes(marks, channelsByScale, options) {
    let { projection: projection, x: x = {}, y: y = {}, fx: fx = {}, fy: fy = {}, axis: axis, grid: grid, facet: facet = {}, facet: { axis: facetAxis = axis, grid: facetGrid } = facet, x: { axis: xAxis = axis, grid: xGrid = xAxis === null ? null : grid } = x, y: { axis: yAxis = axis, grid: yGrid = yAxis === null ? null : grid } = y, fx: { axis: fxAxis = facetAxis, grid: fxGrid = fxAxis === null ? null : facetGrid } = fx, fy: { axis: fyAxis = facetAxis, grid: fyGrid = fyAxis === null ? null : facetGrid } = fy } = options;
    // Disable axes if the corresponding scale is not present.
    if (projection || !(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(x) && !$dce15e0807f8b267$var$hasPositionChannel("x", marks)) xAxis = xGrid = null;
    if (projection || !(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(y) && !$dce15e0807f8b267$var$hasPositionChannel("y", marks)) yAxis = yGrid = null;
    if (!channelsByScale.has("fx")) fxAxis = fxGrid = null;
    if (!channelsByScale.has("fy")) fyAxis = fyGrid = null;
    // Resolve the default implicit axes by checking for explicit ones.
    if (xAxis === undefined) xAxis = !$dce15e0807f8b267$var$hasAxis(marks, "x");
    if (yAxis === undefined) yAxis = !$dce15e0807f8b267$var$hasAxis(marks, "y");
    if (fxAxis === undefined) fxAxis = !$dce15e0807f8b267$var$hasAxis(marks, "fx");
    if (fyAxis === undefined) fyAxis = !$dce15e0807f8b267$var$hasAxis(marks, "fy");
    // Resolve the default orientation of axes.
    if (xAxis === true) xAxis = "bottom";
    if (yAxis === true) yAxis = "left";
    if (fxAxis === true) fxAxis = xAxis === "top" || xAxis === null ? "bottom" : "top";
    if (fyAxis === true) fyAxis = yAxis === "right" || yAxis === null ? "left" : "right";
    const axes = [];
    $dce15e0807f8b267$var$maybeGrid(axes, fyGrid, (0, $fcb78e8696b500a3$export$7093722adfac6b64), fy);
    $dce15e0807f8b267$var$maybeAxis(axes, fyAxis, (0, $fcb78e8696b500a3$export$3cb762475a490c3b), "right", "left", facet, fy);
    $dce15e0807f8b267$var$maybeGrid(axes, fxGrid, (0, $fcb78e8696b500a3$export$8d672a2bd8b3cb8b), fx);
    $dce15e0807f8b267$var$maybeAxis(axes, fxAxis, (0, $fcb78e8696b500a3$export$cf6d8c730042fe7f), "top", "bottom", facet, fx);
    $dce15e0807f8b267$var$maybeGrid(axes, yGrid, (0, $fcb78e8696b500a3$export$7510dfed5fcfcd8f), y);
    $dce15e0807f8b267$var$maybeAxis(axes, yAxis, (0, $fcb78e8696b500a3$export$e4a0de62e0e52fb4), "left", "right", options, y);
    $dce15e0807f8b267$var$maybeGrid(axes, xGrid, (0, $fcb78e8696b500a3$export$6ac963799f18e4c), x);
    $dce15e0807f8b267$var$maybeAxis(axes, xAxis, (0, $fcb78e8696b500a3$export$5bc1a9741b148b9f), "bottom", "top", options, x);
    return axes;
}
function $dce15e0807f8b267$var$maybeAxis(axes, axis, axisType, primary, secondary, defaults, options) {
    if (!axis) return;
    const both = $dce15e0807f8b267$var$isBoth(axis);
    options = $dce15e0807f8b267$var$axisOptions(both ? primary : axis, defaults, options);
    const { line: line } = options;
    if ((axisType === (0, $fcb78e8696b500a3$export$e4a0de62e0e52fb4) || axisType === (0, $fcb78e8696b500a3$export$5bc1a9741b148b9f)) && line && !(0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(line)) axes.push((0, $b946fb4c8a04d9d8$export$2cef06c20297c17d)($dce15e0807f8b267$var$lineOptions(options)));
    axes.push(axisType(options));
    if (both) axes.push(axisType({
        ...options,
        anchor: secondary,
        label: null
    }));
}
function $dce15e0807f8b267$var$maybeGrid(axes, grid, gridType, options) {
    if (!grid || (0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(grid)) return;
    axes.push(gridType($dce15e0807f8b267$var$gridOptions(grid, options)));
}
function $dce15e0807f8b267$var$isBoth(value) {
    return /^\s*both\s*$/i.test(value);
}
function $dce15e0807f8b267$var$axisOptions(anchor, defaults, { line: line = defaults.line, ticks: ticks, tickSize: tickSize, tickSpacing: tickSpacing, tickPadding: tickPadding, tickFormat: tickFormat, tickRotate: tickRotate, fontVariant: fontVariant, ariaLabel: ariaLabel, ariaDescription: ariaDescription, label: label = defaults.label, labelAnchor: labelAnchor, labelArrow: labelArrow = defaults.labelArrow, labelOffset: labelOffset }) {
    return {
        anchor: anchor,
        line: line,
        ticks: ticks,
        tickSize: tickSize,
        tickSpacing: tickSpacing,
        tickPadding: tickPadding,
        tickFormat: tickFormat,
        tickRotate: tickRotate,
        fontVariant: fontVariant,
        ariaLabel: ariaLabel,
        ariaDescription: ariaDescription,
        label: label,
        labelAnchor: labelAnchor,
        labelArrow: labelArrow,
        labelOffset: labelOffset
    };
}
function $dce15e0807f8b267$var$lineOptions(options) {
    const { anchor: anchor, line: line } = options;
    return {
        anchor: anchor,
        facetAnchor: anchor + "-empty",
        stroke: line === true ? undefined : line
    };
}
function $dce15e0807f8b267$var$gridOptions(grid, { stroke: stroke = (0, $cd9e805a4bbd13f9$export$e82f763eaa28f6fe)(grid) ? grid : undefined, ticks: ticks = $dce15e0807f8b267$var$isGridTicks(grid) ? grid : undefined, tickSpacing: tickSpacing, ariaLabel: ariaLabel, ariaDescription: ariaDescription }) {
    return {
        stroke: stroke,
        ticks: ticks,
        tickSpacing: tickSpacing,
        ariaLabel: ariaLabel,
        ariaDescription: ariaDescription
    };
}
function $dce15e0807f8b267$var$isGridTicks(grid) {
    switch(typeof grid){
        case "number":
            return true;
        case "string":
            return !(0, $cd9e805a4bbd13f9$export$e82f763eaa28f6fe)(grid);
    }
    return (0, $cd9e805a4bbd13f9$export$9652023d9040757)(grid) || typeof grid?.range === "function";
}
// Is there an explicit axis already present? TODO We probably want a more
// explicit test than looking for the ARIA label, but it does afford some
// flexibility in axis implementation which is nice.
function $dce15e0807f8b267$var$hasAxis(marks, k) {
    const prefix = `${k}-axis `;
    return marks.some((m)=>m.ariaLabel?.startsWith(prefix));
}
function $dce15e0807f8b267$var$hasPositionChannel(k, marks) {
    for (const mark of marks)for(const key in mark.channels){
        const { scale: scale } = mark.channels[key];
        if (scale === k || scale === "projection") return true;
    }
    return false;
}
function $dce15e0807f8b267$var$inheritScaleLabels(newScales, scales) {
    for(const key in newScales){
        const newScale = newScales[key];
        const scale = scales[key];
        if (newScale.label === undefined && scale) newScale.label = scale.label;
    }
    return newScales;
}
// This differs from the other outerDimensions in that it accounts for rounding
// and outer padding in the facet scales; we want the frame to align exactly
// with the actual range, not the desired range.
function $dce15e0807f8b267$var$actualDimensions({ fx: fx, fy: fy }, dimensions) {
    const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = (0, $d2c16f7a6010a221$export$5d21a1ac38f7e01a)(dimensions);
    const fxr = fx && $dce15e0807f8b267$var$outerRange(fx);
    const fyr = fy && $dce15e0807f8b267$var$outerRange(fy);
    return {
        marginTop: fy ? fyr[0] : marginTop,
        marginRight: fx ? width - fxr[1] : marginRight,
        marginBottom: fy ? height - fyr[1] : marginBottom,
        marginLeft: fx ? fxr[0] : marginLeft,
        // Some marks, namely the x- and y-axis labels, want to know what the
        // desired (rather than actual) margins are for positioning.
        inset: {
            marginTop: dimensions.marginTop,
            marginRight: dimensions.marginRight,
            marginBottom: dimensions.marginBottom,
            marginLeft: dimensions.marginLeft
        },
        width: width,
        height: height
    };
}
function $dce15e0807f8b267$var$outerRange(scale) {
    const domain = scale.domain();
    if (domain.length === 0) return [
        0,
        scale.bandwidth()
    ];
    let x1 = scale(domain[0]);
    let x2 = scale(domain[domain.length - 1]);
    if (x2 < x1) [x1, x2] = [
        x2,
        x1
    ];
    return [
        x1,
        x2 + scale.bandwidth()
    ];
}





var $hga9n = parcelRequire("hga9n");
var $6FEsA = parcelRequire("6FEsA");
const $e054c3d5604c3a19$var$curves = new Map([
    [
        "basis",
        (0, $4fcc1327a5d07e55$export$2e2bcd8739ae039)
    ],
    [
        "basis-closed",
        (0, $183ce554afe8c6f0$export$2e2bcd8739ae039)
    ],
    [
        "basis-open",
        (0, $a34a32e088f640bf$export$2e2bcd8739ae039)
    ],
    [
        "bundle",
        (0, $f6400194fd6a0bdb$export$2e2bcd8739ae039)
    ],
    [
        "bump-x",
        (0, $bf3175dc82ec4a49$export$2c099b5096f70ce6)
    ],
    [
        "bump-y",
        (0, $bf3175dc82ec4a49$export$908da9dfa54cbed6)
    ],
    [
        "cardinal",
        (0, $hga9n.default)
    ],
    [
        "cardinal-closed",
        (0, $73ff40c99770ef6d$export$2e2bcd8739ae039)
    ],
    [
        "cardinal-open",
        (0, $a213115754da7990$export$2e2bcd8739ae039)
    ],
    [
        "catmull-rom",
        (0, $6FEsA.default)
    ],
    [
        "catmull-rom-closed",
        (0, $f936d5ffcfb25824$export$2e2bcd8739ae039)
    ],
    [
        "catmull-rom-open",
        (0, $341349acb9991726$export$2e2bcd8739ae039)
    ],
    [
        "linear",
        (0, $c1e9e09d9174b864$export$2e2bcd8739ae039)
    ],
    [
        "linear-closed",
        (0, $35e56ad4997e8f65$export$2e2bcd8739ae039)
    ],
    [
        "monotone-x",
        (0, $cab75dc01e66b193$export$99563b5420dbdc55)
    ],
    [
        "monotone-y",
        (0, $cab75dc01e66b193$export$8b5360456d6bdb88)
    ],
    [
        "natural",
        (0, $ecaddebfc9069a1b$export$2e2bcd8739ae039)
    ],
    [
        "step",
        (0, $1262f1c88e9696b5$export$2e2bcd8739ae039)
    ],
    [
        "step-after",
        (0, $1262f1c88e9696b5$export$793b3db073781cbb)
    ],
    [
        "step-before",
        (0, $1262f1c88e9696b5$export$10eafa5b7478b343)
    ]
]);
function $e054c3d5604c3a19$export$cb6cd5998041c3c2(curve = (0, $c1e9e09d9174b864$export$2e2bcd8739ae039), tension) {
    if (typeof curve === "function") return curve; // custom curve
    const c = $e054c3d5604c3a19$var$curves.get(`${curve}`.toLowerCase());
    if (!c) throw new Error(`unknown curve: ${curve}`);
    if (tension !== undefined) {
        if ("beta" in c) return c.beta(tension);
        else if ("tension" in c) return c.tension(tension);
        else if ("alpha" in c) return c.alpha(tension);
    }
    return c;
}
function $e054c3d5604c3a19$export$6a0c91309def6a6b(curve = $e054c3d5604c3a19$export$ff5d4948fdbac520, tension) {
    return typeof curve !== "function" && `${curve}`.toLowerCase() === "auto" ? $e054c3d5604c3a19$export$ff5d4948fdbac520 : $e054c3d5604c3a19$export$cb6cd5998041c3c2(curve, tension);
}
function $e054c3d5604c3a19$export$ff5d4948fdbac520(context) {
    return (0, $c1e9e09d9174b864$export$2e2bcd8739ae039)(context);
}












function $7835cc6df31dbb5c$export$b0cd3e1210e3bd40(outputs = {
    y: "count"
}, options = {}) {
    [outputs, options] = $7835cc6df31dbb5c$var$mergeOptions(outputs, options);
    const { x: x, y: y } = options;
    return $7835cc6df31dbb5c$var$binn($7835cc6df31dbb5c$var$maybeBinValue(x, options, (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)), null, null, y, outputs, (0, $99fa11de593a4520$export$26b23c8bb7051b0)(options));
}
function $7835cc6df31dbb5c$export$fb91cb2ec8a31222(outputs = {
    x: "count"
}, options = {}) {
    [outputs, options] = $7835cc6df31dbb5c$var$mergeOptions(outputs, options);
    const { x: x, y: y } = options;
    return $7835cc6df31dbb5c$var$binn(null, $7835cc6df31dbb5c$var$maybeBinValue(y, options, (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)), x, null, outputs, (0, $99fa11de593a4520$export$cc1990e80430bfbb)(options));
}
function $7835cc6df31dbb5c$export$f03e751d9cddb7a(outputs = {
    fill: "count"
}, options = {}) {
    [outputs, options] = $7835cc6df31dbb5c$var$mergeOptions(outputs, options);
    const { x: x, y: y } = $7835cc6df31dbb5c$var$maybeBinValueTuple(options);
    return $7835cc6df31dbb5c$var$binn(x, y, null, null, outputs, (0, $99fa11de593a4520$export$26b23c8bb7051b0)((0, $99fa11de593a4520$export$cc1990e80430bfbb)(options)));
}
function $7835cc6df31dbb5c$var$maybeDenseInterval(bin, k, options = {}) {
    if (options?.interval == null) return options;
    const { reduce: reduce = (0, $23ff17797d38563c$export$e76bb8aee9fc4afa) } = options;
    const outputs = {
        filter: null
    };
    if (options[k] != null) outputs[k] = reduce;
    if (options[`${k}1`] != null) outputs[`${k}1`] = reduce;
    if (options[`${k}2`] != null) outputs[`${k}2`] = reduce;
    return bin(outputs, options);
}
function $7835cc6df31dbb5c$export$5dd1e2373c1d87f4(options = {}) {
    return $7835cc6df31dbb5c$var$maybeDenseInterval($7835cc6df31dbb5c$export$b0cd3e1210e3bd40, "y", (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "x"));
}
function $7835cc6df31dbb5c$export$ca6f170f8f69497e(options = {}) {
    return $7835cc6df31dbb5c$var$maybeDenseInterval($7835cc6df31dbb5c$export$fb91cb2ec8a31222, "x", (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "y"));
}
function $7835cc6df31dbb5c$var$binn(bx, by, gx, gy, { data: reduceData = (0, $23ff17797d38563c$export$e9e62aaf7ac0743d), filter: filter = (0, $23ff17797d38563c$export$32697fc8b2c2e2f7), sort: sort, reverse: reverse, ...outputs // output channel definitions
 } = {}, inputs = {} // input channels and options
) {
    bx = $7835cc6df31dbb5c$var$maybeBin(bx);
    by = $7835cc6df31dbb5c$var$maybeBin(by);
    // Compute the outputs.
    outputs = $7835cc6df31dbb5c$var$maybeBinOutputs(outputs, inputs);
    reduceData = $7835cc6df31dbb5c$var$maybeBinReduce(reduceData, (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655));
    sort = sort == null ? undefined : $7835cc6df31dbb5c$var$maybeBinOutput("sort", sort, inputs);
    filter = filter == null ? undefined : $7835cc6df31dbb5c$var$maybeBinEvaluator("filter", filter, inputs);
    // Don’t group on a channel if an output requires it as an input!
    if (gx != null && (0, $23ff17797d38563c$export$c8c5ed0593b91b40)(outputs, "x", "x1", "x2")) gx = null;
    if (gy != null && (0, $23ff17797d38563c$export$c8c5ed0593b91b40)(outputs, "y", "y1", "y2")) gy = null;
    // Produce x1, x2, y1, and y2 output channels as appropriate (when binning).
    const [BX1, setBX1] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(bx);
    const [BX2, setBX2] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(bx);
    const [BY1, setBY1] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(by);
    const [BY2, setBY2] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(by);
    // Produce x or y output channels as appropriate (when grouping).
    const [k, gk] = gx != null ? [
        gx,
        "x"
    ] : gy != null ? [
        gy,
        "y"
    ] : [];
    const [GK, setGK] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(k);
    // Greedily materialize the z, fill, and stroke channels (if channels and not
    // constants) so that we can reference them for subdividing groups without
    // computing them more than once. We also want to consume options that should
    // only apply to this transform rather than passing them through to the next.
    const { x: x, y: y, z: z, fill: fill, stroke: stroke, x1: x1, x2: x2, y1: y1, y2: y2, domain: domain, cumulative: cumulative, thresholds: thresholds, interval: interval, ...options } = inputs;
    const [GZ, setGZ] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(z);
    const [vfill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    const [vstroke] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke);
    const [GF, setGF] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(vfill);
    const [GS, setGS] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(vstroke);
    return {
        ..."z" in inputs && {
            z: GZ || z
        },
        ..."fill" in inputs && {
            fill: GF || fill
        },
        ..."stroke" in inputs && {
            stroke: GS || stroke
        },
        ...(0, $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options, (data, facets, plotOptions)=>{
            const K = (0, $cd9e805a4bbd13f9$export$90792ed47ffcc9f3)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, k), plotOptions?.[gk]);
            const Z = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, z);
            const F = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, vfill);
            const S = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, vstroke);
            const G = (0, $23ff17797d38563c$export$2b68910c7fd8dbce)(outputs, {
                z: Z,
                fill: F,
                stroke: S
            });
            const groupFacets = [];
            const groupData = [];
            const GK = K && setGK([]);
            const GZ = Z && setGZ([]);
            const GF = F && setGF([]);
            const GS = S && setGS([]);
            const BX1 = bx && setBX1([]);
            const BX2 = bx && setBX2([]);
            const BY1 = by && setBY1([]);
            const BY2 = by && setBY2([]);
            const bin = $7835cc6df31dbb5c$var$bing(bx, by, data);
            let i = 0;
            for (const o of outputs)o.initialize(data);
            if (sort) sort.initialize(data);
            if (filter) filter.initialize(data);
            for (const facet of facets){
                const groupFacet = [];
                for (const o of outputs)o.scope("facet", facet);
                if (sort) sort.scope("facet", facet);
                if (filter) filter.scope("facet", facet);
                for (const [f, I] of (0, $23ff17797d38563c$export$66e58775f8a76bc5)(facet, G)){
                    for (const [k, g] of (0, $23ff17797d38563c$export$66e58775f8a76bc5)(I, K))for (const [b, extent] of bin(g)){
                        if (G) extent.z = f;
                        if (filter && !filter.reduce(b, extent)) continue;
                        groupFacet.push(i++);
                        groupData.push(reduceData.reduceIndex(b, data, extent));
                        if (K) GK.push(k);
                        if (Z) GZ.push(G === Z ? f : Z[(b.length > 0 ? b : g)[0]]);
                        if (F) GF.push(G === F ? f : F[(b.length > 0 ? b : g)[0]]);
                        if (S) GS.push(G === S ? f : S[(b.length > 0 ? b : g)[0]]);
                        if (BX1) BX1.push(extent.x1), BX2.push(extent.x2);
                        if (BY1) BY1.push(extent.y1), BY2.push(extent.y2);
                        for (const o of outputs)o.reduce(b, extent);
                        if (sort) sort.reduce(b, extent);
                    }
                }
                groupFacets.push(groupFacet);
            }
            (0, $23ff17797d38563c$export$e6df691e0874bc87)(groupFacets, sort, reverse);
            return {
                data: groupData,
                facets: groupFacets
            };
        }),
        ...!(0, $23ff17797d38563c$export$c8c5ed0593b91b40)(outputs, "x") && (BX1 ? {
            x1: BX1,
            x2: BX2,
            x: (0, $cd9e805a4bbd13f9$export$a61423b330c3444c)(BX1, BX2)
        } : {
            x: x,
            x1: x1,
            x2: x2
        }),
        ...!(0, $23ff17797d38563c$export$c8c5ed0593b91b40)(outputs, "y") && (BY1 ? {
            y1: BY1,
            y2: BY2,
            y: (0, $cd9e805a4bbd13f9$export$a61423b330c3444c)(BY1, BY2)
        } : {
            y: y,
            y1: y1,
            y2: y2
        }),
        ...GK && {
            [gk]: GK
        },
        ...Object.fromEntries(outputs.map(({ name: name, output: output })=>[
                name,
                output
            ]))
    };
}
// Allow bin options to be specified as part of outputs; merge them into options.
function $7835cc6df31dbb5c$var$mergeOptions({ cumulative: cumulative, domain: domain, thresholds: thresholds, interval: interval, ...outputs }, options) {
    return [
        outputs,
        {
            cumulative: cumulative,
            domain: domain,
            thresholds: thresholds,
            interval: interval,
            ...options
        }
    ];
}
function $7835cc6df31dbb5c$var$maybeBinValue(value, { cumulative: cumulative, domain: domain, thresholds: thresholds, interval: interval }, defaultValue) {
    value = {
        ...(0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(value)
    };
    if (value.domain === undefined) value.domain = domain;
    if (value.cumulative === undefined) value.cumulative = cumulative;
    if (value.thresholds === undefined) value.thresholds = thresholds;
    if (value.interval === undefined) value.interval = interval;
    if (value.value === undefined) value.value = defaultValue;
    value.thresholds = $7835cc6df31dbb5c$export$187f70b6b0433c39(value.thresholds, value.interval);
    return value;
}
function $7835cc6df31dbb5c$var$maybeBinValueTuple(options) {
    let { x: x, y: y } = options;
    x = $7835cc6df31dbb5c$var$maybeBinValue(x, options);
    y = $7835cc6df31dbb5c$var$maybeBinValue(y, options);
    [x.value, y.value] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x.value, y.value);
    return {
        x: x,
        y: y
    };
}
function $7835cc6df31dbb5c$var$maybeBin(options) {
    if (options == null) return;
    const { value: value, cumulative: cumulative, domain: domain = (0, $24461355656d8852$export$2e2bcd8739ae039), thresholds: thresholds } = options;
    const bin = (data)=>{
        let V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value);
        let T; // bin thresholds
        if ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(V) || $7835cc6df31dbb5c$var$isTimeThresholds(thresholds)) {
            V = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(V, (0, $cd9e805a4bbd13f9$export$187f75afdaf90d5b), Float64Array); // like coerceDates, but faster
            let [min, max] = typeof domain === "function" ? domain(V) : domain;
            let t = typeof thresholds === "function" && !(0, $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e)(thresholds) ? thresholds(V, min, max) : thresholds;
            if (typeof t === "number") t = (0, $047ba3ec3f41562e$export$6262d8d056ea44c4)(min, max, t);
            if ((0, $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e)(t)) {
                if (domain === (0, $24461355656d8852$export$2e2bcd8739ae039)) {
                    min = t.floor(min);
                    max = t.offset(t.floor(max));
                }
                t = t.range(min, t.offset(max));
            }
            T = t;
        } else {
            V = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(V);
            let [min, max] = typeof domain === "function" ? domain(V) : domain;
            let t = typeof thresholds === "function" && !(0, $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e)(thresholds) ? thresholds(V, min, max) : thresholds;
            if (typeof t === "number") {
                // This differs from d3.ticks with regard to exclusive bounds: we want a
                // first threshold less than or equal to the minimum, and a last
                // threshold (strictly) greater than the maximum.
                if (domain === (0, $24461355656d8852$export$2e2bcd8739ae039)) {
                    let step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(min, max, t);
                    if (isFinite(step)) {
                        if (step > 0) {
                            let r0 = Math.round(min / step);
                            let r1 = Math.round(max / step);
                            if (!(r0 * step <= min)) --r0;
                            if (!(r1 * step > max)) ++r1;
                            let n = r1 - r0 + 1;
                            t = new Float64Array(n);
                            for(let i = 0; i < n; ++i)t[i] = (r0 + i) * step;
                        } else if (step < 0) {
                            step = -step;
                            let r0 = Math.round(min * step);
                            let r1 = Math.round(max * step);
                            if (!(r0 / step <= min)) --r0;
                            if (!(r1 / step > max)) ++r1;
                            let n = r1 - r0 + 1;
                            t = new Float64Array(n);
                            for(let i = 0; i < n; ++i)t[i] = (r0 + i) / step;
                        } else t = [
                            min
                        ];
                    } else t = [
                        min
                    ];
                } else t = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(min, max, t);
            } else if ((0, $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e)(t)) {
                if (domain === (0, $24461355656d8852$export$2e2bcd8739ae039)) {
                    min = t.floor(min);
                    max = t.offset(t.floor(max));
                }
                t = t.range(min, t.offset(max));
            }
            T = t;
        }
        const E = [];
        if (T.length === 1) E.push([
            T[0],
            T[0]
        ]); // collapsed domain
        else for(let i = 1; i < T.length; ++i)E.push([
            T[i - 1],
            T[i]
        ]);
        E.bin = (cumulative < 0 ? $7835cc6df31dbb5c$var$bin1cn : cumulative > 0 ? $7835cc6df31dbb5c$var$bin1cp : $7835cc6df31dbb5c$var$bin1)(E, T, V);
        return E;
    };
    bin.label = (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(value);
    return bin;
}
function $7835cc6df31dbb5c$export$187f70b6b0433c39(thresholds, interval, defaultThresholds = $7835cc6df31dbb5c$var$thresholdAuto) {
    if (thresholds === undefined) return interval === undefined ? defaultThresholds : (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval);
    if (typeof thresholds === "string") {
        switch(thresholds.toLowerCase()){
            case "freedman-diaconis":
                return 0, $1ae435d6739098c4$export$2e2bcd8739ae039;
            case "scott":
                return 0, $e5c6de1a6d3b2294$export$2e2bcd8739ae039;
            case "sturges":
                return 0, $6d386446084ca1a9$export$2e2bcd8739ae039;
            case "auto":
                return $7835cc6df31dbb5c$var$thresholdAuto;
        }
        return (0, $49e9bdee870d78f0$export$e1d09836890453eb)(thresholds);
    }
    return thresholds; // pass array, count, or function to bin.thresholds
}
function $7835cc6df31dbb5c$var$maybeBinOutputs(outputs, inputs) {
    return (0, $23ff17797d38563c$export$8c5fe1f2932839cd)(outputs, inputs, $7835cc6df31dbb5c$var$maybeBinOutput);
}
function $7835cc6df31dbb5c$var$maybeBinOutput(name, reduce, inputs) {
    return (0, $23ff17797d38563c$export$d428705214c4bb4c)(name, reduce, inputs, $7835cc6df31dbb5c$var$maybeBinEvaluator);
}
function $7835cc6df31dbb5c$var$maybeBinEvaluator(name, reduce, inputs) {
    return (0, $23ff17797d38563c$export$af9bcd7c8847e1bc)(name, reduce, inputs, $7835cc6df31dbb5c$var$maybeBinReduce);
}
function $7835cc6df31dbb5c$var$maybeBinReduce(reduce, value) {
    return (0, $23ff17797d38563c$export$8741001136aed6bd)(reduce, value, $7835cc6df31dbb5c$var$maybeBinReduceFallback);
}
function $7835cc6df31dbb5c$var$maybeBinReduceFallback(reduce) {
    switch(`${reduce}`.toLowerCase()){
        case "x":
            return $7835cc6df31dbb5c$var$reduceX;
        case "x1":
            return $7835cc6df31dbb5c$var$reduceX1;
        case "x2":
            return $7835cc6df31dbb5c$var$reduceX2;
        case "y":
            return $7835cc6df31dbb5c$var$reduceY;
        case "y1":
            return $7835cc6df31dbb5c$var$reduceY1;
        case "y2":
            return $7835cc6df31dbb5c$var$reduceY2;
        case "z":
            return 0, $23ff17797d38563c$export$308e6b8cfac254e0;
    }
    throw new Error(`invalid bin reduce: ${reduce}`);
}
function $7835cc6df31dbb5c$var$thresholdAuto(values, min, max) {
    return Math.min(200, (0, $e5c6de1a6d3b2294$export$2e2bcd8739ae039)(values, min, max));
}
function $7835cc6df31dbb5c$var$isTimeThresholds(t) {
    return (0, $cd9e805a4bbd13f9$export$99c391ff8c95e1af)(t) || (0, $cd9e805a4bbd13f9$export$9652023d9040757)(t) && (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(t);
}
function $7835cc6df31dbb5c$var$bing(bx, by, data) {
    const EX = bx?.(data);
    const EY = by?.(data);
    return EX && EY ? function*(I) {
        const X = EX.bin(I); // first bin on x
        for (const [ix, [x1, x2]] of EX.entries()){
            const Y = EY.bin(X[ix]); // then bin on y
            for (const [iy, [y1, y2]] of EY.entries())yield [
                Y[iy],
                {
                    data: data,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                }
            ];
        }
    } : EX ? function*(I) {
        const X = EX.bin(I);
        for (const [i, [x1, x2]] of EX.entries())yield [
            X[i],
            {
                data: data,
                x1: x1,
                x2: x2
            }
        ];
    } : function*(I) {
        const Y = EY.bin(I);
        for (const [i, [y1, y2]] of EY.entries())yield [
            Y[i],
            {
                data: data,
                y1: y1,
                y2: y2
            }
        ];
    };
}
// non-cumulative distribution
function $7835cc6df31dbb5c$var$bin1(E, T, V) {
    T = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(T); // for faster bisection
    return (I)=>{
        const B = E.map(()=>[]);
        for (const i of I)B[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(T, V[i]) - 1]?.push(i); // TODO quantization?
        return B;
    };
}
// cumulative distribution
function $7835cc6df31dbb5c$var$bin1cp(E, T, V) {
    const bin = $7835cc6df31dbb5c$var$bin1(E, T, V);
    return (I)=>{
        const B = bin(I);
        for(let i = 1, n = B.length; i < n; ++i){
            const C = B[i - 1];
            const b = B[i];
            for (const j of C)b.push(j);
        }
        return B;
    };
}
// complementary cumulative distribution
function $7835cc6df31dbb5c$var$bin1cn(E, T, V) {
    const bin = $7835cc6df31dbb5c$var$bin1(E, T, V);
    return (I)=>{
        const B = bin(I);
        for(let i = B.length - 2; i >= 0; --i){
            const C = B[i + 1];
            const b = B[i];
            for (const j of C)b.push(j);
        }
        return B;
    };
}
function $7835cc6df31dbb5c$var$mid1(x1, x2) {
    const m = (+x1 + +x2) / 2;
    return x1 instanceof Date ? new Date(m) : m;
}
const $7835cc6df31dbb5c$var$reduceX = {
    reduceIndex (I, X, { x1: x1, x2: x2 }) {
        return $7835cc6df31dbb5c$var$mid1(x1, x2);
    }
};
const $7835cc6df31dbb5c$var$reduceY = {
    reduceIndex (I, X, { y1: y1, y2: y2 }) {
        return $7835cc6df31dbb5c$var$mid1(y1, y2);
    }
};
const $7835cc6df31dbb5c$var$reduceX1 = {
    reduceIndex (I, X, { x1: x1 }) {
        return x1;
    }
};
const $7835cc6df31dbb5c$var$reduceX2 = {
    reduceIndex (I, X, { x2: x2 }) {
        return x2;
    }
};
const $7835cc6df31dbb5c$var$reduceY1 = {
    reduceIndex (I, X, { y1: y1 }) {
        return y1;
    }
};
const $7835cc6df31dbb5c$var$reduceY2 = {
    reduceIndex (I, X, { y2: y2 }) {
        return y2;
    }
};




const $56ab23daa4e1674b$var$defaults = {
    ariaLabel: "area",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1
};
class $56ab23daa4e1674b$export$ea1a111407f37557 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x1: x1, y1: y1, x2: x2, y2: y2, z: z, curve: curve, tension: tension } = options;
        super(data, {
            x1: {
                value: x1,
                scale: "x"
            },
            y1: {
                value: y1,
                scale: "y"
            },
            x2: {
                value: x2,
                scale: "x",
                optional: true
            },
            y2: {
                value: y2,
                scale: "y",
                optional: true
            },
            z: {
                value: (0, $cd9e805a4bbd13f9$export$9040d0441634ebe5)(options),
                optional: true
            }
        }, options, $56ab23daa4e1674b$var$defaults);
        this.z = z;
        this.curve = (0, $e054c3d5604c3a19$export$cb6cd5998041c3c2)(curve, tension);
    }
    filter(index) {
        return index;
    }
    render(index, scales, channels, dimensions, context) {
        const { x1: X1, y1: Y1, x2: X2 = X1, y2: Y2 = Y1 } = channels;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, scales, 0, 0).call((g)=>g.selectAll().data((0, $547e5698440387a8$export$33c8ab41edf38638)(index, [
                X1,
                Y1,
                X2,
                Y2
            ], this, channels)).enter().append("path").call((0, $547e5698440387a8$export$2949c2472f804203), this).call((0, $547e5698440387a8$export$ddd674e1b6498f54), this, channels).attr("d", (0, $b654034e6c52569c$export$2e2bcd8739ae039)().curve(this.curve).defined((i)=>i >= 0).x0((i)=>X1[i]).y0((i)=>Y1[i]).x1((i)=>X2[i]).y1((i)=>Y2[i]))).node();
    }
}
function $56ab23daa4e1674b$export$bb3edc44842b5f2e(data, options) {
    if (options === undefined) return $56ab23daa4e1674b$export$9d014eceaec9fa56(data, {
        x: (0, $cd9e805a4bbd13f9$export$43128fadae87b74a),
        y: (0, $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d)
    });
    return new $56ab23daa4e1674b$export$ea1a111407f37557(data, options);
}
function $56ab23daa4e1674b$export$5cc134bfea0d82f9(data, options) {
    const { y: y = (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2), ...rest } = (0, $7835cc6df31dbb5c$export$ca6f170f8f69497e)(options);
    return new $56ab23daa4e1674b$export$ea1a111407f37557(data, (0, $edd8a0486fa281c7$export$8dc1b2cbfd434f0e)((0, $6c8df8405b475220$export$e882a15fe9f7109f)({
        ...rest,
        y1: y,
        y2: undefined
    })));
}
function $56ab23daa4e1674b$export$9d014eceaec9fa56(data, options) {
    const { x: x = (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2), ...rest } = (0, $7835cc6df31dbb5c$export$5dd1e2373c1d87f4)(options);
    return new $56ab23daa4e1674b$export$ea1a111407f37557(data, (0, $edd8a0486fa281c7$export$8e6f10a352d8a326)((0, $6c8df8405b475220$export$463e88814e852032)({
        ...rest,
        x1: x,
        x2: undefined
    })));
}
















function $60fbcda062a2738b$export$328c6efdff286356(data, options) {
    return $60fbcda062a2738b$var$crosshairK((0, $06868e990a5c2092$export$b7fd2c2937973304), data, options);
}
function $60fbcda062a2738b$export$69cd9e72e20630fa(data, options = {}) {
    return $60fbcda062a2738b$var$crosshairK((0, $06868e990a5c2092$export$81f1118cc214bacd), data, options);
}
function $60fbcda062a2738b$export$315a7a47fba9c33a(data, options = {}) {
    return $60fbcda062a2738b$var$crosshairK((0, $06868e990a5c2092$export$a3d8dca9524ddc38), data, options);
}
function $60fbcda062a2738b$var$crosshairK(pointer, data, options = {}) {
    const { x: x, y: y, maxRadius: maxRadius } = options;
    const p = pointer({
        px: x,
        py: y,
        maxRadius: maxRadius
    });
    const M = [];
    if (x != null) M.push((0, $60ff8edb66755c31$export$22653c04c6d89eeb)(data, $60fbcda062a2738b$var$ruleOptions("x", {
        ...p,
        inset: -6
    }, options)));
    if (y != null) M.push((0, $60ff8edb66755c31$export$d121b88bc74f6ae5)(data, $60fbcda062a2738b$var$ruleOptions("y", {
        ...p,
        inset: -6
    }, options)));
    if (x != null) M.push((0, $b4855ffaf649c526$export$6f093cfa640b7166)(data, $60fbcda062a2738b$var$textOptions("x", {
        ...p,
        dy: 9,
        frameAnchor: "bottom",
        lineAnchor: "top"
    }, options)));
    if (y != null) M.push((0, $b4855ffaf649c526$export$6f093cfa640b7166)(data, $60fbcda062a2738b$var$textOptions("y", {
        ...p,
        dx: -9,
        frameAnchor: "left",
        textAnchor: "end"
    }, options)));
    for (const m of M)m.ariaLabel = `crosshair ${m.ariaLabel}`;
    return (0, $24d8c38d667d16c2$export$3a8025f2f3e0c64)(...M);
}
function $60fbcda062a2738b$var$markOptions(k, { channels: pointerChannels, ...pointerOptions }, { facet: facet, facetAnchor: facetAnchor, fx: fx, fy: fy, [k]: p, channels: channels, transform: transform, initializer: initializer }) {
    return {
        ...pointerOptions,
        facet: facet,
        facetAnchor: facetAnchor,
        fx: fx,
        fy: fy,
        [k]: p,
        channels: {
            ...pointerChannels,
            ...channels
        },
        transform: transform,
        initializer: $60fbcda062a2738b$var$pxpy(k, initializer)
    };
}
// Wrap the initializer, if any, mapping px and py to x and y temporarily (e.g.,
// for hexbin) then mapping back to px and py for rendering.
function $60fbcda062a2738b$var$pxpy(k, i) {
    if (i == null) return i;
    return function(data, facets, { x: x1, y: y1, px: px, py: py, ...c1 }, ...args) {
        const { channels: { x: x, y: y, ...c } = {}, ...rest } = i.call(this, data, facets, {
            ...c1,
            x: px,
            y: py
        }, ...args);
        return {
            channels: {
                ...c,
                ...x && {
                    px: x,
                    ...k === "x" && {
                        x: x
                    }
                },
                ...y && {
                    py: y,
                    ...k === "y" && {
                        y: y
                    }
                }
            },
            ...rest
        };
    };
}
function $60fbcda062a2738b$var$ruleOptions(k, pointerOptions, options) {
    const { color: color = "currentColor", opacity: opacity = 0.2, ruleStroke: stroke = color, ruleStrokeOpacity: strokeOpacity = opacity, ruleStrokeWidth: strokeWidth } = options;
    return {
        ...$60fbcda062a2738b$var$markOptions(k, pointerOptions, options),
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth
    };
}
function $60fbcda062a2738b$var$textOptions(k, pointerOptions, options) {
    const { color: color = "currentColor", textFill: fill = color, textFillOpacity: fillOpacity, textStroke: stroke = "var(--plot-background)", textStrokeOpacity: strokeOpacity, textStrokeWidth: strokeWidth = 5 } = options;
    return {
        ...$60fbcda062a2738b$var$markOptions(k, pointerOptions, $60fbcda062a2738b$var$textChannel(k, options)),
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth
    };
}
// Rather than aliasing text to have the same definition as x and y, we use an
// initializer to alias the channel values, such that the text channel can be
// derived by an initializer such as hexbin.
function $60fbcda062a2738b$var$textChannel(source, options) {
    return (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)(options, (data, facets, channels)=>{
        return {
            channels: {
                text: {
                    value: (0, $6eb5f337b2493843$export$dd2b6e807fb37ba3)(channels, source)?.value
                }
            }
        };
    });
}















const $7910fd10d657c0be$var$defaults = {
    ariaLabel: "dot",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
};
function $7910fd10d657c0be$export$d1f5ec764946d194(options) {
    return options.sort === undefined && options.reverse === undefined ? (0, $9dfbc15f77c5eeba$export$97db5808d8f88186)({
        channel: "-r"
    }, options) : options;
}
class $7910fd10d657c0be$export$d046b3c4a416f60d extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, r: r, rotate: rotate, symbol: symbol = (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039), frameAnchor: frameAnchor } = options;
        const [vrotate, crotate] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(rotate, 0);
        const [vsymbol, csymbol] = (0, $7ef09cabd5617a1b$export$5b4fe6145c7212af)(symbol);
        const [vr, cr] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(r, vsymbol == null ? 3 : 4.5);
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            r: {
                value: vr,
                scale: "r",
                filter: (0, $0f3e37548c3914c7$export$aa5128ab863cd04),
                optional: true
            },
            rotate: {
                value: vrotate,
                optional: true
            },
            symbol: {
                value: vsymbol,
                scale: "auto",
                optional: true
            }
        }, $7910fd10d657c0be$export$d1f5ec764946d194(options), $7910fd10d657c0be$var$defaults);
        this.r = cr;
        this.rotate = crotate;
        this.symbol = csymbol;
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
        // Give a hint to the symbol scale; this allows the symbol scale to choose
        // appropriate default symbols based on whether the dots are filled or
        // stroked, and for the symbol legend to match the appearance of the dots.
        const { channels: channels } = this;
        const { symbol: symbolChannel } = channels;
        if (symbolChannel) {
            const { fill: fillChannel, stroke: strokeChannel } = channels;
            symbolChannel.hint = {
                fill: fillChannel ? fillChannel.value === symbolChannel.value ? "color" : "currentColor" : this.fill ?? "currentColor",
                stroke: strokeChannel ? strokeChannel.value === symbolChannel.value ? "color" : "currentColor" : this.stroke ?? "none"
            };
        }
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y: Y, r: R, rotate: A, symbol: S } = channels;
        const { r: r, rotate: rotate, symbol: symbol } = this;
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        const circle = symbol === (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039);
        const size = R ? undefined : r * r * Math.PI;
        if ((0, $0f3e37548c3914c7$export$5f47f64d03acd206)(r)) index = [];
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append(circle ? "circle" : "path").call((0, $547e5698440387a8$export$2949c2472f804203), this).call(circle ? (selection)=>{
                selection.attr("cx", X ? (i)=>X[i] : cx).attr("cy", Y ? (i)=>Y[i] : cy).attr("r", R ? (i)=>R[i] : r);
            } : (selection)=>{
                selection.attr("transform", (0, $bfd513fc05083823$export$ce69bd05624d0c48)`translate(${X ? (i)=>X[i] : cx},${Y ? (i)=>Y[i] : cy})${A ? (i)=>` rotate(${A[i]})` : rotate ? ` rotate(${rotate})` : ``}`).attr("d", R && S ? (i)=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    S[i].draw(p, R[i] * R[i] * Math.PI);
                    return p;
                } : R ? (i)=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    symbol.draw(p, R[i] * R[i] * Math.PI);
                    return p;
                } : S ? (i)=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    S[i].draw(p, size);
                    return p;
                } : (()=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    symbol.draw(p, size);
                    return p;
                })());
            }).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels)).node();
    }
}
function $7910fd10d657c0be$export$94132a0e348806d4(data, { x: x, y: y, ...options } = {}) {
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $7910fd10d657c0be$export$d046b3c4a416f60d(data, {
        ...options,
        x: x,
        y: y
    });
}
function $7910fd10d657c0be$export$2786571523132693(data, { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $7910fd10d657c0be$export$d046b3c4a416f60d(data, (0, $785a735c79529924$export$a7ad4939d5e92aaa)({
        ...options,
        x: x
    }));
}
function $7910fd10d657c0be$export$ef8227e2f1ca16e1(data, { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $7910fd10d657c0be$export$d046b3c4a416f60d(data, (0, $785a735c79529924$export$4d0ebe7ec032f34f)({
        ...options,
        y: y
    }));
}
function $7910fd10d657c0be$export$e1d786d2f707b414(data, options) {
    return $7910fd10d657c0be$export$94132a0e348806d4(data, {
        ...options,
        symbol: "circle"
    });
}
function $7910fd10d657c0be$export$578abc0d25ff055c(data, options) {
    return $7910fd10d657c0be$export$94132a0e348806d4(data, {
        ...options,
        symbol: "hexagon"
    });
}














const $b4700ec791af3ab2$var$defaults = {
    ariaLabel: "line",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1
};
class $b4700ec791af3ab2$export$17d680238e50603e extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, z: z, curve: curve, tension: tension } = options;
        super(data, {
            x: {
                value: x,
                scale: "x"
            },
            y: {
                value: y,
                scale: "y"
            },
            z: {
                value: (0, $cd9e805a4bbd13f9$export$9040d0441634ebe5)(options),
                optional: true
            }
        }, options, $b4700ec791af3ab2$var$defaults);
        this.z = z;
        this.curve = (0, $e054c3d5604c3a19$export$6a0c91309def6a6b)(curve, tension);
        (0, $f013115577adb919$export$6b811a095661528f)(this, options);
    }
    filter(index) {
        return index;
    }
    project(channels, values, context) {
        // For the auto curve, projection is handled at render.
        if (this.curve !== (0, $e054c3d5604c3a19$export$ff5d4948fdbac520)) super.project(channels, values, context);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: X, y: Y } = channels;
        const { curve: curve } = this;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, scales).call((g)=>g.selectAll().data((0, $547e5698440387a8$export$33c8ab41edf38638)(index, [
                X,
                Y
            ], this, channels)).enter().append("path").call((0, $547e5698440387a8$export$2949c2472f804203), this).call((0, $547e5698440387a8$export$ddd674e1b6498f54), this, channels).call((0, $f013115577adb919$export$e6a749a5a88e9589), this, channels, context).attr("d", curve === (0, $e054c3d5604c3a19$export$ff5d4948fdbac520) && context.projection ? $b4700ec791af3ab2$var$sphereLine(context.projection, X, Y) : (0, $3fbda81220c6ea9c$export$2e2bcd8739ae039)().curve(curve).defined((i)=>i >= 0).x((i)=>X[i]).y((i)=>Y[i]))).node();
    }
}
function $b4700ec791af3ab2$var$sphereLine(projection, X, Y) {
    const path = (0, $58c46562f4a8d739$export$2e2bcd8739ae039)(projection);
    X = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(X);
    Y = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(Y);
    return (I)=>{
        let line = [];
        const lines = [
            line
        ];
        for (const i of I)// Check for undefined value; see groupIndex.
        if (i === -1) {
            line = [];
            lines.push(line);
        } else line.push([
            X[i],
            Y[i]
        ]);
        return path({
            type: "MultiLineString",
            coordinates: lines
        });
    };
}
function $b4700ec791af3ab2$export$53f1d5ea8de3d7c(data, { x: x, y: y, ...options } = {}) {
    [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $b4700ec791af3ab2$export$17d680238e50603e(data, {
        ...options,
        x: x,
        y: y
    });
}
function $b4700ec791af3ab2$export$d539b0b4a31c7ef5(data, { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), y: y = (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2), ...options } = {}) {
    return new $b4700ec791af3ab2$export$17d680238e50603e(data, (0, $7835cc6df31dbb5c$export$ca6f170f8f69497e)({
        ...options,
        x: x,
        y: y
    }));
}
function $b4700ec791af3ab2$export$c64634048b1f56ea(data, { x: x = (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2), y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $b4700ec791af3ab2$export$17d680238e50603e(data, (0, $7835cc6df31dbb5c$export$5dd1e2373c1d87f4)({
        ...options,
        x: x,
        y: y
    }));
}
































// Note: this side effect avoids a circular dependency.
(0, $24d8c38d667d16c2$export$c9d15bcfc6d42044).prototype.plot = function({ marks: marks = [], ...options } = {}) {
    return (0, $dce15e0807f8b267$export$2bbbe2756ad57c66)({
        ...options,
        marks: [
            ...marks,
            this
        ]
    });
};



"use client";
var [$504373a3b2738bf1$export$4aacc92b34f48449, $504373a3b2738bf1$export$c1f1c27d8fe70f39] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "CardContext",
    strict: true,
    errorMessage: "useCardContext: `context` is undefined. Seems you forgot to wrap component within <Card />"
});




// src/components/card.ts
var $6d660e11ca17fc8d$export$aa3e815946b80764 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "flex-col",
            "relative",
            "overflow-hidden",
            "h-auto",
            "outline-none",
            "text-foreground",
            "box-border",
            "bg-content1",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        header: [
            "flex",
            "p-3",
            "z-10",
            "w-full",
            "justify-start",
            "items-center",
            "shrink-0",
            "overflow-inherit",
            "color-inherit",
            "subpixel-antialiased"
        ],
        body: [
            "relative",
            "flex",
            "flex-1",
            "w-full",
            "p-3",
            "flex-auto",
            "flex-col",
            "place-content-inherit",
            "align-items-inherit",
            "h-auto",
            "break-words",
            "text-left",
            "overflow-y-auto",
            "subpixel-antialiased"
        ],
        footer: [
            "p-3",
            "h-auto",
            "flex",
            "w-full",
            "items-center",
            "overflow-hidden",
            "color-inherit",
            "subpixel-antialiased"
        ]
    },
    variants: {
        shadow: {
            none: {
                base: "shadow-none"
            },
            sm: {
                base: "shadow-small"
            },
            md: {
                base: "shadow-medium"
            },
            lg: {
                base: "shadow-large"
            }
        },
        radius: {
            none: {
                base: "rounded-none",
                header: "rounded-none",
                footer: "rounded-none"
            },
            sm: {
                base: "rounded-small",
                header: "rounded-t-small",
                footer: "rounded-b-small"
            },
            md: {
                base: "rounded-medium",
                header: "rounded-t-medium",
                footer: "rounded-b-medium"
            },
            lg: {
                base: "rounded-large",
                header: "rounded-t-large",
                footer: "rounded-b-large"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isHoverable: {
            true: {
                base: "data-[hover=true]:bg-content2 dark:data-[hover=true]:bg-content2"
            }
        },
        isPressable: {
            true: {
                base: "cursor-pointer"
            }
        },
        isBlurred: {
            true: {
                base: [
                    "bg-background/80",
                    "dark:bg-background/20",
                    "backdrop-blur-md",
                    "backdrop-saturate-150"
                ]
            }
        },
        isFooterBlurred: {
            true: {
                footer: [
                    "bg-background/10",
                    "backdrop-blur",
                    "backdrop-saturate-150"
                ]
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled cursor-not-allowed"
            }
        },
        disableAnimation: {
            true: "",
            false: {
                base: "transition-transform-background motion-reduce:transition-none"
            }
        }
    },
    compoundVariants: [
        {
            isPressable: true,
            class: "data-[pressed=true]:scale-[0.97] tap-highlight-transparent"
        }
    ],
    defaultVariants: {
        radius: "lg",
        shadow: "md",
        fullWidth: false,
        isHoverable: false,
        isPressable: false,
        isDisabled: false,
        isFooterBlurred: false
    }
});



var $acw62 = parcelRequire("acw62");








"use client";
function $aa87323ed974ea26$export$5a0763f6a9ca51f0(originalProps) {
    var _a, _b, _c, _d;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $6d660e11ca17fc8d$export$aa3e815946b80764).variantKeys);
    const { ref: ref, as: as, children: children, onClick: onClick, onPress: onPress, autoFocus: autoFocus, className: className, classNames: classNames, allowTextSelectionOnPress: allowTextSelectionOnPress = true, ...otherProps } = props;
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const Component = as || (originalProps.isPressable ? "button" : "div");
    const shouldFilterDOMProps = typeof Component === "string";
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const disableRipple = (_d = (_c = originalProps.disableRipple) != null ? _c : globalContext == null ? void 0 : globalContext.disableRipple) != null ? _d : false;
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const { onClick: onRippleClickHandler, onClear: onClearRipple, ripples: ripples } = (0, $b3fe8d327210ab43$export$66d23405c38d2c80)();
    const handleClick = (e)=>{
        if (!disableAnimation && !disableRipple && domRef.current) onRippleClickHandler(e);
    };
    const { buttonProps: buttonProps, isPressed: isPressed } = (0, $99a1faa63f87ca63$export$1aff6edc04132adb)({
        onPress: onPress,
        elementType: as,
        isDisabled: !originalProps.isPressable,
        onClick: (0, $276a22df76563a4a$export$e08e3b67e392101e)(onClick, handleClick),
        allowTextSelectionOnPress: allowTextSelectionOnPress,
        ...otherProps
    }, domRef);
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: !originalProps.isHoverable,
        ...otherProps
    });
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const slots = (0, $acw62.useMemo)(()=>(0, $6d660e11ca17fc8d$export$aa3e815946b80764)({
            ...variantProps,
            disableAnimation: disableAnimation
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        disableAnimation
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            slots: slots,
            classNames: classNames,
            disableAnimation: disableAnimation,
            isDisabled: originalProps.isDisabled,
            isFooterBlurred: originalProps.isFooterBlurred,
            fullWidth: originalProps.fullWidth
        }), [
        slots,
        classNames,
        originalProps.isDisabled,
        originalProps.isFooterBlurred,
        disableAnimation,
        originalProps.fullWidth
    ]);
    const getCardProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ref: domRef,
            className: slots.base({
                class: baseStyles
            }),
            tabIndex: originalProps.isPressable ? 0 : -1,
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps.isDisabled),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(originalProps.isPressable ? {
                ...buttonProps,
                ...focusProps,
                role: "button"
            } : {}, originalProps.isHoverable ? hoverProps : {}, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(props2))
        };
    }, [
        domRef,
        slots,
        baseStyles,
        shouldFilterDOMProps,
        originalProps.isPressable,
        originalProps.isHoverable,
        originalProps.isDisabled,
        isHovered,
        isPressed,
        isFocusVisible,
        buttonProps,
        focusProps,
        hoverProps,
        otherProps
    ]);
    const getRippleProps = (0, $acw62.useCallback)(()=>({
            ripples: ripples,
            onClear: onClearRipple
        }), [
        ripples,
        onClearRipple
    ]);
    return {
        context: context,
        domRef: domRef,
        Component: Component,
        classNames: classNames,
        children: children,
        isHovered: isHovered,
        isPressed: isPressed,
        disableAnimation: disableAnimation,
        isPressable: originalProps.isPressable,
        isHoverable: originalProps.isHoverable,
        disableRipple: disableRipple,
        handleClick: handleClick,
        isFocusVisible: isFocusVisible,
        getCardProps: getCardProps,
        getRippleProps: getRippleProps
    };
}





"use client";
var $06507242a7aa4c9b$var$Card = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, context: context, Component: Component, isPressable: isPressable, disableAnimation: disableAnimation, disableRipple: disableRipple, getCardProps: getCardProps, getRippleProps: getRippleProps } = (0, $aa87323ed974ea26$export$5a0763f6a9ca51f0)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getCardProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $504373a3b2738bf1$export$4aacc92b34f48449), {
                value: context,
                children: children
            }),
            isPressable && !disableAnimation && !disableRipple && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $07aa04cf326100a7$export$db886ec4bd2671e8), {
                ...getRippleProps()
            })
        ]
    });
});
$06507242a7aa4c9b$var$Card.displayName = "NextUI.Card";
var $06507242a7aa4c9b$export$4630804d47451d56 = $06507242a7aa4c9b$var$Card;






"use client";
var $8834a4b8ef3d6ac2$var$CardBody = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $504373a3b2738bf1$export$c1f1c27d8fe70f39)();
    const bodyStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.body, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.body) == null ? void 0 : _a.call(slots, {
            class: bodyStyles
        }),
        ...otherProps,
        children: children
    });
});
$8834a4b8ef3d6ac2$var$CardBody.displayName = "NextUI.CardBody";
var $8834a4b8ef3d6ac2$export$c568166205121897 = $8834a4b8ef3d6ac2$var$CardBody;






"use client";
var $896dc7ac96a1f3a2$var$CardHeader = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $504373a3b2738bf1$export$c1f1c27d8fe70f39)();
    const headerStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.header, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.header) == null ? void 0 : _a.call(slots, {
            class: headerStyles
        }),
        ...otherProps,
        children: children
    });
});
$896dc7ac96a1f3a2$var$CardHeader.displayName = "NextUI.CardHeader";
var $896dc7ac96a1f3a2$export$f23b394cfe48a45c = $896dc7ac96a1f3a2$var$CardHeader;


var $acw62 = parcelRequire("acw62");






// src/components/toggle.ts
var $41061d4c5b0a2287$export$e03c1c3201ee8bb7 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "group relative max-w-fit inline-flex items-center justify-start cursor-pointer touch-none tap-highlight-transparent",
        wrapper: [
            "px-1",
            "relative",
            "inline-flex",
            "items-center",
            "justify-start",
            "flex-shrink-0",
            "overflow-hidden",
            "bg-default-200",
            "rounded-full",
            ...(0, $eb279a3a1c5a3410$export$23b17e6367ab693)
        ],
        thumb: [
            "z-10",
            "flex",
            "items-center",
            "justify-center",
            "bg-white",
            "shadow-small",
            "rounded-full",
            "origin-right"
        ],
        startContent: "z-0 absolute left-1.5 rtl:right-1.5 rtl:left-[unset] text-current",
        endContent: "z-0 absolute right-1.5 rtl:left-1.5 rtl:right-[unset] text-default-600",
        thumbIcon: "text-black",
        label: "relative text-foreground select-none"
    },
    variants: {
        color: {
            default: {
                wrapper: [
                    "group-data-[selected=true]:bg-default-400",
                    "group-data-[selected=true]:text-default-foreground"
                ]
            },
            primary: {
                wrapper: [
                    "group-data-[selected=true]:bg-primary",
                    "group-data-[selected=true]:text-primary-foreground"
                ]
            },
            secondary: {
                wrapper: [
                    "group-data-[selected=true]:bg-secondary",
                    "group-data-[selected=true]:text-secondary-foreground"
                ]
            },
            success: {
                wrapper: [
                    "group-data-[selected=true]:bg-success",
                    "group-data-[selected=true]:text-success-foreground"
                ]
            },
            warning: {
                wrapper: [
                    "group-data-[selected=true]:bg-warning",
                    "group-data-[selected=true]:text-warning-foreground"
                ]
            },
            danger: {
                wrapper: [
                    "group-data-[selected=true]:bg-danger",
                    "data-[selected=true]:text-danger-foreground"
                ]
            }
        },
        size: {
            sm: {
                wrapper: "w-10 h-6 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-4 h-4 text-tiny",
                    "group-data-[selected=true]:ml-4 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-4"
                ],
                endContent: "text-tiny",
                startContent: "text-tiny",
                label: "text-small"
            },
            md: {
                wrapper: "w-12 h-7 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-5 h-5 text-small",
                    "group-data-[selected=true]:ml-5 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-5"
                ],
                endContent: "text-small",
                startContent: "text-small",
                label: "text-medium"
            },
            lg: {
                wrapper: "w-14 h-8 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-6 h-6 text-medium",
                    "group-data-[selected=true]:ml-6 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-6"
                ],
                endContent: "text-medium",
                startContent: "text-medium",
                label: "text-large"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {
                wrapper: "transition-none",
                thumb: "transition-none"
            },
            false: {
                wrapper: "transition-background",
                thumb: "transition-all",
                startContent: [
                    "opacity-0",
                    "scale-50",
                    "transition-transform-opacity",
                    "group-data-[selected=true]:scale-100",
                    "group-data-[selected=true]:opacity-100"
                ],
                endContent: [
                    "opacity-100",
                    "transition-transform-opacity",
                    "group-data-[selected=true]:translate-x-3",
                    "group-data-[selected=true]:opacity-0"
                ]
            }
        }
    },
    defaultVariants: {
        color: "primary",
        size: "md",
        isDisabled: false
    },
    compoundVariants: [
        {
            disableAnimation: false,
            size: "sm",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-5",
                    "group-data-[selected]:group-data-[pressed]:ml-3"
                ]
            }
        },
        {
            disableAnimation: false,
            size: "md",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-6",
                    "group-data-[selected]:group-data-[pressed]:ml-4"
                ]
            }
        },
        {
            disableAnimation: false,
            size: "lg",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-7",
                    "group-data-[selected]:group-data-[pressed]:ml-5"
                ]
            }
        }
    ]
});




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "hrefLang",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $cc67cd2eccfbd1e9$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $cc67cd2eccfbd1e9$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $6d717a44c450d7db$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $31b9d6d1da14bb95$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $640abaf5761202a8$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    (0, $31b9d6d1da14bb95$export$e5c5a5f917a5871c)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cca3b18fc4069ca1$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    let effect = (0, $acw62.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $640abaf5761202a8$export$7f54fc3180508a52)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $31b9d6d1da14bb95$export$e5c5a5f917a5871c)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, $640abaf5761202a8$export$7f54fc3180508a52)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $da0798a52cc2f72c$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $da0798a52cc2f72c$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($da0798a52cc2f72c$var$$b5e257d569688ac6$var$defaultContext);
const $da0798a52cc2f72c$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($da0798a52cc2f72c$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useCounter(cur === $da0798a52cc2f72c$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $da0798a52cc2f72c$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($da0798a52cc2f72c$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($da0798a52cc2f72c$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $da0798a52cc2f72c$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $da0798a52cc2f72c$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$da0798a52cc2f72c$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $da0798a52cc2f72c$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($da0798a52cc2f72c$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $da0798a52cc2f72c$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $da0798a52cc2f72c$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($da0798a52cc2f72c$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $da0798a52cc2f72c$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $da0798a52cc2f72c$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $da0798a52cc2f72c$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($da0798a52cc2f72c$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $da0798a52cc2f72c$var$$b5e257d569688ac6$var$defaultContext && !$da0798a52cc2f72c$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($da0798a52cc2f72c$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$da0798a52cc2f72c$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $da0798a52cc2f72c$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useModernSSRSafeId : $da0798a52cc2f72c$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $da0798a52cc2f72c$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $da0798a52cc2f72c$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($da0798a52cc2f72c$var$$b5e257d569688ac6$var$subscribe, $da0798a52cc2f72c$var$$b5e257d569688ac6$var$getSnapshot, $da0798a52cc2f72c$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($da0798a52cc2f72c$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $c2cb2fafcf95600d$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $c2cb2fafcf95600d$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $c2cb2fafcf95600d$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $da0798a52cc2f72c$export$619500959fc48b26)(value);
    let updateValue = (0, $acw62.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($c2cb2fafcf95600d$var$$bdb11010cef70236$var$canUseDOM) $c2cb2fafcf95600d$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    (0, $31b9d6d1da14bb95$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            $c2cb2fafcf95600d$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $c2cb2fafcf95600d$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $c2cb2fafcf95600d$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $c2cb2fafcf95600d$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $c2cb2fafcf95600d$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $c2cb2fafcf95600d$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $cca3b18fc4069ca1$export$14d238f342723f25)(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $31b9d6d1da14bb95$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


function $8c6be69f7e0d84a0$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $8c6be69f7e0d84a0$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $8c6be69f7e0d84a0$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $8c6be69f7e0d84a0$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8c6be69f7e0d84a0$export$2e2bcd8739ae039 = $8c6be69f7e0d84a0$export$4f5d2d50c9deca37;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $deaac9b4f18be22f$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $6d717a44c450d7db$export$e08e3b67e392101e)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $8c6be69f7e0d84a0$export$2e2bcd8739ae039)(a, b);
            else if (key === "id" && a && b) result.id = (0, $c2cb2fafcf95600d$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bf5bceadda599e82$export$5add1d006293d136(ref, initialValue, onReset) {
    let resetValue = (0, $acw62.useRef)(initialValue);
    let handleReset = (0, $640abaf5761202a8$export$7f54fc3180508a52)(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, $acw62.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $77b2efb26d67d6fd$export$de79e2c695e052f3(element) {
    if ($77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $77b2efb26d67d6fd$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

const $af6adb6fe7d9eda2$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $af6adb6fe7d9eda2$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $af6adb6fe7d9eda2$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $84c6076c3e9a065a$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $84c6076c3e9a065a$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $0b5d08539d4d93b4$export$9ac100e40613ea10 = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $0b5d08539d4d93b4$export$186c6964ca17d99 = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $0b5d08539d4d93b4$export$7bef049ce92e4224 = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $0b5d08539d4d93b4$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $0b5d08539d4d93b4$export$fedb369cb70207f1 = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$export$186c6964ca17d99() || $0b5d08539d4d93b4$export$7bef049ce92e4224();
});
const $0b5d08539d4d93b4$export$e1865c3bedcd822b = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$export$9ac100e40613ea10() || $0b5d08539d4d93b4$export$fedb369cb70207f1();
});
const $0b5d08539d4d93b4$export$78551043582a6a98 = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$0b5d08539d4d93b4$export$6446a186d09e379e();
});
const $0b5d08539d4d93b4$export$6446a186d09e379e = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $0b5d08539d4d93b4$export$a11b0059900ceec8 = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $0b5d08539d4d93b4$export$b7d78993b74f766d = $0b5d08539d4d93b4$var$$c87311424ea30a05$var$cached(function() {
    return $0b5d08539d4d93b4$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5c967e0ffe815a6f$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $0b5d08539d4d93b4$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $5c967e0ffe815a6f$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $0b5d08539d4d93b4$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality = null;
let $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b700e4b10e304ec0$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $0b5d08539d4d93b4$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b700e4b10e304ec0$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $5c967e0ffe815a6f$export$60278871457622de)(e)) {
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b700e4b10e304ec0$export$d90243b58daecda7.get((0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(element);
    const documentObject = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b700e4b10e304ec0$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(element);
    const documentObject = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b700e4b10e304ec0$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b700e4b10e304ec0$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b700e4b10e304ec0$export$d90243b58daecda7.delete(windowObject);
};
function $b700e4b10e304ec0$export$2f1888112f558a7d(element) {
    const documentObject = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b700e4b10e304ec0$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b700e4b10e304ec0$export$2f1888112f558a7d();
function $b700e4b10e304ec0$export$b9b3dfddab17db27() {
    return $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b700e4b10e304ec0$export$630ff653c5ada6a9() {
    return $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality;
}
function $b700e4b10e304ec0$export$8397ddfc504fdb9a(modality) {
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b700e4b10e304ec0$export$98e20ec92f614cfe() {
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($b700e4b10e304ec0$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $da0798a52cc2f72c$export$535bd6ca7f90a273)() ? null : modality;
}
const $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b700e4b10e304ec0$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b700e4b10e304ec0$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b700e4b10e304ec0$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $b700e4b10e304ec0$export$b9b3dfddab17db27());
    $b700e4b10e304ec0$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b700e4b10e304ec0$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b700e4b10e304ec0$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b700e4b10e304ec0$export$b9b3dfddab17db27());
        };
        $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b700e4b10e304ec0$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $79bd88b2b61b6c1a$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(element);
    if ((0, $b700e4b10e304ec0$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $84c6076c3e9a065a$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(element);
        });
    } else (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(element);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $db61109c28057544$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $acw62.useRef)(null);
    return (0, $acw62.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4193c74c1302b152$export$4debdb1a3f0fa79e(context, ref) {
    (0, $31b9d6d1da14bb95$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $aaa83ce1bdcdeea6$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $aaa83ce1bdcdeea6$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $31b9d6d1da14bb95$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $640abaf5761202a8$export$7f54fc3180508a52)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $aaa83ce1bdcdeea6$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $975169c0f65736b3$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $aaa83ce1bdcdeea6$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ead3707309a45e2a$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b47e9f3938b028b3$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $ead3707309a45e2a$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $ead3707309a45e2a$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $acw62.useContext)($cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $4193c74c1302b152$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $db61109c28057544$export$4338b53315abf666)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $cac5a9c96a95104c$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $cac5a9c96a95104c$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $975169c0f65736b3$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $b47e9f3938b028b3$export$8f71654801c2f7cd)(props);
    let interactions = (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $cac5a9c96a95104c$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $79bd88b2b61b6c1a$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $88387ddd86ebda2b$var$$14c0b72509d70225$var$state = "default";
let $88387ddd86ebda2b$var$$14c0b72509d70225$var$savedUserSelect = "";
let $88387ddd86ebda2b$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $88387ddd86ebda2b$export$16a4697467175487(target) {
    if ((0, $0b5d08539d4d93b4$export$fedb369cb70207f1)()) {
        if ($88387ddd86ebda2b$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(target);
            $88387ddd86ebda2b$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $88387ddd86ebda2b$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $88387ddd86ebda2b$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $88387ddd86ebda2b$export$b0d6fa1ab32e3295(target) {
    if ((0, $0b5d08539d4d93b4$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($88387ddd86ebda2b$var$$14c0b72509d70225$var$state !== "disabled") return;
        $88387ddd86ebda2b$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $84c6076c3e9a065a$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($88387ddd86ebda2b$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $af6adb6fe7d9eda2$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $88387ddd86ebda2b$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $88387ddd86ebda2b$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $88387ddd86ebda2b$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $88387ddd86ebda2b$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $88387ddd86ebda2b$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $88387ddd86ebda2b$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c0eca43deeda11c2$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    register: ()=>{}
});
$c0eca43deeda11c2$export$5165eccb35aaadb5.displayName = "PressResponderContext";








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $acw62.createContext)({
    isNative: true,
    open: $56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $56fcfffc2adda9e4$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $acw62.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($56fcfffc2adda9e4$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $56fcfffc2adda9e4$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $56fcfffc2adda9e4$export$9a302a45f65d0572() {
    return (0, $acw62.useContext)($56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $56fcfffc2adda9e4$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $56fcfffc2adda9e4$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $0b5d08539d4d93b4$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ((0, $0b5d08539d4d93b4$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $0b5d08539d4d93b4$export$78551043582a6a98)() && (0, $0b5d08539d4d93b4$export$9ac100e40613ea10)() && !(0, $0b5d08539d4d93b4$export$7bef049ce92e4224)() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $56fcfffc2adda9e4$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $56fcfffc2adda9e4$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$56fcfffc2adda9e4$export$95185d699e05d4d7.isOpening = false;
function $56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $56fcfffc2adda9e4$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$56fcfffc2adda9e4$export$95185d699e05d4d7(link, modifiers));
}
function $56fcfffc2adda9e4$export$bdc77b0c0a3a85d6(props) {
    let router = $56fcfffc2adda9e4$export$9a302a45f65d0572();
    return {
        "data-href": props.href ? router.useHref(props.href) : undefined,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $56fcfffc2adda9e4$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $56fcfffc2adda9e4$export$7e924b3091a3bd18(props) {
    let router = $56fcfffc2adda9e4$export$9a302a45f65d0572();
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? router.useHref(props === null || props === void 0 ? void 0 : props.href) : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e7b2cfdfaef44cde$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)((0, $c0eca43deeda11c2$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $4193c74c1302b152$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $36ba9b20eda67744$export$71511d61b312f219)(this, $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $c6097939c16c8ec7$export$71511d61b312f219)(this, $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent, state){
        (0, $01f13bd32e43989c$export$71511d61b312f219)(this, $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $36ba9b20eda67744$export$71511d61b312f219)(this, $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        var _state_target;
        let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
        const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
    }
}
const $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $b7b46206c8464ebf$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $e7b2cfdfaef44cde$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $640abaf5761202a8$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $640abaf5761202a8$export$7f54fc3180508a52)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $640abaf5761202a8$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $640abaf5761202a8$export$7f54fc3180508a52)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $88387ddd86ebda2b$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $640abaf5761202a8$export$7f54fc3180508a52)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $af6adb6fe7d9eda2$export$b204af158042fbac)(e.currentTarget), "keyup", (0, $6d717a44c450d7db$export$e08e3b67e392101e)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $0b5d08539d4d93b4$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $56fcfffc2adda9e4$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $5c967e0ffe815a6f$export$60278871457622de)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$b7b46206c8464ebf$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$b7b46206c8464ebf$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $56fcfffc2adda9e4$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $5c967e0ffe815a6f$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $88387ddd86ebda2b$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $af6adb6fe7d9eda2$export$b204af158042fbac)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $af6adb6fe7d9eda2$export$b204af158042fbac)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $af6adb6fe7d9eda2$export$b204af158042fbac)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $88387ddd86ebda2b$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $5c967e0ffe815a6f$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $af6adb6fe7d9eda2$export$b204af158042fbac)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $77b2efb26d67d6fd$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $88387ddd86ebda2b$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e));
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                    shouldStopPropagation = triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $88387ddd86ebda2b$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e));
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $88387ddd86ebda2b$export$b0d6fa1ab32e3295)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(element).HTMLInputElement && !$b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $af6adb6fe7d9eda2$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $b7b46206c8464ebf$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ff0f85aab4131368$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, children: children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, validationState: validationState = "valid", isInvalid: isInvalid } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b7b46206c8464ebf$export$45712eceda6fad21)({
        isDisabled: isDisabled
    });
    // iOS does not toggle checkboxes if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $b7b46206c8464ebf$export$45712eceda6fad21)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            state.toggle();
        }
    });
    let { focusableProps: focusableProps } = (0, $cac5a9c96a95104c$export$4c014de7c8940b4c)(props, ref);
    let interactions = (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $cc67cd2eccfbd1e9$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    (0, $bf5bceadda599e82$export$5add1d006293d136)(ref, state.isSelected, state.setSelected);
    return {
        labelProps: (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $deaac9b4f18be22f$export$9d1611c77c2fe928)(domProps, {
            "aria-invalid": isInvalid || validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-controls": props["aria-controls"],
            "aria-readonly": isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            type: "checkbox",
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === "invalid"
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a1ece5ac2fbcd06e$export$d853f7095ae95f88(props, state, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $ff0f85aab4131368$export$cbe85ee05b554577)(props, state, ref);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            role: "switch",
            checked: isSelected
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
    };
}




"use client";
function $a544f12330906cc4$export$d853f7095ae95f88(originalProps = {}) {
    var _a, _b;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $41061d4c5b0a2287$export$e03c1c3201ee8bb7).variantKeys);
    const { ref: ref, as: as, name: name, value: value = "", isReadOnly: isReadOnlyProp = false, autoFocus: autoFocus = false, startContent: startContent, endContent: endContent, defaultSelected: defaultSelected, isSelected: isSelectedProp, children: children, thumbIcon: thumbIcon, className: className, classNames: classNames, onChange: onChange, onValueChange: onValueChange, ...otherProps } = props;
    const Component = as || "label";
    const domRef = (0, $acw62.useRef)(null);
    const inputRef = (0, $acw62.useRef)(null);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const labelId = (0, $acw62.useId)();
    const ariaSwitchProps = (0, $acw62.useMemo)(()=>{
        const ariaLabel = otherProps["aria-label"] || typeof children === "string" ? children : void 0;
        return {
            name: name,
            value: value,
            children: children,
            autoFocus: autoFocus,
            defaultSelected: defaultSelected,
            isSelected: isSelectedProp,
            isDisabled: !!originalProps.isDisabled,
            isReadOnly: isReadOnlyProp,
            "aria-label": ariaLabel,
            "aria-labelledby": otherProps["aria-labelledby"] || labelId,
            onChange: onValueChange
        };
    }, [
        value,
        name,
        labelId,
        children,
        autoFocus,
        isReadOnlyProp,
        isSelectedProp,
        defaultSelected,
        originalProps.isDisabled,
        otherProps["aria-label"],
        otherProps["aria-labelledby"],
        onValueChange
    ]);
    const state = (0, $7000e3ae65df6321$export$8042c6c013fd5226)(ariaSwitchProps);
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const isInputRefChecked = !!inputRef.current.checked;
        state.setSelected(isInputRefChecked);
    }, [
        inputRef.current
    ]);
    const { inputProps: inputProps, isPressed: isPressedKeyboard, isReadOnly: isReadOnly } = (0, $a1ece5ac2fbcd06e$export$d853f7095ae95f88)(ariaSwitchProps, state, inputRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: inputProps.autoFocus
    });
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: inputProps.disabled
    });
    const isInteractionDisabled = ariaSwitchProps.isDisabled || isReadOnly;
    const [isPressed, setPressed] = (0, $acw62.useState)(false);
    const { pressProps: pressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: isInteractionDisabled,
        onPressStart (e) {
            if (e.pointerType !== "keyboard") setPressed(true);
        },
        onPressEnd (e) {
            if (e.pointerType !== "keyboard") setPressed(false);
        }
    });
    const pressed = isInteractionDisabled ? false : isPressed || isPressedKeyboard;
    const isSelected = inputProps.checked;
    const isDisabled = inputProps.disabled;
    const slots = (0, $acw62.useMemo)(()=>(0, $41061d4c5b0a2287$export$e03c1c3201ee8bb7)({
            ...variantProps,
            disableAnimation: disableAnimation
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        disableAnimation
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2)=>{
        return {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(hoverProps, pressProps, otherProps, props2),
            ref: domRef,
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2 == null ? void 0 : props2.className)
            }),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected),
            "data-readonly": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isReadOnly),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(pressed)
        };
    };
    const getWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "aria-hidden": true,
            className: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(slots.wrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            }))
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.wrapper
    ]);
    const getInputProps = (props2 = {})=>{
        return {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(inputProps, focusProps, props2),
            ref: (0, $2bb49473be67834f$export$c9058316764c140e)(inputRef, ref),
            id: inputProps.id,
            onChange: (0, $276a22df76563a4a$export$e08e3b67e392101e)(onChange, inputProps.onChange)
        };
    };
    const getThumbProps = (0, $acw62.useCallback)((props2 = {})=>({
            ...props2,
            className: slots.thumb({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.thumb, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.thumb
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {})=>({
            ...props2,
            id: labelId,
            className: slots.label({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.label, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        isDisabled,
        isSelected
    ]);
    const getThumbIconProps = (0, $acw62.useCallback)((props2 = {
        includeStateProps: false
    })=>(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            width: "1em",
            height: "1em",
            className: slots.thumbIcon({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.thumbIcon)
            })
        }, props2.includeStateProps ? {
            isSelected: isSelected
        } : {}), [
        slots,
        classNames == null ? void 0 : classNames.thumbIcon,
        isSelected
    ]);
    const getStartContentProps = (0, $acw62.useCallback)((props2 = {})=>({
            width: "1em",
            height: "1em",
            ...props2,
            className: slots.startContent({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.startContent, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.startContent,
        isSelected
    ]);
    const getEndContentProps = (0, $acw62.useCallback)((props2 = {})=>({
            width: "1em",
            height: "1em",
            ...props2,
            className: slots.endContent({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.endContent, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.endContent,
        isSelected
    ]);
    return {
        Component: Component,
        slots: slots,
        classNames: classNames,
        domRef: domRef,
        children: children,
        thumbIcon: thumbIcon,
        startContent: startContent,
        endContent: endContent,
        isHovered: isHovered,
        isSelected: isSelected,
        isPressed: pressed,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: isDisabled,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getThumbProps: getThumbProps,
        getThumbIconProps: getThumbIconProps,
        getStartContentProps: getStartContentProps,
        getEndContentProps: getEndContentProps
    };
}




var $acw62 = parcelRequire("acw62");


"use client";
var $3c4e303deef1d205$var$Switch = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, startContent: startContent, endContent: endContent, thumbIcon: thumbIcon, getBaseProps: getBaseProps, getInputProps: getInputProps, getWrapperProps: getWrapperProps, getThumbProps: getThumbProps, getThumbIconProps: getThumbIconProps, getLabelProps: getLabelProps, getStartContentProps: getStartContentProps, getEndContentProps: getEndContentProps } = (0, $a544f12330906cc4$export$d853f7095ae95f88)({
        ...props,
        ref: ref
    });
    const clonedThumbIcon = typeof thumbIcon === "function" ? thumbIcon(getThumbIconProps({
        includeStateProps: true
    })) : thumbIcon && (0, $acw62.cloneElement)(thumbIcon, getThumbIconProps());
    const clonedStartContent = startContent && (0, $acw62.cloneElement)(startContent, getStartContentProps());
    const clonedEndContent = endContent && (0, $acw62.cloneElement)(endContent, getEndContentProps());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
                elementType: "span",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ...getInputProps()
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("span", {
                ...getWrapperProps(),
                children: [
                    startContent && clonedStartContent,
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getThumbProps(),
                        children: thumbIcon && clonedThumbIcon
                    }),
                    endContent && clonedEndContent
                ]
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getLabelProps(),
                children: children
            })
        ]
    });
});
$3c4e303deef1d205$var$Switch.displayName = "NextUI.Switch";
var $3c4e303deef1d205$export$fc15fde3b71d3684 = $3c4e303deef1d205$var$Switch;


// src/chevron-up.tsx

var $c275b0eb101f0650$export$7f01a6cbee61a0f2 = ({ strokeWidth: strokeWidth = 1.5, ...props })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth,
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m18 15-6-6-6 6"
        })
    });











const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $083454c8244247d6$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







const $b352f7cdd42c49d7$var$SCALE_PRECISION = 0.0001;
const $b352f7cdd42c49d7$var$SCALE_MIN = 1 - $b352f7cdd42c49d7$var$SCALE_PRECISION;
const $b352f7cdd42c49d7$var$SCALE_MAX = 1 + $b352f7cdd42c49d7$var$SCALE_PRECISION;
const $b352f7cdd42c49d7$var$TRANSLATE_PRECISION = 0.01;
const $b352f7cdd42c49d7$var$TRANSLATE_MIN = 0 - $b352f7cdd42c49d7$var$TRANSLATE_PRECISION;
const $b352f7cdd42c49d7$var$TRANSLATE_MAX = 0 + $b352f7cdd42c49d7$var$TRANSLATE_PRECISION;
function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    delta.translate = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $b352f7cdd42c49d7$var$SCALE_MIN && delta.scale <= $b352f7cdd42c49d7$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $b352f7cdd42c49d7$var$TRANSLATE_MIN && delta.translate <= $b352f7cdd42c49d7$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}



function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}










// Fixes https://github.com/framer/motion/issues/2270
const $763b481d779908b7$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $74e7c7f6c49b7323$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false, (0, $74e7c7f6c49b7323$export$3ac5aed310be0bee)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $d43ff984f7bd7f1a$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $763b481d779908b7$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanSessionStart),
            onStart: $d43ff984f7bd7f1a$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $acw62.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





"use client";
class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, $acw62.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $6b94e2cfb50380ff$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, $7b02d682eb115277$exports.jsx)($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = /*@__PURE__*/ $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = /*@__PURE__*/ $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a.x, b.x) && $b070f9c5f268d45c$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $b070f9c5f268d45c$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $b070f9c5f268d45c$export$ef641b782d85522(a, b) {
    return $b070f9c5f268d45c$export$22adf28bfca1c186(a.x, b.x) && $b070f9c5f268d45c$export$22adf28bfca1c186(a.y, b.y);
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}
function $b070f9c5f268d45c$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $c4715fe9f944e8b8$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $f5de8fc8cd768a38$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value : (0, $e32104bb79321603$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9e7a9f8af70c9aa6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $d2ca41ba1b84bcfe$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $d2ca41ba1b84bcfe$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $d2ca41ba1b84bcfe$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
function $d2ca41ba1b84bcfe$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $d2ca41ba1b84bcfe$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $59a52f0eed0e0e03$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $9f96722ff12dbfe7$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $d2ca41ba1b84bcfe$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.totalNodes = $d2ca41ba1b84bcfe$var$metrics.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                if ($d2ca41ba1b84bcfe$var$isDebug) window.MotionDebug.record($d2ca41ba1b84bcfe$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $c4715fe9f944e8b8$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $d2ca41ba1b84bcfe$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d2ca41ba1b84bcfe$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $86c10e7c9731f599$export$2da9be4cfdb689b1).now();
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).delta = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp);
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp = now;
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = true;
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).update.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).preRender.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$be3f796aed065412).render.process((0, $9f96722ff12dbfe7$export$fff89137e9e818ce));
            (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $6b94e2cfb50380ff$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($d2ca41ba1b84bcfe$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $9f96722ff12dbfe7$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $5960d81994414d5a$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $5960d81994414d5a$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $b070f9c5f268d45c$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $b070f9c5f268d45c$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $9f96722ff12dbfe7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9f96722ff12dbfe7$export$2cef06c20297c17d).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $f5de8fc8cd768a38$export$335a17c977067b99)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $d2ca41ba1b84bcfe$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                $d2ca41ba1b84bcfe$var$resetDistortingTransform(`rotate${$d2ca41ba1b84bcfe$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $d2ca41ba1b84bcfe$var$resetDistortingTransform(`skew${$d2ca41ba1b84bcfe$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $d2ca41ba1b84bcfe$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($d2ca41ba1b84bcfe$var$isDebug) $d2ca41ba1b84bcfe$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $c7567ac386f9de45$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d2ca41ba1b84bcfe$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d2ca41ba1b84bcfe$var$roundPoint = $d2ca41ba1b84bcfe$var$userAgentContains("applewebkit/") && !$d2ca41ba1b84bcfe$var$userAgentContains("chrome/") ? Math.round : (0, $448ce039afb5ec07$export$8793edee2d425525);
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d2ca41ba1b84bcfe$var$roundPoint(axis.min);
    axis.max = $d2ca41ba1b84bcfe$var$roundPoint(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}
function $d2ca41ba1b84bcfe$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};





const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};




const $2ee5f39f3d699a75$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $e1392d1b9bf233d3$export$d86feac869a7f0d5)({
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
}, (0, $2f8881102ac6dde9$export$56ba0183203348f5));


const $ffb02ccc9d959c1b$export$e25e478948902b8b = /*@__PURE__*/ (0, $f1922c0288de6004$export$3af29c0efb268f04)((0, $2ee5f39f3d699a75$export$46b7e4b9dc6110c3));





let $e26876ce4031e3c8$var$provider = new (0, $5499ec87660a9ba7$export$999cc40da3fbc6f)("matic", "jKHL8FBDC9OR14KUb_n-J0_5KoF9hjDo");
let $e26876ce4031e3c8$var$contractAddress = "0xc3E5ad11aE2F00c740E74B81f134426A3331D950";
let $e26876ce4031e3c8$var$contractAbi = [
    "event Finalized(uint256 indexed pollId, uint256 burned)",
    "event Initialized(uint8 version)",
    "event PollCreated(uint256 pollId)",
    "event Revealed(uint256 indexed pollId, uint256 revealedVotes, uint256 remainingVotes)",
    "event RoleAdminChanged(bytes32 indexed role, bytes32 indexed previousAdminRole, bytes32 indexed newAdminRole)",
    "event RoleGranted(bytes32 indexed role, address indexed account, address indexed sender)",
    "event RoleRevoked(bytes32 indexed role, address indexed account, address indexed sender)",
    "event Voted(uint256 indexed pollId, uint256 voteIndex, address voter, uint256 comoAmount, bytes32 hash)",
    "function DEFAULT_ADMIN_ROLE() view returns (bytes32)",
    "function OPERATOR_ROLE() view returns (bytes32)",
    "function candidates(uint256 pollId) view returns (string[])",
    "function comoContract() view returns (address)",
    "function createPoll(string title_, string[] candidates_, uint256 startAt_, uint256 due_, uint256 minimumCOMO_)",
    "function finalize(uint256 pollId)",
    "function getRoleAdmin(bytes32 role) view returns (bytes32)",
    "function grantRole(bytes32 role, address account)",
    "function hasRole(bytes32 role, address account) view returns (bool)",
    "function hashes(uint256, bytes32) view returns (bool)",
    "function initialize(address voteSignerAddress_, address comoAddress_)",
    "function isInProgress(uint256 pollId) view returns (bool)",
    "function isRevealedVote(uint256, uint256) view returns (bool)",
    "function pollResult(uint256 pollId) view returns (tuple(string candidate, uint256 votes)[])",
    "function polls(uint256) view returns (string title, uint256 startAt, uint256 due, uint256 minimumCOMO, uint256 totalVotedCOMO, uint256 revealedVotes, bool finalized)",
    "function remainingVotes(uint256 pollId) view returns (uint256)",
    "function renounceRole(bytes32 role, address account)",
    "function reset(uint256 pollId, uint256 missingOffset, tuple(uint256 comoAmount, bytes32 hash)[] missingCommitData)",
    "function reveal(uint256 pollId, tuple(uint256 votedCandidateId, bytes32 salt)[] data, uint256 offset)",
    "function revokeRole(bytes32 role, address account)",
    "function setVoteSignerAddress(address addr)",
    "function supportsInterface(bytes4 interfaceId) view returns (bool)",
    "function tokensReceived(address operator, address from, address to, uint256 amount, bytes userData, bytes operatorData)",
    "function totalVotes(uint256 pollId) view returns (uint256)",
    "function userVoteResult(uint256 pollId, address voter) view returns (tuple(string candidate, uint256 votes)[])",
    "function userVoteResults(uint256, address, uint256) view returns (uint256)",
    "function voteSignerAddress() view returns (address)",
    "function voters(uint256, uint256) view returns (address)",
    "function votes(uint256 pollId) view returns (tuple(uint256 comoAmount, bytes32 hash)[])",
    "function votesPerCandidates(uint256 pollId) view returns (uint256[])"
];
let $e26876ce4031e3c8$var$contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)($e26876ce4031e3c8$var$contractAddress, $e26876ce4031e3c8$var$contractAbi, $e26876ce4031e3c8$var$provider);
function $e26876ce4031e3c8$export$2e2bcd8739ae039() {
    let [voteLogs, setVoteLogs] = (0, $acw62.useState)([]);
    let [nicknames, setNicknames] = (0, $acw62.useState)({});
    let [gravityTitle, setGravityTitle] = (0, $acw62.useState)("");
    let [plotSize, setPlotSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    let plotContainerRef = (0, $acw62.useRef)(null);
    let firstBlockNumberRef = (0, $acw62.useRef)(null);
    let listener = (0, $acw62.useCallback)((pollId, voteIndex, voter, comoAmount, hash, event)=>{
        if (!firstBlockNumberRef.current) firstBlockNumberRef.current = event.log.blockNumber;
        setVoteLogs((voteLogs)=>[
                ...voteLogs,
                {
                    pollId: pollId,
                    voteIndex: voteIndex,
                    voter: voter,
                    comoAmount: comoAmount,
                    hash: hash
                }
            ]);
        if (!nicknames[voter]) $e26876ce4031e3c8$var$fetchNicknames([
            voter
        ]).then((newNicknames)=>setNicknames((nicknames)=>({
                    ...nicknames,
                    ...newNicknames
                })));
    }, [
        nicknames
    ]);
    (0, $acw62.useEffect)(()=>{
        $e26876ce4031e3c8$var$contract.addListener("Voted", listener);
        return ()=>void $e26876ce4031e3c8$var$contract.removeListener("Voted", listener);
    }, [
        listener
    ]);
    (0, $acw62.useEffect)(()=>{
        let isCancelled = false;
        (async ()=>{
            let gravities = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).getGravities();
            let lastGravity = gravities.ongoing.length ? gravities.ongoing[0] : gravities.past[0];
            setGravityTitle(lastGravity.title);
            let pollCreatedEventLogs = await $e26876ce4031e3c8$var$contract.queryFilter("PollCreated");
            let pollCreatedEvent = pollCreatedEventLogs.find(({ args: [pollId] })=>pollId == lastGravity.polls[0].pollIdOnChain);
            let startBlockNumber = pollCreatedEvent.blockNumber;
            let lastBlockNumber = await $e26876ce4031e3c8$var$provider.getBlockNumber();
            let queriedEventLogsPromises = [];
            let currentBlockNumber = startBlockNumber;
            while(currentBlockNumber < lastBlockNumber){
                let endBlockNumber = Math.min(lastBlockNumber - 1, currentBlockNumber + 1999);
                // console.log('queryFilter', startBlockNumber, endBlockNumber);
                queriedEventLogsPromises.push($e26876ce4031e3c8$var$contract.queryFilter("Voted", currentBlockNumber, endBlockNumber));
                currentBlockNumber += 2000;
            }
            queriedEventLogsPromises.push($e26876ce4031e3c8$var$contract.queryFilter("Voted", lastBlockNumber));
            let queriedEventLogs = (await Promise.all(queriedEventLogsPromises)).flat();
            let firstBlockNumber = firstBlockNumberRef.current;
            if (firstBlockNumber) queriedEventLogs = queriedEventLogs.filter((eventLog)=>eventLog.blockNumber < firstBlockNumber);
            let queriedVoteLogs = queriedEventLogs.map(({ args: [pollId, voteIndex, voter, comoAmount, hash] })=>({
                    pollId: pollId,
                    voteIndex: voteIndex,
                    voter: voter,
                    comoAmount: comoAmount,
                    hash: hash
                }));
            if (!isCancelled) setVoteLogs((voteLogs)=>[
                    ...queriedVoteLogs,
                    ...voteLogs
                ]);
            let addresses = [
                ...new Set(queriedEventLogs.map((eventLog)=>eventLog.args[2]))
            ];
            let newNicknames = await $e26876ce4031e3c8$var$fetchNicknames(addresses);
            if (!isCancelled) setNicknames((nicknames)=>({
                    ...nicknames,
                    ...newNicknames
                }));
        })();
        return ()=>{
            isCancelled = true;
            setVoteLogs([]);
        };
    }, []);
    let [isCardOpen, setIsCardOpen] = (0, $acw62.useState)(true);
    let [shouldAutoScroll, setShouldAutoScroll] = (0, $acw62.useState)(true);
    let scrollContainerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (scrollContainerRef.current && shouldAutoScroll) scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
    }, [
        shouldAutoScroll,
        voteLogs,
        isCardOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!plotContainerRef.current || voteLogs.length === 0) return;
        let rect = plotContainerRef.current.getBoundingClientRect();
        setPlotSize({
            width: rect.width,
            height: rect.height
        });
        let resizeObserver = new ResizeObserver((entries)=>{
            if (entries[0].contentRect.width && entries[0].contentRect.height) setPlotSize({
                width: entries[0].contentRect.width,
                height: entries[0].contentRect.height
            });
        });
        resizeObserver.observe(plotContainerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        plotContainerRef.current,
        voteLogs
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!plotContainerRef.current || voteLogs.length === 0 || plotSize.width === 0 || plotSize.height === 0) return;
        let accumulatedComoAmount = 0n;
        let transformedData = voteLogs.map((voteLog)=>{
            accumulatedComoAmount += voteLog.comoAmount;
            return {
                voteIndex: Number(voteLog.voteIndex),
                accumulatedComoAmount: Number(accumulatedComoAmount / 1000000000000000000n),
                voter: nicknames[voteLog.voter] || voteLog.voter,
                comoAmount: Number(voteLog.comoAmount / 1000000000000000000n)
            };
        });
        let plot = $dce15e0807f8b267$export$2bbbe2756ad57c66({
            width: plotSize.width,
            height: plotSize.height,
            x: {
                grid: true,
                label: "Vote Index"
            },
            y: {
                grid: true,
                label: "COMO"
            },
            marks: [
                $b4700ec791af3ab2$export$c64634048b1f56ea(transformedData, {
                    x: "voteIndex",
                    y: "accumulatedComoAmount"
                }),
                $56ab23daa4e1674b$export$9d014eceaec9fa56(transformedData, {
                    x: "voteIndex",
                    y: "accumulatedComoAmount",
                    fillOpacity: 0.2
                }),
                $60fbcda062a2738b$export$69cd9e72e20630fa(transformedData, {
                    x: "voteIndex",
                    y: "accumulatedComoAmount"
                }),
                $7910fd10d657c0be$export$94132a0e348806d4(transformedData, $06868e990a5c2092$export$81f1118cc214bacd({
                    x: "voteIndex",
                    y: "accumulatedComoAmount",
                    stroke: "red"
                })),
                $45befbcddbf9afbb$export$5e5b4df997cb5eaa(transformedData, $06868e990a5c2092$export$81f1118cc214bacd({
                    x: "voteIndex",
                    y: "accumulatedComoAmount",
                    lineWidth: Infinity,
                    fontVariant: "tabular-nums",
                    title: (d)=>[
                            `Voter ${d.voter}`,
                            `${d.comoAmount} COMO`
                        ].join("\n\n")
                }))
            ]
        });
        plotContainerRef.current.appendChild(plot);
        function listener() {
            let focusedData = plot.value;
            if (focusedData && scrollContainerRef.current) {
                let rowToScroll = scrollContainerRef.current.querySelector(`#vote-${focusedData.voteIndex}`);
                if (rowToScroll) rowToScroll.scrollIntoView();
            }
        }
        plot.addEventListener("input", listener);
        return ()=>{
            plot.removeEventListener("input", listener);
            plot.remove();
        };
    }, [
        nicknames,
        voteLogs,
        plotSize
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-[calc(100dvh_-_4rem)]",
        children: [
            voteLogs.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "h-full w-full",
                ref: plotContainerRef
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff0009cdb8e38ea8$export$b67103861f057d1a), {
                className: "h-full w-full"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: voteLogs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                    className: "fixed inset-x-6 bottom-4 max-w-xl mx-auto",
                    variants: (0, $0541ef573799255c$export$55b7325ba41bb523).scaleSpringOpacity,
                    initial: "initial",
                    animate: "enter",
                    exit: "exit",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $06507242a7aa4c9b$export$4630804d47451d56), {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $896dc7ac96a1f3a2$export$f23b394cfe48a45c), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex-1 font-bold",
                                        children: "Realtime Votes"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4e303deef1d205$export$fc15fde3b71d3684), {
                                                size: "sm",
                                                isSelected: shouldAutoScroll,
                                                onValueChange: setShouldAutoScroll,
                                                children: "Auto Scroll"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "appearance-none select-none p-2 text-foreground-500 rounded-full hover:bg-default-100 active:bg-default-200 tap-highlight-transparent data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2",
                                                onClick: ()=>setIsCardOpen(!isCardOpen),
                                                children: isCardOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d5bf69f39f72f17$export$4857d3f3f5f8319b), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c275b0eb101f0650$export$7f01a6cbee61a0f2), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isCardOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8834a4b8ef3d6ac2$export$c568166205121897), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67ab465da978cead$export$bef3e985c75eafb5), {
                                            className: "max-h-[40vh]",
                                            ref: scrollContainerRef,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "#"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Voter"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                    children: "Como"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                        children: voteLogs.map((voteLog, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                id: `vote-${voteLog.voteIndex}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: `${voteLog.voteIndex}`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                                            to: nicknames[voteLog.voter] ? `/@${nicknames[voteLog.voter]}` : `/${voteLog.voter}`,
                                                                            children: nicknames[voteLog.voter] || voteLog.voter
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                        children: `${voteLog.comoAmount / 1000000000000000000n}`
                                                                    })
                                                                ]
                                                            }, index))
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            })
        ]
    });
}
async function $e26876ce4031e3c8$var$fetchNicknames(addresses) {
    let addressGroups = [];
    for(let i = 0; i < addresses.length; i += 150)addressGroups.push(addresses.slice(i, i + 150));
    async function fetchGroupNicknames(group) {
        let response = await fetch(`https://cache.nova.gd/user/v1/by-address/${group.join(",")}`);
        let users = await response.json();
        return Object.fromEntries(users.map(({ nickname: nickname, address: address })=>[
                address,
                nickname
            ]));
    }
    try {
        return (await Promise.all(addressGroups.map(fetchGroupNicknames))).reduce((acc, groupNicknames)=>({
                ...acc,
                ...groupNicknames
            }), {});
    } catch (error) {
        console.error("Failed to fetch nicknames:", error);
        return {};
    }
}




var $acw62 = parcelRequire("acw62");

/**
 *  Most interactions with Ethereum requires integer values, which use
 *  the smallest magnitude unit.
 *
 *  For example, imagine dealing with dollars and cents. Since dollars
 *  are divisible, non-integer values are possible, such as ``$10.77``.
 *  By using the smallest indivisible unit (i.e. cents), the value can
 *  be kept as the integer ``1077``.
 *
 *  When receiving decimal input from the user (as a decimal string),
 *  the value should be converted to an integer and when showing a user
 *  a value, the integer value should be converted to a decimal string.
 *
 *  This creates a clear distinction, between values to be used by code
 *  (integers) and values used for display logic to users (decimals).
 *
 *  The native unit in Ethereum, //ether// is divisible to 18 decimal places,
 *  where each individual unit is called a //wei//.
 *
 *  @_subsection api/utils:Unit Conversion  [about-units]
 */ 
/**
 *  The **FixedNumber** class permits using values with decimal places,
 *  using fixed-pont math.
 *
 *  Fixed-point math is still based on integers under-the-hood, but uses an
 *  internal offset to store fractional components below, and each operation
 *  corrects for this after each operation.
 *
 *  @_section: api/utils/fixed-point-math:Fixed-Point Maths  [about-fixed-point-math]
 */ 



const $3321b612fa8b580d$var$BN_N1 = BigInt(-1);
const $3321b612fa8b580d$var$BN_0 = BigInt(0);
const $3321b612fa8b580d$var$BN_1 = BigInt(1);
const $3321b612fa8b580d$var$BN_5 = BigInt(5);
const $3321b612fa8b580d$var$_guard = {};
// Constant to pull zeros from for multipliers
let $3321b612fa8b580d$var$Zeros = "0000";
while($3321b612fa8b580d$var$Zeros.length < 80)$3321b612fa8b580d$var$Zeros += $3321b612fa8b580d$var$Zeros;
// Returns a string "1" followed by decimal "0"s
function $3321b612fa8b580d$var$getTens(decimals) {
    let result = $3321b612fa8b580d$var$Zeros;
    while(result.length < decimals)result += result;
    return BigInt("1" + result.substring(0, decimals));
}
function $3321b612fa8b580d$var$checkValue(val, format, safeOp) {
    const width = BigInt(format.width);
    if (format.signed) {
        const limit = $3321b612fa8b580d$var$BN_1 << width - $3321b612fa8b580d$var$BN_1;
        (0, $634aa51198273feb$export$a7a9523472993e97)(safeOp == null || val >= -limit && val < limit, "overflow", "NUMERIC_FAULT", {
            operation: safeOp,
            fault: "overflow",
            value: val
        });
        if (val > $3321b612fa8b580d$var$BN_0) val = (0, $6fa405e57bb6371e$export$92182edcfa20e5bc)((0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(val, width), width);
        else val = -(0, $6fa405e57bb6371e$export$92182edcfa20e5bc)((0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(-val, width), width);
    } else {
        const limit = $3321b612fa8b580d$var$BN_1 << width;
        (0, $634aa51198273feb$export$a7a9523472993e97)(safeOp == null || val >= 0 && val < limit, "overflow", "NUMERIC_FAULT", {
            operation: safeOp,
            fault: "overflow",
            value: val
        });
        val = (val % limit + limit) % limit & limit - $3321b612fa8b580d$var$BN_1;
    }
    return val;
}
function $3321b612fa8b580d$var$getFormat(value) {
    if (typeof value === "number") value = `fixed128x${value}`;
    let signed = true;
    let width = 128;
    let decimals = 18;
    if (typeof value === "string") {
        // Parse the format string
        if (value === "fixed") ;
        else if (value === "ufixed") signed = false;
        else {
            const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(match, "invalid fixed format", "format", value);
            signed = match[1] !== "u";
            width = parseInt(match[2]);
            decimals = parseInt(match[3]);
        }
    } else if (value) {
        // Extract the values from the object
        const v = value;
        const check = (key, type, defaultValue)=>{
            if (v[key] == null) return defaultValue;
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof v[key] === type, "invalid fixed format (" + key + " not " + type + ")", "format." + key, v[key]);
            return v[key];
        };
        signed = check("signed", "boolean", signed);
        width = check("width", "number", width);
        decimals = check("decimals", "number", decimals);
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(width % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", width);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(decimals <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", decimals);
    const name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
    return {
        signed: signed,
        width: width,
        decimals: decimals,
        name: name
    };
}
function $3321b612fa8b580d$var$toString(val, decimals) {
    let negative = "";
    if (val < $3321b612fa8b580d$var$BN_0) {
        negative = "-";
        val *= $3321b612fa8b580d$var$BN_N1;
    }
    let str = val.toString();
    // No decimal point for whole values
    if (decimals === 0) return negative + str;
    // Pad out to the whole component (including a whole digit)
    while(str.length <= decimals)str = $3321b612fa8b580d$var$Zeros + str;
    // Insert the decimal point
    const index = str.length - decimals;
    str = str.substring(0, index) + "." + str.substring(index);
    // Trim the whole component (leaving at least one 0)
    while(str[0] === "0" && str[1] !== ".")str = str.substring(1);
    // Trim the decimal component (leaving at least one 0)
    while(str[str.length - 1] === "0" && str[str.length - 2] !== ".")str = str.substring(0, str.length - 1);
    return negative + str;
}
class $3321b612fa8b580d$export$d4693c66c2213e45 {
    /**
     *  The specific fixed-point arithmetic field for this value.
     */ format;
    #format;
    // The actual value (accounting for decimals)
    #val;
    // A base-10 value to multiple values by to maintain the magnitude
    #tens;
    /**
     *  This is a property so console.log shows a human-meaningful value.
     *
     *  @private
     */ _value;
    // Use this when changing this file to get some typing info,
    // but then switch to any to mask the internal type
    //constructor(guard: any, value: bigint, format: _FixedFormat) {
    /**
     *  @private
     */ constructor(guard, value, format){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $3321b612fa8b580d$var$_guard, "FixedNumber");
        this.#val = value;
        this.#format = format;
        const _value = $3321b612fa8b580d$var$toString(value, format.decimals);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            format: format.name,
            _value: _value
        });
        this.#tens = $3321b612fa8b580d$var$getTens(format.decimals);
    }
    /**
     *  If true, negative values are permitted, otherwise only
     *  positive values and zero are allowed.
     */ get signed() {
        return this.#format.signed;
    }
    /**
     *  The number of bits available to store the value.
     */ get width() {
        return this.#format.width;
    }
    /**
     *  The number of decimal places in the fixed-point arithment field.
     */ get decimals() {
        return this.#format.decimals;
    }
    /**
     *  The value as an integer, based on the smallest unit the
     *  [[decimals]] allow.
     */ get value() {
        return this.#val;
    }
    #checkFormat(other) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(this.format === other.format, "incompatible format; use fixedNumber.toFormat", "other", other);
    }
    #checkValue(val, safeOp) {
        /*
                const width = BigInt(this.width);
                if (this.signed) {
                    const limit = (BN_1 << (width - BN_1));
                    assert(safeOp == null || (val >= -limit  && val < limit), "overflow", "NUMERIC_FAULT", {
                        operation: <string>safeOp, fault: "overflow", value: val
                    });
        
                    if (val > BN_0) {
                        val = fromTwos(mask(val, width), width);
                    } else {
                        val = -fromTwos(mask(-val, width), width);
                    }
        
                } else {
                    const masked = mask(val, width);
                    assert(safeOp == null || (val >= 0 && val === masked), "overflow", "NUMERIC_FAULT", {
                        operation: <string>safeOp, fault: "overflow", value: val
                    });
                    val = masked;
                }
        */ val = $3321b612fa8b580d$var$checkValue(val, this.#format, safeOp);
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, val, this.#format);
    }
    #add(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val + o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%, ignoring overflow.
     */ addUnsafe(other) {
        return this.#add(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ add(other) {
        return this.#add(other, "add");
    }
    #sub(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val - o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%, ignoring overflow.
     */ subUnsafe(other) {
        return this.#sub(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ sub(other) {
        return this.#sub(other, "sub");
    }
    #mul(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val * o.#val / this.#tens, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%, ignoring overflow and underflow (precision loss).
     */ mulUnsafe(other) {
        return this.#mul(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ mul(other) {
        return this.#mul(other, "mul");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs or if underflow (precision loss) occurs.
     */ mulSignal(other) {
        this.#checkFormat(other);
        const value = this.#val * other.#val;
        (0, $634aa51198273feb$export$a7a9523472993e97)(value % this.#tens === $3321b612fa8b580d$var$BN_0, "precision lost during signalling mul", "NUMERIC_FAULT", {
            operation: "mulSignal",
            fault: "underflow",
            value: this
        });
        return this.#checkValue(value / this.#tens, "mulSignal");
    }
    #div(o, safeOp) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(o.#val !== $3321b612fa8b580d$var$BN_0, "division by zero", "NUMERIC_FAULT", {
            operation: "div",
            fault: "divide-by-zero",
            value: this
        });
        this.#checkFormat(o);
        return this.#checkValue(this.#val * this.#tens / o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */ divUnsafe(other) {
        return this.#div(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */ div(other) {
        return this.#div(other, "div");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
     *  (precision loss) occurs.
     */ divSignal(other) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(other.#val !== $3321b612fa8b580d$var$BN_0, "division by zero", "NUMERIC_FAULT", {
            operation: "div",
            fault: "divide-by-zero",
            value: this
        });
        this.#checkFormat(other);
        const value = this.#val * this.#tens;
        (0, $634aa51198273feb$export$a7a9523472993e97)(value % other.#val === $3321b612fa8b580d$var$BN_0, "precision lost during signalling div", "NUMERIC_FAULT", {
            operation: "divSignal",
            fault: "underflow",
            value: this
        });
        return this.#checkValue(value / other.#val, "divSignal");
    }
    /**
     *  Returns a comparison result between %%this%% and %%other%%.
     *
     *  This is suitable for use in sorting, where ``-1`` implies %%this%%
     *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
     *  both are equal.
     */ cmp(other) {
        let a = this.value, b = other.value;
        // Coerce a and b to the same magnitude
        const delta = this.decimals - other.decimals;
        if (delta > 0) b *= $3321b612fa8b580d$var$getTens(delta);
        else if (delta < 0) a *= $3321b612fa8b580d$var$getTens(-delta);
        // Comnpare
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }
    /**
     *  Returns true if %%other%% is equal to %%this%%.
     */ eq(other) {
        return this.cmp(other) === 0;
    }
    /**
     *  Returns true if %%other%% is less than to %%this%%.
     */ lt(other) {
        return this.cmp(other) < 0;
    }
    /**
     *  Returns true if %%other%% is less than or equal to %%this%%.
     */ lte(other) {
        return this.cmp(other) <= 0;
    }
    /**
     *  Returns true if %%other%% is greater than to %%this%%.
     */ gt(other) {
        return this.cmp(other) > 0;
    }
    /**
     *  Returns true if %%other%% is greater than or equal to %%this%%.
     */ gte(other) {
        return this.cmp(other) >= 0;
    }
    /**
     *  Returns a new [[FixedNumber]] which is the largest **integer**
     *  that is less than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */ floor() {
        let val = this.#val;
        if (this.#val < $3321b612fa8b580d$var$BN_0) val -= this.#tens - $3321b612fa8b580d$var$BN_1;
        val = this.#val / this.#tens * this.#tens;
        return this.#checkValue(val, "floor");
    }
    /**
     *  Returns a new [[FixedNumber]] which is the smallest **integer**
     *  that is greater than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */ ceiling() {
        let val = this.#val;
        if (this.#val > $3321b612fa8b580d$var$BN_0) val += this.#tens - $3321b612fa8b580d$var$BN_1;
        val = this.#val / this.#tens * this.#tens;
        return this.#checkValue(val, "ceiling");
    }
    /**
     *  Returns a new [[FixedNumber]] with the decimal component
     *  rounded up on ties at %%decimals%% places.
     */ round(decimals) {
        if (decimals == null) decimals = 0;
        // Not enough precision to not already be rounded
        if (decimals >= this.decimals) return this;
        const delta = this.decimals - decimals;
        const bump = $3321b612fa8b580d$var$BN_5 * $3321b612fa8b580d$var$getTens(delta - 1);
        let value = this.value + bump;
        const tens = $3321b612fa8b580d$var$getTens(delta);
        value = value / tens * tens;
        $3321b612fa8b580d$var$checkValue(value, this.#format, "round");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, this.#format);
    }
    /**
     *  Returns true if %%this%% is equal to ``0``.
     */ isZero() {
        return this.#val === $3321b612fa8b580d$var$BN_0;
    }
    /**
     *  Returns true if %%this%% is less than ``0``.
     */ isNegative() {
        return this.#val < $3321b612fa8b580d$var$BN_0;
    }
    /**
     *  Returns the string representation of %%this%%.
     */ toString() {
        return this._value;
    }
    /**
     *  Returns a float approximation.
     *
     *  Due to IEEE 754 precission (or lack thereof), this function
     *  can only return an approximation and most values will contain
     *  rounding errors.
     */ toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    /**
     *  Return a new [[FixedNumber]] with the same value but has had
     *  its field set to %%format%%.
     *
     *  This will throw if the value cannot fit into %%format%%.
     */ toFormat(format) {
        return $3321b612fa8b580d$export$d4693c66c2213e45.fromString(this.toString(), format);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% divided by
     *  %%decimal%% places with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
     *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
     *  or underflow (precision loss).
     */ static fromValue(_value, _decimals, _format) {
        const decimals = _decimals == null ? 0 : (0, $6fa405e57bb6371e$export$b14f2714108df84)(_decimals);
        const format = $3321b612fa8b580d$var$getFormat(_format);
        let value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "value");
        const delta = decimals - format.decimals;
        if (delta > 0) {
            const tens = $3321b612fa8b580d$var$getTens(delta);
            (0, $634aa51198273feb$export$a7a9523472993e97)(value % tens === $3321b612fa8b580d$var$BN_0, "value loses precision for format", "NUMERIC_FAULT", {
                operation: "fromValue",
                fault: "underflow",
                value: _value
            });
            value /= tens;
        } else if (delta < 0) value *= $3321b612fa8b580d$var$getTens(-delta);
        $3321b612fa8b580d$var$checkValue(value, format, "fromValue");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, format);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%%, either due to overflow or underflow (precision loss).
     */ static fromString(_value, _format) {
        const match = _value.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(match && match[2].length + match[3].length > 0, "invalid FixedNumber string value", "value", _value);
        const format = $3321b612fa8b580d$var$getFormat(_format);
        let whole = match[2] || "0", decimal = match[3] || "";
        // Pad out the decimals
        while(decimal.length < format.decimals)decimal += $3321b612fa8b580d$var$Zeros;
        // Check precision is safe
        (0, $634aa51198273feb$export$a7a9523472993e97)(decimal.substring(format.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
            operation: "fromString",
            fault: "underflow",
            value: _value
        });
        // Remove extra padding
        decimal = decimal.substring(0, format.decimals);
        const value = BigInt(match[1] + whole + decimal);
        $3321b612fa8b580d$var$checkValue(value, format, "fromString");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, format);
    }
    /**
     *  Creates a new [[FixedNumber]] with the big-endian representation
     *  %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%% due to overflow.
     */ static fromBytes(_value, _format) {
        let value = (0, $6fa405e57bb6371e$export$c221a145703ab783)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_value, "value"));
        const format = $3321b612fa8b580d$var$getFormat(_format);
        if (format.signed) value = (0, $6fa405e57bb6371e$export$92182edcfa20e5bc)(value, format.width);
        $3321b612fa8b580d$var$checkValue(value, format, "fromBytes");
        return new $3321b612fa8b580d$export$d4693c66c2213e45($3321b612fa8b580d$var$_guard, value, format);
    }
} //const f1 = FixedNumber.fromString("12.56", "fixed16x2");
 //const f2 = FixedNumber.fromString("0.3", "fixed16x2");
 //console.log(f1.divSignal(f2));
 //const BUMP = FixedNumber.from("0.5");



const $e3b0a4d4db1a46c4$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $e3b0a4d4db1a46c4$export$bd39b96f71da1885(value, unit) {
    let decimals = 18;
    if (typeof unit === "string") {
        const index = $e3b0a4d4db1a46c4$var$names.indexOf(unit);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(index >= 0, "invalid unit", "unit", unit);
        decimals = 3 * index;
    } else if (unit != null) decimals = (0, $6fa405e57bb6371e$export$b14f2714108df84)(unit, "unit");
    return (0, $3321b612fa8b580d$export$d4693c66c2213e45).fromValue(value, decimals, {
        decimals: decimals,
        width: 512
    }).toString();
}
function $e3b0a4d4db1a46c4$export$203ae30b4f6490b3(value, unit) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "string", "value must be a string", "value", value);
    let decimals = 18;
    if (typeof unit === "string") {
        const index = $e3b0a4d4db1a46c4$var$names.indexOf(unit);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(index >= 0, "invalid unit", "unit", unit);
        decimals = 3 * index;
    } else if (unit != null) decimals = (0, $6fa405e57bb6371e$export$b14f2714108df84)(unit, "unit");
    return (0, $3321b612fa8b580d$export$d4693c66c2213e45).fromString(value, {
        decimals: decimals,
        width: 512
    }).value;
}
function $e3b0a4d4db1a46c4$export$11bc63b4c03ea518(wei) {
    return $e3b0a4d4db1a46c4$export$bd39b96f71da1885(wei, 18);
}
function $e3b0a4d4db1a46c4$export$642c4e67bbdc0bc7(ether) {
    return $e3b0a4d4db1a46c4$export$203ae30b4f6490b3(ether, 18);
}





// NFKC (composed)             // (decomposed)
/**
 *  A constant for the ether symbol (normalized using NFKC).
 *
 *  (**i.e.** ``"\\u039e"``)
 */ const $56b9ace2da5a1ffc$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";
const $56b9ace2da5a1ffc$export$dcfeebc882c24a48 = "\x19Ethereum Signed Message:\n";




function $223310a553815b68$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(message);
    return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        (0, $50aa15ceb128a952$export$8feeb310b4b4752f)((0, $56b9ace2da5a1ffc$export$dcfeebc882c24a48)),
        (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}
function $223310a553815b68$export$228d0e772cc158cb(message, sig) {
    const digest = $223310a553815b68$export$d4c241cec96564c1(message);
    return (0, $e25c0939af0d847b$export$23cc18f96d8510e2)(digest, sig);
}





class $0dc3e77fb9ae1687$export$240e17ab043752ea extends (0, $0e0b4a0a5741b830$export$6c02143914c373f1) {
    /**
     *  The wallet address.
     */ address;
    #signingKey;
    /**
     *  Creates a new BaseWallet for %%privateKey%%, optionally
     *  connected to %%provider%%.
     *
     *  If %%provider%% is not specified, only offline methods can
     *  be used.
     */ constructor(privateKey, provider){
        super(provider);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(privateKey && typeof privateKey.sign === "function", "invalid private key", "privateKey", "[ REDACTED ]");
        this.#signingKey = privateKey;
        const address = (0, $e25c0939af0d847b$export$e67e2732ba9803f9)(this.signingKey.publicKey);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    // Store private values behind getters to reduce visibility
    // in console.log
    /**
     *  The [[SigningKey]] used for signing payloads.
     */ get signingKey() {
        return this.#signingKey;
    }
    /**
     *  The private key for this wallet.
     */ get privateKey() {
        return this.signingKey.privateKey;
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $0dc3e77fb9ae1687$export$240e17ab043752ea(this.#signingKey, provider);
    }
    async signTransaction(tx) {
        tx = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(tx);
        // Replace any Addressable or ENS name with an address
        const { to: to, from: from } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            to: tx.to ? (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(tx.to, this.provider) : undefined,
            from: tx.from ? (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(tx.from, this.provider) : undefined
        });
        if (to != null) tx.to = to;
        if (from != null) tx.from = from;
        if (tx.from != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $69ef3f917ff239a2$export$88411125f012957a)(tx.from) === this.address, "transaction from address mismatch", "tx.from", tx.from);
            delete tx.from;
        }
        // Build the transaction
        const btx = (0, $154b040c27f48330$export$febc5573c75cefb0).from(tx);
        btx.signature = this.signingKey.sign(btx.unsignedHash);
        return btx.serialized;
    }
    async signMessage(message) {
        return this.signMessageSync(message);
    }
    // @TODO: Add a secialized signTx and signTyped sync that enforces
    // all parameters are known?
    /**
     *  Returns the signature for %%message%% signed with this wallet.
     */ signMessageSync(message) {
        return this.signingKey.sign((0, $223310a553815b68$export$d4c241cec96564c1)(message)).serialized;
    }
    async signTypedData(domain, types, value) {
        // Populate any ENS names
        const populated = await (0, $23f01ceb797ea4ad$export$458ab927ae635c3).resolveNames(domain, types, value, async (name)=>{
            // @TODO: this should use resolveName; addresses don't
            //        need a provider
            (0, $634aa51198273feb$export$a7a9523472993e97)(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
                operation: "resolveName",
                info: {
                    name: name
                }
            });
            const address = await this.provider.resolveName(name);
            (0, $634aa51198273feb$export$a7a9523472993e97)(address != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
                value: name
            });
            return address;
        });
        return this.signingKey.sign((0, $23f01ceb797ea4ad$export$458ab927ae635c3).hash(populated.domain, types, populated.value)).serialized;
    }
}


/**
 *  Explain HD Wallets..
 *
 *  @_subsection: api/wallet:HD Wallets  [hd-wallets]
 */ 



// Use the encode-latin.js script to create the necessary
// data files to be consumed by this class



const $748daabed1887818$var$subsChrs = " !#$%&'()*+,-./<=>?@[]^_`{|}~";
const $748daabed1887818$var$Word = /^[a-z]*$/i;
function $748daabed1887818$var$unfold(words, sep) {
    let initial = 97;
    return words.reduce((accum, word)=>{
        if (word === sep) initial++;
        else if (word.match($748daabed1887818$var$Word)) accum.push(String.fromCharCode(initial) + word);
        else {
            initial = 97;
            accum.push(word);
        }
        return accum;
    }, []);
}
function $748daabed1887818$export$2f872c0f2117be69(data, subs) {
    // Replace all the substitutions with their expanded form
    for(let i = $748daabed1887818$var$subsChrs.length - 1; i >= 0; i--)data = data.split($748daabed1887818$var$subsChrs[i]).join(subs.substring(2 * i, 2 * i + 2));
    // Get all tle clumps; each suffix, first-increment and second-increment
    const clumps = [];
    const leftover = data.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (all, item, semi, word)=>{
        if (semi) for(let i = parseInt(semi); i >= 0; i--)clumps.push(";");
        else clumps.push(item.toLowerCase());
        return "";
    });
    /* c8 ignore start */ if (leftover) throw new Error(`leftovers: ${JSON.stringify(leftover)}`);
    /* c8 ignore stop */ return $748daabed1887818$var$unfold($748daabed1887818$var$unfold(clumps, ";"), ":");
}
function $748daabed1887818$export$2580afc3e497c895(data) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(data[0] === "0", "unsupported auwl data", "data", data);
    return $748daabed1887818$export$2f872c0f2117be69(data.substring(1 + 2 * $748daabed1887818$var$subsChrs.length), data.substring(1, 1 + 2 * $748daabed1887818$var$subsChrs.length));
}



class $71b05e7e230d6f68$export$4d9531a8ddb0ebca {
    locale;
    /**
     *  Creates a new Wordlist instance.
     *
     *  Sub-classes MUST call this if they provide their own constructor,
     *  passing in the locale string of the language.
     *
     *  Generally there is no need to create instances of a Wordlist,
     *  since each language-specific Wordlist creates an instance and
     *  there is no state kept internally, so they are safe to share.
     */ constructor(locale){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            locale: locale
        });
    }
    /**
     *  Sub-classes may override this to provide a language-specific
     *  method for spliting %%phrase%% into individual words.
     *
     *  By default, %%phrase%% is split using any sequences of
     *  white-space as defined by regular expressions (i.e. ``/\s+/``).
     */ split(phrase) {
        return phrase.toLowerCase().split(/\s+/g);
    }
    /**
     *  Sub-classes may override this to provider a language-specific
     *  method for joining %%words%% into a phrase.
     *
     *  By default, %%words%% are joined by a single space.
     */ join(words) {
        return words.join(" ");
    }
}


class $761b5b8d3cc900b1$export$cb5e90c6121bec5b extends (0, $71b05e7e230d6f68$export$4d9531a8ddb0ebca) {
    #data;
    #checksum;
    /**
     *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
     *  and validated against the %%checksum%%.
     */ constructor(locale, data, checksum){
        super(locale);
        this.#data = data;
        this.#checksum = checksum;
        this.#words = null;
    }
    /**
     *  The OWL-encoded data.
     */ get _data() {
        return this.#data;
    }
    /**
     *  Decode all the words for the wordlist.
     */ _decodeWords() {
        return (0, $748daabed1887818$export$2580afc3e497c895)(this.#data);
    }
    #words;
    #loadWords() {
        if (this.#words == null) {
            const words = this._decodeWords();
            // Verify the computed list matches the official list
            const checksum = (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(words.join("\n") + "\n");
            /* c8 ignore start */ if (checksum !== this.#checksum) throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
            /* c8 ignore stop */ this.#words = words;
        }
        return this.#words;
    }
    getWord(index) {
        const words = this.#loadWords();
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(index >= 0 && index < words.length, `invalid word index: ${index}`, "index", index);
        return words[index];
    }
    getWordIndex(word) {
        return this.#loadWords().indexOf(word);
    }
}


const $6bf09071e590cbe7$var$words = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO";
const $6bf09071e590cbe7$var$checksum = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
let $6bf09071e590cbe7$var$wordlist = null;
class $6bf09071e590cbe7$export$eafb81b30f0382d9 extends (0, $761b5b8d3cc900b1$export$cb5e90c6121bec5b) {
    /**
     *  Creates a new instance of the English language Wordlist.
     *
     *  This should be unnecessary most of the time as the exported
     *  [[langEn]] should suffice.
     *
     *  @_ignore:
     */ constructor(){
        super("en", $6bf09071e590cbe7$var$words, $6bf09071e590cbe7$var$checksum);
    }
    /**
     *  Returns a singleton instance of a ``LangEn``, creating it
     *  if this is the first time being called.
     */ static wordlist() {
        if ($6bf09071e590cbe7$var$wordlist == null) $6bf09071e590cbe7$var$wordlist = new $6bf09071e590cbe7$export$eafb81b30f0382d9();
        return $6bf09071e590cbe7$var$wordlist;
    }
}






// Returns a byte with the MSB bits set
function $96579c190558f712$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits & 0xff;
}
// Returns a byte with the LSB bits set
function $96579c190558f712$var$getLowerMask(bits) {
    return (1 << bits) - 1 & 0xff;
}
function $96579c190558f712$var$mnemonicToEntropy(mnemonic, wordlist) {
    (0, $634aa51198273feb$export$d993e67fefdfecda)("NFKD");
    if (wordlist == null) wordlist = (0, $6bf09071e590cbe7$export$eafb81b30f0382d9).wordlist();
    const words = wordlist.split(mnemonic);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(words.length % 3 === 0 && words.length >= 12 && words.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
    const entropy = new Uint8Array(Math.ceil(11 * words.length / 8));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(index >= 0, `invalid mnemonic word at index ${i}`, "mnemonic", "[ REDACTED ]");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $96579c190558f712$var$getUpperMask(checksumBits);
    const checksum = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(checksum === (entropy[entropy.length - 1] & checksumMask), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $96579c190558f712$var$entropyToMnemonic(entropy, wordlist) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(entropy.length % 4 === 0 && entropy.length >= 16 && entropy.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]");
    if (wordlist == null) wordlist = (0, $6bf09071e590cbe7$export$eafb81b30f0382d9).wordlist();
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $96579c190558f712$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = parseInt((0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)(entropy).substring(2, 4), 16) & $96579c190558f712$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
const $96579c190558f712$var$_guard = {};
class $96579c190558f712$export$93018d515d60db37 {
    /**
     *  The mnemonic phrase of 12, 15, 18, 21 or 24 words.
     *
     *  Use the [[wordlist]] ``split`` method to get the individual words.
     */ phrase;
    /**
     *  The password used for this mnemonic. If no password is used this
     *  is the empty string (i.e. ``""``) as per the specification.
     */ password;
    /**
     *  The wordlist for this mnemonic.
     */ wordlist;
    /**
     *  The underlying entropy which the mnemonic encodes.
     */ entropy;
    /**
     *  @private
     */ constructor(guard, entropy, phrase, password, wordlist){
        if (password == null) password = "";
        if (wordlist == null) wordlist = (0, $6bf09071e590cbe7$export$eafb81b30f0382d9).wordlist();
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $96579c190558f712$var$_guard, "Mnemonic");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            phrase: phrase,
            password: password,
            wordlist: wordlist,
            entropy: entropy
        });
    }
    /**
     *  Returns the seed for the mnemonic.
     */ computeSeed() {
        const salt = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)("mnemonic" + this.password, "NFKD");
        return (0, $9092348e8cf65603$export$448fa22aedc9dbca)((0, $50aa15ceb128a952$export$8feeb310b4b4752f)(this.phrase, "NFKD"), salt, 2048, 64, "sha512");
    }
    /**
     *  Creates a new Mnemonic for the %%phrase%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */ static fromPhrase(phrase, password, wordlist) {
        // Normalize the case and space; throws if invalid
        const entropy = $96579c190558f712$var$mnemonicToEntropy(phrase, wordlist);
        phrase = $96579c190558f712$var$entropyToMnemonic((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(entropy), wordlist);
        return new $96579c190558f712$export$93018d515d60db37($96579c190558f712$var$_guard, entropy, phrase, password, wordlist);
    }
    /**
     *  Create a new **Mnemonic** from the %%entropy%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */ static fromEntropy(_entropy, password, wordlist) {
        const entropy = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_entropy, "entropy");
        const phrase = $96579c190558f712$var$entropyToMnemonic(entropy, wordlist);
        return new $96579c190558f712$export$93018d515d60db37($96579c190558f712$var$_guard, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(entropy), phrase, password, wordlist);
    }
    /**
     *  Returns the phrase for %%mnemonic%%.
     */ static entropyToPhrase(_entropy, wordlist) {
        const entropy = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_entropy, "entropy");
        return $96579c190558f712$var$entropyToMnemonic(entropy, wordlist);
    }
    /**
     *  Returns the entropy for %%phrase%%.
     */ static phraseToEntropy(phrase, wordlist) {
        return $96579c190558f712$var$mnemonicToEntropy(phrase, wordlist);
    }
    /**
     *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
     *
     *  This checks all the provided words belong to the %%wordlist%%,
     *  that the length is valid and the checksum is correct.
     */ static isValidMnemonic(phrase, wordlist) {
        try {
            $96579c190558f712$var$mnemonicToEntropy(phrase, wordlist);
            return true;
        } catch (error) {}
        return false;
    }
}


/**
 *  The JSON Wallet formats allow a simple way to store the private
 *  keys needed in Ethereum along with related information and allows
 *  for extensible forms of encryption.
 *
 *  These utilities facilitate decrypting and encrypting the most common
 *  JSON Wallet formats.
 *
 *  @_subsection: api/wallet:JSON Wallets  [json-wallets]
 */ /*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */ var $6d51fc1d1af75bc0$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6d51fc1d1af75bc0$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6d51fc1d1af75bc0$var$_AES_key, $6d51fc1d1af75bc0$var$_AES_Kd, $6d51fc1d1af75bc0$var$_AES_Ke;
// Number of rounds by keysize
const $6d51fc1d1af75bc0$var$numberOfRounds = {
    16: 10,
    24: 12,
    32: 14
};
// Round constant words
const $6d51fc1d1af75bc0$var$rcon = [
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36,
    0x6c,
    0xd8,
    0xab,
    0x4d,
    0x9a,
    0x2f,
    0x5e,
    0xbc,
    0x63,
    0xc6,
    0x97,
    0x35,
    0x6a,
    0xd4,
    0xb3,
    0x7d,
    0xfa,
    0xef,
    0xc5,
    0x91
];
// S-box and Inverse S-box (S is for Substitution)
const $6d51fc1d1af75bc0$var$S = [
    0x63,
    0x7c,
    0x77,
    0x7b,
    0xf2,
    0x6b,
    0x6f,
    0xc5,
    0x30,
    0x01,
    0x67,
    0x2b,
    0xfe,
    0xd7,
    0xab,
    0x76,
    0xca,
    0x82,
    0xc9,
    0x7d,
    0xfa,
    0x59,
    0x47,
    0xf0,
    0xad,
    0xd4,
    0xa2,
    0xaf,
    0x9c,
    0xa4,
    0x72,
    0xc0,
    0xb7,
    0xfd,
    0x93,
    0x26,
    0x36,
    0x3f,
    0xf7,
    0xcc,
    0x34,
    0xa5,
    0xe5,
    0xf1,
    0x71,
    0xd8,
    0x31,
    0x15,
    0x04,
    0xc7,
    0x23,
    0xc3,
    0x18,
    0x96,
    0x05,
    0x9a,
    0x07,
    0x12,
    0x80,
    0xe2,
    0xeb,
    0x27,
    0xb2,
    0x75,
    0x09,
    0x83,
    0x2c,
    0x1a,
    0x1b,
    0x6e,
    0x5a,
    0xa0,
    0x52,
    0x3b,
    0xd6,
    0xb3,
    0x29,
    0xe3,
    0x2f,
    0x84,
    0x53,
    0xd1,
    0x00,
    0xed,
    0x20,
    0xfc,
    0xb1,
    0x5b,
    0x6a,
    0xcb,
    0xbe,
    0x39,
    0x4a,
    0x4c,
    0x58,
    0xcf,
    0xd0,
    0xef,
    0xaa,
    0xfb,
    0x43,
    0x4d,
    0x33,
    0x85,
    0x45,
    0xf9,
    0x02,
    0x7f,
    0x50,
    0x3c,
    0x9f,
    0xa8,
    0x51,
    0xa3,
    0x40,
    0x8f,
    0x92,
    0x9d,
    0x38,
    0xf5,
    0xbc,
    0xb6,
    0xda,
    0x21,
    0x10,
    0xff,
    0xf3,
    0xd2,
    0xcd,
    0x0c,
    0x13,
    0xec,
    0x5f,
    0x97,
    0x44,
    0x17,
    0xc4,
    0xa7,
    0x7e,
    0x3d,
    0x64,
    0x5d,
    0x19,
    0x73,
    0x60,
    0x81,
    0x4f,
    0xdc,
    0x22,
    0x2a,
    0x90,
    0x88,
    0x46,
    0xee,
    0xb8,
    0x14,
    0xde,
    0x5e,
    0x0b,
    0xdb,
    0xe0,
    0x32,
    0x3a,
    0x0a,
    0x49,
    0x06,
    0x24,
    0x5c,
    0xc2,
    0xd3,
    0xac,
    0x62,
    0x91,
    0x95,
    0xe4,
    0x79,
    0xe7,
    0xc8,
    0x37,
    0x6d,
    0x8d,
    0xd5,
    0x4e,
    0xa9,
    0x6c,
    0x56,
    0xf4,
    0xea,
    0x65,
    0x7a,
    0xae,
    0x08,
    0xba,
    0x78,
    0x25,
    0x2e,
    0x1c,
    0xa6,
    0xb4,
    0xc6,
    0xe8,
    0xdd,
    0x74,
    0x1f,
    0x4b,
    0xbd,
    0x8b,
    0x8a,
    0x70,
    0x3e,
    0xb5,
    0x66,
    0x48,
    0x03,
    0xf6,
    0x0e,
    0x61,
    0x35,
    0x57,
    0xb9,
    0x86,
    0xc1,
    0x1d,
    0x9e,
    0xe1,
    0xf8,
    0x98,
    0x11,
    0x69,
    0xd9,
    0x8e,
    0x94,
    0x9b,
    0x1e,
    0x87,
    0xe9,
    0xce,
    0x55,
    0x28,
    0xdf,
    0x8c,
    0xa1,
    0x89,
    0x0d,
    0xbf,
    0xe6,
    0x42,
    0x68,
    0x41,
    0x99,
    0x2d,
    0x0f,
    0xb0,
    0x54,
    0xbb,
    0x16
];
const $6d51fc1d1af75bc0$var$Si = [
    0x52,
    0x09,
    0x6a,
    0xd5,
    0x30,
    0x36,
    0xa5,
    0x38,
    0xbf,
    0x40,
    0xa3,
    0x9e,
    0x81,
    0xf3,
    0xd7,
    0xfb,
    0x7c,
    0xe3,
    0x39,
    0x82,
    0x9b,
    0x2f,
    0xff,
    0x87,
    0x34,
    0x8e,
    0x43,
    0x44,
    0xc4,
    0xde,
    0xe9,
    0xcb,
    0x54,
    0x7b,
    0x94,
    0x32,
    0xa6,
    0xc2,
    0x23,
    0x3d,
    0xee,
    0x4c,
    0x95,
    0x0b,
    0x42,
    0xfa,
    0xc3,
    0x4e,
    0x08,
    0x2e,
    0xa1,
    0x66,
    0x28,
    0xd9,
    0x24,
    0xb2,
    0x76,
    0x5b,
    0xa2,
    0x49,
    0x6d,
    0x8b,
    0xd1,
    0x25,
    0x72,
    0xf8,
    0xf6,
    0x64,
    0x86,
    0x68,
    0x98,
    0x16,
    0xd4,
    0xa4,
    0x5c,
    0xcc,
    0x5d,
    0x65,
    0xb6,
    0x92,
    0x6c,
    0x70,
    0x48,
    0x50,
    0xfd,
    0xed,
    0xb9,
    0xda,
    0x5e,
    0x15,
    0x46,
    0x57,
    0xa7,
    0x8d,
    0x9d,
    0x84,
    0x90,
    0xd8,
    0xab,
    0x00,
    0x8c,
    0xbc,
    0xd3,
    0x0a,
    0xf7,
    0xe4,
    0x58,
    0x05,
    0xb8,
    0xb3,
    0x45,
    0x06,
    0xd0,
    0x2c,
    0x1e,
    0x8f,
    0xca,
    0x3f,
    0x0f,
    0x02,
    0xc1,
    0xaf,
    0xbd,
    0x03,
    0x01,
    0x13,
    0x8a,
    0x6b,
    0x3a,
    0x91,
    0x11,
    0x41,
    0x4f,
    0x67,
    0xdc,
    0xea,
    0x97,
    0xf2,
    0xcf,
    0xce,
    0xf0,
    0xb4,
    0xe6,
    0x73,
    0x96,
    0xac,
    0x74,
    0x22,
    0xe7,
    0xad,
    0x35,
    0x85,
    0xe2,
    0xf9,
    0x37,
    0xe8,
    0x1c,
    0x75,
    0xdf,
    0x6e,
    0x47,
    0xf1,
    0x1a,
    0x71,
    0x1d,
    0x29,
    0xc5,
    0x89,
    0x6f,
    0xb7,
    0x62,
    0x0e,
    0xaa,
    0x18,
    0xbe,
    0x1b,
    0xfc,
    0x56,
    0x3e,
    0x4b,
    0xc6,
    0xd2,
    0x79,
    0x20,
    0x9a,
    0xdb,
    0xc0,
    0xfe,
    0x78,
    0xcd,
    0x5a,
    0xf4,
    0x1f,
    0xdd,
    0xa8,
    0x33,
    0x88,
    0x07,
    0xc7,
    0x31,
    0xb1,
    0x12,
    0x10,
    0x59,
    0x27,
    0x80,
    0xec,
    0x5f,
    0x60,
    0x51,
    0x7f,
    0xa9,
    0x19,
    0xb5,
    0x4a,
    0x0d,
    0x2d,
    0xe5,
    0x7a,
    0x9f,
    0x93,
    0xc9,
    0x9c,
    0xef,
    0xa0,
    0xe0,
    0x3b,
    0x4d,
    0xae,
    0x2a,
    0xf5,
    0xb0,
    0xc8,
    0xeb,
    0xbb,
    0x3c,
    0x83,
    0x53,
    0x99,
    0x61,
    0x17,
    0x2b,
    0x04,
    0x7e,
    0xba,
    0x77,
    0xd6,
    0x26,
    0xe1,
    0x69,
    0x14,
    0x63,
    0x55,
    0x21,
    0x0c,
    0x7d
];
// Transformations for encryption
const $6d51fc1d1af75bc0$var$T1 = [
    0xc66363a5,
    0xf87c7c84,
    0xee777799,
    0xf67b7b8d,
    0xfff2f20d,
    0xd66b6bbd,
    0xde6f6fb1,
    0x91c5c554,
    0x60303050,
    0x02010103,
    0xce6767a9,
    0x562b2b7d,
    0xe7fefe19,
    0xb5d7d762,
    0x4dababe6,
    0xec76769a,
    0x8fcaca45,
    0x1f82829d,
    0x89c9c940,
    0xfa7d7d87,
    0xeffafa15,
    0xb25959eb,
    0x8e4747c9,
    0xfbf0f00b,
    0x41adadec,
    0xb3d4d467,
    0x5fa2a2fd,
    0x45afafea,
    0x239c9cbf,
    0x53a4a4f7,
    0xe4727296,
    0x9bc0c05b,
    0x75b7b7c2,
    0xe1fdfd1c,
    0x3d9393ae,
    0x4c26266a,
    0x6c36365a,
    0x7e3f3f41,
    0xf5f7f702,
    0x83cccc4f,
    0x6834345c,
    0x51a5a5f4,
    0xd1e5e534,
    0xf9f1f108,
    0xe2717193,
    0xabd8d873,
    0x62313153,
    0x2a15153f,
    0x0804040c,
    0x95c7c752,
    0x46232365,
    0x9dc3c35e,
    0x30181828,
    0x379696a1,
    0x0a05050f,
    0x2f9a9ab5,
    0x0e070709,
    0x24121236,
    0x1b80809b,
    0xdfe2e23d,
    0xcdebeb26,
    0x4e272769,
    0x7fb2b2cd,
    0xea75759f,
    0x1209091b,
    0x1d83839e,
    0x582c2c74,
    0x341a1a2e,
    0x361b1b2d,
    0xdc6e6eb2,
    0xb45a5aee,
    0x5ba0a0fb,
    0xa45252f6,
    0x763b3b4d,
    0xb7d6d661,
    0x7db3b3ce,
    0x5229297b,
    0xdde3e33e,
    0x5e2f2f71,
    0x13848497,
    0xa65353f5,
    0xb9d1d168,
    0x00000000,
    0xc1eded2c,
    0x40202060,
    0xe3fcfc1f,
    0x79b1b1c8,
    0xb65b5bed,
    0xd46a6abe,
    0x8dcbcb46,
    0x67bebed9,
    0x7239394b,
    0x944a4ade,
    0x984c4cd4,
    0xb05858e8,
    0x85cfcf4a,
    0xbbd0d06b,
    0xc5efef2a,
    0x4faaaae5,
    0xedfbfb16,
    0x864343c5,
    0x9a4d4dd7,
    0x66333355,
    0x11858594,
    0x8a4545cf,
    0xe9f9f910,
    0x04020206,
    0xfe7f7f81,
    0xa05050f0,
    0x783c3c44,
    0x259f9fba,
    0x4ba8a8e3,
    0xa25151f3,
    0x5da3a3fe,
    0x804040c0,
    0x058f8f8a,
    0x3f9292ad,
    0x219d9dbc,
    0x70383848,
    0xf1f5f504,
    0x63bcbcdf,
    0x77b6b6c1,
    0xafdada75,
    0x42212163,
    0x20101030,
    0xe5ffff1a,
    0xfdf3f30e,
    0xbfd2d26d,
    0x81cdcd4c,
    0x180c0c14,
    0x26131335,
    0xc3ecec2f,
    0xbe5f5fe1,
    0x359797a2,
    0x884444cc,
    0x2e171739,
    0x93c4c457,
    0x55a7a7f2,
    0xfc7e7e82,
    0x7a3d3d47,
    0xc86464ac,
    0xba5d5de7,
    0x3219192b,
    0xe6737395,
    0xc06060a0,
    0x19818198,
    0x9e4f4fd1,
    0xa3dcdc7f,
    0x44222266,
    0x542a2a7e,
    0x3b9090ab,
    0x0b888883,
    0x8c4646ca,
    0xc7eeee29,
    0x6bb8b8d3,
    0x2814143c,
    0xa7dede79,
    0xbc5e5ee2,
    0x160b0b1d,
    0xaddbdb76,
    0xdbe0e03b,
    0x64323256,
    0x743a3a4e,
    0x140a0a1e,
    0x924949db,
    0x0c06060a,
    0x4824246c,
    0xb85c5ce4,
    0x9fc2c25d,
    0xbdd3d36e,
    0x43acacef,
    0xc46262a6,
    0x399191a8,
    0x319595a4,
    0xd3e4e437,
    0xf279798b,
    0xd5e7e732,
    0x8bc8c843,
    0x6e373759,
    0xda6d6db7,
    0x018d8d8c,
    0xb1d5d564,
    0x9c4e4ed2,
    0x49a9a9e0,
    0xd86c6cb4,
    0xac5656fa,
    0xf3f4f407,
    0xcfeaea25,
    0xca6565af,
    0xf47a7a8e,
    0x47aeaee9,
    0x10080818,
    0x6fbabad5,
    0xf0787888,
    0x4a25256f,
    0x5c2e2e72,
    0x381c1c24,
    0x57a6a6f1,
    0x73b4b4c7,
    0x97c6c651,
    0xcbe8e823,
    0xa1dddd7c,
    0xe874749c,
    0x3e1f1f21,
    0x964b4bdd,
    0x61bdbddc,
    0x0d8b8b86,
    0x0f8a8a85,
    0xe0707090,
    0x7c3e3e42,
    0x71b5b5c4,
    0xcc6666aa,
    0x904848d8,
    0x06030305,
    0xf7f6f601,
    0x1c0e0e12,
    0xc26161a3,
    0x6a35355f,
    0xae5757f9,
    0x69b9b9d0,
    0x17868691,
    0x99c1c158,
    0x3a1d1d27,
    0x279e9eb9,
    0xd9e1e138,
    0xebf8f813,
    0x2b9898b3,
    0x22111133,
    0xd26969bb,
    0xa9d9d970,
    0x078e8e89,
    0x339494a7,
    0x2d9b9bb6,
    0x3c1e1e22,
    0x15878792,
    0xc9e9e920,
    0x87cece49,
    0xaa5555ff,
    0x50282878,
    0xa5dfdf7a,
    0x038c8c8f,
    0x59a1a1f8,
    0x09898980,
    0x1a0d0d17,
    0x65bfbfda,
    0xd7e6e631,
    0x844242c6,
    0xd06868b8,
    0x824141c3,
    0x299999b0,
    0x5a2d2d77,
    0x1e0f0f11,
    0x7bb0b0cb,
    0xa85454fc,
    0x6dbbbbd6,
    0x2c16163a
];
const $6d51fc1d1af75bc0$var$T2 = [
    0xa5c66363,
    0x84f87c7c,
    0x99ee7777,
    0x8df67b7b,
    0x0dfff2f2,
    0xbdd66b6b,
    0xb1de6f6f,
    0x5491c5c5,
    0x50603030,
    0x03020101,
    0xa9ce6767,
    0x7d562b2b,
    0x19e7fefe,
    0x62b5d7d7,
    0xe64dabab,
    0x9aec7676,
    0x458fcaca,
    0x9d1f8282,
    0x4089c9c9,
    0x87fa7d7d,
    0x15effafa,
    0xebb25959,
    0xc98e4747,
    0x0bfbf0f0,
    0xec41adad,
    0x67b3d4d4,
    0xfd5fa2a2,
    0xea45afaf,
    0xbf239c9c,
    0xf753a4a4,
    0x96e47272,
    0x5b9bc0c0,
    0xc275b7b7,
    0x1ce1fdfd,
    0xae3d9393,
    0x6a4c2626,
    0x5a6c3636,
    0x417e3f3f,
    0x02f5f7f7,
    0x4f83cccc,
    0x5c683434,
    0xf451a5a5,
    0x34d1e5e5,
    0x08f9f1f1,
    0x93e27171,
    0x73abd8d8,
    0x53623131,
    0x3f2a1515,
    0x0c080404,
    0x5295c7c7,
    0x65462323,
    0x5e9dc3c3,
    0x28301818,
    0xa1379696,
    0x0f0a0505,
    0xb52f9a9a,
    0x090e0707,
    0x36241212,
    0x9b1b8080,
    0x3ddfe2e2,
    0x26cdebeb,
    0x694e2727,
    0xcd7fb2b2,
    0x9fea7575,
    0x1b120909,
    0x9e1d8383,
    0x74582c2c,
    0x2e341a1a,
    0x2d361b1b,
    0xb2dc6e6e,
    0xeeb45a5a,
    0xfb5ba0a0,
    0xf6a45252,
    0x4d763b3b,
    0x61b7d6d6,
    0xce7db3b3,
    0x7b522929,
    0x3edde3e3,
    0x715e2f2f,
    0x97138484,
    0xf5a65353,
    0x68b9d1d1,
    0x00000000,
    0x2cc1eded,
    0x60402020,
    0x1fe3fcfc,
    0xc879b1b1,
    0xedb65b5b,
    0xbed46a6a,
    0x468dcbcb,
    0xd967bebe,
    0x4b723939,
    0xde944a4a,
    0xd4984c4c,
    0xe8b05858,
    0x4a85cfcf,
    0x6bbbd0d0,
    0x2ac5efef,
    0xe54faaaa,
    0x16edfbfb,
    0xc5864343,
    0xd79a4d4d,
    0x55663333,
    0x94118585,
    0xcf8a4545,
    0x10e9f9f9,
    0x06040202,
    0x81fe7f7f,
    0xf0a05050,
    0x44783c3c,
    0xba259f9f,
    0xe34ba8a8,
    0xf3a25151,
    0xfe5da3a3,
    0xc0804040,
    0x8a058f8f,
    0xad3f9292,
    0xbc219d9d,
    0x48703838,
    0x04f1f5f5,
    0xdf63bcbc,
    0xc177b6b6,
    0x75afdada,
    0x63422121,
    0x30201010,
    0x1ae5ffff,
    0x0efdf3f3,
    0x6dbfd2d2,
    0x4c81cdcd,
    0x14180c0c,
    0x35261313,
    0x2fc3ecec,
    0xe1be5f5f,
    0xa2359797,
    0xcc884444,
    0x392e1717,
    0x5793c4c4,
    0xf255a7a7,
    0x82fc7e7e,
    0x477a3d3d,
    0xacc86464,
    0xe7ba5d5d,
    0x2b321919,
    0x95e67373,
    0xa0c06060,
    0x98198181,
    0xd19e4f4f,
    0x7fa3dcdc,
    0x66442222,
    0x7e542a2a,
    0xab3b9090,
    0x830b8888,
    0xca8c4646,
    0x29c7eeee,
    0xd36bb8b8,
    0x3c281414,
    0x79a7dede,
    0xe2bc5e5e,
    0x1d160b0b,
    0x76addbdb,
    0x3bdbe0e0,
    0x56643232,
    0x4e743a3a,
    0x1e140a0a,
    0xdb924949,
    0x0a0c0606,
    0x6c482424,
    0xe4b85c5c,
    0x5d9fc2c2,
    0x6ebdd3d3,
    0xef43acac,
    0xa6c46262,
    0xa8399191,
    0xa4319595,
    0x37d3e4e4,
    0x8bf27979,
    0x32d5e7e7,
    0x438bc8c8,
    0x596e3737,
    0xb7da6d6d,
    0x8c018d8d,
    0x64b1d5d5,
    0xd29c4e4e,
    0xe049a9a9,
    0xb4d86c6c,
    0xfaac5656,
    0x07f3f4f4,
    0x25cfeaea,
    0xafca6565,
    0x8ef47a7a,
    0xe947aeae,
    0x18100808,
    0xd56fbaba,
    0x88f07878,
    0x6f4a2525,
    0x725c2e2e,
    0x24381c1c,
    0xf157a6a6,
    0xc773b4b4,
    0x5197c6c6,
    0x23cbe8e8,
    0x7ca1dddd,
    0x9ce87474,
    0x213e1f1f,
    0xdd964b4b,
    0xdc61bdbd,
    0x860d8b8b,
    0x850f8a8a,
    0x90e07070,
    0x427c3e3e,
    0xc471b5b5,
    0xaacc6666,
    0xd8904848,
    0x05060303,
    0x01f7f6f6,
    0x121c0e0e,
    0xa3c26161,
    0x5f6a3535,
    0xf9ae5757,
    0xd069b9b9,
    0x91178686,
    0x5899c1c1,
    0x273a1d1d,
    0xb9279e9e,
    0x38d9e1e1,
    0x13ebf8f8,
    0xb32b9898,
    0x33221111,
    0xbbd26969,
    0x70a9d9d9,
    0x89078e8e,
    0xa7339494,
    0xb62d9b9b,
    0x223c1e1e,
    0x92158787,
    0x20c9e9e9,
    0x4987cece,
    0xffaa5555,
    0x78502828,
    0x7aa5dfdf,
    0x8f038c8c,
    0xf859a1a1,
    0x80098989,
    0x171a0d0d,
    0xda65bfbf,
    0x31d7e6e6,
    0xc6844242,
    0xb8d06868,
    0xc3824141,
    0xb0299999,
    0x775a2d2d,
    0x111e0f0f,
    0xcb7bb0b0,
    0xfca85454,
    0xd66dbbbb,
    0x3a2c1616
];
const $6d51fc1d1af75bc0$var$T3 = [
    0x63a5c663,
    0x7c84f87c,
    0x7799ee77,
    0x7b8df67b,
    0xf20dfff2,
    0x6bbdd66b,
    0x6fb1de6f,
    0xc55491c5,
    0x30506030,
    0x01030201,
    0x67a9ce67,
    0x2b7d562b,
    0xfe19e7fe,
    0xd762b5d7,
    0xabe64dab,
    0x769aec76,
    0xca458fca,
    0x829d1f82,
    0xc94089c9,
    0x7d87fa7d,
    0xfa15effa,
    0x59ebb259,
    0x47c98e47,
    0xf00bfbf0,
    0xadec41ad,
    0xd467b3d4,
    0xa2fd5fa2,
    0xafea45af,
    0x9cbf239c,
    0xa4f753a4,
    0x7296e472,
    0xc05b9bc0,
    0xb7c275b7,
    0xfd1ce1fd,
    0x93ae3d93,
    0x266a4c26,
    0x365a6c36,
    0x3f417e3f,
    0xf702f5f7,
    0xcc4f83cc,
    0x345c6834,
    0xa5f451a5,
    0xe534d1e5,
    0xf108f9f1,
    0x7193e271,
    0xd873abd8,
    0x31536231,
    0x153f2a15,
    0x040c0804,
    0xc75295c7,
    0x23654623,
    0xc35e9dc3,
    0x18283018,
    0x96a13796,
    0x050f0a05,
    0x9ab52f9a,
    0x07090e07,
    0x12362412,
    0x809b1b80,
    0xe23ddfe2,
    0xeb26cdeb,
    0x27694e27,
    0xb2cd7fb2,
    0x759fea75,
    0x091b1209,
    0x839e1d83,
    0x2c74582c,
    0x1a2e341a,
    0x1b2d361b,
    0x6eb2dc6e,
    0x5aeeb45a,
    0xa0fb5ba0,
    0x52f6a452,
    0x3b4d763b,
    0xd661b7d6,
    0xb3ce7db3,
    0x297b5229,
    0xe33edde3,
    0x2f715e2f,
    0x84971384,
    0x53f5a653,
    0xd168b9d1,
    0x00000000,
    0xed2cc1ed,
    0x20604020,
    0xfc1fe3fc,
    0xb1c879b1,
    0x5bedb65b,
    0x6abed46a,
    0xcb468dcb,
    0xbed967be,
    0x394b7239,
    0x4ade944a,
    0x4cd4984c,
    0x58e8b058,
    0xcf4a85cf,
    0xd06bbbd0,
    0xef2ac5ef,
    0xaae54faa,
    0xfb16edfb,
    0x43c58643,
    0x4dd79a4d,
    0x33556633,
    0x85941185,
    0x45cf8a45,
    0xf910e9f9,
    0x02060402,
    0x7f81fe7f,
    0x50f0a050,
    0x3c44783c,
    0x9fba259f,
    0xa8e34ba8,
    0x51f3a251,
    0xa3fe5da3,
    0x40c08040,
    0x8f8a058f,
    0x92ad3f92,
    0x9dbc219d,
    0x38487038,
    0xf504f1f5,
    0xbcdf63bc,
    0xb6c177b6,
    0xda75afda,
    0x21634221,
    0x10302010,
    0xff1ae5ff,
    0xf30efdf3,
    0xd26dbfd2,
    0xcd4c81cd,
    0x0c14180c,
    0x13352613,
    0xec2fc3ec,
    0x5fe1be5f,
    0x97a23597,
    0x44cc8844,
    0x17392e17,
    0xc45793c4,
    0xa7f255a7,
    0x7e82fc7e,
    0x3d477a3d,
    0x64acc864,
    0x5de7ba5d,
    0x192b3219,
    0x7395e673,
    0x60a0c060,
    0x81981981,
    0x4fd19e4f,
    0xdc7fa3dc,
    0x22664422,
    0x2a7e542a,
    0x90ab3b90,
    0x88830b88,
    0x46ca8c46,
    0xee29c7ee,
    0xb8d36bb8,
    0x143c2814,
    0xde79a7de,
    0x5ee2bc5e,
    0x0b1d160b,
    0xdb76addb,
    0xe03bdbe0,
    0x32566432,
    0x3a4e743a,
    0x0a1e140a,
    0x49db9249,
    0x060a0c06,
    0x246c4824,
    0x5ce4b85c,
    0xc25d9fc2,
    0xd36ebdd3,
    0xacef43ac,
    0x62a6c462,
    0x91a83991,
    0x95a43195,
    0xe437d3e4,
    0x798bf279,
    0xe732d5e7,
    0xc8438bc8,
    0x37596e37,
    0x6db7da6d,
    0x8d8c018d,
    0xd564b1d5,
    0x4ed29c4e,
    0xa9e049a9,
    0x6cb4d86c,
    0x56faac56,
    0xf407f3f4,
    0xea25cfea,
    0x65afca65,
    0x7a8ef47a,
    0xaee947ae,
    0x08181008,
    0xbad56fba,
    0x7888f078,
    0x256f4a25,
    0x2e725c2e,
    0x1c24381c,
    0xa6f157a6,
    0xb4c773b4,
    0xc65197c6,
    0xe823cbe8,
    0xdd7ca1dd,
    0x749ce874,
    0x1f213e1f,
    0x4bdd964b,
    0xbddc61bd,
    0x8b860d8b,
    0x8a850f8a,
    0x7090e070,
    0x3e427c3e,
    0xb5c471b5,
    0x66aacc66,
    0x48d89048,
    0x03050603,
    0xf601f7f6,
    0x0e121c0e,
    0x61a3c261,
    0x355f6a35,
    0x57f9ae57,
    0xb9d069b9,
    0x86911786,
    0xc15899c1,
    0x1d273a1d,
    0x9eb9279e,
    0xe138d9e1,
    0xf813ebf8,
    0x98b32b98,
    0x11332211,
    0x69bbd269,
    0xd970a9d9,
    0x8e89078e,
    0x94a73394,
    0x9bb62d9b,
    0x1e223c1e,
    0x87921587,
    0xe920c9e9,
    0xce4987ce,
    0x55ffaa55,
    0x28785028,
    0xdf7aa5df,
    0x8c8f038c,
    0xa1f859a1,
    0x89800989,
    0x0d171a0d,
    0xbfda65bf,
    0xe631d7e6,
    0x42c68442,
    0x68b8d068,
    0x41c38241,
    0x99b02999,
    0x2d775a2d,
    0x0f111e0f,
    0xb0cb7bb0,
    0x54fca854,
    0xbbd66dbb,
    0x163a2c16
];
const $6d51fc1d1af75bc0$var$T4 = [
    0x6363a5c6,
    0x7c7c84f8,
    0x777799ee,
    0x7b7b8df6,
    0xf2f20dff,
    0x6b6bbdd6,
    0x6f6fb1de,
    0xc5c55491,
    0x30305060,
    0x01010302,
    0x6767a9ce,
    0x2b2b7d56,
    0xfefe19e7,
    0xd7d762b5,
    0xababe64d,
    0x76769aec,
    0xcaca458f,
    0x82829d1f,
    0xc9c94089,
    0x7d7d87fa,
    0xfafa15ef,
    0x5959ebb2,
    0x4747c98e,
    0xf0f00bfb,
    0xadadec41,
    0xd4d467b3,
    0xa2a2fd5f,
    0xafafea45,
    0x9c9cbf23,
    0xa4a4f753,
    0x727296e4,
    0xc0c05b9b,
    0xb7b7c275,
    0xfdfd1ce1,
    0x9393ae3d,
    0x26266a4c,
    0x36365a6c,
    0x3f3f417e,
    0xf7f702f5,
    0xcccc4f83,
    0x34345c68,
    0xa5a5f451,
    0xe5e534d1,
    0xf1f108f9,
    0x717193e2,
    0xd8d873ab,
    0x31315362,
    0x15153f2a,
    0x04040c08,
    0xc7c75295,
    0x23236546,
    0xc3c35e9d,
    0x18182830,
    0x9696a137,
    0x05050f0a,
    0x9a9ab52f,
    0x0707090e,
    0x12123624,
    0x80809b1b,
    0xe2e23ddf,
    0xebeb26cd,
    0x2727694e,
    0xb2b2cd7f,
    0x75759fea,
    0x09091b12,
    0x83839e1d,
    0x2c2c7458,
    0x1a1a2e34,
    0x1b1b2d36,
    0x6e6eb2dc,
    0x5a5aeeb4,
    0xa0a0fb5b,
    0x5252f6a4,
    0x3b3b4d76,
    0xd6d661b7,
    0xb3b3ce7d,
    0x29297b52,
    0xe3e33edd,
    0x2f2f715e,
    0x84849713,
    0x5353f5a6,
    0xd1d168b9,
    0x00000000,
    0xeded2cc1,
    0x20206040,
    0xfcfc1fe3,
    0xb1b1c879,
    0x5b5bedb6,
    0x6a6abed4,
    0xcbcb468d,
    0xbebed967,
    0x39394b72,
    0x4a4ade94,
    0x4c4cd498,
    0x5858e8b0,
    0xcfcf4a85,
    0xd0d06bbb,
    0xefef2ac5,
    0xaaaae54f,
    0xfbfb16ed,
    0x4343c586,
    0x4d4dd79a,
    0x33335566,
    0x85859411,
    0x4545cf8a,
    0xf9f910e9,
    0x02020604,
    0x7f7f81fe,
    0x5050f0a0,
    0x3c3c4478,
    0x9f9fba25,
    0xa8a8e34b,
    0x5151f3a2,
    0xa3a3fe5d,
    0x4040c080,
    0x8f8f8a05,
    0x9292ad3f,
    0x9d9dbc21,
    0x38384870,
    0xf5f504f1,
    0xbcbcdf63,
    0xb6b6c177,
    0xdada75af,
    0x21216342,
    0x10103020,
    0xffff1ae5,
    0xf3f30efd,
    0xd2d26dbf,
    0xcdcd4c81,
    0x0c0c1418,
    0x13133526,
    0xecec2fc3,
    0x5f5fe1be,
    0x9797a235,
    0x4444cc88,
    0x1717392e,
    0xc4c45793,
    0xa7a7f255,
    0x7e7e82fc,
    0x3d3d477a,
    0x6464acc8,
    0x5d5de7ba,
    0x19192b32,
    0x737395e6,
    0x6060a0c0,
    0x81819819,
    0x4f4fd19e,
    0xdcdc7fa3,
    0x22226644,
    0x2a2a7e54,
    0x9090ab3b,
    0x8888830b,
    0x4646ca8c,
    0xeeee29c7,
    0xb8b8d36b,
    0x14143c28,
    0xdede79a7,
    0x5e5ee2bc,
    0x0b0b1d16,
    0xdbdb76ad,
    0xe0e03bdb,
    0x32325664,
    0x3a3a4e74,
    0x0a0a1e14,
    0x4949db92,
    0x06060a0c,
    0x24246c48,
    0x5c5ce4b8,
    0xc2c25d9f,
    0xd3d36ebd,
    0xacacef43,
    0x6262a6c4,
    0x9191a839,
    0x9595a431,
    0xe4e437d3,
    0x79798bf2,
    0xe7e732d5,
    0xc8c8438b,
    0x3737596e,
    0x6d6db7da,
    0x8d8d8c01,
    0xd5d564b1,
    0x4e4ed29c,
    0xa9a9e049,
    0x6c6cb4d8,
    0x5656faac,
    0xf4f407f3,
    0xeaea25cf,
    0x6565afca,
    0x7a7a8ef4,
    0xaeaee947,
    0x08081810,
    0xbabad56f,
    0x787888f0,
    0x25256f4a,
    0x2e2e725c,
    0x1c1c2438,
    0xa6a6f157,
    0xb4b4c773,
    0xc6c65197,
    0xe8e823cb,
    0xdddd7ca1,
    0x74749ce8,
    0x1f1f213e,
    0x4b4bdd96,
    0xbdbddc61,
    0x8b8b860d,
    0x8a8a850f,
    0x707090e0,
    0x3e3e427c,
    0xb5b5c471,
    0x6666aacc,
    0x4848d890,
    0x03030506,
    0xf6f601f7,
    0x0e0e121c,
    0x6161a3c2,
    0x35355f6a,
    0x5757f9ae,
    0xb9b9d069,
    0x86869117,
    0xc1c15899,
    0x1d1d273a,
    0x9e9eb927,
    0xe1e138d9,
    0xf8f813eb,
    0x9898b32b,
    0x11113322,
    0x6969bbd2,
    0xd9d970a9,
    0x8e8e8907,
    0x9494a733,
    0x9b9bb62d,
    0x1e1e223c,
    0x87879215,
    0xe9e920c9,
    0xcece4987,
    0x5555ffaa,
    0x28287850,
    0xdfdf7aa5,
    0x8c8c8f03,
    0xa1a1f859,
    0x89898009,
    0x0d0d171a,
    0xbfbfda65,
    0xe6e631d7,
    0x4242c684,
    0x6868b8d0,
    0x4141c382,
    0x9999b029,
    0x2d2d775a,
    0x0f0f111e,
    0xb0b0cb7b,
    0x5454fca8,
    0xbbbbd66d,
    0x16163a2c
];
// Transformations for decryption
const $6d51fc1d1af75bc0$var$T5 = [
    0x51f4a750,
    0x7e416553,
    0x1a17a4c3,
    0x3a275e96,
    0x3bab6bcb,
    0x1f9d45f1,
    0xacfa58ab,
    0x4be30393,
    0x2030fa55,
    0xad766df6,
    0x88cc7691,
    0xf5024c25,
    0x4fe5d7fc,
    0xc52acbd7,
    0x26354480,
    0xb562a38f,
    0xdeb15a49,
    0x25ba1b67,
    0x45ea0e98,
    0x5dfec0e1,
    0xc32f7502,
    0x814cf012,
    0x8d4697a3,
    0x6bd3f9c6,
    0x038f5fe7,
    0x15929c95,
    0xbf6d7aeb,
    0x955259da,
    0xd4be832d,
    0x587421d3,
    0x49e06929,
    0x8ec9c844,
    0x75c2896a,
    0xf48e7978,
    0x99583e6b,
    0x27b971dd,
    0xbee14fb6,
    0xf088ad17,
    0xc920ac66,
    0x7dce3ab4,
    0x63df4a18,
    0xe51a3182,
    0x97513360,
    0x62537f45,
    0xb16477e0,
    0xbb6bae84,
    0xfe81a01c,
    0xf9082b94,
    0x70486858,
    0x8f45fd19,
    0x94de6c87,
    0x527bf8b7,
    0xab73d323,
    0x724b02e2,
    0xe31f8f57,
    0x6655ab2a,
    0xb2eb2807,
    0x2fb5c203,
    0x86c57b9a,
    0xd33708a5,
    0x302887f2,
    0x23bfa5b2,
    0x02036aba,
    0xed16825c,
    0x8acf1c2b,
    0xa779b492,
    0xf307f2f0,
    0x4e69e2a1,
    0x65daf4cd,
    0x0605bed5,
    0xd134621f,
    0xc4a6fe8a,
    0x342e539d,
    0xa2f355a0,
    0x058ae132,
    0xa4f6eb75,
    0x0b83ec39,
    0x4060efaa,
    0x5e719f06,
    0xbd6e1051,
    0x3e218af9,
    0x96dd063d,
    0xdd3e05ae,
    0x4de6bd46,
    0x91548db5,
    0x71c45d05,
    0x0406d46f,
    0x605015ff,
    0x1998fb24,
    0xd6bde997,
    0x894043cc,
    0x67d99e77,
    0xb0e842bd,
    0x07898b88,
    0xe7195b38,
    0x79c8eedb,
    0xa17c0a47,
    0x7c420fe9,
    0xf8841ec9,
    0x00000000,
    0x09808683,
    0x322bed48,
    0x1e1170ac,
    0x6c5a724e,
    0xfd0efffb,
    0x0f853856,
    0x3daed51e,
    0x362d3927,
    0x0a0fd964,
    0x685ca621,
    0x9b5b54d1,
    0x24362e3a,
    0x0c0a67b1,
    0x9357e70f,
    0xb4ee96d2,
    0x1b9b919e,
    0x80c0c54f,
    0x61dc20a2,
    0x5a774b69,
    0x1c121a16,
    0xe293ba0a,
    0xc0a02ae5,
    0x3c22e043,
    0x121b171d,
    0x0e090d0b,
    0xf28bc7ad,
    0x2db6a8b9,
    0x141ea9c8,
    0x57f11985,
    0xaf75074c,
    0xee99ddbb,
    0xa37f60fd,
    0xf701269f,
    0x5c72f5bc,
    0x44663bc5,
    0x5bfb7e34,
    0x8b432976,
    0xcb23c6dc,
    0xb6edfc68,
    0xb8e4f163,
    0xd731dcca,
    0x42638510,
    0x13972240,
    0x84c61120,
    0x854a247d,
    0xd2bb3df8,
    0xaef93211,
    0xc729a16d,
    0x1d9e2f4b,
    0xdcb230f3,
    0x0d8652ec,
    0x77c1e3d0,
    0x2bb3166c,
    0xa970b999,
    0x119448fa,
    0x47e96422,
    0xa8fc8cc4,
    0xa0f03f1a,
    0x567d2cd8,
    0x223390ef,
    0x87494ec7,
    0xd938d1c1,
    0x8ccaa2fe,
    0x98d40b36,
    0xa6f581cf,
    0xa57ade28,
    0xdab78e26,
    0x3fadbfa4,
    0x2c3a9de4,
    0x5078920d,
    0x6a5fcc9b,
    0x547e4662,
    0xf68d13c2,
    0x90d8b8e8,
    0x2e39f75e,
    0x82c3aff5,
    0x9f5d80be,
    0x69d0937c,
    0x6fd52da9,
    0xcf2512b3,
    0xc8ac993b,
    0x10187da7,
    0xe89c636e,
    0xdb3bbb7b,
    0xcd267809,
    0x6e5918f4,
    0xec9ab701,
    0x834f9aa8,
    0xe6956e65,
    0xaaffe67e,
    0x21bccf08,
    0xef15e8e6,
    0xbae79bd9,
    0x4a6f36ce,
    0xea9f09d4,
    0x29b07cd6,
    0x31a4b2af,
    0x2a3f2331,
    0xc6a59430,
    0x35a266c0,
    0x744ebc37,
    0xfc82caa6,
    0xe090d0b0,
    0x33a7d815,
    0xf104984a,
    0x41ecdaf7,
    0x7fcd500e,
    0x1791f62f,
    0x764dd68d,
    0x43efb04d,
    0xccaa4d54,
    0xe49604df,
    0x9ed1b5e3,
    0x4c6a881b,
    0xc12c1fb8,
    0x4665517f,
    0x9d5eea04,
    0x018c355d,
    0xfa877473,
    0xfb0b412e,
    0xb3671d5a,
    0x92dbd252,
    0xe9105633,
    0x6dd64713,
    0x9ad7618c,
    0x37a10c7a,
    0x59f8148e,
    0xeb133c89,
    0xcea927ee,
    0xb761c935,
    0xe11ce5ed,
    0x7a47b13c,
    0x9cd2df59,
    0x55f2733f,
    0x1814ce79,
    0x73c737bf,
    0x53f7cdea,
    0x5ffdaa5b,
    0xdf3d6f14,
    0x7844db86,
    0xcaaff381,
    0xb968c43e,
    0x3824342c,
    0xc2a3405f,
    0x161dc372,
    0xbce2250c,
    0x283c498b,
    0xff0d9541,
    0x39a80171,
    0x080cb3de,
    0xd8b4e49c,
    0x6456c190,
    0x7bcb8461,
    0xd532b670,
    0x486c5c74,
    0xd0b85742
];
const $6d51fc1d1af75bc0$var$T6 = [
    0x5051f4a7,
    0x537e4165,
    0xc31a17a4,
    0x963a275e,
    0xcb3bab6b,
    0xf11f9d45,
    0xabacfa58,
    0x934be303,
    0x552030fa,
    0xf6ad766d,
    0x9188cc76,
    0x25f5024c,
    0xfc4fe5d7,
    0xd7c52acb,
    0x80263544,
    0x8fb562a3,
    0x49deb15a,
    0x6725ba1b,
    0x9845ea0e,
    0xe15dfec0,
    0x02c32f75,
    0x12814cf0,
    0xa38d4697,
    0xc66bd3f9,
    0xe7038f5f,
    0x9515929c,
    0xebbf6d7a,
    0xda955259,
    0x2dd4be83,
    0xd3587421,
    0x2949e069,
    0x448ec9c8,
    0x6a75c289,
    0x78f48e79,
    0x6b99583e,
    0xdd27b971,
    0xb6bee14f,
    0x17f088ad,
    0x66c920ac,
    0xb47dce3a,
    0x1863df4a,
    0x82e51a31,
    0x60975133,
    0x4562537f,
    0xe0b16477,
    0x84bb6bae,
    0x1cfe81a0,
    0x94f9082b,
    0x58704868,
    0x198f45fd,
    0x8794de6c,
    0xb7527bf8,
    0x23ab73d3,
    0xe2724b02,
    0x57e31f8f,
    0x2a6655ab,
    0x07b2eb28,
    0x032fb5c2,
    0x9a86c57b,
    0xa5d33708,
    0xf2302887,
    0xb223bfa5,
    0xba02036a,
    0x5ced1682,
    0x2b8acf1c,
    0x92a779b4,
    0xf0f307f2,
    0xa14e69e2,
    0xcd65daf4,
    0xd50605be,
    0x1fd13462,
    0x8ac4a6fe,
    0x9d342e53,
    0xa0a2f355,
    0x32058ae1,
    0x75a4f6eb,
    0x390b83ec,
    0xaa4060ef,
    0x065e719f,
    0x51bd6e10,
    0xf93e218a,
    0x3d96dd06,
    0xaedd3e05,
    0x464de6bd,
    0xb591548d,
    0x0571c45d,
    0x6f0406d4,
    0xff605015,
    0x241998fb,
    0x97d6bde9,
    0xcc894043,
    0x7767d99e,
    0xbdb0e842,
    0x8807898b,
    0x38e7195b,
    0xdb79c8ee,
    0x47a17c0a,
    0xe97c420f,
    0xc9f8841e,
    0x00000000,
    0x83098086,
    0x48322bed,
    0xac1e1170,
    0x4e6c5a72,
    0xfbfd0eff,
    0x560f8538,
    0x1e3daed5,
    0x27362d39,
    0x640a0fd9,
    0x21685ca6,
    0xd19b5b54,
    0x3a24362e,
    0xb10c0a67,
    0x0f9357e7,
    0xd2b4ee96,
    0x9e1b9b91,
    0x4f80c0c5,
    0xa261dc20,
    0x695a774b,
    0x161c121a,
    0x0ae293ba,
    0xe5c0a02a,
    0x433c22e0,
    0x1d121b17,
    0x0b0e090d,
    0xadf28bc7,
    0xb92db6a8,
    0xc8141ea9,
    0x8557f119,
    0x4caf7507,
    0xbbee99dd,
    0xfda37f60,
    0x9ff70126,
    0xbc5c72f5,
    0xc544663b,
    0x345bfb7e,
    0x768b4329,
    0xdccb23c6,
    0x68b6edfc,
    0x63b8e4f1,
    0xcad731dc,
    0x10426385,
    0x40139722,
    0x2084c611,
    0x7d854a24,
    0xf8d2bb3d,
    0x11aef932,
    0x6dc729a1,
    0x4b1d9e2f,
    0xf3dcb230,
    0xec0d8652,
    0xd077c1e3,
    0x6c2bb316,
    0x99a970b9,
    0xfa119448,
    0x2247e964,
    0xc4a8fc8c,
    0x1aa0f03f,
    0xd8567d2c,
    0xef223390,
    0xc787494e,
    0xc1d938d1,
    0xfe8ccaa2,
    0x3698d40b,
    0xcfa6f581,
    0x28a57ade,
    0x26dab78e,
    0xa43fadbf,
    0xe42c3a9d,
    0x0d507892,
    0x9b6a5fcc,
    0x62547e46,
    0xc2f68d13,
    0xe890d8b8,
    0x5e2e39f7,
    0xf582c3af,
    0xbe9f5d80,
    0x7c69d093,
    0xa96fd52d,
    0xb3cf2512,
    0x3bc8ac99,
    0xa710187d,
    0x6ee89c63,
    0x7bdb3bbb,
    0x09cd2678,
    0xf46e5918,
    0x01ec9ab7,
    0xa8834f9a,
    0x65e6956e,
    0x7eaaffe6,
    0x0821bccf,
    0xe6ef15e8,
    0xd9bae79b,
    0xce4a6f36,
    0xd4ea9f09,
    0xd629b07c,
    0xaf31a4b2,
    0x312a3f23,
    0x30c6a594,
    0xc035a266,
    0x37744ebc,
    0xa6fc82ca,
    0xb0e090d0,
    0x1533a7d8,
    0x4af10498,
    0xf741ecda,
    0x0e7fcd50,
    0x2f1791f6,
    0x8d764dd6,
    0x4d43efb0,
    0x54ccaa4d,
    0xdfe49604,
    0xe39ed1b5,
    0x1b4c6a88,
    0xb8c12c1f,
    0x7f466551,
    0x049d5eea,
    0x5d018c35,
    0x73fa8774,
    0x2efb0b41,
    0x5ab3671d,
    0x5292dbd2,
    0x33e91056,
    0x136dd647,
    0x8c9ad761,
    0x7a37a10c,
    0x8e59f814,
    0x89eb133c,
    0xeecea927,
    0x35b761c9,
    0xede11ce5,
    0x3c7a47b1,
    0x599cd2df,
    0x3f55f273,
    0x791814ce,
    0xbf73c737,
    0xea53f7cd,
    0x5b5ffdaa,
    0x14df3d6f,
    0x867844db,
    0x81caaff3,
    0x3eb968c4,
    0x2c382434,
    0x5fc2a340,
    0x72161dc3,
    0x0cbce225,
    0x8b283c49,
    0x41ff0d95,
    0x7139a801,
    0xde080cb3,
    0x9cd8b4e4,
    0x906456c1,
    0x617bcb84,
    0x70d532b6,
    0x74486c5c,
    0x42d0b857
];
const $6d51fc1d1af75bc0$var$T7 = [
    0xa75051f4,
    0x65537e41,
    0xa4c31a17,
    0x5e963a27,
    0x6bcb3bab,
    0x45f11f9d,
    0x58abacfa,
    0x03934be3,
    0xfa552030,
    0x6df6ad76,
    0x769188cc,
    0x4c25f502,
    0xd7fc4fe5,
    0xcbd7c52a,
    0x44802635,
    0xa38fb562,
    0x5a49deb1,
    0x1b6725ba,
    0x0e9845ea,
    0xc0e15dfe,
    0x7502c32f,
    0xf012814c,
    0x97a38d46,
    0xf9c66bd3,
    0x5fe7038f,
    0x9c951592,
    0x7aebbf6d,
    0x59da9552,
    0x832dd4be,
    0x21d35874,
    0x692949e0,
    0xc8448ec9,
    0x896a75c2,
    0x7978f48e,
    0x3e6b9958,
    0x71dd27b9,
    0x4fb6bee1,
    0xad17f088,
    0xac66c920,
    0x3ab47dce,
    0x4a1863df,
    0x3182e51a,
    0x33609751,
    0x7f456253,
    0x77e0b164,
    0xae84bb6b,
    0xa01cfe81,
    0x2b94f908,
    0x68587048,
    0xfd198f45,
    0x6c8794de,
    0xf8b7527b,
    0xd323ab73,
    0x02e2724b,
    0x8f57e31f,
    0xab2a6655,
    0x2807b2eb,
    0xc2032fb5,
    0x7b9a86c5,
    0x08a5d337,
    0x87f23028,
    0xa5b223bf,
    0x6aba0203,
    0x825ced16,
    0x1c2b8acf,
    0xb492a779,
    0xf2f0f307,
    0xe2a14e69,
    0xf4cd65da,
    0xbed50605,
    0x621fd134,
    0xfe8ac4a6,
    0x539d342e,
    0x55a0a2f3,
    0xe132058a,
    0xeb75a4f6,
    0xec390b83,
    0xefaa4060,
    0x9f065e71,
    0x1051bd6e,
    0x8af93e21,
    0x063d96dd,
    0x05aedd3e,
    0xbd464de6,
    0x8db59154,
    0x5d0571c4,
    0xd46f0406,
    0x15ff6050,
    0xfb241998,
    0xe997d6bd,
    0x43cc8940,
    0x9e7767d9,
    0x42bdb0e8,
    0x8b880789,
    0x5b38e719,
    0xeedb79c8,
    0x0a47a17c,
    0x0fe97c42,
    0x1ec9f884,
    0x00000000,
    0x86830980,
    0xed48322b,
    0x70ac1e11,
    0x724e6c5a,
    0xfffbfd0e,
    0x38560f85,
    0xd51e3dae,
    0x3927362d,
    0xd9640a0f,
    0xa621685c,
    0x54d19b5b,
    0x2e3a2436,
    0x67b10c0a,
    0xe70f9357,
    0x96d2b4ee,
    0x919e1b9b,
    0xc54f80c0,
    0x20a261dc,
    0x4b695a77,
    0x1a161c12,
    0xba0ae293,
    0x2ae5c0a0,
    0xe0433c22,
    0x171d121b,
    0x0d0b0e09,
    0xc7adf28b,
    0xa8b92db6,
    0xa9c8141e,
    0x198557f1,
    0x074caf75,
    0xddbbee99,
    0x60fda37f,
    0x269ff701,
    0xf5bc5c72,
    0x3bc54466,
    0x7e345bfb,
    0x29768b43,
    0xc6dccb23,
    0xfc68b6ed,
    0xf163b8e4,
    0xdccad731,
    0x85104263,
    0x22401397,
    0x112084c6,
    0x247d854a,
    0x3df8d2bb,
    0x3211aef9,
    0xa16dc729,
    0x2f4b1d9e,
    0x30f3dcb2,
    0x52ec0d86,
    0xe3d077c1,
    0x166c2bb3,
    0xb999a970,
    0x48fa1194,
    0x642247e9,
    0x8cc4a8fc,
    0x3f1aa0f0,
    0x2cd8567d,
    0x90ef2233,
    0x4ec78749,
    0xd1c1d938,
    0xa2fe8cca,
    0x0b3698d4,
    0x81cfa6f5,
    0xde28a57a,
    0x8e26dab7,
    0xbfa43fad,
    0x9de42c3a,
    0x920d5078,
    0xcc9b6a5f,
    0x4662547e,
    0x13c2f68d,
    0xb8e890d8,
    0xf75e2e39,
    0xaff582c3,
    0x80be9f5d,
    0x937c69d0,
    0x2da96fd5,
    0x12b3cf25,
    0x993bc8ac,
    0x7da71018,
    0x636ee89c,
    0xbb7bdb3b,
    0x7809cd26,
    0x18f46e59,
    0xb701ec9a,
    0x9aa8834f,
    0x6e65e695,
    0xe67eaaff,
    0xcf0821bc,
    0xe8e6ef15,
    0x9bd9bae7,
    0x36ce4a6f,
    0x09d4ea9f,
    0x7cd629b0,
    0xb2af31a4,
    0x23312a3f,
    0x9430c6a5,
    0x66c035a2,
    0xbc37744e,
    0xcaa6fc82,
    0xd0b0e090,
    0xd81533a7,
    0x984af104,
    0xdaf741ec,
    0x500e7fcd,
    0xf62f1791,
    0xd68d764d,
    0xb04d43ef,
    0x4d54ccaa,
    0x04dfe496,
    0xb5e39ed1,
    0x881b4c6a,
    0x1fb8c12c,
    0x517f4665,
    0xea049d5e,
    0x355d018c,
    0x7473fa87,
    0x412efb0b,
    0x1d5ab367,
    0xd25292db,
    0x5633e910,
    0x47136dd6,
    0x618c9ad7,
    0x0c7a37a1,
    0x148e59f8,
    0x3c89eb13,
    0x27eecea9,
    0xc935b761,
    0xe5ede11c,
    0xb13c7a47,
    0xdf599cd2,
    0x733f55f2,
    0xce791814,
    0x37bf73c7,
    0xcdea53f7,
    0xaa5b5ffd,
    0x6f14df3d,
    0xdb867844,
    0xf381caaf,
    0xc43eb968,
    0x342c3824,
    0x405fc2a3,
    0xc372161d,
    0x250cbce2,
    0x498b283c,
    0x9541ff0d,
    0x017139a8,
    0xb3de080c,
    0xe49cd8b4,
    0xc1906456,
    0x84617bcb,
    0xb670d532,
    0x5c74486c,
    0x5742d0b8
];
const $6d51fc1d1af75bc0$var$T8 = [
    0xf4a75051,
    0x4165537e,
    0x17a4c31a,
    0x275e963a,
    0xab6bcb3b,
    0x9d45f11f,
    0xfa58abac,
    0xe303934b,
    0x30fa5520,
    0x766df6ad,
    0xcc769188,
    0x024c25f5,
    0xe5d7fc4f,
    0x2acbd7c5,
    0x35448026,
    0x62a38fb5,
    0xb15a49de,
    0xba1b6725,
    0xea0e9845,
    0xfec0e15d,
    0x2f7502c3,
    0x4cf01281,
    0x4697a38d,
    0xd3f9c66b,
    0x8f5fe703,
    0x929c9515,
    0x6d7aebbf,
    0x5259da95,
    0xbe832dd4,
    0x7421d358,
    0xe0692949,
    0xc9c8448e,
    0xc2896a75,
    0x8e7978f4,
    0x583e6b99,
    0xb971dd27,
    0xe14fb6be,
    0x88ad17f0,
    0x20ac66c9,
    0xce3ab47d,
    0xdf4a1863,
    0x1a3182e5,
    0x51336097,
    0x537f4562,
    0x6477e0b1,
    0x6bae84bb,
    0x81a01cfe,
    0x082b94f9,
    0x48685870,
    0x45fd198f,
    0xde6c8794,
    0x7bf8b752,
    0x73d323ab,
    0x4b02e272,
    0x1f8f57e3,
    0x55ab2a66,
    0xeb2807b2,
    0xb5c2032f,
    0xc57b9a86,
    0x3708a5d3,
    0x2887f230,
    0xbfa5b223,
    0x036aba02,
    0x16825ced,
    0xcf1c2b8a,
    0x79b492a7,
    0x07f2f0f3,
    0x69e2a14e,
    0xdaf4cd65,
    0x05bed506,
    0x34621fd1,
    0xa6fe8ac4,
    0x2e539d34,
    0xf355a0a2,
    0x8ae13205,
    0xf6eb75a4,
    0x83ec390b,
    0x60efaa40,
    0x719f065e,
    0x6e1051bd,
    0x218af93e,
    0xdd063d96,
    0x3e05aedd,
    0xe6bd464d,
    0x548db591,
    0xc45d0571,
    0x06d46f04,
    0x5015ff60,
    0x98fb2419,
    0xbde997d6,
    0x4043cc89,
    0xd99e7767,
    0xe842bdb0,
    0x898b8807,
    0x195b38e7,
    0xc8eedb79,
    0x7c0a47a1,
    0x420fe97c,
    0x841ec9f8,
    0x00000000,
    0x80868309,
    0x2bed4832,
    0x1170ac1e,
    0x5a724e6c,
    0x0efffbfd,
    0x8538560f,
    0xaed51e3d,
    0x2d392736,
    0x0fd9640a,
    0x5ca62168,
    0x5b54d19b,
    0x362e3a24,
    0x0a67b10c,
    0x57e70f93,
    0xee96d2b4,
    0x9b919e1b,
    0xc0c54f80,
    0xdc20a261,
    0x774b695a,
    0x121a161c,
    0x93ba0ae2,
    0xa02ae5c0,
    0x22e0433c,
    0x1b171d12,
    0x090d0b0e,
    0x8bc7adf2,
    0xb6a8b92d,
    0x1ea9c814,
    0xf1198557,
    0x75074caf,
    0x99ddbbee,
    0x7f60fda3,
    0x01269ff7,
    0x72f5bc5c,
    0x663bc544,
    0xfb7e345b,
    0x4329768b,
    0x23c6dccb,
    0xedfc68b6,
    0xe4f163b8,
    0x31dccad7,
    0x63851042,
    0x97224013,
    0xc6112084,
    0x4a247d85,
    0xbb3df8d2,
    0xf93211ae,
    0x29a16dc7,
    0x9e2f4b1d,
    0xb230f3dc,
    0x8652ec0d,
    0xc1e3d077,
    0xb3166c2b,
    0x70b999a9,
    0x9448fa11,
    0xe9642247,
    0xfc8cc4a8,
    0xf03f1aa0,
    0x7d2cd856,
    0x3390ef22,
    0x494ec787,
    0x38d1c1d9,
    0xcaa2fe8c,
    0xd40b3698,
    0xf581cfa6,
    0x7ade28a5,
    0xb78e26da,
    0xadbfa43f,
    0x3a9de42c,
    0x78920d50,
    0x5fcc9b6a,
    0x7e466254,
    0x8d13c2f6,
    0xd8b8e890,
    0x39f75e2e,
    0xc3aff582,
    0x5d80be9f,
    0xd0937c69,
    0xd52da96f,
    0x2512b3cf,
    0xac993bc8,
    0x187da710,
    0x9c636ee8,
    0x3bbb7bdb,
    0x267809cd,
    0x5918f46e,
    0x9ab701ec,
    0x4f9aa883,
    0x956e65e6,
    0xffe67eaa,
    0xbccf0821,
    0x15e8e6ef,
    0xe79bd9ba,
    0x6f36ce4a,
    0x9f09d4ea,
    0xb07cd629,
    0xa4b2af31,
    0x3f23312a,
    0xa59430c6,
    0xa266c035,
    0x4ebc3774,
    0x82caa6fc,
    0x90d0b0e0,
    0xa7d81533,
    0x04984af1,
    0xecdaf741,
    0xcd500e7f,
    0x91f62f17,
    0x4dd68d76,
    0xefb04d43,
    0xaa4d54cc,
    0x9604dfe4,
    0xd1b5e39e,
    0x6a881b4c,
    0x2c1fb8c1,
    0x65517f46,
    0x5eea049d,
    0x8c355d01,
    0x877473fa,
    0x0b412efb,
    0x671d5ab3,
    0xdbd25292,
    0x105633e9,
    0xd647136d,
    0xd7618c9a,
    0xa10c7a37,
    0xf8148e59,
    0x133c89eb,
    0xa927eece,
    0x61c935b7,
    0x1ce5ede1,
    0x47b13c7a,
    0xd2df599c,
    0xf2733f55,
    0x14ce7918,
    0xc737bf73,
    0xf7cdea53,
    0xfdaa5b5f,
    0x3d6f14df,
    0x44db8678,
    0xaff381ca,
    0x68c43eb9,
    0x24342c38,
    0xa3405fc2,
    0x1dc37216,
    0xe2250cbc,
    0x3c498b28,
    0x0d9541ff,
    0xa8017139,
    0x0cb3de08,
    0xb4e49cd8,
    0x56c19064,
    0xcb84617b,
    0x32b670d5,
    0x6c5c7448,
    0xb85742d0
];
// Transformations for decryption key expansion
const $6d51fc1d1af75bc0$var$U1 = [
    0x00000000,
    0x0e090d0b,
    0x1c121a16,
    0x121b171d,
    0x3824342c,
    0x362d3927,
    0x24362e3a,
    0x2a3f2331,
    0x70486858,
    0x7e416553,
    0x6c5a724e,
    0x62537f45,
    0x486c5c74,
    0x4665517f,
    0x547e4662,
    0x5a774b69,
    0xe090d0b0,
    0xee99ddbb,
    0xfc82caa6,
    0xf28bc7ad,
    0xd8b4e49c,
    0xd6bde997,
    0xc4a6fe8a,
    0xcaaff381,
    0x90d8b8e8,
    0x9ed1b5e3,
    0x8ccaa2fe,
    0x82c3aff5,
    0xa8fc8cc4,
    0xa6f581cf,
    0xb4ee96d2,
    0xbae79bd9,
    0xdb3bbb7b,
    0xd532b670,
    0xc729a16d,
    0xc920ac66,
    0xe31f8f57,
    0xed16825c,
    0xff0d9541,
    0xf104984a,
    0xab73d323,
    0xa57ade28,
    0xb761c935,
    0xb968c43e,
    0x9357e70f,
    0x9d5eea04,
    0x8f45fd19,
    0x814cf012,
    0x3bab6bcb,
    0x35a266c0,
    0x27b971dd,
    0x29b07cd6,
    0x038f5fe7,
    0x0d8652ec,
    0x1f9d45f1,
    0x119448fa,
    0x4be30393,
    0x45ea0e98,
    0x57f11985,
    0x59f8148e,
    0x73c737bf,
    0x7dce3ab4,
    0x6fd52da9,
    0x61dc20a2,
    0xad766df6,
    0xa37f60fd,
    0xb16477e0,
    0xbf6d7aeb,
    0x955259da,
    0x9b5b54d1,
    0x894043cc,
    0x87494ec7,
    0xdd3e05ae,
    0xd33708a5,
    0xc12c1fb8,
    0xcf2512b3,
    0xe51a3182,
    0xeb133c89,
    0xf9082b94,
    0xf701269f,
    0x4de6bd46,
    0x43efb04d,
    0x51f4a750,
    0x5ffdaa5b,
    0x75c2896a,
    0x7bcb8461,
    0x69d0937c,
    0x67d99e77,
    0x3daed51e,
    0x33a7d815,
    0x21bccf08,
    0x2fb5c203,
    0x058ae132,
    0x0b83ec39,
    0x1998fb24,
    0x1791f62f,
    0x764dd68d,
    0x7844db86,
    0x6a5fcc9b,
    0x6456c190,
    0x4e69e2a1,
    0x4060efaa,
    0x527bf8b7,
    0x5c72f5bc,
    0x0605bed5,
    0x080cb3de,
    0x1a17a4c3,
    0x141ea9c8,
    0x3e218af9,
    0x302887f2,
    0x223390ef,
    0x2c3a9de4,
    0x96dd063d,
    0x98d40b36,
    0x8acf1c2b,
    0x84c61120,
    0xaef93211,
    0xa0f03f1a,
    0xb2eb2807,
    0xbce2250c,
    0xe6956e65,
    0xe89c636e,
    0xfa877473,
    0xf48e7978,
    0xdeb15a49,
    0xd0b85742,
    0xc2a3405f,
    0xccaa4d54,
    0x41ecdaf7,
    0x4fe5d7fc,
    0x5dfec0e1,
    0x53f7cdea,
    0x79c8eedb,
    0x77c1e3d0,
    0x65daf4cd,
    0x6bd3f9c6,
    0x31a4b2af,
    0x3fadbfa4,
    0x2db6a8b9,
    0x23bfa5b2,
    0x09808683,
    0x07898b88,
    0x15929c95,
    0x1b9b919e,
    0xa17c0a47,
    0xaf75074c,
    0xbd6e1051,
    0xb3671d5a,
    0x99583e6b,
    0x97513360,
    0x854a247d,
    0x8b432976,
    0xd134621f,
    0xdf3d6f14,
    0xcd267809,
    0xc32f7502,
    0xe9105633,
    0xe7195b38,
    0xf5024c25,
    0xfb0b412e,
    0x9ad7618c,
    0x94de6c87,
    0x86c57b9a,
    0x88cc7691,
    0xa2f355a0,
    0xacfa58ab,
    0xbee14fb6,
    0xb0e842bd,
    0xea9f09d4,
    0xe49604df,
    0xf68d13c2,
    0xf8841ec9,
    0xd2bb3df8,
    0xdcb230f3,
    0xcea927ee,
    0xc0a02ae5,
    0x7a47b13c,
    0x744ebc37,
    0x6655ab2a,
    0x685ca621,
    0x42638510,
    0x4c6a881b,
    0x5e719f06,
    0x5078920d,
    0x0a0fd964,
    0x0406d46f,
    0x161dc372,
    0x1814ce79,
    0x322bed48,
    0x3c22e043,
    0x2e39f75e,
    0x2030fa55,
    0xec9ab701,
    0xe293ba0a,
    0xf088ad17,
    0xfe81a01c,
    0xd4be832d,
    0xdab78e26,
    0xc8ac993b,
    0xc6a59430,
    0x9cd2df59,
    0x92dbd252,
    0x80c0c54f,
    0x8ec9c844,
    0xa4f6eb75,
    0xaaffe67e,
    0xb8e4f163,
    0xb6edfc68,
    0x0c0a67b1,
    0x02036aba,
    0x10187da7,
    0x1e1170ac,
    0x342e539d,
    0x3a275e96,
    0x283c498b,
    0x26354480,
    0x7c420fe9,
    0x724b02e2,
    0x605015ff,
    0x6e5918f4,
    0x44663bc5,
    0x4a6f36ce,
    0x587421d3,
    0x567d2cd8,
    0x37a10c7a,
    0x39a80171,
    0x2bb3166c,
    0x25ba1b67,
    0x0f853856,
    0x018c355d,
    0x13972240,
    0x1d9e2f4b,
    0x47e96422,
    0x49e06929,
    0x5bfb7e34,
    0x55f2733f,
    0x7fcd500e,
    0x71c45d05,
    0x63df4a18,
    0x6dd64713,
    0xd731dcca,
    0xd938d1c1,
    0xcb23c6dc,
    0xc52acbd7,
    0xef15e8e6,
    0xe11ce5ed,
    0xf307f2f0,
    0xfd0efffb,
    0xa779b492,
    0xa970b999,
    0xbb6bae84,
    0xb562a38f,
    0x9f5d80be,
    0x91548db5,
    0x834f9aa8,
    0x8d4697a3
];
const $6d51fc1d1af75bc0$var$U2 = [
    0x00000000,
    0x0b0e090d,
    0x161c121a,
    0x1d121b17,
    0x2c382434,
    0x27362d39,
    0x3a24362e,
    0x312a3f23,
    0x58704868,
    0x537e4165,
    0x4e6c5a72,
    0x4562537f,
    0x74486c5c,
    0x7f466551,
    0x62547e46,
    0x695a774b,
    0xb0e090d0,
    0xbbee99dd,
    0xa6fc82ca,
    0xadf28bc7,
    0x9cd8b4e4,
    0x97d6bde9,
    0x8ac4a6fe,
    0x81caaff3,
    0xe890d8b8,
    0xe39ed1b5,
    0xfe8ccaa2,
    0xf582c3af,
    0xc4a8fc8c,
    0xcfa6f581,
    0xd2b4ee96,
    0xd9bae79b,
    0x7bdb3bbb,
    0x70d532b6,
    0x6dc729a1,
    0x66c920ac,
    0x57e31f8f,
    0x5ced1682,
    0x41ff0d95,
    0x4af10498,
    0x23ab73d3,
    0x28a57ade,
    0x35b761c9,
    0x3eb968c4,
    0x0f9357e7,
    0x049d5eea,
    0x198f45fd,
    0x12814cf0,
    0xcb3bab6b,
    0xc035a266,
    0xdd27b971,
    0xd629b07c,
    0xe7038f5f,
    0xec0d8652,
    0xf11f9d45,
    0xfa119448,
    0x934be303,
    0x9845ea0e,
    0x8557f119,
    0x8e59f814,
    0xbf73c737,
    0xb47dce3a,
    0xa96fd52d,
    0xa261dc20,
    0xf6ad766d,
    0xfda37f60,
    0xe0b16477,
    0xebbf6d7a,
    0xda955259,
    0xd19b5b54,
    0xcc894043,
    0xc787494e,
    0xaedd3e05,
    0xa5d33708,
    0xb8c12c1f,
    0xb3cf2512,
    0x82e51a31,
    0x89eb133c,
    0x94f9082b,
    0x9ff70126,
    0x464de6bd,
    0x4d43efb0,
    0x5051f4a7,
    0x5b5ffdaa,
    0x6a75c289,
    0x617bcb84,
    0x7c69d093,
    0x7767d99e,
    0x1e3daed5,
    0x1533a7d8,
    0x0821bccf,
    0x032fb5c2,
    0x32058ae1,
    0x390b83ec,
    0x241998fb,
    0x2f1791f6,
    0x8d764dd6,
    0x867844db,
    0x9b6a5fcc,
    0x906456c1,
    0xa14e69e2,
    0xaa4060ef,
    0xb7527bf8,
    0xbc5c72f5,
    0xd50605be,
    0xde080cb3,
    0xc31a17a4,
    0xc8141ea9,
    0xf93e218a,
    0xf2302887,
    0xef223390,
    0xe42c3a9d,
    0x3d96dd06,
    0x3698d40b,
    0x2b8acf1c,
    0x2084c611,
    0x11aef932,
    0x1aa0f03f,
    0x07b2eb28,
    0x0cbce225,
    0x65e6956e,
    0x6ee89c63,
    0x73fa8774,
    0x78f48e79,
    0x49deb15a,
    0x42d0b857,
    0x5fc2a340,
    0x54ccaa4d,
    0xf741ecda,
    0xfc4fe5d7,
    0xe15dfec0,
    0xea53f7cd,
    0xdb79c8ee,
    0xd077c1e3,
    0xcd65daf4,
    0xc66bd3f9,
    0xaf31a4b2,
    0xa43fadbf,
    0xb92db6a8,
    0xb223bfa5,
    0x83098086,
    0x8807898b,
    0x9515929c,
    0x9e1b9b91,
    0x47a17c0a,
    0x4caf7507,
    0x51bd6e10,
    0x5ab3671d,
    0x6b99583e,
    0x60975133,
    0x7d854a24,
    0x768b4329,
    0x1fd13462,
    0x14df3d6f,
    0x09cd2678,
    0x02c32f75,
    0x33e91056,
    0x38e7195b,
    0x25f5024c,
    0x2efb0b41,
    0x8c9ad761,
    0x8794de6c,
    0x9a86c57b,
    0x9188cc76,
    0xa0a2f355,
    0xabacfa58,
    0xb6bee14f,
    0xbdb0e842,
    0xd4ea9f09,
    0xdfe49604,
    0xc2f68d13,
    0xc9f8841e,
    0xf8d2bb3d,
    0xf3dcb230,
    0xeecea927,
    0xe5c0a02a,
    0x3c7a47b1,
    0x37744ebc,
    0x2a6655ab,
    0x21685ca6,
    0x10426385,
    0x1b4c6a88,
    0x065e719f,
    0x0d507892,
    0x640a0fd9,
    0x6f0406d4,
    0x72161dc3,
    0x791814ce,
    0x48322bed,
    0x433c22e0,
    0x5e2e39f7,
    0x552030fa,
    0x01ec9ab7,
    0x0ae293ba,
    0x17f088ad,
    0x1cfe81a0,
    0x2dd4be83,
    0x26dab78e,
    0x3bc8ac99,
    0x30c6a594,
    0x599cd2df,
    0x5292dbd2,
    0x4f80c0c5,
    0x448ec9c8,
    0x75a4f6eb,
    0x7eaaffe6,
    0x63b8e4f1,
    0x68b6edfc,
    0xb10c0a67,
    0xba02036a,
    0xa710187d,
    0xac1e1170,
    0x9d342e53,
    0x963a275e,
    0x8b283c49,
    0x80263544,
    0xe97c420f,
    0xe2724b02,
    0xff605015,
    0xf46e5918,
    0xc544663b,
    0xce4a6f36,
    0xd3587421,
    0xd8567d2c,
    0x7a37a10c,
    0x7139a801,
    0x6c2bb316,
    0x6725ba1b,
    0x560f8538,
    0x5d018c35,
    0x40139722,
    0x4b1d9e2f,
    0x2247e964,
    0x2949e069,
    0x345bfb7e,
    0x3f55f273,
    0x0e7fcd50,
    0x0571c45d,
    0x1863df4a,
    0x136dd647,
    0xcad731dc,
    0xc1d938d1,
    0xdccb23c6,
    0xd7c52acb,
    0xe6ef15e8,
    0xede11ce5,
    0xf0f307f2,
    0xfbfd0eff,
    0x92a779b4,
    0x99a970b9,
    0x84bb6bae,
    0x8fb562a3,
    0xbe9f5d80,
    0xb591548d,
    0xa8834f9a,
    0xa38d4697
];
const $6d51fc1d1af75bc0$var$U3 = [
    0x00000000,
    0x0d0b0e09,
    0x1a161c12,
    0x171d121b,
    0x342c3824,
    0x3927362d,
    0x2e3a2436,
    0x23312a3f,
    0x68587048,
    0x65537e41,
    0x724e6c5a,
    0x7f456253,
    0x5c74486c,
    0x517f4665,
    0x4662547e,
    0x4b695a77,
    0xd0b0e090,
    0xddbbee99,
    0xcaa6fc82,
    0xc7adf28b,
    0xe49cd8b4,
    0xe997d6bd,
    0xfe8ac4a6,
    0xf381caaf,
    0xb8e890d8,
    0xb5e39ed1,
    0xa2fe8cca,
    0xaff582c3,
    0x8cc4a8fc,
    0x81cfa6f5,
    0x96d2b4ee,
    0x9bd9bae7,
    0xbb7bdb3b,
    0xb670d532,
    0xa16dc729,
    0xac66c920,
    0x8f57e31f,
    0x825ced16,
    0x9541ff0d,
    0x984af104,
    0xd323ab73,
    0xde28a57a,
    0xc935b761,
    0xc43eb968,
    0xe70f9357,
    0xea049d5e,
    0xfd198f45,
    0xf012814c,
    0x6bcb3bab,
    0x66c035a2,
    0x71dd27b9,
    0x7cd629b0,
    0x5fe7038f,
    0x52ec0d86,
    0x45f11f9d,
    0x48fa1194,
    0x03934be3,
    0x0e9845ea,
    0x198557f1,
    0x148e59f8,
    0x37bf73c7,
    0x3ab47dce,
    0x2da96fd5,
    0x20a261dc,
    0x6df6ad76,
    0x60fda37f,
    0x77e0b164,
    0x7aebbf6d,
    0x59da9552,
    0x54d19b5b,
    0x43cc8940,
    0x4ec78749,
    0x05aedd3e,
    0x08a5d337,
    0x1fb8c12c,
    0x12b3cf25,
    0x3182e51a,
    0x3c89eb13,
    0x2b94f908,
    0x269ff701,
    0xbd464de6,
    0xb04d43ef,
    0xa75051f4,
    0xaa5b5ffd,
    0x896a75c2,
    0x84617bcb,
    0x937c69d0,
    0x9e7767d9,
    0xd51e3dae,
    0xd81533a7,
    0xcf0821bc,
    0xc2032fb5,
    0xe132058a,
    0xec390b83,
    0xfb241998,
    0xf62f1791,
    0xd68d764d,
    0xdb867844,
    0xcc9b6a5f,
    0xc1906456,
    0xe2a14e69,
    0xefaa4060,
    0xf8b7527b,
    0xf5bc5c72,
    0xbed50605,
    0xb3de080c,
    0xa4c31a17,
    0xa9c8141e,
    0x8af93e21,
    0x87f23028,
    0x90ef2233,
    0x9de42c3a,
    0x063d96dd,
    0x0b3698d4,
    0x1c2b8acf,
    0x112084c6,
    0x3211aef9,
    0x3f1aa0f0,
    0x2807b2eb,
    0x250cbce2,
    0x6e65e695,
    0x636ee89c,
    0x7473fa87,
    0x7978f48e,
    0x5a49deb1,
    0x5742d0b8,
    0x405fc2a3,
    0x4d54ccaa,
    0xdaf741ec,
    0xd7fc4fe5,
    0xc0e15dfe,
    0xcdea53f7,
    0xeedb79c8,
    0xe3d077c1,
    0xf4cd65da,
    0xf9c66bd3,
    0xb2af31a4,
    0xbfa43fad,
    0xa8b92db6,
    0xa5b223bf,
    0x86830980,
    0x8b880789,
    0x9c951592,
    0x919e1b9b,
    0x0a47a17c,
    0x074caf75,
    0x1051bd6e,
    0x1d5ab367,
    0x3e6b9958,
    0x33609751,
    0x247d854a,
    0x29768b43,
    0x621fd134,
    0x6f14df3d,
    0x7809cd26,
    0x7502c32f,
    0x5633e910,
    0x5b38e719,
    0x4c25f502,
    0x412efb0b,
    0x618c9ad7,
    0x6c8794de,
    0x7b9a86c5,
    0x769188cc,
    0x55a0a2f3,
    0x58abacfa,
    0x4fb6bee1,
    0x42bdb0e8,
    0x09d4ea9f,
    0x04dfe496,
    0x13c2f68d,
    0x1ec9f884,
    0x3df8d2bb,
    0x30f3dcb2,
    0x27eecea9,
    0x2ae5c0a0,
    0xb13c7a47,
    0xbc37744e,
    0xab2a6655,
    0xa621685c,
    0x85104263,
    0x881b4c6a,
    0x9f065e71,
    0x920d5078,
    0xd9640a0f,
    0xd46f0406,
    0xc372161d,
    0xce791814,
    0xed48322b,
    0xe0433c22,
    0xf75e2e39,
    0xfa552030,
    0xb701ec9a,
    0xba0ae293,
    0xad17f088,
    0xa01cfe81,
    0x832dd4be,
    0x8e26dab7,
    0x993bc8ac,
    0x9430c6a5,
    0xdf599cd2,
    0xd25292db,
    0xc54f80c0,
    0xc8448ec9,
    0xeb75a4f6,
    0xe67eaaff,
    0xf163b8e4,
    0xfc68b6ed,
    0x67b10c0a,
    0x6aba0203,
    0x7da71018,
    0x70ac1e11,
    0x539d342e,
    0x5e963a27,
    0x498b283c,
    0x44802635,
    0x0fe97c42,
    0x02e2724b,
    0x15ff6050,
    0x18f46e59,
    0x3bc54466,
    0x36ce4a6f,
    0x21d35874,
    0x2cd8567d,
    0x0c7a37a1,
    0x017139a8,
    0x166c2bb3,
    0x1b6725ba,
    0x38560f85,
    0x355d018c,
    0x22401397,
    0x2f4b1d9e,
    0x642247e9,
    0x692949e0,
    0x7e345bfb,
    0x733f55f2,
    0x500e7fcd,
    0x5d0571c4,
    0x4a1863df,
    0x47136dd6,
    0xdccad731,
    0xd1c1d938,
    0xc6dccb23,
    0xcbd7c52a,
    0xe8e6ef15,
    0xe5ede11c,
    0xf2f0f307,
    0xfffbfd0e,
    0xb492a779,
    0xb999a970,
    0xae84bb6b,
    0xa38fb562,
    0x80be9f5d,
    0x8db59154,
    0x9aa8834f,
    0x97a38d46
];
const $6d51fc1d1af75bc0$var$U4 = [
    0x00000000,
    0x090d0b0e,
    0x121a161c,
    0x1b171d12,
    0x24342c38,
    0x2d392736,
    0x362e3a24,
    0x3f23312a,
    0x48685870,
    0x4165537e,
    0x5a724e6c,
    0x537f4562,
    0x6c5c7448,
    0x65517f46,
    0x7e466254,
    0x774b695a,
    0x90d0b0e0,
    0x99ddbbee,
    0x82caa6fc,
    0x8bc7adf2,
    0xb4e49cd8,
    0xbde997d6,
    0xa6fe8ac4,
    0xaff381ca,
    0xd8b8e890,
    0xd1b5e39e,
    0xcaa2fe8c,
    0xc3aff582,
    0xfc8cc4a8,
    0xf581cfa6,
    0xee96d2b4,
    0xe79bd9ba,
    0x3bbb7bdb,
    0x32b670d5,
    0x29a16dc7,
    0x20ac66c9,
    0x1f8f57e3,
    0x16825ced,
    0x0d9541ff,
    0x04984af1,
    0x73d323ab,
    0x7ade28a5,
    0x61c935b7,
    0x68c43eb9,
    0x57e70f93,
    0x5eea049d,
    0x45fd198f,
    0x4cf01281,
    0xab6bcb3b,
    0xa266c035,
    0xb971dd27,
    0xb07cd629,
    0x8f5fe703,
    0x8652ec0d,
    0x9d45f11f,
    0x9448fa11,
    0xe303934b,
    0xea0e9845,
    0xf1198557,
    0xf8148e59,
    0xc737bf73,
    0xce3ab47d,
    0xd52da96f,
    0xdc20a261,
    0x766df6ad,
    0x7f60fda3,
    0x6477e0b1,
    0x6d7aebbf,
    0x5259da95,
    0x5b54d19b,
    0x4043cc89,
    0x494ec787,
    0x3e05aedd,
    0x3708a5d3,
    0x2c1fb8c1,
    0x2512b3cf,
    0x1a3182e5,
    0x133c89eb,
    0x082b94f9,
    0x01269ff7,
    0xe6bd464d,
    0xefb04d43,
    0xf4a75051,
    0xfdaa5b5f,
    0xc2896a75,
    0xcb84617b,
    0xd0937c69,
    0xd99e7767,
    0xaed51e3d,
    0xa7d81533,
    0xbccf0821,
    0xb5c2032f,
    0x8ae13205,
    0x83ec390b,
    0x98fb2419,
    0x91f62f17,
    0x4dd68d76,
    0x44db8678,
    0x5fcc9b6a,
    0x56c19064,
    0x69e2a14e,
    0x60efaa40,
    0x7bf8b752,
    0x72f5bc5c,
    0x05bed506,
    0x0cb3de08,
    0x17a4c31a,
    0x1ea9c814,
    0x218af93e,
    0x2887f230,
    0x3390ef22,
    0x3a9de42c,
    0xdd063d96,
    0xd40b3698,
    0xcf1c2b8a,
    0xc6112084,
    0xf93211ae,
    0xf03f1aa0,
    0xeb2807b2,
    0xe2250cbc,
    0x956e65e6,
    0x9c636ee8,
    0x877473fa,
    0x8e7978f4,
    0xb15a49de,
    0xb85742d0,
    0xa3405fc2,
    0xaa4d54cc,
    0xecdaf741,
    0xe5d7fc4f,
    0xfec0e15d,
    0xf7cdea53,
    0xc8eedb79,
    0xc1e3d077,
    0xdaf4cd65,
    0xd3f9c66b,
    0xa4b2af31,
    0xadbfa43f,
    0xb6a8b92d,
    0xbfa5b223,
    0x80868309,
    0x898b8807,
    0x929c9515,
    0x9b919e1b,
    0x7c0a47a1,
    0x75074caf,
    0x6e1051bd,
    0x671d5ab3,
    0x583e6b99,
    0x51336097,
    0x4a247d85,
    0x4329768b,
    0x34621fd1,
    0x3d6f14df,
    0x267809cd,
    0x2f7502c3,
    0x105633e9,
    0x195b38e7,
    0x024c25f5,
    0x0b412efb,
    0xd7618c9a,
    0xde6c8794,
    0xc57b9a86,
    0xcc769188,
    0xf355a0a2,
    0xfa58abac,
    0xe14fb6be,
    0xe842bdb0,
    0x9f09d4ea,
    0x9604dfe4,
    0x8d13c2f6,
    0x841ec9f8,
    0xbb3df8d2,
    0xb230f3dc,
    0xa927eece,
    0xa02ae5c0,
    0x47b13c7a,
    0x4ebc3774,
    0x55ab2a66,
    0x5ca62168,
    0x63851042,
    0x6a881b4c,
    0x719f065e,
    0x78920d50,
    0x0fd9640a,
    0x06d46f04,
    0x1dc37216,
    0x14ce7918,
    0x2bed4832,
    0x22e0433c,
    0x39f75e2e,
    0x30fa5520,
    0x9ab701ec,
    0x93ba0ae2,
    0x88ad17f0,
    0x81a01cfe,
    0xbe832dd4,
    0xb78e26da,
    0xac993bc8,
    0xa59430c6,
    0xd2df599c,
    0xdbd25292,
    0xc0c54f80,
    0xc9c8448e,
    0xf6eb75a4,
    0xffe67eaa,
    0xe4f163b8,
    0xedfc68b6,
    0x0a67b10c,
    0x036aba02,
    0x187da710,
    0x1170ac1e,
    0x2e539d34,
    0x275e963a,
    0x3c498b28,
    0x35448026,
    0x420fe97c,
    0x4b02e272,
    0x5015ff60,
    0x5918f46e,
    0x663bc544,
    0x6f36ce4a,
    0x7421d358,
    0x7d2cd856,
    0xa10c7a37,
    0xa8017139,
    0xb3166c2b,
    0xba1b6725,
    0x8538560f,
    0x8c355d01,
    0x97224013,
    0x9e2f4b1d,
    0xe9642247,
    0xe0692949,
    0xfb7e345b,
    0xf2733f55,
    0xcd500e7f,
    0xc45d0571,
    0xdf4a1863,
    0xd647136d,
    0x31dccad7,
    0x38d1c1d9,
    0x23c6dccb,
    0x2acbd7c5,
    0x15e8e6ef,
    0x1ce5ede1,
    0x07f2f0f3,
    0x0efffbfd,
    0x79b492a7,
    0x70b999a9,
    0x6bae84bb,
    0x62a38fb5,
    0x5d80be9f,
    0x548db591,
    0x4f9aa883,
    0x4697a38d
];
function $6d51fc1d1af75bc0$var$convertToInt32(bytes) {
    const result = [];
    for(let i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
    return result;
}
class $6d51fc1d1af75bc0$export$b80fbe1c3a2b92b5 {
    get key() {
        return $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_key, "f").slice();
    }
    constructor(key){
        $6d51fc1d1af75bc0$var$_AES_key.set(this, void 0);
        $6d51fc1d1af75bc0$var$_AES_Kd.set(this, void 0);
        $6d51fc1d1af75bc0$var$_AES_Ke.set(this, void 0);
        if (!(this instanceof $6d51fc1d1af75bc0$export$b80fbe1c3a2b92b5)) throw Error("AES must be instanitated with `new`");
        $6d51fc1d1af75bc0$var$__classPrivateFieldSet(this, $6d51fc1d1af75bc0$var$_AES_key, new Uint8Array(key), "f");
        const rounds = $6d51fc1d1af75bc0$var$numberOfRounds[this.key.length];
        if (rounds == null) throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        $6d51fc1d1af75bc0$var$__classPrivateFieldSet(this, $6d51fc1d1af75bc0$var$_AES_Ke, [], "f");
        // decryption round keys
        $6d51fc1d1af75bc0$var$__classPrivateFieldSet(this, $6d51fc1d1af75bc0$var$_AES_Kd, [], "f");
        for(let i = 0; i <= rounds; i++){
            $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f").push([
                0,
                0,
                0,
                0
            ]);
            $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f").push([
                0,
                0,
                0,
                0
            ]);
        }
        const roundKeyCount = (rounds + 1) * 4;
        const KC = this.key.length / 4;
        // convert the key into ints
        const tk = $6d51fc1d1af75bc0$var$convertToInt32(this.key);
        // copy values into round key arrays
        let index;
        for(let i = 0; i < KC; i++){
            index = i >> 2;
            $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f")[index][i % 4] = tk[i];
            $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        let rconpointer = 0;
        let t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= $6d51fc1d1af75bc0$var$S[tt >> 16 & 0xFF] << 24 ^ $6d51fc1d1af75bc0$var$S[tt >> 8 & 0xFF] << 16 ^ $6d51fc1d1af75bc0$var$S[tt & 0xFF] << 8 ^ $6d51fc1d1af75bc0$var$S[tt >> 24 & 0xFF] ^ $6d51fc1d1af75bc0$var$rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(let i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(let i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= $6d51fc1d1af75bc0$var$S[tt & 0xFF] ^ $6d51fc1d1af75bc0$var$S[tt >> 8 & 0xFF] << 8 ^ $6d51fc1d1af75bc0$var$S[tt >> 16 & 0xFF] << 16 ^ $6d51fc1d1af75bc0$var$S[tt >> 24 & 0xFF] << 24;
                for(let i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            let i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f")[r][c] = tk[i];
                $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(let r = 1; r < rounds; r++)for(let c = 0; c < 4; c++){
            tt = $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[r][c];
            $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[r][c] = $6d51fc1d1af75bc0$var$U1[tt >> 24 & 0xFF] ^ $6d51fc1d1af75bc0$var$U2[tt >> 16 & 0xFF] ^ $6d51fc1d1af75bc0$var$U3[tt >> 8 & 0xFF] ^ $6d51fc1d1af75bc0$var$U4[tt & 0xFF];
        }
    }
    encrypt(plaintext) {
        if (plaintext.length != 16) throw new TypeError("invalid plaintext size (must be 16 bytes)");
        const rounds = $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f").length - 1;
        const a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        let t = $6d51fc1d1af75bc0$var$convertToInt32(plaintext);
        for(let i = 0; i < 4; i++)t[i] ^= $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f")[0][i];
        // apply round transforms
        for(let r = 1; r < rounds; r++){
            for(let i = 0; i < 4; i++)a[i] = $6d51fc1d1af75bc0$var$T1[t[i] >> 24 & 0xff] ^ $6d51fc1d1af75bc0$var$T2[t[(i + 1) % 4] >> 16 & 0xff] ^ $6d51fc1d1af75bc0$var$T3[t[(i + 2) % 4] >> 8 & 0xff] ^ $6d51fc1d1af75bc0$var$T4[t[(i + 3) % 4] & 0xff] ^ $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f")[r][i];
            t = a.slice();
        }
        // the last round is special
        const result = new Uint8Array(16);
        let tt = 0;
        for(let i = 0; i < 4; i++){
            tt = $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Ke, "f")[rounds][i];
            result[4 * i] = ($6d51fc1d1af75bc0$var$S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = ($6d51fc1d1af75bc0$var$S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = ($6d51fc1d1af75bc0$var$S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = ($6d51fc1d1af75bc0$var$S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    }
    decrypt(ciphertext) {
        if (ciphertext.length != 16) throw new TypeError("invalid ciphertext size (must be 16 bytes)");
        const rounds = $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f").length - 1;
        const a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        let t = $6d51fc1d1af75bc0$var$convertToInt32(ciphertext);
        for(let i = 0; i < 4; i++)t[i] ^= $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[0][i];
        // apply round transforms
        for(let r = 1; r < rounds; r++){
            for(let i = 0; i < 4; i++)a[i] = $6d51fc1d1af75bc0$var$T5[t[i] >> 24 & 0xff] ^ $6d51fc1d1af75bc0$var$T6[t[(i + 3) % 4] >> 16 & 0xff] ^ $6d51fc1d1af75bc0$var$T7[t[(i + 2) % 4] >> 8 & 0xff] ^ $6d51fc1d1af75bc0$var$T8[t[(i + 1) % 4] & 0xff] ^ $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[r][i];
            t = a.slice();
        }
        // the last round is special
        const result = new Uint8Array(16);
        let tt = 0;
        for(let i = 0; i < 4; i++){
            tt = $6d51fc1d1af75bc0$var$__classPrivateFieldGet(this, $6d51fc1d1af75bc0$var$_AES_Kd, "f")[rounds][i];
            result[4 * i] = ($6d51fc1d1af75bc0$var$Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = ($6d51fc1d1af75bc0$var$Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = ($6d51fc1d1af75bc0$var$Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = ($6d51fc1d1af75bc0$var$Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    }
}
$6d51fc1d1af75bc0$var$_AES_key = new WeakMap(), $6d51fc1d1af75bc0$var$_AES_Kd = new WeakMap(), $6d51fc1d1af75bc0$var$_AES_Ke = new WeakMap();



class $cab20cd7989e2e0a$export$8c22f84b3f82e04d {
    constructor(name, key, cls){
        if (cls && !(this instanceof cls)) throw new Error(`${name} must be instantiated with "new"`);
        Object.defineProperties(this, {
            aes: {
                enumerable: true,
                value: new (0, $6d51fc1d1af75bc0$export$b80fbe1c3a2b92b5)(key)
            },
            name: {
                enumerable: true,
                value: name
            }
        });
    }
}


// Cipher Block Chaining

var $7f45a2f0be97d532$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7f45a2f0be97d532$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7f45a2f0be97d532$var$_CBC_iv, $7f45a2f0be97d532$var$_CBC_lastBlock;
class $7f45a2f0be97d532$export$8ad3f227af08fcc5 extends (0, $cab20cd7989e2e0a$export$8c22f84b3f82e04d) {
    constructor(key, iv){
        super("ECC", key, $7f45a2f0be97d532$export$8ad3f227af08fcc5);
        $7f45a2f0be97d532$var$_CBC_iv.set(this, void 0);
        $7f45a2f0be97d532$var$_CBC_lastBlock.set(this, void 0);
        if (iv) {
            if (iv.length % 16) throw new TypeError("invalid iv size (must be 16 bytes)");
            $7f45a2f0be97d532$var$__classPrivateFieldSet(this, $7f45a2f0be97d532$var$_CBC_iv, new Uint8Array(iv), "f");
        } else $7f45a2f0be97d532$var$__classPrivateFieldSet(this, $7f45a2f0be97d532$var$_CBC_iv, new Uint8Array(16), "f");
        $7f45a2f0be97d532$var$__classPrivateFieldSet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, this.iv, "f");
    }
    get iv() {
        return new Uint8Array($7f45a2f0be97d532$var$__classPrivateFieldGet(this, $7f45a2f0be97d532$var$_CBC_iv, "f"));
    }
    encrypt(plaintext) {
        if (plaintext.length % 16) throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
        const ciphertext = new Uint8Array(plaintext.length);
        for(let i = 0; i < plaintext.length; i += 16){
            for(let j = 0; j < 16; j++)$7f45a2f0be97d532$var$__classPrivateFieldGet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, "f")[j] ^= plaintext[i + j];
            $7f45a2f0be97d532$var$__classPrivateFieldSet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, this.aes.encrypt($7f45a2f0be97d532$var$__classPrivateFieldGet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, "f")), "f");
            ciphertext.set($7f45a2f0be97d532$var$__classPrivateFieldGet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, "f"), i);
        }
        return ciphertext;
    }
    decrypt(ciphertext) {
        if (ciphertext.length % 16) throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
        const plaintext = new Uint8Array(ciphertext.length);
        for(let i = 0; i < ciphertext.length; i += 16){
            const block = this.aes.decrypt(ciphertext.subarray(i, i + 16));
            for(let j = 0; j < 16; j++){
                plaintext[i + j] = block[j] ^ $7f45a2f0be97d532$var$__classPrivateFieldGet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, "f")[j];
                $7f45a2f0be97d532$var$__classPrivateFieldGet(this, $7f45a2f0be97d532$var$_CBC_lastBlock, "f")[j] = ciphertext[i + j];
            }
        }
        return plaintext;
    }
}
$7f45a2f0be97d532$var$_CBC_iv = new WeakMap(), $7f45a2f0be97d532$var$_CBC_lastBlock = new WeakMap();


// Cipher Feedback

var $6608f8d81ce75b6d$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6608f8d81ce75b6d$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6608f8d81ce75b6d$var$_CFB_instances, $6608f8d81ce75b6d$var$_CFB_iv, $6608f8d81ce75b6d$var$_CFB_shiftRegister, $6608f8d81ce75b6d$var$_CFB_shift;
class $6608f8d81ce75b6d$export$9f0e51cd97c572a extends (0, $cab20cd7989e2e0a$export$8c22f84b3f82e04d) {
    constructor(key, iv, segmentSize = 8){
        super("CFB", key, $6608f8d81ce75b6d$export$9f0e51cd97c572a);
        $6608f8d81ce75b6d$var$_CFB_instances.add(this);
        $6608f8d81ce75b6d$var$_CFB_iv.set(this, void 0);
        $6608f8d81ce75b6d$var$_CFB_shiftRegister.set(this, void 0);
        // This library currently only handles byte-aligned segmentSize
        if (!Number.isInteger(segmentSize) || segmentSize % 8) throw new TypeError("invalid segmentSize");
        Object.defineProperties(this, {
            segmentSize: {
                enumerable: true,
                value: segmentSize
            }
        });
        if (iv) {
            if (iv.length % 16) throw new TypeError("invalid iv size (must be 16 bytes)");
            $6608f8d81ce75b6d$var$__classPrivateFieldSet(this, $6608f8d81ce75b6d$var$_CFB_iv, new Uint8Array(iv), "f");
        } else $6608f8d81ce75b6d$var$__classPrivateFieldSet(this, $6608f8d81ce75b6d$var$_CFB_iv, new Uint8Array(16), "f");
        $6608f8d81ce75b6d$var$__classPrivateFieldSet(this, $6608f8d81ce75b6d$var$_CFB_shiftRegister, this.iv, "f");
    }
    get iv() {
        return new Uint8Array($6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_iv, "f"));
    }
    encrypt(plaintext) {
        if (8 * plaintext.length % this.segmentSize) throw new TypeError("invalid plaintext size (must be multiple of segmentSize bytes)");
        const segmentSize = this.segmentSize / 8;
        const ciphertext = new Uint8Array(plaintext);
        for(let i = 0; i < ciphertext.length; i += segmentSize){
            const xorSegment = this.aes.encrypt($6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_shiftRegister, "f"));
            for(let j = 0; j < segmentSize; j++)ciphertext[i + j] ^= xorSegment[j];
            $6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_instances, "m", $6608f8d81ce75b6d$var$_CFB_shift).call(this, ciphertext.subarray(i));
        }
        return ciphertext;
    }
    decrypt(ciphertext) {
        if (8 * ciphertext.length % this.segmentSize) throw new TypeError("invalid ciphertext size (must be multiple of segmentSize bytes)");
        const segmentSize = this.segmentSize / 8;
        const plaintext = new Uint8Array(ciphertext);
        for(let i = 0; i < plaintext.length; i += segmentSize){
            const xorSegment = this.aes.encrypt($6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_shiftRegister, "f"));
            for(let j = 0; j < segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            $6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_instances, "m", $6608f8d81ce75b6d$var$_CFB_shift).call(this, ciphertext.subarray(i));
        }
        return plaintext;
    }
}
$6608f8d81ce75b6d$var$_CFB_iv = new WeakMap(), $6608f8d81ce75b6d$var$_CFB_shiftRegister = new WeakMap(), $6608f8d81ce75b6d$var$_CFB_instances = new WeakSet(), $6608f8d81ce75b6d$var$_CFB_shift = function _CFB_shift(data) {
    const segmentSize = this.segmentSize / 8;
    // Shift the register
    $6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_shiftRegister, "f").set($6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_shiftRegister, "f").subarray(segmentSize));
    $6608f8d81ce75b6d$var$__classPrivateFieldGet(this, $6608f8d81ce75b6d$var$_CFB_shiftRegister, "f").set(data.subarray(0, segmentSize), 16 - segmentSize);
};


// Counter Mode

var $02c7752739d27bf2$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $02c7752739d27bf2$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $02c7752739d27bf2$var$_CTR_remaining, $02c7752739d27bf2$var$_CTR_remainingIndex, $02c7752739d27bf2$var$_CTR_counter;
class $02c7752739d27bf2$export$2744a2827dddfba4 extends (0, $cab20cd7989e2e0a$export$8c22f84b3f82e04d) {
    constructor(key, initialValue){
        super("CTR", key, $02c7752739d27bf2$export$2744a2827dddfba4);
        // Remaining bytes for the one-time pad
        $02c7752739d27bf2$var$_CTR_remaining.set(this, void 0);
        $02c7752739d27bf2$var$_CTR_remainingIndex.set(this, void 0);
        // The current counter
        $02c7752739d27bf2$var$_CTR_counter.set(this, void 0);
        $02c7752739d27bf2$var$__classPrivateFieldSet(this, $02c7752739d27bf2$var$_CTR_counter, new Uint8Array(16), "f");
        $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f").fill(0);
        $02c7752739d27bf2$var$__classPrivateFieldSet(this, $02c7752739d27bf2$var$_CTR_remaining, $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f"), "f"); // This will be discarded immediately
        $02c7752739d27bf2$var$__classPrivateFieldSet(this, $02c7752739d27bf2$var$_CTR_remainingIndex, 16, "f");
        if (initialValue == null) initialValue = 1;
        if (typeof initialValue === "number") this.setCounterValue(initialValue);
        else this.setCounterBytes(initialValue);
    }
    get counter() {
        return new Uint8Array($02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f"));
    }
    setCounterValue(value) {
        if (!Number.isInteger(value) || value < 0 || value > Number.MAX_SAFE_INTEGER) throw new TypeError("invalid counter initial integer value");
        for(let index = 15; index >= 0; --index){
            $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f")[index] = value % 256;
            value = Math.floor(value / 256);
        }
    }
    setCounterBytes(value) {
        if (value.length !== 16) throw new TypeError("invalid counter initial Uint8Array value length");
        $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f").set(value);
    }
    increment() {
        for(let i = 15; i >= 0; i--)if ($02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f")[i] === 255) $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f")[i] = 0;
        else {
            $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f")[i]++;
            break;
        }
    }
    encrypt(plaintext) {
        var _a, _b;
        const crypttext = new Uint8Array(plaintext);
        for(let i = 0; i < crypttext.length; i++){
            if ($02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_remainingIndex, "f") === 16) {
                $02c7752739d27bf2$var$__classPrivateFieldSet(this, $02c7752739d27bf2$var$_CTR_remaining, this.aes.encrypt($02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_counter, "f")), "f");
                $02c7752739d27bf2$var$__classPrivateFieldSet(this, $02c7752739d27bf2$var$_CTR_remainingIndex, 0, "f");
                this.increment();
            }
            crypttext[i] ^= $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_remaining, "f")[$02c7752739d27bf2$var$__classPrivateFieldSet(this, $02c7752739d27bf2$var$_CTR_remainingIndex, (_b = $02c7752739d27bf2$var$__classPrivateFieldGet(this, $02c7752739d27bf2$var$_CTR_remainingIndex, "f"), _a = _b++, _b), "f"), _a];
        }
        return crypttext;
    }
    decrypt(ciphertext) {
        return this.encrypt(ciphertext);
    }
}
$02c7752739d27bf2$var$_CTR_remaining = new WeakMap(), $02c7752739d27bf2$var$_CTR_remainingIndex = new WeakMap(), $02c7752739d27bf2$var$_CTR_counter = new WeakMap();


// Electronic Code Book

class $5e1dd23cc93b0d28$export$5c3eb387265a857d extends (0, $cab20cd7989e2e0a$export$8c22f84b3f82e04d) {
    constructor(key){
        super("ECB", key, $5e1dd23cc93b0d28$export$5c3eb387265a857d);
    }
    encrypt(plaintext) {
        if (plaintext.length % 16) throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
        const crypttext = new Uint8Array(plaintext.length);
        for(let i = 0; i < plaintext.length; i += 16)crypttext.set(this.aes.encrypt(plaintext.subarray(i, i + 16)), i);
        return crypttext;
    }
    decrypt(crypttext) {
        if (crypttext.length % 16) throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
        const plaintext = new Uint8Array(crypttext.length);
        for(let i = 0; i < crypttext.length; i += 16)plaintext.set(this.aes.decrypt(crypttext.subarray(i, i + 16)), i);
        return plaintext;
    }
}


// Output Feedback

var $4865d4a461bf0a85$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4865d4a461bf0a85$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4865d4a461bf0a85$var$_OFB_iv, $4865d4a461bf0a85$var$_OFB_lastPrecipher, $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex;
class $4865d4a461bf0a85$export$4e33cd0d7170f298 extends (0, $cab20cd7989e2e0a$export$8c22f84b3f82e04d) {
    constructor(key, iv){
        super("OFB", key, $4865d4a461bf0a85$export$4e33cd0d7170f298);
        $4865d4a461bf0a85$var$_OFB_iv.set(this, void 0);
        $4865d4a461bf0a85$var$_OFB_lastPrecipher.set(this, void 0);
        $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex.set(this, void 0);
        if (iv) {
            if (iv.length % 16) throw new TypeError("invalid iv size (must be 16 bytes)");
            $4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_iv, new Uint8Array(iv), "f");
        } else $4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_iv, new Uint8Array(16), "f");
        $4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipher, this.iv, "f");
        $4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex, 16, "f");
    }
    get iv() {
        return new Uint8Array($4865d4a461bf0a85$var$__classPrivateFieldGet(this, $4865d4a461bf0a85$var$_OFB_iv, "f"));
    }
    encrypt(plaintext) {
        var _a, _b;
        if (plaintext.length % 16) throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
        const ciphertext = new Uint8Array(plaintext);
        for(let i = 0; i < ciphertext.length; i++){
            if ($4865d4a461bf0a85$var$__classPrivateFieldGet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex, "f") === 16) {
                $4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipher, this.aes.encrypt($4865d4a461bf0a85$var$__classPrivateFieldGet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipher, "f")), "f");
                $4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex, 0, "f");
            }
            ciphertext[i] ^= $4865d4a461bf0a85$var$__classPrivateFieldGet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipher, "f")[$4865d4a461bf0a85$var$__classPrivateFieldSet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex, (_b = $4865d4a461bf0a85$var$__classPrivateFieldGet(this, $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex, "f"), _a = _b++, _b), "f"), _a];
        }
        return ciphertext;
    }
    decrypt(ciphertext) {
        if (ciphertext.length % 16) throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
        return this.encrypt(ciphertext);
    }
}
$4865d4a461bf0a85$var$_OFB_iv = new WeakMap(), $4865d4a461bf0a85$var$_OFB_lastPrecipher = new WeakMap(), $4865d4a461bf0a85$var$_OFB_lastPrecipherIndex = new WeakMap();


function $af88c8c4d4f42bcf$export$ba35d8504cfc929a(data) {
    const padder = 16 - data.length % 16;
    const result = new Uint8Array(data.length + padder);
    result.set(data);
    for(let i = data.length; i < result.length; i++)result[i] = padder;
    return result;
}
function $af88c8c4d4f42bcf$export$87ffca4a2c0a1844(data) {
    if (data.length < 16) throw new TypeError("PKCS#7 invalid length");
    const padder = data[data.length - 1];
    if (padder > 16) throw new TypeError("PKCS#7 padding byte out of range");
    const length = data.length - padder;
    for(let i = 0; i < padder; i++){
        if (data[length + i] !== padder) throw new TypeError("PKCS#7 invalid padding byte");
    }
    return new Uint8Array(data.subarray(0, length));
}







/**
 *  Explain UUID and link to RFC here.
 *
 *  @_subsection: api/utils:UUID  [about-uuid]
 */ 
function $188a9470c016faeb$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(randomBytes, "randomBytes");
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}


/**
 *  @_ignore
 */ 
function $bc8a838f5c404db0$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && !hexString.startsWith("0x")) hexString = "0x" + hexString;
    return (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(hexString);
}
function $bc8a838f5c404db0$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $bc8a838f5c404db0$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(password, "NFKC");
    return (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(password);
}
function $bc8a838f5c404db0$export$e60f04f78478f7ae(object, _path) {
    const match = _path.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(match != null, "invalid path", "path", _path);
    const path = match[1];
    const type = match[3];
    const reqd = match[4] === "!";
    let cur = object;
    for (const comp of path.toLowerCase().split(".")){
        // Search for a child object with a case-insensitive matching key
        if (Array.isArray(cur)) {
            if (!comp.match(/^[0-9]+$/)) break;
            cur = cur[parseInt(comp)];
        } else if (typeof cur === "object") {
            let found = null;
            for(const key in cur)if (key.toLowerCase() === comp) {
                found = cur[key];
                break;
            }
            cur = found;
        } else cur = null;
        if (cur == null) break;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(!reqd || cur != null, "missing required value", "path", path);
    if (type && cur != null) {
        if (type === "int") {
            if (typeof cur === "string" && cur.match(/^-?[0-9]+$/)) return parseInt(cur);
            else if (Number.isSafeInteger(cur)) return cur;
        }
        if (type === "number") {
            if (typeof cur === "string" && cur.match(/^-?[0-9.]*$/)) return parseFloat(cur);
        }
        if (type === "data") {
            if (typeof cur === "string") return $bc8a838f5c404db0$export$2cde08bde0cfd932(cur);
        }
        if (type === "array" && Array.isArray(cur)) return cur;
        if (type === typeof cur) return cur;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `wrong type found for ${type} `, "path", path);
    }
    return cur;
} /*
export function follow(object: any, path: string): null | string {
    let currentChild = object;

    for (const comp of path.toLowerCase().split('/')) {

        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for (const key in currentChild) {
             if (key.toLowerCase() === comp) {
                 matchingChild = currentChild[key];
                 break;
             }
        }

        if (matchingChild === null) { return null; }

        currentChild = matchingChild;
    }

    return currentChild;
}

// "path/to/something:type!"
export function followRequired(data: any, path: string): string {
    const value = follow(data, path);
    if (value != null) { return value; }
    return logger.throwArgumentError("invalid value", `data:${ path }`,
    JSON.stringify(data));
}
*/  // See: https://www.ietf.org/rfc/rfc4122.txt (Section 4.4)
 /*
export function uuidV4(randomBytes: BytesLike): string {
    const bytes = getBytes(randomBytes, "randomBytes");

    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = (bytes[6] & 0x0f) | 0x40;

    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const value = hexlify(bytes);

    return [
       value.substring(2, 10),
       value.substring(10, 14),
       value.substring(14, 18),
       value.substring(18, 22),
       value.substring(22, 34),
    ].join("-");
}
*/ 



const $35425b0d7a251838$var$defaultPath = "m/44'/60'/0'/0/0";
function $35425b0d7a251838$export$63d296401f2c71cb(json) {
    try {
        const data = JSON.parse(json);
        const version = data.version != null ? parseInt(data.version) : 0;
        if (version === 3) return true;
    } catch (error) {}
    return false;
}
function $35425b0d7a251838$var$decrypt(data, key, ciphertext) {
    const cipher = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.cipher:string");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.cipherparams.iv:data!");
        const aesCtr = new (0, $02c7752739d27bf2$export$2744a2827dddfba4)(key, iv);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(aesCtr.decrypt(ciphertext));
    }
    (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported cipher", "UNSUPPORTED_OPERATION", {
        operation: "decrypt"
    });
}
function $35425b0d7a251838$var$getAccount(data, _key) {
    const key = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_key);
    const ciphertext = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.ciphertext:data!");
    const computedMAC = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(computedMAC === (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
    const privateKey = $35425b0d7a251838$var$decrypt(data, key.slice(0, 16), ciphertext);
    const address = (0, $e25c0939af0d847b$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (!check.startsWith("0x")) check = "0x" + check;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $69ef3f917ff239a2$export$88411125f012957a)(check) === address, "keystore address/privateKey mismatch", "address", data.address);
    }
    const account = {
        address: address,
        privateKey: privateKey
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    const version = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "x-ethers.version:string");
    if (version === "0.1") {
        const mnemonicKey = key.slice(32, 64);
        const mnemonicCiphertext = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "x-ethers.mnemonicCiphertext:data!");
        const mnemonicIv = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "x-ethers.mnemonicCounter:data!");
        const mnemonicAesCtr = new (0, $02c7752739d27bf2$export$2744a2827dddfba4)(mnemonicKey, mnemonicIv);
        account.mnemonic = {
            path: (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "x-ethers.path:string") || $35425b0d7a251838$var$defaultPath,
            locale: (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "x-ethers.locale:string") || "en",
            entropy: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(mnemonicAesCtr.decrypt(mnemonicCiphertext)))
        };
    }
    return account;
}
function $35425b0d7a251838$var$getDecryptKdfParams(data) {
    const kdf = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdf:string");
    if (kdf && typeof kdf === "string") {
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.salt:data!");
            const N = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.n:int!");
            const r = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.r:int!");
            const p = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.p:int!");
            // Make sure N is a power of 2
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(N > 0 && (N & N - 1) === 0, "invalid kdf.N", "kdf.N", N);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(r > 0 && p > 0, "invalid kdf", "kdf", kdf);
            const dkLen = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.dklen:int!");
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(dkLen === 32, "invalid kdf.dklen", "kdf.dflen", dkLen);
            return {
                name: "scrypt",
                salt: salt,
                N: N,
                r: r,
                p: p,
                dkLen: 64
            };
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.salt:data!");
            const prf = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.prf:string!");
            const algorithm = prf.split("-").pop();
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(algorithm === "sha256" || algorithm === "sha512", "invalid kdf.pdf", "kdf.pdf", prf);
            const count = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.c:int!");
            const dkLen = (0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "crypto.kdfparams.dklen:int!");
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(dkLen === 32, "invalid kdf.dklen", "kdf.dklen", dkLen);
            return {
                name: "pbkdf2",
                salt: salt,
                count: count,
                dkLen: dkLen,
                algorithm: algorithm
            };
        }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported key-derivation function", "kdf", kdf);
}
function $35425b0d7a251838$export$1f8e256e768c407(json, _password) {
    const data = JSON.parse(json);
    const password = (0, $bc8a838f5c404db0$export$350bd33120f7413e)(_password);
    const params = $35425b0d7a251838$var$getDecryptKdfParams(data);
    if (params.name === "pbkdf2") {
        const { salt: salt, count: count, dkLen: dkLen, algorithm: algorithm } = params;
        const key = (0, $9092348e8cf65603$export$448fa22aedc9dbca)(password, salt, count, dkLen, algorithm);
        return $35425b0d7a251838$var$getAccount(data, key);
    }
    (0, $634aa51198273feb$export$a7a9523472993e97)(params.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", {
        params: params
    });
    const { salt: salt, N: N, r: r, p: p, dkLen: dkLen } = params;
    const key = (0, $e794241b1cb9b0d3$export$86c79e0734c26a76)(password, salt, N, r, p, dkLen);
    return $35425b0d7a251838$var$getAccount(data, key);
}
function $35425b0d7a251838$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, duration);
    });
}
async function $35425b0d7a251838$export$e87607340ca53727(json, _password, progress) {
    const data = JSON.parse(json);
    const password = (0, $bc8a838f5c404db0$export$350bd33120f7413e)(_password);
    const params = $35425b0d7a251838$var$getDecryptKdfParams(data);
    if (params.name === "pbkdf2") {
        if (progress) {
            progress(0);
            await $35425b0d7a251838$var$stall(0);
        }
        const { salt: salt, count: count, dkLen: dkLen, algorithm: algorithm } = params;
        const key = (0, $9092348e8cf65603$export$448fa22aedc9dbca)(password, salt, count, dkLen, algorithm);
        if (progress) {
            progress(1);
            await $35425b0d7a251838$var$stall(0);
        }
        return $35425b0d7a251838$var$getAccount(data, key);
    }
    (0, $634aa51198273feb$export$a7a9523472993e97)(params.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", {
        params: params
    });
    const { salt: salt, N: N, r: r, p: p, dkLen: dkLen } = params;
    const key = await (0, $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3)(password, salt, N, r, p, dkLen, progress);
    return $35425b0d7a251838$var$getAccount(data, key);
}
function $35425b0d7a251838$var$getEncryptKdfParams(options) {
    // Check/generate the salt
    const salt = options.salt != null ? (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(options.salt, "options.salt") : (0, $90bc03290273a6e1$export$5f828d93ff035aa8)(32);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof N === "number" && N > 0 && Number.isSafeInteger(N) && (BigInt(N) & BigInt(N - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", N);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof r === "number" && r > 0 && Number.isSafeInteger(r), "invalid scrypt r parameter", "options.r", r);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof p === "number" && p > 0 && Number.isSafeInteger(p), "invalid scrypt p parameter", "options.p", p);
    return {
        name: "scrypt",
        dkLen: 32,
        salt: salt,
        N: N,
        r: r,
        p: p
    };
}
function $35425b0d7a251838$var$_encryptKeystore(key, kdf, account, options) {
    const privateKey = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(account.privateKey, "privateKey");
    // Override initialization vector
    const iv = options.iv != null ? (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(options.iv, "options.iv") : (0, $90bc03290273a6e1$export$5f828d93ff035aa8)(16);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(iv.length === 16, "invalid options.iv length", "options.iv", options.iv);
    // Override the uuid
    const uuidRandom = options.uuid != null ? (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(options.uuid, "options.uuid") : (0, $90bc03290273a6e1$export$5f828d93ff035aa8)(16);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(uuidRandom.length === 16, "invalid options.uuid length", "options.uuid", options.iv);
    // This will be used to encrypt the wallet (as per Web3 secret storage)
    // - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    // - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    const derivedKey = key.slice(0, 16);
    const macPrefix = key.slice(16, 32);
    // Encrypt the private key
    const aesCtr = new (0, $02c7752739d27bf2$export$2744a2827dddfba4)(derivedKey, iv);
    const ciphertext = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(aesCtr.encrypt(privateKey));
    // Compute the message authentication code, used to check the password
    const mac = (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        macPrefix,
        ciphertext
    ]));
    // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
    const data = {
        address: account.address.substring(2).toLowerCase(),
        id: (0, $188a9470c016faeb$export$ec7b18ebad55a3a9)(uuidRandom),
        version: 3,
        Crypto: {
            cipher: "aes-128-ctr",
            cipherparams: {
                iv: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(iv).substring(2)
            },
            ciphertext: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(ciphertext).substring(2),
            kdf: "scrypt",
            kdfparams: {
                salt: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(kdf.salt).substring(2),
                n: kdf.N,
                dklen: 32,
                p: kdf.p,
                r: kdf.r
            },
            mac: mac.substring(2)
        }
    };
    // If we have a mnemonic, encrypt it into the JSON wallet
    if (account.mnemonic) {
        const client = options.client != null ? options.client : `ethers/${0, $9f7bf65ddafc81a6$export$83d89fbfd8236492}`;
        const path = account.mnemonic.path || $35425b0d7a251838$var$defaultPath;
        const locale = account.mnemonic.locale || "en";
        const mnemonicKey = key.slice(32, 64);
        const entropy = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(account.mnemonic.entropy, "account.mnemonic.entropy");
        const mnemonicIv = (0, $90bc03290273a6e1$export$5f828d93ff035aa8)(16);
        const mnemonicAesCtr = new (0, $02c7752739d27bf2$export$2744a2827dddfba4)(mnemonicKey, mnemonicIv);
        const mnemonicCiphertext = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(mnemonicAesCtr.encrypt(entropy));
        const now = new Date();
        const timestamp = now.getUTCFullYear() + "-" + (0, $bc8a838f5c404db0$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $bc8a838f5c404db0$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $bc8a838f5c404db0$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $bc8a838f5c404db0$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $bc8a838f5c404db0$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
        const gethFilename = "UTC--" + timestamp + "--" + data.address;
        data["x-ethers"] = {
            client: client,
            gethFilename: gethFilename,
            path: path,
            locale: locale,
            mnemonicCounter: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(mnemonicIv).substring(2),
            mnemonicCiphertext: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(mnemonicCiphertext).substring(2),
            version: "0.1"
        };
    }
    return JSON.stringify(data);
}
function $35425b0d7a251838$export$34a2fe7c460baa1b(account, password, options) {
    if (options == null) options = {};
    const passwordBytes = (0, $bc8a838f5c404db0$export$350bd33120f7413e)(password);
    const kdf = $35425b0d7a251838$var$getEncryptKdfParams(options);
    const key = (0, $e794241b1cb9b0d3$export$86c79e0734c26a76)(passwordBytes, kdf.salt, kdf.N, kdf.r, kdf.p, 64);
    return $35425b0d7a251838$var$_encryptKeystore((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(key), kdf, account, options);
}
async function $35425b0d7a251838$export$894a95c34c56a476(account, password, options) {
    if (options == null) options = {};
    const passwordBytes = (0, $bc8a838f5c404db0$export$350bd33120f7413e)(password);
    const kdf = $35425b0d7a251838$var$getEncryptKdfParams(options);
    const key = await (0, $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3)(passwordBytes, kdf.salt, kdf.N, kdf.r, kdf.p, 64, options.progressCallback);
    return $35425b0d7a251838$var$_encryptKeystore((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(key), kdf, account, options);
}


const $b05424e4ec4c044c$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
// "Bitcoin seed"
const $b05424e4ec4c044c$var$MasterSecret = new Uint8Array([
    66,
    105,
    116,
    99,
    111,
    105,
    110,
    32,
    115,
    101,
    101,
    100
]);
const $b05424e4ec4c044c$var$HardenedBit = 0x80000000;
const $b05424e4ec4c044c$var$N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $b05424e4ec4c044c$var$Nibbles = "0123456789abcdef";
function $b05424e4ec4c044c$var$zpad(value, length) {
    let result = "";
    while(value){
        result = $b05424e4ec4c044c$var$Nibbles[value % 16] + result;
        value = Math.trunc(value / 16);
    }
    while(result.length < length * 2)result = "0" + result;
    return "0x" + result;
}
function $b05424e4ec4c044c$var$encodeBase58Check(_value) {
    const value = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_value);
    const check = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)((0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)(value)), 0, 4);
    const bytes = (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        value,
        check
    ]);
    return (0, $afe06f2b2ad79fd5$export$743e6bddc3282b13)(bytes);
}
const $b05424e4ec4c044c$var$_guard = {};
function $b05424e4ec4c044c$var$ser_I(index, chainCode, publicKey, privateKey) {
    const data = new Uint8Array(37);
    if (index & $b05424e4ec4c044c$var$HardenedBit) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(privateKey != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
            operation: "deriveChild"
        });
        // Data = 0x00 || ser_256(k_par)
        data.set((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(privateKey), 1);
    } else // Data = ser_p(point(k_par))
    data.set((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(publicKey));
    // Data += ser_32(i)
    for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
    const I = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $be13a0f2e0d9ad05$export$967075d2f3b8e7ff)("sha512", chainCode, data));
    return {
        IL: I.slice(0, 32),
        IR: I.slice(32)
    };
}
function $b05424e4ec4c044c$var$derivePath(node, path) {
    const components = path.split("/");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(components.length > 0, "invalid path", "path", path);
    if (components[0] === "m") {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(node.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${node.depth}`, "path", path);
        components.shift();
    }
    let result = node;
    for(let i = 0; i < components.length; i++){
        const component = components[i];
        if (component.match(/^[0-9]+'$/)) {
            const index = parseInt(component.substring(0, component.length - 1));
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(index < $b05424e4ec4c044c$var$HardenedBit, "invalid path index", `path[${i}]`, component);
            result = result.deriveChild($b05424e4ec4c044c$var$HardenedBit + index);
        } else if (component.match(/^[0-9]+$/)) {
            const index = parseInt(component);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(index < $b05424e4ec4c044c$var$HardenedBit, "invalid path index", `path[${i}]`, component);
            result = result.deriveChild(index);
        } else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid path component", `path[${i}]`, component);
    }
    return result;
}
class $b05424e4ec4c044c$export$95e1874239eea27d extends (0, $0dc3e77fb9ae1687$export$240e17ab043752ea) {
    /**
     *  The compressed public key.
     */ publicKey;
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */ fingerprint;
    /**
     *  The parent fingerprint.
     */ parentFingerprint;
    /**
     *  The mnemonic used to create this HD Node, if available.
     *
     *  Sources such as extended keys do not encode the mnemonic, in
     *  which case this will be ``null``.
     */ mnemonic;
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */ chainCode;
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provide full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  encode it.
     */ path;
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */ index;
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */ depth;
    /**
     *  @private
     */ constructor(guard, signingKey, parentFingerprint, chainCode, path, index, depth, mnemonic, provider){
        super(signingKey, provider);
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $b05424e4ec4c044c$var$_guard, "HDNodeWallet");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            publicKey: signingKey.compressedPublicKey
        });
        const fingerprint = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e)((0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            parentFingerprint: parentFingerprint,
            fingerprint: fingerprint,
            chainCode: chainCode,
            path: path,
            index: index,
            depth: depth
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            mnemonic: mnemonic
        });
    }
    connect(provider) {
        return new $b05424e4ec4c044c$export$95e1874239eea27d($b05424e4ec4c044c$var$_guard, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, provider);
    }
    #account() {
        const account = {
            address: this.address,
            privateKey: this.privateKey
        };
        const m = this.mnemonic;
        if (this.path && m && m.wordlist.locale === "en" && m.password === "") account.mnemonic = {
            path: this.path,
            locale: "en",
            entropy: m.entropy
        };
        return account;
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */ async encrypt(password, progressCallback) {
        return await (0, $35425b0d7a251838$export$894a95c34c56a476)(this.#account(), password, {
            progressCallback: progressCallback
        });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */ encryptSync(password) {
        return (0, $35425b0d7a251838$export$34a2fe7c460baa1b)(this.#account(), password);
    }
    /**
     *  The extended key.
     *
     *  This key will begin with the prefix ``xpriv`` and can be used to
     *  reconstruct this HD Node to derive its children.
     */ get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", {
            operation: "extendedKey"
        });
        return $b05424e4ec4c044c$var$encodeBase58Check((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            "0x0488ADE4",
            $b05424e4ec4c044c$var$zpad(this.depth, 1),
            this.parentFingerprint,
            $b05424e4ec4c044c$var$zpad(this.index, 4),
            this.chainCode,
            (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
                "0x00",
                this.privateKey
            ])
        ]));
    }
    /**
     *  Returns true if this wallet has a path, providing a Type Guard
     *  that the path is non-null.
     */ hasPath() {
        return this.path != null;
    }
    /**
     *  Returns a neutered HD Node, which removes the private details
     *  of an HD Node.
     *
     *  A neutered node has no private key, but can be used to derive
     *  child addresses and other public data about the HD Node.
     */ neuter() {
        return new $b05424e4ec4c044c$export$1699d1bbbd194d93($b05424e4ec4c044c$var$_guard, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
    }
    /**
     *  Return the child for %%index%%.
     */ deriveChild(_index) {
        const index = (0, $6fa405e57bb6371e$export$b14f2714108df84)(_index, "index");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(index <= 0xffffffff, "invalid index", "index", index);
        // Base path
        let path = this.path;
        if (path) {
            path += "/" + (index & ~$b05424e4ec4c044c$var$HardenedBit);
            if (index & $b05424e4ec4c044c$var$HardenedBit) path += "'";
        }
        const { IR: IR, IL: IL } = $b05424e4ec4c044c$var$ser_I(index, this.chainCode, this.publicKey, this.privateKey);
        const ki = new (0, $015cdebda6711d1b$export$21643ca94aed3e83)((0, $6fa405e57bb6371e$export$c6ebe05badb16181)(((0, $6fa405e57bb6371e$export$c221a145703ab783)(IL) + BigInt(this.privateKey)) % $b05424e4ec4c044c$var$N, 32));
        return new $b05424e4ec4c044c$export$95e1874239eea27d($b05424e4ec4c044c$var$_guard, ki, this.fingerprint, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(IR), path, index, this.depth + 1, this.mnemonic, this.provider);
    }
    /**
     *  Return the HDNode for %%path%% from this node.
     */ derivePath(path) {
        return $b05424e4ec4c044c$var$derivePath(this, path);
    }
    static #fromSeed(_seed, mnemonic) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$9a14abb1a440cd5e)(_seed), "invalid seed", "seed", "[REDACTED]");
        const seed = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_seed, "seed");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(seed.length >= 16 && seed.length <= 64, "invalid seed", "seed", "[REDACTED]");
        const I = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $be13a0f2e0d9ad05$export$967075d2f3b8e7ff)("sha512", $b05424e4ec4c044c$var$MasterSecret, seed));
        const signingKey = new (0, $015cdebda6711d1b$export$21643ca94aed3e83)((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(I.slice(0, 32)));
        return new $b05424e4ec4c044c$export$95e1874239eea27d($b05424e4ec4c044c$var$_guard, signingKey, "0x00000000", (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(I.slice(32)), "m", 0, 0, mnemonic, null);
    }
    /**
     *  Creates a new HD Node from %%extendedKey%%.
     *
     *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
     *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
     *  or full HD Node ([[HDNodeWallet) respectively.
     */ static fromExtendedKey(extendedKey) {
        const bytes = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)((0, $afe06f2b2ad79fd5$export$63d430871b22e3d9)(extendedKey)); // @TODO: redact
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bytes.length === 82 || $b05424e4ec4c044c$var$encodeBase58Check(bytes.slice(0, 78)) === extendedKey, "invalid extended key", "extendedKey", "[ REDACTED ]");
        const depth = bytes[4];
        const parentFingerprint = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
        const index = parseInt((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                {
                    const publicKey = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(key);
                    return new $b05424e4ec4c044c$export$1699d1bbbd194d93($b05424e4ec4c044c$var$_guard, (0, $e25c0939af0d847b$export$e67e2732ba9803f9)(publicKey), publicKey, parentFingerprint, chainCode, null, index, depth, null);
                }
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $b05424e4ec4c044c$export$95e1874239eea27d($b05424e4ec4c044c$var$_guard, new (0, $015cdebda6711d1b$export$21643ca94aed3e83)(key.slice(1)), parentFingerprint, chainCode, null, index, depth, null, null);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
    }
    /**
     *  Creates a new random HDNode.
     */ static createRandom(password, path, wordlist) {
        if (password == null) password = "";
        if (path == null) path = $b05424e4ec4c044c$export$d48ad89f7e11a603;
        if (wordlist == null) wordlist = (0, $6bf09071e590cbe7$export$eafb81b30f0382d9).wordlist();
        const mnemonic = (0, $96579c190558f712$export$93018d515d60db37).fromEntropy((0, $90bc03290273a6e1$export$5f828d93ff035aa8)(16), password, wordlist);
        return $b05424e4ec4c044c$export$95e1874239eea27d.#fromSeed(mnemonic.computeSeed(), mnemonic).derivePath(path);
    }
    /**
     *  Create an HD Node from %%mnemonic%%.
     */ static fromMnemonic(mnemonic, path) {
        if (!path) path = $b05424e4ec4c044c$export$d48ad89f7e11a603;
        return $b05424e4ec4c044c$export$95e1874239eea27d.#fromSeed(mnemonic.computeSeed(), mnemonic).derivePath(path);
    }
    /**
     *  Creates an HD Node from a mnemonic %%phrase%%.
     */ static fromPhrase(phrase, password, path, wordlist) {
        if (password == null) password = "";
        if (path == null) path = $b05424e4ec4c044c$export$d48ad89f7e11a603;
        if (wordlist == null) wordlist = (0, $6bf09071e590cbe7$export$eafb81b30f0382d9).wordlist();
        const mnemonic = (0, $96579c190558f712$export$93018d515d60db37).fromPhrase(phrase, password, wordlist);
        return $b05424e4ec4c044c$export$95e1874239eea27d.#fromSeed(mnemonic.computeSeed(), mnemonic).derivePath(path);
    }
    /**
     *  Creates an HD Node from a %%seed%%.
     */ static fromSeed(seed) {
        return $b05424e4ec4c044c$export$95e1874239eea27d.#fromSeed(seed, null);
    }
}
class $b05424e4ec4c044c$export$1699d1bbbd194d93 extends (0, $0e0b4a0a5741b830$export$7dbc56d9b9612bad) {
    /**
     *  The compressed public key.
     */ publicKey;
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */ fingerprint;
    /**
     *  The parent node fingerprint.
     */ parentFingerprint;
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */ chainCode;
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provider full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  enocde it.
     */ path;
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */ index;
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */ depth;
    /**
     *  @private
     */ constructor(guard, address, publicKey, parentFingerprint, chainCode, path, index, depth, provider){
        super(address, provider);
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $b05424e4ec4c044c$var$_guard, "HDNodeVoidWallet");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            publicKey: publicKey
        });
        const fingerprint = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e)((0, $c1049352abb4e7c6$export$bced8d2aada2d1c9)(publicKey)), 0, 4);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            publicKey: publicKey,
            fingerprint: fingerprint,
            parentFingerprint: parentFingerprint,
            chainCode: chainCode,
            path: path,
            index: index,
            depth: depth
        });
    }
    connect(provider) {
        return new $b05424e4ec4c044c$export$1699d1bbbd194d93($b05424e4ec4c044c$var$_guard, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, provider);
    }
    /**
     *  The extended key.
     *
     *  This key will begin with the prefix ``xpub`` and can be used to
     *  reconstruct this neutered key to derive its children addresses.
     */ get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", {
            operation: "extendedKey"
        });
        return $b05424e4ec4c044c$var$encodeBase58Check((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            "0x0488B21E",
            $b05424e4ec4c044c$var$zpad(this.depth, 1),
            this.parentFingerprint,
            $b05424e4ec4c044c$var$zpad(this.index, 4),
            this.chainCode,
            this.publicKey
        ]));
    }
    /**
     *  Returns true if this wallet has a path, providing a Type Guard
     *  that the path is non-null.
     */ hasPath() {
        return this.path != null;
    }
    /**
     *  Return the child for %%index%%.
     */ deriveChild(_index) {
        const index = (0, $6fa405e57bb6371e$export$b14f2714108df84)(_index, "index");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(index <= 0xffffffff, "invalid index", "index", index);
        // Base path
        let path = this.path;
        if (path) {
            path += "/" + (index & ~$b05424e4ec4c044c$var$HardenedBit);
            if (index & $b05424e4ec4c044c$var$HardenedBit) path += "'";
        }
        const { IR: IR, IL: IL } = $b05424e4ec4c044c$var$ser_I(index, this.chainCode, this.publicKey, null);
        const Ki = (0, $015cdebda6711d1b$export$21643ca94aed3e83).addPoints(IL, this.publicKey, true);
        const address = (0, $e25c0939af0d847b$export$e67e2732ba9803f9)(Ki);
        return new $b05424e4ec4c044c$export$1699d1bbbd194d93($b05424e4ec4c044c$var$_guard, address, Ki, this.fingerprint, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(IR), path, index, this.depth + 1, this.provider);
    }
    /**
     *  Return the signer for %%path%% from this node.
     */ derivePath(path) {
        return $b05424e4ec4c044c$var$derivePath(this, path);
    }
}
function $b05424e4ec4c044c$export$22b80e4f9eff636d(_index) {
    const index = (0, $6fa405e57bb6371e$export$b14f2714108df84)(_index, "index");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(index >= 0 && index < $b05424e4ec4c044c$var$HardenedBit, "invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}
function $b05424e4ec4c044c$export$3062973ac7973298(_index) {
    const index = (0, $6fa405e57bb6371e$export$b14f2714108df84)(_index, "index");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(index >= 0 && index < $b05424e4ec4c044c$var$HardenedBit, "invalid account index", "index", index);
    return `m/44'/60'/0'/0/${index}`;
}


/**
 *  @_subsection: api/wallet:JSON Wallets  [json-wallets]
 */ 





function $ab3e063fed9a42b7$export$5afa2cfb54be9385(json) {
    try {
        const data = JSON.parse(json);
        if (data.encseed) return true;
    } catch (error) {}
    return false;
}
function $ab3e063fed9a42b7$export$eacfdf3784ce8533(json, _password) {
    const data = JSON.parse(json);
    const password = (0, $bc8a838f5c404db0$export$350bd33120f7413e)(_password);
    // Ethereum Address
    const address = (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "ethaddr:string!"));
    // Encrypted Seed
    const encseed = (0, $bc8a838f5c404db0$export$2cde08bde0cfd932)((0, $bc8a838f5c404db0$export$e60f04f78478f7ae)(data, "encseed:string!"));
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(encseed && encseed.length % 16 === 0, "invalid encseed", "json", json);
    const key = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $9092348e8cf65603$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, $7f45a2f0be97d532$export$8ad3f227af08fcc5)(key, iv);
    const seed = (0, $af88c8c4d4f42bcf$export$87ffca4a2c0a1844)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    return {
        address: address,
        privateKey: (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(seedHex)
    };
}




function $e31fa7eca94d8741$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, duration);
    });
}
class $e31fa7eca94d8741$export$bcca3ea514774656 extends (0, $0dc3e77fb9ae1687$export$240e17ab043752ea) {
    /**
     *  Create a new wallet for the private %%key%%, optionally connected
     *  to %%provider%%.
     */ constructor(key, provider){
        if (typeof key === "string" && !key.startsWith("0x")) key = "0x" + key;
        let signingKey = typeof key === "string" ? new (0, $015cdebda6711d1b$export$21643ca94aed3e83)(key) : key;
        super(signingKey, provider);
    }
    connect(provider) {
        return new $e31fa7eca94d8741$export$bcca3ea514774656(this.signingKey, provider);
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */ async encrypt(password, progressCallback) {
        const account = {
            address: this.address,
            privateKey: this.privateKey
        };
        return await (0, $35425b0d7a251838$export$894a95c34c56a476)(account, password, {
            progressCallback: progressCallback
        });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */ encryptSync(password) {
        const account = {
            address: this.address,
            privateKey: this.privateKey
        };
        return (0, $35425b0d7a251838$export$34a2fe7c460baa1b)(account, password);
    }
    static #fromAccount(account) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(account, "invalid JSON wallet", "json", "[ REDACTED ]");
        if ("mnemonic" in account && account.mnemonic && account.mnemonic.locale === "en") {
            const mnemonic = (0, $96579c190558f712$export$93018d515d60db37).fromEntropy(account.mnemonic.entropy);
            const wallet = (0, $b05424e4ec4c044c$export$95e1874239eea27d).fromMnemonic(mnemonic, account.mnemonic.path);
            if (wallet.address === account.address && wallet.privateKey === account.privateKey) return wallet;
            console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
        }
        const wallet = new $e31fa7eca94d8741$export$bcca3ea514774656(account.privateKey);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(wallet.address === account.address, "address/privateKey mismatch", "json", "[ REDACTED ]");
        return wallet;
    }
    /**
     *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
     *  with %%password%%.
     *
     *  If %%progress%% is provided, it is called periodically during
     *  decryption so that any UI can be updated.
     */ static async fromEncryptedJson(json, password, progress) {
        let account = null;
        if ((0, $35425b0d7a251838$export$63d296401f2c71cb)(json)) account = await (0, $35425b0d7a251838$export$e87607340ca53727)(json, password, progress);
        else if ((0, $ab3e063fed9a42b7$export$5afa2cfb54be9385)(json)) {
            if (progress) {
                progress(0);
                await $e31fa7eca94d8741$var$stall(0);
            }
            account = (0, $ab3e063fed9a42b7$export$eacfdf3784ce8533)(json, password);
            if (progress) {
                progress(1);
                await $e31fa7eca94d8741$var$stall(0);
            }
        }
        return $e31fa7eca94d8741$export$bcca3ea514774656.#fromAccount(account);
    }
    /**
     *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
     *
     *  The [[fromEncryptedJson]] method is preferred, as this method
     *  will lock up and freeze the UI during decryption, which may take
     *  some time.
     */ static fromEncryptedJsonSync(json, password) {
        let account = null;
        if ((0, $35425b0d7a251838$export$63d296401f2c71cb)(json)) account = (0, $35425b0d7a251838$export$1f8e256e768c407)(json, password);
        else if ((0, $ab3e063fed9a42b7$export$5afa2cfb54be9385)(json)) account = (0, $ab3e063fed9a42b7$export$eacfdf3784ce8533)(json, password);
        else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid JSON wallet", "json", "[ REDACTED ]");
        return $e31fa7eca94d8741$export$bcca3ea514774656.#fromAccount(account);
    }
    /**
     *  Creates a new random [[HDNodeWallet]] using the available
     *  [cryptographic random source](randomBytes).
     *
     *  If there is no crytographic random source, this will throw.
     */ static createRandom(provider) {
        const wallet = (0, $b05424e4ec4c044c$export$95e1874239eea27d).createRandom();
        if (provider) return wallet.connect(provider);
        return wallet;
    }
    /**
     *  Creates a [[HDNodeWallet]] for %%phrase%%.
     */ static fromPhrase(phrase, provider) {
        const wallet = (0, $b05424e4ec4c044c$export$95e1874239eea27d).fromPhrase(phrase);
        if (provider) return wallet.connect(provider);
        return wallet;
    }
}





let $f94943c3ed27e058$var$provider = new (0, $5499ec87660a9ba7$export$999cc40da3fbc6f)("matic", "jKHL8FBDC9OR14KUb_n-J0_5KoF9hjDo");
let $f94943c3ed27e058$var$contractAddress = "0xc3E5ad11aE2F00c740E74B81f134426A3331D950";
let $f94943c3ed27e058$var$contractAbi = [
    "event Finalized(uint256 indexed pollId, uint256 burned)",
    "event Initialized(uint8 version)",
    "event PollCreated(uint256 pollId)",
    "event Revealed(uint256 indexed pollId, uint256 revealedVotes, uint256 remainingVotes)",
    "event RoleAdminChanged(bytes32 indexed role, bytes32 indexed previousAdminRole, bytes32 indexed newAdminRole)",
    "event RoleGranted(bytes32 indexed role, address indexed account, address indexed sender)",
    "event RoleRevoked(bytes32 indexed role, address indexed account, address indexed sender)",
    "event Voted(uint256 indexed pollId, uint256 voteIndex, address voter, uint256 comoAmount, bytes32 hash)",
    "function DEFAULT_ADMIN_ROLE() view returns (bytes32)",
    "function OPERATOR_ROLE() view returns (bytes32)",
    "function candidates(uint256 pollId) view returns (string[])",
    "function comoContract() view returns (address)",
    "function createPoll(string title_, string[] candidates_, uint256 startAt_, uint256 due_, uint256 minimumCOMO_)",
    "function finalize(uint256 pollId)",
    "function getRoleAdmin(bytes32 role) view returns (bytes32)",
    "function grantRole(bytes32 role, address account)",
    "function hasRole(bytes32 role, address account) view returns (bool)",
    "function hashes(uint256, bytes32) view returns (bool)",
    "function initialize(address voteSignerAddress_, address comoAddress_)",
    "function isInProgress(uint256 pollId) view returns (bool)",
    "function isRevealedVote(uint256, uint256) view returns (bool)",
    "function pollResult(uint256 pollId) view returns (tuple(string candidate, uint256 votes)[])",
    "function polls(uint256) view returns (string title, uint256 startAt, uint256 due, uint256 minimumCOMO, uint256 totalVotedCOMO, uint256 revealedVotes, bool finalized)",
    "function remainingVotes(uint256 pollId) view returns (uint256)",
    "function renounceRole(bytes32 role, address account)",
    "function reset(uint256 pollId, uint256 missingOffset, tuple(uint256 comoAmount, bytes32 hash)[] missingCommitData)",
    "function reveal(uint256 pollId, tuple(uint256 votedCandidateId, bytes32 salt)[] data, uint256 offset)",
    "function revokeRole(bytes32 role, address account)",
    "function setVoteSignerAddress(address addr)",
    "function supportsInterface(bytes4 interfaceId) view returns (bool)",
    "function tokensReceived(address operator, address from, address to, uint256 amount, bytes userData, bytes operatorData)",
    "function totalVotes(uint256 pollId) view returns (uint256)",
    "function userVoteResult(uint256 pollId, address voter) view returns (tuple(string candidate, uint256 votes)[])",
    "function userVoteResults(uint256, address, uint256) view returns (uint256)",
    "function voteSignerAddress() view returns (address)",
    "function voters(uint256, uint256) view returns (address)",
    "function votes(uint256 pollId) view returns (tuple(uint256 comoAmount, bytes32 hash)[])",
    "function votesPerCandidates(uint256 pollId) view returns (uint256[])"
];
let $f94943c3ed27e058$var$contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)($f94943c3ed27e058$var$contractAddress, $f94943c3ed27e058$var$contractAbi, $f94943c3ed27e058$var$provider);
function $f94943c3ed27e058$var$GravityDetail() {
    let { gravityId: gravityId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    let [gravity, setGravity] = (0, $acw62.useState)(null);
    let [pollDetails, setPollDetails] = (0, $acw62.useState)({});
    let [voteResults, setVoteResults] = (0, $acw62.useState)({});
    let [choiceId, setChoiceId] = (0, $acw62.useState)(null);
    let [comoAmount, setComoAmount] = (0, $acw62.useState)(1);
    let [isVoting, setIsVoting] = (0, $acw62.useState)(false);
    let [voteError, setVoteError] = (0, $acw62.useState)(null);
    let currentAccount = (0, $f18c256353fe9c11$export$8a2442b306735398)();
    let ramperWalletSecrets = currentAccount?.ramperWalletSecrets;
    (0, $acw62.useEffect)(()=>{
        if (!currentAccount) return;
        let isCancelled = false;
        (async ()=>{
            let gravityData = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).getGravity(parseInt(gravityId));
            if (!isCancelled) setGravity(gravityData);
            let pollDetailsData = await Promise.all(gravityData.polls.map((poll)=>(0, $9105f8a53cedb7f3$export$cc1aced799785edc).getPollDetail(gravityData.id, poll.id)));
            if (!isCancelled) setPollDetails(Object.fromEntries(pollDetailsData.map((detail)=>[
                    detail.id,
                    detail
                ])));
        })();
        return ()=>void (isCancelled = true);
    }, [
        gravityId,
        currentAccount
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!gravity) return;
        let isCancelled = false;
        (async ()=>{
            let voteResultsData = await Promise.all(gravity.polls.filter((poll)=>poll.finalized).map((poll)=>$f94943c3ed27e058$var$contract.votesPerCandidates(poll.pollIdOnChain || poll.id).then((votes)=>({
                        pollId: poll.id,
                        votes: votes
                    }))));
            if (!isCancelled) setVoteResults(Object.fromEntries(voteResultsData.map(({ pollId: pollId, votes: votes })=>[
                    pollId,
                    votes
                ])));
        })();
        return ()=>void (isCancelled = true);
    }, [
        gravity
    ]);
    let handleVote = async (pollId)=>{
        if (!choiceId || comoAmount <= 0 || !ramperWalletSecrets) {
            setVoteError("Please select a choice, enter a valid COMO amount, and ensure you're logged in");
            return;
        }
        setIsVoting(true);
        setVoteError(null);
        try {
            let { version: version, dek: dek, encryptedKey: encryptedKey } = ramperWalletSecrets;
            let wallet = (0, $e31fa7eca94d8741$export$bcca3ea514774656).fromPhrase(await (0, $ba3d3511b573d5ac$export$4f15789826015814)(version, dek, encryptedKey), $f94943c3ed27e058$var$provider);
            let { callData: callData } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).fabricateVote("tripleS", pollId, choiceId, comoAmount);
            let abiCoder = new (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6)();
            let encodedVoteData = abiCoder.encode([
                "uint256",
                "bytes32",
                "bytes"
            ], [
                callData.pollIdOnChain,
                callData.hash,
                callData.signature
            ]);
            let erc777Interface = new (0, $fcb356ece91f4842$export$48cefb51a4e315b2)([
                "function send(address to, uint256 amount, bytes calldata data) external"
            ]);
            let txData = erc777Interface.encodeFunctionData("send", [
                $f94943c3ed27e058$var$contractAddress,
                (0, $e3b0a4d4db1a46c4$export$642c4e67bbdc0bc7)(comoAmount.toString()),
                encodedVoteData
            ]);
            console.log(txData);
            let tx = {
                to: $f94943c3ed27e058$var$contractAddress,
                data: txData
            };
            // FIXME: This keeps failing with the error 'execution reverted'
            let txResponse = await wallet.sendTransaction(tx);
            await txResponse.wait();
        } catch (error) {
            console.error(error);
            setVoteError("An error occurred while voting. Please try again.");
        } finally{
            setIsVoting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: gravity ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: gravity.title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: gravity.description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Polls"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            children: gravity.polls.map((poll)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: poll.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "Start Date: ",
                                                new Date(poll.startDate).toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "End Date: ",
                                                new Date(poll.endDate).toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "Finalized: ",
                                                poll.finalized ? "Yes" : "No"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Choices:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    children: pollDetails[poll.id]?.choices.map((choice, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "radio",
                                                                            name: `poll-${poll.id}`,
                                                                            value: choice.id,
                                                                            onChange: ()=>setChoiceId(choice.id),
                                                                            disabled: poll.finalized
                                                                        }),
                                                                        choice.title
                                                                    ]
                                                                }),
                                                                poll.finalized && voteResults[poll.id] ? ` - Votes: ${voteResults[poll.id][index] / 1000000000000000000n || 0}` : ""
                                                            ]
                                                        }, choice.id))
                                                })
                                            ]
                                        }),
                                        !poll.finalized && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "number",
                                                    min: "1",
                                                    value: comoAmount,
                                                    onChange: (e)=>setComoAmount(parseInt(e.target.value)),
                                                    placeholder: "COMO amount"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    onClick: ()=>handleVote(poll.id),
                                                    disabled: isVoting || !choiceId,
                                                    children: isVoting ? "Voting..." : "Vote"
                                                }),
                                                voteError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    style: {
                                                        color: "red"
                                                    },
                                                    children: voteError
                                                })
                                            ]
                                        })
                                    ]
                                }, poll.id))
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: "No gravity found."
        })
    });
}
var $f94943c3ed27e058$export$2e2bcd8739ae039 = $f94943c3ed27e058$var$GravityDetail;




var $acw62 = parcelRequire("acw62");






"use client";
var $87b8b5faab40ab5b$var$CardFooter = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $504373a3b2738bf1$export$c1f1c27d8fe70f39)();
    const footerStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.footer, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.footer) == null ? void 0 : _a.call(slots, {
            class: footerStyles
        }),
        ...otherProps,
        children: children
    });
});
$87b8b5faab40ab5b$var$CardFooter.displayName = "NextUI.CardFooter";
var $87b8b5faab40ab5b$export$69daf8f7928b4c69 = $87b8b5faab40ab5b$var$CardFooter;


"use client";
function $e9c2f6993092f42a$var$CheckIcon(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        "aria-hidden": "true",
        role: "presentation",
        viewBox: "0 0 17 18",
        ...otherProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            fill: "none",
            points: "1 9 7 14 15 4",
            stroke: "currentColor",
            strokeDasharray: 22,
            strokeDashoffset: isSelected ? 44 : 66,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            style: !disableAnimation && isSelected ? {
                transition: "stroke-dashoffset 250ms linear 0.2s"
            } : {}
        })
    });
}
function $e9c2f6993092f42a$var$IndeterminateIcon(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        stroke: "currentColor",
        strokeWidth: 3,
        viewBox: "0 0 24 24",
        ...otherProps,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("line", {
            x1: "21",
            x2: "3",
            y1: "12",
            y2: "12"
        })
    });
}
function $e9c2f6993092f42a$export$c0a1936901b0e55(props) {
    const { isIndeterminate: isIndeterminate, ...otherProps } = props;
    const BaseIcon = isIndeterminate ? $e9c2f6993092f42a$var$IndeterminateIcon : $e9c2f6993092f42a$var$CheckIcon;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
        ...otherProps
    });
}



"use client";
var [$f48775ee0589c9d1$export$95a3c27e07a551c3, $f48775ee0589c9d1$export$5575526870d5c2ae] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "CheckboxGroupContext",
    strict: false
});




var $acw62 = parcelRequire("acw62");



// src/components/checkbox.ts
var $d7edc562b7f0c5d9$export$b07e517d22efa1ca = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "group relative max-w-fit inline-flex items-center justify-start cursor-pointer tap-highlight-transparent p-2 -m-2",
        wrapper: [
            "relative",
            "inline-flex",
            "items-center",
            "justify-center",
            "flex-shrink-0",
            "overflow-hidden",
            "before:content-['']",
            "before:absolute",
            "before:inset-0",
            "before:border-solid",
            "before:border-2",
            "before:box-border",
            "before:border-default",
            "after:content-['']",
            "after:absolute",
            "after:inset-0",
            "after:scale-50",
            "after:opacity-0",
            "after:origin-center",
            "group-data-[selected=true]:after:scale-100",
            "group-data-[selected=true]:after:opacity-100",
            "group-data-[hover=true]:before:bg-default-100",
            ...(0, $eb279a3a1c5a3410$export$23b17e6367ab693)
        ],
        icon: "z-10 w-4 h-3 opacity-0 group-data-[selected=true]:opacity-100",
        label: "relative text-foreground select-none"
    },
    variants: {
        color: {
            default: {
                wrapper: "after:bg-default after:text-default-foreground text-default-foreground"
            },
            primary: {
                wrapper: "after:bg-primary after:text-primary-foreground text-primary-foreground"
            },
            secondary: {
                wrapper: "after:bg-secondary after:text-secondary-foreground text-secondary-foreground"
            },
            success: {
                wrapper: "after:bg-success after:text-success-foreground text-success-foreground"
            },
            warning: {
                wrapper: "after:bg-warning after:text-warning-foreground text-warning-foreground"
            },
            danger: {
                wrapper: "after:bg-danger after:text-danger-foreground text-danger-foreground"
            }
        },
        size: {
            sm: {
                wrapper: [
                    "w-4 h-4 mr-2 rtl:ml-2 rtl:mr-[unset]",
                    "rounded-[calc(theme(borderRadius.medium)*0.5)]",
                    "before:rounded-[calc(theme(borderRadius.medium)*0.5)]",
                    "after:rounded-[calc(theme(borderRadius.medium)*0.5)]"
                ],
                label: "text-small",
                icon: "w-3 h-2"
            },
            md: {
                wrapper: [
                    "w-5 h-5 mr-2 rtl:ml-2 rtl:mr-[unset]",
                    "rounded-[calc(theme(borderRadius.medium)*0.6)]",
                    "before:rounded-[calc(theme(borderRadius.medium)*0.6)]",
                    "after:rounded-[calc(theme(borderRadius.medium)*0.6)]"
                ],
                label: "text-medium",
                icon: "w-4 h-3"
            },
            lg: {
                wrapper: [
                    "w-6 h-6 mr-2 rtl:ml-2 rtl:mr-[unset]",
                    "rounded-[calc(theme(borderRadius.medium)*0.7)]",
                    "before:rounded-[calc(theme(borderRadius.medium)*0.7)]",
                    "after:rounded-[calc(theme(borderRadius.medium)*0.7)]"
                ],
                label: "text-large",
                icon: "w-5 h-4"
            }
        },
        radius: {
            none: {
                wrapper: "rounded-none before:rounded-none after:rounded-none"
            },
            sm: {
                wrapper: [
                    "rounded-[calc(theme(borderRadius.medium)*0.5)]",
                    "before:rounded-[calc(theme(borderRadius.medium)*0.5)]",
                    "after:rounded-[calc(theme(borderRadius.medium)*0.5)]"
                ]
            },
            md: {
                wrapper: [
                    "rounded-[calc(theme(borderRadius.medium)*0.6)]",
                    "before:rounded-[calc(theme(borderRadius.medium)*0.6)]",
                    "after:rounded-[calc(theme(borderRadius.medium)*0.6)]"
                ]
            },
            lg: {
                wrapper: [
                    "rounded-[calc(theme(borderRadius.medium)*0.7)]",
                    "before:rounded-[calc(theme(borderRadius.medium)*0.7)]",
                    "after:rounded-[calc(theme(borderRadius.medium)*0.7)]"
                ]
            },
            full: {
                wrapper: "rounded-full before:rounded-full after:rounded-full"
            }
        },
        lineThrough: {
            true: {
                label: [
                    "inline-flex",
                    "items-center",
                    "justify-center",
                    "before:content-['']",
                    "before:absolute",
                    "before:bg-foreground",
                    "before:w-0",
                    "before:h-0.5",
                    "group-data-[selected=true]:opacity-60",
                    "group-data-[selected=true]:before:w-full"
                ]
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                wrapper: "before:border-danger",
                label: "text-danger"
            }
        },
        disableAnimation: {
            true: {
                wrapper: "transition-none",
                icon: "transition-none",
                label: "transition-none"
            },
            false: {
                wrapper: [
                    "before:transition-colors",
                    "group-data-[pressed=true]:scale-95",
                    "transition-transform",
                    "after:transition-transform-opacity",
                    "after:!ease-linear",
                    "after:!duration-200",
                    "motion-reduce:transition-none"
                ],
                icon: "transition-opacity motion-reduce:transition-none",
                label: "transition-colors-opacity before:transition-width motion-reduce:transition-none"
            }
        }
    },
    defaultVariants: {
        color: "primary",
        size: "md",
        isDisabled: false,
        lineThrough: false
    }
});
var $d7edc562b7f0c5d9$export$b507296dd3c7a2ce = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "relative flex flex-col gap-2",
        label: "relative text-medium text-foreground-500",
        wrapper: "flex flex-col flex-wrap gap-2 data-[orientation=horizontal]:flex-row",
        description: "text-small text-foreground-400",
        errorMessage: "text-small text-danger"
    },
    variants: {
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5"
            }
        },
        isInvalid: {
            true: {
                description: "text-danger"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                description: "transition-colors !duration-150 motion-reduce:transition-none"
            }
        }
    },
    defaultVariants: {
        isInvalid: false,
        isRequired: false
    }
});








var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b4339c2d38764402$export$e375f10ce42261c5(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, $81bdb3f3d704c389$export$fc1a364ae1f3ff10)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $ff0f85aab4131368$export$cbe85ee05b554577)({
        ...props,
        isInvalid: isInvalid
    }, state, inputRef);
    (0, $5ebe99b56f6edee7$export$b8473d3665f3a75a)(props, validationState, inputRef);
    let { isIndeterminate: isIndeterminate, isRequired: isRequired, validationBehavior: validationBehavior = "aria" } = props;
    (0, $acw62.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            checked: isSelected,
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            required: isRequired && validationBehavior === "native"
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dd7cc37f25404243$export$ec98120685d4f57d = new WeakMap();




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b56f3b0feae20926$export$353b32fc6898d37d(props, state, inputRef) {
    const toggleState = (0, $7000e3ae65df6321$export$8042c6c013fd5226)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { name: name, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $dd7cc37f25404243$export$ec98120685d4f57d).get(state);
    var _props_validationBehavior;
    validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
    // Local validation for this checkbox.
    let { realtimeValidation: realtimeValidation } = (0, $81bdb3f3d704c389$export$fc1a364ae1f3ff10)({
        ...props,
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: "aria"
    });
    // Update the checkbox group state when realtime validation changes.
    let nativeValidation = (0, $acw62.useRef)((0, $81bdb3f3d704c389$export$dad6ae84456c676a));
    let updateValidation = ()=>{
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, $acw62.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    let displayValidation = validationBehavior === "native" ? state.displayValidation : combinedRealtimeValidation;
    var _props_isRequired;
    let res = (0, $b4339c2d38764402$export$e375f10ce42261c5)({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
        validationBehavior: validationBehavior,
        [(0, $81bdb3f3d704c389$export$a763b9476acd3eb)]: {
            realtimeValidation: combinedRealtimeValidation,
            displayValidation: displayValidation,
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation,
            updateValidation (v) {
                nativeValidation.current = v;
                updateValidation();
            }
        }
    }, toggleState, inputRef);
    return {
        ...res,
        inputProps: {
            ...res.inputProps,
            "aria-describedby": [
                props["aria-describedby"],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(" ") || undefined
        }
    };
}




"use client";
function $1f01b8de20668435$export$e375f10ce42261c5(props = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const groupContext = (0, $f48775ee0589c9d1$export$5575526870d5c2ae)();
    const isInGroup = !!groupContext;
    const { as: as, ref: ref, value: value = "", children: children, icon: icon, name: name, isRequired: isRequired, isReadOnly: isReadOnlyProp = false, autoFocus: autoFocus = false, isSelected: isSelectedProp, size: size = (_a = groupContext == null ? void 0 : groupContext.size) != null ? _a : "md", color: color = (_b = groupContext == null ? void 0 : groupContext.color) != null ? _b : "primary", radius: radius = groupContext == null ? void 0 : groupContext.radius, lineThrough: lineThrough = (_c = groupContext == null ? void 0 : groupContext.lineThrough) != null ? _c : false, isDisabled: isDisabledProp = (_d = groupContext == null ? void 0 : groupContext.isDisabled) != null ? _d : false, disableAnimation: disableAnimation = (_f = (_e = groupContext == null ? void 0 : groupContext.disableAnimation) != null ? _e : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _f : false, validationState: validationState, isInvalid: isInvalid = validationState ? validationState === "invalid" : (_g = groupContext == null ? void 0 : groupContext.isInvalid) != null ? _g : false, isIndeterminate: isIndeterminate = false, validationBehavior: validationBehavior = (_h = groupContext == null ? void 0 : groupContext.validationBehavior) != null ? _h : "aria", defaultSelected: defaultSelected, classNames: classNames, className: className, onValueChange: onValueChange, ...otherProps } = props;
    if (groupContext && (0, $337b0bbaace84edd$export$a866f231438cc228)) {
        if (isSelectedProp) (0, $9d7cf34bba787841$export$c106dd0671a0fc2d)("The Checkbox.Group is being used, `isSelected` will be ignored. Use the `value` of the Checkbox.Group instead.", "Checkbox");
        if (defaultSelected) (0, $9d7cf34bba787841$export$c106dd0671a0fc2d)("The Checkbox.Group is being used, `defaultSelected` will be ignored. Use the `defaultValue` of the Checkbox.Group instead.", "Checkbox");
    }
    const Component = as || "label";
    const domRef = (0, $acw62.useRef)(null);
    const inputRef = (0, $acw62.useRef)(null);
    let onChange = props.onChange;
    if (isInGroup) {
        const dispatch = ()=>{
            groupContext.groupState.resetValidation();
        };
        onChange = (0, $276a22df76563a4a$export$e08e3b67e392101e)(dispatch, onChange);
    }
    const labelId = (0, $acw62.useId)();
    const ariaCheckboxProps = (0, $acw62.useMemo)(()=>{
        return {
            name: name,
            value: value,
            children: children,
            autoFocus: autoFocus,
            defaultSelected: defaultSelected,
            validationBehavior: validationBehavior,
            isIndeterminate: isIndeterminate,
            isRequired: isRequired,
            isInvalid: isInvalid,
            isSelected: isSelectedProp,
            isDisabled: isDisabledProp,
            isReadOnly: isReadOnlyProp,
            "aria-label": (0, $bc1b15abc9efe839$export$a3d82bd9a7fbdcbb)(otherProps["aria-label"], children),
            "aria-labelledby": otherProps["aria-labelledby"] || labelId,
            onChange: onValueChange
        };
    }, [
        value,
        name,
        labelId,
        children,
        autoFocus,
        isInvalid,
        isIndeterminate,
        isDisabledProp,
        isReadOnlyProp,
        isSelectedProp,
        defaultSelected,
        validationBehavior,
        otherProps["aria-label"],
        otherProps["aria-labelledby"],
        onValueChange
    ]);
    const toggleState = (0, $7000e3ae65df6321$export$8042c6c013fd5226)(ariaCheckboxProps);
    const { inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isPressed: isPressedKeyboard } = isInGroup ? (0, $b56f3b0feae20926$export$353b32fc6898d37d)({
        ...ariaCheckboxProps
    }, groupContext.groupState, inputRef) : (0, $b4339c2d38764402$export$e375f10ce42261c5)({
        ...ariaCheckboxProps
    }, toggleState, inputRef);
    const isInteractionDisabled = isDisabled || isReadOnly;
    const [isPressed, setPressed] = (0, $acw62.useState)(false);
    const { pressProps: pressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: isInteractionDisabled,
        onPressStart (e) {
            if (e.pointerType !== "keyboard") setPressed(true);
        },
        onPressEnd (e) {
            if (e.pointerType !== "keyboard") setPressed(false);
        }
    });
    const pressed = isInteractionDisabled ? false : isPressed || isPressedKeyboard;
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: inputProps.disabled
    });
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: inputProps.autoFocus
    });
    const slots = (0, $acw62.useMemo)(()=>(0, $d7edc562b7f0c5d9$export$b07e517d22efa1ca)({
            color: color,
            size: size,
            radius: radius,
            isInvalid: isInvalid,
            lineThrough: lineThrough,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        color,
        size,
        radius,
        isInvalid,
        lineThrough,
        isDisabled,
        disableAnimation
    ]);
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const isInputRefChecked = !!inputRef.current.checked;
        toggleState.setSelected(isInputRefChecked);
    }, [
        inputRef.current
    ]);
    const onChangeProp = (0, $c33d700ad058062b$export$25bec8c6f54ee79a)(onChange);
    const handleCheckboxChange = (0, $acw62.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        onChangeProp == null || onChangeProp(event);
    }, [
        isReadOnly,
        isDisabled,
        onChangeProp
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (0, $acw62.useCallback)(()=>{
        return {
            ref: domRef,
            className: slots.base({
                class: baseStyles
            }),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected || isIndeterminate),
            "data-invalid": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isInvalid),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(pressed),
            "data-readonly": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(inputProps.readOnly),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-indeterminate": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isIndeterminate),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(hoverProps, pressProps, otherProps)
        };
    }, [
        slots,
        baseStyles,
        isDisabled,
        isSelected,
        isIndeterminate,
        isInvalid,
        isHovered,
        isFocused,
        pressed,
        inputProps.readOnly,
        isFocusVisible,
        hoverProps,
        pressProps,
        otherProps
    ]);
    const getWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "aria-hidden": true,
            className: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(slots.wrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            }))
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.wrapper
    ]);
    const getInputProps = (0, $acw62.useCallback)(()=>{
        return {
            ref: (0, $2bb49473be67834f$export$c9058316764c140e)(inputRef, ref),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(inputProps, focusProps),
            onChange: (0, $276a22df76563a4a$export$e08e3b67e392101e)(inputProps.onChange, handleCheckboxChange)
        };
    }, [
        inputProps,
        focusProps,
        handleCheckboxChange
    ]);
    const getLabelProps = (0, $acw62.useCallback)(()=>({
            id: labelId,
            className: slots.label({
                class: classNames == null ? void 0 : classNames.label
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        isDisabled,
        isSelected,
        isInvalid
    ]);
    const getIconProps = (0, $acw62.useCallback)(()=>({
            isSelected: isSelected,
            isIndeterminate: isIndeterminate,
            disableAnimation: disableAnimation,
            className: slots.icon({
                class: classNames == null ? void 0 : classNames.icon
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.icon,
        isSelected,
        isIndeterminate,
        disableAnimation
    ]);
    return {
        Component: Component,
        icon: icon,
        children: children,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        isFocused: isFocused,
        isHovered: isHovered,
        isFocusVisible: isFocusVisible,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getIconProps: getIconProps
    };
}





var $acw62 = parcelRequire("acw62");

"use client";
var $575e4434e57cabe0$var$Checkbox = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, icon: icon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e9c2f6993092f42a$export$c0a1936901b0e55), {}), getBaseProps: getBaseProps, getWrapperProps: getWrapperProps, getInputProps: getInputProps, getIconProps: getIconProps, getLabelProps: getLabelProps } = (0, $1f01b8de20668435$export$e375f10ce42261c5)({
        ...props,
        ref: ref
    });
    const clonedIcon = typeof icon === "function" ? icon(getIconProps()) : (0, $acw62.cloneElement)(icon, getIconProps());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
                elementType: "span",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ...getInputProps()
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getWrapperProps(),
                children: clonedIcon
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getLabelProps(),
                children: children
            })
        ]
    });
});
$575e4434e57cabe0$var$Checkbox.displayName = "NextUI.Checkbox";
var $575e4434e57cabe0$export$40f39952efc279e6 = $575e4434e57cabe0$var$Checkbox;








// src/components/chip.ts
var $2ce6a802135f6990$export$aa2a4c698c03a4c8 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "relative",
            "max-w-fit",
            "min-w-min",
            "inline-flex",
            "items-center",
            "justify-between",
            "box-border",
            "whitespace-nowrap"
        ],
        content: "flex-1 text-inherit font-normal",
        dot: [
            "w-2",
            "h-2",
            "ml-1",
            "rounded-full"
        ],
        avatar: "flex-shrink-0",
        closeButton: [
            "z-10",
            "appearance-none",
            "outline-none",
            "select-none",
            "transition-opacity",
            "opacity-70",
            "hover:opacity-100",
            "cursor-pointer",
            "active:opacity-disabled",
            "tap-highlight-transparent"
        ]
    },
    variants: {
        variant: {
            solid: {},
            bordered: {
                base: "border-medium bg-transparent"
            },
            light: {
                base: "bg-transparent"
            },
            flat: {},
            faded: {
                base: "border-medium"
            },
            shadow: {},
            dot: {
                base: "border-medium border-default text-foreground bg-transparent"
            }
        },
        color: {
            default: {
                dot: "bg-default-400"
            },
            primary: {
                dot: "bg-primary"
            },
            secondary: {
                dot: "bg-secondary"
            },
            success: {
                dot: "bg-success"
            },
            warning: {
                dot: "bg-warning"
            },
            danger: {
                dot: "bg-danger"
            }
        },
        size: {
            sm: {
                base: "px-1 h-6 text-tiny",
                content: "px-1",
                closeButton: "text-medium",
                avatar: "w-4 h-4"
            },
            md: {
                base: "px-1 h-7 text-small",
                content: "px-2",
                closeButton: "text-large",
                avatar: "w-5 h-5"
            },
            lg: {
                base: "px-2 h-8 text-medium",
                content: "px-2",
                closeButton: "text-xl",
                avatar: "w-6 h-6"
            }
        },
        radius: {
            none: {
                base: "rounded-none"
            },
            sm: {
                base: "rounded-small"
            },
            md: {
                base: "rounded-medium"
            },
            lg: {
                base: "rounded-large"
            },
            full: {
                base: "rounded-full"
            }
        },
        isOneChar: {
            true: {},
            false: {}
        },
        isCloseable: {
            true: {},
            false: {}
        },
        hasStartContent: {
            true: {}
        },
        hasEndContent: {
            true: {}
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        isCloseButtonFocusVisible: {
            true: {
                closeButton: [
                    ...(0, $eb279a3a1c5a3410$export$e0ed6e3275f8955),
                    "ring-1",
                    "rounded-full"
                ]
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        color: "default",
        size: "md",
        radius: "full",
        isDisabled: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.default
            }
        },
        {
            variant: "solid",
            color: "primary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.primary
            }
        },
        {
            variant: "solid",
            color: "secondary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.secondary
            }
        },
        {
            variant: "solid",
            color: "success",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.success
            }
        },
        {
            variant: "solid",
            color: "warning",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.warning
            }
        },
        {
            variant: "solid",
            color: "danger",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.danger
            }
        },
        {
            variant: "shadow",
            color: "default",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.default
            }
        },
        {
            variant: "shadow",
            color: "primary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.primary
            }
        },
        {
            variant: "shadow",
            color: "secondary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.secondary
            }
        },
        {
            variant: "shadow",
            color: "success",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.success
            }
        },
        {
            variant: "shadow",
            color: "warning",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.warning
            }
        },
        {
            variant: "shadow",
            color: "danger",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).shadow.danger
            }
        },
        {
            variant: "bordered",
            color: "default",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.default
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.primary
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.secondary
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.success
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.warning
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).bordered.danger
            }
        },
        {
            variant: "flat",
            color: "default",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.default
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.primary
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.secondary
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.success
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.warning
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).flat.danger
            }
        },
        {
            variant: "faded",
            color: "default",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.default
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.primary
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.secondary
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.success
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.warning
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).faded.danger
            }
        },
        {
            variant: "light",
            color: "default",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.default
            }
        },
        {
            variant: "light",
            color: "primary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.primary
            }
        },
        {
            variant: "light",
            color: "secondary",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.secondary
            }
        },
        {
            variant: "light",
            color: "success",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.success
            }
        },
        {
            variant: "light",
            color: "warning",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.warning
            }
        },
        {
            variant: "light",
            color: "danger",
            class: {
                base: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).light.danger
            }
        },
        {
            isOneChar: true,
            hasStartContent: false,
            hasEndContent: false,
            size: "sm",
            class: {
                base: "w-5 h-5 min-w-5 min-h-5"
            }
        },
        {
            isOneChar: true,
            hasStartContent: false,
            hasEndContent: false,
            size: "md",
            class: {
                base: "w-6 h-6 min-w-6 min-h-6"
            }
        },
        {
            isOneChar: true,
            hasStartContent: false,
            hasEndContent: false,
            size: "lg",
            class: {
                base: "w-7 h-7 min-w-7 min-h-7"
            }
        },
        {
            isOneChar: true,
            isCloseable: false,
            hasStartContent: false,
            hasEndContent: false,
            class: {
                base: "px-0 justify-center",
                content: "px-0 flex-none"
            }
        },
        {
            isOneChar: true,
            isCloseable: true,
            hasStartContent: false,
            hasEndContent: false,
            class: {
                base: "w-auto"
            }
        },
        {
            isOneChar: true,
            variant: "dot",
            class: {
                base: "w-auto h-7 px-1 items-center",
                content: "px-2"
            }
        },
        {
            hasStartContent: true,
            size: "sm",
            class: {
                content: "pl-0.5"
            }
        },
        {
            hasStartContent: true,
            size: [
                "md",
                "lg"
            ],
            class: {
                content: "pl-1"
            }
        },
        {
            hasEndContent: true,
            size: "sm",
            class: {
                content: "pr-0.5"
            }
        },
        {
            hasEndContent: true,
            size: [
                "md",
                "lg"
            ],
            class: {
                content: "pr-1"
            }
        }
    ]
});





var $acw62 = parcelRequire("acw62");
"use client";
function $e86c74f2db234913$export$d086eaf5893f194e(originalProps) {
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $2ce6a802135f6990$export$aa2a4c698c03a4c8).variantKeys);
    const { ref: ref, as: as, children: children, avatar: avatar, startContent: startContent, endContent: endContent, onClose: onClose, classNames: classNames, className: className, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const isCloseable = !!onClose;
    const isDotVariant = originalProps.variant === "dot";
    const { focusProps: closeFocusProps, isFocusVisible: isCloseButtonFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const isOneChar = (0, $acw62.useMemo)(()=>typeof children === "string" && (children == null ? void 0 : children.length) === 1, [
        children
    ]);
    const hasStartContent = (0, $acw62.useMemo)(()=>!!avatar || !!startContent, [
        avatar,
        startContent
    ]);
    const hasEndContent = (0, $acw62.useMemo)(()=>!!endContent || isCloseable, [
        endContent,
        isCloseable
    ]);
    const slots = (0, $acw62.useMemo)(()=>(0, $2ce6a802135f6990$export$aa2a4c698c03a4c8)({
            ...variantProps,
            hasStartContent: hasStartContent,
            hasEndContent: hasEndContent,
            isOneChar: isOneChar,
            isCloseable: isCloseable,
            isCloseButtonFocusVisible: isCloseButtonFocusVisible
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isCloseButtonFocusVisible,
        hasStartContent,
        hasEndContent,
        isOneChar,
        isCloseable
    ]);
    const { pressProps: closePressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled),
        onPress: onClose
    });
    const getChipProps = ()=>{
        return {
            ref: domRef,
            className: slots.base({
                class: baseStyles
            }),
            ...otherProps
        };
    };
    const getCloseButtonProps = ()=>{
        return {
            role: "button",
            tabIndex: 0,
            className: slots.closeButton({
                class: classNames == null ? void 0 : classNames.closeButton
            }),
            "aria-label": "close chip",
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(closePressProps, closeFocusProps)
        };
    };
    const getAvatarClone = (avatar2)=>{
        if (!(0, $acw62.isValidElement)(avatar2)) return null;
        return (0, $acw62.cloneElement)(avatar2, {
            className: slots.avatar({
                class: classNames == null ? void 0 : classNames.avatar
            })
        });
    };
    const getContentClone = (content)=>(0, $acw62.isValidElement)(content) ? (0, $acw62.cloneElement)(content, {
            className: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)("max-h-[80%]", content.props.className)
        }) : null;
    return {
        Component: Component,
        children: children,
        slots: slots,
        classNames: classNames,
        isDot: isDotVariant,
        isCloseable: isCloseable,
        startContent: getAvatarClone(avatar) || getContentClone(startContent),
        endContent: getContentClone(endContent),
        getCloseButtonProps: getCloseButtonProps,
        getChipProps: getChipProps
    };
}





var $acw62 = parcelRequire("acw62");

"use client";
var $09f39d5db2614b7e$var$Chip = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, slots: slots, classNames: classNames, isDot: isDot, isCloseable: isCloseable, startContent: startContent, endContent: endContent, getCloseButtonProps: getCloseButtonProps, getChipProps: getChipProps } = (0, $e86c74f2db234913$export$d086eaf5893f194e)({
        ...props,
        ref: ref
    });
    const start = (0, $acw62.useMemo)(()=>{
        if (isDot && !startContent) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: slots.dot({
                class: classNames == null ? void 0 : classNames.dot
            })
        });
        return startContent;
    }, [
        slots,
        startContent,
        isDot
    ]);
    const end = (0, $acw62.useMemo)(()=>{
        if (isCloseable) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            ...getCloseButtonProps(),
            children: endContent || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $674bd67e3ad1a850$export$2b32a5a2c6e4dc78), {})
        });
        return endContent;
    }, [
        endContent,
        isCloseable,
        getCloseButtonProps
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getChipProps(),
        children: [
            start,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: slots.content({
                    class: classNames == null ? void 0 : classNames.content
                }),
                children: children
            }),
            end
        ]
    });
});
$09f39d5db2614b7e$var$Chip.displayName = "NextUI.Chip";
var $09f39d5db2614b7e$export$54839a81113e9e92 = $09f39d5db2614b7e$var$Chip;


"use client";
var [$e6a1038e0fe5d8f3$export$59b7462f266cd53f, $e6a1038e0fe5d8f3$export$7bea016dc7ad2ddf] = (0, $55a4002fe538d791$export$fd42f52fd3ae1109)({
    name: "RadioGroupContext",
    strict: false
});



var $acw62 = parcelRequire("acw62");




// src/components/radio.ts
var $be7890a77d69f6d5$export$b56dc0f160585b86 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "group relative max-w-fit inline-flex items-center justify-start cursor-pointer tap-highlight-transparent p-2 -m-2",
        wrapper: [
            "relative",
            "inline-flex",
            "items-center",
            "justify-center",
            "flex-shrink-0",
            "overflow-hidden",
            "border-solid",
            "border-medium",
            "box-border",
            "border-default",
            "rounded-full",
            "group-data-[hover-unselected=true]:bg-default-100",
            ...(0, $eb279a3a1c5a3410$export$23b17e6367ab693)
        ],
        labelWrapper: "flex flex-col ml-1",
        control: [
            "z-10",
            "w-2",
            "h-2",
            "opacity-0",
            "scale-0",
            "origin-center",
            "rounded-full",
            "group-data-[selected=true]:opacity-100",
            "group-data-[selected=true]:scale-100"
        ],
        label: "relative text-foreground select-none",
        description: "relative text-foreground-400"
    },
    variants: {
        color: {
            default: {
                control: "bg-default-500 text-default-foreground",
                wrapper: "group-data-[selected=true]:border-default-500"
            },
            primary: {
                control: "bg-primary text-primary-foreground",
                wrapper: "group-data-[selected=true]:border-primary"
            },
            secondary: {
                control: "bg-secondary text-secondary-foreground",
                wrapper: "group-data-[selected=true]:border-secondary"
            },
            success: {
                control: "bg-success text-success-foreground",
                wrapper: "group-data-[selected=true]:border-success"
            },
            warning: {
                control: "bg-warning text-warning-foreground",
                wrapper: "group-data-[selected=true]:border-warning"
            },
            danger: {
                control: "bg-danger text-danger-foreground",
                wrapper: "group-data-[selected=true]:border-danger"
            }
        },
        size: {
            sm: {
                wrapper: "w-4 h-4",
                control: "w-1.5 h-1.5",
                labelWrapper: "ml-1",
                label: "text-small",
                description: "text-tiny"
            },
            md: {
                wrapper: "w-5 h-5",
                control: "w-2 h-2",
                labelWrapper: "ml-2 rtl:mr-2 rtl:ml-[unset]",
                label: "text-medium",
                description: "text-small"
            },
            lg: {
                wrapper: "w-6 h-6",
                control: "w-2.5 h-2.5",
                labelWrapper: "ml-2 rtl:mr-2 rtl:ml-[unset]",
                label: "text-large",
                description: "text-medium"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                control: "bg-danger text-danger-foreground",
                wrapper: "border-danger group-data-[selected=true]:border-danger",
                label: "text-danger",
                description: "text-danger-300"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                wrapper: [
                    "group-data-[pressed=true]:scale-95",
                    "transition-transform-colors",
                    "motion-reduce:transition-none"
                ],
                control: "transition-transform-opacity motion-reduce:transition-none",
                label: "transition-colors motion-reduce:transition-none",
                description: "transition-colors motion-reduce:transition-none"
            }
        }
    },
    defaultVariants: {
        color: "primary",
        size: "md",
        isDisabled: false,
        isInvalid: false
    }
});
var $be7890a77d69f6d5$export$7246d22ab0922ede = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "relative flex flex-col gap-2",
        label: "relative text-foreground-500",
        wrapper: "flex flex-col flex-wrap gap-2 data-[orientation=horizontal]:flex-row",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5"
            }
        },
        isInvalid: {
            true: {
                description: "text-danger"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                description: "transition-colors !duration-150 motion-reduce:transition-none"
            }
        }
    },
    defaultVariants: {
        isInvalid: false,
        isRequired: false
    }
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3e5881b0e5eb876a$export$37b65e5b5444d35c = new WeakMap();






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $37e9bd225cfc8096$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value, children: children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: isDisabled
    });
    // iOS does not toggle radios if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPress () {
            state.setSelectedValue(value);
        }
    });
    let { focusableProps: focusableProps } = (0, $4513518cfd051728$export$4c014de7c8940b4c)((0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name: name, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $3e5881b0e5eb876a$export$37b65e5b5444d35c).get(state);
    (0, $90b3fb06004350ee$export$5add1d006293d136)(ref, state.selectedValue, state.setSelectedValue);
    (0, $5ebe99b56f6edee7$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior
    }, state, ref);
    return {
        labelProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, {
            ...interactions,
            type: "radio",
            name: name,
            tabIndex: tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === "native",
            checked: checked,
            value: value,
            onChange: onChange,
            "aria-describedby": [
                props["aria-describedby"],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(" ") || undefined
        }),
        isDisabled: isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}






"use client";
function $7eed5c65df82c238$export$37b0961d2f4751e2(props) {
    var _a, _b, _c, _d, _e;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const groupContext = (0, $e6a1038e0fe5d8f3$export$7bea016dc7ad2ddf)();
    const { as: as, ref: ref, classNames: classNames, id: id, value: value, children: children, description: description, size: size = (_a = groupContext == null ? void 0 : groupContext.size) != null ? _a : "md", color: color = (_b = groupContext == null ? void 0 : groupContext.color) != null ? _b : "primary", isDisabled: isDisabledProp = (_c = groupContext == null ? void 0 : groupContext.isDisabled) != null ? _c : false, disableAnimation: disableAnimation = (_e = (_d = groupContext == null ? void 0 : groupContext.disableAnimation) != null ? _d : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _e : false, onChange: onChange = groupContext == null ? void 0 : groupContext.onChange, autoFocus: autoFocus = false, className: className, ...otherProps } = props;
    if (groupContext && (0, $337b0bbaace84edd$export$a866f231438cc228)) {
        if ("checked" in otherProps) (0, $9d7cf34bba787841$export$c106dd0671a0fc2d)('Remove props "checked" if in the Radio.Group.', "Radio");
        if (value === void 0) (0, $9d7cf34bba787841$export$c106dd0671a0fc2d)('Props "value" must be defined if in the Radio.Group.', "Radio");
    }
    const Component = as || "label";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const inputRef = (0, $acw62.useRef)(null);
    const labelId = (0, $acw62.useId)();
    const descriptionId = (0, $acw62.useId)();
    const isRequired = (0, $acw62.useMemo)(()=>{
        var _a2;
        return (_a2 = groupContext.isRequired) != null ? _a2 : false;
    }, [
        groupContext.isRequired
    ]);
    const isInvalid = groupContext.isInvalid;
    const ariaRadioProps = (0, $acw62.useMemo)(()=>{
        const ariaDescribedBy = [
            otherProps["aria-describedby"],
            descriptionId
        ].filter(Boolean).join(" ") || void 0;
        return {
            id: id,
            isRequired: isRequired,
            isDisabled: isDisabledProp,
            "aria-label": otherProps["aria-label"],
            "aria-labelledby": otherProps["aria-labelledby"] || labelId,
            "aria-describedby": ariaDescribedBy
        };
    }, [
        id,
        isDisabledProp,
        isRequired,
        description,
        otherProps["aria-label"],
        otherProps["aria-labelledby"],
        otherProps["aria-describedby"],
        descriptionId
    ]);
    const { inputProps: inputProps, isDisabled: isDisabled, isSelected: isSelected, isPressed: isPressedKeyboard } = (0, $37e9bd225cfc8096$export$37b0961d2f4751e2)({
        value: value,
        children: typeof children === "function" ? true : children,
        ...ariaRadioProps
    }, groupContext.groupState, inputRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const interactionDisabled = isDisabled || inputProps.readOnly;
    const [isPressed, setPressed] = (0, $acw62.useState)(false);
    const { pressProps: pressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: interactionDisabled,
        onPressStart (e) {
            if (e.pointerType !== "keyboard") setPressed(true);
        },
        onPressEnd (e) {
            if (e.pointerType !== "keyboard") setPressed(false);
        }
    });
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: interactionDisabled
    });
    const pressed = interactionDisabled ? false : isPressed || isPressedKeyboard;
    const slots = (0, $acw62.useMemo)(()=>(0, $be7890a77d69f6d5$export$b56dc0f160585b86)({
            color: color,
            size: size,
            isInvalid: isInvalid,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        color,
        size,
        isDisabled,
        isInvalid,
        disableAnimation
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ref: domRef,
            className: slots.base({
                class: baseStyles
            }),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected),
            "data-invalid": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isInvalid),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(pressed),
            "data-hover-unselected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered && !isSelected),
            "data-readonly": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(inputProps.readOnly),
            "aria-required": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isRequired),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(hoverProps, pressProps, otherProps)
        };
    }, [
        slots,
        baseStyles,
        domRef,
        isDisabled,
        isFocused,
        isFocusVisible,
        isSelected,
        isInvalid,
        isHovered,
        pressed,
        inputProps.readOnly,
        isRequired,
        otherProps
    ]);
    const getWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "aria-hidden": true,
            className: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(slots.wrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.wrapper, props2.className)
            }))
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.wrapper
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ref: inputRef,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(props2, inputProps, focusProps),
            onChange: (0, $276a22df76563a4a$export$e08e3b67e392101e)(inputProps.onChange, onChange)
        };
    }, [
        inputProps,
        focusProps,
        onChange
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {})=>({
            ...props2,
            id: labelId,
            className: slots.label({
                class: classNames == null ? void 0 : classNames.label
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        isDisabled,
        isSelected,
        isInvalid
    ]);
    const getLabelWrapperProps = (0, $acw62.useCallback)((props2 = {})=>({
            ...props2,
            className: slots.labelWrapper({
                class: classNames == null ? void 0 : classNames.labelWrapper
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.labelWrapper
    ]);
    const getControlProps = (0, $acw62.useCallback)((props2 = {})=>({
            ...props2,
            className: slots.control({
                class: classNames == null ? void 0 : classNames.control
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.control
    ]);
    const getDescriptionProps = (0, $acw62.useCallback)((props2 = {})=>({
            ...props2,
            id: descriptionId,
            className: slots.description({
                class: classNames == null ? void 0 : classNames.description
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    return {
        Component: Component,
        children: children,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        isFocusVisible: isFocusVisible,
        description: description,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getLabelWrapperProps: getLabelWrapperProps,
        getControlProps: getControlProps,
        getDescriptionProps: getDescriptionProps
    };
}





"use client";
var $df433e363e28b078$var$Radio = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, description: description, getBaseProps: getBaseProps, getWrapperProps: getWrapperProps, getInputProps: getInputProps, getLabelProps: getLabelProps, getLabelWrapperProps: getLabelWrapperProps, getControlProps: getControlProps, getDescriptionProps: getDescriptionProps } = (0, $7eed5c65df82c238$export$37b0961d2f4751e2)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
                elementType: "span",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ...getInputProps()
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getWrapperProps(),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                    ...getControlProps()
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...getLabelWrapperProps(),
                children: [
                    children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getLabelProps(),
                        children: children
                    }),
                    description && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...getDescriptionProps(),
                        children: description
                    })
                ]
            })
        ]
    });
});
$df433e363e28b078$var$Radio.displayName = "NextUI.Radio";
var $df433e363e28b078$export$ae409d22c5d3c393 = $df433e363e28b078$var$Radio;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $e90184212d2f0701$var$$a54cdc5c1942b639$var$instance = Math.round(Math.random() * 10000000000);
let $e90184212d2f0701$var$$a54cdc5c1942b639$var$i = 0;
function $e90184212d2f0701$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, $acw62.useMemo)(()=>props.name || `radio-group-${$e90184212d2f0701$var$$a54cdc5c1942b639$var$instance}-${++$e90184212d2f0701$var$$a54cdc5c1942b639$var$i}`, [
        props.name
    ]);
    var _props_defaultValue;
    let [selectedValue, setSelected] = (0, $aeb9a1fd28de218f$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
    let [lastFocusedValue, setLastFocusedValue] = (0, $acw62.useState)(null);
    let validation = (0, $81bdb3f3d704c389$export$fc1a364ae1f3ff10)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    return {
        ...validation,
        name: name,
        selectedValue: selectedValue,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? "invalid" : null),
        isInvalid: isInvalid
    };
}








/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $00905d44be62fae9$export$62b9571f283ff5c2(props, state) {
    let { name: name, isReadOnly: isReadOnly, isRequired: isRequired, isDisabled: isDisabled, orientation: orientation = "vertical", validationBehavior: validationBehavior = "aria" } = props;
    let { direction: direction } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $2532b24858cbaf4b$export$294aa081a6c6f55d)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span",
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps } = (0, $27a2d14f8c063b81$export$420e68273165f4ec)({
        onBlurWithin (e) {
            var _props_onBlur;
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case "ArrowRight":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";
                else nextDir = "next";
                break;
            case "ArrowLeft":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "next";
                else nextDir = "prev";
                break;
            case "ArrowDown":
                nextDir = "next";
                break;
            case "ArrowUp":
                nextDir = "prev";
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = (0, $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa)(e.currentTarget, {
            from: e.target
        });
        let nextElem;
        if (nextDir === "next") {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = (0, $fc8082d5d9c62cca$export$f680877a34711e37)(name);
    (0, $3e5881b0e5eb876a$export$37b65e5b5444d35c).set(state, {
        name: groupName,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    return {
        radioGroupProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: "radiogroup",
            onKeyDown: onKeyDown,
            "aria-invalid": state.isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-readonly": isReadOnly || undefined,
            "aria-required": isRequired || undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-orientation": orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}






"use client";
function $692b53c940523c7c$export$62b9571f283ff5c2(props) {
    var _a, _b;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const { as: as, ref: ref, classNames: classNames, children: children, label: label, value: value, name: name, isInvalid: isInvalidProp, validationState: validationState, validationBehavior: validationBehavior = (_a = globalContext == null ? void 0 : globalContext.validationBehavior) != null ? _a : "aria", size: size = "md", color: color = "primary", isDisabled: isDisabled = false, disableAnimation: disableAnimation = (_b = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false, orientation: orientation = "vertical", isRequired: isRequired = false, isReadOnly: isReadOnly, errorMessage: errorMessage, description: description, className: className, onChange: onChange, onValueChange: onValueChange, ...otherProps } = props;
    const Component = as || "div";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const otherPropsWithOrientation = (0, $acw62.useMemo)(()=>{
        return {
            ...otherProps,
            value: value,
            name: name,
            "aria-label": (0, $bc1b15abc9efe839$export$a3d82bd9a7fbdcbb)(otherProps["aria-label"], label),
            isRequired: isRequired,
            isReadOnly: isReadOnly,
            isInvalid: validationState === "invalid" || isInvalidProp,
            orientation: orientation,
            validationBehavior: validationBehavior,
            onChange: onValueChange
        };
    }, [
        otherProps,
        value,
        name,
        label,
        isRequired,
        isReadOnly,
        isInvalidProp,
        validationState,
        validationBehavior,
        orientation,
        onValueChange
    ]);
    const groupState = (0, $e90184212d2f0701$export$bca9d026f8e704eb)(otherPropsWithOrientation);
    const { labelProps: labelProps, radioGroupProps: groupProps, errorMessageProps: errorMessageProps, descriptionProps: descriptionProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $00905d44be62fae9$export$62b9571f283ff5c2)(otherPropsWithOrientation, groupState);
    const isInvalid = otherPropsWithOrientation.isInvalid || isAriaInvalid || groupState.isInvalid;
    const context = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            groupState: groupState,
            isRequired: isRequired,
            isInvalid: isInvalid,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation,
            onChange: onChange
        }), [
        size,
        color,
        isRequired,
        isDisabled,
        isInvalid,
        onChange,
        disableAnimation,
        groupState.name,
        groupState.isDisabled,
        groupState.isReadOnly,
        groupState.isRequired,
        groupState.selectedValue,
        groupState.lastFocusedValue
    ]);
    const slots = (0, $acw62.useMemo)(()=>(0, $be7890a77d69f6d5$export$7246d22ab0922ede)({
            isRequired: isRequired,
            isInvalid: isInvalid,
            disableAnimation: disableAnimation
        }), [
        isInvalid,
        isRequired,
        disableAnimation
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getGroupProps = (0, $acw62.useCallback)(()=>{
        return {
            ref: domRef,
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(groupProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }))
        };
    }, [
        domRef,
        slots,
        baseStyles,
        groupProps,
        otherProps
    ]);
    const getLabelProps = (0, $acw62.useCallback)(()=>{
        return {
            className: slots.label({
                class: classNames == null ? void 0 : classNames.label
            }),
            ...labelProps
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.label,
        labelProps,
        classNames == null ? void 0 : classNames.label
    ]);
    const getWrapperProps = (0, $acw62.useCallback)(()=>{
        return {
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            }),
            role: "presentation",
            "data-orientation": orientation
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.wrapper,
        orientation,
        slots.wrapper
    ]);
    const getDescriptionProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            className: slots.description({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description,
        descriptionProps,
        slots.description
    ]);
    const getErrorMessageProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            className: slots.errorMessage({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.errorMessage,
        errorMessageProps
    ]);
    return {
        Component: Component,
        children: children,
        label: label,
        context: context,
        description: description,
        isInvalid: isInvalid,
        errorMessage: typeof errorMessage === "function" ? errorMessage({
            isInvalid: isInvalid,
            validationErrors: validationErrors,
            validationDetails: validationDetails
        }) : errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" ")),
        getGroupProps: getGroupProps,
        getLabelProps: getLabelProps,
        getWrapperProps: getWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps
    };
}





"use client";
var $02b40243896087d2$var$RadioGroup = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, children: children, label: label, context: context, description: description, isInvalid: isInvalid, errorMessage: errorMessage, getGroupProps: getGroupProps, getLabelProps: getLabelProps, getWrapperProps: getWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps } = (0, $692b53c940523c7c$export$62b9571f283ff5c2)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ...getGroupProps(),
        children: [
            label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...getLabelProps(),
                children: label
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getWrapperProps(),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e6a1038e0fe5d8f3$export$59b7462f266cd53f), {
                    value: context,
                    children: children
                })
            }),
            isInvalid && errorMessage ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        ]
    });
});
$02b40243896087d2$var$RadioGroup.displayName = "NextUI.RadioGroup";
var $02b40243896087d2$export$cb30f4715ae71f77 = $02b40243896087d2$var$RadioGroup;




// src/components/select.ts
var $2e6e07926e181c80$export$2e6c959c16ff56b8 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: [
            "group inline-flex flex-col relative w-full"
        ],
        label: [
            "block",
            "absolute",
            "z-10",
            "origin-top-left",
            "rtl:origin-top-right",
            "subpixel-antialiased",
            "text-small",
            "text-foreground-500",
            "pointer-events-none"
        ],
        mainWrapper: "w-full flex flex-col",
        trigger: "relative px-3 gap-3 w-full inline-flex flex-row items-center shadow-sm outline-none tap-highlight-transparent",
        innerWrapper: "inline-flex h-full w-[calc(100%_-_theme(spacing.6))] min-h-4 items-center gap-1.5 box-border",
        selectorIcon: "absolute right-3 rtl:left-3 rtl:right-[unset] w-4 h-4",
        spinner: "absolute right-3 rtl:left-3 rtl:right-[unset]",
        value: [
            "text-foreground-500",
            "font-normal",
            "w-full",
            "text-left",
            "rtl:text-right"
        ],
        listboxWrapper: "scroll-py-6 max-h-64 w-full",
        listbox: "",
        popoverContent: "w-full p-1 overflow-hidden",
        helperWrapper: "p-1 flex relative flex-col gap-1.5",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        variant: {
            flat: {
                trigger: [
                    "bg-default-100",
                    "data-[hover=true]:bg-default-200",
                    "group-data-[focus=true]:bg-default-100"
                ]
            },
            faded: {
                trigger: [
                    "bg-default-100",
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400"
                ],
                value: "group-data-[has-value=true]:text-default-foreground"
            },
            bordered: {
                trigger: [
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400",
                    "data-[open=true]:border-default-foreground",
                    "data-[focus=true]:border-default-foreground",
                    "data-[focus=true]:border-default-foreground"
                ]
            },
            underlined: {
                trigger: [
                    "!px-1",
                    "!pb-0",
                    "!gap-0",
                    "relative",
                    "box-border",
                    "border-b-medium",
                    "shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "border-default-200",
                    "!rounded-none",
                    "hover:border-default-300",
                    "after:content-['']",
                    "after:w-0",
                    "after:origin-center",
                    "after:bg-default-foreground",
                    "after:absolute",
                    "after:left-1/2",
                    "after:-translate-x-1/2",
                    "after:-bottom-[2px]",
                    "after:h-[2px]",
                    "data-[open=true]:after:w-full",
                    "data-[focus=true]:after:w-full"
                ],
                label: "group-data-[filled=true]:text-foreground"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                label: "text-tiny",
                trigger: "h-8 min-h-8 px-2 rounded-small",
                value: "text-small"
            },
            md: {
                trigger: "h-10 min-h-10 rounded-medium",
                value: "text-small"
            },
            lg: {
                trigger: "h-12 min-h-12 rounded-large",
                value: "text-medium"
            }
        },
        radius: {
            none: {
                trigger: "rounded-none"
            },
            sm: {
                trigger: "rounded-small"
            },
            md: {
                trigger: "rounded-medium"
            },
            lg: {
                trigger: "rounded-large"
            },
            full: {
                trigger: "rounded-full"
            }
        },
        labelPlacement: {
            outside: {
                base: "flex flex-col"
            },
            "outside-left": {
                base: "flex-row items-center flex-nowrap items-start",
                label: "relative pr-2 rtl:pl-2 rtl:pr-[unset] text-foreground"
            },
            inside: {
                label: "text-tiny cursor-pointer",
                trigger: "flex-col items-start justify-center gap-0"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none",
                trigger: "pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                label: "!text-danger",
                value: "!text-danger",
                selectorIcon: "text-danger"
            }
        },
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5"
            }
        },
        isMultiline: {
            true: {
                label: "relative",
                trigger: "!h-auto"
            },
            false: {
                value: "truncate"
            }
        },
        disableAnimation: {
            true: {
                trigger: "after:transition-none",
                base: "transition-none",
                label: "transition-none",
                selectorIcon: "transition-none"
            },
            false: {
                base: "transition-background motion-reduce:transition-none !duration-150",
                label: [
                    "will-change-auto",
                    "origin-top-left",
                    "rtl:origin-top-right",
                    "!duration-200",
                    "!ease-out",
                    "transition-[transform,color,left,opacity]",
                    "motion-reduce:transition-none"
                ],
                selectorIcon: "transition-transform duration-150 ease motion-reduce:transition-none"
            }
        },
        disableSelectorIconRotation: {
            true: {},
            false: {
                selectorIcon: "data-[open=true]:rotate-180"
            }
        }
    },
    defaultVariants: {
        variant: "flat",
        color: "default",
        size: "md",
        labelPlacement: "inside",
        fullWidth: true,
        isDisabled: false,
        isMultiline: false,
        disableSelectorIconRotation: false
    },
    compoundVariants: [
        {
            variant: "flat",
            color: "default",
            class: {
                value: "group-data-[has-value=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                trigger: [
                    "bg-primary-50",
                    "text-primary",
                    "data-[hover=true]:bg-primary-100",
                    "group-data-[focus=true]:bg-primary-50"
                ],
                value: "text-primary",
                label: "text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                trigger: [
                    "bg-secondary-50",
                    "text-secondary",
                    "data-[hover=true]:bg-secondary-100",
                    "group-data-[focus=true]:bg-secondary-50"
                ],
                value: "text-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                trigger: [
                    "bg-success-50",
                    "text-success-600",
                    "dark:text-success",
                    "data-[hover=true]:bg-success-100",
                    "group-data-[focus=true]:bg-success-50"
                ],
                value: "text-success-600 dark:text-success",
                label: "text-success-600 dark:text-success"
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                trigger: [
                    "bg-warning-50",
                    "text-warning-600",
                    "dark:text-warning",
                    "data-[hover=true]:bg-warning-100",
                    "group-data-[focus=true]:bg-warning-50"
                ],
                value: "text-warning-600 dark:text-warning",
                label: "text-warning-600 dark:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                trigger: [
                    "bg-danger-50",
                    "text-danger",
                    "dark:text-danger-500",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ],
                value: "text-danger dark:text-danger-500",
                label: "text-danger dark:text-danger-500"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                trigger: "data-[hover=true]:border-primary",
                label: "text-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                trigger: "data-[hover=true]:border-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                trigger: "data-[hover=true]:border-success",
                label: "text-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                trigger: "data-[hover=true]:border-warning",
                label: "text-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                trigger: "data-[hover=true]:border-danger",
                label: "text-danger"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                value: "group-data-[has-value=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                trigger: "after:bg-primary",
                label: "text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                trigger: "after:bg-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                trigger: "after:bg-success",
                label: "text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                trigger: "after:bg-warning",
                label: "text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                trigger: "after:bg-danger",
                label: "text-danger"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                trigger: [
                    "data-[open=true]:border-primary",
                    "data-[focus=true]:border-primary"
                ],
                label: "text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                trigger: [
                    "data-[open=true]:border-secondary",
                    "data-[focus=true]:border-secondary"
                ],
                label: "text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                trigger: [
                    "data-[open=true]:border-success",
                    "data-[focus=true]:border-success"
                ],
                label: "text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                trigger: [
                    "data-[open=true]:border-warning",
                    "data-[focus=true]:border-warning"
                ],
                label: "text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                trigger: [
                    "data-[open=true]:border-danger",
                    "data-[focus=true]:border-danger"
                ],
                label: "text-danger"
            }
        },
        {
            labelPlacement: "inside",
            color: "default",
            class: {
                label: "group-data-[filled=true]:text-default-600"
            }
        },
        {
            labelPlacement: "outside",
            color: "default",
            class: {
                label: "group-data-[filled=true]:text-foreground"
            }
        },
        {
            radius: "full",
            size: [
                "sm"
            ],
            class: {
                trigger: "px-3"
            }
        },
        {
            radius: "full",
            size: "md",
            class: {
                trigger: "px-4"
            }
        },
        {
            radius: "full",
            size: "lg",
            class: {
                trigger: "px-5"
            }
        },
        {
            disableAnimation: false,
            variant: [
                "faded",
                "bordered"
            ],
            class: {
                trigger: "transition-colors motion-reduce:transition-none"
            }
        },
        {
            disableAnimation: false,
            variant: "underlined",
            class: {
                trigger: "after:transition-width motion-reduce:after:transition-none"
            }
        },
        {
            variant: [
                "flat",
                "faded"
            ],
            class: {
                trigger: [
                    ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
                ]
            }
        },
        {
            isInvalid: true,
            variant: "flat",
            class: {
                trigger: [
                    "bg-danger-50",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ]
            }
        },
        {
            isInvalid: true,
            variant: "bordered",
            class: {
                trigger: "!border-danger group-data-[focus=true]:border-danger"
            }
        },
        {
            isInvalid: true,
            variant: "underlined",
            class: {
                trigger: "after:bg-danger"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            class: {
                trigger: "h-12 min-h-12 py-1.5 px-3"
            }
        },
        {
            labelPlacement: "inside",
            size: "md",
            class: {
                trigger: "h-14 min-h-14 py-2"
            }
        },
        {
            labelPlacement: "inside",
            size: "lg",
            class: {
                label: "text-small",
                trigger: "h-16 min-h-16 py-2.5 gap-0"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "group-data-[filled=true]:pointer-events-auto"
                ]
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            class: {
                base: "group relative justify-end",
                label: [
                    "pb-0",
                    "z-20",
                    "top-1/2",
                    "-translate-y-1/2",
                    "group-data-[filled=true]:left-0",
                    "rtl:group-data-[filled=true]:right-0",
                    "rtl:group-data-[filled=true]:left-[unset]"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            class: {
                label: "group-data-[filled=true]:scale-85"
            }
        },
        {
            labelPlacement: "inside",
            size: [
                "sm",
                "md"
            ],
            class: {
                label: "text-small"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-4"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-4"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-5"
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_3.5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_4px)]"
                ]
            }
        },
        {
            labelPlacement: "outside",
            size: "sm",
            isMultiline: false,
            class: {
                label: [
                    "left-2",
                    "rtl:right-2",
                    "rtl:left-[unset]",
                    "text-tiny",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.tiny)/2_+_16px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_8px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "left-3",
                    "rtl:right-3",
                    "rtl:left-[unset]",
                    "text-small",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_20px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_10px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "left-3",
                    "rtl:right-3",
                    "rtl:left-[unset]",
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_24px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_12px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: true,
            class: {
                label: "pb-1.5"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "pe-2",
                    "max-w-full",
                    "text-ellipsis",
                    "overflow-hidden"
                ]
            }
        }
    ]
});




var $acw62 = parcelRequire("acw62");





// src/use-multiselect.ts







var $acw62 = parcelRequire("acw62");
function $dd9a2c68403bb4cb$export$efbfa63d6e989c0e(props, state, ref) {
    const { disallowEmptySelection: disallowEmptySelection, isDisabled: isDisabled } = props;
    const collator = (0, $42a2eb2bd28e75db$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    const delegate = (0, $acw62.useMemo)(()=>new (0, $376f10d3e3d8d3ed$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, null, collator), [
        state.collection,
        state.disabledKeys,
        collator
    ]);
    const { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $16a1933d449b51c0$export$dc9c12ed27dd1b49)({
        isDisabled: isDisabled,
        type: "listbox"
    }, state, ref);
    const triggerOnKeyDown = (e)=>{
        if (state.selectionMode === "single") switch(e.key){
            case "ArrowLeft":
                {
                    e.preventDefault();
                    const key = state.selectedKeys.size > 0 ? delegate.getKeyAbove(state.selectedKeys.values().next().value) : delegate.getFirstKey();
                    if (key) state.setSelectedKeys([
                        key
                    ]);
                    break;
                }
            case "ArrowRight":
                {
                    e.preventDefault();
                    const key = state.selectedKeys.size > 0 ? delegate.getKeyBelow(state.selectedKeys.values().next().value) : delegate.getFirstKey();
                    if (key) state.setSelectedKeys([
                        key
                    ]);
                    break;
                }
        }
    };
    const { typeSelectProps: typeSelectProps } = (0, $b0877533d50c8386$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKeys([
                key
            ]);
        }
    });
    const { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    const { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $2532b24858cbaf4b$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: "span",
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    const domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    const triggerProps = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(typeSelectProps, menuTriggerProps, fieldProps);
    const valueId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                var _a;
                if (!props.isDisabled) {
                    (_a = ref.current) == null || _a.focus();
                    (0, $b995f28c9a72ee4c$export$8397ddfc504fdb9a)("keyboard");
                }
            }
        },
        triggerProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, {
            ...triggerProps,
            onKeyDown: (0, $276a22df76563a4a$export$e08e3b67e392101e)(triggerProps.onKeyDown, triggerOnKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            "aria-labelledby": [
                valueId,
                domProps["aria-label"] !== void 0 ? domProps["aria-labelledby"] !== void 0 ? domProps["aria-labelledby"] : triggerProps.id : triggerProps["aria-labelledby"]
            ].join(" "),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            disallowEmptySelection: disallowEmptySelection,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                state.setFocused(false);
            },
            onFocus: menuProps == null ? void 0 : menuProps.onFocus,
            "aria-labelledby": [
                fieldProps["aria-labelledby"],
                triggerProps["aria-label"] && !fieldProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" ")
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

// src/use-multiselect-list-state.ts


var $acw62 = parcelRequire("acw62");
function $65ff849274ba6b3c$export$ce1d728ee50eab64(props) {
    const { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager, selectionManager: { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, selectionMode: selectionMode } } = (0, $3eb881aaecc1e120$export$2f645645f7bca764)(props);
    const missingKeys = (0, $acw62.useMemo)(()=>{
        if (!props.isLoading && selectedKeys.size !== 0) return Array.from(selectedKeys).filter(Boolean).filter((key)=>!collection.getItem(key));
        return [];
    }, [
        selectedKeys,
        collection
    ]);
    const selectedItems = selectedKeys.size !== 0 ? Array.from(selectedKeys).map((key)=>{
        return collection.getItem(key);
    }).filter(Boolean) : null;
    if (missingKeys.length) console.warn(`Select: Keys "${missingKeys.join(", ")}" passed to "selectedKeys" are not present in the collection.`);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectionMode: selectionMode,
        selectedKeys: selectedKeys,
        setSelectedKeys: setSelectedKeys.bind(selectionManager),
        selectedItems: selectedItems
    };
}





var $acw62 = parcelRequire("acw62");
function $a9f379e72ccc919b$export$85e876c5ce5df8f0(props) {
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    const triggerState = (0, $941f255681c12466$export$79fefeb1c2091ac3)(props);
    const listState = (0, $65ff849274ba6b3c$export$ce1d728ee50eab64)({
        ...props,
        onSelectionChange: (keys)=>{
            if (props.onSelectionChange != null) {
                if (keys === "all") props.onSelectionChange(new Set(listState.collection.getKeys()));
                else props.onSelectionChange(keys);
            }
            if (props.selectionMode === "single") triggerState.close();
        }
    });
    const validationState = (0, $81bdb3f3d704c389$export$fc1a364ae1f3ff10)({
        ...props,
        validationBehavior: "native",
        value: listState.selectedKeys
    });
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        focusStrategy: focusStrategy,
        close () {
            triggerState.close();
        },
        open (focusStrategy2 = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy2);
                triggerState.open();
            }
        },
        toggle (focusStrategy2 = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy2);
                triggerState.toggle();
                validationState.commitValidation();
            }
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}




"use client";
var $d42711db0fdc8a9b$export$703601b7e90536f8 = /* @__PURE__ */ new WeakMap();
function $d42711db0fdc8a9b$export$e64b2f635402ca43(originalProps) {
    var _a, _b, _c, _d, _e;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $2e6e07926e181c80$export$2e6c959c16ff56b8).variantKeys);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const { ref: ref, as: as, label: label, name: name, isLoading: isLoading, selectorIcon: selectorIcon, isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange, startContent: startContent, endContent: endContent, description: description, renderValue: renderValue, onSelectionChange: onSelectionChange, placeholder: placeholder, children: children, disallowEmptySelection: disallowEmptySelection = false, selectionMode: selectionMode = "single", spinnerRef: spinnerRef, scrollRef: scrollRefProp, popoverProps: popoverProps = {}, scrollShadowProps: scrollShadowProps = {}, listboxProps: listboxProps = {}, spinnerProps: spinnerProps = {}, validationState: validationState, onChange: onChange, onClose: onClose, className: className, classNames: classNames, ...otherProps } = props;
    const scrollShadowRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(scrollRefProp);
    const slotsProps = {
        popoverProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            placement: "bottom",
            triggerScaleOnOpen: false,
            offset: 5,
            disableAnimation: disableAnimation
        }, popoverProps),
        scrollShadowProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            ref: scrollShadowRef,
            isEnabled: (_c = originalProps.showScrollIndicators) != null ? _c : true,
            hideScrollBar: true,
            offset: 15
        }, scrollShadowProps),
        listboxProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)({
            disableAnimation: disableAnimation
        }, listboxProps)
    };
    const Component = as || "button";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const triggerRef = (0, $acw62.useRef)(null);
    const listBoxRef = (0, $acw62.useRef)(null);
    const popoverRef = (0, $acw62.useRef)(null);
    let state = (0, $a9f379e72ccc919b$export$85e876c5ce5df8f0)({
        ...props,
        isOpen: isOpen,
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        children: children,
        isRequired: originalProps.isRequired,
        isDisabled: originalProps.isDisabled,
        defaultOpen: defaultOpen,
        onOpenChange: (open)=>{
            onOpenChange == null || onOpenChange(open);
            if (!open) onClose == null || onClose();
        },
        onSelectionChange: (keys)=>{
            onSelectionChange == null || onSelectionChange(keys);
            if (onChange && typeof onChange === "function" && domRef.current) {
                const event = {
                    target: {
                        ...domRef.current,
                        value: Array.from(keys).join(","),
                        name: domRef.current.name
                    }
                };
                onChange(event);
            }
        }
    });
    state = {
        ...state,
        ...originalProps.isDisabled && {
            disabledKeys: /* @__PURE__ */ new Set([
                ...state.collection.getKeys()
            ])
        }
    };
    (0, $71777250bd01414e$export$deebe11a338de063)(()=>{
        var _a2;
        if (!((_a2 = domRef.current) == null ? void 0 : _a2.value)) return;
        state.setSelectedKeys(/* @__PURE__ */ new Set([
            ...state.selectedKeys,
            domRef.current.value
        ]));
    }, [
        domRef.current
    ]);
    const { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $dd9a2c68403bb4cb$export$efbfa63d6e989c0e)({
        ...props,
        disallowEmptySelection: disallowEmptySelection,
        isDisabled: originalProps.isDisabled
    }, state, triggerRef);
    const isInvalid = originalProps.isInvalid || validationState === "invalid" || isAriaInvalid;
    const { isPressed: isPressed, buttonProps: buttonProps } = (0, $99a1faa63f87ca63$export$1aff6edc04132adb)(triggerProps, triggerRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: originalProps.isDisabled
    });
    const labelPlacement = (0, $acw62.useMemo)(()=>{
        var _a2;
        if ((!originalProps.labelPlacement || originalProps.labelPlacement === "inside") && !label) return "outside";
        return (_a2 = originalProps.labelPlacement) != null ? _a2 : "inside";
    }, [
        originalProps.labelPlacement,
        label
    ]);
    const hasPlaceholder = !!placeholder;
    const shouldLabelBeOutside = labelPlacement === "outside-left" || labelPlacement === "outside" && (hasPlaceholder || !!originalProps.isMultiline);
    const shouldLabelBeInside = labelPlacement === "inside";
    const isOutsideLeft = labelPlacement === "outside-left";
    const isFilled = state.isOpen || hasPlaceholder || !!((_d = state.selectedItems) == null ? void 0 : _d.length) || !!startContent || !!endContent || !!originalProps.isMultiline;
    const hasValue = !!((_e = state.selectedItems) == null ? void 0 : _e.length);
    const hasLabel = !!label;
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const slots = (0, $acw62.useMemo)(()=>(0, $2e6e07926e181c80$export$2e6c959c16ff56b8)({
            ...variantProps,
            isInvalid: isInvalid,
            labelPlacement: labelPlacement,
            disableAnimation: disableAnimation,
            className: className
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isInvalid,
        labelPlacement,
        disableAnimation,
        className
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && popoverRef.current && listBoxRef.current) {
            let selectedItem = listBoxRef.current.querySelector("[aria-selected=true] [data-label=true]");
            let scrollShadow = scrollShadowRef.current;
            if (selectedItem && scrollShadow && selectedItem.parentElement) {
                let scrollShadowRect = scrollShadow == null ? void 0 : scrollShadow.getBoundingClientRect();
                let scrollShadowHeight = scrollShadowRect.height;
                scrollShadow.scrollTop = selectedItem.parentElement.offsetTop - scrollShadowHeight / 2 + selectedItem.parentElement.clientHeight / 2;
            }
        }
    }, [
        state.isOpen,
        disableAnimation
    ]);
    const errorMessage = typeof props.errorMessage === "function" ? props.errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : props.errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" "));
    const hasHelper = !!description || !!errorMessage;
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && popoverRef.current && triggerRef.current) {
            let selectRect = triggerRef.current.getBoundingClientRect();
            let popover = popoverRef.current;
            popover.style.width = selectRect.width + "px";
        }
    }, [
        state.isOpen
    ]);
    const getBaseProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-slot": "base",
            "data-filled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFilled),
            "data-has-value": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasValue),
            "data-has-label": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasLabel),
            "data-has-helper": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(hasHelper),
            "data-invalid": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isInvalid),
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2.className)
            }),
            ...props2
        }), [
        slots,
        hasHelper,
        hasValue,
        hasLabel,
        isFilled,
        baseStyles
    ]);
    const getTriggerProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ref: triggerRef,
            "data-slot": "trigger",
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(originalProps == null ? void 0 : originalProps.isDisabled),
            "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
            "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
            className: slots.trigger({
                class: classNames == null ? void 0 : classNames.trigger
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(buttonProps, focusProps, hoverProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(props2))
        };
    }, [
        slots,
        triggerRef,
        state.isOpen,
        classNames == null ? void 0 : classNames.trigger,
        originalProps == null ? void 0 : originalProps.isDisabled,
        isFocused,
        isPressed,
        isFocusVisible,
        isHovered,
        buttonProps,
        focusProps,
        hoverProps,
        otherProps,
        shouldFilterDOMProps
    ]);
    const getHiddenSelectProps = (0, $acw62.useCallback)((props2 = {})=>({
            state: state,
            triggerRef: triggerRef,
            selectRef: domRef,
            selectionMode: selectionMode,
            label: originalProps == null ? void 0 : originalProps.label,
            name: originalProps == null ? void 0 : originalProps.name,
            isRequired: originalProps == null ? void 0 : originalProps.isRequired,
            autoComplete: originalProps == null ? void 0 : originalProps.autoComplete,
            isDisabled: originalProps == null ? void 0 : originalProps.isDisabled,
            onChange: onChange,
            ...props2
        }), [
        state,
        selectionMode,
        originalProps == null ? void 0 : originalProps.label,
        originalProps == null ? void 0 : originalProps.autoComplete,
        originalProps == null ? void 0 : originalProps.name,
        originalProps == null ? void 0 : originalProps.isDisabled,
        triggerRef
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-slot": "label",
            className: slots.label({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.label, props2.className)
            }),
            ...labelProps,
            ...props2
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        labelProps
    ]);
    const getValueProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-slot": "value",
            className: slots.value({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.value, props2.className)
            }),
            ...valueProps,
            ...props2
        }), [
        slots,
        classNames == null ? void 0 : classNames.value,
        valueProps
    ]);
    const getListboxWrapperProps = (0, $acw62.useCallback)((props2 = {})=>({
            "data-slot": "listboxWrapper",
            className: slots.listboxWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.listboxWrapper, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(slotsProps.scrollShadowProps, props2)
        }), [
        slots.listboxWrapper,
        classNames == null ? void 0 : classNames.listboxWrapper,
        slotsProps.scrollShadowProps
    ]);
    const getListboxProps = (props2 = {})=>{
        return {
            state: state,
            ref: listBoxRef,
            "data-slot": "listbox",
            className: slots.listbox({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.listbox, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(slotsProps.listboxProps, props2, menuProps)
        };
    };
    const getPopoverProps = (0, $acw62.useCallback)((props2 = {})=>{
        var _a2, _b2;
        const popoverProps2 = (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(slotsProps.popoverProps, props2);
        return {
            state: state,
            triggerRef: triggerRef,
            ref: popoverRef,
            "data-slot": "popover",
            scrollRef: listBoxRef,
            triggerType: "listbox",
            classNames: {
                content: slots.popoverContent({
                    class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.popoverContent, props2.className)
                })
            },
            ...popoverProps2,
            offset: state.selectedItems && state.selectedItems.length > 0 ? state.selectedItems.length * 1e-8 + (((_a2 = slotsProps.popoverProps) == null ? void 0 : _a2.offset) || 0) : (_b2 = slotsProps.popoverProps) == null ? void 0 : _b2.offset,
            shouldCloseOnInteractOutside: (popoverProps2 == null ? void 0 : popoverProps2.shouldCloseOnInteractOutside) ? popoverProps2.shouldCloseOnInteractOutside : (element)=>(0, $6298ff82a135c7fc$export$ef74e55a94b62f23)(element, domRef, state)
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.popoverContent,
        slotsProps.popoverProps,
        triggerRef,
        state,
        state.selectedItems
    ]);
    const getSelectorIconProps = (0, $acw62.useCallback)(()=>({
            "data-slot": "selectorIcon",
            "aria-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            "data-open": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(state.isOpen),
            className: slots.selectorIcon({
                class: classNames == null ? void 0 : classNames.selectorIcon
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.selectorIcon,
        state.isOpen
    ]);
    const getInnerWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "innerWrapper",
            className: slots.innerWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.innerWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.innerWrapper
    ]);
    const getHelperWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "helperWrapper",
            className: slots.helperWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.helperWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.helperWrapper
    ]);
    const getDescriptionProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            "data-slot": "description",
            className: slots.description({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    const getMainWrapperProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "mainWrapper",
            className: slots.mainWrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.mainWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.mainWrapper
    ]);
    const getErrorMessageProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            "data-slot": "errorMessage",
            className: slots.errorMessage({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        errorMessageProps,
        classNames == null ? void 0 : classNames.errorMessage
    ]);
    const getSpinnerProps = (0, $acw62.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            "data-slot": "spinner",
            color: "current",
            size: "sm",
            ...spinnerProps,
            ...props2,
            ref: spinnerRef,
            className: slots.spinner({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.spinner, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        spinnerRef,
        spinnerProps,
        classNames == null ? void 0 : classNames.spinner
    ]);
    $d42711db0fdc8a9b$export$703601b7e90536f8.set(state, {
        isDisabled: originalProps == null ? void 0 : originalProps.isDisabled,
        isRequired: originalProps == null ? void 0 : originalProps.isRequired,
        name: originalProps == null ? void 0 : originalProps.name,
        validationBehavior: "native"
    });
    return {
        Component: Component,
        domRef: domRef,
        state: state,
        label: label,
        name: name,
        triggerRef: triggerRef,
        isLoading: isLoading,
        placeholder: placeholder,
        startContent: startContent,
        endContent: endContent,
        description: description,
        selectorIcon: selectorIcon,
        hasHelper: hasHelper,
        labelPlacement: labelPlacement,
        hasPlaceholder: hasPlaceholder,
        renderValue: renderValue,
        selectionMode: selectionMode,
        disableAnimation: disableAnimation,
        isOutsideLeft: isOutsideLeft,
        shouldLabelBeOutside: shouldLabelBeOutside,
        shouldLabelBeInside: shouldLabelBeInside,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        getBaseProps: getBaseProps,
        getTriggerProps: getTriggerProps,
        getLabelProps: getLabelProps,
        getValueProps: getValueProps,
        getListboxProps: getListboxProps,
        getPopoverProps: getPopoverProps,
        getSpinnerProps: getSpinnerProps,
        getMainWrapperProps: getMainWrapperProps,
        getListboxWrapperProps: getListboxWrapperProps,
        getHiddenSelectProps: getHiddenSelectProps,
        getInnerWrapperProps: getInnerWrapperProps,
        getHelperWrapperProps: getHelperWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps,
        getSelectorIconProps: getSelectorIconProps
    };
}







"use client";
function $473e51e6fe8368ed$export$f809e80f58e251d1(props, state, triggerRef) {
    var _a, _b;
    let data = (0, $d42711db0fdc8a9b$export$703601b7e90536f8).get(state) || {};
    let { autoComplete: autoComplete, name: name = data.name, isDisabled: isDisabled = data.isDisabled, selectionMode: selectionMode, onChange: onChange } = props;
    let { validationBehavior: validationBehavior, isRequired: isRequired } = data;
    let modality = (0, $b995f28c9a72ee4c$export$98e20ec92f614cfe)();
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $7d2c6e0c39112405$export$a966af930f325cab)();
    (0, $90b3fb06004350ee$export$5add1d006293d136)(props.selectRef, state.selectedKeys, state.setSelectedKeys);
    (0, $5ebe99b56f6edee7$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior,
        focus: ()=>{
            var _a2;
            return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
        }
    }, state, props.selectRef);
    return {
        containerProps: {
            ...visuallyHiddenProps,
            "aria-hidden": true,
            ["data-a11y-ignore"]: "aria-hidden-focus"
        },
        inputProps: {
            type: "text",
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            autoComplete: autoComplete,
            value: (_a = [
                ...state.selectedKeys
            ].join(",")) != null ? _a : "",
            required: isRequired,
            style: {
                fontSize: 16
            },
            onFocus: ()=>{
                var _a2;
                return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
            },
            disabled: isDisabled,
            onChange: ()=>{}
        },
        selectProps: {
            name: name,
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            size: state.collection.size,
            value: selectionMode === "multiple" ? [
                ...state.selectedKeys
            ].map((k)=>String(k)) : (_b = [
                ...state.selectedKeys
            ][0]) != null ? _b : "",
            multiple: selectionMode === "multiple",
            onChange: (e)=>{
                state.setSelectedKeys(e.target.value);
                onChange == null || onChange(e);
            }
        }
    };
}
function $473e51e6fe8368ed$export$cbd84cdb2e668835(props) {
    var _a;
    let { state: state, triggerRef: triggerRef, selectRef: selectRef, label: label, name: name, isDisabled: isDisabled } = props;
    let { containerProps: containerProps, inputProps: inputProps, selectProps: selectProps } = $473e51e6fe8368ed$export$f809e80f58e251d1({
        ...props,
        selectRef: selectRef
    }, state, triggerRef);
    if (state.collection.size <= 300) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...containerProps,
        "data-testid": "hidden-select-container",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...inputProps
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("label", {
                children: [
                    label,
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        ...selectProps,
                        ref: selectRef,
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("option", {}),
                            [
                                ...state.collection.getKeys()
                            ].map((key)=>{
                                let item = state.collection.getItem(key);
                                if ((item == null ? void 0 : item.type) === "item") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: item.key,
                                    children: item.textValue
                                }, item.key);
                            })
                        ]
                    })
                ]
            })
        ]
    });
    else if (name) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
        autoComplete: selectProps.autoComplete,
        disabled: isDisabled,
        name: name,
        type: "hidden",
        value: (_a = [
            ...state.selectedKeys
        ].join(",")) != null ? _a : ""
    });
    return null;
}










var $acw62 = parcelRequire("acw62");



"use client";
function $6ac24db504ef2115$var$Select(props, ref) {
    const { Component: Component, state: state, label: label, hasHelper: hasHelper, isLoading: isLoading, triggerRef: triggerRef, selectorIcon: selectorIcon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3d5bf69f39f72f17$export$4857d3f3f5f8319b), {}), description: description, errorMessage: errorMessage, isInvalid: isInvalid, startContent: startContent, endContent: endContent, placeholder: placeholder, renderValue: renderValue, isOutsideLeft: isOutsideLeft, disableAnimation: disableAnimation, getBaseProps: getBaseProps, getLabelProps: getLabelProps, getTriggerProps: getTriggerProps, getValueProps: getValueProps, getListboxProps: getListboxProps, getPopoverProps: getPopoverProps, getSpinnerProps: getSpinnerProps, getMainWrapperProps: getMainWrapperProps, getInnerWrapperProps: getInnerWrapperProps, getHiddenSelectProps: getHiddenSelectProps, getHelperWrapperProps: getHelperWrapperProps, getListboxWrapperProps: getListboxWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps, getSelectorIconProps: getSelectorIconProps } = (0, $d42711db0fdc8a9b$export$e64b2f635402ca43)({
        ...props,
        ref: ref
    });
    const labelContent = label ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...getLabelProps(),
        children: label
    }) : null;
    const clonedIcon = (0, $acw62.cloneElement)(selectorIcon, getSelectorIconProps());
    const helperWrapper = (0, $acw62.useMemo)(()=>{
        if (!hasHelper) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...getHelperWrapperProps(),
            children: isInvalid && errorMessage ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        });
    }, [
        hasHelper,
        isInvalid,
        errorMessage,
        description,
        getHelperWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    const renderSelectedItem = (0, $acw62.useMemo)(()=>{
        var _a;
        if (!((_a = state.selectedItems) == null ? void 0 : _a.length)) return placeholder;
        if (renderValue && typeof renderValue === "function") {
            const mappedItems = [
                ...state.selectedItems
            ].map((item)=>({
                    key: item.key,
                    data: item.value,
                    type: item.type,
                    props: item.props,
                    textValue: item.textValue,
                    rendered: item.rendered,
                    "aria-label": item["aria-label"]
                }));
            return renderValue(mappedItems);
        }
        return state.selectedItems.map((item)=>item.textValue).join(", ");
    }, [
        state.selectedItems,
        renderValue,
        placeholder
    ]);
    const renderIndicator = (0, $acw62.useMemo)(()=>{
        if (isLoading) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ff0009cdb8e38ea8$export$b67103861f057d1a), {
            ...getSpinnerProps()
        });
        return clonedIcon;
    }, [
        isLoading,
        clonedIcon,
        getSpinnerProps
    ]);
    const popoverContent = (0, $acw62.useMemo)(()=>state.isOpen ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $eb832465a4ea348e$export$4f32f7e42026f90b), {
            ...getPopoverProps(),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $67ab465da978cead$export$bef3e985c75eafb5), {
                ...getListboxWrapperProps(),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $29de8649494b89cd$export$3f842a5957aa0e7a), {
                    ...getListboxProps()
                })
            })
        }) : null, [
        state.isOpen,
        getPopoverProps,
        state,
        triggerRef,
        getListboxWrapperProps,
        getListboxProps
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $473e51e6fe8368ed$export$cbd84cdb2e668835), {
                ...getHiddenSelectProps()
            }),
            isOutsideLeft ? labelContent : null,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...getMainWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
                        ...getTriggerProps(),
                        children: [
                            !isOutsideLeft ? labelContent : null,
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                ...getInnerWrapperProps(),
                                children: [
                                    startContent,
                                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        ...getValueProps(),
                                        children: renderSelectedItem
                                    }),
                                    endContent && state.selectedItems && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
                                        elementType: "span",
                                        children: ","
                                    }),
                                    endContent
                                ]
                            }),
                            renderIndicator
                        ]
                    }),
                    helperWrapper
                ]
            }),
            disableAnimation ? popoverContent : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: popoverContent
            })
        ]
    });
}
var $6ac24db504ef2115$export$5f058b6414bc662f = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)($6ac24db504ef2115$var$Select);
$6ac24db504ef2115$var$Select.displayName = "NextUI.Select";


"use client";
var $586c05b4a2af2627$var$TabItemBase = (0, $805dabd401117505$export$6d08773d2e66f8f2);
var $586c05b4a2af2627$export$e694ae5b295abf40 = $586c05b4a2af2627$var$TabItemBase;




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $95d9ad6a2a44012e$export$552312adfd451dab = new WeakMap();
function $95d9ad6a2a44012e$var$$2140fb2337097f2d$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $95d9ad6a2a44012e$export$37cd4213f2ad742e(state, columnKey) {
    let gridId = $95d9ad6a2a44012e$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error("Unknown grid");
    return `${gridId}-${$95d9ad6a2a44012e$var$$2140fb2337097f2d$var$normalizeKey(columnKey)}`;
}
function $95d9ad6a2a44012e$export$19baff3266315d44(state, rowKey, columnKey) {
    let gridId = $95d9ad6a2a44012e$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error("Unknown grid");
    return `${gridId}-${$95d9ad6a2a44012e$var$$2140fb2337097f2d$var$normalizeKey(rowKey)}-${$95d9ad6a2a44012e$var$$2140fb2337097f2d$var$normalizeKey(columnKey)}`;
}
function $95d9ad6a2a44012e$export$85069b70317f543(state, rowKey) {
    // A row is labelled by it's row headers.
    return [
        ...state.collection.rowHeaderColumnKeys
    ].map((columnKey)=>$95d9ad6a2a44012e$export$19baff3266315d44(state, rowKey, columnKey)).join(" ");
}


var $16c136a6f5c8cad6$export$2e2bcd8739ae039 = {};
$16c136a6f5c8cad6$export$2e2bcd8739ae039 = {
    "ascending": `\u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "ascendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "columnSize": (args)=>`${args.value} \u{628}\u{627}\u{644}\u{628}\u{643}\u{633}\u{644}`,
    "descending": `\u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "descendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "resizerDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} Enter \u{644}\u{628}\u{62F}\u{621} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectAll": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{644}`,
    "sortable": `\u{639}\u{645}\u{648}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{62A}\u{631}\u{62A}\u{64A}\u{628}`
};


var $d2ca834c45489730$export$2e2bcd8739ae039 = {};
$d2ca834c45489730$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432}\u{44A}\u{432} \u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}\u{435}\u{43B}\u{430}`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432} \u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{442}\u{435}`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectAll": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{43E}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{449}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`
};


var $ef1c1077b7277253$export$2e2bcd8739ae039 = {};
$ef1c1077b7277253$export$2e2bcd8739ae039 = {
    "ascending": `vzestupn\u{11B}`,
    "ascendingSort": (args)=>`\u{159}azeno vzestupn\u{11B} podle sloupce ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixel\u{16F}`,
    "descending": `sestupn\u{11B}`,
    "descendingSort": (args)=>`\u{159}azeno sestupn\u{11B} podle sloupce ${args.columnName}`,
    "resizerDescription": `Stisknut\xedm kl\xe1vesy Enter za\u{10D}nete m\u{11B}nit velikost`,
    "select": `Vybrat`,
    "selectAll": `Vybrat v\u{161}e`,
    "sortable": `sloupec s mo\u{17E}nost\xed \u{159}azen\xed`
};


var $1b1b051cae975f3d$export$2e2bcd8739ae039 = {};
$1b1b051cae975f3d$export$2e2bcd8739ae039 = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i stigende r\xe6kkef\xf8lge`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `faldende`,
    "descendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i faldende r\xe6kkef\xf8lge`,
    "resizerDescription": `Tryk p\xe5 Enter for at \xe6ndre st\xf8rrelse`,
    "select": `V\xe6lg`,
    "selectAll": `V\xe6lg alle`,
    "sortable": `sorterbar kolonne`
};


var $f8a469125022f983$export$2e2bcd8739ae039 = {};
$f8a469125022f983$export$2e2bcd8739ae039 = {
    "ascending": `aufsteigend`,
    "ascendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in aufsteigender Reihenfolge`,
    "columnSize": (args)=>`${args.value} Pixel`,
    "descending": `absteigend`,
    "descendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in absteigender Reihenfolge`,
    "resizerDescription": `Eingabetaste zum Starten der Gr\xf6\xdfen\xe4nderung dr\xfccken`,
    "select": `Ausw\xe4hlen`,
    "selectAll": `Alles ausw\xe4hlen`,
    "sortable": `sortierbare Spalte`
};


var $580fb85837ad8dbd$export$2e2bcd8739ae039 = {};
$580fb85837ad8dbd$export$2e2bcd8739ae039 = {
    "ascending": `\u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "ascendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `\u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "descendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "resizerDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3B1}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE}\u{3C2} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3CC}\u{3BB}\u{3C9}\u{3BD}`,
    "sortable": `\u{3A3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}`
};


var $4b77d44ddc106a5b$export$2e2bcd8739ae039 = {};
$4b77d44ddc106a5b$export$2e2bcd8739ae039 = {
    "select": `Select`,
    "selectAll": `Select All`,
    "sortable": `sortable column`,
    "ascending": `ascending`,
    "descending": `descending`,
    "ascendingSort": (args)=>`sorted by column ${args.columnName} in ascending order`,
    "descendingSort": (args)=>`sorted by column ${args.columnName} in descending order`,
    "columnSize": (args)=>`${args.value} pixels`,
    "resizerDescription": `Press Enter to start resizing`
};


var $cfab3c9136015c3d$export$2e2bcd8739ae039 = {};
$cfab3c9136015c3d$export$2e2bcd8739ae039 = {
    "ascending": `de subida`,
    "ascendingSort": (args)=>`ordenado por columna ${args.columnName} en orden de subida`,
    "columnSize": (args)=>`${args.value} p\xedxeles`,
    "descending": `de bajada`,
    "descendingSort": (args)=>`ordenado por columna ${args.columnName} en orden de bajada`,
    "resizerDescription": `Pulse Intro para empezar a redimensionar`,
    "select": `Seleccionar`,
    "selectAll": `Seleccionar todos`,
    "sortable": `columna ordenable`
};


var $486c460807ae7c07$export$2e2bcd8739ae039 = {};
$486c460807ae7c07$export$2e2bcd8739ae039 = {
    "ascending": `t\xf5usev j\xe4rjestus`,
    "ascendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} t\xf5usvas j\xe4rjestuses`,
    "columnSize": (args)=>`${args.value} pikslit`,
    "descending": `laskuv j\xe4rjestus`,
    "descendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} laskuvas j\xe4rjestuses`,
    "resizerDescription": `Suuruse muutmise alustamiseks vajutage klahvi Enter`,
    "select": `Vali`,
    "selectAll": `Vali k\xf5ik`,
    "sortable": `sorditav veerg`
};


var $e2df8a1e0226eba3$export$2e2bcd8739ae039 = {};
$e2df8a1e0226eba3$export$2e2bcd8739ae039 = {
    "ascending": `nouseva`,
    "ascendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan nousevassa j\xe4rjestyksess\xe4`,
    "columnSize": (args)=>`${args.value} pikseli\xe4`,
    "descending": `laskeva`,
    "descendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan laskevassa j\xe4rjestyksess\xe4`,
    "resizerDescription": `Aloita koon muutos painamalla Enter-n\xe4pp\xe4int\xe4`,
    "select": `Valitse`,
    "selectAll": `Valitse kaikki`,
    "sortable": `lajiteltava sarake`
};


var $e3180d7312191d42$export$2e2bcd8739ae039 = {};
$e3180d7312191d42$export$2e2bcd8739ae039 = {
    "ascending": `croissant`,
    "ascendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre croissant`,
    "columnSize": (args)=>`${args.value}\xa0pixels`,
    "descending": `d\xe9croissant`,
    "descendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre d\xe9croissant`,
    "resizerDescription": `Appuyez sur Entr\xe9e pour commencer le redimensionnement.`,
    "select": `S\xe9lectionner`,
    "selectAll": `S\xe9lectionner tout`,
    "sortable": `colonne triable`
};


var $ebf98fb574514750$export$2e2bcd8739ae039 = {};
$ebf98fb574514750$export$2e2bcd8739ae039 = {
    "ascending": `\u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "ascendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "columnSize": (args)=>`${args.value} \u{5E4}\u{5D9}\u{5E7}\u{5E1}\u{5DC}\u{5D9}\u{5DD}`,
    "descending": `\u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "descendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "resizerDescription": `\u{5D4}\u{5E7}\u{5E9} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5E0}\u{5D5}\u{5EA} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5D5}\u{5D3}\u{5DC}`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectAll": `\u{5D1}\u{5D7}\u{5E8} \u{5D4}\u{5DB}\u{5D5}\u{5DC}`,
    "sortable": `\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} \u{5E9}\u{5E0}\u{5D9}\u{5EA}\u{5DF} \u{5DC}\u{5DE}\u{5D9}\u{5D9}\u{5DF}`
};


var $45235ff08b87d1aa$export$2e2bcd8739ae039 = {};
$45235ff08b87d1aa$export$2e2bcd8739ae039 = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`razvrstano po stupcima ${args.columnName} rastu\u{107}em redoslijedom`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`razvrstano po stupcima ${args.columnName} padaju\u{107}im redoslijedom`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Odaberite`,
    "selectAll": `Odaberite sve`,
    "sortable": `stupac koji se mo\u{17E}e razvrstati`
};


var $978e1b97a428640a$export$2e2bcd8739ae039 = {};
$978e1b97a428640a$export$2e2bcd8739ae039 = {
    "ascending": `n\xf6vekv\u{151}`,
    "ascendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, n\xf6vekv\u{151} sorrendben`,
    "columnSize": (args)=>`${args.value} k\xe9ppont`,
    "descending": `cs\xf6kken\u{151}`,
    "descendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, cs\xf6kken\u{151} sorrendben`,
    "resizerDescription": `Nyomja le az Enter billenty\u{171}t az \xe1tm\xe9retez\xe9s megkezd\xe9s\xe9hez`,
    "select": `Kijel\xf6l\xe9s`,
    "selectAll": `\xd6sszes kijel\xf6l\xe9se`,
    "sortable": `rendezend\u{151} oszlop`
};


var $d7215832b82bb3ce$export$2e2bcd8739ae039 = {};
$d7215832b82bb3ce$export$2e2bcd8739ae039 = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`in ordine crescente in base alla colonna ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`in ordine decrescente in base alla colonna ${args.columnName}`,
    "resizerDescription": `Premi Invio per iniziare a ridimensionare`,
    "select": `Seleziona`,
    "selectAll": `Seleziona tutto`,
    "sortable": `colonna ordinabile`
};


var $7bfadf1cd66fd235$export$2e2bcd8739ae039 = {};
$7bfadf1cd66fd235$export$2e2bcd8739ae039 = {
    "ascending": `\u{6607}\u{9806}`,
    "ascendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{6607}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "columnSize": (args)=>`${args.value} \u{30D4}\u{30AF}\u{30BB}\u{30EB}`,
    "descending": `\u{964D}\u{9806}`,
    "descendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{964D}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "resizerDescription": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{3092}\u{958B}\u{59CB}`,
    "select": `\u{9078}\u{629E}`,
    "selectAll": `\u{3059}\u{3079}\u{3066}\u{9078}\u{629E}`,
    "sortable": `\u{4E26}\u{3079}\u{66FF}\u{3048}\u{53EF}\u{80FD}\u{306A}\u{5217}`
};


var $eded3d8e8b4c2a40$export$2e2bcd8739ae039 = {};
$eded3d8e8b4c2a40$export$2e2bcd8739ae039 = {
    "ascending": `\u{C624}\u{B984}\u{CC28}\u{C21C}`,
    "ascendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{C624}\u{B984}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "columnSize": (args)=>`${args.value} \u{D53D}\u{C140}`,
    "descending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C}`,
    "descendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{B0B4}\u{B9BC}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "resizerDescription": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectAll": `\u{BAA8}\u{B450} \u{C120}\u{D0DD}`,
    "sortable": `\u{C815}\u{B82C} \u{AC00}\u{B2A5}\u{D55C} \u{C5F4}`
};


var $4ddd1ef778a7ad83$export$2e2bcd8739ae039 = {};
$4ddd1ef778a7ad83$export$2e2bcd8739ae039 = {
    "ascending": `did\u{117}jan\u{10D}ia tvarka`,
    "ascendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} did\u{117}jan\u{10D}ia tvarka`,
    "columnSize": (args)=>`${args.value} piks.`,
    "descending": `ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "descendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "resizerDescription": `Paspauskite \u{201E}Enter\u{201C}, kad prad\u{117}tum\u{117}te keisti dyd\u{12F}`,
    "select": `Pasirinkti`,
    "selectAll": `Pasirinkti visk\u{105}`,
    "sortable": `rikiuojamas stulpelis`
};


var $6f778bd2672027a9$export$2e2bcd8739ae039 = {};
$6f778bd2672027a9$export$2e2bcd8739ae039 = {
    "ascending": `augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "ascendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "columnSize": (args)=>`${args.value} pikse\u{13C}i`,
    "descending": `dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "descendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "resizerDescription": `Nospiediet Enter, lai s\u{101}ktu izm\u{113}ru main\u{12B}\u{161}anu`,
    "select": `Atlas\u{12B}t`,
    "selectAll": `Atlas\u{12B}t visu`,
    "sortable": `k\u{101}rtojam\u{101} kolonna`
};


var $2ad407504db979c2$export$2e2bcd8739ae039 = {};
$2ad407504db979c2$export$2e2bcd8739ae039 = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sortert etter kolonne ${args.columnName} i stigende rekkef\xf8lge`,
    "columnSize": (args)=>`${args.value} piksler`,
    "descending": `synkende`,
    "descendingSort": (args)=>`sortert etter kolonne ${args.columnName} i synkende rekkef\xf8lge`,
    "resizerDescription": `Trykk p\xe5 Enter for \xe5 starte st\xf8rrelsesendring`,
    "select": `Velg`,
    "selectAll": `Velg alle`,
    "sortable": `kolonne som kan sorteres`
};


var $df711d46bdc3b6f1$export$2e2bcd8739ae039 = {};
$df711d46bdc3b6f1$export$2e2bcd8739ae039 = {
    "ascending": `oplopend`,
    "ascendingSort": (args)=>`gesorteerd in oplopende volgorde in kolom ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `aflopend`,
    "descendingSort": (args)=>`gesorteerd in aflopende volgorde in kolom ${args.columnName}`,
    "resizerDescription": `Druk op Enter om het formaat te wijzigen`,
    "select": `Selecteren`,
    "selectAll": `Alles selecteren`,
    "sortable": `sorteerbare kolom`
};


var $4d582943a98edbf3$export$2e2bcd8739ae039 = {};
$4d582943a98edbf3$export$2e2bcd8739ae039 = {
    "ascending": `rosn\u{105}co`,
    "ascendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku rosn\u{105}cym`,
    "columnSize": (args)=>`Liczba pikseli: ${args.value}`,
    "descending": `malej\u{105}co`,
    "descendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku malej\u{105}cym`,
    "resizerDescription": `Naci\u{15B}nij Enter, aby rozpocz\u{105}\u{107} zmienianie rozmiaru`,
    "select": `Zaznacz`,
    "selectAll": `Zaznacz wszystko`,
    "sortable": `kolumna z mo\u{17C}liwo\u{15B}ci\u{105} sortowania`
};


var $5d650c0bf592f5cf$export$2e2bcd8739ae039 = {};
$5d650c0bf592f5cf$export$2e2bcd8739ae039 = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem crescente`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem decrescente`,
    "resizerDescription": `Pressione Enter para come\xe7ar a redimensionar`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `coluna classific\xe1vel`
};


var $50e09e7b8d840f7e$export$2e2bcd8739ae039 = {};
$50e09e7b8d840f7e$export$2e2bcd8739ae039 = {
    "ascending": `ascendente`,
    "ascendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem ascendente`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `descendente`,
    "descendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem descendente`,
    "resizerDescription": `Prima Enter para iniciar o redimensionamento`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `Coluna orden\xe1vel`
};


var $4bdeb41188084d52$export$2e2bcd8739ae039 = {};
$4bdeb41188084d52$export$2e2bcd8739ae039 = {
    "ascending": `cresc\u{103}toare`,
    "ascendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine cresc\u{103}toare`,
    "columnSize": (args)=>`${args.value} pixeli`,
    "descending": `descresc\u{103}toare`,
    "descendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine descresc\u{103}toare`,
    "resizerDescription": `Ap\u{103}sa\u{21B}i pe Enter pentru a \xeencepe redimensionarea`,
    "select": `Selectare`,
    "selectAll": `Selectare total\u{103}`,
    "sortable": `coloan\u{103} sortabil\u{103}`
};


var $806933b0faa9e03c$export$2e2bcd8739ae039 = {};
$806933b0faa9e03c$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{435}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44F}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}.`,
    "descending": `\u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    "resizerDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{43E}\u{432}`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{443}\u{435}\u{43C}\u{44B}\u{439} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446}`
};


var $f7546d3c0cebe59d$export$2e2bcd8739ae039 = {};
$f7546d3c0cebe59d$export$2e2bcd8739ae039 = {
    "ascending": `vzostupne`,
    "ascendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "columnSize": (args)=>`Po\u{10D}et pixelov: ${args.value}`,
    "descending": `zostupne`,
    "descendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "resizerDescription": `Stla\u{10D}en\xedm kl\xe1vesu Enter za\u{10D}nete zmenu ve\u{13E}kosti`,
    "select": `Vybra\u{165}`,
    "selectAll": `Vybra\u{165} v\u{161}etko`,
    "sortable": `zoradite\u{13E}n\xfd st\u{13A}pec`
};


var $5d5e4af482000dc7$export$2e2bcd8739ae039 = {};
$5d5e4af482000dc7$export$2e2bcd8739ae039 = {
    "ascending": `nara\u{161}\u{10D}ajo\u{10D}e`,
    "ascendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v nara\u{161}\u{10D}ajo\u{10D}em vrstnem redu`,
    "columnSize": (args)=>`${args.value} slikovnih pik`,
    "descending": `padajo\u{10D}e`,
    "descendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v padajo\u{10D}em vrstnem redu`,
    "resizerDescription": `Pritisnite tipko Enter da za\u{10D}nete spreminjati velikost`,
    "select": `Izberite`,
    "selectAll": `Izberite vse`,
    "sortable": `razvrstljivi stolpec`
};


var $6c992f74b1fd98b3$export$2e2bcd8739ae039 = {};
$6c992f74b1fd98b3$export$2e2bcd8739ae039 = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`sortirano po kolonama ${args.columnName} rastu\u{107}im redosledom`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`sortirano po kolonama ${args.columnName} padaju\u{107}im redosledom`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Izaberite`,
    "selectAll": `Izaberite sve`,
    "sortable": `kolona koja se mo\u{17E}e sortirati`
};


var $a64ecd2709b71ce4$export$2e2bcd8739ae039 = {};
$a64ecd2709b71ce4$export$2e2bcd8739ae039 = {
    "ascending": `stigande`,
    "ascendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i stigande ordning`,
    "columnSize": (args)=>`${args.value} pixlar`,
    "descending": `fallande`,
    "descendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i fallande ordning`,
    "resizerDescription": `Tryck p\xe5 Retur f\xf6r att b\xf6rja \xe4ndra storlek`,
    "select": `Markera`,
    "selectAll": `Markera allt`,
    "sortable": `sorterbar kolumn`
};


var $6f1ead633f0ca904$export$2e2bcd8739ae039 = {};
$6f1ead633f0ca904$export$2e2bcd8739ae039 = {
    "ascending": `artan s\u{131}rada`,
    "ascendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re artan d\xfczende s\u{131}rala`,
    "columnSize": (args)=>`${args.value} piksel`,
    "descending": `azalan s\u{131}rada`,
    "descendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re azalan d\xfczende s\u{131}rala`,
    "resizerDescription": `Yeniden boyutland\u{131}rmak i\xe7in Enter'a bas\u{131}n`,
    "select": `Se\xe7`,
    "selectAll": `T\xfcm\xfcn\xfc Se\xe7`,
    "sortable": `S\u{131}ralanabilir s\xfctun`
};


var $cc1cbd486d236044$export$2e2bcd8739ae039 = {};
$cc1cbd486d236044$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "ascendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{456}\u{43A}\u{441}.`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "descendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{437}\u{43C}\u{456}\u{43D}\u{443} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectAll": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{435}\u{446}\u{44C}`
};


var $b7218cf199b16f33$export$2e2bcd8739ae039 = {};
$b7218cf199b16f33$export$2e2bcd8739ae039 = {
    "ascending": `\u{5347}\u{5E8F}`,
    "ascendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{964D}\u{5E8F}`,
    "descendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "resizerDescription": `\u{6309}\u{201C}\u{8F93}\u{5165}\u{201D}\u{952E}\u{5F00}\u{59CB}\u{8C03}\u{6574}\u{5927}\u{5C0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectAll": `\u{5168}\u{9009}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{5217}`
};


var $e90dff6b933ef28f$export$2e2bcd8739ae039 = {};
$e90dff6b933ef28f$export$2e2bcd8739ae039 = {
    "ascending": `\u{905E}\u{589E}`,
    "ascendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{589E}\u{6392}\u{5E8F}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{905E}\u{6E1B}`,
    "descendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{6E1B}\u{6392}\u{5E8F}`,
    "resizerDescription": `\u{6309} Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{8ABF}\u{6574}\u{5927}\u{5C0F}`,
    "select": `\u{9078}\u{53D6}`,
    "selectAll": `\u{5168}\u{9078}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{6B04}`
};


var $c1d04d5abf7d86c5$export$2e2bcd8739ae039 = {};
$c1d04d5abf7d86c5$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $16c136a6f5c8cad6$export$2e2bcd8739ae039),
    "bg-BG": (0, $d2ca834c45489730$export$2e2bcd8739ae039),
    "cs-CZ": (0, $ef1c1077b7277253$export$2e2bcd8739ae039),
    "da-DK": (0, $1b1b051cae975f3d$export$2e2bcd8739ae039),
    "de-DE": (0, $f8a469125022f983$export$2e2bcd8739ae039),
    "el-GR": (0, $580fb85837ad8dbd$export$2e2bcd8739ae039),
    "en-US": (0, $4b77d44ddc106a5b$export$2e2bcd8739ae039),
    "es-ES": (0, $cfab3c9136015c3d$export$2e2bcd8739ae039),
    "et-EE": (0, $486c460807ae7c07$export$2e2bcd8739ae039),
    "fi-FI": (0, $e2df8a1e0226eba3$export$2e2bcd8739ae039),
    "fr-FR": (0, $e3180d7312191d42$export$2e2bcd8739ae039),
    "he-IL": (0, $ebf98fb574514750$export$2e2bcd8739ae039),
    "hr-HR": (0, $45235ff08b87d1aa$export$2e2bcd8739ae039),
    "hu-HU": (0, $978e1b97a428640a$export$2e2bcd8739ae039),
    "it-IT": (0, $d7215832b82bb3ce$export$2e2bcd8739ae039),
    "ja-JP": (0, $7bfadf1cd66fd235$export$2e2bcd8739ae039),
    "ko-KR": (0, $eded3d8e8b4c2a40$export$2e2bcd8739ae039),
    "lt-LT": (0, $4ddd1ef778a7ad83$export$2e2bcd8739ae039),
    "lv-LV": (0, $6f778bd2672027a9$export$2e2bcd8739ae039),
    "nb-NO": (0, $2ad407504db979c2$export$2e2bcd8739ae039),
    "nl-NL": (0, $df711d46bdc3b6f1$export$2e2bcd8739ae039),
    "pl-PL": (0, $4d582943a98edbf3$export$2e2bcd8739ae039),
    "pt-BR": (0, $5d650c0bf592f5cf$export$2e2bcd8739ae039),
    "pt-PT": (0, $50e09e7b8d840f7e$export$2e2bcd8739ae039),
    "ro-RO": (0, $4bdeb41188084d52$export$2e2bcd8739ae039),
    "ru-RU": (0, $806933b0faa9e03c$export$2e2bcd8739ae039),
    "sk-SK": (0, $f7546d3c0cebe59d$export$2e2bcd8739ae039),
    "sl-SI": (0, $5d5e4af482000dc7$export$2e2bcd8739ae039),
    "sr-SP": (0, $6c992f74b1fd98b3$export$2e2bcd8739ae039),
    "sv-SE": (0, $a64ecd2709b71ce4$export$2e2bcd8739ae039),
    "tr-TR": (0, $6f1ead633f0ca904$export$2e2bcd8739ae039),
    "uk-UA": (0, $cc1cbd486d236044$export$2e2bcd8739ae039),
    "zh-CN": (0, $b7218cf199b16f33$export$2e2bcd8739ae039),
    "zh-TW": (0, $e90dff6b933ef28f$export$2e2bcd8739ae039)
};




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9f525a3b0fffde56$export$e6235c0d09b995d0 = new WeakMap();


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6fe7e04ee350a224$export$de79e2c695e052f3(element) {
    if ($6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $6fe7e04ee350a224$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $6fe7e04ee350a224$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $6fe7e04ee350a224$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $6fe7e04ee350a224$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $6fe7e04ee350a224$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

const $197c48392f4e1d6f$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $197c48392f4e1d6f$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $197c48392f4e1d6f$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $cf870a9bbd9ff446$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $cf870a9bbd9ff446$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $2cc678f6ff87f7f4$export$9ac100e40613ea10 = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $2cc678f6ff87f7f4$export$186c6964ca17d99 = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $2cc678f6ff87f7f4$export$7bef049ce92e4224 = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $2cc678f6ff87f7f4$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $2cc678f6ff87f7f4$export$fedb369cb70207f1 = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$export$186c6964ca17d99() || $2cc678f6ff87f7f4$export$7bef049ce92e4224();
});
const $2cc678f6ff87f7f4$export$e1865c3bedcd822b = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$export$9ac100e40613ea10() || $2cc678f6ff87f7f4$export$fedb369cb70207f1();
});
const $2cc678f6ff87f7f4$export$78551043582a6a98 = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$2cc678f6ff87f7f4$export$6446a186d09e379e();
});
const $2cc678f6ff87f7f4$export$6446a186d09e379e = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $2cc678f6ff87f7f4$export$a11b0059900ceec8 = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $2cc678f6ff87f7f4$export$b7d78993b74f766d = $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$cached(function() {
    return $2cc678f6ff87f7f4$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1ff97716fa10ea55$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $2cc678f6ff87f7f4$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $1ff97716fa10ea55$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $2cc678f6ff87f7f4$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $012705f78676000f$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $012705f78676000f$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($012705f78676000f$var$$b5e257d569688ac6$var$defaultContext);
const $012705f78676000f$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $012705f78676000f$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($012705f78676000f$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $012705f78676000f$var$$b5e257d569688ac6$var$useCounter(cur === $012705f78676000f$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $012705f78676000f$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($012705f78676000f$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($012705f78676000f$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $012705f78676000f$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $012705f78676000f$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$012705f78676000f$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $012705f78676000f$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($012705f78676000f$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $012705f78676000f$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $012705f78676000f$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $012705f78676000f$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($012705f78676000f$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $012705f78676000f$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $012705f78676000f$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $012705f78676000f$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $012705f78676000f$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($012705f78676000f$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $012705f78676000f$var$$b5e257d569688ac6$var$defaultContext && !$012705f78676000f$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $012705f78676000f$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $012705f78676000f$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($012705f78676000f$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$012705f78676000f$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $012705f78676000f$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $012705f78676000f$var$$b5e257d569688ac6$var$useModernSSRSafeId : $012705f78676000f$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $012705f78676000f$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $012705f78676000f$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $012705f78676000f$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $012705f78676000f$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($012705f78676000f$var$$b5e257d569688ac6$var$subscribe, $012705f78676000f$var$$b5e257d569688ac6$var$getSnapshot, $012705f78676000f$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($012705f78676000f$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality = null;
let $08afaaadcf52b950$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $08afaaadcf52b950$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $08afaaadcf52b950$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $08afaaadcf52b950$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $2cc678f6ff87f7f4$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($08afaaadcf52b950$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $1ff97716fa10ea55$export$60278871457622de)(e)) {
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $08afaaadcf52b950$export$d90243b58daecda7.get((0, $197c48392f4e1d6f$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(element);
    const documentObject = (0, $197c48392f4e1d6f$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $08afaaadcf52b950$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $08afaaadcf52b950$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(element);
    const documentObject = (0, $197c48392f4e1d6f$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$08afaaadcf52b950$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $08afaaadcf52b950$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $08afaaadcf52b950$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $08afaaadcf52b950$export$d90243b58daecda7.delete(windowObject);
};
function $08afaaadcf52b950$export$2f1888112f558a7d(element) {
    const documentObject = (0, $197c48392f4e1d6f$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $08afaaadcf52b950$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $08afaaadcf52b950$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$08afaaadcf52b950$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $08afaaadcf52b950$export$2f1888112f558a7d();
function $08afaaadcf52b950$export$b9b3dfddab17db27() {
    return $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $08afaaadcf52b950$export$630ff653c5ada6a9() {
    return $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality;
}
function $08afaaadcf52b950$export$8397ddfc504fdb9a(modality) {
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality = modality;
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $08afaaadcf52b950$export$98e20ec92f614cfe() {
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($08afaaadcf52b950$var$$507fabe10e71c6fb$var$currentModality);
        };
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $08afaaadcf52b950$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $012705f78676000f$export$535bd6ca7f90a273)() ? null : modality;
}
const $08afaaadcf52b950$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $08afaaadcf52b950$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$08afaaadcf52b950$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$08afaaadcf52b950$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $08afaaadcf52b950$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $08afaaadcf52b950$export$b9b3dfddab17db27());
    $08afaaadcf52b950$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $08afaaadcf52b950$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $08afaaadcf52b950$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$08afaaadcf52b950$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($08afaaadcf52b950$export$b9b3dfddab17db27());
        };
        $08afaaadcf52b950$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $08afaaadcf52b950$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df3ab836248960e6$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(element);
    if ((0, $08afaaadcf52b950$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $cf870a9bbd9ff446$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(element);
        });
    } else (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(element);
}



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $aae4f1966d9b61f4$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $aae4f1966d9b61f4$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $aae4f1966d9b61f4$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $aae4f1966d9b61f4$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $aae4f1966d9b61f4$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $aae4f1966d9b61f4$export$e989c0fffaa6b27a(element.parentElement, element));
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d51a89e8879dada7$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $abb89b02b945ae0b$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $abb89b02b945ae0b$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
let $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = null;
function $abb89b02b945ae0b$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)(null);
    let endRef = (0, $acw62.useRef)(null);
    let scopeRef = (0, $acw62.useRef)([]);
    let { parentNode: parentNode } = (0, $acw62.useContext)($abb89b02b945ae0b$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $acw62.useMemo)(()=>new $abb89b02b945ae0b$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $abb89b02b945ae0b$export$d06fae2ee68b101e.root;
        if ($abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope && !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isAncestorScope($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $abb89b02b945ae0b$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        let node = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        let stopPropagation = (e)=>e.stopPropagation();
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($abb89b02b945ae0b$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return ()=>{
            for (let node of nodes)node.removeEventListener($abb89b02b945ae0b$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
        };
    }, [
        children
    ]);
    $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $acw62.useEffect)(()=>{
        const activeElement = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $abb89b02b945ae0b$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope || $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(parentScope))) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $abb89b02b945ae0b$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $acw62.useMemo)(()=>$abb89b02b945ae0b$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $acw62.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($abb89b02b945ae0b$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $abb89b02b945ae0b$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($abb89b02b945ae0b$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $197c48392f4e1d6f$export$b204af158042fbac)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $197c48392f4e1d6f$export$b204af158042fbac)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $abb89b02b945ae0b$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $abb89b02b945ae0b$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $abb89b02b945ae0b$export$4c063cf1350e6fed(element) {
    return element.matches($abb89b02b945ae0b$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)(undefined);
    let raf = (0, $acw62.useRef)(undefined);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope || $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isAncestorScope($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope.current) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusFirstInScope($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope.current) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusFirstInScope($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $abb89b02b945ae0b$export$d06fae2ee68b101e.traverse($abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $abb89b02b945ae0b$export$1258395f99bf9cbf(element) {
    return $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInChildScope(element, $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $df3ab836248960e6$export$80f3e147d781571c)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    return nextNode;
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement($abb89b02b945ae0b$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== "undefined" ? (0, $197c48392f4e1d6f$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope || $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isAncestorScope($abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $197c48392f4e1d6f$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $abb89b02b945ae0b$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $abb89b02b945ae0b$var$$9bf71ea28793e738$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $abb89b02b945ae0b$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                let node = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$getFirstInScope(treeNode.scopeRef.current, true);
                                $abb89b02b945ae0b$var$$9bf71ea28793e738$var$restoreFocusToElement(node);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($abb89b02b945ae0b$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(node);
}
function $abb89b02b945ae0b$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $abb89b02b945ae0b$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $abb89b02b945ae0b$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $197c48392f4e1d6f$export$b204af158042fbac)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $aae4f1966d9b61f4$export$e989c0fffaa6b27a)(node) && (!scope || $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $abb89b02b945ae0b$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $197c48392f4e1d6f$export$b204af158042fbac)(root).activeElement;
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $197c48392f4e1d6f$export$b204af158042fbac)(root).activeElement;
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$last(walker);
                if (next) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $abb89b02b945ae0b$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $abb89b02b945ae0b$var$$9bf71ea28793e738$var$last(walker);
            if (next) $abb89b02b945ae0b$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $abb89b02b945ae0b$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $abb89b02b945ae0b$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $abb89b02b945ae0b$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $abb89b02b945ae0b$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $abb89b02b945ae0b$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $abb89b02b945ae0b$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $abb89b02b945ae0b$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $abb89b02b945ae0b$export$d06fae2ee68b101e = new $abb89b02b945ae0b$var$$9bf71ea28793e738$var$Tree();


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $81d6398042826ed3$export$2bb74740c4e19def(node, checkForOverflow) {
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $197ba42be1d4bd6e$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $81d6398042826ed3$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $81d6398042826ed3$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $d73b6ad2362dbd92$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a5da9ad69d8f6c1a$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $75aa55a33d7ff518$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    let effect = (0, $acw62.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $a55c69720d203325$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $a55c69720d203325$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $a55c69720d203325$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $012705f78676000f$export$619500959fc48b26)(value);
    let updateValue = (0, $acw62.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($a55c69720d203325$var$$bdb11010cef70236$var$canUseDOM) $a55c69720d203325$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            $a55c69720d203325$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $a55c69720d203325$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $a55c69720d203325$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $a55c69720d203325$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $a55c69720d203325$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $a55c69720d203325$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $75aa55a33d7ff518$export$14d238f342723f25)(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


function $f6647d905df74852$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f6647d905df74852$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f6647d905df74852$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f6647d905df74852$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f6647d905df74852$export$2e2bcd8739ae039 = $f6647d905df74852$export$4f5d2d50c9deca37;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $141841b57ef3d97b$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $d73b6ad2362dbd92$export$e08e3b67e392101e)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $f6647d905df74852$export$2e2bcd8739ae039)(a, b);
            else if (key === "id" && a && b) result.id = (0, $a55c69720d203325$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b262d8e402385590$export$94ed1c92c7beeb22(node, checkForOverflow) {
    const scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $81d6398042826ed3$export$2bb74740c4e19def)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $156837c9cb9a2307$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $156837c9cb9a2307$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $156837c9cb9a2307$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $156837c9cb9a2307$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $156837c9cb9a2307$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            let scrollParents = (0, $b262d8e402385590$export$94ed1c92c7beeb22)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            for (let scrollParent of scrollParents)$156837c9cb9a2307$export$53a0910f038337bd(scrollParent, targetElement);
        }
    }
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $380de51024797179$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $380de51024797179$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $380de51024797179$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $380de51024797179$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $380de51024797179$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $dce510f044473c95$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$dce510f044473c95$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, $380de51024797179$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
    };
}
let $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$currentLocale = $dce510f044473c95$export$f09106e7c6677ec5();
let $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$currentLocale = $dce510f044473c95$export$f09106e7c6677ec5();
    for (let listener of $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$listeners)listener($dce510f044473c95$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $dce510f044473c95$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $012705f78676000f$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $acw62.useState)($dce510f044473c95$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $acw62.useEffect)(()=>{
        if ($dce510f044473c95$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($dce510f044473c95$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $dce510f044473c95$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $67b31b056ed2d14f$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $67b31b056ed2d14f$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $dce510f044473c95$export$188ec29ebc2bdc3a)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $380de51024797179$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($67b31b056ed2d14f$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $67b31b056ed2d14f$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $dce510f044473c95$export$188ec29ebc2bdc3a)();
    let context = (0, $acw62.useContext)($67b31b056ed2d14f$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea2551b7f29719f6$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $2cc678f6ff87f7f4$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $ea2551b7f29719f6$export$16792effe837dba3(e) {
    if ((0, $2cc678f6ff87f7f4$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $acw62.createContext)({
    isNative: true,
    open: $81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $81a8485bbc20a512$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $acw62.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($81a8485bbc20a512$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $81a8485bbc20a512$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $81a8485bbc20a512$export$9a302a45f65d0572() {
    return (0, $acw62.useContext)($81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $81a8485bbc20a512$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $81a8485bbc20a512$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $2cc678f6ff87f7f4$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ((0, $2cc678f6ff87f7f4$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $2cc678f6ff87f7f4$export$78551043582a6a98)() && (0, $2cc678f6ff87f7f4$export$9ac100e40613ea10)() && !(0, $2cc678f6ff87f7f4$export$7bef049ce92e4224)() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $81a8485bbc20a512$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $81a8485bbc20a512$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$81a8485bbc20a512$export$95185d699e05d4d7.isOpening = false;
function $81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $81a8485bbc20a512$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$81a8485bbc20a512$export$95185d699e05d4d7(link, modifiers));
}
function $81a8485bbc20a512$export$bdc77b0c0a3a85d6(props) {
    let router = $81a8485bbc20a512$export$9a302a45f65d0572();
    return {
        "data-href": props.href ? router.useHref(props.href) : undefined,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $81a8485bbc20a512$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $81a8485bbc20a512$export$7e924b3091a3bd18(props) {
    let router = $81a8485bbc20a512$export$9a302a45f65d0572();
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? router.useHref(props === null || props === void 0 ? void 0 : props.href) : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state = "default";
let $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$savedUserSelect = "";
let $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $0ee6eadbbbacb18b$export$16a4697467175487(target) {
    if ((0, $2cc678f6ff87f7f4$export$fedb369cb70207f1)()) {
        if ($0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $197c48392f4e1d6f$export$b204af158042fbac)(target);
            $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $0ee6eadbbbacb18b$export$b0d6fa1ab32e3295(target) {
    if ((0, $2cc678f6ff87f7f4$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state !== "disabled") return;
        $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $cf870a9bbd9ff446$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $197c48392f4e1d6f$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $0ee6eadbbbacb18b$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5ef6cc46f322ec10$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    register: ()=>{}
});
$5ef6cc46f322ec10$export$5165eccb35aaadb5.displayName = "PressResponderContext";






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $24dfce3ccd38920c$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d3faa972dd98cea1$export$4debdb1a3f0fa79e(context, ref) {
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $c73849e12f594991$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)((0, $5ef6cc46f322ec10$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $d3faa972dd98cea1$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $c73849e12f594991$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $c73849e12f594991$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $36ba9b20eda67744$export$71511d61b312f219)(this, $c73849e12f594991$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $c6097939c16c8ec7$export$71511d61b312f219)(this, $c73849e12f594991$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent, state){
        (0, $01f13bd32e43989c$export$71511d61b312f219)(this, $c73849e12f594991$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $36ba9b20eda67744$export$71511d61b312f219)(this, $c73849e12f594991$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        var _state_target;
        let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
        const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
    }
}
const $c73849e12f594991$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $c73849e12f594991$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $c73849e12f594991$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $24dfce3ccd38920c$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $c73849e12f594991$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $c73849e12f594991$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $c73849e12f594991$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $c73849e12f594991$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $0ee6eadbbbacb18b$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($c73849e12f594991$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($c73849e12f594991$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $197c48392f4e1d6f$export$b204af158042fbac)(e.currentTarget), "keyup", (0, $d73b6ad2362dbd92$export$e08e3b67e392101e)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $2cc678f6ff87f7f4$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $81a8485bbc20a512$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $1ff97716fa10ea55$export$60278871457622de)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $c73849e12f594991$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $c73849e12f594991$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$c73849e12f594991$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$c73849e12f594991$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $81a8485bbc20a512$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $1ff97716fa10ea55$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $0ee6eadbbbacb18b$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $197c48392f4e1d6f$export$b204af158042fbac)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $197c48392f4e1d6f$export$b204af158042fbac)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $197c48392f4e1d6f$export$b204af158042fbac)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $0ee6eadbbbacb18b$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $1ff97716fa10ea55$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $197c48392f4e1d6f$export$b204af158042fbac)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $c73849e12f594991$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $0ee6eadbbbacb18b$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $197c48392f4e1d6f$export$f21a1ffae260145a)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $c73849e12f594991$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e));
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $c73849e12f594991$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                    shouldStopPropagation = triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $0ee6eadbbbacb18b$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel($c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e));
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $0ee6eadbbbacb18b$export$b0d6fa1ab32e3295)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(element).HTMLInputElement && !$c73849e12f594991$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $197c48392f4e1d6f$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $c73849e12f594991$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $c73849e12f594991$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $c73849e12f594991$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $c73849e12f594991$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$c73849e12f594991$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($c73849e12f594991$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $c73849e12f594991$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $c73849e12f594991$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $c73849e12f594991$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $33276942d31a090d$var$$ef06256079686ba0$var$descriptionId = 0;
const $33276942d31a090d$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $33276942d31a090d$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $acw62.useState)();
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        if (!description) return;
        let desc = $33276942d31a090d$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$33276942d31a090d$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $33276942d31a090d$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $33276942d31a090d$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6d60303f5b5f5366$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $6d60303f5b5f5366$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $6d60303f5b5f5366$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $acw62.useRef)(undefined);
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $24dfce3ccd38920c$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = (0, $c73849e12f594991$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $33276942d31a090d$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3d6314457f7d3ed1$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $81a8485bbc20a512$export$9a302a45f65d0572)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && (0, $ea2551b7f29719f6$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ((0, $ea2551b7f29719f6$export$16792effe837dba3)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $acw62.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $df3ab836248960e6$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $acw62.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $acw62.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $acw62.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) {
            let itemProps = manager.getItemProps(key);
            router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
        }
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $3d6314457f7d3ed1$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$3d6314457f7d3ed1$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $3d6314457f7d3ed1$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $3d6314457f7d3ed1$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $c73849e12f594991$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $6d60303f5b5f5366$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $81a8485bbc20a512$export$95185d699e05d4d7).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $3d6314457f7d3ed1$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $3d6314457f7d3ed1$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4a7e4abc48d8de6a$export$c7e10bfc0c59f67c(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized, focusMode: focusMode = "child", shouldSelectOnPressUp: shouldSelectOnPressUp, onAction: onAction } = props;
    let { direction: direction } = (0, $67b31b056ed2d14f$export$43bb16f9c6d9e3f7)();
    let { keyboardDelegate: keyboardDelegate, actions: { onCellAction: onCellAction } } = (0, $9f525a3b0fffde56$export$e6235c0d09b995d0).get(state);
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, $acw62.useRef)(null);
    // Handles focusing the cell. If there is a focusable child,
    // it is focused, otherwise the cell itself is focused.
    let focus = ()=>{
        let treeWalker = (0, $abb89b02b945ae0b$export$2d6ec8fc375ceafa)(ref.current);
        if (focusMode === "child") {
            // If focus is already on a focusable child within the cell, early return so we don't shift focus
            if (ref.current.contains(document.activeElement) && ref.current !== document.activeElement) return;
            let focusable = state.selectionManager.childFocusStrategy === "last" ? $4a7e4abc48d8de6a$var$$ab90dcbc1b5466d0$var$last(treeWalker) : treeWalker.firstChild();
            if (focusable) {
                (0, $df3ab836248960e6$export$80f3e147d781571c)(focusable);
                return;
            }
        }
        if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current.contains(document.activeElement)) (0, $df3ab836248960e6$export$80f3e147d781571c)(ref.current);
    };
    let { itemProps: itemProps, isPressed: isPressed } = (0, $3d6314457f7d3ed1$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        focus: focus,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onCellAction ? ()=>onCellAction(node.key) : onAction,
        isDisabled: state.collection.size === 0
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || state.isKeyboardNavigationDisabled) return;
        let walker = (0, $abb89b02b945ae0b$export$2d6ec8fc375ceafa)(ref.current);
        walker.currentNode = document.activeElement;
        switch(e.key){
            case "ArrowLeft":
                {
                    // Find the next focusable element within the cell.
                    let focusable = direction === "rtl" ? walker.nextNode() : walker.previousNode();
                    // Don't focus the cell itself if focusMode is "child"
                    if (focusMode === "child" && focusable === ref.current) focusable = null;
                    e.preventDefault();
                    e.stopPropagation();
                    if (focusable) {
                        (0, $df3ab836248960e6$export$80f3e147d781571c)(focusable);
                        (0, $156837c9cb9a2307$export$c826860796309d1b)(focusable, {
                            containingElement: (0, $197ba42be1d4bd6e$export$cfa2225e87938781)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then move to the next cell to the left of this one.
                        // This will be handled by useSelectableCollection. However, if there is no cell to the left
                        // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
                        // same as this one. In that case we need to handle focusing either the cell or the first/last
                        // child, depending on the focus mode.
                        let prev = keyboardDelegate.getKeyLeftOf(node.key);
                        if (prev !== node.key) {
                            // We prevent the capturing event from reaching children of the cell, e.g. pickers.
                            // We want arrow keys to navigate to the next cell instead. We need to re-dispatch
                            // the event from a higher parent so it still bubbles and gets handled by useSelectableCollection.
                            ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                            break;
                        }
                        if (focusMode === "cell" && direction === "rtl") {
                            (0, $df3ab836248960e6$export$80f3e147d781571c)(ref.current);
                            (0, $156837c9cb9a2307$export$c826860796309d1b)(ref.current, {
                                containingElement: (0, $197ba42be1d4bd6e$export$cfa2225e87938781)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === "rtl" ? walker.firstChild() : $4a7e4abc48d8de6a$var$$ab90dcbc1b5466d0$var$last(walker);
                            if (focusable) {
                                (0, $df3ab836248960e6$export$80f3e147d781571c)(focusable);
                                (0, $156837c9cb9a2307$export$c826860796309d1b)(focusable, {
                                    containingElement: (0, $197ba42be1d4bd6e$export$cfa2225e87938781)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case "ArrowRight":
                {
                    let focusable = direction === "rtl" ? walker.previousNode() : walker.nextNode();
                    if (focusMode === "child" && focusable === ref.current) focusable = null;
                    e.preventDefault();
                    e.stopPropagation();
                    if (focusable) {
                        (0, $df3ab836248960e6$export$80f3e147d781571c)(focusable);
                        (0, $156837c9cb9a2307$export$c826860796309d1b)(focusable, {
                            containingElement: (0, $197ba42be1d4bd6e$export$cfa2225e87938781)(ref.current)
                        });
                    } else {
                        let next = keyboardDelegate.getKeyRightOf(node.key);
                        if (next !== node.key) {
                            // We prevent the capturing event from reaching children of the cell, e.g. pickers.
                            // We want arrow keys to navigate to the next cell instead. We need to re-dispatch
                            // the event from a higher parent so it still bubbles and gets handled by useSelectableCollection.
                            ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                            break;
                        }
                        if (focusMode === "cell" && direction === "ltr") {
                            (0, $df3ab836248960e6$export$80f3e147d781571c)(ref.current);
                            (0, $156837c9cb9a2307$export$c826860796309d1b)(ref.current, {
                                containingElement: (0, $197ba42be1d4bd6e$export$cfa2225e87938781)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === "rtl" ? $4a7e4abc48d8de6a$var$$ab90dcbc1b5466d0$var$last(walker) : walker.firstChild();
                            if (focusable) {
                                (0, $df3ab836248960e6$export$80f3e147d781571c)(focusable);
                                (0, $156837c9cb9a2307$export$c826860796309d1b)(focusable, {
                                    containingElement: (0, $197ba42be1d4bd6e$export$cfa2225e87938781)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
                // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    // Grid cells can have focusable elements inside them. In this case, focus should
    // be marshalled to that element rather than focusing the cell itself.
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the gridcell itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row/cell
            // in that case since the table should act like a single tab stop.
            if (!(0, $08afaaadcf52b950$export$b9b3dfddab17db27)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
        // If the cell itself is focused, wait a frame so that focus finishes propagatating
        // up to the tree, and move focus to a focusable child if possible.
        requestAnimationFrame(()=>{
            if (focusMode === "child" && document.activeElement === ref.current) focus();
        });
    };
    let gridCellProps = (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(itemProps, {
        role: "gridcell",
        onKeyDownCapture: onKeyDownCapture,
        onFocus: onFocus
    });
    var _node_colIndex;
    if (isVirtualized) gridCellProps["aria-colindex"] = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + 1; // aria-colindex is 1-based
    // When pressing with a pointer and cell selection is not enabled, usePress will be applied to the
    // row rather than the cell. However, when the row is draggable, usePress cannot preventDefault
    // on pointer down, so the browser will try to focus the cell which has a tabIndex applied.
    // To avoid this, remove the tabIndex from the cell briefly on pointer down.
    if (shouldSelectOnPressUp && gridCellProps.tabIndex != null && gridCellProps.onPointerDown == null) gridCellProps.onPointerDown = (e)=>{
        let el = e.currentTarget;
        let tabindex = el.getAttribute("tabindex");
        el.removeAttribute("tabindex");
        requestAnimationFrame(()=>{
            el.setAttribute("tabindex", tabindex);
        });
    };
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}
function $4a7e4abc48d8de6a$var$$ab90dcbc1b5466d0$var$last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}




function $928aa0e7bfd716f6$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $928aa0e7bfd716f6$export$9514819a8c81e960(props, state, ref) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let { node: node } = props;
    let allowsSorting = node.props.allowsSorting;
    // if there are no focusable children, the column header will focus the cell
    let { gridCellProps: gridCellProps } = (0, $4a7e4abc48d8de6a$export$c7e10bfc0c59f67c)({
        ...props,
        focusMode: "child"
    }, state, ref);
    let isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === "single";
    let { pressProps: pressProps } = (0, $5da6a07904df2822$export$45712eceda6fad21)({
        isDisabled: !allowsSorting || isSelectionCellDisabled,
        onPress () {
            state.sort(node.key);
        },
        ref: ref
    });
    // Needed to pick up the focusable context, enabling things like Tooltips for example
    let { focusableProps: focusableProps } = (0, $4513518cfd051728$export$4c014de7c8940b4c)({}, ref);
    let ariaSort = null;
    let isSortedColumn = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === node.key;
    let sortDirection = (_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction;
    // aria-sort not supported in Android Talkback
    if (node.props.allowsSorting && !(0, $b82880ba168cba95$export$a11b0059900ceec8)()) ariaSort = isSortedColumn ? sortDirection : "none";
    let stringFormatter = (0, $99f36fc287ff500a$export$f12b703ca79dfbb1)($928aa0e7bfd716f6$var$$parcel$interopDefault((0, $c1d04d5abf7d86c5$export$2e2bcd8739ae039)), "@react-aria/table");
    let sortDescription;
    if (allowsSorting) {
        sortDescription = `${stringFormatter.format("sortable")}`;
        // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
        if (isSortedColumn && sortDirection && (0, $b82880ba168cba95$export$a11b0059900ceec8)()) sortDescription = `${sortDescription}, ${stringFormatter.format(sortDirection)}`;
    }
    let descriptionProps = (0, $63b5f1dcd2b5cccc$export$f8aeda7b10753fa1)(sortDescription);
    let shouldDisableFocus = state.collection.size === 0;
    (0, $acw62.useEffect)(()=>{
        if (shouldDisableFocus && state.selectionManager.focusedKey === node.key) state.selectionManager.setFocusedKey(null);
    }, [
        shouldDisableFocus,
        state.selectionManager,
        node.key
    ]);
    return {
        columnHeaderProps: {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(gridCellProps, pressProps, focusableProps, descriptionProps, shouldDisableFocus && {
                tabIndex: -1
            }),
            role: "columnheader",
            id: (0, $95d9ad6a2a44012e$export$37cd4213f2ad742e)(state, node.key),
            "aria-colspan": node.colspan && node.colspan > 1 ? node.colspan : null,
            "aria-sort": ariaSort
        }
    };
}



var $9f8b26fcdbc1e839$export$2e2bcd8739ae039 = {};
$9f8b26fcdbc1e839$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{63A}\u{64A}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "longPressToSelect": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{64B}\u{627} \u{644}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{648}\u{636}\u{639} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}.`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectedAll": `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{627}\u{635}\u{631}`,
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`
};


var $86219a406b23393d$export$2e2bcd8739ae039 = {};
$86219a406b23393d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{435} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{438} \u{437}\u{430}\u{434}\u{440}\u{44A}\u{436}\u{442}\u{435} \u{437}\u{430} \u{434}\u{430} \u{432}\u{43B}\u{435}\u{437}\u{435}\u{442}\u{435} \u{432} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43D} \u{440}\u{435}\u{436}\u{438}\u{43C}.`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`
};


var $a523eaf7c853f02d$export$2e2bcd8739ae039 = {};
$a523eaf7c853f02d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Polo\u{17E}ka ${args.item} nen\xed vybr\xe1na.`,
    "longPressToSelect": `Dlouh\xfdm stisknut\xedm p\u{159}ejdete do re\u{17E}imu v\xfdb\u{11B}ru.`,
    "select": `Vybrat`,
    "selectedAll": `Vybr\xe1ny v\u{161}echny polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nevybr\xe1ny \u{17E}\xe1dn\xe9 polo\u{17E}ky`,
            one: ()=>`Vybr\xe1na ${formatter.number(args.count)} polo\u{17E}ka`,
            other: ()=>`Vybr\xe1no ${formatter.number(args.count)} polo\u{17E}ek`
        })}.`,
    "selectedItem": (args)=>`Vybr\xe1na polo\u{17E}ka ${args.item}.`
};


var $487a751f38cc49b2$export$2e2bcd8739ae039 = {};
$487a751f38cc49b2$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ikke valgt.`,
    "longPressToSelect": `Lav et langt tryk for at aktivere valgtilstand.`,
    "select": `V\xe6lg`,
    "selectedAll": `Alle elementer valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer valgt`,
            one: ()=>`${formatter.number(args.count)} element valgt`,
            other: ()=>`${formatter.number(args.count)} elementer valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} valgt.`
};


var $2bed4c5f6df51356$export$2e2bcd8739ae039 = {};
$2bed4c5f6df51356$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nicht ausgew\xe4hlt.`,
    "longPressToSelect": `Gedr\xfcckt halten, um Auswahlmodus zu \xf6ffnen.`,
    "select": `Ausw\xe4hlen`,
    "selectedAll": `Alle Elemente ausgew\xe4hlt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Keine Elemente ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} Element ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} Elemente ausgew\xe4hlt`
        })}.`,
    "selectedItem": (args)=>`${args.item} ausgew\xe4hlt.`
};


var $46f125047de50006$export$2e2bcd8739ae039 = {};
$46f125047de50006$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`,
    "longPressToSelect": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3C0}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3BB}\u{3B5}\u{3B9}\u{3C4}\u{3BF}\u{3C5}\u{3C1}\u{3B3}\u{3AF}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}.`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1} \u{3C4}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
            one: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "selectedItem": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`
};


var $d1c95d1c57d65848$export$2e2bcd8739ae039 = {};
$d1c95d1c57d65848$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};


var $33c11fbf0c50997d$export$2e2bcd8739ae039 = {};
$33c11fbf0c50997d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} no seleccionado.`,
    "longPressToSelect": `Mantenga pulsado para abrir el modo de selecci\xf3n.`,
    "select": `Seleccionar`,
    "selectedAll": `Todos los elementos seleccionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ning\xfan elemento seleccionado`,
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} seleccionado.`
};


var $7abb4a5454505bc3$export$2e2bcd8739ae039 = {};
$7abb4a5454505bc3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} pole valitud.`,
    "longPressToSelect": `Valikure\u{17E}iimi sisenemiseks vajutage pikalt.`,
    "select": `Vali`,
    "selectedAll": `K\xf5ik \xfcksused valitud.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\xdcksusi pole valitud`,
            one: ()=>`${formatter.number(args.count)} \xfcksus valitud`,
            other: ()=>`${formatter.number(args.count)} \xfcksust valitud`
        })}.`,
    "selectedItem": (args)=>`${args.item} valitud.`
};


var $8fc7342ac9deb5a8$export$2e2bcd8739ae039 = {};
$8fc7342ac9deb5a8$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Kohdetta ${args.item} ei valittu.`,
    "longPressToSelect": `Siirry valintatilaan painamalla pitk\xe4\xe4n.`,
    "select": `Valitse`,
    "selectedAll": `Kaikki kohteet valittu.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei yht\xe4\xe4n kohdetta valittu`,
            one: ()=>`${formatter.number(args.count)} kohde valittu`,
            other: ()=>`${formatter.number(args.count)} kohdetta valittu`
        })}.`,
    "selectedItem": (args)=>`${args.item} valittu.`
};


var $21f3f00eb0dc2529$export$2e2bcd8739ae039 = {};
$21f3f00eb0dc2529$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non s\xe9lectionn\xe9.`,
    "longPressToSelect": `Appuyez de mani\xe8re prolong\xe9e pour passer en mode de s\xe9lection.`,
    "select": `S\xe9lectionner`,
    "selectedAll": `Tous les \xe9l\xe9ments s\xe9lectionn\xe9s.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "selectedItem": (args)=>`${args.item} s\xe9lectionn\xe9.`
};


var $6fa6a310da28fe84$export$2e2bcd8739ae039 = {};
$6fa6a310da28fe84$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`,
    "longPressToSelect": `\u{5D4}\u{5E7}\u{5E9}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DC}\u{5DB}\u{5E0}\u{5D9}\u{5E1}\u{5D4} \u{5DC}\u{5DE}\u{5E6}\u{5D1} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}.`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD}`,
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} ${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`
};


var $f555ab3d7cd1c813$export$2e2bcd8739ae039 = {};
$f555ab3d7cd1c813$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Stavka ${args.item} nije odabrana.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u na\u{10D}in odabira.`,
    "select": `Odaberite`,
    "selectedAll": `Odabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije odabrana nijedna stavka`,
            one: ()=>`Odabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Odabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`Stavka ${args.item} je odabrana.`
};


var $a840ee0cd37a451c$export$2e2bcd8739ae039 = {};
$a840ee0cd37a451c$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nincs kijel\xf6lve.`,
    "longPressToSelect": `Nyomja hosszan a kijel\xf6l\xe9shez.`,
    "select": `Kijel\xf6l\xe9s`,
    "selectedAll": `Az \xf6sszes elem kijel\xf6lve.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy elem sincs kijel\xf6lve`,
            one: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`
        })}.`,
    "selectedItem": (args)=>`${args.item} kijel\xf6lve.`
};


var $f30dac74db8f45e3$export$2e2bcd8739ae039 = {};
$f30dac74db8f45e3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non selezionato.`,
    "longPressToSelect": `Premi a lungo per passare alla modalit\xe0 di selezione.`,
    "select": `Seleziona`,
    "selectedAll": `Tutti gli elementi selezionati.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessun elemento selezionato`,
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "selectedItem": (args)=>`${args.item} selezionato.`
};


var $bbb3397f562fc16d$export$2e2bcd8739ae039 = {};
$bbb3397f562fc16d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{9078}\u{629E}\u{30E2}\u{30FC}\u{30C9}\u{3092}\u{958B}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "select": `\u{9078}\u{629E}`,
    "selectedAll": `\u{3059}\u{3079}\u{3066}\u{306E}\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9805}\u{76EE}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            one: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`,
            other: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}\u{3002}`,
    "selectedItem": (args)=>`${args.item} \u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`
};


var $77912acbcfed8f04$export$2e2bcd8739ae039 = {};
$77912acbcfed8f04$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "longPressToSelect": `\u{C120}\u{D0DD} \u{BAA8}\u{B4DC}\u{B85C} \u{B4E4}\u{C5B4}\u{AC00}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectedAll": `\u{BAA8}\u{B4E0} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`
        })}.`,
    "selectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`
};


var $eb57594a03fc2ea8$export$2e2bcd8739ae039 = {};
$eb57594a03fc2ea8$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nepasirinkta.`,
    "longPressToSelect": `Nor\u{117}dami \u{12F}jungti pasirinkimo re\u{17E}im\u{105}, paspauskite ir palaikykite.`,
    "select": `Pasirinkti`,
    "selectedAll": `Pasirinkti visi elementai.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nepasirinktas n\u{117} vienas elementas`,
            one: ()=>`Pasirinktas ${formatter.number(args.count)} elementas`,
            other: ()=>`Pasirinkta element\u{173}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Pasirinkta: ${args.item}.`
};


var $871e6173eac15536$export$2e2bcd8739ae039 = {};
$871e6173eac15536$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Vienums ${args.item} nav atlas\u{12B}ts.`,
    "longPressToSelect": `Ilgi turiet nospiestu. lai iesl\u{113}gtu atlases re\u{17E}\u{12B}mu.`,
    "select": `Atlas\u{12B}t`,
    "selectedAll": `Atlas\u{12B}ti visi vienumi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts neviens vienums`,
            one: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`,
            other: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Atlas\u{12B}ts vienums ${args.item}.`
};


var $400483a36cbc9fde$export$2e2bcd8739ae039 = {};
$400483a36cbc9fde$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} er ikke valgt.`,
    "longPressToSelect": `Bruk et langt trykk for \xe5 g\xe5 inn i valgmodus.`,
    "select": `Velg`,
    "selectedAll": `Alle elementer er valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer er valgt`,
            one: ()=>`${formatter.number(args.count)} element er valgt`,
            other: ()=>`${formatter.number(args.count)} elementer er valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} er valgt.`
};


var $33b00aa368606041$export$2e2bcd8739ae039 = {};
$33b00aa368606041$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} niet geselecteerd.`,
    "longPressToSelect": `Druk lang om de selectiemodus te openen.`,
    "select": `Selecteren`,
    "selectedAll": `Alle items geselecteerd.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Geen items geselecteerd`,
            one: ()=>`${formatter.number(args.count)} item geselecteerd`,
            other: ()=>`${formatter.number(args.count)} items geselecteerd`
        })}.`,
    "selectedItem": (args)=>`${args.item} geselecteerd.`
};


var $450f6572106463ee$export$2e2bcd8739ae039 = {};
$450f6572106463ee$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nie zaznaczono ${args.item}.`,
    "longPressToSelect": `Naci\u{15B}nij i przytrzymaj, aby wej\u{15B}\u{107} do trybu wyboru.`,
    "select": `Zaznacz`,
    "selectedAll": `Wszystkie zaznaczone elementy.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nie zaznaczono \u{17C}adnych element\xf3w`,
            one: ()=>`${formatter.number(args.count)} zaznaczony element`,
            other: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`
        })}.`,
    "selectedItem": (args)=>`Zaznaczono ${args.item}.`
};


var $73a5fa843956ee0d$export$2e2bcd8739ae039 = {};
$73a5fa843956ee0d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Mantenha pressionado para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};


var $3ab0f84796c50869$export$2e2bcd8739ae039 = {};
$3ab0f84796c50869$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Prima continuamente para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};


var $13bdbec83191f553$export$2e2bcd8739ae039 = {};
$13bdbec83191f553$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} neselectat.`,
    "longPressToSelect": `Ap\u{103}sa\u{21B}i lung pentru a intra \xeen modul de selectare.`,
    "select": `Selectare`,
    "selectedAll": `Toate elementele selectate.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciun element selectat`,
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "selectedItem": (args)=>`${args.item} selectat.`
};


var $9af9c825193028b5$export$2e2bcd8739ae039 = {};
$9af9c825193028b5$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}.`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{44B} \u{432}\u{441}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
            one: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};


var $df0a39eb646c6f71$export$2e2bcd8739ae039 = {};
$df0a39eb646c6f71$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nevybrat\xe9 polo\u{17E}ky: ${args.item}.`,
    "longPressToSelect": `Dlh\u{161}\xedm stla\u{10D}en\xedm prejdite do re\u{17E}imu v\xfdberu.`,
    "select": `Vybra\u{165}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{17D}iadne vybrat\xe9 polo\u{17E}ky`,
            one: ()=>`${formatter.number(args.count)} vybrat\xe1 polo\u{17E}ka`,
            other: ()=>`Po\u{10D}et vybrat\xfdch polo\u{17E}iek:${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Vybrat\xe9 polo\u{17E}ky: ${args.item}.`
};


var $ad9182e2fd407df8$export$2e2bcd8739ae039 = {};
$ad9182e2fd407df8$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Element ${args.item} ni izbran.`,
    "longPressToSelect": `Za izbirni na\u{10D}in pritisnite in dlje \u{10D}asa dr\u{17E}ite.`,
    "select": `Izberite`,
    "selectedAll": `Vsi elementi so izbrani.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Noben element ni izbran`,
            one: ()=>`${formatter.number(args.count)} element je izbran`,
            other: ()=>`${formatter.number(args.count)} elementov je izbranih`
        })}.`,
    "selectedItem": (args)=>`Element ${args.item} je izbran.`
};


var $ea43eb0e789936b4$export$2e2bcd8739ae039 = {};
$ea43eb0e789936b4$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nije izabrano.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u re\u{17E}im biranja.`,
    "select": `Izaberite`,
    "selectedAll": `Izabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije izabrana nijedna stavka`,
            one: ()=>`Izabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Izabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`${args.item} je izabrano.`
};


var $faf0e46a1b395d9e$export$2e2bcd8739ae039 = {};
$faf0e46a1b395d9e$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ej markerat.`,
    "longPressToSelect": `Tryck l\xe4nge n\xe4r du vill \xf6ppna v\xe4ljarl\xe4ge.`,
    "select": `Markera`,
    "selectedAll": `Alla markerade objekt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga markerade objekt`,
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "selectedItem": (args)=>`${args.item} markerat.`
};


var $d9fff3bec02c6aa2$export$2e2bcd8739ae039 = {};
$d9fff3bec02c6aa2$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} se\xe7ilmedi.`,
    "longPressToSelect": `Se\xe7im moduna girmek i\xe7in uzun bas\u{131}n.`,
    "select": `Se\xe7`,
    "selectedAll": `T\xfcm \xf6geler se\xe7ildi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7bir \xf6ge se\xe7ilmedi`,
            one: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`,
            other: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`
        })}.`,
    "selectedItem": (args)=>`${args.item} se\xe7ildi.`
};


var $4b29953dbbb81ac9$export$2e2bcd8739ae039 = {};
$4b29953dbbb81ac9$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{412}\u{438}\u{43A}\u{43E}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43E}\u{432}\u{433}\u{435} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{43D}\u{43D}\u{44F}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{438}\u{431}\u{43E}\u{440}\u{443}.`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectedAll": `\u{423}\u{441}\u{456} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{416}\u{43E}\u{434}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            one: ()=>`${formatter.number(args.count)} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};


var $6e37f310dc954ba5$export$2e2bcd8739ae039 = {};
$6e37f310dc954ba5$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9009}\u{62E9} ${args.item}\u{3002}`,
    "longPressToSelect": `\u{957F}\u{6309}\u{4EE5}\u{8FDB}\u{5165}\u{9009}\u{62E9}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectedAll": `\u{5DF2}\u{9009}\u{62E9}\u{6240}\u{6709}\u{9879}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9009}\u{62E9}\u{9879}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.item}\u{3002}`
};


var $343fa5dff8f76e82$export$2e2bcd8739ae039 = {};
$343fa5dff8f76e82$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{6309}\u{4EE5}\u{9032}\u{5165}\u{9078}\u{64C7}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9078}\u{53D6}`,
    "selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`
};


var $48595e8d278ad32c$export$2e2bcd8739ae039 = {};
$48595e8d278ad32c$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $9f8b26fcdbc1e839$export$2e2bcd8739ae039),
    "bg-BG": (0, $86219a406b23393d$export$2e2bcd8739ae039),
    "cs-CZ": (0, $a523eaf7c853f02d$export$2e2bcd8739ae039),
    "da-DK": (0, $487a751f38cc49b2$export$2e2bcd8739ae039),
    "de-DE": (0, $2bed4c5f6df51356$export$2e2bcd8739ae039),
    "el-GR": (0, $46f125047de50006$export$2e2bcd8739ae039),
    "en-US": (0, $d1c95d1c57d65848$export$2e2bcd8739ae039),
    "es-ES": (0, $33c11fbf0c50997d$export$2e2bcd8739ae039),
    "et-EE": (0, $7abb4a5454505bc3$export$2e2bcd8739ae039),
    "fi-FI": (0, $8fc7342ac9deb5a8$export$2e2bcd8739ae039),
    "fr-FR": (0, $21f3f00eb0dc2529$export$2e2bcd8739ae039),
    "he-IL": (0, $6fa6a310da28fe84$export$2e2bcd8739ae039),
    "hr-HR": (0, $f555ab3d7cd1c813$export$2e2bcd8739ae039),
    "hu-HU": (0, $a840ee0cd37a451c$export$2e2bcd8739ae039),
    "it-IT": (0, $f30dac74db8f45e3$export$2e2bcd8739ae039),
    "ja-JP": (0, $bbb3397f562fc16d$export$2e2bcd8739ae039),
    "ko-KR": (0, $77912acbcfed8f04$export$2e2bcd8739ae039),
    "lt-LT": (0, $eb57594a03fc2ea8$export$2e2bcd8739ae039),
    "lv-LV": (0, $871e6173eac15536$export$2e2bcd8739ae039),
    "nb-NO": (0, $400483a36cbc9fde$export$2e2bcd8739ae039),
    "nl-NL": (0, $33b00aa368606041$export$2e2bcd8739ae039),
    "pl-PL": (0, $450f6572106463ee$export$2e2bcd8739ae039),
    "pt-BR": (0, $73a5fa843956ee0d$export$2e2bcd8739ae039),
    "pt-PT": (0, $3ab0f84796c50869$export$2e2bcd8739ae039),
    "ro-RO": (0, $13bdbec83191f553$export$2e2bcd8739ae039),
    "ru-RU": (0, $9af9c825193028b5$export$2e2bcd8739ae039),
    "sk-SK": (0, $df0a39eb646c6f71$export$2e2bcd8739ae039),
    "sl-SI": (0, $ad9182e2fd407df8$export$2e2bcd8739ae039),
    "sr-SP": (0, $ea43eb0e789936b4$export$2e2bcd8739ae039),
    "sv-SE": (0, $faf0e46a1b395d9e$export$2e2bcd8739ae039),
    "tr-TR": (0, $d9fff3bec02c6aa2$export$2e2bcd8739ae039),
    "uk-UA": (0, $4b29953dbbb81ac9$export$2e2bcd8739ae039),
    "zh-CN": (0, $6e37f310dc954ba5$export$2e2bcd8739ae039),
    "zh-TW": (0, $343fa5dff8f76e82$export$2e2bcd8739ae039)
};






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d9311eb993d17970$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $d9311eb993d17970$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $d9311eb993d17970$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $2e7c3812ae71e8c9$export$c17fa47878dc55b6)(strings);
        $d9311eb993d17970$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $d9311eb993d17970$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $2e7c3812ae71e8c9$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $d9311eb993d17970$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $d9311eb993d17970$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $67b31b056ed2d14f$export$43bb16f9c6d9e3f7)();
    let dictionary = $d9311eb993d17970$export$87b761675e8eaa10(strings, packageName);
    return (0, $acw62.useMemo)(()=>new (0, $14efe04c6ea1ca1f$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}


function $f02ded4bdfab511b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $f02ded4bdfab511b$export$70e2eed1a92976ad(props, state) {
    let { key: key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, $a55c69720d203325$export$f680877a34711e37)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, $d9311eb993d17970$export$f12b703ca79dfbb1)($f02ded4bdfab511b$var$$parcel$interopDefault((0, $48595e8d278ad32c$export$2e2bcd8739ae039)), "@react-aria/grid");
    return {
        checkboxProps: {
            id: checkboxId,
            "aria-label": stringFormatter.format("select"),
            isSelected: isSelected,
            isDisabled: isDisabled,
            onChange: onChange
        }
    };
}



function $ba0d02636058dc72$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ba0d02636058dc72$export$16ea7f650bd7c1bb(props, state) {
    let { key: key } = props;
    const { checkboxProps: checkboxProps } = (0, $f02ded4bdfab511b$export$70e2eed1a92976ad)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            "aria-labelledby": `${checkboxProps.id} ${(0, $95d9ad6a2a44012e$export$85069b70317f543)(state, key)}`
        }
    };
}
function $ba0d02636058dc72$export$1003db6a7e384b99(state) {
    let { isEmpty: isEmpty, isSelectAll: isSelectAll, selectionMode: selectionMode } = state.selectionManager;
    const stringFormatter = (0, $99f36fc287ff500a$export$f12b703ca79dfbb1)($ba0d02636058dc72$var$$parcel$interopDefault((0, $c1d04d5abf7d86c5$export$2e2bcd8739ae039)), "@react-aria/table");
    return {
        checkboxProps: {
            "aria-label": stringFormatter.format(selectionMode === "single" ? "select" : "selectAll"),
            isSelected: isSelectAll,
            isDisabled: selectionMode !== "multiple" || state.collection.size === 0,
            isIndeterminate: !isEmpty && !isSelectAll,
            onChange: ()=>state.selectionManager.toggleSelectAll()
        }
    };
}







"use client";
var $ea7309e03be8cf89$var$TableSelectAllCheckbox = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const { as: as, className: className, node: node, slots: slots, state: state, selectionMode: selectionMode, color: color, checkboxesProps: checkboxesProps, disableAnimation: disableAnimation, classNames: classNames, ...otherProps } = props;
    const Component = as || "th";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { columnHeaderProps: columnHeaderProps } = (0, $928aa0e7bfd716f6$export$9514819a8c81e960)({
        node: node
    }, state, domRef);
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { checkboxProps: checkboxProps } = (0, $ba0d02636058dc72$export$1003db6a7e384b99)(state);
    const thStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.th, className, (_a = node.props) == null ? void 0 : _a.className);
    const isSingleSelectionMode = selectionMode === "single";
    const { onChange: onChange, ...otherCheckboxProps } = checkboxProps;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(columnHeaderProps, focusProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(node.props, {
            enabled: shouldFilterDOMProps
        }), (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
            enabled: shouldFilterDOMProps
        })),
        className: (_b = slots.th) == null ? void 0 : _b.call(slots, {
            class: thStyles
        }),
        children: isSingleSelectionMode ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
            children: checkboxProps["aria-label"]
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
            color: color,
            disableAnimation: disableAnimation,
            onValueChange: onChange,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(checkboxesProps, otherCheckboxProps)
        })
    });
});
$ea7309e03be8cf89$var$TableSelectAllCheckbox.displayName = "NextUI.TableSelectAllCheckbox";
var $ea7309e03be8cf89$export$ab49b1d1dfe14ac6 = $ea7309e03be8cf89$var$TableSelectAllCheckbox;



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $c085aaf65db31e4b$export$de3fdf6493c353d {
    *[Symbol.iterator]() {
        yield* [
            ...this.rows
        ];
    }
    get size() {
        return [
            ...this.rows
        ].length;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        var _;
        return (_ = [
            ...this.rows
        ][0]) === null || _ === void 0 ? void 0 : _.key;
    }
    getLastKey() {
        var _rows_;
        let rows = [
            ...this.rows
        ];
        return (_rows_ = rows[rows.length - 1]) === null || _rows_ === void 0 ? void 0 : _rows_.key;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(opts){
        this.keyMap = new Map();
        this.keyMap = new Map();
        this.columnCount = opts === null || opts === void 0 ? void 0 : opts.columnCount;
        this.rows = [];
        let visit = (node)=>{
            // If the node is the same object as the previous node for the same key,
            // we can skip this node and its children. We always visit columns though,
            // because we depend on order to build the columns array.
            let prevNode = this.keyMap.get(node.key);
            if (opts.visitNode) node = opts.visitNode(node);
            this.keyMap.set(node.key, node);
            let childKeys = new Set();
            let last;
            for (let child of node.childNodes){
                if (child.type === "cell" && child.parentKey == null) child.parentKey = node.key;
                childKeys.add(child.key);
                if (last) {
                    last.nextKey = child.key;
                    child.prevKey = last.key;
                } else child.prevKey = null;
                visit(child);
                last = child;
            }
            if (last) last.nextKey = null;
            // Remove deleted nodes and their children from the key map
            if (prevNode) {
                for (let child of prevNode.childNodes)if (!childKeys.has(child.key)) remove(child);
            }
        };
        let remove = (node)=>{
            this.keyMap.delete(node.key);
            for (let child of node.childNodes)if (this.keyMap.get(child.key) === child) remove(child);
        };
        let last;
        opts.items.forEach((node, i)=>{
            let rowNode = {
                level: 0,
                key: "row-" + i,
                type: "row",
                value: undefined,
                hasChildNodes: true,
                childNodes: [
                    ...node.childNodes
                ],
                rendered: undefined,
                textValue: undefined,
                ...node
            };
            if (last) {
                last.nextKey = rowNode.key;
                rowNode.prevKey = last.key;
            } else rowNode.prevKey = null;
            this.rows.push(rowNode);
            visit(rowNode);
            last = rowNode;
        });
        if (last) last.nextKey = null;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY = "row-header-column-" + Math.random().toString(36).slice(2);
let $53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG = "row-header-column-" + Math.random().toString(36).slice(2);
while($53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY === $53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG)$53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG = "row-header-column-" + Math.random().toString(36).slice(2);
function $53f1b163da101254$export$7c127db850d4e81e(keyMap, columnNodes) {
    if (columnNodes.length === 0) return [];
    let columns = [];
    let seen = new Map();
    for (let column of columnNodes){
        let parentKey = column.parentKey;
        let col = [
            column
        ];
        while(parentKey){
            let parent = keyMap.get(parentKey);
            if (!parent) break;
            // If we've already seen this parent, than it is shared
            // with a previous column. If the current column is taller
            // than the previous column, than we need to shift the parent
            // in the previous column so it's level with the current column.
            if (seen.has(parent)) {
                parent.colspan++;
                let { column: column, index: index } = seen.get(parent);
                if (index > col.length) break;
                for(let i = index; i < col.length; i++)column.splice(i, 0, null);
                // Adjust shifted indices
                for(let i = col.length; i < column.length; i++)if (column[i] && seen.has(column[i])) seen.get(column[i]).index = i;
            } else {
                parent.colspan = 1;
                col.push(parent);
                seen.set(parent, {
                    column: col,
                    index: col.length - 1
                });
            }
            parentKey = parent.parentKey;
        }
        columns.push(col);
        column.index = columns.length - 1;
    }
    let maxLength = Math.max(...columns.map((c)=>c.length));
    let headerRows = Array(maxLength).fill(0).map(()=>[]);
    // Convert columns into rows.
    let colIndex = 0;
    for (let column of columns){
        let i = maxLength - 1;
        for (let item of column){
            if (item) {
                // Fill the space up until the current column with a placeholder
                let row = headerRows[i];
                let rowLength = row.reduce((p, c)=>p + c.colspan, 0);
                if (rowLength < colIndex) {
                    let placeholder = {
                        type: "placeholder",
                        key: "placeholder-" + item.key,
                        colspan: colIndex - rowLength,
                        index: rowLength,
                        value: null,
                        rendered: null,
                        level: i,
                        hasChildNodes: false,
                        childNodes: [],
                        textValue: null
                    };
                    // eslint-disable-next-line max-depth
                    if (row.length > 0) {
                        row[row.length - 1].nextKey = placeholder.key;
                        placeholder.prevKey = row[row.length - 1].key;
                    }
                    row.push(placeholder);
                }
                if (row.length > 0) {
                    row[row.length - 1].nextKey = item.key;
                    item.prevKey = row[row.length - 1].key;
                }
                item.level = i;
                item.colIndex = colIndex;
                row.push(item);
            }
            i--;
        }
        colIndex++;
    }
    // Add placeholders at the end of each row that is shorter than the maximum
    let i = 0;
    for (let row of headerRows){
        let rowLength = row.reduce((p, c)=>p + c.colspan, 0);
        if (rowLength < columnNodes.length) {
            let placeholder = {
                type: "placeholder",
                key: "placeholder-" + row[row.length - 1].key,
                colspan: columnNodes.length - rowLength,
                index: rowLength,
                value: null,
                rendered: null,
                level: i,
                hasChildNodes: false,
                childNodes: [],
                textValue: null,
                prevKey: row[row.length - 1].key
            };
            row.push(placeholder);
        }
        i++;
    }
    return headerRows.map((childNodes, index)=>{
        let row = {
            type: "headerrow",
            key: "headerrow-" + index,
            index: index,
            value: null,
            rendered: null,
            level: 0,
            hasChildNodes: true,
            childNodes: childNodes,
            textValue: null
        };
        return row;
    });
}
class $53f1b163da101254$export$596e1b2e2cf93690 extends (0, $c085aaf65db31e4b$export$de3fdf6493c353d) {
    *[Symbol.iterator]() {
        yield* this.body.childNodes;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        var _getFirstItem;
        return (_getFirstItem = (0, $f2e2cae04a4a64ed$export$fbdeaa6a76694f71)(this.body.childNodes)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
    }
    getLastKey() {
        var _getLastItem;
        return (_getLastItem = (0, $f2e2cae04a4a64ed$export$7475b2c64539e4cf)(this.body.childNodes)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return "";
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        if (rowHeaderColumnKeys) {
            let text = [];
            for (let cell of row.childNodes){
                let column = this.columns[cell.index];
                if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
                if (text.length === rowHeaderColumnKeys.size) break;
            }
            return text.join(" ");
        }
        return "";
    }
    constructor(nodes, prev, opts){
        let rowHeaderColumnKeys = new Set();
        let body;
        let columns = [];
        // Add cell for selection checkboxes if needed.
        if (opts === null || opts === void 0 ? void 0 : opts.showSelectionCheckboxes) {
            let rowHeaderColumn = {
                type: "column",
                key: $53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY,
                value: null,
                textValue: "",
                level: 0,
                index: (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) ? 1 : 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isSelectionCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        // Add cell for drag buttons if needed.
        if (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) {
            let rowHeaderColumn = {
                type: "column",
                key: $53f1b163da101254$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG,
                value: null,
                textValue: "",
                level: 0,
                index: 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isDragButtonCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        let rows = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case "body":
                    body = node;
                    break;
                case "column":
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        columns.push(node);
                        if (node.props.isRowHeader) rowHeaderColumnKeys.add(node.key);
                    }
                    break;
                case "item":
                    rows.push(node);
                    return; // do not go into childNodes
            }
            for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let headerRows = $53f1b163da101254$export$7c127db850d4e81e(columnKeyMap, columns);
        headerRows.forEach((row, i)=>rows.splice(i, 0, row));
        super({
            columnCount: columns.length,
            items: rows,
            visitNode: (node)=>{
                node.column = columns[node.index];
                return node;
            }
        });
        this._size = 0;
        this.columns = columns;
        this.rowHeaderColumnKeys = rowHeaderColumnKeys;
        this.body = body;
        this.headerRows = headerRows;
        this._size = [
            ...body.childNodes
        ].length;
        // Default row header column to the first one.
        if (this.rowHeaderColumnKeys.size === 0) this.rowHeaderColumnKeys.add(this.columns.find((column)=>{
            var _column_props, _column_props1;
            return !((_column_props = column.props) === null || _column_props === void 0 ? void 0 : _column_props.isDragButtonCell) && !((_column_props1 = column.props) === null || _column_props1 === void 0 ? void 0 : _column_props1.isSelectionCell);
        }).key);
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ec08255246377ec2$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $ec08255246377ec2$export$fbdeaa6a76694f71(iterable) {
    return $ec08255246377ec2$export$5f3398f8733f90e2(iterable, 0);
}
function $ec08255246377ec2$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $ec08255246377ec2$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $ec08255246377ec2$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$ec08255246377ec2$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$ec08255246377ec2$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $ec08255246377ec2$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}




var $acw62 = parcelRequire("acw62");
function $af0467e2fe60c42e$export$4007ac09ff9c68ed(props) {
    let { collection: collection, focusMode: focusMode } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let selectionState = props.UNSAFE_selectionState || (0, $d9a874fb3bf4546a$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let setFocusedKey = selectionState.setFocusedKey;
    selectionState.setFocusedKey = (key, child)=>{
        // If focusMode is cell and an item is focused, focus a child cell instead.
        if (focusMode === "cell" && key != null) {
            let item = collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item") {
                var _getLastItem, _getFirstItem;
                let children = (0, $ec08255246377ec2$export$1005530eda016c13)(item, collection);
                if (child === "last") key = (_getLastItem = (0, $ec08255246377ec2$export$7475b2c64539e4cf)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key;
                else key = (_getFirstItem = (0, $ec08255246377ec2$export$fbdeaa6a76694f71)(children)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key;
            }
        }
        setFocusedKey(key, child);
    };
    let selectionManager = (0, $acw62.useMemo)(()=>new (0, $5c11c5ee2979fbfd$export$6c8a5aaad13c9852)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const node = cachedCollection.current.getItem(selectionState.focusedKey);
            const parentNode = node.parentKey != null && (node.type === "cell" || node.type === "rowheader" || node.type === "column") ? cachedCollection.current.getItem(node.parentKey) : node;
            const cachedRows = cachedCollection.current.rows;
            const rows = collection.rows;
            const diff = cachedRows.length - rows.length;
            let index = Math.min(diff > 1 ? Math.max(parentNode.index - diff + 1, 0) : parentNode.index, rows.length - 1);
            let newRow;
            while(index >= 0){
                if (!selectionManager.isDisabled(rows[index].key) && rows[index].type !== "headerrow") {
                    newRow = rows[index];
                    break;
                }
                // Find next, not disabled row.
                if (index < rows.length - 1) index++;
                else {
                    if (index > parentNode.index) index = parentNode.index;
                    index--;
                }
            }
            if (newRow) {
                const childNodes = newRow.hasChildNodes ? [
                    ...(0, $ec08255246377ec2$export$1005530eda016c13)(newRow, collection)
                ] : [];
                const keyToFocus = newRow.hasChildNodes && parentNode !== node && node.index < childNodes.length ? childNodes[node.index].key : newRow.key;
                selectionState.setFocusedKey(keyToFocus);
            } else selectionState.setFocusedKey(null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        isKeyboardNavigationDisabled: false,
        selectionManager: selectionManager
    };
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6745aa7b182015c2$var$$4a0dd036d492cee4$var$OPPOSITE_SORT_DIRECTION = {
    ascending: "descending",
    descending: "ascending"
};
function $6745aa7b182015c2$export$907bcc6c48325fd6(props) {
    let [isKeyboardNavigationDisabled, setKeyboardNavigationDisabled] = (0, $acw62.useState)(false);
    let { selectionMode: selectionMode = "none", showSelectionCheckboxes: showSelectionCheckboxes, showDragButtons: showDragButtons } = props;
    let context = (0, $acw62.useMemo)(()=>({
            showSelectionCheckboxes: showSelectionCheckboxes && selectionMode !== "none",
            showDragButtons: showDragButtons,
            selectionMode: selectionMode,
            columns: []
        }), [
        props.children,
        showSelectionCheckboxes,
        selectionMode,
        showDragButtons
    ]);
    let collection = (0, $fdcbc319f3a11c20$export$6cd28814d92fa9c9)(props, (0, $acw62.useCallback)((nodes)=>new (0, $53f1b163da101254$export$596e1b2e2cf93690)(nodes, null, context), [
        context
    ]), context);
    let { disabledKeys: disabledKeys, selectionManager: selectionManager } = (0, $af0467e2fe60c42e$export$4007ac09ff9c68ed)({
        ...props,
        collection: collection,
        disabledBehavior: props.disabledBehavior || "selection"
    });
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        showSelectionCheckboxes: props.showSelectionCheckboxes || false,
        sortDescriptor: props.sortDescriptor,
        isKeyboardNavigationDisabled: collection.size === 0 || isKeyboardNavigationDisabled,
        setKeyboardNavigationDisabled: setKeyboardNavigationDisabled,
        sort (columnKey, direction) {
            var _props_sortDescriptor;
            props.onSortChange({
                column: columnKey,
                direction: direction !== null && direction !== void 0 ? direction : ((_props_sortDescriptor = props.sortDescriptor) === null || _props_sortDescriptor === void 0 ? void 0 : _props_sortDescriptor.column) === columnKey ? $6745aa7b182015c2$var$$4a0dd036d492cee4$var$OPPOSITE_SORT_DIRECTION[props.sortDescriptor.direction] : "ascending"
            });
        }
    };
}





/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3ee99a444fa0bf9e$export$8f5ed9ff9f511381 {
    getItemRect(key) {
        let container = this.ref.current;
        let item = key != null ? container.querySelector(`[data-key="${CSS.escape(key.toString())}"]`) : null;
        if (!item) return null;
        let containerRect = container.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        return {
            x: itemRect.left - containerRect.left + container.scrollLeft,
            y: itemRect.top - containerRect.top + container.scrollTop,
            width: itemRect.width,
            height: itemRect.height
        };
    }
    getContentSize() {
        let container = this.ref.current;
        return {
            width: container.scrollWidth,
            height: container.scrollHeight
        };
    }
    getVisibleRect() {
        let container = this.ref.current;
        return {
            x: container.scrollLeft,
            y: container.scrollTop,
            width: container.offsetWidth,
            height: container.offsetHeight
        };
    }
    constructor(ref){
        this.ref = ref;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $606495dc51801775$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $606495dc51801775$export$fbdeaa6a76694f71(iterable) {
    return $606495dc51801775$export$5f3398f8733f90e2(iterable, 0);
}
function $606495dc51801775$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $606495dc51801775$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $606495dc51801775$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$606495dc51801775$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$606495dc51801775$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $606495dc51801775$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $762f61a7fdfd7021$export$de9feff04fda126e {
    isCell(node) {
        return node.type === "cell";
    }
    isRow(node) {
        return node.type === "row" || node.type === "item";
    }
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === "all" && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    findPreviousKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!this.isDisabled(item) && (!pred || pred(item))) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    findNextKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!this.isDisabled(item) && (!pred || pred(item))) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey;
        // Find the next item
        key = this.findNextKey(key, (item)=>item.type === "item");
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the next row.
            if (this.isCell(startItem)) {
                let item = this.collection.getItem(key);
                return (0, $606495dc51801775$export$5f3398f8733f90e2)((0, $606495dc51801775$export$1005530eda016c13)(item, this.collection), startItem.index).key;
            }
            // Otherwise, focus the next row
            if (this.focusMode === "row") return key;
        }
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus is on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey;
        // Find the previous item
        key = this.findPreviousKey(key, (item)=>item.type === "item");
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the previous row.
            if (this.isCell(startItem)) {
                let item = this.collection.getItem(key);
                return (0, $606495dc51801775$export$5f3398f8733f90e2)((0, $606495dc51801775$export$1005530eda016c13)(item, this.collection), startItem.index).key;
            }
            // Otherwise, focus the previous row
            if (this.focusMode === "row") return key;
        }
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus is on a row, focus the first child cell.
        if (this.isRow(item)) {
            let children = (0, $606495dc51801775$export$1005530eda016c13)(item, this.collection);
            return this.direction === "rtl" ? (0, $606495dc51801775$export$7475b2c64539e4cf)(children).key : (0, $606495dc51801775$export$fbdeaa6a76694f71)(children).key;
        }
        // If focus is on a cell, focus the next cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item)) {
            let parent = this.collection.getItem(item.parentKey);
            let children = (0, $606495dc51801775$export$1005530eda016c13)(parent, this.collection);
            let next = this.direction === "rtl" ? (0, $606495dc51801775$export$5f3398f8733f90e2)(children, item.index - 1) : (0, $606495dc51801775$export$5f3398f8733f90e2)(children, item.index + 1);
            if (next) return next.key;
            // focus row only if focusMode is set to row
            if (this.focusMode === "row") return item.parentKey;
            return this.direction === "rtl" ? this.getFirstKey(key) : this.getLastKey(key);
        }
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus is on a row, focus the last child cell.
        if (this.isRow(item)) {
            let children = (0, $606495dc51801775$export$1005530eda016c13)(item, this.collection);
            return this.direction === "rtl" ? (0, $606495dc51801775$export$fbdeaa6a76694f71)(children).key : (0, $606495dc51801775$export$7475b2c64539e4cf)(children).key;
        }
        // If focus is on a cell, focus the previous cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item)) {
            let parent = this.collection.getItem(item.parentKey);
            let children = (0, $606495dc51801775$export$1005530eda016c13)(parent, this.collection);
            let prev = this.direction === "rtl" ? (0, $606495dc51801775$export$5f3398f8733f90e2)(children, item.index + 1) : (0, $606495dc51801775$export$5f3398f8733f90e2)(children, item.index - 1);
            if (prev) return prev.key;
            // focus row only if focusMode is set to row
            if (this.focusMode === "row") return item.parentKey;
            return this.direction === "rtl" ? this.getLastKey(key) : this.getFirstKey(key);
        }
    }
    getFirstKey(key, global) {
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the first cell in the parent row.
            if (this.isCell(item) && !global) {
                let parent = this.collection.getItem(item.parentKey);
                return (0, $606495dc51801775$export$fbdeaa6a76694f71)((0, $606495dc51801775$export$1005530eda016c13)(parent, this.collection)).key;
            }
        }
        // Find the first row
        key = this.findNextKey(null, (item)=>item.type === "item");
        // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
        if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
            let item = this.collection.getItem(key);
            key = (0, $606495dc51801775$export$fbdeaa6a76694f71)((0, $606495dc51801775$export$1005530eda016c13)(item, this.collection)).key;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getLastKey(key, global) {
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the last cell in the parent row.
            if (this.isCell(item) && !global) {
                let parent = this.collection.getItem(item.parentKey);
                let children = (0, $606495dc51801775$export$1005530eda016c13)(parent, this.collection);
                return (0, $606495dc51801775$export$7475b2c64539e4cf)(children).key;
            }
        }
        // Find the last row
        key = this.findPreviousKey(null, (item)=>item.type === "item");
        // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
        if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
            let item = this.collection.getItem(key);
            let children = (0, $606495dc51801775$export$1005530eda016c13)(item, this.collection);
            key = (0, $606495dc51801775$export$7475b2c64539e4cf)(children).key;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getKeyPageAbove(key) {
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
        while(itemRect && itemRect.y > pageY){
            key = this.getKeyAbove(key);
            itemRect = this.layoutDelegate.getItemRect(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let pageHeight = this.layoutDelegate.getVisibleRect().height;
        let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y + pageHeight);
        while(itemRect && itemRect.y + itemRect.height < pageY){
            let nextKey = this.getKeyBelow(key);
            // If nextKey is undefined, we've reached the last row already
            if (nextKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(nextKey);
            key = nextKey;
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem.type === "cell") key = startItem.parentKey;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            // check row text value for match
            if (item.textValue) {
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) {
                    if (this.isRow(item) && this.focusMode === "cell") return (0, $606495dc51801775$export$fbdeaa6a76694f71)((0, $606495dc51801775$export$1005530eda016c13)(item, this.collection)).key;
                    return item.key;
                }
            }
            key = this.findNextKey(key, (item)=>item.type === "item");
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
    constructor(options){
        this.collection = options.collection;
        this.disabledKeys = options.disabledKeys;
        this.disabledBehavior = options.disabledBehavior || "all";
        this.direction = options.direction;
        this.collator = options.collator;
        this.layoutDelegate = options.layoutDelegate || (options.layout ? new $762f61a7fdfd7021$var$$d1c300d9c497e402$var$DeprecatedLayoutDelegate(options.layout) : new (0, $3ee99a444fa0bf9e$export$8f5ed9ff9f511381)(options.ref));
        this.focusMode = options.focusMode || "row";
    }
}
class $762f61a7fdfd7021$var$$d1c300d9c497e402$var$DeprecatedLayoutDelegate {
    getContentSize() {
        return this.layout.getContentSize();
    }
    getItemRect(key) {
        var _this_layout_getLayoutInfo;
        return ((_this_layout_getLayoutInfo = this.layout.getLayoutInfo(key)) === null || _this_layout_getLayoutInfo === void 0 ? void 0 : _this_layout_getLayoutInfo.rect) || null;
    }
    getVisibleRect() {
        return this.layout.virtualizer.visibleRect;
    }
    constructor(layout){
        this.layout = layout;
    }
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b5fdd4ad3cde52c5$export$da43f8f5cb04028d extends (0, $762f61a7fdfd7021$export$de9feff04fda126e) {
    isCell(node) {
        return node.type === "cell" || node.type === "rowheader" || node.type === "column";
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a column, then focus the first child column if any,
        // or find the corresponding cell in the first row.
        if (startItem.type === "column") {
            let child = (0, $f2e2cae04a4a64ed$export$fbdeaa6a76694f71)((0, $f2e2cae04a4a64ed$export$1005530eda016c13)(startItem, this.collection));
            if (child) return child.key;
            let firstKey = this.getFirstKey();
            if (firstKey == null) return;
            let firstItem = this.collection.getItem(firstKey);
            return (0, $f2e2cae04a4a64ed$export$5f3398f8733f90e2)((0, $f2e2cae04a4a64ed$export$1005530eda016c13)(firstItem, this.collection), startItem.index).key;
        }
        return super.getKeyBelow(key);
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a column, focus the parent column if any
        if (startItem.type === "column") {
            let parent = this.collection.getItem(startItem.parentKey);
            if (parent && parent.type === "column") return parent.key;
            return;
        }
        // only return above row key if not header row
        let superKey = super.getKeyAbove(key);
        if (superKey != null && this.collection.getItem(superKey).type !== "headerrow") return superKey;
        // If no item was found, and focus was on a cell, then focus the
        // corresponding column header.
        if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
        // If focus was on a row, then focus the first column header.
        return this.collection.columns[0].key;
    }
    findNextColumnKey(column) {
        // Search following columns
        let key = this.findNextKey(column.key, (item)=>item.type === "column");
        if (key != null) return key;
        // Wrap around to the first column
        let row = this.collection.headerRows[column.level];
        for (let item of (0, $f2e2cae04a4a64ed$export$1005530eda016c13)(row, this.collection)){
            if (item.type === "column") return item.key;
        }
    }
    findPreviousColumnKey(column) {
        // Search previous columns
        let key = this.findPreviousKey(column.key, (item)=>item.type === "column");
        if (key != null) return key;
        // Wrap around to the last column
        let row = this.collection.headerRows[column.level];
        let childNodes = [
            ...(0, $f2e2cae04a4a64ed$export$1005530eda016c13)(row, this.collection)
        ];
        for(let i = childNodes.length - 1; i >= 0; i--){
            let item = childNodes[i];
            if (item.type === "column") return item.key;
        }
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus was on a column, then focus the next column
        if (item.type === "column") return this.direction === "rtl" ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
        return super.getKeyRightOf(key);
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus was on a column, then focus the previous column
        if (item.type === "column") return this.direction === "rtl" ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
        return super.getKeyLeftOf(key);
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem.type === "cell") key = startItem.parentKey;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            // Check each of the row header cells in this row for a match
            for (let cell of (0, $f2e2cae04a4a64ed$export$1005530eda016c13)(item, this.collection)){
                let column = collection.columns[cell.index];
                if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
                    let substring = cell.textValue.slice(0, search.length);
                    if (this.collator.compare(substring, search) === 0) {
                        // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                        let fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                        return fromItem.type === "cell" ? cell.key : item.key;
                    }
                }
            }
            key = this.getKeyBelow(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
}









var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $542096eef1d90ad3$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    const lastDeps = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}


function $9198fe27bd284789$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9198fe27bd284789$export$137e594ef3218a10(props, state) {
    let { getRowText: getRowText = (key)=>{
        var _state_collection_getTextValue, _state_collection, _state_collection_getItem;
        var _state_collection_getTextValue1;
        return (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : (_state_collection_getItem = state.collection.getItem(key)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.textValue;
    } } = props;
    let stringFormatter = (0, $d9311eb993d17970$export$f12b703ca79dfbb1)($9198fe27bd284789$var$$parcel$interopDefault((0, $48595e8d278ad32c$export$2e2bcd8739ae039)), "@react-aria/grid");
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, $acw62.useRef)(selection);
    (0, $542096eef1d90ad3$export$496315a1608d9602)(()=>{
        var _lastSelection_current;
        if (!state.selectionManager.isFocused) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = $9198fe27bd284789$var$$92599c3fd427b763$var$diffSelection(selection, lastSelection.current);
        let removedKeys = $9198fe27bd284789$var$$92599c3fd427b763$var$diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === "replace";
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
                let currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
                if (currentSelectionText) messages.push(stringFormatter.format("selectedItem", {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let addedText = getRowText(addedKeys.keys().next().value);
            if (addedText) messages.push(stringFormatter.format("selectedItem", {
                item: addedText
            }));
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            if (state.collection.getItem(removedKeys.keys().next().value)) {
                let removedText = getRowText(removedKeys.keys().next().value);
                if (removedText) messages.push(stringFormatter.format("deselectedItem", {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === "multiple") {
            if (messages.length === 0 || selection === "all" || selection.size > 1 || lastSelection.current === "all" || ((_lastSelection_current = lastSelection.current) === null || _lastSelection_current === void 0 ? void 0 : _lastSelection_current.size) > 1) messages.push(selection === "all" ? stringFormatter.format("selectedAll") : stringFormatter.format("selectedCount", {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, $f79874db04d9a0b8$export$a9b970dcc4ae71a9)(messages.join(" "));
        lastSelection.current = selection;
    }, [
        selection
    ]);
}
function $9198fe27bd284789$var$$92599c3fd427b763$var$diffSelection(a, b) {
    let res = new Set();
    if (a === "all" || b === "all") return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}







var $acw62 = parcelRequire("acw62");
function $806729dbd7d7d367$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $806729dbd7d7d367$export$be42ebdab07ae4c2(props) {
    let stringFormatter = (0, $d9311eb993d17970$export$f12b703ca79dfbb1)($806729dbd7d7d367$var$$parcel$interopDefault((0, $48595e8d278ad32c$export$2e2bcd8739ae039)), "@react-aria/grid");
    let modality = (0, $08afaaadcf52b950$export$98e20ec92f614cfe)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === "pointer" || modality === "virtual" || modality == null) && typeof window !== "undefined" && "ontouchstart" in window;
    let interactionDescription = (0, $acw62.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message = undefined;
        if (shouldLongPress) message = stringFormatter.format("longPressToSelect");
        return selectionBehavior === "replace" && selectionMode !== "none" && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, $33276942d31a090d$export$f8aeda7b10753fa1)(interactionDescription);
    return descriptionProps;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b0008881afab06a3$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $b0008881afab06a3$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const $b0008881afab06a3$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "hrefLang",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const $b0008881afab06a3$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $b0008881afab06a3$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($b0008881afab06a3$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $b0008881afab06a3$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $b0008881afab06a3$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $b0008881afab06a3$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $19cc783c5cbc3c51$var$$325a3faab7a68acd$var$cache = new Map();
function $19cc783c5cbc3c51$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $67b31b056ed2d14f$export$43bb16f9c6d9e3f7)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($19cc783c5cbc3c51$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $19cc783c5cbc3c51$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $19cc783c5cbc3c51$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bbe12d822ead6a87$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $acw62.useState)(false);
    (0, $d51a89e8879dada7$export$e5c5a5f917a5871c)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, $abb89b02b945ae0b$export$2d6ec8fc375ceafa)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $785b6294a57350cd$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $785b6294a57350cd$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $acw62.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $785b6294a57350cd$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $785b6294a57350cd$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $785b6294a57350cd$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df13589ec5bf2fc9$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $a5da9ad69d8f6c1a$export$7f54fc3180508a52)(handler);
    let isDisabled = handler == null;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $47b0a4b31f0e4dc9$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $67b31b056ed2d14f$export$43bb16f9c6d9e3f7)();
    let router = (0, $81a8485bbc20a512$export$9a302a45f65d0572)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !(0, $ea2551b7f29719f6$export$d3e3bd3e26688c04)(e)) {
                    (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    let itemProps = manager.getItemProps(key);
                    router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !(0, $ea2551b7f29719f6$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $ea2551b7f29719f6$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if ((0, $ea2551b7f29719f6$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $ea2551b7f29719f6$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if ((0, $ea2551b7f29719f6$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ((0, $ea2551b7f29719f6$export$16792effe837dba3)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                if (!disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $abb89b02b945ae0b$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    /// TODO: should this happen all the time??
    let scrollPos = (0, $acw62.useRef)({
        top: 0,
        left: 0
    });
    (0, $df13589ec5bf2fc9$export$90fc3a17d93f704c)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $6fe7e04ee350a224$export$de79e2c695e052f3)(element);
                let modality = (0, $08afaaadcf52b950$export$630ff653c5ada6a9)();
                if (modality === "keyboard") (0, $156837c9cb9a2307$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $acw62.useRef)(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $df3ab836248960e6$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Scroll the focused element into view when the focusedKey changes.
    let lastFocusedKey = (0, $acw62.useRef)(manager.focusedKey);
    (0, $acw62.useEffect)(()=>{
        if (manager.isFocused && manager.focusedKey != null && (manager.focusedKey !== lastFocusedKey.current || autoFocusRef.current) && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let modality = (0, $08afaaadcf52b950$export$630ff653c5ada6a9)();
            let element = ref.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (!element) // The collection may initially be empty (e.g. virtualizer), so wait until the element exists.
            return;
            if (modality === "keyboard" || autoFocusRef.current) {
                (0, $156837c9cb9a2307$export$53a0910f038337bd)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $156837c9cb9a2307$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (!shouldUseVirtualFocus && manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $df3ab836248960e6$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    });
    (0, $df13589ec5bf2fc9$export$90fc3a17d93f704c)(ref, "react-aria-focus-scope-restore", (e)=>{
        e.preventDefault();
        manager.setFocused(true);
    });
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $785b6294a57350cd$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0ba0bcadb3533953$export$f6b86a04e5d66d90(props, state, ref) {
    let { isVirtualized: isVirtualized, keyboardDelegate: keyboardDelegate, focusMode: focusMode, scrollRef: scrollRef, getRowText: getRowText, onRowAction: onRowAction, onCellAction: onCellAction } = props;
    let { selectionManager: manager } = state;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $19cc783c5cbc3c51$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let { direction: direction } = (0, $67b31b056ed2d14f$export$43bb16f9c6d9e3f7)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $762f61a7fdfd7021$export$de9feff04fda126e)({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            direction: direction,
            collator: collator,
            focusMode: focusMode
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        focusMode
    ]);
    let { collectionProps: collectionProps } = (0, $47b0a4b31f0e4dc9$export$d6daf82dcd84e87c)({
        ref: ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        isVirtualized: isVirtualized,
        scrollRef: scrollRef
    });
    let id = (0, $a55c69720d203325$export$f680877a34711e37)(props.id);
    (0, $9f525a3b0fffde56$export$e6235c0d09b995d0).set(state, {
        keyboardDelegate: delegate,
        actions: {
            onRowAction: onRowAction,
            onCellAction: onCellAction
        }
    });
    let descriptionProps = (0, $806729dbd7d7d367$export$be42ebdab07ae4c2)({
        selectionManager: manager,
        hasItemActions: !!(onRowAction || onCellAction)
    });
    let domProps = (0, $b0008881afab06a3$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let onFocus = (0, $acw62.useCallback)((e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
    }, [
        manager
    ]);
    // Continue to track collection focused state even if keyboard navigation is disabled
    let navDisabledHandlers = (0, $acw62.useMemo)(()=>({
            onBlur: collectionProps.onBlur,
            onFocus: onFocus
        }), [
        onFocus,
        collectionProps.onBlur
    ]);
    let hasTabbableChild = (0, $bbe12d822ead6a87$export$eac1895992b9f3d6)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let gridProps = (0, $141841b57ef3d97b$export$9d1611c77c2fe928)(domProps, {
        role: "grid",
        id: id,
        "aria-multiselectable": manager.selectionMode === "multiple" ? "true" : undefined
    }, state.isKeyboardNavigationDisabled ? navDisabledHandlers : collectionProps, state.collection.size === 0 && {
        tabIndex: hasTabbableChild ? -1 : 0
    }, descriptionProps);
    if (isVirtualized) {
        gridProps["aria-rowcount"] = state.collection.size;
        gridProps["aria-colcount"] = state.collection.columnCount;
    }
    (0, $9198fe27bd284789$export$137e594ef3218a10)({
        getRowText: getRowText
    }, state);
    return {
        gridProps: gridProps
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $756bc67872044ff1$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    const lastDeps = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $6ba33dc807dfb06e$var$$f4e2df6bd15f8569$var$_tableNestedRows = false;
function $6ba33dc807dfb06e$export$d9d8a0f82de49530() {
    $6ba33dc807dfb06e$var$$f4e2df6bd15f8569$var$_tableNestedRows = true;
}
function $6ba33dc807dfb06e$export$1b00cb14a96194e6() {
    return $6ba33dc807dfb06e$var$$f4e2df6bd15f8569$var$_tableNestedRows;
}



function $3f3a92cd42925da9$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3f3a92cd42925da9$export$25bceaac3c7e4dc7(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate, isVirtualized: isVirtualized, layout: layout } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $42a2eb2bd28e75db$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let { direction: direction } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $b5fdd4ad3cde52c5$export$da43f8f5cb04028d)({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            direction: direction,
            collator: collator,
            layout: layout
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        layout
    ]);
    let id = (0, $fc8082d5d9c62cca$export$f680877a34711e37)(props.id);
    (0, $95d9ad6a2a44012e$export$552312adfd451dab).set(state, id);
    let { gridProps: gridProps } = (0, $0ba0bcadb3533953$export$f6b86a04e5d66d90)({
        ...props,
        id: id,
        keyboardDelegate: delegate
    }, state, ref);
    // Override to include header rows
    if (isVirtualized) gridProps["aria-rowcount"] = state.collection.size + state.collection.headerRows.length;
    if ((0, $6ba33dc807dfb06e$export$1b00cb14a96194e6)() && "expandedKeys" in state) gridProps.role = "treegrid";
    let { column: column, direction: sortDirection } = state.sortDescriptor || {};
    let stringFormatter = (0, $99f36fc287ff500a$export$f12b703ca79dfbb1)($3f3a92cd42925da9$var$$parcel$interopDefault((0, $c1d04d5abf7d86c5$export$2e2bcd8739ae039)), "@react-aria/table");
    let sortDescription = (0, $acw62.useMemo)(()=>{
        var _state_collection_columns_find;
        let columnName = (_state_collection_columns_find = state.collection.columns.find((c)=>c.key === column)) === null || _state_collection_columns_find === void 0 ? void 0 : _state_collection_columns_find.textValue;
        return sortDirection && column ? stringFormatter.format(`${sortDirection}Sort`, {
            columnName: columnName
        }) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortDirection,
        column,
        state.collection.columns
    ]);
    let descriptionProps = (0, $63b5f1dcd2b5cccc$export$f8aeda7b10753fa1)(sortDescription);
    (0, $756bc67872044ff1$export$496315a1608d9602)(()=>{
        (0, $f79874db04d9a0b8$export$a9b970dcc4ae71a9)(sortDescription, "assertive", 500);
    }, [
        sortDescription
    ]);
    return {
        gridProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(gridProps, descriptionProps, {
            // merge sort description with long press information
            "aria-describedby": [
                descriptionProps["aria-describedby"],
                gridProps["aria-describedby"]
            ].filter(Boolean).join(" ")
        })
    };
}





// src/components/table.ts
var $d0bdbaa1ab90c866$export$9852986a3ec5f6a0 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "flex flex-col relative gap-4",
        wrapper: [
            "p-4",
            "z-0",
            "flex",
            "flex-col",
            "relative",
            "justify-between",
            "gap-4",
            "shadow-small",
            "bg-content1",
            "overflow-auto"
        ],
        table: "min-w-full h-auto",
        thead: "[&>tr]:first:rounded-lg",
        tbody: "",
        tr: [
            "group",
            "outline-none",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        th: [
            "group",
            "px-3",
            "h-10",
            "align-middle",
            "bg-default-100",
            "whitespace-nowrap",
            "text-foreground-500",
            "text-tiny",
            "font-semibold",
            "first:rounded-l-lg",
            "rtl:first:rounded-r-lg",
            "rtl:first:rounded-l-[unset]",
            "last:rounded-r-lg",
            "rtl:last:rounded-l-lg",
            "rtl:last:rounded-r-[unset]",
            "outline-none",
            "data-[sortable=true]:cursor-pointer",
            "data-[hover=true]:text-foreground-400",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        td: [
            "py-2",
            "px-3",
            "relative",
            "align-middle",
            "whitespace-normal",
            "text-small",
            "font-normal",
            "outline-none",
            "[&>*]:z-1",
            "[&>*]:relative",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba),
            "before:content-['']",
            "before:absolute",
            "before:z-0",
            "before:inset-0",
            "before:opacity-0",
            "data-[selected=true]:before:opacity-100",
            "group-data-[disabled=true]:text-foreground-300",
            "group-data-[disabled=true]:cursor-not-allowed"
        ],
        tfoot: "",
        sortIcon: [
            "ml-2",
            "mb-px",
            "opacity-0",
            "text-inherit",
            "inline-block",
            "transition-transform-opacity",
            "data-[visible=true]:opacity-100",
            "group-data-[hover=true]:opacity-100",
            "data-[direction=ascending]:rotate-180"
        ],
        emptyWrapper: "text-foreground-400 align-middle text-center h-40",
        loadingWrapper: "absolute inset-0 flex items-center justify-center"
    },
    variants: {
        color: {
            default: {
                td: "before:bg-default/60 data-[selected=true]:text-default-foreground"
            },
            primary: {
                td: "before:bg-primary/20 data-[selected=true]:text-primary"
            },
            secondary: {
                td: "before:bg-secondary/20 data-[selected=true]:text-secondary"
            },
            success: {
                td: "before:bg-success/20 data-[selected=true]:text-success-600 dark:data-[selected=true]:text-success"
            },
            warning: {
                td: "before:bg-warning/20 data-[selected=true]:text-warning-600 dark:data-[selected=true]:text-warning"
            },
            danger: {
                td: "before:bg-danger/20 data-[selected=true]:text-danger dark:data-[selected=true]:text-danger-500"
            }
        },
        layout: {
            auto: {
                table: "table-auto"
            },
            fixed: {
                table: "table-fixed"
            }
        },
        radius: {
            none: {
                wrapper: "rounded-none"
            },
            sm: {
                wrapper: "rounded-small"
            },
            md: {
                wrapper: "rounded-medium"
            },
            lg: {
                wrapper: "rounded-large"
            }
        },
        shadow: {
            none: {
                wrapper: "shadow-none"
            },
            sm: {
                wrapper: "shadow-small"
            },
            md: {
                wrapper: "shadow-medium"
            },
            lg: {
                wrapper: "shadow-large"
            }
        },
        hideHeader: {
            true: {
                thead: "hidden"
            }
        },
        isStriped: {
            true: {
                td: [
                    "group-data-[odd=true]:before:bg-default-100",
                    "group-data-[odd=true]:before:opacity-100",
                    "group-data-[odd=true]:before:-z-10"
                ]
            }
        },
        isCompact: {
            true: {
                td: "py-1"
            },
            false: {}
        },
        isHeaderSticky: {
            true: {
                thead: "sticky top-0 z-20 [&>tr]:first:shadow-small"
            }
        },
        isSelectable: {
            true: {
                tr: "cursor-default",
                td: [
                    "group-aria-[selected=false]:group-data-[hover=true]:before:bg-default-100",
                    "group-aria-[selected=false]:group-data-[hover=true]:before:opacity-70"
                ]
            }
        },
        isMultiSelectable: {
            true: {
                td: [
                    "group-data-[first=true]:first:before:rounded-tl-lg",
                    "group-data-[first=true]:rtl:first:before:rounded-tr-lg",
                    "group-data-[first=true]:rtl:first:before:rounded-tl-[unset]",
                    "group-data-[first=true]:last:before:rounded-tr-lg",
                    "group-data-[first=true]:rtl:last:before:rounded-tl-lg",
                    "group-data-[first=true]:rtl:last:before:rounded-tr-[unset]",
                    "group-data-[middle=true]:before:rounded-none",
                    "group-data-[last=true]:first:before:rounded-bl-lg",
                    "group-data-[last=true]:rtl:first:before:rounded-br-lg",
                    "group-data-[last=true]:rtl:first:before:rounded-bl-[unset]",
                    "group-data-[last=true]:last:before:rounded-br-lg",
                    "group-data-[last=true]:rtl:last:before:rounded-bl-lg",
                    "group-data-[last=true]:rtl:last:before:rounded-br-[unset]"
                ]
            },
            false: {
                td: [
                    "first:before:rounded-l-lg",
                    "rtl:first:before:rounded-r-lg",
                    "rtl:first:before:rounded-l-[unset]",
                    "last:before:rounded-r-lg",
                    "rtl:last:before:rounded-l-lg",
                    "rtl:last:before:rounded-r-[unset]"
                ]
            }
        },
        fullWidth: {
            true: {
                base: "w-full",
                wrapper: "w-full",
                table: "w-full"
            }
        },
        align: {
            start: {
                th: "text-start",
                td: "text-start"
            },
            center: {
                th: "text-center",
                td: "text-center"
            },
            end: {
                th: "text-end",
                td: "text-end"
            }
        }
    },
    defaultVariants: {
        layout: "auto",
        shadow: "sm",
        radius: "lg",
        color: "default",
        isCompact: false,
        hideHeader: false,
        isStriped: false,
        fullWidth: true,
        align: "start"
    },
    compoundVariants: [
        {
            isStriped: true,
            color: "default",
            class: {
                td: "group-data-[odd=true]:data-[selected=true]:before:bg-default/60"
            }
        },
        {
            isStriped: true,
            color: "primary",
            class: {
                td: "group-data-[odd=true]:data-[selected=true]:before:bg-primary/20"
            }
        },
        {
            isStriped: true,
            color: "secondary",
            class: {
                td: "group-data-[odd=true]:data-[selected=true]:before:bg-secondary/20"
            }
        },
        {
            isStriped: true,
            color: "success",
            class: {
                td: "group-data-[odd=true]:data-[selected=true]:before:bg-success/20"
            }
        },
        {
            isStriped: true,
            color: "warning",
            class: {
                td: "group-data-[odd=true]:data-[selected=true]:before:bg-warning/20"
            }
        },
        {
            isStriped: true,
            color: "danger",
            class: {
                td: "group-data-[odd=true]:data-[selected=true]:before:bg-danger/20"
            }
        }
    ]
});





"use client";
function $7981957268c4fb5e$export$25bceaac3c7e4dc7(originalProps) {
    var _a;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $d0bdbaa1ab90c866$export$9852986a3ec5f6a0).variantKeys);
    const { ref: ref, as: as, baseRef: baseRef, children: children, className: className, classNames: classNames, layoutNode: layoutNode, removeWrapper: removeWrapper = false, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, selectionMode: selectionMode = "none", topContentPlacement: topContentPlacement = "inside", bottomContentPlacement: bottomContentPlacement = "inside", selectionBehavior: selectionBehavior = selectionMode === "none" ? null : "toggle", disabledBehavior: disabledBehavior = "selection", showSelectionCheckboxes: showSelectionCheckboxes = selectionMode === "multiple" && selectionBehavior !== "replace", BaseComponent: BaseComponent = "div", checkboxesProps: checkboxesProps, topContent: topContent, bottomContent: bottomContent, onRowAction: onRowAction, onCellAction: onCellAction, ...otherProps } = props;
    const Component = as || "table";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const domBaseRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(baseRef);
    const state = (0, $6745aa7b182015c2$export$907bcc6c48325fd6)({
        ...originalProps,
        children: children,
        showSelectionCheckboxes: showSelectionCheckboxes
    });
    const { collection: collection } = state;
    const { gridProps: gridProps } = (0, $3f3a92cd42925da9$export$25bceaac3c7e4dc7)({
        ...originalProps,
        layout: layoutNode
    }, state, domRef);
    const isSelectable = selectionMode !== "none";
    const isMultiSelectable = selectionMode === "multiple";
    const slots = (0, $acw62.useMemo)(()=>(0, $d0bdbaa1ab90c866$export$9852986a3ec5f6a0)({
            ...variantProps,
            isSelectable: isSelectable,
            isMultiSelectable: isMultiSelectable
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        isSelectable,
        isMultiSelectable
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const values = (0, $acw62.useMemo)(()=>{
        var _a2;
        return {
            state: state,
            slots: slots,
            isSelectable: isSelectable,
            collection: collection,
            classNames: classNames,
            color: originalProps == null ? void 0 : originalProps.color,
            disableAnimation: disableAnimation,
            checkboxesProps: checkboxesProps,
            isHeaderSticky: (_a2 = originalProps == null ? void 0 : originalProps.isHeaderSticky) != null ? _a2 : false,
            selectionMode: selectionMode,
            selectionBehavior: selectionBehavior,
            disabledBehavior: disabledBehavior,
            showSelectionCheckboxes: showSelectionCheckboxes,
            onRowAction: onRowAction,
            onCellAction: onCellAction
        };
    }, [
        slots,
        state,
        collection,
        isSelectable,
        classNames,
        selectionMode,
        selectionBehavior,
        checkboxesProps,
        disabledBehavior,
        disableAnimation,
        showSelectionCheckboxes,
        originalProps == null ? void 0 : originalProps.color,
        originalProps == null ? void 0 : originalProps.isHeaderSticky,
        onRowAction,
        onCellAction
    ]);
    const getBaseProps = (0, $acw62.useCallback)((props2)=>({
            ...props2,
            ref: domBaseRef,
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2 == null ? void 0 : props2.className)
            })
        }), [
        baseStyles,
        slots
    ]);
    const getWrapperProps = (0, $acw62.useCallback)((props2)=>({
            ...props2,
            ref: domBaseRef,
            className: slots.wrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            })
        }), [
        classNames == null ? void 0 : classNames.wrapper,
        slots
    ]);
    const getTableProps = (0, $acw62.useCallback)((props2)=>({
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(gridProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2),
            onKeyDownCapture: void 0,
            ref: domRef,
            className: slots.table({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.table, props2 == null ? void 0 : props2.className)
            })
        }), [
        classNames == null ? void 0 : classNames.table,
        shouldFilterDOMProps,
        slots,
        gridProps,
        otherProps
    ]);
    return {
        BaseComponent: BaseComponent,
        Component: Component,
        children: children,
        state: state,
        collection: collection,
        values: values,
        topContent: topContent,
        bottomContent: bottomContent,
        removeWrapper: removeWrapper,
        topContentPlacement: topContentPlacement,
        bottomContentPlacement: bottomContentPlacement,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps,
        getTableProps: getTableProps
    };
}



var $acw62 = parcelRequire("acw62");





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1d41e9ae116d0796$export$49571c903d73624c(props, state, ref) {
    let { gridCellProps: gridCellProps, isPressed: isPressed } = (0, $4a7e4abc48d8de6a$export$c7e10bfc0c59f67c)(props, state, ref);
    let columnKey = props.node.column.key;
    if (state.collection.rowHeaderColumnKeys.has(columnKey)) {
        gridCellProps.role = "rowheader";
        gridCellProps.id = (0, $95d9ad6a2a44012e$export$19baff3266315d44)(state, props.node.parentKey, columnKey);
    }
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}





"use client";
var $c5b0da9e1a9fdd43$var$TableCell = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b, _c;
    const { as: as, className: className, node: node, rowKey: rowKey, slots: slots, state: state, classNames: classNames, ...otherProps } = props;
    const Component = as || "td";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { gridCellProps: gridCellProps } = (0, $1d41e9ae116d0796$export$49571c903d73624c)({
        node: node
    }, state, domRef);
    const tdStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.td, className, (_a = node.props) == null ? void 0 : _a.className);
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const isRowSelected = state.selectionManager.isSelected(rowKey);
    const cell = (0, $acw62.useMemo)(()=>{
        const cellType = typeof node.rendered;
        return cellType !== "object" && cellType !== "function" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: node.rendered
        }) : node.rendered;
    }, [
        node.rendered
    ]);
    const columnProps = ((_b = node.column) == null ? void 0 : _b.props) || {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isRowSelected),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(gridCellProps, focusProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(node.props, {
            enabled: shouldFilterDOMProps
        }), otherProps),
        className: (_c = slots.td) == null ? void 0 : _c.call(slots, {
            align: columnProps.align,
            class: tdStyles
        }),
        children: cell
    });
});
$c5b0da9e1a9fdd43$var$TableCell.displayName = "NextUI.TableCell";
var $c5b0da9e1a9fdd43$export$1a8c89c19dbc91b1 = $c5b0da9e1a9fdd43$var$TableCell;











"use client";
var $0706b459d755baaf$var$TableCheckboxCell = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const { as: as, className: className, node: node, rowKey: rowKey, slots: slots, state: state, color: color, disableAnimation: disableAnimation, checkboxesProps: checkboxesProps, selectionMode: selectionMode, classNames: classNames, ...otherProps } = props;
    const Component = as || "td";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { gridCellProps: gridCellProps } = (0, $1d41e9ae116d0796$export$49571c903d73624c)({
        node: node
    }, state, domRef);
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { checkboxProps: checkboxProps } = (0, $ba0d02636058dc72$export$16ea7f650bd7c1bb)({
        key: (node == null ? void 0 : node.parentKey) || node.key
    }, state);
    const tdStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.td, className, (_a = node.props) == null ? void 0 : _a.className);
    const isSingleSelectionMode = selectionMode === "single";
    const { onChange: onChange, ...otherCheckboxProps } = checkboxProps;
    const isRowSelected = state.selectionManager.isSelected(rowKey);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isRowSelected),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(gridCellProps, focusProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(node.props, {
            enabled: shouldFilterDOMProps
        }), otherProps),
        className: (_b = slots.td) == null ? void 0 : _b.call(slots, {
            class: tdStyles
        }),
        children: isSingleSelectionMode ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
            children: checkboxProps["aria-label"]
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
            color: color,
            disableAnimation: disableAnimation,
            onValueChange: onChange,
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(checkboxesProps, otherCheckboxProps)
        })
    });
});
$0706b459d755baaf$var$TableCheckboxCell.displayName = "NextUI.TableCheckboxCell";
var $0706b459d755baaf$export$dfd671599f97b715 = $0706b459d755baaf$var$TableCheckboxCell;











/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $111687245d23fc77$export$96357d5a73f686fa(props, state, ref) {
    var _node_props, _node_props1;
    let { node: node, isVirtualized: isVirtualized, shouldSelectOnPressUp: shouldSelectOnPressUp, onAction: onAction } = props;
    let { actions: actions } = (0, $9f525a3b0fffde56$export$e6235c0d09b995d0).get(state);
    let onRowAction = actions.onRowAction ? ()=>actions.onRowAction(node.key) : onAction;
    let { itemProps: itemProps, ...states } = (0, $3d6314457f7d3ed1$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onRowAction || (node === null || node === void 0 ? void 0 : (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.onAction) ? (0, $d73b6ad2362dbd92$export$e08e3b67e392101e)(node === null || node === void 0 ? void 0 : (_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.onAction, onRowAction) : undefined,
        isDisabled: state.collection.size === 0
    });
    let isSelected = state.selectionManager.isSelected(node.key);
    let rowProps = {
        role: "row",
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined,
        "aria-disabled": states.isDisabled || undefined,
        ...itemProps
    };
    if (isVirtualized) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps,
        ...states
    };
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ffdeed353d1efbf5$var$$b2db214c022798eb$var$EXPANSION_KEYS = {
    expand: {
        ltr: "ArrowRight",
        rtl: "ArrowLeft"
    },
    "collapse": {
        ltr: "ArrowLeft",
        rtl: "ArrowRight"
    }
};
function $ffdeed353d1efbf5$export$7f2f6ae19e707aa5(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized } = props;
    let { rowProps: rowProps, ...states } = (0, $111687245d23fc77$export$96357d5a73f686fa)(props, state, ref);
    let { direction: direction } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    if (isVirtualized && !((0, $6ba33dc807dfb06e$export$1b00cb14a96194e6)() && "expandedKeys" in state)) rowProps["aria-rowindex"] = node.index + 1 + state.collection.headerRows.length; // aria-rowindex is 1 based
    else delete rowProps["aria-rowindex"];
    let treeGridRowProps = {};
    if ((0, $6ba33dc807dfb06e$export$1b00cb14a96194e6)() && "expandedKeys" in state) {
        let treeNode = state.keyMap.get(node.key);
        if (treeNode != null) {
            var _treeNode_props, _treeNode_props_children, _treeNode_props1;
            let hasChildRows = ((_treeNode_props = treeNode.props) === null || _treeNode_props === void 0 ? void 0 : _treeNode_props.UNSTABLE_childItems) || ((_treeNode_props1 = treeNode.props) === null || _treeNode_props1 === void 0 ? void 0 : (_treeNode_props_children = _treeNode_props1.children) === null || _treeNode_props_children === void 0 ? void 0 : _treeNode_props_children.length) > state.userColumnCount;
            treeGridRowProps = {
                onKeyDown: (e)=>{
                    if (e.key === $ffdeed353d1efbf5$var$$b2db214c022798eb$var$EXPANSION_KEYS["expand"][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && state.expandedKeys !== "all" && !state.expandedKeys.has(treeNode.key)) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    } else if (e.key === $ffdeed353d1efbf5$var$$b2db214c022798eb$var$EXPANSION_KEYS["collapse"][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && (state.expandedKeys === "all" || state.expandedKeys.has(treeNode.key))) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    }
                },
                "aria-expanded": hasChildRows ? state.expandedKeys === "all" || state.expandedKeys.has(node.key) : undefined,
                "aria-level": treeNode.level,
                "aria-posinset": treeNode.indexOfType + 1,
                "aria-setsize": treeNode.level > 1 ? (0, $f2e2cae04a4a64ed$export$7475b2c64539e4cf)(state.keyMap.get(treeNode === null || treeNode === void 0 ? void 0 : treeNode.parentKey).childNodes).indexOfType + 1 : (0, $f2e2cae04a4a64ed$export$7475b2c64539e4cf)(state.keyMap.get(state.collection.body.key).childNodes).indexOfType + 1
            };
        }
    }
    let linkProps = states.hasAction ? (0, $4a4107ecda93bad9$export$51437d503373d223)(node.props) : {};
    return {
        rowProps: {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(rowProps, treeGridRowProps, linkProps),
            "aria-labelledby": (0, $95d9ad6a2a44012e$export$85069b70317f543)(state, node.key)
        },
        ...states
    };
}






var $acw62 = parcelRequire("acw62");

"use client";
var $eff1259cb05bfb9e$var$TableRow = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const { as: as, className: className, children: children, node: node, slots: slots, state: state, isSelectable: isSelectable, classNames: classNames, ...otherProps } = props;
    const Component = as || ((props == null ? void 0 : props.href) ? "a" : "tr");
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { rowProps: rowProps } = (0, $ffdeed353d1efbf5$export$7f2f6ae19e707aa5)({
        node: node
    }, state, domRef);
    const trStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.tr, className, (_a = node.props) == null ? void 0 : _a.className);
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const isDisabled = state.disabledKeys.has(node.key);
    const isSelected = state.selectionManager.isSelected(node.key);
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled
    });
    const { isFirst: isFirst, isLast: isLast, isMiddle: isMiddle, isOdd: isOdd } = (0, $acw62.useMemo)(()=>{
        const isFirst2 = node.key === state.collection.getFirstKey();
        const isLast2 = node.key === state.collection.getLastKey();
        const isMiddle2 = !isFirst2 && !isLast2;
        const isOdd2 = (node == null ? void 0 : node.index) ? (node.index + 1) % 2 === 0 : false;
        return {
            isFirst: isFirst2,
            isLast: isLast2,
            isMiddle: isMiddle2,
            isOdd: isOdd2
        };
    }, [
        node,
        state.collection
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabled),
        "data-first": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFirst),
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
        "data-last": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isLast),
        "data-middle": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isMiddle),
        "data-odd": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isOdd),
        "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(rowProps, focusProps, isSelectable ? hoverProps : {}, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(node.props, {
            enabled: shouldFilterDOMProps
        }), otherProps),
        className: (_b = slots.tr) == null ? void 0 : _b.call(slots, {
            class: trStyles
        }),
        children: children
    });
});
$eff1259cb05bfb9e$var$TableRow.displayName = "NextUI.TableRow";
var $eff1259cb05bfb9e$export$eee7efc9a4e84001 = $eff1259cb05bfb9e$var$TableRow;









/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $576383405b4e66dd$export$1b95a7d2d517b841(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized } = props;
    let rowProps = {
        role: "row"
    };
    if (isVirtualized && !((0, $6ba33dc807dfb06e$export$1b00cb14a96194e6)() && "expandedKeys" in state)) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps
    };
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f4978a739f4ae46e$export$d3037f5d3f3e51bf() {
    return {
        rowGroupProps: {
            role: "rowgroup"
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2002fc76336ef0b3$export$6fb1613bd7b28198() {
    return (0, $f4978a739f4ae46e$export$d3037f5d3f3e51bf)();
}




var $acw62 = parcelRequire("acw62");

"use client";
var $3dc000a1743ad448$var$TableBody = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, slots: slots, state: state, collection: collection, isSelectable: isSelectable, color: color, disableAnimation: disableAnimation, checkboxesProps: checkboxesProps, selectionMode: selectionMode, classNames: classNames, ...otherProps } = props;
    const Component = as || "tbody";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { rowGroupProps: rowGroupProps } = (0, $2002fc76336ef0b3$export$6fb1613bd7b28198)();
    const tbodyStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.tbody, className);
    const bodyProps = collection == null ? void 0 : collection.body.props;
    const isLoading = (bodyProps == null ? void 0 : bodyProps.isLoading) || (bodyProps == null ? void 0 : bodyProps.loadingState) === "loading" || (bodyProps == null ? void 0 : bodyProps.loadingState) === "loadingMore";
    const renderRows = (0, $acw62.useMemo)(()=>{
        return [
            ...collection.body.childNodes
        ].map((row)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $eff1259cb05bfb9e$export$eee7efc9a4e84001), {
                classNames: classNames,
                isSelectable: isSelectable,
                node: row,
                slots: slots,
                state: state,
                children: [
                    ...row.childNodes
                ].map((cell)=>cell.props.isSelectionCell ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0706b459d755baaf$export$dfd671599f97b715), {
                        checkboxesProps: checkboxesProps,
                        classNames: classNames,
                        color: color,
                        disableAnimation: disableAnimation,
                        node: cell,
                        rowKey: row.key,
                        selectionMode: selectionMode,
                        slots: slots,
                        state: state
                    }, cell.key) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c5b0da9e1a9fdd43$export$1a8c89c19dbc91b1), {
                        classNames: classNames,
                        node: cell,
                        rowKey: row.key,
                        slots: slots,
                        state: state
                    }, cell.key))
            }, row.key));
    }, [
        collection.body.childNodes,
        classNames,
        isSelectable,
        slots,
        state
    ]);
    let emptyContent;
    let loadingContent;
    if (collection.size === 0 && bodyProps.emptyContent) emptyContent = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("tr", {
        role: "row",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("td", {
            className: slots == null ? void 0 : slots.emptyWrapper({
                class: classNames == null ? void 0 : classNames.emptyWrapper
            }),
            colSpan: collection.columnCount,
            role: "gridcell",
            children: !isLoading && bodyProps.emptyContent
        })
    });
    if (isLoading && bodyProps.loadingContent) loadingContent = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("tr", {
        role: "row",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("td", {
                className: slots == null ? void 0 : slots.loadingWrapper({
                    class: classNames == null ? void 0 : classNames.loadingWrapper
                }),
                colSpan: collection.columnCount,
                role: "gridcell",
                children: bodyProps.loadingContent
            }),
            !emptyContent && collection.size === 0 ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("td", {
                className: slots == null ? void 0 : slots.emptyWrapper({
                    class: classNames == null ? void 0 : classNames.emptyWrapper
                })
            }) : null
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ref: domRef,
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(rowGroupProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(bodyProps, {
            enabled: shouldFilterDOMProps
        }), otherProps),
        className: (_a = slots.tbody) == null ? void 0 : _a.call(slots, {
            class: tbodyStyles
        }),
        "data-empty": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(collection.size === 0),
        "data-loading": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isLoading),
        children: [
            renderRows,
            loadingContent,
            emptyContent
        ]
    });
});
$3dc000a1743ad448$var$TableBody.displayName = "NextUI.TableBody";
var $3dc000a1743ad448$export$cae9d4714bdb0040 = $3dc000a1743ad448$var$TableBody;












"use client";
var $ae9e227e089df2bf$var$TableColumnHeader = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b, _c, _d, _e;
    const { as: as, className: className, state: state, node: node, slots: slots, classNames: classNames, ...otherProps } = props;
    const Component = as || "th";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { columnHeaderProps: columnHeaderProps } = (0, $928aa0e7bfd716f6$export$9514819a8c81e960)({
        node: node
    }, state, domRef);
    const thStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.th, className, (_a = node.props) == null ? void 0 : _a.className);
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({});
    const { hideHeader: hideHeader, align: align, ...columnProps } = node.props;
    const allowsSorting = columnProps.allowsSorting;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ref: domRef,
        colSpan: node.colspan,
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
        "data-sortable": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(allowsSorting),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(columnHeaderProps, focusProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(columnProps, {
            enabled: shouldFilterDOMProps
        }), allowsSorting ? hoverProps : {}, otherProps),
        className: (_b = slots.th) == null ? void 0 : _b.call(slots, {
            align: align,
            class: thStyles
        }),
        children: [
            hideHeader ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7d2c6e0c39112405$export$439d29a4e110a164), {
                children: node.rendered
            }) : node.rendered,
            allowsSorting && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3d5bf69f39f72f17$export$4857d3f3f5f8319b), {
                "aria-hidden": "true",
                className: (_c = slots.sortIcon) == null ? void 0 : _c.call(slots, {
                    class: classNames == null ? void 0 : classNames.sortIcon
                }),
                "data-direction": (_d = state.sortDescriptor) == null ? void 0 : _d.direction,
                "data-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(((_e = state.sortDescriptor) == null ? void 0 : _e.column) === node.key),
                strokeWidth: 3
            })
        ]
    });
});
$ae9e227e089df2bf$var$TableColumnHeader.displayName = "NextUI.TableColumnHeader";
var $ae9e227e089df2bf$export$b2c6dc5b2c41e2af = $ae9e227e089df2bf$var$TableColumnHeader;








"use client";
var $ed7532f6edcccdef$var$TableHeaderRow = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const { as: as, className: className, children: children, node: node, slots: slots, classNames: classNames, state: state, ...otherProps } = props;
    const Component = as || "tr";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { rowProps: rowProps } = (0, $576383405b4e66dd$export$1b95a7d2d517b841)({
        node: node
    }, state, domRef);
    const trStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.tr, className, (_a = node.props) == null ? void 0 : _a.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(rowProps, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(node.props, {
            enabled: shouldFilterDOMProps
        }), otherProps),
        className: (_b = slots.tr) == null ? void 0 : _b.call(slots, {
            class: trStyles
        }),
        children: children
    });
});
$ed7532f6edcccdef$var$TableHeaderRow.displayName = "NextUI.TableHeaderRow";
var $ed7532f6edcccdef$export$565500cba76b2388 = $ed7532f6edcccdef$var$TableHeaderRow;








"use client";
var $b6f1e01594f6ff80$var$TableRowGroup = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, slots: slots, classNames: classNames, ...otherProps } = props;
    const Component = as || "thead";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { rowGroupProps: rowGroupProps } = (0, $2002fc76336ef0b3$export$6fb1613bd7b28198)();
    const theadStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.thead, className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.thead) == null ? void 0 : _a.call(slots, {
            class: theadStyles
        }),
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(rowGroupProps, otherProps),
        children: children
    });
});
$b6f1e01594f6ff80$var$TableRowGroup.displayName = "NextUI.TableRowGroup";
var $b6f1e01594f6ff80$export$6f5675592ad0c799 = $b6f1e01594f6ff80$var$TableRowGroup;



var $acw62 = parcelRequire("acw62");
// src/utils.ts
var $41c6639d0b06372a$export$5458b64234d1333c = {
    px: "1px",
    0: "0px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    11: "2.75rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};




// src/components/spacer.ts
var $45e61ec3849b08cb$export$8cc075c801fd6817 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    base: "w-px h-px inline-block",
    variants: {
        isInline: {
            true: "inline-block",
            false: "block"
        }
    },
    defaultVariants: {
        isInline: false
    }
});




var $acw62 = parcelRequire("acw62");
var $e989446f462ec2be$export$1bc603050bd777b1 = (value)=>{
    var _a;
    return (_a = (0, $41c6639d0b06372a$export$5458b64234d1333c)[value]) != null ? _a : value;
};
function $e989446f462ec2be$export$58945fa1b9292af9(originalProps) {
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $45e61ec3849b08cb$export$8cc075c801fd6817).variantKeys);
    const { as: as, className: className, x: x = 1, y: y = 1, ...otherProps } = props;
    const Component = as || "span";
    const styles = (0, $acw62.useMemo)(()=>(0, $45e61ec3849b08cb$export$8cc075c801fd6817)({
            ...variantProps,
            className: className
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        className
    ]);
    const marginLeft = $e989446f462ec2be$export$1bc603050bd777b1(x);
    const marginTop = $e989446f462ec2be$export$1bc603050bd777b1(y);
    const getSpacerProps = (props2 = {})=>({
            ...props2,
            ...otherProps,
            "aria-hidden": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(true),
            className: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(styles, props2.className),
            style: {
                ...props2.style,
                ...otherProps.style,
                marginLeft: marginLeft,
                marginTop: marginTop
            }
        });
    return {
        Component: Component,
        getSpacerProps: getSpacerProps
    };
}




var $c2d5cf3f65a96edc$var$Spacer = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, getSpacerProps: getSpacerProps } = (0, $e989446f462ec2be$export$58945fa1b9292af9)({
        ...props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...getSpacerProps()
    });
});
$c2d5cf3f65a96edc$var$Spacer.displayName = "NextUI.Spacer";
var $c2d5cf3f65a96edc$export$64d520e621f7eab5 = $c2d5cf3f65a96edc$var$Spacer;




"use client";
var $a1557883e42e31c6$var$Table = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    const { BaseComponent: BaseComponent, Component: Component, collection: collection, values: values, topContent: topContent, topContentPlacement: topContentPlacement, bottomContentPlacement: bottomContentPlacement, bottomContent: bottomContent, removeWrapper: removeWrapper, getBaseProps: getBaseProps, getWrapperProps: getWrapperProps, getTableProps: getTableProps } = (0, $7981957268c4fb5e$export$25bceaac3c7e4dc7)({
        ...props,
        ref: ref
    });
    const Wrapper = (0, $acw62.useCallback)(({ children: children })=>{
        if (removeWrapper) return children;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseComponent, {
            ...getWrapperProps(),
            children: children
        });
    }, [
        removeWrapper,
        getWrapperProps
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getBaseProps(),
        children: [
            topContentPlacement === "outside" && topContent,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Wrapper, {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        topContentPlacement === "inside" && topContent,
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
                            ...getTableProps(),
                            children: [
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $b6f1e01594f6ff80$export$6f5675592ad0c799), {
                                    classNames: values.classNames,
                                    slots: values.slots,
                                    children: [
                                        collection.headerRows.map((headerRow)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ed7532f6edcccdef$export$565500cba76b2388), {
                                                classNames: values.classNames,
                                                node: headerRow,
                                                slots: values.slots,
                                                state: values.state,
                                                children: [
                                                    ...headerRow.childNodes
                                                ].map((column)=>{
                                                    var _a;
                                                    return ((_a = column == null ? void 0 : column.props) == null ? void 0 : _a.isSelectionCell) ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ea7309e03be8cf89$export$ab49b1d1dfe14ac6), {
                                                        checkboxesProps: values.checkboxesProps,
                                                        classNames: values.classNames,
                                                        color: values.color,
                                                        disableAnimation: values.disableAnimation,
                                                        node: column,
                                                        selectionMode: values.selectionMode,
                                                        slots: values.slots,
                                                        state: values.state
                                                    }, column == null ? void 0 : column.key) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ae9e227e089df2bf$export$b2c6dc5b2c41e2af), {
                                                        classNames: values.classNames,
                                                        node: column,
                                                        slots: values.slots,
                                                        state: values.state
                                                    }, column == null ? void 0 : column.key);
                                                })
                                            }, headerRow == null ? void 0 : headerRow.key)),
                                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c2d5cf3f65a96edc$export$64d520e621f7eab5), {
                                            as: "tr",
                                            tabIndex: -1,
                                            y: 1
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3dc000a1743ad448$export$cae9d4714bdb0040), {
                                    checkboxesProps: values.checkboxesProps,
                                    classNames: values.classNames,
                                    collection: values.collection,
                                    color: values.color,
                                    disableAnimation: values.disableAnimation,
                                    isSelectable: values.isSelectable,
                                    selectionMode: values.selectionMode,
                                    slots: values.slots,
                                    state: values.state
                                })
                            ]
                        }),
                        bottomContentPlacement === "inside" && bottomContent
                    ]
                })
            }),
            bottomContentPlacement === "outside" && bottomContent
        ]
    });
});
$a1557883e42e31c6$var$Table.displayName = "NextUI.Table";
var $a1557883e42e31c6$export$243f992f13002393 = $a1557883e42e31c6$var$Table;


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $119a6d6135e6bea9$var$$4ae5314bf50db1a3$var$TableBody(props) {
    return null;
}
$119a6d6135e6bea9$var$$4ae5314bf50db1a3$var$TableBody.getCollectionNode = function* getCollectionNode(props) {
    let { children: children, items: items } = props;
    yield {
        type: "body",
        hasChildNodes: true,
        props: props,
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (item)=>{
                    items.push({
                        type: "item",
                        element: item
                    });
                });
                yield* items;
            }
        }
    };
};
/**
 * A TableBody is a container for the Row elements of a Table. Rows can be statically defined
 * as children, or generated dynamically using a function based on the data passed to the `items` prop.
 */ // We don't want getCollectionNode to show up in the type definition
let $119a6d6135e6bea9$export$76ccd210b9029917 = $119a6d6135e6bea9$var$$4ae5314bf50db1a3$var$TableBody;


"use client";
var $56bd304ee6f8d96b$var$TableBody = (0, $119a6d6135e6bea9$export$76ccd210b9029917);
var $56bd304ee6f8d96b$export$cae9d4714bdb0040 = $56bd304ee6f8d96b$var$TableBody;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4818dab17c872c99$var$$941d1d9a6a28982a$var$Cell(props) {
    return null;
}
$4818dab17c872c99$var$$941d1d9a6a28982a$var$Cell.getCollectionNode = function* getCollectionNode(props) {
    let { children: children } = props;
    let textValue = props.textValue || (typeof children === "string" ? children : "") || props["aria-label"] || "";
    yield {
        type: "cell",
        props: props,
        rendered: children,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: false
    };
};
/**
 * A Cell represents the value of a single Column within a Table Row.
 */ // We don't want getCollectionNode to show up in the type definition
let $4818dab17c872c99$export$f6f0c3fe4ec306ea = $4818dab17c872c99$var$$941d1d9a6a28982a$var$Cell;


"use client";
var $dcaabaac807b89eb$var$TableCell = (0, $4818dab17c872c99$export$f6f0c3fe4ec306ea);
var $dcaabaac807b89eb$export$1a8c89c19dbc91b1 = $dcaabaac807b89eb$var$TableCell;


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $be8282e0315a54cf$var$$1cd244557c2f97d5$var$Column(props) {
    return null;
}
$be8282e0315a54cf$var$$1cd244557c2f97d5$var$Column.getCollectionNode = function* getCollectionNode(props, context) {
    let { title: title, children: children, childColumns: childColumns } = props;
    let rendered = title || children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"];
    let fullNodes = yield {
        type: "column",
        hasChildNodes: !!childColumns || title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) > 0,
        rendered: rendered,
        textValue: textValue,
        props: props,
        *childNodes () {
            if (childColumns) for (let child of childColumns)yield {
                type: "column",
                value: child
            };
            else if (title) {
                let childColumns = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    childColumns.push({
                        type: "column",
                        element: child
                    });
                });
                yield* childColumns;
            }
        },
        shouldInvalidate (newContext) {
            // This is a bit of a hack, but it works.
            // If this method is called, then there's a cached version of this node available.
            // But, we need to keep the list of columns in the new context up to date.
            updateContext(newContext);
            return false;
        }
    };
    let updateContext = (context)=>{
        // register leaf columns on the context so that <Row> can access them
        for (let node of fullNodes)if (!node.hasChildNodes) context.columns.push(node);
    };
    updateContext(context);
};
/**
 * A Column represents a field of each item within a Table. Columns may also contain nested
 * Column elements to represent column groups. Nested columns can be statically defined as
 * children, or dynamically generated using a function based on the `childColumns` prop.
 */ // We don't want getCollectionNode to show up in the type definition
let $be8282e0315a54cf$export$816b5d811295e6bc = $be8282e0315a54cf$var$$1cd244557c2f97d5$var$Column;


"use client";
var $bb52f7bb7f27effd$var$TableColumn = (0, $be8282e0315a54cf$export$816b5d811295e6bc);
var $bb52f7bb7f27effd$export$543cfe274bbcf0c9 = $bb52f7bb7f27effd$var$TableColumn;


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c76d2306a0bc4153$var$$312ae3b56a94a86e$var$TableHeader(props) {
    return null;
}
$c76d2306a0bc4153$var$$312ae3b56a94a86e$var$TableHeader.getCollectionNode = function* getCollectionNode(props, context) {
    let { children: children, columns: columns } = props;
    // Clear columns so they aren't double added in strict mode.
    context.columns = [];
    if (typeof children === "function") {
        if (!columns) throw new Error("props.children was a function but props.columns is missing");
        for (let column of columns)yield {
            type: "column",
            value: column,
            renderer: children
        };
    } else {
        let columns = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (column)=>{
            columns.push({
                type: "column",
                element: column
            });
        });
        yield* columns;
    }
};
/**
 * A TableHeader is a container for the Column elements in a Table. Columns can be statically defined
 * as children, or generated dynamically using a function based on the data passed to the `columns` prop.
 */ // We don't want getCollectionNode to show up in the type definition
let $c76d2306a0bc4153$export$f850895b287ef28e = $c76d2306a0bc4153$var$$312ae3b56a94a86e$var$TableHeader;


"use client";
var $7203efdeccfc2375$var$TableHeader = (0, $c76d2306a0bc4153$export$f850895b287ef28e);
var $7203efdeccfc2375$export$251388f483db4908 = $7203efdeccfc2375$var$TableHeader;


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cf4a4297bd64db15$var$$70d70eb16ea48428$var$Row(props) {
    return null;
}
$cf4a4297bd64db15$var$$70d70eb16ea48428$var$Row.getCollectionNode = function* getCollectionNode(props, context) {
    let { children: children, textValue: textValue, UNSTABLE_childItems: UNSTABLE_childItems } = props;
    yield {
        type: "item",
        props: props,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: true,
        *childNodes () {
            // Process cells first
            if (context.showDragButtons) yield {
                type: "cell",
                key: "header-drag",
                props: {
                    isDragButtonCell: true
                }
            };
            if (context.showSelectionCheckboxes && context.selectionMode !== "none") yield {
                type: "cell",
                key: "header",
                props: {
                    isSelectionCell: true
                }
            };
            if (typeof children === "function") {
                for (let column of context.columns)yield {
                    type: "cell",
                    element: children(column.key),
                    key: column.key // this is combined with the row key by CollectionBuilder
                };
                if (UNSTABLE_childItems) for (let child of UNSTABLE_childItems)// the parent renderer and use that to build the full node of this child row, using the value provided here to generate the cells
                yield {
                    type: "item",
                    value: child
                };
            } else {
                let cells = [];
                let childRows = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (node)=>{
                    if (node.type === $cf4a4297bd64db15$var$$70d70eb16ea48428$var$Row) {
                        if (cells.length < context.columns.length) throw new Error("All of a Row's child Cells must be positioned before any child Rows.");
                        childRows.push({
                            type: "item",
                            element: node
                        });
                    } else cells.push({
                        type: "cell",
                        element: node
                    });
                });
                if (cells.length !== context.columns.length) throw new Error(`Cell count must match column count. Found ${cells.length} cells and ${context.columns.length} columns.`);
                yield* cells;
                yield* childRows;
            }
        },
        shouldInvalidate (newContext) {
            // Invalidate all rows if the columns changed.
            return newContext.columns.length !== context.columns.length || newContext.columns.some((c, i)=>c.key !== context.columns[i].key) || newContext.showSelectionCheckboxes !== context.showSelectionCheckboxes || newContext.showDragButtons !== context.showDragButtons || newContext.selectionMode !== context.selectionMode;
        }
    };
};
/**
 * A Row represents a single item in a Table and contains Cell elements for each column.
 * Cells can be statically defined as children, or generated dynamically using a function
 * based on the columns defined in the TableHeader.
 */ // We don't want getCollectionNode to show up in the type definition
let $cf4a4297bd64db15$export$b59bdbef9ce70de2 = $cf4a4297bd64db15$var$$70d70eb16ea48428$var$Row;


"use client";
var $e1d5270867337b33$var$TableRow = (0, $cf4a4297bd64db15$export$b59bdbef9ce70de2);
var $e1d5270867337b33$export$eee7efc9a4e84001 = $e1d5270867337b33$var$TableRow;





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $200b1273fb83454d$export$c5f62239608282b6 = new WeakMap();
function $200b1273fb83454d$export$567fc7097e064344(state, key, role) {
    if (typeof key === "string") key = key.replace(/\s+/g, "");
    let baseId = $200b1273fb83454d$export$c5f62239608282b6.get(state);
    return `${baseId}-${role}-${key}`;
}





var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $55d56af2e4966de4$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $acw62.useState)(false);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9ed89fda71184118$export$fae0121b5afe572d(props, state, ref) {
    // The tabpanel should have tabIndex=0 when there are no tabbable elements within it.
    // Otherwise, tabbing from the focused tab should go directly to the first tabbable element
    // within the tabpanel.
    let tabIndex = (0, $55d56af2e4966de4$export$eac1895992b9f3d6)(ref) ? undefined : 0;
    var _props_id;
    const id = (0, $200b1273fb83454d$export$567fc7097e064344)(state, (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : state === null || state === void 0 ? void 0 : state.selectedKey, "tabpanel");
    const tabPanelProps = (0, $2ca439ee1a804558$export$d6875122194c7b44)({
        ...props,
        id: id,
        "aria-labelledby": (0, $200b1273fb83454d$export$567fc7097e064344)(state, state === null || state === void 0 ? void 0 : state.selectedKey, "tab")
    });
    return {
        tabPanelProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(tabPanelProps, {
            tabIndex: tabIndex,
            role: "tabpanel",
            "aria-describedby": props["aria-describedby"],
            "aria-details": props["aria-details"]
        })
    };
}




"use client";
var $d58274ae4e45a7fe$var$TabPanel = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const { as: as, tabKey: tabKey, destroyInactiveTabPanel: destroyInactiveTabPanel, state: state, className: className, slots: slots, classNames: classNames, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const { tabPanelProps: tabPanelProps } = (0, $9ed89fda71184118$export$fae0121b5afe572d)({
        ...props,
        id: String(tabKey)
    }, state, domRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const selectedItem = state.selectedItem;
    const content = state.collection.getItem(tabKey).props.children;
    const tabPanelStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.panel, className, (_a = selectedItem == null ? void 0 : selectedItem.props) == null ? void 0 : _a.className);
    const isSelected = tabKey === (selectedItem == null ? void 0 : selectedItem.key);
    if (!content || !isSelected && destroyInactiveTabPanel) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: domRef,
        "data-focus": isFocused,
        "data-focus-visible": isFocusVisible,
        "data-inert": !isSelected ? "true" : void 0,
        inert: !isSelected ? "true" : void 0,
        ...isSelected && (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(tabPanelProps, focusProps, otherProps),
        className: (_b = slots.panel) == null ? void 0 : _b.call(slots, {
            class: tabPanelStyles
        }),
        "data-slot": "panel",
        children: content
    });
});
$d58274ae4e45a7fe$var$TabPanel.displayName = "NextUI.TabPanel";
var $d58274ae4e45a7fe$export$1e1524a300d1fd38 = $d58274ae4e45a7fe$var$TabPanel;






const $a135099456a3a66d$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $a135099456a3a66d$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $a135099456a3a66d$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $a135099456a3a66d$var$e(o.overflowY, n) || $a135099456a3a66d$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $a135099456a3a66d$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $a135099456a3a66d$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $a135099456a3a66d$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$a135099456a3a66d$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $a135099456a3a66d$var$t(W) && p(W);){
        if (W = $a135099456a3a66d$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $a135099456a3a66d$var$n(W) && !$a135099456a3a66d$var$n(document.documentElement) || null != W && $a135099456a3a66d$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $a135099456a3a66d$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $a135099456a3a66d$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $a135099456a3a66d$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $a135099456a3a66d$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};


const $b26c6e29c94de039$var$o = (e)=>!1 === e ? {
        block: "end",
        inline: "nearest"
    } : ((e)=>e === Object(e) && 0 !== Object.keys(e).length)(e) ? e : {
        block: "start",
        inline: "nearest"
    };
function $b26c6e29c94de039$export$2e2bcd8739ae039(t, n) {
    if (!t.isConnected || !((e)=>{
        let o = e;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(t)) return;
    if (((e)=>"object" == typeof e && "function" == typeof e.behavior)(n)) return n.behavior((0, $a135099456a3a66d$export$3b12cb22b12b954b)(t, n));
    const r = "boolean" == typeof n || null == n ? void 0 : n.behavior;
    for (const { el: i, top: a, left: l } of (0, $a135099456a3a66d$export$3b12cb22b12b954b)(t, $b26c6e29c94de039$var$o(n)))i.scroll({
        top: a,
        left: l,
        behavior: r
    });
}






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $54d4909d2560d817$export$fdf4756d5b8ef90a(props, state, ref) {
    let { key: key, isDisabled: propsDisabled, shouldSelectOnPressUp: shouldSelectOnPressUp } = props;
    let { selectionManager: manager, selectedKey: selectedKey } = state;
    let isSelected = key === selectedKey;
    let isDisabled = propsDisabled || state.isDisabled || state.selectionManager.isDisabled(key);
    let { itemProps: itemProps, isPressed: isPressed } = (0, $195fc3c02bfc1bb3$export$ecf600387e221c37)({
        selectionManager: manager,
        key: key,
        ref: ref,
        isDisabled: isDisabled,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        linkBehavior: "selection"
    });
    let tabId = (0, $200b1273fb83454d$export$567fc7097e064344)(state, key, "tab");
    let tabPanelId = (0, $200b1273fb83454d$export$567fc7097e064344)(state, key, "tabpanel");
    let { tabIndex: tabIndex } = itemProps;
    let item = state.collection.getItem(key);
    let domProps = (0, $b8574754bee97e48$export$457c3d6518dd4c6f)(item === null || item === void 0 ? void 0 : item.props, {
        labelable: true
    });
    delete domProps.id;
    let linkProps = (0, $4a4107ecda93bad9$export$7e924b3091a3bd18)(item === null || item === void 0 ? void 0 : item.props);
    return {
        tabProps: (0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(domProps, linkProps, itemProps, {
            id: tabId,
            "aria-selected": isSelected,
            "aria-disabled": isDisabled || undefined,
            "aria-controls": isSelected ? tabPanelId : undefined,
            tabIndex: isDisabled ? undefined : tabIndex,
            role: "tab"
        }),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed
    };
}






/**
 * @public
 */ const $7f46fbf4444a9d13$export$31b6301a9536f8bb = {
    ...(0, $5b406ea0040c92c5$export$2cb19dbf990677e3),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};


// src/index.ts

var $acw62 = parcelRequire("acw62");
function $98ae50ee67409932$export$80c2a3957bcb42ea(props = {}) {
    const { rerender: rerender = false, delay: delay = 0 } = props;
    const isMountedRef = (0, $acw62.useRef)(false);
    const [isMounted, setIsMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        isMountedRef.current = true;
        let timer = null;
        if (rerender) {
            if (delay > 0) timer = setTimeout(()=>{
                setIsMounted(true);
            }, delay);
            else setIsMounted(true);
        }
        return ()=>{
            isMountedRef.current = false;
            if (rerender) setIsMounted(false);
            if (timer) clearTimeout(timer);
        };
    }, [
        rerender
    ]);
    return [
        (0, $acw62.useCallback)(()=>isMountedRef.current, []),
        isMounted
    ];
}



"use client";
var $350a76e04dfee88b$var$Tab = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { className: className, as: as, item: item, state: state, classNames: classNames, isDisabled: isDisabledProp, listRef: listRef, slots: slots, motionProps: motionProps, disableAnimation: disableAnimation, disableCursorAnimation: disableCursorAnimation, shouldSelectOnPressUp: shouldSelectOnPressUp, onClick: onClick, ...otherProps } = props;
    const { key: key } = item;
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const Component = as || (props.href ? "a" : "button");
    const shouldFilterDOMProps = typeof Component === "string";
    const { tabProps: tabProps, isSelected: isSelected, isDisabled: isDisabledItem, isPressed: isPressed } = (0, $54d4909d2560d817$export$fdf4756d5b8ef90a)({
        key: key,
        isDisabled: isDisabledProp,
        shouldSelectOnPressUp: shouldSelectOnPressUp
    }, state, domRef);
    if (props.children == null) delete tabProps["aria-controls"];
    const isDisabled = isDisabledProp || isDisabledItem;
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $eb6b0cc1c3f8613d$export$4e328f61c538687f)();
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $4a6a19e952a3e910$export$ae780daf29e6d456)({
        isDisabled: isDisabled
    });
    const tabStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.tab, className);
    const [, isMounted] = (0, $98ae50ee67409932$export$80c2a3957bcb42ea)({
        rerender: true
    });
    const handleClick = ()=>{
        (0, $276a22df76563a4a$export$e08e3b67e392101e)(onClick, tabProps.onClick);
        if (!(domRef == null ? void 0 : domRef.current) || !(listRef == null ? void 0 : listRef.current)) return;
        (0, $b26c6e29c94de039$export$2e2bcd8739ae039)(domRef.current, {
            scrollMode: "if-needed",
            behavior: "smooth",
            block: "end",
            inline: "end",
            boundary: listRef == null ? void 0 : listRef.current
        });
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(Component, {
        ref: domRef,
        "data-disabled": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isDisabledItem),
        "data-focus": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocused),
        "data-focus-visible": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isFocusVisible),
        "data-hover": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isHovered),
        "data-hover-unselected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)((isHovered || isPressed) && !isSelected),
        "data-pressed": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isPressed),
        "data-selected": (0, $337b0bbaace84edd$export$5cc3b7b83e34ade7)(isSelected),
        "data-slot": "tab",
        ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(tabProps, !isDisabled ? {
            ...focusProps,
            ...hoverProps
        } : {}, (0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
            enabled: shouldFilterDOMProps,
            omitPropNames: /* @__PURE__ */ new Set([
                "title"
            ])
        }), {
            onClick: handleClick
        }),
        className: (_a = slots.tab) == null ? void 0 : _a.call(slots, {
            class: tabStyles
        }),
        title: otherProps == null ? void 0 : otherProps.titleValue,
        type: Component === "button" ? "button" : void 0,
        children: [
            isSelected && !disableAnimation && !disableCursorAnimation && isMounted ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0bd28bebc5020f64$export$23c340a7eb1b419), {
                features: (0, $7f46fbf4444a9d13$export$31b6301a9536f8bb),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b066ad3acb0975d$export$953cecd6e717a553).span, {
                    className: slots.cursor({
                        class: classNames == null ? void 0 : classNames.cursor
                    }),
                    "data-slot": "cursor",
                    layoutDependency: false,
                    layoutId: "cursor",
                    transition: {
                        type: "spring",
                        bounce: 0.15,
                        duration: 0.5
                    },
                    ...motionProps
                })
            }) : null,
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: slots.tabContent({
                    class: classNames == null ? void 0 : classNames.tabContent
                }),
                "data-slot": "tabContent",
                children: item.rendered
            })
        ]
    });
});
$350a76e04dfee88b$var$Tab.displayName = "NextUI.Tab";
var $350a76e04dfee88b$export$937bc6071adf91f = $350a76e04dfee88b$var$Tab;






// src/components/tabs.ts
var $78f5957a65c02df5$export$39f5674517ec0000 = (0, $ff90aca5bea9a9da$export$984d890fc49ac622)({
    slots: {
        base: "inline-flex",
        tabList: [
            "flex",
            "p-1",
            "h-fit",
            "gap-2",
            "items-center",
            "flex-nowrap",
            "overflow-x-scroll",
            "scrollbar-hide",
            "bg-default-100"
        ],
        tab: [
            "z-0",
            "w-full",
            "px-3",
            "py-1",
            "flex",
            "group",
            "relative",
            "justify-center",
            "items-center",
            "outline-none",
            "cursor-pointer",
            "transition-opacity",
            "tap-highlight-transparent",
            "data-[disabled=true]:cursor-not-allowed",
            "data-[disabled=true]:opacity-30",
            "data-[hover-unselected=true]:opacity-disabled",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        tabContent: [
            "relative",
            "z-10",
            "text-inherit",
            "whitespace-nowrap",
            "transition-colors",
            "text-default-500",
            "group-data-[selected=true]:text-foreground"
        ],
        cursor: [
            "absolute",
            "z-0",
            "bg-white"
        ],
        panel: [
            "py-3",
            "px-1",
            "outline-none",
            "data-[inert=true]:hidden",
            ...(0, $eb279a3a1c5a3410$export$13376dc9c57a19ba)
        ],
        wrapper: []
    },
    variants: {
        variant: {
            solid: {
                cursor: "inset-0"
            },
            light: {
                tabList: "bg-transparent dark:bg-transparent",
                cursor: "inset-0"
            },
            underlined: {
                tabList: "bg-transparent dark:bg-transparent",
                cursor: "h-[2px] w-[80%] bottom-0 shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]"
            },
            bordered: {
                tabList: "bg-transparent dark:bg-transparent border-medium border-default-200 shadow-sm",
                cursor: "inset-0"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                tabList: "rounded-medium",
                tab: "h-7 text-tiny rounded-small",
                cursor: "rounded-small"
            },
            md: {
                tabList: "rounded-medium",
                tab: "h-8 text-small rounded-small",
                cursor: "rounded-small"
            },
            lg: {
                tabList: "rounded-large",
                tab: "h-9 text-medium rounded-medium",
                cursor: "rounded-medium"
            }
        },
        radius: {
            none: {
                tabList: "rounded-none",
                tab: "rounded-none",
                cursor: "rounded-none"
            },
            sm: {
                tabList: "rounded-medium",
                tab: "rounded-small",
                cursor: "rounded-small"
            },
            md: {
                tabList: "rounded-medium",
                tab: "rounded-small",
                cursor: "rounded-small"
            },
            lg: {
                tabList: "rounded-large",
                tab: "rounded-medium",
                cursor: "rounded-medium"
            },
            full: {
                tabList: "rounded-full",
                tab: "rounded-full",
                cursor: "rounded-full"
            }
        },
        fullWidth: {
            true: {
                base: "w-full",
                tabList: "w-full"
            }
        },
        isDisabled: {
            true: {
                tabList: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {
                tab: "transition-none",
                tabContent: "transition-none"
            }
        },
        placement: {
            top: {},
            start: {
                tabList: "flex-col",
                panel: "py-0 px-3",
                wrapper: "flex"
            },
            end: {
                tabList: "flex-col",
                panel: "py-0 px-3",
                wrapper: "flex flex-row-reverse"
            },
            bottom: {
                wrapper: "flex flex-col-reverse"
            }
        }
    },
    defaultVariants: {
        color: "default",
        variant: "solid",
        size: "md",
        fullWidth: false,
        isDisabled: false
    },
    compoundVariants: [
        {
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            color: "default",
            class: {
                cursor: [
                    "bg-background",
                    "dark:bg-default",
                    "shadow-small"
                ],
                tabContent: "group-data-[selected=true]:text-default-foreground"
            }
        },
        {
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            color: "primary",
            class: {
                cursor: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.primary,
                tabContent: "group-data-[selected=true]:text-primary-foreground"
            }
        },
        {
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            color: "secondary",
            class: {
                cursor: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.secondary,
                tabContent: "group-data-[selected=true]:text-secondary-foreground"
            }
        },
        {
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            color: "success",
            class: {
                cursor: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.success,
                tabContent: "group-data-[selected=true]:text-success-foreground"
            }
        },
        {
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            color: "warning",
            class: {
                cursor: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.warning,
                tabContent: "group-data-[selected=true]:text-warning-foreground"
            }
        },
        {
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            color: "danger",
            class: {
                cursor: (0, $eae4eee576f3a8f9$export$ac48af53e325e736).solid.danger,
                tabContent: "group-data-[selected=true]:text-danger-foreground"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                cursor: "bg-foreground",
                tabContent: "group-data-[selected=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                cursor: "bg-primary",
                tabContent: "group-data-[selected=true]:text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                cursor: "bg-secondary",
                tabContent: "group-data-[selected=true]:text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                cursor: "bg-success",
                tabContent: "group-data-[selected=true]:text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                cursor: "bg-warning",
                tabContent: "group-data-[selected=true]:text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                cursor: "bg-danger",
                tabContent: "group-data-[selected=true]:text-danger"
            }
        },
        {
            disableAnimation: true,
            variant: "underlined",
            class: {
                tab: [
                    "after:content-['']",
                    "after:absolute",
                    "after:bottom-0",
                    "after:h-[2px]",
                    "after:w-[80%]",
                    "after:opacity-0",
                    "after:shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "data-[selected=true]:after:opacity-100"
                ]
            }
        },
        {
            disableAnimation: true,
            color: "default",
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            class: {
                tab: "data-[selected=true]:bg-default data-[selected=true]:text-default-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "primary",
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            class: {
                tab: "data-[selected=true]:bg-primary data-[selected=true]:text-primary-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "secondary",
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            class: {
                tab: "data-[selected=true]:bg-secondary data-[selected=true]:text-secondary-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "success",
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            class: {
                tab: "data-[selected=true]:bg-success data-[selected=true]:text-success-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "warning",
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            class: {
                tab: "data-[selected=true]:bg-warning data-[selected=true]:text-warning-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "danger",
            variant: [
                "solid",
                "bordered",
                "light"
            ],
            class: {
                tab: "data-[selected=true]:bg-danger data-[selected=true]:text-danger-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "default",
            variant: "underlined",
            class: {
                tab: "data-[selected=true]:after:bg-foreground"
            }
        },
        {
            disableAnimation: true,
            color: "primary",
            variant: "underlined",
            class: {
                tab: "data-[selected=true]:after:bg-primary"
            }
        },
        {
            disableAnimation: true,
            color: "secondary",
            variant: "underlined",
            class: {
                tab: "data-[selected=true]:after:bg-secondary"
            }
        },
        {
            disableAnimation: true,
            color: "success",
            variant: "underlined",
            class: {
                tab: "data-[selected=true]:after:bg-success"
            }
        },
        {
            disableAnimation: true,
            color: "warning",
            variant: "underlined",
            class: {
                tab: "data-[selected=true]:after:bg-warning"
            }
        },
        {
            disableAnimation: true,
            color: "danger",
            variant: "underlined",
            class: {
                tab: "data-[selected=true]:after:bg-danger"
            }
        }
    ],
    compoundSlots: [
        {
            variant: "underlined",
            slots: [
                "tab",
                "tabList",
                "cursor"
            ],
            class: [
                "rounded-none"
            ]
        }
    ]
});





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $47580dd79b295b0a$export$4ba071daf4e486(props) {
    var _props_defaultSelectedKey;
    let state = (0, $11e167d4228171fe$export$e7f05e985daf4b5f)({
        ...props,
        suppressTextValueWarning: true,
        defaultSelectedKey: (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : $47580dd79b295b0a$var$$76f919a04c5a7d14$var$findDefaultSelectedKey(props.collection, props.disabledKeys ? new Set(props.disabledKeys) : new Set())
    });
    let { selectionManager: selectionManager, collection: collection, selectedKey: currentSelectedKey } = state;
    let lastSelectedKey = (0, $acw62.useRef)(currentSelectedKey);
    (0, $acw62.useEffect)(()=>{
        // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)
        let selectedKey = currentSelectedKey;
        if (selectionManager.isEmpty || !collection.getItem(selectedKey)) {
            selectedKey = $47580dd79b295b0a$var$$76f919a04c5a7d14$var$findDefaultSelectedKey(collection, state.disabledKeys);
            if (selectedKey != null) selectionManager.setSelectedKeys([
                selectedKey
            ]);
        }
        // If the tablist doesn't have focus and the selected key changes or if there isn't a focused key yet, change focused key to the selected key if it exists.
        if (selectedKey != null && selectionManager.focusedKey == null || !selectionManager.isFocused && selectedKey !== lastSelectedKey.current) selectionManager.setFocusedKey(selectedKey);
        lastSelectedKey.current = selectedKey;
    });
    return {
        ...state,
        isDisabled: props.isDisabled || false
    };
}
function $47580dd79b295b0a$var$$76f919a04c5a7d14$var$findDefaultSelectedKey(collection, disabledKeys) {
    let selectedKey = null;
    if (collection) {
        selectedKey = collection.getFirstKey();
        // loop over tabs until we find one that isn't disabled and select that
        while(disabledKeys.has(selectedKey) && selectedKey !== collection.getLastKey())selectedKey = collection.getKeyAfter(selectedKey);
        // if this check is true, then every item is disabled, it makes more sense to default to the first key than the last
        if (disabledKeys.has(selectedKey) && selectedKey === collection.getLastKey()) selectedKey = collection.getFirstKey();
    }
    return selectedKey;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3a08961a411e098e$export$15010ca3c1abe90b {
    getKeyLeftOf(key) {
        if (this.flipDirection) return this.getNextKey(key);
        return this.getPreviousKey(key);
    }
    getKeyRightOf(key) {
        if (this.flipDirection) return this.getPreviousKey(key);
        return this.getNextKey(key);
    }
    getKeyAbove(key) {
        return this.getPreviousKey(key);
    }
    getKeyBelow(key) {
        return this.getNextKey(key);
    }
    isDisabled(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return this.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled);
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        if (key != null && this.isDisabled(key)) key = this.getNextKey(key);
        return key;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        if (key != null && this.isDisabled(key)) key = this.getPreviousKey(key);
        return key;
    }
    getNextKey(key) {
        do {
            key = this.collection.getKeyAfter(key);
            if (key == null) key = this.collection.getFirstKey();
        }while (this.isDisabled(key));
        return key;
    }
    getPreviousKey(key) {
        do {
            key = this.collection.getKeyBefore(key);
            if (key == null) key = this.collection.getLastKey();
        }while (this.isDisabled(key));
        return key;
    }
    constructor(collection, direction, orientation, disabledKeys = new Set()){
        this.collection = collection;
        this.flipDirection = direction === "rtl" && orientation === "horizontal";
        this.disabledKeys = disabledKeys;
    }
}




var $acw62 = parcelRequire("acw62");


/*
* Copyright 2020 Adobe. All rights reserved.
* This file is licensed to you under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License. You may obtain a copy
* of the License at http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software distributed under
* the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
* OF ANY KIND, either express or implied. See the License for the specific language
* governing permissions and limitations under the License.
*/ function $b1fd341d95f95a84$export$773e389e644c5874(props, state, ref) {
    let { orientation: orientation = "horizontal", keyboardActivation: keyboardActivation = "automatic" } = props;
    let { collection: collection, selectionManager: manager, disabledKeys: disabledKeys } = state;
    let { direction: direction } = (0, $b8a0d3089da586dd$export$43bb16f9c6d9e3f7)();
    let delegate = (0, $acw62.useMemo)(()=>new (0, $3a08961a411e098e$export$15010ca3c1abe90b)(collection, direction, orientation, disabledKeys), [
        collection,
        disabledKeys,
        orientation,
        direction
    ]);
    let { collectionProps: collectionProps } = (0, $0033009e76f45f0a$export$d6daf82dcd84e87c)({
        ref: ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        selectOnFocus: keyboardActivation === "automatic",
        disallowEmptySelection: true,
        scrollRef: ref,
        linkBehavior: "selection"
    });
    // Compute base id for all tabs
    let tabsId = (0, $fc8082d5d9c62cca$export$f680877a34711e37)();
    (0, $200b1273fb83454d$export$c5f62239608282b6).set(state, tabsId);
    let tabListLabelProps = (0, $2ca439ee1a804558$export$d6875122194c7b44)({
        ...props,
        id: tabsId
    });
    return {
        tabListProps: {
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(collectionProps, tabListLabelProps),
            role: "tablist",
            "aria-orientation": orientation,
            tabIndex: undefined
        }
    };
}



"use client";
function $a022380a5db4df4f$export$d2589202ac9c89c3(originalProps) {
    var _a, _b, _c;
    const globalContext = (0, $d32167910469b3b9$export$f3632c8327428963)();
    const [props, variantProps] = (0, $a166571f9c69a3c9$export$9f203ede2b8cf905)(originalProps, (0, $78f5957a65c02df5$export$39f5674517ec0000).variantKeys);
    const { ref: ref, as: as, className: className, classNames: classNames, children: children, disableCursorAnimation: disableCursorAnimation, motionProps: motionProps, isVertical: isVertical = false, shouldSelectOnPressUp: shouldSelectOnPressUp = true, destroyInactiveTabPanel: destroyInactiveTabPanel = true, ...otherProps } = props;
    const Component = as || "div";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $1bd7f9c4cf7b22f6$export$c2c55ef9111cafd8)(ref);
    const disableAnimation = (_b = (_a = originalProps == null ? void 0 : originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const state = (0, $47580dd79b295b0a$export$4ba071daf4e486)({
        children: children,
        ...otherProps
    });
    const { tabListProps: tabListProps } = (0, $b1fd341d95f95a84$export$773e389e644c5874)(otherProps, state, domRef);
    const slots = (0, $acw62.useMemo)(()=>(0, $78f5957a65c02df5$export$39f5674517ec0000)({
            ...variantProps,
            className: className,
            disableAnimation: disableAnimation,
            ...isVertical ? {
                placement: "start"
            } : {}
        }), [
        (0, $91ffd9bd684fd1b9$export$36eebbb473f6d2fe)(variantProps),
        className,
        disableAnimation,
        isVertical
    ]);
    const baseStyles = (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const values = (0, $acw62.useMemo)(()=>({
            state: state,
            slots: slots,
            classNames: classNames,
            motionProps: motionProps,
            disableAnimation: disableAnimation,
            listRef: domRef,
            shouldSelectOnPressUp: shouldSelectOnPressUp,
            disableCursorAnimation: disableCursorAnimation,
            isDisabled: originalProps == null ? void 0 : originalProps.isDisabled
        }), [
        state,
        slots,
        domRef,
        motionProps,
        disableAnimation,
        disableCursorAnimation,
        shouldSelectOnPressUp,
        originalProps == null ? void 0 : originalProps.isDisabled,
        classNames
    ]);
    const getBaseProps = (0, $acw62.useCallback)((props2)=>({
            "data-slot": "base",
            className: slots.base({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(baseStyles, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)((0, $55f8b00eba900d0b$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2)
        }), [
        baseStyles,
        otherProps,
        slots
    ]);
    const placement = (_c = variantProps.placement) != null ? _c : isVertical ? "start" : "top";
    const getWrapperProps = (0, $acw62.useCallback)((props2)=>({
            "data-slot": "tabWrapper",
            className: slots.wrapper({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            }),
            "data-placement": placement,
            "data-vertical": isVertical || placement === "start" || placement === "end" ? "vertical" : "horizontal"
        }), [
        classNames,
        slots,
        placement,
        isVertical
    ]);
    const getTabListProps = (0, $acw62.useCallback)((props2)=>({
            ref: domRef,
            "data-slot": "tabList",
            className: slots.tabList({
                class: (0, $f78e4903178d7a09$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.tabList, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $5c52a3669a00adc5$export$9d1611c77c2fe928)(tabListProps, props2)
        }), [
        domRef,
        tabListProps,
        classNames,
        slots
    ]);
    return {
        Component: Component,
        domRef: domRef,
        state: state,
        values: values,
        destroyInactiveTabPanel: destroyInactiveTabPanel,
        getBaseProps: getBaseProps,
        getTabListProps: getTabListProps,
        getWrapperProps: getWrapperProps
    };
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const $bc54d4fcbe865063$export$f3b8df5418bf8d44 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $9f96722ff12dbfe7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}


const $44632392a5c0b426$var$notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function $44632392a5c0b426$export$df39f9da6f278ce7() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach($44632392a5c0b426$var$notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}


"use client";
const $f38e3304a6cbbfa3$var$shouldInheritGroup = (inherit)=>inherit === true;
const $f38e3304a6cbbfa3$var$shouldInheritId = (inherit)=>$f38e3304a6cbbfa3$var$shouldInheritGroup(inherit === true) || inherit === "id";
const $f38e3304a6cbbfa3$export$7fe0cbe305f29bb4 = ({ children: children, id: id, inherit: inherit = true })=>{
    const layoutGroupContext = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    const deprecatedLayoutGroupContext = (0, $acw62.useContext)((0, $bc54d4fcbe865063$export$f3b8df5418bf8d44));
    const [forceRender, key] = (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)();
    const context = (0, $acw62.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if ($f38e3304a6cbbfa3$var$shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id: id,
            group: $f38e3304a6cbbfa3$var$shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, $44632392a5c0b426$export$df39f9da6f278ce7)() : (0, $44632392a5c0b426$export$df39f9da6f278ce7)()
        };
    }
    const memoizedContext = (0, $acw62.useMemo)(()=>({
            ...context.current,
            forceRender: forceRender
        }), [
        key
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $4ae202aab5791dbc$export$a3579ca508007a95).Provider, {
        value: memoizedContext,
        children: children
    });
};




"use client";
function $cbcd334feb13e201$var$Tabs(props, ref) {
    const { Component: Component, values: values, state: state, destroyInactiveTabPanel: destroyInactiveTabPanel, getBaseProps: getBaseProps, getTabListProps: getTabListProps, getWrapperProps: getWrapperProps } = (0, $a022380a5db4df4f$export$d2589202ac9c89c3)({
        ...props,
        ref: ref
    });
    const layoutId = (0, $acw62.useId)();
    const layoutGroupEnabled = !props.disableAnimation && !props.disableCursorAnimation;
    const tabsProps = {
        state: state,
        listRef: values.listRef,
        slots: values.slots,
        classNames: values.classNames,
        isDisabled: values.isDisabled,
        motionProps: values.motionProps,
        disableAnimation: values.disableAnimation,
        shouldSelectOnPressUp: values.shouldSelectOnPressUp,
        disableCursorAnimation: values.disableCursorAnimation
    };
    const tabs = [
        ...state.collection
    ].map((item)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $350a76e04dfee88b$export$937bc6071adf91f), {
            item: item,
            ...tabsProps,
            ...item.props
        }, item.key));
    const renderTabs = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...getBaseProps(),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...getTabListProps(),
                    children: layoutGroupEnabled ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f38e3304a6cbbfa3$export$7fe0cbe305f29bb4), {
                        id: layoutId,
                        children: tabs
                    }) : tabs
                })
            }),
            [
                ...state.collection
            ].map((item)=>{
                return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d58274ae4e45a7fe$export$1e1524a300d1fd38), {
                    classNames: values.classNames,
                    destroyInactiveTabPanel: destroyInactiveTabPanel,
                    slots: values.slots,
                    state: values.state,
                    tabKey: item.key
                }, item.key);
            })
        ]
    });
    if ("placement" in props || "isVertical" in props) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...getWrapperProps(),
        children: renderTabs
    });
    return renderTabs;
}
var $cbcd334feb13e201$export$c093b509da7852a5 = (0, $a166571f9c69a3c9$export$257a8862b851cb5b)($cbcd334feb13e201$var$Tabs);
$cbcd334feb13e201$var$Tabs.displayName = "NextUI.Tabs";




var $acw62 = parcelRequire("acw62");





/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $1a67fe2836545e3c$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = "";
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $1a67fe2836545e3c$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $1a67fe2836545e3c$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = "";
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $1a67fe2836545e3c$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : "";
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $1a67fe2836545e3c$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : "";
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $1a67fe2836545e3c$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $1a67fe2836545e3c$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== "object") tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== "object") {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== "object") delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== "undefined" ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $1a67fe2836545e3c$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== "undefined" && typeof tokenMap[token].$uidMap[uid] !== "undefined" ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $1a67fe2836545e3c$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== "object") this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== "object") delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $1a67fe2836545e3c$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $1a67fe2836545e3c$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($1a67fe2836545e3c$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $1a67fe2836545e3c$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $1a67fe2836545e3c$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    "do": true,
    does: true,
    either: true,
    "else": true,
    ever: true,
    every: true,
    "for": true,
    from: true,
    "get": true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    "if": true,
    "in": true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    "this": true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    "while": true,
    who: true,
    whom: true,
    why: true,
    will: true,
    "with": true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$1a67fe2836545e3c$export$eeaf491a400e882a.constructor = false;
$1a67fe2836545e3c$export$eeaf491a400e882a.hasOwnProperty = false;
$1a67fe2836545e3c$export$eeaf491a400e882a.isPrototypeOf = false;
$1a67fe2836545e3c$export$eeaf491a400e882a.propertyIsEnumerable = false;
$1a67fe2836545e3c$export$eeaf491a400e882a.toLocaleString = false;
$1a67fe2836545e3c$export$eeaf491a400e882a.toString = false;
$1a67fe2836545e3c$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $1a67fe2836545e3c$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$1a67fe2836545e3c$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $1a67fe2836545e3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1a67fe2836545e3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1a67fe2836545e3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1a67fe2836545e3c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $1a67fe2836545e3c$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error("js-search requires a uid field name constructor parameter");
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $1a67fe2836545e3c$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $1a67fe2836545e3c$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $1a67fe2836545e3c$export$147e8ac43c84713a();
        this._tokenizer = new $1a67fe2836545e3c$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $1a67fe2836545e3c$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $1a67fe2836545e3c$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== "string" && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === "string") {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $1a67fe2836545e3c$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error("IIndexStrategy cannot be set after initialization");
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error("ISanitizer cannot be set after initialization");
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error("ISearchIndex cannot be set after initialization");
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error("ITokenizer cannot be set after initialization");
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $1a67fe2836545e3c$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $1a67fe2836545e3c$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $1a67fe2836545e3c$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || "mark";
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText("").length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = "";
        var sanitizedCurrentWord = "";
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === " ") {
                actualCurrentWord = "";
                sanitizedCurrentWord = "";
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $af43570ba0a8567e$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $af43570ba0a8567e$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $af43570ba0a8567e$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $af43570ba0a8567e$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};


const $ae8077da5dad972b$export$76974b428a49f15b = (index)=>index;
const $ae8077da5dad972b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $ae8077da5dad972b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $ae8077da5dad972b$var$addEventListenerOptions = {
    passive: true
};
const $ae8077da5dad972b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $ae8077da5dad972b$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $ae8077da5dad972b$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $ae8077da5dad972b$var$supportsScrollend ? ()=>void 0 : (0, $af43570ba0a8567e$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $ae8077da5dad972b$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $ae8077da5dad972b$var$supportsScrollend ? ()=>void 0 : (0, $af43570ba0a8567e$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $ae8077da5dad972b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $ae8077da5dad972b$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $ae8077da5dad972b$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $ae8077da5dad972b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $ae8077da5dad972b$export$76974b428a49f15b,
                rangeExtractor: $ae8077da5dad972b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $ae8077da5dad972b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $ae8077da5dad972b$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[$ae8077da5dad972b$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $af43570ba0a8567e$export$9a1adf421b69c6a)(this.getOffsetForIndex(index, align));
                    if (!(0, $af43570ba0a8567e$export$8a4f1dcc58a69dbd)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $ae8077da5dad972b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $ae8077da5dad972b$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $ae8077da5dad972b$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $64d08e094a93fa77$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $64d08e094a93fa77$var$useVirtualizerBase(options) {
    const rerender = $acw62.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $11492dca620dcaa5$exports.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $acw62.useState(()=>new (0, $ae8077da5dad972b$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $acw62.useEffect(()=>{
        return instance._didMount();
    }, []);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $64d08e094a93fa77$export$dd6d526d88b5a137(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        observeElementRect: $ae8077da5dad972b$export$5a50ff2cde8c3802,
        observeElementOffset: $ae8077da5dad972b$export$fbc040aee017375a,
        scrollToFn: (0, $ae8077da5dad972b$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $64d08e094a93fa77$export$645722dcac657cb9(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $ae8077da5dad972b$export$e911b82c7a99311),
        observeElementOffset: (0, $ae8077da5dad972b$export$518998f8c5d09287),
        scrollToFn: (0, $ae8077da5dad972b$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}



var $acw62 = parcelRequire("acw62");

function $643289de0f480f5f$var$_extends() {
    return $643289de0f480f5f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $643289de0f480f5f$var$_extends.apply(null, arguments);
}
var $643289de0f480f5f$var$reservedModifierKeywords = [
    "shift",
    "alt",
    "meta",
    "mod",
    "ctrl"
];
var $643289de0f480f5f$var$mappedKeys = {
    esc: "escape",
    "return": "enter",
    ".": "period",
    ",": "comma",
    "-": "slash",
    " ": "space",
    "`": "backquote",
    "#": "backslash",
    "+": "bracketright",
    ShiftLeft: "shift",
    ShiftRight: "shift",
    AltLeft: "alt",
    AltRight: "alt",
    MetaLeft: "meta",
    MetaRight: "meta",
    OSLeft: "meta",
    OSRight: "meta",
    ControlLeft: "ctrl",
    ControlRight: "ctrl"
};
function $643289de0f480f5f$var$mapKey(key) {
    return (key && $643289de0f480f5f$var$mappedKeys[key] || key || "").trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function $643289de0f480f5f$var$isHotkeyModifier(key) {
    return $643289de0f480f5f$var$reservedModifierKeywords.includes(key);
}
function $643289de0f480f5f$var$parseKeysHookInput(keys, splitKey) {
    if (splitKey === void 0) splitKey = ",";
    return keys.split(splitKey);
}
function $643289de0f480f5f$var$parseHotkey(hotkey, combinationKey, description) {
    if (combinationKey === void 0) combinationKey = "+";
    var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k) {
        return $643289de0f480f5f$var$mapKey(k);
    });
    var modifiers = {
        alt: keys.includes("alt"),
        ctrl: keys.includes("ctrl") || keys.includes("control"),
        shift: keys.includes("shift"),
        meta: keys.includes("meta"),
        mod: keys.includes("mod")
    };
    var singleCharKeys = keys.filter(function(k) {
        return !$643289de0f480f5f$var$reservedModifierKeywords.includes(k);
    });
    return $643289de0f480f5f$var$_extends({}, modifiers, {
        keys: singleCharKeys,
        description: description
    });
}
(function() {
    if (typeof document !== "undefined") {
        document.addEventListener("keydown", function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$pushToCurrentlyPressedKeys([
                $643289de0f480f5f$var$mapKey(e.key),
                $643289de0f480f5f$var$mapKey(e.code)
            ]);
        });
        document.addEventListener("keyup", function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$removeFromCurrentlyPressedKeys([
                $643289de0f480f5f$var$mapKey(e.key),
                $643289de0f480f5f$var$mapKey(e.code)
            ]);
        });
    }
    if (typeof window !== "undefined") window.addEventListener("blur", function() {
        $643289de0f480f5f$var$currentlyPressedKeys.clear();
    });
})();
var $643289de0f480f5f$var$currentlyPressedKeys = /*#__PURE__*/ new Set();
// https://github.com/microsoft/TypeScript/issues/17002
function $643289de0f480f5f$var$isReadonlyArray(value) {
    return Array.isArray(value);
}
function $643289de0f480f5f$export$eae3d25ef8fab782(key, splitKey) {
    if (splitKey === void 0) splitKey = ",";
    var hotkeyArray = $643289de0f480f5f$var$isReadonlyArray(key) ? key : key.split(splitKey);
    return hotkeyArray.every(function(hotkey) {
        return $643289de0f480f5f$var$currentlyPressedKeys.has(hotkey.trim().toLowerCase());
    });
}
function $643289de0f480f5f$var$pushToCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if ($643289de0f480f5f$var$currentlyPressedKeys.has("meta")) $643289de0f480f5f$var$currentlyPressedKeys.forEach(function(key) {
        return !$643289de0f480f5f$var$isHotkeyModifier(key) && $643289de0f480f5f$var$currentlyPressedKeys["delete"](key.toLowerCase());
    });
    hotkeyArray.forEach(function(hotkey) {
        return $643289de0f480f5f$var$currentlyPressedKeys.add(hotkey.toLowerCase());
    });
}
function $643289de0f480f5f$var$removeFromCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (key === "meta") $643289de0f480f5f$var$currentlyPressedKeys.clear();
    else hotkeyArray.forEach(function(hotkey) {
        return $643289de0f480f5f$var$currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
}
function $643289de0f480f5f$var$maybePreventDefault(e, hotkey, preventDefault) {
    if (typeof preventDefault === "function" && preventDefault(e, hotkey) || preventDefault === true) e.preventDefault();
}
function $643289de0f480f5f$var$isHotkeyEnabled(e, hotkey, enabled) {
    if (typeof enabled === "function") return enabled(e, hotkey);
    return enabled === true || enabled === undefined;
}
function $643289de0f480f5f$var$isKeyboardEventTriggeredByInput(ev) {
    return $643289de0f480f5f$var$isHotkeyEnabledOnTag(ev, [
        "input",
        "textarea",
        "select"
    ]);
}
function $643289de0f480f5f$var$isHotkeyEnabledOnTag(_ref, enabledOnTags) {
    var target = _ref.target;
    if (enabledOnTags === void 0) enabledOnTags = false;
    var targetTagName = target && target.tagName;
    if ($643289de0f480f5f$var$isReadonlyArray(enabledOnTags)) return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
        return tag.toLowerCase() === targetTagName.toLowerCase();
    }));
    return Boolean(targetTagName && enabledOnTags && enabledOnTags === true);
}
function $643289de0f480f5f$var$isScopeActive(activeScopes, scopes) {
    if (activeScopes.length === 0 && scopes) {
        console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
        return true;
    }
    if (!scopes) return true;
    return activeScopes.some(function(scope) {
        return scopes.includes(scope);
    }) || activeScopes.includes("*");
}
var $643289de0f480f5f$var$isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent(e, hotkey, ignoreModifiers) {
    if (ignoreModifiers === void 0) ignoreModifiers = false;
    var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
    var pressedKeyUppercase = e.key, code = e.code, ctrlKey = e.ctrlKey, metaKey = e.metaKey, shiftKey = e.shiftKey, altKey = e.altKey;
    var keyCode = $643289de0f480f5f$var$mapKey(code);
    var pressedKey = pressedKeyUppercase.toLowerCase();
    if (!(keys != null && keys.includes(keyCode)) && !(keys != null && keys.includes(pressedKey)) && ![
        "ctrl",
        "control",
        "unknown",
        "meta",
        "alt",
        "shift",
        "os"
    ].includes(keyCode)) return false;
    if (!ignoreModifiers) {
        // We check the pressed keys for compatibility with the keyup event. In keyup events the modifier flags are not set.
        if (alt === !altKey && pressedKey !== "alt") return false;
        if (shift === !shiftKey && pressedKey !== "shift") return false;
        // Mod is a special key name that is checking for meta on macOS and ctrl on other platforms
        if (mod) {
            if (!metaKey && !ctrlKey) return false;
        } else {
            if (meta === !metaKey && pressedKey !== "meta" && pressedKey !== "os") return false;
            if (ctrl === !ctrlKey && pressedKey !== "ctrl" && pressedKey !== "control") return false;
        }
    }
    // All modifiers are correct, now check the key
    // If the key is set, we check for the key
    if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) return true;
    else if (keys) // Check if all keys are present in pressedDownKeys set
    return $643289de0f480f5f$export$eae3d25ef8fab782(keys);
    else if (!keys) // If the key is not set, we only listen for modifiers, that check went alright, so we return true
    return true;
    // There is nothing that matches.
    return false;
};
var $643289de0f480f5f$var$BoundHotkeysProxyProvider = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $643289de0f480f5f$var$useBoundHotkeysProxy = function useBoundHotkeysProxy() {
    return (0, $acw62.useContext)($643289de0f480f5f$var$BoundHotkeysProxyProvider);
};
function $643289de0f480f5f$var$BoundHotkeysProxyProviderProvider(_ref) {
    var addHotkey = _ref.addHotkey, removeHotkey = _ref.removeHotkey, children = _ref.children;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($643289de0f480f5f$var$BoundHotkeysProxyProvider.Provider, {
        value: {
            addHotkey: addHotkey,
            removeHotkey: removeHotkey
        },
        children: children
    });
}
function $643289de0f480f5f$var$deepEqual(x, y) {
    //@ts-ignore
    return x && y && typeof x === "object" && typeof y === "object" ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
    Object.keys(x).reduce(function(isEqual, key) {
        return isEqual && $643289de0f480f5f$var$deepEqual(x[key], y[key]);
    }, true) : x === y;
}
var $643289de0f480f5f$var$HotkeysContext = /*#__PURE__*/ (0, $acw62.createContext)({
    hotkeys: [],
    enabledScopes: [],
    toggleScope: function toggleScope() {},
    enableScope: function enableScope() {},
    disableScope: function disableScope() {}
});
var $643289de0f480f5f$export$183c7bf336967877 = function useHotkeysContext() {
    return (0, $acw62.useContext)($643289de0f480f5f$var$HotkeysContext);
};
var $643289de0f480f5f$export$9d58aaad435254c0 = function HotkeysProvider(_ref) {
    var _ref$initiallyActiveS = _ref.initiallyActiveScopes, initiallyActiveScopes = _ref$initiallyActiveS === void 0 ? [
        "*"
    ] : _ref$initiallyActiveS, children = _ref.children;
    var _useState = (0, $acw62.useState)((initiallyActiveScopes == null ? void 0 : initiallyActiveScopes.length) > 0 ? initiallyActiveScopes : [
        "*"
    ]), internalActiveScopes = _useState[0], setInternalActiveScopes = _useState[1];
    var _useState2 = (0, $acw62.useState)([]), boundHotkeys = _useState2[0], setBoundHotkeys = _useState2[1];
    var enableScope = (0, $acw62.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes("*")) return [
                scope
            ];
            return Array.from(new Set([].concat(prev, [
                scope
            ])));
        });
    }, []);
    var disableScope = (0, $acw62.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.filter(function(s) {
                return s !== scope;
            }).length === 0) return [
                "*"
            ];
            else return prev.filter(function(s) {
                return s !== scope;
            });
        });
    }, []);
    var toggleScope = (0, $acw62.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes(scope)) {
                if (prev.filter(function(s) {
                    return s !== scope;
                }).length === 0) return [
                    "*"
                ];
                else return prev.filter(function(s) {
                    return s !== scope;
                });
            } else {
                if (prev.includes("*")) return [
                    scope
                ];
                return Array.from(new Set([].concat(prev, [
                    scope
                ])));
            }
        });
    }, []);
    var addBoundHotkey = (0, $acw62.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return [].concat(prev, [
                hotkey
            ]);
        });
    }, []);
    var removeBoundHotkey = (0, $acw62.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return prev.filter(function(h) {
                return !$643289de0f480f5f$var$deepEqual(h, hotkey);
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($643289de0f480f5f$var$HotkeysContext.Provider, {
        value: {
            enabledScopes: internalActiveScopes,
            hotkeys: boundHotkeys,
            enableScope: enableScope,
            disableScope: disableScope,
            toggleScope: toggleScope
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($643289de0f480f5f$var$BoundHotkeysProxyProviderProvider, {
            addHotkey: addBoundHotkey,
            removeHotkey: removeBoundHotkey,
            children: children
        })
    });
};
function $643289de0f480f5f$var$useDeepEqualMemo(value) {
    var ref = (0, $acw62.useRef)(undefined);
    if (!$643289de0f480f5f$var$deepEqual(ref.current, value)) ref.current = value;
    return ref.current;
}
var $643289de0f480f5f$var$stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
};
var $643289de0f480f5f$var$useSafeLayoutEffect = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $643289de0f480f5f$export$1b0c17123b4f3646(keys, callback, options, dependencies) {
    var _useState = (0, $acw62.useState)(null), ref = _useState[0], setRef = _useState[1];
    var hasTriggeredRef = (0, $acw62.useRef)(false);
    var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : undefined;
    var _keys = $643289de0f480f5f$var$isReadonlyArray(keys) ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
    var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : undefined;
    var memoisedCB = (0, $acw62.useCallback)(callback, _deps != null ? _deps : []);
    var cbRef = (0, $acw62.useRef)(memoisedCB);
    if (_deps) cbRef.current = memoisedCB;
    else cbRef.current = callback;
    var memoisedOptions = $643289de0f480f5f$var$useDeepEqualMemo(_options);
    var _useHotkeysContext = $643289de0f480f5f$export$183c7bf336967877(), enabledScopes = _useHotkeysContext.enabledScopes;
    var proxy = $643289de0f480f5f$var$useBoundHotkeysProxy();
    $643289de0f480f5f$var$useSafeLayoutEffect(function() {
        if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !$643289de0f480f5f$var$isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) return;
        var listener = function listener(e, isKeyUp) {
            var _e$target;
            if (isKeyUp === void 0) isKeyUp = false;
            if ($643289de0f480f5f$var$isKeyboardEventTriggeredByInput(e) && !$643289de0f480f5f$var$isHotkeyEnabledOnTag(e, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) return;
            // TODO: SINCE THE EVENT IS NOW ATTACHED TO THE REF, THE ACTIVE ELEMENT CAN NEVER BE INSIDE THE REF. THE HOTKEY ONLY TRIGGERS IF THE
            // REF IS THE ACTIVE ELEMENT. THIS IS A PROBLEM SINCE FOCUSED SUB COMPONENTS WON'T TRIGGER THE HOTKEY.
            if (ref !== null) {
                var rootNode = ref.getRootNode();
                if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref && !ref.contains(rootNode.activeElement)) {
                    $643289de0f480f5f$var$stopPropagation(e);
                    return;
                }
            }
            if ((_e$target = e.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) return;
            $643289de0f480f5f$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                var _hotkey$keys;
                var hotkey = $643289de0f480f5f$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
                if ($643289de0f480f5f$var$isHotkeyMatchingKeyboardEvent(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes("*")) {
                    if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e)) return;
                    if (isKeyUp && hasTriggeredRef.current) return;
                    $643289de0f480f5f$var$maybePreventDefault(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
                    if (!$643289de0f480f5f$var$isHotkeyEnabled(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
                        $643289de0f480f5f$var$stopPropagation(e);
                        return;
                    }
                    // Execute the user callback for that hotkey
                    cbRef.current(e, hotkey);
                    if (!isKeyUp) hasTriggeredRef.current = true;
                }
            });
        };
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$pushToCurrentlyPressedKeys($643289de0f480f5f$var$mapKey(event.code));
            if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === undefined && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) listener(event);
        };
        var handleKeyUp = function handleKeyUp(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $643289de0f480f5f$var$removeFromCurrentlyPressedKeys($643289de0f480f5f$var$mapKey(event.code));
            hasTriggeredRef.current = false;
            if (memoisedOptions != null && memoisedOptions.keyup) listener(event, true);
        };
        var domNode = ref || (_options == null ? void 0 : _options.document) || document;
        // @ts-ignore
        domNode.addEventListener("keyup", handleKeyUp);
        // @ts-ignore
        domNode.addEventListener("keydown", handleKeyDown);
        if (proxy) $643289de0f480f5f$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
            return proxy.addHotkey($643289de0f480f5f$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
        return function() {
            // @ts-ignore
            domNode.removeEventListener("keyup", handleKeyUp);
            // @ts-ignore
            domNode.removeEventListener("keydown", handleKeyDown);
            if (proxy) $643289de0f480f5f$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                return proxy.removeHotkey($643289de0f480f5f$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
            });
        };
    }, [
        ref,
        _keys,
        memoisedOptions,
        enabledScopes
    ]);
    return setRef;
}
function $643289de0f480f5f$export$175b3984f625ab17() {
    var _useState = (0, $acw62.useState)(new Set()), keys = _useState[0], setKeys = _useState[1];
    var _useState2 = (0, $acw62.useState)(false), isRecording = _useState2[0], setIsRecording = _useState2[1];
    var handler = (0, $acw62.useCallback)(function(event) {
        if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
        return;
        event.preventDefault();
        event.stopPropagation();
        setKeys(function(prev) {
            var newKeys = new Set(prev);
            newKeys.add($643289de0f480f5f$var$mapKey(event.code));
            return newKeys;
        });
    }, []);
    var stop = (0, $acw62.useCallback)(function() {
        if (typeof document !== "undefined") {
            document.removeEventListener("keydown", handler);
            setIsRecording(false);
        }
    }, [
        handler
    ]);
    var start = (0, $acw62.useCallback)(function() {
        setKeys(new Set());
        if (typeof document !== "undefined") {
            stop();
            document.addEventListener("keydown", handler);
            setIsRecording(true);
        }
    }, [
        handler,
        stop
    ]);
    var resetKeys = (0, $acw62.useCallback)(function() {
        setKeys(new Set());
    }, []);
    return [
        keys,
        {
            start: start,
            stop: stop,
            resetKeys: resetKeys,
            isRecording: isRecording
        }
    ];
}




function $d99295d792044717$var$Objekt({ objekt: objekt, ownedObjekts: ownedObjekts, wantsList: wantsList, selectedObjekts: selectedObjekts, setSelectedObjekts: setSelectedObjekts, onObjektPress: onObjektPress, onListChange: onListChange }) {
    let ownedTransferableObjekts = ownedObjekts.filter((objekt)=>objekt.transferable);
    let isSomeObjektSelected = ownedTransferableObjekts.some((objekt)=>selectedObjekts.includes(objekt));
    let isEveryObjektSelected = ownedTransferableObjekts.every((objekt)=>selectedObjekts.includes(objekt));
    function onSelectedObjektsToggle() {
        if (isEveryObjektSelected) setSelectedObjekts(selectedObjekts.filter((objekt)=>!ownedTransferableObjekts.includes(objekt)));
        else setSelectedObjekts([
            ...selectedObjekts,
            ...ownedTransferableObjekts.filter((objekt)=>!selectedObjekts.includes(objekt))
        ]);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative w-full aspect-w-[1083] aspect-h-[1673]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "group absolute inset-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06507242a7aa4c9b$export$4630804d47451d56), {
                            className: "absolute inset-0",
                            shadow: "none",
                            radius: "sm",
                            isPressable: !!onObjektPress,
                            onPress: ()=>onObjektPress?.(objekt),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: objekt.frontImage
                            })
                        }),
                        ownedTransferableObjekts.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
                            className: "absolute w-9 h-9 top-2 left-2 z-10",
                            isSelected: isEveryObjektSelected && isSomeObjektSelected,
                            isIndeterminate: !isEveryObjektSelected && isSomeObjektSelected,
                            onValueChange: onSelectedObjektsToggle
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a8a01edcf9e5fefd$export$3bd981faadafe0b3), {
                            placement: "bottom-start",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7a8d7d87317964b$export$bf3f08696645e39f), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                        isIconOnly: true,
                                        radius: "sm",
                                        className: "absolute invisible group-hover:visible min-w-[auto] w-7 h-7 top-2 right-2 opacity-90",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$ff37b15d9b58df3c), {
                                            className: "w-5 h-5 text-foreground-500"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa7e2859a413aac$export$a94b2d6670970977), {
                                    onAction: async (key)=>{
                                        if (!(0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).token) {
                                            alert("WIP: Handle gracefully, show relogin message.");
                                            return;
                                        }
                                        switch(key){
                                            case "add-wants":
                                                await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).addCollectionsToList("want", [
                                                    objekt.collectionId
                                                ]);
                                                onListChange?.();
                                                break;
                                            case "add-haves":
                                                await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).addCollectionsToList("have", [
                                                    objekt.collectionId
                                                ]);
                                                onListChange?.();
                                                break;
                                            case "remove-wants":
                                                await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).removeCollectionsFromList("want", [
                                                    objekt.collectionId
                                                ]);
                                                onListChange?.();
                                                break;
                                            case "remove-haves":
                                                await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).removeCollectionsFromList("have", [
                                                    objekt.collectionId
                                                ]);
                                                onListChange?.();
                                                break;
                                        }
                                    },
                                    children: wantsList.includes(objekt.collectionId) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4107eb738d7c5e40$export$42228163bda52c88), {
                                        children: "Remove from My Wants"
                                    }, "remove-wants") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4107eb738d7c5e40$export$42228163bda52c88), {
                                        children: "Add to My Wants"
                                    }, "add-wants")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9b21e3b0663024ed$export$b56270f92ff8018), {
                    placement: "bottom",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ed69f79ca0040ce$export$251d96216457b64b), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09f39d5db2614b7e$export$54839a81113e9e92), {
                                className: "text-tiny",
                                size: "sm",
                                variant: "flat",
                                startContent: ownedObjekts.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "w-2 h-2 mx-1 rounded-full bg-default-400"
                                }) : null,
                                children: objekt.collectionId
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $09f067fab22dde0c$export$2a0d18fe44adc4b6), {
                            className: "p-0 flex flex-col gap-2 py-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-2 text-small font-bold",
                                    children: "Objekts"
                                }),
                                ownedObjekts.map((objekt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
                                                size: "sm",
                                                className: "px-4",
                                                isSelected: selectedObjekts.includes(objekt),
                                                isDisabled: !objekt.transferable,
                                                onValueChange: (isSelected)=>{
                                                    if (isSelected) setSelectedObjekts([
                                                        ...selectedObjekts,
                                                        objekt
                                                    ]);
                                                    else setSelectedObjekts(selectedObjekts.filter((selectedObjekt)=>selectedObjekt !== objekt));
                                                },
                                                children: [
                                                    objekt.collectionId,
                                                    " #",
                                                    objekt.objektNo
                                                ]
                                            })
                                        ]
                                    }, objekt.tokenId)),
                                ownedObjekts.length == 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "px-2",
                                            children: "You do not own this objekt."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $d99295d792044717$export$410423fda3f412a({ artist: artist, members: members, seasons: seasons, classes: classes, artistOptions: artistOptions, memberOptions: memberOptions, seasonOptions: seasonOptions, classOptions: classOptions, setArtist: setArtist, setMembers: setMembers, setSeasons: setSeasons, setClasses: setClasses, query: query, setQuery: setQuery }) {
    let { isOpen: isSearchOpen, onOpen: onSearchOpen, onOpenChange: onSearchOpenChange } = (0, $7c70e959e80c13a8$export$6e3e27031a30522f)();
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)("mod+f", onSearchOpen, {
        preventDefault: true
    });
    function onArtistChange(artists) {
        setArtist(Array.from(artists)[0]);
    }
    function onMembersChange(members) {
        setMembers(Array.from(members));
    }
    function onSeasonsChange(seasons) {
        setSeasons(Array.from(seasons));
    }
    function onClassesChange(classes) {
        setClasses(Array.from(classes));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col sm:flex-row w-full gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac24db504ef2115$export$5f058b6414bc662f), {
                        label: "Artist",
                        placeholder: "Select an artist",
                        selectedKeys: [
                            artist
                        ],
                        onSelectionChange: onArtistChange,
                        className: "w-[auto] flex-1",
                        children: artistOptions.map((artist)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: artist,
                                children: artist
                            }, artist))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac24db504ef2115$export$5f058b6414bc662f), {
                        label: "Member",
                        placeholder: "Select a member",
                        selectionMode: "multiple",
                        selectedKeys: members,
                        onSelectionChange: onMembersChange,
                        className: "w-[auto] flex-1",
                        endContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            role: "button",
                            tabIndex: 0,
                            "data-filled": members.length > 0,
                            className: "p-2 -m-2 z-10 hidden absolute right-8 top-5 appearance-none select-none opacity-0 hover:!opacity-100 cursor-pointer active:!opacity-70 rounded-full outline-none text-large data-[filled=true]:block data-[filled=true]:opacity-70 transition-opacity motion-reduce:transition-none",
                            onClick: ()=>setMembers([]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $674bd67e3ad1a850$export$2b32a5a2c6e4dc78), {})
                        }),
                        children: memberOptions.map((member)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: member,
                                children: member
                            }, member))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac24db504ef2115$export$5f058b6414bc662f), {
                        label: "Season",
                        placeholder: "Select a season",
                        selectionMode: "multiple",
                        selectedKeys: seasons,
                        onSelectionChange: onSeasonsChange,
                        className: "w-[auto] flex-1",
                        endContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            role: "button",
                            tabIndex: 0,
                            "data-filled": seasons.length > 0,
                            className: "p-2 -m-2 z-10 hidden absolute right-8 top-5 appearance-none select-none opacity-0 hover:!opacity-100 cursor-pointer active:!opacity-70 rounded-full outline-none text-large data-[filled=true]:block data-[filled=true]:opacity-70 transition-opacity motion-reduce:transition-none",
                            onClick: ()=>setSeasons([]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $674bd67e3ad1a850$export$2b32a5a2c6e4dc78), {})
                        }),
                        children: seasonOptions.map((season)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: season,
                                children: season
                            }, season))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac24db504ef2115$export$5f058b6414bc662f), {
                        label: "Class",
                        placeholder: "Select a class",
                        selectionMode: "multiple",
                        selectedKeys: classes,
                        onSelectionChange: onClassesChange,
                        className: "w-[auto] flex-1",
                        endContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            role: "button",
                            tabIndex: 0,
                            "data-filled": classes.length > 0,
                            className: "p-2 -m-2 z-10 hidden absolute right-8 top-5 appearance-none select-none opacity-0 hover:!opacity-100 cursor-pointer active:!opacity-70 rounded-full outline-none text-large data-[filled=true]:block data-[filled=true]:opacity-70 transition-opacity motion-reduce:transition-none",
                            onClick: ()=>setClasses([]),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $674bd67e3ad1a850$export$2b32a5a2c6e4dc78), {})
                        }),
                        children: classOptions.map((class_)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: class_,
                                children: class_
                            }, class_))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                        className: "bg-default-100 h-14 text-foreground-500 font-medium",
                        onPress: onSearchOpen,
                        startContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$82eafebb825fc23f), {}),
                        children: "Search"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f48272b62179a444$export$194c5e3f782179f4), {
                isOpen: isSearchOpen,
                onOpenChange: onSearchOpenChange,
                placement: "top",
                shouldBlockScroll: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90430c3f5844fbf9$export$e7e965ff0372e8c), {
                    children: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e693153d3a5c272$export$921a3451e53aa4ce), {
                            isClearable: true,
                            label: "Search",
                            placeholder: "Search Objekts",
                            value: query,
                            onValueChange: setQuery,
                            classNames: {
                                input: "text-base placeholder:text-small"
                            },
                            autoFocus: true,
                            startContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$82eafebb825fc23f), {
                                className: "text-foreground-500"
                            })
                        })
                })
            })
        ]
    });
}
function $d99295d792044717$export$2b694fd04bcbe43d({ objekts: objekts, ownedObjekts: ownedObjekts, wantsList: wantsList, selectedObjekts: selectedObjekts, setSelectedObjekts: setSelectedObjekts, onObjektPress: onObjektPress, onListChange: onListChange }) {
    let ownedObjektMap = (0, $acw62.useMemo)(()=>{
        let map = new Map();
        for (let objekt of ownedObjekts){
            if (!map.has(objekt.collectionId)) map.set(objekt.collectionId, []);
            map.get(objekt.collectionId).push(objekt);
        }
        for (let objekts of map.values())objekts.sort((a, b)=>a.objektNo - b.objektNo);
        return map;
    }, [
        ownedObjekts
    ]);
    let collectionList = (0, $acw62.useMemo)(()=>{
        let collections = new Map();
        for (let objekt of objekts){
            let collectionName = `${objekt.season} ${objekt.collectionNo}`;
            if (!collections.has(collectionName)) collections.set(collectionName, []);
            collections.get(collectionName).push(objekt);
        }
        return Array.from(collections.entries()).sort(([a], [b])=>a < b ? 1 : a > b ? -1 : 0);
    }, [
        objekts
    ]);
    let [objektsPerRow, setObjektsPerRow] = (0, $acw62.useState)(2);
    (0, $acw62.useLayoutEffect)(()=>{
        let smQuery = window.matchMedia("(min-width: 640px)");
        let lgQuery = window.matchMedia("(min-width: 1024px)");
        function updateObjektsPerRow() {
            if (lgQuery.matches) setObjektsPerRow(6);
            else if (smQuery.matches) setObjektsPerRow(4);
            else setObjektsPerRow(2);
        }
        updateObjektsPerRow();
        smQuery.addEventListener("change", updateObjektsPerRow);
        lgQuery.addEventListener("change", updateObjektsPerRow);
        return ()=>{
            smQuery.removeEventListener("change", updateObjektsPerRow);
            lgQuery.removeEventListener("change", updateObjektsPerRow);
        };
    }, []);
    let rows = (0, $acw62.useMemo)(()=>{
        let rows = [];
        let currentRow = [];
        let currentRowObjekts = 0;
        for (let [collectionName, objekts] of collectionList){
            if (objekts.length > objektsPerRow || currentRowObjekts + objekts.length > objektsPerRow) {
                if (currentRow.length > 0) rows.push(currentRow);
                currentRow = [];
                currentRowObjekts = 0;
            }
            currentRow.push([
                collectionName,
                objekts
            ]);
            currentRowObjekts += objekts.length;
        }
        if (currentRow.length > 0) rows.push(currentRow);
        return rows;
    }, [
        collectionList,
        objektsPerRow
    ]);
    let parentRef = (0, $acw62.useRef)(null);
    let parentOffsetRef = (0, $acw62.useRef)(0);
    (0, $acw62.useLayoutEffect)(()=>{
        parentOffsetRef.current = parentRef.current?.offsetTop ?? 0;
    }, []);
    let virtualizer = (0, $64d08e094a93fa77$export$645722dcac657cb9)({
        count: rows.length,
        estimateSize: (index)=>{
            let totalObjektsCount = rows[index].reduce((count, [_, objekts])=>count + objekts.length, 0);
            let estimatedObjektHeight = objektsPerRow === 6 ? 320 : objektsPerRow === 4 ? 450 : 540;
            return Math.ceil(totalObjektsCount / objektsPerRow) * estimatedObjektHeight;
        },
        scrollMargin: parentOffsetRef.current
    });
    let virtualItems = virtualizer.getVirtualItems();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: parentRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: virtualizer.getTotalSize()
            },
            className: "relative",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute top-0 inset-x-0",
                style: {
                    transform: `translateY(${(virtualItems[0]?.start ?? 0) - virtualizer.options.scrollMargin}px)`
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-4",
                    children: virtualItems.map((item)=>{
                        let row = rows[item.index];
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-index": item.index,
                            ref: virtualizer.measureElement,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: [
                                    "grid grid-cols-2 gap-4",
                                    "grid grid-cols-4 gap-4",
                                    "grid grid-cols-6 gap-4"
                                ][objektsPerRow / 2 - 1],
                                children: row.map(([collectionName, objekts])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: [
                                            "col-span-1",
                                            "col-span-2",
                                            "col-span-3",
                                            "col-span-4",
                                            "col-span-5",
                                            "col-span-6"
                                        ][Math.min(objekts.length, objektsPerRow) - 1],
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-center text-small font-medium",
                                                children: collectionName
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {
                                                className: "mt-2 mb-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: [
                                                    "grid grid-cols-1 gap-4",
                                                    "grid grid-cols-2 gap-4",
                                                    "grid grid-cols-3 gap-4",
                                                    "grid grid-cols-4 gap-4",
                                                    "grid grid-cols-5 gap-4",
                                                    "grid grid-cols-6 gap-4"
                                                ][Math.min(objekts.length, objektsPerRow) - 1],
                                                children: objekts.map((objekt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d99295d792044717$var$Objekt, {
                                                        objekt: objekt,
                                                        ownedObjekts: ownedObjektMap.get(objekt.collectionId) ?? [],
                                                        wantsList: wantsList,
                                                        selectedObjekts: selectedObjekts,
                                                        setSelectedObjekts: setSelectedObjekts,
                                                        onObjektPress: onObjektPress,
                                                        onListChange: onListChange
                                                    }, objekt.collectionId))
                                            })
                                        ]
                                    }, collectionName))
                            })
                        }, item.index);
                    })
                })
            })
        })
    });
}



var $acw62 = parcelRequire("acw62");

function $9a9dd0b0fb5253bc$export$919a0a57c724d531(name, defaultValue = "", navigateOpts) {
    let [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    let currentValue = searchParams.get(name) ?? defaultValue;
    let [value, setValue_] = (0, $acw62.useState)(currentValue);
    // https://react.dev/reference/react/useState#storing-information-from-previous-renders
    if (!navigateOpts?.replace && value !== currentValue) setValue_(currentValue);
    let setValue = (0, $acw62.useCallback)((value)=>{
        let newSearchParams = Object.fromEntries(Array.from(searchParams.entries()).filter(([key])=>key !== name));
        setValue_(value);
        if (value === defaultValue) setSearchParams(newSearchParams, navigateOpts);
        else setSearchParams({
            ...newSearchParams,
            [name]: value
        }, navigateOpts);
    }, [
        searchParams
    ]);
    return [
        value,
        setValue
    ];
}
function $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508(name, navigateOpts) {
    let [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    let currentValues = searchParams.getAll(name);
    let [values, setValues_] = (0, $acw62.useState)(currentValues);
    // https://react.dev/reference/react/useState#storing-information-from-previous-renders
    if (!navigateOpts?.replace && (values.length !== currentValues.length || values.some((value, i)=>value !== currentValues[i]))) setValues_(currentValues);
    let setValues = (0, $acw62.useCallback)((values)=>{
        let newSearchParams = Object.fromEntries(Array.from(searchParams.entries()).filter(([key])=>key !== name));
        setValues_(values);
        if (values.length === 0) setSearchParams(newSearchParams, navigateOpts);
        else setSearchParams({
            ...newSearchParams,
            [name]: values
        }, navigateOpts);
    }, [
        searchParams
    ]);
    return [
        values,
        setValues
    ];
}



async function $b0edfae642bad352$export$f4c5de44377d2946({ params: params }) {
    let { userId: userId } = params;
    let address;
    let profileImageUrl = "";
    if (userId.startsWith("@")) {
        let nickname = userId.substring(1);
        let { profile: profile } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).get(`/user/v1/by-nickname/${nickname}`);
        address = profile.address;
        profileImageUrl = profile.profileImageUrl;
    } else if (userId.startsWith("0x")) address = userId;
    else throw new Error("unexpected userId given");
    let [{ artist: tripleS }, { artist: artms }] = await Promise.all([
        (0, $9105f8a53cedb7f3$export$cc1aced799785edc).get("/artist/v1/tripleS"),
        (0, $9105f8a53cedb7f3$export$cc1aced799785edc).get("/artist/v1/artms")
    ]);
    let response = await fetch("https://cosmo.goranmoomin.dev/objekts.json");
    let json = await response.json();
    return {
        objekts: json.filter((item)=>"objekt" in item).map((item)=>item.objekt),
        address: address,
        profileImageUrl: profileImageUrl,
        artists: [
            tripleS,
            artms
        ]
    };
}
var $a9e0ce0379c04938$exports = {};
$a9e0ce0379c04938$exports = new URL("add-to-list.97836d60.png", import.meta.url).toString();


function $b0edfae642bad352$var$ObjektsTab({ objekts: objekts, artists: artists, address: address, userId: userId }) {
    let currentAccount = (0, $f18c256353fe9c11$export$8a2442b306735398)();
    let credentials = currentAccount?.credentials;
    let ownedObjekts = (0, $f35b12426ac7c493$export$f3ad2dcd205cf43)((startAfter)=>(0, $9105f8a53cedb7f3$export$cc1aced799785edc).getOwnedObjekts(address, startAfter), [
        address
    ]);
    let myOwnedObjekts = (0, $f35b12426ac7c493$export$f3ad2dcd205cf43)(async (startAfter)=>{
        if (!credentials) return {
            hasNext: false,
            total: 0,
            objekts: []
        };
        return await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).getOwnedObjektsByMe(startAfter);
    }, [
        credentials
    ]);
    let [wantsList, setWantsList] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let isCancelled = false;
        (async ()=>{
            try {
                let { lists: lists } = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getUserDetails(address);
                if (!isCancelled) setWantsList(lists.find((list)=>list.name === "want")?.collectionIds || []);
            } catch (error) {
                console.error("Failed to fetch wants/haves lists:", error);
            }
        })();
        return ()=>{
            isCancelled = true;
        };
    }, [
        address
    ]);
    let [myWantsList, setMyWantsList] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!currentAccount) return;
        let isCancelled = false;
        (async ()=>{
            try {
                let { lists: lists } = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getUserDetails(currentAccount.profile.address);
                if (!isCancelled) setMyWantsList(lists.find((list)=>list.name === "want")?.collectionIds || []);
            } catch (error) {
                console.error("Failed to fetch wants/haves lists:", error);
            }
        })();
        return ()=>{
            isCancelled = true;
        };
    }, [
        currentAccount
    ]);
    async function onListChange() {
        if (!currentAccount) return;
        try {
            let { lists: lists } = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getUserDetails(currentAccount.profile.address);
            setMyWantsList(lists.find((list)=>list.name === "want")?.collectionIds || []);
        } catch (error) {
            console.error("Failed to reload wants/haves lists:", error);
        }
    }
    let search = (0, $acw62.useMemo)(()=>{
        let search = new (0, $1a67fe2836545e3c$export$4b85d3515bd863a5)("collectionId");
        search.addIndex("artists");
        search.addIndex("season");
        search.addIndex("class");
        search.addIndex("member");
        search.addIndex("collectionId");
        search.addDocuments(objekts);
        return search;
    }, [
        objekts
    ]);
    let artistOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.flatMap((objekt)=>objekt.artists ?? [
                "tripleS"
            ]))), [
        objekts
    ]);
    let [artistName, setArtistName] = (0, $9a9dd0b0fb5253bc$export$919a0a57c724d531)("artist", "tripleS");
    let artist = artists.find((artist)=>artist.name === artistName);
    objekts = (0, $acw62.useMemo)(()=>objekts.filter((objekt)=>(objekt.artists ?? [
                "tripleS"
            ]).includes(artistName)).sort((a, b)=>{
            let aIndex = artist?.members.findIndex((member)=>member.name === a.member) ?? -1;
            let bIndex = artist?.members.findIndex((member)=>member.name === b.member) ?? -1;
            if (aIndex === -1) return 1;
            else if (bIndex === -1) return -1;
            else return aIndex - bIndex;
        }), [
        objekts,
        artistName,
        artist
    ]);
    let memberOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.map((objekt)=>objekt.member))).sort((a, b)=>{
            let aIndex = artist?.members.findIndex((member)=>member.name === a) ?? -1;
            let bIndex = artist?.members.findIndex((member)=>member.name === b) ?? -1;
            if (aIndex === -1) return 1;
            else if (bIndex === -1) return -1;
            else return aIndex - bIndex;
        }), [
        objekts
    ]);
    let seasonOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.map((objekt)=>objekt.season))), [
        objekts
    ]);
    let classOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.map((objekt)=>objekt.class))), [
        objekts
    ]);
    let [members, setMembers] = (0, $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508)("members");
    let [seasons, setSeasons] = (0, $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508)("seasons");
    let [classes, setClasses] = (0, $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508)("classes");
    let [query, setQuery] = (0, $9a9dd0b0fb5253bc$export$919a0a57c724d531)("q", "", {
        replace: true
    });
    let [filterOption, setFilterOption] = (0, $acw62.useState)("owned");
    let isWantsList = !!(0, $7939e29d663dd3ed$export$6c330e8992e8a295)(":userId/wants");
    let isHavesList = !!(0, $7939e29d663dd3ed$export$6c330e8992e8a295)(":userId/haves");
    let selectedList = isWantsList ? "wants" : isHavesList ? "haves" : "all";
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    function setSelectedList(selectedList) {
        switch(selectedList){
            case "all":
                navigate(`/${userId}`);
                break;
            case "wants":
                navigate(`/${userId}/wants`);
                break;
            case "haves":
                navigate(`/${userId}/haves`);
                break;
        }
    }
    if (selectedList === "wants") ownedObjekts = myOwnedObjekts;
    objekts = (0, $acw62.useMemo)(()=>{
        objekts = (0, $f35b12426ac7c493$export$c93005f913098d76)(objekts, members, seasons, classes, filterOption, ownedObjekts);
        if (selectedList === "wants") // the other user's wants, objekts displayed should be what I have
        objekts = objekts.filter((objekt)=>wantsList.includes(objekt.collectionId));
        else if (selectedList === "haves") // My wants, objekts displayed should be what the other user has
        objekts = objekts.filter((objekt)=>myWantsList.includes(objekt.collectionId));
        return objekts;
    }, [
        objekts,
        members,
        seasons,
        classes,
        filterOption,
        ownedObjekts,
        selectedList,
        wantsList,
        myWantsList
    ]);
    // query changes frequently, so should be memoized separately.
    objekts = (0, $acw62.useMemo)(()=>{
        if (query) objekts = search.search(query).filter((objekt)=>objekts.includes(objekt));
        return objekts;
    }, [
        objekts,
        search,
        query
    ]);
    let [selectedObjekts, setSelectedObjekts] = (0, $acw62.useState)([]);
    let [isCardOpen, setIsCardOpen] = (0, $acw62.useState)(true);
    let [selectedObjektForModal, setSelectedObjektForModal] = (0, $acw62.useState)(null);
    let { isOpen: isModalOpen, onOpen: onModalOpen, onOpenChange: onModalOpenChange } = (0, $7c70e959e80c13a8$export$6e3e27031a30522f)();
    function onObjektPress(objekt) {
        setSelectedObjektForModal(objekt);
        onModalOpen();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d99295d792044717$export$410423fda3f412a), {
                artist: artistName,
                members: members,
                seasons: seasons,
                classes: classes,
                artistOptions: artistOptions,
                memberOptions: memberOptions,
                seasonOptions: seasonOptions,
                classOptions: classOptions,
                setArtist: setArtistName,
                setMembers: setMembers,
                setSeasons: setSeasons,
                setClasses: setClasses,
                query: query,
                setQuery: setQuery
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col w-full sm:flex-row gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $02b40243896087d2$export$cb30f4715ae71f77), {
                        label: "Filter options",
                        orientation: "horizontal",
                        value: filterOption,
                        onValueChange: (value)=>setFilterOption(value),
                        className: "grow order-2 sm:order-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df433e363e28b078$export$ae409d22c5d3c393), {
                                value: "all",
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df433e363e28b078$export$ae409d22c5d3c393), {
                                value: "owned",
                                children: [
                                    "Owned",
                                    selectedList === "wants" ? " by me" : selectedList === "haves" ? ` by them` : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df433e363e28b078$export$ae409d22c5d3c393), {
                                value: "transferable",
                                children: [
                                    "Sendable",
                                    selectedList === "wants" ? " by me" : selectedList === "haves" ? ` by them` : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6ac24db504ef2115$export$5f058b6414bc662f), {
                        label: "Display List",
                        selectedKeys: [
                            selectedList
                        ],
                        onSelectionChange: (selectedKeys)=>setSelectedList(Array.from(selectedKeys)[0]),
                        className: "w-[auto] sm:max-w-xs order-1 sm:order-2 flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: "all",
                                children: "All Objekts"
                            }, "all"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: "wants",
                                children: "Their Wants"
                            }, "wants"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                value: "haves",
                                children: "My Wants"
                            }, "haves")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-medium font-medium",
                children: query && `Search results for: ${query}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f48272b62179a444$export$194c5e3f782179f4), {
                size: "3xl",
                isOpen: isModalOpen,
                onOpenChange: onModalOpenChange,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90430c3f5844fbf9$export$e7e965ff0372e8c), {
                    children: (onClose)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f35b12426ac7c493$export$ff94be36a1b487d), {
                            objekt: selectedObjektForModal,
                            onClose: onClose,
                            ownedObjekts: ownedObjekts.filter((objekt)=>objekt.collectionId === selectedObjektForModal.collectionId).toSorted((a, b)=>a.objektNo - b.objektNo),
                            selectedObjekts: selectedObjekts,
                            setSelectedObjekts: setSelectedObjekts
                        })
                })
            }),
            objekts.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-small font-medium text-foreground-500",
                        children: selectedList === "haves" ? "Mark any objekt as Want to share your Want list." : selectedList === "wants" ? "No objekts matches." : "No objekt matches your query."
                    }),
                    selectedList === "haves" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "max-w-96",
                        src: new URL($a9e0ce0379c04938$exports).href
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d99295d792044717$export$2b694fd04bcbe43d), {
                objekts: objekts,
                ownedObjekts: ownedObjekts,
                selectedObjekts: selectedObjekts,
                setSelectedObjekts: setSelectedObjekts,
                onObjektPress: onObjektPress,
                wantsList: myWantsList,
                onListChange: onListChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: selectedObjekts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                    className: "fixed inset-x-6 bottom-4 max-w-lg mx-auto",
                    variants: (0, $0541ef573799255c$export$55b7325ba41bb523).scaleSpringOpacity,
                    initial: "initial",
                    animate: "enter",
                    exit: "exit",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $06507242a7aa4c9b$export$4630804d47451d56), {
                        className: "max-h-[60vh]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $896dc7ac96a1f3a2$export$f23b394cfe48a45c), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1 font-bold",
                                        children: [
                                            selectedObjekts.length,
                                            " Selected Objekt",
                                            selectedObjekts.length > 1 ? "s" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "appearance-none select-none p-2 text-foreground-500 rounded-full hover:bg-default-100 active:bg-default-200 tap-highlight-transparent data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2",
                                        onClick: ()=>setIsCardOpen(!isCardOpen),
                                        children: isCardOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d5bf69f39f72f17$export$4857d3f3f5f8319b), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c275b0eb101f0650$export$7f01a6cbee61a0f2), {})
                                    })
                                ]
                            }),
                            isCardOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67ab465da978cead$export$bef3e985c75eafb5), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8834a4b8ef3d6ac2$export$c568166205121897), {
                                            children: selectedObjekts.map((objekt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex h-8",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
                                                            className: "max-w-none flex-1",
                                                            isSelected: selectedObjekts.includes(objekt),
                                                            onValueChange: (isSelected)=>{
                                                                if (isSelected) setSelectedObjekts([
                                                                    ...selectedObjekts,
                                                                    objekt
                                                                ]);
                                                                else setSelectedObjekts(selectedObjekts.filter((selectedObjekt)=>selectedObjekt !== objekt));
                                                            },
                                                            children: [
                                                                objekt.collectionId,
                                                                " #",
                                                                objekt.objektNo
                                                            ]
                                                        })
                                                    })
                                                }, objekt.tokenId))
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            })
        ]
    });
}
function $b0edfae642bad352$export$2e2bcd8739ae039() {
    let { userId: userId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    let { objekts: objekts, artists: artists, address: address, profileImageUrl: profileImageUrl } = (0, $7939e29d663dd3ed$export$1448a5050d252c4d)();
    let isTradeTab = !!(0, $7939e29d663dd3ed$export$6c330e8992e8a295)(":userId/trades");
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-5xl mx-auto px-6 py-2 flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03acd725adb4588e$export$2f4e98393b39571a), {
                name: userId,
                description: userId.startsWith("@") ? address : undefined,
                avatarProps: {
                    src: profileImageUrl || "https://static.cosmo.fans/uploads/images/img_profile_gallag@3x.png",
                    className: "h-20 w-20 shrink-0"
                },
                classNames: {
                    base: "justify-start my-4",
                    name: "text-large",
                    wrapper: "min-w-0",
                    description: "text-base w-full overflow-hidden text-ellipsis"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbcd334feb13e201$export$c093b509da7852a5), {
                classNames: {
                    panel: "p-0"
                },
                selectedKey: isTradeTab ? "trades" : "objekts",
                onSelectionChange: (key)=>{
                    if (key === "trades") navigate(`/${userId}/trades`);
                    else navigate(`/${userId}`);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $586c05b4a2af2627$export$e694ae5b295abf40), {
                        title: "Objekts",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0edfae642bad352$var$ObjektsTab, {
                            objekts: objekts,
                            artists: artists,
                            address: address,
                            userId: userId
                        })
                    }, "objekts"),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $586c05b4a2af2627$export$e694ae5b295abf40), {
                        title: "Trades",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f35b12426ac7c493$export$848ecf509cebe3ae), {
                            address: address
                        })
                    }, "trades")
                ]
            })
        ]
    });
}


















async function $f35b12426ac7c493$export$f4c5de44377d2946() {
    let [{ artist: tripleS }, { artist: artms }] = await Promise.all([
        (0, $9105f8a53cedb7f3$export$cc1aced799785edc).get("/artist/v1/tripleS"),
        (0, $9105f8a53cedb7f3$export$cc1aced799785edc).get("/artist/v1/artms")
    ]);
    let response = await fetch("https://cosmo.goranmoomin.dev/objekts.json");
    let json = await response.json();
    return {
        objekts: json.filter((item)=>"objekt" in item).map((item)=>item.objekt),
        artists: [
            tripleS,
            artms
        ]
    };
}
function $f35b12426ac7c493$export$f3ad2dcd205cf43(getPage, deps) {
    let [objekts, setObjekts] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        setObjekts([]);
        let isCancelled = false;
        (async ()=>{
            let page = await getPage();
            if (!isCancelled) setObjekts((objekts)=>[
                    ...objekts,
                    ...page.objekts
                ]);
            if (page.hasNext) {
                let nextStartAfter = parseInt(page.nextStartAfter);
                let promises = [];
                for(let startAfter = nextStartAfter; startAfter < page.total; startAfter += nextStartAfter)promises.push(getPage(startAfter).then((page)=>{
                    if (!isCancelled) setObjekts((objekts)=>[
                            ...objekts,
                            ...page.objekts
                        ]);
                }));
                await Promise.all(promises);
            }
        })();
        return ()=>void (isCancelled = true);
    }, deps);
    return objekts;
}
function $f35b12426ac7c493$var$CosmoNicknameAutocomplete({ nickname: nickname, setNickname: setNickname, isInvalid: isInvalid = false, errorMessage: errorMessage }) {
    let list = (0, $fb5ac2544e0480b5$export$bc3384a35de93d66)({
        async load ({ filterText: filterText }) {
            if (!filterText || filterText.length < 4) return {
                items: []
            };
            let { results: items } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).searchUsers(filterText);
            return {
                items: items
            };
        }
    });
    let [listFilterText] = (0, $a0ce7fac17a9bc96$export$21805fee57372823)(nickname, 100);
    (0, $acw62.useEffect)(()=>list.setFilterText(listFilterText), [
        listFilterText
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4242086c8a2b354a$export$e47a559fed520648), {
        isClearable: true,
        label: "COSMO ID",
        placeholder: "Recipient COSMO ID",
        allowsCustomValue: true,
        isLoading: list.isLoading,
        items: list.items,
        inputValue: nickname,
        onInputChange: setNickname,
        inputProps: {
            classNames: {
                input: "text-base placeholder:text-small"
            }
        },
        popoverProps: {
            placement: "top"
        },
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        children: list.items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                textValue: item.nickname,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03acd725adb4588e$export$2f4e98393b39571a), {
                    name: item.nickname,
                    description: item.address,
                    avatarProps: {
                        src: "https://static.cosmo.fans/uploads/images/img_profile_gallag@3x.png"
                    }
                })
            }, item.nickname))
    });
}
function $f35b12426ac7c493$export$ff94be36a1b487d({ objekt: objekt, onClose: onClose, ownedObjekts: ownedObjekts, selectedObjekts: selectedObjekts, setSelectedObjekts: setSelectedObjekts }) {
    let [objektNo, setObjektNo] = (0, $acw62.useState)("");
    let [objektCount, setObjektCount] = (0, $acw62.useState)(0);
    let [transfers, setTransfers] = (0, $acw62.useState)(null);
    let [nicknames, setNicknames] = (0, $acw62.useState)({});
    let [timestamps, setTimestamps] = (0, $acw62.useState)({});
    function onToggleObjektSelection(objekt, isSelected) {
        setSelectedObjekts((currentSelectedObjekts)=>{
            if (isSelected) return [
                ...currentSelectedObjekts,
                objekt
            ];
            else return currentSelectedObjekts.filter((selectedObjekt)=>selectedObjekt !== objekt);
        });
    }
    (0, $acw62.useEffect)(()=>{
        let isCancelled = false;
        (async ()=>{
            let objektCount = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getObjektCount(objekt.collectionId);
            if (!isCancelled) setObjektCount(objektCount);
        })();
        return ()=>void (isCancelled = true);
    }, [
        objekt
    ]);
    let [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    let [isFlipped, setIsFlipped] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31c5bb588189e544$export$3b7be5d1e99a7c62), {
                children: objekt.collectionId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63b3cab10eaf2f6b$export$186c5a93653b521c), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row items-stretch gap-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-[12rem] self-center sm:min-w-[16rem]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative w-full aspect-w-[1083] aspect-h-[1673] transition-transform",
                                style: {
                                    transformStyle: "preserve-3d",
                                    transform: isFlipped ? "rotateY(180deg)" : ""
                                },
                                onClick: ()=>setIsFlipped(!isFlipped),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "absolute inset-0",
                                        style: {
                                            backfaceVisibility: "hidden"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: objekt.frontImage,
                                            alt: "Objekt Image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "absolute inset-0",
                                        style: {
                                            backfaceVisibility: "hidden",
                                            transform: "rotateY(180deg)"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: objekt.backImage,
                                            alt: "Objekt Back Image"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Artists:"
                                        }),
                                        " ",
                                        objekt.artists?.join(", ")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Season:"
                                        }),
                                        " ",
                                        objekt.season
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Class:"
                                        }),
                                        " ",
                                        objekt.class
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Member:"
                                        }),
                                        " ",
                                        objekt.member
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-bold",
                                            children: "Total Objekt Count:"
                                        }),
                                        " ",
                                        objektCount
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbcd334feb13e201$export$c093b509da7852a5), {
                                    "aria-label": "Tabs",
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $586c05b4a2af2627$export$e694ae5b295abf40), {
                                            title: "Owned",
                                            children: ownedObjekts.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-col",
                                                children: ownedObjekts.map((ownedObjekt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
                                                        isSelected: selectedObjekts.includes(ownedObjekt),
                                                        isDisabled: !ownedObjekt.transferable,
                                                        onValueChange: (isSelected)=>onToggleObjektSelection(ownedObjekt, isSelected),
                                                        children: [
                                                            ownedObjekt.collectionId,
                                                            " #",
                                                            ownedObjekt.objektNo
                                                        ]
                                                    }, ownedObjekt.tokenId))
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex h-40 justify-center items-center text-foreground-400",
                                                children: "No objekts owned."
                                            })
                                        }, "owned"),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $586c05b4a2af2627$export$e694ae5b295abf40), {
                                            title: "Details",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                                    className: "flex flex-row gap-3",
                                                    onSubmit: async (e)=>{
                                                        e.preventDefault();
                                                        if (!objektNo) return;
                                                        setIsLoading(true);
                                                        try {
                                                            let transfers = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getObjektTransfers(objekt.collectionId, parseInt(objektNo));
                                                            let addresses = new Set();
                                                            let blockNumbers = new Set();
                                                            for (let transfer of transfers){
                                                                if (transfer.from !== "0x0000000000000000000000000000000000000000") addresses.add(transfer.from);
                                                                addresses.add(transfer.to);
                                                                blockNumbers.add(transfer.blockNumber);
                                                            }
                                                            let [nicknames, timestamps] = await Promise.all([
                                                                $f35b12426ac7c493$export$d3f95d07e1158e47(Array.from(addresses)),
                                                                $f35b12426ac7c493$export$9add19257750fd0f(Array.from(blockNumbers))
                                                            ]);
                                                            setTransfers(transfers);
                                                            setNicknames(nicknames);
                                                            setTimestamps(timestamps);
                                                        } finally{
                                                            setIsLoading(false);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e693153d3a5c272$export$921a3451e53aa4ce), {
                                                            type: "number",
                                                            inputMode: "numeric",
                                                            pattern: "[0-9]*",
                                                            placeholder: "Objekt Number",
                                                            startContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$fc47a954fcd1cdda), {
                                                                className: "text-foreground-500 w-6 h-6"
                                                            }),
                                                            value: objektNo,
                                                            onValueChange: setObjektNo,
                                                            classNames: {
                                                                input: "text-base placeholder:text-small"
                                                            },
                                                            disabled: isLoading
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                                            type: "submit",
                                                            isIconOnly: true,
                                                            color: "primary",
                                                            variant: "flat",
                                                            isLoading: isLoading,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$8ab25e1bd13dc8cb), {
                                                                className: "w-6 h-6"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a1557883e42e31c6$export$243f992f13002393), {
                                                    className: "mt-4",
                                                    removeWrapper: true,
                                                    isStriped: true,
                                                    layout: "fixed",
                                                    classNames: {
                                                        td: "group-data-[odd=true]:before:-z-10"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7203efdeccfc2375$export$251388f483db4908), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb52f7bb7f27effd$export$543cfe274bbcf0c9), {
                                                                    className: "w-40",
                                                                    children: "Owner"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb52f7bb7f27effd$export$543cfe274bbcf0c9), {
                                                                    children: "Date"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56bd304ee6f8d96b$export$cae9d4714bdb0040), {
                                                            emptyContent: transfers === null ? "No objekt specified." : "Not minted yet.",
                                                            children: (transfers ?? []).map((transfer, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e1d5270867337b33$export$eee7efc9a4e84001), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dcaabaac807b89eb$export$1a8c89c19dbc91b1), {
                                                                            className: "overflow-hidden text-ellipsis",
                                                                            children: nicknames[transfer.to] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                                                className: "inline",
                                                                                to: `/@${nicknames[transfer.to]}`,
                                                                                children: nicknames[transfer.to]
                                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                                                className: "inline",
                                                                                to: `/${transfer.to}`,
                                                                                children: transfer.to
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dcaabaac807b89eb$export$1a8c89c19dbc91b1), {
                                                                            children: new Date(timestamps[transfer.blockNumber] * 1000).toLocaleString("en-US")
                                                                        })
                                                                    ]
                                                                }, index))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "details")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $494d13c4d83d8955$export$69511fbe09cd360b), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                    color: "danger",
                    onPress: onClose,
                    children: "Close"
                })
            })
        ]
    });
}
function $f35b12426ac7c493$export$c93005f913098d76(objekts, members, seasons, classes, filterOption, ownedObjekts) {
    objekts = objekts.filter((objekt)=>members.length ? members.includes(objekt.member) : true).filter((objekt)=>seasons.length ? seasons.includes(objekt.season) : true).filter((objekt)=>classes.length ? classes.includes(objekt.class) : true);
    switch(filterOption){
        case "owned":
            objekts = objekts.filter((objekt)=>ownedObjekts.some((ownedObjekt)=>ownedObjekt.collectionId === objekt.collectionId));
            break;
        case "transferable":
            objekts = objekts.filter((objekt)=>ownedObjekts.some((ownedObjekt)=>ownedObjekt.collectionId === objekt.collectionId && ownedObjekt.transferable));
            break;
        case "all":
            break;
    }
    return objekts;
}

function $f35b12426ac7c493$var$ObjektsTab({ objekts: objekts, artists: artists }) {
    let currentAccount = (0, $f18c256353fe9c11$export$8a2442b306735398)();
    let credentials = currentAccount?.credentials;
    let ramperWalletSecrets = currentAccount?.ramperWalletSecrets;
    let ownedObjekts = $f35b12426ac7c493$export$f3ad2dcd205cf43(async (startAfter)=>{
        if (!credentials) return {
            hasNext: false,
            total: 0,
            objekts: []
        };
        return await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).getOwnedObjektsByMe(startAfter);
    }, [
        credentials
    ]);
    let [myWantsList, setMyWantsList] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!currentAccount) return;
        let isCancelled = false;
        (async ()=>{
            try {
                let { lists: lists } = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getUserDetails(currentAccount.profile.address);
                if (!isCancelled) setMyWantsList(lists.find((list)=>list.name === "want")?.collectionIds || []);
            } catch (error) {
                console.error("Failed to fetch wants/haves lists:", error);
            }
        })();
        return ()=>{
            isCancelled = true;
        };
    }, [
        currentAccount
    ]);
    async function onListChange() {
        if (!currentAccount) return;
        try {
            let { lists: lists } = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getUserDetails(currentAccount.profile.address);
            setMyWantsList(lists.find((list)=>list.name === "want")?.collectionIds || []);
        } catch (error) {
            console.error("Failed to reload wants/haves lists:", error);
        }
    }
    let search = (0, $acw62.useMemo)(()=>{
        let search = new (0, $1a67fe2836545e3c$export$4b85d3515bd863a5)("collectionId");
        search.addIndex("artists");
        search.addIndex("season");
        search.addIndex("class");
        search.addIndex("member");
        search.addIndex("collectionId");
        search.addDocuments(objekts);
        return search;
    }, [
        objekts
    ]);
    let artistOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.flatMap((objekt)=>objekt.artists ?? [
                "tripleS"
            ]))), [
        objekts
    ]);
    let [artistName, setArtistName] = (0, $9a9dd0b0fb5253bc$export$919a0a57c724d531)("artist", "tripleS");
    let artist = artists.find((artist)=>artist.name === artistName);
    objekts = (0, $acw62.useMemo)(()=>objekts.filter((objekt)=>(objekt.artists ?? [
                "tripleS"
            ]).includes(artistName)).sort((a, b)=>{
            let aIndex = artist?.members.findIndex((member)=>member.name === a.member) ?? -1;
            let bIndex = artist?.members.findIndex((member)=>member.name === b.member) ?? -1;
            if (aIndex === -1) return 1;
            else if (bIndex === -1) return -1;
            else return aIndex - bIndex;
        }), [
        objekts,
        artistName,
        artist
    ]);
    let memberOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.map((objekt)=>objekt.member))).sort((a, b)=>{
            let aIndex = artist?.members.findIndex((member)=>member.name === a) ?? -1;
            let bIndex = artist?.members.findIndex((member)=>member.name === b) ?? -1;
            if (aIndex === -1) return 1;
            else if (bIndex === -1) return -1;
            else return aIndex - bIndex;
        }), [
        objekts
    ]);
    let seasonOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.map((objekt)=>objekt.season))), [
        objekts
    ]);
    let classOptions = (0, $acw62.useMemo)(()=>Array.from(new Set(objekts.map((objekt)=>objekt.class))), [
        objekts
    ]);
    let [members, setMembers] = (0, $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508)("members");
    let [seasons, setSeasons] = (0, $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508)("seasons");
    let [classes, setClasses] = (0, $9a9dd0b0fb5253bc$export$f4ad3548b6dc8508)("classes");
    let [query, setQuery] = (0, $9a9dd0b0fb5253bc$export$919a0a57c724d531)("q", "", {
        replace: true
    });
    let [filterOption, setFilterOption] = (0, $acw62.useState)("all");
    let isWantsList = !!(0, $7939e29d663dd3ed$export$6c330e8992e8a295)("/wants");
    let selectedList = isWantsList ? "wants" : "all";
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    function setSelectedList(selectedList) {
        switch(selectedList){
            case "all":
                navigate("/");
                break;
            case "wants":
                navigate("/wants");
                break;
        }
    }
    objekts = (0, $acw62.useMemo)(()=>{
        objekts = $f35b12426ac7c493$export$c93005f913098d76(objekts, members, seasons, classes, filterOption, ownedObjekts);
        if (selectedList === "wants") objekts = objekts.filter((objekt)=>myWantsList.includes(objekt.collectionId));
        return objekts;
    }, [
        objekts,
        members,
        seasons,
        classes,
        filterOption,
        ownedObjekts,
        selectedList,
        myWantsList
    ]);
    // query changes frequently, so should be memoized separately.
    objekts = (0, $acw62.useMemo)(()=>{
        if (query) objekts = search.search(query).filter((objekt)=>objekts.includes(objekt)).sort((a, b)=>{
            let aIndex = artist?.members.findIndex((member)=>member.name === a.member) ?? -1;
            let bIndex = artist?.members.findIndex((member)=>member.name === b.member) ?? -1;
            if (aIndex === -1) return 1;
            else if (bIndex === -1) return -1;
            else return aIndex - bIndex;
        });
        return objekts;
    }, [
        objekts,
        search,
        query
    ]);
    let [selectedObjekts, setSelectedObjekts_] = (0, $acw62.useState)([]);
    let [error, setError] = (0, $acw62.useState)("");
    let [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    let [recipientNickname, setRecipientNickname_] = (0, $acw62.useState)("");
    function setRecipientNickname(newRecipientNickname) {
        setRecipientNickname_(newRecipientNickname);
        setError("");
    }
    let [txStates, setTxStates] = (0, $acw62.useState)([]);
    function setSelectedObjekts(newSelectedObjekts) {
        if (isLoading) return;
        if (typeof newSelectedObjekts === "function") newSelectedObjekts = newSelectedObjekts(selectedObjekts);
        setSelectedObjekts_(newSelectedObjekts);
        setTxStates(newSelectedObjekts.map(()=>({
                status: "initial",
                error: ""
            })));
    }
    async function onSendButtonPress() {
        if (!ramperWalletSecrets) return;
        try {
            setIsLoading(true);
            setError("");
            let provider = new (0, $5499ec87660a9ba7$export$999cc40da3fbc6f)("matic", "jKHL8FBDC9OR14KUb_n-J0_5KoF9hjDo");
            let feeData = await provider.getFeeData();
            let { profile: recipientProfile } = await (0, $9105f8a53cedb7f3$export$cc1aced799785edc).get(`/user/v1/by-nickname/${recipientNickname}`);
            let contractAddresses = {
                artms: "0x0fB69F54bA90f17578a59823E09e5a1f8F3FA200",
                tripleS: "0xA4B37bE40F7b231Ee9574c4b16b7DDb7EAcDC99B"
            };
            let contractAbi = [
                "function transferFrom(address from, address to, uint256 tokenId) public"
            ];
            let contracts = {
                artms: new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(contractAddresses["artms"], contractAbi, provider),
                tripleS: new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(contractAddresses["tripleS"], contractAbi, provider)
            };
            let { version: version, dek: dek, encryptedKey: encryptedKey } = ramperWalletSecrets;
            let wallet = (0, $e31fa7eca94d8741$export$bcca3ea514774656).fromPhrase(await (0, $ba3d3511b573d5ac$export$4f15789826015814)(version, dek, encryptedKey), provider);
            let senderAddress = wallet.address;
            let recipientAddress = recipientProfile.address;
            let nonce = await wallet.getNonce();
            let hasError = false;
            for(let i = 0; i < selectedObjekts.length; i += 8){
                let selectedObjektsBatch = selectedObjekts.slice(i, i + 8);
                await Promise.all(selectedObjektsBatch.map(async (selectedObjekt, j)=>{
                    let index = i + j;
                    try {
                        let artist = (selectedObjekt.artists ?? [
                            "tripleS"
                        ])[0];
                        let tokenId = selectedObjekt.tokenId;
                        let contract = contracts[artist];
                        let contractAddress = contractAddresses[artist];
                        let txData = contract.interface.encodeFunctionData("transferFrom", [
                            senderAddress,
                            recipientAddress,
                            tokenId
                        ]);
                        let tx = {
                            nonce: nonce++,
                            // gasLimit: 300000,
                            gasLimit: await wallet.estimateGas({
                                to: contractAddress,
                                data: txData
                            }),
                            maxFeePerGas: feeData.maxFeePerGas * 160n / 100n,
                            maxPriorityFeePerGas: feeData.maxPriorityFeePerGas * 160n / 100n,
                            to: contractAddress,
                            data: txData
                        };
                        setTxStates((txStates)=>[
                                ...txStates.slice(0, index),
                                {
                                    status: "sending",
                                    error: ""
                                },
                                ...txStates.slice(index + 1)
                            ]);
                        let txResult = await wallet.sendTransaction(tx);
                        let txReceipt = await txResult.wait();
                        console.log(txReceipt);
                        setTxStates((txStates)=>[
                                ...txStates.slice(0, index),
                                {
                                    status: "success",
                                    error: ""
                                },
                                ...txStates.slice(index + 1)
                            ]);
                    } catch (error) {
                        // .catch(error =>
                        hasError = true;
                        console.error(error);
                        console.dir(error);
                        let message;
                        if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) {
                            message = error.reason ?? "A blockchain error has occurred.";
                            if (error.reason === "ERC721: transfer caller is not owner nor approved") message = "You have already sent this objekt.";
                        } else if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) message = "Transaction was replaced\nThis usually means you have sent other objekts in a different method.";
                        else if (error instanceof Error) message = error.message;
                        else message = "An unknown error has occurred.";
                        setTxStates((txStates)=>[
                                ...txStates.slice(0, index),
                                {
                                    status: "error",
                                    error: message
                                },
                                ...txStates.slice(index + 1)
                            ]);
                    }
                }));
            }
            if (!hasError) setSelectedObjekts([]);
        } catch (error) {
            console.error(error);
            if (error instanceof Error) setError(error.message);
        } finally{
            setIsLoading(false);
        }
    }
    let [isCardOpen, setIsCardOpen] = (0, $acw62.useState)(true);
    let [selectedObjektForModal, setSelectedObjektForModal] = (0, $acw62.useState)(null);
    let { isOpen: isModalOpen, onOpen: onModalOpen, onOpenChange: onModalOpenChange } = (0, $7c70e959e80c13a8$export$6e3e27031a30522f)();
    function onObjektPress(objekt) {
        setSelectedObjektForModal(objekt);
        onModalOpen();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d99295d792044717$export$410423fda3f412a), {
                artist: artistName,
                members: members,
                seasons: seasons,
                classes: classes,
                artistOptions: artistOptions,
                memberOptions: memberOptions,
                seasonOptions: seasonOptions,
                classOptions: classOptions,
                setArtist: setArtistName,
                setMembers: setMembers,
                setSeasons: setSeasons,
                setClasses: setClasses,
                query: query,
                setQuery: setQuery
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col w-full sm:flex-row gap-4",
                children: [
                    selectedList === "all" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $02b40243896087d2$export$cb30f4715ae71f77), {
                        label: "Filter options",
                        orientation: "horizontal",
                        value: filterOption,
                        onValueChange: (value)=>setFilterOption(value),
                        className: "grow order-2 sm:order-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df433e363e28b078$export$ae409d22c5d3c393), {
                                value: "all",
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df433e363e28b078$export$ae409d22c5d3c393), {
                                value: "owned",
                                children: "Owned"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df433e363e28b078$export$ae409d22c5d3c393), {
                                value: "transferable",
                                children: "Sendable"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-row gap-2 grow order-2 sm:order-1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6ac24db504ef2115$export$5f058b6414bc662f), {
                        label: "Display List",
                        selectedKeys: [
                            selectedList
                        ],
                        onSelectionChange: (selectedKeys)=>setSelectedList(Array.from(selectedKeys)[0]),
                        className: "w-[auto] sm:max-w-xs order-1 sm:order-2 flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                children: "All Objekts"
                            }, "all"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9bba36bb6f6f82$export$c9741ea17cd30897), {
                                children: "My Wants"
                            }, "wants")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-medium font-medium",
                children: query && `Search results for: ${query}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f48272b62179a444$export$194c5e3f782179f4), {
                size: "3xl",
                isOpen: isModalOpen,
                onOpenChange: onModalOpenChange,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90430c3f5844fbf9$export$e7e965ff0372e8c), {
                    children: (onClose)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f35b12426ac7c493$export$ff94be36a1b487d, {
                            objekt: selectedObjektForModal,
                            onClose: onClose,
                            ownedObjekts: ownedObjekts.filter((objekt)=>objekt.collectionId === selectedObjektForModal.collectionId).toSorted((a, b)=>a.objektNo - b.objektNo),
                            selectedObjekts: selectedObjekts,
                            setSelectedObjekts: setSelectedObjekts
                        })
                })
            }),
            objekts.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-small font-medium text-foreground-500",
                        children: selectedList === "wants" ? "Mark any objekt as Want to share your Want list." : "No objekt matches your query."
                    }),
                    selectedList === "wants" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "max-w-96",
                        src: new URL($a9e0ce0379c04938$exports).href
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d99295d792044717$export$2b694fd04bcbe43d), {
                objekts: objekts,
                ownedObjekts: ownedObjekts,
                selectedObjekts: selectedObjekts,
                setSelectedObjekts: setSelectedObjekts,
                onObjektPress: onObjektPress,
                wantsList: myWantsList,
                onListChange: onListChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                children: selectedObjekts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffb02ccc9d959c1b$export$e25e478948902b8b).div, {
                    className: "fixed inset-x-6 bottom-4 max-w-lg mx-auto",
                    variants: (0, $0541ef573799255c$export$55b7325ba41bb523).scaleSpringOpacity,
                    initial: "initial",
                    animate: "enter",
                    exit: "exit",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $06507242a7aa4c9b$export$4630804d47451d56), {
                        className: "max-h-[60vh]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $896dc7ac96a1f3a2$export$f23b394cfe48a45c), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1 font-bold",
                                        children: [
                                            selectedObjekts.length,
                                            " Selected Objekt",
                                            selectedObjekts.length > 1 ? "s" : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "appearance-none select-none p-2 text-foreground-500 rounded-full hover:bg-default-100 active:bg-default-200 tap-highlight-transparent data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2",
                                        onClick: ()=>setIsCardOpen(!isCardOpen),
                                        children: isCardOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d5bf69f39f72f17$export$4857d3f3f5f8319b), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c275b0eb101f0650$export$7f01a6cbee61a0f2), {})
                                    })
                                ]
                            }),
                            isCardOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67ab465da978cead$export$bef3e985c75eafb5), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8834a4b8ef3d6ac2$export$c568166205121897), {
                                            children: selectedObjekts.map((objekt, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex h-8",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $575e4434e57cabe0$export$40f39952efc279e6), {
                                                                className: "max-w-none flex-1",
                                                                isSelected: selectedObjekts.includes(objekt),
                                                                onValueChange: (isSelected)=>{
                                                                    if (isSelected) setSelectedObjekts([
                                                                        ...selectedObjekts,
                                                                        objekt
                                                                    ]);
                                                                    else setSelectedObjekts(selectedObjekts.filter((selectedObjekt)=>selectedObjekt !== objekt));
                                                                },
                                                                children: [
                                                                    objekt.collectionId,
                                                                    " #",
                                                                    objekt.objektNo
                                                                ]
                                                            }),
                                                            txStates[i].status === "sending" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff0009cdb8e38ea8$export$b67103861f057d1a), {
                                                                size: "sm",
                                                                className: "w-8 h-8"
                                                            }),
                                                            txStates[i].status === "error" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9b21e3b0663024ed$export$b56270f92ff8018), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ed69f79ca0040ce$export$251d96216457b64b), {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                                                            isIconOnly: true,
                                                                            size: "sm",
                                                                            variant: "light",
                                                                            color: "warning",
                                                                            "aria-label": "View error",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$19bc16ee58e19b3d), {
                                                                                className: "w-6 h-6"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09f067fab22dde0c$export$2a0d18fe44adc4b6), {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "max-w-[20rem] text-danger break-words",
                                                                            children: txStates[i].error.split("\n").map((line, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                                                                    children: [
                                                                                        index !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                                        line
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            txStates[i].status === "success" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1fad2d25eff3c89d$export$7dd004358974b05d), {
                                                                className: "text-success w-8 h-8 p-1"
                                                            })
                                                        ]
                                                    })
                                                }, objekt.tokenId))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8834a4b8ef3d6ac2$export$c568166205121897), {
                                        className: "shrink-0",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f35b12426ac7c493$var$CosmoNicknameAutocomplete, {
                                            nickname: recipientNickname,
                                            setNickname: setRecipientNickname,
                                            isInvalid: !!error,
                                            errorMessage: error
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87b8b5faab40ab5b$export$69daf8f7928b4c69), {
                                        className: "shrink-0",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $315c520e7ca388e0$export$11c362adf4e83e40), {
                                            color: "primary",
                                            onClick: onSendButtonPress,
                                            isLoading: isLoading,
                                            children: "Send"
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            })
        ]
    });
}
function $f35b12426ac7c493$export$848ecf509cebe3ae({ address: address }) {
    let [transfers, setTransfers] = (0, $acw62.useState)([]);
    let [nicknames, setNicknames] = (0, $acw62.useState)({});
    let [timestamps, setTimestamps] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        let isCancelled = false;
        (async ()=>{
            let { transfers: transfers } = await (0, $6a6d46e8aa41c2b9$export$cdfaf390086a2115).getUserDetails(address);
            let addresses = new Set();
            let blockNumbers = new Set();
            for (let transfer of transfers){
                if (transfer.from !== "0x0000000000000000000000000000000000000000") addresses.add(transfer.from);
                addresses.add(transfer.to);
                blockNumbers.add(transfer.blockNumber);
            }
            await Promise.all([
                $f35b12426ac7c493$export$d3f95d07e1158e47(Array.from(addresses)).then((nicknames)=>{
                    if (!isCancelled) {
                        setTransfers(transfers);
                        setNicknames(nicknames);
                    }
                }),
                $f35b12426ac7c493$export$9add19257750fd0f(Array.from(blockNumbers)).then((timestamps)=>{
                    if (!isCancelled) {
                        setTransfers(transfers);
                        setTimestamps(timestamps);
                    }
                })
            ]);
        // if (!isCancelled) {
        //   setTransfers(transfers);
        //   setNicknames(nicknames);
        //   setTimestamps(timestamps);
        // }
        })();
        return ()=>void (isCancelled = true);
    }, [
        address
    ]);
    let parentRef = (0, $acw62.useRef)(null);
    let parentOffsetRef = (0, $acw62.useRef)(0);
    (0, $acw62.useLayoutEffect)(()=>{
        parentOffsetRef.current = parentRef.current?.offsetTop ?? 0;
    }, []);
    let virtualizer = (0, $64d08e094a93fa77$export$645722dcac657cb9)({
        count: transfers.length,
        estimateSize: ()=>40,
        scrollMargin: parentOffsetRef.current
    });
    let virtualItems = virtualizer.getVirtualItems();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: parentRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: virtualizer.getTotalSize()
            },
            className: "relative",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute top-0 inset-x-0",
                style: {
                    transform: `translateY(${(virtualItems[0]?.start ?? 0) - virtualizer.options.scrollMargin}px)`
                },
                children: virtualItems.map((item)=>{
                    let transfer = transfers[item.index];
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "data-index": item.index,
                        ref: virtualizer.measureElement,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-1 md:flex-row md:gap-4 mx-auto py-2 items-center justify-center text-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "md:basis-48",
                                        children: timestamps[transfer.blockNumber] ? new Date(timestamps[transfer.blockNumber] * 1000).toLocaleString("en-US") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff0009cdb8e38ea8$export$b67103861f057d1a), {
                                            size: "sm"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {
                                        orientation: "vertical",
                                        className: "hidden md:block h-auto self-stretch"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "md:basis-64",
                                        children: [
                                            transfer.objekt.collectionId,
                                            " #",
                                            transfer.objekt.objektNo
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {
                                        orientation: "vertical",
                                        className: "hidden md:block h-auto self-stretch"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex gap-2 md:basis-48 items-center justify-center",
                                        children: [
                                            transfer.to === address ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09f39d5db2614b7e$export$54839a81113e9e92), {
                                                size: "sm",
                                                color: "primary",
                                                children: "From"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09f39d5db2614b7e$export$54839a81113e9e92), {
                                                size: "sm",
                                                color: "secondary",
                                                children: "To"
                                            }),
                                            transfer.to === address ? transfer.from === "0x0000000000000000000000000000000000000000" ? "COSMO" : nicknames[transfer.from] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                className: "inline",
                                                to: `/@${nicknames[transfer.from]}`,
                                                children: nicknames[transfer.from]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                className: "inline",
                                                to: `/${transfer.from}`,
                                                children: transfer.from
                                            }) : nicknames[transfer.to] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                className: "inline",
                                                to: `/@${nicknames[transfer.to]}`,
                                                children: nicknames[transfer.to]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$a6c7ac8248d6e38a), {
                                                className: "inline",
                                                to: `/${transfer.to}`,
                                                children: transfer.to
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $563106d728412f79$export$2233c5fdcde64809), {
                                className: "md:max-w-[46rem] mx-auto"
                            })
                        ]
                    }, item.index);
                })
            })
        })
    });
}
async function $f35b12426ac7c493$export$d3f95d07e1158e47(addresses) {
    if (addresses.length == 0) return {};
    let promises = [];
    for(let i = 0; i < addresses.length; i += 150){
        let addressesBatch = addresses.slice(i, i + 150);
        promises.push((async ()=>{
            let response = await fetch(`https://cache.nova.gd/user/v1/by-address/${addressesBatch.join(",")}`);
            let json = await response.json();
            return json.map(({ address: address, nickname: nickname })=>[
                    address,
                    nickname
                ]);
        })());
    }
    let entries = (await Promise.all(promises)).flat();
    return Object.fromEntries(entries);
}
let $f35b12426ac7c493$var$provider = new (0, $5499ec87660a9ba7$export$999cc40da3fbc6f)("matic", "jKHL8FBDC9OR14KUb_n-J0_5KoF9hjDo");
async function $f35b12426ac7c493$export$9add19257750fd0f(blockNumbers) {
    let entries = (await Promise.all(Array.from(blockNumbers).map(async (blockNumber)=>[
            blockNumber,
            (await $f35b12426ac7c493$var$provider.getBlock(blockNumber))?.timestamp
        ]))).filter(([, timestamp])=>!!timestamp);
    return Object.fromEntries(entries);
}
function $f35b12426ac7c493$export$2e2bcd8739ae039() {
    let { objekts: objekts, artists: artists } = (0, $7939e29d663dd3ed$export$1448a5050d252c4d)();
    let currentAccount = (0, $f18c256353fe9c11$export$8a2442b306735398)();
    let isTradeTab = !!(0, $7939e29d663dd3ed$export$6c330e8992e8a295)("/trades");
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "max-w-5xl mx-auto px-6 py-2 flex flex-col gap-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbcd334feb13e201$export$c093b509da7852a5), {
            disabledKeys: currentAccount ? [] : [
                "trades"
            ],
            selectedKey: isTradeTab ? "trades" : "objekts",
            onSelectionChange: (key)=>{
                if (key === "trades") navigate("/trades");
                else navigate("/");
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $586c05b4a2af2627$export$e694ae5b295abf40), {
                    title: currentAccount ? "My Objekts" : "All Objekts",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f35b12426ac7c493$var$ObjektsTab, {
                        objekts: objekts,
                        artists: artists
                    })
                }, "objekts"),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $586c05b4a2af2627$export$e694ae5b295abf40), {
                    title: "My Trades",
                    children: currentAccount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f35b12426ac7c493$export$848ecf509cebe3ae, {
                        address: currentAccount.profile.address
                    })
                }, "trades")
            ]
        })
    });
}




$795a7664e1a3c052$export$2cd8252107eb640b({
    dsn: "https://55ac6857dd124992edb028afcf22ead2@o4505666811920384.ingest.sentry.io/4506268814802944",
    integrations: [
        new $1a684ef8a4a48899$export$46d3bbd0375f5fa4({
            tracePropagationTargets: [
                "localhost"
            ]
        }),
        new $5de7be2bba18bd29$export$6b59b88de1ff9cb7()
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
});
let $70fc9a727fa662ae$var$router = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b44fba3bcf08e7$export$2e2bcd8739ae039), {}),
        children: [
            // FIXME: I know React Router isn't expected to be used like this.
            {
                path: "",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f35b12426ac7c493$export$2e2bcd8739ae039), {}),
                loader: (0, $f35b12426ac7c493$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: "wants",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f35b12426ac7c493$export$2e2bcd8739ae039), {}),
                loader: (0, $f35b12426ac7c493$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: "haves",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f35b12426ac7c493$export$2e2bcd8739ae039), {}),
                loader: (0, $f35b12426ac7c493$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: "trades",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f35b12426ac7c493$export$2e2bcd8739ae039), {}),
                loader: (0, $f35b12426ac7c493$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: "gravity",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e26876ce4031e3c8$export$2e2bcd8739ae039), {})
            },
            {
                path: "gravity/:gravityId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f94943c3ed27e058$export$2e2bcd8739ae039), {})
            },
            {
                path: ":userId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0edfae642bad352$export$2e2bcd8739ae039), {}),
                loader: (0, $b0edfae642bad352$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: ":userId/wants",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0edfae642bad352$export$2e2bcd8739ae039), {}),
                loader: (0, $b0edfae642bad352$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: ":userId/haves",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0edfae642bad352$export$2e2bcd8739ae039), {}),
                loader: (0, $b0edfae642bad352$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            },
            {
                path: ":userId/trades",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0edfae642bad352$export$2e2bcd8739ae039), {}),
                loader: (0, $b0edfae642bad352$export$f4c5de44377d2946),
                shouldRevalidate: ({ currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (currentUrl.pathname === nextUrl.pathname) return false;
                    return true;
                }
            }
        ]
    }
]);
(0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root")).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdbc87c1e713f7c4$export$a3257b987c70dc9c), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f18c256353fe9c11$export$3b12c90f285de08e), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
            router: $70fc9a727fa662ae$var$router
        })
    })
}));


//# sourceMappingURL=index.6c6e44c4.js.map
